webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var angular = __webpack_require__(1);
	var ngAnimate = __webpack_require__(3);
	/*const ngCookies = require('angular-cookies');
	const ngResource = require('angular-resource');
	const ngSanitize = require('angular-sanitize');
	import 'angular-socket-io';*/
	var uiRouter = __webpack_require__(5);
	var uiBootstrap = __webpack_require__(6);
	var ngNotification = __webpack_require__(8);
	var ngMask = __webpack_require__(10);
	var ngTranslate = __webpack_require__(12);
	var ngColorPicker = __webpack_require__(13).name;
	var ngUiselect = __webpack_require__(15);
	var dynamicNumber = __webpack_require__(17);
	// const ngMessages = require('angular-messages');
	// import ngValidationMatch from 'angular-validation-match';
	/*require('ace-builds');
	require('angular-ui-ace');*/
	var app_config_1 = __webpack_require__(18);
	var toolbar_component_1 = __webpack_require__(20);
	var propertybox_component_1 = __webpack_require__(22);
	var blockly_component_1 = __webpack_require__(25);
	var toolbox_component_1 = __webpack_require__(255);
	var review_component_1 = __webpack_require__(257);
	var manage_view_component_1 = __webpack_require__(263);
	var hierarchy_component_1 = __webpack_require__(265);
	var commonpropertybox_component_1 = __webpack_require__(267);
	var undo_redo_component_1 = __webpack_require__(270);
	var login_component_1 = __webpack_require__(272);
	var multiCellSelect_directive_1 = __webpack_require__(274);
	var datetimepicker_directive_1 = __webpack_require__(275);
	var main_component_1 = __webpack_require__(276);
	var help_component_1 = __webpack_require__(279);
	var app_constants_1 = __webpack_require__(282);
	var language_service_1 = __webpack_require__(283);
	var counter_service_1 = __webpack_require__(284);
	var util_module_1 = __webpack_require__(285);
	var signature_component_1 = __webpack_require__(287);
	var stepper_component_1 = __webpack_require__(288);
	var api_connection_component_1 = __webpack_require__(290);
	var searchFilter_1 = __webpack_require__(292);
	// Application Components
	var dashboard_component_1 = __webpack_require__(293);
	var create_component_1 = __webpack_require__(296);
	// Global Services
	var localStorage_service_1 = __webpack_require__(333);
	__webpack_require__(334);
	angular.module('nodeApp', [
	    /*  ngCookies,
	      ngResource,
	      ngSanitize,*/
	    ngAnimate,
	    ngTranslate,
	    ngColorPicker,
	    __webpack_require__(335),
	    ngUiselect,
	    multiCellSelect_directive_1.default,
	    /*  'btford.socket-io',
	      'ui.ace',
	    */
	    uiRouter,
	    uiBootstrap,
	    ngNotification,
	    ngMask,
	    dynamicNumber,
	    localStorage_service_1.default,
	    /*  _Auth,
	      account,
	      admin,
	      navbar,
	      footer,*/
	    toolbar_component_1.default,
	    propertybox_component_1.default,
	    commonpropertybox_component_1.default,
	    toolbox_component_1.default,
	    review_component_1.default,
	    manage_view_component_1.default,
	    blockly_component_1.default,
	    main_component_1.default,
	    help_component_1.default,
	    app_constants_1.default,
	    language_service_1.default,
	    counter_service_1.default,
	    /* socket,*/
	    util_module_1.default,
	    dashboard_component_1.default,
	    create_component_1.default,
	    hierarchy_component_1.default,
	    commonpropertybox_component_1.default,
	    undo_redo_component_1.default,
	    login_component_1.default,
	    signature_component_1.default,
	    'angularSpectrumColorpicker',
	    'imageupload',
	    datetimepicker_directive_1.default,
	    'ui.bootstrap.datetimepicker',
	    searchFilter_1.default,
	    stepper_component_1.default,
	    api_connection_component_1.default
	])
	    .config(app_config_1.routeConfig)
	    .constant('config', window.GLOBALS)
	    .constant('PROJECTNAME', window.PROJECTNAME)
	    .filter('ratingrange', function () {
	    return function (input, total) {
	        total = parseInt(total);
	        for (var i = 0; i < total; i++)
	            input.push(i);
	        return input;
	    };
	})
	    .config(['$provide', function ($provide) {
	    $provide.decorator('taTranslations', ['taRegisterTool', '$delegate', function (taRegisterTool, taTranslations) {
	            taTranslations.insertImage.tooltip = 'Insert Image URL';
	            return taTranslations;
	        }]);
	}]);
	angular
	    .element(document)
	    .ready(function () {
	    angular.bootstrap(document, ['nodeApp'], {
	        strictDi: true
	    });
	});
	document.oncontextmenu = function () {
	    return false;
	};


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	//https://github.com/angular/angular.js/pull/10732
	
	var angular = __webpack_require__(1);
	var mask = __webpack_require__(11);
	
	module.exports = 'ui.mask';


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	/*!
	 * angular-ui-mask
	 * https://github.com/angular-ui/ui-mask
	 * Version: 1.8.7 - 2016-07-26T16:01:23.393Z
	 * License: MIT
	 */
	
	
	(function () { 
	'use strict';
	/*
	 Attaches input mask onto input element
	 */
	angular.module('ui.mask', [])
	        .value('uiMaskConfig', {
	            maskDefinitions: {
	                '9': /\d/,
	                'A': /[a-zA-Z]/,
	                '*': /[a-zA-Z0-9]/
	            },
	            clearOnBlur: true,
	            clearOnBlurPlaceholder: false,
	            escChar: '\\',
	            eventsToHandle: ['input', 'keyup', 'click', 'focus'],
	            addDefaultPlaceholder: true,
	            allowInvalidValue: false
	        })
	        .provider('uiMask.Config', function() {
	            var options = {};
	
	            this.maskDefinitions = function(maskDefinitions) {
	                return options.maskDefinitions = maskDefinitions;
	            };
	            this.clearOnBlur = function(clearOnBlur) {
	                return options.clearOnBlur = clearOnBlur;
	            };
	            this.clearOnBlurPlaceholder = function(clearOnBlurPlaceholder) {
	                return options.clearOnBlurPlaceholder = clearOnBlurPlaceholder;
	            };
	            this.eventsToHandle = function(eventsToHandle) {
	                return options.eventsToHandle = eventsToHandle;
	            };
	            this.addDefaultPlaceholder = function(addDefaultPlaceholder) {
	                return options.addDefaultPlaceholder = addDefaultPlaceholder;
	            };
	            this.allowInvalidValue = function(allowInvalidValue) {
	                return options.allowInvalidValue = allowInvalidValue;
	            };
	            this.$get = ['uiMaskConfig', function(uiMaskConfig) {
	                var tempOptions = uiMaskConfig;
	                for(var prop in options) {
	                    if (angular.isObject(options[prop]) && !angular.isArray(options[prop])) {
	                        angular.extend(tempOptions[prop], options[prop]);
	                    } else {
	                        tempOptions[prop] = options[prop];
	                    }
	                }
	
	                return tempOptions;
	            }];
	        })
	        .directive('uiMask', ['uiMask.Config', function(maskConfig) {
	                function isFocused (elem) {
	                  return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
	                }
	
	                return {
	                    priority: 100,
	                    require: 'ngModel',
	                    restrict: 'A',
	                    compile: function uiMaskCompilingFunction() {
	                        var options = angular.copy(maskConfig);
	
	                        return function uiMaskLinkingFunction(scope, iElement, iAttrs, controller) {
	                            var maskProcessed = false, eventsBound = false,
	                                    maskCaretMap, maskPatterns, maskPlaceholder, maskComponents,
	                                    // Minimum required length of the value to be considered valid
	                                    minRequiredLength,
	                                    value, valueMasked, isValid,
	                                    // Vars for initializing/uninitializing
	                                    originalPlaceholder = iAttrs.placeholder,
	                                    originalMaxlength = iAttrs.maxlength,
	                                    // Vars used exclusively in eventHandler()
	                                    oldValue, oldValueUnmasked, oldCaretPosition, oldSelectionLength,
	                                    // Used for communicating if a backspace operation should be allowed between
	                                    // keydownHandler and eventHandler
	                                    preventBackspace;
	
	                            var originalIsEmpty = controller.$isEmpty;
	                            controller.$isEmpty = function(value) {
	                                if (maskProcessed) {
	                                    return originalIsEmpty(unmaskValue(value || ''));
	                                } else {
	                                    return originalIsEmpty(value);
	                                }
	                            };
	
	                            function initialize(maskAttr) {
	                                if (!angular.isDefined(maskAttr)) {
	                                    return uninitialize();
	                                }
	                                processRawMask(maskAttr);
	                                if (!maskProcessed) {
	                                    return uninitialize();
	                                }
	                                initializeElement();
	                                bindEventListeners();
	                                return true;
	                            }
	
	                            function initPlaceholder(placeholderAttr) {
	                                if ( ! placeholderAttr) {
	                                    return;
	                                }
	
	                                maskPlaceholder = placeholderAttr;
	
	                                // If the mask is processed, then we need to update the value
	                                // but don't set the value if there is nothing entered into the element
	                                // and there is a placeholder attribute on the element because that
	                                // will only set the value as the blank maskPlaceholder
	                                // and override the placeholder on the element
	                                if (maskProcessed && !(iElement.val().length === 0 && angular.isDefined(iAttrs.placeholder))) {
	                                    iElement.val(maskValue(unmaskValue(iElement.val())));
	                                }
	                            }
	
	                            function initPlaceholderChar() {
	                                return initialize(iAttrs.uiMask);
	                            }
	
	                            var modelViewValue = false;
	                            iAttrs.$observe('modelViewValue', function(val) {
	                                if (val === 'true') {
	                                    modelViewValue = true;
	                                }
	                            });
	
	                            iAttrs.$observe('allowInvalidValue', function(val) {
	                                linkOptions.allowInvalidValue = val === ''
	                                    ? true
	                                    : !!val;
	                                formatter(controller.$modelValue);
	                            });
	
	                            function formatter(fromModelValue) {
	                                if (!maskProcessed) {
	                                    return fromModelValue;
	                                }
	                                value = unmaskValue(fromModelValue || '');
	                                isValid = validateValue(value);
	                                controller.$setValidity('mask', isValid);
	
	                                if (!value.length) return undefined;
	                                if (isValid || linkOptions.allowInvalidValue) {
	                                    return maskValue(value);
	                                } else {
	                                    return undefined;
	                                }
	                            }
	
	                            function parser(fromViewValue) {
	                                if (!maskProcessed) {
	                                    return fromViewValue;
	                                }
	                                value = unmaskValue(fromViewValue || '');
	                                isValid = validateValue(value);
	                                // We have to set viewValue manually as the reformatting of the input
	                                // value performed by eventHandler() doesn't happen until after
	                                // this parser is called, which causes what the user sees in the input
	                                // to be out-of-sync with what the controller's $viewValue is set to.
	                                controller.$viewValue = value.length ? maskValue(value) : '';
	                                controller.$setValidity('mask', isValid);
	
	                                if (isValid || linkOptions.allowInvalidValue) {
	                                    return modelViewValue ? controller.$viewValue : value;
	                                }
	                            }
	
	                            var linkOptions = {};
	
	                            if (iAttrs.uiOptions) {
	                                linkOptions = scope.$eval('[' + iAttrs.uiOptions + ']');
	                                if (angular.isObject(linkOptions[0])) {
	                                    // we can't use angular.copy nor angular.extend, they lack the power to do a deep merge
	                                    linkOptions = (function(original, current) {
	                                        for (var i in original) {
	                                            if (Object.prototype.hasOwnProperty.call(original, i)) {
	                                                if (current[i] === undefined) {
	                                                    current[i] = angular.copy(original[i]);
	                                                } else {
	                                                    if (angular.isObject(current[i]) && !angular.isArray(current[i])) {
	                                                        current[i] = angular.extend({}, original[i], current[i]);
	                                                    }
	                                                }
	                                            }
	                                        }
	                                        return current;
	                                    })(options, linkOptions[0]);
	                                } else {
	                                    linkOptions = options;  //gotta be a better way to do this..
	                                }
	                            } else {
	                                linkOptions = options;
	                            }
	
	                            iAttrs.$observe('uiMask', initialize);
	                            if (angular.isDefined(iAttrs.uiMaskPlaceholder)) {
	                                iAttrs.$observe('uiMaskPlaceholder', initPlaceholder);
	                            }
	                            else {
	                                iAttrs.$observe('placeholder', initPlaceholder);
	                            }
	                            if (angular.isDefined(iAttrs.uiMaskPlaceholderChar)) {
	                                iAttrs.$observe('uiMaskPlaceholderChar', initPlaceholderChar);
	                            }
	
	                            controller.$formatters.unshift(formatter);
	                            controller.$parsers.unshift(parser);
	
	                            function uninitialize() {
	                                maskProcessed = false;
	                                unbindEventListeners();
	
	                                if (angular.isDefined(originalPlaceholder)) {
	                                    iElement.attr('placeholder', originalPlaceholder);
	                                } else {
	                                    iElement.removeAttr('placeholder');
	                                }
	
	                                if (angular.isDefined(originalMaxlength)) {
	                                    iElement.attr('maxlength', originalMaxlength);
	                                } else {
	                                    iElement.removeAttr('maxlength');
	                                }
	
	                                iElement.val(controller.$modelValue);
	                                controller.$viewValue = controller.$modelValue;
	                                return false;
	                            }
	
	                            function initializeElement() {
	                                value = oldValueUnmasked = unmaskValue(controller.$modelValue || '');
	                                valueMasked = oldValue = maskValue(value);
	                                isValid = validateValue(value);
	                                if (iAttrs.maxlength) { // Double maxlength to allow pasting new val at end of mask
	                                    iElement.attr('maxlength', maskCaretMap[maskCaretMap.length - 1] * 2);
	                                }
	                                if ( ! originalPlaceholder && linkOptions.addDefaultPlaceholder) {
	                                    iElement.attr('placeholder', maskPlaceholder);
	                                }
	                                var viewValue = controller.$modelValue;
	                                var idx = controller.$formatters.length;
	                                while(idx--) {
	                                    viewValue = controller.$formatters[idx](viewValue);
	                                }
	                                controller.$viewValue = viewValue || '';
	                                controller.$render();
	                                // Not using $setViewValue so we don't clobber the model value and dirty the form
	                                // without any kind of user interaction.
	                            }
	
	                            function bindEventListeners() {
	                                if (eventsBound) {
	                                    return;
	                                }
	                                iElement.bind('blur', blurHandler);
	                                iElement.bind('mousedown mouseup', mouseDownUpHandler);
	                                iElement.bind('keydown', keydownHandler);
	                                iElement.bind(linkOptions.eventsToHandle.join(' '), eventHandler);
	                                eventsBound = true;
	                            }
	
	                            function unbindEventListeners() {
	                                if (!eventsBound) {
	                                    return;
	                                }
	                                iElement.unbind('blur', blurHandler);
	                                iElement.unbind('mousedown', mouseDownUpHandler);
	                                iElement.unbind('mouseup', mouseDownUpHandler);
	                                iElement.unbind('keydown', keydownHandler);
	                                iElement.unbind('input', eventHandler);
	                                iElement.unbind('keyup', eventHandler);
	                                iElement.unbind('click', eventHandler);
	                                iElement.unbind('focus', eventHandler);
	                                eventsBound = false;
	                            }
	
	                            function validateValue(value) {
	                                // Zero-length value validity is ngRequired's determination
	                                return value.length ? value.length >= minRequiredLength : true;
	                            }
	
	                            function unmaskValue(value) {
	                                var valueUnmasked = '',
	                                    input = iElement[0],
	                                    maskPatternsCopy = maskPatterns.slice(),
	                                    selectionStart = oldCaretPosition,
	                                    selectionEnd = selectionStart + getSelectionLength(input),
	                                    valueOffset, valueDelta, tempValue = '';
	                                // Preprocess by stripping mask components from value
	                                value = value.toString();
	                                valueOffset = 0;
	                                valueDelta = value.length - maskPlaceholder.length;
	                                angular.forEach(maskComponents, function(component) {
	                                    var position = component.position;
	                                    //Only try and replace the component if the component position is not within the selected range
	                                    //If component was in selected range then it was removed with the user input so no need to try and remove that component
	                                    if (!(position >= selectionStart && position < selectionEnd)) {
	                                        if (position >= selectionStart) {
	                                            position += valueDelta;
	                                        }
	                                        if (value.substring(position, position + component.value.length) === component.value) {
	                                            tempValue += value.slice(valueOffset, position);// + value.slice(position + component.value.length);
	                                            valueOffset = position + component.value.length;
	                                        }
	                                    }
	                                });
	                                value = tempValue + value.slice(valueOffset);
	                                angular.forEach(value.split(''), function(chr) {
	                                    if (maskPatternsCopy.length && maskPatternsCopy[0].test(chr)) {
	                                        valueUnmasked += chr;
	                                        maskPatternsCopy.shift();
	                                    }
	                                });
	
	                                return valueUnmasked;
	                            }
	
	                            function maskValue(unmaskedValue) {
	                                var valueMasked = '',
	                                        maskCaretMapCopy = maskCaretMap.slice();
	
	                                angular.forEach(maskPlaceholder.split(''), function(chr, i) {
	                                    if (unmaskedValue.length && i === maskCaretMapCopy[0]) {
	                                        valueMasked += unmaskedValue.charAt(0) || '_';
	                                        unmaskedValue = unmaskedValue.substr(1);
	                                        maskCaretMapCopy.shift();
	                                    }
	                                    else {
	                                        valueMasked += chr;
	                                    }
	                                });
	                                return valueMasked;
	                            }
	
	                            function getPlaceholderChar(i) {
	                                var placeholder = angular.isDefined(iAttrs.uiMaskPlaceholder) ? iAttrs.uiMaskPlaceholder : iAttrs.placeholder,
	                                    defaultPlaceholderChar;
	
	                                if (angular.isDefined(placeholder) && placeholder[i]) {
	                                    return placeholder[i];
	                                } else {
	                                    defaultPlaceholderChar = angular.isDefined(iAttrs.uiMaskPlaceholderChar) && iAttrs.uiMaskPlaceholderChar ? iAttrs.uiMaskPlaceholderChar : '_';
	                                    return (defaultPlaceholderChar.toLowerCase() === 'space') ? ' ' : defaultPlaceholderChar[0];
	                                }
	                            }
	
	                            // Generate array of mask components that will be stripped from a masked value
	                            // before processing to prevent mask components from being added to the unmasked value.
	                            // E.g., a mask pattern of '+7 9999' won't have the 7 bleed into the unmasked value.
	                            function getMaskComponents() {
	                                var maskPlaceholderChars = maskPlaceholder.split(''),
	                                        maskPlaceholderCopy, components;
	
	                                //maskCaretMap can have bad values if the input has the ui-mask attribute implemented as an obversable property, e.g. the demo page
	                                if (maskCaretMap && !isNaN(maskCaretMap[0])) {
	                                    //Instead of trying to manipulate the RegEx based on the placeholder characters
	                                    //we can simply replace the placeholder characters based on the already built
	                                    //maskCaretMap to underscores and leave the original working RegEx to get the proper
	                                    //mask components
	                                    angular.forEach(maskCaretMap, function(value) {
	                                        maskPlaceholderChars[value] = '_';
	                                    });
	                                }
	                                maskPlaceholderCopy = maskPlaceholderChars.join('');
	                                components = maskPlaceholderCopy.replace(/[_]+/g, '_').split('_');
	                                components = components.filter(function(s) {
	                                    return s !== '';
	                                });
	
	                                // need a string search offset in cases where the mask contains multiple identical components
	                                // E.g., a mask of 99.99.99-999.99
	                                var offset = 0;
	                                return components.map(function(c) {
	                                    var componentPosition = maskPlaceholderCopy.indexOf(c, offset);
	                                    offset = componentPosition + 1;
	                                    return {
	                                        value: c,
	                                        position: componentPosition
	                                    };
	                                });
	                            }
	
	                            function processRawMask(mask) {
	                                var characterCount = 0;
	
	                                maskCaretMap = [];
	                                maskPatterns = [];
	                                maskPlaceholder = '';
	
	                                if (angular.isString(mask)) {
	                                    minRequiredLength = 0;
	
	                                    var isOptional = false,
	                                            numberOfOptionalCharacters = 0,
	                                            splitMask = mask.split('');
	
	                                    var inEscape = false;
	                                    angular.forEach(splitMask, function(chr, i) {
	                                        if (inEscape) {
	                                            inEscape = false;
	                                            maskPlaceholder += chr;
	                                            characterCount++;
	                                        }
	                                        else if (linkOptions.escChar === chr) {
	                                            inEscape = true;
	                                        }
	                                        else if (linkOptions.maskDefinitions[chr]) {
	                                            maskCaretMap.push(characterCount);
	
	                                            maskPlaceholder += getPlaceholderChar(i - numberOfOptionalCharacters);
	                                            maskPatterns.push(linkOptions.maskDefinitions[chr]);
	
	                                            characterCount++;
	                                            if (!isOptional) {
	                                                minRequiredLength++;
	                                            }
	
	                                            isOptional = false;
	                                        }
	                                        else if (chr === '?') {
	                                            isOptional = true;
	                                            numberOfOptionalCharacters++;
	                                        }
	                                        else {
	                                            maskPlaceholder += chr;
	                                            characterCount++;
	                                        }
	                                    });
	                                }
	                                // Caret position immediately following last position is valid.
	                                maskCaretMap.push(maskCaretMap.slice().pop() + 1);
	
	                                maskComponents = getMaskComponents();
	                                maskProcessed = maskCaretMap.length > 1 ? true : false;
	                            }
	
	                            var prevValue = iElement.val();
	                            function blurHandler() {
	                                if (linkOptions.clearOnBlur || ((linkOptions.clearOnBlurPlaceholder) && (value.length === 0) && iAttrs.placeholder)) {
	                                    oldCaretPosition = 0;
	                                    oldSelectionLength = 0;
	                                    if (!isValid || value.length === 0) {
	                                        valueMasked = '';
	                                        iElement.val('');
	                                        scope.$apply(function() {
	                                            //only $setViewValue when not $pristine to avoid changing $pristine state.
	                                            if (!controller.$pristine) {
	                                                controller.$setViewValue('');
	                                            }
	                                        });
	                                    }
	                                }
	                                //Check for different value and trigger change.
	                                //Check for different value and trigger change.
	                                if (value !== prevValue) {
	                                    // #157 Fix the bug from the trigger when backspacing exactly on the first letter (emptying the field)
	                                    // and then blurring out.
	                                    // Angular uses html element and calls setViewValue(element.value.trim()), setting it to the trimmed mask
	                                    // when it should be empty
	                                    var currentVal = iElement.val();
	                                    var isTemporarilyEmpty = value === '' && currentVal && angular.isDefined(iAttrs.uiMaskPlaceholderChar) && iAttrs.uiMaskPlaceholderChar === 'space'; 
	                                    if(isTemporarilyEmpty) {
	                                        iElement.val('');
	                                    }
	                                    triggerChangeEvent(iElement[0]);
	                                    if(isTemporarilyEmpty) {
	                                        iElement.val(currentVal);
	                                    }
	                                }
	                                prevValue = value;
	                            }
	
	                            function triggerChangeEvent(element) {
	                                var change;
	                                if (angular.isFunction(window.Event) && !element.fireEvent) {
	                                    // modern browsers and Edge
	                                    change = new Event('change', {
	                                        view: window,
	                                        bubbles: true,
	                                        cancelable: false
	                                    });
	                                    element.dispatchEvent(change);
	                                } else if ('createEvent' in document) {
	                                    // older browsers
	                                    change = document.createEvent('HTMLEvents');
	                                    change.initEvent('change', false, true);
	                                    element.dispatchEvent(change);
	                                }
	                                else if (element.fireEvent) {
	                                    // IE <= 11
	                                    element.fireEvent('onchange');
	                                }
	                            }
	
	                            function mouseDownUpHandler(e) {
	                                if (e.type === 'mousedown') {
	                                    iElement.bind('mouseout', mouseoutHandler);
	                                } else {
	                                    iElement.unbind('mouseout', mouseoutHandler);
	                                }
	                            }
	
	                            iElement.bind('mousedown mouseup', mouseDownUpHandler);
	
	                            function mouseoutHandler() {
	                                /*jshint validthis: true */
	                                oldSelectionLength = getSelectionLength(this);
	                                iElement.unbind('mouseout', mouseoutHandler);
	                            }
	
	                            function keydownHandler(e) {
			              	/*jshint validthis: true */
					var isKeyBackspace = e.which === 8,
					caretPos = getCaretPosition(this) - 1 || 0, //value in keydown is pre change so bump caret position back to simulate post change
					isCtrlZ = e.which === 90 && e.ctrlKey; //ctrl+z pressed
			
					if (isKeyBackspace) {
						while(caretPos >= 0) {
							if (isValidCaretPosition(caretPos)) {
							//re-adjust the caret position.
							//Increment to account for the initial decrement to simulate post change caret position
							setCaretPosition(this, caretPos + 1);
							break;
							}
						caretPos--;
						}
					preventBackspace = caretPos === -1;
					}
					
					if (isCtrlZ) {
						// prevent IE bug - value should be returned to initial state
						iElement.val('');
						e.preventDefault();
					}
				}
	
	                            function eventHandler(e) {
	                                /*jshint validthis: true */
	                                e = e || {};
	                                // Allows more efficient minification
	                                var eventWhich = e.which,
	                                        eventType = e.type;
	
	                                // Prevent shift and ctrl from mucking with old values
	                                if (eventWhich === 16 || eventWhich === 91) {
	                                    return;
	                                }
	
	                                var val = iElement.val(),
	                                        valOld = oldValue,
	                                        valMasked,
	                                        valAltered = false,
	                                        valUnmasked = unmaskValue(val),
	                                        valUnmaskedOld = oldValueUnmasked,
	                                        caretPos = getCaretPosition(this) || 0,
	                                        caretPosOld = oldCaretPosition || 0,
	                                        caretPosDelta = caretPos - caretPosOld,
	                                        caretPosMin = maskCaretMap[0],
	                                        caretPosMax = maskCaretMap[valUnmasked.length] || maskCaretMap.slice().shift(),
	                                        selectionLenOld = oldSelectionLength || 0,
	                                        isSelected = getSelectionLength(this) > 0,
	                                        wasSelected = selectionLenOld > 0,
	                                        // Case: Typing a character to overwrite a selection
	                                        isAddition = (val.length > valOld.length) || (selectionLenOld && val.length > valOld.length - selectionLenOld),
	                                        // Case: Delete and backspace behave identically on a selection
	                                        isDeletion = (val.length < valOld.length) || (selectionLenOld && val.length === valOld.length - selectionLenOld),
	                                        isSelection = (eventWhich >= 37 && eventWhich <= 40) && e.shiftKey, // Arrow key codes
	
	                                        isKeyLeftArrow = eventWhich === 37,
	                                        // Necessary due to "input" event not providing a key code
	                                        isKeyBackspace = eventWhich === 8 || (eventType !== 'keyup' && isDeletion && (caretPosDelta === -1)),
	                                        isKeyDelete = eventWhich === 46 || (eventType !== 'keyup' && isDeletion && (caretPosDelta === 0) && !wasSelected),
	                                        // Handles cases where caret is moved and placed in front of invalid maskCaretMap position. Logic below
	                                        // ensures that, on click or leftward caret placement, caret is moved leftward until directly right of
	                                        // non-mask character. Also applied to click since users are (arguably) more likely to backspace
	                                        // a character when clicking within a filled input.
	                                        caretBumpBack = (isKeyLeftArrow || isKeyBackspace || eventType === 'click') && caretPos > caretPosMin;
	
	                                oldSelectionLength = getSelectionLength(this);
	
	                                // These events don't require any action
	                                if (isSelection || (isSelected && (eventType === 'click' || eventType === 'keyup' || eventType === 'focus'))) {
	                                    return;
	                                }
	
	                                if (isKeyBackspace && preventBackspace) {
	                                    iElement.val(maskPlaceholder);
	                                    // This shouldn't be needed but for some reason after aggressive backspacing the controller $viewValue is incorrect.
	                                    // This keeps the $viewValue updated and correct.
	                                    scope.$apply(function () {
	                                        controller.$setViewValue(''); // $setViewValue should be run in angular context, otherwise the changes will be invisible to angular and user code.
	                                    });
	                                    setCaretPosition(this, caretPosOld);
	                                    return;
	                                }
	
	                                // Value Handling
	                                // ==============
	
	                                // User attempted to delete but raw value was unaffected--correct this grievous offense
	                                if ((eventType === 'input') && isDeletion && !wasSelected && valUnmasked === valUnmaskedOld) {
	                                    while (isKeyBackspace && caretPos > caretPosMin && !isValidCaretPosition(caretPos)) {
	                                        caretPos--;
	                                    }
	                                    while (isKeyDelete && caretPos < caretPosMax && maskCaretMap.indexOf(caretPos) === -1) {
	                                        caretPos++;
	                                    }
	                                    var charIndex = maskCaretMap.indexOf(caretPos);
	                                    // Strip out non-mask character that user would have deleted if mask hadn't been in the way.
	                                    valUnmasked = valUnmasked.substring(0, charIndex) + valUnmasked.substring(charIndex + 1);
	
	                                    // If value has not changed, don't want to call $setViewValue, may be caused by IE raising input event due to placeholder
	                                    if (valUnmasked !== valUnmaskedOld)
	                                        valAltered = true;
	                                }
	
	                                // Update values
	                                valMasked = maskValue(valUnmasked);
	
	                                oldValue = valMasked;
	                                oldValueUnmasked = valUnmasked;
	
	                                //additional check to fix the problem where the viewValue is out of sync with the value of the element.
	                                //better fix for commit 2a83b5fb8312e71d220a497545f999fc82503bd9 (I think)
	                                if (!valAltered && val.length > valMasked.length)
	                                    valAltered = true;
	
	                                iElement.val(valMasked);
	
	                                //we need this check.  What could happen if you don't have it is that you'll set the model value without the user
	                                //actually doing anything.  Meaning, things like pristine and touched will be set.
	                                if (valAltered) {
	                                    scope.$apply(function () {
	                                        controller.$setViewValue(valMasked); // $setViewValue should be run in angular context, otherwise the changes will be invisible to angular and user code.
	                                    });
	                                }
	
	                                // Caret Repositioning
	                                // ===================
	
	                                // Ensure that typing always places caret ahead of typed character in cases where the first char of
	                                // the input is a mask char and the caret is placed at the 0 position.
	                                if (isAddition && (caretPos <= caretPosMin)) {
	                                    caretPos = caretPosMin + 1;
	                                }
	
	                                if (caretBumpBack) {
	                                    caretPos--;
	                                }
	
	                                // Make sure caret is within min and max position limits
	                                caretPos = caretPos > caretPosMax ? caretPosMax : caretPos < caretPosMin ? caretPosMin : caretPos;
	
	                                // Scoot the caret back or forth until it's in a non-mask position and within min/max position limits
	                                while (!isValidCaretPosition(caretPos) && caretPos > caretPosMin && caretPos < caretPosMax) {
	                                    caretPos += caretBumpBack ? -1 : 1;
	                                }
	
	                                if ((caretBumpBack && caretPos < caretPosMax) || (isAddition && !isValidCaretPosition(caretPosOld))) {
	                                    caretPos++;
	                                }
	                                oldCaretPosition = caretPos;
	                                setCaretPosition(this, caretPos);
	                            }
	
	                            function isValidCaretPosition(pos) {
	                                return maskCaretMap.indexOf(pos) > -1;
	                            }
	
	                            function getCaretPosition(input) {
	                                if (!input)
	                                    return 0;
	                                if (input.selectionStart !== undefined) {
	                                    return input.selectionStart;
	                                } else if (document.selection) {
	                                    if (isFocused(iElement[0])) {
	                                        // Curse you IE
	                                        input.focus();
	                                        var selection = document.selection.createRange();
	                                        selection.moveStart('character', input.value ? -input.value.length : 0);
	                                        return selection.text.length;
	                                    }
	                                }
	                                return 0;
	                            }
	
	                            function setCaretPosition(input, pos) {
	                                if (!input)
	                                    return 0;
	                                if (input.offsetWidth === 0 || input.offsetHeight === 0) {
	                                    return; // Input's hidden
	                                }
	                                if (input.setSelectionRange) {
	                                    if (isFocused(iElement[0])) {
	                                        input.focus();
	                                        input.setSelectionRange(pos, pos);
	                                    }
	                                }
	                                else if (input.createTextRange) {
	                                    // Curse you IE
	                                    var range = input.createTextRange();
	                                    range.collapse(true);
	                                    range.moveEnd('character', pos);
	                                    range.moveStart('character', pos);
	                                    range.select();
	                                }
	                            }
	
	                            function getSelectionLength(input) {
	                                if (!input)
	                                    return 0;
	                                if (input.selectionStart !== undefined) {
	                                    return (input.selectionEnd - input.selectionStart);
	                                }
	                                if (window.getSelection) {
	                                    return (window.getSelection().toString().length);
	                                }
	                                if (document.selection) {
	                                    return (document.selection.createRange().text.length);
	                                }
	                                return 0;
	                            }
	
	                            // https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Array/indexOf
	                            if (!Array.prototype.indexOf) {
	                                Array.prototype.indexOf = function(searchElement /*, fromIndex */) {
	                                    if (this === null) {
	                                        throw new TypeError();
	                                    }
	                                    var t = Object(this);
	                                    var len = t.length >>> 0;
	                                    if (len === 0) {
	                                        return -1;
	                                    }
	                                    var n = 0;
	                                    if (arguments.length > 1) {
	                                        n = Number(arguments[1]);
	                                        if (n !== n) { // shortcut for verifying if it's NaN
	                                            n = 0;
	                                        } else if (n !== 0 && n !== Infinity && n !== -Infinity) {
	                                            n = (n > 0 || -1) * Math.floor(Math.abs(n));
	                                        }
	                                    }
	                                    if (n >= len) {
	                                        return -1;
	                                    }
	                                    var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
	                                    for (; k < len; k++) {
	                                        if (k in t && t[k] === searchElement) {
	                                            return k;
	                                        }
	                                    }
	                                    return -1;
	                                };
	                            }
	
	                        };
	                    }
	                };
	            }
	        ]);
	
	}());

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * angular-translate - v2.19.1 - 2024-01-21
	 * 
	 * Copyright (c) 2024 The angular-translate team, Pascal Precht; Licensed MIT
	 */
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return (factory());
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && module.exports) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    factory();
	  }
	}(this, function () {
	
	/**
	 * @ngdoc overview
	 * @name pascalprecht.translate
	 *
	 * @description
	 * The main module which holds everything together.
	 */
	runTranslate.$inject = ['$translate'];
	$translate.$inject = ['$STORAGE_KEY', '$windowProvider', '$translateSanitizationProvider', 'pascalprechtTranslateOverrider'];
	$translateDefaultInterpolation.$inject = ['$interpolate', '$translateSanitization'];
	translateDirective.$inject = ['$translate', '$interpolate', '$compile', '$parse', '$rootScope'];
	translateAttrDirective.$inject = ['$translate', '$rootScope'];
	translateCloakDirective.$inject = ['$translate', '$rootScope'];
	translateFilterFactory.$inject = ['$parse', '$translate'];
	$translationCache.$inject = ['$cacheFactory'];
	angular.module('pascalprecht.translate', ['ng'])
	  .run(runTranslate);
	
	function runTranslate($translate) {
	
	  'use strict';
	
	  var key = $translate.storageKey(),
	    storage = $translate.storage();
	
	  var fallbackFromIncorrectStorageValue = function () {
	    var preferred = $translate.preferredLanguage();
	    if (angular.isString(preferred)) {
	      $translate.use(preferred);
	      // $translate.use() will also remember the language.
	      // So, we don't need to call storage.put() here.
	    } else {
	      storage.put(key, $translate.use());
	    }
	  };
	
	  fallbackFromIncorrectStorageValue.displayName = 'fallbackFromIncorrectStorageValue';
	
	  if (storage) {
	    if (!storage.get(key)) {
	      fallbackFromIncorrectStorageValue();
	    } else {
	      $translate.use(storage.get(key))['catch'](fallbackFromIncorrectStorageValue);
	    }
	  } else if (angular.isString($translate.preferredLanguage())) {
	    $translate.use($translate.preferredLanguage());
	  }
	}
	
	runTranslate.displayName = 'runTranslate';
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateSanitizationProvider
	 *
	 * @description
	 *
	 * Configurations for $translateSanitization
	 */
	angular.module('pascalprecht.translate').provider('$translateSanitization', $translateSanitizationProvider);
	
	function $translateSanitizationProvider () {
	
	  'use strict';
	
	  var $sanitize,
	      $sce,
	      currentStrategy = null, // TODO change to either 'sanitize', 'escape' or ['sanitize', 'escapeParameters'] in 3.0.
	      hasConfiguredStrategy = false,
	      hasShownNoStrategyConfiguredWarning = false,
	      strategies;
	
	  /**
	   * Definition of a sanitization strategy function
	   * @callback StrategyFunction
	   * @param {string|object} value - value to be sanitized (either a string or an interpolated value map)
	   * @param {string} mode - either 'text' for a string (translation) or 'params' for the interpolated params
	   * @return {string|object}
	   */
	
	  /**
	   * @ngdoc property
	   * @name strategies
	   * @propertyOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Following strategies are built-in:
	   * <dl>
	   *   <dt>sanitize</dt>
	   *   <dd>Sanitizes HTML in the translation text using $sanitize</dd>
	   *   <dt>escape</dt>
	   *   <dd>Escapes HTML in the translation</dd>
	   *   <dt>sanitizeParameters</dt>
	   *   <dd>Sanitizes HTML in the values of the interpolation parameters using $sanitize</dd>
	   *   <dt>escapeParameters</dt>
	   *   <dd>Escapes HTML in the values of the interpolation parameters</dd>
	   *   <dt>escaped</dt>
	   *   <dd>Support legacy strategy name 'escaped' for backwards compatibility (will be removed in 3.0)</dd>
	   * </dl>
	   *
	   */
	
	  strategies = {
	    sanitize: function (value, mode/*, context*/) {
	      if (mode === 'text') {
	        value = htmlSanitizeValue(value);
	      }
	      return value;
	    },
	    escape: function (value, mode/*, context*/) {
	      if (mode === 'text') {
	        value = htmlEscapeValue(value);
	      }
	      return value;
	    },
	    sanitizeParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlSanitizeValue);
	      }
	      return value;
	    },
	    escapeParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlEscapeValue);
	      }
	      return value;
	    },
	    sce: function (value, mode, context) {
	      if (mode === 'text') {
	        value = htmlTrustValue(value);
	      } else if (mode === 'params') {
	        if (context !== 'filter') {
	          // do html escape in filter context #1101
	          value = mapInterpolationParameters(value, htmlEscapeValue);
	        }
	      }
	      return value;
	    },
	    sceParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlTrustValue);
	      }
	      return value;
	    }
	  };
	  // Support legacy strategy name 'escaped' for backwards compatibility.
	  // TODO should be removed in 3.0
	  strategies.escaped = strategies.escapeParameters;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#addStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Adds a sanitization strategy to the list of known strategies.
	   *
	   * @param {string} strategyName - unique key for a strategy
	   * @param {StrategyFunction} strategyFunction - strategy function
	   * @returns {object} this
	   */
	  this.addStrategy = function (strategyName, strategyFunction) {
	    strategies[strategyName] = strategyFunction;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#removeStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Removes a sanitization strategy from the list of known strategies.
	   *
	   * @param {string} strategyName - unique key for a strategy
	   * @returns {object} this
	   */
	  this.removeStrategy = function (strategyName) {
	    delete strategies[strategyName];
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#useStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
	   *
	   * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
	   * @returns {object} this
	   */
	  this.useStrategy = function (strategy) {
	    hasConfiguredStrategy = true;
	    currentStrategy = strategy;
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translateSanitization
	   * @requires $injector
	   * @requires $log
	   *
	   * @description
	   * Sanitizes interpolation parameters and translated texts.
	   *
	   */
	  this.$get = ['$injector', '$log', function ($injector, $log) {
	
	    var cachedStrategyMap = {};
	
	    var applyStrategies = function (value, mode, context, selectedStrategies) {
	      angular.forEach(selectedStrategies, function (selectedStrategy) {
	        if (angular.isFunction(selectedStrategy)) {
	          value = selectedStrategy(value, mode, context);
	        } else if (angular.isFunction(strategies[selectedStrategy])) {
	          value = strategies[selectedStrategy](value, mode, context);
	        } else if (angular.isString(strategies[selectedStrategy])) {
	          if (!cachedStrategyMap[strategies[selectedStrategy]]) {
	            try {
	              cachedStrategyMap[strategies[selectedStrategy]] = $injector.get(strategies[selectedStrategy]);
	            } catch (e) {
	              cachedStrategyMap[strategies[selectedStrategy]] = function() {};
	              throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
	            }
	          }
	          value = cachedStrategyMap[strategies[selectedStrategy]](value, mode, context);
	        } else {
	          throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
	        }
	      });
	      return value;
	    };
	
	    // TODO: should be removed in 3.0
	    var showNoStrategyConfiguredWarning = function () {
	      if (!hasConfiguredStrategy && !hasShownNoStrategyConfiguredWarning) {
	        $log.warn('pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details.');
	        hasShownNoStrategyConfiguredWarning = true;
	      }
	    };
	
	    if ($injector.has('$sanitize')) {
	      $sanitize = $injector.get('$sanitize');
	    }
	    if ($injector.has('$sce')) {
	      $sce = $injector.get('$sce');
	    }
	
	    return {
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateSanitization#useStrategy
	       * @methodOf pascalprecht.translate.$translateSanitization
	       *
	       * @description
	       * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
	       *
	       * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
	       */
	      useStrategy: (function (self) {
	        return function (strategy) {
	          self.useStrategy(strategy);
	        };
	      })(this),
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateSanitization#sanitize
	       * @methodOf pascalprecht.translate.$translateSanitization
	       *
	       * @description
	       * Sanitizes a value.
	       *
	       * @param {string|object} value The value which should be sanitized.
	       * @param {string} mode The current sanitization mode, either 'params' or 'text'.
	       * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
	       * @param {string} [context] The context of this call: filter, service. Default is service
	       * @returns {string|object} sanitized value
	       */
	      sanitize: function (value, mode, strategy, context) {
	        if (!currentStrategy) {
	          showNoStrategyConfiguredWarning();
	        }
	
	        if (!strategy && strategy !== null) {
	          strategy = currentStrategy;
	        }
	
	        if (!strategy) {
	          return value;
	        }
	
	        if (!context) {
	          context = 'service';
	        }
	
	        var selectedStrategies = angular.isArray(strategy) ? strategy : [strategy];
	        return applyStrategies(value, mode, context, selectedStrategies);
	      }
	    };
	  }];
	
	  var htmlEscapeValue = function (value) {
	    var element = angular.element('<div></div>');
	    element.text(value); // not chainable, see #1044
	    return element.html();
	  };
	
	  var htmlSanitizeValue = function (value) {
	    if (!$sanitize) {
	      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as \'escape\'.');
	    }
	    return $sanitize(value);
	  };
	
	  var htmlTrustValue = function (value) {
	    if (!$sce) {
	      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sce service.');
	    }
	    return $sce.trustAsHtml(value);
	  };
	
	  var mapInterpolationParameters = function (value, iteratee, stack) {
	    if (angular.isDate(value)) {
	      return value;
	    } else if (angular.isObject(value)) {
	      var result = angular.isArray(value) ? [] : {};
	
	      if (!stack) {
	        stack = [];
	      } else {
	        if (stack.indexOf(value) > -1) {
	          throw new Error('pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object');
	        }
	      }
	
	      stack.push(value);
	      angular.forEach(value, function (propertyValue, propertyKey) {
	
	        /* Skipping function properties. */
	        if (angular.isFunction(propertyValue)) {
	          return;
	        }
	
	        result[propertyKey] = mapInterpolationParameters(propertyValue, iteratee, stack);
	      });
	      stack.splice(-1, 1); // remove last
	
	      return result;
	    } else if (angular.isNumber(value)) {
	      return value;
	    } else if (value === true || value === false) {
	      return value;
	    } else if (!angular.isUndefined(value) && value !== null) {
	      return iteratee(value);
	    } else {
	      return value;
	    }
	  };
	}
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateProvider
	 * @description
	 *
	 * $translateProvider allows developers to register translation-tables, asynchronous loaders
	 * and similar to configure translation behavior directly inside of a module.
	 *
	 */
	angular.module('pascalprecht.translate')
	  .constant('pascalprechtTranslateOverrider', {})
	  .provider('$translate', $translate);
	
	function $translate($STORAGE_KEY, $windowProvider, $translateSanitizationProvider, pascalprechtTranslateOverrider) {
	
	  'use strict';
	
	  var $translationTable = {},
	    $preferredLanguage,
	    $availableLanguageKeys = [],
	    $languageKeyAliases,
	    $fallbackLanguage,
	    $fallbackWasString,
	    $uses,
	    $nextLang,
	    $storageFactory,
	    $storageKey = $STORAGE_KEY,
	    $storagePrefix,
	    $missingTranslationHandlerFactory,
	    $interpolationFactory,
	    $interpolatorFactories = [],
	    $loaderFactory,
	    $cloakClassName = 'translate-cloak',
	    $loaderOptions,
	    $notFoundIndicatorLeft,
	    $notFoundIndicatorRight,
	    $postCompilingEnabled = false,
	    $forceAsyncReloadEnabled = false,
	    $allowNamespaces = true,
	    $nestedObjectDelimeter = '.',
	    $isReady = false,
	    $keepContent = false,
	    loaderCache,
	    directivePriority = 0,
	    statefulFilter = true,
	    postProcessFn,
	    uniformLanguageTagResolver = 'default',
	    languageTagResolver = {
	      'default' : function (tag) {
	        return (tag || '').split('-').join('_');
	      },
	      java : function (tag) {
	        var temp = (tag || '').split('-').join('_');
	        var parts = temp.split('_');
	        return parts.length > 1 ? (parts[0].toLowerCase() + '_' + parts[1].toUpperCase()) : temp;
	      },
	      bcp47 : function (tag) {
	        var temp = (tag || '').split('_').join('-');
	        var parts = temp.split('-');
	
	        switch (parts.length) {
	          case 1: // language only
	            parts[0] = parts[0].toLowerCase();
	            break;
	          case 2: // language-script or language-region
	            parts[0] = parts[0].toLowerCase();
	            if (parts[1].length === 4) { // parts[1] is script
	              parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
	            } else { // parts[1] is region
	              parts[1] = parts[1].toUpperCase();
	            }
	            break;
	          case 3: // language-script-region
	            parts[0] = parts[0].toLowerCase();
	            parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
	            parts[2] = parts[2].toUpperCase();
	            break;
	          default:
	            return temp;
	        }
	
	        return parts.join('-');
	      },
	      'iso639-1' : function (tag) {
	        var temp = (tag || '').split('_').join('-');
	        var parts = temp.split('-');
	        return parts[0].toLowerCase();
	      }
	    };
	
	  var version = '2.19.1';
	
	  // tries to determine the browsers language
	  var getFirstBrowserLanguage = function () {
	
	    // internal purpose only
	    if (angular.isFunction(pascalprechtTranslateOverrider.getLocale)) {
	      return pascalprechtTranslateOverrider.getLocale();
	    }
	
	    var nav = $windowProvider.$get().navigator,
	      browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
	      i,
	      language;
	
	    // support for HTML 5.1 "navigator.languages"
	    if (angular.isArray(nav.languages)) {
	      for (i = 0; i < nav.languages.length; i++) {
	        language = nav.languages[i];
	        if (language && language.length) {
	          return language;
	        }
	      }
	    }
	
	    // support for other well known properties in browsers
	    for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
	      language = nav[browserLanguagePropertyKeys[i]];
	      if (language && language.length) {
	        return language;
	      }
	    }
	
	    return null;
	  };
	  getFirstBrowserLanguage.displayName = 'angular-translate/service: getFirstBrowserLanguage';
	
	  // tries to determine the browsers locale
	  var getLocale = function () {
	    var locale = getFirstBrowserLanguage() || '';
	    if (languageTagResolver[uniformLanguageTagResolver]) {
	      locale = languageTagResolver[uniformLanguageTagResolver](locale);
	    }
	    return locale;
	  };
	  getLocale.displayName = 'angular-translate/service: getLocale';
	
	  /**
	   * @name indexOf
	   * @private
	   *
	   * @description
	   * indexOf polyfill. Kinda sorta.
	   *
	   * @param {array} array Array to search in.
	   * @param {string} searchElement Element to search for.
	   *
	   * @returns {int} Index of search element.
	   */
	  var indexOf = function (array, searchElement) {
	    for (var i = 0, len = array.length; i < len; i++) {
	      if (array[i] === searchElement) {
	        return i;
	      }
	    }
	    return -1;
	  };
	
	  /**
	   * @name trim
	   * @private
	   *
	   * @description
	   * trim polyfill
	   *
	   * @returns {string} The string stripped of whitespace from both ends
	   */
	  var trim = function () {
	    return this.toString().replace(/^\s+|\s+$/g, '');
	  };
	
	  /**
	   * @name lowercase
	   * @private
	   *
	   * @description
	   * Return the lowercase string only if the type is string
	   *
	   * @returns {string} The string all in lowercase
	   */
	  var lowercase = function (string) {
	    return angular.isString(string) ? string.toLowerCase() : string;
	  };
	
	  var negotiateLocale = function (preferred) {
	    if (!preferred) {
	      return;
	    }
	
	    var avail = [],
	      locale = lowercase(preferred),
	      i = 0,
	      n = $availableLanguageKeys.length;
	
	    for (; i < n; i++) {
	      avail.push(lowercase($availableLanguageKeys[i]));
	    }
	
	    // Check for an exact match in our list of available keys
	    i = indexOf(avail, locale);
	    if (i > -1) {
	      return $availableLanguageKeys[i];
	    }
	
	    if ($languageKeyAliases) {
	      var alias;
	      for (var langKeyAlias in $languageKeyAliases) {
	        if ($languageKeyAliases.hasOwnProperty(langKeyAlias)) {
	          var hasWildcardKey = false;
	          var hasExactKey = Object.prototype.hasOwnProperty.call($languageKeyAliases, langKeyAlias) &&
	            lowercase(langKeyAlias) === lowercase(preferred);
	
	          if (langKeyAlias.slice(-1) === '*') {
	            hasWildcardKey = lowercase(langKeyAlias.slice(0, -1)) === lowercase(preferred.slice(0, langKeyAlias.length - 1));
	          }
	          if (hasExactKey || hasWildcardKey) {
	            alias = $languageKeyAliases[langKeyAlias];
	            if (indexOf(avail, lowercase(alias)) > -1) {
	              return alias;
	            }
	          }
	        }
	      }
	    }
	
	    // Check for a language code without region
	    var parts = preferred.split('_');
	
	    if (parts.length > 1 && indexOf(avail, lowercase(parts[0])) > -1) {
	      return parts[0];
	    }
	
	    // If everything fails, return undefined.
	    return;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translations
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a new translation table for specific language key.
	   *
	   * To register a translation table for specific language, pass a defined language
	   * key as first parameter.
	   *
	   * <pre>
	   *  // register translation table for language: 'de_DE'
	   *  $translateProvider.translations('de_DE', {
	   *    'GREETING': 'Hallo Welt!'
	   *  });
	   *
	   *  // register another one
	   *  $translateProvider.translations('en_US', {
	   *    'GREETING': 'Hello world!'
	   *  });
	   * </pre>
	   *
	   * When registering multiple translation tables for for the same language key,
	   * the actual translation table gets extended. This allows you to define module
	   * specific translation which only get added, once a specific module is loaded in
	   * your app.
	   *
	   * Invoking this method with no arguments returns the translation table which was
	   * registered with no language key. Invoking it with a language key returns the
	   * related translation table.
	   *
	   * @param {string} langKey A language key.
	   * @param {object} translationTable A plain old JavaScript object that represents a translation table.
	   *
	   */
	  var translations = function (langKey, translationTable) {
	
	    if (!langKey && !translationTable) {
	      return $translationTable;
	    }
	
	    if (langKey && !translationTable) {
	      if (angular.isString(langKey)) {
	        return $translationTable[langKey];
	      }
	    } else {
	      if (!angular.isObject($translationTable[langKey])) {
	        $translationTable[langKey] = {};
	      }
	      angular.extend($translationTable[langKey], flatObject(translationTable));
	    }
	    return this;
	  };
	
	  this.translations = translations;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#cloakClassName
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   *
	   * Let's you change the class name for `translate-cloak` directive.
	   * Default class name is `translate-cloak`.
	   *
	   * @param {string} name translate-cloak class name
	   */
	  this.cloakClassName = function (name) {
	    if (!name) {
	      return $cloakClassName;
	    }
	    $cloakClassName = name;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#allowNamespaces
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Let's you disable namespaces, if you don't need nested translation
	   * object files. Disabling namespaces can improve performance.
	   *
	   * Default value is `true`. Namespaces are enabled by default.
	   *
	   * @param {boolean} namespacesEnabled - namespaces are enabled or not
	   */
	  this.allowNamespaces = function (namespacesEnabled) {
	    if (namespacesEnabled === undefined) {
	      return $allowNamespaces;
	    }
	    $allowNamespaces = namespacesEnabled;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#nestedObjectDelimeter
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   *
	   * Let's you change the delimiter for namespaced translations.
	   * Default delimiter is `.`.
	   *
	   * @param {string} delimiter namespace separator
	   */
	  this.nestedObjectDelimeter = function (delimiter) {
	    if (!delimiter) {
	      return $nestedObjectDelimeter;
	    }
	    $nestedObjectDelimeter = delimiter;
	    return this;
	  };
	
	  /**
	   * @name flatObject
	   * @private
	   *
	   * @description
	   * Flats an object. This function is used to flatten given translation data with
	   * namespaces, so they are later accessible via dot notation.
	   */
	  var flatObject = function (data, path, result, prevKey) {
	    var key, keyWithPath, keyWithShortPath, val;
	
	    if (!path) {
	      path = [];
	    }
	    if (!result) {
	      result = {};
	    }
	    if (!$allowNamespaces) {
	      return data;
	    }
	    for (key in data) {
	      if (!Object.prototype.hasOwnProperty.call(data, key)) {
	        continue;
	      }
	      val = data[key];
	      if (angular.isObject(val)) {
	        flatObject(val, path.concat(key), result, key);
	      } else {
	        keyWithPath = path.length ? ('' + path.join($nestedObjectDelimeter) + $nestedObjectDelimeter + key) : key;
	        if (path.length && key === prevKey) {
	          // Create shortcut path (foo.bar == foo.bar.bar)
	          keyWithShortPath = '' + path.join($nestedObjectDelimeter);
	          // Link it to original path
	          result[keyWithShortPath] = '@:' + keyWithPath;
	        }
	        result[keyWithPath] = val;
	      }
	    }
	    return result;
	  };
	  flatObject.displayName = 'flatObject';
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#addInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Adds interpolation services to angular-translate, so it can manage them.
	   *
	   * @param {object} factory Interpolation service factory
	   */
	  this.addInterpolation = function (factory) {
	    $interpolatorFactories.push(factory);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use interpolation functionality of messageformat.js.
	   * This is useful when having high level pluralization and gender selection.
	   */
	  this.useMessageFormatInterpolation = function () {
	    return this.useInterpolation('$translateMessageFormatInterpolation');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate which interpolation style to use as default, application-wide.
	   * Simply pass a factory/service name. The interpolation service has to implement
	   * the correct interface.
	   *
	   * @param {string} factory Interpolation service name.
	   */
	  this.useInterpolation = function (factory) {
	    $interpolationFactory = factory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Simply sets a sanitation strategy type.
	   *
	   * @param {string} value Strategy type.
	   */
	  this.useSanitizeValueStrategy = function (value) {
	    $translateSanitizationProvider.useStrategy(value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#preferredLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which of the registered translation tables to use for translation
	   * at initial startup by passing a language key. Similar to `$translateProvider#use`
	   * only that it says which language to **prefer**.
	   * It is recommended to call this after {@link pascalprecht.translate.$translate#fallbackLanguage fallbackLanguage()}.
	   *
	   * @param {string} langKey A language key.
	   */
	  this.preferredLanguage = function (langKey) {
	    if (langKey) {
	      setupPreferredLanguage(langKey);
	      return this;
	    }
	    return $preferredLanguage;
	  };
	  var setupPreferredLanguage = function (langKey) {
	    if (langKey) {
	      $preferredLanguage = langKey;
	    }
	    return $preferredLanguage;
	  };
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found. E.g. when
	   * setting the indicator as 'X' and one tries to translate a translation id
	   * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
	   *
	   * Internally this methods sets a left indicator and a right indicator using
	   * `$translateProvider.translationNotFoundIndicatorLeft()` and
	   * `$translateProvider.translationNotFoundIndicatorRight()`.
	   *
	   * **Note**: These methods automatically add a whitespace between the indicators
	   * and the translation id.
	   *
	   * @param {string} indicator An indicator, could be any string.
	   */
	  this.translationNotFoundIndicator = function (indicator) {
	    this.translationNotFoundIndicatorLeft(indicator);
	    this.translationNotFoundIndicatorRight(indicator);
	    return this;
	  };
	
	  /**
	   * ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found left to the
	   * translation id.
	   *
	   * @param {string} indicator An indicator.
	   */
	  this.translationNotFoundIndicatorLeft = function (indicator) {
	    if (!indicator) {
	      return $notFoundIndicatorLeft;
	    }
	    $notFoundIndicatorLeft = indicator;
	    return this;
	  };
	
	  /**
	   * ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found right to the
	   * translation id.
	   *
	   * @param {string} indicator An indicator.
	   */
	  this.translationNotFoundIndicatorRight = function (indicator) {
	    if (!indicator) {
	      return $notFoundIndicatorRight;
	    }
	    $notFoundIndicatorRight = indicator;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#fallbackLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which of the registered translation tables to use when missing translations
	   * at initial startup by passing a language key. Similar to `$translateProvider#use`
	   * only that it says which language to **fallback**.
	   *
	   * @param {string||array} langKey A language key.
	   *
	   */
	  this.fallbackLanguage = function (langKey) {
	    fallbackStack(langKey);
	    return this;
	  };
	
	  var fallbackStack = function (langKey) {
	    if (langKey) {
	      if (angular.isString(langKey)) {
	        $fallbackWasString = true;
	        $fallbackLanguage = [langKey];
	      } else if (angular.isArray(langKey)) {
	        $fallbackWasString = false;
	        $fallbackLanguage = langKey;
	      }
	      if (angular.isString($preferredLanguage) && indexOf($fallbackLanguage, $preferredLanguage) < 0) {
	        $fallbackLanguage.push($preferredLanguage);
	      }
	
	      return this;
	    } else {
	      if ($fallbackWasString) {
	        return $fallbackLanguage[0];
	      } else {
	        return $fallbackLanguage;
	      }
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#use
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Set which translation table to use for translation by given language key. When
	   * trying to 'use' a language which isn't provided, it'll throw an error.
	   *
	   * You actually don't have to use this method since `$translateProvider#preferredLanguage`
	   * does the job too.
	   *
	   * @param {string} langKey A language key.
	   */
	  this.use = function (langKey) {
	    if (langKey) {
	      if (!$translationTable[langKey] && (!$loaderFactory)) {
	        // only throw an error, when not loading translation data asynchronously
	        throw new Error('$translateProvider couldn\'t find translationTable for langKey: \'' + langKey + '\'');
	      }
	      $uses = langKey;
	      return this;
	    }
	    return $uses;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#resolveClientLocale
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
	   *
	   * @returns {string} the current client/browser language key
	   */
	  this.resolveClientLocale = function () {
	    return getLocale();
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#storageKey
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which key must represent the choosed language by a user in the storage.
	   *
	   * @param {string} key A key for the storage.
	   */
	  var storageKey = function (key) {
	    if (!key) {
	      if ($storagePrefix) {
	        return $storagePrefix + $storageKey;
	      }
	      return $storageKey;
	    }
	    $storageKey = key;
	    return this;
	  };
	
	  this.storageKey = storageKey;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useUrlLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
	   *
	   * @param {string} url Url
	   * @param {Object=} options Optional configuration object
	   */
	  this.useUrlLoader = function (url, options) {
	    return this.useLoader('$translateUrlLoader', angular.extend({url : url}, options));
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
	   *
	   * @param {Object=} options Optional configuration object
	   */
	  this.useStaticFilesLoader = function (options) {
	    return this.useLoader('$translateStaticFilesLoader', options);
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use any other service as loader.
	   *
	   * @param {string} loaderFactory Factory name to use
	   * @param {Object=} options Optional configuration object
	   */
	  this.useLoader = function (loaderFactory, options) {
	    $loaderFactory = loaderFactory;
	    $loaderOptions = options || {};
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLocalStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
	   *
	   */
	  this.useLocalStorage = function () {
	    return this.useStorage('$translateLocalStorage');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useCookieStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
	   */
	  this.useCookieStorage = function () {
	    return this.useStorage('$translateCookieStorage');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use custom service as storage layer.
	   */
	  this.useStorage = function (storageFactory) {
	    $storageFactory = storageFactory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#storagePrefix
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets prefix for storage key.
	   *
	   * @param {string} prefix Storage key prefix
	   */
	  this.storagePrefix = function (prefix) {
	    if (!prefix) {
	      return prefix;
	    }
	    $storagePrefix = prefix;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use built-in log handler when trying to translate
	   * a translation Id which doesn't exist.
	   *
	   * This is actually a shortcut method for `useMissingTranslationHandler()`.
	   *
	   */
	  this.useMissingTranslationHandlerLog = function () {
	    return this.useMissingTranslationHandler('$translateMissingTranslationHandlerLog');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Expects a factory name which later gets instantiated with `$injector`.
	   * This method can be used to tell angular-translate to use a custom
	   * missingTranslationHandler. Just build a factory which returns a function
	   * and expects a translation id as argument.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.useMissingTranslationHandler('customHandler');
	   *  });
	   *
	   *  app.factory('customHandler', function (dep1, dep2) {
	   *    return function (translationId) {
	   *      // something with translationId and dep1 and dep2
	   *    };
	   *  });
	   * </pre>
	   *
	   * @param {string} factory Factory name
	   */
	  this.useMissingTranslationHandler = function (factory) {
	    $missingTranslationHandlerFactory = factory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#usePostCompiling
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If post compiling is enabled, all translated values will be processed
	   * again with AngularJS' $compile.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.usePostCompiling(true);
	   *  });
	   * </pre>
	   *
	   * @param {string} factory Factory name
	   */
	  this.usePostCompiling = function (value) {
	    $postCompilingEnabled = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#forceAsyncReload
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If force async reload is enabled, async loader will always be called
	   * even if $translationTable already contains the language key, adding
	   * possible new entries to the $translationTable.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.forceAsyncReload(true);
	   *  });
	   * </pre>
	   *
	   * @param {boolean} value - valid values are true or false
	   */
	  this.forceAsyncReload = function (value) {
	    $forceAsyncReloadEnabled = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#uniformLanguageTag
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate which language tag should be used as a result when determining
	   * the current browser language.
	   *
	   * This setting must be set before invoking {@link pascalprecht.translate.$translateProvider#methods_determinePreferredLanguage determinePreferredLanguage()}.
	   *
	   * <pre>
	   * $translateProvider
	   *   .uniformLanguageTag('bcp47')
	   *   .determinePreferredLanguage()
	   * </pre>
	   *
	   * The resolver currently supports:
	   * * default
	   *     (traditionally: hyphens will be converted into underscores, i.e. en-US => en_US)
	   *     en-US => en_US
	   *     en_US => en_US
	   *     en-us => en_us
	   * * java
	   *     like default, but the second part will be always in uppercase
	   *     en-US => en_US
	   *     en_US => en_US
	   *     en-us => en_US
	   * * BCP 47 (RFC 4646 & 4647)
	   *     EN => en
	   *     en-US => en-US
	   *     en_US => en-US
	   *     en-us => en-US
	   *     sr-latn => sr-Latn
	   *     sr-latn-rs => sr-Latn-RS
	   *
	   * See also:
	   * * http://en.wikipedia.org/wiki/IETF_language_tag
	   * * http://www.w3.org/International/core/langtags/
	   * * http://tools.ietf.org/html/bcp47
	   *
	   * @param {string|object} options - options (or standard)
	   * @param {string} options.standard - valid values are 'default', 'bcp47', 'java'
	   */
	  this.uniformLanguageTag = function (options) {
	
	    if (!options) {
	      options = {};
	    } else if (angular.isString(options)) {
	      options = {
	        standard : options
	      };
	    }
	
	    uniformLanguageTagResolver = options.standard;
	
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to try to determine on its own which language key
	   * to set as preferred language. When `fn` is given, angular-translate uses it
	   * to determine a language key, otherwise it uses the built-in `getLocale()`
	   * method.
	   *
	   * The `getLocale()` returns a language key in the format `[lang]_[country]` or
	   * `[lang]` depending on what the browser provides.
	   *
	   * Use this method at your own risk, since not all browsers return a valid
	   * locale (see {@link pascalprecht.translate.$translateProvider#methods_uniformLanguageTag uniformLanguageTag()}).
	   *
	   * @param {Function=} fn Function to determine a browser's locale
	   */
	  this.determinePreferredLanguage = function (fn) {
	
	    var locale = (fn && angular.isFunction(fn)) ? fn() : getLocale();
	
	    if (!$availableLanguageKeys.length) {
	      $preferredLanguage = locale;
	    } else {
	      $preferredLanguage = negotiateLocale(locale) || locale;
	    }
	
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a set of language keys the app will work with. Use this method in
	   * combination with
	   * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
	   * When available languages keys are registered, angular-translate
	   * tries to find the best fitting language key depending on the browsers locale,
	   * considering your language key convention.
	   *
	   * @param {object} languageKeys Array of language keys the your app will use
	   * @param {object=} aliases Alias map.
	   */
	  this.registerAvailableLanguageKeys = function (languageKeys, aliases) {
	    if (languageKeys) {
	      $availableLanguageKeys = languageKeys;
	      if (aliases) {
	        $languageKeyAliases = aliases;
	      }
	      return this;
	    }
	    return $availableLanguageKeys;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLoaderCache
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a cache for internal $http based loaders.
	   * {@link pascalprecht.translate.$translationCache $translationCache}.
	   * When false the cache will be disabled (default). When true or undefined
	   * the cache will be a default (see $cacheFactory). When an object it will
	   * be treat as a cache object itself: the usage is $http({cache: cache})
	   *
	   * @param {object} cache boolean, string or cache-object
	   */
	  this.useLoaderCache = function (cache) {
	    if (cache === false) {
	      // disable cache
	      loaderCache = undefined;
	    } else if (cache === true) {
	      // enable cache using AJS defaults
	      loaderCache = true;
	    } else if (typeof(cache) === 'undefined') {
	      // enable cache using default
	      loaderCache = '$translationCache';
	    } else if (cache) {
	      // enable cache using given one (see $cacheFactory)
	      loaderCache = cache;
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#directivePriority
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets the default priority of the translate directive. The standard value is `0`.
	   * Calling this function without an argument will return the current value.
	   *
	   * @param {number} priority for the translate-directive
	   */
	  this.directivePriority = function (priority) {
	    if (priority === undefined) {
	      // getter
	      return directivePriority;
	    } else {
	      // setter with chaining
	      directivePriority = priority;
	      return this;
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#statefulFilter
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Since AngularJS 1.3, filters which are not stateless (depending at the scope)
	   * have to explicit define this behavior.
	   * Sets whether the translate filter should be stateful or stateless. The standard value is `true`
	   * meaning being stateful.
	   * Calling this function without an argument will return the current value.
	   *
	   * @param {boolean} state - defines the state of the filter
	   */
	  this.statefulFilter = function (state) {
	    if (state === undefined) {
	      // getter
	      return statefulFilter;
	    } else {
	      // setter with chaining
	      statefulFilter = state;
	      return this;
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#postProcess
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * The post processor will be intercept right after the translation result. It can modify the result.
	   *
	   * @param {object} fn Function or service name (string) to be called after the translation value has been set / resolved. The function itself will enrich every value being processed and then continue the normal resolver process
	   */
	  this.postProcess = function (fn) {
	    if (fn) {
	      postProcessFn = fn;
	    } else {
	      postProcessFn = undefined;
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#keepContent
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If keepContent is set to true than translate directive will always use innerHTML
	   * as a default translation
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.keepContent(true);
	   *  });
	   * </pre>
	   *
	   * @param {boolean} value - valid values are true or false
	   */
	  this.keepContent = function (value) {
	    $keepContent = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translate
	   * @requires $interpolate
	   * @requires $log
	   * @requires $rootScope
	   * @requires $q
	   *
	   * @description
	   * The `$translate` service is the actual core of angular-translate. It expects a translation id
	   * and optional interpolate parameters to translate contents.
	   *
	   * <pre>
	   *  $translate('HEADLINE_TEXT').then(function (translation) {
	   *    $scope.translatedText = translation;
	   *  });
	   * </pre>
	   *
	   * @param {string|array} translationId A token which represents a translation id
	   *                                     This can be optionally an array of translation ids which
	   *                                     results that the function returns an object where each key
	   *                                     is the translation id and the value the translation.
	   * @param {object=} [interpolateParams={}] An object hash for dynamic values
	   * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
	   * @param {string=} [defaultTranslationText=undefined] the optional default translation text that is written as
	   *                                        as default text in case it is not found in any configured language
	   * @param {string=} [forceLanguage=false] A language to be used instead of the current language
	   * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
	   * @returns {object} promise
	   */
	  this.$get = ['$log', '$injector', '$rootScope', '$q', function ($log, $injector, $rootScope, $q) {
	
	    var Storage,
	      defaultInterpolator = $injector.get($interpolationFactory || '$translateDefaultInterpolation'),
	      pendingLoader = false,
	      interpolatorHashMap = {},
	      langPromises = {},
	      fallbackIndex,
	      startFallbackIteration;
	
	    var $translate = function (translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy) {
	      if (!$uses && $preferredLanguage) {
	        $uses = $preferredLanguage;
	      }
	      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
	        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;
	
	      // Check forceLanguage is present
	      if (forceLanguage) {
	        loadTranslationsIfMissing(forceLanguage);
	      }
	
	      // Duck detection: If the first argument is an array, a bunch of translations was requested.
	      // The result is an object.
	      if (angular.isArray(translationId)) {
	        // Inspired by Q.allSettled by Kris Kowal
	        // https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
	        // This transforms all promises regardless resolved or rejected
	        var translateAll = function (translationIds) {
	          var results = {}; // storing the actual results
	          var promises = []; // promises to wait for
	          // Wraps the promise a) being always resolved and b) storing the link id->value
	          var translate = function (translationId) {
	            var deferred = $q.defer();
	            var regardless = function (value) {
	              results[translationId] = value;
	              deferred.resolve([translationId, value]);
	            };
	            // we don't care whether the promise was resolved or rejected; just store the values
	            $translate(translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy).then(regardless, regardless);
	            return deferred.promise;
	          };
	          for (var i = 0, c = translationIds.length; i < c; i++) {
	            promises.push(translate(translationIds[i]));
	          }
	          // wait for all (including storing to results)
	          return $q.all(promises).then(function () {
	            // return the results
	            return results;
	          });
	        };
	        return translateAll(translationId);
	      }
	
	      var deferred = $q.defer();
	
	      // trim off any whitespace
	      if (translationId) {
	        translationId = trim.apply(translationId);
	      } else {
	        throw new TypeError('translationId must be a not empty string');
	      }
	
	      var promiseToWaitFor = (function () {
	        var promise = langPromises[uses] || langPromises[$preferredLanguage];
	
	        fallbackIndex = 0;
	
	        if ($storageFactory && !promise) {
	          // looks like there's no pending promise for $preferredLanguage or
	          // $uses. Maybe there's one pending for a language that comes from
	          // storage.
	          var langKey = Storage.get($storageKey);
	          promise = langPromises[langKey];
	
	          if ($fallbackLanguage && $fallbackLanguage.length) {
	            var index = indexOf($fallbackLanguage, langKey);
	            // maybe the language from storage is also defined as fallback language
	            // we increase the fallback language index to not search in that language
	            // as fallback, since it's probably the first used language
	            // in that case the index starts after the first element
	            fallbackIndex = (index === 0) ? 1 : 0;
	
	            // but we can make sure to ALWAYS fallback to preferred language at least
	            if (indexOf($fallbackLanguage, $preferredLanguage) < 0) {
	              $fallbackLanguage.push($preferredLanguage);
	            }
	          }
	        }
	        return promise;
	      }());
	
	      if (!promiseToWaitFor) {
	        // no promise to wait for? okay. Then there's no loader registered
	        // nor is a one pending for language that comes from storage.
	        // We can just translate.
	        determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	      } else {
	        var promiseResolved = function () {
	          // $uses may have changed while waiting
	          if (!forceLanguage) {
	            uses = $uses;
	          }
	          determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	        };
	        promiseResolved.displayName = 'promiseResolved';
	
	        promiseToWaitFor['finally'](promiseResolved)['catch'](angular.noop); // we don't care about errors here, already handled
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name applyNotFoundIndicators
	     * @private
	     *
	     * @description
	     * Applies not fount indicators to given translation id, if needed.
	     * This function gets only executed, if a translation id doesn't exist,
	     * which is why a translation id is expected as argument.
	     *
	     * @param {string} translationId Translation id.
	     * @returns {string} Same as given translation id but applied with not found
	     * indicators.
	     */
	    var applyNotFoundIndicators = function (translationId) {
	      // applying notFoundIndicators
	      if ($notFoundIndicatorLeft) {
	        translationId = [$notFoundIndicatorLeft, translationId].join(' ');
	      }
	      if ($notFoundIndicatorRight) {
	        translationId = [translationId, $notFoundIndicatorRight].join(' ');
	      }
	      return translationId;
	    };
	
	    /**
	     * @name useLanguage
	     * @private
	     *
	     * @description
	     * Makes actual use of a language by setting a given language key as used
	     * language and informs registered interpolators to also use the given
	     * key as locale.
	     *
	     * @param {string} key Locale key.
	     */
	    var useLanguage = function (key) {
	      $uses = key;
	
	      // make sure to store new language key before triggering success event
	      if ($storageFactory) {
	        Storage.put($translate.storageKey(), $uses);
	      }
	
	      $rootScope.$emit('$translateChangeSuccess', {language : key});
	
	      // inform default interpolator
	      defaultInterpolator.setLocale($uses);
	
	      var eachInterpolator = function (interpolator, id) {
	        interpolatorHashMap[id].setLocale($uses);
	      };
	      eachInterpolator.displayName = 'eachInterpolatorLocaleSetter';
	
	      // inform all others too!
	      angular.forEach(interpolatorHashMap, eachInterpolator);
	      $rootScope.$emit('$translateChangeEnd', {language : key});
	    };
	
	    /**
	     * @name loadAsync
	     * @private
	     *
	     * @description
	     * Kicks off registered async loader using `$injector` and applies existing
	     * loader options. When resolved, it updates translation tables accordingly
	     * or rejects with given language key.
	     *
	     * @param {string} key Language key.
	     * @return {Promise} A promise.
	     */
	    var loadAsync = function (key) {
	      if (!key) {
	        throw 'No language key specified for loading.';
	      }
	
	      var deferred = $q.defer();
	
	      $rootScope.$emit('$translateLoadingStart', {language : key});
	      pendingLoader = true;
	
	      var cache = loaderCache;
	      if (typeof(cache) === 'string') {
	        // getting on-demand instance of loader
	        cache = $injector.get(cache);
	      }
	
	      var loaderOptions = angular.extend({}, $loaderOptions, {
	        key : key,
	        $http : angular.extend({}, {
	          cache : cache
	        }, $loaderOptions.$http)
	      });
	
	      var onLoaderSuccess = function (data) {
	        var translationTable = {};
	        $rootScope.$emit('$translateLoadingSuccess', {language : key});
	
	        if (angular.isArray(data)) {
	          angular.forEach(data, function (table) {
	            angular.extend(translationTable, flatObject(table));
	          });
	        } else {
	          angular.extend(translationTable, flatObject(data));
	        }
	        pendingLoader = false;
	        deferred.resolve({
	          key : key,
	          table : translationTable
	        });
	        $rootScope.$emit('$translateLoadingEnd', {language : key});
	      };
	      onLoaderSuccess.displayName = 'onLoaderSuccess';
	
	      var onLoaderError = function (key) {
	        $rootScope.$emit('$translateLoadingError', {language : key});
	        deferred.reject(key);
	        $rootScope.$emit('$translateLoadingEnd', {language : key});
	      };
	      onLoaderError.displayName = 'onLoaderError';
	
	      $injector.get($loaderFactory)(loaderOptions)
	        .then(onLoaderSuccess, onLoaderError);
	
	      return deferred.promise;
	    };
	
	    if ($storageFactory) {
	      Storage = $injector.get($storageFactory);
	
	      if (!Storage.get || !Storage.put) {
	        throw new Error('Couldn\'t use storage \'' + $storageFactory + '\', missing get() or put() method!');
	      }
	    }
	
	    // if we have additional interpolations that were added via
	    // $translateProvider.addInterpolation(), we have to map'em
	    if ($interpolatorFactories.length) {
	      var eachInterpolationFactory = function (interpolatorFactory) {
	        var interpolator = $injector.get(interpolatorFactory);
	        // setting initial locale for each interpolation service
	        interpolator.setLocale($preferredLanguage || $uses);
	        // make'em recognizable through id
	        interpolatorHashMap[interpolator.getInterpolationIdentifier()] = interpolator;
	      };
	      eachInterpolationFactory.displayName = 'interpolationFactoryAdder';
	
	      angular.forEach($interpolatorFactories, eachInterpolationFactory);
	    }
	
	    /**
	     * @name getTranslationTable
	     * @private
	     *
	     * @description
	     * Returns a promise that resolves to the translation table
	     * or is rejected if an error occurred.
	     *
	     * @param langKey
	     * @returns {Q.promise}
	     */
	    var getTranslationTable = function (langKey) {
	      var deferred = $q.defer();
	      if (Object.prototype.hasOwnProperty.call($translationTable, langKey)) {
	        deferred.resolve($translationTable[langKey]);
	      } else if (langPromises[langKey]) {
	        var onResolve = function (data) {
	          translations(data.key, data.table);
	          deferred.resolve(data.table);
	        };
	        onResolve.displayName = 'translationTableResolver';
	        langPromises[langKey].then(onResolve, deferred.reject);
	      } else {
	        deferred.reject();
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name getFallbackTranslation
	     * @private
	     *
	     * @description
	     * Returns a promise that will resolve to the translation
	     * or be rejected if no translation was found for the language.
	     * This function is currently only used for fallback language translation.
	     *
	     * @param langKey The language to translate to.
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {Q.promise}
	     */
	    var getFallbackTranslation = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var deferred = $q.defer();
	
	      var onResolve = function (translationTable) {
	        if (Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
	          Interpolator.setLocale(langKey);
	          var translation = translationTable[translationId];
	          if (translation.substr(0, 2) === '@:') {
	            getFallbackTranslation(langKey, translation.substr(2), interpolateParams, Interpolator, sanitizeStrategy)
	              .then(deferred.resolve, deferred.reject);
	          } else {
	            var interpolatedValue = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'service', sanitizeStrategy, translationId);
	            interpolatedValue = applyPostProcessing(translationId, translationTable[translationId], interpolatedValue, interpolateParams, langKey);
	
	            deferred.resolve(interpolatedValue);
	
	          }
	          Interpolator.setLocale($uses);
	        } else {
	          deferred.reject();
	        }
	      };
	      onResolve.displayName = 'fallbackTranslationResolver';
	
	      getTranslationTable(langKey).then(onResolve, deferred.reject);
	
	      return deferred.promise;
	    };
	
	    /**
	     * @name getFallbackTranslationInstant
	     * @private
	     *
	     * @description
	     * Returns a translation
	     * This function is currently only used for fallback language translation.
	     *
	     * @param langKey The language to translate to.
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy sanitize strategy override
	     *
	     * @returns {string} translation
	     */
	    var getFallbackTranslationInstant = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var result, translationTable = $translationTable[langKey];
	
	      if (translationTable && Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
	        Interpolator.setLocale(langKey);
	        result = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'filter', sanitizeStrategy, translationId);
	        result = applyPostProcessing(translationId, translationTable[translationId], result, interpolateParams, langKey, sanitizeStrategy);
	        // workaround for TrustedValueHolderType
	        if (!angular.isString(result) && angular.isFunction(result.$$unwrapTrustedValue)) {
	          var result2 = result.$$unwrapTrustedValue();
	          if (result2.substr(0, 2) === '@:') {
	            return getFallbackTranslationInstant(langKey, result2.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
	          }
	        } else if (result.substr(0, 2) === '@:') {
	          return getFallbackTranslationInstant(langKey, result.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
	        }
	        Interpolator.setLocale($uses);
	      }
	
	      return result;
	    };
	
	
	    /**
	     * @name translateByHandler
	     * @private
	     *
	     * Translate by missing translation handler.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param defaultTranslationText
	     * @param sanitizeStrategy sanitize strategy override
	     *
	     * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
	     * absent
	     */
	    var translateByHandler = function (translationId, interpolateParams, defaultTranslationText, sanitizeStrategy) {
	      // If we have a handler factory - we might also call it here to determine if it provides
	      // a default text for a translationid that can't be found anywhere in our tables
	      if ($missingTranslationHandlerFactory) {
	        return $injector.get($missingTranslationHandlerFactory)(translationId, $uses, interpolateParams, defaultTranslationText, sanitizeStrategy);
	      } else {
	        return translationId;
	      }
	    };
	
	    /**
	     * @name resolveForFallbackLanguage
	     * @private
	     *
	     * Recursive helper function for fallbackTranslation that will sequentially look
	     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	     *
	     * @param fallbackLanguageIndex
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param defaultTranslationText
	     * @param sanitizeStrategy
	     * @returns {Q.promise} Promise that will resolve to the translation.
	     */
	    var resolveForFallbackLanguage = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
	      var deferred = $q.defer();
	
	      if (fallbackLanguageIndex < $fallbackLanguage.length) {
	        var langKey = $fallbackLanguage[fallbackLanguageIndex];
	        getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy).then(
	          function (data) {
	            deferred.resolve(data);
	          },
	          function () {
	            // Look in the next fallback language for a translation.
	            // It delays the resolving by passing another promise to resolve.
	            return resolveForFallbackLanguage(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	          }
	        );
	      } else {
	        // No translation found in any fallback language
	        // if a default translation text is set in the directive, then return this as a result
	        if (defaultTranslationText) {
	          deferred.resolve(defaultTranslationText);
	        } else {
	          var missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
	
	          // if no default translation is set and an error handler is defined, send it to the handler
	          // and then return the result if it isn't undefined
	          if ($missingTranslationHandlerFactory && missingTranslationHandlerTranslation) {
	            deferred.resolve(missingTranslationHandlerTranslation);
	          } else {
	            deferred.reject(applyNotFoundIndicators(translationId));
	          }
	        }
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name resolveForFallbackLanguageInstant
	     * @private
	     *
	     * Recursive helper function for fallbackTranslation that will sequentially look
	     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	     *
	     * @param fallbackLanguageIndex
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {string} translation
	     */
	    var resolveForFallbackLanguageInstant = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var result;
	
	      if (fallbackLanguageIndex < $fallbackLanguage.length) {
	        var langKey = $fallbackLanguage[fallbackLanguageIndex];
	        result = getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy);
	        if (!result && result !== '') {
	          result = resolveForFallbackLanguageInstant(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator);
	        }
	      }
	      return result;
	    };
	
	    /**
	     * Translates with the usage of the fallback languages.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param defaultTranslationText
	     * @param sanitizeStrategy
	     * @returns {Q.promise} Promise, that resolves to the translation.
	     */
	    var fallbackTranslation = function (translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
	      // Start with the fallbackLanguage with index 0
	      return resolveForFallbackLanguage((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy);
	    };
	
	    /**
	     * Translates with the usage of the fallback languages.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {String} translation
	     */
	    var fallbackTranslationInstant = function (translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      // Start with the fallbackLanguage with index 0
	      return resolveForFallbackLanguageInstant((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, sanitizeStrategy);
	    };
	
	    var determineTranslation = function (translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy) {
	
	      var deferred = $q.defer();
	
	      var table = uses ? $translationTable[uses] : $translationTable,
	        Interpolator = (interpolationId) ? interpolatorHashMap[interpolationId] : defaultInterpolator;
	
	      // if the translation id exists, we can just interpolate it
	      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
	        var translation = table[translationId];
	
	        // If using link, rerun $translate with linked translationId and return it
	        if (translation.substr(0, 2) === '@:') {
	
	          $translate(translation.substr(2), interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy)
	            .then(deferred.resolve, deferred.reject);
	        } else {
	          //
	          var resolvedTranslation = Interpolator.interpolate(translation, interpolateParams, 'service', sanitizeStrategy, translationId);
	          resolvedTranslation = applyPostProcessing(translationId, translation, resolvedTranslation, interpolateParams, uses);
	          deferred.resolve(resolvedTranslation);
	        }
	      } else {
	        var missingTranslationHandlerTranslation;
	        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	        if ($missingTranslationHandlerFactory && !pendingLoader) {
	          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
	        }
	
	        // since we couldn't translate the inital requested translation id,
	        // we try it now with one or more fallback languages, if fallback language(s) is
	        // configured.
	        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
	          fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy)
	            .then(function (translation) {
	              deferred.resolve(translation);
	            }, function (_translationId) {
	              deferred.reject(applyNotFoundIndicators(_translationId));
	            });
	        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          if (defaultTranslationText) {
	            deferred.resolve(defaultTranslationText);
	          } else {
	            deferred.resolve(missingTranslationHandlerTranslation);
	          }
	        } else {
	          if (defaultTranslationText) {
	            deferred.resolve(defaultTranslationText);
	          } else {
	            deferred.reject(applyNotFoundIndicators(translationId));
	          }
	        }
	      }
	      return deferred.promise;
	    };
	
	    var determineTranslationInstant = function (translationId, interpolateParams, interpolationId, uses, sanitizeStrategy) {
	
	      var result, table = uses ? $translationTable[uses] : $translationTable,
	        Interpolator = defaultInterpolator;
	
	      // if the interpolation id exists use custom interpolator
	      if (interpolatorHashMap && Object.prototype.hasOwnProperty.call(interpolatorHashMap, interpolationId)) {
	        Interpolator = interpolatorHashMap[interpolationId];
	      }
	
	      // if the translation id exists, we can just interpolate it
	      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
	        var translation = table[translationId];
	
	        // If using link, rerun $translate with linked translationId and return it
	        if (translation.substr(0, 2) === '@:') {
	          result = determineTranslationInstant(translation.substr(2), interpolateParams, interpolationId, uses, sanitizeStrategy);
	        } else {
	          result = Interpolator.interpolate(translation, interpolateParams, 'filter', sanitizeStrategy, translationId);
	          result = applyPostProcessing(translationId, translation, result, interpolateParams, uses, sanitizeStrategy);
	        }
	      } else {
	        var missingTranslationHandlerTranslation;
	        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	        if ($missingTranslationHandlerFactory && !pendingLoader) {
	          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
	        }
	
	        // since we couldn't translate the inital requested translation id,
	        // we try it now with one or more fallback languages, if fallback language(s) is
	        // configured.
	        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
	          fallbackIndex = 0;
	          result = fallbackTranslationInstant(translationId, interpolateParams, Interpolator, sanitizeStrategy);
	        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          result = missingTranslationHandlerTranslation;
	        } else {
	          result = applyNotFoundIndicators(translationId);
	        }
	      }
	
	      return result;
	    };
	
	    var clearNextLangAndPromise = function (key) {
	      if ($nextLang === key) {
	        $nextLang = undefined;
	      }
	      langPromises[key] = undefined;
	    };
	
	    var applyPostProcessing = function (translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy) {
	      var fn = postProcessFn;
	
	      if (fn) {
	
	        if (typeof(fn) === 'string') {
	          // getting on-demand instance
	          fn = $injector.get(fn);
	        }
	        if (fn) {
	          return fn(translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy);
	        }
	      }
	
	      return resolvedTranslation;
	    };
	
	    var loadTranslationsIfMissing = function (key) {
	      if (!$translationTable[key] && $loaderFactory && !langPromises[key]) {
	        langPromises[key] = loadAsync(key).then(function (translation) {
	          translations(translation.key, translation.table);
	          return translation;
	        });
	      }
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#preferredLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key for the preferred language.
	     *
	     * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
	     *
	     * @return {string} preferred language key
	     */
	    $translate.preferredLanguage = function (langKey) {
	      if (langKey) {
	        setupPreferredLanguage(langKey);
	      }
	      return $preferredLanguage;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#cloakClassName
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the configured class name for `translate-cloak` directive.
	     *
	     * @return {string} cloakClassName
	     */
	    $translate.cloakClassName = function () {
	      return $cloakClassName;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#allowNamespaces
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns if namespaces are enabled
	     *
	     * @return {boolean} allowNamespaces value
	     */
	    $translate.allowNamespaces = function () {
	      return $allowNamespaces;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#nestedObjectDelimeter
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the configured delimiter for nested namespaces.
	     *
	     * @return {string} nestedObjectDelimeter
	     */
	    $translate.nestedObjectDelimeter = function () {
	      return $nestedObjectDelimeter;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#fallbackLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key for the fallback languages or sets a new fallback stack.
	     * It is recommended to call this before {@link pascalprecht.translate.$translateProvider#preferredLanguage preferredLanguage()}.
	     *
	     * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
	     *
	     * @return {string||array} fallback language key
	     */
	    $translate.fallbackLanguage = function (langKey) {
	      if (langKey !== undefined && langKey !== null) {
	        fallbackStack(langKey);
	
	        // as we might have an async loader initiated and a new translation language might have been defined
	        // we need to add the promise to the stack also. So - iterate.
	        if ($loaderFactory) {
	          if ($fallbackLanguage && $fallbackLanguage.length) {
	            for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	              if (!langPromises[$fallbackLanguage[i]]) {
	                langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]);
	              }
	            }
	          }
	        }
	        $translate.use($translate.use());
	      }
	      if ($fallbackWasString) {
	        return $fallbackLanguage[0];
	      } else {
	        return $fallbackLanguage;
	      }
	
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#useFallbackLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Sets the first key of the fallback language stack to be used for translation.
	     * Therefore all languages in the fallback array BEFORE this key will be skipped!
	     *
	     * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
	     * get back to the whole stack
	     */
	    $translate.useFallbackLanguage = function (langKey) {
	      if (langKey !== undefined && langKey !== null) {
	        if (!langKey) {
	          startFallbackIteration = 0;
	        } else {
	          var langKeyPosition = indexOf($fallbackLanguage, langKey);
	          if (langKeyPosition > -1) {
	            startFallbackIteration = langKeyPosition;
	          }
	        }
	
	      }
	
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#proposedLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key of language that is currently loaded asynchronously.
	     *
	     * @return {string} language key
	     */
	    $translate.proposedLanguage = function () {
	      return $nextLang;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#storage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns registered storage.
	     *
	     * @return {object} Storage
	     */
	    $translate.storage = function () {
	      return Storage;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#negotiateLocale
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns a language key based on available languages and language aliases. If a
	     * language key cannot be resolved, returns undefined.
	     *
	     * If no or a falsy key is given, returns undefined.
	     *
	     * @param {string} [key] Language key
	     * @return {string|undefined} Language key or undefined if no language key is found.
	     */
	    $translate.negotiateLocale = negotiateLocale;
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#use
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Tells angular-translate which language to use by given language key. This method is
	     * used to change language at runtime. It also takes care of storing the language
	     * key in a configured store to let your app remember the choosed language.
	     *
	     * When trying to 'use' a language which isn't available it tries to load it
	     * asynchronously with registered loaders.
	     *
	     * Returns promise object with loaded language file data or string of the currently used language.
	     *
	     * If no or a falsy key is given it returns the currently used language key.
	     * The returned string will be ```undefined``` if setting up $translate hasn't finished.
	     * @example
	     * $translate.use("en_US").then(function(data){
	       *   $scope.text = $translate("HELLO");
	       * });
	     *
	     * @param {string=} key Language key
	     * @return {object|string} Promise with loaded language data or the language key if a falsy param was given.
	     */
	    $translate.use = function (key) {
	      if (!key) {
	        return $uses;
	      }
	
	      var deferred = $q.defer();
	      deferred.promise.then(null, angular.noop); // AJS "Possibly unhandled rejection"
	
	      $rootScope.$emit('$translateChangeStart', {language : key});
	
	      // Try to get the aliased language key
	      var aliasedKey = negotiateLocale(key);
	      // Ensure only registered language keys will be loaded
	      if ($availableLanguageKeys.length > 0 && !aliasedKey) {
	        return $q.reject(key);
	      }
	
	      if (aliasedKey) {
	        key = aliasedKey;
	      }
	
	      // if there isn't a translation table for the language we've requested,
	      // we load it asynchronously
	      $nextLang = key;
	      if (($forceAsyncReloadEnabled || !$translationTable[key]) && $loaderFactory && !langPromises[key]) {
	        langPromises[key] = loadAsync(key).then(function (translation) {
	          translations(translation.key, translation.table);
	          deferred.resolve(translation.key);
	          if ($nextLang === key) {
	            useLanguage(translation.key);
	          }
	          return translation;
	        }, function (key) {
	          $rootScope.$emit('$translateChangeError', {language : key});
	          deferred.reject(key);
	          $rootScope.$emit('$translateChangeEnd', {language : key});
	          return $q.reject(key);
	        });
	        langPromises[key]['finally'](function () {
	          clearNextLangAndPromise(key);
	        })['catch'](angular.noop); // we don't care about errors (clearing)
	      } else if (langPromises[key]) {
	        // we are already loading this asynchronously
	        // resolve our new deferred when the old langPromise is resolved
	        langPromises[key].then(function (translation) {
	          if ($nextLang === translation.key) {
	            useLanguage(translation.key);
	          }
	          deferred.resolve(translation.key);
	          return translation;
	        }, function (key) {
	          // find first available fallback language if that request has failed
	          if (!$uses && $fallbackLanguage && $fallbackLanguage.length > 0 && $fallbackLanguage[0] !== key) {
	            return $translate.use($fallbackLanguage[0]).then(deferred.resolve, deferred.reject);
	          } else {
	            return deferred.reject(key);
	          }
	        });
	      } else {
	        deferred.resolve(key);
	        useLanguage(key);
	      }
	
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#resolveClientLocale
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
	     *
	     * @returns {string} the current client/browser language key
	     */
	    $translate.resolveClientLocale = function () {
	      return getLocale();
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#storageKey
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the key for the storage.
	     *
	     * @return {string} storage key
	     */
	    $translate.storageKey = function () {
	      return storageKey();
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isPostCompilingEnabled
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether post compiling is enabled or not
	     *
	     * @return {bool} storage key
	     */
	    $translate.isPostCompilingEnabled = function () {
	      return $postCompilingEnabled;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isForceAsyncReloadEnabled
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether force async reload is enabled or not
	     *
	     * @return {boolean} forceAsyncReload value
	     */
	    $translate.isForceAsyncReloadEnabled = function () {
	      return $forceAsyncReloadEnabled;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isKeepContent
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether keepContent or not
	     *
	     * @return {boolean} keepContent value
	     */
	    $translate.isKeepContent = function () {
	      return $keepContent;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#refresh
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
	     * the module will drop all existent translation tables and load new version of those which
	     * are currently in use.
	     *
	     * Refresh means that the module will drop target translation table and try to load it again.
	     *
	     * In case there are no loaders registered the refresh() method will throw an Error.
	     *
	     * If the module is able to refresh translation tables refresh() method will broadcast
	     * $translateRefreshStart and $translateRefreshEnd events.
	     *
	     * @example
	     * // this will drop all currently existent translation tables and reload those which are
	     * // currently in use
	     * $translate.refresh();
	     * // this will refresh a translation table for the en_US language
	     * $translate.refresh('en_US');
	     *
	     * @param {string} langKey A language key of the table, which has to be refreshed
	     *
	     * @return {promise} Promise, which will be resolved in case a translation tables refreshing
	     * process is finished successfully, and reject if not.
	     */
	    $translate.refresh = function (langKey) {
	      if (!$loaderFactory) {
	        throw new Error('Couldn\'t refresh translation table, no loader registered!');
	      }
	
	      $rootScope.$emit('$translateRefreshStart', {language : langKey});
	
	      var deferred = $q.defer(), updatedLanguages = {};
	
	      //private helper
	      function loadNewData(languageKey) {
	        var promise = loadAsync(languageKey);
	        //update the load promise cache for this language
	        langPromises[languageKey] = promise;
	        //register a data handler for the promise
	        promise.then(function (data) {
	            //clear the cache for this language
	            $translationTable[languageKey] = {};
	            //add the new data for this language
	            translations(languageKey, data.table);
	            //track that we updated this language
	            updatedLanguages[languageKey] = true;
	          },
	          //handle rejection to appease the $q validation
	          angular.noop);
	        return promise;
	      }
	
	      //set up post-processing
	      deferred.promise.then(
	        function () {
	          for (var key in $translationTable) {
	            if ($translationTable.hasOwnProperty(key)) {
	              //delete cache entries that were not updated
	              if (!(key in updatedLanguages)) {
	                delete $translationTable[key];
	              }
	            }
	          }
	          if ($uses) {
	            useLanguage($uses);
	          }
	        },
	        //handle rejection to appease the $q validation
	        angular.noop
	      )['finally'](
	        function () {
	          $rootScope.$emit('$translateRefreshEnd', {language : langKey});
	        }
	      );
	
	      if (!langKey) {
	        // if there's no language key specified we refresh ALL THE THINGS!
	        var languagesToReload = $fallbackLanguage && $fallbackLanguage.slice() || [];
	        if ($uses && languagesToReload.indexOf($uses) === -1) {
	          languagesToReload.push($uses);
	        }
	        $q.all(languagesToReload.map(loadNewData)).then(deferred.resolve, deferred.reject);
	
	      } else if ($translationTable[langKey]) {
	        //just refresh the specified language cache
	        loadNewData(langKey).then(deferred.resolve, deferred.reject);
	
	      } else {
	        deferred.reject();
	      }
	
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#instant
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns a translation instantly from the internal state of loaded translation. All rules
	     * regarding the current language, the preferred language of even fallback languages will be
	     * used except any promise handling. If a language was not found, an asynchronous loading
	     * will be invoked in the background.
	     *
	     * @param {string|array} translationId A token which represents a translation id
	     *                                     This can be optionally an array of translation ids which
	     *                                     results that the function's promise returns an object where
	     *                                     each key is the translation id and the value the translation.
	     * @param {object=} [interpolateParams={}] Params
	     * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
	     * @param {string=} [forceLanguage=false] A language to be used instead of the current language
	     * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
	     *
	     * @return {string|object} translation
	     */
	    $translate.instant = function (translationId, interpolateParams, interpolationId, forceLanguage, sanitizeStrategy) {
	
	      // we don't want to re-negotiate $uses
	      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
	        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;
	
	      // Detect undefined and null values to shorten the execution and prevent exceptions
	      if (translationId === null || angular.isUndefined(translationId)) {
	        return translationId;
	      }
	
	      // Check forceLanguage is present
	      if (forceLanguage) {
	        loadTranslationsIfMissing(forceLanguage);
	      }
	
	      // Duck detection: If the first argument is an array, a bunch of translations was requested.
	      // The result is an object.
	      if (angular.isArray(translationId)) {
	        var results = {};
	        for (var i = 0, c = translationId.length; i < c; i++) {
	          results[translationId[i]] = $translate.instant(translationId[i], interpolateParams, interpolationId, forceLanguage, sanitizeStrategy);
	        }
	        return results;
	      }
	
	      // We discarded unacceptable values. So we just need to verify if translationId is empty String
	      if (angular.isString(translationId) && translationId.length < 1) {
	        return translationId;
	      }
	
	      // trim off any whitespace
	      if (translationId) {
	        translationId = trim.apply(translationId);
	      }
	
	      var result, possibleLangKeys = [];
	      if ($preferredLanguage) {
	        possibleLangKeys.push($preferredLanguage);
	      }
	      if (uses) {
	        possibleLangKeys.push(uses);
	      }
	      if ($fallbackLanguage && $fallbackLanguage.length) {
	        possibleLangKeys = possibleLangKeys.concat($fallbackLanguage);
	      }
	      for (var j = 0, d = possibleLangKeys.length; j < d; j++) {
	        var possibleLangKey = possibleLangKeys[j];
	        if ($translationTable[possibleLangKey]) {
	          if (typeof $translationTable[possibleLangKey][translationId] !== 'undefined') {
	            result = determineTranslationInstant(translationId, interpolateParams, interpolationId, uses, sanitizeStrategy);
	          }
	        }
	        if (typeof result !== 'undefined') {
	          break;
	        }
	      }
	
	      if (!result && result !== '') {
	        if ($notFoundIndicatorLeft || $notFoundIndicatorRight) {
	          result = applyNotFoundIndicators(translationId);
	        } else {
	          // Return translation of default interpolator if not found anything.
	          result = defaultInterpolator.interpolate(translationId, interpolateParams, 'filter', sanitizeStrategy);
	
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          var missingTranslationHandlerTranslation;
	          if ($missingTranslationHandlerFactory && !pendingLoader) {
	            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
	          }
	
	          if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	            result = missingTranslationHandlerTranslation;
	          }
	        }
	      }
	
	      return result;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#versionInfo
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the current version information for the angular-translate library
	     *
	     * @return {string} angular-translate version
	     */
	    $translate.versionInfo = function () {
	      return version;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#loaderCache
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the defined loaderCache.
	     *
	     * @return {boolean|string|object} current value of loaderCache
	     */
	    $translate.loaderCache = function () {
	      return loaderCache;
	    };
	
	    // internal purpose only
	    $translate.directivePriority = function () {
	      return directivePriority;
	    };
	
	    // internal purpose only
	    $translate.statefulFilter = function () {
	      return statefulFilter;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isReady
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether the service is "ready" to translate (i.e. loading 1st language).
	     *
	     * See also {@link pascalprecht.translate.$translate#methods_onReady onReady()}.
	     *
	     * @return {boolean} current value of ready
	     */
	    $translate.isReady = function () {
	      return $isReady;
	    };
	
	    var $onReadyDeferred = $q.defer();
	    $onReadyDeferred.promise.then(function () {
	      $isReady = true;
	    });
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#onReady
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Calls the function provided or resolved the returned promise after the service is "ready" to translate (i.e. loading 1st language).
	     *
	     * See also {@link pascalprecht.translate.$translate#methods_isReady isReady()}.
	     *
	     * @param {Function=} fn Function to invoke when service is ready
	     * @return {object} Promise resolved when service is ready
	     */
	    $translate.onReady = function (fn) {
	      var deferred = $q.defer();
	      if (angular.isFunction(fn)) {
	        deferred.promise.then(fn);
	      }
	      if ($isReady) {
	        deferred.resolve();
	      } else {
	        $onReadyDeferred.promise.then(deferred.resolve);
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#getAvailableLanguageKeys
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * This function simply returns the registered language keys being defined before in the config phase
	     * With this, an application can use the array to provide a language selection dropdown or similar
	     * without any additional effort
	     *
	     * @returns {object} returns the list of possibly registered language keys and mapping or null if not defined
	     */
	    $translate.getAvailableLanguageKeys = function () {
	      if ($availableLanguageKeys.length > 0) {
	        return $availableLanguageKeys;
	      }
	      return null;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#getTranslationTable
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns translation table by the given language key.
	     *
	     * Unless a language is provided it returns a translation table of the current one.
	     * Note: If translation dictionary is currently downloading or in progress
	     * it will return null.
	     *
	     * @param {string} langKey A token which represents a translation id
	     *
	     * @return {object} a copy of angular-translate $translationTable
	     */
	    $translate.getTranslationTable = function (langKey) {
	      langKey = langKey || $translate.use();
	      if (langKey && $translationTable[langKey]) {
	        return angular.copy($translationTable[langKey]);
	      }
	      return null;
	    };
	
	    // Whenever $translateReady is being fired, this will ensure the state of $isReady
	    var globalOnReadyListener = $rootScope.$on('$translateReady', function () {
	      $onReadyDeferred.resolve();
	      globalOnReadyListener(); // one time only
	      globalOnReadyListener = null;
	    });
	    var globalOnChangeListener = $rootScope.$on('$translateChangeEnd', function () {
	      $onReadyDeferred.resolve();
	      globalOnChangeListener(); // one time only
	      globalOnChangeListener = null;
	    });
	
	    if ($loaderFactory) {
	
	      // If at least one async loader is defined and there are no
	      // (default) translations available we should try to load them.
	      if (angular.equals($translationTable, {})) {
	        if ($translate.use()) {
	          $translate.use($translate.use());
	        }
	      }
	
	      // Also, if there are any fallback language registered, we start
	      // loading them asynchronously as soon as we can.
	      if ($fallbackLanguage && $fallbackLanguage.length) {
	        var processAsyncResult = function (translation) {
	          translations(translation.key, translation.table);
	          $rootScope.$emit('$translateChangeEnd', {language : translation.key});
	          return translation;
	        };
	        for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	          var fallbackLanguageId = $fallbackLanguage[i];
	          if ($forceAsyncReloadEnabled || !$translationTable[fallbackLanguageId]) {
	            langPromises[fallbackLanguageId] = loadAsync(fallbackLanguageId).then(processAsyncResult);
	          }
	        }
	      }
	    } else {
	      $rootScope.$emit('$translateReady', {language : $translate.use()});
	    }
	
	    return $translate;
	  }];
	}
	
	$translate.displayName = 'displayName';
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateDefaultInterpolation
	 * @requires $interpolate
	 *
	 * @description
	 * Uses angular's `$interpolate` services to interpolate strings against some values.
	 *
	 * Be aware to configure a proper sanitization strategy.
	 *
	 * See also:
	 * * {@link pascalprecht.translate.$translateSanitization}
	 *
	 * @return {object} $translateDefaultInterpolation Interpolator service
	 */
	angular.module('pascalprecht.translate').factory('$translateDefaultInterpolation', $translateDefaultInterpolation);
	
	function $translateDefaultInterpolation ($interpolate, $translateSanitization) {
	
	  'use strict';
	
	  var $translateInterpolator = {},
	      $locale,
	      $identifier = 'default';
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Sets current locale (this is currently not use in this interpolation).
	   *
	   * @param {string} locale Language key or locale.
	   */
	  $translateInterpolator.setLocale = function (locale) {
	    $locale = locale;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Returns an identifier for this interpolation service.
	   *
	   * @returns {string} $identifier
	   */
	  $translateInterpolator.getInterpolationIdentifier = function () {
	    return $identifier;
	  };
	
	  /**
	   * @deprecated will be removed in 3.0
	   * @see {@link pascalprecht.translate.$translateSanitization}
	   */
	  $translateInterpolator.useSanitizeValueStrategy = function (value) {
	    $translateSanitization.useStrategy(value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Interpolates given value agains given interpolate params using angulars
	   * `$interpolate` service.
	   *
	   * Since AngularJS 1.5, `value` must not be a string but can be anything input.
	   *
	   * @param {string} value translation
	   * @param {object} [interpolationParams={}] interpolation params
	   * @param {string} [context=undefined] current context (filter, directive, service)
	   * @param {string} [sanitizeStrategy=undefined] sanitize strategy (use default unless set)
	   * @param {string} translationId current translationId
	   *
	   * @returns {string} interpolated string
	   */
	  $translateInterpolator.interpolate = function (value, interpolationParams, context, sanitizeStrategy, translationId) { // jshint ignore:line
	    interpolationParams = interpolationParams || {};
	    interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params', sanitizeStrategy, context);
	
	    var interpolatedText;
	    if (angular.isNumber(value)) {
	      // numbers are safe
	      interpolatedText = '' + value;
	    } else if (angular.isString(value)) {
	      // strings must be interpolated (that's the job here)
	      interpolatedText = $interpolate(value)(interpolationParams);
	      interpolatedText = $translateSanitization.sanitize(interpolatedText, 'text', sanitizeStrategy, context);
	    } else {
	      // neither a number or a string, cant interpolate => empty string
	      interpolatedText = '';
	    }
	
	    return interpolatedText;
	  };
	
	  return $translateInterpolator;
	}
	
	$translateDefaultInterpolation.displayName = '$translateDefaultInterpolation';
	
	angular.module('pascalprecht.translate').constant('$STORAGE_KEY', 'NG_TRANSLATE_LANG_KEY');
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translate
	 * @requires $interpolate,
	 * @requires $compile,
	 * @requires $parse,
	 * @requires $rootScope
	 * @restrict AE
	 *
	 * @description
	 * Translates given translation id either through attribute or DOM content.
	 * Internally it uses $translate service to translate the translation id. It possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate Translation id which could be either string or interpolated string.
	 * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
	 * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
	 * @param {string=} translate-default will be used unless translation was successful
	 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
	 * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translateProvider#methods_usePostCompiling}
	 * @param {boolean=} translate-keep-content (default true if present) defines that in case a KEY could not be translated, that the existing content is left in the innerHTML}
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <pre translate="TRANSLATION_ID"></pre>
	        <pre translate>TRANSLATION_ID</pre>
	        <pre translate translate-attr-title="TRANSLATION_ID"></pre>
	        <pre translate="{{translationId}}"></pre>
	        <pre translate>{{translationId}}</pre>
	        <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
	        <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
	        <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
	        <pre translate translate-values="{{values}}">WITH_VALUES</pre>
	        <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>
	        <pre translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hi"></pre>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}',
	          'WITH_CAMEL_CASE_KEY': 'The interpolation key is camel cased: {{camelCaseKey}}'
	        }).preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	    <file name="scenario.js">
	      it('should translate', function () {
	        inject(function ($rootScope, $compile) {
	          $rootScope.translationId = 'TRANSLATION_ID';
	
	          element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate>{{translationId}}</p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.attr('title')).toBe('Hello there!');
	
	          element = $compile('<p translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hello"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('The interpolation key is camel cased: Hello');
	        });
	      });
	    </file>
	   </example>
	 */
	.directive('translate', translateDirective);
	function translateDirective($translate, $interpolate, $compile, $parse, $rootScope) {
	
	  'use strict';
	
	  /**
	   * @name trim
	   * @private
	   *
	   * @description
	   * trim polyfill
	   *
	   * @returns {string} The string stripped of whitespace from both ends
	   */
	  var trim = function() {
	    return this.toString().replace(/^\s+|\s+$/g, '');
	  };
	
	  /**
	   * @name lowercase
	   * @private
	   *
	   * @description
	   * Return the lowercase string only if the type is string
	   *
	   * @returns {string} The string all in lowercase
	   */
	  var lowercase = function (string) {
	    return angular.isString(string) ? string.toLowerCase() : string;
	  };
	
	  return {
	    restrict: 'AE',
	    scope: true,
	    priority: $translate.directivePriority(),
	    compile: function (tElement, tAttr) {
	
	      var translateValuesExist = (tAttr.translateValues) ?
	        tAttr.translateValues : undefined;
	
	      var translateInterpolation = (tAttr.translateInterpolation) ?
	        tAttr.translateInterpolation : undefined;
	
	      var translateSanitizeStrategyExist = (tAttr.translateSanitizeStrategy) ?
	        tAttr.translateSanitizeStrategy : undefined;
	
	      var translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);
	
	      var interpolateRegExp = '^(.*)(' + $interpolate.startSymbol() + '.*' + $interpolate.endSymbol() + ')(.*)',
	          watcherRegExp = '^(.*)' + $interpolate.startSymbol() + '(.*)' + $interpolate.endSymbol() + '(.*)';
	
	      return function linkFn(scope, iElement, iAttr) {
	
	        scope.interpolateParams = {};
	        scope.preText = '';
	        scope.postText = '';
	        scope.translateNamespace = getTranslateNamespace(scope);
	        var translationIds = {};
	
	        var initInterpolationParams = function (interpolateParams, iAttr, tAttr) {
	          // initial setup
	          if (iAttr.translateValues) {
	            angular.extend(interpolateParams, $parse(iAttr.translateValues)(scope.$parent));
	          }
	          // initially fetch all attributes if existing and fill the params
	          if (translateValueExist) {
	            for (var attr in tAttr) {
	              if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
	                var attributeName = lowercase(attr.substr(14, 1)) + attr.substr(15);
	                interpolateParams[attributeName] = tAttr[attr];
	              }
	            }
	          }
	        };
	
	        // Ensures any change of the attribute "translate" containing the id will
	        // be re-stored to the scope's "translationId".
	        // If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
	        var observeElementTranslation = function (translationId) {
	
	          // Remove any old watcher
	          if (angular.isFunction(observeElementTranslation._unwatchOld)) {
	            observeElementTranslation._unwatchOld();
	            observeElementTranslation._unwatchOld = undefined;
	          }
	
	          if (angular.equals(translationId , '') || !angular.isDefined(translationId)) {
	            var iElementText = trim.apply(iElement.text()).replace(/\n/g, ' ');
	
	            // Resolve translation id by inner html if required
	            var interpolateMatches = iElementText.match(interpolateRegExp);
	            // Interpolate translation id if required
	            if (angular.isArray(interpolateMatches)) {
	              scope.preText = interpolateMatches[1];
	              scope.postText = interpolateMatches[3];
	              translationIds.translate = $interpolate(interpolateMatches[2])(scope.$parent);
	              var watcherMatches = iElementText.match(watcherRegExp);
	              if (angular.isArray(watcherMatches) && watcherMatches[2] && watcherMatches[2].length) {
	                observeElementTranslation._unwatchOld = scope.$watch(watcherMatches[2], function (newValue) {
	                  translationIds.translate = newValue;
	                  updateTranslations();
	                });
	              }
	            } else {
	              // do not assigne the translation id if it is empty.
	              translationIds.translate = !iElementText ? undefined : iElementText;
	            }
	          } else {
	            translationIds.translate = translationId;
	          }
	          updateTranslations();
	        };
	
	        var observeAttributeTranslation = function (translateAttr) {
	          iAttr.$observe(translateAttr, function (translationId) {
	            translationIds[translateAttr] = translationId;
	            updateTranslations();
	          });
	        };
	
	        // initial setup with values
	        initInterpolationParams(scope.interpolateParams, iAttr, tAttr);
	
	        var firstAttributeChangedEvent = true;
	        iAttr.$observe('translate', function (translationId) {
	          if (typeof translationId === 'undefined') {
	            // case of element "<translate>xyz</translate>"
	            observeElementTranslation('');
	          } else {
	            // case of regular attribute
	            if (translationId !== '' || !firstAttributeChangedEvent) {
	              translationIds.translate = translationId;
	              updateTranslations();
	            }
	          }
	          firstAttributeChangedEvent = false;
	        });
	
	        for (var translateAttr in iAttr) {
	          if (iAttr.hasOwnProperty(translateAttr) && translateAttr.substr(0, 13) === 'translateAttr' && translateAttr.length > 13) {
	            observeAttributeTranslation(translateAttr);
	          }
	        }
	
	        iAttr.$observe('translateDefault', function (value) {
	          scope.defaultText = value;
	          updateTranslations();
	        });
	
	        if (translateSanitizeStrategyExist) {
	          iAttr.$observe('translateSanitizeStrategy', function (value) {
	            scope.sanitizeStrategy = $parse(value)(scope.$parent);
	            updateTranslations();
	          });
	        }
	
	        if (translateValuesExist) {
	          iAttr.$observe('translateValues', function (interpolateParams) {
	            if (interpolateParams) {
	              scope.$parent.$watch(function () {
	                angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
	              });
	            }
	          });
	        }
	
	        if (translateValueExist) {
	          var observeValueAttribute = function (attrName) {
	            iAttr.$observe(attrName, function (value) {
	              var attributeName = lowercase(attrName.substr(14, 1)) + attrName.substr(15);
	              scope.interpolateParams[attributeName] = value;
	            });
	          };
	          for (var attr in iAttr) {
	            if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
	              observeValueAttribute(attr);
	            }
	          }
	        }
	
	        // Master update function
	        var updateTranslations = function () {
	          for (var key in translationIds) {
	            if (translationIds.hasOwnProperty(key) && translationIds[key] !== undefined) {
	              updateTranslation(key, translationIds[key], scope, scope.interpolateParams, scope.defaultText, scope.translateNamespace);
	            }
	          }
	        };
	
	        // Put translation processing function outside loop
	        var updateTranslation = function(translateAttr, translationId, scope, interpolateParams, defaultTranslationText, translateNamespace) {
	          if (translationId) {
	            // if translation id starts with '.' and translateNamespace given, prepend namespace
	            if (translateNamespace && translationId.charAt(0) === '.') {
	              translationId = translateNamespace + translationId;
	            }
	
	            $translate(translationId, interpolateParams, translateInterpolation, defaultTranslationText, scope.translateLanguage, scope.sanitizeStrategy)
	              .then(function (translation) {
	                applyTranslation(translation, scope, true, translateAttr);
	              }, function (translationId) {
	                applyTranslation(translationId, scope, false, translateAttr);
	              });
	          } else {
	            // as an empty string cannot be translated, we can solve this using successful=false
	            applyTranslation(translationId, scope, false, translateAttr);
	          }
	        };
	
	        var applyTranslation = function (value, scope, successful, translateAttr) {
	          if (!successful) {
	            if (typeof scope.defaultText !== 'undefined') {
	              value = scope.defaultText;
	            }
	          }
	          if (translateAttr === 'translate') {
	            // default translate into innerHTML
	            if (successful || (!successful && !$translate.isKeepContent() && typeof iAttr.translateKeepContent === 'undefined')) {
	              iElement.empty().append(scope.preText + value + scope.postText);
	            }
	            var globallyEnabled = $translate.isPostCompilingEnabled();
	            var locallyDefined = typeof tAttr.translateCompile !== 'undefined';
	            var locallyEnabled = locallyDefined && tAttr.translateCompile !== 'false';
	            if ((globallyEnabled && !locallyDefined) || locallyEnabled) {
	              $compile(iElement.contents())(scope);
	            }
	          } else {
	            // translate attribute
	            var attributeName = iAttr.$attr[translateAttr];
	            if (attributeName.substr(0, 5) === 'data-') {
	              // ensure html5 data prefix is stripped
	              attributeName = attributeName.substr(5);
	            }
	            attributeName = attributeName.substr(15);
	            iElement.attr(attributeName, value);
	          }
	        };
	
	        if (translateValuesExist || translateValueExist || iAttr.translateDefault) {
	          scope.$watch('interpolateParams', updateTranslations, true);
	        }
	
	        // Replaced watcher on translateLanguage with event listener
	        scope.$on('translateLanguageChanged', updateTranslations);
	
	        // Ensures the text will be refreshed after the current language was changed
	        // w/ $translate.use(...)
	        var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);
	
	        // ensure translation will be looked up at least one
	        if (iElement.text().length) {
	          if (iAttr.translate) {
	            observeElementTranslation(iAttr.translate);
	          } else {
	            observeElementTranslation('');
	          }
	        } else if (iAttr.translate) {
	          // ensure attribute will be not skipped
	          observeElementTranslation(iAttr.translate);
	        }
	        updateTranslations();
	        scope.$on('$destroy', unbind);
	      };
	    }
	  };
	}
	
	/**
	 * Returns the scope's namespace.
	 * @private
	 * @param scope
	 * @returns {string}
	 */
	function getTranslateNamespace(scope) {
	  'use strict';
	  if (scope.translateNamespace) {
	    return scope.translateNamespace;
	  }
	  if (scope.$parent) {
	    return getTranslateNamespace(scope.$parent);
	  }
	}
	
	translateDirective.displayName = 'translateDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translate-attr
	 * @restrict A
	 *
	 * @description
	 * Translates attributes like translate-attr-ATTR, but with an object like ng-class.
	 * Internally it uses `translate` service to translate translation id. It possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate-attr Object literal mapping attributes to translation ids.
	 * @param {string=} translate-values Values to pass into the translation ids. Can be passed as object literal string.
	 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{value: 5}" />
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}',
	        }).preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	    <file name="scenario.js">
	      it('should translate', function () {
	        inject(function ($rootScope, $compile) {
	          $rootScope.translationId = 'TRANSLATION_ID';
	
	          element = $compile('<input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{ value: 5 }" />')($rootScope);
	          $rootScope.$digest();
	          expect(element.attr('placeholder)).toBe('Hello there!');
	          expect(element.attr('title)).toBe('The following value is dynamic: 5');
	        });
	      });
	    </file>
	   </example>
	 */
	.directive('translateAttr', translateAttrDirective);
	function translateAttrDirective($translate, $rootScope) {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    priority: $translate.directivePriority(),
	    link: function linkFn(scope, element, attr) {
	
	      var translateAttr,
	          translateValues,
	          translateSanitizeStrategy,
	          previousAttributes = {};
	
	      // Main update translations function
	      var updateTranslations = function () {
	        angular.forEach(translateAttr, function (translationId, attributeName) {
	          if (!translationId) {
	            return;
	          }
	          previousAttributes[attributeName] = true;
	
	          // if translation id starts with '.' and translateNamespace given, prepend namespace
	          if (scope.translateNamespace && translationId.charAt(0) === '.') {
	            translationId = scope.translateNamespace + translationId;
	          }
	          $translate(translationId, translateValues, attr.translateInterpolation, undefined, scope.translateLanguage, translateSanitizeStrategy)
	            .then(function (translation) {
	              element.attr(attributeName, translation);
	            }, function (translationId) {
	              element.attr(attributeName, translationId);
	            });
	        });
	
	        // Removing unused attributes that were previously used
	        angular.forEach(previousAttributes, function (flag, attributeName) {
	          if (!translateAttr[attributeName]) {
	            element.removeAttr(attributeName);
	            delete previousAttributes[attributeName];
	          }
	        });
	      };
	
	      // Watch for attribute changes
	      watchAttribute(
	        scope,
	        attr.translateAttr,
	        function (newValue) { translateAttr = newValue; },
	        updateTranslations
	      );
	      // Watch for value changes
	      watchAttribute(
	        scope,
	        attr.translateValues,
	        function (newValue) { translateValues = newValue; },
	        updateTranslations
	      );
	      // Watch for sanitize strategy changes
	      watchAttribute(
	        scope,
	        attr.translateSanitizeStrategy,
	        function (newValue) { translateSanitizeStrategy = newValue; },
	        updateTranslations
	      );
	
	      if (attr.translateValues) {
	        scope.$watch(attr.translateValues, updateTranslations, true);
	      }
	
	      // Replaced watcher on translateLanguage with event listener
	      scope.$on('translateLanguageChanged', updateTranslations);
	
	      // Ensures the text will be refreshed after the current language was changed
	      // w/ $translate.use(...)
	      var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);
	
	      updateTranslations();
	      scope.$on('$destroy', unbind);
	    }
	  };
	}
	
	function watchAttribute(scope, attribute, valueCallback, changeCallback) {
	  'use strict';
	  if (!attribute) {
	    return;
	  }
	  if (attribute.substr(0, 2) === '::') {
	    attribute = attribute.substr(2);
	  } else {
	    scope.$watch(attribute, function(newValue) {
	      valueCallback(newValue);
	      changeCallback();
	    }, true);
	  }
	  valueCallback(scope.$eval(attribute));
	}
	
	translateAttrDirective.displayName = 'translateAttrDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateCloak
	 * @requires $translate
	 * @restrict A
	 *
	 * $description
	 * Adds a `translate-cloak` class name to the given element where this directive
	 * is applied initially and removes it, once a loader has finished loading.
	 *
	 * This directive can be used to prevent initial flickering when loading translation
	 * data asynchronously.
	 *
	 * The class name is defined in
	 * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
	 *
	 * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
	 *                                  or hiding the cloak. Basically it relies on the translation
	 *                                  resolve.
	 */
	.directive('translateCloak', translateCloakDirective);
	
	function translateCloakDirective($translate, $rootScope) {
	
	  'use strict';
	
	  return {
	    compile : function (tElement) {
	      var applyCloak = function (element) {
	          element.addClass($translate.cloakClassName());
	        },
	        removeCloak = function (element) {
	          element.removeClass($translate.cloakClassName());
	        };
	      applyCloak(tElement);
	
	      return function linkFn(scope, iElement, iAttr) {
	        //Create bound functions that incorporate the active DOM element.
	        var iRemoveCloak = removeCloak.bind(this, iElement), iApplyCloak = applyCloak.bind(this, iElement);
	        if (iAttr.translateCloak && iAttr.translateCloak.length) {
	          // Register a watcher for the defined translation allowing a fine tuned cloak
	          iAttr.$observe('translateCloak', function (translationId) {
	            $translate(translationId).then(iRemoveCloak, iApplyCloak);
	          });
	          $rootScope.$on('$translateChangeSuccess', function () {
	            $translate(iAttr.translateCloak).then(iRemoveCloak, iApplyCloak);
	          });
	        } else {
	          $translate.onReady(iRemoveCloak);
	        }
	      };
	    }
	  };
	}
	
	translateCloakDirective.displayName = 'translateCloakDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateNamespace
	 * @restrict A
	 *
	 * @description
	 * Translates given translation id either through attribute or DOM content.
	 * Internally it uses `translate` filter to translate translation id. It is possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate namespace name which could be either string or interpolated string.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div translate-namespace="CONTENT">
	
	        <div>
	            <h1 translate>.HEADERS.TITLE</h1>
	            <h1 translate>.HEADERS.WELCOME</h1>
	        </div>
	
	        <div translate-namespace=".HEADERS">
	            <h1 translate>.TITLE</h1>
	            <h1 translate>.WELCOME</h1>
	        </div>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'CONTENT': {
	            'HEADERS': {
	                TITLE: 'Title'
	            }
	          },
	          'CONTENT.HEADERS.WELCOME': 'Welcome'
	        }).preferredLanguage('en');
	
	      });
	
	    </file>
	   </example>
	 */
	.directive('translateNamespace', translateNamespaceDirective);
	
	function translateNamespaceDirective() {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    scope: true,
	    compile: function () {
	      return {
	        pre: function (scope, iElement, iAttrs) {
	          scope.translateNamespace = _getTranslateNamespace(scope);
	
	          if (scope.translateNamespace && iAttrs.translateNamespace.charAt(0) === '.') {
	            scope.translateNamespace += iAttrs.translateNamespace;
	          } else {
	            scope.translateNamespace = iAttrs.translateNamespace;
	          }
	        }
	      };
	    }
	  };
	}
	
	/**
	 * Returns the scope's namespace.
	 * @private
	 * @param scope
	 * @returns {string}
	 */
	function _getTranslateNamespace(scope) {
	  'use strict';
	  if (scope.translateNamespace) {
	    return scope.translateNamespace;
	  }
	  if (scope.$parent) {
	    return _getTranslateNamespace(scope.$parent);
	  }
	}
	
	translateNamespaceDirective.displayName = 'translateNamespaceDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateLanguage
	 * @restrict A
	 *
	 * @description
	 * Forces the language to the directives in the underlying scope.
	 *
	 * @param {string=} translate language that will be negotiated.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div>
	
	        <div>
	            <h1 translate>HELLO</h1>
	        </div>
	
	        <div translate-language="de">
	            <h1 translate>HELLO</h1>
	        </div>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider
	          .translations('en',{
	            'HELLO': 'Hello world!'
	          })
	          .translations('de',{
	            'HELLO': 'Hallo Welt!'
	          })
	          .preferredLanguage('en');
	
	      });
	
	    </file>
	   </example>
	 */
	.directive('translateLanguage', translateLanguageDirective);
	
	function translateLanguageDirective() {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    scope: true,
	    compile: function () {
	      return function linkFn(scope, iElement, iAttrs) {
	
	        iAttrs.$observe('translateLanguage', function (newTranslateLanguage) {
	          scope.translateLanguage = newTranslateLanguage;
	        });
	
	        scope.$watch('translateLanguage', function(){
	          scope.$broadcast('translateLanguageChanged');
	        });
	      };
	    }
	  };
	}
	
	translateLanguageDirective.displayName = 'translateLanguageDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc filter
	 * @name pascalprecht.translate.filter:translate
	 * @requires $parse
	 * @requires pascalprecht.translate.$translate
	 * @function
	 *
	 * @description
	 * Uses `$translate` service to translate contents. Accepts interpolate parameters
	 * to pass dynamized values though translation.
	 *
	 * @param {string} translationId A translation id to be translated.
	 * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
	 *
	 * @returns {string} Translated text.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
	        <pre>{{ translationId | translate }}</pre>
	        <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
	        <pre>{{ 'WITH_VALUES' | translate:values }}</pre>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en', {
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}'
	        });
	        $translateProvider.preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	   </example>
	 */
	.filter('translate', translateFilterFactory);
	
	function translateFilterFactory($parse, $translate) {
	
	  'use strict';
	
	  var translateFilter = function (translationId, interpolateParams, interpolation, forceLanguage) {
	    if (!angular.isObject(interpolateParams)) {
	      var ctx = this || {
	        '__SCOPE_IS_NOT_AVAILABLE': 'More info at https://github.com/angular/angular.js/commit/8863b9d04c722b278fa93c5d66ad1e578ad6eb1f'
	        };
	      interpolateParams = $parse(interpolateParams)(ctx);
	    }
	
	    return $translate.instant(translationId, interpolateParams, interpolation, forceLanguage);
	  };
	
	  if ($translate.statefulFilter()) {
	    translateFilter.$stateful = true;
	  }
	
	  return translateFilter;
	}
	
	translateFilterFactory.displayName = 'translateFilterFactory';
	
	angular.module('pascalprecht.translate')
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translationCache
	 * @requires $cacheFactory
	 *
	 * @description
	 * The first time a translation table is used, it is loaded in the translation cache for quick retrieval. You
	 * can load translation tables directly into the cache by consuming the
	 * `$translationCache` service directly.
	 *
	 * @return {object} $cacheFactory object.
	 */
	  .factory('$translationCache', $translationCache);
	
	function $translationCache($cacheFactory) {
	
	  'use strict';
	
	  return $cacheFactory('translations');
	}
	
	$translationCache.displayName = '$translationCache';
	return 'pascalprecht.translate';
	
	}));


/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*jslint node: true */
	(function(root, factory) {
	  "use strict";
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	  } else if (typeof module !== 'undefined' && typeof module.exports ===
	    'object') {
	    module.exports = factory(require('angular'));
	
	  } else {
	    return factory(root.angular);
	  }
	}(window, function(angular) {
	  'use strict';
	
	  var wasPasted = false;
	
	  function convModelToView(modelValue, viewSeparator, prepend, append) {
	    if (modelValue === undefined || modelValue === null || modelValue ===
	      "") {
	      return "";
	    }
	    var newViewValue = '';
	    if (viewSeparator === ',') {
	      newViewValue = String(modelValue).replace(".", ",");
	    } else {
	      newViewValue = String(modelValue);
	    }
	    return newViewValue;
	  }
	
	  function convViewToModel(viewValue, viewSeparator, thousandSeparator) {
	
	    if (viewSeparator === ',') {
	      return String(viewValue).replace(/['\.\s]/g, "").replace(",", ".");
	    } else if (viewSeparator === '.') {
	      return String(viewValue).replace(/[',\s]/g, "");
	    }
	  }
	
	  function addPrependAppend(value, prepend, append) {
	    var newViewValue = value;
	    if (append) {
	      newViewValue = newViewValue + append;
	    }
	    if (prepend) {
	      if (/^\-.+/.test(newViewValue)) {
	        newViewValue = newViewValue.replace('-', '-' + prepend);
	      } else if (/^\-/.test(newViewValue)) {
	        newViewValue = newViewValue;
	      } else {
	        newViewValue = prepend + newViewValue;
	      }
	    }
	    return newViewValue;
	  }
	
	  function initIntegerPart(attrs_num_int, def_num_int) {
	    if (attrs_num_int >= 0) {
	      var _num_int = parseInt(attrs_num_int, 10);
	      if (isNaN(_num_int) === false && isFinite(_num_int) && _num_int >= 0) {
	        return _num_int;
	      }
	    }
	    return def_num_int;
	  }
	
	  function initFractionPart(attrs_num_fract, def_num_fract) {
	    if (attrs_num_fract >= 0) {
	      var _num_fract = parseInt(attrs_num_fract, 10);
	      if (isNaN(_num_fract) === false && isFinite(_num_fract) && _num_fract >=
	        0) {
	        return _num_fract;
	      }
	    }
	    return def_num_fract;
	  }
	
	  function initSeparator(attrs_num_sep, def_num_sep) {
	    if (attrs_num_sep === ',') {
	      return ',';
	    } else if (attrs_num_sep === '.') {
	      return '.';
	    }
	    return def_num_sep;
	  }
	
	  function initIsPositive(attrs_num_pos, def_num_pos) {
	    if (attrs_num_pos === 'false' || attrs_num_pos === false) {
	      return false;
	    } else if (attrs_num_pos === 'true' || attrs_num_pos === true) {
	      return true;
	    }
	    return def_num_pos;
	  }
	
	  function initIsNegative(attrs_num_neg, def_num_neg) {
	    if (attrs_num_neg === 'false' || attrs_num_neg === false) {
	      return false;
	    } else if (attrs_num_neg === 'true' || attrs_num_neg === true) {
	      return true;
	    }
	    return def_num_neg;
	  }
	
	  function initRound(attrs_round, def_round) {
	    if (attrs_round === 'floor') {
	      return Math.floor;
	    } else if (attrs_round === 'ceil') {
	      return Math.ceil;
	    } else if (attrs_round === 'round') {
	      return Math.round;
	    }
	    return def_round;
	  }
	
	  function initIsFixed(attrs_fixed, def_fixed) {
	    if (attrs_fixed === 'false' || attrs_fixed === false) {
	      return false;
	    } else if (attrs_fixed === 'true' || attrs_fixed === true) {
	      return true;
	    }
	    return def_fixed;
	  }
	
	  function initIsThousand(attrs_thousand, def_thousand) {
	    if (attrs_thousand === 'false' || attrs_thousand === false) {
	      return false;
	    } else if (attrs_thousand === 'true' || attrs_thousand === true) {
	      return true;
	    }
	    return def_thousand;
	  }
	
	  function initThousandSeparator(attrs_thousand, fractionSeparator,
	    def_thousand) {
	    if (!attrs_thousand) {
	      return def_thousand;
	    }
	    var regexp;
	    if (fractionSeparator === '.') {
	      regexp = new RegExp('^[\',\\s]$');
	    } else {
	      regexp = new RegExp('^[\'\\.\\s]$');
	    }
	    if (regexp.test(attrs_thousand)) {
	      return attrs_thousand;
	    } else {
	      return def_thousand;
	    }
	  }
	
	  function initNumAppendPrepend(attrs_num_char) {
	    var regexp = new RegExp('[^\\d,\\.\\s\\-]{1}');
	    if (regexp.test(attrs_num_char)) {
	      return attrs_num_char;
	    }
	    return null;
	  }
	
	
	
	  function buildRegexp(integerPart, fractionPart, fractionSeparator,
	    isPositiveNumber, isNegativeNumber) {
	    var negativeRegex = '-?';
	    if (isPositiveNumber === false && isNegativeNumber === true) {
	      negativeRegex = '-';
	    } else if (isPositiveNumber === true && isNegativeNumber === false) {
	      negativeRegex = '';
	    }
	    var intRegex = '[0-9]{0,' + (integerPart) + '}';
	    if (integerPart === 0) {
	      intRegex = '0';
	    }
	    var fractRegex = '(\\' + fractionSeparator + '([0-9]){0,' +
	      fractionPart + '})';
	    if (fractionPart === 0) {
	      fractRegex = '';
	    }
	    return new RegExp('^' + negativeRegex + intRegex + fractRegex + '?$');
	  }
	
	  function removeLeadingZero(value) {
	    return String(value)
	      .replace(/^(-?)(0+)$/g, "$10") //change 00000 to '0' and -00000 to '-0'
	      .replace(/^0(\d+)/g, "$1") //change 000001 to '1'
	      .replace(/^-0(\d+)/g, "-$1") //change -013212 to -0
	      .replace(new RegExp('^-([\\.,\\s])', 'g'), "-0$1") //change -. to -0.
	      .replace(new RegExp('^[\\.,\\s]', 'g'), "0$&"); //change . to 0.
	  }
	
	  function removePrependAppendChars(value, prepend, append) {
	    var newValue = value;
	    if (prepend) {
	      newValue = newValue.replace(new RegExp('[\\' + prepend + ']', 'g'),
	        '');
	    }
	    if (append) {
	      newValue = newValue.replace(new RegExp('[\\' + append + ']', 'g'), '');
	    }
	    return newValue;
	  }
	
	  function removeThousandSeparators(value, thousandSeparator) {
	    if (thousandSeparator === '.') {
	      return String(value).replace(/\./g, "");
	    } else if (thousandSeparator === ',') {
	      return String(value).replace(/,/g, "");
	    } else {
	      return String(value).replace(new RegExp('[\'\\s]', 'g'), "");
	    }
	  }
	
	  function addThousandSeparator(value, fractionSeparator, thousandSeparator) {
	    value = String(value).split(fractionSeparator);
	    value[0] = value[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
	    return value.join(fractionSeparator);
	  }
	
	  function addFixedZeros(value, parameters) {
	    var newValue = value;
	    if (parameters.isFixed) {
	      var fractionPart = newValue.split(parameters.fractionSeparator)[1];
	      var fractionLength = (fractionPart && fractionPart.length) ?
	        fractionPart.length : 0;
	      if (fractionLength === 0) {
	        newValue += parameters.fractionSeparator;
	      }
	      for (var i = fractionLength; i < parameters.fractionPart; i++) {
	        newValue += "0";
	      }
	    }
	    return newValue;
	  }
	
	  function changeViewValue(ngModelController, value, parameters, state,
	    disable) {
	
	    if (disable) {
	      state.enable = false;
	    }
	    var valueString = String(value);
	    var valueWithFixedZeros = addFixedZeros(valueString, parameters);
	    var valueWithPrependAppend = addPrependAppend(valueWithFixedZeros,
	      parameters.prepend, parameters.append);
	    // https://github.com/angular/angular.js/issues/13068
	    // ngModelController.$viewValue = value;
	    var version = angular.version;
	    if (version.major === 1 && version.minor === 2) {
	      ngModelController.$viewValue = valueWithPrependAppend;
	    } else {
	      ngModelController.$setViewValue(valueWithPrependAppend);
	    }
	    ngModelController.$render();
	  }
	
	  function filterModelValue(
	    value,
	    fractionPart,
	    fractionSeparator,
	    roundFunction,
	    numFixed,
	    isThousandSeparator,
	    thousandSeparator,
	    prepend,
	    append
	  ) {
	    if (value === '' || value === undefined || value === null) {
	      return '';
	    }
	    value = Number(value);
	    if (!isNaN(value) && isFinite(value)) {
	      var powerOfTen = Math.pow(10, fractionPart);
	      if (numFixed) {
	        value = convModelToView((roundFunction(value * powerOfTen) /
	            powerOfTen).toFixed(fractionPart), fractionSeparator, prepend,
	          append);
	      } else {
	        value = convModelToView(String(roundFunction(value * powerOfTen) /
	          powerOfTen), fractionSeparator, prepend, append);
	      }
	      value = addPrependAppend(value, prepend, append);
	      if (isThousandSeparator) {
	        value = addThousandSeparator(value, fractionSeparator,
	          thousandSeparator);
	      }
	      return value;
	    }
	    if (numFixed) {
	      return (0).toFixed(fractionPart);
	    } else {
	      return "0";
	    }
	  }
	  /**
	   * from this source:
	   * http://stackoverflow.com/a/2897229/4138339
	   */
	  function getCaretPosition(oField) {
	    var iCaretPos = 0;
	    if (document.selection) {
	      oField.focus();
	      var oSel = document.selection.createRange();
	      oSel.moveStart('character', -oField.value.length);
	      iCaretPos = oSel.text.length;
	    } else if (oField.selectionStart || oField.selectionStart == '0')
	      iCaretPos = oField.selectionDirection == 'backward' ? oField.selectionStart :
	      oField.selectionEnd;
	    return (iCaretPos);
	  }
	  /**
	   * from this source
	   * http://stackoverflow.com/a/22574572/4138339
	   */
	  function setCaretPosition(elem, caretPos) {
	    if (elem !== null) {
	      if (elem.createTextRange) {
	        var range = elem.createTextRange();
	        range.move('character', caretPos);
	        range.select();
	      } else {
	        if (elem.selectionStart) {
	          elem.focus();
	          elem.setSelectionRange(caretPos, caretPos);
	        } else
	          elem.focus();
	      }
	    }
	  }
	
	  function countThousandSeparatorToPosition(value, separator, position) {
	    var countPosition = 0;
	    var countDots = 0;
	    for (var i = 0; i < value.length; i++) {
	      if (value[i] !== separator) {
	        countPosition++;
	        if (countPosition >= position) break;
	      } else {
	        countDots++;
	      }
	    }
	    return countDots;
	  }
	
	  function cutSurplusFractionPart(value, parameters) {
	
	    var newValue = value;
	    var splitedValue = newValue.split(parameters.fractionSeparator);
	    var integerPart = splitedValue[0];
	    var fractionPart = splitedValue[1];
	    if (fractionPart && fractionPart.length > parameters.fractionPart) {
	      fractionPart = fractionPart.slice(0, parameters.fractionPart);
	      newValue = [integerPart, fractionPart].join(parameters.fractionSeparator);
	    }
	    return newValue;
	  }
	
	  function prepareResponse(value) {
	    if (value === null) {
	      return null;
	    } else {
	      return Number(value);
	    }
	  }
	
	  function createPropertyObject(scope, key, value) {
	    var properties = {
	      awnum: scope.awnum,
	      numInt: scope.numInt,
	      numFract: scope.numFract,
	      numSep: scope.numSep,
	      numPos: scope.numPos,
	      numNeg: scope.numNeg,
	      numRound: scope.numRound,
	      numThousand: scope.numThousand,
	      numThousandSep: scope.numThousandSep,
	      numPrepend: scope.numPrepend,
	      numAppend: scope.numAppend,
	      numFixed: scope.numFixed
	    };
	    if (key) {
	      properties[key] = value;
	    }
	    return properties;
	  }
	
	  function removeDoubledDecimalSeparators(value, parameters) {
	    return value.replace(new RegExp("[\\" + parameters.fractionSeparator +
	      "]+", "g"), parameters.fractionSeparator);
	  }
	
	  function initAllProperties(properties, element, attrs, ngModelController,
	    dynamicNumberStrategy) {
	    var strategy = {};
	    if (properties.awnum) {
	      strategy = dynamicNumberStrategy.getStrategy(properties.awnum);
	    }
	    var integerPart = initIntegerPart(properties.numInt !== undefined ?
	      properties.numInt : strategy.numInt, 6);
	    var fractionPart = initFractionPart(properties.numFract !== undefined ?
	      properties.numFract : strategy.numFract, 2);
	    var fractionSeparator = initSeparator(properties.numSep !== undefined ?
	      properties.numSep : strategy.numSep, '.');
	    var isPositiveNumber = initIsPositive(properties.numPos !== undefined ?
	      properties.numPos : strategy.numPos, true);
	    var isNegativeNumber = initIsNegative(properties.numNeg !== undefined ?
	      properties.numNeg : strategy.numNeg, true);
	    var roundFunction = initRound(properties.numRound !== undefined ?
	      properties.numRound : strategy.numRound, Math.round);
	    var isThousandSeparator = initIsThousand(properties.numThousand !==
	      undefined ? properties.numThousand : strategy.numThousand, false);
	    var thousandSeparator = initThousandSeparator(properties.numThousandSep !==
	      undefined ? properties.numThousandSep : strategy.numThousandSep,
	      fractionSeparator, fractionSeparator === '.' ? ',' : '.');
	    var prepend = initNumAppendPrepend(properties.numPrepend !== undefined ?
	      properties.numPrepend : strategy.numPrepend);
	    var append = initNumAppendPrepend(properties.numAppend !== undefined ?
	      properties.numAppend : strategy.numAppend);
	    var isFixed = initIsFixed(properties.numFixed !== undefined ?
	      properties.numFixed : strategy.numFixed, false);
	    if (isPositiveNumber === false && isNegativeNumber === false) {
	      throw new Error(
	        'Number is set to not be positive and not be negative. Change num_pos attr or/and num_neg attr to true'
	      );
	    }
	    var viewRegexTest = buildRegexp(integerPart, fractionPart,
	      fractionSeparator, isPositiveNumber, isNegativeNumber);
	    return {
	      element: element,
	      attrs: attrs,
	      ngModelController: ngModelController,
	      viewRegexTest: viewRegexTest,
	      integerPart: integerPart,
	      fractionPart: fractionPart,
	      fractionSeparator: fractionSeparator,
	      isPositiveNumber: isPositiveNumber,
	      isNegativeNumber: isNegativeNumber,
	      roundFunction: roundFunction,
	      isThousandSeparator: isThousandSeparator,
	      thousandSeparator: thousandSeparator,
	      prepend: prepend,
	      append: append,
	      isFixed: isFixed
	    }
	  }
	
	  function directiveParser(value, parameters, state) {
	    var element = parameters.element;
	    var attrs = parameters.attrs;
	    var ngModelController = parameters.ngModelController;
	    var viewRegexTest = parameters.viewRegexTest;
	    var integerPart = parameters.integerPart;
	    var fractionPart = parameters.fractionPart;
	    var fractionSeparator = parameters.fractionSeparator;
	    var isPositiveNumber = parameters.isPositiveNumber;
	    var isNegativeNumber = parameters.isNegativeNumber;
	    var roundFunction = parameters.roundFunction;
	    var isThousandSeparator = parameters.isThousandSeparator;
	    var thousandSeparator = parameters.thousandSeparator;
	    var prepend = parameters.prepend;
	    var append = parameters.append;
	    var isFixed = parameters.isFixed;
	
	    var parsedValue = String(value);
	
	    if (wasPasted) {
	      wasPasted = false;
	
	      // Remove all characters which are not number-relevant
	      var regex = new RegExp('[^' + ((isNegativeNumber) ? '-' : '') +
	        fractionSeparator + thousandSeparator + '0-9]+', 'g');
	      parsedValue = parsedValue.replace(regex, '');
	
	      // Remove trailing separators
	      regex = new RegExp('^[' + fractionSeparator + thousandSeparator + ']');
	      parsedValue = parsedValue.replace(regex, '');
	
	      // Replace separator if at fraction position
	      regex = new RegExp('[' + fractionSeparator + thousandSeparator +
	        ']([0-9]{' + fractionPart + '})$');
	      parsedValue = parsedValue.replace(regex, fractionSeparator + '$1');
	    }
	    parsedValue = removePrependAppendChars(parsedValue, prepend, append);
	    parsedValue = removeDoubledDecimalSeparators(parsedValue, parameters);
	    if (new RegExp('^[\.,' + thousandSeparator + ']{2,}').test(parsedValue)) {
	      changeViewValue(ngModelController, '', parameters, state);
	      return null;
	    }
	    var cursorPosition = getCaretPosition(element[0]);
	    if (prepend) {
	      cursorPosition--;
	    }
	    var valBeforeCursor = parsedValue.slice(0, cursorPosition);
	    valBeforeCursor = removeThousandSeparators(valBeforeCursor,
	      thousandSeparator);
	    parsedValue = removeThousandSeparators(parsedValue, thousandSeparator);
	    valBeforeCursor = removeLeadingZero(valBeforeCursor);
	    var beforeRemovingLeadingZero = parsedValue;
	    parsedValue = removeLeadingZero(parsedValue);
	    if (parsedValue === "0" + fractionSeparator &&
	      beforeRemovingLeadingZero === fractionSeparator && isPositiveNumber) {
	      if (fractionPart) {
	        changeViewValue(ngModelController, '' + fractionSeparator,
	          parameters, state, true);
	        setCaretPosition(element[0], 2);
	        return null;
	      } else {
	        changeViewValue(ngModelController, '', parameters, state);
	        return null;
	      }
	    }
	    if (parsedValue === '' && String(value).charAt(0) === '0') {
	      changeViewValue(ngModelController, '', parameters);
	      return null;
	    }
	    if (parsedValue === undefined || parsedValue === '') {
	      changeViewValue(ngModelController, '', parameters);
	      return null;
	    }
	    if (parsedValue === '-') {
	      if (isPositiveNumber && !isNegativeNumber) {
	        changeViewValue(ngModelController, '', parameters, state);
	      } else {
	        changeViewValue(ngModelController, '-', parameters, state);
	      }
	      return null;
	    }
	
	    parsedValue = cutSurplusFractionPart(parsedValue, parameters);
	    /**
	     * view value failed 'correct view format' test
	     * therefore view value is set from last correct model value (it must be formatted - change dot to comma)
	     */
	    if (viewRegexTest.test(parsedValue) === false) {
	      var modelValue = convModelToView(ngModelController.$modelValue,
	        fractionSeparator, parameters);
	
	      if (isThousandSeparator) {
	        modelValue = addThousandSeparator(modelValue, fractionSeparator,
	          thousandSeparator);
	      }
	      changeViewValue(ngModelController, modelValue, parameters, state);
	      setCaretPosition(element[0], cursorPosition - 1);
	      return ngModelController.$modelValue;
	    }
	    /**
	     * view value success 'correct view format' test
	     * therefore model value is set from correct view value (it must be formatter - change comma to dot)
	     */
	    else {
	      var dots = 0;
	      var currentPosition = valBeforeCursor.length;
	      if (isThousandSeparator) {
	        parsedValue = addThousandSeparator(parsedValue, fractionSeparator,
	          thousandSeparator);
	        dots = countThousandSeparatorToPosition(parsedValue,
	          thousandSeparator, currentPosition);
	      }
	      if (prepend) {
	        dots++;
	        if (new RegExp('^(\\-\\d)$').test(parsedValue)) {
	          dots += 2;
	        }
	        if (new RegExp('^(\\d)$').test(parsedValue)) {
	          dots++;
	        }
	      }
	      changeViewValue(ngModelController, parsedValue, parameters, state);
	      setCaretPosition(element[0], currentPosition + dots);
	      return convViewToModel(parsedValue, fractionSeparator,
	        thousandSeparator);
	    }
	  }
	
	  function triggerParsers(ngModelController, value) {
	    ngModelController.$setViewValue('');
	    ngModelController.$render();
	    ngModelController.$setViewValue(value);
	    ngModelController.$render();
	  }
	
	  function onPropertyWatch(ngModelController, initObject) {
	    var value = filterModelValue(
	      ngModelController.$modelValue,
	      initObject.fractionPart,
	      initObject.fractionSeparator,
	      initObject.roundFunction,
	      initObject.isFixed,
	      initObject.isThousandSeparator,
	      initObject.thousandSeparator,
	      initObject.prepend,
	      initObject.append
	    );
	    triggerParsers(ngModelController, value);
	  }
	
	  function dynamicNumberDirective(dynamicNumberStrategy) {
	    return {
	      restrict: 'A',
	      require: '?ngModel',
	      scope: {
	        awnum: "@",
	        numInt: "@",
	        numFract: "@",
	        numSep: "@",
	        numPos: "@",
	        numNeg: "@",
	        numRound: "@",
	        numThousand: "@",
	        numThousandSep: "@",
	        numPrepend: "@",
	        numAppend: "@",
	        numFixed: "@"
	      },
	      link: function(scope, element, attrs, ngModelController) {
	        if (!element[0] || element[0].tagName !== 'INPUT' || (element[0].type !==
	            'text' && element[0].type !== 'tel')) {
	          console.warn(
	            'Directive angular-dynamic-number works only for \'input\' tag with type = \'text\' or type = \'tel\''
	          );
	          return;
	        }
	        if (!ngModelController) {
	          console.warn(
	            'Directive angular-dynamic-number need ngModel attribute');
	          return;
	        }
	        var initObject = initAllProperties(
	          createPropertyObject(scope),
	          element,
	          attrs,
	          ngModelController,
	          dynamicNumberStrategy
	        );
	
	        element.on('paste', function() {
	          wasPasted = true;
	        });
	
	        scope.$watch('numInt', function(newProperty, oldProperty) {
	          if (oldProperty === newProperty) {
	            return;
	          }
	          initObject = initAllProperties(createPropertyObject(scope,
	              'numInt', newProperty), element, attrs,
	            ngModelController, dynamicNumberStrategy);
	          onPropertyWatch(ngModelController, initObject);
	        });
	
	        scope.$watch('numFract', function(newProperty, oldProperty) {
	          if (oldProperty === newProperty) {
	            return;
	          }
	          initObject = initAllProperties(createPropertyObject(scope,
	              'numFract', newProperty), element, attrs,
	            ngModelController, dynamicNumberStrategy);
	          onPropertyWatch(ngModelController, initObject);
	        });
	
	        scope.$watch('numSep', function(newProperty, oldProperty) {
	          if (oldProperty === newProperty) {
	            return;
	          }
	          initObject = initAllProperties(createPropertyObject(scope,
	              'numSep', newProperty), element, attrs,
	            ngModelController, dynamicNumberStrategy);
	          onPropertyWatch(ngModelController, initObject);
	        });
	
	        scope.$watch('numPos', function(newProperty, oldProperty) {
	          if (oldProperty === newProperty) {
	            return;
	          }
	          initObject = initAllProperties(createPropertyObject(scope,
	              'numPos', newProperty), element, attrs,
	            ngModelController, dynamicNumberStrategy);
	          onPropertyWatch(ngModelController, initObject);
	        });
	
	        scope.$watch('numNeg', function(newProperty, oldProperty) {
	          if (oldProperty === newProperty) {
	            return;
	          }
	          initObject = initAllProperties(createPropertyObject(scope,
	              'numNeg', newProperty), element, attrs,
	            ngModelController, dynamicNumberStrategy);
	          onPropertyWatch(ngModelController, initObject);
	        });
	
	        scope.$watch('numThousand', function(newProperty, oldProperty) {
	          if (oldProperty === newProperty) {
	            return;
	          }
	          initObject = initAllProperties(createPropertyObject(scope,
	              'numThousand', newProperty), element, attrs,
	            ngModelController, dynamicNumberStrategy);
	          onPropertyWatch(ngModelController, initObject);
	        });
	
	        scope.$watch('numThousandSep', function(newProperty, oldProperty) {
	          if (oldProperty === newProperty) {
	            return;
	          }
	          initObject = initAllProperties(createPropertyObject(scope,
	              'numThousandSep', newProperty), element, attrs,
	            ngModelController, dynamicNumberStrategy);
	          onPropertyWatch(ngModelController, initObject);
	        });
	
	        scope.$watch('numAppend', function(newProperty, oldProperty) {
	          if (oldProperty === newProperty) {
	            return;
	          }
	          initObject = initAllProperties(createPropertyObject(scope,
	              'numAppend', newProperty), element, attrs,
	            ngModelController, dynamicNumberStrategy);
	          onPropertyWatch(ngModelController, initObject);
	        });
	
	        scope.$watch('numPrepend', function(newProperty, oldProperty) {
	          if (oldProperty === newProperty) {
	            return;
	          }
	          initObject = initAllProperties(createPropertyObject(scope,
	              'numPrepend', newProperty), element, attrs,
	            ngModelController, dynamicNumberStrategy);
	          onPropertyWatch(ngModelController, initObject);
	        });
	        scope.$watch('numFixed', function(newProperty, oldProperty) {
	          if (oldProperty === newProperty) {
	            return;
	          }
	          initObject = initAllProperties(createPropertyObject(scope,
	              'numFixed', newProperty), element, attrs,
	            ngModelController, dynamicNumberStrategy);
	          onPropertyWatch(ngModelController, initObject);
	        });
	        var state = {
	          enable: true,
	          count: 0
	        };
	        ngModelController.$parsers.unshift(function(value) {
	          if (state.enable) {
	            state.count++;
	            return prepareResponse(directiveParser(value, initObject,
	              state));
	          } else {
	            state.enable = true;
	            return value;
	          }
	        });
	        /**
	         * it is like filter,
	         */
	        ngModelController.$formatters.push(function(value) {
	          return filterModelValue(
	            value,
	            initObject.fractionPart,
	            initObject.fractionSeparator,
	            initObject.roundFunction,
	            initObject.isFixed,
	            initObject.isThousandSeparator,
	            initObject.thousandSeparator,
	            initObject.prepend,
	            initObject.append
	          );
	        });
	      }
	    };
	  }
	
	  var moduleName = 'dynamicNumber';
	
	  angular.module(moduleName, [])
	    .provider('dynamicNumberStrategy', function() {
	      var strategies = {};
	
	      this.addStrategy = addStrategy;
	      this.getStrategy = getStrategy;
	      this.getStrategies = getStrategies;
	
	      var strategyProvider = {
	        addStrategy: addStrategy,
	        getStrategy: getStrategy,
	        getStrategies: getStrategies
	      };
	
	      this.$get = function() {
	        return strategyProvider;
	      };
	
	      function addStrategy(name, strategy) {
	        strategies[name] = strategy;
	      }
	
	      function getStrategy(name) {
	        return strategies[name];
	      }
	
	      function getStrategies() {
	        return strategies;
	      }
	    })
	    .filter('awnum', ['dynamicNumberStrategy', function(
	      dynamicNumberStrategy) {
	      return function(value, numFract, numSep, numRound, numFixed,
	        numThousand, numThousandSep, numPrepend, numAppend) {
	        var strategy = {};
	        var fractionPart;
	        if (angular.isString(numFract)) {
	          strategy = dynamicNumberStrategy.getStrategy(numFract);
	          numFract = strategy.numFract;
	        }
	        var fractionPart = initFractionPart(numFract, 2);
	        var fractionSeparator = initSeparator(numSep !== undefined ?
	          numSep : strategy.numSep, '.');
	        var roundFunction = initRound(numRound !== undefined ?
	          numRound : strategy.numRound, Math.round);
	        var isFixed = initIsFixed(numFixed !== undefined ? numFixed :
	          strategy.numFixed, false);
	        var isThousandSeparator = initIsThousand(numThousand !==
	          undefined ? numThousand : strategy.numThousand, false);
	        var thousandSeparator = initThousandSeparator(numThousandSep !==
	          undefined ? numThousandSep : strategy.numThousandSep,
	          fractionSeparator, fractionSeparator === '.' ? ',' : '.');
	        var prepend = initNumAppendPrepend(numPrepend !== undefined ?
	          numPrepend : strategy.numPrepend);
	        var append = initNumAppendPrepend(numAppend !== undefined ?
	          numAppend : strategy.numAppend);
	        var filteredValue = filterModelValue(value, fractionPart,
	          fractionSeparator, roundFunction, isFixed,
	          isThousandSeparator, thousandSeparator, prepend, append);
	        if (filteredValue === '') {
	          return '0';
	        }
	        return filteredValue;
	      };
	    }])
	    .directive('awnum', ['dynamicNumberStrategy', dynamicNumberDirective]);
	
	  return moduleName;
	}));


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	routeConfig.$inject = ['$urlRouterProvider', '$locationProvider', '$translateProvider', '$provide', '$httpProvider'];
	var angular = __webpack_require__(1);
	var action_constants_1 = __webpack_require__(19);
	var removeToobarOptions = function (taOptions) {
	    var toolsToRemove = ["pre", "quote", "html", "insertVideo", "wordcount", "charcount"];
	    if (taOptions.toolbar && taOptions.toolbar.length) {
	        for (var i = 0; i < toolsToRemove.length; i++) {
	            for (var j = 0; j < taOptions.toolbar.length; j++) {
	                var index = taOptions.toolbar[j].indexOf(toolsToRemove[i]);
	                if (index > -1) {
	                    taOptions.toolbar[j].splice(index, 1);
	                }
	            }
	        }
	    }
	};
	var adoddleWebURL = window.properties.service.asiteUrl;
	var unauthorisedRedirect = function (response) {
	    if (!response || !response.status) {
	        return;
	    }
	    switch (response.status) {
	        case 401:
	            angular.element('body').hide();
	            window.onbeforeunload = function () { };
	            window.location.href = adoddleWebURL + "/unauthorised";
	            break;
	        case 403:
	            window.localStorage.setItem('sessionState', 'Inactive');
	            window.openLoginModal();
	            /* angular.element('body').hide();
	            (<any>window).onbeforeunload = function () {};
	            window.location.href = adoddleWebURL + "/session-timed-out"; */
	            break;
	    }
	};
	function routeConfig($urlRouterProvider, $locationProvider, $translateProvider, $provide, $httpProvider) {
	    'ngInject';
	    $urlRouterProvider
	        .otherwise('/');
	    $locationProvider.html5Mode(true);
	    $translateProvider.preferredLanguage('en_GB');
	    if (window.GLOBALS && window.GLOBALS.for !== 'Meta-Data') {
	        $translateProvider.useLoader('customLoader');
	    }
	    angular.lowercase = angular.$$lowercase;
	    angular.uppercase = angular.$$uppercase;
	    $provide.factory('httpInterceptor', ['$q', function ($q) {
	        return {
	            'response': function (response) {
	                if (response.config.url.indexOf(action_constants_1.Ids.GET_SESSION_TIMEOUT_DETAILS) == -1) {
	                    window.setsessionTimoutTimer && window.setsessionTimoutTimer();
	                }
	                unauthorisedRedirect(response);
	                return response;
	            },
	            'responseError': function (rejection) {
	                if (rejection.config.url.indexOf(action_constants_1.Ids.GET_SESSION_TIMEOUT_DETAILS) == -1) {
	                    window.setsessionTimoutTimer && window.setsessionTimoutTimer();
	                }
	                unauthorisedRedirect(rejection);
	                return $q.reject(rejection);
	            }
	        };
	    }]);
	    $httpProvider.interceptors.push('httpInterceptor');
	    $provide.decorator('taToolFunctions', ['$delegate', function ($delegate) {
	            // save original function to call it later
	            var imgOnSelectActionFn = $delegate.imgOnSelectAction;
	            // decorate imgOnSelectAction
	            $delegate.imgOnSelectAction = function (event, $element, editorScope) {
	                // call original function in which img toolbar is constructed
	                imgOnSelectActionFn(event, $element, editorScope);
	                // set popover size to fit content
	                // btw, dunno why it is set to concrete size
	                editorScope.displayElements.popover.css('width', 'auto');
	                editorScope.displayElements.popover
	                    .find('.btn-group')
	                    .eq(1).remove();
	            };
	            return $delegate;
	        }]);
	    $provide.decorator('taOptions', ['taRegisterTool', '$delegate', function (taRegisterTool, taOptions) {
	            // $delegate is the taOptions we are decorating
	            // register the tool with textAngular
	            removeToobarOptions(taOptions);
	            taRegisterTool('backgroundColor', {
	                //display: "<div spectrum-colorpicker ng-model='color' on-change='!!color && action(color)' format='\"hex\"' options='options'></div>",
	                display: "<div spectrum-colorpicker ng-model='color' on-change='!!color && action(color)' format='\"rgb\"' options='options'></div>",
	                action: function (color) {
	                    var me = this;
	                    if (!this.$editor().wrapSelection) {
	                        setTimeout(function () {
	                            me.action(color);
	                        }, 100);
	                    }
	                    else {
	                        if (color != "rgb(255, 255, 255)" && color != "#fff") {
	                            return this.$editor().wrapSelection('backColor', color);
	                        }
	                    }
	                },
	                options: {
	                    replacerClassName: 'fa fa-paint-brush', showButtons: false, appendTo: ".drop-area"
	                },
	                color: "#fff"
	            });
	            taRegisterTool('fontColor', {
	                display: "<spectrum-colorpicker trigger-id='{{trigger}}' ng-model='color' on-change='!!color && action(color)' format='\"hex\"' options='options'></spectrum-colorpicker>",
	                action: function (color) {
	                    var me = this;
	                    if (!this.$editor().wrapSelection) {
	                        setTimeout(function () {
	                            me.action(color);
	                        }, 100);
	                    }
	                    else {
	                        if (color != '#000' && color != '#000000') {
	                            return this.$editor().wrapSelection('foreColor', color);
	                        }
	                    }
	                },
	                options: {
	                    replacerClassName: 'fa fa-font', showButtons: false, appendTo: ".drop-area", showAlpha: false
	                },
	                color: "#000"
	            });
	            taRegisterTool('fontName', {
	                display: "<span class='bar-btn-dropdown dropdown' uib-dropdown style='padding:4px 10px; z-index:3'>" +
	                    "<button class='dropdown-toggle dropdown-toggle-btn' uib-dropdown-toggle type='button' ng-disabled='showHtml()'>Font-Family&nbsp;<i class='fa fa-caret-down'></i></button>" +
	                    "<ul class='dropdown-menu' uib-dropdown-menu aria-labelledby='dropdownMenu' style='max-height: 110px;overflow-x: scroll;'><li ng-repeat='o in options'><button class='checked-dropdown' style='font-family: {{o.css}}; width: 100%' type='button' ng-click='action($event, o.css)'><i ng-if='o.active' class='fa fa-check'></i>{{o.name}}</button></li></ul></span>",
	                action: function (event, font) {
	                    //Ask if event is really an event.
	                    if (!!event.stopPropagation) {
	                        //With this, you stop the event of textAngular.
	                        event.stopPropagation();
	                        //Then click in the body to close the dropdown.
	                        $("body").trigger("click");
	                    }
	                    return this.$editor().wrapSelection('fontName', font);
	                },
	                options: [
	                    { name: 'Arial', css: 'Arial' },
	                    { name: 'Helvetica', css: 'Helvetica' },
	                    { name: 'Times New Roman', css: 'Times New Roman' },
	                    { name: 'Times', css: 'Times' },
	                    { name: 'Courier New', css: 'Courier New' },
	                    { name: 'Courier', css: 'Courier' },
	                    { name: 'Verdana', css: 'Verdana' },
	                    { name: 'Georgia', css: 'Georgia' },
	                    { name: 'Palatino Linotype', css: 'Palatino Linotype' },
	                    { name: 'Garamond', css: 'Garamond' },
	                    { name: 'Bookman Old Style', css: 'Bookman Old Style' },
	                    { name: 'Comic Sans MS', css: 'Comic Sans MS' },
	                    { name: 'Trebuchet MS', css: 'Trebuchet MS' },
	                    { name: 'Arial Black', css: 'Arial Black' },
	                    { name: 'Impact', css: 'Impact' },
	                    { name: 'Calibri', css: 'Calibri' },
	                    { name: 'Century Gothic', css: 'Century Gothic' },
	                    { name: 'Sans Serif', css: 'Sans Serif' },
	                    { name: 'Sofia Pro Regular', css: 'Sofia Pro Regular' },
	                    { name: 'Sofia Pro Semi Bold', css: 'Sofia Pro Semi Bold' }
	                ]
	            });
	            taRegisterTool('fontSize', {
	                display: "<span class='bar-btn-dropdown dropdown' uib-dropdown style='padding:4px 10px; z-index:3'>" +
	                    "<button class=' dropdown-toggle dropdown-toggle-btn' uib-dropdown-toggle type='button' ng-disabled='showHtml()'>Font-Size&nbsp;<i class='fa fa-caret-down'></i></button>" +
	                    "<ul class='dropdown-menu' uib-dropdown-menu aria-labelledby='dropdownMenu' style='max-height: 110px;overflow-x: scroll;'><li ng-repeat='o in options'><button class='checked-dropdown' style='font-size: {{o.css}}; width: 100%' type='button' ng-click='action($event, o.value)'><i ng-if='o.active' class='fa fa-check'></i> {{o.name}}</button></li></ul>" +
	                    "</span>",
	                action: function (event, size) {
	                    //Ask if event is really an event.
	                    if (!!event.stopPropagation) {
	                        //With this, you stop the event of textAngular.
	                        event.stopPropagation();
	                        //Then click in the body to close the dropdown.
	                        $("body").trigger("click");
	                    }
	                    return this.$editor().wrapSelection('fontSize', parseInt(size));
	                },
	                options: [
	                    { name: '1 (8pt)', css: 'xx-small', value: 1 },
	                    { name: '2 (10pt)', css: 'x-small', value: 2 },
	                    { name: '3 (12pt)', css: 'small', value: 3 },
	                    { name: '4 (14pt)', css: 'medium', value: 4 },
	                    { name: '5 (18pt)', css: 'large', value: 5 },
	                    { name: '6 (24pt)', css: 'x-large', value: 6 },
	                    { name: '7 (30pt)', css: 'xx-large', value: 7 }
	                ]
	            });
	            // add the button to the default toolbar definition
	            taOptions.toolbar[1].push('backgroundColor', 'fontColor', 'fontName', 'fontSize');
	            return taOptions;
	        }]);
	    window.intercomSettings = {
	        app_id: window.GLOBALS && window.GLOBALS.intercomAppId,
	        created_at: "1611146676893"
	    };
	}
	exports.routeConfig = routeConfig;


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	'use strict';
	var Ids = {
	    GET_FORM_VIEW_JSON: 'get/',
	    GET_FOLDER_META_DATA: 'metadata/folderMetadata',
	    GET_FORM_VIEW_JSON_BY_FORM_TYPE: 'metadata/edit/',
	    SAVE_DESIGN: 'save',
	    SAVE_DESIGN_BY_FORM_TYPE: 'metadata/saveDesign',
	    DISCARD_DRAFT: 'metadata/discardDraft/',
	    SEARCH_TEMPLATE: 'find',
	    CREATE_TEMPLATE: 'save',
	    DELETE_TEMPLATE: 'delete',
	    GET_LANGUAGE_KEYS: 'language/messages/getall',
	    GET_USP: 'user/usp/get',
	    GET_AVAILABLE_SECONDARY_DS: 'getAvailableSecondaryDS',
	    GET_APPS_LOOKUP_DATA: 'appsLookUpData',
	    GET_ALL_LANGUAGES: 'languages/getall',
	    UPDATE_TEMPLATENAME: 'metadata/updateTemplateName',
	    GET_PROTECTED_PARAMS: 'reservedfields',
	    ACTIVATE_USER_SESSION: 'login/activateUserSession',
	    GET_SESSION_TIMEOUT_DETAILS: 'login/getSessionTimeoutDetails',
	    GET_CUSTOM_ATTR_NAMES: 'form/canames',
	    GET_NUMBER_FORMAT_ENABLED_DETAIL: 'home?action_id=1903',
	    GET_ALL_FORMS: 'getAllAsiteSupportedApi',
	    SAVE_API_CONNECTION: 'saveApiConnection',
	    GET_API_CONNECTION_LIST: 'getApiConnectionList',
	    COPY_API_CONNECTION: 'copyApiConnection',
	    REMOVE_API_CONNECTION: 'deleteApiConnection',
	    GET_ALL_PROJECTS: 'getPopupData',
	    GET_FORMSTATUS_BY_PROJECTS: 'htmlForm/getStatusByProjectIds',
	    GET_FORMSTYPEBYPROJECTS: 'htmlForm/getFormTypeDetailsByProjectIds',
	    GET_CUSTOMFORMFIELDS: 'htmlForm/getCustomFormFieldsWithFormTypeIds',
	    DESIGN_STYLE: {
	        STANDARD: '1',
	        ADVANCED: '2',
	    }
	};
	exports.Ids = Ids;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var angular = __webpack_require__(1);
	var ToolbarComponent = (function () {
	    function ToolbarComponent() {
	        this.radioModel = this.active;
	    }
	    return ToolbarComponent;
	}());
	exports.ToolbarComponent = ToolbarComponent;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('directives.toolbar', [])
	    .component('toolbar', {
	    template: __webpack_require__(21),
	    controller: ToolbarComponent,
	    bindings: {
	        active: '@',
	        onToolbarClick: '@'
	    }
	})
	    .name;


/***/ }),
/* 21 */
/***/ (function(module, exports) {

	module.exports = "<header class=\"container-fluid\">\n    <div class=\"row bg-grey\">\n        <div class=\"col-xs-7 col-md-offset-5\">\n            <div class=\"btn-toolbar\" role=\"toolbar\">\n                <div class=\"btn-group\">\n                    <label class=\"btn btn-default\" ui-sref=\"create\" ng-model=\"$ctrl.radioModel\" uib-btn-radio=\"'Designer'\">Designer</label>\n                </div>\n            </div>\n        </div>\n    </div>\n</header>"

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var angular = __webpack_require__(1);
	var _ = __webpack_require__(23);
	var blockly_component_1 = __webpack_require__(25);
	var moment = __webpack_require__(115);
	/**
	 * Propertybox for defining properties for selected control.
	 *
	 * @export
	 * @class PropertyboxComponent
	 */
	var PropertyboxComponent = (function () {
	    /**
	     * Creates an instance of PropertyboxComponent.
	     *
	     * @param {any} localStorage
	     *
	     * @memberOf PropertyboxComponent
	     */
	    PropertyboxComponent.$inject = ['localStorage', '$http', '$filter', 'Notification', '$uibModal', '$document', 'Util', '$window', '$translate', '$rootScope', 'config', '$scope', '$sce', '$timeout'];
	    function PropertyboxComponent(localStorage, $http, $filter, Notification, $uibModal, $document, Util, $window, $translate, $rootScope, config, $scope, $sce, $timeout) {
	        /**
	         * Supported Languages
	         *
	         * @type {*}@memberof PropertyboxComponent
	         */
	        this.SupportedLanguages = [
	            {
	                "displayCountry": "United Kingdom",
	                "languageId": "en_GB",
	                "displayLanguage": "English"
	            },
	            {
	                "displayCountry": "United States",
	                "languageId": "en_US",
	                "displayLanguage": "English"
	            },
	            {
	                "displayCountry": "Canada",
	                "languageId": "en_CA",
	                "displayLanguage": "English"
	            },
	            {
	                "displayCountry": "France",
	                "languageId": "fr_FR",
	                "displayLanguage": "Français"
	            },
	            {
	                "displayCountry": "Russia",
	                "languageId": "ru_RU",
	                "displayLanguage": "Русский"
	            },
	            {
	                "displayCountry": "Spain",
	                "languageId": "es_ES",
	                "displayLanguage": "Español"
	            },
	            {
	                "displayCountry": "Australia",
	                "languageId": "en_AU",
	                "displayLanguage": "English"
	            },
	            {
	                "displayCountry": "China",
	                "languageId": "zh_CN",
	                "displayLanguage": "中文"
	            },
	            {
	                "displayCountry": "Germany",
	                "languageId": "de_DE",
	                "displayLanguage": "Deutsch"
	            },
	            {
	                "displayCountry": "Ireland",
	                "languageId": "ga_IE",
	                "displayLanguage": "Gaeilge"
	            },
	            {
	                "displayCountry": "South Africa",
	                "languageId": "en_ZA",
	                "displayLanguage": "English"
	            }
	        ];
	        /**
	         * Color picker default options
	         *
	         * @memberof PropertyboxComponent
	         */
	        this.colorPickerOptions = {
	            showButtons: false,
	            replacerClassName: 'spectrum-color-picker',
	            containerClassName: 'spectrum-color-picker-container'
	        };
	        /**
	         * Date picker default options
	         *
	         * @type {*}@memberof PropertyboxComponent
	         */
	        this.dateOptions = {
	            formatDay: 'dd',
	            formatMonth: 'MMM',
	            formatYear: 'yyyy',
	            showWeeks: false
	        };
	        this.timePickerOptions = {
	            showMeridian: true
	        };
	        this.timeFormat = 'HH:mm';
	        this.numberFormatEnabled = false;
	        this.cellColor = 'rgba(255, 255, 255, 0)';
	        this.multiCellObject = [];
	        /**
	         * Basic sections list
	         *
	         * @type {*}
	         * @memberof PropertyboxComponent
	         */
	        this.basicFields = ["Basic", "Display", "control.style", "label.style", "switch.style", "padding", "style", "row.style", "Size", "Borders", "Merge", "File Attributes Setup", "Form Fields Setup", "Add/Edit Fields"];
	        /**
	         * Advance sections list
	         *
	         * @type {*}
	         * @memberof PropertyboxComponent
	         */
	        this.advancedFields = ["Advanced", "datasource", "Events"];
	        this.typeWiseDataFieldNameAllowed = {
	            'Attachment': ['Attachment'],
	            'Signature': ['Signature'],
	            'Rich-Text-Box': ['Rich-Text-Box'],
	            'Textbox': ['Textbox', 'Text-Area'],
	            'Text-Area': ['Textbox', 'Text-Area'],
	            'Map': ['Map'],
	            'Dropdown': ['Dropdown'],
	            'MultiDropdown': ['MultiDropdown'],
	            'Datepicker': ['Datepicker'],
	            'Checkbox': ['Checkbox'],
	            'Radio': ['Radio'],
	            'ToggleButton': ['ToggleButton'],
	            'Timepicker': ['Timepicker'],
	            'Rating': ['Rating'],
	            'InlineAssocFiles': ['InlineAssocFiles'],
	            'InlineAssocApps': ['InlineAssocApps'],
	            'ViewAssociations': ['ViewAssociations']
	        };
	        this.maximizedCodeEditor = false;
	        this.noop = angular.noop;
	        this.Util = Util;
	        this.config = config;
	        this.hideProperties = false;
	        this.basicSelected = false;
	        this.$document = $document;
	        this.$uibModal = $uibModal;
	        this.$http = $http;
	        this.$filter = $filter;
	        this.store = localStorage;
	        this.$translate = $translate;
	        this.selectedView = this.store.get('selectedView');
	        this.views = this.store.get('views');
	        this.numberFormatEnabled = this.store.get("numberFormatEnabled");
	        this.models = this.store.get('components');
	        this.availableDS = [];
	        this.oneAtATime = true;
	        this.isOpen = [true];
	        this.ngNotification = Notification;
	        this.$window = $window;
	        this.$rootScope = $rootScope;
	        var self = this;
	        this.colorPickerEventApi = {
	            onChange: function (type) {
	                //self.updateStyle(type);
	            }
	        };
	        self.$rootScope.$on('controlValueChanged', function (event, properties) {
	            self.updateDSField(properties);
	            self.onPropValueChanged();
	        });
	        this.datePickerOptions = {
	            format: this.Util.getNewDateFormat('default'),
	            showClear: true,
	            showClose: true,
	            showTodayButton: true,
	            allowInputToggle: true,
	            useCurrent: false,
	            sideBySide: true,
	            keepOpen: false,
	            toolbarPlacement: "bottom",
	            locale: this.config.languageId.split('_')[0],
	            icons: {
	                close: 'closeText',
	                clear: 'clearText',
	                today: 'todayText'
	            }
	        };
	        $scope.htmlPopover = $sce.trustAsHtml(self.$translate.instant('popover.fieldname'));
	        $scope.htmlPopoverForFitScreen = $sce.trustAsHtml(self.$translate.instant('popover.fit.to.screen'));
	        $scope.htmlPopoverForRatingProps = $sce.trustAsHtml(self.$translate.instant('popover.rating'));
	        $scope.htmlPopoverForRatingValueProps = $sce.trustAsHtml(self.$translate.instant('value.popover.rating'));
	        $scope.htmlPopoverForWorkingDays = $sce.trustAsHtml(self.$translate.instant('popover.working.days'));
	        $scope.htmlPopoverForEmbeddedAttachment = $sce.trustAsHtml(self.$translate.instant('popover-embedded-attachment'));
	        var digestTimeOut;
	        this.$rootScope.$on('controlChanged', function (event, args) {
	            self.basicSelected = false;
	            digestTimeOut && $timeout.cancel(digestTimeOut);
	            digestTimeOut = $timeout(function () {
	                var sItem = self.getSelectedItem();
	                if (sItem.type == 'Datepicker') {
	                    var _allprops = self.getSelectedItemProperties();
	                    var pickerId = self.getSelectedItem().uid, _props = _allprops['Basic'], myPropDateElem = angular.element("input[picker-id=p_" + pickerId + "]"), dateTimeFormat = _props['Display Format'].selectedValue == 'default' ? self.Util.getNewDateFormat('default') : _props['Display Format'].selectedValue;
	                    if (_props['Time'] && _props['Time'].selectedValue) {
	                        dateTimeFormat = _props['Time Format'].selectedValue == 'true' ? dateTimeFormat + ' hh:mm A' : dateTimeFormat + ' HH:mm';
	                    }
	                    myPropDateElem.datetimepicker('destroy');
	                    self.datePickerOptions.format = dateTimeFormat;
	                    // Reinitialize with new options
	                    myPropDateElem.datetimepicker(self.datePickerOptions);
	                }
	                if (sItem && (sItem.type === 'InlineAssocFiles' || sItem.type === 'InlineAssocApps')) {
	                    self.updateLanguageData(sItem);
	                }
	                $scope.$digest();
	            }, 100);
	        });
	        this.$rootScope.$on('numberFormatEnabledChanged', function () {
	            self.numberFormatEnabled = self.store.get("numberFormatEnabled");
	        });
	        $scope.htmlPopoverForDataFieldName = $sce.trustAsHtml(self.$translate.instant('popover.data.fieldname'));
	    }
	    PropertyboxComponent.prototype.updateLanguageData = function (selectedItem) {
	        var languageData = this.store.get('Languages') || {};
	        var viewName = selectedItem.viewName;
	        var uid = selectedItem.uid;
	        var textValue = selectedItem.properties.Basic.Text.selectedValue;
	        // Key format for InlineAssocFiles/Apps
	        var textKey = viewName + "_InlineAssoc_" + uid;
	        if (!languageData['Default']) {
	            languageData['Default'] = {};
	        }
	        if (!languageData['Default'][textKey]) {
	            languageData['Default'][textKey] = textValue;
	        }
	        else if (languageData['Default'] && languageData['Default'][textKey]) {
	            languageData['Default'][textKey] = textValue;
	        }
	        // Save updated language data
	        this.store.set('Languages', languageData);
	    };
	    /**
	     * @brief      Open model dialog which contains code editor as body content
	     *
	     * @return     null
	     */
	    PropertyboxComponent.prototype.openCodeEditorDialog = function (eventDetail) {
	        var self = this;
	        var codeEditorModalInstance = self.$uibModal.open({
	            animation: true,
	            ariaLabelledBy: 'modal-title',
	            ariaDescribedBy: 'modal-body',
	            templateUrl: 'codeEditor.html',
	            backdrop: 'static',
	            keyboard: false,
	            controllerAs: '$ctrl',
	            windowClass: 'code-editor-modal',
	            appendTo: angular.element(self.$document[0].querySelector('.form-builder')),
	            controller: function () {
	                var _this = this;
	                this.maximized = false;
	                this.showSpinner = true;
	                self.maximizedCodeEditor = false;
	                angular.element(window).on('resize', function () {
	                    self.codeEditorResizeHandler();
	                });
	                window.setTimeout(function () {
	                    self.codeEditorResizeHandler();
	                    self.codeEditor = angular.element(self.$document[0].querySelector('#blocklyCodeEditor')).data('$asiteBlocklyController');
	                    self.codeEditor.setVal(eventDetail.xmlValue);
	                }, 10);
	                document.body.style.overflow = 'hidden';
	                this.isPasteDisabled = function () {
	                    if (self.$window.localStorage.getItem('domXml')) {
	                        return false;
	                    }
	                    return true;
	                };
	                this.copyBlockly = function () {
	                    self.codeEditor = angular.element(self.$document[0].querySelector('#blocklyCodeEditor')).data('$asiteBlocklyController');
	                    var valObJ = self.codeEditor.getVal(true);
	                    self.Util.setBlocklyBlock(valObJ);
	                };
	                this.pasteBlockly = function () {
	                    try {
	                        self.codeEditor = angular.element(self.$document[0].querySelector('#blocklyCodeEditor')).data('$asiteBlocklyController');
	                        var newDomBlock = self.Util.getBlocklyBlock();
	                        self.codeEditor.setVal(newDomBlock);
	                    }
	                    catch (error) {
	                        self.ngNotification.error({ message: error.message.split('and')[0], positionX: 'center', replaceMessage: true });
	                    }
	                };
	                this.save = function () {
	                    //Read and Validate value from Blockly Eitor and save it
	                    var valObJ = self.codeEditor.getVal(true);
	                    if (valObJ.isAPIInProgress) {
	                        self.ngNotification.error({ message: 'API call is in progress ', positionX: 'center', replaceMessage: true });
	                        return;
	                    }
	                    var infiniteLoopPath;
	                    if (eventDetail.name == 'onChange') {
	                        infiniteLoopPath = self.getInfiniteLoopToChangeValue(valObJ.xmlVal);
	                    }
	                    if (infiniteLoopPath) {
	                        self.ngNotification.error({
	                            message: "Please ckeck your code. We detect a infinite loop to change value. Path : " + infiniteLoopPath,
	                            positionX: 'center',
	                            replaceMessage: true
	                        });
	                    }
	                    else {
	                        eventDetail.selectedValue = valObJ.scriptVal;
	                        eventDetail.xmlValue = valObJ.xmlVal;
	                        eventDetail.systemFields = valObJ.systemFields;
	                        eventDetail.autoNumberFieldDetail = valObJ.autoNumberFieldDetail;
	                        self.updateAllReadonlyControlEventsProperty(eventDetail);
	                        codeEditorModalInstance.close();
	                        self.destroyCodeEditor();
	                    }
	                };
	                /**
	                 * @brief      Close dialog
	                 * @return     NULL
	                 */
	                this.cancel = function () {
	                    // codeEditorModalInstance.dismiss('cancel');
	                    codeEditorModalInstance.close(false);
	                    self.destroyCodeEditor();
	                };
	                this.maximize = function () {
	                    _this.maximized = true;
	                    self.maximizedCodeEditor = true;
	                    self.codeEditorResizeHandler();
	                };
	                this.minimize = function () {
	                    _this.maximized = false;
	                    self.maximizedCodeEditor = false;
	                    self.codeEditorResizeHandler();
	                };
	            }
	        });
	    };
	    /**
	     * @brief      Find out value change event infinite loop path
	     *
	     * @return     Array of control names which generate infinite loop
	     */
	    PropertyboxComponent.prototype.getInfiniteLoopToChangeValue = function (xmlVal) {
	        var self = this;
	        var controlName = self.getSelectedControlFieldName();
	        self.valChangeControlsNameData = {};
	        self.valChangeControlsNameData[controlName] = {};
	        self.getDeepLevelValueSetterControlName(self.valChangeControlsNameData[controlName], undefined, xmlVal);
	        return self.getInfiniteLoopPath();
	    };
	    /**
	     * @brief      Set value chagne control name into instance variable. If control name is passed and XmlVal is not defined that findout xmlVal using control name
	     *
	     * @return     null
	     */
	    PropertyboxComponent.prototype.getDeepLevelValueSetterControlName = function (data, controlName, xmlVal) {
	        var self = this;
	        if (!xmlVal && controlName) {
	            var properties = self.getProperties(controlName);
	            xmlVal = properties && properties.Events.change && properties.Events.change.xmlValue;
	        }
	        var controlNames = blockly_component_1.getAllValueSetterControlName(xmlVal);
	        controlNames.forEach(function (name) {
	            data[name] = {};
	            if (!self.getInfiniteLoopPath()) {
	                self.getDeepLevelValueSetterControlName(data[name], name);
	            }
	        });
	    };
	    /**
	     * @brief      Generate path for each branch of object
	     *
	     * @return     Array of uniq path of each branch of object
	     */
	    PropertyboxComponent.prototype.getPath = function (object) {
	        function iter(obj, path) {
	            var keys = Object.keys(obj);
	            if (keys.length) {
	                return keys.forEach(function (k) {
	                    iter(obj[k], path.concat(k));
	                });
	            }
	            result.push(path);
	        }
	        var result = [];
	        iter(object, []);
	        return result;
	    };
	    /**
	     * @brief      Find out one of the infinite loop path
	     *
	     * @return     Array of path (control name) which generate infinite loop
	     */
	    PropertyboxComponent.prototype.getInfiniteLoopPath = function () {
	        var self = this;
	        var paths = self.getPath(self.valChangeControlsNameData);
	        var infiniteLoop;
	        paths.some(function (path) {
	            if (path.length !== _.uniq(path).length) {
	                infiniteLoop = path;
	                return true;
	            }
	        });
	        return infiniteLoop;
	    };
	    PropertyboxComponent.prototype.codeEditorResizeHandler = function () {
	        var width = (this.maximizedCodeEditor) ? window.innerWidth : Math.min(1280, window.innerWidth);
	        var height = (this.maximizedCodeEditor) ? window.innerHeight : Math.min(600, window.innerHeight);
	        var margin = (this.maximizedCodeEditor) ? 10 : (width <= 768) ? 10 : 30;
	        angular.element('.form-builder .code-editor-modal .modal-dialog').css({
	            'width': (width - (margin * 2)) + 'px',
	            'height': (height - (margin * 2)) + 'px',
	            'marginTop': margin + 'px',
	            'marginBottom': margin + 'px'
	        });
	    };
	    /**
	     * @brief      Destroy existing code editer intanceview.
	     *
	     * @return     null
	     */
	    PropertyboxComponent.prototype.destroyCodeEditor = function () {
	        var self = this;
	        document.body.style.overflow = '';
	        self.codeEditor.destroyCodeEditor();
	        self.codeEditor = undefined;
	        angular.element(window).off('resize');
	    };
	    /**
	     * @brief      Opens a language dialog.
	     *
	     * @return     null
	     */
	    PropertyboxComponent.prototype.openLanguageDialog = function (fieldname, propertyField) {
	        var _this = this;
	        var self = this;
	        var selectedItem = self.getSelectedItemProperties();
	        var uid = self.getSelectedItem().uid;
	        var value = '';
	        if (propertyField.name == 'labelon') {
	            value = selectedItem.Basic.LabelOn.selectedValue;
	        }
	        else if (propertyField.name == 'labeloff') {
	            value = selectedItem.Basic.LabelOff.selectedValue;
	        }
	        else if (propertyField.name == 'displayLabel') {
	            value = selectedItem.Basic.DisplayLabel.selectedValue;
	        }
	        else if ((self.getSelectedItem()['type'] === 'InlineAssocFiles' || self.getSelectedItem()['type'] === 'InlineAssocApps')) {
	            if (propertyField['name'] === 'text') {
	                value = selectedItem.Basic.Text.selectedValue;
	            }
	            else {
	                value = selectedItem.Basic.Label.selectedValue;
	            }
	        }
	        else {
	            if (selectedItem.Basic.Label) {
	                value = selectedItem.Basic.Label.selectedValue;
	            }
	            if (selectedItem.Basic.Text) {
	                value = selectedItem.Basic.Text.selectedValue;
	            }
	        }
	        this.LanguageObject = this.store.get('Languages') || {};
	        var LanguageModalInstance = this.$uibModal.open({
	            animation: true,
	            ariaLabelledBy: 'modal-title',
	            ariaDescribedBy: 'modal-body',
	            templateUrl: 'languageModal.html',
	            backdrop: 'static',
	            keyboard: false,
	            controllerAs: '$ctrl',
	            appendTo: angular.element(self.$document[0].querySelector('.form-builder')),
	            controller: function () {
	                this.supportedLanguages = angular.copy(self.Util.supportedLanguages);
	                this.languageObj = {
	                    'Default': {
	                        displayCountry: "Default",
	                        displayLanguage: "Default",
	                        languageId: "Default",
	                        label: value
	                    }
	                };
	                for (var i = 0; i < this.supportedLanguages.length; i++) {
	                    var language = this.supportedLanguages[i];
	                    this.languageObj[language.languageId] = language;
	                    if (propertyField.name == 'labelon' || propertyField.name == 'labeloff' || propertyField.name == 'displayLabel') {
	                        this.languageObj[language.languageId].label = self.LanguageObject[language.languageId] && self.LanguageObject[language.languageId][self.selectedView.view.viewName + '_' + propertyField.name + '_' + uid] || '';
	                    }
	                    else if ((self.getSelectedItem()['type'] === 'InlineAssocFiles' || self.getSelectedItem()['type'] === 'InlineAssocApps') && propertyField.name === 'text') {
	                        this.languageObj[language.languageId].label = self.LanguageObject[language.languageId] && self.LanguageObject[language.languageId][self.selectedView.view.viewName + '_InlineAssoc_' + uid] || '';
	                    }
	                    else {
	                        this.languageObj[language.languageId].label = self.LanguageObject[language.languageId] && self.LanguageObject[language.languageId][self.selectedView.view.viewName + '_' + uid] || '';
	                    }
	                }
	                /**
	                 * @brief      Re-oraganize language JSON
	                 *             And Send it to parent controller.
	                 *
	                 * @return     NULL
	                 */
	                this.save = function () {
	                    for (var lang in this.languageObj) {
	                        if (propertyField.name == 'labelon' || propertyField.name == 'labeloff' || propertyField.name == 'displayLabel') {
	                            if (this.languageObj[lang].label) {
	                                this.languageObj[lang][self.selectedView.view.viewName + '_' + propertyField.name + '_' + uid] = this.languageObj[lang].label;
	                            }
	                            else {
	                                delete this.languageObj[lang][self.selectedView.view.viewName + '_' + propertyField.name + '_' + uid];
	                            }
	                        }
	                        else if ((self.getSelectedItem()['type'] === 'InlineAssocFiles' || self.getSelectedItem()['type'] === 'InlineAssocApps') && propertyField['name'] === 'text') {
	                            if (this.languageObj[lang].label) {
	                                this.languageObj[lang][self.selectedView.view.viewName + '_InlineAssoc_' + uid] = this.languageObj[lang].label;
	                            }
	                            else {
	                                delete this.languageObj[lang][self.selectedView.view.viewName + '_InlineAssoc_' + uid];
	                            }
	                        }
	                        else {
	                            if (this.languageObj[lang].label) {
	                                this.languageObj[lang][self.selectedView.view.viewName + '_' + uid] = this.languageObj[lang].label;
	                            }
	                            else {
	                                delete this.languageObj[lang][self.selectedView.view.viewName + '_' + uid];
	                            }
	                        }
	                        delete this.languageObj[lang].label;
	                        delete this.languageObj[lang].displayCountry;
	                        delete this.languageObj[lang].displayLanguage;
	                        delete this.languageObj[lang].languageId;
	                    }
	                    LanguageModalInstance.close(this.languageObj);
	                };
	                /**
	                 * @brief      Close language dialog
	                 *
	                 * @return     NULL
	                 */
	                this.cancel = function () {
	                    // LanguageModalInstance.dismiss('cancel');
	                    LanguageModalInstance.close(false);
	                };
	            }
	        });
	        LanguageModalInstance.result.then(function (selectedItem) {
	            for (var lang in selectedItem) {
	                self.LanguageObject[lang] = self.LanguageObject[lang] || {};
	                if (Object.keys(selectedItem[lang]).length > 0) {
	                    angular.merge(self.LanguageObject[lang], selectedItem[lang]);
	                }
	                else {
	                    var keyToDelete = propertyField.name === 'labelon' || propertyField.name === 'labeloff' || propertyField.name === 'displayLabel'
	                        ? self.selectedView.view.viewName + '_' + propertyField.name + '_' + uid
	                        : self.selectedView.view.viewName + '_' + uid;
	                    if ((self.getSelectedItem()['type'] === 'InlineAssocFiles' || self.getSelectedItem()['type'] === 'InlineAssocApps') && propertyField['name'] === 'text') {
	                        Object.keys(self.LanguageObject[lang]).length > 0 && delete self.LanguageObject[lang][self.selectedView.view.viewName + '_InlineAssoc_' + uid];
	                    }
	                    if (Object.keys(self.LanguageObject[lang]).length > 0) {
	                        delete self.LanguageObject[lang][keyToDelete];
	                    }
	                }
	            }
	            _this.store.set('Languages', self.LanguageObject);
	            if (propertyField.name == 'labelon') {
	                self.getSelectedItemProperties().Basic.LabelOn.selectedValue = self.LanguageObject['Default'][self.selectedView.view.viewName + '_labelon_' + uid];
	            }
	            else if (propertyField.name == 'labeloff') {
	                self.getSelectedItemProperties().Basic.LabelOff.selectedValue = self.LanguageObject['Default'][self.selectedView.view.viewName + '_labeloff_' + uid];
	            }
	            else if (propertyField.name == 'displayLabel') {
	                self.getSelectedItemProperties().Basic.DisplayLabel.selectedValue = self.LanguageObject['Default'][self.selectedView.view.viewName + '_displayLabel_' + uid];
	            }
	            else if ((self.getSelectedItem()['type'] === 'InlineAssocFiles' || self.getSelectedItem()['type'] === 'InlineAssocApps')) {
	                if (propertyField['name'] === 'text') {
	                    var asocId = self.selectedView.view.viewName && self.selectedView.view.viewName + '_InlineAssoc_' + uid;
	                    asocId && self.LanguageObject['Default'][asocId] && (self.getSelectedItemProperties().Basic.Text.selectedValue = self.LanguageObject['Default'][asocId]);
	                }
	                else {
	                    self.getSelectedItemProperties().Basic.Label.selectedValue = self.LanguageObject['Default'] && self.LanguageObject['Default'][self.selectedView.view.viewName + '_' + uid];
	                }
	            }
	            else {
	                var labelKey = self.selectedView.view.viewName + '_' + uid;
	                var selectedValue = (self.LanguageObject['Default'] && self.LanguageObject['Default'][labelKey]) || '';
	                var itemProperties = self.getSelectedItemProperties().Basic;
	                if (itemProperties.Label) {
	                    itemProperties.Label.selectedValue = selectedValue;
	                }
	                else {
	                    itemProperties.Text.selectedValue = selectedValue;
	                }
	            }
	        }, function () {
	            console.log('Modal dismissed at: ' + new Date());
	        });
	    };
	    /**
	     * @brief      Opens a language dialog for number separator.
	     *
	     * @return     null
	     */
	    PropertyboxComponent.prototype.openLanguageDialogForNumberSeparator = function (values) {
	        var self = this;
	        var LanguageModalInstance = this.$uibModal.open({
	            animation: true,
	            ariaLabelledBy: 'modal-title',
	            ariaDescribedBy: 'modal-body',
	            templateUrl: 'languageNumberSeparatorModal.html',
	            backdrop: 'static',
	            keyboard: false,
	            controllerAs: '$ctrl',
	            windowClass: 'number-separator-modal',
	            appendTo: angular.element(self.$document[0].querySelector('.form-builder')),
	            controller: function () {
	                this.supportedLanguages = angular.copy(self.Util.supportedLanguages);
	                this.allowDecimalSeparator = values.Validate.selectedValue == 'Decimal';
	                var decimalThousandSeparator = values.DecimalThousandSeparator.selectedValue;
	                this.languageObj = {
	                    'Default': angular.copy(decimalThousandSeparator.Default)
	                };
	                if (this.languageObj['Default'] && this.languageObj['Default'].thousand == ' ') {
	                    this.languageObj['Default'].thousand = 'SPACE';
	                }
	                for (var i = 0; i < this.supportedLanguages.length; i++) {
	                    var language = this.supportedLanguages[i];
	                    this.languageObj[language.languageId] = language;
	                    this.languageObj[language.languageId].decimal = decimalThousandSeparator[language.languageId] && decimalThousandSeparator[language.languageId].decimal || '';
	                    if (decimalThousandSeparator[language.languageId] && decimalThousandSeparator[language.languageId].thousand == ' ') {
	                        decimalThousandSeparator[language.languageId].thousand = 'SPACE';
	                    }
	                    this.languageObj[language.languageId].thousand = decimalThousandSeparator[language.languageId] && decimalThousandSeparator[language.languageId].thousand || '';
	                }
	                /**
	                 * @brief      Re-oraganize language JSON
	                 *             And Send it to parent controller.
	                 *
	                 * @return     NULL
	                 */
	                this.save = function () {
	                    if (this.allowDecimalSeparator) {
	                        var sameValueForDecimalAndThoudSeparator = [];
	                        for (var lang in this.languageObj) {
	                            if (this.languageObj[lang].decimal && this.languageObj[lang].thousand && this.languageObj[lang].decimal == this.languageObj[lang].thousand ||
	                                ((this.languageObj['Default'].decimal == this.languageObj[lang].thousand) && this.languageObj[lang].decimal == "") ||
	                                ((this.languageObj['Default'].thousand == this.languageObj[lang].decimal) && this.languageObj[lang].thousand == "")) {
	                                sameValueForDecimalAndThoudSeparator.push(this.languageObj[lang].displayCountry);
	                            }
	                        }
	                        if (sameValueForDecimalAndThoudSeparator.length) {
	                            self.ngNotification.error({
	                                message: "Please enter a different value for these contries. " + sameValueForDecimalAndThoudSeparator.join(', '),
	                                positionX: 'center',
	                                replaceMessage: true
	                            });
	                            return;
	                        }
	                    }
	                    for (var lang in this.languageObj) {
	                        if (!values.DecimalThousandSeparator.selectedValue[lang]) {
	                            values.DecimalThousandSeparator.selectedValue[lang] = {
	                                languageId: lang
	                            };
	                        }
	                        values.DecimalThousandSeparator.selectedValue[lang].decimal = (this.allowDecimalSeparator) ? this.languageObj[lang].decimal : this.languageObj[lang].thousand == '.' ? ',' : (this.languageObj[lang].thousand == "" && this.languageObj['Default'].thousand) == '.' ? ',' : '.';
	                        values.DecimalThousandSeparator.selectedValue[lang].thousand = this.languageObj[lang].thousand == 'SPACE' ? ' ' : this.languageObj[lang].thousand;
	                    }
	                    LanguageModalInstance.close(this.languageObj);
	                };
	                /**
	                 * @brief      Close language dialog
	                 *
	                 * @return     NULL
	                 */
	                this.cancel = function () {
	                    // LanguageModalInstance.dismiss('cancel');
	                    LanguageModalInstance.close(false);
	                };
	            }
	        });
	    };
	    PropertyboxComponent.prototype.getSelectedControlFieldName = function () {
	        var properties = this.getSelectedItemProperties();
	        return properties && properties.Basic && properties.Basic['Field Name'] && properties.Basic['Field Name'].selectedValue;
	    };
	    PropertyboxComponent.prototype.getProperties = function (fieldName) {
	        var self = this;
	        if (!fieldName) {
	            return;
	        }
	        var controls = self.Util.getAllControls();
	        var properties;
	        controls.some(function (control) {
	            if (control.properties && control.properties.Basic && control.properties.Basic['Field Name'] && control.properties.Basic['Field Name'].selectedValue == fieldName) {
	                properties = control.properties;
	                return true;
	            }
	        });
	        return properties;
	    };
	    /**
	     * @brief      Gets the selected item properties.
	     *
	     * @return     The selected item properties.
	     */
	    PropertyboxComponent.prototype.getSelectedItemProperties = function () {
	        var selected = this.Util.returnSelected(this.selectedView.view.controls.A);
	        var properties = (selected.length == 1) ? selected[0].properties : {};
	        return properties;
	    };
	    PropertyboxComponent.prototype.getInitialColor = function () {
	        var selected = this.Util.returnSelected(this.selectedView.view.controls.A);
	        if (selected && selected.length == 1) {
	            this.fieldName = selected[0].properties.Basic['Field Name'].selectedValue;
	            var ele = angular.element('.canvas').find("[data-fieldname=\"" + this.fieldName + "\"]").find('.eng-selected-item');
	            this.multiCellObject = [];
	            if (ele.length) {
	                for (var i = 0; i < ele.length; i++) {
	                    var col = ele[i].cellIndex;
	                    var row = parseInt(ele[i].id.replace('-' + col, ''));
	                    var dataObj;
	                    if (ele[i].attributes.name && ele[i].attributes.name.nodeValue == "header_data") {
	                        dataObj = selected[0].header_data[row][col];
	                    }
	                    else if (ele[i].attributes.name && ele[i].attributes.name.nodeValue == "footer_data") {
	                        dataObj = selected[0].footer_data[row][col];
	                    }
	                    else if (selected[0].data) {
	                        if (selected[0].type == "Layout")
	                            dataObj = selected[0].data[col];
	                        else
	                            dataObj = selected[0].data[row][col];
	                    }
	                    if (dataObj.style && dataObj.style['background-color'])
	                        this.cellColor = dataObj.style['background-color'];
	                    else
	                        this.cellColor = 'rgba(255, 255, 255, 0)'; //'transparent'
	                    this.multiCellObject.push({ "cellRow": row, "cellCol": col, "background-color": this.cellColor });
	                }
	            }
	            else
	                this.cellColor = 'rgba(255, 255, 255, 0)'; //'transparent'
	            this.onPropValueChanged();
	        }
	    };
	    PropertyboxComponent.prototype.setBackgroundColor = function () {
	        if (this.fieldName) {
	            var selected = this.Util.getControlByFieldName(this.fieldName);
	            var ele = angular.element('.canvas').find("[data-fieldname=\"" + this.fieldName + "\"]").find('.eng-selected-item');
	            if (ele.length && this.cellColor) {
	                for (var i = 0; i < ele.length; i++) {
	                    var col = ele[i].cellIndex;
	                    var row = parseInt(ele[i].id.replace('-' + col, ''));
	                    var dataObj;
	                    if (ele[i].attributes.name && ele[i].attributes.name.nodeValue == "header_data") {
	                        dataObj = selected.header_data[row][col];
	                    }
	                    else if (ele[i].attributes.name && ele[i].attributes.name.nodeValue == "footer_data") {
	                        dataObj = selected.footer_data[row][col];
	                    }
	                    else if (selected.data) {
	                        if (selected.type == "Layout")
	                            dataObj = selected.data[col];
	                        else
	                            dataObj = selected.data[row][col];
	                    }
	                    if (!dataObj.style)
	                        dataObj.style = {};
	                    if (this.$window.multiCellSelected) {
	                        dataObj.style['background-color'] = this.multiCellObject[i]["background-color"];
	                        this.cellColor = this.multiCellObject[i]["background-color"];
	                    }
	                    else {
	                        dataObj.style['background-color'] = this.cellColor;
	                    }
	                }
	            }
	            if (this.$window.multiCellSelected)
	                this.$window.multiCellSelected = false;
	        }
	    };
	    PropertyboxComponent.prototype.removeCellColor = function () {
	        var selected = this.Util.returnSelected(this.selectedView.view.controls.A);
	        if (selected && selected.length == 1) {
	            this.fieldName = selected[0].properties.Basic['Field Name'].selectedValue;
	            var properties = selected[0].properties;
	            var ele = angular.element('.canvas').find("[data-fieldname=\"" + properties.Basic['Field Name'].selectedValue + "\"]").find('.eng-selected-item');
	            if (ele.length) {
	                for (var i = 0; i < ele.length; i++) {
	                    var col = ele[i].cellIndex;
	                    var row = parseInt(ele[i].id.replace('-' + col, ''));
	                    var dataObj;
	                    if (ele[i].attributes.name && ele[i].attributes.name.nodeValue == "header_data") {
	                        dataObj = selected[0].header_data[row][col];
	                    }
	                    else if (ele[i].attributes.name && ele[i].attributes.name.nodeValue == "footer_data") {
	                        dataObj = selected[0].footer_data[row][col];
	                    }
	                    else if (selected[0].data) {
	                        if (selected[0].type == "Layout")
	                            dataObj = selected[0].data[col];
	                        else
	                            dataObj = selected[0].data[row][col];
	                    }
	                    if (dataObj.style && dataObj.style['background-color'])
	                        dataObj.style['background-color'] = 'rgba(255, 255, 255, 0)';
	                }
	            }
	        }
	    };
	    /**
	     * @brief      Gets the selected item.
	     *
	     * @return     The selected item.
	     */
	    PropertyboxComponent.prototype.getSelectedItem = function () {
	        var selected = this.Util.returnSelected(this.selectedView.view.controls.A);
	        if (selected[0] && selected[0].type == "Button" || selected[0] && selected[0].type == "SiteLocationButton") {
	            delete selected[0].properties.Margin;
	        }
	        return (selected.length == 1) ? selected[0] : {};
	    };
	    PropertyboxComponent.prototype.getSelectedItemCell = function () {
	        var selected = this.Util.returnSelected(this.selectedView.view.controls.A);
	        if (selected.length && selected.length == 1) {
	            var properties = selected[0].properties;
	            var ele = angular.element('.canvas').find("[data-fieldname=\"" + properties.Basic['Field Name'].selectedValue + "\"]").find('.eng-selected-item');
	            if (ele.length)
	                return true;
	            else
	                return false;
	        }
	        else
	            return false;
	    };
	    PropertyboxComponent.prototype.getSelectedButtonProperties = function (values) {
	        if (this.config.for == "Meta-Data" || !values.Name) {
	            return true;
	        }
	        var selectedItemType = this.getSelectedItem().type;
	        if (selectedItemType == "Line" || selectedItemType == "Image" || selectedItemType == "Label") {
	            return true;
	        }
	        if (this.basicSelected) {
	            return this.basicFields.indexOf(values.Name.selectedValue) == -1;
	        }
	        return this.advancedFields.indexOf(values.Name.selectedValue) == -1;
	    };
	    PropertyboxComponent.prototype.isDivhide = function () {
	        if (this.config.for == "Meta-Data") {
	            return true;
	        }
	        var selectedItemType = this.getSelectedItem().type;
	        return selectedItemType == "Line" || selectedItemType == "Image" || selectedItemType == "Label";
	    };
	    /**
	     * Add option for control (Radio, checkbox).
	     *
	     * @param {any} index
	     * @param {any} item
	     * @param {any} list
	     *
	     * @memberof PropertyboxComponent
	     */
	    PropertyboxComponent.prototype.addIntoList = function (index, item, list) {
	        var lastId = Math.max.apply(Math, list.map(function (o) { return o.id; }));
	        var copiedItem = angular.copy(item);
	        for (var i in copiedItem) {
	            if (copiedItem[i].name) {
	                copiedItem[i].name = "";
	            }
	            if (copiedItem[i].relation) {
	                copiedItem[i].relation = {};
	            }
	        }
	        var arrayOfValues = [];
	        var arrayOfLabels = [];
	        for (var j = list.length - 1; j >= 0; j--) {
	            arrayOfValues.push(list[j].Value.name);
	            arrayOfLabels.push(list[j].Label.name);
	        }
	        if (this.Util.hasDuplicates(arrayOfValues) || this.Util.hasDuplicates(arrayOfLabels)) {
	            var msg = this.$translate.instant('duplicate.value.found');
	            this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
	            return;
	        }
	        copiedItem['id'] = lastId + 1;
	        list.splice((index + 1), 0, copiedItem);
	        if (typeof this.updateRows === "function") {
	            this.updateRows();
	        }
	    };
	    PropertyboxComponent.prototype.removeDefault = function (list) {
	        for (var i in list) {
	            list[i].Default.name = false;
	        }
	        this.updateRows();
	    };
	    /**
	     *  Remove option for control (Radio, checkbox).
	     *
	     * @param {any} index
	     * @param {any} list
	     *
	     * @memberof PropertyboxComponent
	     */
	    PropertyboxComponent.prototype.removeFromList = function (index, list) {
	        list.splice(index, 1);
	        if (typeof this.updateRows === "function") {
	            this.updateRows();
	        }
	    };
	    /**
	    * @description Update reference control table list and optionlist when original control static data updated.
	    */
	    PropertyboxComponent.prototype.updateReferenceControl = function (list) {
	        var selectedItem = this.getSelectedItem();
	        var controls = this.Util.getControlsByDataFieldName(selectedItem.properties.Basic['Data Field Name'].selectedValue);
	        if (controls.length > 1) {
	            controls.forEach(function (element) {
	                if (element['uid'] != selectedItem['uid']) {
	                    element['properties']['Data Source'].table.list = list && list['list'];
	                }
	            });
	        }
	    };
	    /**
	     * Update layout in designer after change in property.
	     *
	     *
	     * @memberof PropertyboxComponent
	     */
	    PropertyboxComponent.prototype.updateColumns = function () {
	        var selectedItems = this.Util.returnSelected(this.selectedView.view.controls.A);
	        if (selectedItems.length == 1) {
	            var localObj = selectedItems[0], columns = localObj.properties.Display.Columns.selectedValue.split('/')[1], existingColumn = localObj.data.length, columnAdded = void 0;
	            if (columns > existingColumn) {
	                columnAdded = columns - existingColumn;
	                for (var i = 0; i < columnAdded; ++i) {
	                    localObj.data.push({ elems: [[]] });
	                }
	            }
	            if (columns < existingColumn) {
	                localObj.data.length = columns;
	            }
	        }
	    };
	    /**
	     * Update table in designer after change in property.(Rows, Columns)
	     *
	     *
	     * @memberof PropertyboxComponent
	     */
	    PropertyboxComponent.prototype.updateTable = function () {
	        //setTimeout(() => {
	        var selectedItems = this.Util.returnSelected(this.selectedView.view.controls.A);
	        if (selectedItems.length == 1) {
	            var localObj = selectedItems[0];
	            var rows = localObj.properties.Display.Rows.selectedValue;
	            var columns = localObj.properties.Display.Columns.selectedValue;
	            if (!rows || !columns)
	                return;
	            var existingRow = localObj.data.length, existingColumn = localObj.data[0].length, rowAdded = void 0, columnAdded = void 0;
	            localObj.ids = []; // Deselect cells when udpate rows/columns
	            localObj.reset = true;
	            // Increase Rows
	            if (rows > existingRow) {
	                rowAdded = rows - existingRow;
	                for (var i = 0; i < rowAdded; ++i) {
	                    localObj.data.push([]);
	                    for (var j = 0; j < columns; ++j) {
	                        localObj.data[existingRow + i].push({ elems: [[]] });
	                    }
	                }
	            }
	            // Increase Columns
	            if (columns > existingColumn) {
	                columnAdded = columns - existingColumn;
	                for (var i = 0; i < columnAdded; ++i) {
	                    for (var j = 0; j < rows; ++j) {
	                        localObj.data[j].push({ elems: [[]] });
	                    }
	                }
	            }
	            // Decrease Rows
	            if (rows < existingRow) {
	                localObj.data.length = rows;
	            }
	            // Decrease Columns
	            if (columns < existingColumn) {
	                for (var i = 0; i < rows; ++i) {
	                    localObj.data[i].length = columns;
	                }
	            }
	        }
	        //}, 1000);
	    };
	    /**
	     * Update/Reset Repeating table's columns properties
	     *
	     * @memberof PropertyboxComponent
	     */
	    PropertyboxComponent.prototype.updateRepeatingTable = function () {
	        var selectedItems = this.Util.returnSelected(this.selectedView.view.controls.A);
	        if (selectedItems.length == 1) {
	            var localObj = selectedItems[0], columns = localObj.properties.Basic.Columns.selectedValue, existingColumn = localObj.data[0].length, columnAdded = void 0;
	            if (!columns)
	                return;
	            if (columns > existingColumn) {
	                columnAdded = columns - existingColumn;
	                for (var i = 0; i < columnAdded; ++i) {
	                    localObj.data[0].push({ elems: [[]] });
	                    localObj.header_data[0].push({ elems: [[]] });
	                    localObj.footer_data[0].push({ elems: [[]] });
	                }
	            }
	            if (columns < existingColumn) {
	                localObj.data[0].length = columns;
	                localObj.header_data[0].length = columns;
	                localObj.footer_data[0].length = columns;
	            }
	        }
	    };
	    /**
	     * Update/reset Repeating table Header and footer properties
	     *
	     * @memberof PropertyboxComponent
	     */
	    PropertyboxComponent.prototype.updateHeaderAndFooter = function () {
	        var selectedItems = this.Util.returnSelected(this.selectedView.view.controls.A);
	        if (selectedItems.length == 1) {
	            var localObj = selectedItems[0];
	            var columns = localObj.properties.Basic.Columns.selectedValue;
	            var headerIncluded = localObj.properties.Basic.Include_Header.selectedValue;
	            var footerIncluded = localObj.properties.Basic.Include_Footer.selectedValue;
	            if (!headerIncluded) {
	                localObj.header_data = [[]];
	            }
	            if (!footerIncluded) {
	                localObj.footer_data = [[]];
	            }
	            for (var j = 0; j < columns; ++j) {
	                !headerIncluded && localObj.header_data[0].push({ elems: [[]] });
	                !footerIncluded && localObj.footer_data[0].push({ elems: [[]] });
	            }
	        }
	    };
	    /**
	     * Validate input type="number"
	     *
	     * @param {any} $event
	     * @param {any} value
	     * @memberof PropertyboxComponent
	     */
	    PropertyboxComponent.prototype.validPattern = function ($event, value) {
	        var paddingAttribute = ["top", "bottom", "left", "right"];
	        if (paddingAttribute.indexOf(value.name) > -1) {
	            var inputValue = isNaN(parseFloat($event.target.value)) ? '0' : parseFloat($event.target.value);
	            if (parseFloat(inputValue) < parseFloat(value.min) || parseFloat(inputValue) > parseFloat(value.max)) {
	                inputValue = value.min;
	                this.ngNotification.error({
	                    message: "Please enter a valid number between " + value.min + " to " + value.max + ".",
	                    positionX: 'center',
	                    replaceMessage: true
	                });
	            }
	            value.selectedValue = inputValue;
	            $event.target.value = inputValue;
	        }
	        else if (['char.limit', 'Columns', 'min', 'max', 'value', 'thumbnail.width', 'thumbnail.height'].indexOf(value.name) > -1) {
	            var currentControl = this.getSelectedItem();
	            var inputValue = isNaN(parseInt($event.target.value)) ? '0' : $event.target.value;
	            if (parseInt(inputValue) < parseInt(value.min) || parseInt(inputValue) > parseInt(value.max)) {
	                var msg = 'Please enter a valid number between ' + value.min + ' to ' + value.max + '.';
	                if (currentControl && currentControl.type == 'Rich-Text-Box') {
	                    value.selectedValue = isNaN(value.default) ? 3000 : value.default;
	                    $event.target.value = isNaN(value.default) ? 3000 : value.default;
	                    msg = 'Maximum 5000 Characters allowed!';
	                }
	                else {
	                    value.selectedValue = isNaN(value.default) ? 20 : value.default;
	                    $event.target.value = isNaN(value.default) ? 20 : value.default;
	                }
	                this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
	            }
	            else {
	                value.selectedValue = (parseInt(inputValue) != 0 ? parseInt(inputValue) : (value.default === undefined) ? 20 : value.default);
	            }
	        }
	        else if (['height', 'width'].indexOf(value.name) > -1) {
	            var inputValue = isNaN(parseInt($event.target.value)) ? value.min : $event.target.value;
	            if (parseInt(inputValue) < parseInt(value.min) || parseInt(inputValue) > parseInt(value.max)) {
	                value.selectedValue = value.min;
	                $event.target.value = value.min;
	                var msg = 'Please enter a valid number between ' + value.min + ' to ' + value.max + '.';
	                this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
	            }
	            else {
	                value.selectedValue = (parseInt(inputValue) != 0 ? parseInt(inputValue) : value.min);
	            }
	        }
	    };
	    PropertyboxComponent.prototype.updateAllReadonlyControlEventsProperty = function (eventDetail) {
	        if (!eventDetail) {
	            return;
	        }
	        var totalItems = this.Util.getAllControls();
	        var selectedItem = this.getSelectedItem();
	        var filtered = _.filter(totalItems, { uid: selectedItem.uid });
	        filtered.forEach(function (control) {
	            if (control.properties && control.properties.Events) {
	                for (var event_1 in control.properties.Events) {
	                    var eDetail = control.properties.Events[event_1];
	                    if (eDetail.disable && (eDetail.name == eventDetail.name)) {
	                        eDetail.selectedValueReadonly = eventDetail.selectedValue;
	                    }
	                }
	            }
	        });
	    };
	    /**
	     * Validate field name on input blur event (Only for Field Name property)
	     * Replace field name in Globle and Event code editor script where user had used this field name
	     *
	     * @param {any} value - New value of field name
	     * @param {any} prevValue - Prev value of field name
	     * @memberof PropertyboxComponent
	     */
	    PropertyboxComponent.prototype.restrictChar = function (value, prevValue) {
	        if (value == prevValue) {
	            return;
	        }
	        var validText = this.Util.isValidXMLTagName(value);
	        var isValid = this.Util.isValidString(value);
	        if (!isValid) {
	            var selectedItem = this.getSelectedItem();
	            var msg = 'Field name must conform to the following guidelines:<br>-	Field name can consist of a letter, a digit, an underscore(_).<br>-	The first character must be a letter, or an underscore (_).<br>-	Field name cannot contain more than two undescore  (_) continuously.<br>-	Field name cannot contain spaces or start with system reserved words like XML or xml or Xml script, window<br>';
	            this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
	            selectedItem.properties.Basic['Field Name'].selectedValue = prevValue;
	            return;
	        }
	        else if (validText == false) {
	            var msg = 'Field name must conform to the following guidelines:<br>-	Field name can consist of a letter, a digit, an underscore(_).<br>-	The first character must be a letter, or an underscore (_).<br>-	Field name cannot contain more than two undescore  (_) continuously.<br>-	Field name cannot contain spaces or start with system reserved words like XML or xml or Xml<br>';
	            this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
	        }
	        else if (value && (value.startsWith("DS_") || value.startsWith("DSI_"))) {
	            var msg = 'Field name cannot start with "DS_" or "DSI_" as they are reserved for system fields. Kindly update the field name to continue.';
	            this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
	        }
	        else {
	            var selectedItem = this.getSelectedItem();
	            var totalItems = this.Util.getAllControls();
	            var filtered = _.filter(totalItems, { uid: selectedItem.uid });
	            var filterReadOnlyControls = filtered.filter(function (val) {
	                return val.copiedFrom != undefined;
	            });
	            selectedItem.properties.Basic['Field Name'].prevSelectedValue = value;
	            var filterCalculatedValues = "";
	            for (var i = 0; i < filterReadOnlyControls.length; i++) {
	                filterCalculatedValues = filterReadOnlyControls[i].copiedFrom;
	                _.set(filterReadOnlyControls[i], "properties.Basic['Field Name'].selectedValue", value);
	                _.set(filterReadOnlyControls[i], "properties.Basic['Field Name'].prevSelectedValue", value);
	                filterReadOnlyControls[i].copiedFrom && (filterReadOnlyControls[i].copiedFrom = value);
	            }
	            // initialize the filterCalculatedValues with the previous value, if it is empty
	            if (!filterCalculatedValues) {
	                filterCalculatedValues = prevValue;
	            }
	            var filterCalculatedControls = _.filter(totalItems, { pasteAsCalculatedFrom: filterCalculatedValues });
	            if (filterCalculatedControls.length && !selectedItem.hasOwnProperty('pasteAsCalculatedFrom')) {
	                this.Util.updateCalculatedControls(filterCalculatedControls, selectedItem, value, 'FieldName');
	            }
	            this.Util.replaceFieldNameInCodeEditor(totalItems, prevValue, value);
	        }
	    };
	    ;
	    /**
	     * Validate data field name on input blur event (Only for Data Field Name property)
	     * Replace data field name in Globle and Event code editor script where user had used this field name
	     *
	     * @param {any} value - New value of data field name
	     * @param {any} prevValue - Prev value of data field name
	     * @memberof PropertyboxComponent
	     */
	    PropertyboxComponent.prototype.restrictCharInDataFieldName = function (value, prevValue, excludeDSValidation) {
	        if (excludeDSValidation === void 0) { excludeDSValidation = false; }
	        var self = this;
	        if (typeof value == 'object') {
	            prevValue = value['Data Field Name'].prevSelectedValue;
	            value = value['Data Field Name'].selectedValue;
	        }
	        if (value == prevValue) {
	            return;
	        }
	        var validText = self.Util.isValidXMLTagName(value);
	        if (validText == false) {
	            var msg = 'Data Field Name must conform to the following guidelines:<br>-	Data Field Name can consist of a letter, a digit, an underscore(_).<br>-	The first character must be a letter, or an underscore (_).<br>-	Data field name cannot contain more than two undescore  (_) continuously.<br>-	Data Field name cannot contain spaces or start with system reserved words like XML or xml or Xml<br>';
	            self.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
	            return;
	        }
	        if (!excludeDSValidation && value && (value.startsWith("DS_") || value.startsWith("DSI_"))) {
	            var msg = 'Data Field Name cannot start with "DS_" or "DSI_" as they are reserved for system fields. Kindly update the field name to continue.';
	            self.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
	            return;
	        }
	        var selectedItem = self.getSelectedItem();
	        var totalItems = self.Util.getAllControls();
	        var notAllowedControlTypes = [];
	        totalItems.forEach(function (item) {
	            if (selectedItem.type != item.type) {
	                var dataFieldName = item.properties.Basic && item.properties.Basic['Data Field Name'] && item.properties.Basic['Data Field Name'].selectedValue;
	                if (dataFieldName && value == dataFieldName && (self.typeWiseDataFieldNameAllowed[selectedItem.type].indexOf(item.type) == -1)) {
	                    notAllowedControlTypes.push(item.type);
	                }
	            }
	        });
	        if (notAllowedControlTypes.length) {
	            var dataFieldNameTypeError = "Please set a Data Field Name which is not used for another controls or use same Data Field Name which is used for " + self.typeWiseDataFieldNameAllowed[selectedItem.type].join(', ') + " control.";
	            self.ngNotification.error({ message: dataFieldNameTypeError, positionX: 'center', replaceMessage: true });
	            _.set(selectedItem, "properties.Basic['Data Field Name'].selectedValue", prevValue);
	            return;
	        }
	        var filtered = _.filter(totalItems, { uid: selectedItem.uid });
	        for (var i = 0; i < filtered.length; i++) {
	            if (filtered[i].properties && filtered[i].properties.Basic && filtered[i].properties.Basic['Data Field Name']) {
	                _.set(filtered[i], "properties.Basic['Data Field Name'].selectedValue", value);
	                _.set(filtered[i], "properties.Basic['Data Field Name'].prevSelectedValue", value);
	            }
	        }
	        //Rename data field in FX value if same data field name is used
	        var regex = /(^\{\{.*?\}\}$)/;
	        totalItems.forEach(function (control) {
	            var controlValue = _.get(control, 'properties.Basic.Value.selectedValue', '');
	            if (typeof (controlValue) == 'boolean') {
	                if (controlValue && (prevValue == controlValue)) {
	                    _.set(control, 'properties.Basic.Value.selectedValue', '{{' + value + '}}');
	                    self.updateDSField(control.properties.Basic);
	                }
	            }
	            else {
	                if (controlValue.match && controlValue.match(regex)) {
	                    var val = controlValue.replace('{{', '').replace('}}', '');
	                    if (val && (prevValue == val)) {
	                        _.set(control, 'properties.Basic.Value.selectedValue', '{{' + value + '}}');
	                        self.updateDSField(control.properties.Basic);
	                    }
	                }
	            }
	        });
	        var calculatedControlFieldName = _.get(selectedItem, 'properties.Basic["Field Name"].selectedValue');
	        var calculatedControls = _.filter(totalItems, { pasteAsCalculatedFrom: calculatedControlFieldName });
	        if (calculatedControls.length) {
	            this.Util.updateCalculatedControls(calculatedControls, selectedItem, value, 'DataFieldName');
	        }
	        this.Util.replaceDataFieldNameInCodeEditor(totalItems, prevValue, value);
	    };
	    ;
	    /**
	     * Open data source selection popup for dropdown
	     *
	     * @param {any} sourceType
	     * @param {any} properties
	     * @memberof PropertyboxComponent
	     */
	    PropertyboxComponent.prototype.editDataSource = function (sourceType, properties) {
	        var self = this;
	        var selectedItem = self.getSelectedItem();
	        if (selectedItem.type == "Dropdown" || selectedItem.type == "MultiDropdown") {
	            self.editDropDownSource(sourceType, properties);
	        }
	        if (selectedItem.type == "Image") {
	            self.editImageSource(sourceType, properties);
	        }
	    };
	    PropertyboxComponent.prototype.sourceChanged = function (sourceType, properties) {
	        var self = this;
	        var selectedItem = self.getSelectedItem();
	        if (selectedItem.type == "Image") {
	            _.set(properties, 'Url.selectedValue', '');
	        }
	    };
	    PropertyboxComponent.prototype.editImageSource = function (sourceType, properties) {
	        var self = this;
	        var modalInstance = this.$uibModal.open({
	            animation: true,
	            ariaLabelledBy: 'modal-title',
	            ariaDescribedBy: 'modal-body',
	            templateUrl: 'image.html',
	            backdrop: 'static',
	            keyboard: false,
	            controllerAs: '$ctrl',
	            windowClass: 'image-modal',
	            appendTo: angular.element(self.$document[0].querySelector('.form-builder')),
	            controller: function () {
	                var _this = this;
	                var selectedItem = self.getSelectedItemProperties();
	                _this.image = '';
	                _this.source = _.get(selectedItem, "Basic.Url.selectedValue", '');
	                _this.sourceType = sourceType;
	                if ((_this.sourceType == 0 && _this.source.indexOf('data:') == 0) || (_this.sourceType == 1 && _this.source.indexOf('http') == 0)) {
	                    _this.source = '';
	                }
	                _this.properties = angular.copy(properties);
	                _this.save = function (url) {
	                    _.set(properties, 'Url.selectedValue', url || '');
	                    this.cancel();
	                };
	                _this.cancel = function () {
	                    // modalInstance.dismiss('cancel');
	                    modalInstance.close(false);
	                };
	            }
	        });
	    };
	    PropertyboxComponent.prototype.editDropDownSource = function (sourceType, properties) {
	        var self = this;
	        var modalInstance = this.$uibModal.open({
	            animation: true,
	            ariaLabelledBy: 'modal-title',
	            ariaDescribedBy: 'modal-body',
	            templateUrl: 'dataSource.html',
	            backdrop: 'static',
	            keyboard: false,
	            controllerAs: '$ctrl',
	            appendTo: angular.element(self.$document[0].querySelector('.form-builder')),
	            controller: function () {
	                var _this = this;
	                this.sourceType = sourceType;
	                this.urls = [];
	                var selectedItem = self.getSelectedItemProperties();
	                this.sourceType == 3 && (this.multipleSelectedValue = (selectedItem.Basic['Multi-Select'] && selectedItem.Basic['Multi-Select'].selectedValue) || selectedItem['Basic'].ControlType == 'MultiDropdown');
	                this.properties = JSON.parse(JSON.stringify(properties));
	                this.sourceType == 1 && (this.urls = self.Util.getAvailableDS());
	                this.sourceType == 4 && (this.urls = self.Util.getFixedFields(this.properties.fixedFieldUrl.singleValue));
	                // this.sourceType == 5 && (this.urls = self.Util.getCustomAttributes());
	                this.list = (this.properties.table || {}).list;
	                this.parameterList = (this.properties.Parameters || {}).list;
	                this.designType = self.config.for;
	                var setDropdownOptionsForHierarchy = function () {
	                    var selectedValue = _this.properties.customAttr.selectedValue;
	                    //Filtering out ONLY the Hierarchy containing Attribute Sets from the response data
	                    var projectCustomAttributeSets = JSON.parse(JSON.stringify(self.$rootScope.ProjectCustomAttributeSet));
	                    _this.firstDropdownOptions.length = 0;
	                    if (projectCustomAttributeSets && projectCustomAttributeSets.length && selectedValue) {
	                        for (var i = 0; i < projectCustomAttributeSets.length; i++) {
	                            var attrSet = projectCustomAttributeSets[i];
	                            if (attrSet.hierarchyAttributes) {
	                                var hasParentAsAttr = false;
	                                for (var j = 0; j < attrSet.hierarchyAttributes.length; j++) {
	                                    var element = attrSet.hierarchyAttributes[j];
	                                    if (element.parentAttributeName == selectedValue) {
	                                        hasParentAsAttr = true;
	                                        break;
	                                    }
	                                }
	                                hasParentAsAttr && _this.firstDropdownOptions.push({
	                                    attributeName: attrSet.attributeSetName,
	                                    attributeSetId: attrSet.attributeSetId,
	                                    hierarchyAttributes: attrSet.hierarchyAttributes
	                                });
	                            }
	                        }
	                    }
	                    // Dropdown options for Child Dropdown
	                    if (!_this.firstDropdownOptions.length) {
	                        _this.secondDropdownOptions.length = 0;
	                    }
	                    else {
	                        var fielNameArr = [];
	                        for (var k = 0; k < _this.allControls.length; k++) {
	                            var controls = _this.allControls[k];
	                            if (controls.viewName == self.selectedView.view.viewName && controls.copiedFrom == undefined && controls.selected == true && controls.properties["Data Source"].Source.selectedValue == 5 && controls.parent == 'repeating-table') {
	                                _this.allControlsgGot = [];
	                                // this will check the controls with same level of RT need to be map.
	                                for (var x = 0; x < _this.allControlsRT.length; x++) {
	                                    if (_this.allControlsRT[x].parentFieldName == controls.parentFieldName && controls.parent == 'repeating-table') {
	                                        _this.allControlsgGot.push(_this.allControlsRT[x]);
	                                    }
	                                    // this will check the controls with nested 1 level deep of RT need to be map.
	                                    for (var f = 0; f < _this.gotAllControls.length; f++) {
	                                        if (_this.gotAllControls[f].properties.Basic && _this.gotAllControls[f].properties.Basic['Data Field Name'] != undefined && _this.gotAllControls[f].properties.Basic['Data Field Name'].selectedValue == _this.allControlsRT[x].parentFieldName && _this.gotAllControls[f].parentFieldName == controls.parentFieldName) {
	                                            _this.allControlsgGot.push(_this.allControlsRT[x]);
	                                        }
	                                    }
	                                }
	                                break;
	                            }
	                            else
	                                _this.allControlsgGot = _this.allControls.filter(function (control) { return control.viewName === self.selectedView.view.viewName && !control.copiedFrom && control.properties["Data Source"].Source.selectedValue == 5; });
	                        }
	                        _this.optionNumber = [];
	                        for (var j = 0; j < _this.firstDropdownOptions.length; j++) {
	                            _this.elements = [];
	                            for (var l = 0; l < _this.firstDropdownOptions[j].hierarchyAttributes.length; l++) {
	                                if (_this.firstDropdownOptions[j].hierarchyAttributes[l].parentAttributeName == _this.properties.customAttr.selectedValue) {
	                                    for (var k = 0; k < _this.allControlsgGot.length; k++) {
	                                        var control = _this.allControlsgGot[k];
	                                        if (control.selected != true && control.properties["Data Source"].Source.selectedValue == 5) {
	                                            if (_this.firstDropdownOptions[j].hierarchyAttributes[l].childAttributeName == control.properties["Data Source"].customAttr.selectedValue) {
	                                                _this.elements.push(JSON.stringify({
	                                                    controlFieldName: control.properties.Basic["Field Name"].selectedValue,
	                                                    attributeName: _this.firstDropdownOptions[j].hierarchyAttributes[l].childAttributeName
	                                                }));
	                                                fielNameArr.push(control.properties.Basic["Field Name"].selectedValue);
	                                            }
	                                        }
	                                    }
	                                }
	                            }
	                            _this.optionNumber[j] = _this.firstDropdownOptions[j].attributeSetId;
	                            _this.secondDropdownOptions[j] = _this.elements;
	                        }
	                    }
	                    if (!_this.firstDropdownOptions && !_this.secondDropdownOptions.length) {
	                        _this.hierarchyData.length = 0;
	                        _this.hierarchyData.push({
	                            attributeSetData: '',
	                            childDropdown: '',
	                            parentAttributeName: ''
	                        });
	                    }
	                };
	                var updateCustomAttr = function (oldAttr, columnList) {
	                    if (Object.keys(oldAttr.name).length != 0) {
	                        var findNewAttrID = columnList.filter(function (e) { return e.id != oldAttr.name.id && e.colDisplayName == oldAttr.name.colDisplayName; });
	                        findNewAttrID && findNewAttrID[0] && (oldAttr.name.id = findNewAttrID[0].id);
	                        findNewAttrID && findNewAttrID[0] && (oldAttr.value = findNewAttrID[0].id);
	                    }
	                };
	                if (this.sourceType == 5) {
	                    this.urls = self.Util.getCustomAttributes();
	                    this.gotAllControls = self.Util.getAllControls();
	                    this.allControls = self.Util.getControlsByType(['Dropdown', 'MultiDropdown']);
	                    this.allControlsRT = [];
	                    this.allControlsNew = [];
	                    for (var i = 0; i < this.allControls.length; i++) {
	                        if (this.allControls[i].parent == 'repeating-table') {
	                            _this.allControlsRT.push(this.allControls[i]);
	                        }
	                        else {
	                            _this.allControlsNew.push(this.allControls[i]);
	                        }
	                    }
	                    this.hierarchyData = this.properties.customAttr.hierarchyData;
	                    this.firstDropdownOptions = [];
	                    this.secondDropdownOptions = [];
	                    if (this.hierarchyData && this.hierarchyData.length < 1) {
	                        this.hierarchyData.push({
	                            attributeSetData: '',
	                            childDropdown: '',
	                            parentAttributeName: ''
	                        });
	                    }
	                    setDropdownOptionsForHierarchy();
	                }
	                if (this.sourceType == 6) {
	                    this.columnList = self.Util.docColData;
	                    this.columnList = this.columnList.filter(function (e) { return e.colDisplayName != 'Doc Ref'; });
	                    if (this.list.length > 1) {
	                        for (var _i = 0, _a = this.list; _i < _a.length; _i++) {
	                            var item = _a[_i];
	                            item.Value.name.isCustomAttributeColumn == true && updateCustomAttr(item.Value, this.columnList);
	                        }
	                    }
	                }
	                if (this.sourceType == 7) {
	                    this.columnList = self.Util.appColData;
	                    this.columnList = this.columnList.filter(function (e) { return e.colDisplayName != 'ID'; });
	                }
	                if (this.sourceType == 8) {
	                    if (selectedItem.Basic['Assoc Type'].selectedValue == 'Files') {
	                        this.columnList = self.Util.docColData;
	                        this.columnList = this.columnList.filter(function (e) { return e.colDisplayName != 'Doc Ref'; });
	                        if (this.list.length > 1) {
	                            for (var _b = 0, _c = this.list; _b < _c.length; _b++) {
	                                var item = _c[_b];
	                                item.Value.name.isCustomAttributeColumn == true && updateCustomAttr(item.Value, this.columnList);
	                            }
	                        }
	                    }
	                    else if (selectedItem.Basic['Assoc Type'].selectedValue == 'Apps') {
	                        this.columnList = self.Util.appColData;
	                        this.columnList = this.columnList.filter(function (e) { return e.colDisplayName != 'ID'; });
	                    }
	                }
	                this.getSelectedDropdownOption = function (item, selectedOption) {
	                    if (selectedOption && selectedOption != "") {
	                        var index = this.columnList.findIndex(function (ele) { return ele.id == selectedOption; });
	                        item.name = this.columnList[index];
	                    }
	                    else if (selectedOption == "") {
	                        item.name = selectedOption;
	                    }
	                };
	                this.addAssocRowInList = function (index, item, list) {
	                    var lastId = Math.max.apply(Math, list.map(function (o) { return o.id; }));
	                    var copiedItem = angular.copy(item);
	                    for (var i in copiedItem) {
	                        if (copiedItem[i].name && copiedItem[i].name != 'sorting') {
	                            copiedItem[i].name = "";
	                        }
	                        if (copiedItem[i].selectedValue) {
	                            copiedItem[i].selectedValue = "";
	                        }
	                    }
	                    var arrayOfValues = [];
	                    for (var j = list.length - 1; j >= 0; j--) {
	                        var uniqVal = list[j].Value.name.fieldName ? list[j].Value.name.fieldName : list[j].Value.name;
	                        list[j].Value && arrayOfValues.push(uniqVal);
	                    }
	                    if (this.Util.hasDuplicates(arrayOfValues)) {
	                        var msg = this.$translate.instant('duplicate.value.found');
	                        this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
	                        return;
	                    }
	                    copiedItem['id'] = lastId + 1;
	                    list.splice((index + 1), 0, copiedItem);
	                    if (typeof this.updateRows === "function") {
	                        this.updateRows();
	                    }
	                };
	                this.selectSortOrder = function (item, selectedVal) {
	                    for (var _i = 0, _a = this.list; _i < _a.length; _i++) {
	                        var ele = _a[_i];
	                        if (ele.Sorting && ele.Sorting.selectedValue && ele.Sorting.selectedValue != '') {
	                            ele.Sorting.selectedValue = '';
	                        }
	                    }
	                    item.selectedValue = selectedVal;
	                };
	                this.selectDefaultSortOrd = function (item, selectedVal) {
	                    if (item.DefaultRd) {
	                        return;
	                    }
	                    else {
	                        item.selectedValue = selectedVal;
	                        item['DefaultRd'] = true;
	                    }
	                };
	                if (this.properties.fixedFieldUrl && typeof this.properties.fixedFieldUrl.selectedValue != 'string') {
	                    var field = this.urls.filter(function (value) {
	                        return value.value == _this.properties.fixedFieldUrl.selectedValue.value;
	                    });
	                    if (field.length) {
	                        this.properties.fixedFieldUrl.selectedValue.key = field[0].key;
	                    }
	                }
	                this.clearAttributeSet = function () {
	                    this.properties.customAttr.selectedValue = '';
	                    this.firstDropdownOptions = [];
	                    this.secondDropdownOptions = [];
	                    if (this.hierarchyData && this.properties.customAttr.hierarchyApplied) {
	                        this.hierarchyData.length = 0;
	                        this.hierarchyData.push({
	                            attributeSetData: '',
	                            childDropdown: '',
	                            parentAttributeName: ''
	                        });
	                    }
	                };
	                this.onChangeFunctionAttributeName = function () {
	                    angular.isObject(this.properties.customAttr.selectedValue) && (this.properties.customAttr.selectedValue = this.properties.customAttr.selectedValue.value);
	                    var selectedValue = this.properties.customAttr.selectedValue;
	                    if (!selectedValue) {
	                        self.ngNotification.error({ message: 'Custom Attribute name missing.', positionX: 'center', replaceMessage: true });
	                        if (this.hierarchyData && this.properties.customAttr.hierarchyApplied) {
	                            this.firstDropdownOptions = [];
	                            this.secondDropdownOptions = [];
	                            this.hierarchyData.length = 0;
	                            this.hierarchyData.push({
	                                attributeSetData: '',
	                                childDropdown: '',
	                                parentAttributeName: ''
	                            });
	                        }
	                        return;
	                    }
	                    if (selectedValue.indexOf('"') != -1) {
	                        self.ngNotification.error({ message: 'Custom Attribute name should not contain ".', positionX: 'center', replaceMessage: true });
	                        return;
	                    }
	                    if (this.sourceType == 5) {
	                        setDropdownOptionsForHierarchy();
	                    }
	                };
	                this.save = function () {
	                    if (this.sourceType == 3) {
	                        var arrOfValues = [];
	                        var arrOfLabels = [];
	                        for (var j = this.properties.table.list.length - 1; j >= 0; j--) {
	                            arrOfValues.push(this.properties.table.list[j].Value.name);
	                            arrOfLabels.push(this.properties.table.list[j].Label.name);
	                        }
	                        if (this.Util.hasDuplicates(arrOfValues) || this.Util.hasDuplicates(arrOfLabels)) {
	                            var msg = self.$translate.instant('duplicate.value.found');
	                            self.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
	                            return;
	                        }
	                        self.updateReferenceControl(this);
	                    }
	                    if (this.sourceType == 1) {
	                        if (!angular.isObject(this.properties.Url.selectedValue)) {
	                            self.ngNotification.error({ message: 'Url is missing.', positionX: 'center', replaceMessage: true });
	                            return;
	                        }
	                    }
	                    if (this.sourceType == 4) {
	                        if (!angular.isObject(this.properties.fixedFieldUrl.selectedValue)) {
	                            self.ngNotification.error({ message: 'Url is missing.', positionX: 'center', replaceMessage: true });
	                            return;
	                        }
	                    }
	                    if (this.sourceType == 5) {
	                        if (!this.properties.customAttr.selectedValue) {
	                            self.ngNotification.error({ message: 'Custom Attribute name missing.', positionX: 'center', replaceMessage: true });
	                            return;
	                        }
	                        var selectedValue = angular.isObject(this.properties.customAttr.selectedValue) ? this.properties.customAttr.selectedValue.value : this.properties.customAttr.selectedValue;
	                        if (selectedValue.indexOf('"') != -1) {
	                            self.ngNotification.error({ message: 'Custom Attribute name should not contain ".', positionX: 'center', replaceMessage: true });
	                            return;
	                        }
	                        if (this.properties.customAttr.hierarchyApplied == true) {
	                            for (var j_1 = this.hierarchyData.length - 1; j_1 >= 0; j_1--) {
	                                if (!this.hierarchyData[j_1].attributeSetData) {
	                                    self.ngNotification.error({ message: 'Attribute Set missing.', positionX: 'center', replaceMessage: true });
	                                    return;
	                                }
	                                if (!this.hierarchyData[j_1].childDropdown) {
	                                    self.ngNotification.error({ message: 'Child Attribute missing.', positionX: 'center', replaceMessage: true });
	                                    return;
	                                }
	                                this.hierarchyData[j_1].parentAttributeName = this.properties.customAttr.selectedValue;
	                            }
	                        }
	                        angular.isObject(this.properties.customAttr.selectedValue) && (this.properties.customAttr.selectedValue = this.properties.customAttr.selectedValue.value);
	                    }
	                    if (this.sourceType == 6 || this.sourceType == 7 || this.sourceType == 8) {
	                        var arrOfValues = [];
	                        for (var j_2 = this.properties.table.list.length - 1; j_2 >= 0; j_2--) {
	                            arrOfValues.push(this.properties.table.list[j_2].Value.name.fieldName);
	                            if (this.Util.hasDuplicates(arrOfValues)) {
	                                var msg = self.$translate.instant('duplicate.value.found');
	                                self.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
	                                return;
	                            }
	                            else if (this.properties.table.list[j_2].Value.name.fieldName == undefined) {
	                                self.ngNotification.error({ message: 'Please select value in every dropdown', positionX: 'center', replaceMessage: true });
	                                return;
	                            }
	                        }
	                    }
	                    properties.table && (properties.table.list = this.list);
	                    properties.Parameters && (properties.Parameters.list = this.parameterList);
	                    angular.merge(properties, this.properties);
	                    if (this.sourceType == 6 || this.sourceType == 7 || this.sourceType == 8) {
	                        try {
	                            self.Util.refreshReadOnlyControlsPropeties(self.getSelectedItem().properties.Basic['Field Name'].selectedValue);
	                        }
	                        catch (error) {
	                            console.log(error);
	                        }
	                    }
	                    this.cancel();
	                };
	                this.cancel = function () {
	                    // modalInstance.dismiss('cancel');
	                    modalInstance.close(false);
	                };
	                this.addIntoList = self.addIntoList;
	                this.addInList = function (index, list) {
	                    list.splice(index, 0, {
	                        attributeSetData: '',
	                        childDropdown: '',
	                        parentAttributeName: '',
	                        childAttributeName: ''
	                    });
	                };
	                this.removeFromListDD = function (index, list) {
	                    list.splice(index, 1);
	                };
	                this.getDropdowns = function (selectedOption) {
	                    if (selectedOption) {
	                        for (var k = 0; k < _this.optionNumber.length; k++) {
	                            if (_this.optionNumber[k] == selectedOption) {
	                                return _this.secondDropdownOptions[k].filter(function (item, index, arr) { return arr.indexOf(item) === index; });
	                            }
	                        }
	                    }
	                };
	                this.ngNotification = self.ngNotification;
	                this.Util = self.Util;
	                this.$translate = self.$translate;
	                this.removeFromList = self.removeFromList;
	                this.isObject = angular.isObject;
	                this.openDSHelp = self.openDSHelp.bind(self);
	                this.resetDefaultForRadio = self.resetDefaultForRadio;
	            }
	        });
	    };
	    /**
	     * Open Fixedfields value selection popup
	     *
	     * @param {any} properties
	     * @memberof PropertyboxComponent
	     */
	    PropertyboxComponent.prototype.existingDataField = function (properties) {
	        var self = this, selected = this.Util.returnSelected(this.selectedView.view.controls.A), numberSelectedType, numberSelectedTypeUnderRepeatingTbl = false, showExistingDS = selected.length && selected[0].parent != 'repeating-table', selectedOperator, selectedElemType = selected[0].type.toLowerCase(), currentCalQuery, validFormula = true;
	        if (selectedElemType == "display field") {
	            //updating text box value type to number if validate is selected as decimal/integer 
	            this.updateValueType();
	            numberSelectedType = properties.Type.number;
	            var parentnode = properties.parentNode.id;
	            this.updateRepeatingTableDSFieldType("", false, parentnode);
	            numberSelectedTypeUnderRepeatingTbl = properties.Type.numberUnderRepeatingTable;
	            currentCalQuery = properties.formula.html;
	        }
	        var operatorsAry = ['+', '-', '*', '/', '(', ')', ',', '\'', '[', ']'];
	        var modalInstance = this.$uibModal.open({
	            animation: true,
	            ariaLabelledBy: 'modal-title',
	            ariaDescribedBy: 'modal-body',
	            templateUrl: 'existingDataField.html',
	            backdrop: 'static',
	            keyboard: false,
	            controllerAs: '$ctrl',
	            windowClass: 'calculate-field-modal',
	            appendTo: angular.element(self.$document[0].querySelector('.form-builder')),
	            controller: function () {
	                var _this = this;
	                //getting all the textbox fields where validate is set as decimal/integer and Calculated-Value fields
	                if (numberSelectedType == true && showExistingDS && selectedElemType == "display field") {
	                    properties.Label.isSelected = true;
	                    this.numberfields = self.Util.getNumberFieldNames();
	                    properties.Type.number = true;
	                }
	                else if (numberSelectedTypeUnderRepeatingTbl == true && selectedElemType == "display field") {
	                    properties.Label.isSelected = true;
	                    var parentnode = properties.parentNode.id;
	                    this.numberfields = self.Util.getNumberFieldNamesunderRepeatingTbl(undefined, undefined, parentnode);
	                    properties.Type.number = true;
	                }
	                this.systemfields = showExistingDS ? self.Util.getDataFieldNames() : [];
	                this.systemfields = this.systemfields.concat(self.Util.getFixedFields(true));
	                this.getFieldsByGroup = function (search, inputfield) {
	                    if (!search)
	                        search = "";
	                    if (_this.properties.DSName.selectedValue == "calculated" || inputfield == 'field')
	                        _this.fields = _this.numberfields;
	                    else
	                        _this.fields = _this.systemfields;
	                    var filtered = _.filter(angular.copy(_this.fields), function (n) {
	                        if (_.includes(n.key.toLowerCase(), search.toLowerCase())) {
	                            return n;
	                        }
	                    });
	                    if (inputfield == 'field') {
	                        filtered = filtered.filter(function (el) {
	                            if ((el.parent && el.parent == "outsideRT") || !el.parent)
	                                return el;
	                        });
	                    }
	                    var results = _.groupBy(filtered, 'group');
	                    results = _.map(results, function (g) {
	                        g[0].firstInGroup = true; // the first item in each group
	                        return g;
	                    });
	                    results = _.flatten(results);
	                    return results;
	                };
	                this.properties = angular.copy(properties);
	                if (this.properties.DSName.selectedValue != "calculated") {
	                    this.Value = this.properties.Value.selectedValue;
	                    var regex = /(^\{\{.*?\}\}$)/;
	                    if (this.Value && this.Value.match(regex)) {
	                        var val_1 = this.Value.replace('{{', '').replace('}}', '');
	                        if (this.properties.DSName.selectedValue == "calculated")
	                            this.fields = this.numberfields;
	                        else
	                            this.fields = this.systemfields;
	                        var field = this.fields.filter(function (value) {
	                            return value.key == val_1;
	                        });
	                        field.length && (this.Value = field[0]);
	                    }
	                    if (!angular.isObject(this.Value)) {
	                        this.Value = "";
	                    }
	                }
	                this.save = function () {
	                    if (this.properties.DSName.selectedValue != "calculated") {
	                        if (properties.formula) {
	                            this.resetCondition(properties);
	                        }
	                        if (angular.isObject(this.Value)) {
	                            properties.Value.selectedValue = '{{' + this.Value.key + '}}';
	                            properties.DSName && (properties.DSName.selectedValue = this.Value.value);
	                            properties.Value.readonly = false;
	                            // Removing the pasteAsCalculated control property
	                            var selectedItem = self.getSelectedItem();
	                            selectedItem.hasOwnProperty('derivedControlType') && delete selectedItem.derivedControlType;
	                            selectedItem.hasOwnProperty('derivedFromFieldName') && delete selectedItem.derivedFromFieldName;
	                            selectedItem.hasOwnProperty('pasteAsCalculatedFrom') && delete selectedItem.pasteAsCalculatedFrom;
	                        }
	                        else {
	                            properties.DSName && (properties.DSName.selectedValue = '');
	                        }
	                    }
	                    else {
	                        if (!this.syncCalcQuery())
	                            return;
	                        var calculationQuery = this.properties.formula.html;
	                        properties.formula.html = calculationQuery;
	                        var textboxFieldsAry = calculationQuery.split('<span class="calculateFieldSpan">');
	                        textboxFieldsAry = textboxFieldsAry.filter(function (el) {
	                            if (el != "")
	                                return el;
	                        });
	                        var views = self.views, calFields_1 = [];
	                        for (var view in views) {
	                            for (var v = 0; v < self.Util.getIteams(views[view].controls.A).length; v++) {
	                                calFields_1.push(self.Util.getIteams(views[view].controls.A)[v]);
	                            }
	                        }
	                        var showValMsg_1 = false, selField_1;
	                        textboxFieldsAry.forEach(function (field) {
	                            field = field.substr(0, field.indexOf("</span>"));
	                            if (field.indexOf("sum(") != -1)
	                                field = field.substr(4, field.length - 5);
	                            calFields_1.forEach(function (calField) {
	                                if (calField.type == "Textbox") {
	                                    if ((field == calField.properties.Basic["Field Name"].selectedValue && calField.properties.Basic.Validate.selectedValue != "Integer" && calField.properties.Basic.Validate.selectedValue != "Decimal")) {
	                                        showValMsg_1 = true;
	                                        selField_1 = field;
	                                    }
	                                }
	                            });
	                        });
	                        if (showValMsg_1) {
	                            self.ngNotification.error({ message: "Validate type for " + selField_1 + " is not Integer or Decimal", positionX: 'center', replaceMessage: true });
	                            return;
	                        }
	                        //removing html and keeping only the values from the query
	                        calculationQuery = calculationQuery
	                            .replace(/<span class="calculateFieldSpan">/g, ' ')
	                            .replace(/<span class="calculateOptSpan">/g, ' ')
	                            .replace(/<span class="calculateNumSpan">/g, ' ')
	                            .replace(/<span class="calculateBracesSpan">/g, ' ')
	                            .replace(/<\/span>/g, ' ');
	                        var formulaToPrint = calculationQuery;
	                        if (calculationQuery.indexOf("math.sum") != -1)
	                            calculationQuery = calculationQuery.replace(/math.sum/g, 'MATH_SUM_FUN');
	                        var splitAry = calculationQuery.split(" "), UidArry_1 = [];
	                        var _loop_1 = function(i) {
	                            if (!parseFloat(splitAry[i])) {
	                                var str_1 = angular.element.trim(splitAry[i].replace("sum(", "").replace(")", "").replace("{", "").replace("}", ""));
	                                calFields_1.forEach(function (calField) {
	                                    if ((calField.type == "Textbox" || calField.type == "Display field") && calField.properties.Basic["Field Name"].selectedValue == str_1) {
	                                        if (UidArry_1.indexOf(calField.uid) == -1)
	                                            UidArry_1.push(calField.uid);
	                                    }
	                                });
	                            }
	                        };
	                        for (var i = 0; i < splitAry.length; i++) {
	                            _loop_1(i);
	                        }
	                        properties.formula.uids = UidArry_1;
	                        for (var i = 0; i < splitAry.length; i++) {
	                            if (splitAry[i] != "" && !parseFloat(splitAry[i]) && operatorsAry.indexOf(splitAry[i]) == -1 && splitAry[i].indexOf("{") != -1 && splitAry[i].indexOf("}") != -1)
	                                splitAry[i] = 1;
	                        }
	                        calculationQuery = splitAry.join("");
	                        calculationQuery = calculationQuery.replace(/MATH_SUM_FUN/g, 'math.sum');
	                        try {
	                            if (eval(calculationQuery)) {
	                                validFormula = true;
	                                this.cancel();
	                            }
	                        }
	                        catch (err) {
	                            self.ngNotification.error({ message: "Please enter a valid calculation formula", positionX: 'center', replaceMessage: true });
	                            validFormula = false;
	                            return;
	                        }
	                        //updating rules lists 
	                        if (properties.list && properties.list.listItem.length) {
	                            this.properties.list.listItem = this.properties.list.listItem.filter(function (item) {
	                                if (item.field.value != "" || item.id == 0)
	                                    return item;
	                            });
	                            properties.list.listItem = this.properties.list.listItem;
	                        }
	                        //adding all the rules into an array for displaying under properties tab
	                        var rules_1 = [];
	                        var rulesStr_1 = "";
	                        if (this.properties.list) {
	                            this.properties.list.listItem.forEach(function (item) {
	                                if (item.field.value != "" && angular.isObject(item.field.value)) {
	                                    rulesStr_1 = "If " + item.field.value.value + " is " + item.operator.selected;
	                                    if (item.target.hidden == false && item.target.disable == false) {
	                                        rulesStr_1 = rulesStr_1 + " " + item.target.value;
	                                    }
	                                    if (item.conjuction.hidden == false) {
	                                        rulesStr_1 = rulesStr_1 + " " + item.conjuction.selected;
	                                    }
	                                    if (rulesStr_1 != "")
	                                        rulesStr_1 = rulesStr_1 + '\n';
	                                    rules_1.push(rulesStr_1);
	                                }
	                            });
	                            if (formulaToPrint && formulaToPrint != "") {
	                                var splitFormulaAry = formulaToPrint.split(" ");
	                                for (var f = 0; f < splitFormulaAry.length; f++) {
	                                    if (splitFormulaAry[f] != "" && operatorsAry.indexOf(splitFormulaAry[f]) == -1 && !parseFloat(splitFormulaAry[f])) {
	                                        splitFormulaAry[f] = splitFormulaAry[f];
	                                    }
	                                }
	                                formulaToPrint = splitFormulaAry.join(" ");
	                                console.log("formulaToPrint: " + formulaToPrint);
	                                properties.Value.readonly = true;
	                                if (rules_1.length) {
	                                    rules_1[rules_1.length - 1] = rules_1[rules_1.length - 1].replace("AND", '');
	                                    properties.formula.hidden = false;
	                                    properties.formula.selectedValue = rules_1.join("");
	                                    properties.formula.rules = rules_1.join("");
	                                }
	                                var appendStr = (properties.formula.selectedValue != "") ? "than " : " ";
	                                properties.formula.selectedValue = properties.formula.selectedValue + appendStr
	                                    + properties["Field Name"].selectedValue + " = "
	                                    + formulaToPrint;
	                                properties.DSName.selectedValue = "calculated";
	                                if (!this.properties.formula.edit)
	                                    properties.Value.selectedValue = formulaToPrint;
	                                else
	                                    properties.Value.selectedValue = this.properties.Value.selectedValue;
	                            }
	                            else if (this.properties.DSName.selectedValue == "calculated" || (this.Value == "" && (this.properties.DSName.selectedValue != "calculated"))) {
	                                //reseting to default if calculation query removed and saved
	                                this.resetCondition(properties);
	                            }
	                            this.properties.list.listItem[0].addField.value = '';
	                            this.properties.list.listItem[0].addSum.disable = true;
	                            this.properties.list.listItem[0].addField.disable = true;
	                        }
	                    }
	                    this.cancel();
	                };
	                this.cancel = function () {
	                    if (!validFormula)
	                        properties.formula.html = currentCalQuery;
	                    properties.Label.isSelected = false;
	                    // modalInstance.dismiss('cancel');
	                    modalInstance.close(false);
	                };
	                this.isObject = angular.isObject;
	                this.openDSHelp = self.openDSHelp.bind(self);
	                this.addNewRuleDiv = self.addNewRuleDiv;
	                this.removeFromList = self.removeFromList;
	                this.resetCondition = self.resetCondition;
	                //updating the selected tab
	                this.showcurrenttabdiv = function (selectedVal) {
	                    if (selectedVal == "")
	                        this.properties.DSName.selectedValue = "calculated";
	                    else
	                        this.properties.DSName.selectedValue = "";
	                };
	                //validation for valid calculation query
	                this.checkForOperator = function (optIndex, calculationQuery, bracesIndex, keypressed) {
	                    var operatorAdded = true;
	                    if (calculationQuery.length != optIndex + 10 && calculationQuery != '') {
	                        operatorAdded = false;
	                    }
	                    if (bracesIndex != undefined) {
	                        if ((calculationQuery != '' && calculationQuery.length == bracesIndex + 42 && calculationQuery.charAt(calculationQuery.length - 8) == "(") || calculationQuery.length == optIndex + 10 || calculationQuery == "") {
	                            operatorAdded = true;
	                        }
	                        else {
	                            operatorAdded = false;
	                        }
	                    }
	                    else if ((calculationQuery == "" && keypressed != ")") ||
	                        (calculationQuery != '' && ((calculationQuery.length != optIndex + 10 && keypressed == ")" && calculationQuery.indexOf("(") != -1) ||
	                            (calculationQuery.length == optIndex + 10 && keypressed == "(") ||
	                            (calculationQuery.lastIndexOf('<span class="calculateBracesSpan">') + 42 != calculationQuery.length && keypressed == ")") ||
	                            (calculationQuery.lastIndexOf('<span class="calculateBracesSpan">') + 42 == calculationQuery.length && keypressed == "(")) &&
	                            (calculationQuery.indexOf(")") == -1 || keypressed == "(" || (calculationQuery.indexOf("(") != -1 && calculationQuery.indexOf(")") != -1 && calculationQuery.match(/\(/g).length > calculationQuery.match(/\)/g).length)))) {
	                        operatorAdded = true;
	                    }
	                    else
	                        operatorAdded = false;
	                    if (!operatorAdded)
	                        self.ngNotification.error({ message: "Please enter an operator!", positionX: 'center', replaceMessage: true });
	                    return operatorAdded;
	                },
	                    //entering key pressed values from calculator
	                    this.num = function (keypressed, keytype) {
	                        var calculationQuery = this.properties.formula.html;
	                        var optIndex = calculationQuery.lastIndexOf('<span class="calculateOptSpan">');
	                        var bracesIndex = calculationQuery.lastIndexOf('<span class="calculateBracesSpan">');
	                        if (optIndex != -1)
	                            optIndex = optIndex + 31;
	                        else
	                            optIndex == 0;
	                        if (keytype && keytype == "field") {
	                            if (keypressed.value && keypressed.value != "" && this.checkForOperator(optIndex, calculationQuery, bracesIndex)) {
	                                var fieldentered = keypressed.value;
	                                this.properties.formula.html = calculationQuery + '<span class="calculateFieldSpan">{' + fieldentered + '}</span>';
	                                this.properties.list.listItem[0].addField.value = "";
	                                this.properties.list.listItem[0].addField.disable = true;
	                            }
	                            else {
	                                return;
	                            }
	                        }
	                        else {
	                            if (keytype && keytype == 'operator') {
	                                if (calculationQuery == "") {
	                                    self.ngNotification.error({ message: "First character cannot be an operator!", positionX: 'center', replaceMessage: true });
	                                    return;
	                                }
	                                if (calculationQuery.length == bracesIndex + 42 && calculationQuery.charAt(calculationQuery.length - 8) == "(") {
	                                    self.ngNotification.error({ message: "Operator not allowed after opening bracket!", positionX: 'center', replaceMessage: true });
	                                    return;
	                                }
	                                if (calculationQuery.length == optIndex + 10) {
	                                    var charAtIndex = calculationQuery.charAt(optIndex + 1);
	                                    if (operatorsAry.indexOf(charAtIndex) != -1) {
	                                        this.properties.formula.html = calculationQuery.substr(0, optIndex + 1) + keypressed + calculationQuery.substr(optIndex + 1 + keypressed.length);
	                                    }
	                                }
	                                else {
	                                    this.properties.formula.html = this.properties.formula.html + '<span class="calculateOptSpan"> ' + keypressed + ' </span>';
	                                }
	                            }
	                            else if (keytype && keytype == 'braces') {
	                                if (this.checkForOperator(optIndex, calculationQuery, undefined, keypressed))
	                                    this.properties.formula.html = this.properties.formula.html + '<span class="calculateBracesSpan">' + keypressed + '</span>';
	                            }
	                            else {
	                                var startSpanIndex = calculationQuery.lastIndexOf('<span class="calculateNumSpan">');
	                                var tempCalcQuery = calculationQuery.substr(startSpanIndex, calculationQuery.length);
	                                var closeSpanIndex = tempCalcQuery.indexOf('</span>');
	                                var numIndex = startSpanIndex + closeSpanIndex + 7;
	                                if (keypressed == "." && ((tempCalcQuery.indexOf(".") != -1 && tempCalcQuery.match(/\./g).length) ||
	                                    calculationQuery.length == optIndex + 10 || calculationQuery.length == bracesIndex + 42 || calculationQuery == "")) {
	                                    self.ngNotification.error({ message: "Please enter valid number!", positionX: 'center', replaceMessage: true });
	                                    return;
	                                }
	                                if (numIndex == calculationQuery.length && calculationQuery != "") {
	                                    var addCharAt = calculationQuery.length - 7;
	                                    this.properties.formula.html = calculationQuery.substr(0, addCharAt).concat(keypressed) + '</span>';
	                                }
	                                else {
	                                    if (this.checkForOperator(optIndex, calculationQuery, bracesIndex))
	                                        this.properties.formula.html = this.properties.formula.html + '<span class="calculateNumSpan">' + keypressed + '</span>';
	                                }
	                            }
	                        }
	                    };
	                //clearing last key pressed from calculator
	                this.clear = function () {
	                    var calculationQuery = this.properties.formula.html;
	                    var calculateAry = calculationQuery.split("</span>");
	                    //removing charecters for numbers added from span
	                    var startSpanIndex = calculationQuery.lastIndexOf('<span class="calculateNumSpan">');
	                    var tempCalcQuery = calculationQuery.substr(startSpanIndex, calculationQuery.length);
	                    var closeSpanIndex = tempCalcQuery.indexOf('</span>');
	                    var numIndex = startSpanIndex + closeSpanIndex + 7;
	                    var removeCharAt = startSpanIndex + closeSpanIndex - 1;
	                    if (startSpanIndex + 39 != calculationQuery.length && numIndex == calculationQuery.length) {
	                        calculationQuery = calculationQuery.substr(0, removeCharAt) + calculationQuery.substr(removeCharAt + 1);
	                        this.properties.formula.html = calculationQuery;
	                    }
	                    else {
	                        calculateAry = calculateAry.slice(0, -2);
	                        this.properties.formula.html = calculateAry.join("</span>");
	                        if (calculateAry.length)
	                            this.properties.formula.html = this.properties.formula.html + "</span>";
	                    }
	                };
	                //validating the target fields value against validate type(decimal/integer) for the selected textbox field 
	                this.convertNumber = function (index) {
	                    var numberType = this.properties.list.listItem[index].field.value.type;
	                    var currentNum = this.properties.list.listItem[index].target.value;
	                    if (this.properties.list.listItem[index].field.value == "") {
	                        self.ngNotification.error({ message: "Please select a field!", positionX: 'center', replaceMessage: true });
	                        return;
	                    }
	                    if (currentNum != "" && numberType) {
	                        if (numberType.toLowerCase() == "decimal" && currentNum % 1 == 0) {
	                            this.properties.list.listItem[index].target.value = Number(currentNum.toFixed(2));
	                        }
	                        else if (numberType.toLowerCase() == "integer") {
	                            if (currentNum % 1 != 0) {
	                                self.ngNotification.error({ message: "Please enter an integer", positionX: 'center', replaceMessage: true });
	                                this.properties.list.listItem[index].target.value = 0;
	                                return;
	                            }
	                        }
	                    }
	                };
	                this.onDragStart = function (item) {
	                    selectedOperator = item.operator.options.value;
	                };
	                this.initialSelectedOption = function () {
	                    this.properties.list.listItem.forEach(function (item) {
	                        if (item.operator.selected)
	                            item.operator.options.value = item.operator.selected;
	                        else
	                            item.operator.options.value = "Equal to";
	                    });
	                };
	                //setting the selected operator value on dragging the conditon li
	                this.logListEvent = function (index) {
	                    this.properties.list.listItem[index].operator.options.value = selectedOperator;
	                    this.properties.list.listItem[index].operator.selected = selectedOperator;
	                },
	                    this.updateOperatorValue = function (currentValue, index) {
	                        //updating selected with current value
	                        if (this.properties.list.listItem[index].operator.options) {
	                            this.properties.list.listItem[index].operator.selected = currentValue;
	                        }
	                        //disabling target field if operator is selected as empty/not empty
	                        if (this.properties.list.listItem[index].operator.selected == "Empty" || this.properties.list.listItem[index].operator.selected == "Not empty")
	                            this.properties.list.listItem[index].target.disable = true;
	                        else
	                            this.properties.list.listItem[index].target.disable = false;
	                    },
	                    //toggling advance tab
	                    this.showCalculationMethod = function ($event) {
	                        this.properties.formula.html = '';
	                        // angular.element("#calculationFormulaDiv").html("");
	                        this.properties.formula.advanceQuery = "";
	                        var selectedoption = $event.target.innerText;
	                        if (selectedoption == "Advanced") {
	                            this.properties.Type.calculation = 'advance';
	                        }
	                        else {
	                            this.properties.Type.calculation = '';
	                        }
	                    },
	                    //setting input text for advance query on selecting option from dropdown
	                    this.setQueryVal = function (event) {
	                        var selectedElem = event.target.innerText;
	                        var existingquery = angular.element("#inputQuery").val();
	                        if (selectedElem != "" && existingquery != "") {
	                            existingquery = existingquery.slice(0, -1);
	                            existingquery = existingquery + selectedElem;
	                            this.properties.formula.advanceQuery = existingquery;
	                        }
	                    },
	                    //adding prefix sum for repeating table fields
	                    this.addSum = function (selectedField) {
	                        var calculationQuery = this.properties.formula.html, optIndex = calculationQuery.lastIndexOf('<span class="calculateOptSpan">'), bracesIndex = calculationQuery.lastIndexOf('<span class="calculateBracesSpan">');
	                        if (optIndex != -1)
	                            optIndex = optIndex + 31;
	                        else
	                            optIndex == 0;
	                        if (angular.isObject(selectedField) && selectedField.value && this.checkForOperator(optIndex, calculationQuery, bracesIndex)) {
	                            this.properties.formula.html = this.properties.formula.html + '<span class="calculateFieldSpan">sum({' + selectedField.value + '})</span>';
	                            this.properties.list.listItem[0].addField.value = "";
	                            this.properties.list.listItem[0].addSum.disable = true;
	                        }
	                    },
	                    //toggling add field/sum buttons based upon field selected
	                    this.setaddType = function (selectedVal) {
	                        var _this = this;
	                        var isFieldTypeRepeating = properties.Type.numberUnderRepeatingTable;
	                        var numberFieldsunderRptngTbl = self.Util.getNumberFieldNamesunderRepeatingTbl();
	                        var numberFields = self.Util.getNumberFieldNames();
	                        //for enabling sum button for footer calculated fields
	                        if (properties.parentNode.footer)
	                            isFieldTypeRepeating = false;
	                        if (angular.isObject(selectedVal)) {
	                            numberFields.forEach(function (field) {
	                                if (field.key == selectedVal.key) {
	                                    _this.properties.list.listItem[0].addField.disable = false;
	                                    _this.properties.list.listItem[0].addSum.disable = true;
	                                }
	                            });
	                            numberFieldsunderRptngTbl.forEach(function (field) {
	                                if (field.key == selectedVal.key && !isFieldTypeRepeating) {
	                                    isFieldTypeRepeating = true;
	                                    _this.properties.list.listItem[0].addSum.disable = false;
	                                    _this.properties.list.listItem[0].addField.disable = true;
	                                }
	                            });
	                        }
	                    },
	                    this.EnableEditing = function (text) {
	                        if (text == "Edit") {
	                            this.properties.formula.edit = true;
	                            this.properties.formula.editText = "Back";
	                            this.properties.Value.selectedValue = this.properties.formula.html
	                                .replace(/<span class="calculateFieldSpan">/g, ' ')
	                                .replace(/<span class="calculateOptSpan">/g, ' ')
	                                .replace(/<span class="calculateNumSpan">/g, ' ')
	                                .replace(/<span class="calculateBracesSpan">/g, ' ')
	                                .replace(/<\/span>/g, ' ');
	                        }
	                        else {
	                            this.properties.formula.edit = false;
	                            this.properties.formula.editText = "Edit";
	                            this.syncCalcQuery(true);
	                        }
	                    },
	                    this.showMsg = function () {
	                        var msg = "Invalid Query! Your query do not comply to one or all of the instruction mentioned below:<br><br>" +
	                            "Query should contain only valid syntax and parameters as mentioned below:<br>" +
	                            "- Integer or Decimal Number<br>" +
	                            "- Brackets ( Curly Brackets i.e. '{ }' OR Rounded Brackets i.e. '( )' )<br>" +
	                            "- Mathematical Operators ( +, -, *, / )<br>" +
	                            "- All Field Name used in design e.g. 'Total', 'Quantity', 'Cost'<br>" +
	                            "- Use Rounded Brackets for any sub calculations e.g. ( {Quantity}*{Cost}) + ({Cost}*0.10)<br>" +
	                            "- Only numeric field name to be used, and field name should match to any existing defined field name.<br>" +
	                            "- Field name must be used within curly bracket without any space in between e.g. {Quantity}<br><br>" +
	                            "Please update the query, and try saving it again.";
	                        self.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
	                        return;
	                    },
	                    this.isUndefined = function (o) {
	                        return typeof o === 'undefined';
	                    },
	                    this.sub = function (s, o, re) {
	                        re = re || (/\{\s*([^\|\}\}]+?)\s*(?:\|([^\}\}]*))?\s*\}/g);
	                        return ((s.replace) ? s.replace(re, function (match, key) {
	                            return (!this.isUndefined(o[key])) ? o[key] : match;
	                        }) : s);
	                    };
	                this.syncCalcQuery = function (editTrue) {
	                    var sync = this.properties.formula.edit, editedHtml = this.properties.formula.html, editedValue = this.properties.Value.selectedValue, returnType = true, parentNodeId = this.properties.parentNode && this.properties.parentNode.id, isFooter = this.properties.parentNode && this.properties.parentNode.footer;
	                    var mathFunAry = ["math.min", "math.max", "math.mean", "math.median", "math.prod", "math.variance", "math.std"];
	                    if (sync || editTrue) {
	                        var splitAry = [];
	                        if (editedValue.indexOf("math.sum") != -1)
	                            editedValue = editedValue.replace(/math.sum/g, 'MATH_SUM_FUN');
	                        if (editedValue.indexOf("sum({") != -1) {
	                            var tempAry = editedValue.split("sum(");
	                            for (var t = 0; t < tempAry.length; t++) {
	                                var str = tempAry[t].substr(1, tempAry[t].indexOf("})"));
	                                if (str != "" && str.indexOf("{") == -1)
	                                    tempAry[t] = "sum(" + tempAry[t].replace(")", "");
	                            }
	                            editedValue = tempAry.join("");
	                        }
	                        splitAry = editedValue.split("}");
	                        for (var s = 0; s < splitAry.length; s++) {
	                            var split = splitAry[s];
	                            if (split.indexOf("{") != -1) {
	                                var str = split, isMathFun = false;
	                                for (var m = 0; m < mathFunAry.length; m++) {
	                                    if (str.indexOf(mathFunAry[m]) != -1) {
	                                        str = str.substr(str.indexOf(mathFunAry[m]), str.length);
	                                        isMathFun = true;
	                                    }
	                                }
	                                if (!isMathFun) {
	                                    if (str.indexOf("sum(") != -1)
	                                        str = str.substr(str.indexOf("sum("), str.length);
	                                    else
	                                        str = str.substr(str.indexOf("{"), str.length);
	                                }
	                                str = angular.element.trim(str);
	                                var views = self.views, itemsAry = [], matchFound = false;
	                                for (var view in views) {
	                                    for (var v = 0; v < self.Util.getIteams(views[view].controls.A).length; v++) {
	                                        itemsAry.push(self.Util.getIteams(views[view].controls.A)[v]);
	                                    }
	                                }
	                                if (parentNodeId) {
	                                    itemsAry = self.Util.getNumberFieldNamesunderRepeatingTbl(undefined, undefined, parentNodeId);
	                                    for (var i = 0; i < itemsAry.length; i++) {
	                                        var item = itemsAry[i];
	                                        for (var m = 0; m < mathFunAry.length; m++) {
	                                            if ((item.value == str.replace("{", "").replace("}", "").replace("sum(", "").replace(")", "").replace(mathFunAry[m], "")) && ((str.indexOf("sum(") == -1 && str.indexOf(mathFunAry[m]) == -1) || isFooter))
	                                                matchFound = true;
	                                        }
	                                    }
	                                }
	                                else {
	                                    for (var i = 0; i < itemsAry.length; i++) {
	                                        var item = itemsAry[i];
	                                        if (item.type == "Display field" || item.type == "Textbox") {
	                                            if (item.properties.Basic.parentNode && item.properties.Basic.parentNode.id) {
	                                                for (var m = 0; m < mathFunAry.length; m++) {
	                                                    if ((item.properties["Basic"]["Field Name"].selectedValue.replace("{", "").replace("}", "") == str.replace("{", "").replace("}", "").replace("sum(", "").replace(")", "").replace(mathFunAry[m], "")) && (editedValue.indexOf("sum(") == -1 || str.indexOf("sum(") != -1))
	                                                        matchFound = true;
	                                                }
	                                            }
	                                            else {
	                                                for (var m = 0; m < mathFunAry.length; m++) {
	                                                    str = angular.element.trim(str.replace("{", "").replace("}", "").replace("sum(", "").replace(")", "").replace(mathFunAry[m], "").replace("(", ""));
	                                                    if (item.properties["Basic"]["Field Name"].selectedValue.replace("{", "").replace("}", "") == str && str.indexOf("sum(") == -1)
	                                                        matchFound = true;
	                                                }
	                                            }
	                                        }
	                                    }
	                                }
	                                if (!matchFound)
	                                    returnType = false;
	                                else {
	                                    if (isMathFun) {
	                                        var rplc = str.substr(str.indexOf("(") + 1, str.length);
	                                        splitAry[s] = splitAry[s].replace(rplc, "1");
	                                    }
	                                    else
	                                        splitAry[s] = splitAry[s].replace(str, "1");
	                                    splitAry[s] = splitAry[s].replace("{", "");
	                                }
	                            }
	                        }
	                        try {
	                            var finalQry = splitAry.join(" ");
	                            finalQry = finalQry.replace(/MATH_SUM_FUN/g, 'math.sum');
	                            if (eval(finalQry) || eval(finalQry) == 0) {
	                                editedValue = editedValue
	                                    .replace(/\//g, '<span class="calculateOptSpan">/</span>')
	                                    .replace(/\+/g, '<span class="calculateOptSpan">+</span>')
	                                    .replace(/\*/g, '<span class="calculateOptSpan">*</span>');
	                                splitAry = editedValue.split("}");
	                                for (var s = 0; s < splitAry.length; s++) {
	                                    var split = splitAry[s];
	                                    if (split.indexOf("{") != -1) {
	                                        var str = split;
	                                        if (str.indexOf("sum(") != -1)
	                                            str = str.substr(0, str.indexOf("sum({"));
	                                        else
	                                            str = str.substr(0, str.indexOf("{"));
	                                        str = str.replace(/\-/g, '<span class="calculateOptSpan">-</span>')
	                                            .replace(/\(/g, '<span class="calculateBracesSpan">(</span>')
	                                            .replace(/\)/g, '<span class="calculateBracesSpan">)</span>')
	                                            .replace(/\'/g, '<span class="calculateOptSpan">\'</span>')
	                                            .replace(/\]/g, '<span class="calculateOptSpan">\]</span>')
	                                            .replace(/\[/g, '<span class="calculateOptSpan">\[</span>')
	                                            .replace(/\,/g, '<span class="calculateOptSpan">,</span>');
	                                        if (split.indexOf("sum(") != -1)
	                                            splitAry[s] = str + '<span class="calculateFieldSpan">' + split.substr(split.indexOf("sum({"), split.length) + '})</span>';
	                                        else
	                                            splitAry[s] = str + '<span class="calculateFieldSpan">' + split.substr(split.indexOf("{"), split.length) + '}</span>';
	                                    }
	                                    else {
	                                        splitAry[s] = splitAry[s]
	                                            .replace(/\-/g, '<span class="calculateOptSpan">-</span>')
	                                            .replace(/\(/g, '<span class="calculateBracesSpan">(</span>')
	                                            .replace(/\)/g, '<span class="calculateBracesSpan">)</span>')
	                                            .replace(/\'/g, '<span class="calculateOptSpan">\'</span>')
	                                            .replace(/\]/g, '<span class="calculateOptSpan">\]</span>')
	                                            .replace(/\[/g, '<span class="calculateOptSpan">\[</span>')
	                                            .replace(/\,/g, '<span class="calculateOptSpan">,</span>');
	                                    }
	                                }
	                                var numSplitAry = splitAry.join("").split("</span>");
	                                for (var s = 0; s < numSplitAry.length; s++) {
	                                    var str = numSplitAry[s].substr(0, numSplitAry[s].indexOf("<span"));
	                                    if (angular.element.trim(str) != "" || parseFloat(numSplitAry[s]) || parseFloat(numSplitAry[s]) == 0) {
	                                        if (parseFloat(str) || parseFloat(numSplitAry[s]) || parseFloat(numSplitAry[s]) == 0) {
	                                            if (parseFloat(numSplitAry[s]) || parseFloat(numSplitAry[s]) == 0)
	                                                str = parseFloat(numSplitAry[s]).toString();
	                                            numSplitAry[s] = numSplitAry[s].replace(new RegExp(str), '<span class="calculateNumSpan">' + str + '</span>');
	                                        }
	                                        else {
	                                            numSplitAry[s] = numSplitAry[s].replace(new RegExp(str), '<span class="calculateFieldSpan">' + str + '</span>');
	                                        }
	                                    }
	                                }
	                                var finalHTML = numSplitAry.join("</span>").replace(/MATH_SUM_FUN/g, 'math.sum');
	                                this.properties.formula.html = finalHTML;
	                            }
	                            else {
	                                this.showMsg();
	                                returnType = false;
	                            }
	                        }
	                        catch (err) {
	                            this.showMsg();
	                            returnType = false;
	                        }
	                    }
	                    return returnType;
	                };
	            }
	        });
	    };
	    PropertyboxComponent.prototype.updateFieldName = function (fieldName, oldFieldName, uid) {
	        var views = this.views, controls = [], newFieldNameCount = 0;
	        if (Object.keys(views).length) {
	            for (var view in views) {
	                for (var v = 0; v < this.Util.getIteams(views[view].controls.A).length; v++) {
	                    controls.push(this.Util.getIteams(views[view].controls.A)[v]);
	                }
	            }
	            if (controls.length) {
	                for (var c = 0; c < controls.length; c++) {
	                    var control = controls[c];
	                    if (!control.copiedFrom && control.properties.Basic && control.properties.Basic["Field Name"] && control.properties.Basic["Field Name"].selectedValue == fieldName) {
	                        newFieldNameCount += 1;
	                    }
	                }
	                if (newFieldNameCount > 1) {
	                    this.ngNotification.error({ message: "Duplicate Field Name : " + fieldName, positionX: 'center', replaceMessage: true });
	                    return;
	                }
	                for (var i = 0; i < controls.length; i++) {
	                    var control = controls[i];
	                    if (control.type == "Display field") {
	                        if (control.properties["Basic"]["DSName"].selectedValue == "calculated") {
	                            var UidAry = control.properties["Basic"]["formula"] && control.properties["Basic"]["formula"]["uids"];
	                            if (UidAry.length && UidAry.indexOf(uid) != -1) {
	                                var valueSplitAry = control.properties["Basic"]["Value"].selectedValue.split("}");
	                                for (var s = 0; s < valueSplitAry.length; s++) {
	                                    var split = valueSplitAry[s];
	                                    if (split.indexOf("{") != -1) {
	                                        var str = split.substr(split.indexOf("{"), split.length);
	                                        str = str.replace("{", "").replace("}", "").replace("sum(", "").replace(")", "");
	                                        if (oldFieldName.replace("{", "").replace("}", "") == str) {
	                                            valueSplitAry[s] = valueSplitAry[s].substr(0, valueSplitAry[s].indexOf("{") + 1) + fieldName;
	                                        }
	                                    }
	                                }
	                                control.properties["Basic"]["Value"].selectedValue = valueSplitAry.join("}");
	                                var htmlSplitAry = control.properties["Basic"]["formula"].html.split('}');
	                                for (var h = 0; h < htmlSplitAry.length; h++) {
	                                    var split = htmlSplitAry[h];
	                                    if (split.indexOf("{") != -1) {
	                                        var str = split.substr(split.indexOf("{"), split.length);
	                                        str = str.replace("{", "").replace("}", "").replace("sum(", "").replace(")", "");
	                                        if (oldFieldName.replace("{", "").replace("}", "") == str) {
	                                            htmlSplitAry[h] = htmlSplitAry[h].substr(0, htmlSplitAry[h].indexOf("{") + 1) + fieldName;
	                                        }
	                                    }
	                                }
	                                control.properties["Basic"]["formula"].html = htmlSplitAry.join("}");
	                            }
	                        }
	                    }
	                }
	            }
	        }
	    };
	    /**
	     * Search and set fixedfield value in properties from user friendly names.
	     *
	     * @param {any} properties
	     * @memberof PropertyboxComponent
	     */
	    PropertyboxComponent.prototype.updateDSField = function (properties) {
	        var value = properties.Value.selectedValue;
	        var self = this;
	        var fields = self.Util.getDataFieldNames();
	        fields = fields.concat(self.Util.getFixedFields(true));
	        var regex = /(^\{\{.*?\}\}$)/;
	        if (typeof (value) !== 'boolean' && value.match(regex)) {
	            var val_2 = value.replace('{{', '').replace('}}', '');
	            var field = fields.filter(function (value) {
	                return value.key == val_2;
	            });
	            if (field.length) {
	                properties.DSName.selectedValue = field[0].value;
	            }
	            else {
	                properties.DSName.selectedValue = '';
	            }
	        }
	        else {
	            properties.DSName.selectedValue = '';
	        }
	        if (value == "") {
	            this.resetCondition(properties);
	        }
	    };
	    //reseting to default if calculation query removed and saved
	    PropertyboxComponent.prototype.resetCondition = function (properties) {
	        properties.Value.readonly = false;
	        properties.DSName.selectedValue = "";
	        properties.Value.selectedValue = "";
	        if (properties.formula) {
	            properties.formula.hidden = true;
	            properties.formula.selectedValue = "";
	            properties.formula.html = "";
	            properties.formula.rules = "";
	        }
	        if (properties.list) {
	            properties.list.listItem.forEach(function (item) {
	                item.field.value = '';
	                item.operator.options.value = "Equal to";
	                item.operator.selected = "Equal to";
	                item.target.value = 0;
	                item.target.disable = false;
	                item.conjuction.hidden = true;
	                item.addField.value = '';
	                item.remove.hidden = true;
	            });
	            properties.list.listItem = properties.list.listItem.filter(function (item) {
	                if (item.field.value != "" || item.id == 0)
	                    return item;
	            });
	        }
	    };
	    /**
	     * Check and Update style of current control's children.
	     *
	     * @param {any} key
	     * @returns
	     * @memberof PropertyboxComponent
	     */
	    PropertyboxComponent.prototype.updateStyle = function (key) {
	        /* let selectedItem = this.getSelectedItem();
	        if (!Object.keys(selectedItem).length || (selectedItem.type != "Layout" && selectedItem.type != "RepeatingTable" && selectedItem.type != "Table"))
	            return;
	        let properties = selectedItem.properties.Style;
	        let children = selectedItem.data;
	        this.updateChildStyle([selectedItem], properties, key); */
	    };
	    /**
	     * Update child's style property with parent(Layout, Table)
	     *
	     * @param {any} controls
	     * @param {any} properties
	     * @param {any} key
	     * @memberof PropertyboxComponent
	     */
	    PropertyboxComponent.prototype.updateChildStyle = function (controls, properties, key) {
	        var self = this;
	        if (controls.length) {
	            for (var i = 0; i < controls.length; i++) {
	                if (controls[i].type == "Image") {
	                    key == 'alignment' && (controls[i].properties.Style['font-style-group'].members.alignment.selectedValue = properties['style-group'].members.alignment.selectedValue);
	                    key == 'background-color' && (controls[i].properties.Style['font-style-group'].members['background-color'].selectedValue = properties['font-style-group'].members['background-color'].selectedValue);
	                }
	                else {
	                    if (key == 'font-family' || key == 'font-size' || key == 'background-color') {
	                        controls[i].properties.Style['font-style-group'].members[key].selectedValue = properties['font-style-group'].members[key].selectedValue;
	                    }
	                    else if (key == 'bold' || key == 'italic' || key == 'underline' || key == 'alignment' || key == 'font-color') {
	                        controls[i].properties.Style['style-group'].members[key].selectedValue = properties['style-group'].members[key].selectedValue;
	                    }
	                }
	                if (controls[i].type == "Layout") {
	                    self.Util.accessLayoutElements(controls[i], function (elems) {
	                        self.updateChildStyle(elems, properties, key);
	                    });
	                }
	                if (controls[i].type == "Table") {
	                    self.Util.accessTableElements(controls[i], function (elems) {
	                        self.updateChildStyle(elems, properties, key);
	                    });
	                }
	                if (controls[i].type == "RepeatingTable") {
	                    self.Util.accessRepeatingTableElements(controls[i], function (elems) {
	                        self.updateChildStyle(elems, properties, key);
	                    });
	                }
	                if (controls[i].type == "Section") {
	                    self.Util.accessSectionElements(controls[i], function (elems) {
	                        self.updateChildStyle(elems, properties, key);
	                    });
	                }
	            }
	        }
	    };
	    /**
	    * Update value on /off for toggle button,
	    * Also check if it is empty and notify user
	    * @param {any} properties
	    * @memberof PropertyboxComponent
	    */
	    PropertyboxComponent.prototype.updateValueText = function (properties, fieldName) {
	        if (fieldName == 'value.on' && properties['ValueOn'].selectedValue == '') {
	            var msg = 'Please enter the required ' + this.$translate.instant(fieldName) + ' input';
	            this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
	            return;
	        }
	        else if (fieldName == 'value.off' && properties['ValueOff'].selectedValue == '') {
	            var msg = 'Please enter the required ' + this.$translate.instant(fieldName) + ' input';
	            this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
	            return;
	        }
	    };
	    /**
	         * hide and show the working Days property based on date dateType
	         *
	         * @param {any} dateType
	         * @param {any} properties
	         * @memberof PropertyboxComponent
	         */
	    PropertyboxComponent.prototype.updateDateType = function (dateType, properties) {
	        if (dateType == '2') {
	            properties['Working Days'].hidden = false;
	        }
	        else {
	            properties['Working Days'].hidden = true;
	            properties['Working Days'].selectedValue = false;
	        }
	    };
	    /**
	     * Update default value from date picker
	     *
	     * @param {any} dateFormat
	     * @param {any} properties
	     * @memberof PropertyboxComponent
	     */
	    PropertyboxComponent.prototype.updateDefaultDate = function (dateFormat, properties) {
	        var selectedItemProps = this.getSelectedItemProperties();
	        var pickerId = this.getSelectedItem().uid, isDateEmpty = true, myDateElem = angular.element("input[picker-id=" + pickerId + "]"), myPropDateElem = angular.element("input[picker-id=p_" + pickerId + "]"), sideBySide = true, dateTimeFormat = properties['Display Format'].selectedValue == 'default' ? this.Util.getNewDateFormat('default') : properties['Display Format'].selectedValue;
	        if (properties['Time'] && properties['Time'].selectedValue) {
	            selectedItemProps.Advance["Closed Date"].selectedValue = false;
	            selectedItemProps.Advance["Closed Date"].disable = true;
	            dateTimeFormat = properties['Time Format'].selectedValue == 'true' ? dateTimeFormat + ' hh:mm A' : dateTimeFormat + ' HH:mm';
	        }
	        else {
	            selectedItemProps.Advance["Closed Date"].disable = false;
	        }
	        if (properties['Default'].selectedValue) {
	            isDateEmpty = false;
	        }
	        var value = properties.Default.dateObj;
	        myDateElem.datetimepicker('destroy');
	        myPropDateElem.datetimepicker('destroy');
	        // Re-int with new options
	        myDateElem.datetimepicker({
	            format: dateTimeFormat,
	            sideBySide: sideBySide,
	            showClear: true,
	            showClose: true,
	            showTodayButton: true,
	            allowInputToggle: true,
	            keepOpen: false,
	            useCurrent: false,
	            toolbarPlacement: "bottom",
	            locale: this.config.languageId.split('_')[0],
	            icons: {
	                close: 'closeText',
	                clear: 'clearText',
	                today: 'todayText'
	            }
	        });
	        myPropDateElem.datetimepicker({
	            format: dateTimeFormat,
	            sideBySide: sideBySide,
	            showClear: true,
	            showClose: true,
	            showTodayButton: true,
	            allowInputToggle: true,
	            keepOpen: false,
	            useCurrent: false,
	            toolbarPlacement: "bottom",
	            locale: this.config.languageId.split('_')[0],
	            icons: {
	                close: 'closeText',
	                clear: 'clearText',
	                today: 'todayText'
	            }
	        });
	        if (!isDateEmpty && value) {
	            myDateElem.data('DateTimePicker').date(value);
	            myPropDateElem.data('DateTimePicker').date(value);
	        }
	    };
	    PropertyboxComponent.prototype.updateDefaultTime = function (format, properties) {
	        var pickerId = this.getSelectedItem().uid;
	        this.setTimeFormat(properties);
	        var timeFormat = format == 'true' ? 'hh:mm A' : 'HH:mm';
	        var defaultValue = _.get(properties, 'Default.selectedValue', '');
	        _.set(properties, 'Default.currentTime', moment(new Date()).format(timeFormat));
	        if (defaultValue) {
	            _.set(properties, 'Default.dateObj', moment(defaultValue, timeFormat).toDate());
	        }
	    };
	    PropertyboxComponent.prototype.setTimeFormat = function (properties) {
	        properties['timeFormat'] = properties['timeFormat'] ? properties['timeFormat'] : 'HH:mm';
	        var selectedItem = this.getSelectedItem(), timeFormat = 'HH:mm';
	        if (properties['Time Format']) {
	            timeFormat = properties['Time Format'].selectedValue == 'true' ? 'hh:mm a' : 'HH:mm';
	            selectedItem.timeFormat = timeFormat;
	            properties['timeFormat'] = timeFormat;
	        }
	    };
	    PropertyboxComponent.prototype.getTimePickerOptions = function (properties) {
	        if (properties['Time Format']) {
	            this.timePickerOptions.showMeridian = JSON.parse(properties['Time Format'].selectedValue);
	            return this.timePickerOptions;
	        }
	    };
	    PropertyboxComponent.prototype.checkValidInput = function (event, properties) {
	        if (event.currentTarget) {
	            if (event.currentTarget.className.indexOf('ng-invalid') != -1) {
	                properties.Default.selectedValue = null;
	            }
	        }
	    };
	    PropertyboxComponent.prototype.checkValidInputDate = function (properties) {
	        var dateTimeFormat = properties['Display Format'].selectedValue == 'default' ? this.Util.getNewDateFormat('default') : properties['Display Format'].selectedValue;
	        if (properties['Time'] && properties['Time'].selectedValue) {
	            dateTimeFormat = properties['Time Format'].selectedValue == 'true' ? dateTimeFormat + ' hh:mm A' : dateTimeFormat + ' HH:mm';
	        }
	        var itemVal = properties['Default'].selectedValue;
	        itemVal = moment(itemVal, dateTimeFormat).toDate();
	        if (itemVal == 'Invalid Date') {
	            if (properties['Default']['dateObj']) {
	                properties['Default'].selectedValue = moment(properties['Default']['dateObj']).format(dateTimeFormat);
	            }
	            else {
	                properties['Default'].selectedValue = '';
	            }
	        }
	        else if (itemVal != 'Invalid Date' && properties['Default']['dateObj']) {
	            properties['Default'].selectedValue = moment(properties['Default']['dateObj']).format(dateTimeFormat);
	        }
	    };
	    PropertyboxComponent.prototype.updatePickerDisplay = function (event, properties) {
	        event.preventDefault();
	        var dateElemPicker = angular.element(event.currentTarget);
	        dateElemPicker.data("DateTimePicker").keyBinds({ 't': null });
	        var curFormat = dateElemPicker.data("DateTimePicker").options().format;
	        var dateobj = properties['Default'].dateObj;
	        if (dateobj) {
	            if ((properties['Default'].selectedValue && properties['Default'].selectedValue.length) == curFormat.length) {
	                dateElemPicker.data('DateTimePicker').date(dateobj);
	            }
	        }
	    };
	    PropertyboxComponent.prototype.getDatePickerOptions = function (properties) {
	        var dateTimeFormat = properties['Display Format'].selectedValue == 'default' ? this.Util.getNewDateFormat('default') : properties['Display Format'].selectedValue;
	        if (properties['Time'] && properties['Time'].selectedValue) {
	            dateTimeFormat = properties['Time Format'].selectedValue == 'true' ? dateTimeFormat + ' hh:mm A' : dateTimeFormat + ' HH:mm';
	        }
	        this.datePickerOptions.format = dateTimeFormat;
	        properties.pickerOptions = this.datePickerOptions;
	    };
	    PropertyboxComponent.prototype.getParsedDate = function (properties) {
	        var dateTimeFormat = properties['Display Format'].selectedValue == 'default' ? this.Util.getNewDateFormat('default') : properties['Display Format'].selectedValue;
	        if (properties['Time'] && properties['Time'].selectedValue) {
	            dateTimeFormat = properties['Time Format'].selectedValue == 'true' ? dateTimeFormat + ' hh:mm A' : dateTimeFormat + ' HH:mm';
	        }
	        var itemVal = properties['Default'].selectedValue;
	        itemVal = moment(itemVal, dateTimeFormat).toDate();
	        if (itemVal != 'Invalid Date') {
	            properties['Default'].dateObj = moment(itemVal, dateTimeFormat).toDate();
	        }
	        else if (properties['Default'].selectedValue == '' || properties['Default'].selectedValue == undefined) {
	            properties['Default'].dateObj = '';
	        }
	    };
	    PropertyboxComponent.prototype.openDatepicker = function (properties) {
	        var pickerId = this.getSelectedItem().uid, myPropDateElem = angular.element("input[picker-id=p_" + pickerId + "]");
	        myPropDateElem.datetimepicker('toggle');
	    };
	    PropertyboxComponent.prototype.updateRows = function () {
	        this.getListItems();
	    };
	    PropertyboxComponent.prototype.getRows = function () {
	        var selectedItem = this.getSelectedItemProperties();
	        if (selectedItem) {
	            var columnCount = _.get(selectedItem, '["Basic"].Number.selectedValue', 1);
	            if (columnCount <= 0)
	                columnCount = 1;
	            var rowsArr = _.get(selectedItem, '["Data Source"].table.list', []);
	            var rowsCount = rowsArr.length;
	            rowsCount = Math.ceil(rowsCount / columnCount);
	            return rowsCount;
	        }
	    };
	    PropertyboxComponent.prototype.getListItems = function () {
	        var selectedItem = this.getSelectedItem();
	        var selectedItemProperties = this.getSelectedItemProperties();
	        if (selectedItem) {
	            var rowsArr = _.get(selectedItemProperties, '["Data Source"].table.list', []);
	            var columnCount = _.get(selectedItemProperties, '["Basic"].Number.selectedValue', 1);
	            if (columnCount <= 0)
	                columnCount = 1;
	            var rows = this.getRows();
	            var items = [];
	            for (var i = 0; i < rows; i++) {
	                var rowItems = [];
	                for (var j = 0; j < columnCount; j++) {
	                    if (rowsArr[j + (i * columnCount)]) {
	                        rowItems.push(rowsArr[j + (i * columnCount)]);
	                    }
	                }
	                items.push(rowItems);
	            }
	            selectedItem.optionsList = items;
	        }
	    };
	    PropertyboxComponent.prototype.mapTypeChanged = function (value, properties) {
	        _.set(properties, 'Default.selectedValue', '');
	    };
	    PropertyboxComponent.prototype.openDSHelp = function () {
	        var form = document.createElement("form");
	        form.target = "_blank";
	        form.method = "POST";
	        form.action = '/help';
	        form.style.display = "none";
	        var input = document.createElement("input");
	        input.type = "hidden";
	        input.name = 'USP';
	        input.value = JSON.stringify(this.$rootScope.USP);
	        var inputBrandingId = document.createElement("input");
	        inputBrandingId.type = "hidden";
	        inputBrandingId.name = 'brandingId';
	        inputBrandingId.value = this.config.brandingId;
	        form.appendChild(inputBrandingId);
	        form.appendChild(input);
	        document.body.appendChild(form);
	        form.submit();
	        document.body.removeChild(form);
	    };
	    PropertyboxComponent.prototype.resetDefaultForRadio = function (value, list) {
	        if (list.length) {
	            for (var i = 0; i < list.length; i++) {
	                var element = list[i];
	                element.Default.name = '';
	            }
	        }
	        value.name = true;
	    };
	    PropertyboxComponent.prototype.resetDefault = function () {
	        var selectedItem = this.getSelectedItemProperties();
	        if (selectedItem) {
	            var dsType = _.get(selectedItem, '["Data Source"].Source.selectedValue', '');
	            if (dsType == '3') {
	                var list = _.get(selectedItem, '["Data Source"].table.list', []);
	                for (var i = 0; i < list.length; i++) {
	                    var element = list[i];
	                    element.Default.name = '';
	                }
	            }
	        }
	    };
	    PropertyboxComponent.prototype.validateMin = function (item) {
	        if (item['Min'].selectedValue >= item['Max'].selectedValue) {
	            var msg = this.$translate.instant('min.greater.max');
	            this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
	            return;
	        }
	    };
	    //toggling app status sync
	    PropertyboxComponent.prototype.enableAppStatusSync = function () {
	        var selectedItem = this.getSelectedItemProperties();
	        if (selectedItem.Advance["App Status"].selectedValue == true) {
	            //seting default values on app sync status 
	            var oldDataFieldName = selectedItem.Basic["Data Field Name"].selectedValue;
	            selectedItem.Basic["Data Field Name"].selectedValue = "DS_ALL_FORMSTATUS";
	            selectedItem.Basic["Data Field Name"].disable = true;
	            this.restrictCharInDataFieldName("DS_ALL_FORMSTATUS", oldDataFieldName, true);
	            selectedItem.Basic["Multi-Select"].disable = true;
	            selectedItem.Basic["Multi-Select"].selectedValue = false;
	            selectedItem["Data Source"].Source.selectedValue = '4'; //setting data source as system data
	            selectedItem["Data Source"].forceToDisabled = true; //Disable all data source radio button
	            //setting the all form status as the selected value if app sync status enabled 
	            var urls = this.Util.getFixedFields(selectedItem["Data Source"].fixedFieldUrl.singleValue); //fetching all the system fixed field values
	            if (urls.length && selectedItem.Advance["App Status"].selectedValue == true) {
	                for (var i = 0; i < urls.length; i++) {
	                    if (urls[i].value == "DS_ALL_FORMSTATUS") {
	                        if (selectedItem["Data Source"].fixedFieldUrl.selectedValue == "")
	                            selectedItem["Data Source"].fixedFieldUrl.selectedValue = {};
	                        _.set(selectedItem["Data Source"], 'fixedFieldUrl.selectedValue', urls[i]);
	                    }
	                }
	            }
	        }
	        else {
	            var fieldName = selectedItem.Basic["Field Name"].selectedValue;
	            selectedItem.Basic["Data Field Name"].selectedValue = fieldName;
	            this.restrictCharInDataFieldName(fieldName, "DS_ALL_FORMSTATUS", true);
	            selectedItem.Basic["Data Field Name"].disable = false;
	            selectedItem.Basic["Multi-Select"].disable = false;
	            selectedItem.Advance["App Status"].selectedValue = false;
	            //removing all form status as selected value, if app sync status disabled
	            selectedItem["Data Source"].Source.selectedValue = '3';
	            selectedItem["Data Source"].forceToDisabled = false; //Enable all data source radio button               
	            _.set(selectedItem["Data Source"], 'fixedFieldUrl.selectedValue', "");
	        }
	    };
	    //toggling closed date sync
	    PropertyboxComponent.prototype.enableClosedDateSync = function () {
	        var selectedItem = this.getSelectedItemProperties();
	        if (selectedItem.Advance["Closed Date"].selectedValue == true) {
	            //setting default value if closed date sync enabled
	            var oldDataFieldName = selectedItem.Basic["Data Field Name"].selectedValue;
	            selectedItem.Basic["Data Field Name"].selectedValue = "DS_CLOSE_DUE_DATE";
	            selectedItem.Basic["Data Field Name"].disable = true;
	            this.restrictCharInDataFieldName("DS_CLOSE_DUE_DATE", oldDataFieldName, true);
	            //setting datepicker as required, so it's mandatory to add a date when submitting a form
	            selectedItem.Basic.Required.selectedValue = true;
	            selectedItem.Basic.Required.disable = true;
	            selectedItem.Basic.Time.selectedValue = false;
	            selectedItem.Basic.Time.disable = true;
	        }
	        else {
	            var fieldName = selectedItem.Basic["Field Name"].selectedValue;
	            selectedItem.Basic["Data Field Name"].selectedValue = fieldName;
	            this.restrictCharInDataFieldName(fieldName, "DS_CLOSE_DUE_DATE", true);
	            selectedItem.Basic["Data Field Name"].disable = false;
	            selectedItem.Basic.Required.selectedValue = false;
	            selectedItem.Basic.Required.disable = false;
	            selectedItem.Basic.Time.selectedValue = false;
	            selectedItem.Basic.Time.disable = false;
	        }
	    };
	    /**
	     * @brief      Merge Table Cells
	     *
	     * @return     { Void }
	     */
	    PropertyboxComponent.prototype.mergeCell = function () {
	        var item = this.Util.returnSelected(this.selectedView.view.controls.A)[0];
	        // Variables
	        var isRowSpan, isColspan, row, col, selectedCellArray = [], isValid = true, colSpanCount = 1, rowSpanCount = 1;
	        var rowSet = new Set();
	        var colSet = new Set();
	        var isSelectedCellIsRow = true;
	        var isSelectedCellIsCol = true;
	        // Find what user wants Rowspan/Colspan?
	        var oldRow, oldCol, oldRowspan, oldColspan;
	        item.ids.sort(function (a, b) {
	            var c = parseInt(a.split('-')[0]);
	            var d = parseInt(b.split('-')[0]);
	            return c - d;
	        });
	        item.ids.sort(function (a, b) {
	            var c = parseInt(a.split('-')[1]);
	            var d = parseInt(b.split('-')[1]);
	            return c - d;
	        });
	        item.ids.forEach(function (combination, index) {
	            var cellRow = parseInt(combination.split("-")[0], 10), cellCol = parseInt(combination.split("-")[1], 10), colspan = (item.data[cellRow][cellCol].colspan) ? item.data[cellRow][cellCol].colspan : 1, rowspan = (item.data[cellRow][cellCol].rowspan) ? item.data[cellRow][cellCol].rowspan : 1;
	            if (row === cellRow && isColspan !== false) {
	                isColspan = true;
	                colSpanCount = colSpanCount + colspan;
	            }
	            if (((oldCol + 1) !== cellCol && isColspan === true || rowspan > 10) || (oldRowspan > 1 && rowspan === 1) || (oldRowspan === 1 && rowspan > 1)) {
	                isColspan = false;
	            }
	            if (col === cellCol && isRowSpan !== false) {
	                isRowSpan = true;
	                rowSpanCount = rowSpanCount + rowspan;
	            }
	            if (((oldRow + 1) !== cellRow && isRowSpan === true || colspan > 10) || (oldColspan > 1 && colspan === 1) || (oldColspan === 1 && colspan > 1)) {
	                isRowSpan = false;
	            }
	            if (index === 0) {
	                row = cellRow;
	                col = cellCol;
	            }
	            oldRow = cellRow + (rowspan - 1);
	            oldCol = cellCol + (colspan - 1);
	            oldRowspan = rowspan;
	            oldColspan = colspan;
	            selectedCellArray.push([cellRow, cellCol]);
	            // Adding row and col into the Set
	            rowSet.add(cellRow);
	            colSet.add(cellCol);
	        });
	        // check for the rowSet and colSet size, if it is equal to one or not, if not then show the error msg.
	        isSelectedCellIsRow = rowSet.size === 1;
	        isSelectedCellIsCol = colSet.size === 1;
	        // Count cells
	        var cellCount = item.ids.length;
	        // Validate Selection
	        if (item.ids.length === 0) {
	            this.ngNotification.error({ message: "Please use Shift+Right Click to select cell in table", positionX: 'center', replaceMessage: true });
	            return;
	        }
	        if ((!isSelectedCellIsRow && !isSelectedCellIsCol) || (!isColspan && !isRowSpan)) {
	            this.ngNotification.error({ message: 'Invalid Selection.', positionX: 'center', replaceMessage: true });
	            item.reset = true;
	            item.ids = [];
	            return false;
	        }
	        // Apply colspan/rowspan
	        if (isColspan) {
	            if (item.data[row][col].colspan) {
	                item.data[row][col].colspan = item.data[row][col].colspan + (colSpanCount - 1);
	            }
	            else {
	                item.data[row][col].colspan = colSpanCount;
	            }
	        }
	        if (isRowSpan) {
	            if (item.data[row][col].rowspan) {
	                item.data[row][col].rowspan = item.data[row][col].rowspan + (rowSpanCount - 1);
	            }
	            else {
	                item.data[row][col].rowspan = rowSpanCount;
	            }
	        }
	        selectedCellArray.forEach(function (cell, index) {
	            if (index === 0) {
	                return;
	            }
	            item.data[cell[0]][cell[1]].hide = true;
	        });
	        item.reset = true;
	        item.ids = [];
	    };
	    PropertyboxComponent.prototype.splitCell = function () {
	        var item = this.Util.returnSelected(this.selectedView.view.controls.A)[0];
	        var selectedCells = item.ids;
	        if (!selectedCells || !selectedCells.length) {
	            return;
	        }
	        for (var i = 0; i < selectedCells.length; i++) {
	            var cell = selectedCells[i], cellRow = parseInt(cell.split("-")[0], 10), cellCol = parseInt(cell.split("-")[1], 10), rowSpan = item.data[cellRow][cellCol].rowspan, colSpan = item.data[cellRow][cellCol].colspan;
	            if (rowSpan) {
	                for (var j = 1; j < rowSpan; j++) {
	                    item.data[cellRow + j][cellCol].hide = false;
	                    item.data[cellRow + j][cellCol].rowspan = '';
	                }
	            }
	            if (colSpan) {
	                for (var j = 1; j < colSpan; j++) {
	                    item.data[cellRow][cellCol + j].hide = false;
	                    item.data[cellRow][cellCol + j].colspan = '';
	                }
	            }
	            item.data[cellRow][cellCol].rowspan = '';
	            item.data[cellRow][cellCol].colspan = '';
	            item.reset = true;
	        }
	    };
	    PropertyboxComponent.prototype.showColorPicker = function ($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        angular.element($event.currentTarget).closest('.color-picker').find('.spectrum-color-picker').trigger('click');
	    };
	    PropertyboxComponent.prototype.removeWidth = function () {
	        var item = this.Util.returnSelected(this.selectedView.view.controls.A)[0];
	        item.width = {};
	    };
	    PropertyboxComponent.prototype.removeRow = function () {
	        var item = this.Util.returnSelected(this.selectedView.view.controls.A)[0];
	        if (item.selectedRows.length === item.data.length) {
	            alert("Can not remove all rows.");
	            return false;
	        }
	        for (var i = item.selectedRows.length - 1; i >= 0; i--) {
	            item.data.splice(item.selectedRows[i], 1);
	            item.properties.Display.Rows.selectedValue -= 1;
	        }
	        item.selectedRows = [];
	    };
	    //add new rule
	    PropertyboxComponent.prototype.addNewRuleDiv = function (index, item, list) {
	        var lastId = Math.max.apply(Math, list.map(function (o) { return o.id; }));
	        var copiedItem = angular.copy(item);
	        copiedItem['id'] = lastId + 1;
	        list.splice((index + 1), 0, copiedItem);
	        list[index + 1].field.value = '';
	        list[index + 1].target.value = 0;
	        list[index].conjuction.hidden = false;
	        list[index].remove.hidden = false;
	    };
	    //removing existing rule
	    PropertyboxComponent.prototype.removeRuleDiv = function (index, list) {
	        list.splice(index, 1);
	    };
	    //updating value type to number for selected calculation fields/textbox(type - decimal/integer)
	    PropertyboxComponent.prototype.updateValueType = function () {
	        var validateselectedtype, dsFieldCount = 0, textboxCount = 0;
	        var selectedItems = [];
	        for (var view in this.views) {
	            for (var v = 0; v < this.Util.getIteams(this.views[view].controls.A).length; v++) {
	                selectedItems.push(this.Util.getIteams(this.views[view].controls.A)[v]);
	            }
	        }
	        selectedItems.forEach(function (label) {
	            if (label.type.toLowerCase() == "display field")
	                dsFieldCount++;
	        });
	        selectedItems.forEach(function (textbox) {
	            if (textbox.type.toLowerCase() == "textbox") {
	                validateselectedtype = textbox.properties.Basic.Validate.selectedValue;
	                if (validateselectedtype != "" && (validateselectedtype == "Integer" || validateselectedtype == "Decimal"))
	                    textboxCount++;
	            }
	        });
	        selectedItems.forEach(function (item) {
	            if (item.type.toLowerCase() == "textbox" && item.properties.Basic.Type) {
	                if (dsFieldCount > 1 || textboxCount > 0)
	                    item.properties.Basic.Type.number = true;
	                else
	                    item.properties.Basic.Type.number = false;
	            }
	            else if (item.type.toLowerCase() == "display field" && item.properties.Basic.Type) {
	                if (dsFieldCount > 1 || textboxCount > 0)
	                    item.properties.Basic.Type.number = true;
	                else
	                    item.properties.Basic.Type.number = false;
	            }
	        });
	    };
	    //return counts for calculated fields and textbox(type - integer/decimal) added under repeating table
	    PropertyboxComponent.prototype.returnFieldCounts = function (selectedItems, parentnode) {
	        var _this = this;
	        var selectedcolumn, validateselectedtype, dsFieldCount = 0, textboxCount = 0;
	        selectedItems.forEach(function (item) {
	            if (item.type.toLowerCase() == "repeatingtable") {
	                var tableId_1 = "repeatingTable" + item.id;
	                if (tableId_1 == parentnode) {
	                    item.data[0].forEach(function (data) {
	                        selectedcolumn = data.elems[0];
	                        selectedcolumn.forEach(function (column) {
	                            if (column.properties.Basic && column.properties.Basic.parentNode && column.properties.Basic.parentNode.id == tableId_1) {
	                                if (column.type.toLowerCase() == "display field")
	                                    dsFieldCount++;
	                                else if (column.type.toLowerCase() == "textbox") {
	                                    validateselectedtype = column.properties.Basic.Validate.selectedValue;
	                                    if (validateselectedtype != "" && (validateselectedtype == "Integer" || validateselectedtype == "Decimal"))
	                                        textboxCount++;
	                                }
	                                else if (column.type.toLowerCase() == "repeatingtable") {
	                                    _this.returnFieldCounts([column], parentnode);
	                                }
	                            }
	                        });
	                    });
	                }
	            }
	        });
	        return [textboxCount, dsFieldCount];
	    };
	    //setting calculated fields and textbox as number type based upon the count, for fields under repeating table(s)
	    PropertyboxComponent.prototype.updateRepeatingTableDSFieldType = function (selectedItems, textboxunderrepeatingtbl, parentnode) {
	        var _this = this;
	        if (!angular.isObject(selectedItems)) {
	            selectedItems = [];
	            for (var view in this.views) {
	                for (var v = 0; v < this.Util.getIteams(this.views[view].controls.A).length; v++) {
	                    selectedItems.push(this.Util.getIteams(this.views[view].controls.A)[v]);
	                }
	            }
	        }
	        var selectedcolumn, textboxCount = this.returnFieldCounts(selectedItems, parentnode)[0], dsFieldCount = this.returnFieldCounts(selectedItems, parentnode)[1];
	        selectedItems.forEach(function (item) {
	            if (item.type.toLowerCase() == "repeatingtable") {
	                item.data[0].forEach(function (data) {
	                    selectedcolumn = data.elems[0];
	                    selectedcolumn.forEach(function (column) {
	                        if (column.type.toLowerCase() == "textbox") {
	                            var parentnode_1 = column.properties.Basic.parentNode.id;
	                            if (dsFieldCount > 1 || textboxCount > 0) {
	                                _this.returnFieldType(true, parentnode_1);
	                                textboxunderrepeatingtbl = true;
	                            }
	                            else
	                                _this.returnFieldType(false, parentnode_1);
	                        }
	                        else if (column.type.toLowerCase() == "display field") {
	                            var parentnode_2 = column.properties.Basic.parentNode.id;
	                            if (dsFieldCount > 1 || textboxCount > 0) {
	                                _this.returnFieldType(true, parentnode_2);
	                            }
	                            else
	                                _this.returnFieldType(false, parentnode_2);
	                        }
	                        else if (column.type.toLowerCase() == "repeatingtable") {
	                            _this.updateRepeatingTableDSFieldType(selectedcolumn, textboxunderrepeatingtbl, parentnode);
	                        }
	                    });
	                });
	            }
	        });
	    };
	    PropertyboxComponent.prototype.returnFieldType = function (type, parentnode) {
	        var currentparentnodeId = this.getSelectedItemProperties().Basic.parentNode.id;
	        if (parentnode == currentparentnodeId) {
	            if (type == true && currentparentnodeId != 0) {
	                this.getSelectedItemProperties().Basic.Type.numberUnderRepeatingTable = true;
	                this.getSelectedItemProperties().Basic.Type.number = true;
	            }
	            else {
	                this.getSelectedItemProperties().Basic.Type.numberUnderRepeatingTable = false;
	                this.getSelectedItemProperties().Basic.Type.number = false;
	            }
	        }
	    };
	    /**
	     * Invoked when current selected control property is changed.
	     */
	    PropertyboxComponent.prototype.onPropValueChanged = function () {
	        var self = this;
	        var selectedItem = self.getSelectedItem();
	        if (selectedItem && (selectedItem.type === 'InlineAssocFiles' || selectedItem.type === 'InlineAssocApps')) {
	            self.updateLanguageData(selectedItem);
	        }
	        if (selectedItem.properties && selectedItem.properties.Basic) {
	            var controlFieldName = selectedItem.properties.Basic['Field Name'] && selectedItem.properties.Basic['Field Name'].selectedValue;
	            self.$rootScope.$broadcast('controlPropertyChanged', controlFieldName);
	        }
	    };
	    PropertyboxComponent.prototype.setDisplayFormat = function (icon, value, properties) {
	        var selectedItem = '';
	        var selectedIcon = '';
	        properties['Display Format'].options.forEach(function (item) {
	            if (value == item.value && icon == item.icon) {
	                selectedItem = item.key;
	                selectedIcon = item.icon;
	            }
	        });
	        properties['Display Format'].selectedName = selectedItem;
	        properties['Display Format'].selectedIcon = selectedIcon;
	        properties['Display Format'].selectedValue = value;
	    };
	    PropertyboxComponent.prototype.isValidURL = function (str) {
	        var a = document.createElement('a');
	        a.href = str;
	        return (a.host && a.host != window.location.host);
	    };
	    PropertyboxComponent.prototype.onDigitSepratorToggle = function (properties, value) {
	        properties.DecimalPlaces.hidden = properties.Validate.selectedValue != 'Decimal' || !value.selectedValue;
	        if (value.selectedValue) {
	            properties.DigitSeparator.addOnButton = properties.DigitSeparator.addOnButton.replace(' hidden', '');
	        }
	        else {
	            properties.DigitSeparator.addOnButton += ' hidden';
	        }
	    };
	    PropertyboxComponent.prototype.onFormatTypeChanged = function (selectedValue, properties) {
	        this.updateValueType();
	        if (this.numberFormatEnabled && (selectedValue == 'Integer' || selectedValue == 'Decimal')) {
	            properties.DigitSeparator.hidden = false;
	            properties.DecimalPlaces.hidden = selectedValue != 'Decimal' || !properties.DigitSeparator.selectedValue;
	            properties.DecimalPlaces.selectedValue = "0";
	        }
	        else {
	            properties.DigitSeparator.selectedValue = false;
	            properties.DigitSeparator.hidden = true;
	            properties.DecimalPlaces.hidden = true;
	            properties.DecimalPlaces.selectedValue = "0";
	        }
	    };
	    PropertyboxComponent.prototype.onThumbailSizeChanged = function (selectedValue, properties) {
	        if (selectedValue == 'customize') {
	            properties['Thumbnail Width'].hidden = false;
	            properties['Thumbnail Height'].hidden = false;
	        }
	        else {
	            properties['Thumbnail Width'].hidden = true;
	            properties['Thumbnail Height'].hidden = true;
	        }
	    };
	    PropertyboxComponent.prototype.onThumbnailViewChanged = function (selectedValue, properties) {
	        if (selectedValue == true && properties['Thumbnail Size'].selectedValue == 'customize') {
	            properties['Thumbnail Width'].hidden = false;
	            properties['Thumbnail Height'].hidden = false;
	        }
	        else {
	            properties['Thumbnail Width'].hidden = true;
	            properties['Thumbnail Height'].hidden = true;
	        }
	    };
	    PropertyboxComponent.prototype.removeDuplicateData = function (properties) {
	        var list = properties.list;
	        var arrayOfValues = [];
	        var arrayOfLabels = [];
	        for (var j = list.length - 1; j >= 0; j--) {
	            arrayOfValues.push(list[j].Value.name);
	            arrayOfLabels.push(list[j].Label.name);
	        }
	        if (this.Util.hasDuplicates(arrayOfValues) || this.Util.hasDuplicates(arrayOfLabels)) {
	            var msg = this.$translate.instant('duplicate.value.found');
	            this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
	            return;
	        }
	    };
	    PropertyboxComponent.prototype.setNumberField = function (event, properties) {
	        var val = event.target.value;
	        if (val <= 0 || val > 999) {
	            event.target.value = 1;
	            properties['Number'].selectedValue = 1;
	        }
	    };
	    PropertyboxComponent.prototype.checkRequired = function (value, fieldname) {
	        var _this = this;
	        if (value == '') {
	            var msg = 'Please enter the required field';
	            this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
	            return;
	        }
	        else {
	            if (fieldname == 'linkAddress' && !this.isValidURL(value)) {
	                var msg = 'Please enter the valid Link Address';
	                this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
	                return;
	            }
	            else if (fieldname == 'linkAddress' && this.isValidURL(value)) {
	                this.$http({
	                    'url': 'https://safebrowsing.googleapis.com/v4/threatMatches:find?key=AIzaSyDL3Ax5ksdqPSJ8c6BKNma9d3M4VKrk0Xk',
	                    'method': 'POST',
	                    'headers': {
	                        'Content-Type': 'application/json'
	                    },
	                    'data': {
	                        "client": {
	                            "clientId": "Asite_001",
	                            "clientVersion": "1"
	                        },
	                        "threatInfo": {
	                            "threatTypes": ["MALWARE", "SOCIAL_ENGINEERING"],
	                            "platformTypes": ["WINDOWS"],
	                            "threatEntryTypes": ["URL"],
	                            "threatEntries": [
	                                { "url": value },
	                            ]
	                        }
	                    }
	                }).then(function (response) {
	                    if (Object.keys(response.data).length != 0) {
	                        var msg = 'The url entered is not in the safe Browsing lists';
	                        _this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
	                        return;
	                    }
	                    else {
	                        var selectedItem = _this.getSelectedItem();
	                        var totalItems = _this.Util.getAllControls();
	                        if (selectedItem.type === 'Hyperlink') {
	                            var filtered = _.filter(totalItems, { uid: selectedItem.uid });
	                            for (var i = 0; i < filtered.length; i++) {
	                                _.set(filtered[i], "properties.Basic['Value'].selectedValue", value);
	                                filtered[i].copiedFrom && (filtered[i].copiedFrom = value);
	                            }
	                        }
	                    }
	                });
	            }
	        }
	    };
	    PropertyboxComponent.prototype.addcolumnName = function () {
	        var self = this;
	        var selectedItem = self.getSelectedItem();
	        var properties = selectedItem.properties.Association.selectedColumn;
	        if (selectedItem.type == 'InlineAssocFiles') {
	            selectedItem.properties.Association.AddSetup.clicked = true;
	            self.editDropDownSource('6', properties);
	        }
	        if (selectedItem.type == 'InlineAssocApps') {
	            selectedItem.properties.Association.AddSetup.clicked = true;
	            self.editDropDownSource('7', properties);
	        }
	        if (selectedItem.type == 'ViewAssociations') {
	            var assocType = selectedItem.properties.Basic['Assoc Type'].selectedValue;
	            if (assocType) {
	                selectedItem.properties.Association.AddSetup.clicked = true;
	                properties = selectedItem.properties.Association[assocType];
	                self.editDropDownSource('8', properties);
	            }
	        }
	    };
	    return PropertyboxComponent;
	}());
	exports.PropertyboxComponent = PropertyboxComponent;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('directives.propertybox', [])
	    .component('propertybox', {
	    template: __webpack_require__(254),
	    controller: PropertyboxComponent
	})
	    .name;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.18.1';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function',
	      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`',
	      INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading whitespace. */
	  var reTrimStart = /^\s+/;
	
	  /** Used to match a single whitespace character. */
	  var reWhitespace = /\s/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */
	  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */
	  function baseTrim(string) {
	    return string
	      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	      : string;
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedEndIndex(string) {
	    var index = string.length;
	
	    while (index-- && reWhitespace.test(string.charAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * **Security:** See
	     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
	     * — `_.template` is insecure and will be removed in v5.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            };
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }
	
	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }
	
	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	
	      // Prevent prototype pollution:
	      // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
	      // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
	      var index = -1,
	          length = path.length;
	
	      if (!length) {
	        return true;
	      }
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	
	        // Always block "__proto__" anywhere in the path if it's not expected
	        if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) {
	          return false;
	        }
	
	        // Block constructor/prototype as non-terminal traversal keys to prevent
	        // escaping the object graph into built-in constructors and prototypes.
	        if ((key === 'constructor' || key === 'prototype') && index < length - 1) {
	          return false;
	        }
	      }
	
	      var obj = parent(object, path);
	      return obj == null || delete obj[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        baseAssignValue(result, pair[0], pair[1]);
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * **Note:** If `lower` is greater than `upper`, the values are swapped.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * // when lower is greater than upper the values are swapped
	     * _.random(5, 0);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(-5);
	     * // => an integer between -5 and 0
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Security:** `_.template` is insecure and should not be used. It will be
	     * removed in Lodash v5. Avoid untrusted input. See
	     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      arrayEach(importsKeys, function(key) {
	        if (reForbiddenIdentifierChars.test(key)) {
	          throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
	        }
	      });
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Throw an error if a forbidden character was found in `variable`, to prevent
	      // potential command injection attacks.
	      else if (reForbiddenIdentifierChars.test(variable)) {
	        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
	      }
	
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return baseTrim(string);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.slice(0, trimmedEndIndex(string) + 1);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(24)(module)))

/***/ }),
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var angular = __webpack_require__(1);
	var Blockly = __webpack_require__(26);
	var blockly_custom_block_1 = __webpack_require__(36);
	/**
	 * Initialize Blockly code editor with its toolbox
	 */
	var BlocklyComponent = (function () {
	    BlocklyComponent.$inject = ['Notification', '$element', 'Util', 'config', '$http', 'PROJECTNAME'];
	    function BlocklyComponent(Notification, $element, Util, config, $http, PROJECTNAME) {
	        /**
	         * @type {*}@memberof BlocklyComponent
	         */
	        this.globleMethods = [];
	        this.controlFieldNames = [];
	        this.controlDataFieldNames = [];
	        this.dataFieldNameBlocks = ['custom-property-value-setter', 'custom-property-value-getter', 'auto_next_number_block',
	            'custom-date-diff', 'custom-date-add-subtract', 'minmax_datevalue', 'api_data_clone'];
	        this.fieldNameBlocks = ['custom-property-setter', 'custom-property-setter_by_getter', 'custom-property-getter', 'custom-reset-repeating-table', 'custom-get-repeating-table-rows', 'minmax_datevalue'];
	        this.allCustomBlocks = ['custom-property-value-setter', 'custom-property-value-getter',
	            'custom-property-setter', 'custom-property-setter_by_getter', 'custom-property-getter', 'custom-reset-repeating-table',
	            'sp_value_getter', 'sp_value_comparator', 'auto_next_number_block', 'auto_next_number_suffix_block', 'custom_math_to_fixed', 'custom-get-repeating-table-rows',
	            'set_timeout', 'clear_timeout', 'set_time_interval', 'clear_time_interval', 'minmax_datevalue', 'api_data_clone'];
	        var self = this;
	        self.http = $http;
	        self.$element = $element;
	        self.ngNotification = Notification;
	        self.Util = Util;
	        var viewNames = self.Util.getCurrentFormViewNames();
	        var fieldNames = self.Util.getFieldNames();
	        fieldNames.forEach(function (data) {
	            self.controlFieldNames.push(data.key);
	        });
	        var dataFieldNames = self.Util.getDataFieldNames();
	        dataFieldNames.forEach(function (data) {
	            if (self.controlDataFieldNames.indexOf(data.key) == -1) {
	                self.controlDataFieldNames.push(data.key);
	            }
	        });
	        var formID = config.formID;
	        var projectName = PROJECTNAME.replaceAll("&#39;", "'");
	        var projectId = config.formDetail.id ? config.formDetail.id.projectId : undefined;
	        var instanceGroupId = config.formDetail.id ? config.formDetail.id.instanceGroupId : undefined;
	        var apiList = self.Util.getAllAPIConnections(formID, instanceGroupId, projectId);
	        var projectList = self.Util.getProjectList();
	        apiList.then(function (response) {
	            projectList.then(function (projects) {
	                var apiLists = response.data.entity.length ? response.data.entity.filter(function (el) { return el.status == 'Established'; }) : [];
	                blockly_custom_block_1.ControlBlocklyBlocks({
	                    fieldNames: fieldNames,
	                    dataFieldNames: dataFieldNames,
	                    config: config,
	                    Util: Util,
	                    systemSingleValue: self.Util.getFixedFields(true),
	                    systemMultiValue: self.Util.getFixedFields(false),
	                    apiNames: apiLists,
	                    $http: $http,
	                    projects: projects,
	                    projectName: projectName,
	                    projectId: projectId,
	                    viewNames: viewNames,
	                    Notification: Notification
	                });
	                setTimeout(function () {
	                    self.initCodeEditor();
	                }, 10);
	                if (self.$element && self.$element.parent() && $(self.$element.parent()[0])) {
	                    $(self.$element.parent()[0]).removeClass('loading');
	                }
	            });
	        }, function (err) {
	            console.log(err);
	        });
	        //Set globle methods blocks into toolbox before create instance of Blockly
	        self.setGlobleMethods();
	        self.setGlobleMethodDefination('noopMethod');
	    }
	    BlocklyComponent.prototype.$onChanges = function (changedProps) {
	        if (changedProps && changedProps.maximized != undefined) {
	            this.resizeHandler();
	        }
	    };
	    /**
	     * @brief      Destroy existing code editor view and initialize new instance of code editor on '#codeEditorWindow' view.
	     *
	     * @return     null
	     */
	    BlocklyComponent.prototype.initCodeEditor = function () {
	        var self = this;
	        var elCodeEditorWindow = self.$element.find('#codeEditorWindow')[0];
	        if (!elCodeEditorWindow) {
	            return;
	        }
	        if (!Blockly) {
	            console.error('Blockly is not defined');
	            return;
	        }
	        window['codeEditor'] = self.codeEditor = Blockly.inject(elCodeEditorWindow, {
	            toolbox: self.$element.find('#toolbox')[0],
	            move: {
	                scrollbars: true,
	                drag: true,
	                wheel: true
	            }
	        });
	        self.setVal(self.codeEditorVal);
	        self.resizeHandler();
	        angular.element(window).on('resize.blocklyeditor', function () {
	            self.resizeHandler();
	        });
	    };
	    BlocklyComponent.prototype.setVal = function (val) {
	        var self = this;
	        if (!self.codeEditor) {
	            self.codeEditorVal = val;
	            return;
	        }
	        self.codeEditorVal = undefined;
	        if (val && typeof val == 'string') {
	            var xmlVal = Blockly.Xml.textToDom(val);
	            angular.element(xmlVal).children().each(function (ind, child) {
	                self.resetControlBlockIfFieldNameNotFound(child);
	                self.resetControlBlockIfDataFieldNameNotFound(child);
	                var typeName = child.getAttribute('type') || '';
	                if (typeName && typeName.indexOf('fn_') == 0) {
	                    self.setGlobleMethodDefination(typeName.replace('fn_', ''));
	                }
	            });
	            Blockly.Xml.domToWorkspace(xmlVal, self.codeEditor);
	        }
	        self.resizeHandler();
	    };
	    BlocklyComponent.prototype.resetControlBlockIfFieldNameNotFound = function (child) {
	        var self = this;
	        var typeName = child.getAttribute('type') || '';
	        if (self.fieldNameBlocks.indexOf(typeName) != -1) {
	            self.resetBlockVal(child);
	        }
	        self.fieldNameBlocks.forEach(function (blockType) {
	            var childs = angular.element(child).find('block[type=' + blockType + ']');
	            if (childs.length) {
	                childs.each(function (ind, item) {
	                    self.resetBlockVal(item);
	                });
	            }
	        });
	    };
	    BlocklyComponent.prototype.resetBlockVal = function (item) {
	        var self = this;
	        item = angular.element(item);
	        var controlName = item.find(' > field[name=CONTROL_NAME]').text();
	        if (self.controlFieldNames.indexOf(controlName) == -1) {
	            item.find(' > field[name=CONTROL_NAME]').text('');
	            item.find(' > field[name=PROPERTY_NAME]').text('');
	            item.find(' > field[name=PROPERTY_VALUE]').text('');
	        }
	    };
	    BlocklyComponent.prototype.resetControlBlockIfDataFieldNameNotFound = function (child) {
	        var self = this;
	        var typeName = child.getAttribute('type') || '';
	        if (self.dataFieldNameBlocks.indexOf(typeName) != -1) {
	            self.resetDataFieldBlockVal(child);
	        }
	        self.dataFieldNameBlocks.forEach(function (blockType) {
	            var childs = angular.element(child).find('block[type=' + blockType + ']');
	            if (childs.length) {
	                childs.each(function (ind, item) {
	                    self.resetDataFieldBlockVal(item);
	                });
	            }
	        });
	    };
	    BlocklyComponent.prototype.resetDataFieldBlockVal = function (item) {
	        var self = this;
	        item = angular.element(item);
	        if (item.attr('type') == 'custom-date-diff') {
	            var date1ControlName = item.find(' > field[name=DATE1]').text();
	            if (self.controlDataFieldNames.indexOf(date1ControlName) == -1) {
	                item.find(' > field[name=DATE1]').text('');
	            }
	            var date2ControlName = item.find(' > field[name=DATE2]').text();
	            if (self.controlDataFieldNames.indexOf(date2ControlName) == -1) {
	                item.find(' > field[name=DATE2]').text('');
	            }
	        }
	        else {
	            var controlName = item.find(' > field[name=CONTROL_NAME]').text();
	            if (self.controlDataFieldNames.indexOf(controlName) == -1) {
	                item.find(' > field[name=CONTROL_NAME]').text('');
	                item.find(' > field[name=PROPERTY_VALUE]').text('');
	            }
	        }
	    };
	    BlocklyComponent.prototype.setGlobleMethods = function () {
	        var self = this;
	        self.globleMethods = [];
	        if (self.globleCodeEditor || !Blockly || !window['globle'] || !window['globle'].xmlVal) {
	            return;
	        }
	        var xmlVal = Blockly.Xml.textToDom(window['globle'].xmlVal);
	        if (!xmlVal) {
	            return;
	        }
	        angular.element(xmlVal).children().each(function (ind, child) {
	            var $child = angular.element(child);
	            var $type = $child.attr('type');
	            if ($type && ($type == 'procedures_defnoreturn' || $type == 'procedures_defreturn') && (self.allCustomBlocks.indexOf($type) == -1)) {
	                var methodName = $child.find(' > field').text();
	                if (methodName) {
	                    self.setGlobleMethodDefination(methodName, $type);
	                    self.globleMethods.push('fn_' + methodName);
	                }
	            }
	        });
	    };
	    BlocklyComponent.prototype.setGlobleMethodDefination = function (methodName, type) {
	        if (type === void 0) { type = 'procedures_defnoreturn'; }
	        if (!methodName || this.globleMethods.indexOf('fn_' + methodName) != -1) {
	            return;
	        }
	        Blockly.Blocks['fn_' + methodName] = {
	            init: function () {
	                this.appendDummyInput().appendField(new Blockly.FieldLabelSerializable(methodName), "NAME");
	                if (type == 'procedures_defnoreturn') {
	                    this.setNextStatement(true, null);
	                    this.setPreviousStatement(true, null);
	                }
	                else {
	                    this.setOutput(true, null);
	                }
	                this.setColour(Blockly.Msg.PROCEDURES_HUE);
	                this.setTooltip(Blockly.Msg.PROCEDURES_CALLNORETURN_TOOLTIP.replace('%1', methodName));
	                this.setHelpUrl("");
	            }
	        };
	        Blockly['JavaScript']['fn_' + methodName] = function (block) {
	            var code = block.inputList[0].fieldRow[0].getValue().replace(/ /g, '_');
	            return ' window.globleMethod(' + code + ' && ' + code + '()); \n';
	        };
	    };
	    BlocklyComponent.prototype.getVal = function (alertError) {
	        var self = this;
	        if (!self.codeEditor) {
	            return;
	        }
	        try {
	            var xmlDom_1 = Blockly.Xml.workspaceToDom(self.codeEditor);
	            var systemFields_1 = [];
	            var autoNumberFieldDetail_1 = {};
	            if (xmlDom_1) {
	                var elSPValueComparator = angular.element(xmlDom_1).find('block[type=sp_value_comparator]');
	                elSPValueComparator.each(function (ind, ele) {
	                    var name = angular.element(ele).find('field[name=SP_NAME]').text();
	                    systemFields_1.push(name);
	                });
	                var elSPValueGetter = angular.element(xmlDom_1).find('block[type=sp_value_getter]');
	                elSPValueGetter.each(function (ind, ele) {
	                    var name = angular.element(ele).find('field[name=SP_NAME]').text();
	                    systemFields_1.push(name);
	                });
	                var CustomBlockName = angular.element(xmlDom_1).find('block[type=auto_next_number_block]');
	                if (CustomBlockName.length) {
	                    CustomBlockName.each(function (index, block) {
	                        self.handleAutoNumberingBlock(xmlDom_1, block, autoNumberFieldDetail_1);
	                    });
	                }
	                else {
	                    self.handleAutoNumberingBlock(xmlDom_1, CustomBlockName, autoNumberFieldDetail_1);
	                }
	                // push userDetails field 
	                var userDetailsField = angular.element(xmlDom_1).find('block[type="sp_user_details_getter"]');
	                userDetailsField.length && systemFields_1.push('DS_USERDETAILS_FILTERED');
	                var isAPIInProgress = false;
	                if (Blockly.mainWorkspace && Blockly.mainWorkspace['topBlocks_'] && Blockly.mainWorkspace['topBlocks_'].length) {
	                    Blockly.mainWorkspace['topBlocks_'].forEach(function (e) {
	                        if (e.type == 'set_api_data') {
	                            isAPIInProgress = Blockly.mainWorkspace['isAPIInProgress'];
	                        }
	                    });
	                }
	            }
	            return {
	                scriptVal: Blockly['JavaScript'].workspaceToCode(self.codeEditor),
	                xmlVal: Blockly.Xml.domToText(xmlDom_1),
	                systemFields: systemFields_1,
	                autoNumberFieldDetail: autoNumberFieldDetail_1,
	                isAPIInProgress: isAPIInProgress
	            };
	        }
	        catch (e) {
	            if (alertError) {
	                self.showEditorError();
	            }
	            return {
	                scriptVal: '',
	                xmlVal: '',
	                systemFields: [],
	                autoNumberFieldDetail: {},
	                isAPIInProgress: false
	            };
	        }
	    };
	    BlocklyComponent.prototype.handleAutoNumberingBlock = function (xmlDom, block, autoNumberFieldDetail) {
	        var self = this;
	        try {
	            var blockName = void 0;
	            var autoNumberBlock = angular.element(block);
	            var isBlockInsideFunctionAndDisabled = self.isAutoNumberBlockDisabledAndInsideFunction(autoNumberBlock);
	            // Checking for the disabled autonumbering
	            isBlockInsideFunctionAndDisabled || autoNumberBlock.attr('disabled') || autoNumberBlock.length == 0 ? blockName = 'block[type=auto_next_number_suffix_block]' : blockName = 'block[type=auto_next_number_block]';
	            var elAutoNumber = angular.element(xmlDom).find(blockName);
	            elAutoNumber.length && elAutoNumber.each(function (ind, element) {
	                var isBlockDisableAndInsideFunc = self.isAutoNumberBlockDisabledAndInsideFunction(angular.element(element));
	                if (isBlockDisableAndInsideFunc || angular.element(element).attr('disabled')) {
	                    return;
	                }
	                var fieldName = angular.element(element).find('field[name=AUTO_NUMBER_FIELD]').eq(0).text();
	                var computedFieldNames = [];
	                angular.element(element).find('field[name=CONTROL_NAME]').each(function (ind, fieldNameControl) {
	                    var name = angular.element(fieldNameControl).text();
	                    name && computedFieldNames.push(name);
	                });
	                autoNumberFieldDetail[fieldName] = {
	                    fieldName: fieldName,
	                    numberLength: parseInt(angular.element(element).find('field[name=AUTO_NUMBER_LENGTH]').text()) || 3,
	                    startFrom: parseInt(angular.element(element).find('field[name=AUTO_NUMBER_START_FROM]').text()) - 1 || 0,
	                    autoNumberPosition: angular.element(element).find('field[name=AUTO_NUMBER_POSITION]').text() || 'POSTFIX',
	                    autoNumberStringCheck: angular.element(element).find('field[name=AUTO_NUMBER_STRINGCHECK]').text() || 'YES',
	                    autoNumberSeparator: angular.element(element).find('field[name=AUTO_NUMBER_SEPARATOR]').text() || '-',
	                    autoNumberComputedFieldName: computedFieldNames,
	                };
	            });
	        }
	        catch (err) {
	            self.showEditorError();
	        }
	    };
	    BlocklyComponent.prototype.isAutoNumberBlockDisabledAndInsideFunction = function (block) {
	        var isBlockDisableInsideFn = block.closest('block[type="procedures_defnoreturn"][disabled="true"]') || block.closest('block[type="procedures_defreturn"][disabled="true"]'); // checking for the disabled function which contains the autonumbering
	        if (isBlockDisableInsideFn.length) {
	            return true;
	        }
	        return false;
	    };
	    BlocklyComponent.prototype.showEditorError = function () {
	        var self = this;
	        self.ngNotification.error({
	            message: "Please enter a valid script code.",
	            positionX: 'center',
	            replaceMessage: true
	        });
	    };
	    BlocklyComponent.prototype.resizeHandler = function () {
	        var self = this;
	        if (!self.codeEditor) {
	            return;
	        }
	        var height = (self.maximized) ? window.innerHeight - 180 : Math.max(500, window.innerHeight) - 180;
	        var margin = (self.maximized) ? 0 : (window.innerWidth <= 768) ? 10 : 30;
	        self.$element.find('#codeEditorWindow').css('height', (height - (margin * 2)) + 'px');
	        Blockly.svgResize(self.codeEditor);
	    };
	    BlocklyComponent.prototype.getGlobleMethodsDetail = function () {
	        var self = this;
	        var globleMethodDetails = {};
	        if (!Blockly || !window['globle'] || !window['globle'].xmlVal) {
	            return globleMethodDetails;
	        }
	        var xmlVal = Blockly.Xml.textToDom(window['globle'].xmlVal);
	        if (!xmlVal) {
	            return globleMethodDetails;
	        }
	        angular.element(xmlVal).children().each(function (ind, child) {
	            var $child = angular.element(child);
	            var $type = $child.attr('type');
	            if ($type && ($type == 'procedures_defnoreturn' || $type == 'procedures_defreturn') && (self.allCustomBlocks.indexOf($type) == -1)) {
	                var methodName = $child.find(' > field').text();
	                globleMethodDetails[$child.attr('id')] = methodName;
	            }
	        });
	        return globleMethodDetails;
	    };
	    /**
	     * @brief      Destroy existing code editer intanceview.
	     *
	     * @return     null
	     */
	    BlocklyComponent.prototype.destroyCodeEditor = function () {
	        var self = this;
	        if (!self.codeEditor) {
	            return;
	        }
	        self.codeEditor.clear();
	        window['codeEditor'] = undefined;
	        self.codeEditor = undefined;
	        self.codeEditorVal = undefined;
	        angular.element(window).off('resize.blocklyeditor');
	    };
	    return BlocklyComponent;
	}());
	exports.BlocklyComponent = BlocklyComponent;
	exports.convertXMLStringToNode = function (xmlVal) {
	    return Blockly.Xml.textToDom(xmlVal);
	};
	exports.getAllValueSetterControlName = function (xmlVal) {
	    if (!xmlVal) {
	        return [];
	    }
	    var xmlNode = Blockly.Xml.textToDom(xmlVal);
	    var valueBlocks = [];
	    var setterBlocks = angular.element(xmlNode).find('block[type="custom-property-setter"]');
	    setterBlocks.each(function (ind, setterBlock) {
	        if (angular.element(setterBlock).find('field[name=PROPERTY_NAME]').text() == 'value') {
	            valueBlocks.push(angular.element(setterBlock).find('field[name=CONTROL_NAME]').text());
	        }
	    });
	    return valueBlocks;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('directives.asiteBlockly', []).component('asiteBlockly', {
	    template: __webpack_require__(114),
	    controller: BlocklyComponent,
	    bindings: {
	        globleCodeEditor: '<',
	        maximized: '<'
	    }
	}).name;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* eslint-disable */
	;(function(root, factory) {
	  if (true) { // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(27)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') { // Node.js
	    module.exports = factory(require('./node'));
	  } else { // Browser
	    root.Blockly = factory(root.Blockly);
	  }
	}(this, function(Blockly) {
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 * SPDX-License-Identifier: Apache-2.0
	 */
	
	/**
	 * @fileoverview Blockly module.
	 */
	
	/* eslint-disable */
	'use strict';
	return Blockly;
	})); 


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* eslint-disable */
	;(function(root, factory) {
	  if (true) { // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(28), __webpack_require__(31), __webpack_require__(32), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') { // Node.js
	    module.exports = factory(require('./core-browser'), require('./msg/en'), require('./blocks'), require('./javascript'));
	  } else { // Browser
	    root.Blockly = factory(root.Blockly, root.En, root.BlocklyBlocks, root.BlocklyJS);
	  }
	}(this, function(Blockly, En, BlocklyBlocks, BlocklyJS) {
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 * SPDX-License-Identifier: Apache-2.0
	 */
	
	/**
	 * @fileoverview Blockly module for the browser. This includes Blockly core
	 * and built in blocks, the JavaScript code generator and the English block
	 * localization files.
	 */
	
	/* eslint-disable */
	'use strict';
	
	// Include the EN Locale by default.
	Blockly.setLocale(En);
	
	Blockly.Blocks = Blockly.Blocks || {};
	Object.keys(BlocklyBlocks).forEach(function (k) {
	  Blockly.Blocks[k] = BlocklyBlocks[k];
	});
	
	Blockly.JavaScript = BlocklyJS;
	return Blockly;
	})); 


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* eslint-disable */
	;(function(root, factory) {
	  if (true) { // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(29)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') { // Node.js
	    module.exports = factory(require('./blockly'));
	  } else { // Browser
	    root.Blockly = factory(root.Blockly);
	  }
	}(this, function(Blockly) {
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 * SPDX-License-Identifier: Apache-2.0
	 */
	
	/**
	 * @fileoverview Blockly core module for the browser. It includes blockly.js
	 *               and adds a helper method for setting the locale.
	 */
	
	/* eslint-disable */
	'use strict';
	
	// Add a helper method to set the Blockly locale.
	Blockly.setLocale = function (locale) {
	  Blockly.Msg = Blockly.Msg || {};
	  Object.keys(locale).forEach(function (k) {
	    Blockly.Msg[k] = locale[k];
	  });
	};
	
	return Blockly;
	})); 


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* eslint-disable */
	;(function(root, factory) {
	  if (true) { // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') { // Node.js
	    module.exports = factory(require('./blockly_compressed'));
	  } else { // Browser
	    root.Blockly = factory(root.Blockly);
	  }
	}(this, function(Blockly) {
	/**
	 * @license
	 * Copyright 2020 Google LLC
	 * SPDX-License-Identifier: Apache-2.0
	 */
	
	/**
	 * @fileoverview Blockly module.
	 */
	
	/* eslint-disable */
	'use strict';
	
	return Blockly;
	})); 


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {// Do not edit this file; automatically generated by gulp.
	
	/* eslint-disable */
	;(function(root, factory) {
	  if (true) { // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') { // Node.js
	    module.exports = factory();
	  } else { // Browser
	    root.Blockly = factory();
	  }
	}(this, function() {
	  'use strict';var Blockly={constants:{},LINE_MODE_MULTIPLIER:40,PAGE_MODE_MULTIPLIER:125,DRAG_RADIUS:5,FLYOUT_DRAG_RADIUS:10,SNAP_RADIUS:28};Blockly.CONNECTING_SNAP_RADIUS=Blockly.SNAP_RADIUS;Blockly.CURRENT_CONNECTION_PREFERENCE=8;Blockly.BUMP_DELAY=250;Blockly.BUMP_RANDOMNESS=10;Blockly.COLLAPSE_CHARS=30;Blockly.LONGPRESS=750;Blockly.SOUND_LIMIT=100;Blockly.DRAG_STACK=!0;Blockly.HSV_SATURATION=.45;Blockly.HSV_VALUE=.65;Blockly.SPRITE={width:96,height:124,url:"sprites.png"};Blockly.INPUT_VALUE=1;
	Blockly.OUTPUT_VALUE=2;Blockly.NEXT_STATEMENT=3;Blockly.PREVIOUS_STATEMENT=4;Blockly.DUMMY_INPUT=5;Blockly.ALIGN_LEFT=-1;Blockly.ALIGN_CENTRE=0;Blockly.ALIGN_RIGHT=1;Blockly.DRAG_NONE=0;Blockly.DRAG_STICKY=1;Blockly.DRAG_BEGIN=1;Blockly.DRAG_FREE=2;Blockly.OPPOSITE_TYPE=[];Blockly.OPPOSITE_TYPE[Blockly.INPUT_VALUE]=Blockly.OUTPUT_VALUE;Blockly.OPPOSITE_TYPE[Blockly.OUTPUT_VALUE]=Blockly.INPUT_VALUE;Blockly.OPPOSITE_TYPE[Blockly.NEXT_STATEMENT]=Blockly.PREVIOUS_STATEMENT;
	Blockly.OPPOSITE_TYPE[Blockly.PREVIOUS_STATEMENT]=Blockly.NEXT_STATEMENT;Blockly.TOOLBOX_AT_TOP=0;Blockly.TOOLBOX_AT_BOTTOM=1;Blockly.TOOLBOX_AT_LEFT=2;Blockly.TOOLBOX_AT_RIGHT=3;Blockly.DELETE_AREA_NONE=null;Blockly.DELETE_AREA_TRASH=1;Blockly.DELETE_AREA_TOOLBOX=2;Blockly.VARIABLE_CATEGORY_NAME="VARIABLE";Blockly.VARIABLE_DYNAMIC_CATEGORY_NAME="VARIABLE_DYNAMIC";Blockly.PROCEDURE_CATEGORY_NAME="PROCEDURE";Blockly.RENAME_VARIABLE_ID="RENAME_VARIABLE_ID";Blockly.DELETE_VARIABLE_ID="DELETE_VARIABLE_ID";Blockly.utils={};Blockly.utils.global=function(){return"object"===typeof self?self:"object"===typeof window?window:"object"===typeof global?global:this}();Blockly.Msg={};Blockly.utils.global.Blockly||(Blockly.utils.global.Blockly={});Blockly.utils.global.Blockly.Msg||(Blockly.utils.global.Blockly.Msg=Blockly.Msg);Blockly.utils.colour={};
	Blockly.utils.colour.parse=function(a){a=String(a).toLowerCase().trim();var b=Blockly.utils.colour.names[a];if(b)return b;b="0x"==a.substring(0,2)?"#"+a.substring(2):a;b="#"==b[0]?b:"#"+b;if(/^#[0-9a-f]{6}$/.test(b))return b;if(/^#[0-9a-f]{3}$/.test(b))return["#",b[1],b[1],b[2],b[2],b[3],b[3]].join("");var c=a.match(/^(?:rgb)?\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/);return c&&(a=Number(c[1]),b=Number(c[2]),c=Number(c[3]),0<=a&&256>a&&0<=b&&256>b&&0<=c&&256>c)?Blockly.utils.colour.rgbToHex(a,b,
	c):null};Blockly.utils.colour.rgbToHex=function(a,b,c){b=a<<16|b<<8|c;return 16>a?"#"+(16777216|b).toString(16).substr(1):"#"+b.toString(16)};Blockly.utils.colour.hexToRgb=function(a){a=Blockly.utils.colour.parse(a);if(!a)return[0,0,0];a=parseInt(a.substr(1),16);return[a>>16,a>>8&255,a&255]};
	Blockly.utils.colour.hsvToHex=function(a,b,c){var d=0,e=0,f=0;if(0==b)f=e=d=c;else{var g=Math.floor(a/60),h=a/60-g;a=c*(1-b);var k=c*(1-b*h);b=c*(1-b*(1-h));switch(g){case 1:d=k;e=c;f=a;break;case 2:d=a;e=c;f=b;break;case 3:d=a;e=k;f=c;break;case 4:d=b;e=a;f=c;break;case 5:d=c;e=a;f=k;break;case 6:case 0:d=c,e=b,f=a}}return Blockly.utils.colour.rgbToHex(Math.floor(d),Math.floor(e),Math.floor(f))};
	Blockly.utils.colour.blend=function(a,b,c){a=Blockly.utils.colour.parse(a);if(!a)return null;b=Blockly.utils.colour.parse(b);if(!b)return null;a=Blockly.utils.colour.hexToRgb(a);b=Blockly.utils.colour.hexToRgb(b);return Blockly.utils.colour.rgbToHex(Math.round(b[0]+c*(a[0]-b[0])),Math.round(b[1]+c*(a[1]-b[1])),Math.round(b[2]+c*(a[2]-b[2])))};
	Blockly.utils.colour.names={aqua:"#00ffff",black:"#000000",blue:"#0000ff",fuchsia:"#ff00ff",gray:"#808080",green:"#008000",lime:"#00ff00",maroon:"#800000",navy:"#000080",olive:"#808000",purple:"#800080",red:"#ff0000",silver:"#c0c0c0",teal:"#008080",white:"#ffffff",yellow:"#ffff00"};Blockly.utils.Coordinate=function(a,b){this.x=a;this.y=b};Blockly.utils.Coordinate.equals=function(a,b){return a==b?!0:a&&b?a.x==b.x&&a.y==b.y:!1};Blockly.utils.Coordinate.distance=function(a,b){var c=a.x-b.x;a=a.y-b.y;return Math.sqrt(c*c+a*a)};Blockly.utils.Coordinate.magnitude=function(a){return Math.sqrt(a.x*a.x+a.y*a.y)};Blockly.utils.Coordinate.difference=function(a,b){return new Blockly.utils.Coordinate(a.x-b.x,a.y-b.y)};
	Blockly.utils.Coordinate.sum=function(a,b){return new Blockly.utils.Coordinate(a.x+b.x,a.y+b.y)};Blockly.utils.Coordinate.prototype.scale=function(a){this.x*=a;this.y*=a;return this};Blockly.utils.Coordinate.prototype.translate=function(a,b){this.x+=a;this.y+=b;return this};Blockly.utils.Rect=function(a,b,c,d){this.top=a;this.bottom=b;this.left=c;this.right=d};Blockly.utils.Rect.prototype.contains=function(a,b){return a>=this.left&&a<=this.right&&b>=this.top&&b<=this.bottom};Blockly.utils.string={};Blockly.utils.string.startsWith=function(a,b){return 0==a.lastIndexOf(b,0)};Blockly.utils.string.shortestStringLength=function(a){return a.length?a.reduce(function(a,c){return a.length<c.length?a:c}).length:0};
	Blockly.utils.string.commonWordPrefix=function(a,b){if(!a.length)return 0;if(1==a.length)return a[0].length;var c=0;b=b||Blockly.utils.string.shortestStringLength(a);for(var d=0;d<b;d++){for(var e=a[0][d],f=1;f<a.length;f++)if(e!=a[f][d])return c;" "==e&&(c=d+1)}for(f=1;f<a.length;f++)if((e=a[f][d])&&" "!=e)return c;return b};
	Blockly.utils.string.commonWordSuffix=function(a,b){if(!a.length)return 0;if(1==a.length)return a[0].length;var c=0;b=b||Blockly.utils.string.shortestStringLength(a);for(var d=0;d<b;d++){for(var e=a[0].substr(-d-1,1),f=1;f<a.length;f++)if(e!=a[f].substr(-d-1,1))return c;" "==e&&(c=d+1)}for(f=1;f<a.length;f++)if((e=a[f].charAt(a[f].length-d-1))&&" "!=e)return c;return b};Blockly.utils.string.wrap=function(a,b){a=a.split("\n");for(var c=0;c<a.length;c++)a[c]=Blockly.utils.string.wrapLine_(a[c],b);return a.join("\n")};
	Blockly.utils.string.wrapLine_=function(a,b){if(a.length<=b)return a;for(var c=a.trim().split(/\s+/),d=0;d<c.length;d++)c[d].length>b&&(b=c[d].length);d=-Infinity;var e=1;do{var f=d;var g=a;a=[];var h=c.length/e,k=1;for(d=0;d<c.length-1;d++)k<(d+1.5)/h?(k++,a[d]=!0):a[d]=!1;a=Blockly.utils.string.wrapMutate_(c,a,b);d=Blockly.utils.string.wrapScore_(c,a,b);a=Blockly.utils.string.wrapToText_(c,a);e++}while(d>f);return g};
	Blockly.utils.string.wrapScore_=function(a,b,c){for(var d=[0],e=[],f=0;f<a.length;f++)d[d.length-1]+=a[f].length,!0===b[f]?(d.push(0),e.push(a[f].charAt(a[f].length-1))):!1===b[f]&&d[d.length-1]++;a=Math.max.apply(Math,d);for(f=b=0;f<d.length;f++)b-=2*Math.pow(Math.abs(c-d[f]),1.5),b-=Math.pow(a-d[f],1.5),-1!=".?!".indexOf(e[f])?b+=c/3:-1!=",;)]}".indexOf(e[f])&&(b+=c/4);1<d.length&&d[d.length-1]<=d[d.length-2]&&(b+=.5);return b};
	Blockly.utils.string.wrapMutate_=function(a,b,c){for(var d=Blockly.utils.string.wrapScore_(a,b,c),e,f=0;f<b.length-1;f++)if(b[f]!=b[f+1]){var g=[].concat(b);g[f]=!g[f];g[f+1]=!g[f+1];var h=Blockly.utils.string.wrapScore_(a,g,c);h>d&&(d=h,e=g)}return e?Blockly.utils.string.wrapMutate_(a,e,c):b};Blockly.utils.string.wrapToText_=function(a,b){for(var c=[],d=0;d<a.length;d++)c.push(a[d]),void 0!==b[d]&&c.push(b[d]?"\n":" ");return c.join("")};Blockly.utils.Size=function(a,b){this.width=a;this.height=b};Blockly.utils.Size.equals=function(a,b){return a==b?!0:a&&b?a.width==b.width&&a.height==b.height:!1};Blockly.utils.style={};Blockly.utils.style.getSize=function(a){if("none"!=Blockly.utils.style.getStyle_(a,"display"))return Blockly.utils.style.getSizeWithDisplay_(a);var b=a.style,c=b.display,d=b.visibility,e=b.position;b.visibility="hidden";b.position="absolute";b.display="inline";var f=a.offsetWidth;a=a.offsetHeight;b.display=c;b.position=e;b.visibility=d;return new Blockly.utils.Size(f,a)};Blockly.utils.style.getSizeWithDisplay_=function(a){return new Blockly.utils.Size(a.offsetWidth,a.offsetHeight)};
	Blockly.utils.style.getStyle_=function(a,b){return Blockly.utils.style.getComputedStyle(a,b)||Blockly.utils.style.getCascadedStyle(a,b)||a.style&&a.style[b]};Blockly.utils.style.getComputedStyle=function(a,b){return document.defaultView&&document.defaultView.getComputedStyle&&(a=document.defaultView.getComputedStyle(a,null))?a[b]||a.getPropertyValue(b)||"":""};Blockly.utils.style.getCascadedStyle=function(a,b){return a.currentStyle?a.currentStyle[b]:null};
	Blockly.utils.style.getPageOffset=function(a){var b=new Blockly.utils.Coordinate(0,0);a=a.getBoundingClientRect();var c=document.documentElement;c=new Blockly.utils.Coordinate(window.pageXOffset||c.scrollLeft,window.pageYOffset||c.scrollTop);b.x=a.left+c.x;b.y=a.top+c.y;return b};Blockly.utils.style.getViewportPageOffset=function(){var a=document.body,b=document.documentElement;return new Blockly.utils.Coordinate(a.scrollLeft||b.scrollLeft,a.scrollTop||b.scrollTop)};
	Blockly.utils.style.setElementShown=function(a,b){a.style.display=b?"":"none"};Blockly.utils.style.isRightToLeft=function(a){return"rtl"==Blockly.utils.style.getStyle_(a,"direction")};
	Blockly.utils.style.getBorderBox=function(a){var b=Blockly.utils.style.getComputedStyle(a,"borderLeftWidth"),c=Blockly.utils.style.getComputedStyle(a,"borderRightWidth"),d=Blockly.utils.style.getComputedStyle(a,"borderTopWidth");a=Blockly.utils.style.getComputedStyle(a,"borderBottomWidth");return{top:parseFloat(d),right:parseFloat(c),bottom:parseFloat(a),left:parseFloat(b)}};
	Blockly.utils.style.scrollIntoContainerView=function(a,b,c){a=Blockly.utils.style.getContainerOffsetToScrollInto(a,b,c);b.scrollLeft=a.x;b.scrollTop=a.y};
	Blockly.utils.style.getContainerOffsetToScrollInto=function(a,b,c){var d=Blockly.utils.style.getPageOffset(a),e=Blockly.utils.style.getPageOffset(b),f=Blockly.utils.style.getBorderBox(b),g=d.x-e.x-f.left;d=d.y-e.y-f.top;e=Blockly.utils.style.getSizeWithDisplay_(a);a=b.clientWidth-e.width;e=b.clientHeight-e.height;f=b.scrollLeft;b=b.scrollTop;c?(f+=g-a/2,b+=d-e/2):(f+=Math.min(g,Math.max(g-a,0)),b+=Math.min(d,Math.max(d-e,0)));return new Blockly.utils.Coordinate(f,b)};Blockly.utils.userAgent={};
	(function(a){function b(a){return-1!=c.indexOf(a.toUpperCase())}Blockly.utils.userAgent.raw=a;var c=Blockly.utils.userAgent.raw.toUpperCase();Blockly.utils.userAgent.IE=b("Trident")||b("MSIE");Blockly.utils.userAgent.EDGE=b("Edge");Blockly.utils.userAgent.JAVA_FX=b("JavaFX");Blockly.utils.userAgent.CHROME=(b("Chrome")||b("CriOS"))&&!Blockly.utils.userAgent.EDGE;Blockly.utils.userAgent.WEBKIT=b("WebKit")&&!Blockly.utils.userAgent.EDGE;Blockly.utils.userAgent.GECKO=b("Gecko")&&!Blockly.utils.userAgent.WEBKIT&&
	!Blockly.utils.userAgent.IE&&!Blockly.utils.userAgent.EDGE;Blockly.utils.userAgent.ANDROID=b("Android");Blockly.utils.userAgent.IPAD=b("iPad");Blockly.utils.userAgent.IPOD=b("iPod");Blockly.utils.userAgent.IPHONE=b("iPhone")&&!Blockly.utils.userAgent.IPAD&&!Blockly.utils.userAgent.IPOD;Blockly.utils.userAgent.MAC=b("Macintosh");Blockly.utils.userAgent.TABLET=Blockly.utils.userAgent.IPAD||Blockly.utils.userAgent.ANDROID&&!b("Mobile")||b("Silk");Blockly.utils.userAgent.MOBILE=!Blockly.utils.userAgent.TABLET&&
	(Blockly.utils.userAgent.IPOD||Blockly.utils.userAgent.IPHONE||Blockly.utils.userAgent.ANDROID||b("IEMobile"))})(Blockly.utils.global.navigator&&Blockly.utils.global.navigator.userAgent||"");Blockly.utils.noEvent=function(a){a.preventDefault();a.stopPropagation()};Blockly.utils.isTargetInput=function(a){return"textarea"==a.target.type||"text"==a.target.type||"number"==a.target.type||"email"==a.target.type||"password"==a.target.type||"search"==a.target.type||"tel"==a.target.type||"url"==a.target.type||a.target.isContentEditable};
	Blockly.utils.getRelativeXY=function(a){var b=new Blockly.utils.Coordinate(0,0),c=a.getAttribute("x");c&&(b.x=parseInt(c,10));if(c=a.getAttribute("y"))b.y=parseInt(c,10);if(c=(c=a.getAttribute("transform"))&&c.match(Blockly.utils.getRelativeXY.XY_REGEX_))b.x+=Number(c[1]),c[3]&&(b.y+=Number(c[3]));(a=a.getAttribute("style"))&&-1<a.indexOf("translate")&&(a=a.match(Blockly.utils.getRelativeXY.XY_STYLE_REGEX_))&&(b.x+=Number(a[1]),a[3]&&(b.y+=Number(a[3])));return b};
	Blockly.utils.getInjectionDivXY_=function(a){for(var b=0,c=0;a;){var d=Blockly.utils.getRelativeXY(a);b+=d.x;c+=d.y;if(-1!=(" "+(a.getAttribute("class")||"")+" ").indexOf(" injectionDiv "))break;a=a.parentNode}return new Blockly.utils.Coordinate(b,c)};Blockly.utils.getRelativeXY.XY_REGEX_=/translate\(\s*([-+\d.e]+)([ ,]\s*([-+\d.e]+)\s*)?/;Blockly.utils.getRelativeXY.XY_STYLE_REGEX_=/transform:\s*translate(?:3d)?\(\s*([-+\d.e]+)\s*px([ ,]\s*([-+\d.e]+)\s*px)?/;
	Blockly.utils.isRightButton=function(a){return a.ctrlKey&&Blockly.utils.userAgent.MAC?!0:2==a.button};Blockly.utils.mouseToSvg=function(a,b,c){var d=b.createSVGPoint();d.x=a.clientX;d.y=a.clientY;c||(c=b.getScreenCTM().inverse());return d.matrixTransform(c)};
	Blockly.utils.getScrollDeltaPixels=function(a){switch(a.deltaMode){default:return{x:a.deltaX,y:a.deltaY};case 1:return{x:a.deltaX*Blockly.LINE_MODE_MULTIPLIER,y:a.deltaY*Blockly.LINE_MODE_MULTIPLIER};case 2:return{x:a.deltaX*Blockly.PAGE_MODE_MULTIPLIER,y:a.deltaY*Blockly.PAGE_MODE_MULTIPLIER}}};Blockly.utils.tokenizeInterpolation=function(a){return Blockly.utils.tokenizeInterpolation_(a,!0)};
	Blockly.utils.replaceMessageReferences=function(a){if("string"!=typeof a)return a;a=Blockly.utils.tokenizeInterpolation_(a,!1);return a.length?String(a[0]):""};Blockly.utils.checkMessageReferences=function(a){for(var b=!0,c=Blockly.Msg,d=a.match(/%{BKY_[A-Z]\w*}/ig),e=0;e<d.length;e++){var f=d[e].toUpperCase();void 0==c[f.slice(6,-1)]&&(console.log("WARNING: No message string for "+d[e]+" in "+a),b=!1)}return b};
	Blockly.utils.tokenizeInterpolation_=function(a,b){var c=[],d=a.split("");d.push("");var e=0;a=[];for(var f=null,g=0;g<d.length;g++){var h=d[g];0==e?"%"==h?((h=a.join(""))&&c.push(h),a.length=0,e=1):a.push(h):1==e?"%"==h?(a.push(h),e=0):b&&"0"<=h&&"9">=h?(e=2,f=h,(h=a.join(""))&&c.push(h),a.length=0):"{"==h?e=3:(a.push("%",h),e=0):2==e?"0"<=h&&"9">=h?f+=h:(c.push(parseInt(f,10)),g--,e=0):3==e&&(""==h?(a.splice(0,0,"%{"),g--,e=0):"}"!=h?a.push(h):(e=a.join(""),/[A-Z]\w*/i.test(e)?(h=e.toUpperCase(),
	(h=Blockly.utils.string.startsWith(h,"BKY_")?h.substring(4):null)&&h in Blockly.Msg?(e=Blockly.Msg[h],"string"==typeof e?Array.prototype.push.apply(c,Blockly.utils.tokenizeInterpolation_(e,b)):b?c.push(String(e)):c.push(e)):c.push("%{"+e+"}")):c.push("%{"+e+"}"),e=a.length=0))}(h=a.join(""))&&c.push(h);b=[];for(g=a.length=0;g<c.length;++g)"string"==typeof c[g]?a.push(c[g]):((h=a.join(""))&&b.push(h),a.length=0,b.push(c[g]));(h=a.join(""))&&b.push(h);a.length=0;return b};
	Blockly.utils.genUid=function(){for(var a=Blockly.utils.genUid.soup_.length,b=[],c=0;20>c;c++)b[c]=Blockly.utils.genUid.soup_.charAt(Math.random()*a);return b.join("")};Blockly.utils.genUid.soup_="!#$%()*+,-./:;=?@[]^_`{|}~ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	Blockly.utils.is3dSupported=function(){if(void 0!==Blockly.utils.is3dSupported.cached_)return Blockly.utils.is3dSupported.cached_;if(!Blockly.utils.global.getComputedStyle)return!1;var a=document.createElement("p"),b="none",c={webkitTransform:"-webkit-transform",OTransform:"-o-transform",msTransform:"-ms-transform",MozTransform:"-moz-transform",transform:"transform"};document.body.insertBefore(a,null);for(var d in c)if(void 0!==a.style[d]){a.style[d]="translate3d(1px,1px,1px)";b=Blockly.utils.global.getComputedStyle(a);
	if(!b)return document.body.removeChild(a),!1;b=b.getPropertyValue(c[d])}document.body.removeChild(a);Blockly.utils.is3dSupported.cached_="none"!==b;return Blockly.utils.is3dSupported.cached_};Blockly.utils.runAfterPageLoad=function(a){if("object"!=typeof document)throw Error("Blockly.utils.runAfterPageLoad() requires browser document.");if("complete"==document.readyState)a();else var b=setInterval(function(){"complete"==document.readyState&&(clearInterval(b),a())},10)};
	Blockly.utils.getViewportBBox=function(){var a=Blockly.utils.style.getViewportPageOffset();return new Blockly.utils.Rect(a.y,document.documentElement.clientHeight+a.y,a.x,document.documentElement.clientWidth+a.x)};Blockly.utils.arrayRemove=function(a,b){b=a.indexOf(b);if(-1==b)return!1;a.splice(b,1);return!0};
	Blockly.utils.getDocumentScroll=function(){var a=document.documentElement,b=window;return Blockly.utils.userAgent.IE&&b.pageYOffset!=a.scrollTop?new Blockly.utils.Coordinate(a.scrollLeft,a.scrollTop):new Blockly.utils.Coordinate(b.pageXOffset||a.scrollLeft,b.pageYOffset||a.scrollTop)};Blockly.utils.getBlockTypeCounts=function(a,b){var c=Object.create(null),d=a.getDescendants(!0);b&&(a=a.getNextBlock())&&(a=d.indexOf(a),d.splice(a,d.length-a));for(a=0;b=d[a];a++)c[b.type]?c[b.type]++:c[b.type]=1;return c};
	Blockly.utils.screenToWsCoordinates=function(a,b){var c=b.x;b=b.y;var d=a.getInjectionDiv().getBoundingClientRect();c=new Blockly.utils.Coordinate(c-d.left,b-d.top);b=a.getOriginOffsetInPixels();return Blockly.utils.Coordinate.difference(c,b).scale(1/a.scale)};
	Blockly.utils.parseBlockColour=function(a){var b="string"==typeof a?Blockly.utils.replaceMessageReferences(a):a,c=Number(b);if(!isNaN(c)&&0<=c&&360>=c)return{hue:c,hex:Blockly.utils.colour.hsvToHex(c,Blockly.HSV_SATURATION,255*Blockly.HSV_VALUE)};if(c=Blockly.utils.colour.parse(b))return{hue:null,hex:c};c='Invalid colour: "'+b+'"';a!=b&&(c+=' (from "'+a+'")');throw Error(c);};Blockly.Events={};Blockly.Events.group_="";Blockly.Events.recordUndo=!0;Blockly.Events.disabled_=0;Blockly.Events.CREATE="create";Blockly.Events.BLOCK_CREATE=Blockly.Events.CREATE;Blockly.Events.DELETE="delete";Blockly.Events.BLOCK_DELETE=Blockly.Events.DELETE;Blockly.Events.CHANGE="change";Blockly.Events.BLOCK_CHANGE=Blockly.Events.CHANGE;Blockly.Events.MOVE="move";Blockly.Events.BLOCK_MOVE=Blockly.Events.MOVE;Blockly.Events.VAR_CREATE="var_create";Blockly.Events.VAR_DELETE="var_delete";
	Blockly.Events.VAR_RENAME="var_rename";Blockly.Events.UI="ui";Blockly.Events.COMMENT_CREATE="comment_create";Blockly.Events.COMMENT_DELETE="comment_delete";Blockly.Events.COMMENT_CHANGE="comment_change";Blockly.Events.COMMENT_MOVE="comment_move";Blockly.Events.FINISHED_LOADING="finished_loading";Blockly.Events.BUMP_EVENTS=[Blockly.Events.BLOCK_CREATE,Blockly.Events.BLOCK_MOVE,Blockly.Events.COMMENT_CREATE,Blockly.Events.COMMENT_MOVE];Blockly.Events.FIRE_QUEUE_=[];
	Blockly.Events.fire=function(a){Blockly.Events.isEnabled()&&(Blockly.Events.FIRE_QUEUE_.length||setTimeout(Blockly.Events.fireNow_,0),Blockly.Events.FIRE_QUEUE_.push(a))};Blockly.Events.fireNow_=function(){for(var a=Blockly.Events.filter(Blockly.Events.FIRE_QUEUE_,!0),b=Blockly.Events.FIRE_QUEUE_.length=0,c;c=a[b];b++)if(c.workspaceId){var d=Blockly.Workspace.getById(c.workspaceId);d&&d.fireChangeListener(c)}};
	Blockly.Events.filter=function(a,b){a=a.slice();b||a.reverse();for(var c=[],d=Object.create(null),e=0,f;f=a[e];e++)if(!f.isNull()){var g=[f.type,f.blockId,f.workspaceId].join(" "),h=d[g],k=h?h.event:null;if(!h)d[g]={event:f,index:e},c.push(f);else if(f.type==Blockly.Events.MOVE&&h.index==e-1)k.newParentId=f.newParentId,k.newInputName=f.newInputName,k.newCoordinate=f.newCoordinate,h.index=e;else if(f.type==Blockly.Events.CHANGE&&f.element==k.element&&f.name==k.name)k.newValue=f.newValue;else if(f.type!=
	Blockly.Events.UI||"click"!=f.element||"commentOpen"!=k.element&&"mutatorOpen"!=k.element&&"warningOpen"!=k.element)d[g]={event:f,index:1},c.push(f)}a=c.filter(function(a){return!a.isNull()});b||a.reverse();for(e=1;f=a[e];e++)f.type==Blockly.Events.CHANGE&&"mutation"==f.element&&a.unshift(a.splice(e,1)[0]);return a};Blockly.Events.clearPendingUndo=function(){for(var a=0,b;b=Blockly.Events.FIRE_QUEUE_[a];a++)b.recordUndo=!1};Blockly.Events.disable=function(){Blockly.Events.disabled_++};
	Blockly.Events.enable=function(){Blockly.Events.disabled_--};Blockly.Events.isEnabled=function(){return 0==Blockly.Events.disabled_};Blockly.Events.getGroup=function(){return Blockly.Events.group_};Blockly.Events.setGroup=function(a){Blockly.Events.group_="boolean"==typeof a?a?Blockly.utils.genUid():"":a};Blockly.Events.getDescendantIds=function(a){var b=[];a=a.getDescendants(!1);for(var c=0,d;d=a[c];c++)b[c]=d.id;return b};
	Blockly.Events.fromJson=function(a,b){switch(a.type){case Blockly.Events.CREATE:var c=new Blockly.Events.Create(null);break;case Blockly.Events.DELETE:c=new Blockly.Events.Delete(null);break;case Blockly.Events.CHANGE:c=new Blockly.Events.Change(null,"","","","");break;case Blockly.Events.MOVE:c=new Blockly.Events.Move(null);break;case Blockly.Events.VAR_CREATE:c=new Blockly.Events.VarCreate(null);break;case Blockly.Events.VAR_DELETE:c=new Blockly.Events.VarDelete(null);break;case Blockly.Events.VAR_RENAME:c=
	new Blockly.Events.VarRename(null,"");break;case Blockly.Events.UI:c=new Blockly.Events.Ui(null,"","","");break;case Blockly.Events.COMMENT_CREATE:c=new Blockly.Events.CommentCreate(null);break;case Blockly.Events.COMMENT_CHANGE:c=new Blockly.Events.CommentChange(null,"","");break;case Blockly.Events.COMMENT_MOVE:c=new Blockly.Events.CommentMove(null);break;case Blockly.Events.COMMENT_DELETE:c=new Blockly.Events.CommentDelete(null);break;case Blockly.Events.FINISHED_LOADING:c=new Blockly.Events.FinishedLoading(b);
	break;default:throw Error("Unknown event type.");}c.fromJson(a);c.workspaceId=b.id;return c};
	Blockly.Events.disableOrphans=function(a){if((a.type==Blockly.Events.MOVE||a.type==Blockly.Events.CREATE)&&a.workspaceId){var b=Blockly.Workspace.getById(a.workspaceId);if(a=b.getBlockById(a.blockId)){var c=a.getParent();if(c&&c.isEnabled())for(b=a.getDescendants(!1),a=0;c=b[a];a++)c.setEnabled(!0);else if((a.outputConnection||a.previousConnection)&&!b.isDragging()){do a.setEnabled(!1),a=a.getNextBlock();while(a)}}}};Blockly.Events.Abstract=function(){this.workspaceId=void 0;this.group=Blockly.Events.getGroup();this.recordUndo=Blockly.Events.recordUndo};Blockly.Events.Abstract.prototype.toJson=function(){var a={type:this.type};this.group&&(a.group=this.group);return a};Blockly.Events.Abstract.prototype.fromJson=function(a){this.group=a.group};Blockly.Events.Abstract.prototype.isNull=function(){return!1};Blockly.Events.Abstract.prototype.run=function(a){};
	Blockly.Events.Abstract.prototype.getEventWorkspace_=function(){if(this.workspaceId)var a=Blockly.Workspace.getById(this.workspaceId);if(!a)throw Error("Workspace is null. Event must have been generated from real Blockly events.");return a};Blockly.utils.object={};Blockly.utils.object.inherits=function(a,b){a.superClass_=b.prototype;a.prototype=Object.create(b.prototype);a.prototype.constructor=a};Blockly.utils.object.mixin=function(a,b){for(var c in b)a[c]=b[c]};Blockly.utils.object.deepMerge=function(a,b){for(var c in b)a[c]=null!=b[c]&&"object"===typeof b[c]?Blockly.utils.object.deepMerge(a[c]||Object.create(null),b[c]):b[c];return a};Blockly.utils.object.values=function(a){return Object.values?Object.values(a):Object.keys(a).map(function(b){return a[b]})};Blockly.Events.Ui=function(a,b,c,d){Blockly.Events.Ui.superClass_.constructor.call(this);this.blockId=a?a.id:null;this.workspaceId=a?a.workspace.id:void 0;this.element=b;this.oldValue=c;this.newValue=d;this.recordUndo=!1};Blockly.utils.object.inherits(Blockly.Events.Ui,Blockly.Events.Abstract);Blockly.Events.Ui.prototype.type=Blockly.Events.UI;
	Blockly.Events.Ui.prototype.toJson=function(){var a=Blockly.Events.Ui.superClass_.toJson.call(this);a.element=this.element;void 0!==this.newValue&&(a.newValue=this.newValue);this.blockId&&(a.blockId=this.blockId);return a};Blockly.Events.Ui.prototype.fromJson=function(a){Blockly.Events.Ui.superClass_.fromJson.call(this,a);this.element=a.element;this.newValue=a.newValue;this.blockId=a.blockId};Blockly.utils.dom={};Blockly.utils.dom.SVG_NS="http://www.w3.org/2000/svg";Blockly.utils.dom.HTML_NS="http://www.w3.org/1999/xhtml";Blockly.utils.dom.XLINK_NS="http://www.w3.org/1999/xlink";Blockly.utils.dom.NodeType={ELEMENT_NODE:1,TEXT_NODE:3,COMMENT_NODE:8,DOCUMENT_POSITION_CONTAINED_BY:16};Blockly.utils.dom.cacheWidths_=null;Blockly.utils.dom.cacheReference_=0;Blockly.utils.dom.canvasContext_=null;
	Blockly.utils.dom.createSvgElement=function(a,b,c){a=document.createElementNS(Blockly.utils.dom.SVG_NS,a);for(var d in b)a.setAttribute(d,b[d]);document.body.runtimeStyle&&(a.runtimeStyle=a.currentStyle=a.style);c&&c.appendChild(a);return a};Blockly.utils.dom.addClass=function(a,b){var c=a.getAttribute("class")||"";if(-1!=(" "+c+" ").indexOf(" "+b+" "))return!1;c&&(c+=" ");a.setAttribute("class",c+b);return!0};
	Blockly.utils.dom.removeClass=function(a,b){var c=a.getAttribute("class");if(-1==(" "+c+" ").indexOf(" "+b+" "))return!1;c=c.split(/\s+/);for(var d=0;d<c.length;d++)c[d]&&c[d]!=b||(c.splice(d,1),d--);c.length?a.setAttribute("class",c.join(" ")):a.removeAttribute("class");return!0};Blockly.utils.dom.hasClass=function(a,b){return-1!=(" "+a.getAttribute("class")+" ").indexOf(" "+b+" ")};Blockly.utils.dom.removeNode=function(a){return a&&a.parentNode?a.parentNode.removeChild(a):null};
	Blockly.utils.dom.insertAfter=function(a,b){var c=b.nextSibling;b=b.parentNode;if(!b)throw Error("Reference node has no parent.");c?b.insertBefore(a,c):b.appendChild(a)};Blockly.utils.dom.containsNode=function(a,b){return!!(a.compareDocumentPosition(b)&Blockly.utils.dom.NodeType.DOCUMENT_POSITION_CONTAINED_BY)};Blockly.utils.dom.setCssTransform=function(a,b){a.style.transform=b;a.style["-webkit-transform"]=b};
	Blockly.utils.dom.startTextWidthCache=function(){Blockly.utils.dom.cacheReference_++;Blockly.utils.dom.cacheWidths_||(Blockly.utils.dom.cacheWidths_={})};Blockly.utils.dom.stopTextWidthCache=function(){Blockly.utils.dom.cacheReference_--;Blockly.utils.dom.cacheReference_||(Blockly.utils.dom.cacheWidths_=null)};
	Blockly.utils.dom.getTextWidth=function(a){var b=a.textContent+"\n"+a.className.baseVal,c;if(Blockly.utils.dom.cacheWidths_&&(c=Blockly.utils.dom.cacheWidths_[b]))return c;try{c=Blockly.utils.userAgent.IE||Blockly.utils.userAgent.EDGE?a.getBBox().width:a.getComputedTextLength()}catch(d){return 8*a.textContent.length}Blockly.utils.dom.cacheWidths_&&(Blockly.utils.dom.cacheWidths_[b]=c);return c};
	Blockly.utils.dom.getFastTextWidth=function(a,b,c,d){return Blockly.utils.dom.getFastTextWidthWithSizeString(a,b+"pt",c,d)};
	Blockly.utils.dom.getFastTextWidthWithSizeString=function(a,b,c,d){var e=a.textContent;a=e+"\n"+a.className.baseVal;var f;if(Blockly.utils.dom.cacheWidths_&&(f=Blockly.utils.dom.cacheWidths_[a]))return f;Blockly.utils.dom.canvasContext_||(f=document.createElement("canvas"),f.className="blocklyComputeCanvas",document.body.appendChild(f),Blockly.utils.dom.canvasContext_=f.getContext("2d"));Blockly.utils.dom.canvasContext_.font=c+" "+b+" "+d;f=Blockly.utils.dom.canvasContext_.measureText(e).width;Blockly.utils.dom.cacheWidths_&&
	(Blockly.utils.dom.cacheWidths_[a]=f);return f};
	Blockly.utils.dom.measureFontMetrics=function(a,b,c,d){var e=document.createElement("span");e.style.font=c+" "+b+" "+d;e.textContent=a;a=document.createElement("div");a.style.width="1px";a.style.height="0px";b=document.createElement("div");b.setAttribute("style","position: fixed; top: 0; left: 0; display: flex;");b.appendChild(e);b.appendChild(a);document.body.appendChild(b);try{c={},b.style.alignItems="baseline",c.baseline=a.offsetTop-e.offsetTop,b.style.alignItems="flex-end",c.height=a.offsetTop-
	e.offsetTop}finally{document.body.removeChild(b)}return c};Blockly.BlockDragSurfaceSvg=function(a){this.container_=a;this.createDom()};Blockly.BlockDragSurfaceSvg.prototype.SVG_=null;Blockly.BlockDragSurfaceSvg.prototype.dragGroup_=null;Blockly.BlockDragSurfaceSvg.prototype.container_=null;Blockly.BlockDragSurfaceSvg.prototype.scale_=1;Blockly.BlockDragSurfaceSvg.prototype.surfaceXY_=null;
	Blockly.BlockDragSurfaceSvg.prototype.createDom=function(){this.SVG_||(this.SVG_=Blockly.utils.dom.createSvgElement("svg",{xmlns:Blockly.utils.dom.SVG_NS,"xmlns:html":Blockly.utils.dom.HTML_NS,"xmlns:xlink":Blockly.utils.dom.XLINK_NS,version:"1.1","class":"blocklyBlockDragSurface"},this.container_),this.dragGroup_=Blockly.utils.dom.createSvgElement("g",{},this.SVG_))};
	Blockly.BlockDragSurfaceSvg.prototype.setBlocksAndShow=function(a){if(this.dragGroup_.childNodes.length)throw Error("Already dragging a block.");this.dragGroup_.appendChild(a);this.SVG_.style.display="block";this.surfaceXY_=new Blockly.utils.Coordinate(0,0)};Blockly.BlockDragSurfaceSvg.prototype.translateAndScaleGroup=function(a,b,c){this.scale_=c;a=a.toFixed(0);b=b.toFixed(0);this.dragGroup_.setAttribute("transform","translate("+a+","+b+") scale("+c+")")};
	Blockly.BlockDragSurfaceSvg.prototype.translateSurfaceInternal_=function(){var a=this.surfaceXY_.x,b=this.surfaceXY_.y;a=a.toFixed(0);b=b.toFixed(0);this.SVG_.style.display="block";Blockly.utils.dom.setCssTransform(this.SVG_,"translate3d("+a+"px, "+b+"px, 0px)")};Blockly.BlockDragSurfaceSvg.prototype.translateSurface=function(a,b){this.surfaceXY_=new Blockly.utils.Coordinate(a*this.scale_,b*this.scale_);this.translateSurfaceInternal_()};
	Blockly.BlockDragSurfaceSvg.prototype.getSurfaceTranslation=function(){var a=Blockly.utils.getRelativeXY(this.SVG_);return new Blockly.utils.Coordinate(a.x/this.scale_,a.y/this.scale_)};Blockly.BlockDragSurfaceSvg.prototype.getGroup=function(){return this.dragGroup_};Blockly.BlockDragSurfaceSvg.prototype.getCurrentBlock=function(){return this.dragGroup_.firstChild};
	Blockly.BlockDragSurfaceSvg.prototype.clearAndHide=function(a){a?a.appendChild(this.getCurrentBlock()):this.dragGroup_.removeChild(this.getCurrentBlock());this.SVG_.style.display="none";if(this.dragGroup_.childNodes.length)throw Error("Drag group was not cleared.");this.surfaceXY_=null};Blockly.utils.IdGenerator={};Blockly.utils.IdGenerator.nextId_=0;Blockly.utils.IdGenerator.getNextUniqueId=function(){return"blockly-"+(Blockly.utils.IdGenerator.nextId_++).toString(36)};Blockly.Component=function(){this.rightToLeft_=Blockly.Component.defaultRightToLeft;this.id_=null;this.inDocument_=!1;this.parent_=this.element_=null;this.children_=[];this.childIndex_={};this.disposed_=!1};Blockly.Component.defaultRightToLeft=!1;Blockly.Component.Error={ALREADY_RENDERED:"Component already rendered",PARENT_UNABLE_TO_BE_SET:"Unable to set parent component",CHILD_INDEX_OUT_OF_BOUNDS:"Child component index out of bounds",ABSTRACT_METHOD:"Unimplemented abstract method"};
	Blockly.Component.prototype.getId=function(){return this.id_||(this.id_=Blockly.utils.IdGenerator.getNextUniqueId())};Blockly.Component.prototype.getElement=function(){return this.element_};Blockly.Component.prototype.setElementInternal=function(a){this.element_=a};
	Blockly.Component.prototype.setParent=function(a){if(this==a)throw Error(Blockly.Component.Error.PARENT_UNABLE_TO_BE_SET);if(a&&this.parent_&&this.id_&&this.parent_.getChild(this.id_)&&this.parent_!=a)throw Error(Blockly.Component.Error.PARENT_UNABLE_TO_BE_SET);this.parent_=a};Blockly.Component.prototype.getParent=function(){return this.parent_};Blockly.Component.prototype.isInDocument=function(){return this.inDocument_};
	Blockly.Component.prototype.createDom=function(){throw Error(Blockly.Component.Error.ABSTRACT_METHOD);};Blockly.Component.prototype.render=function(a){this.render_(a)};Blockly.Component.prototype.render_=function(a,b){if(this.inDocument_)throw Error(Blockly.Component.Error.ALREADY_RENDERED);this.element_||this.createDom();a?a.insertBefore(this.element_,b||null):document.body.appendChild(this.element_);this.parent_&&!this.parent_.isInDocument()||this.enterDocument()};
	Blockly.Component.prototype.enterDocument=function(){this.inDocument_=!0;this.forEachChild(function(a){!a.isInDocument()&&a.getElement()&&a.enterDocument()})};Blockly.Component.prototype.exitDocument=function(){this.forEachChild(function(a){a.isInDocument()&&a.exitDocument()});this.inDocument_=!1};Blockly.Component.prototype.dispose=function(){this.disposed_||(this.disposed_=!0,this.disposeInternal())};
	Blockly.Component.prototype.disposeInternal=function(){this.inDocument_&&this.exitDocument();this.forEachChild(function(a){a.dispose()});this.element_&&Blockly.utils.dom.removeNode(this.element_);this.parent_=this.element_=this.childIndex_=this.children_=null};Blockly.Component.prototype.addChild=function(a,b){this.addChildAt(a,this.getChildCount(),b)};
	Blockly.Component.prototype.addChildAt=function(a,b,c){if(a.inDocument_&&(c||!this.inDocument_))throw Error(Blockly.Component.Error.ALREADY_RENDERED);if(0>b||b>this.getChildCount())throw Error(Blockly.Component.Error.CHILD_INDEX_OUT_OF_BOUNDS);this.childIndex_[a.getId()]=a;if(a.getParent()==this){var d=this.children_.indexOf(a);-1<d&&this.children_.splice(d,1)}a.setParent(this);this.children_.splice(b,0,a);a.inDocument_&&this.inDocument_&&a.getParent()==this?(c=this.getContentElement(),b=c.childNodes[b]||
	null,b!=a.getElement()&&c.insertBefore(a.getElement(),b)):c?(this.element_||this.createDom(),b=this.getChildAt(b+1),a.render_(this.getContentElement(),b?b.element_:null)):this.inDocument_&&!a.inDocument_&&a.element_&&a.element_.parentNode&&a.element_.parentNode.nodeType==Blockly.utils.dom.NodeType.ELEMENT_NODE&&a.enterDocument()};Blockly.Component.prototype.getContentElement=function(){return this.element_};Blockly.Component.prototype.hasChildren=function(){return 0!=this.children_.length};
	Blockly.Component.prototype.getChildCount=function(){return this.children_.length};Blockly.Component.prototype.getChild=function(a){return a?this.childIndex_[a]||null:null};Blockly.Component.prototype.getChildAt=function(a){return this.children_[a]||null};Blockly.Component.prototype.forEachChild=function(a,b){for(var c=0;c<this.children_.length;c++)a.call(b,this.children_[c],c)};Blockly.Css={};Blockly.Css.injected_=!1;Blockly.Css.register=function(a){if(Blockly.Css.injected_)throw Error("CSS already injected");Array.prototype.push.apply(Blockly.Css.CONTENT,a);a.length=0};
	Blockly.Css.inject=function(a,b){if(!Blockly.Css.injected_){Blockly.Css.injected_=!0;var c=Blockly.Css.CONTENT.join("\n");Blockly.Css.CONTENT.length=0;a&&(a=b.replace(/[\\/]$/,""),c=c.replace(/<<<PATH>>>/g,a),a=document.createElement("style"),a.id="blockly-common-style",c=document.createTextNode(c),a.appendChild(c),document.head.insertBefore(a,document.head.firstChild))}};Blockly.Css.setCursor=function(a){console.warn("Deprecated call to Blockly.Css.setCursor. See issue #981 for context")};
	Blockly.Css.CONTENT=[".blocklySvg {","background-color: #fff;","outline: none;","overflow: hidden;","position: absolute;","display: block;","}",".blocklyWidgetDiv {","display: none;","position: absolute;","z-index: 99999;","}",".injectionDiv {","height: 100%;","position: relative;","overflow: hidden;","touch-action: none;","}",".blocklyNonSelectable {","user-select: none;","-ms-user-select: none;","-webkit-user-select: none;","}",".blocklyWsDragSurface {","display: none;","position: absolute;","top: 0;",
	"left: 0;","}",".blocklyWsDragSurface.blocklyOverflowVisible {","overflow: visible;","}",".blocklyBlockDragSurface {","display: none;","position: absolute;","top: 0;","left: 0;","right: 0;","bottom: 0;","overflow: visible !important;","z-index: 50;","}",".blocklyBlockCanvas.blocklyCanvasTransitioning,",".blocklyBubbleCanvas.blocklyCanvasTransitioning {","transition: transform .5s;","}",".blocklyTooltipDiv {","background-color: #ffffc7;","border: 1px solid #ddc;","box-shadow: 4px 4px 20px 1px rgba(0,0,0,.15);",
	"color: #000;","display: none;","font: 9pt sans-serif;","opacity: .9;","padding: 2px;","position: absolute;","z-index: 100000;","}",".blocklyDropDownDiv {","position: absolute;","left: 0;","top: 0;","z-index: 1000;","display: none;","border: 1px solid;","border-color: #dadce0;","background-color: #fff;","border-radius: 2px;","padding: 4px;","box-shadow: 0 0 3px 1px rgba(0,0,0,.3);","}",".blocklyDropDownDiv.blocklyFocused {","box-shadow: 0 0 6px 1px rgba(0,0,0,.3);","}",".blocklyDropDownContent {",
	"max-height: 300px;","overflow: auto;","overflow-x: hidden;","}",".blocklyDropDownArrow {","position: absolute;","left: 0;","top: 0;","width: 16px;","height: 16px;","z-index: -1;","background-color: inherit;","border-color: inherit;","}",".blocklyDropDownButton {","display: inline-block;","float: left;","padding: 0;","margin: 4px;","border-radius: 4px;","outline: none;","border: 1px solid;","transition: box-shadow .1s;","cursor: pointer;","}",".blocklyArrowTop {","border-top: 1px solid;","border-left: 1px solid;",
	"border-top-left-radius: 4px;","border-color: inherit;","}",".blocklyArrowBottom {","border-bottom: 1px solid;","border-right: 1px solid;","border-bottom-right-radius: 4px;","border-color: inherit;","}",".blocklyResizeSE {","cursor: se-resize;","fill: #aaa;","}",".blocklyResizeSW {","cursor: sw-resize;","fill: #aaa;","}",".blocklyResizeLine {","stroke: #515A5A;","stroke-width: 1;","}",".blocklyHighlightedConnectionPath {","fill: none;","stroke: #fc3;","stroke-width: 4px;","}",".blocklyPathLight {",
	"fill: none;","stroke-linecap: round;","stroke-width: 1;","}",".blocklySelected>.blocklyPathLight {","display: none;","}",".blocklyDraggable {",'cursor: url("<<<PATH>>>/handopen.cur"), auto;',"cursor: grab;","cursor: -webkit-grab;","}",".blocklyDragging {",'cursor: url("<<<PATH>>>/handclosed.cur"), auto;',"cursor: grabbing;","cursor: -webkit-grabbing;","}",".blocklyDraggable:active {",'cursor: url("<<<PATH>>>/handclosed.cur"), auto;',"cursor: grabbing;","cursor: -webkit-grabbing;","}",".blocklyBlockDragSurface .blocklyDraggable {",
	'cursor: url("<<<PATH>>>/handclosed.cur"), auto;',"cursor: grabbing;","cursor: -webkit-grabbing;","}",".blocklyDragging.blocklyDraggingDelete {",'cursor: url("<<<PATH>>>/handdelete.cur"), auto;',"}",".blocklyDragging>.blocklyPath,",".blocklyDragging>.blocklyPathLight {","fill-opacity: .8;","stroke-opacity: .8;","}",".blocklyDragging>.blocklyPathDark {","display: none;","}",".blocklyDisabled>.blocklyPath {","fill-opacity: .5;","stroke-opacity: .5;","}",".blocklyDisabled>.blocklyPathLight,",".blocklyDisabled>.blocklyPathDark {",
	"display: none;","}",".blocklyInsertionMarker>.blocklyPath,",".blocklyInsertionMarker>.blocklyPathLight,",".blocklyInsertionMarker>.blocklyPathDark {","fill-opacity: .2;","stroke: none;","}",".blocklyMultilineText {","font-family: monospace;","}",".blocklyNonEditableText>text {","pointer-events: none;","}",".blocklyFlyout {","position: absolute;","z-index: 20;","}",".blocklyText text {","cursor: default;","}",".blocklySvg text,",".blocklyBlockDragSurface text {","user-select: none;","-ms-user-select: none;",
	"-webkit-user-select: none;","cursor: inherit;","}",".blocklyHidden {","display: none;","}",".blocklyFieldDropdown:not(.blocklyHidden) {","display: block;","}",".blocklyIconGroup {","cursor: default;","}",".blocklyIconGroup:not(:hover),",".blocklyIconGroupReadonly {","opacity: .6;","}",".blocklyIconShape {","fill: #00f;","stroke: #fff;","stroke-width: 1px;","}",".blocklyIconSymbol {","fill: #fff;","}",".blocklyMinimalBody {","margin: 0;","padding: 0;","}",".blocklyHtmlInput {","border: none;","border-radius: 4px;",
	"height: 100%;","margin: 0;","outline: none;","padding: 0;","width: 100%;","text-align: center;","display: block;","box-sizing: border-box;","}",".blocklyHtmlInput::-ms-clear {","display: none;","}",".blocklyMainBackground {","stroke-width: 1;","stroke: #c6c6c6;","}",".blocklyMutatorBackground {","fill: #fff;","stroke: #ddd;","stroke-width: 1;","}",".blocklyFlyoutBackground {","fill: #ddd;","fill-opacity: .8;","}",".blocklyMainWorkspaceScrollbar {","z-index: 20;","}",".blocklyFlyoutScrollbar {","z-index: 30;",
	"}",".blocklyScrollbarHorizontal,",".blocklyScrollbarVertical {","position: absolute;","outline: none;","}",".blocklyScrollbarBackground {","opacity: 0;","}",".blocklyScrollbarHandle {","fill: #ccc;","}",".blocklyScrollbarBackground:hover+.blocklyScrollbarHandle,",".blocklyScrollbarHandle:hover {","fill: #bbb;","}",".blocklyFlyout .blocklyScrollbarHandle {","fill: #bbb;","}",".blocklyFlyout .blocklyScrollbarBackground:hover+.blocklyScrollbarHandle,",".blocklyFlyout .blocklyScrollbarHandle:hover {",
	"fill: #aaa;","}",".blocklyInvalidInput {","background: #faa;","}",".blocklyVerticalMarker {","stroke-width: 3px;","fill: rgba(255,255,255,.5);","pointer-events: none;","}",".blocklyComputeCanvas {","position: absolute;","width: 0;","height: 0;","}",".blocklyNoPointerEvents {","pointer-events: none;","}",".blocklyContextMenu {","border-radius: 4px;","max-height: 100%;","}",".blocklyDropdownMenu {","border-radius: 2px;","padding: 0 !important;","}",".blocklyDropdownMenu .blocklyMenuItem {","padding-left: 28px;",
	"}",".blocklyDropdownMenu .blocklyMenuItemRtl {","padding-left: 5px;","padding-right: 28px;","}",".blocklyWidgetDiv .blocklyMenu {","background: #fff;","border: 1px solid transparent;","box-shadow: 0 0 3px 1px rgba(0,0,0,.3);","font: normal 13px Arial, sans-serif;","margin: 0;","outline: none;","padding: 4px 0;","position: absolute;","overflow-y: auto;","overflow-x: hidden;","max-height: 100%;","z-index: 20000;","}",".blocklyWidgetDiv .blocklyMenu.blocklyFocused {","box-shadow: 0 0 6px 1px rgba(0,0,0,.3);",
	"}",".blocklyDropDownDiv .blocklyMenu {",'font: normal 13px "Helvetica Neue", Helvetica, sans-serif;',"outline: none;","z-index: 20000;","}",".blocklyMenuItem {","border: none;","color: #000;","cursor: pointer;","list-style: none;","margin: 0;","min-width: 7em;","padding: 6px 15px;","white-space: nowrap;","}",".blocklyMenuItemDisabled {","color: #ccc;","cursor: inherit;","}",".blocklyMenuItemHighlight {","background-color: rgba(0,0,0,.1);","}",".blocklyMenuItemCheckbox {","height: 16px;","position: absolute;",
	"width: 16px;","}",".blocklyMenuItemSelected .blocklyMenuItemCheckbox {","background: url(<<<PATH>>>/sprites.png) no-repeat -48px -16px;","float: left;","margin-left: -24px;","position: static;","}",".blocklyMenuItemRtl .blocklyMenuItemCheckbox {","float: right;","margin-right: -24px;","}"];Blockly.utils.math={};Blockly.utils.math.toRadians=function(a){return a*Math.PI/180};Blockly.utils.math.toDegrees=function(a){return 180*a/Math.PI};Blockly.utils.math.clamp=function(a,b,c){if(c<a){var d=c;c=a;a=d}return Math.max(a,Math.min(b,c))};Blockly.DropDownDiv=function(){};Blockly.DropDownDiv.boundsElement_=null;Blockly.DropDownDiv.owner_=null;Blockly.DropDownDiv.positionToField_=null;Blockly.DropDownDiv.ARROW_SIZE=16;Blockly.DropDownDiv.BORDER_SIZE=1;Blockly.DropDownDiv.ARROW_HORIZONTAL_PADDING=12;Blockly.DropDownDiv.PADDING_Y=16;Blockly.DropDownDiv.ANIMATION_TIME=.25;Blockly.DropDownDiv.animateOutTimer_=null;Blockly.DropDownDiv.onHide_=null;Blockly.DropDownDiv.rendererClassName_="";Blockly.DropDownDiv.themeClassName_="";
	Blockly.DropDownDiv.createDom=function(){if(!Blockly.DropDownDiv.DIV_){var a=document.createElement("div");a.className="blocklyDropDownDiv";(Blockly.parentContainer||document.body).appendChild(a);Blockly.DropDownDiv.DIV_=a;var b=document.createElement("div");b.className="blocklyDropDownContent";a.appendChild(b);Blockly.DropDownDiv.content_=b;b=document.createElement("div");b.className="blocklyDropDownArrow";a.appendChild(b);Blockly.DropDownDiv.arrow_=b;Blockly.DropDownDiv.DIV_.style.opacity=0;Blockly.DropDownDiv.DIV_.style.transition=
	"transform "+Blockly.DropDownDiv.ANIMATION_TIME+"s, opacity "+Blockly.DropDownDiv.ANIMATION_TIME+"s";a.addEventListener("focusin",function(){Blockly.utils.dom.addClass(a,"blocklyFocused")});a.addEventListener("focusout",function(){Blockly.utils.dom.removeClass(a,"blocklyFocused")})}};Blockly.DropDownDiv.setBoundsElement=function(a){Blockly.DropDownDiv.boundsElement_=a};Blockly.DropDownDiv.getContentDiv=function(){return Blockly.DropDownDiv.content_};
	Blockly.DropDownDiv.clearContent=function(){Blockly.DropDownDiv.content_.textContent="";Blockly.DropDownDiv.content_.style.width=""};Blockly.DropDownDiv.setColour=function(a,b){Blockly.DropDownDiv.DIV_.style.backgroundColor=a;Blockly.DropDownDiv.DIV_.style.borderColor=b};Blockly.DropDownDiv.showPositionedByBlock=function(a,b,c,d){return Blockly.DropDownDiv.showPositionedByRect_(Blockly.DropDownDiv.getScaledBboxOfBlock_(b),a,c,d)};
	Blockly.DropDownDiv.showPositionedByField=function(a,b,c){Blockly.DropDownDiv.positionToField_=!0;return Blockly.DropDownDiv.showPositionedByRect_(Blockly.DropDownDiv.getScaledBboxOfField_(a),a,b,c)};Blockly.DropDownDiv.getScaledBboxOfBlock_=function(a){var b=a.getSvgRoot(),c=b.getBBox(),d=a.workspace.scale;a=c.height*d;c=c.width*d;b=Blockly.utils.style.getPageOffset(b);return new Blockly.utils.Rect(b.y,b.y+a,b.x,b.x+c)};
	Blockly.DropDownDiv.getScaledBboxOfField_=function(a){a=a.getScaledBBox();return new Blockly.utils.Rect(a.top,a.bottom,a.left,a.right)};Blockly.DropDownDiv.showPositionedByRect_=function(a,b,c,d){var e=a.left+(a.right-a.left)/2,f=a.bottom;a=a.top;d&&(a+=d);d=b.getSourceBlock();for(var g=d.workspace;g.options.parentWorkspace;)g=g.options.parentWorkspace;Blockly.DropDownDiv.setBoundsElement(g.getParentSvg().parentNode);return Blockly.DropDownDiv.show(b,d.RTL,e,f,e,a,c)};
	Blockly.DropDownDiv.show=function(a,b,c,d,e,f,g){Blockly.DropDownDiv.owner_=a;Blockly.DropDownDiv.onHide_=g||null;a=Blockly.DropDownDiv.DIV_;a.style.direction=b?"rtl":"ltr";b=Blockly.getMainWorkspace();Blockly.DropDownDiv.rendererClassName_=b.getRenderer().getClassName();Blockly.DropDownDiv.themeClassName_=b.getTheme().getClassName();Blockly.utils.dom.addClass(a,Blockly.DropDownDiv.rendererClassName_);Blockly.utils.dom.addClass(a,Blockly.DropDownDiv.themeClassName_);return Blockly.DropDownDiv.positionInternal_(c,
	d,e,f)};Blockly.DropDownDiv.getBoundsInfo_=function(){var a=Blockly.utils.style.getPageOffset(Blockly.DropDownDiv.boundsElement_),b=Blockly.utils.style.getSize(Blockly.DropDownDiv.boundsElement_);return{left:a.x,right:a.x+b.width,top:a.y,bottom:a.y+b.height,width:b.width,height:b.height}};
	Blockly.DropDownDiv.getPositionMetrics_=function(a,b,c,d){var e=Blockly.DropDownDiv.getBoundsInfo_(),f=Blockly.utils.style.getSize(Blockly.DropDownDiv.DIV_);return b+f.height<e.bottom?Blockly.DropDownDiv.getPositionBelowMetrics_(a,b,e,f):d-f.height>e.top?Blockly.DropDownDiv.getPositionAboveMetrics_(c,d,e,f):b+f.height<document.documentElement.clientHeight?Blockly.DropDownDiv.getPositionBelowMetrics_(a,b,e,f):d-f.height>document.documentElement.clientTop?Blockly.DropDownDiv.getPositionAboveMetrics_(c,
	d,e,f):Blockly.DropDownDiv.getPositionTopOfPageMetrics_(a,e,f)};Blockly.DropDownDiv.getPositionBelowMetrics_=function(a,b,c,d){a=Blockly.DropDownDiv.getPositionX(a,c.left,c.right,d.width);return{initialX:a.divX,initialY:b,finalX:a.divX,finalY:b+Blockly.DropDownDiv.PADDING_Y,arrowX:a.arrowX,arrowY:-(Blockly.DropDownDiv.ARROW_SIZE/2+Blockly.DropDownDiv.BORDER_SIZE),arrowAtTop:!0,arrowVisible:!0}};
	Blockly.DropDownDiv.getPositionAboveMetrics_=function(a,b,c,d){a=Blockly.DropDownDiv.getPositionX(a,c.left,c.right,d.width);return{initialX:a.divX,initialY:b-d.height,finalX:a.divX,finalY:b-d.height-Blockly.DropDownDiv.PADDING_Y,arrowX:a.arrowX,arrowY:d.height-2*Blockly.DropDownDiv.BORDER_SIZE-Blockly.DropDownDiv.ARROW_SIZE/2,arrowAtTop:!1,arrowVisible:!0}};
	Blockly.DropDownDiv.getPositionTopOfPageMetrics_=function(a,b,c){a=Blockly.DropDownDiv.getPositionX(a,b.left,b.right,c.width);return{initialX:a.divX,initialY:0,finalX:a.divX,finalY:0,arrowAtTop:null,arrowX:null,arrowY:null,arrowVisible:!1}};
	Blockly.DropDownDiv.getPositionX=function(a,b,c,d){var e=a;a=Blockly.utils.math.clamp(b,a-d/2,c-d);e-=Blockly.DropDownDiv.ARROW_SIZE/2;b=Blockly.DropDownDiv.ARROW_HORIZONTAL_PADDING;d=Blockly.utils.math.clamp(b,e-a,d-b-Blockly.DropDownDiv.ARROW_SIZE);return{arrowX:d,divX:a}};Blockly.DropDownDiv.isVisible=function(){return!!Blockly.DropDownDiv.owner_};
	Blockly.DropDownDiv.hideIfOwner=function(a,b){return Blockly.DropDownDiv.owner_===a?(b?Blockly.DropDownDiv.hideWithoutAnimation():Blockly.DropDownDiv.hide(),!0):!1};
	Blockly.DropDownDiv.hide=function(){var a=Blockly.DropDownDiv.DIV_;a.style.transform="translate(0, 0)";a.style.opacity=0;Blockly.DropDownDiv.animateOutTimer_=setTimeout(function(){Blockly.DropDownDiv.hideWithoutAnimation()},1E3*Blockly.DropDownDiv.ANIMATION_TIME);Blockly.DropDownDiv.onHide_&&(Blockly.DropDownDiv.onHide_(),Blockly.DropDownDiv.onHide_=null)};
	Blockly.DropDownDiv.hideWithoutAnimation=function(){if(Blockly.DropDownDiv.isVisible()){Blockly.DropDownDiv.animateOutTimer_&&clearTimeout(Blockly.DropDownDiv.animateOutTimer_);var a=Blockly.DropDownDiv.DIV_;a.style.transform="";a.style.left="";a.style.top="";a.style.opacity=0;a.style.display="none";a.style.backgroundColor="";a.style.borderColor="";Blockly.DropDownDiv.onHide_&&(Blockly.DropDownDiv.onHide_(),Blockly.DropDownDiv.onHide_=null);Blockly.DropDownDiv.clearContent();Blockly.DropDownDiv.owner_=
	null;Blockly.DropDownDiv.rendererClassName_&&(Blockly.utils.dom.removeClass(a,Blockly.DropDownDiv.rendererClassName_),Blockly.DropDownDiv.rendererClassName_="");Blockly.DropDownDiv.themeClassName_&&(Blockly.utils.dom.removeClass(a,Blockly.DropDownDiv.themeClassName_),Blockly.DropDownDiv.themeClassName_="");Blockly.getMainWorkspace().markFocused()}};
	Blockly.DropDownDiv.positionInternal_=function(a,b,c,d){a=Blockly.DropDownDiv.getPositionMetrics_(a,b,c,d);a.arrowVisible?(Blockly.DropDownDiv.arrow_.style.display="",Blockly.DropDownDiv.arrow_.style.transform="translate("+a.arrowX+"px,"+a.arrowY+"px) rotate(45deg)",Blockly.DropDownDiv.arrow_.setAttribute("class",a.arrowAtTop?"blocklyDropDownArrow blocklyArrowTop":"blocklyDropDownArrow blocklyArrowBottom")):Blockly.DropDownDiv.arrow_.style.display="none";b=Math.floor(a.initialX);c=Math.floor(a.initialY);
	d=Math.floor(a.finalX);var e=Math.floor(a.finalY),f=Blockly.DropDownDiv.DIV_;f.style.left=b+"px";f.style.top=c+"px";f.style.display="block";f.style.opacity=1;f.style.transform="translate("+(d-b)+"px,"+(e-c)+"px)";return!!a.arrowAtTop};
	Blockly.DropDownDiv.repositionForWindowResize=function(){if(Blockly.DropDownDiv.owner_){var a=Blockly.DropDownDiv.owner_,b=a.getSourceBlock();a=Blockly.DropDownDiv.positionToField_?Blockly.DropDownDiv.getScaledBboxOfField_(a):Blockly.DropDownDiv.getScaledBboxOfBlock_(b);b=a.left+(a.right-a.left)/2;Blockly.DropDownDiv.positionInternal_(b,a.bottom,b,a.top)}else Blockly.DropDownDiv.hide()};Blockly.Grid=function(a,b){this.gridPattern_=a;this.spacing_=b.spacing;this.length_=b.length;this.line2_=(this.line1_=a.firstChild)&&this.line1_.nextSibling;this.snapToGrid_=b.snap};Blockly.Grid.prototype.scale_=1;Blockly.Grid.prototype.dispose=function(){this.gridPattern_=null};Blockly.Grid.prototype.shouldSnap=function(){return this.snapToGrid_};Blockly.Grid.prototype.getSpacing=function(){return this.spacing_};Blockly.Grid.prototype.getPatternId=function(){return this.gridPattern_.id};
	Blockly.Grid.prototype.update=function(a){this.scale_=a;var b=this.spacing_*a||100;this.gridPattern_.setAttribute("width",b);this.gridPattern_.setAttribute("height",b);b=Math.floor(this.spacing_/2)+.5;var c=b-this.length_/2,d=b+this.length_/2;b*=a;c*=a;d*=a;this.setLineAttributes_(this.line1_,a,c,d,b,b);this.setLineAttributes_(this.line2_,a,b,b,c,d)};
	Blockly.Grid.prototype.setLineAttributes_=function(a,b,c,d,e,f){a&&(a.setAttribute("stroke-width",b),a.setAttribute("x1",c),a.setAttribute("y1",e),a.setAttribute("x2",d),a.setAttribute("y2",f))};Blockly.Grid.prototype.moveTo=function(a,b){this.gridPattern_.setAttribute("x",a);this.gridPattern_.setAttribute("y",b);(Blockly.utils.userAgent.IE||Blockly.utils.userAgent.EDGE)&&this.update(this.scale_)};
	Blockly.Grid.createDom=function(a,b,c){a=Blockly.utils.dom.createSvgElement("pattern",{id:"blocklyGridPattern"+a,patternUnits:"userSpaceOnUse"},c);0<b.length&&0<b.spacing?(Blockly.utils.dom.createSvgElement("line",{stroke:b.colour},a),1<b.length&&Blockly.utils.dom.createSvgElement("line",{stroke:b.colour},a)):Blockly.utils.dom.createSvgElement("line",{},a);return a};Blockly.registry={};Blockly.registry.typeMap_={};Blockly.registry.DEFAULT="default";Blockly.registry.Type=function(a){this.name_=a};Blockly.registry.Type.prototype.toString=function(){return this.name_};Blockly.registry.Type.RENDERER=new Blockly.registry.Type("renderer");Blockly.registry.Type.FIELD=new Blockly.registry.Type("field");Blockly.registry.Type.TOOLBOX=new Blockly.registry.Type("toolbox");Blockly.registry.Type.THEME=new Blockly.registry.Type("theme");
	Blockly.registry.register=function(a,b,c){if(!(a instanceof Blockly.registry.Type)&&"string"!=typeof a||""==String(a).trim())throw Error('Invalid type "'+a+'". The type must be a non-empty string or a Blockly.registry.Type.');a=String(a).toLowerCase();if("string"!=typeof b||""==b.trim())throw Error('Invalid name "'+b+'". The name must be a non-empty string.');b=b.toLowerCase();if(!c)throw Error("Can not register a null value");var d=Blockly.registry.typeMap_[a];d||(d=Blockly.registry.typeMap_[a]=
	{});Blockly.registry.validate_(a,c);if(d[b])throw Error('Name "'+b+'" with type "'+a+'" already registered.');d[b]=c};Blockly.registry.validate_=function(a,b){switch(a){case String(Blockly.registry.Type.FIELD):if("function"!=typeof b.fromJson)throw Error('Type "'+a+'" must have a fromJson function');}};
	Blockly.registry.unregister=function(a,b){a=String(a).toLowerCase();b=b.toLowerCase();var c=Blockly.registry.typeMap_[a];c?c[b]?delete Blockly.registry.typeMap_[a][b]:console.warn('No name "'+b+'" with type "'+a+'" found'):console.warn('No type "'+a+'" found')};
	Blockly.registry.getItem_=function(a,b){a=String(a).toLowerCase();b=b.toLowerCase();var c=Blockly.registry.typeMap_[a];return c?c[b]?c[b]:(console.warn('No name "'+b+'" with type "'+a+'" found'),null):(console.warn('No type "'+a+'" found'),null)};Blockly.registry.getClass=function(a,b){return Blockly.registry.getItem_(a,b)};Blockly.registry.getObject=function(a,b){return Blockly.registry.getItem_(a,b)};
	Blockly.registry.getClassFromOptions=function(a,b){b=b.plugins[a.toString()]||Blockly.registry.DEFAULT;return"function"==typeof b?b:Blockly.registry.getClass(a,b)};Blockly.Theme=function(a,b,c,d){this.name=a;this.blockStyles=b||Object.create(null);this.categoryStyles=c||Object.create(null);this.componentStyles=d||Object.create(null);this.fontStyle=Object.create(null);this.startHats=null;Blockly.registry.register(Blockly.registry.Type.THEME,a,this)};Blockly.Theme.prototype.getClassName=function(){return this.name+"-theme"};Blockly.Theme.prototype.setBlockStyle=function(a,b){this.blockStyles[a]=b};
	Blockly.Theme.prototype.setCategoryStyle=function(a,b){this.categoryStyles[a]=b};Blockly.Theme.prototype.getComponentStyle=function(a){return(a=this.componentStyles[a])&&"string"==typeof propertyValue&&this.getComponentStyle(a)?this.getComponentStyle(a):a?String(a):null};Blockly.Theme.prototype.setComponentStyle=function(a,b){this.componentStyles[a]=b};Blockly.Theme.prototype.setFontStyle=function(a){this.fontStyle=a};Blockly.Theme.prototype.setStartHats=function(a){this.startHats=a};
	Blockly.Theme.defineTheme=function(a,b){var c=new Blockly.Theme(a),d=b.base;d&&("string"==typeof d&&(d=Blockly.registry.getObject(Blockly.registry.Type.THEME,d)),d instanceof Blockly.Theme&&(Blockly.utils.object.deepMerge(c,d),c.name=a));Blockly.utils.object.deepMerge(c.blockStyles,b.blockStyles);Blockly.utils.object.deepMerge(c.categoryStyles,b.categoryStyles);Blockly.utils.object.deepMerge(c.componentStyles,b.componentStyles);Blockly.utils.object.deepMerge(c.fontStyle,b.fontStyle);null!=b.startHats&&
	(c.startHats=b.startHats);return c};Blockly.Themes={};Blockly.Themes.Classic={};Blockly.Themes.Classic.defaultBlockStyles={colour_blocks:{colourPrimary:"20"},list_blocks:{colourPrimary:"260"},logic_blocks:{colourPrimary:"210"},loop_blocks:{colourPrimary:"120"},math_blocks:{colourPrimary:"230"},procedure_blocks:{colourPrimary:"290"},text_blocks:{colourPrimary:"160"},variable_blocks:{colourPrimary:"330"},variable_dynamic_blocks:{colourPrimary:"310"},hat_blocks:{colourPrimary:"330",hat:"cap"}};
	Blockly.Themes.Classic.categoryStyles={colour_category:{colour:"20"},list_category:{colour:"260"},logic_category:{colour:"210"},loop_category:{colour:"120"},math_category:{colour:"230"},procedure_category:{colour:"290"},text_category:{colour:"160"},variable_category:{colour:"330"},variable_dynamic_category:{colour:"310"}};Blockly.Themes.Classic=new Blockly.Theme("classic",Blockly.Themes.Classic.defaultBlockStyles,Blockly.Themes.Classic.categoryStyles);Blockly.utils.KeyCodes={WIN_KEY_FF_LINUX:0,MAC_ENTER:3,BACKSPACE:8,TAB:9,NUM_CENTER:12,ENTER:13,SHIFT:16,CTRL:17,ALT:18,PAUSE:19,CAPS_LOCK:20,ESC:27,SPACE:32,PAGE_UP:33,PAGE_DOWN:34,END:35,HOME:36,LEFT:37,UP:38,RIGHT:39,DOWN:40,PLUS_SIGN:43,PRINT_SCREEN:44,INSERT:45,DELETE:46,ZERO:48,ONE:49,TWO:50,THREE:51,FOUR:52,FIVE:53,SIX:54,SEVEN:55,EIGHT:56,NINE:57,FF_SEMICOLON:59,FF_EQUALS:61,FF_DASH:173,FF_HASH:163,QUESTION_MARK:63,AT_SIGN:64,A:65,B:66,C:67,D:68,E:69,F:70,G:71,H:72,I:73,J:74,K:75,L:76,M:77,
	N:78,O:79,P:80,Q:81,R:82,S:83,T:84,U:85,V:86,W:87,X:88,Y:89,Z:90,META:91,WIN_KEY_RIGHT:92,CONTEXT_MENU:93,NUM_ZERO:96,NUM_ONE:97,NUM_TWO:98,NUM_THREE:99,NUM_FOUR:100,NUM_FIVE:101,NUM_SIX:102,NUM_SEVEN:103,NUM_EIGHT:104,NUM_NINE:105,NUM_MULTIPLY:106,NUM_PLUS:107,NUM_MINUS:109,NUM_PERIOD:110,NUM_DIVISION:111,F1:112,F2:113,F3:114,F4:115,F5:116,F6:117,F7:118,F8:119,F9:120,F10:121,F11:122,F12:123,NUMLOCK:144,SCROLL_LOCK:145,FIRST_MEDIA_KEY:166,LAST_MEDIA_KEY:183,SEMICOLON:186,DASH:189,EQUALS:187,COMMA:188,
	PERIOD:190,SLASH:191,APOSTROPHE:192,TILDE:192,SINGLE_QUOTE:222,OPEN_SQUARE_BRACKET:219,BACKSLASH:220,CLOSE_SQUARE_BRACKET:221,WIN_KEY:224,MAC_FF_META:224,MAC_WK_CMD_LEFT:91,MAC_WK_CMD_RIGHT:93,WIN_IME:229,VK_NONAME:252,PHANTOM:255};Blockly.user={};Blockly.user.keyMap={};Blockly.user.keyMap.map_={};Blockly.user.keyMap.modifierKeys={SHIFT:"Shift",CONTROL:"Control",ALT:"Alt",META:"Meta"};Blockly.user.keyMap.setActionForKey=function(a,b){var c=Blockly.user.keyMap.getKeyByAction(b);c&&delete Blockly.user.keyMap.map_[c];Blockly.user.keyMap.map_[a]=b};Blockly.user.keyMap.setKeyMap=function(a){Blockly.user.keyMap.map_=a};Blockly.user.keyMap.getKeyMap=function(){var a={};Blockly.utils.object.mixin(a,Blockly.user.keyMap.map_);return a};
	Blockly.user.keyMap.getActionByKeyCode=function(a){return Blockly.user.keyMap.map_[a]};Blockly.user.keyMap.getKeyByAction=function(a){for(var b=Object.keys(Blockly.user.keyMap.map_),c=0,d;d=b[c];c++)if(Blockly.user.keyMap.map_[d].name===a.name)return d;return null};Blockly.user.keyMap.serializeKeyEvent=function(a){for(var b=Blockly.utils.object.values(Blockly.user.keyMap.modifierKeys),c="",d=0,e;e=b[d];d++)a.getModifierState(e)&&(c+=e);return c+=a.keyCode};
	Blockly.user.keyMap.checkModifiers_=function(a,b){for(var c=0,d;d=a[c];c++)if(0>b.indexOf(d))throw Error(d+" is not a valid modifier key.");};Blockly.user.keyMap.createSerializedKey=function(a,b){var c="",d=Blockly.utils.object.values(Blockly.user.keyMap.modifierKeys);Blockly.user.keyMap.checkModifiers_(b,d);for(var e=0,f;f=d[e];e++)-1<b.indexOf(f)&&(c+=f);return c+a};
	Blockly.user.keyMap.createDefaultKeyMap=function(){var a={},b=Blockly.user.keyMap.createSerializedKey(Blockly.utils.KeyCodes.K,[Blockly.user.keyMap.modifierKeys.CONTROL,Blockly.user.keyMap.modifierKeys.SHIFT]),c=Blockly.user.keyMap.createSerializedKey(Blockly.utils.KeyCodes.W,[Blockly.user.keyMap.modifierKeys.SHIFT]),d=Blockly.user.keyMap.createSerializedKey(Blockly.utils.KeyCodes.A,[Blockly.user.keyMap.modifierKeys.SHIFT]),e=Blockly.user.keyMap.createSerializedKey(Blockly.utils.KeyCodes.S,[Blockly.user.keyMap.modifierKeys.SHIFT]),
	f=Blockly.user.keyMap.createSerializedKey(Blockly.utils.KeyCodes.D,[Blockly.user.keyMap.modifierKeys.SHIFT]);a[Blockly.utils.KeyCodes.W]=Blockly.navigation.ACTION_PREVIOUS;a[Blockly.utils.KeyCodes.A]=Blockly.navigation.ACTION_OUT;a[Blockly.utils.KeyCodes.S]=Blockly.navigation.ACTION_NEXT;a[Blockly.utils.KeyCodes.D]=Blockly.navigation.ACTION_IN;a[Blockly.utils.KeyCodes.I]=Blockly.navigation.ACTION_INSERT;a[Blockly.utils.KeyCodes.ENTER]=Blockly.navigation.ACTION_MARK;a[Blockly.utils.KeyCodes.X]=Blockly.navigation.ACTION_DISCONNECT;
	a[Blockly.utils.KeyCodes.T]=Blockly.navigation.ACTION_TOOLBOX;a[Blockly.utils.KeyCodes.E]=Blockly.navigation.ACTION_EXIT;a[Blockly.utils.KeyCodes.ESC]=Blockly.navigation.ACTION_EXIT;a[b]=Blockly.navigation.ACTION_TOGGLE_KEYBOARD_NAV;a[c]=Blockly.navigation.ACTION_MOVE_WS_CURSOR_UP;a[d]=Blockly.navigation.ACTION_MOVE_WS_CURSOR_LEFT;a[e]=Blockly.navigation.ACTION_MOVE_WS_CURSOR_DOWN;a[f]=Blockly.navigation.ACTION_MOVE_WS_CURSOR_RIGHT;return a};Blockly.utils.Metrics=function(){};Blockly.utils.toolbox={};Blockly.utils.toolbox.convertToolboxToJSON=function(a){return a?Array.isArray(a)&&a.length&&!a[0].nodeType?(Blockly.utils.toolbox.hasCategories(a)&&console.warn("Due to some performance issues, defining a toolbox usingJSON is not ready yet. Please define your toolbox using xml."),a):Blockly.utils.toolbox.toolboxXmlToJson_(a):null};
	Blockly.utils.toolbox.toolboxXmlToJson_=function(a){var b=[],c=a.childNodes;c||(c=a);a=0;for(var d;d=c[a];a++)if(d.tagName){var e={},f=d.tagName.toUpperCase();e.kind=f;"BLOCK"==f?e.blockxml=d:"CATEGORY"==f&&(e.contents=Blockly.utils.toolbox.toolboxXmlToJson_(d));for(f=0;f<d.attributes.length;f++){var g=d.attributes[f];e[g.nodeName]=g.value}b.push(e)}return b};Blockly.utils.toolbox.hasCategories=function(a){return Array.isArray(a)?!(!a.length||"CATEGORY"!=a[0].kind.toUpperCase()):!(!a||!a.getElementsByTagName("category").length)};Blockly.utils.xml={};Blockly.utils.xml.NAME_SPACE="https://developers.google.com/blockly/xml";Blockly.utils.xml.document=function(){return document};Blockly.utils.xml.createElement=function(a){return Blockly.utils.xml.document().createElementNS(Blockly.utils.xml.NAME_SPACE,a)};Blockly.utils.xml.createTextNode=function(a){return Blockly.utils.xml.document().createTextNode(a)};Blockly.utils.xml.textToDomDocument=function(a){return(new DOMParser).parseFromString(a,"text/xml")};
	Blockly.utils.xml.domToText=function(a){return(new XMLSerializer).serializeToString(a)};Blockly.Events.BlockBase=function(a){Blockly.Events.BlockBase.superClass_.constructor.call(this);this.blockId=a.id;this.workspaceId=a.workspace.id};Blockly.utils.object.inherits(Blockly.Events.BlockBase,Blockly.Events.Abstract);Blockly.Events.BlockBase.prototype.toJson=function(){var a=Blockly.Events.BlockBase.superClass_.toJson.call(this);a.blockId=this.blockId;return a};
	Blockly.Events.BlockBase.prototype.fromJson=function(a){Blockly.Events.BlockBase.superClass_.fromJson.call(this,a);this.blockId=a.blockId};Blockly.Events.Change=function(a,b,c,d,e){a&&(Blockly.Events.Change.superClass_.constructor.call(this,a),this.element=b,this.name=c,this.oldValue=d,this.newValue=e)};Blockly.utils.object.inherits(Blockly.Events.Change,Blockly.Events.BlockBase);Blockly.Events.BlockChange=Blockly.Events.Change;Blockly.Events.Change.prototype.type=Blockly.Events.CHANGE;
	Blockly.Events.Change.prototype.toJson=function(){var a=Blockly.Events.Change.superClass_.toJson.call(this);a.element=this.element;this.name&&(a.name=this.name);a.newValue=this.newValue;return a};Blockly.Events.Change.prototype.fromJson=function(a){Blockly.Events.Change.superClass_.fromJson.call(this,a);this.element=a.element;this.name=a.name;this.newValue=a.newValue};Blockly.Events.Change.prototype.isNull=function(){return this.oldValue==this.newValue};
	Blockly.Events.Change.prototype.run=function(a){var b=this.getEventWorkspace_().getBlockById(this.blockId);if(b)switch(b.mutator&&b.mutator.setVisible(!1),a=a?this.newValue:this.oldValue,this.element){case "field":(b=b.getField(this.name))?b.setValue(a):console.warn("Can't set non-existent field: "+this.name);break;case "comment":b.setCommentText(a||null);break;case "collapsed":b.setCollapsed(!!a);break;case "disabled":b.setEnabled(!a);break;case "inline":b.setInputsInline(!!a);break;case "mutation":var c=
	"";b.mutationToDom&&(c=(c=b.mutationToDom())&&Blockly.Xml.domToText(c));if(b.domToMutation){var d=Blockly.Xml.textToDom(a||"<mutation/>");b.domToMutation(d)}Blockly.Events.fire(new Blockly.Events.Change(b,"mutation",null,c,a));break;default:console.warn("Unknown change type: "+this.element)}else console.warn("Can't change non-existent block: "+this.blockId)};
	Blockly.Events.Create=function(a){a&&(Blockly.Events.Create.superClass_.constructor.call(this,a),this.xml=a.workspace.rendered?Blockly.Xml.blockToDomWithXY(a):Blockly.Xml.blockToDom(a),this.ids=Blockly.Events.getDescendantIds(a))};Blockly.utils.object.inherits(Blockly.Events.Create,Blockly.Events.BlockBase);Blockly.Events.BlockCreate=Blockly.Events.Create;Blockly.Events.Create.prototype.type=Blockly.Events.CREATE;
	Blockly.Events.Create.prototype.toJson=function(){var a=Blockly.Events.Create.superClass_.toJson.call(this);a.xml=Blockly.Xml.domToText(this.xml);a.ids=this.ids;return a};Blockly.Events.Create.prototype.fromJson=function(a){Blockly.Events.Create.superClass_.fromJson.call(this,a);this.xml=Blockly.Xml.textToDom(a.xml);this.ids=a.ids};
	Blockly.Events.Create.prototype.run=function(a){var b=this.getEventWorkspace_();if(a)a=Blockly.utils.xml.createElement("xml"),a.appendChild(this.xml),Blockly.Xml.domToWorkspace(a,b);else{a=0;for(var c;c=this.ids[a];a++){var d=b.getBlockById(c);d?d.dispose(!1):c==this.blockId&&console.warn("Can't uncreate non-existent block: "+c)}}};
	Blockly.Events.Delete=function(a){if(a){if(a.getParent())throw Error("Connected blocks cannot be deleted.");Blockly.Events.Delete.superClass_.constructor.call(this,a);this.oldXml=a.workspace.rendered?Blockly.Xml.blockToDomWithXY(a):Blockly.Xml.blockToDom(a);this.ids=Blockly.Events.getDescendantIds(a)}};Blockly.utils.object.inherits(Blockly.Events.Delete,Blockly.Events.BlockBase);Blockly.Events.BlockDelete=Blockly.Events.Delete;Blockly.Events.Delete.prototype.type=Blockly.Events.DELETE;
	Blockly.Events.Delete.prototype.toJson=function(){var a=Blockly.Events.Delete.superClass_.toJson.call(this);a.ids=this.ids;return a};Blockly.Events.Delete.prototype.fromJson=function(a){Blockly.Events.Delete.superClass_.fromJson.call(this,a);this.ids=a.ids};
	Blockly.Events.Delete.prototype.run=function(a){var b=this.getEventWorkspace_();if(a){a=0;for(var c;c=this.ids[a];a++){var d=b.getBlockById(c);d?d.dispose(!1):c==this.blockId&&console.warn("Can't delete non-existent block: "+c)}}else a=Blockly.utils.xml.createElement("xml"),a.appendChild(this.oldXml),Blockly.Xml.domToWorkspace(a,b)};
	Blockly.Events.Move=function(a){a&&(Blockly.Events.Move.superClass_.constructor.call(this,a),a=this.currentLocation_(),this.oldParentId=a.parentId,this.oldInputName=a.inputName,this.oldCoordinate=a.coordinate)};Blockly.utils.object.inherits(Blockly.Events.Move,Blockly.Events.BlockBase);Blockly.Events.BlockMove=Blockly.Events.Move;Blockly.Events.Move.prototype.type=Blockly.Events.MOVE;
	Blockly.Events.Move.prototype.toJson=function(){var a=Blockly.Events.Move.superClass_.toJson.call(this);this.newParentId&&(a.newParentId=this.newParentId);this.newInputName&&(a.newInputName=this.newInputName);this.newCoordinate&&(a.newCoordinate=Math.round(this.newCoordinate.x)+","+Math.round(this.newCoordinate.y));return a};
	Blockly.Events.Move.prototype.fromJson=function(a){Blockly.Events.Move.superClass_.fromJson.call(this,a);this.newParentId=a.newParentId;this.newInputName=a.newInputName;a.newCoordinate&&(a=a.newCoordinate.split(","),this.newCoordinate=new Blockly.utils.Coordinate(Number(a[0]),Number(a[1])))};Blockly.Events.Move.prototype.recordNew=function(){var a=this.currentLocation_();this.newParentId=a.parentId;this.newInputName=a.inputName;this.newCoordinate=a.coordinate};
	Blockly.Events.Move.prototype.currentLocation_=function(){var a=this.getEventWorkspace_().getBlockById(this.blockId),b={},c=a.getParent();if(c){if(b.parentId=c.id,a=c.getInputWithBlock(a))b.inputName=a.name}else b.coordinate=a.getRelativeToSurfaceXY();return b};Blockly.Events.Move.prototype.isNull=function(){return this.oldParentId==this.newParentId&&this.oldInputName==this.newInputName&&Blockly.utils.Coordinate.equals(this.oldCoordinate,this.newCoordinate)};
	Blockly.Events.Move.prototype.run=function(a){var b=this.getEventWorkspace_(),c=b.getBlockById(this.blockId);if(c){var d=a?this.newParentId:this.oldParentId,e=a?this.newInputName:this.oldInputName;a=a?this.newCoordinate:this.oldCoordinate;var f=null;if(d&&(f=b.getBlockById(d),!f)){console.warn("Can't connect to non-existent block: "+d);return}c.getParent()&&c.unplug();if(a)e=c.getRelativeToSurfaceXY(),c.moveBy(a.x-e.x,a.y-e.y);else{c=c.outputConnection||c.previousConnection;if(e){if(b=f.getInput(e))var g=
	b.connection}else c.type==Blockly.PREVIOUS_STATEMENT&&(g=f.nextConnection);g?c.connect(g):console.warn("Can't connect to non-existent input: "+e)}}else console.warn("Can't move non-existent block: "+this.blockId)};Blockly.Events.FinishedLoading=function(a){this.workspaceId=a.id;this.group=Blockly.Events.getGroup();this.recordUndo=!1};Blockly.utils.object.inherits(Blockly.Events.FinishedLoading,Blockly.Events.Ui);Blockly.Events.FinishedLoading.prototype.type=Blockly.Events.FINISHED_LOADING;Blockly.Events.FinishedLoading.prototype.toJson=function(){var a={type:this.type};this.group&&(a.group=this.group);this.workspaceId&&(a.workspaceId=this.workspaceId);return a};
	Blockly.Events.FinishedLoading.prototype.fromJson=function(a){this.workspaceId=a.workspaceId;this.group=a.group};Blockly.Events.VarBase=function(a){Blockly.Events.VarBase.superClass_.constructor.call(this);this.varId=a.getId();this.workspaceId=a.workspace.id};Blockly.utils.object.inherits(Blockly.Events.VarBase,Blockly.Events.Abstract);Blockly.Events.VarBase.prototype.toJson=function(){var a=Blockly.Events.VarBase.superClass_.toJson.call(this);a.varId=this.varId;return a};Blockly.Events.VarBase.prototype.fromJson=function(a){Blockly.Events.VarBase.superClass_.toJson.call(this);this.varId=a.varId};
	Blockly.Events.VarCreate=function(a){a&&(Blockly.Events.VarCreate.superClass_.constructor.call(this,a),this.varType=a.type,this.varName=a.name)};Blockly.utils.object.inherits(Blockly.Events.VarCreate,Blockly.Events.VarBase);Blockly.Events.VarCreate.prototype.type=Blockly.Events.VAR_CREATE;Blockly.Events.VarCreate.prototype.toJson=function(){var a=Blockly.Events.VarCreate.superClass_.toJson.call(this);a.varType=this.varType;a.varName=this.varName;return a};
	Blockly.Events.VarCreate.prototype.fromJson=function(a){Blockly.Events.VarCreate.superClass_.fromJson.call(this,a);this.varType=a.varType;this.varName=a.varName};Blockly.Events.VarCreate.prototype.run=function(a){var b=this.getEventWorkspace_();a?b.createVariable(this.varName,this.varType,this.varId):b.deleteVariableById(this.varId)};Blockly.Events.VarDelete=function(a){a&&(Blockly.Events.VarDelete.superClass_.constructor.call(this,a),this.varType=a.type,this.varName=a.name)};
	Blockly.utils.object.inherits(Blockly.Events.VarDelete,Blockly.Events.VarBase);Blockly.Events.VarDelete.prototype.type=Blockly.Events.VAR_DELETE;Blockly.Events.VarDelete.prototype.toJson=function(){var a=Blockly.Events.VarDelete.superClass_.toJson.call(this);a.varType=this.varType;a.varName=this.varName;return a};Blockly.Events.VarDelete.prototype.fromJson=function(a){Blockly.Events.VarDelete.superClass_.fromJson.call(this,a);this.varType=a.varType;this.varName=a.varName};
	Blockly.Events.VarDelete.prototype.run=function(a){var b=this.getEventWorkspace_();a?b.deleteVariableById(this.varId):b.createVariable(this.varName,this.varType,this.varId)};Blockly.Events.VarRename=function(a,b){a&&(Blockly.Events.VarRename.superClass_.constructor.call(this,a),this.oldName=a.name,this.newName=b)};Blockly.utils.object.inherits(Blockly.Events.VarRename,Blockly.Events.VarBase);Blockly.Events.VarRename.prototype.type=Blockly.Events.VAR_RENAME;
	Blockly.Events.VarRename.prototype.toJson=function(){var a=Blockly.Events.VarRename.superClass_.toJson.call(this);a.oldName=this.oldName;a.newName=this.newName;return a};Blockly.Events.VarRename.prototype.fromJson=function(a){Blockly.Events.VarRename.superClass_.fromJson.call(this,a);this.oldName=a.oldName;this.newName=a.newName};Blockly.Events.VarRename.prototype.run=function(a){var b=this.getEventWorkspace_();a?b.renameVariableById(this.varId,this.newName):b.renameVariableById(this.varId,this.oldName)};Blockly.Xml={};Blockly.Xml.workspaceToDom=function(a,b){var c=Blockly.utils.xml.createElement("xml"),d=Blockly.Xml.variablesToDom(Blockly.Variables.allUsedVarModels(a));d.hasChildNodes()&&c.appendChild(d);var e=a.getTopComments(!0);d=0;for(var f;f=e[d];d++)c.appendChild(f.toXmlWithXY(b));a=a.getTopBlocks(!0);for(d=0;e=a[d];d++)c.appendChild(Blockly.Xml.blockToDomWithXY(e,b));return c};
	Blockly.Xml.variablesToDom=function(a){for(var b=Blockly.utils.xml.createElement("variables"),c=0,d;d=a[c];c++){var e=Blockly.utils.xml.createElement("variable");e.appendChild(Blockly.utils.xml.createTextNode(d.name));d.type&&e.setAttribute("type",d.type);e.id=d.getId();b.appendChild(e)}return b};
	Blockly.Xml.blockToDomWithXY=function(a,b){if(a.isInsertionMarker()&&(a=a.getChildren(!1)[0],!a))return new DocumentFragment;var c;a.workspace.RTL&&(c=a.workspace.getWidth());b=Blockly.Xml.blockToDom(a,b);var d=a.getRelativeToSurfaceXY();b.setAttribute("x",Math.round(a.workspace.RTL?c-d.x:d.x));b.setAttribute("y",Math.round(d.y));return b};Blockly.Xml.fieldToDom_=function(a){if(a.isSerializable()){var b=Blockly.utils.xml.createElement("field");b.setAttribute("name",a.name||"");return a.toXml(b)}return null};
	Blockly.Xml.allFieldsToDom_=function(a,b){for(var c=0,d;d=a.inputList[c];c++)for(var e=0,f;f=d.fieldRow[e];e++)(f=Blockly.Xml.fieldToDom_(f))&&b.appendChild(f)};
	Blockly.Xml.blockToDom=function(a,b){if(a.isInsertionMarker())return(a=a.getChildren(!1)[0])?Blockly.Xml.blockToDom(a):new DocumentFragment;var c=Blockly.utils.xml.createElement(a.isShadow()?"shadow":"block");c.setAttribute("type",a.type);b||c.setAttribute("id",a.id);if(a.mutationToDom){var d=a.mutationToDom();d&&(d.hasChildNodes()||d.hasAttributes())&&c.appendChild(d)}Blockly.Xml.allFieldsToDom_(a,c);if(d=a.getCommentText()){var e=a.commentModel.size,f=a.commentModel.pinned,g=Blockly.utils.xml.createElement("comment");
	g.appendChild(Blockly.utils.xml.createTextNode(d));g.setAttribute("pinned",f);g.setAttribute("h",e.height);g.setAttribute("w",e.width);c.appendChild(g)}a.data&&(d=Blockly.utils.xml.createElement("data"),d.appendChild(Blockly.utils.xml.createTextNode(a.data)),c.appendChild(d));for(d=0;e=a.inputList[d];d++){var h;f=!0;if(e.type!=Blockly.DUMMY_INPUT){var k=e.connection.targetBlock();e.type==Blockly.INPUT_VALUE?h=Blockly.utils.xml.createElement("value"):e.type==Blockly.NEXT_STATEMENT&&(h=Blockly.utils.xml.createElement("statement"));
	g=e.connection.getShadowDom();!g||k&&k.isShadow()||h.appendChild(Blockly.Xml.cloneShadow_(g,b));k&&(g=Blockly.Xml.blockToDom(k,b),g.nodeType==Blockly.utils.dom.NodeType.ELEMENT_NODE&&(h.appendChild(g),f=!1));h.setAttribute("name",e.name);f||c.appendChild(h)}}void 0!=a.inputsInline&&a.inputsInline!=a.inputsInlineDefault&&c.setAttribute("inline",a.inputsInline);a.isCollapsed()&&c.setAttribute("collapsed",!0);a.isEnabled()||c.setAttribute("disabled",!0);a.isDeletable()||a.isShadow()||c.setAttribute("deletable",
	!1);a.isMovable()||a.isShadow()||c.setAttribute("movable",!1);a.isEditable()||c.setAttribute("editable",!1);if(d=a.getNextBlock())g=Blockly.Xml.blockToDom(d,b),g.nodeType==Blockly.utils.dom.NodeType.ELEMENT_NODE&&(h=Blockly.utils.xml.createElement("next"),h.appendChild(g),c.appendChild(h));g=a.nextConnection&&a.nextConnection.getShadowDom();!g||d&&d.isShadow()||h.appendChild(Blockly.Xml.cloneShadow_(g,b));return c};
	Blockly.Xml.cloneShadow_=function(a,b){for(var c=a=a.cloneNode(!0),d;c;)if(b&&"shadow"==c.nodeName&&c.removeAttribute("id"),c.firstChild)c=c.firstChild;else{for(;c&&!c.nextSibling;)d=c,c=c.parentNode,d.nodeType==Blockly.utils.dom.NodeType.TEXT_NODE&&""==d.data.trim()&&c.firstChild!=d&&Blockly.utils.dom.removeNode(d);c&&(d=c,c=c.nextSibling,d.nodeType==Blockly.utils.dom.NodeType.TEXT_NODE&&""==d.data.trim()&&Blockly.utils.dom.removeNode(d))}return a};
	Blockly.Xml.domToText=function(a){a=Blockly.utils.xml.domToText(a);var b=/(<[^/](?:[^>]*[^/])?>[^<]*)\n([^<]*<\/)/;do{var c=a;a=a.replace(b,"$1&#10;$2")}while(a!=c);return a.replace(/<(\w+)([^<]*)\/>/g,"<$1$2></$1>")};
	Blockly.Xml.domToPrettyText=function(a){a=Blockly.Xml.domToText(a).split("<");for(var b="",c=1;c<a.length;c++){var d=a[c];"/"==d[0]&&(b=b.substring(2));a[c]=b+"<"+d;"/"!=d[0]&&"/>"!=d.slice(-2)&&(b+="  ")}a=a.join("\n");a=a.replace(/(<(\w+)\b[^>]*>[^\n]*)\n *<\/\2>/g,"$1</$2>");return a.replace(/^\n/,"")};
	Blockly.Xml.textToDom=function(a){var b=Blockly.utils.xml.textToDomDocument(a);if(!b||!b.documentElement||b.getElementsByTagName("parsererror").length)throw Error("textToDom was unable to parse: "+a);return b.documentElement};Blockly.Xml.clearWorkspaceAndLoadFromXml=function(a,b){b.setResizesEnabled(!1);b.clear();a=Blockly.Xml.domToWorkspace(a,b);b.setResizesEnabled(!0);return a};
	Blockly.Xml.domToWorkspace=function(a,b){if(a instanceof Blockly.Workspace){var c=a;a=b;b=c;console.warn("Deprecated call to Blockly.Xml.domToWorkspace, swap the arguments.")}var d;b.RTL&&(d=b.getWidth());c=[];Blockly.utils.dom.startTextWidthCache();var e=Blockly.Events.getGroup();e||Blockly.Events.setGroup(!0);b.setResizesEnabled&&b.setResizesEnabled(!1);var f=!0;try{for(var g=0,h;h=a.childNodes[g];g++){var k=h.nodeName.toLowerCase(),l=h;if("block"==k||"shadow"==k&&!Blockly.Events.recordUndo){var m=
	Blockly.Xml.domToBlock(l,b);c.push(m.id);var n=l.hasAttribute("x")?parseInt(l.getAttribute("x"),10):10,p=l.hasAttribute("y")?parseInt(l.getAttribute("y"),10):10;isNaN(n)||isNaN(p)||m.moveBy(b.RTL?d-n:n,p);f=!1}else{if("shadow"==k)throw TypeError("Shadow block cannot be a top-level block.");if("comment"==k)b.rendered?Blockly.WorkspaceCommentSvg?Blockly.WorkspaceCommentSvg.fromXml(l,b,d):console.warn("Missing require for Blockly.WorkspaceCommentSvg, ignoring workspace comment."):Blockly.WorkspaceComment?
	Blockly.WorkspaceComment.fromXml(l,b):console.warn("Missing require for Blockly.WorkspaceComment, ignoring workspace comment.");else if("variables"==k){if(f)Blockly.Xml.domToVariables(l,b);else throw Error("'variables' tag must exist once before block and shadow tag elements in the workspace XML, but it was found in another location.");f=!1}}}}finally{e||Blockly.Events.setGroup(!1),Blockly.utils.dom.stopTextWidthCache()}b.setResizesEnabled&&b.setResizesEnabled(!0);Blockly.Events.fire(new Blockly.Events.FinishedLoading(b));
	return c};Blockly.Xml.appendDomToWorkspace=function(a,b){var c;b.hasOwnProperty("scale")&&(c=b.getBlocksBoundingBox());a=Blockly.Xml.domToWorkspace(a,b);if(c&&c.top!=c.bottom){var d=c.bottom;var e=b.RTL?c.right:c.left;var f=Infinity,g=-Infinity,h=Infinity;for(c=0;c<a.length;c++){var k=b.getBlockById(a[c]).getRelativeToSurfaceXY();k.y<h&&(h=k.y);k.x<f&&(f=k.x);k.x>g&&(g=k.x)}d=d-h+10;e=b.RTL?e-g:e-f;for(c=0;c<a.length;c++)b.getBlockById(a[c]).moveBy(e,d)}return a};
	Blockly.Xml.domToBlock=function(a,b){if(a instanceof Blockly.Workspace){var c=a;a=b;b=c;console.warn("Deprecated call to Blockly.Xml.domToBlock, swap the arguments.")}Blockly.Events.disable();c=b.getAllVariables();try{var d=Blockly.Xml.domToBlockHeadless_(a,b),e=d.getDescendants(!1);if(b.rendered){d.setConnectionTracking(!1);for(var f=e.length-1;0<=f;f--)e[f].initSvg();for(f=e.length-1;0<=f;f--)e[f].render(!1);setTimeout(function(){d.disposed||d.setConnectionTracking(!0)},1);d.updateDisabled();b.resizeContents()}else for(f=
	e.length-1;0<=f;f--)e[f].initModel()}finally{Blockly.Events.enable()}if(Blockly.Events.isEnabled()){a=Blockly.Variables.getAddedVariables(b,c);for(f=0;f<a.length;f++)Blockly.Events.fire(new Blockly.Events.VarCreate(a[f]));Blockly.Events.fire(new Blockly.Events.BlockCreate(d))}return d};
	Blockly.Xml.domToVariables=function(a,b){for(var c=0,d;d=a.childNodes[c];c++)if(d.nodeType==Blockly.utils.dom.NodeType.ELEMENT_NODE){var e=d.getAttribute("type"),f=d.getAttribute("id");b.createVariable(d.textContent,e,f)}};
	Blockly.Xml.domToBlockHeadless_=function(a,b){var c=null,d=a.getAttribute("type");if(!d)throw TypeError("Block type unspecified: "+a.outerHTML);var e=a.getAttribute("id");c=b.newBlock(d,e);var f=null;e=0;for(var g;g=a.childNodes[e];e++)if(g.nodeType!=Blockly.utils.dom.NodeType.TEXT_NODE){var h=f=null;var k=0;for(var l;l=g.childNodes[k];k++)l.nodeType==Blockly.utils.dom.NodeType.ELEMENT_NODE&&("block"==l.nodeName.toLowerCase()?f=l:"shadow"==l.nodeName.toLowerCase()&&(h=l));!f&&h&&(f=h);l=g.getAttribute("name");
	k=g;switch(g.nodeName.toLowerCase()){case "mutation":c.domToMutation&&(c.domToMutation(k),c.initSvg&&c.initSvg());break;case "comment":if(!Blockly.Comment){console.warn("Missing require for Blockly.Comment, ignoring block comment.");break}f=k.textContent;h="true"==k.getAttribute("pinned");g=parseInt(k.getAttribute("w"),10);k=parseInt(k.getAttribute("h"),10);c.setCommentText(f);c.commentModel.pinned=h;isNaN(g)||isNaN(k)||(c.commentModel.size=new Blockly.utils.Size(g,k));h&&c.getCommentIcon&&!c.isInFlyout&&
	setTimeout(function(){c.getCommentIcon().setVisible(!0)},1);break;case "data":c.data=g.textContent;break;case "title":case "field":Blockly.Xml.domToField_(c,l,k);break;case "value":case "statement":k=c.getInput(l);if(!k){console.warn("Ignoring non-existent input "+l+" in block "+d);break}h&&k.connection.setShadowDom(h);if(f)if(f=Blockly.Xml.domToBlockHeadless_(f,b),f.outputConnection)k.connection.connect(f.outputConnection);else if(f.previousConnection)k.connection.connect(f.previousConnection);else throw TypeError("Child block does not have output or previous statement.");
	break;case "next":h&&c.nextConnection&&c.nextConnection.setShadowDom(h);if(f){if(!c.nextConnection)throw TypeError("Next statement does not exist.");if(c.nextConnection.isConnected())throw TypeError("Next statement is already connected.");f=Blockly.Xml.domToBlockHeadless_(f,b);if(!f.previousConnection)throw TypeError("Next block does not have previous statement.");c.nextConnection.connect(f.previousConnection)}break;default:console.warn("Ignoring unknown tag: "+g.nodeName)}}(e=a.getAttribute("inline"))&&
	c.setInputsInline("true"==e);(e=a.getAttribute("disabled"))&&c.setEnabled("true"!=e&&"disabled"!=e);(e=a.getAttribute("deletable"))&&c.setDeletable("true"==e);(e=a.getAttribute("movable"))&&c.setMovable("true"==e);(e=a.getAttribute("editable"))&&c.setEditable("true"==e);(e=a.getAttribute("collapsed"))&&c.setCollapsed("true"==e);if("shadow"==a.nodeName.toLowerCase()){a=c.getChildren(!1);for(e=0;b=a[e];e++)if(!b.isShadow())throw TypeError("Shadow block not allowed non-shadow child.");if(c.getVarModels().length)throw TypeError("Shadow blocks cannot have variable references.");
	c.setShadow(!0)}return c};Blockly.Xml.domToField_=function(a,b,c){var d=a.getField(b);d?d.fromXml(c):console.warn("Ignoring non-existent field "+b+" in block "+a.type)};Blockly.Xml.deleteNext=function(a){for(var b=0,c;c=a.childNodes[b];b++)if("next"==c.nodeName.toLowerCase()){a.removeChild(c);break}};Blockly.Options=function(a){var b=!!a.readOnly;if(b)var c=null,d=!1,e=!1,f=!1,g=!1,h=!1,k=!1;else{c=a.toolbox;Array.isArray(c)||(c=Blockly.Options.parseToolboxTree(c||null));c=Blockly.utils.toolbox.convertToolboxToJSON(c);d=Blockly.utils.toolbox.hasCategories(c);e=a.trashcan;void 0===e&&(e=d);var l=a.maxTrashcanContents;e?void 0===l&&(l=32):l=0;f=a.collapse;void 0===f&&(f=d);g=a.comments;void 0===g&&(g=d);h=a.disable;void 0===h&&(h=d);k=a.sounds;void 0===k&&(k=!0)}var m=!!a.rtl,n=a.horizontalLayout;
	void 0===n&&(n=!1);var p=a.toolboxPosition;p="end"!==p;p=n?p?Blockly.TOOLBOX_AT_TOP:Blockly.TOOLBOX_AT_BOTTOM:p==m?Blockly.TOOLBOX_AT_RIGHT:Blockly.TOOLBOX_AT_LEFT;var q=a.css;void 0===q&&(q=!0);var r="https://blockly-demo.appspot.com/static/media/";a.media?r=a.media:a.path&&(r=a.path+"media/");var t=void 0===a.oneBasedIndex?!0:!!a.oneBasedIndex,u=a.keyMap||Blockly.user.keyMap.createDefaultKeyMap(),v=a.renderer||"geras",w=a.plugins||{};this.RTL=m;this.oneBasedIndex=t;this.collapse=f;this.comments=
	g;this.disable=h;this.readOnly=b;this.maxBlocks=a.maxBlocks||Infinity;this.maxInstances=a.maxInstances;this.pathToMedia=r;this.hasCategories=d;this.moveOptions=Blockly.Options.parseMoveOptions(a,d);this.hasScrollbars=this.moveOptions.scrollbars;this.hasTrashcan=e;this.maxTrashcanContents=l;this.hasSounds=k;this.hasCss=q;this.horizontalLayout=n;this.languageTree=c;this.gridOptions=Blockly.Options.parseGridOptions_(a);this.zoomOptions=Blockly.Options.parseZoomOptions_(a);this.toolboxPosition=p;this.theme=
	Blockly.Options.parseThemeOptions_(a);this.keyMap=u;this.renderer=v;this.rendererOverrides=a.rendererOverrides;this.gridPattern=null;this.parentWorkspace=a.parentWorkspace;this.plugins=w};Blockly.BlocklyOptions=function(){};Blockly.Options.parseMoveOptions=function(a,b){var c=a.move||{},d={};d.scrollbars=void 0===c.scrollbars&&void 0===a.scrollbars?b:!!c.scrollbars||!!a.scrollbars;d.wheel=d.scrollbars&&void 0!==c.wheel?!!c.wheel:!1;d.drag=d.scrollbars?void 0===c.drag?!0:!!c.drag:!1;return d};
	Blockly.Options.parseZoomOptions_=function(a){a=a.zoom||{};var b={};b.controls=void 0===a.controls?!1:!!a.controls;b.wheel=void 0===a.wheel?!1:!!a.wheel;b.startScale=void 0===a.startScale?1:Number(a.startScale);b.maxScale=void 0===a.maxScale?3:Number(a.maxScale);b.minScale=void 0===a.minScale?.3:Number(a.minScale);b.scaleSpeed=void 0===a.scaleSpeed?1.2:Number(a.scaleSpeed);b.pinch=void 0===a.pinch?b.wheel||b.controls:!!a.pinch;return b};
	Blockly.Options.parseGridOptions_=function(a){a=a.grid||{};var b={};b.spacing=Number(a.spacing)||0;b.colour=a.colour||"#888";b.length=void 0===a.length?1:Number(a.length);b.snap=0<b.spacing&&!!a.snap;return b};Blockly.Options.parseThemeOptions_=function(a){a=a.theme||Blockly.Themes.Classic;return"string"==typeof a?Blockly.registry.getObject(Blockly.registry.Type.THEME,a):a instanceof Blockly.Theme?a:Blockly.Theme.defineTheme(a.name||"builtin"+Blockly.utils.IdGenerator.getNextUniqueId(),a)};
	Blockly.Options.parseToolboxTree=function(a){if(a){if("string"!=typeof a&&(Blockly.utils.userAgent.IE&&a.outerHTML?a=a.outerHTML:a instanceof Element||(a=null)),"string"==typeof a&&(a=Blockly.Xml.textToDom(a),"xml"!=a.nodeName.toLowerCase()))throw TypeError("Toolbox should be an <xml> document.");}else a=null;return a};Blockly.Touch={};Blockly.Touch.TOUCH_ENABLED="ontouchstart"in Blockly.utils.global||!!(Blockly.utils.global.document&&document.documentElement&&"ontouchstart"in document.documentElement)||!(!Blockly.utils.global.navigator||!Blockly.utils.global.navigator.maxTouchPoints&&!Blockly.utils.global.navigator.msMaxTouchPoints);Blockly.Touch.touchIdentifier_=null;Blockly.Touch.TOUCH_MAP={};
	Blockly.utils.global.PointerEvent?Blockly.Touch.TOUCH_MAP={mousedown:["pointerdown"],mouseenter:["pointerenter"],mouseleave:["pointerleave"],mousemove:["pointermove"],mouseout:["pointerout"],mouseover:["pointerover"],mouseup:["pointerup","pointercancel"],touchend:["pointerup"],touchcancel:["pointercancel"]}:Blockly.Touch.TOUCH_ENABLED&&(Blockly.Touch.TOUCH_MAP={mousedown:["touchstart"],mousemove:["touchmove"],mouseup:["touchend","touchcancel"]});Blockly.longPid_=0;
	Blockly.longStart=function(a,b){Blockly.longStop_();a.changedTouches&&1!=a.changedTouches.length||(Blockly.longPid_=setTimeout(function(){a.changedTouches&&(a.button=2,a.clientX=a.changedTouches[0].clientX,a.clientY=a.changedTouches[0].clientY);b&&b.handleRightClick(a)},Blockly.LONGPRESS))};Blockly.longStop_=function(){Blockly.longPid_&&(clearTimeout(Blockly.longPid_),Blockly.longPid_=0)};Blockly.Touch.clearTouchIdentifier=function(){Blockly.Touch.touchIdentifier_=null};
	Blockly.Touch.shouldHandleEvent=function(a){return!Blockly.Touch.isMouseOrTouchEvent(a)||Blockly.Touch.checkTouchIdentifier(a)};Blockly.Touch.getTouchIdentifierFromEvent=function(a){return void 0!=a.pointerId?a.pointerId:a.changedTouches&&a.changedTouches[0]&&void 0!==a.changedTouches[0].identifier&&null!==a.changedTouches[0].identifier?a.changedTouches[0].identifier:"mouse"};
	Blockly.Touch.checkTouchIdentifier=function(a){var b=Blockly.Touch.getTouchIdentifierFromEvent(a);return void 0!==Blockly.Touch.touchIdentifier_&&null!==Blockly.Touch.touchIdentifier_?Blockly.Touch.touchIdentifier_==b:"mousedown"==a.type||"touchstart"==a.type||"pointerdown"==a.type?(Blockly.Touch.touchIdentifier_=b,!0):!1};Blockly.Touch.setClientFromTouch=function(a){if(Blockly.utils.string.startsWith(a.type,"touch")){var b=a.changedTouches[0];a.clientX=b.clientX;a.clientY=b.clientY}};
	Blockly.Touch.isMouseOrTouchEvent=function(a){return Blockly.utils.string.startsWith(a.type,"touch")||Blockly.utils.string.startsWith(a.type,"mouse")||Blockly.utils.string.startsWith(a.type,"pointer")};Blockly.Touch.isTouchEvent=function(a){return Blockly.utils.string.startsWith(a.type,"touch")||Blockly.utils.string.startsWith(a.type,"pointer")};
	Blockly.Touch.splitEventByTouches=function(a){var b=[];if(a.changedTouches)for(var c=0;c<a.changedTouches.length;c++)b[c]={type:a.type,changedTouches:[a.changedTouches[c]],target:a.target,stopPropagation:function(){a.stopPropagation()},preventDefault:function(){a.preventDefault()}};else b.push(a);return b};Blockly.ScrollbarPair=function(a){this.workspace_=a;this.hScroll=new Blockly.Scrollbar(a,!0,!0,"blocklyMainWorkspaceScrollbar");this.vScroll=new Blockly.Scrollbar(a,!1,!0,"blocklyMainWorkspaceScrollbar");this.corner_=Blockly.utils.dom.createSvgElement("rect",{height:Blockly.Scrollbar.scrollbarThickness,width:Blockly.Scrollbar.scrollbarThickness,"class":"blocklyScrollbarBackground"},null);Blockly.utils.dom.insertAfter(this.corner_,a.getBubbleCanvas());this.oldHostMetrics_=null};
	Blockly.ScrollbarPair.prototype.dispose=function(){Blockly.utils.dom.removeNode(this.corner_);this.oldHostMetrics_=this.workspace_=this.corner_=null;this.hScroll.dispose();this.hScroll=null;this.vScroll.dispose();this.vScroll=null};
	Blockly.ScrollbarPair.prototype.resize=function(){var a=this.workspace_.getMetrics();if(a){var b=!1,c=!1;this.oldHostMetrics_&&this.oldHostMetrics_.viewWidth==a.viewWidth&&this.oldHostMetrics_.viewHeight==a.viewHeight&&this.oldHostMetrics_.absoluteTop==a.absoluteTop&&this.oldHostMetrics_.absoluteLeft==a.absoluteLeft?(this.oldHostMetrics_&&this.oldHostMetrics_.contentWidth==a.contentWidth&&this.oldHostMetrics_.viewLeft==a.viewLeft&&this.oldHostMetrics_.contentLeft==a.contentLeft||(b=!0),this.oldHostMetrics_&&
	this.oldHostMetrics_.contentHeight==a.contentHeight&&this.oldHostMetrics_.viewTop==a.viewTop&&this.oldHostMetrics_.contentTop==a.contentTop||(c=!0)):c=b=!0;b&&this.hScroll.resize(a);c&&this.vScroll.resize(a);this.oldHostMetrics_&&this.oldHostMetrics_.viewWidth==a.viewWidth&&this.oldHostMetrics_.absoluteLeft==a.absoluteLeft||this.corner_.setAttribute("x",this.vScroll.position.x);this.oldHostMetrics_&&this.oldHostMetrics_.viewHeight==a.viewHeight&&this.oldHostMetrics_.absoluteTop==a.absoluteTop||this.corner_.setAttribute("y",
	this.hScroll.position.y);this.oldHostMetrics_=a}};Blockly.ScrollbarPair.prototype.set=function(a,b){var c={};a*=this.hScroll.ratio;b*=this.vScroll.ratio;var d=this.vScroll.scrollViewSize_;c.x=this.getRatio_(a,this.hScroll.scrollViewSize_);c.y=this.getRatio_(b,d);this.workspace_.setMetrics(c);this.hScroll.setHandlePosition(a);this.vScroll.setHandlePosition(b)};Blockly.ScrollbarPair.prototype.getRatio_=function(a,b){a/=b;return isNaN(a)?0:a};
	Blockly.Scrollbar=function(a,b,c,d){this.workspace_=a;this.pair_=c||!1;this.horizontal_=b;this.ratio=this.oldHostMetrics_=null;this.createDom_(d);this.position=new Blockly.utils.Coordinate(0,0);a=Blockly.Scrollbar.scrollbarThickness;b?(this.svgBackground_.setAttribute("height",a),this.outerSvg_.setAttribute("height",a),this.svgHandle_.setAttribute("height",a-5),this.svgHandle_.setAttribute("y",2.5),this.lengthAttribute_="width",this.positionAttribute_="x"):(this.svgBackground_.setAttribute("width",
	a),this.outerSvg_.setAttribute("width",a),this.svgHandle_.setAttribute("width",a-5),this.svgHandle_.setAttribute("x",2.5),this.lengthAttribute_="height",this.positionAttribute_="y");this.onMouseDownBarWrapper_=Blockly.bindEventWithChecks_(this.svgBackground_,"mousedown",this,this.onMouseDownBar_);this.onMouseDownHandleWrapper_=Blockly.bindEventWithChecks_(this.svgHandle_,"mousedown",this,this.onMouseDownHandle_)};Blockly.Scrollbar.prototype.origin_=new Blockly.utils.Coordinate(0,0);
	Blockly.Scrollbar.prototype.startDragMouse_=0;Blockly.Scrollbar.prototype.scrollViewSize_=0;Blockly.Scrollbar.prototype.handleLength_=0;Blockly.Scrollbar.prototype.handlePosition_=0;Blockly.Scrollbar.prototype.isVisible_=!0;Blockly.Scrollbar.prototype.containerVisible_=!0;Blockly.Scrollbar.scrollbarThickness=15;Blockly.Touch.TOUCH_ENABLED&&(Blockly.Scrollbar.scrollbarThickness=25);
	Blockly.Scrollbar.metricsAreEquivalent_=function(a,b){return a&&b&&a.viewWidth==b.viewWidth&&a.viewHeight==b.viewHeight&&a.viewLeft==b.viewLeft&&a.viewTop==b.viewTop&&a.absoluteTop==b.absoluteTop&&a.absoluteLeft==b.absoluteLeft&&a.contentWidth==b.contentWidth&&a.contentHeight==b.contentHeight&&a.contentLeft==b.contentLeft&&a.contentTop==b.contentTop?!0:!1};
	Blockly.Scrollbar.prototype.dispose=function(){this.cleanUp_();Blockly.unbindEvent_(this.onMouseDownBarWrapper_);this.onMouseDownBarWrapper_=null;Blockly.unbindEvent_(this.onMouseDownHandleWrapper_);this.onMouseDownHandleWrapper_=null;Blockly.utils.dom.removeNode(this.outerSvg_);this.svgBackground_=this.svgGroup_=this.outerSvg_=null;this.svgHandle_&&(this.workspace_.getThemeManager().unsubscribe(this.svgHandle_),this.svgHandle_=null);this.workspace_=null};
	Blockly.Scrollbar.prototype.setHandleLength_=function(a){this.handleLength_=a;this.svgHandle_.setAttribute(this.lengthAttribute_,this.handleLength_)};Blockly.Scrollbar.prototype.setHandlePosition=function(a){this.handlePosition_=a;this.svgHandle_.setAttribute(this.positionAttribute_,this.handlePosition_)};
	Blockly.Scrollbar.prototype.setScrollViewSize_=function(a){this.scrollViewSize_=a;this.outerSvg_.setAttribute(this.lengthAttribute_,this.scrollViewSize_);this.svgBackground_.setAttribute(this.lengthAttribute_,this.scrollViewSize_)};Blockly.ScrollbarPair.prototype.setContainerVisible=function(a){this.hScroll.setContainerVisible(a);this.vScroll.setContainerVisible(a)};
	Blockly.Scrollbar.prototype.setPosition=function(a,b){this.position.x=a;this.position.y=b;Blockly.utils.dom.setCssTransform(this.outerSvg_,"translate("+(this.position.x+this.origin_.x)+"px,"+(this.position.y+this.origin_.y)+"px)")};Blockly.Scrollbar.prototype.resize=function(a){if(!a&&(a=this.workspace_.getMetrics(),!a))return;Blockly.Scrollbar.metricsAreEquivalent_(a,this.oldHostMetrics_)||(this.oldHostMetrics_=a,this.horizontal_?this.resizeHorizontal_(a):this.resizeVertical_(a),this.onScroll_())};
	Blockly.Scrollbar.prototype.resizeHorizontal_=function(a){this.resizeViewHorizontal(a)};Blockly.Scrollbar.prototype.resizeViewHorizontal=function(a){var b=a.viewWidth-1;this.pair_&&(b-=Blockly.Scrollbar.scrollbarThickness);this.setScrollViewSize_(Math.max(0,b));b=a.absoluteLeft+.5;this.pair_&&this.workspace_.RTL&&(b+=Blockly.Scrollbar.scrollbarThickness);this.setPosition(b,a.absoluteTop+a.viewHeight-Blockly.Scrollbar.scrollbarThickness-.5);this.resizeContentHorizontal(a)};
	Blockly.Scrollbar.prototype.resizeContentHorizontal=function(a){this.pair_||this.setVisible(this.scrollViewSize_<a.contentWidth);this.ratio=this.scrollViewSize_/a.contentWidth;if(-Infinity==this.ratio||Infinity==this.ratio||isNaN(this.ratio))this.ratio=0;this.setHandleLength_(Math.max(0,a.viewWidth*this.ratio));this.setHandlePosition(this.constrainHandle_((a.viewLeft-a.contentLeft)*this.ratio))};Blockly.Scrollbar.prototype.resizeVertical_=function(a){this.resizeViewVertical(a)};
	Blockly.Scrollbar.prototype.resizeViewVertical=function(a){var b=a.viewHeight-1;this.pair_&&(b-=Blockly.Scrollbar.scrollbarThickness);this.setScrollViewSize_(Math.max(0,b));b=a.absoluteLeft+.5;this.workspace_.RTL||(b+=a.viewWidth-Blockly.Scrollbar.scrollbarThickness-1);this.setPosition(b,a.absoluteTop+.5);this.resizeContentVertical(a)};
	Blockly.Scrollbar.prototype.resizeContentVertical=function(a){this.pair_||this.setVisible(this.scrollViewSize_<a.contentHeight);this.ratio=this.scrollViewSize_/a.contentHeight;if(-Infinity==this.ratio||Infinity==this.ratio||isNaN(this.ratio))this.ratio=0;this.setHandleLength_(Math.max(0,a.viewHeight*this.ratio));this.setHandlePosition(this.constrainHandle_((a.viewTop-a.contentTop)*this.ratio))};
	Blockly.Scrollbar.prototype.createDom_=function(a){var b="blocklyScrollbar"+(this.horizontal_?"Horizontal":"Vertical");a&&(b+=" "+a);this.outerSvg_=Blockly.utils.dom.createSvgElement("svg",{"class":b},null);this.svgGroup_=Blockly.utils.dom.createSvgElement("g",{},this.outerSvg_);this.svgBackground_=Blockly.utils.dom.createSvgElement("rect",{"class":"blocklyScrollbarBackground"},this.svgGroup_);a=Math.floor((Blockly.Scrollbar.scrollbarThickness-5)/2);this.svgHandle_=Blockly.utils.dom.createSvgElement("rect",
	{"class":"blocklyScrollbarHandle",rx:a,ry:a},this.svgGroup_);this.workspace_.getThemeManager().subscribe(this.svgHandle_,"scrollbarColour","fill");this.workspace_.getThemeManager().subscribe(this.svgHandle_,"scrollbarOpacity","fill-opacity");Blockly.utils.dom.insertAfter(this.outerSvg_,this.workspace_.getParentSvg())};Blockly.Scrollbar.prototype.isVisible=function(){return this.isVisible_};
	Blockly.Scrollbar.prototype.setContainerVisible=function(a){var b=a!=this.containerVisible_;this.containerVisible_=a;b&&this.updateDisplay_()};Blockly.Scrollbar.prototype.setVisible=function(a){var b=a!=this.isVisible();if(this.pair_)throw Error("Unable to toggle visibility of paired scrollbars.");this.isVisible_=a;b&&this.updateDisplay_()};
	Blockly.Scrollbar.prototype.updateDisplay_=function(){this.containerVisible_&&this.isVisible()?this.outerSvg_.setAttribute("display","block"):this.outerSvg_.setAttribute("display","none")};
	Blockly.Scrollbar.prototype.onMouseDownBar_=function(a){this.workspace_.markFocused();Blockly.Touch.clearTouchIdentifier();this.cleanUp_();if(Blockly.utils.isRightButton(a))a.stopPropagation();else{var b=Blockly.utils.mouseToSvg(a,this.workspace_.getParentSvg(),this.workspace_.getInverseScreenCTM());b=this.horizontal_?b.x:b.y;var c=Blockly.utils.getInjectionDivXY_(this.svgHandle_);c=this.horizontal_?c.x:c.y;var d=this.handlePosition_,e=.95*this.handleLength_;b<=c?d-=e:b>=c+this.handleLength_&&(d+=
	e);this.setHandlePosition(this.constrainHandle_(d));this.onScroll_();a.stopPropagation();a.preventDefault()}};
	Blockly.Scrollbar.prototype.onMouseDownHandle_=function(a){this.workspace_.markFocused();this.cleanUp_();Blockly.utils.isRightButton(a)?a.stopPropagation():(this.startDragHandle=this.handlePosition_,this.workspace_.setupDragSurface(),this.startDragMouse_=this.horizontal_?a.clientX:a.clientY,Blockly.Scrollbar.onMouseUpWrapper_=Blockly.bindEventWithChecks_(document,"mouseup",this,this.onMouseUpHandle_),Blockly.Scrollbar.onMouseMoveWrapper_=Blockly.bindEventWithChecks_(document,"mousemove",this,this.onMouseMoveHandle_),
	a.stopPropagation(),a.preventDefault())};Blockly.Scrollbar.prototype.onMouseMoveHandle_=function(a){this.setHandlePosition(this.constrainHandle_(this.startDragHandle+((this.horizontal_?a.clientX:a.clientY)-this.startDragMouse_)));this.onScroll_()};Blockly.Scrollbar.prototype.onMouseUpHandle_=function(){this.workspace_.resetDragSurface();Blockly.Touch.clearTouchIdentifier();this.cleanUp_()};
	Blockly.Scrollbar.prototype.cleanUp_=function(){Blockly.hideChaff(!0);Blockly.Scrollbar.onMouseUpWrapper_&&(Blockly.unbindEvent_(Blockly.Scrollbar.onMouseUpWrapper_),Blockly.Scrollbar.onMouseUpWrapper_=null);Blockly.Scrollbar.onMouseMoveWrapper_&&(Blockly.unbindEvent_(Blockly.Scrollbar.onMouseMoveWrapper_),Blockly.Scrollbar.onMouseMoveWrapper_=null)};
	Blockly.Scrollbar.prototype.constrainHandle_=function(a){return a=0>=a||isNaN(a)||this.scrollViewSize_<this.handleLength_?0:Math.min(a,this.scrollViewSize_-this.handleLength_)};Blockly.Scrollbar.prototype.onScroll_=function(){var a=this.handlePosition_/this.scrollViewSize_;isNaN(a)&&(a=0);var b={};this.horizontal_?b.x=a:b.y=a;this.workspace_.setMetrics(b)};Blockly.Scrollbar.prototype.set=function(a){this.setHandlePosition(this.constrainHandle_(a*this.ratio));this.onScroll_()};
	Blockly.Scrollbar.prototype.setOrigin=function(a,b){this.origin_=new Blockly.utils.Coordinate(a,b)};Blockly.Tooltip={};Blockly.Tooltip.visible=!1;Blockly.Tooltip.blocked_=!1;Blockly.Tooltip.LIMIT=50;Blockly.Tooltip.mouseOutPid_=0;Blockly.Tooltip.showPid_=0;Blockly.Tooltip.lastX_=0;Blockly.Tooltip.lastY_=0;Blockly.Tooltip.element_=null;Blockly.Tooltip.poisonedElement_=null;Blockly.Tooltip.OFFSET_X=0;Blockly.Tooltip.OFFSET_Y=10;Blockly.Tooltip.RADIUS_OK=10;Blockly.Tooltip.HOVER_MS=750;Blockly.Tooltip.MARGINS=5;Blockly.Tooltip.DIV=null;
	Blockly.Tooltip.createDom=function(){Blockly.Tooltip.DIV||(Blockly.Tooltip.DIV=document.createElement("div"),Blockly.Tooltip.DIV.className="blocklyTooltipDiv",(Blockly.parentContainer||document.body).appendChild(Blockly.Tooltip.DIV))};
	Blockly.Tooltip.bindMouseEvents=function(a){a.mouseOverWrapper_=Blockly.bindEvent_(a,"mouseover",null,Blockly.Tooltip.onMouseOver_);a.mouseOutWrapper_=Blockly.bindEvent_(a,"mouseout",null,Blockly.Tooltip.onMouseOut_);a.addEventListener("mousemove",Blockly.Tooltip.onMouseMove_,!1)};Blockly.Tooltip.unbindMouseEvents=function(a){a&&(Blockly.unbindEvent_(a.mouseOverWrapper_),Blockly.unbindEvent_(a.mouseOutWrapper_),a.removeEventListener("mousemove",Blockly.Tooltip.onMouseMove_))};
	Blockly.Tooltip.onMouseOver_=function(a){if(!Blockly.Tooltip.blocked_){for(a=a.currentTarget;"string"!=typeof a.tooltip&&"function"!=typeof a.tooltip;)a=a.tooltip;Blockly.Tooltip.element_!=a&&(Blockly.Tooltip.hide(),Blockly.Tooltip.poisonedElement_=null,Blockly.Tooltip.element_=a);clearTimeout(Blockly.Tooltip.mouseOutPid_)}};
	Blockly.Tooltip.onMouseOut_=function(a){Blockly.Tooltip.blocked_||(Blockly.Tooltip.mouseOutPid_=setTimeout(function(){Blockly.Tooltip.element_=null;Blockly.Tooltip.poisonedElement_=null;Blockly.Tooltip.hide()},1),clearTimeout(Blockly.Tooltip.showPid_))};
	Blockly.Tooltip.onMouseMove_=function(a){if(Blockly.Tooltip.element_&&Blockly.Tooltip.element_.tooltip&&!Blockly.Tooltip.blocked_)if(Blockly.Tooltip.visible){var b=Blockly.Tooltip.lastX_-a.pageX;a=Blockly.Tooltip.lastY_-a.pageY;Math.sqrt(b*b+a*a)>Blockly.Tooltip.RADIUS_OK&&Blockly.Tooltip.hide()}else Blockly.Tooltip.poisonedElement_!=Blockly.Tooltip.element_&&(clearTimeout(Blockly.Tooltip.showPid_),Blockly.Tooltip.lastX_=a.pageX,Blockly.Tooltip.lastY_=a.pageY,Blockly.Tooltip.showPid_=setTimeout(Blockly.Tooltip.show_,
	Blockly.Tooltip.HOVER_MS))};Blockly.Tooltip.dispose=function(){Blockly.Tooltip.element_=null;Blockly.Tooltip.poisonedElement_=null;Blockly.Tooltip.hide()};Blockly.Tooltip.hide=function(){Blockly.Tooltip.visible&&(Blockly.Tooltip.visible=!1,Blockly.Tooltip.DIV&&(Blockly.Tooltip.DIV.style.display="none"));Blockly.Tooltip.showPid_&&clearTimeout(Blockly.Tooltip.showPid_)};Blockly.Tooltip.block=function(){Blockly.Tooltip.hide();Blockly.Tooltip.blocked_=!0};
	Blockly.Tooltip.unblock=function(){Blockly.Tooltip.blocked_=!1};
	Blockly.Tooltip.show_=function(){if(!Blockly.Tooltip.blocked_&&(Blockly.Tooltip.poisonedElement_=Blockly.Tooltip.element_,Blockly.Tooltip.DIV)){Blockly.Tooltip.DIV.textContent="";for(var a=Blockly.Tooltip.element_.tooltip;"function"==typeof a;)a=a();a=Blockly.utils.string.wrap(a,Blockly.Tooltip.LIMIT);a=a.split("\n");for(var b=0;b<a.length;b++){var c=document.createElement("div");c.appendChild(document.createTextNode(a[b]));Blockly.Tooltip.DIV.appendChild(c)}a=Blockly.Tooltip.element_.RTL;b=document.documentElement.clientWidth;
	c=document.documentElement.clientHeight;Blockly.Tooltip.DIV.style.direction=a?"rtl":"ltr";Blockly.Tooltip.DIV.style.display="block";Blockly.Tooltip.visible=!0;var d=Blockly.Tooltip.lastX_;d=a?d-(Blockly.Tooltip.OFFSET_X+Blockly.Tooltip.DIV.offsetWidth):d+Blockly.Tooltip.OFFSET_X;var e=Blockly.Tooltip.lastY_+Blockly.Tooltip.OFFSET_Y;e+Blockly.Tooltip.DIV.offsetHeight>c+window.scrollY&&(e-=Blockly.Tooltip.DIV.offsetHeight+2*Blockly.Tooltip.OFFSET_Y);a?d=Math.max(Blockly.Tooltip.MARGINS-window.scrollX,
	d):d+Blockly.Tooltip.DIV.offsetWidth>b+window.scrollX-2*Blockly.Tooltip.MARGINS&&(d=b-Blockly.Tooltip.DIV.offsetWidth-2*Blockly.Tooltip.MARGINS);Blockly.Tooltip.DIV.style.top=e+"px";Blockly.Tooltip.DIV.style.left=d+"px"}};Blockly.WorkspaceDragSurfaceSvg=function(a){this.container_=a;this.createDom()};Blockly.WorkspaceDragSurfaceSvg.prototype.SVG_=null;Blockly.WorkspaceDragSurfaceSvg.prototype.container_=null;
	Blockly.WorkspaceDragSurfaceSvg.prototype.createDom=function(){this.SVG_||(this.SVG_=Blockly.utils.dom.createSvgElement("svg",{xmlns:Blockly.utils.dom.SVG_NS,"xmlns:html":Blockly.utils.dom.HTML_NS,"xmlns:xlink":Blockly.utils.dom.XLINK_NS,version:"1.1","class":"blocklyWsDragSurface blocklyOverflowVisible"},null),this.container_.appendChild(this.SVG_))};
	Blockly.WorkspaceDragSurfaceSvg.prototype.translateSurface=function(a,b){a=a.toFixed(0);b=b.toFixed(0);this.SVG_.style.display="block";Blockly.utils.dom.setCssTransform(this.SVG_,"translate3d("+a+"px, "+b+"px, 0px)")};Blockly.WorkspaceDragSurfaceSvg.prototype.getSurfaceTranslation=function(){return Blockly.utils.getRelativeXY(this.SVG_)};
	Blockly.WorkspaceDragSurfaceSvg.prototype.clearAndHide=function(a){if(!a)throw Error("Couldn't clear and hide the drag surface: missing new surface.");var b=this.SVG_.childNodes[0],c=this.SVG_.childNodes[1];if(!(b&&c&&Blockly.utils.dom.hasClass(b,"blocklyBlockCanvas")&&Blockly.utils.dom.hasClass(c,"blocklyBubbleCanvas")))throw Error("Couldn't clear and hide the drag surface. A node was missing.");null!=this.previousSibling_?Blockly.utils.dom.insertAfter(b,this.previousSibling_):a.insertBefore(b,a.firstChild);
	Blockly.utils.dom.insertAfter(c,b);this.SVG_.style.display="none";if(this.SVG_.childNodes.length)throw Error("Drag surface was not cleared.");Blockly.utils.dom.setCssTransform(this.SVG_,"");this.previousSibling_=null};
	Blockly.WorkspaceDragSurfaceSvg.prototype.setContentsAndShow=function(a,b,c,d,e,f){if(this.SVG_.childNodes.length)throw Error("Already dragging a block.");this.previousSibling_=c;a.setAttribute("transform","translate(0, 0) scale("+f+")");b.setAttribute("transform","translate(0, 0) scale("+f+")");this.SVG_.setAttribute("width",d);this.SVG_.setAttribute("height",e);this.SVG_.appendChild(a);this.SVG_.appendChild(b);this.SVG_.style.display="block"};Blockly.ASTNode=function(a,b,c){if(!b)throw Error("Cannot create a node without a location.");this.type_=a;this.isConnection_=Blockly.ASTNode.isConnectionType_(a);this.location_=b;this.wsCoordinate_=null;this.processParams_(c||null)};Blockly.ASTNode.types={FIELD:"field",BLOCK:"block",INPUT:"input",OUTPUT:"output",NEXT:"next",PREVIOUS:"previous",STACK:"stack",WORKSPACE:"workspace"};Blockly.ASTNode.NAVIGATE_ALL_FIELDS=!1;Blockly.ASTNode.DEFAULT_OFFSET_Y=-20;Blockly.ASTNode.isConnectionType_=function(a){switch(a){case Blockly.ASTNode.types.PREVIOUS:case Blockly.ASTNode.types.NEXT:case Blockly.ASTNode.types.INPUT:case Blockly.ASTNode.types.OUTPUT:return!0}return!1};
	Blockly.ASTNode.createFieldNode=function(a){return a?new Blockly.ASTNode(Blockly.ASTNode.types.FIELD,a):null};
	Blockly.ASTNode.createConnectionNode=function(a){return a?a.type==Blockly.INPUT_VALUE||a.type==Blockly.NEXT_STATEMENT&&a.getParentInput()?Blockly.ASTNode.createInputNode(a.getParentInput()):a.type==Blockly.NEXT_STATEMENT?new Blockly.ASTNode(Blockly.ASTNode.types.NEXT,a):a.type==Blockly.OUTPUT_VALUE?new Blockly.ASTNode(Blockly.ASTNode.types.OUTPUT,a):a.type==Blockly.PREVIOUS_STATEMENT?new Blockly.ASTNode(Blockly.ASTNode.types.PREVIOUS,a):null:null};
	Blockly.ASTNode.createInputNode=function(a){return a&&a.connection?new Blockly.ASTNode(Blockly.ASTNode.types.INPUT,a.connection):null};Blockly.ASTNode.createBlockNode=function(a){return a?new Blockly.ASTNode(Blockly.ASTNode.types.BLOCK,a):null};Blockly.ASTNode.createStackNode=function(a){return a?new Blockly.ASTNode(Blockly.ASTNode.types.STACK,a):null};Blockly.ASTNode.createWorkspaceNode=function(a,b){return b&&a?new Blockly.ASTNode(Blockly.ASTNode.types.WORKSPACE,a,{wsCoordinate:b}):null};
	Blockly.ASTNode.createTopNode=function(a){var b=a.previousConnection||a.outputConnection;return b?Blockly.ASTNode.createConnectionNode(b):Blockly.ASTNode.createBlockNode(a)};Blockly.ASTNode.prototype.processParams_=function(a){a&&a.wsCoordinate&&(this.wsCoordinate_=a.wsCoordinate)};Blockly.ASTNode.prototype.getLocation=function(){return this.location_};Blockly.ASTNode.prototype.getType=function(){return this.type_};Blockly.ASTNode.prototype.getWsCoordinate=function(){return this.wsCoordinate_};
	Blockly.ASTNode.prototype.isConnection=function(){return this.isConnection_};Blockly.ASTNode.prototype.findNextForInput_=function(){var a=this.location_.getParentInput(),b=a.getSourceBlock();a=b.inputList.indexOf(a)+1;for(var c;c=b.inputList[a];a++){for(var d=c.fieldRow,e=0,f;f=d[e];e++)if(f.isClickable()||Blockly.ASTNode.NAVIGATE_ALL_FIELDS)return Blockly.ASTNode.createFieldNode(f);if(c.connection)return Blockly.ASTNode.createInputNode(c)}return null};
	Blockly.ASTNode.prototype.findNextForField_=function(){var a=this.location_,b=a.getParentInput(),c=a.getSourceBlock(),d=c.inputList.indexOf(b);for(a=b.fieldRow.indexOf(a)+1;b=c.inputList[d];d++){for(var e=b.fieldRow;a<e.length;){if(e[a].isClickable()||Blockly.ASTNode.NAVIGATE_ALL_FIELDS)return Blockly.ASTNode.createFieldNode(e[a]);a++}a=0;if(b.connection)return Blockly.ASTNode.createInputNode(b)}return null};
	Blockly.ASTNode.prototype.findPrevForInput_=function(){for(var a=this.location_.getParentInput(),b=a.getSourceBlock(),c=b.inputList.indexOf(a),d;d=b.inputList[c];c--){if(d.connection&&d!==a)return Blockly.ASTNode.createInputNode(d);d=d.fieldRow;for(var e=d.length-1,f;f=d[e];e--)if(f.isClickable()||Blockly.ASTNode.NAVIGATE_ALL_FIELDS)return Blockly.ASTNode.createFieldNode(f)}return null};
	Blockly.ASTNode.prototype.findPrevForField_=function(){var a=this.location_,b=a.getParentInput(),c=a.getSourceBlock(),d=c.inputList.indexOf(b);a=b.fieldRow.indexOf(a)-1;for(var e;e=c.inputList[d];d--){if(e.connection&&e!==b)return Blockly.ASTNode.createInputNode(e);for(e=e.fieldRow;-1<a;){if(e[a].isClickable()||Blockly.ASTNode.NAVIGATE_ALL_FIELDS)return Blockly.ASTNode.createFieldNode(e[a]);a--}0<=d-1&&(a=c.inputList[d-1].fieldRow.length-1)}return null};
	Blockly.ASTNode.prototype.navigateBetweenStacks_=function(a){var b=this.getLocation();b instanceof Blockly.Block||(b=b.getSourceBlock());if(!b||!b.workspace)return null;var c=b.getRootBlock();b=c.workspace.getTopBlocks(!0);for(var d=0,e;e=b[d];d++)if(c.id==e.id)return a=d+(a?1:-1),-1==a||a==b.length?null:Blockly.ASTNode.createStackNode(b[a]);throw Error("Couldn't find "+(a?"next":"previous")+" stack?!");};
	Blockly.ASTNode.prototype.findTopASTNodeForBlock_=function(a){var b=a.previousConnection||a.outputConnection;return b?Blockly.ASTNode.createConnectionNode(b):Blockly.ASTNode.createBlockNode(a)};Blockly.ASTNode.prototype.getOutAstNodeForBlock_=function(a){if(!a)return null;a=a.getTopStackBlock();var b=a.previousConnection||a.outputConnection;return b&&b.targetConnection&&b.targetConnection.getParentInput()?Blockly.ASTNode.createInputNode(b.targetConnection.getParentInput()):Blockly.ASTNode.createStackNode(a)};
	Blockly.ASTNode.prototype.findFirstFieldOrInput_=function(a){a=a.inputList;for(var b=0,c;c=a[b];b++){for(var d=c.fieldRow,e=0,f;f=d[e];e++)if(f.isClickable()||Blockly.ASTNode.NAVIGATE_ALL_FIELDS)return Blockly.ASTNode.createFieldNode(f);if(c.connection)return Blockly.ASTNode.createInputNode(c)}return null};
	Blockly.ASTNode.prototype.getSourceBlock=function(){return this.getType()===Blockly.ASTNode.types.BLOCK?this.getLocation():this.getType()===Blockly.ASTNode.types.STACK?this.getLocation():this.getType()===Blockly.ASTNode.types.WORKSPACE?null:this.getLocation().getSourceBlock()};
	Blockly.ASTNode.prototype.next=function(){switch(this.type_){case Blockly.ASTNode.types.STACK:return this.navigateBetweenStacks_(!0);case Blockly.ASTNode.types.OUTPUT:var a=this.location_;return Blockly.ASTNode.createBlockNode(a.getSourceBlock());case Blockly.ASTNode.types.FIELD:return this.findNextForField_();case Blockly.ASTNode.types.INPUT:return this.findNextForInput_();case Blockly.ASTNode.types.BLOCK:return Blockly.ASTNode.createConnectionNode(this.location_.nextConnection);case Blockly.ASTNode.types.PREVIOUS:return a=
	this.location_,Blockly.ASTNode.createBlockNode(a.getSourceBlock());case Blockly.ASTNode.types.NEXT:return a=this.location_,Blockly.ASTNode.createConnectionNode(a.targetConnection)}return null};
	Blockly.ASTNode.prototype.in=function(){switch(this.type_){case Blockly.ASTNode.types.WORKSPACE:var a=this.location_.getTopBlocks(!0);if(0<a.length)return Blockly.ASTNode.createStackNode(a[0]);break;case Blockly.ASTNode.types.STACK:return a=this.location_,this.findTopASTNodeForBlock_(a);case Blockly.ASTNode.types.BLOCK:return a=this.location_,this.findFirstFieldOrInput_(a);case Blockly.ASTNode.types.INPUT:return Blockly.ASTNode.createConnectionNode(this.location_.targetConnection)}return null};
	Blockly.ASTNode.prototype.prev=function(){switch(this.type_){case Blockly.ASTNode.types.STACK:return this.navigateBetweenStacks_(!1);case Blockly.ASTNode.types.FIELD:return this.findPrevForField_();case Blockly.ASTNode.types.INPUT:return this.findPrevForInput_();case Blockly.ASTNode.types.BLOCK:var a=this.location_;return Blockly.ASTNode.createConnectionNode(a.previousConnection||a.outputConnection);case Blockly.ASTNode.types.PREVIOUS:a=this.location_;if((a=a.targetConnection)&&!a.getParentInput())return Blockly.ASTNode.createConnectionNode(a);
	break;case Blockly.ASTNode.types.NEXT:return a=this.location_,Blockly.ASTNode.createBlockNode(a.getSourceBlock())}return null};
	Blockly.ASTNode.prototype.out=function(){switch(this.type_){case Blockly.ASTNode.types.STACK:var a=this.location_,b=a.getRelativeToSurfaceXY();b=new Blockly.utils.Coordinate(b.x,b.y+Blockly.ASTNode.DEFAULT_OFFSET_Y);return Blockly.ASTNode.createWorkspaceNode(a.workspace,b);case Blockly.ASTNode.types.OUTPUT:return a=this.location_,(b=a.targetConnection)?Blockly.ASTNode.createConnectionNode(b):Blockly.ASTNode.createStackNode(a.getSourceBlock());case Blockly.ASTNode.types.FIELD:return Blockly.ASTNode.createBlockNode(this.location_.getSourceBlock());
	case Blockly.ASTNode.types.INPUT:return a=this.location_,Blockly.ASTNode.createBlockNode(a.getSourceBlock());case Blockly.ASTNode.types.BLOCK:return a=this.location_,this.getOutAstNodeForBlock_(a);case Blockly.ASTNode.types.PREVIOUS:return a=this.location_,this.getOutAstNodeForBlock_(a.getSourceBlock());case Blockly.ASTNode.types.NEXT:return a=this.location_,this.getOutAstNodeForBlock_(a.getSourceBlock())}return null};Blockly.Blocks=Object.create(null);Blockly.Connection=function(a,b){this.sourceBlock_=a;this.type=b};Blockly.Connection.CAN_CONNECT=0;Blockly.Connection.REASON_SELF_CONNECTION=1;Blockly.Connection.REASON_WRONG_TYPE=2;Blockly.Connection.REASON_TARGET_NULL=3;Blockly.Connection.REASON_CHECKS_FAILED=4;Blockly.Connection.REASON_DIFFERENT_WORKSPACES=5;Blockly.Connection.REASON_SHADOW_PARENT=6;Blockly.Connection.prototype.targetConnection=null;Blockly.Connection.prototype.disposed=!1;Blockly.Connection.prototype.check_=null;
	Blockly.Connection.prototype.shadowDom_=null;Blockly.Connection.prototype.x=0;Blockly.Connection.prototype.y=0;
	Blockly.Connection.prototype.connect_=function(a){var b=this,c=b.getSourceBlock(),d=a.getSourceBlock();a.isConnected()&&a.disconnect();if(b.isConnected()){var e=b.targetBlock(),f=b.getShadowDom();b.setShadowDom(null);if(e.isShadow())f=Blockly.Xml.blockToDom(e),e.dispose(!1),e=null;else if(b.type==Blockly.INPUT_VALUE){if(!e.outputConnection)throw Error("Orphan block does not have an output connection.");var g=Blockly.Connection.lastConnectionInRow(d,e);g&&(e.outputConnection.connect(g),e=null)}else if(b.type==
	Blockly.NEXT_STATEMENT){if(!e.previousConnection)throw Error("Orphan block does not have a previous connection.");for(g=d;g.nextConnection;){var h=g.getNextBlock();if(h&&!h.isShadow())g=h;else{e.previousConnection.checkType(g.nextConnection)&&(g.nextConnection.connect(e.previousConnection),e=null);break}}}if(e&&(b.disconnect(),Blockly.Events.recordUndo)){var k=Blockly.Events.getGroup();setTimeout(function(){if(e.workspace&&!e.getParent()){Blockly.Events.setGroup(k);if(e.outputConnection)e.outputConnection.onFailedConnect(b);
	else if(e.previousConnection)e.previousConnection.onFailedConnect(b);Blockly.Events.setGroup(!1)}},Blockly.BUMP_DELAY)}b.setShadowDom(f)}var l;Blockly.Events.isEnabled()&&(l=new Blockly.Events.BlockMove(d));Blockly.Connection.connectReciprocally_(b,a);d.setParent(c);l&&(l.recordNew(),Blockly.Events.fire(l))};Blockly.Connection.prototype.dispose=function(){if(this.isConnected()){this.setShadowDom(null);var a=this.targetBlock();a.isShadow()?a.dispose(!1):a.unplug()}this.disposed=!0};
	Blockly.Connection.prototype.getSourceBlock=function(){return this.sourceBlock_};Blockly.Connection.prototype.isSuperior=function(){return this.type==Blockly.INPUT_VALUE||this.type==Blockly.NEXT_STATEMENT};Blockly.Connection.prototype.isConnected=function(){return!!this.targetConnection};
	Blockly.Connection.prototype.canConnectWithReason=function(a){if(!a)return Blockly.Connection.REASON_TARGET_NULL;if(this.isSuperior())var b=this.sourceBlock_,c=a.getSourceBlock();else c=this.sourceBlock_,b=a.getSourceBlock();return b&&b==c?Blockly.Connection.REASON_SELF_CONNECTION:a.type!=Blockly.OPPOSITE_TYPE[this.type]?Blockly.Connection.REASON_WRONG_TYPE:b&&c&&b.workspace!==c.workspace?Blockly.Connection.REASON_DIFFERENT_WORKSPACES:this.checkType(a)?b.isShadow()&&!c.isShadow()?Blockly.Connection.REASON_SHADOW_PARENT:
	Blockly.Connection.CAN_CONNECT:Blockly.Connection.REASON_CHECKS_FAILED};
	Blockly.Connection.prototype.checkConnection=function(a){switch(this.canConnectWithReason(a)){case Blockly.Connection.CAN_CONNECT:break;case Blockly.Connection.REASON_SELF_CONNECTION:throw Error("Attempted to connect a block to itself.");case Blockly.Connection.REASON_DIFFERENT_WORKSPACES:throw Error("Blocks not on same workspace.");case Blockly.Connection.REASON_WRONG_TYPE:throw Error("Attempt to connect incompatible types.");case Blockly.Connection.REASON_TARGET_NULL:throw Error("Target connection is null.");
	case Blockly.Connection.REASON_CHECKS_FAILED:throw Error("Connection checks failed. "+(this+" expected "+this.check_+", found "+a.check_));case Blockly.Connection.REASON_SHADOW_PARENT:throw Error("Connecting non-shadow to shadow block.");default:throw Error("Unknown connection failure: this should never happen!");}};
	Blockly.Connection.prototype.canConnectToPrevious_=function(a){if(this.targetConnection||-1!=Blockly.draggingConnections.indexOf(a))return!1;if(!a.targetConnection)return!0;a=a.targetBlock();return a.isInsertionMarker()?!a.getPreviousBlock():!1};
	Blockly.Connection.prototype.isConnectionAllowed=function(a){if(a.sourceBlock_.isInsertionMarker()||this.canConnectWithReason(a)!=Blockly.Connection.CAN_CONNECT)return!1;switch(a.type){case Blockly.PREVIOUS_STATEMENT:return this.canConnectToPrevious_(a);case Blockly.OUTPUT_VALUE:if(a.isConnected()&&!a.targetBlock().isInsertionMarker()||this.isConnected())return!1;break;case Blockly.INPUT_VALUE:if(a.isConnected()&&!a.targetBlock().isMovable()&&!a.targetBlock().isShadow())return!1;break;case Blockly.NEXT_STATEMENT:if(a.isConnected()&&
	!this.sourceBlock_.nextConnection&&!a.targetBlock().isShadow()&&a.targetBlock().nextConnection)return!1;break;default:throw Error("Unknown connection type in isConnectionAllowed");}return-1!=Blockly.draggingConnections.indexOf(a)?!1:!0};Blockly.Connection.prototype.onFailedConnect=function(a){};
	Blockly.Connection.prototype.connect=function(a){if(this.targetConnection!=a){this.checkConnection(a);var b=Blockly.Events.getGroup();b||Blockly.Events.setGroup(!0);this.isSuperior()?this.connect_(a):a.connect_(this);b||Blockly.Events.setGroup(!1)}};Blockly.Connection.connectReciprocally_=function(a,b){if(!a||!b)throw Error("Cannot connect null connections.");a.targetConnection=b;b.targetConnection=a};
	Blockly.Connection.singleConnection_=function(a,b){for(var c=null,d=0;d<a.inputList.length;d++){var e=a.inputList[d].connection;if(e&&e.type==Blockly.INPUT_VALUE&&b.outputConnection.checkType(e)){if(c)return null;c=e}}return c};Blockly.Connection.lastConnectionInRow=function(a,b){for(var c;c=Blockly.Connection.singleConnection_(a,b);)if(a=c.targetBlock(),!a||a.isShadow())return c;return null};
	Blockly.Connection.prototype.disconnect=function(){var a=this.targetConnection;if(!a)throw Error("Source connection not connected.");if(a.targetConnection!=this)throw Error("Target connection not connected to source connection.");if(this.isSuperior()){var b=this.sourceBlock_;var c=a.getSourceBlock();a=this}else b=a.getSourceBlock(),c=this.sourceBlock_;var d=Blockly.Events.getGroup();d||Blockly.Events.setGroup(!0);this.disconnectInternal_(b,c);a.respawnShadow_();d||Blockly.Events.setGroup(!1)};
	Blockly.Connection.prototype.disconnectInternal_=function(a,b){var c;Blockly.Events.isEnabled()&&(c=new Blockly.Events.BlockMove(b));this.targetConnection=this.targetConnection.targetConnection=null;b.setParent(null);c&&(c.recordNew(),Blockly.Events.fire(c))};
	Blockly.Connection.prototype.respawnShadow_=function(){var a=this.getSourceBlock(),b=this.getShadowDom();if(a.workspace&&b&&Blockly.Events.recordUndo)if(a=Blockly.Xml.domToBlock(b,a.workspace),a.outputConnection)this.connect(a.outputConnection);else if(a.previousConnection)this.connect(a.previousConnection);else throw Error("Child block does not have output or previous statement.");};
	Blockly.Connection.prototype.targetBlock=function(){return this.isConnected()?this.targetConnection.getSourceBlock():null};Blockly.Connection.prototype.checkType=function(a){if(!this.check_||!a.check_)return!0;for(var b=0;b<this.check_.length;b++)if(-1!=a.check_.indexOf(this.check_[b]))return!0;return!1};Blockly.Connection.prototype.checkType_=function(a){console.warn("Deprecated call to Blockly.Connection.prototype.checkType_, use Blockly.Connection.prototype.checkType instead.");return this.checkType(a)};
	Blockly.Connection.prototype.onCheckChanged_=function(){!this.isConnected()||this.targetConnection&&this.checkType(this.targetConnection)||(this.isSuperior()?this.targetBlock():this.sourceBlock_).unplug()};Blockly.Connection.prototype.setCheck=function(a){a?(Array.isArray(a)||(a=[a]),this.check_=a,this.onCheckChanged_()):this.check_=null;return this};Blockly.Connection.prototype.getCheck=function(){return this.check_};Blockly.Connection.prototype.setShadowDom=function(a){this.shadowDom_=a};
	Blockly.Connection.prototype.getShadowDom=function(){return this.shadowDom_};Blockly.Connection.prototype.neighbours=function(a){return[]};Blockly.Connection.prototype.getParentInput=function(){for(var a=null,b=this.sourceBlock_,c=b.inputList,d=0;d<b.inputList.length;d++)if(c[d].connection===this){a=c[d];break}return a};
	Blockly.Connection.prototype.toString=function(){var a=this.sourceBlock_;if(a)if(a.outputConnection==this)var b="Output Connection of ";else if(a.previousConnection==this)b="Previous Connection of ";else if(a.nextConnection==this)b="Next Connection of ";else{b=null;for(var c=0,d;d=a.inputList[c];c++)if(d.connection==this){b=d;break}if(b)b='Input "'+b.name+'" connection on ';else return console.warn("Connection not actually connected to sourceBlock_"),"Orphan Connection"}else return"Orphan Connection";
	return b+a.toDevString()};Blockly.Extensions={};Blockly.Extensions.ALL_={};Blockly.Extensions.register=function(a,b){if("string"!=typeof a||""==a.trim())throw Error('Error: Invalid extension name "'+a+'"');if(Blockly.Extensions.ALL_[a])throw Error('Error: Extension "'+a+'" is already registered.');if("function"!=typeof b)throw Error('Error: Extension "'+a+'" must be a function');Blockly.Extensions.ALL_[a]=b};
	Blockly.Extensions.registerMixin=function(a,b){if(!b||"object"!=typeof b)throw Error('Error: Mixin "'+a+'" must be a object');Blockly.Extensions.register(a,function(){this.mixin(b)})};
	Blockly.Extensions.registerMutator=function(a,b,c,d){var e='Error when registering mutator "'+a+'": ';Blockly.Extensions.checkHasFunction_(e,b.domToMutation,"domToMutation");Blockly.Extensions.checkHasFunction_(e,b.mutationToDom,"mutationToDom");var f=Blockly.Extensions.checkMutatorDialog_(b,e);if(c&&"function"!=typeof c)throw Error('Extension "'+a+'" is not a function');Blockly.Extensions.register(a,function(){if(f){if(!Blockly.Mutator)throw Error(e+"Missing require for Blockly.Mutator");this.setMutator(new Blockly.Mutator(d||
	[]))}this.mixin(b);c&&c.apply(this)})};Blockly.Extensions.unregister=function(a){Blockly.Extensions.ALL_[a]?delete Blockly.Extensions.ALL_[a]:console.warn('No extension mapping for name "'+a+'" found to unregister')};
	Blockly.Extensions.apply=function(a,b,c){var d=Blockly.Extensions.ALL_[a];if("function"!=typeof d)throw Error('Error: Extension "'+a+'" not found.');if(c)Blockly.Extensions.checkNoMutatorProperties_(a,b);else var e=Blockly.Extensions.getMutatorProperties_(b);d.apply(b);if(c)Blockly.Extensions.checkBlockHasMutatorProperties_('Error after applying mutator "'+a+'": ',b);else if(!Blockly.Extensions.mutatorPropertiesMatch_(e,b))throw Error('Error when applying extension "'+a+'": mutation properties changed when applying a non-mutator extension.');
	};Blockly.Extensions.checkHasFunction_=function(a,b,c){if(!b)throw Error(a+'missing required property "'+c+'"');if("function"!=typeof b)throw Error(a+'" required property "'+c+'" must be a function');};Blockly.Extensions.checkNoMutatorProperties_=function(a,b){if(Blockly.Extensions.getMutatorProperties_(b).length)throw Error('Error: tried to apply mutation "'+a+'" to a block that already has mutator functions.  Block id: '+b.id);};
	Blockly.Extensions.checkMutatorDialog_=function(a,b){var c=void 0!==a.compose,d=void 0!==a.decompose;if(c&&d){if("function"!=typeof a.compose)throw Error(b+"compose must be a function.");if("function"!=typeof a.decompose)throw Error(b+"decompose must be a function.");return!0}if(c||d)throw Error(b+'Must have both or neither of "compose" and "decompose"');return!1};
	Blockly.Extensions.checkBlockHasMutatorProperties_=function(a,b){if("function"!=typeof b.domToMutation)throw Error(a+'Applying a mutator didn\'t add "domToMutation"');if("function"!=typeof b.mutationToDom)throw Error(a+'Applying a mutator didn\'t add "mutationToDom"');Blockly.Extensions.checkMutatorDialog_(b,a)};
	Blockly.Extensions.getMutatorProperties_=function(a){var b=[];void 0!==a.domToMutation&&b.push(a.domToMutation);void 0!==a.mutationToDom&&b.push(a.mutationToDom);void 0!==a.compose&&b.push(a.compose);void 0!==a.decompose&&b.push(a.decompose);return b};Blockly.Extensions.mutatorPropertiesMatch_=function(a,b){b=Blockly.Extensions.getMutatorProperties_(b);if(b.length!=a.length)return!1;for(var c=0;c<b.length;c++)if(a[c]!=b[c])return!1;return!0};
	Blockly.Extensions.buildTooltipForDropdown=function(a,b){var c=[];"object"==typeof document&&Blockly.utils.runAfterPageLoad(function(){for(var a in b)Blockly.utils.checkMessageReferences(b[a])});return function(){this.type&&-1==c.indexOf(this.type)&&(Blockly.Extensions.checkDropdownOptionsInTable_(this,a,b),c.push(this.type));this.setTooltip(function(){var d=String(this.getFieldValue(a)),e=b[d];null==e?-1==c.indexOf(this.type)&&(d="No tooltip mapping for value "+d+" of field "+a,null!=this.type&&
	(d+=" of block type "+this.type),console.warn(d+".")):e=Blockly.utils.replaceMessageReferences(e);return e}.bind(this))}};Blockly.Extensions.checkDropdownOptionsInTable_=function(a,b,c){var d=a.getField(b);if(!d.isOptionListDynamic()){d=d.getOptions();for(var e=0;e<d.length;++e){var f=d[e][1];null==c[f]&&console.warn("No tooltip mapping for value "+f+" of field "+b+" of block type "+a.type)}}};
	Blockly.Extensions.buildTooltipWithFieldText=function(a,b){"object"==typeof document&&Blockly.utils.runAfterPageLoad(function(){Blockly.utils.checkMessageReferences(a)});return function(){this.setTooltip(function(){var c=this.getField(b);return Blockly.utils.replaceMessageReferences(a).replace("%1",c?c.getText():"")}.bind(this))}};
	Blockly.Extensions.extensionParentTooltip_=function(){this.tooltipWhenNotConnected_=this.tooltip;this.setTooltip(function(){var a=this.getParent();return a&&a.getInputsInline()&&a.tooltip||this.tooltipWhenNotConnected_}.bind(this))};Blockly.Extensions.register("parent_tooltip_when_inline",Blockly.Extensions.extensionParentTooltip_);Blockly.fieldRegistry={};Blockly.fieldRegistry.register=function(a,b){Blockly.registry.register(Blockly.registry.Type.FIELD,a,b)};Blockly.fieldRegistry.unregister=function(a){Blockly.registry.unregister(Blockly.registry.Type.FIELD,a)};
	Blockly.fieldRegistry.fromJson=function(a){var b=Blockly.registry.getClass(Blockly.registry.Type.FIELD,a.type);return b?b.fromJson(a):(console.warn("Blockly could not create a field of type "+a.type+". The field is probably not being registered. This could be because the file is not loaded, the field does not register itself (Issue #1584), or the registration is not being reached."),null)};Blockly.blockAnimations={};Blockly.blockAnimations.disconnectPid_=0;Blockly.blockAnimations.disconnectGroup_=null;Blockly.blockAnimations.disposeUiEffect=function(a){var b=a.workspace,c=a.getSvgRoot();b.getAudioManager().play("delete");a=b.getSvgXY(c);c=c.cloneNode(!0);c.translateX_=a.x;c.translateY_=a.y;c.setAttribute("transform","translate("+a.x+","+a.y+")");b.getParentSvg().appendChild(c);c.bBox_=c.getBBox();Blockly.blockAnimations.disposeUiStep_(c,b.RTL,new Date,b.scale)};
	Blockly.blockAnimations.disposeUiStep_=function(a,b,c,d){var e=(new Date-c)/150;1<e?Blockly.utils.dom.removeNode(a):(a.setAttribute("transform","translate("+(a.translateX_+(b?-1:1)*a.bBox_.width*d/2*e)+","+(a.translateY_+a.bBox_.height*d*e)+") scale("+(1-e)*d+")"),setTimeout(Blockly.blockAnimations.disposeUiStep_,10,a,b,c,d))};
	Blockly.blockAnimations.connectionUiEffect=function(a){var b=a.workspace,c=b.scale;b.getAudioManager().play("click");if(!(1>c)){var d=b.getSvgXY(a.getSvgRoot());a.outputConnection?(d.x+=(a.RTL?3:-3)*c,d.y+=13*c):a.previousConnection&&(d.x+=(a.RTL?-23:23)*c,d.y+=3*c);a=Blockly.utils.dom.createSvgElement("circle",{cx:d.x,cy:d.y,r:0,fill:"none",stroke:"#888","stroke-width":10},b.getParentSvg());Blockly.blockAnimations.connectionUiStep_(a,new Date,c)}};
	Blockly.blockAnimations.connectionUiStep_=function(a,b,c){var d=(new Date-b)/150;1<d?Blockly.utils.dom.removeNode(a):(a.setAttribute("r",25*d*c),a.style.opacity=1-d,Blockly.blockAnimations.disconnectPid_=setTimeout(Blockly.blockAnimations.connectionUiStep_,10,a,b,c))};
	Blockly.blockAnimations.disconnectUiEffect=function(a){a.workspace.getAudioManager().play("disconnect");if(!(1>a.workspace.scale)){var b=a.getHeightWidth().height;b=Math.atan(10/b)/Math.PI*180;a.RTL||(b*=-1);Blockly.blockAnimations.disconnectUiStep_(a.getSvgRoot(),b,new Date)}};
	Blockly.blockAnimations.disconnectUiStep_=function(a,b,c){var d=(new Date-c)/200;1<d?a.skew_="":(a.skew_="skewX("+Math.round(Math.sin(d*Math.PI*3)*(1-d)*b)+")",Blockly.blockAnimations.disconnectGroup_=a,Blockly.blockAnimations.disconnectPid_=setTimeout(Blockly.blockAnimations.disconnectUiStep_,10,a,b,c));a.setAttribute("transform",a.translate_+a.skew_)};
	Blockly.blockAnimations.disconnectUiStop=function(){if(Blockly.blockAnimations.disconnectGroup_){clearTimeout(Blockly.blockAnimations.disconnectPid_);var a=Blockly.blockAnimations.disconnectGroup_;a.skew_="";a.setAttribute("transform",a.translate_);Blockly.blockAnimations.disconnectGroup_=null}};Blockly.InsertionMarkerManager=function(a){this.topBlock_=Blockly.selected=a;this.workspace_=a.workspace;this.lastMarker_=this.lastOnStack_=null;this.firstMarker_=this.createMarkerBlock_(this.topBlock_);this.localConnection_=this.closestConnection_=null;this.wouldDeleteBlock_=!1;this.fadedBlock_=this.highlightedBlock_=this.markerConnection_=null;this.availableConnections_=this.initAvailableConnections_()};Blockly.InsertionMarkerManager.PREVIEW_TYPE={INSERTION_MARKER:0,INPUT_OUTLINE:1,REPLACEMENT_FADE:2};
	Blockly.InsertionMarkerManager.prototype.dispose=function(){this.availableConnections_.length=0;Blockly.Events.disable();try{this.firstMarker_&&this.firstMarker_.dispose(),this.lastMarker_&&this.lastMarker_.dispose()}finally{Blockly.Events.enable()}};Blockly.InsertionMarkerManager.prototype.updateAvailableConnections=function(){this.availableConnections_=this.initAvailableConnections_()};Blockly.InsertionMarkerManager.prototype.wouldDeleteBlock=function(){return this.wouldDeleteBlock_};
	Blockly.InsertionMarkerManager.prototype.wouldConnectBlock=function(){return!!this.closestConnection_};
	Blockly.InsertionMarkerManager.prototype.applyConnections=function(){if(this.closestConnection_&&(Blockly.Events.disable(),this.hidePreview_(),Blockly.Events.enable(),this.localConnection_.connect(this.closestConnection_),this.topBlock_.rendered)){var a=this.localConnection_.isSuperior()?this.closestConnection_:this.localConnection_;Blockly.blockAnimations.connectionUiEffect(a.getSourceBlock());this.topBlock_.getRootBlock().bringToFront()}};
	Blockly.InsertionMarkerManager.prototype.update=function(a,b){var c=this.getCandidate_(a);if((this.wouldDeleteBlock_=this.shouldDelete_(c,b))||this.shouldUpdatePreviews_(c,a))Blockly.Events.disable(),this.maybeHidePreview_(c),this.maybeShowPreview_(c),Blockly.Events.enable()};
	Blockly.InsertionMarkerManager.prototype.createMarkerBlock_=function(a){var b=a.type;Blockly.Events.disable();try{var c=this.workspace_.newBlock(b);c.setInsertionMarker(!0);if(a.mutationToDom){var d=a.mutationToDom();d&&c.domToMutation(d)}for(b=0;b<a.inputList.length;b++){var e=a.inputList[b];if(e.name!=Blockly.Block.COLLAPSED_INPUT_NAME){var f=c.inputList[b];for(d=0;d<e.fieldRow.length;d++)f.fieldRow[d].setValue(e.fieldRow[d].getValue())}}c.setCollapsed(a.isCollapsed());c.setInputsInline(a.getInputsInline());
	c.initSvg();c.getSvgRoot().setAttribute("visibility","hidden")}finally{Blockly.Events.enable()}return c};Blockly.InsertionMarkerManager.prototype.initAvailableConnections_=function(){var a=this.topBlock_.getConnections_(!1),b=this.topBlock_.lastConnectionInStack();b&&b!=this.topBlock_.nextConnection&&(a.push(b),this.lastOnStack_=b,this.lastMarker_=this.createMarkerBlock_(b.getSourceBlock()));return a};
	Blockly.InsertionMarkerManager.prototype.shouldUpdatePreviews_=function(a,b){var c=a.local,d=a.closest;a=a.radius;if(c&&d){if(this.localConnection_&&this.closestConnection_){if(this.closestConnection_==d&&this.localConnection_==c)return!1;c=this.localConnection_.x+b.x-this.closestConnection_.x;b=this.localConnection_.y+b.y-this.closestConnection_.y;b=Math.sqrt(c*c+b*b);return!(d&&a>b-Blockly.CURRENT_CONNECTION_PREFERENCE)}if(this.localConnection_||this.closestConnection_)console.error("Only one of localConnection_ and closestConnection_ was set.");
	else return!0}else return!(!this.localConnection_||!this.closestConnection_);console.error("Returning true from shouldUpdatePreviews, but it's not clear why.");return!0};Blockly.InsertionMarkerManager.prototype.getCandidate_=function(a){for(var b=this.getStartRadius_(),c=null,d=null,e=0;e<this.availableConnections_.length;e++){var f=this.availableConnections_[e],g=f.closest(b,a);g.connection&&(c=g.connection,d=f,b=g.radius)}return{closest:c,local:d,radius:b}};
	Blockly.InsertionMarkerManager.prototype.getStartRadius_=function(){return this.closestConnection_&&this.localConnection_?Blockly.CONNECTING_SNAP_RADIUS:Blockly.SNAP_RADIUS};Blockly.InsertionMarkerManager.prototype.shouldDelete_=function(a,b){a=a&&!!a.closest&&b!=Blockly.DELETE_AREA_TOOLBOX;return!!b&&!this.topBlock_.getParent()&&this.topBlock_.isDeletable()&&!a};
	Blockly.InsertionMarkerManager.prototype.maybeShowPreview_=function(a){if(!this.wouldDeleteBlock_){var b=a.closest;a=a.local;b&&(b==this.closestConnection_||b.getSourceBlock().isInsertionMarker()?console.log("Trying to connect to an insertion marker"):(this.closestConnection_=b,this.localConnection_=a,this.showPreview_()))}};
	Blockly.InsertionMarkerManager.prototype.showPreview_=function(){var a=this.closestConnection_,b=this.workspace_.getRenderer();switch(b.getConnectionPreviewMethod(a,this.localConnection_,this.topBlock_)){case Blockly.InsertionMarkerManager.PREVIEW_TYPE.INPUT_OUTLINE:this.showInsertionInputOutline_();break;case Blockly.InsertionMarkerManager.PREVIEW_TYPE.INSERTION_MARKER:this.showInsertionMarker_();break;case Blockly.InsertionMarkerManager.PREVIEW_TYPE.REPLACEMENT_FADE:this.showReplacementFade_()}a&&
	b.shouldHighlightConnection(a)&&a.highlight()};Blockly.InsertionMarkerManager.prototype.maybeHidePreview_=function(a){if(a.closest){var b=this.closestConnection_!=a.closest;a=this.localConnection_!=a.local;this.closestConnection_&&this.localConnection_&&(b||a||this.wouldDeleteBlock_)&&this.hidePreview_()}else this.hidePreview_();this.localConnection_=this.closestConnection_=this.markerConnection_=null};
	Blockly.InsertionMarkerManager.prototype.hidePreview_=function(){this.closestConnection_&&this.closestConnection_.targetBlock()&&this.workspace_.getRenderer().shouldHighlightConnection(this.closestConnection_)&&this.closestConnection_.unhighlight();this.fadedBlock_?this.hideReplacementFade_():this.highlightedBlock_?this.hideInsertionInputOutline_():this.markerConnection_&&this.hideInsertionMarker_()};
	Blockly.InsertionMarkerManager.prototype.showInsertionMarker_=function(){var a=this.localConnection_,b=this.closestConnection_,c=this.lastOnStack_&&a==this.lastOnStack_?this.lastMarker_:this.firstMarker_;a=c.getMatchingConnection(a.getSourceBlock(),a);if(a==this.markerConnection_)throw Error("Made it to showInsertionMarker_ even though the marker isn't changing");c.render();c.rendered=!0;c.getSvgRoot().setAttribute("visibility","visible");a&&b&&c.positionNearConnection(a,b);b&&a.connect(b);this.markerConnection_=
	a};
	Blockly.InsertionMarkerManager.prototype.hideInsertionMarker_=function(){if(this.markerConnection_){var a=this.markerConnection_,b=a.getSourceBlock(),c=b.nextConnection,d=b.previousConnection,e=b.outputConnection;e=a.type==Blockly.INPUT_VALUE&&!(e&&e.targetConnection);!(a!=c||d&&d.targetConnection)||e?a.targetBlock().unplug(!1):a.type==Blockly.NEXT_STATEMENT&&a!=c?(c=a.targetConnection,c.getSourceBlock().unplug(!1),d=d?d.targetConnection:null,b.unplug(!0),d&&d.connect(c)):b.unplug(!0);if(a.targetConnection)throw Error("markerConnection_ still connected at the end of disconnectInsertionMarker");this.markerConnection_=
	null;b.getSvgRoot().setAttribute("visibility","hidden")}else console.log("No insertion marker connection to disconnect")};Blockly.InsertionMarkerManager.prototype.showInsertionInputOutline_=function(){var a=this.closestConnection_;this.highlightedBlock_=a.getSourceBlock();this.highlightedBlock_.highlightShapeForInput(a,!0)};
	Blockly.InsertionMarkerManager.prototype.hideInsertionInputOutline_=function(){this.highlightedBlock_.highlightShapeForInput(this.closestConnection_,!1);this.highlightedBlock_=null};Blockly.InsertionMarkerManager.prototype.showReplacementFade_=function(){this.fadedBlock_=this.closestConnection_.targetBlock();this.fadedBlock_.fadeForReplacement(!0)};Blockly.InsertionMarkerManager.prototype.hideReplacementFade_=function(){this.fadedBlock_.fadeForReplacement(!1);this.fadedBlock_=null};
	Blockly.InsertionMarkerManager.prototype.getInsertionMarkers=function(){var a=[];this.firstMarker_&&a.push(this.firstMarker_);this.lastMarker_&&a.push(this.lastMarker_);return a};Blockly.BlockDragger=function(a,b){this.draggingBlock_=a;this.workspace_=b;this.draggedConnectionManager_=new Blockly.InsertionMarkerManager(this.draggingBlock_);this.deleteArea_=null;this.wouldDeleteBlock_=!1;this.startXY_=this.draggingBlock_.getRelativeToSurfaceXY();this.dragIconData_=Blockly.BlockDragger.initIconData_(a)};Blockly.BlockDragger.prototype.dispose=function(){this.dragIconData_.length=0;this.draggedConnectionManager_&&this.draggedConnectionManager_.dispose()};
	Blockly.BlockDragger.initIconData_=function(a){var b=[];a=a.getDescendants(!1);for(var c=0,d;d=a[c];c++){d=d.getIcons();for(var e=0;e<d.length;e++){var f={location:d[e].getIconLocation(),icon:d[e]};b.push(f)}}return b};
	Blockly.BlockDragger.prototype.startBlockDrag=function(a,b){Blockly.Events.getGroup()||Blockly.Events.setGroup(!0);this.fireDragStartEvent_();this.workspace_.isMutator&&this.draggingBlock_.bringToFront();Blockly.utils.dom.startTextWidthCache();this.workspace_.setResizesEnabled(!1);Blockly.blockAnimations.disconnectUiStop();if(this.draggingBlock_.getParent()||b&&this.draggingBlock_.nextConnection&&this.draggingBlock_.nextConnection.targetBlock())this.draggingBlock_.unplug(b),a=this.pixelsToWorkspaceUnits_(a),
	a=Blockly.utils.Coordinate.sum(this.startXY_,a),this.draggingBlock_.translate(a.x,a.y),Blockly.blockAnimations.disconnectUiEffect(this.draggingBlock_),this.draggedConnectionManager_.updateAvailableConnections();this.draggingBlock_.setDragging(!0);this.draggingBlock_.moveToDragSurface();(a=this.workspace_.getToolbox())&&"function"==typeof a.addStyle&&(b=this.draggingBlock_.isDeletable()?"blocklyToolboxDelete":"blocklyToolboxGrab",a.addStyle(b))};
	Blockly.BlockDragger.prototype.fireDragStartEvent_=function(){var a=new Blockly.Events.Ui(this.draggingBlock_,"dragStart",null,this.draggingBlock_.getDescendants(!1));Blockly.Events.fire(a)};Blockly.BlockDragger.prototype.dragBlock=function(a,b){b=this.pixelsToWorkspaceUnits_(b);var c=Blockly.utils.Coordinate.sum(this.startXY_,b);this.draggingBlock_.moveDuringDrag(c);this.dragIcons_(b);this.deleteArea_=this.workspace_.isDeleteArea(a);this.draggedConnectionManager_.update(b,this.deleteArea_);this.updateCursorDuringBlockDrag_()};
	Blockly.BlockDragger.prototype.endBlockDrag=function(a,b){this.dragBlock(a,b);this.dragIconData_=[];this.fireDragEndEvent_();Blockly.utils.dom.stopTextWidthCache();Blockly.blockAnimations.disconnectUiStop();a=this.pixelsToWorkspaceUnits_(b);b=Blockly.utils.Coordinate.sum(this.startXY_,a);this.draggingBlock_.moveOffDragSurface(b);this.maybeDeleteBlock_()||(this.draggingBlock_.moveConnections(a.x,a.y),this.draggingBlock_.setDragging(!1),this.fireMoveEvent_(),this.draggedConnectionManager_.wouldConnectBlock()?
	this.draggedConnectionManager_.applyConnections():this.draggingBlock_.render(),this.draggingBlock_.scheduleSnapAndBump());this.workspace_.setResizesEnabled(!0);(a=this.workspace_.getToolbox())&&"function"==typeof a.removeStyle&&(b=this.draggingBlock_.isDeletable()?"blocklyToolboxDelete":"blocklyToolboxGrab",a.removeStyle(b));Blockly.Events.setGroup(!1)};
	Blockly.BlockDragger.prototype.fireDragEndEvent_=function(){var a=new Blockly.Events.Ui(this.draggingBlock_,"dragStop",this.draggingBlock_.getDescendants(!1),null);Blockly.Events.fire(a)};Blockly.BlockDragger.prototype.fireMoveEvent_=function(){var a=new Blockly.Events.BlockMove(this.draggingBlock_);a.oldCoordinate=this.startXY_;a.recordNew();Blockly.Events.fire(a)};
	Blockly.BlockDragger.prototype.maybeDeleteBlock_=function(){var a=this.workspace_.trashcan;this.wouldDeleteBlock_?(a&&setTimeout(a.close.bind(a),100),this.fireMoveEvent_(),this.draggingBlock_.dispose(!1,!0),Blockly.draggingConnections=[]):a&&a.close();return this.wouldDeleteBlock_};
	Blockly.BlockDragger.prototype.updateCursorDuringBlockDrag_=function(){this.wouldDeleteBlock_=this.draggedConnectionManager_.wouldDeleteBlock();var a=this.workspace_.trashcan;this.wouldDeleteBlock_?(this.draggingBlock_.setDeleteStyle(!0),this.deleteArea_==Blockly.DELETE_AREA_TRASH&&a&&a.setOpen(!0)):(this.draggingBlock_.setDeleteStyle(!1),a&&a.setOpen(!1))};
	Blockly.BlockDragger.prototype.pixelsToWorkspaceUnits_=function(a){a=new Blockly.utils.Coordinate(a.x/this.workspace_.scale,a.y/this.workspace_.scale);this.workspace_.isMutator&&a.scale(1/this.workspace_.options.parentWorkspace.scale);return a};Blockly.BlockDragger.prototype.dragIcons_=function(a){for(var b=0;b<this.dragIconData_.length;b++){var c=this.dragIconData_[b];c.icon.setIconLocation(Blockly.utils.Coordinate.sum(c.location,a))}};
	Blockly.BlockDragger.prototype.getInsertionMarkers=function(){return this.draggedConnectionManager_&&this.draggedConnectionManager_.getInsertionMarkers?this.draggedConnectionManager_.getInsertionMarkers():[]};Blockly.VariableMap=function(a){this.variableMap_=Object.create(null);this.workspace=a};Blockly.VariableMap.prototype.clear=function(){this.variableMap_=Object.create(null)};Blockly.VariableMap.prototype.renameVariable=function(a,b){var c=this.getVariable(b,a.type),d=this.workspace.getAllBlocks(!1);Blockly.Events.setGroup(!0);try{c&&c.getId()!=a.getId()?this.renameVariableWithConflict_(a,b,c,d):this.renameVariableAndUses_(a,b,d)}finally{Blockly.Events.setGroup(!1)}};
	Blockly.VariableMap.prototype.renameVariableById=function(a,b){var c=this.getVariableById(a);if(!c)throw Error("Tried to rename a variable that didn't exist. ID: "+a);this.renameVariable(c,b)};Blockly.VariableMap.prototype.renameVariableAndUses_=function(a,b,c){Blockly.Events.fire(new Blockly.Events.VarRename(a,b));a.name=b;for(b=0;b<c.length;b++)c[b].updateVarName(a)};
	Blockly.VariableMap.prototype.renameVariableWithConflict_=function(a,b,c,d){var e=a.type;b!=c.name&&this.renameVariableAndUses_(c,b,d);for(b=0;b<d.length;b++)d[b].renameVarById(a.getId(),c.getId());Blockly.Events.fire(new Blockly.Events.VarDelete(a));a=this.getVariablesOfType(e).indexOf(a);this.variableMap_[e].splice(a,1)};
	Blockly.VariableMap.prototype.createVariable=function(a,b,c){var d=this.getVariable(a,b);if(d){if(c&&d.getId()!=c)throw Error('Variable "'+a+'" is already in use and its id is "'+d.getId()+'" which conflicts with the passed in id, "'+c+'".');return d}if(c&&this.getVariableById(c))throw Error('Variable id, "'+c+'", is already in use.');d=c||Blockly.utils.genUid();b=b||"";d=new Blockly.VariableModel(this.workspace,a,b,d);a=this.variableMap_[b]||[];a.push(d);delete this.variableMap_[b];this.variableMap_[b]=
	a;return d};Blockly.VariableMap.prototype.deleteVariable=function(a){for(var b=this.variableMap_[a.type],c=0,d;d=b[c];c++)if(d.getId()==a.getId()){b.splice(c,1);Blockly.Events.fire(new Blockly.Events.VarDelete(a));break}};
	Blockly.VariableMap.prototype.deleteVariableById=function(a){var b=this.getVariableById(a);if(b){var c=b.name,d=this.getVariableUsesById(a);a=0;for(var e;e=d[a];a++)if("procedures_defnoreturn"==e.type||"procedures_defreturn"==e.type){a=e.getFieldValue("NAME");c=Blockly.Msg.CANNOT_DELETE_VARIABLE_PROCEDURE.replace("%1",c).replace("%2",a);Blockly.alert(c);return}var f=this;1<d.length?(c=Blockly.Msg.DELETE_VARIABLE_CONFIRMATION.replace("%1",String(d.length)).replace("%2",c),Blockly.confirm(c,function(a){a&&
	b&&f.deleteVariableInternal(b,d)})):f.deleteVariableInternal(b,d)}else console.warn("Can't delete non-existent variable: "+a)};Blockly.VariableMap.prototype.deleteVariableInternal=function(a,b){var c=Blockly.Events.getGroup();c||Blockly.Events.setGroup(!0);try{for(var d=0;d<b.length;d++)b[d].dispose(!0);this.deleteVariable(a)}finally{c||Blockly.Events.setGroup(!1)}};
	Blockly.VariableMap.prototype.getVariable=function(a,b){if(b=this.variableMap_[b||""])for(var c=0,d;d=b[c];c++)if(Blockly.Names.equals(d.name,a))return d;return null};Blockly.VariableMap.prototype.getVariableById=function(a){for(var b=Object.keys(this.variableMap_),c=0;c<b.length;c++)for(var d=b[c],e=0,f;f=this.variableMap_[d][e];e++)if(f.getId()==a)return f;return null};Blockly.VariableMap.prototype.getVariablesOfType=function(a){return(a=this.variableMap_[a||""])?a.slice():[]};
	Blockly.VariableMap.prototype.getVariableTypes=function(a){var b={};Blockly.utils.object.mixin(b,this.variableMap_);a&&a.getPotentialVariableMap()&&Blockly.utils.object.mixin(b,a.getPotentialVariableMap().variableMap_);a=Object.keys(b);b=!1;for(var c=0;c<a.length;c++)""==a[c]&&(b=!0);b||a.push("");return a};Blockly.VariableMap.prototype.getAllVariables=function(){var a=[],b;for(b in this.variableMap_)a=a.concat(this.variableMap_[b]);return a};
	Blockly.VariableMap.prototype.getAllVariableNames=function(){var a=[],b;for(b in this.variableMap_)for(var c=this.variableMap_[b],d=0,e;e=c[d];d++)a.push(e.name);return a};Blockly.VariableMap.prototype.getVariableUsesById=function(a){for(var b=[],c=this.workspace.getAllBlocks(!1),d=0;d<c.length;d++){var e=c[d].getVarModels();if(e)for(var f=0;f<e.length;f++)e[f].getId()==a&&b.push(c[d])}return b};Blockly.Workspace=function(a){this.id=Blockly.utils.genUid();Blockly.Workspace.WorkspaceDB_[this.id]=this;this.options=a||new Blockly.Options({});this.RTL=!!this.options.RTL;this.horizontalLayout=!!this.options.horizontalLayout;this.toolboxPosition=this.options.toolboxPosition;this.topBlocks_=[];this.topComments_=[];this.commentDB_=Object.create(null);this.listeners_=[];this.undoStack_=[];this.redoStack_=[];this.blockDB_=Object.create(null);this.typedBlocksDB_=Object.create(null);this.variableMap_=
	new Blockly.VariableMap(this);this.potentialVariableMap_=null};Blockly.Workspace.prototype.rendered=!1;Blockly.Workspace.prototype.isClearing=!1;Blockly.Workspace.prototype.MAX_UNDO=1024;Blockly.Workspace.prototype.connectionDBList=null;Blockly.Workspace.prototype.dispose=function(){this.listeners_.length=0;this.clear();delete Blockly.Workspace.WorkspaceDB_[this.id]};Blockly.Workspace.SCAN_ANGLE=3;
	Blockly.Workspace.prototype.sortObjects_=function(a,b){a=a.getRelativeToSurfaceXY();b=b.getRelativeToSurfaceXY();return a.y+Blockly.Workspace.prototype.sortObjects_.offset*a.x-(b.y+Blockly.Workspace.prototype.sortObjects_.offset*b.x)};Blockly.Workspace.prototype.addTopBlock=function(a){this.topBlocks_.push(a)};Blockly.Workspace.prototype.removeTopBlock=function(a){if(!Blockly.utils.arrayRemove(this.topBlocks_,a))throw Error("Block not present in workspace's list of top-most blocks.");};
	Blockly.Workspace.prototype.getTopBlocks=function(a){var b=[].concat(this.topBlocks_);a&&1<b.length&&(this.sortObjects_.offset=Math.sin(Blockly.utils.math.toRadians(Blockly.Workspace.SCAN_ANGLE)),this.RTL&&(this.sortObjects_.offset*=-1),b.sort(this.sortObjects_));return b};Blockly.Workspace.prototype.addTypedBlock=function(a){this.typedBlocksDB_[a.type]||(this.typedBlocksDB_[a.type]=[]);this.typedBlocksDB_[a.type].push(a)};
	Blockly.Workspace.prototype.removeTypedBlock=function(a){this.typedBlocksDB_[a.type].splice(this.typedBlocksDB_[a.type].indexOf(a),1);this.typedBlocksDB_[a.type].length||delete this.typedBlocksDB_[a.type]};
	Blockly.Workspace.prototype.getBlocksByType=function(a,b){if(!this.typedBlocksDB_[a])return[];a=this.typedBlocksDB_[a].slice(0);b&&1<a.length&&(this.sortObjects_.offset=Math.sin(Blockly.utils.math.toRadians(Blockly.Workspace.SCAN_ANGLE)),this.RTL&&(this.sortObjects_.offset*=-1),a.sort(this.sortObjects_));return a};
	Blockly.Workspace.prototype.addTopComment=function(a){this.topComments_.push(a);this.commentDB_[a.id]&&console.warn('Overriding an existing comment on this workspace, with id "'+a.id+'"');this.commentDB_[a.id]=a};Blockly.Workspace.prototype.removeTopComment=function(a){if(!Blockly.utils.arrayRemove(this.topComments_,a))throw Error("Comment not present in workspace's list of top-most comments.");delete this.commentDB_[a.id]};
	Blockly.Workspace.prototype.getTopComments=function(a){var b=[].concat(this.topComments_);a&&1<b.length&&(this.sortObjects_.offset=Math.sin(Blockly.utils.math.toRadians(Blockly.Workspace.SCAN_ANGLE)),this.RTL&&(this.sortObjects_.offset*=-1),b.sort(this.sortObjects_));return b};
	Blockly.Workspace.prototype.getAllBlocks=function(a){if(a){a=this.getTopBlocks(!0);for(var b=[],c=0;c<a.length;c++)b.push.apply(b,a[c].getDescendants(!0))}else for(b=this.getTopBlocks(!1),c=0;c<b.length;c++)b.push.apply(b,b[c].getChildren(!1));return b.filter(function(a){return!a.isInsertionMarker()})};
	Blockly.Workspace.prototype.clear=function(){this.isClearing=!0;try{var a=Blockly.Events.getGroup();for(a||Blockly.Events.setGroup(!0);this.topBlocks_.length;)this.topBlocks_[0].dispose(!1);for(;this.topComments_.length;)this.topComments_[this.topComments_.length-1].dispose(!1);a||Blockly.Events.setGroup(!1);this.variableMap_.clear();this.potentialVariableMap_&&this.potentialVariableMap_.clear()}finally{this.isClearing=!1}};
	Blockly.Workspace.prototype.renameVariableById=function(a,b){this.variableMap_.renameVariableById(a,b)};Blockly.Workspace.prototype.createVariable=function(a,b,c){return this.variableMap_.createVariable(a,b,c)};Blockly.Workspace.prototype.getVariableUsesById=function(a){return this.variableMap_.getVariableUsesById(a)};Blockly.Workspace.prototype.deleteVariableById=function(a){this.variableMap_.deleteVariableById(a)};
	Blockly.Workspace.prototype.variableIndexOf=function(a){console.warn("Deprecated call to Blockly.Workspace.prototype.variableIndexOf");return-1};Blockly.Workspace.prototype.getVariable=function(a,b){return this.variableMap_.getVariable(a,b)};Blockly.Workspace.prototype.getVariableById=function(a){return this.variableMap_.getVariableById(a)};Blockly.Workspace.prototype.getVariablesOfType=function(a){return this.variableMap_.getVariablesOfType(a)};Blockly.Workspace.prototype.getVariableTypes=function(){return this.variableMap_.getVariableTypes(this)};
	Blockly.Workspace.prototype.getAllVariables=function(){return this.variableMap_.getAllVariables()};Blockly.Workspace.prototype.getAllVariableNames=function(){return this.variableMap_.getAllVariableNames()};Blockly.Workspace.prototype.getWidth=function(){return 0};Blockly.Workspace.prototype.newBlock=function(a,b){return new Blockly.Block(this,a,b)};Blockly.Workspace.prototype.remainingCapacity=function(){return isNaN(this.options.maxBlocks)?Infinity:this.options.maxBlocks-this.getAllBlocks(!1).length};
	Blockly.Workspace.prototype.remainingCapacityOfType=function(a){return this.options.maxInstances?(void 0!==this.options.maxInstances[a]?this.options.maxInstances[a]:Infinity)-this.getBlocksByType(a,!1).length:Infinity};Blockly.Workspace.prototype.isCapacityAvailable=function(a){if(!this.hasBlockLimits())return!0;var b=0,c;for(c in a){if(a[c]>this.remainingCapacityOfType(c))return!1;b+=a[c]}return b>this.remainingCapacity()?!1:!0};
	Blockly.Workspace.prototype.hasBlockLimits=function(){return Infinity!=this.options.maxBlocks||!!this.options.maxInstances};Blockly.Workspace.prototype.undo=function(a){var b=a?this.redoStack_:this.undoStack_,c=a?this.undoStack_:this.redoStack_,d=b.pop();if(d){for(var e=[d];b.length&&d.group&&d.group==b[b.length-1].group;)e.push(b.pop());for(b=0;d=e[b];b++)c.push(d);e=Blockly.Events.filter(e,a);Blockly.Events.recordUndo=!1;try{for(b=0;d=e[b];b++)d.run(a)}finally{Blockly.Events.recordUndo=!0}}};
	Blockly.Workspace.prototype.clearUndo=function(){this.undoStack_.length=0;this.redoStack_.length=0;Blockly.Events.clearPendingUndo()};Blockly.Workspace.prototype.addChangeListener=function(a){this.listeners_.push(a);return a};Blockly.Workspace.prototype.removeChangeListener=function(a){Blockly.utils.arrayRemove(this.listeners_,a)};
	Blockly.Workspace.prototype.fireChangeListener=function(a){if(a.recordUndo)for(this.undoStack_.push(a),this.redoStack_.length=0;this.undoStack_.length>this.MAX_UNDO&&0<=this.MAX_UNDO;)this.undoStack_.shift();for(var b=0,c;c=this.listeners_[b];b++)c(a)};Blockly.Workspace.prototype.getBlockById=function(a){return this.blockDB_[a]||null};Blockly.Workspace.prototype.setBlockById=function(a,b){this.blockDB_[a]=b};Blockly.Workspace.prototype.removeBlockById=function(a){delete this.blockDB_[a]};
	Blockly.Workspace.prototype.getCommentById=function(a){return this.commentDB_[a]||null};Blockly.Workspace.prototype.allInputsFilled=function(a){for(var b=this.getTopBlocks(!1),c=0,d;d=b[c];c++)if(!d.allInputsFilled(a))return!1;return!0};Blockly.Workspace.prototype.getPotentialVariableMap=function(){return this.potentialVariableMap_};Blockly.Workspace.prototype.createPotentialVariableMap=function(){this.potentialVariableMap_=new Blockly.VariableMap(this)};
	Blockly.Workspace.prototype.getVariableMap=function(){return this.variableMap_};Blockly.Workspace.prototype.setVariableMap=function(a){this.variableMap_=a};Blockly.Workspace.WorkspaceDB_=Object.create(null);Blockly.Workspace.getById=function(a){return Blockly.Workspace.WorkspaceDB_[a]||null};Blockly.Workspace.getAll=function(){var a=[],b;for(b in Blockly.Workspace.WorkspaceDB_)a.push(Blockly.Workspace.WorkspaceDB_[b]);return a};Blockly.Bubble=function(a,b,c,d,e,f){this.workspace_=a;this.content_=b;this.shape_=c;this.onMouseDownResizeWrapper_=this.onMouseDownBubbleWrapper_=this.moveCallback_=this.resizeCallback_=null;this.disposed=!1;c=Blockly.Bubble.ARROW_ANGLE;this.workspace_.RTL&&(c=-c);this.arrow_radians_=Blockly.utils.math.toRadians(c);a.getBubbleCanvas().appendChild(this.createDom_(b,!(!e||!f)));this.setAnchorLocation(d);e&&f||(a=this.content_.getBBox(),e=a.width+2*Blockly.Bubble.BORDER_WIDTH,f=a.height+2*Blockly.Bubble.BORDER_WIDTH);
	this.setBubbleSize(e,f);this.positionBubble_();this.renderArrow_();this.rendered_=!0};Blockly.Bubble.BORDER_WIDTH=6;Blockly.Bubble.ARROW_THICKNESS=5;Blockly.Bubble.ARROW_ANGLE=20;Blockly.Bubble.ARROW_BEND=4;Blockly.Bubble.ANCHOR_RADIUS=8;Blockly.Bubble.onMouseUpWrapper_=null;Blockly.Bubble.onMouseMoveWrapper_=null;
	Blockly.Bubble.unbindDragEvents_=function(){Blockly.Bubble.onMouseUpWrapper_&&(Blockly.unbindEvent_(Blockly.Bubble.onMouseUpWrapper_),Blockly.Bubble.onMouseUpWrapper_=null);Blockly.Bubble.onMouseMoveWrapper_&&(Blockly.unbindEvent_(Blockly.Bubble.onMouseMoveWrapper_),Blockly.Bubble.onMouseMoveWrapper_=null)};Blockly.Bubble.bubbleMouseUp_=function(a){Blockly.Touch.clearTouchIdentifier();Blockly.Bubble.unbindDragEvents_()};Blockly.Bubble.prototype.rendered_=!1;Blockly.Bubble.prototype.anchorXY_=null;
	Blockly.Bubble.prototype.relativeLeft_=0;Blockly.Bubble.prototype.relativeTop_=0;Blockly.Bubble.prototype.width_=0;Blockly.Bubble.prototype.height_=0;Blockly.Bubble.prototype.autoLayout_=!0;
	Blockly.Bubble.prototype.createDom_=function(a,b){this.bubbleGroup_=Blockly.utils.dom.createSvgElement("g",{},null);var c={filter:"url(#"+this.workspace_.getRenderer().getConstants().embossFilterId+")"};Blockly.utils.userAgent.JAVA_FX&&(c={});c=Blockly.utils.dom.createSvgElement("g",c,this.bubbleGroup_);this.bubbleArrow_=Blockly.utils.dom.createSvgElement("path",{},c);this.bubbleBack_=Blockly.utils.dom.createSvgElement("rect",{"class":"blocklyDraggable",x:0,y:0,rx:Blockly.Bubble.BORDER_WIDTH,ry:Blockly.Bubble.BORDER_WIDTH},
	c);b?(this.resizeGroup_=Blockly.utils.dom.createSvgElement("g",{"class":this.workspace_.RTL?"blocklyResizeSW":"blocklyResizeSE"},this.bubbleGroup_),b=2*Blockly.Bubble.BORDER_WIDTH,Blockly.utils.dom.createSvgElement("polygon",{points:"0,x x,x x,0".replace(/x/g,b.toString())},this.resizeGroup_),Blockly.utils.dom.createSvgElement("line",{"class":"blocklyResizeLine",x1:b/3,y1:b-1,x2:b-1,y2:b/3},this.resizeGroup_),Blockly.utils.dom.createSvgElement("line",{"class":"blocklyResizeLine",x1:2*b/3,y1:b-1,x2:b-
	1,y2:2*b/3},this.resizeGroup_)):this.resizeGroup_=null;this.workspace_.options.readOnly||(this.onMouseDownBubbleWrapper_=Blockly.bindEventWithChecks_(this.bubbleBack_,"mousedown",this,this.bubbleMouseDown_),this.resizeGroup_&&(this.onMouseDownResizeWrapper_=Blockly.bindEventWithChecks_(this.resizeGroup_,"mousedown",this,this.resizeMouseDown_)));this.bubbleGroup_.appendChild(a);return this.bubbleGroup_};Blockly.Bubble.prototype.getSvgRoot=function(){return this.bubbleGroup_};
	Blockly.Bubble.prototype.setSvgId=function(a){this.bubbleGroup_.dataset&&(this.bubbleGroup_.dataset.blockId=a)};Blockly.Bubble.prototype.bubbleMouseDown_=function(a){var b=this.workspace_.getGesture(a);b&&b.handleBubbleStart(a,this)};Blockly.Bubble.prototype.showContextMenu=function(a){};Blockly.Bubble.prototype.isDeletable=function(){return!1};
	Blockly.Bubble.prototype.resizeMouseDown_=function(a){this.promote();Blockly.Bubble.unbindDragEvents_();Blockly.utils.isRightButton(a)||(this.workspace_.startDrag(a,new Blockly.utils.Coordinate(this.workspace_.RTL?-this.width_:this.width_,this.height_)),Blockly.Bubble.onMouseUpWrapper_=Blockly.bindEventWithChecks_(document,"mouseup",this,Blockly.Bubble.bubbleMouseUp_),Blockly.Bubble.onMouseMoveWrapper_=Blockly.bindEventWithChecks_(document,"mousemove",this,this.resizeMouseMove_),Blockly.hideChaff());
	a.stopPropagation()};Blockly.Bubble.prototype.resizeMouseMove_=function(a){this.autoLayout_=!1;a=this.workspace_.moveDrag(a);this.setBubbleSize(this.workspace_.RTL?-a.x:a.x,a.y);this.workspace_.RTL&&this.positionBubble_()};Blockly.Bubble.prototype.registerResizeEvent=function(a){this.resizeCallback_=a};Blockly.Bubble.prototype.registerMoveEvent=function(a){this.moveCallback_=a};
	Blockly.Bubble.prototype.promote=function(){var a=this.bubbleGroup_.parentNode;return a.lastChild!==this.bubbleGroup_?(a.appendChild(this.bubbleGroup_),!0):!1};Blockly.Bubble.prototype.setAnchorLocation=function(a){this.anchorXY_=a;this.rendered_&&this.positionBubble_()};
	Blockly.Bubble.prototype.layoutBubble_=function(){var a=this.workspace_.getMetrics();a.viewLeft/=this.workspace_.scale;a.viewWidth/=this.workspace_.scale;a.viewTop/=this.workspace_.scale;a.viewHeight/=this.workspace_.scale;var b=this.getOptimalRelativeLeft_(a),c=this.getOptimalRelativeTop_(a),d=this.shape_.getBBox(),e={x:b,y:-this.height_-this.workspace_.getRenderer().getConstants().MIN_BLOCK_HEIGHT},f={x:-this.width_-30,y:c};c={x:d.width,y:c};var g={x:b,y:d.height};b=d.width<d.height?c:g;d=d.width<
	d.height?g:c;c=this.getOverlap_(e,a);g=this.getOverlap_(f,a);var h=this.getOverlap_(b,a);a=this.getOverlap_(d,a);a=Math.max(c,g,h,a);c==a?(this.relativeLeft_=e.x,this.relativeTop_=e.y):g==a?(this.relativeLeft_=f.x,this.relativeTop_=f.y):h==a?(this.relativeLeft_=b.x,this.relativeTop_=b.y):(this.relativeLeft_=d.x,this.relativeTop_=d.y)};
	Blockly.Bubble.prototype.getOverlap_=function(a,b){var c=this.workspace_.RTL?this.anchorXY_.x-a.x-this.width_:a.x+this.anchorXY_.x;a=a.y+this.anchorXY_.y;return Math.max(0,Math.min(1,(Math.min(c+this.width_,b.viewLeft+b.viewWidth)-Math.max(c,b.viewLeft))*(Math.min(a+this.height_,b.viewTop+b.viewHeight)-Math.max(a,b.viewTop))/(this.width_*this.height_)))};
	Blockly.Bubble.prototype.getOptimalRelativeLeft_=function(a){var b=-this.width_/4;if(this.width_>a.viewWidth)return b;if(this.workspace_.RTL)var c=this.anchorXY_.x-b,d=c-this.width_,e=a.viewLeft+a.viewWidth,f=a.viewLeft+Blockly.Scrollbar.scrollbarThickness/this.workspace_.scale;else d=b+this.anchorXY_.x,c=d+this.width_,f=a.viewLeft,e=a.viewLeft+a.viewWidth-Blockly.Scrollbar.scrollbarThickness/this.workspace_.scale;this.workspace_.RTL?d<f?b=-(f-this.anchorXY_.x+this.width_):c>e&&(b=-(e-this.anchorXY_.x)):
	d<f?b=f-this.anchorXY_.x:c>e&&(b=e-this.anchorXY_.x-this.width_);return b};Blockly.Bubble.prototype.getOptimalRelativeTop_=function(a){var b=-this.height_/4;if(this.height_>a.viewHeight)return b;var c=this.anchorXY_.y+b,d=c+this.height_,e=a.viewTop;a=a.viewTop+a.viewHeight-Blockly.Scrollbar.scrollbarThickness/this.workspace_.scale;var f=this.anchorXY_.y;c<e?b=e-f:d>a&&(b=a-f-this.height_);return b};
	Blockly.Bubble.prototype.positionBubble_=function(){var a=this.anchorXY_.x;a=this.workspace_.RTL?a-(this.relativeLeft_+this.width_):a+this.relativeLeft_;this.moveTo(a,this.relativeTop_+this.anchorXY_.y)};Blockly.Bubble.prototype.moveTo=function(a,b){this.bubbleGroup_.setAttribute("transform","translate("+a+","+b+")")};Blockly.Bubble.prototype.setDragging=function(a){!a&&this.moveCallback_&&this.moveCallback_()};
	Blockly.Bubble.prototype.getBubbleSize=function(){return new Blockly.utils.Size(this.width_,this.height_)};
	Blockly.Bubble.prototype.setBubbleSize=function(a,b){var c=2*Blockly.Bubble.BORDER_WIDTH;a=Math.max(a,c+45);b=Math.max(b,c+20);this.width_=a;this.height_=b;this.bubbleBack_.setAttribute("width",a);this.bubbleBack_.setAttribute("height",b);this.resizeGroup_&&(this.workspace_.RTL?this.resizeGroup_.setAttribute("transform","translate("+2*Blockly.Bubble.BORDER_WIDTH+","+(b-c)+") scale(-1 1)"):this.resizeGroup_.setAttribute("transform","translate("+(a-c)+","+(b-c)+")"));this.autoLayout_&&this.layoutBubble_();
	this.positionBubble_();this.renderArrow_();this.resizeCallback_&&this.resizeCallback_()};
	Blockly.Bubble.prototype.renderArrow_=function(){var a=[],b=this.width_/2,c=this.height_/2,d=-this.relativeLeft_,e=-this.relativeTop_;if(b==d&&c==e)a.push("M "+b+","+c);else{e-=c;d-=b;this.workspace_.RTL&&(d*=-1);var f=Math.sqrt(e*e+d*d),g=Math.acos(d/f);0>e&&(g=2*Math.PI-g);var h=g+Math.PI/2;h>2*Math.PI&&(h-=2*Math.PI);var k=Math.sin(h),l=Math.cos(h),m=this.getBubbleSize();h=(m.width+m.height)/Blockly.Bubble.ARROW_THICKNESS;h=Math.min(h,m.width,m.height)/4;m=1-Blockly.Bubble.ANCHOR_RADIUS/f;d=b+
	m*d;e=c+m*e;m=b+h*l;var n=c+h*k;b-=h*l;c-=h*k;k=g+this.arrow_radians_;k>2*Math.PI&&(k-=2*Math.PI);g=Math.sin(k)*f/Blockly.Bubble.ARROW_BEND;f=Math.cos(k)*f/Blockly.Bubble.ARROW_BEND;a.push("M"+m+","+n);a.push("C"+(m+f)+","+(n+g)+" "+d+","+e+" "+d+","+e);a.push("C"+d+","+e+" "+(b+f)+","+(c+g)+" "+b+","+c)}a.push("z");this.bubbleArrow_.setAttribute("d",a.join(" "))};Blockly.Bubble.prototype.setColour=function(a){this.bubbleBack_.setAttribute("fill",a);this.bubbleArrow_.setAttribute("fill",a)};
	Blockly.Bubble.prototype.dispose=function(){this.onMouseDownBubbleWrapper_&&Blockly.unbindEvent_(this.onMouseDownBubbleWrapper_);this.onMouseDownResizeWrapper_&&Blockly.unbindEvent_(this.onMouseDownResizeWrapper_);Blockly.Bubble.unbindDragEvents_();Blockly.utils.dom.removeNode(this.bubbleGroup_);this.disposed=!0};
	Blockly.Bubble.prototype.moveDuringDrag=function(a,b){a?a.translateSurface(b.x,b.y):this.moveTo(b.x,b.y);this.relativeLeft_=this.workspace_.RTL?this.anchorXY_.x-b.x-this.width_:b.x-this.anchorXY_.x;this.relativeTop_=b.y-this.anchorXY_.y;this.renderArrow_()};Blockly.Bubble.prototype.getRelativeToSurfaceXY=function(){return new Blockly.utils.Coordinate(this.workspace_.RTL?-this.relativeLeft_+this.anchorXY_.x-this.width_:this.anchorXY_.x+this.relativeLeft_,this.anchorXY_.y+this.relativeTop_)};
	Blockly.Bubble.prototype.setAutoLayout=function(a){this.autoLayout_=a};Blockly.Events.CommentBase=function(a){this.commentId=a.id;this.workspaceId=a.workspace.id;this.group=Blockly.Events.getGroup();this.recordUndo=Blockly.Events.recordUndo};Blockly.utils.object.inherits(Blockly.Events.CommentBase,Blockly.Events.Abstract);Blockly.Events.CommentBase.prototype.toJson=function(){var a=Blockly.Events.CommentBase.superClass_.toJson.call(this);this.commentId&&(a.commentId=this.commentId);return a};
	Blockly.Events.CommentBase.prototype.fromJson=function(a){Blockly.Events.CommentBase.superClass_.fromJson.call(this,a);this.commentId=a.commentId};Blockly.Events.CommentChange=function(a,b,c){a&&(Blockly.Events.CommentChange.superClass_.constructor.call(this,a),this.oldContents_=b,this.newContents_=c)};Blockly.utils.object.inherits(Blockly.Events.CommentChange,Blockly.Events.CommentBase);Blockly.Events.CommentChange.prototype.type=Blockly.Events.COMMENT_CHANGE;
	Blockly.Events.CommentChange.prototype.toJson=function(){var a=Blockly.Events.CommentChange.superClass_.toJson.call(this);a.newContents=this.newContents_;return a};Blockly.Events.CommentChange.prototype.fromJson=function(a){Blockly.Events.CommentChange.superClass_.fromJson.call(this,a);this.newContents_=a.newValue};Blockly.Events.CommentChange.prototype.isNull=function(){return this.oldContents_==this.newContents_};
	Blockly.Events.CommentChange.prototype.run=function(a){var b=this.getEventWorkspace_().getCommentById(this.commentId);b?b.setContent(a?this.newContents_:this.oldContents_):console.warn("Can't change non-existent comment: "+this.commentId)};Blockly.Events.CommentCreate=function(a){a&&(Blockly.Events.CommentCreate.superClass_.constructor.call(this,a),this.xml=a.toXmlWithXY())};Blockly.utils.object.inherits(Blockly.Events.CommentCreate,Blockly.Events.CommentBase);
	Blockly.Events.CommentCreate.prototype.type=Blockly.Events.COMMENT_CREATE;Blockly.Events.CommentCreate.prototype.toJson=function(){var a=Blockly.Events.CommentCreate.superClass_.toJson.call(this);a.xml=Blockly.Xml.domToText(this.xml);return a};Blockly.Events.CommentCreate.prototype.fromJson=function(a){Blockly.Events.CommentCreate.superClass_.fromJson.call(this,a);this.xml=Blockly.Xml.textToDom(a.xml)};
	Blockly.Events.CommentCreate.prototype.run=function(a){Blockly.Events.CommentCreateDeleteHelper(this,a)};Blockly.Events.CommentCreateDeleteHelper=function(a,b){var c=a.getEventWorkspace_();b?(b=Blockly.utils.xml.createElement("xml"),b.appendChild(a.xml),Blockly.Xml.domToWorkspace(b,c)):(c=c.getCommentById(a.commentId))?c.dispose(!1,!1):console.warn("Can't uncreate non-existent comment: "+a.commentId)};
	Blockly.Events.CommentDelete=function(a){a&&(Blockly.Events.CommentDelete.superClass_.constructor.call(this,a),this.xml=a.toXmlWithXY())};Blockly.utils.object.inherits(Blockly.Events.CommentDelete,Blockly.Events.CommentBase);Blockly.Events.CommentDelete.prototype.type=Blockly.Events.COMMENT_DELETE;Blockly.Events.CommentDelete.prototype.toJson=function(){return Blockly.Events.CommentDelete.superClass_.toJson.call(this)};
	Blockly.Events.CommentDelete.prototype.fromJson=function(a){Blockly.Events.CommentDelete.superClass_.fromJson.call(this,a)};Blockly.Events.CommentDelete.prototype.run=function(a){Blockly.Events.CommentCreateDeleteHelper(this,!a)};Blockly.Events.CommentMove=function(a){a&&(Blockly.Events.CommentMove.superClass_.constructor.call(this,a),this.comment_=a,this.oldCoordinate_=a.getXY(),this.newCoordinate_=null)};Blockly.utils.object.inherits(Blockly.Events.CommentMove,Blockly.Events.CommentBase);
	Blockly.Events.CommentMove.prototype.recordNew=function(){if(!this.comment_)throw Error("Tried to record the new position of a comment on the same event twice.");this.newCoordinate_=this.comment_.getXY();this.comment_=null};Blockly.Events.CommentMove.prototype.type=Blockly.Events.COMMENT_MOVE;Blockly.Events.CommentMove.prototype.setOldCoordinate=function(a){this.oldCoordinate_=a};
	Blockly.Events.CommentMove.prototype.toJson=function(){var a=Blockly.Events.CommentMove.superClass_.toJson.call(this);this.newCoordinate_&&(a.newCoordinate=Math.round(this.newCoordinate_.x)+","+Math.round(this.newCoordinate_.y));return a};Blockly.Events.CommentMove.prototype.fromJson=function(a){Blockly.Events.CommentMove.superClass_.fromJson.call(this,a);a.newCoordinate&&(a=a.newCoordinate.split(","),this.newCoordinate_=new Blockly.utils.Coordinate(Number(a[0]),Number(a[1])))};
	Blockly.Events.CommentMove.prototype.isNull=function(){return Blockly.utils.Coordinate.equals(this.oldCoordinate_,this.newCoordinate_)};Blockly.Events.CommentMove.prototype.run=function(a){var b=this.getEventWorkspace_().getCommentById(this.commentId);if(b){a=a?this.newCoordinate_:this.oldCoordinate_;var c=b.getXY();b.moveBy(a.x-c.x,a.y-c.y)}else console.warn("Can't move non-existent comment: "+this.commentId)};Blockly.BubbleDragger=function(a,b){this.draggingBubble_=a;this.workspace_=b;this.deleteArea_=null;this.wouldDeleteBubble_=!1;this.startXY_=this.draggingBubble_.getRelativeToSurfaceXY();this.dragSurface_=Blockly.utils.is3dSupported()&&b.getBlockDragSurface()?b.getBlockDragSurface():null};Blockly.BubbleDragger.prototype.dispose=function(){this.dragSurface_=this.workspace_=this.draggingBubble_=null};
	Blockly.BubbleDragger.prototype.startBubbleDrag=function(){Blockly.Events.getGroup()||Blockly.Events.setGroup(!0);this.workspace_.setResizesEnabled(!1);this.draggingBubble_.setAutoLayout(!1);this.dragSurface_&&this.moveToDragSurface_();this.draggingBubble_.setDragging&&this.draggingBubble_.setDragging(!0);var a=this.workspace_.getToolbox();if(a&&"function"==typeof a.addStyle){var b=this.draggingBubble_.isDeletable()?"blocklyToolboxDelete":"blocklyToolboxGrab";a.addStyle(b)}};
	Blockly.BubbleDragger.prototype.dragBubble=function(a,b){b=this.pixelsToWorkspaceUnits_(b);b=Blockly.utils.Coordinate.sum(this.startXY_,b);this.draggingBubble_.moveDuringDrag(this.dragSurface_,b);this.draggingBubble_.isDeletable()&&(this.deleteArea_=this.workspace_.isDeleteArea(a),this.updateCursorDuringBubbleDrag_())};
	Blockly.BubbleDragger.prototype.maybeDeleteBubble_=function(){var a=this.workspace_.trashcan;this.wouldDeleteBubble_?(a&&setTimeout(a.close.bind(a),100),this.fireMoveEvent_(),this.draggingBubble_.dispose(!1,!0)):a&&a.close();return this.wouldDeleteBubble_};
	Blockly.BubbleDragger.prototype.updateCursorDuringBubbleDrag_=function(){this.wouldDeleteBubble_=this.deleteArea_!=Blockly.DELETE_AREA_NONE;var a=this.workspace_.trashcan;this.wouldDeleteBubble_?(this.draggingBubble_.setDeleteStyle(!0),this.deleteArea_==Blockly.DELETE_AREA_TRASH&&a&&a.setOpen(!0)):(this.draggingBubble_.setDeleteStyle(!1),a&&a.setOpen(!1))};
	Blockly.BubbleDragger.prototype.endBubbleDrag=function(a,b){this.dragBubble(a,b);a=this.pixelsToWorkspaceUnits_(b);a=Blockly.utils.Coordinate.sum(this.startXY_,a);this.draggingBubble_.moveTo(a.x,a.y);this.maybeDeleteBubble_()||(this.dragSurface_&&this.dragSurface_.clearAndHide(this.workspace_.getBubbleCanvas()),this.draggingBubble_.setDragging&&this.draggingBubble_.setDragging(!1),this.fireMoveEvent_());this.workspace_.setResizesEnabled(!0);(a=this.workspace_.getToolbox())&&"function"==typeof a.removeStyle&&
	(b=this.draggingBubble_.isDeletable()?"blocklyToolboxDelete":"blocklyToolboxGrab",a.removeStyle(b));Blockly.Events.setGroup(!1)};Blockly.BubbleDragger.prototype.fireMoveEvent_=function(){if(this.draggingBubble_.isComment){var a=new Blockly.Events.CommentMove(this.draggingBubble_);a.setOldCoordinate(this.startXY_);a.recordNew();Blockly.Events.fire(a)}};
	Blockly.BubbleDragger.prototype.pixelsToWorkspaceUnits_=function(a){a=new Blockly.utils.Coordinate(a.x/this.workspace_.scale,a.y/this.workspace_.scale);this.workspace_.isMutator&&a.scale(1/this.workspace_.options.parentWorkspace.scale);return a};Blockly.BubbleDragger.prototype.moveToDragSurface_=function(){this.draggingBubble_.moveTo(0,0);this.dragSurface_.translateSurface(this.startXY_.x,this.startXY_.y);this.dragSurface_.setBlocksAndShow(this.draggingBubble_.getSvgRoot())};Blockly.WorkspaceDragger=function(a){this.workspace_=a;this.startScrollXY_=new Blockly.utils.Coordinate(a.scrollX,a.scrollY)};Blockly.WorkspaceDragger.prototype.dispose=function(){this.workspace_=null};Blockly.WorkspaceDragger.prototype.startDrag=function(){Blockly.selected&&Blockly.selected.unselect();this.workspace_.setupDragSurface()};Blockly.WorkspaceDragger.prototype.endDrag=function(a){this.drag(a);this.workspace_.resetDragSurface()};
	Blockly.WorkspaceDragger.prototype.drag=function(a){a=Blockly.utils.Coordinate.sum(this.startScrollXY_,a);this.workspace_.scroll(a.x,a.y)};Blockly.FlyoutDragger=function(a){Blockly.FlyoutDragger.superClass_.constructor.call(this,a.getWorkspace());this.scrollbar_=a.scrollbar;this.horizontalLayout_=a.horizontalLayout};Blockly.utils.object.inherits(Blockly.FlyoutDragger,Blockly.WorkspaceDragger);Blockly.FlyoutDragger.prototype.drag=function(a){a=Blockly.utils.Coordinate.sum(this.startScrollXY_,a);this.horizontalLayout_?this.scrollbar_.set(-a.x):this.scrollbar_.set(-a.y)};Blockly.Action=function(a,b){this.name=a;this.desc=b};Blockly.navigation={};Blockly.navigation.loggingCallback=null;Blockly.navigation.STATE_FLYOUT=1;Blockly.navigation.STATE_WS=2;Blockly.navigation.STATE_TOOLBOX=3;Blockly.navigation.WS_MOVE_DISTANCE=40;Blockly.navigation.currentState_=Blockly.navigation.STATE_WS;
	Blockly.navigation.actionNames={PREVIOUS:"previous",NEXT:"next",IN:"in",OUT:"out",INSERT:"insert",MARK:"mark",DISCONNECT:"disconnect",TOOLBOX:"toolbox",EXIT:"exit",TOGGLE_KEYBOARD_NAV:"toggle_keyboard_nav",MOVE_WS_CURSOR_UP:"move workspace cursor up",MOVE_WS_CURSOR_DOWN:"move workspace cursor down",MOVE_WS_CURSOR_LEFT:"move workspace cursor left",MOVE_WS_CURSOR_RIGHT:"move workspace cursor right"};Blockly.navigation.MARKER_NAME="local_marker_1";Blockly.navigation.getMarker=function(){return Blockly.navigation.getNavigationWorkspace().getMarker(Blockly.navigation.MARKER_NAME)};
	Blockly.navigation.getNavigationWorkspace=function(){return Blockly.getMainWorkspace()};Blockly.navigation.focusToolbox_=function(){var a=Blockly.navigation.getNavigationWorkspace().getToolbox();a&&(Blockly.navigation.currentState_=Blockly.navigation.STATE_TOOLBOX,Blockly.navigation.resetFlyout_(!1),Blockly.navigation.getMarker().getCurNode()||Blockly.navigation.markAtCursor_(),a.selectFirstCategory())};
	Blockly.navigation.focusFlyout_=function(){Blockly.navigation.currentState_=Blockly.navigation.STATE_FLYOUT;var a=Blockly.navigation.getNavigationWorkspace();var b=a.getToolbox();a=b?b.getFlyout():a.getFlyout();Blockly.navigation.getMarker().getCurNode()||Blockly.navigation.markAtCursor_();a&&a.getWorkspace()&&(a=a.getWorkspace().getTopBlocks(!0),0<a.length&&(a=a[0],a=Blockly.ASTNode.createStackNode(a),Blockly.navigation.getFlyoutCursor_().setCurNode(a)))};
	Blockly.navigation.focusWorkspace_=function(){Blockly.hideChaff();var a=Blockly.navigation.getNavigationWorkspace(),b=a.getCursor(),c=!!a.getToolbox(),d=a.getTopBlocks(!0);Blockly.navigation.resetFlyout_(c);Blockly.navigation.currentState_=Blockly.navigation.STATE_WS;0<d.length?b.setCurNode(Blockly.ASTNode.createTopNode(d[0])):(c=new Blockly.utils.Coordinate(100,100),a=Blockly.ASTNode.createWorkspaceNode(a,c),b.setCurNode(a))};
	Blockly.navigation.getFlyoutCursor_=function(){var a=Blockly.navigation.getNavigationWorkspace(),b=null;a.rendered&&(b=(a=(b=a.getToolbox())?b.getFlyout():a.getFlyout())?a.getWorkspace().getCursor():null);return b};
	Blockly.navigation.insertFromFlyout=function(){var a=Blockly.navigation.getNavigationWorkspace(),b=a.getFlyout();if(b&&b.isVisible()){var c=Blockly.navigation.getFlyoutCursor_().getCurNode().getLocation();c.isEnabled()?(b=b.createBlock(c),b.render(),b.setConnectionTracking(!0),a.getCursor().setCurNode(Blockly.ASTNode.createBlockNode(b)),Blockly.navigation.modify_()||Blockly.navigation.warn_("Something went wrong while inserting a block from the flyout."),Blockly.navigation.focusWorkspace_(),a.getCursor().setCurNode(Blockly.ASTNode.createTopNode(b)),
	Blockly.navigation.removeMark_()):Blockly.navigation.warn_("Can't insert a disabled block.")}else Blockly.navigation.warn_("Trying to insert from the flyout when the flyout does not  exist or is not visible")};Blockly.navigation.resetFlyout_=function(a){Blockly.navigation.getFlyoutCursor_()&&(Blockly.navigation.getFlyoutCursor_().hide(),a&&Blockly.navigation.getNavigationWorkspace().getFlyout().hide())};
	Blockly.navigation.modifyWarn_=function(){var a=Blockly.navigation.getMarker().getCurNode(),b=Blockly.navigation.getNavigationWorkspace().getCursor().getCurNode();if(!a)return Blockly.navigation.warn_("Cannot insert with no marked node."),!1;if(!b)return Blockly.navigation.warn_("Cannot insert with no cursor node."),!1;a=a.getType();b=b.getType();return a==Blockly.ASTNode.types.FIELD?(Blockly.navigation.warn_("Should not have been able to mark a field."),!1):a==Blockly.ASTNode.types.BLOCK?(Blockly.navigation.warn_("Should not have been able to mark a block."),
	!1):a==Blockly.ASTNode.types.STACK?(Blockly.navigation.warn_("Should not have been able to mark a stack."),!1):b==Blockly.ASTNode.types.FIELD?(Blockly.navigation.warn_("Cannot attach a field to anything else."),!1):b==Blockly.ASTNode.types.WORKSPACE?(Blockly.navigation.warn_("Cannot attach a workspace to anything else."),!1):!0};
	Blockly.navigation.moveBlockToWorkspace_=function(a,b){if(!a)return!1;if(a.isShadow())return Blockly.navigation.warn_("Cannot move a shadow block to the workspace."),!1;a.getParent()&&a.unplug(!1);a.moveTo(b.getWsCoordinate());return!0};
	Blockly.navigation.modify_=function(){var a=Blockly.navigation.getMarker().getCurNode(),b=Blockly.navigation.getNavigationWorkspace().getCursor().getCurNode();if(!Blockly.navigation.modifyWarn_())return!1;var c=a.getType(),d=b.getType(),e=b.getLocation(),f=a.getLocation();if(a.isConnection()&&b.isConnection())return Blockly.navigation.connect_(e,f);if(a.isConnection()&&(d==Blockly.ASTNode.types.BLOCK||d==Blockly.ASTNode.types.STACK))return Blockly.navigation.insertBlock(e,f);if(c==Blockly.ASTNode.types.WORKSPACE)return b=
	b?b.getSourceBlock():null,Blockly.navigation.moveBlockToWorkspace_(b,a);Blockly.navigation.warn_("Unexpected state in Blockly.navigation.modify_.");return!1};Blockly.navigation.disconnectChild_=function(a,b){var c=a.getSourceBlock(),d=b.getSourceBlock();c.getRootBlock()==d.getRootBlock()&&(-1<c.getDescendants(!1).indexOf(d)?Blockly.navigation.getInferiorConnection_(b).disconnect():Blockly.navigation.getInferiorConnection_(a).disconnect())};
	Blockly.navigation.moveAndConnect_=function(a,b){if(!a||!b)return!1;var c=a.getSourceBlock();return b.canConnectWithReason(a)==Blockly.Connection.CAN_CONNECT?(Blockly.navigation.disconnectChild_(a,b),b.isSuperior()||c.getRootBlock().positionNearConnection(a,b),b.connect(a),!0):!1};Blockly.navigation.getInferiorConnection_=function(a){var b=a.getSourceBlock();return a.isSuperior()?b.previousConnection?b.previousConnection:b.outputConnection?b.outputConnection:null:a};
	Blockly.navigation.getSuperiorConnection_=function(a){return a.isSuperior()?a:a.targetConnection?a.targetConnection:null};
	Blockly.navigation.connect_=function(a,b){if(!a||!b)return!1;var c=Blockly.navigation.getInferiorConnection_(a),d=Blockly.navigation.getSuperiorConnection_(b),e=Blockly.navigation.getSuperiorConnection_(a),f=Blockly.navigation.getInferiorConnection_(b);if(c&&d&&Blockly.navigation.moveAndConnect_(c,d)||e&&f&&Blockly.navigation.moveAndConnect_(e,f)||Blockly.navigation.moveAndConnect_(a,b))return!0;try{b.checkConnection(a)}catch(g){Blockly.navigation.warn_("Connection failed with error: "+g)}return!1};
	Blockly.navigation.insertBlock=function(a,b){switch(b.type){case Blockly.PREVIOUS_STATEMENT:if(Blockly.navigation.connect_(a.nextConnection,b))return!0;break;case Blockly.NEXT_STATEMENT:if(Blockly.navigation.connect_(a.previousConnection,b))return!0;break;case Blockly.INPUT_VALUE:if(Blockly.navigation.connect_(a.outputConnection,b))return!0;break;case Blockly.OUTPUT_VALUE:for(var c=0;c<a.inputList.length;c++){var d=a.inputList[c].connection;if(d&&d.type===Blockly.INPUT_VALUE&&Blockly.navigation.connect_(d,
	b))return!0}if(a.outputConnection&&Blockly.navigation.connect_(a.outputConnection,b))return!0}Blockly.navigation.warn_("This block can not be inserted at the marked location.");return!1};
	Blockly.navigation.disconnectBlocks_=function(){var a=Blockly.navigation.getNavigationWorkspace(),b=a.getCursor().getCurNode();if(b.isConnection()){var c=b.getLocation();c.isConnected()?(b=c.isSuperior()?c:c.targetConnection,c=c.isSuperior()?c.targetConnection:c,c.getSourceBlock().isShadow()?Blockly.navigation.log_("Cannot disconnect a shadow block"):(b.disconnect(),c.bumpAwayFrom(b),b.getSourceBlock().getRootBlock().bringToFront(),b=Blockly.ASTNode.createConnectionNode(b),a.getCursor().setCurNode(b))):
	Blockly.navigation.log_("Cannot disconnect unconnected connection")}else Blockly.navigation.log_("Cannot disconnect blocks when the cursor is not on a connection")};Blockly.navigation.markAtCursor_=function(){Blockly.navigation.getMarker().setCurNode(Blockly.navigation.getNavigationWorkspace().getCursor().getCurNode())};Blockly.navigation.removeMark_=function(){var a=Blockly.navigation.getMarker();a.setCurNode(null);a.hide()};
	Blockly.navigation.setState=function(a){Blockly.navigation.currentState_=a};
	Blockly.navigation.moveCursorOnBlockDelete=function(a){var b=Blockly.navigation.getNavigationWorkspace();if(b&&(b=b.getCursor())){var c=b.getCurNode();c=c?c.getSourceBlock():null;c===a?c.getParent()?(a=c.previousConnection||c.outputConnection)&&b.setCurNode(Blockly.ASTNode.createConnectionNode(a.targetConnection)):b.setCurNode(Blockly.ASTNode.createWorkspaceNode(c.workspace,c.getRelativeToSurfaceXY())):c&&-1<a.getChildren(!1).indexOf(c)&&b.setCurNode(Blockly.ASTNode.createWorkspaceNode(c.workspace,
	c.getRelativeToSurfaceXY()))}};Blockly.navigation.moveCursorOnBlockMutation=function(a){var b=Blockly.navigation.getNavigationWorkspace().getCursor();if(b){var c=b.getCurNode();c=c?c.getSourceBlock():null;c===a&&b.setCurNode(Blockly.ASTNode.createBlockNode(c))}};Blockly.navigation.enableKeyboardAccessibility=function(){var a=Blockly.navigation.getNavigationWorkspace();a.keyboardAccessibilityMode||(a.keyboardAccessibilityMode=!0,Blockly.navigation.focusWorkspace_())};
	Blockly.navigation.disableKeyboardAccessibility=function(){var a=Blockly.navigation.getNavigationWorkspace();a.keyboardAccessibilityMode&&(a.keyboardAccessibilityMode=!1,a.getCursor().hide(),Blockly.navigation.getMarker().hide(),Blockly.navigation.getFlyoutCursor_()&&Blockly.navigation.getFlyoutCursor_().hide())};Blockly.navigation.log_=function(a){Blockly.navigation.loggingCallback?Blockly.navigation.loggingCallback("log",a):console.log(a)};
	Blockly.navigation.warn_=function(a){Blockly.navigation.loggingCallback?Blockly.navigation.loggingCallback("warn",a):console.warn(a)};Blockly.navigation.error_=function(a){Blockly.navigation.loggingCallback?Blockly.navigation.loggingCallback("error",a):console.error(a)};Blockly.navigation.onKeyPress=function(a){a=Blockly.user.keyMap.serializeKeyEvent(a);return(a=Blockly.user.keyMap.getActionByKeyCode(a))?Blockly.navigation.onBlocklyAction(a):!1};
	Blockly.navigation.onBlocklyAction=function(a){var b=Blockly.navigation.getNavigationWorkspace(),c=b.options.readOnly,d=!1;b.keyboardAccessibilityMode?c?-1<Blockly.navigation.READONLY_ACTION_LIST.indexOf(a)&&(d=Blockly.navigation.handleActions_(a)):d=Blockly.navigation.handleActions_(a):a.name===Blockly.navigation.actionNames.TOGGLE_KEYBOARD_NAV&&(Blockly.navigation.enableKeyboardAccessibility(),d=!0);return d};
	Blockly.navigation.handleActions_=function(a){return a.name==Blockly.navigation.actionNames.TOOLBOX||Blockly.navigation.currentState_==Blockly.navigation.STATE_TOOLBOX?Blockly.navigation.toolboxOnAction_(a):a.name==Blockly.navigation.actionNames.TOGGLE_KEYBOARD_NAV?(Blockly.navigation.disableKeyboardAccessibility(),!0):Blockly.navigation.currentState_==Blockly.navigation.STATE_WS?Blockly.navigation.workspaceOnAction_(a):Blockly.navigation.currentState_==Blockly.navigation.STATE_FLYOUT?Blockly.navigation.flyoutOnAction_(a):
	!1};Blockly.navigation.flyoutOnAction_=function(a){var b=Blockly.navigation.getNavigationWorkspace(),c=b.getToolbox();if((b=c?c.getFlyout():b.getFlyout())&&b.onBlocklyAction(a))return!0;switch(a.name){case Blockly.navigation.actionNames.OUT:return Blockly.navigation.focusToolbox_(),!0;case Blockly.navigation.actionNames.MARK:return Blockly.navigation.insertFromFlyout(),!0;case Blockly.navigation.actionNames.EXIT:return Blockly.navigation.focusWorkspace_(),!0;default:return!1}};
	Blockly.navigation.toolboxOnAction_=function(a){var b=Blockly.navigation.getNavigationWorkspace(),c=b.getToolbox();return c&&"function"==typeof c.onBlocklyAction&&c.onBlocklyAction(a)?!0:a.name===Blockly.navigation.actionNames.TOOLBOX?(b.getToolbox()?Blockly.navigation.focusToolbox_():Blockly.navigation.focusFlyout_(),!0):a.name===Blockly.navigation.actionNames.IN?(Blockly.navigation.focusFlyout_(),!0):a.name===Blockly.navigation.actionNames.EXIT?(Blockly.navigation.focusWorkspace_(),!0):!1};
	Blockly.navigation.moveWSCursor_=function(a,b){var c=Blockly.navigation.getNavigationWorkspace(),d=c.getCursor(),e=c.getCursor().getCurNode();if(e.getType()!==Blockly.ASTNode.types.WORKSPACE)return!1;e=e.getWsCoordinate();d.setCurNode(Blockly.ASTNode.createWorkspaceNode(c,new Blockly.utils.Coordinate(a*Blockly.navigation.WS_MOVE_DISTANCE+e.x,b*Blockly.navigation.WS_MOVE_DISTANCE+e.y)));return!0};
	Blockly.navigation.workspaceOnAction_=function(a){if(Blockly.navigation.getNavigationWorkspace().getCursor().onBlocklyAction(a))return!0;switch(a.name){case Blockly.navigation.actionNames.INSERT:return Blockly.navigation.modify_(),!0;case Blockly.navigation.actionNames.MARK:return Blockly.navigation.handleEnterForWS_(),!0;case Blockly.navigation.actionNames.DISCONNECT:return Blockly.navigation.disconnectBlocks_(),!0;case Blockly.navigation.actionNames.MOVE_WS_CURSOR_UP:return Blockly.navigation.moveWSCursor_(0,
	-1);case Blockly.navigation.actionNames.MOVE_WS_CURSOR_DOWN:return Blockly.navigation.moveWSCursor_(0,1);case Blockly.navigation.actionNames.MOVE_WS_CURSOR_LEFT:return Blockly.navigation.moveWSCursor_(-1,0);case Blockly.navigation.actionNames.MOVE_WS_CURSOR_RIGHT:return Blockly.navigation.moveWSCursor_(1,0);default:return!1}};
	Blockly.navigation.handleEnterForWS_=function(){var a=Blockly.navigation.getNavigationWorkspace().getCursor().getCurNode(),b=a.getType();b==Blockly.ASTNode.types.FIELD?a.getLocation().showEditor():a.isConnection()||b==Blockly.ASTNode.types.WORKSPACE?Blockly.navigation.markAtCursor_():b==Blockly.ASTNode.types.BLOCK?Blockly.navigation.warn_("Cannot mark a block."):b==Blockly.ASTNode.types.STACK&&Blockly.navigation.warn_("Cannot mark a stack.")};
	Blockly.navigation.ACTION_PREVIOUS=new Blockly.Action(Blockly.navigation.actionNames.PREVIOUS,"Go to the previous location.");Blockly.navigation.ACTION_OUT=new Blockly.Action(Blockly.navigation.actionNames.OUT,"Go to the parent of the current location.");Blockly.navigation.ACTION_NEXT=new Blockly.Action(Blockly.navigation.actionNames.NEXT,"Go to the next location.");Blockly.navigation.ACTION_IN=new Blockly.Action(Blockly.navigation.actionNames.IN,"Go to the first child of the current location.");
	Blockly.navigation.ACTION_INSERT=new Blockly.Action(Blockly.navigation.actionNames.INSERT,"Connect the current location to the marked location.");Blockly.navigation.ACTION_MARK=new Blockly.Action(Blockly.navigation.actionNames.MARK,"Mark the current location.");Blockly.navigation.ACTION_DISCONNECT=new Blockly.Action(Blockly.navigation.actionNames.DISCONNECT,"Disconnect the block at the current location from its parent.");
	Blockly.navigation.ACTION_TOOLBOX=new Blockly.Action(Blockly.navigation.actionNames.TOOLBOX,"Open the toolbox.");Blockly.navigation.ACTION_EXIT=new Blockly.Action(Blockly.navigation.actionNames.EXIT,"Close the current modal, such as a toolbox or field editor.");Blockly.navigation.ACTION_TOGGLE_KEYBOARD_NAV=new Blockly.Action(Blockly.navigation.actionNames.TOGGLE_KEYBOARD_NAV,"Turns on and off keyboard navigation.");
	Blockly.navigation.ACTION_MOVE_WS_CURSOR_LEFT=new Blockly.Action(Blockly.navigation.actionNames.MOVE_WS_CURSOR_LEFT,"Move the workspace cursor to the lefts.");Blockly.navigation.ACTION_MOVE_WS_CURSOR_RIGHT=new Blockly.Action(Blockly.navigation.actionNames.MOVE_WS_CURSOR_RIGHT,"Move the workspace cursor to the right.");Blockly.navigation.ACTION_MOVE_WS_CURSOR_UP=new Blockly.Action(Blockly.navigation.actionNames.MOVE_WS_CURSOR_UP,"Move the workspace cursor up.");
	Blockly.navigation.ACTION_MOVE_WS_CURSOR_DOWN=new Blockly.Action(Blockly.navigation.actionNames.MOVE_WS_CURSOR_DOWN,"Move the workspace cursor down.");Blockly.navigation.READONLY_ACTION_LIST=[Blockly.navigation.ACTION_PREVIOUS,Blockly.navigation.ACTION_OUT,Blockly.navigation.ACTION_IN,Blockly.navigation.ACTION_NEXT,Blockly.navigation.ACTION_TOGGLE_KEYBOARD_NAV];Blockly.Gesture=function(a,b){this.mouseDownXY_=null;this.currentDragDeltaXY_=new Blockly.utils.Coordinate(0,0);this.startWorkspace_=this.targetBlock_=this.startBlock_=this.startField_=this.startBubble_=null;this.creatorWorkspace_=b;this.isDraggingBubble_=this.isDraggingBlock_=this.isDraggingWorkspace_=this.hasExceededDragRadius_=!1;this.mostRecentEvent_=a;this.flyout_=this.workspaceDragger_=this.blockDragger_=this.bubbleDragger_=this.onUpWrapper_=this.onMoveWrapper_=null;this.isEnding_=this.hasStarted_=
	this.calledUpdateIsDragging_=!1;this.healStack_=!Blockly.DRAG_STACK};Blockly.Gesture.prototype.dispose=function(){Blockly.Touch.clearTouchIdentifier();Blockly.Tooltip.unblock();this.creatorWorkspace_.clearGesture();this.onMoveWrapper_&&Blockly.unbindEvent_(this.onMoveWrapper_);this.onUpWrapper_&&Blockly.unbindEvent_(this.onUpWrapper_);this.blockDragger_&&this.blockDragger_.dispose();this.workspaceDragger_&&this.workspaceDragger_.dispose();this.bubbleDragger_&&this.bubbleDragger_.dispose()};
	Blockly.Gesture.prototype.updateFromEvent_=function(a){var b=new Blockly.utils.Coordinate(a.clientX,a.clientY);this.updateDragDelta_(b)&&(this.updateIsDragging_(),Blockly.longStop_());this.mostRecentEvent_=a};
	Blockly.Gesture.prototype.updateDragDelta_=function(a){this.currentDragDeltaXY_=Blockly.utils.Coordinate.difference(a,this.mouseDownXY_);return this.hasExceededDragRadius_?!1:this.hasExceededDragRadius_=Blockly.utils.Coordinate.magnitude(this.currentDragDeltaXY_)>(this.flyout_?Blockly.FLYOUT_DRAG_RADIUS:Blockly.DRAG_RADIUS)};
	Blockly.Gesture.prototype.updateIsDraggingFromFlyout_=function(){return this.targetBlock_&&this.flyout_.isBlockCreatable_(this.targetBlock_)?!this.flyout_.isScrollable()||this.flyout_.isDragTowardWorkspace(this.currentDragDeltaXY_)?(this.startWorkspace_=this.flyout_.targetWorkspace,this.startWorkspace_.updateScreenCalculationsIfScrolled(),Blockly.Events.getGroup()||Blockly.Events.setGroup(!0),this.startBlock_=null,this.targetBlock_=this.flyout_.createBlock(this.targetBlock_),this.targetBlock_.select(),
	!0):!1:!1};Blockly.Gesture.prototype.updateIsDraggingBubble_=function(){if(!this.startBubble_)return!1;this.isDraggingBubble_=!0;this.startDraggingBubble_();return!0};Blockly.Gesture.prototype.updateIsDraggingBlock_=function(){if(!this.targetBlock_)return!1;this.flyout_?this.isDraggingBlock_=this.updateIsDraggingFromFlyout_():this.targetBlock_.isMovable()&&(this.isDraggingBlock_=!0);return this.isDraggingBlock_?(this.startDraggingBlock_(),!0):!1};
	Blockly.Gesture.prototype.updateIsDraggingWorkspace_=function(){if(this.flyout_?this.flyout_.isScrollable():this.startWorkspace_&&this.startWorkspace_.isDraggable())this.workspaceDragger_=this.flyout_?new Blockly.FlyoutDragger(this.flyout_):new Blockly.WorkspaceDragger(this.startWorkspace_),this.isDraggingWorkspace_=!0,this.workspaceDragger_.startDrag()};
	Blockly.Gesture.prototype.updateIsDragging_=function(){if(this.calledUpdateIsDragging_)throw Error("updateIsDragging_ should only be called once per gesture.");this.calledUpdateIsDragging_=!0;this.updateIsDraggingBubble_()||this.updateIsDraggingBlock_()||this.updateIsDraggingWorkspace_()};
	Blockly.Gesture.prototype.startDraggingBlock_=function(){this.blockDragger_=new Blockly.BlockDragger(this.targetBlock_,this.startWorkspace_);this.blockDragger_.startBlockDrag(this.currentDragDeltaXY_,this.healStack_);this.blockDragger_.dragBlock(this.mostRecentEvent_,this.currentDragDeltaXY_)};
	Blockly.Gesture.prototype.startDraggingBubble_=function(){this.bubbleDragger_=new Blockly.BubbleDragger(this.startBubble_,this.startWorkspace_);this.bubbleDragger_.startBubbleDrag();this.bubbleDragger_.dragBubble(this.mostRecentEvent_,this.currentDragDeltaXY_)};
	Blockly.Gesture.prototype.doStart=function(a){Blockly.utils.isTargetInput(a)?this.cancel():(this.hasStarted_=!0,Blockly.blockAnimations.disconnectUiStop(),this.startWorkspace_.updateScreenCalculationsIfScrolled(),this.startWorkspace_.isMutator&&this.startWorkspace_.resize(),Blockly.hideChaff(!!this.flyout_),this.startWorkspace_.markFocused(),this.mostRecentEvent_=a,Blockly.Tooltip.block(),this.targetBlock_&&(!this.targetBlock_.isInFlyout&&a.shiftKey&&this.targetBlock_.workspace.keyboardAccessibilityMode?
	this.creatorWorkspace_.getCursor().setCurNode(Blockly.ASTNode.createTopNode(this.targetBlock_)):this.targetBlock_.select()),Blockly.utils.isRightButton(a)?this.handleRightClick(a):("touchstart"!=a.type.toLowerCase()&&"pointerdown"!=a.type.toLowerCase()||"mouse"==a.pointerType||Blockly.longStart(a,this),this.mouseDownXY_=new Blockly.utils.Coordinate(a.clientX,a.clientY),this.healStack_=a.altKey||a.ctrlKey||a.metaKey,this.bindMouseEvents(a)))};
	Blockly.Gesture.prototype.bindMouseEvents=function(a){this.onMoveWrapper_=Blockly.bindEventWithChecks_(document,"mousemove",null,this.handleMove.bind(this));this.onUpWrapper_=Blockly.bindEventWithChecks_(document,"mouseup",null,this.handleUp.bind(this));a.preventDefault();a.stopPropagation()};
	Blockly.Gesture.prototype.handleMove=function(a){this.updateFromEvent_(a);this.isDraggingWorkspace_?this.workspaceDragger_.drag(this.currentDragDeltaXY_):this.isDraggingBlock_?this.blockDragger_.dragBlock(this.mostRecentEvent_,this.currentDragDeltaXY_):this.isDraggingBubble_&&this.bubbleDragger_.dragBubble(this.mostRecentEvent_,this.currentDragDeltaXY_);a.preventDefault();a.stopPropagation()};
	Blockly.Gesture.prototype.handleUp=function(a){this.updateFromEvent_(a);Blockly.longStop_();this.isEnding_?console.log("Trying to end a gesture recursively."):(this.isEnding_=!0,this.isDraggingBubble_?this.bubbleDragger_.endBubbleDrag(a,this.currentDragDeltaXY_):this.isDraggingBlock_?this.blockDragger_.endBlockDrag(a,this.currentDragDeltaXY_):this.isDraggingWorkspace_?this.workspaceDragger_.endDrag(this.currentDragDeltaXY_):this.isBubbleClick_()?this.doBubbleClick_():this.isFieldClick_()?this.doFieldClick_():
	this.isBlockClick_()?this.doBlockClick_():this.isWorkspaceClick_()&&this.doWorkspaceClick_(a),a.preventDefault(),a.stopPropagation(),this.dispose())};
	Blockly.Gesture.prototype.cancel=function(){this.isEnding_||(Blockly.longStop_(),this.isDraggingBubble_?this.bubbleDragger_.endBubbleDrag(this.mostRecentEvent_,this.currentDragDeltaXY_):this.isDraggingBlock_?this.blockDragger_.endBlockDrag(this.mostRecentEvent_,this.currentDragDeltaXY_):this.isDraggingWorkspace_&&this.workspaceDragger_.endDrag(this.currentDragDeltaXY_),this.dispose())};
	Blockly.Gesture.prototype.handleRightClick=function(a){this.targetBlock_?(this.bringBlockToFront_(),Blockly.hideChaff(!!this.flyout_),this.targetBlock_.showContextMenu(a)):this.startBubble_?this.startBubble_.showContextMenu(a):this.startWorkspace_&&!this.flyout_&&(Blockly.hideChaff(),this.startWorkspace_.showContextMenu(a));a.preventDefault();a.stopPropagation();this.dispose()};
	Blockly.Gesture.prototype.handleWsStart=function(a,b){if(this.hasStarted_)throw Error("Tried to call gesture.handleWsStart, but the gesture had already been started.");this.setStartWorkspace_(b);this.mostRecentEvent_=a;this.doStart(a);this.startWorkspace_.keyboardAccessibilityMode&&Blockly.navigation.setState(Blockly.navigation.STATE_WS)};Blockly.Gesture.prototype.fireWorkspaceClick_=function(a){var b=new Blockly.Events.Ui(null,"workspaceClick",null,null);b.workspaceId=a.id;Blockly.Events.fire(b)};
	Blockly.Gesture.prototype.handleFlyoutStart=function(a,b){if(this.hasStarted_)throw Error("Tried to call gesture.handleFlyoutStart, but the gesture had already been started.");this.setStartFlyout_(b);this.handleWsStart(a,b.getWorkspace())};Blockly.Gesture.prototype.handleBlockStart=function(a,b){if(this.hasStarted_)throw Error("Tried to call gesture.handleBlockStart, but the gesture had already been started.");this.setStartBlock(b);this.mostRecentEvent_=a};
	Blockly.Gesture.prototype.handleBubbleStart=function(a,b){if(this.hasStarted_)throw Error("Tried to call gesture.handleBubbleStart, but the gesture had already been started.");this.setStartBubble(b);this.mostRecentEvent_=a};Blockly.Gesture.prototype.doBubbleClick_=function(){this.startBubble_.setFocus&&this.startBubble_.setFocus();this.startBubble_.select&&this.startBubble_.select()};Blockly.Gesture.prototype.doFieldClick_=function(){this.startField_.showEditor(this.mostRecentEvent_);this.bringBlockToFront_()};
	Blockly.Gesture.prototype.doBlockClick_=function(){this.flyout_&&this.flyout_.autoClose?this.targetBlock_.isEnabled()&&(Blockly.Events.getGroup()||Blockly.Events.setGroup(!0),this.flyout_.createBlock(this.targetBlock_).scheduleSnapAndBump()):Blockly.Events.fire(new Blockly.Events.Ui(this.startBlock_,"click",void 0,void 0));this.bringBlockToFront_();Blockly.Events.setGroup(!1)};
	Blockly.Gesture.prototype.doWorkspaceClick_=function(a){var b=this.creatorWorkspace_;a.shiftKey&&b.keyboardAccessibilityMode?(a=new Blockly.utils.Coordinate(a.clientX,a.clientY),a=Blockly.utils.screenToWsCoordinates(b,a),a=Blockly.ASTNode.createWorkspaceNode(b,a),b.getCursor().setCurNode(a)):Blockly.selected&&Blockly.selected.unselect();this.fireWorkspaceClick_(b)};Blockly.Gesture.prototype.bringBlockToFront_=function(){this.targetBlock_&&!this.flyout_&&this.targetBlock_.bringToFront()};
	Blockly.Gesture.prototype.setStartField=function(a){if(this.hasStarted_)throw Error("Tried to call gesture.setStartField, but the gesture had already been started.");this.startField_||(this.startField_=a)};Blockly.Gesture.prototype.setStartBubble=function(a){this.startBubble_||(this.startBubble_=a)};Blockly.Gesture.prototype.setStartBlock=function(a){this.startBlock_||this.startBubble_||(this.startBlock_=a,a.isInFlyout&&a!=a.getRootBlock()?this.setTargetBlock_(a.getRootBlock()):this.setTargetBlock_(a))};
	Blockly.Gesture.prototype.setTargetBlock_=function(a){a.isShadow()?this.setTargetBlock_(a.getParent()):this.targetBlock_=a};Blockly.Gesture.prototype.setStartWorkspace_=function(a){this.startWorkspace_||(this.startWorkspace_=a)};Blockly.Gesture.prototype.setStartFlyout_=function(a){this.flyout_||(this.flyout_=a)};Blockly.Gesture.prototype.isBubbleClick_=function(){return!!this.startBubble_&&!this.hasExceededDragRadius_};
	Blockly.Gesture.prototype.isBlockClick_=function(){return!!this.startBlock_&&!this.hasExceededDragRadius_&&!this.isFieldClick_()};Blockly.Gesture.prototype.isFieldClick_=function(){return(this.startField_?this.startField_.isClickable():!1)&&!this.hasExceededDragRadius_&&(!this.flyout_||!this.flyout_.autoClose)};Blockly.Gesture.prototype.isWorkspaceClick_=function(){return!this.startBlock_&&!this.startBubble_&&!this.startField_&&!this.hasExceededDragRadius_};
	Blockly.Gesture.prototype.isDragging=function(){return this.isDraggingWorkspace_||this.isDraggingBlock_||this.isDraggingBubble_};Blockly.Gesture.prototype.hasStarted=function(){return this.hasStarted_};Blockly.Gesture.prototype.getInsertionMarkers=function(){return this.blockDragger_?this.blockDragger_.getInsertionMarkers():[]};Blockly.Gesture.inProgress=function(){for(var a=Blockly.Workspace.getAll(),b=0,c;c=a[b];b++)if(c.currentGesture_)return!0;return!1};Blockly.Field=function(a,b,c){this.value_=this.DEFAULT_VALUE;this.tooltip_=this.validator_=null;this.size_=new Blockly.utils.Size(0,0);this.constants_=this.mouseDownWrapper_=this.textContent_=this.textElement_=this.borderRect_=this.fieldGroup_=this.markerSvg_=this.cursorSvg_=null;c&&this.configure_(c);this.setValue(a);b&&this.setValidator(b)};Blockly.Field.prototype.DEFAULT_VALUE=null;Blockly.Field.prototype.name=void 0;Blockly.Field.prototype.disposed=!1;
	Blockly.Field.prototype.maxDisplayLength=50;Blockly.Field.prototype.sourceBlock_=null;Blockly.Field.prototype.isDirty_=!0;Blockly.Field.prototype.visible_=!0;Blockly.Field.prototype.clickTarget_=null;Blockly.Field.NBSP="\u00a0";Blockly.Field.prototype.EDITABLE=!0;Blockly.Field.prototype.SERIALIZABLE=!1;Blockly.Field.prototype.configure_=function(a){var b=a.tooltip;"string"==typeof b&&(b=Blockly.utils.replaceMessageReferences(a.tooltip));b&&this.setTooltip(b)};
	Blockly.Field.prototype.setSourceBlock=function(a){if(this.sourceBlock_)throw Error("Field already bound to a block.");this.sourceBlock_=a};Blockly.Field.prototype.getConstants=function(){!this.constants_&&this.sourceBlock_&&this.sourceBlock_.workspace&&this.sourceBlock_.workspace.rendered&&(this.constants_=this.sourceBlock_.workspace.getRenderer().getConstants());return this.constants_};Blockly.Field.prototype.getSourceBlock=function(){return this.sourceBlock_};
	Blockly.Field.prototype.init=function(){this.fieldGroup_||(this.fieldGroup_=Blockly.utils.dom.createSvgElement("g",{},null),this.isVisible()||(this.fieldGroup_.style.display="none"),this.sourceBlock_.getSvgRoot().appendChild(this.fieldGroup_),this.initView(),this.updateEditable(),this.setTooltip(this.tooltip_),this.bindEvents_(),this.initModel())};Blockly.Field.prototype.initView=function(){this.createBorderRect_();this.createTextElement_()};Blockly.Field.prototype.initModel=function(){};
	Blockly.Field.prototype.createBorderRect_=function(){this.borderRect_=Blockly.utils.dom.createSvgElement("rect",{rx:this.getConstants().FIELD_BORDER_RECT_RADIUS,ry:this.getConstants().FIELD_BORDER_RECT_RADIUS,x:0,y:0,height:this.size_.height,width:this.size_.width,"class":"blocklyFieldRect"},this.fieldGroup_)};
	Blockly.Field.prototype.createTextElement_=function(){this.textElement_=Blockly.utils.dom.createSvgElement("text",{"class":"blocklyText"},this.fieldGroup_);this.getConstants().FIELD_TEXT_BASELINE_CENTER&&this.textElement_.setAttribute("dominant-baseline","central");this.textContent_=document.createTextNode("");this.textElement_.appendChild(this.textContent_)};
	Blockly.Field.prototype.bindEvents_=function(){Blockly.Tooltip.bindMouseEvents(this.getClickTarget_());this.mouseDownWrapper_=Blockly.bindEventWithChecks_(this.getClickTarget_(),"mousedown",this,this.onMouseDown_)};Blockly.Field.prototype.fromXml=function(a){this.setValue(a.textContent)};Blockly.Field.prototype.toXml=function(a){a.textContent=this.getValue();return a};
	Blockly.Field.prototype.dispose=function(){Blockly.DropDownDiv.hideIfOwner(this);Blockly.WidgetDiv.hideIfOwner(this);Blockly.Tooltip.unbindMouseEvents(this.getClickTarget_());this.mouseDownWrapper_&&Blockly.unbindEvent_(this.mouseDownWrapper_);Blockly.utils.dom.removeNode(this.fieldGroup_);this.disposed=!0};
	Blockly.Field.prototype.updateEditable=function(){var a=this.fieldGroup_;this.EDITABLE&&a&&(this.sourceBlock_.isEditable()?(Blockly.utils.dom.addClass(a,"blocklyEditableText"),Blockly.utils.dom.removeClass(a,"blocklyNonEditableText"),a.style.cursor=this.CURSOR):(Blockly.utils.dom.addClass(a,"blocklyNonEditableText"),Blockly.utils.dom.removeClass(a,"blocklyEditableText"),a.style.cursor=""))};
	Blockly.Field.prototype.isClickable=function(){return!!this.sourceBlock_&&this.sourceBlock_.isEditable()&&!!this.showEditor_&&"function"===typeof this.showEditor_};Blockly.Field.prototype.isCurrentlyEditable=function(){return this.EDITABLE&&!!this.sourceBlock_&&this.sourceBlock_.isEditable()};
	Blockly.Field.prototype.isSerializable=function(){var a=!1;this.name&&(this.SERIALIZABLE?a=!0:this.EDITABLE&&(console.warn("Detected an editable field that was not serializable. Please define SERIALIZABLE property as true on all editable custom fields. Proceeding with serialization."),a=!0));return a};Blockly.Field.prototype.isVisible=function(){return this.visible_};
	Blockly.Field.prototype.setVisible=function(a){if(this.visible_!=a){this.visible_=a;var b=this.getSvgRoot();b&&(b.style.display=a?"block":"none")}};Blockly.Field.prototype.setValidator=function(a){this.validator_=a};Blockly.Field.prototype.getValidator=function(){return this.validator_};Blockly.Field.prototype.classValidator=function(a){return a};
	Blockly.Field.prototype.callValidator=function(a){var b=this.classValidator(a);if(null===b)return null;void 0!==b&&(a=b);if(b=this.getValidator()){b=b.call(this,a);if(null===b)return null;void 0!==b&&(a=b)}return a};Blockly.Field.prototype.getSvgRoot=function(){return this.fieldGroup_};Blockly.Field.prototype.applyColour=function(){};Blockly.Field.prototype.render_=function(){this.textContent_&&(this.textContent_.nodeValue=this.getDisplayText_());this.updateSize_()};
	Blockly.Field.prototype.showEditor=function(a){this.isClickable()&&this.showEditor_(a)};Blockly.Field.prototype.updateWidth=function(){console.warn("Deprecated call to updateWidth, call Blockly.Field.updateSize_ to force an update to the size of the field, or Blockly.utils.dom.getTextWidth() to check the size of the field.");this.updateSize_()};
	Blockly.Field.prototype.updateSize_=function(a){var b=this.getConstants();a=void 0!=a?a:this.borderRect_?this.getConstants().FIELD_BORDER_RECT_X_PADDING:0;var c=2*a,d=b.FIELD_TEXT_HEIGHT,e=0;this.textElement_&&(e=Blockly.utils.dom.getFastTextWidth(this.textElement_,b.FIELD_TEXT_FONTSIZE,b.FIELD_TEXT_FONTWEIGHT,b.FIELD_TEXT_FONTFAMILY),c+=e);this.borderRect_&&(d=Math.max(d,b.FIELD_BORDER_RECT_HEIGHT));this.size_.height=d;this.size_.width=c;this.positionTextElement_(a,e);this.positionBorderRect_()};
	Blockly.Field.prototype.positionTextElement_=function(a,b){if(this.textElement_){var c=this.getConstants(),d=this.size_.height/2;this.textElement_.setAttribute("x",this.sourceBlock_.RTL?this.size_.width-b-a:a);this.textElement_.setAttribute("y",c.FIELD_TEXT_BASELINE_CENTER?d:d-c.FIELD_TEXT_HEIGHT/2+c.FIELD_TEXT_BASELINE)}};
	Blockly.Field.prototype.positionBorderRect_=function(){this.borderRect_&&(this.borderRect_.setAttribute("width",this.size_.width),this.borderRect_.setAttribute("height",this.size_.height),this.borderRect_.setAttribute("rx",this.getConstants().FIELD_BORDER_RECT_RADIUS),this.borderRect_.setAttribute("ry",this.getConstants().FIELD_BORDER_RECT_RADIUS))};
	Blockly.Field.prototype.getSize=function(){if(!this.isVisible())return new Blockly.utils.Size(0,0);this.isDirty_?(this.render_(),this.isDirty_=!1):this.visible_&&0==this.size_.width&&(console.warn("Deprecated use of setting size_.width to 0 to rerender a field. Set field.isDirty_ to true instead."),this.render_());return this.size_};
	Blockly.Field.prototype.getScaledBBox=function(){if(this.borderRect_)a=this.borderRect_.getBoundingClientRect(),c=Blockly.utils.style.getPageOffset(this.borderRect_),d=a.width,a=a.height;else{var a=this.sourceBlock_.getHeightWidth(),b=this.sourceBlock_.workspace.scale,c=this.getAbsoluteXY_(),d=a.width*b;a=a.height*b;Blockly.utils.userAgent.GECKO?(c.x+=1.5*b,c.y+=1.5*b):Blockly.utils.userAgent.EDGE||Blockly.utils.userAgent.IE||(c.x-=.5*b,c.y-=.5*b);d+=1*b;a+=1*b}return new Blockly.utils.Rect(c.y,c.y+
	a,c.x,c.x+d)};Blockly.Field.prototype.getDisplayText_=function(){var a=this.getText();if(!a)return Blockly.Field.NBSP;a.length>this.maxDisplayLength&&(a=a.substring(0,this.maxDisplayLength-2)+"\u2026");a=a.replace(/\s/g,Blockly.Field.NBSP);this.sourceBlock_&&this.sourceBlock_.RTL&&(a+="\u200f");return a};Blockly.Field.prototype.getText=function(){if(this.getText_){var a=this.getText_.call(this);if(null!==a)return String(a)}return String(this.getValue())};
	Blockly.Field.prototype.setText=function(a){throw Error("setText method is deprecated");};Blockly.Field.prototype.markDirty=function(){this.isDirty_=!0;this.constants_=null};Blockly.Field.prototype.forceRerender=function(){this.isDirty_=!0;this.sourceBlock_&&this.sourceBlock_.rendered&&(this.sourceBlock_.render(),this.sourceBlock_.bumpNeighbours(),this.updateMarkers_())};
	Blockly.Field.prototype.setValue=function(a){if(null!==a){var b=this.doClassValidation_(a);a=this.processValidation_(a,b);if(!(a instanceof Error)){if(b=this.getValidator())if(b=b.call(this,a),a=this.processValidation_(a,b),a instanceof Error)return;b=this.sourceBlock_;if(!b||!b.disposed){var c=this.getValue();c!==a&&(b&&Blockly.Events.isEnabled()&&Blockly.Events.fire(new Blockly.Events.BlockChange(b,"field",this.name||null,c,a)),this.doValueUpdate_(a),this.isDirty_&&this.forceRerender())}}}};
	Blockly.Field.prototype.processValidation_=function(a,b){if(null===b)return this.doValueInvalid_(a),this.isDirty_&&this.forceRerender(),Error();void 0!==b&&(a=b);return a};Blockly.Field.prototype.getValue=function(){return this.value_};Blockly.Field.prototype.doClassValidation_=function(a){return null===a||void 0===a?null:a=this.classValidator(a)};Blockly.Field.prototype.doValueUpdate_=function(a){this.value_=a;this.isDirty_=!0};Blockly.Field.prototype.doValueInvalid_=function(a){};
	Blockly.Field.prototype.onMouseDown_=function(a){this.sourceBlock_&&this.sourceBlock_.workspace&&(a=this.sourceBlock_.workspace.getGesture(a))&&a.setStartField(this)};Blockly.Field.prototype.setTooltip=function(a){var b=this.getClickTarget_();b?b.tooltip=a||""===a?a:this.sourceBlock_:this.tooltip_=a};Blockly.Field.prototype.getClickTarget_=function(){return this.clickTarget_||this.getSvgRoot()};Blockly.Field.prototype.getAbsoluteXY_=function(){return Blockly.utils.style.getPageOffset(this.getClickTarget_())};
	Blockly.Field.prototype.referencesVariables=function(){return!1};Blockly.Field.prototype.getParentInput=function(){for(var a=null,b=this.sourceBlock_,c=b.inputList,d=0;d<b.inputList.length;d++)for(var e=c[d],f=e.fieldRow,g=0;g<f.length;g++)if(f[g]===this){a=e;break}return a};Blockly.Field.prototype.getFlipRtl=function(){return!1};Blockly.Field.prototype.isTabNavigable=function(){return!1};Blockly.Field.prototype.onBlocklyAction=function(a){return!1};
	Blockly.Field.prototype.setCursorSvg=function(a){a?(this.fieldGroup_.appendChild(a),this.cursorSvg_=a):this.cursorSvg_=null};Blockly.Field.prototype.setMarkerSvg=function(a){a?(this.fieldGroup_.appendChild(a),this.markerSvg_=a):this.markerSvg_=null};Blockly.Field.prototype.updateMarkers_=function(){var a=this.sourceBlock_.workspace;a.keyboardAccessibilityMode&&this.cursorSvg_&&a.getCursor().draw();a.keyboardAccessibilityMode&&this.markerSvg_&&a.getMarker(Blockly.navigation.MARKER_NAME).draw()};Blockly.FieldLabel=function(a,b,c){this.class_=null;Blockly.FieldLabel.superClass_.constructor.call(this,a,null,c);c||(this.class_=b||null)};Blockly.utils.object.inherits(Blockly.FieldLabel,Blockly.Field);Blockly.FieldLabel.prototype.DEFAULT_VALUE="";Blockly.FieldLabel.fromJson=function(a){var b=Blockly.utils.replaceMessageReferences(a.text);return new Blockly.FieldLabel(b,void 0,a)};Blockly.FieldLabel.prototype.EDITABLE=!1;
	Blockly.FieldLabel.prototype.configure_=function(a){Blockly.FieldLabel.superClass_.configure_.call(this,a);this.class_=a["class"]};Blockly.FieldLabel.prototype.initView=function(){this.createTextElement_();this.class_&&Blockly.utils.dom.addClass(this.textElement_,this.class_)};Blockly.FieldLabel.prototype.doClassValidation_=function(a){return null===a||void 0===a?null:String(a)};
	Blockly.FieldLabel.prototype.setClass=function(a){this.textElement_&&(this.class_&&Blockly.utils.dom.removeClass(this.textElement_,this.class_),a&&Blockly.utils.dom.addClass(this.textElement_,a));this.class_=a};Blockly.fieldRegistry.register("field_label",Blockly.FieldLabel);Blockly.Input=function(a,b,c,d){if(a!=Blockly.DUMMY_INPUT&&!b)throw Error("Value inputs and statement inputs must have non-empty name.");this.type=a;this.name=b;this.sourceBlock_=c;this.connection=d;this.fieldRow=[]};Blockly.Input.prototype.align=Blockly.ALIGN_LEFT;Blockly.Input.prototype.visible_=!0;Blockly.Input.prototype.getSourceBlock=function(){return this.sourceBlock_};Blockly.Input.prototype.appendField=function(a,b){this.insertFieldAt(this.fieldRow.length,a,b);return this};
	Blockly.Input.prototype.insertFieldAt=function(a,b,c){if(0>a||a>this.fieldRow.length)throw Error("index "+a+" out of bounds.");if(!(b||""==b&&c))return a;"string"==typeof b&&(b=new Blockly.FieldLabel(b));b.setSourceBlock(this.sourceBlock_);this.sourceBlock_.rendered&&b.init();b.name=c;b.setVisible(this.isVisible());c=b;c.prefixField&&(a=this.insertFieldAt(a,c.prefixField));this.fieldRow.splice(a,0,b);++a;c.suffixField&&(a=this.insertFieldAt(a,c.suffixField));this.sourceBlock_.rendered&&(this.sourceBlock_=
	this.sourceBlock_,this.sourceBlock_.render(),this.sourceBlock_.bumpNeighbours());return a};Blockly.Input.prototype.removeField=function(a,b){for(var c=0,d;d=this.fieldRow[c];c++)if(d.name===a)return d.dispose(),this.fieldRow.splice(c,1),this.sourceBlock_.rendered&&(this.sourceBlock_=this.sourceBlock_,this.sourceBlock_.render(),this.sourceBlock_.bumpNeighbours()),!0;if(b)return!1;throw Error('Field "'+a+'" not found.');};Blockly.Input.prototype.isVisible=function(){return this.visible_};
	Blockly.Input.prototype.setVisible=function(a){var b=[];if(this.visible_==a)return b;this.visible_=a;for(var c=0,d;d=this.fieldRow[c];c++)d.setVisible(a);this.connection&&(this.connection=this.connection,a?b=this.connection.startTrackingAll():this.connection.stopTrackingAll(),c=this.connection.targetBlock())&&(c.getSvgRoot().style.display=a?"block":"none");return b};Blockly.Input.prototype.markDirty=function(){for(var a=0,b;b=this.fieldRow[a];a++)b.markDirty()};
	Blockly.Input.prototype.setCheck=function(a){if(!this.connection)throw Error("This input does not have a connection.");this.connection.setCheck(a);return this};Blockly.Input.prototype.setAlign=function(a){this.align=a;this.sourceBlock_.rendered&&(this.sourceBlock_=this.sourceBlock_,this.sourceBlock_.render());return this};Blockly.Input.prototype.init=function(){if(this.sourceBlock_.workspace.rendered)for(var a=0;a<this.fieldRow.length;a++)this.fieldRow[a].init()};
	Blockly.Input.prototype.dispose=function(){for(var a=0,b;b=this.fieldRow[a];a++)b.dispose();this.connection&&this.connection.dispose();this.sourceBlock_=null};Blockly.Block=function(a,b,c){if(Blockly.Generator&&"undefined"!=typeof Blockly.Generator.prototype[b])throw Error('Block prototypeName "'+b+'" conflicts with Blockly.Generator members.');this.id=c&&!a.getBlockById(c)?c:Blockly.utils.genUid();a.setBlockById(this.id,this);this.previousConnection=this.nextConnection=this.outputConnection=null;this.inputList=[];this.inputsInline=void 0;this.disabled=!1;this.tooltip="";this.contextMenu=!0;this.parentBlock_=null;this.childBlocks_=[];this.editable_=this.movable_=
	this.deletable_=!0;this.collapsed_=this.isShadow_=!1;this.comment=this.outputShape_=null;this.commentModel={text:null,pinned:!1,size:new Blockly.utils.Size(160,80)};this.xy_=new Blockly.utils.Coordinate(0,0);this.workspace=a;this.isInFlyout=a.isFlyout;this.isInMutator=a.isMutator;this.RTL=a.RTL;this.isInsertionMarker_=!1;this.hat=void 0;this.rendered=null;this.statementInputCount=0;if(b){this.type=b;c=Blockly.Blocks[b];if(!c||"object"!=typeof c)throw TypeError("Unknown block type: "+b);Blockly.utils.object.mixin(this,
	c)}a.addTopBlock(this);a.addTypedBlock(this);"function"==typeof this.init&&this.init();this.inputsInlineDefault=this.inputsInline;if(Blockly.Events.isEnabled()){(a=Blockly.Events.getGroup())||Blockly.Events.setGroup(!0);try{Blockly.Events.fire(new Blockly.Events.BlockCreate(this))}finally{a||Blockly.Events.setGroup(!1)}}"function"==typeof this.onchange&&this.setOnChange(this.onchange)};Blockly.Block.COLLAPSED_INPUT_NAME="_TEMP_COLLAPSED_INPUT";Blockly.Block.COLLAPSED_FIELD_NAME="_TEMP_COLLAPSED_FIELD";
	Blockly.Block.prototype.data=null;Blockly.Block.prototype.disposed=!1;Blockly.Block.prototype.hue_=null;Blockly.Block.prototype.colour_="#000000";Blockly.Block.prototype.styleName_=null;
	Blockly.Block.prototype.dispose=function(a){if(this.workspace){this.onchangeWrapper_&&this.workspace.removeChangeListener(this.onchangeWrapper_);this.unplug(a);Blockly.Events.isEnabled()&&Blockly.Events.fire(new Blockly.Events.BlockDelete(this));Blockly.Events.disable();try{this.workspace&&(this.workspace.removeTopBlock(this),this.workspace.removeTypedBlock(this),this.workspace.removeBlockById(this.id),this.workspace=null);Blockly.selected==this&&(Blockly.selected=null);for(var b=this.childBlocks_.length-
	1;0<=b;b--)this.childBlocks_[b].dispose(!1);b=0;for(var c;c=this.inputList[b];b++)c.dispose();this.inputList.length=0;var d=this.getConnections_(!0);b=0;for(var e;e=d[b];b++)e.dispose()}finally{Blockly.Events.enable(),this.disposed=!0}}};Blockly.Block.prototype.initModel=function(){for(var a=0,b;b=this.inputList[a];a++)for(var c=0,d;d=b.fieldRow[c];c++)d.initModel&&d.initModel()};Blockly.Block.prototype.unplug=function(a){this.outputConnection?this.unplugFromRow_(a):this.previousConnection&&this.unplugFromStack_(a)};
	Blockly.Block.prototype.unplugFromRow_=function(a){var b=null;this.outputConnection.isConnected()&&(b=this.outputConnection.targetConnection,this.outputConnection.disconnect());if(b&&a&&(a=this.getOnlyValueConnection_())&&a.isConnected()&&!a.targetBlock().isShadow())if(a=a.targetConnection,a.disconnect(),a.checkType(b))b.connect(a);else a.onFailedConnect(b)};
	Blockly.Block.prototype.getOnlyValueConnection_=function(){for(var a=null,b=0;b<this.inputList.length;b++){var c=this.inputList[b].connection;if(c&&c.type==Blockly.INPUT_VALUE&&c.targetConnection){if(a)return null;a=c}}return a};
	Blockly.Block.prototype.unplugFromStack_=function(a){var b=null;this.previousConnection.isConnected()&&(b=this.previousConnection.targetConnection,this.previousConnection.disconnect());var c=this.getNextBlock();a&&c&&!c.isShadow()&&(a=this.nextConnection.targetConnection,a.disconnect(),b&&b.checkType(a)&&b.connect(a))};
	Blockly.Block.prototype.getConnections_=function(a){a=[];this.outputConnection&&a.push(this.outputConnection);this.previousConnection&&a.push(this.previousConnection);this.nextConnection&&a.push(this.nextConnection);for(var b=0,c;c=this.inputList[b];b++)c.connection&&a.push(c.connection);return a};Blockly.Block.prototype.lastConnectionInStack=function(){for(var a=this.nextConnection;a;){var b=a.targetBlock();if(!b)return a;a=b.nextConnection}return null};Blockly.Block.prototype.bumpNeighbours=function(){console.warn("Not expected to reach Block.bumpNeighbours function. BlockSvg.bumpNeighbours was expected to be called instead.")};
	Blockly.Block.prototype.getParent=function(){return this.parentBlock_};Blockly.Block.prototype.getInputWithBlock=function(a){for(var b=0,c;c=this.inputList[b];b++)if(c.connection&&c.connection.targetBlock()==a)return c;return null};Blockly.Block.prototype.getSurroundParent=function(){var a=this;do{var b=a;a=a.getParent();if(!a)return null}while(a.getNextBlock()==b);return a};Blockly.Block.prototype.getNextBlock=function(){return this.nextConnection&&this.nextConnection.targetBlock()};
	Blockly.Block.prototype.getPreviousBlock=function(){return this.previousConnection&&this.previousConnection.targetBlock()};Blockly.Block.prototype.getFirstStatementConnection=function(){for(var a=0,b;b=this.inputList[a];a++)if(b.connection&&b.connection.type==Blockly.NEXT_STATEMENT)return b.connection;return null};Blockly.Block.prototype.getRootBlock=function(){var a=this;do{var b=a;a=b.parentBlock_}while(a);return b};
	Blockly.Block.prototype.getTopStackBlock=function(){var a=this;do var b=a.getPreviousBlock();while(b&&b.getNextBlock()==a&&(a=b));return a};Blockly.Block.prototype.getChildren=function(a){if(!a)return this.childBlocks_;a=[];for(var b=0,c;c=this.inputList[b];b++)c.connection&&(c=c.connection.targetBlock())&&a.push(c);(b=this.getNextBlock())&&a.push(b);return a};
	Blockly.Block.prototype.setParent=function(a){if(a!=this.parentBlock_){if(this.parentBlock_){Blockly.utils.arrayRemove(this.parentBlock_.childBlocks_,this);if(this.previousConnection&&this.previousConnection.isConnected())throw Error("Still connected to previous block.");if(this.outputConnection&&this.outputConnection.isConnected())throw Error("Still connected to parent block.");this.parentBlock_=null}else this.workspace.removeTopBlock(this);(this.parentBlock_=a)?a.childBlocks_.push(this):this.workspace.addTopBlock(this)}};
	Blockly.Block.prototype.getDescendants=function(a){for(var b=[this],c=this.getChildren(a),d,e=0;d=c[e];e++)b.push.apply(b,d.getDescendants(a));return b};Blockly.Block.prototype.isDeletable=function(){return this.deletable_&&!this.isShadow_&&!(this.workspace&&this.workspace.options.readOnly)};Blockly.Block.prototype.setDeletable=function(a){this.deletable_=a};Blockly.Block.prototype.isMovable=function(){return this.movable_&&!this.isShadow_&&!(this.workspace&&this.workspace.options.readOnly)};
	Blockly.Block.prototype.setMovable=function(a){this.movable_=a};Blockly.Block.prototype.isDuplicatable=function(){return this.workspace.hasBlockLimits()?this.workspace.isCapacityAvailable(Blockly.utils.getBlockTypeCounts(this,!0)):!0};Blockly.Block.prototype.isShadow=function(){return this.isShadow_};Blockly.Block.prototype.setShadow=function(a){this.isShadow_=a};Blockly.Block.prototype.isInsertionMarker=function(){return this.isInsertionMarker_};
	Blockly.Block.prototype.setInsertionMarker=function(a){this.isInsertionMarker_=a};Blockly.Block.prototype.isEditable=function(){return this.editable_&&!(this.workspace&&this.workspace.options.readOnly)};Blockly.Block.prototype.setEditable=function(a){this.editable_=a;a=0;for(var b;b=this.inputList[a];a++)for(var c=0,d;d=b.fieldRow[c];c++)d.updateEditable()};Blockly.Block.prototype.isDisposed=function(){return this.disposed};
	Blockly.Block.prototype.getMatchingConnection=function(a,b){var c=this.getConnections_(!0);a=a.getConnections_(!0);if(c.length!=a.length)throw Error("Connection lists did not match in length.");for(var d=0;d<a.length;d++)if(a[d]==b)return c[d];return null};Blockly.Block.prototype.setHelpUrl=function(a){this.helpUrl=a};Blockly.Block.prototype.setTooltip=function(a){this.tooltip=a};Blockly.Block.prototype.getColour=function(){return this.colour_};Blockly.Block.prototype.getStyleName=function(){return this.styleName_};
	Blockly.Block.prototype.getHue=function(){return this.hue_};Blockly.Block.prototype.setColour=function(a){a=Blockly.utils.parseBlockColour(a);this.hue_=a.hue;this.colour_=a.hex};Blockly.Block.prototype.setStyle=function(a){this.styleName_=a};Blockly.Block.prototype.setOnChange=function(a){if(a&&"function"!=typeof a)throw Error("onchange must be a function.");this.onchangeWrapper_&&this.workspace.removeChangeListener(this.onchangeWrapper_);if(this.onchange=a)this.onchangeWrapper_=a.bind(this),this.workspace.addChangeListener(this.onchangeWrapper_)};
	Blockly.Block.prototype.getField=function(a){for(var b=0,c;c=this.inputList[b];b++)for(var d=0,e;e=c.fieldRow[d];d++)if(e.name==a)return e;return null};Blockly.Block.prototype.getVars=function(){for(var a=[],b=0,c;c=this.inputList[b];b++)for(var d=0,e;e=c.fieldRow[d];d++)e.referencesVariables()&&a.push(e.getValue());return a};
	Blockly.Block.prototype.getVarModels=function(){for(var a=[],b=0,c;c=this.inputList[b];b++)for(var d=0,e;e=c.fieldRow[d];d++)e.referencesVariables()&&(e=this.workspace.getVariableById(e.getValue()))&&a.push(e);return a};Blockly.Block.prototype.updateVarName=function(a){for(var b=0,c;c=this.inputList[b];b++)for(var d=0,e;e=c.fieldRow[d];d++)e.referencesVariables()&&a.getId()==e.getValue()&&e.refreshVariableName()};
	Blockly.Block.prototype.renameVarById=function(a,b){for(var c=0,d;d=this.inputList[c];c++)for(var e=0,f;f=d.fieldRow[e];e++)f.referencesVariables()&&a==f.getValue()&&f.setValue(b)};Blockly.Block.prototype.getFieldValue=function(a){return(a=this.getField(a))?a.getValue():null};Blockly.Block.prototype.setFieldValue=function(a,b){var c=this.getField(b);if(!c)throw Error('Field "'+b+'" not found.');c.setValue(a)};
	Blockly.Block.prototype.setPreviousStatement=function(a,b){if(a){void 0===b&&(b=null);if(!this.previousConnection){if(this.outputConnection)throw Error("Remove output connection prior to adding previous connection.");this.previousConnection=this.makeConnection_(Blockly.PREVIOUS_STATEMENT)}this.previousConnection.setCheck(b)}else if(this.previousConnection){if(this.previousConnection.isConnected())throw Error("Must disconnect previous statement before removing connection.");this.previousConnection.dispose();
	this.previousConnection=null}};Blockly.Block.prototype.setNextStatement=function(a,b){if(a)void 0===b&&(b=null),this.nextConnection||(this.nextConnection=this.makeConnection_(Blockly.NEXT_STATEMENT)),this.nextConnection.setCheck(b);else if(this.nextConnection){if(this.nextConnection.isConnected())throw Error("Must disconnect next statement before removing connection.");this.nextConnection.dispose();this.nextConnection=null}};
	Blockly.Block.prototype.setOutput=function(a,b){if(a){void 0===b&&(b=null);if(!this.outputConnection){if(this.previousConnection)throw Error("Remove previous connection prior to adding output connection.");this.outputConnection=this.makeConnection_(Blockly.OUTPUT_VALUE)}this.outputConnection.setCheck(b)}else if(this.outputConnection){if(this.outputConnection.isConnected())throw Error("Must disconnect output value before removing connection.");this.outputConnection.dispose();this.outputConnection=
	null}};Blockly.Block.prototype.setInputsInline=function(a){this.inputsInline!=a&&(Blockly.Events.fire(new Blockly.Events.BlockChange(this,"inline",null,this.inputsInline,a)),this.inputsInline=a)};
	Blockly.Block.prototype.getInputsInline=function(){if(void 0!=this.inputsInline)return this.inputsInline;for(var a=1;a<this.inputList.length;a++)if(this.inputList[a-1].type==Blockly.DUMMY_INPUT&&this.inputList[a].type==Blockly.DUMMY_INPUT)return!1;for(a=1;a<this.inputList.length;a++)if(this.inputList[a-1].type==Blockly.INPUT_VALUE&&this.inputList[a].type==Blockly.DUMMY_INPUT)return!0;return!1};Blockly.Block.prototype.setOutputShape=function(a){this.outputShape_=a};
	Blockly.Block.prototype.getOutputShape=function(){return this.outputShape_};Blockly.Block.prototype.setDisabled=function(a){console.warn("Deprecated call to Blockly.Block.prototype.setDisabled, use Blockly.Block.prototype.setEnabled instead.");this.setEnabled(!a)};Blockly.Block.prototype.isEnabled=function(){return!this.disabled};
	Blockly.Block.prototype.setEnabled=function(a){this.isEnabled()!=a&&(Blockly.Events.fire(new Blockly.Events.BlockChange(this,"disabled",null,this.disabled,!a)),this.disabled=!a)};Blockly.Block.prototype.getInheritedDisabled=function(){for(var a=this.getSurroundParent();a;){if(a.disabled)return!0;a=a.getSurroundParent()}return!1};Blockly.Block.prototype.isCollapsed=function(){return this.collapsed_};
	Blockly.Block.prototype.setCollapsed=function(a){this.collapsed_!=a&&(Blockly.Events.fire(new Blockly.Events.BlockChange(this,"collapsed",null,this.collapsed_,a)),this.collapsed_=a)};
	Blockly.Block.prototype.toString=function(a,b){function c(a){var b=a.getCheck();!b&&a.targetConnection&&(b=a.targetConnection.getCheck());return!!b&&(-1!=b.indexOf("Boolean")||-1!=b.indexOf("Number"))}function d(){g&&g.getType()==h.getType()&&g.getLocation()==h.getLocation()&&(g=null)}var e=[];b=b||"?";var f=Blockly.ASTNode.NAVIGATE_ALL_FIELDS;Blockly.ASTNode.NAVIGATE_ALL_FIELDS=!0;for(var g=Blockly.ASTNode.createBlockNode(this),h=g;g;){switch(g.getType()){case Blockly.ASTNode.types.INPUT:var k=g.getLocation();
	g.in()?c(k)&&e.push("("):e.push(b);break;case Blockly.ASTNode.types.FIELD:k=g.getLocation(),k.name!=Blockly.Block.COLLAPSED_FIELD_NAME&&e.push(k.getText())}k=g;g=k.in()||k.next();if(!g){g=k.out();for(d();g&&!g.next();)g=g.out(),d(),g&&g.getType()==Blockly.ASTNode.types.INPUT&&c(g.getLocation())&&e.push(")");g&&(g=g.next())}}Blockly.ASTNode.NAVIGATE_ALL_FIELDS=f;b=2;for(f=e.length;b<f;b++)"("==e[b-2]&&")"==e[b]&&(e[b-2]=e[b-1],e.splice(b-1,2),f-=2);e=e.join(" ").replace(/(\() | (\))/gmi,"$1$2").trim()||
	"???";a&&e.length>a&&(e=e.substring(0,a-3)+"...");return e};Blockly.Block.prototype.appendValueInput=function(a){return this.appendInput_(Blockly.INPUT_VALUE,a)};Blockly.Block.prototype.appendStatementInput=function(a){return this.appendInput_(Blockly.NEXT_STATEMENT,a)};Blockly.Block.prototype.appendDummyInput=function(a){return this.appendInput_(Blockly.DUMMY_INPUT,a||"")};
	Blockly.Block.prototype.jsonInit=function(a){var b=a.type?'Block "'+a.type+'": ':"";if(a.output&&a.previousStatement)throw Error(b+"Must not have both an output and a previousStatement.");a.style&&a.style.hat&&(this.hat=a.style.hat,a.style=null);if(a.style&&a.colour)throw Error(b+"Must not have both a colour and a style.");a.style?this.jsonInitStyle_(a,b):this.jsonInitColour_(a,b);for(var c=0;void 0!==a["message"+c];)this.interpolate_(a["message"+c],a["args"+c]||[],a["lastDummyAlign"+c],b),c++;void 0!==
	a.inputsInline&&this.setInputsInline(a.inputsInline);void 0!==a.output&&this.setOutput(!0,a.output);void 0!==a.outputShape&&this.setOutputShape(a.outputShape);void 0!==a.previousStatement&&this.setPreviousStatement(!0,a.previousStatement);void 0!==a.nextStatement&&this.setNextStatement(!0,a.nextStatement);void 0!==a.tooltip&&(c=a.tooltip,c=Blockly.utils.replaceMessageReferences(c),this.setTooltip(c));void 0!==a.enableContextMenu&&(c=a.enableContextMenu,this.contextMenu=!!c);void 0!==a.helpUrl&&(c=
	a.helpUrl,c=Blockly.utils.replaceMessageReferences(c),this.setHelpUrl(c));"string"==typeof a.extensions&&(console.warn(b+"JSON attribute 'extensions' should be an array of strings. Found raw string in JSON for '"+a.type+"' block."),a.extensions=[a.extensions]);void 0!==a.mutator&&Blockly.Extensions.apply(a.mutator,this,!0);if(Array.isArray(a.extensions))for(a=a.extensions,b=0;b<a.length;++b)Blockly.Extensions.apply(a[b],this,!1)};
	Blockly.Block.prototype.jsonInitColour_=function(a,b){if("colour"in a)if(void 0===a.colour)console.warn(b+"Undefined colour value.");else{a=a.colour;try{this.setColour(a)}catch(c){console.warn(b+"Illegal colour value: ",a)}}};Blockly.Block.prototype.jsonInitStyle_=function(a,b){a=a.style;try{this.setStyle(a)}catch(c){console.warn(b+"Style does not exist: ",a)}};
	Blockly.Block.prototype.mixin=function(a,b){if(void 0!==b&&"boolean"!=typeof b)throw Error("opt_disableCheck must be a boolean if provided");if(!b){b=[];for(var c in a)void 0!==this[c]&&b.push(c);if(b.length)throw Error("Mixin will overwrite block members: "+JSON.stringify(b));}Blockly.utils.object.mixin(this,a)};
	Blockly.Block.prototype.interpolate_=function(a,b,c,d){var e=Blockly.utils.tokenizeInterpolation(a),f=[],g=0;a=[];for(var h=0;h<e.length;h++){var k=e[h];if("number"==typeof k){if(0>=k||k>b.length)throw Error('Block "'+this.type+'": Message index %'+k+" out of range.");if(f[k])throw Error('Block "'+this.type+'": Message index %'+k+" duplicated.");f[k]=!0;g++;a.push(b[k-1])}else(k=k.trim())&&a.push(k)}if(g!=b.length)throw Error('Block "'+this.type+'": Message does not reference all '+b.length+" arg(s).");
	a.length&&("string"==typeof a[a.length-1]||Blockly.utils.string.startsWith(a[a.length-1].type,"field_"))&&(h={type:"input_dummy"},c&&(h.align=c),a.push(h));c={LEFT:Blockly.ALIGN_LEFT,RIGHT:Blockly.ALIGN_RIGHT,CENTRE:Blockly.ALIGN_CENTRE,CENTER:Blockly.ALIGN_CENTRE};b=[];for(h=0;h<a.length;h++)if(f=a[h],"string"==typeof f)b.push([f,void 0]);else{e=g=null;do if(k=!1,"string"==typeof f)g=new Blockly.FieldLabel(f);else switch(f.type){case "input_value":e=this.appendValueInput(f.name);break;case "input_statement":e=
	this.appendStatementInput(f.name);break;case "input_dummy":e=this.appendDummyInput(f.name);break;default:g=Blockly.fieldRegistry.fromJson(f),!g&&f.alt&&(f=f.alt,k=!0)}while(k);if(g)b.push([g,f.name]);else if(e){f.check&&e.setCheck(f.check);f.align&&(g=c[f.align.toUpperCase()],void 0===g?console.warn(d+"Illegal align value: ",f.align):e.setAlign(g));for(f=0;f<b.length;f++)e.appendField(b[f][0],b[f][1]);b.length=0}}};
	Blockly.Block.prototype.appendInput_=function(a,b){var c=null;if(a==Blockly.INPUT_VALUE||a==Blockly.NEXT_STATEMENT)c=this.makeConnection_(a);a==Blockly.NEXT_STATEMENT&&this.statementInputCount++;a=new Blockly.Input(a,b,this,c);this.inputList.push(a);return a};
	Blockly.Block.prototype.moveInputBefore=function(a,b){if(a!=b){for(var c=-1,d=b?-1:this.inputList.length,e=0,f;f=this.inputList[e];e++)if(f.name==a){if(c=e,-1!=d)break}else if(b&&f.name==b&&(d=e,-1!=c))break;if(-1==c)throw Error('Named input "'+a+'" not found.');if(-1==d)throw Error('Reference input "'+b+'" not found.');this.moveNumberedInputBefore(c,d)}};
	Blockly.Block.prototype.moveNumberedInputBefore=function(a,b){if(a==b)throw Error("Can't move input to itself.");if(a>=this.inputList.length)throw RangeError("Input index "+a+" out of bounds.");if(b>this.inputList.length)throw RangeError("Reference input "+b+" out of bounds.");var c=this.inputList[a];this.inputList.splice(a,1);a<b&&b--;this.inputList.splice(b,0,c)};
	Blockly.Block.prototype.removeInput=function(a,b){for(var c=0,d;d=this.inputList[c];c++)if(d.name==a)return d.type==Blockly.NEXT_STATEMENT&&this.statementInputCount--,d.dispose(),this.inputList.splice(c,1),!0;if(b)return!1;throw Error("Input not found: "+a);};Blockly.Block.prototype.getInput=function(a){for(var b=0,c;c=this.inputList[b];b++)if(c.name==a)return c;return null};Blockly.Block.prototype.getInputTargetBlock=function(a){return(a=this.getInput(a))&&a.connection&&a.connection.targetBlock()};
	Blockly.Block.prototype.getCommentText=function(){return this.commentModel.text};Blockly.Block.prototype.setCommentText=function(a){this.commentModel.text!=a&&(Blockly.Events.fire(new Blockly.Events.BlockChange(this,"comment",null,this.commentModel.text,a)),this.comment=this.commentModel.text=a)};Blockly.Block.prototype.setWarningText=function(a,b){};Blockly.Block.prototype.setMutator=function(a){};Blockly.Block.prototype.getRelativeToSurfaceXY=function(){return this.xy_};
	Blockly.Block.prototype.moveBy=function(a,b){if(this.parentBlock_)throw Error("Block has parent.");var c=new Blockly.Events.BlockMove(this);this.xy_.translate(a,b);c.recordNew();Blockly.Events.fire(c)};Blockly.Block.prototype.makeConnection_=function(a){return new Blockly.Connection(this,a)};
	Blockly.Block.prototype.allInputsFilled=function(a){void 0===a&&(a=!0);if(!a&&this.isShadow())return!1;for(var b=0,c;c=this.inputList[b];b++)if(c.connection&&(c=c.connection.targetBlock(),!c||!c.allInputsFilled(a)))return!1;return(b=this.getNextBlock())?b.allInputsFilled(a):!0};Blockly.Block.prototype.toDevString=function(){var a=this.type?'"'+this.type+'" block':"Block";this.id&&(a+=' (id="'+this.id+'")');return a};Blockly.blockRendering={};Blockly.blockRendering.IPathObject=function(a,b){};Blockly.utils.aria={};Blockly.utils.aria.ARIA_PREFIX_="aria-";Blockly.utils.aria.ROLE_ATTRIBUTE_="role";Blockly.utils.aria.Role={GRID:"grid",GRIDCELL:"gridcell",GROUP:"group",LISTBOX:"listbox",MENU:"menu",MENUITEM:"menuitem",MENUITEMCHECKBOX:"menuitemcheckbox",OPTION:"option",PRESENTATION:"presentation",ROW:"row",TREE:"tree",TREEITEM:"treeitem"};
	Blockly.utils.aria.State={ACTIVEDESCENDANT:"activedescendant",COLCOUNT:"colcount",DISABLED:"disabled",EXPANDED:"expanded",INVALID:"invalid",LABEL:"label",LABELLEDBY:"labelledby",LEVEL:"level",ORIENTATION:"orientation",POSINSET:"posinset",ROWCOUNT:"rowcount",SELECTED:"selected",SETSIZE:"setsize",VALUEMAX:"valuemax",VALUEMIN:"valuemin"};Blockly.utils.aria.setRole=function(a,b){a.setAttribute(Blockly.utils.aria.ROLE_ATTRIBUTE_,b)};
	Blockly.utils.aria.setState=function(a,b,c){Array.isArray(c)&&(c=c.join(" "));a.setAttribute(Blockly.utils.aria.ARIA_PREFIX_+b,c)};Blockly.Menu=function(){this.menuItems_=[];this.roleName_=this.element_=this.onKeyDownHandler_=this.mouseLeaveHandler_=this.mouseEnterHandler_=this.clickHandler_=this.mouseOverHandler_=this.highlightedItem_=this.openingCoords=null};Blockly.Menu.prototype.addChild=function(a){this.menuItems_.push(a)};
	Blockly.Menu.prototype.render=function(a){var b=document.createElement("div");b.className="blocklyMenu goog-menu blocklyNonSelectable";b.tabIndex=0;this.roleName_&&Blockly.utils.aria.setRole(b,this.roleName_);this.element_=b;for(var c=0,d;d=this.menuItems_[c];c++)b.appendChild(d.createDom());this.mouseOverHandler_=Blockly.bindEventWithChecks_(b,"mouseover",this,this.handleMouseOver_,!0);this.clickHandler_=Blockly.bindEventWithChecks_(b,"click",this,this.handleClick_,!0);this.mouseEnterHandler_=Blockly.bindEventWithChecks_(b,
	"mouseenter",this,this.handleMouseEnter_,!0);this.mouseLeaveHandler_=Blockly.bindEventWithChecks_(b,"mouseleave",this,this.handleMouseLeave_,!0);this.onKeyDownHandler_=Blockly.bindEventWithChecks_(b,"keydown",this,this.handleKeyEvent_);a.appendChild(b)};Blockly.Menu.prototype.getElement=function(){return this.element_};Blockly.Menu.prototype.focus=function(){var a=this.getElement();a&&(a.focus({preventScroll:!0}),Blockly.utils.dom.addClass(a,"blocklyFocused"))};
	Blockly.Menu.prototype.blur_=function(){var a=this.getElement();a&&(a.blur(),Blockly.utils.dom.removeClass(a,"blocklyFocused"))};Blockly.Menu.prototype.setRole=function(a){this.roleName_=a};
	Blockly.Menu.prototype.dispose=function(){this.mouseOverHandler_&&(Blockly.unbindEvent_(this.mouseOverHandler_),this.mouseOverHandler_=null);this.clickHandler_&&(Blockly.unbindEvent_(this.clickHandler_),this.clickHandler_=null);this.mouseEnterHandler_&&(Blockly.unbindEvent_(this.mouseEnterHandler_),this.mouseEnterHandler_=null);this.mouseLeaveHandler_&&(Blockly.unbindEvent_(this.mouseLeaveHandler_),this.mouseLeaveHandler_=null);this.onKeyDownHandler_&&(Blockly.unbindEvent_(this.onKeyDownHandler_),
	this.onKeyDownHandler_=null);for(var a=0,b;b=this.menuItems_[a];a++)b.dispose();this.element_=null};Blockly.Menu.prototype.getMenuItem_=function(a){for(var b=this.getElement();a&&a!=b;){if(Blockly.utils.dom.hasClass(a,"blocklyMenuItem"))for(var c=0,d;d=this.menuItems_[c];c++)if(d.getElement()==a)return d;a=a.parentElement}return null};
	Blockly.Menu.prototype.setHighlighted=function(a){var b=this.highlightedItem_;b&&(b.setHighlighted(!1),this.highlightedItem_=null);a&&(a.setHighlighted(!0),this.highlightedItem_=a,b=this.getElement(),Blockly.utils.style.scrollIntoContainerView(a.getElement(),b),Blockly.utils.aria.setState(b,Blockly.utils.aria.State.ACTIVEDESCENDANT,a.getId()))};Blockly.Menu.prototype.highlightNext=function(){var a=this.menuItems_.indexOf(this.highlightedItem_);this.highlightHelper_(a,1)};
	Blockly.Menu.prototype.highlightPrevious=function(){var a=this.menuItems_.indexOf(this.highlightedItem_);this.highlightHelper_(0>a?this.menuItems_.length:a,-1)};Blockly.Menu.prototype.highlightFirst_=function(){this.highlightHelper_(-1,1)};Blockly.Menu.prototype.highlightLast_=function(){this.highlightHelper_(this.menuItems_.length,-1)};Blockly.Menu.prototype.highlightHelper_=function(a,b){a+=b;for(var c;c=this.menuItems_[a];){if(c.isEnabled()){this.setHighlighted(c);break}a+=b}};
	Blockly.Menu.prototype.handleMouseOver_=function(a){(a=this.getMenuItem_(a.target))&&(a.isEnabled()?this.highlightedItem_!=a&&this.setHighlighted(a):this.setHighlighted(null))};Blockly.Menu.prototype.handleClick_=function(a){var b=this.openingCoords;this.openingCoords=null;if(b&&"number"==typeof a.clientX){var c=new Blockly.utils.Coordinate(a.clientX,a.clientY);if(1>Blockly.utils.Coordinate.distance(b,c))return}(a=this.getMenuItem_(a.target))&&a.performAction()};
	Blockly.Menu.prototype.handleMouseEnter_=function(a){this.focus()};Blockly.Menu.prototype.handleMouseLeave_=function(a){this.getElement()&&(this.blur_(),this.setHighlighted(null))};
	Blockly.Menu.prototype.handleKeyEvent_=function(a){if(this.menuItems_.length&&!(a.shiftKey||a.ctrlKey||a.metaKey||a.altKey)){var b=this.highlightedItem_;switch(a.keyCode){case Blockly.utils.KeyCodes.ENTER:case Blockly.utils.KeyCodes.SPACE:b&&b.performAction();break;case Blockly.utils.KeyCodes.UP:this.highlightPrevious();break;case Blockly.utils.KeyCodes.DOWN:this.highlightNext();break;case Blockly.utils.KeyCodes.PAGE_UP:case Blockly.utils.KeyCodes.HOME:this.highlightFirst_();break;case Blockly.utils.KeyCodes.PAGE_DOWN:case Blockly.utils.KeyCodes.END:this.highlightLast_();
	break;default:return}a.preventDefault();a.stopPropagation()}};Blockly.Menu.prototype.getSize=function(){var a=this.getElement(),b=Blockly.utils.style.getSize(a);b.height=a.scrollHeight;return b};Blockly.MenuItem=function(a,b){this.content_=a;this.value_=b;this.enabled_=!0;this.element_=null;this.rightToLeft_=!1;this.roleName_=null;this.highlight_=this.checked_=this.checkable_=!1;this.actionHandler_=null};
	Blockly.MenuItem.prototype.createDom=function(){var a=document.createElement("div");a.id=Blockly.utils.IdGenerator.getNextUniqueId();this.element_=a;a.className="blocklyMenuItem goog-menuitem "+(this.enabled_?"":"blocklyMenuItemDisabled goog-menuitem-disabled ")+(this.checked_?"blocklyMenuItemSelected goog-option-selected ":"")+(this.highlight_?"blocklyMenuItemHighlight goog-menuitem-highlight ":"")+(this.rightToLeft_?"blocklyMenuItemRtl goog-menuitem-rtl ":"");var b=document.createElement("div");
	b.className="blocklyMenuItemContent goog-menuitem-content";if(this.checkable_){var c=document.createElement("div");c.className="blocklyMenuItemCheckbox goog-menuitem-checkbox";b.appendChild(c)}c=this.content_;"string"==typeof this.content_&&(c=document.createTextNode(this.content_));b.appendChild(c);a.appendChild(b);this.roleName_&&Blockly.utils.aria.setRole(a,this.roleName_);Blockly.utils.aria.setState(a,Blockly.utils.aria.State.SELECTED,this.checkable_&&this.checked_||!1);Blockly.utils.aria.setState(a,
	Blockly.utils.aria.State.DISABLED,!this.enabled_);return a};Blockly.MenuItem.prototype.dispose=function(){this.element_=null};Blockly.MenuItem.prototype.getElement=function(){return this.element_};Blockly.MenuItem.prototype.getId=function(){return this.element_.id};Blockly.MenuItem.prototype.getValue=function(){return this.value_};Blockly.MenuItem.prototype.setRightToLeft=function(a){this.rightToLeft_=a};Blockly.MenuItem.prototype.setRole=function(a){this.roleName_=a};
	Blockly.MenuItem.prototype.setCheckable=function(a){this.checkable_=a};Blockly.MenuItem.prototype.setChecked=function(a){this.checked_=a};Blockly.MenuItem.prototype.setHighlighted=function(a){this.highlight_=a;var b=this.getElement();b&&this.isEnabled()&&(a?(Blockly.utils.dom.addClass(b,"blocklyMenuItemHighlight"),Blockly.utils.dom.addClass(b,"goog-menuitem-highlight")):(Blockly.utils.dom.removeClass(b,"blocklyMenuItemHighlight"),Blockly.utils.dom.removeClass(b,"goog-menuitem-highlight")))};
	Blockly.MenuItem.prototype.isEnabled=function(){return this.enabled_};Blockly.MenuItem.prototype.setEnabled=function(a){this.enabled_=a};Blockly.MenuItem.prototype.performAction=function(){this.isEnabled()&&this.actionHandler_&&this.actionHandler_(this)};Blockly.MenuItem.prototype.onAction=function(a,b){this.actionHandler_=a.bind(b)};Blockly.ContextMenu={};Blockly.ContextMenu.currentBlock=null;Blockly.ContextMenu.menu_=null;Blockly.ContextMenu.show=function(a,b,c){Blockly.WidgetDiv.show(Blockly.ContextMenu,c,Blockly.ContextMenu.dispose);if(b.length){var d=Blockly.ContextMenu.populate_(b,c);Blockly.ContextMenu.menu_=d;Blockly.ContextMenu.position_(d,a,c);setTimeout(function(){d.focus()},1);Blockly.ContextMenu.currentBlock=null}else Blockly.ContextMenu.hide()};
	Blockly.ContextMenu.populate_=function(a,b){var c=new Blockly.Menu;c.setRole(Blockly.utils.aria.Role.MENU);for(var d=0,e;e=a[d];d++){var f=new Blockly.MenuItem(e.text);f.setRightToLeft(b);f.setRole(Blockly.utils.aria.Role.MENUITEM);c.addChild(f);f.setEnabled(e.enabled);if(e.enabled)f.onAction(function(a){Blockly.ContextMenu.hide();this.callback()},e)}return c};
	Blockly.ContextMenu.position_=function(a,b,c){var d=Blockly.utils.getViewportBBox();b=new Blockly.utils.Rect(b.clientY+d.top,b.clientY+d.top,b.clientX+d.left,b.clientX+d.left);Blockly.ContextMenu.createWidget_(a);var e=a.getSize();c&&(b.left+=e.width,b.right+=e.width,d.left+=e.width,d.right+=e.width);Blockly.WidgetDiv.positionWithAnchor(d,b,e,c);a.focus()};
	Blockly.ContextMenu.createWidget_=function(a){a.render(Blockly.WidgetDiv.DIV);var b=a.getElement();Blockly.utils.dom.addClass(b,"blocklyContextMenu");Blockly.bindEventWithChecks_(b,"contextmenu",null,Blockly.utils.noEvent);a.focus()};Blockly.ContextMenu.hide=function(){Blockly.WidgetDiv.hideIfOwner(Blockly.ContextMenu);Blockly.ContextMenu.currentBlock=null};Blockly.ContextMenu.dispose=function(){Blockly.ContextMenu.menu_&&(Blockly.ContextMenu.menu_.dispose(),Blockly.ContextMenu.menu_=null)};
	Blockly.ContextMenu.callbackFactory=function(a,b){return function(){Blockly.Events.disable();try{var c=Blockly.Xml.domToBlock(b,a.workspace),d=a.getRelativeToSurfaceXY();d.x=a.RTL?d.x-Blockly.SNAP_RADIUS:d.x+Blockly.SNAP_RADIUS;d.y+=2*Blockly.SNAP_RADIUS;c.moveBy(d.x,d.y)}finally{Blockly.Events.enable()}Blockly.Events.isEnabled()&&!c.isShadow()&&Blockly.Events.fire(new Blockly.Events.BlockCreate(c));c.select()}};
	Blockly.ContextMenu.blockDeleteOption=function(a){var b=a.getDescendants(!1).length,c=a.getNextBlock();c&&(b-=c.getDescendants(!1).length);return{text:1==b?Blockly.Msg.DELETE_BLOCK:Blockly.Msg.DELETE_X_BLOCKS.replace("%1",String(b)),enabled:!0,callback:function(){Blockly.Events.setGroup(!0);a.dispose(!0,!0);Blockly.Events.setGroup(!1)}}};Blockly.ContextMenu.blockHelpOption=function(a){return{enabled:!("function"==typeof a.helpUrl?!a.helpUrl():!a.helpUrl),text:Blockly.Msg.HELP,callback:function(){a.showHelp()}}};
	Blockly.ContextMenu.blockDuplicateOption=function(a){var b=a.isDuplicatable();return{text:Blockly.Msg.DUPLICATE_BLOCK,enabled:b,callback:function(){Blockly.duplicate(a)}}};Blockly.ContextMenu.blockCommentOption=function(a){var b={enabled:!Blockly.utils.userAgent.IE};a.getCommentIcon()?(b.text=Blockly.Msg.REMOVE_COMMENT,b.callback=function(){a.setCommentText(null)}):(b.text=Blockly.Msg.ADD_COMMENT,b.callback=function(){a.setCommentText("")});return b};
	Blockly.ContextMenu.commentDeleteOption=function(a){return{text:Blockly.Msg.REMOVE_COMMENT,enabled:!0,callback:function(){Blockly.Events.setGroup(!0);a.dispose(!0,!0);Blockly.Events.setGroup(!1)}}};Blockly.ContextMenu.commentDuplicateOption=function(a){return{text:Blockly.Msg.DUPLICATE_COMMENT,enabled:!0,callback:function(){Blockly.duplicate(a)}}};
	Blockly.ContextMenu.workspaceCommentOption=function(a,b){if(!Blockly.WorkspaceCommentSvg)throw Error("Missing require for Blockly.WorkspaceCommentSvg");var c={enabled:!Blockly.utils.userAgent.IE};c.text=Blockly.Msg.ADD_COMMENT;c.callback=function(){var c=new Blockly.WorkspaceCommentSvg(a,Blockly.Msg.WORKSPACE_COMMENT_DEFAULT_TEXT,Blockly.WorkspaceCommentSvg.DEFAULT_SIZE,Blockly.WorkspaceCommentSvg.DEFAULT_SIZE),e=a.getInjectionDiv().getBoundingClientRect();e=new Blockly.utils.Coordinate(b.clientX-
	e.left,b.clientY-e.top);var f=a.getOriginOffsetInPixels();e=Blockly.utils.Coordinate.difference(e,f);e.scale(1/a.scale);c.moveBy(e.x,e.y);a.rendered&&(c.initSvg(),c.render(),c.select())};return c};Blockly.RenderedConnection=function(a,b){Blockly.RenderedConnection.superClass_.constructor.call(this,a,b);this.db_=a.workspace.connectionDBList[b];this.dbOpposite_=a.workspace.connectionDBList[Blockly.OPPOSITE_TYPE[b]];this.offsetInBlock_=new Blockly.utils.Coordinate(0,0);this.trackedState_=Blockly.RenderedConnection.TrackedState.WILL_TRACK;this.targetConnection=null};Blockly.utils.object.inherits(Blockly.RenderedConnection,Blockly.Connection);
	Blockly.RenderedConnection.TrackedState={WILL_TRACK:-1,UNTRACKED:0,TRACKED:1};Blockly.RenderedConnection.prototype.dispose=function(){Blockly.RenderedConnection.superClass_.dispose.call(this);this.trackedState_==Blockly.RenderedConnection.TrackedState.TRACKED&&this.db_.removeConnection(this,this.y)};Blockly.RenderedConnection.prototype.getSourceBlock=function(){return Blockly.RenderedConnection.superClass_.getSourceBlock.call(this)};Blockly.RenderedConnection.prototype.targetBlock=function(){return Blockly.RenderedConnection.superClass_.targetBlock.call(this)};
	Blockly.RenderedConnection.prototype.distanceFrom=function(a){var b=this.x-a.x;a=this.y-a.y;return Math.sqrt(b*b+a*a)};
	Blockly.RenderedConnection.prototype.bumpAwayFrom=function(a){if(!this.sourceBlock_.workspace.isDragging()){var b=this.sourceBlock_.getRootBlock();if(!b.isInFlyout){var c=!1;if(!b.isMovable()){b=a.getSourceBlock().getRootBlock();if(!b.isMovable())return;a=this;c=!0}var d=Blockly.selected==b;d||b.addSelect();var e=a.x+Blockly.SNAP_RADIUS+Math.floor(Math.random()*Blockly.BUMP_RANDOMNESS)-this.x,f=a.y+Blockly.SNAP_RADIUS+Math.floor(Math.random()*Blockly.BUMP_RANDOMNESS)-this.y;c&&(f=-f);b.RTL&&(e=a.x-
	Blockly.SNAP_RADIUS-Math.floor(Math.random()*Blockly.BUMP_RANDOMNESS)-this.x);b.moveBy(e,f);d||b.removeSelect()}}};
	Blockly.RenderedConnection.prototype.moveTo=function(a,b){this.trackedState_==Blockly.RenderedConnection.TrackedState.WILL_TRACK?(this.db_.addConnection(this,b),this.trackedState_=Blockly.RenderedConnection.TrackedState.TRACKED):this.trackedState_==Blockly.RenderedConnection.TrackedState.TRACKED&&(this.db_.removeConnection(this,this.y),this.db_.addConnection(this,b));this.x=a;this.y=b};Blockly.RenderedConnection.prototype.moveBy=function(a,b){this.moveTo(this.x+a,this.y+b)};
	Blockly.RenderedConnection.prototype.moveToOffset=function(a){this.moveTo(a.x+this.offsetInBlock_.x,a.y+this.offsetInBlock_.y)};Blockly.RenderedConnection.prototype.setOffsetInBlock=function(a,b){this.offsetInBlock_.x=a;this.offsetInBlock_.y=b};Blockly.RenderedConnection.prototype.getOffsetInBlock=function(){return this.offsetInBlock_};
	Blockly.RenderedConnection.prototype.tighten=function(){var a=this.targetConnection.x-this.x,b=this.targetConnection.y-this.y;if(0!=a||0!=b){var c=this.targetBlock(),d=c.getSvgRoot();if(!d)throw Error("block is not rendered.");d=Blockly.utils.getRelativeXY(d);c.getSvgRoot().setAttribute("transform","translate("+(d.x-a)+","+(d.y-b)+")");c.moveConnections(-a,-b)}};Blockly.RenderedConnection.prototype.closest=function(a,b){return this.dbOpposite_.searchForClosest(this,a,b)};
	Blockly.RenderedConnection.prototype.highlight=function(){var a=this.sourceBlock_.workspace.getRenderer().getConstants();var b=a.shapeFor(this);this.type==Blockly.INPUT_VALUE||this.type==Blockly.OUTPUT_VALUE?(a=a.TAB_OFFSET_FROM_TOP,b=Blockly.utils.svgPaths.moveBy(0,-a)+Blockly.utils.svgPaths.lineOnAxis("v",a)+b.pathDown+Blockly.utils.svgPaths.lineOnAxis("v",a)):(a=a.NOTCH_OFFSET_LEFT-a.CORNER_RADIUS,b=Blockly.utils.svgPaths.moveBy(-a,0)+Blockly.utils.svgPaths.lineOnAxis("h",a)+b.pathLeft+Blockly.utils.svgPaths.lineOnAxis("h",
	a));a=this.sourceBlock_.getRelativeToSurfaceXY();Blockly.Connection.highlightedPath_=Blockly.utils.dom.createSvgElement("path",{"class":"blocklyHighlightedConnectionPath",d:b,transform:"translate("+(this.x-a.x)+","+(this.y-a.y)+")"+(this.sourceBlock_.RTL?" scale(-1 1)":"")},this.sourceBlock_.getSvgRoot())};Blockly.RenderedConnection.prototype.unhighlight=function(){Blockly.utils.dom.removeNode(Blockly.Connection.highlightedPath_);delete Blockly.Connection.highlightedPath_};
	Blockly.RenderedConnection.prototype.setTracking=function(a){a&&this.trackedState_==Blockly.RenderedConnection.TrackedState.TRACKED||!a&&this.trackedState_==Blockly.RenderedConnection.TrackedState.UNTRACKED||this.sourceBlock_.isInFlyout||(a?(this.db_.addConnection(this,this.y),this.trackedState_=Blockly.RenderedConnection.TrackedState.TRACKED):(this.trackedState_==Blockly.RenderedConnection.TrackedState.TRACKED&&this.db_.removeConnection(this,this.y),this.trackedState_=Blockly.RenderedConnection.TrackedState.UNTRACKED))};
	Blockly.RenderedConnection.prototype.stopTrackingAll=function(){this.setTracking(!1);if(this.targetConnection)for(var a=this.targetBlock().getDescendants(!1),b=0;b<a.length;b++){for(var c=a[b],d=c.getConnections_(!0),e=0;e<d.length;e++)d[e].setTracking(!1);c=c.getIcons();for(e=0;e<c.length;e++)c[e].setVisible(!1)}};
	Blockly.RenderedConnection.prototype.startTrackingAll=function(){this.setTracking(!0);var a=[];if(this.type!=Blockly.INPUT_VALUE&&this.type!=Blockly.NEXT_STATEMENT)return a;var b=this.targetBlock();if(b){if(b.isCollapsed()){var c=[];b.outputConnection&&c.push(b.outputConnection);b.nextConnection&&c.push(b.nextConnection);b.previousConnection&&c.push(b.previousConnection)}else c=b.getConnections_(!0);for(var d=0;d<c.length;d++)a.push.apply(a,c[d].startTrackingAll());a.length||(a[0]=b)}return a};
	Blockly.RenderedConnection.prototype.isConnectionAllowed=function(a,b){return this.distanceFrom(a)>b?!1:Blockly.RenderedConnection.superClass_.isConnectionAllowed.call(this,a)};Blockly.RenderedConnection.prototype.onFailedConnect=function(a){this.bumpAwayFrom(a)};
	Blockly.RenderedConnection.prototype.disconnectInternal_=function(a,b){Blockly.RenderedConnection.superClass_.disconnectInternal_.call(this,a,b);a.rendered&&a.render();b.rendered&&(b.updateDisabled(),b.render(),b.getSvgRoot().style.display="block")};
	Blockly.RenderedConnection.prototype.respawnShadow_=function(){var a=this.getSourceBlock(),b=this.getShadowDom();if(a.workspace&&b&&Blockly.Events.recordUndo){Blockly.RenderedConnection.superClass_.respawnShadow_.call(this);b=this.targetBlock();if(!b)throw Error("Couldn't respawn the shadow block that should exist here.");b.initSvg();b.render(!1);a.rendered&&a.render()}};Blockly.RenderedConnection.prototype.neighbours=function(a){return this.dbOpposite_.getNeighbours(this,a)};
	Blockly.RenderedConnection.prototype.connect_=function(a){Blockly.RenderedConnection.superClass_.connect_.call(this,a);var b=this.getSourceBlock();a=a.getSourceBlock();var c=b.rendered,d=a.rendered;c&&b.updateDisabled();d&&a.updateDisabled();c&&d&&(this.type==Blockly.NEXT_STATEMENT||this.type==Blockly.PREVIOUS_STATEMENT?a.render():b.render());if(b=b.getInputWithBlock(a))b=b.isVisible(),a.getSvgRoot().style.display=b?"block":"none"};
	Blockly.RenderedConnection.prototype.onCheckChanged_=function(){!this.isConnected()||this.targetConnection&&this.checkType(this.targetConnection)||((this.isSuperior()?this.targetBlock():this.sourceBlock_).unplug(),this.sourceBlock_.bumpNeighbours())};Blockly.Marker=function(){this.drawer_=this.curNode_=this.colour=null;this.type="marker"};Blockly.Marker.prototype.setDrawer=function(a){this.drawer_=a};Blockly.Marker.prototype.getDrawer=function(){return this.drawer_};Blockly.Marker.prototype.getCurNode=function(){return this.curNode_};Blockly.Marker.prototype.setCurNode=function(a){var b=this.curNode_;this.curNode_=a;this.drawer_&&this.drawer_.draw(b,this.curNode_)};
	Blockly.Marker.prototype.draw=function(){this.drawer_&&this.drawer_.draw(this.curNode_,this.curNode_)};Blockly.Marker.prototype.hide=function(){this.drawer_&&this.drawer_.hide()};Blockly.Marker.prototype.dispose=function(){this.getDrawer()&&this.getDrawer().dispose()};Blockly.Cursor=function(){Blockly.Cursor.superClass_.constructor.call(this);this.type="cursor"};Blockly.utils.object.inherits(Blockly.Cursor,Blockly.Marker);Blockly.Cursor.prototype.next=function(){var a=this.getCurNode();if(!a)return null;for(a=a.next();a&&a.next()&&(a.getType()==Blockly.ASTNode.types.NEXT||a.getType()==Blockly.ASTNode.types.BLOCK);)a=a.next();a&&this.setCurNode(a);return a};
	Blockly.Cursor.prototype.in=function(){var a=this.getCurNode();if(!a)return null;if(a.getType()==Blockly.ASTNode.types.PREVIOUS||a.getType()==Blockly.ASTNode.types.OUTPUT)a=a.next();(a=a.in())&&this.setCurNode(a);return a};Blockly.Cursor.prototype.prev=function(){var a=this.getCurNode();if(!a)return null;for(a=a.prev();a&&a.prev()&&(a.getType()==Blockly.ASTNode.types.NEXT||a.getType()==Blockly.ASTNode.types.BLOCK);)a=a.prev();a&&this.setCurNode(a);return a};
	Blockly.Cursor.prototype.out=function(){var a=this.getCurNode();if(!a)return null;(a=a.out())&&a.getType()==Blockly.ASTNode.types.BLOCK&&(a=a.prev()||a);a&&this.setCurNode(a);return a};
	Blockly.Cursor.prototype.onBlocklyAction=function(a){if(this.getCurNode()&&this.getCurNode().getType()===Blockly.ASTNode.types.FIELD&&this.getCurNode().getLocation().onBlocklyAction(a))return!0;switch(a.name){case Blockly.navigation.actionNames.PREVIOUS:return this.prev(),!0;case Blockly.navigation.actionNames.OUT:return this.out(),!0;case Blockly.navigation.actionNames.NEXT:return this.next(),!0;case Blockly.navigation.actionNames.IN:return this.in(),!0;default:return!1}};Blockly.BasicCursor=function(){Blockly.BasicCursor.superClass_.constructor.call(this)};Blockly.utils.object.inherits(Blockly.BasicCursor,Blockly.Cursor);Blockly.BasicCursor.prototype.next=function(){var a=this.getCurNode();if(!a)return null;(a=this.getNextNode_(a,this.validNode_))&&this.setCurNode(a);return a};Blockly.BasicCursor.prototype.in=function(){return this.next()};
	Blockly.BasicCursor.prototype.prev=function(){var a=this.getCurNode();if(!a)return null;(a=this.getPreviousNode_(a,this.validNode_))&&this.setCurNode(a);return a};Blockly.BasicCursor.prototype.out=function(){return this.prev()};Blockly.BasicCursor.prototype.getNextNode_=function(a,b){if(!a)return null;var c=a.in()||a.next();if(b(c))return c;if(c)return this.getNextNode_(c,b);a=this.findSiblingOrParent_(a.out());return b(a)?a:a?this.getNextNode_(a,b):null};
	Blockly.BasicCursor.prototype.getPreviousNode_=function(a,b){if(!a)return null;var c=a.prev();c=c?this.getRightMostChild_(c):a.out();return b(c)?c:c?this.getPreviousNode_(c,b):null};Blockly.BasicCursor.prototype.validNode_=function(a){var b=!1;a=a&&a.getType();if(a==Blockly.ASTNode.types.OUTPUT||a==Blockly.ASTNode.types.INPUT||a==Blockly.ASTNode.types.FIELD||a==Blockly.ASTNode.types.NEXT||a==Blockly.ASTNode.types.PREVIOUS||a==Blockly.ASTNode.types.WORKSPACE)b=!0;return b};
	Blockly.BasicCursor.prototype.findSiblingOrParent_=function(a){if(!a)return null;var b=a.next();return b?b:this.findSiblingOrParent_(a.out())};Blockly.BasicCursor.prototype.getRightMostChild_=function(a){if(!a.in())return a;for(a=a.in();a.next();)a=a.next();return this.getRightMostChild_(a)};Blockly.TabNavigateCursor=function(){Blockly.TabNavigateCursor.superClass_.constructor.call(this)};Blockly.utils.object.inherits(Blockly.TabNavigateCursor,Blockly.BasicCursor);Blockly.TabNavigateCursor.prototype.validNode_=function(a){var b=!1,c=a&&a.getType();a&&(a=a.getLocation(),c==Blockly.ASTNode.types.FIELD&&a&&a.isTabNavigable()&&a.isClickable()&&(b=!0));return b};Blockly.BlockSvg=function(a,b,c){this.svgGroup_=Blockly.utils.dom.createSvgElement("g",{},null);this.svgGroup_.translate_="";this.style=a.getRenderer().getConstants().getBlockStyle(null);this.pathObject=a.getRenderer().makePathObject(this.svgGroup_,this.style);this.renderIsInProgress_=this.rendered=!1;this.workspace=a;this.previousConnection=this.nextConnection=this.outputConnection=null;this.useDragSurface_=Blockly.utils.is3dSupported()&&!!a.getBlockDragSurface();var d=this.pathObject.svgPath;d.tooltip=
	this;Blockly.Tooltip.bindMouseEvents(d);Blockly.BlockSvg.superClass_.constructor.call(this,a,b,c);this.svgGroup_.dataset&&(this.svgGroup_.dataset.id=this.id)};Blockly.utils.object.inherits(Blockly.BlockSvg,Blockly.Block);Blockly.BlockSvg.prototype.height=0;Blockly.BlockSvg.prototype.width=0;Blockly.BlockSvg.prototype.warningTextDb_=null;Blockly.BlockSvg.INLINE=-1;Blockly.BlockSvg.COLLAPSED_WARNING_ID="TEMP_COLLAPSED_WARNING_";
	Blockly.BlockSvg.prototype.initSvg=function(){if(!this.workspace.rendered)throw TypeError("Workspace is headless.");for(var a=0,b;b=this.inputList[a];a++)b.init();b=this.getIcons();for(a=0;a<b.length;a++)b[a].createIcon();this.applyColour();this.pathObject.updateMovable(this.isMovable());a=this.getSvgRoot();this.workspace.options.readOnly||this.eventsInit_||!a||Blockly.bindEventWithChecks_(a,"mousedown",this,this.onMouseDown_);this.eventsInit_=!0;a.parentNode||this.workspace.getCanvas().appendChild(a)};
	Blockly.BlockSvg.prototype.getColourSecondary=function(){return this.style.colourSecondary};Blockly.BlockSvg.prototype.getColourTertiary=function(){return this.style.colourTertiary};Blockly.BlockSvg.prototype.getColourShadow=function(){return this.getColourSecondary()};Blockly.BlockSvg.prototype.getColourBorder=function(){return{colourBorder:this.getColourTertiary(),colourLight:null,colourDark:null}};
	Blockly.BlockSvg.prototype.select=function(){if(this.isShadow()&&this.getParent())this.getParent().select();else if(Blockly.selected!=this){var a=null;if(Blockly.selected){a=Blockly.selected.id;Blockly.Events.disable();try{Blockly.selected.unselect()}finally{Blockly.Events.enable()}}a=new Blockly.Events.Ui(null,"selected",a,this.id);a.workspaceId=this.workspace.id;Blockly.Events.fire(a);Blockly.selected=this;this.addSelect()}};
	Blockly.BlockSvg.prototype.unselect=function(){if(Blockly.selected==this){var a=new Blockly.Events.Ui(null,"selected",this.id,null);a.workspaceId=this.workspace.id;Blockly.Events.fire(a);Blockly.selected=null;this.removeSelect()}};Blockly.BlockSvg.prototype.mutator=null;Blockly.BlockSvg.prototype.comment=null;Blockly.BlockSvg.prototype.commentIcon_=null;Blockly.BlockSvg.prototype.warning=null;
	Blockly.BlockSvg.prototype.getIcons=function(){var a=[];this.mutator&&a.push(this.mutator);this.commentIcon_&&a.push(this.commentIcon_);this.warning&&a.push(this.warning);return a};
	Blockly.BlockSvg.prototype.setParent=function(a){var b=this.parentBlock_;if(a!=b){Blockly.utils.dom.startTextWidthCache();Blockly.BlockSvg.superClass_.setParent.call(this,a);Blockly.utils.dom.stopTextWidthCache();var c=this.getSvgRoot();if(!this.workspace.isClearing&&c){var d=this.getRelativeToSurfaceXY();a?(a.getSvgRoot().appendChild(c),a=this.getRelativeToSurfaceXY(),this.moveConnections(a.x-d.x,a.y-d.y)):b&&(this.workspace.getCanvas().appendChild(c),this.translate(d.x,d.y));this.applyColour()}}};
	Blockly.BlockSvg.prototype.getRelativeToSurfaceXY=function(){var a=0,b=0,c=this.useDragSurface_?this.workspace.getBlockDragSurface().getGroup():null,d=this.getSvgRoot();if(d){do{var e=Blockly.utils.getRelativeXY(d);a+=e.x;b+=e.y;this.useDragSurface_&&this.workspace.getBlockDragSurface().getCurrentBlock()==d&&(e=this.workspace.getBlockDragSurface().getSurfaceTranslation(),a+=e.x,b+=e.y);d=d.parentNode}while(d&&d!=this.workspace.getCanvas()&&d!=c)}return new Blockly.utils.Coordinate(a,b)};
	Blockly.BlockSvg.prototype.moveBy=function(a,b){if(this.parentBlock_)throw Error("Block has parent.");var c=Blockly.Events.isEnabled();if(c)var d=new Blockly.Events.BlockMove(this);var e=this.getRelativeToSurfaceXY();this.translate(e.x+a,e.y+b);this.moveConnections(a,b);c&&(d.recordNew(),Blockly.Events.fire(d));this.workspace.resizeContents()};Blockly.BlockSvg.prototype.translate=function(a,b){this.getSvgRoot().setAttribute("transform","translate("+a+","+b+")")};
	Blockly.BlockSvg.prototype.moveToDragSurface=function(){if(this.useDragSurface_){var a=this.getRelativeToSurfaceXY();this.clearTransformAttributes_();this.workspace.getBlockDragSurface().translateSurface(a.x,a.y);(a=this.getSvgRoot())&&this.workspace.getBlockDragSurface().setBlocksAndShow(a)}};Blockly.BlockSvg.prototype.moveTo=function(a){var b=this.getRelativeToSurfaceXY();this.moveBy(a.x-b.x,a.y-b.y)};
	Blockly.BlockSvg.prototype.moveOffDragSurface=function(a){this.useDragSurface_&&(this.translate(a.x,a.y),this.workspace.getBlockDragSurface().clearAndHide(this.workspace.getCanvas()))};Blockly.BlockSvg.prototype.moveDuringDrag=function(a){this.useDragSurface_?this.workspace.getBlockDragSurface().translateSurface(a.x,a.y):(this.svgGroup_.translate_="translate("+a.x+","+a.y+")",this.svgGroup_.setAttribute("transform",this.svgGroup_.translate_+this.svgGroup_.skew_))};
	Blockly.BlockSvg.prototype.clearTransformAttributes_=function(){this.getSvgRoot().removeAttribute("transform")};Blockly.BlockSvg.prototype.snapToGrid=function(){if(this.workspace&&!this.workspace.isDragging()&&!this.getParent()&&!this.isInFlyout){var a=this.workspace.getGrid();if(a&&a.shouldSnap()){var b=a.getSpacing(),c=b/2,d=this.getRelativeToSurfaceXY();a=Math.round((d.x-c)/b)*b+c-d.x;b=Math.round((d.y-c)/b)*b+c-d.y;a=Math.round(a);b=Math.round(b);0==a&&0==b||this.moveBy(a,b)}}};
	Blockly.BlockSvg.prototype.getBoundingRectangle=function(){var a=this.getRelativeToSurfaceXY(),b=this.getHeightWidth();if(this.RTL){var c=a.x-b.width;var d=a.x}else c=a.x,d=a.x+b.width;return new Blockly.utils.Rect(a.y,a.y+b.height,c,d)};Blockly.BlockSvg.prototype.markDirty=function(){this.pathObject.constants=this.workspace.getRenderer().getConstants();for(var a=0,b;b=this.inputList[a];a++)b.markDirty()};
	Blockly.BlockSvg.prototype.setCollapsed=function(a){this.collapsed_!=a&&(Blockly.BlockSvg.superClass_.setCollapsed.call(this,a),a?this.rendered&&this.render():this.updateCollapsed_())};
	Blockly.BlockSvg.prototype.updateCollapsed_=function(){for(var a=this.isCollapsed(),b=Blockly.Block.COLLAPSED_INPUT_NAME,c=Blockly.Block.COLLAPSED_FIELD_NAME,d=0,e;e=this.inputList[d];d++)e.name!=b&&e.setVisible(!a);if(a){e=this.getIcons();for(d=0;a=e[d];d++)a.setVisible(!1);d=this.toString(Blockly.COLLAPSE_CHARS);(e=this.getField(c))?e.setValue(d):(e=this.getInput(b)||this.appendDummyInput(b),e.appendField(new Blockly.FieldLabel(d),c))}else this.removeInput(b)};
	Blockly.BlockSvg.prototype.tab=function(a,b){var c=new Blockly.TabNavigateCursor;c.setCurNode(Blockly.ASTNode.createFieldNode(a));a=c.getCurNode();c.onBlocklyAction(b?Blockly.navigation.ACTION_NEXT:Blockly.navigation.ACTION_PREVIOUS);(b=c.getCurNode())&&b!==a&&(b.getLocation().showEditor(),this.workspace.keyboardAccessibilityMode&&this.workspace.getCursor().setCurNode(b))};
	Blockly.BlockSvg.prototype.onMouseDown_=function(a){var b=this.workspace&&this.workspace.getGesture(a);b&&b.handleBlockStart(a,this)};Blockly.BlockSvg.prototype.showHelp=function(){var a="function"==typeof this.helpUrl?this.helpUrl():this.helpUrl;a&&window.open(a)};
	Blockly.BlockSvg.prototype.generateContextMenu=function(){if(this.workspace.options.readOnly||!this.contextMenu)return null;var a=this,b=[];if(!this.isInFlyout){this.isDeletable()&&this.isMovable()&&b.push(Blockly.ContextMenu.blockDuplicateOption(a));this.workspace.options.comments&&!this.collapsed_&&this.isEditable()&&b.push(Blockly.ContextMenu.blockCommentOption(a));if(this.isMovable())if(this.collapsed_)this.workspace.options.collapse&&(c={enabled:!0},c.text=Blockly.Msg.EXPAND_BLOCK,c.callback=
	function(){a.setCollapsed(!1)},b.push(c));else{for(var c=1;c<this.inputList.length;c++)if(this.inputList[c-1].type!=Blockly.NEXT_STATEMENT&&this.inputList[c].type!=Blockly.NEXT_STATEMENT){c={enabled:!0};var d=this.getInputsInline();c.text=d?Blockly.Msg.EXTERNAL_INPUTS:Blockly.Msg.INLINE_INPUTS;c.callback=function(){a.setInputsInline(!d)};b.push(c);break}this.workspace.options.collapse&&(c={enabled:!0},c.text=Blockly.Msg.COLLAPSE_BLOCK,c.callback=function(){a.setCollapsed(!0)},b.push(c))}this.workspace.options.disable&&
	this.isEditable()&&(c={text:this.isEnabled()?Blockly.Msg.DISABLE_BLOCK:Blockly.Msg.ENABLE_BLOCK,enabled:!this.getInheritedDisabled(),callback:function(){var b=Blockly.Events.getGroup();b||Blockly.Events.setGroup(!0);a.setEnabled(!a.isEnabled());b||Blockly.Events.setGroup(!1)}},b.push(c));this.isDeletable()&&b.push(Blockly.ContextMenu.blockDeleteOption(a))}b.push(Blockly.ContextMenu.blockHelpOption(a));this.customContextMenu&&this.customContextMenu(b);return b};
	Blockly.BlockSvg.prototype.showContextMenu=function(a){var b=this.generateContextMenu();b&&b.length&&(Blockly.ContextMenu.show(a,b,this.RTL),Blockly.ContextMenu.currentBlock=this)};Blockly.BlockSvg.prototype.moveConnections=function(a,b){if(this.rendered){for(var c=this.getConnections_(!1),d=0;d<c.length;d++)c[d].moveBy(a,b);c=this.getIcons();for(d=0;d<c.length;d++)c[d].computeIconLocation();for(d=0;d<this.childBlocks_.length;d++)this.childBlocks_[d].moveConnections(a,b)}};
	Blockly.BlockSvg.prototype.setDragging=function(a){if(a){var b=this.getSvgRoot();b.translate_="";b.skew_="";Blockly.draggingConnections=Blockly.draggingConnections.concat(this.getConnections_(!0));Blockly.utils.dom.addClass(this.svgGroup_,"blocklyDragging")}else Blockly.draggingConnections=[],Blockly.utils.dom.removeClass(this.svgGroup_,"blocklyDragging");for(b=0;b<this.childBlocks_.length;b++)this.childBlocks_[b].setDragging(a)};
	Blockly.BlockSvg.prototype.setMovable=function(a){Blockly.BlockSvg.superClass_.setMovable.call(this,a);this.pathObject.updateMovable(a)};Blockly.BlockSvg.prototype.setEditable=function(a){Blockly.BlockSvg.superClass_.setEditable.call(this,a);a=this.getIcons();for(var b=0;b<a.length;b++)a[b].updateEditable()};Blockly.BlockSvg.prototype.setShadow=function(a){Blockly.BlockSvg.superClass_.setShadow.call(this,a);this.applyColour()};
	Blockly.BlockSvg.prototype.setInsertionMarker=function(a){this.isInsertionMarker_!=a&&(this.isInsertionMarker_=a)&&(this.setColour(this.workspace.getRenderer().getConstants().INSERTION_MARKER_COLOUR),this.pathObject.updateInsertionMarker(!0))};Blockly.BlockSvg.prototype.getSvgRoot=function(){return this.svgGroup_};
	Blockly.BlockSvg.prototype.dispose=function(a,b){if(this.workspace){Blockly.Tooltip.dispose();Blockly.Tooltip.unbindMouseEvents(this.pathObject.svgPath);Blockly.utils.dom.startTextWidthCache();var c=this.workspace;Blockly.selected==this&&(this.unselect(),this.workspace.cancelCurrentGesture());Blockly.ContextMenu.currentBlock==this&&Blockly.ContextMenu.hide();this.workspace.keyboardAccessibilityMode&&Blockly.navigation.moveCursorOnBlockDelete(this);b&&this.rendered&&(this.unplug(a),Blockly.blockAnimations.disposeUiEffect(this));
	this.rendered=!1;if(this.warningTextDb_){for(var d in this.warningTextDb_)clearTimeout(this.warningTextDb_[d]);this.warningTextDb_=null}b=this.getIcons();for(d=0;d<b.length;d++)b[d].dispose();Blockly.BlockSvg.superClass_.dispose.call(this,!!a);Blockly.utils.dom.removeNode(this.svgGroup_);c.resizeContents();this.svgGroup_=null;Blockly.utils.dom.stopTextWidthCache()}};
	Blockly.BlockSvg.prototype.toCopyData=function(){var a=Blockly.Xml.blockToDom(this,!0);Blockly.Xml.deleteNext(a);var b=this.getRelativeToSurfaceXY();a.setAttribute("x",this.RTL?-b.x:b.x);a.setAttribute("y",b.y);return{xml:a,source:this.workspace,typeCounts:Blockly.utils.getBlockTypeCounts(this,!0)}};Blockly.BlockSvg.prototype.applyColour=function(){this.pathObject.applyColour(this);for(var a=this.getIcons(),b=0;b<a.length;b++)a[b].applyColour();for(a=0;b=this.inputList[a];a++)for(var c=0,d;d=b.fieldRow[c];c++)d.applyColour()};
	Blockly.BlockSvg.prototype.updateDisabled=function(){var a=this.getChildren(!1);this.applyColour();for(var b=0,c;c=a[b];b++)c.updateDisabled()};Blockly.BlockSvg.prototype.getCommentIcon=function(){return this.commentIcon_};
	Blockly.BlockSvg.prototype.setCommentText=function(a){if(!Blockly.Comment)throw Error("Missing require for Blockly.Comment");this.commentModel.text!=a&&(Blockly.BlockSvg.superClass_.setCommentText.call(this,a),a=null!=a,!!this.commentIcon_==a?this.commentIcon_.updateText():(a?this.comment=this.commentIcon_=new Blockly.Comment(this):(this.commentIcon_.dispose(),this.comment=this.commentIcon_=null),this.rendered&&(this.render(),this.bumpNeighbours())))};
	Blockly.BlockSvg.prototype.setWarningText=function(a,b){if(!Blockly.Warning)throw Error("Missing require for Blockly.Warning");this.warningTextDb_||(this.warningTextDb_=Object.create(null));var c=b||"";if(c)this.warningTextDb_[c]&&(clearTimeout(this.warningTextDb_[c]),delete this.warningTextDb_[c]);else for(var d in this.warningTextDb_)clearTimeout(this.warningTextDb_[d]),delete this.warningTextDb_[d];if(this.workspace.isDragging()){var e=this;this.warningTextDb_[c]=setTimeout(function(){e.workspace&&
	(delete e.warningTextDb_[c],e.setWarningText(a,c))},100)}else{this.isInFlyout&&(a=null);b=!1;if("string"==typeof a){d=this.getSurroundParent();for(var f=null;d;)d.isCollapsed()&&(f=d),d=d.getSurroundParent();f&&f.setWarningText(Blockly.Msg.COLLAPSED_WARNINGS_WARNING,Blockly.BlockSvg.COLLAPSED_WARNING_ID);this.warning||(this.warning=new Blockly.Warning(this),b=!0);this.warning.setText(a,c)}else this.warning&&!c?(this.warning.dispose(),b=!0):this.warning&&(b=this.warning.getText(),this.warning.setText("",
	c),(d=this.warning.getText())||this.warning.dispose(),b=b!=d);b&&this.rendered&&(this.render(),this.bumpNeighbours())}};Blockly.BlockSvg.prototype.setMutator=function(a){this.mutator&&this.mutator!==a&&this.mutator.dispose();a&&(a.setBlock(this),this.mutator=a,a.createIcon());this.rendered&&(this.render(),this.bumpNeighbours())};
	Blockly.BlockSvg.prototype.setDisabled=function(a){console.warn("Deprecated call to Blockly.BlockSvg.prototype.setDisabled, use Blockly.BlockSvg.prototype.setEnabled instead.");this.setEnabled(!a)};Blockly.BlockSvg.prototype.setEnabled=function(a){this.isEnabled()!=a&&(Blockly.BlockSvg.superClass_.setEnabled.call(this,a),this.rendered&&!this.getInheritedDisabled()&&this.updateDisabled())};Blockly.BlockSvg.prototype.setHighlighted=function(a){this.rendered&&this.pathObject.updateHighlighted(a)};
	Blockly.BlockSvg.prototype.addSelect=function(){this.pathObject.updateSelected(!0)};Blockly.BlockSvg.prototype.removeSelect=function(){this.pathObject.updateSelected(!1)};Blockly.BlockSvg.prototype.setDeleteStyle=function(a){this.pathObject.updateDraggingDelete(a)};Blockly.BlockSvg.prototype.getColour=function(){return this.style.colourPrimary};
	Blockly.BlockSvg.prototype.setColour=function(a){Blockly.BlockSvg.superClass_.setColour.call(this,a);a=this.workspace.getRenderer().getConstants().getBlockStyleForColour(this.colour_);this.pathObject.setStyle(a.style);this.style=a.style;this.styleName_=a.name;this.applyColour()};
	Blockly.BlockSvg.prototype.setStyle=function(a){var b=this.workspace.getRenderer().getConstants().getBlockStyle(a);this.styleName_=a;if(b)this.hat=b.hat,this.pathObject.setStyle(b),this.colour_=b.colourPrimary,this.style=b,this.applyColour();else throw Error("Invalid style name: "+a);};Blockly.BlockSvg.prototype.bringToFront=function(){var a=this;do{var b=a.getSvgRoot(),c=b.parentNode,d=c.childNodes;d[d.length-1]!==b&&c.appendChild(b);a=a.getParent()}while(a)};
	Blockly.BlockSvg.prototype.setPreviousStatement=function(a,b){Blockly.BlockSvg.superClass_.setPreviousStatement.call(this,a,b);this.rendered&&(this.render(),this.bumpNeighbours())};Blockly.BlockSvg.prototype.setNextStatement=function(a,b){Blockly.BlockSvg.superClass_.setNextStatement.call(this,a,b);this.rendered&&(this.render(),this.bumpNeighbours())};Blockly.BlockSvg.prototype.setOutput=function(a,b){Blockly.BlockSvg.superClass_.setOutput.call(this,a,b);this.rendered&&(this.render(),this.bumpNeighbours())};
	Blockly.BlockSvg.prototype.setInputsInline=function(a){Blockly.BlockSvg.superClass_.setInputsInline.call(this,a);this.rendered&&(this.render(),this.bumpNeighbours())};Blockly.BlockSvg.prototype.removeInput=function(a,b){a=Blockly.BlockSvg.superClass_.removeInput.call(this,a,b);this.rendered&&(this.render(),this.bumpNeighbours());return a};
	Blockly.BlockSvg.prototype.moveNumberedInputBefore=function(a,b){Blockly.BlockSvg.superClass_.moveNumberedInputBefore.call(this,a,b);this.rendered&&(this.render(),this.bumpNeighbours())};Blockly.BlockSvg.prototype.appendInput_=function(a,b){a=Blockly.BlockSvg.superClass_.appendInput_.call(this,a,b);this.rendered&&(this.render(),this.bumpNeighbours());return a};
	Blockly.BlockSvg.prototype.setConnectionTracking=function(a){this.previousConnection&&this.previousConnection.setTracking(a);this.outputConnection&&this.outputConnection.setTracking(a);if(this.nextConnection){this.nextConnection.setTracking(a);var b=this.nextConnection.targetBlock();b&&b.setConnectionTracking(a)}if(!this.collapsed_)for(b=0;b<this.inputList.length;b++){var c=this.inputList[b].connection;c&&(c.setTracking(a),(c=c.targetBlock())&&c.setConnectionTracking(a))}};
	Blockly.BlockSvg.prototype.getConnections_=function(a){var b=[];if(a||this.rendered)if(this.outputConnection&&b.push(this.outputConnection),this.previousConnection&&b.push(this.previousConnection),this.nextConnection&&b.push(this.nextConnection),a||!this.collapsed_){a=0;for(var c;c=this.inputList[a];a++)c.connection&&b.push(c.connection)}return b};Blockly.BlockSvg.prototype.lastConnectionInStack=function(){return Blockly.BlockSvg.superClass_.lastConnectionInStack.call(this)};
	Blockly.BlockSvg.prototype.getMatchingConnection=function(a,b){return Blockly.BlockSvg.superClass_.getMatchingConnection.call(this,a,b)};Blockly.BlockSvg.prototype.makeConnection_=function(a){return new Blockly.RenderedConnection(this,a)};
	Blockly.BlockSvg.prototype.bumpNeighbours=function(){if(this.workspace&&!this.workspace.isDragging()){var a=this.getRootBlock();if(!a.isInFlyout)for(var b=this.getConnections_(!1),c=0,d;d=b[c];c++){d.isConnected()&&d.isSuperior()&&d.targetBlock().bumpNeighbours();for(var e=d.neighbours(Blockly.SNAP_RADIUS),f=0,g;g=e[f];f++)d.isConnected()&&g.isConnected()||g.getSourceBlock().getRootBlock()!=a&&(d.isSuperior()?g.bumpAwayFrom(d):d.bumpAwayFrom(g))}}};
	Blockly.BlockSvg.prototype.scheduleSnapAndBump=function(){var a=this,b=Blockly.Events.getGroup();setTimeout(function(){Blockly.Events.setGroup(b);a.snapToGrid();Blockly.Events.setGroup(!1)},Blockly.BUMP_DELAY/2);setTimeout(function(){Blockly.Events.setGroup(b);a.bumpNeighbours();Blockly.Events.setGroup(!1)},Blockly.BUMP_DELAY)};Blockly.BlockSvg.prototype.positionNearConnection=function(a,b){a.type!=Blockly.NEXT_STATEMENT&&a.type!=Blockly.INPUT_VALUE||this.moveBy(b.x-a.x,b.y-a.y)};
	Blockly.BlockSvg.prototype.getParent=function(){return Blockly.BlockSvg.superClass_.getParent.call(this)};Blockly.BlockSvg.prototype.getRootBlock=function(){return Blockly.BlockSvg.superClass_.getRootBlock.call(this)};
	Blockly.BlockSvg.prototype.render=function(a){if(!this.renderIsInProgress_){this.renderIsInProgress_=!0;try{this.rendered=!0;Blockly.utils.dom.startTextWidthCache();this.isCollapsed()&&this.updateCollapsed_();this.workspace.getRenderer().render(this);this.updateConnectionLocations_();if(!1!==a){var b=this.getParent();b?b.render(!0):this.workspace.resizeContents()}Blockly.utils.dom.stopTextWidthCache();this.updateMarkers_()}finally{this.renderIsInProgress_=!1}}};
	Blockly.BlockSvg.prototype.updateMarkers_=function(){this.workspace.keyboardAccessibilityMode&&this.pathObject.cursorSvg&&this.workspace.getCursor().draw();this.workspace.keyboardAccessibilityMode&&this.pathObject.markerSvg&&this.workspace.getMarker(Blockly.navigation.MARKER_NAME).draw()};
	Blockly.BlockSvg.prototype.updateConnectionLocations_=function(){var a=this.getRelativeToSurfaceXY();this.previousConnection&&this.previousConnection.moveToOffset(a);this.outputConnection&&this.outputConnection.moveToOffset(a);for(var b=0;b<this.inputList.length;b++){var c=this.inputList[b].connection;c&&(c.moveToOffset(a),c.isConnected()&&c.tighten())}this.nextConnection&&(this.nextConnection.moveToOffset(a),this.nextConnection.isConnected()&&this.nextConnection.tighten())};
	Blockly.BlockSvg.prototype.setCursorSvg=function(a){this.pathObject.setCursorSvg(a)};Blockly.BlockSvg.prototype.setMarkerSvg=function(a){this.pathObject.setMarkerSvg(a)};Blockly.BlockSvg.prototype.getHeightWidth=function(){var a=this.height,b=this.width,c=this.getNextBlock();if(c){c=c.getHeightWidth();var d=this.workspace.getRenderer().getConstants().NOTCH_HEIGHT;a+=c.height-d;b=Math.max(b,c.width)}return{height:a,width:b}};Blockly.BlockSvg.prototype.fadeForReplacement=function(a){this.pathObject.updateReplacementFade(a)};
	Blockly.BlockSvg.prototype.highlightShapeForInput=function(a,b){this.pathObject.updateShapeForInputHighlight(a,b)};Blockly.blockRendering.useDebugger=!1;Blockly.blockRendering.register=function(a,b){Blockly.registry.register(Blockly.registry.Type.RENDERER,a,b)};Blockly.blockRendering.unregister=function(a){Blockly.registry.unregister(Blockly.registry.Type.RENDERER,a)};Blockly.blockRendering.startDebugger=function(){Blockly.blockRendering.useDebugger=!0};Blockly.blockRendering.stopDebugger=function(){Blockly.blockRendering.useDebugger=!1};
	Blockly.blockRendering.init=function(a,b,c){a=new (Blockly.registry.getClass(Blockly.registry.Type.RENDERER,a))(a);a.init(b,c);return a};Blockly.ConnectionDB=function(){this.connections_=[]};Blockly.ConnectionDB.prototype.addConnection=function(a,b){b=this.calculateIndexForYPos_(b);this.connections_.splice(b,0,a)};
	Blockly.ConnectionDB.prototype.findIndexOfConnection_=function(a,b){if(!this.connections_.length)return-1;var c=this.calculateIndexForYPos_(b);if(c>=this.connections_.length)return-1;b=a.y;for(var d=c;0<=d&&this.connections_[d].y==b;){if(this.connections_[d]==a)return d;d--}for(;c<this.connections_.length&&this.connections_[c].y==b;){if(this.connections_[c]==a)return c;c++}return-1};
	Blockly.ConnectionDB.prototype.calculateIndexForYPos_=function(a){if(!this.connections_.length)return 0;for(var b=0,c=this.connections_.length;b<c;){var d=Math.floor((b+c)/2);if(this.connections_[d].y<a)b=d+1;else if(this.connections_[d].y>a)c=d;else{b=d;break}}return b};Blockly.ConnectionDB.prototype.removeConnection=function(a,b){a=this.findIndexOfConnection_(a,b);if(-1==a)throw Error("Unable to find connection in connectionDB.");this.connections_.splice(a,1)};
	Blockly.ConnectionDB.prototype.getNeighbours=function(a,b){function c(a){var c=e-d[a].x,g=f-d[a].y;Math.sqrt(c*c+g*g)<=b&&k.push(d[a]);return g<b}var d=this.connections_,e=a.x,f=a.y;a=0;for(var g=d.length-2,h=g;a<h;)d[h].y<f?a=h:g=h,h=Math.floor((a+g)/2);var k=[];g=a=h;if(d.length){for(;0<=a&&c(a);)a--;do g++;while(g<d.length&&c(g))}return k};Blockly.ConnectionDB.prototype.isInYRange_=function(a,b,c){return Math.abs(this.connections_[a].y-b)<=c};
	Blockly.ConnectionDB.prototype.searchForClosest=function(a,b,c){if(!this.connections_.length)return{connection:null,radius:b};var d=a.y,e=a.x;a.x=e+c.x;a.y=d+c.y;var f=this.calculateIndexForYPos_(a.y);c=null;for(var g=b,h,k=f-1;0<=k&&this.isInYRange_(k,a.y,b);)h=this.connections_[k],a.isConnectionAllowed(h,g)&&(c=h,g=h.distanceFrom(a)),k--;for(;f<this.connections_.length&&this.isInYRange_(f,a.y,b);)h=this.connections_[f],a.isConnectionAllowed(h,g)&&(c=h,g=h.distanceFrom(a)),f++;a.x=e;a.y=d;return{connection:c,
	radius:g}};Blockly.ConnectionDB.init=function(){var a=[];a[Blockly.INPUT_VALUE]=new Blockly.ConnectionDB;a[Blockly.OUTPUT_VALUE]=new Blockly.ConnectionDB;a[Blockly.NEXT_STATEMENT]=new Blockly.ConnectionDB;a[Blockly.PREVIOUS_STATEMENT]=new Blockly.ConnectionDB;return a};Blockly.MarkerManager=function(a){this.cursorSvg_=this.cursor_=null;this.markers_={};this.workspace_=a};Blockly.MarkerManager.prototype.registerMarker=function(a,b){this.markers_[a]&&this.unregisterMarker(a);b.setDrawer(this.workspace_.getRenderer().makeMarkerDrawer(this.workspace_,b));this.setMarkerSvg(b.getDrawer().createDom());this.markers_[a]=b};
	Blockly.MarkerManager.prototype.unregisterMarker=function(a){var b=this.markers_[a];if(b)b.dispose(),delete this.markers_[a];else throw Error("Marker with id "+a+" does not exist. Can only unregistermarkers that exist.");};Blockly.MarkerManager.prototype.getCursor=function(){return this.cursor_};Blockly.MarkerManager.prototype.getMarker=function(a){return this.markers_[a]};
	Blockly.MarkerManager.prototype.setCursor=function(a){this.cursor_&&this.cursor_.getDrawer()&&this.cursor_.getDrawer().dispose();if(this.cursor_=a)a=this.workspace_.getRenderer().makeMarkerDrawer(this.workspace_,this.cursor_),this.cursor_.setDrawer(a),this.setCursorSvg(this.cursor_.getDrawer().createDom())};Blockly.MarkerManager.prototype.setCursorSvg=function(a){a?(this.workspace_.getBlockCanvas().appendChild(a),this.cursorSvg_=a):this.cursorSvg_=null};
	Blockly.MarkerManager.prototype.setMarkerSvg=function(a){a?this.workspace_.getBlockCanvas()&&(this.cursorSvg_?this.workspace_.getBlockCanvas().insertBefore(a,this.cursorSvg_):this.workspace_.getBlockCanvas().appendChild(a)):this.markerSvg_=null};Blockly.MarkerManager.prototype.updateMarkers=function(){this.workspace_.keyboardAccessibilityMode&&this.cursorSvg_&&this.workspace_.getCursor().draw()};
	Blockly.MarkerManager.prototype.dispose=function(){for(var a=Object.keys(this.markers_),b=0,c;c=a[b];b++)this.unregisterMarker(c);this.markers_=null;this.cursor_.dispose();this.cursor_=null};Blockly.ThemeManager=function(a,b){this.workspace_=a;this.theme_=b;this.subscribedWorkspaces_=[];this.componentDB_=Object.create(null)};Blockly.ThemeManager.prototype.getTheme=function(){return this.theme_};
	Blockly.ThemeManager.prototype.setTheme=function(a){var b=this.theme_;this.theme_=a;if(a=this.workspace_.getInjectionDiv())b&&Blockly.utils.dom.removeClass(a,b.getClassName()),Blockly.utils.dom.addClass(a,this.theme_.getClassName());for(b=0;a=this.subscribedWorkspaces_[b];b++)a.refreshTheme();b=0;a=Object.keys(this.componentDB_);for(var c;c=a[b];b++)for(var d=0,e;e=this.componentDB_[c][d];d++){var f=e.element;e=e.propertyName;var g=this.theme_&&this.theme_.getComponentStyle(c);f.style[e]=g||""}Blockly.hideChaff()};
	Blockly.ThemeManager.prototype.subscribeWorkspace=function(a){this.subscribedWorkspaces_.push(a)};Blockly.ThemeManager.prototype.unsubscribeWorkspace=function(a){a=this.subscribedWorkspaces_.indexOf(a);if(0>a)throw Error("Cannot unsubscribe a workspace that hasn't been subscribed.");this.subscribedWorkspaces_.splice(a,1)};
	Blockly.ThemeManager.prototype.subscribe=function(a,b,c){this.componentDB_[b]||(this.componentDB_[b]=[]);this.componentDB_[b].push({element:a,propertyName:c});b=this.theme_&&this.theme_.getComponentStyle(b);a.style[c]=b||""};Blockly.ThemeManager.prototype.unsubscribe=function(a){if(a)for(var b=Object.keys(this.componentDB_),c=0,d;d=b[c];c++){for(var e=this.componentDB_[d],f=e.length-1;0<=f;f--)e[f].element===a&&e.splice(f,1);this.componentDB_[d].length||delete this.componentDB_[d]}};
	Blockly.ThemeManager.prototype.dispose=function(){this.componentDB_=this.subscribedWorkspaces_=this.theme_=this.owner_=null};Blockly.TouchGesture=function(a,b){Blockly.TouchGesture.superClass_.constructor.call(this,a,b);this.isMultiTouch_=!1;this.cachedPoints_=Object.create(null);this.startDistance_=this.previousScale_=0;this.isPinchZoomEnabled_=this.onStartWrapper_=null};Blockly.utils.object.inherits(Blockly.TouchGesture,Blockly.Gesture);Blockly.TouchGesture.ZOOM_IN_MULTIPLIER=5;Blockly.TouchGesture.ZOOM_OUT_MULTIPLIER=6;
	Blockly.TouchGesture.prototype.doStart=function(a){this.isPinchZoomEnabled_=this.startWorkspace_.options.zoomOptions&&this.startWorkspace_.options.zoomOptions.pinch;Blockly.TouchGesture.superClass_.doStart.call(this,a);!this.isEnding_&&Blockly.Touch.isTouchEvent(a)&&this.handleTouchStart(a)};
	Blockly.TouchGesture.prototype.bindMouseEvents=function(a){this.onStartWrapper_=Blockly.bindEventWithChecks_(document,"mousedown",null,this.handleStart.bind(this),!0);this.onMoveWrapper_=Blockly.bindEventWithChecks_(document,"mousemove",null,this.handleMove.bind(this),!0);this.onUpWrapper_=Blockly.bindEventWithChecks_(document,"mouseup",null,this.handleUp.bind(this),!0);a.preventDefault();a.stopPropagation()};
	Blockly.TouchGesture.prototype.handleStart=function(a){!this.isDragging()&&Blockly.Touch.isTouchEvent(a)&&(this.handleTouchStart(a),this.isMultiTouch()&&Blockly.longStop_())};Blockly.TouchGesture.prototype.handleMove=function(a){this.isDragging()?Blockly.Touch.shouldHandleEvent(a)&&Blockly.TouchGesture.superClass_.handleMove.call(this,a):this.isMultiTouch()?(Blockly.Touch.isTouchEvent(a)&&this.handleTouchMove(a),Blockly.longStop_()):Blockly.TouchGesture.superClass_.handleMove.call(this,a)};
	Blockly.TouchGesture.prototype.handleUp=function(a){Blockly.Touch.isTouchEvent(a)&&!this.isDragging()&&this.handleTouchEnd(a);!this.isMultiTouch()||this.isDragging()?Blockly.Touch.shouldHandleEvent(a)&&Blockly.TouchGesture.superClass_.handleUp.call(this,a):(a.preventDefault(),a.stopPropagation(),this.dispose())};Blockly.TouchGesture.prototype.isMultiTouch=function(){return this.isMultiTouch_};
	Blockly.TouchGesture.prototype.dispose=function(){Blockly.TouchGesture.superClass_.dispose.call(this);this.onStartWrapper_&&Blockly.unbindEvent_(this.onStartWrapper_)};Blockly.TouchGesture.prototype.handleTouchStart=function(a){var b=Blockly.Touch.getTouchIdentifierFromEvent(a);this.cachedPoints_[b]=this.getTouchPoint(a);b=Object.keys(this.cachedPoints_);2==b.length&&(this.startDistance_=Blockly.utils.Coordinate.distance(this.cachedPoints_[b[0]],this.cachedPoints_[b[1]]),this.isMultiTouch_=!0,a.preventDefault())};
	Blockly.TouchGesture.prototype.handleTouchMove=function(a){var b=Blockly.Touch.getTouchIdentifierFromEvent(a);this.cachedPoints_[b]=this.getTouchPoint(a);b=Object.keys(this.cachedPoints_);this.isPinchZoomEnabled_&&2===b.length?this.handlePinch_(a):Blockly.TouchGesture.superClass_.handleMove.call(this,a)};
	Blockly.TouchGesture.prototype.handlePinch_=function(a){var b=Object.keys(this.cachedPoints_);b=Blockly.utils.Coordinate.distance(this.cachedPoints_[b[0]],this.cachedPoints_[b[1]])/this.startDistance_;if(0<this.previousScale_&&Infinity>this.previousScale_){var c=b-this.previousScale_;c=0<c?c*Blockly.TouchGesture.ZOOM_IN_MULTIPLIER:c*Blockly.TouchGesture.ZOOM_OUT_MULTIPLIER;var d=this.startWorkspace_,e=Blockly.utils.mouseToSvg(a,d.getParentSvg(),d.getInverseScreenCTM());d.zoom(e.x,e.y,c)}this.previousScale_=
	b;a.preventDefault()};Blockly.TouchGesture.prototype.handleTouchEnd=function(a){a=Blockly.Touch.getTouchIdentifierFromEvent(a);this.cachedPoints_[a]&&delete this.cachedPoints_[a];2>Object.keys(this.cachedPoints_).length&&(this.cachedPoints_=Object.create(null),this.previousScale_=0)};Blockly.TouchGesture.prototype.getTouchPoint=function(a){return this.startWorkspace_?new Blockly.utils.Coordinate(a.pageX?a.pageX:a.changedTouches[0].pageX,a.pageY?a.pageY:a.changedTouches[0].pageY):null};Blockly.WorkspaceAudio=function(a){this.parentWorkspace_=a;this.SOUNDS_=Object.create(null)};Blockly.WorkspaceAudio.prototype.lastSound_=null;Blockly.WorkspaceAudio.prototype.dispose=function(){this.SOUNDS_=this.parentWorkspace_=null};
	Blockly.WorkspaceAudio.prototype.load=function(a,b){if(a.length){try{var c=new Blockly.utils.global.Audio}catch(h){return}for(var d,e=0;e<a.length;e++){var f=a[e],g=f.match(/\.(\w+)$/);if(g&&c.canPlayType("audio/"+g[1])){d=new Blockly.utils.global.Audio(f);break}}d&&d.play&&(this.SOUNDS_[b]=d)}};
	Blockly.WorkspaceAudio.prototype.preload=function(){for(var a in this.SOUNDS_){var b=this.SOUNDS_[a];b.volume=.01;var c=b.play();void 0!==c?c.then(b.pause).catch(function(){}):b.pause();if(Blockly.utils.userAgent.IPAD||Blockly.utils.userAgent.IPHONE)break}};
	Blockly.WorkspaceAudio.prototype.play=function(a,b){var c=this.SOUNDS_[a];c?(a=new Date,null!=this.lastSound_&&a-this.lastSound_<Blockly.SOUND_LIMIT||(this.lastSound_=a,c=Blockly.utils.userAgent.IPAD||Blockly.utils.userAgent.ANDROID?c:c.cloneNode(),c.volume=void 0===b?1:b,c.play())):this.parentWorkspace_&&this.parentWorkspace_.getAudioManager().play(a,b)};Blockly.WorkspaceSvg=function(a,b,c){Blockly.WorkspaceSvg.superClass_.constructor.call(this,a);this.getMetrics=a.getMetrics||Blockly.WorkspaceSvg.getTopLevelWorkspaceMetrics_;this.setMetrics=a.setMetrics||Blockly.WorkspaceSvg.setTopLevelWorkspaceMetrics_;this.connectionDBList=Blockly.ConnectionDB.init();b&&(this.blockDragSurface_=b);c&&(this.workspaceDragSurface_=c);this.useWorkspaceDragSurface_=!!this.workspaceDragSurface_&&Blockly.utils.is3dSupported();this.highlightedBlocks_=[];this.audioManager_=
	new Blockly.WorkspaceAudio(a.parentWorkspace);this.grid_=this.options.gridPattern?new Blockly.Grid(this.options.gridPattern,a.gridOptions):null;this.markerManager_=new Blockly.MarkerManager(this);this.toolboxCategoryCallbacks_={};this.flyoutButtonCallbacks_={};Blockly.Variables&&Blockly.Variables.flyoutCategory&&this.registerToolboxCategoryCallback(Blockly.VARIABLE_CATEGORY_NAME,Blockly.Variables.flyoutCategory);Blockly.VariablesDynamic&&Blockly.VariablesDynamic.flyoutCategory&&this.registerToolboxCategoryCallback(Blockly.VARIABLE_DYNAMIC_CATEGORY_NAME,
	Blockly.VariablesDynamic.flyoutCategory);Blockly.Procedures&&Blockly.Procedures.flyoutCategory&&(this.registerToolboxCategoryCallback(Blockly.PROCEDURE_CATEGORY_NAME,Blockly.Procedures.flyoutCategory),this.addChangeListener(Blockly.Procedures.mutatorOpenListener));this.themeManager_=this.options.parentWorkspace?this.options.parentWorkspace.getThemeManager():new Blockly.ThemeManager(this,this.options.theme||Blockly.Themes.Classic);this.themeManager_.subscribeWorkspace(this);this.renderer_=Blockly.blockRendering.init(this.options.renderer||
	"geras",this.getTheme(),this.options.rendererOverrides);this.cachedParentSvg_=null;this.keyboardAccessibilityMode=!1;this.topBoundedElements_=[]};Blockly.utils.object.inherits(Blockly.WorkspaceSvg,Blockly.Workspace);Blockly.WorkspaceSvg.prototype.resizeHandlerWrapper_=null;Blockly.WorkspaceSvg.prototype.rendered=!0;Blockly.WorkspaceSvg.prototype.isVisible_=!0;Blockly.WorkspaceSvg.prototype.isFlyout=!1;Blockly.WorkspaceSvg.prototype.isMutator=!1;Blockly.WorkspaceSvg.prototype.resizesEnabled_=!0;
	Blockly.WorkspaceSvg.prototype.scrollX=0;Blockly.WorkspaceSvg.prototype.scrollY=0;Blockly.WorkspaceSvg.prototype.startScrollX=0;Blockly.WorkspaceSvg.prototype.startScrollY=0;Blockly.WorkspaceSvg.prototype.dragDeltaXY_=null;Blockly.WorkspaceSvg.prototype.scale=1;Blockly.WorkspaceSvg.prototype.trashcan=null;Blockly.WorkspaceSvg.prototype.scrollbar=null;Blockly.WorkspaceSvg.prototype.flyout_=null;Blockly.WorkspaceSvg.prototype.toolbox_=null;Blockly.WorkspaceSvg.prototype.currentGesture_=null;
	Blockly.WorkspaceSvg.prototype.blockDragSurface_=null;Blockly.WorkspaceSvg.prototype.workspaceDragSurface_=null;Blockly.WorkspaceSvg.prototype.useWorkspaceDragSurface_=!1;Blockly.WorkspaceSvg.prototype.isDragSurfaceActive_=!1;Blockly.WorkspaceSvg.prototype.injectionDiv_=null;Blockly.WorkspaceSvg.prototype.lastRecordedPageScroll_=null;Blockly.WorkspaceSvg.prototype.targetWorkspace=null;Blockly.WorkspaceSvg.prototype.inverseScreenCTM_=null;Blockly.WorkspaceSvg.prototype.inverseScreenCTMDirty_=!0;
	Blockly.WorkspaceSvg.prototype.getMarkerManager=function(){return this.markerManager_};Blockly.WorkspaceSvg.prototype.setCursorSvg=function(a){this.markerManager_.setCursorSvg(a)};Blockly.WorkspaceSvg.prototype.setMarkerSvg=function(a){this.markerManager_.setMarkerSvg(a)};Blockly.WorkspaceSvg.prototype.getMarker=function(a){return this.markerManager_?this.markerManager_.getMarker(a):null};
	Blockly.WorkspaceSvg.prototype.getCursor=function(){return this.markerManager_?this.markerManager_.getCursor():null};Blockly.WorkspaceSvg.prototype.getRenderer=function(){return this.renderer_};Blockly.WorkspaceSvg.prototype.getThemeManager=function(){return this.themeManager_};Blockly.WorkspaceSvg.prototype.getTheme=function(){return this.themeManager_.getTheme()};Blockly.WorkspaceSvg.prototype.setTheme=function(a){a||(a=Blockly.Themes.Classic);this.themeManager_.setTheme(a)};
	Blockly.WorkspaceSvg.prototype.refreshTheme=function(){this.svgGroup_&&this.renderer_.refreshDom(this.svgGroup_,this.getTheme());this.updateBlockStyles_(this.getAllBlocks(!1).filter(function(a){return void 0!==a.getStyleName()}));this.refreshToolboxSelection();this.toolbox_&&this.toolbox_.refreshTheme();this.isVisible()&&this.setVisible(!0);var a=new Blockly.Events.Ui(null,"theme",null,null);a.workspaceId=this.id;Blockly.Events.fire(a)};
	Blockly.WorkspaceSvg.prototype.updateBlockStyles_=function(a){for(var b=0,c;c=a[b];b++){var d=c.getStyleName();d&&(c.setStyle(d),c.mutator&&c.mutator.updateBlockStyle())}};Blockly.WorkspaceSvg.prototype.getInverseScreenCTM=function(){if(this.inverseScreenCTMDirty_){var a=this.getParentSvg().getScreenCTM();a&&(this.inverseScreenCTM_=a.inverse(),this.inverseScreenCTMDirty_=!1)}return this.inverseScreenCTM_};
	Blockly.WorkspaceSvg.prototype.updateInverseScreenCTM=function(){this.inverseScreenCTMDirty_=!0};Blockly.WorkspaceSvg.prototype.isVisible=function(){return this.isVisible_};
	Blockly.WorkspaceSvg.prototype.getSvgXY=function(a){var b=0,c=0,d=1;if(Blockly.utils.dom.containsNode(this.getCanvas(),a)||Blockly.utils.dom.containsNode(this.getBubbleCanvas(),a))d=this.scale;do{var e=Blockly.utils.getRelativeXY(a);if(a==this.getCanvas()||a==this.getBubbleCanvas())d=1;b+=e.x*d;c+=e.y*d;a=a.parentNode}while(a&&a!=this.getParentSvg());return new Blockly.utils.Coordinate(b,c)};Blockly.WorkspaceSvg.prototype.getOriginOffsetInPixels=function(){return Blockly.utils.getInjectionDivXY_(this.getCanvas())};
	Blockly.WorkspaceSvg.prototype.getInjectionDiv=function(){if(!this.injectionDiv_)for(var a=this.svgGroup_;a;){if(-1!=(" "+(a.getAttribute("class")||"")+" ").indexOf(" injectionDiv ")){this.injectionDiv_=a;break}a=a.parentNode}return this.injectionDiv_};Blockly.WorkspaceSvg.prototype.getBlockCanvas=function(){return this.svgBlockCanvas_};Blockly.WorkspaceSvg.prototype.setResizeHandlerWrapper=function(a){this.resizeHandlerWrapper_=a};
	Blockly.WorkspaceSvg.prototype.createDom=function(a){this.svgGroup_=Blockly.utils.dom.createSvgElement("g",{"class":"blocklyWorkspace"},null);a&&(this.svgBackground_=Blockly.utils.dom.createSvgElement("rect",{height:"100%",width:"100%","class":a},this.svgGroup_),"blocklyMainBackground"==a&&this.grid_?this.svgBackground_.style.fill="url(#"+this.grid_.getPatternId()+")":this.themeManager_.subscribe(this.svgBackground_,"workspaceBackgroundColour","fill"));this.svgBlockCanvas_=Blockly.utils.dom.createSvgElement("g",
	{"class":"blocklyBlockCanvas"},this.svgGroup_);this.svgBubbleCanvas_=Blockly.utils.dom.createSvgElement("g",{"class":"blocklyBubbleCanvas"},this.svgGroup_);this.isFlyout||(Blockly.bindEventWithChecks_(this.svgGroup_,"mousedown",this,this.onMouseDown_,!1,!0),Blockly.bindEventWithChecks_(this.svgGroup_,"wheel",this,this.onMouseWheel_));if(this.options.hasCategories){if(!Blockly.Toolbox)throw Error("Missing require for Blockly.Toolbox");this.toolbox_=new (Blockly.registry.getClassFromOptions(Blockly.registry.Type.TOOLBOX,
	this.options))(this)}this.grid_&&this.grid_.update(this.scale);this.recordDeleteAreas();this.markerManager_.setCursor(new Blockly.Cursor);this.markerManager_.registerMarker(Blockly.navigation.MARKER_NAME,new Blockly.Marker);this.renderer_.createDom(this.svgGroup_,this.getTheme());return this.svgGroup_};
	Blockly.WorkspaceSvg.prototype.dispose=function(){this.rendered=!1;this.currentGesture_&&this.currentGesture_.cancel();this.svgGroup_&&(Blockly.utils.dom.removeNode(this.svgGroup_),this.svgGroup_=null);this.svgBubbleCanvas_=this.svgBlockCanvas_=null;this.toolbox_&&(this.toolbox_.dispose(),this.toolbox_=null);this.flyout_&&(this.flyout_.dispose(),this.flyout_=null);this.trashcan&&(this.trashcan.dispose(),this.trashcan=null);this.scrollbar&&(this.scrollbar.dispose(),this.scrollbar=null);this.zoomControls_&&
	(this.zoomControls_.dispose(),this.zoomControls_=null);this.audioManager_&&(this.audioManager_.dispose(),this.audioManager_=null);this.grid_&&(this.grid_.dispose(),this.grid_=null);this.renderer_.dispose();this.markerManager_&&(this.markerManager_.dispose(),this.markerManager_=null);Blockly.WorkspaceSvg.superClass_.dispose.call(this);this.themeManager_&&(this.themeManager_.unsubscribeWorkspace(this),this.themeManager_.unsubscribe(this.svgBackground_),this.options.parentWorkspace||(this.themeManager_.dispose(),
	this.themeManager_=null));this.flyoutButtonCallbacks_=this.toolboxCategoryCallbacks_=this.connectionDBList=null;if(!this.options.parentWorkspace){var a=this.getParentSvg().parentNode;a&&Blockly.utils.dom.removeNode(a)}this.resizeHandlerWrapper_&&(Blockly.unbindEvent_(this.resizeHandlerWrapper_),this.resizeHandlerWrapper_=null)};Blockly.WorkspaceSvg.prototype.newBlock=function(a,b){return new Blockly.BlockSvg(this,a,b)};
	Blockly.WorkspaceSvg.prototype.addTrashcan=function(){if(!Blockly.Trashcan)throw Error("Missing require for Blockly.Trashcan");this.trashcan=new Blockly.Trashcan(this);var a=this.trashcan.createDom();this.svgGroup_.insertBefore(a,this.svgBlockCanvas_)};Blockly.WorkspaceSvg.prototype.addZoomControls=function(){if(!Blockly.ZoomControls)throw Error("Missing require for Blockly.ZoomControls");this.zoomControls_=new Blockly.ZoomControls(this);var a=this.zoomControls_.createDom();this.svgGroup_.appendChild(a)};
	Blockly.WorkspaceSvg.prototype.addFlyout=function(a){var b=new Blockly.Options({parentWorkspace:this,rtl:this.RTL,oneBasedIndex:this.options.oneBasedIndex,horizontalLayout:this.horizontalLayout,renderer:this.options.renderer,rendererOverrides:this.options.rendererOverrides});b.toolboxPosition=this.options.toolboxPosition;if(this.horizontalLayout){if(!Blockly.HorizontalFlyout)throw Error("Missing require for Blockly.HorizontalFlyout");this.flyout_=new Blockly.HorizontalFlyout(b)}else{if(!Blockly.VerticalFlyout)throw Error("Missing require for Blockly.VerticalFlyout");
	this.flyout_=new Blockly.VerticalFlyout(b)}this.flyout_.autoClose=!1;this.flyout_.getWorkspace().setVisible(!0);return this.flyout_.createDom(a)};Blockly.WorkspaceSvg.prototype.getFlyout=function(a){return this.flyout_||a?this.flyout_:this.toolbox_?this.toolbox_.getFlyout():null};Blockly.WorkspaceSvg.prototype.getToolbox=function(){return this.toolbox_};Blockly.WorkspaceSvg.prototype.updateScreenCalculations_=function(){this.updateInverseScreenCTM();this.recordDeleteAreas()};
	Blockly.WorkspaceSvg.prototype.resizeContents=function(){this.resizesEnabled_&&this.rendered&&(this.scrollbar&&this.scrollbar.resize(),this.updateInverseScreenCTM())};Blockly.WorkspaceSvg.prototype.resize=function(){this.toolbox_&&this.toolbox_.position();this.flyout_&&this.flyout_.position();this.trashcan&&this.trashcan.position();this.zoomControls_&&this.zoomControls_.position();this.scrollbar&&this.scrollbar.resize();this.updateScreenCalculations_()};
	Blockly.WorkspaceSvg.prototype.updateScreenCalculationsIfScrolled=function(){var a=Blockly.utils.getDocumentScroll();Blockly.utils.Coordinate.equals(this.lastRecordedPageScroll_,a)||(this.lastRecordedPageScroll_=a,this.updateScreenCalculations_())};Blockly.WorkspaceSvg.prototype.getCanvas=function(){return this.svgBlockCanvas_};Blockly.WorkspaceSvg.prototype.getBubbleCanvas=function(){return this.svgBubbleCanvas_};
	Blockly.WorkspaceSvg.prototype.getParentSvg=function(){if(!this.cachedParentSvg_)for(var a=this.svgGroup_;a;){if("svg"==a.tagName){this.cachedParentSvg_=a;break}a=a.parentNode}return this.cachedParentSvg_};
	Blockly.WorkspaceSvg.prototype.translate=function(a,b){if(this.useWorkspaceDragSurface_&&this.isDragSurfaceActive_)this.workspaceDragSurface_.translateSurface(a,b);else{var c="translate("+a+","+b+") scale("+this.scale+")";this.svgBlockCanvas_.setAttribute("transform",c);this.svgBubbleCanvas_.setAttribute("transform",c)}this.blockDragSurface_&&this.blockDragSurface_.translateAndScaleGroup(a,b,this.scale);this.grid_&&this.grid_.moveTo(a,b)};
	Blockly.WorkspaceSvg.prototype.resetDragSurface=function(){if(this.useWorkspaceDragSurface_){this.isDragSurfaceActive_=!1;var a=this.workspaceDragSurface_.getSurfaceTranslation();this.workspaceDragSurface_.clearAndHide(this.svgGroup_);a="translate("+a.x+","+a.y+") scale("+this.scale+")";this.svgBlockCanvas_.setAttribute("transform",a);this.svgBubbleCanvas_.setAttribute("transform",a)}};
	Blockly.WorkspaceSvg.prototype.setupDragSurface=function(){if(this.useWorkspaceDragSurface_&&!this.isDragSurfaceActive_){this.isDragSurfaceActive_=!0;var a=this.svgBlockCanvas_.previousSibling,b=parseInt(this.getParentSvg().getAttribute("width"),10),c=parseInt(this.getParentSvg().getAttribute("height"),10),d=Blockly.utils.getRelativeXY(this.getCanvas());this.workspaceDragSurface_.setContentsAndShow(this.getCanvas(),this.getBubbleCanvas(),a,b,c,this.scale);this.workspaceDragSurface_.translateSurface(d.x,
	d.y)}};Blockly.WorkspaceSvg.prototype.getBlockDragSurface=function(){return this.blockDragSurface_};Blockly.WorkspaceSvg.prototype.getWidth=function(){var a=this.getMetrics();return a?a.viewWidth/this.scale:0};
	Blockly.WorkspaceSvg.prototype.setVisible=function(a){this.isVisible_=a;if(this.svgGroup_)if(this.scrollbar&&this.scrollbar.setContainerVisible(a),this.getFlyout()&&this.getFlyout().setContainerVisible(a),this.getParentSvg().style.display=a?"block":"none",this.toolbox_&&this.toolbox_.setVisible(a),a){a=this.getAllBlocks(!1);for(var b=a.length-1;0<=b;b--)a[b].markDirty();this.render();this.toolbox_&&this.toolbox_.position()}else Blockly.hideChaff(!0)};
	Blockly.WorkspaceSvg.prototype.render=function(){for(var a=this.getAllBlocks(!1),b=a.length-1;0<=b;b--)a[b].render(!1);if(this.currentGesture_)for(a=this.currentGesture_.getInsertionMarkers(),b=0;b<a.length;b++)a[b].render(!1);this.markerManager_.updateMarkers()};Blockly.WorkspaceSvg.prototype.traceOn=function(){console.warn("Deprecated call to traceOn, delete this.")};
	Blockly.WorkspaceSvg.prototype.highlightBlock=function(a,b){if(void 0===b){for(var c=0,d;d=this.highlightedBlocks_[c];c++)d.setHighlighted(!1);this.highlightedBlocks_.length=0}if(d=a?this.getBlockById(a):null)(a=void 0===b||b)?-1==this.highlightedBlocks_.indexOf(d)&&this.highlightedBlocks_.push(d):Blockly.utils.arrayRemove(this.highlightedBlocks_,d),d.setHighlighted(a)};
	Blockly.WorkspaceSvg.prototype.paste=function(a){!this.rendered||a.getElementsByTagName("block").length>=this.remainingCapacity()||(this.currentGesture_&&this.currentGesture_.cancel(),"comment"==a.tagName.toLowerCase()?this.pasteWorkspaceComment_(a):this.pasteBlock_(a))};
	Blockly.WorkspaceSvg.prototype.pasteBlock_=function(a){Blockly.Events.disable();try{var b=Blockly.Xml.domToBlock(a,this),c=this.getMarker(Blockly.navigation.MARKER_NAME).getCurNode();if(this.keyboardAccessibilityMode&&c&&c.isConnection()){var d=c.getLocation();Blockly.navigation.insertBlock(b,d);return}var e=parseInt(a.getAttribute("x"),10),f=parseInt(a.getAttribute("y"),10);if(!isNaN(e)&&!isNaN(f)){this.RTL&&(e=-e);do{a=!1;var g=this.getAllBlocks(!1);c=0;for(var h;h=g[c];c++){var k=h.getRelativeToSurfaceXY();
	if(1>=Math.abs(e-k.x)&&1>=Math.abs(f-k.y)){a=!0;break}}if(!a){var l=b.getConnections_(!1);c=0;for(var m;m=l[c];c++)if(m.closest(Blockly.SNAP_RADIUS,new Blockly.utils.Coordinate(e,f)).connection){a=!0;break}}a&&(e=this.RTL?e-Blockly.SNAP_RADIUS:e+Blockly.SNAP_RADIUS,f+=2*Blockly.SNAP_RADIUS)}while(a);b.moveBy(e,f)}}finally{Blockly.Events.enable()}Blockly.Events.isEnabled()&&!b.isShadow()&&Blockly.Events.fire(new Blockly.Events.BlockCreate(b));b.select()};
	Blockly.WorkspaceSvg.prototype.pasteWorkspaceComment_=function(a){Blockly.Events.disable();try{var b=Blockly.WorkspaceCommentSvg.fromXml(a,this),c=parseInt(a.getAttribute("x"),10),d=parseInt(a.getAttribute("y"),10);isNaN(c)||isNaN(d)||(this.RTL&&(c=-c),b.moveBy(c+50,d+50))}finally{Blockly.Events.enable()}Blockly.Events.isEnabled();b.select()};
	Blockly.WorkspaceSvg.prototype.refreshToolboxSelection=function(){var a=this.isFlyout?this.targetWorkspace:this;a&&!a.currentGesture_&&a.toolbox_&&a.toolbox_.getFlyout()&&a.toolbox_.refreshSelection()};Blockly.WorkspaceSvg.prototype.renameVariableById=function(a,b){Blockly.WorkspaceSvg.superClass_.renameVariableById.call(this,a,b);this.refreshToolboxSelection()};Blockly.WorkspaceSvg.prototype.deleteVariableById=function(a){Blockly.WorkspaceSvg.superClass_.deleteVariableById.call(this,a);this.refreshToolboxSelection()};
	Blockly.WorkspaceSvg.prototype.createVariable=function(a,b,c){a=Blockly.WorkspaceSvg.superClass_.createVariable.call(this,a,b,c);this.refreshToolboxSelection();return a};Blockly.WorkspaceSvg.prototype.recordDeleteAreas=function(){this.deleteAreaTrash_=this.trashcan&&this.svgGroup_.parentNode?this.trashcan.getClientRect():null;this.deleteAreaToolbox_=this.flyout_?this.flyout_.getClientRect():this.toolbox_&&"function"==typeof this.toolbox_.getClientRect?this.toolbox_.getClientRect():null};
	Blockly.WorkspaceSvg.prototype.isDeleteArea=function(a){return this.deleteAreaTrash_&&this.deleteAreaTrash_.contains(a.clientX,a.clientY)?Blockly.DELETE_AREA_TRASH:this.deleteAreaToolbox_&&this.deleteAreaToolbox_.contains(a.clientX,a.clientY)?Blockly.DELETE_AREA_TOOLBOX:Blockly.DELETE_AREA_NONE};Blockly.WorkspaceSvg.prototype.onMouseDown_=function(a){var b=this.getGesture(a);b&&b.handleWsStart(a,this)};
	Blockly.WorkspaceSvg.prototype.startDrag=function(a,b){a=Blockly.utils.mouseToSvg(a,this.getParentSvg(),this.getInverseScreenCTM());a.x/=this.scale;a.y/=this.scale;this.dragDeltaXY_=Blockly.utils.Coordinate.difference(b,a)};Blockly.WorkspaceSvg.prototype.moveDrag=function(a){a=Blockly.utils.mouseToSvg(a,this.getParentSvg(),this.getInverseScreenCTM());a.x/=this.scale;a.y/=this.scale;return Blockly.utils.Coordinate.sum(this.dragDeltaXY_,a)};
	Blockly.WorkspaceSvg.prototype.isDragging=function(){return null!=this.currentGesture_&&this.currentGesture_.isDragging()};Blockly.WorkspaceSvg.prototype.isDraggable=function(){return this.options.moveOptions&&this.options.moveOptions.drag};
	Blockly.WorkspaceSvg.prototype.isContentBounded=function(){return this.options.moveOptions&&this.options.moveOptions.scrollbars||this.options.moveOptions&&this.options.moveOptions.wheel||this.options.moveOptions&&this.options.moveOptions.drag||this.options.zoomOptions&&this.options.zoomOptions.controls||this.options.zoomOptions&&this.options.zoomOptions.wheel||this.options.zoomOptions&&this.options.zoomOptions.pinch};
	Blockly.WorkspaceSvg.prototype.isMovable=function(){return this.options.moveOptions&&this.options.moveOptions.scrollbars||this.options.moveOptions&&this.options.moveOptions.wheel||this.options.moveOptions&&this.options.moveOptions.drag||this.options.zoomOptions&&this.options.zoomOptions.wheel||this.options.zoomOptions&&this.options.zoomOptions.pinch};
	Blockly.WorkspaceSvg.prototype.onMouseWheel_=function(a){if(Blockly.Gesture.inProgress())a.preventDefault(),a.stopPropagation();else{var b=this.options.zoomOptions&&this.options.zoomOptions.wheel,c=this.options.moveOptions&&this.options.moveOptions.wheel;if(b||c){var d=Blockly.utils.getScrollDeltaPixels(a);!b||!a.ctrlKey&&c?(b=this.scrollX-d.x,c=this.scrollY-d.y,a.shiftKey&&!d.x&&(b=this.scrollX-d.y,c=this.scrollY),this.scroll(b,c)):(d=-d.y/50,b=Blockly.utils.mouseToSvg(a,this.getParentSvg(),this.getInverseScreenCTM()),
	this.zoom(b.x,b.y,d));a.preventDefault()}}};Blockly.WorkspaceSvg.prototype.getBlocksBoundingBox=function(){var a=this.getTopBoundedElements();if(!a.length)return new Blockly.utils.Rect(0,0,0,0);for(var b=a[0].getBoundingRectangle(),c=1;c<a.length;c++){var d=a[c].getBoundingRectangle();d.top<b.top&&(b.top=d.top);d.bottom>b.bottom&&(b.bottom=d.bottom);d.left<b.left&&(b.left=d.left);d.right>b.right&&(b.right=d.right)}return b};
	Blockly.WorkspaceSvg.prototype.cleanUp=function(){this.setResizesEnabled(!1);Blockly.Events.setGroup(!0);for(var a=this.getTopBlocks(!0),b=0,c=0,d;d=a[c];c++)if(d.isMovable()){var e=d.getRelativeToSurfaceXY();d.moveBy(-e.x,b-e.y);d.snapToGrid();b=d.getRelativeToSurfaceXY().y+d.getHeightWidth().height+this.renderer_.getConstants().MIN_BLOCK_HEIGHT}Blockly.Events.setGroup(!1);this.setResizesEnabled(!0)};
	Blockly.WorkspaceSvg.prototype.showContextMenu=function(a){function b(a){if(a.isDeletable())p=p.concat(a.getDescendants(!1));else{a=a.getChildren(!1);for(var c=0;c<a.length;c++)b(a[c])}}function c(){Blockly.Events.setGroup(f);var a=p.shift();a&&(a.workspace?(a.dispose(!1,!0),setTimeout(c,10)):c());Blockly.Events.setGroup(!1)}if(!this.options.readOnly&&!this.isFlyout){var d=[],e=this.getTopBlocks(!0),f=Blockly.utils.genUid(),g=this,h={};h.text=Blockly.Msg.UNDO;h.enabled=0<this.undoStack_.length;h.callback=
	this.undo.bind(this,!1);d.push(h);h={};h.text=Blockly.Msg.REDO;h.enabled=0<this.redoStack_.length;h.callback=this.undo.bind(this,!0);d.push(h);this.isMovable()&&(h={},h.text=Blockly.Msg.CLEAN_UP,h.enabled=1<e.length,h.callback=this.cleanUp.bind(this),d.push(h));if(this.options.collapse){for(var k=h=!1,l=0;l<e.length;l++)for(var m=e[l];m;)m.isCollapsed()?h=!0:k=!0,m=m.getNextBlock();var n=function(a){for(var b=0,c=0;c<e.length;c++)for(var d=e[c];d;)setTimeout(d.setCollapsed.bind(d,a),b),d=d.getNextBlock(),
	b+=10};k={enabled:k};k.text=Blockly.Msg.COLLAPSE_ALL;k.callback=function(){n(!0)};d.push(k);h={enabled:h};h.text=Blockly.Msg.EXPAND_ALL;h.callback=function(){n(!1)};d.push(h)}var p=[];for(l=0;l<e.length;l++)b(e[l]);h={text:1==p.length?Blockly.Msg.DELETE_BLOCK:Blockly.Msg.DELETE_X_BLOCKS.replace("%1",String(p.length)),enabled:0<p.length,callback:function(){g.currentGesture_&&g.currentGesture_.cancel();2>p.length?c():Blockly.confirm(Blockly.Msg.DELETE_ALL_BLOCKS.replace("%1",p.length),function(a){a&&
	c()})}};d.push(h);this.configureContextMenu&&this.configureContextMenu(d,a);Blockly.ContextMenu.show(a,d,this.RTL)}};
	Blockly.WorkspaceSvg.prototype.updateToolbox=function(a){Array.isArray(a)||(a=Blockly.Options.parseToolboxTree(a));if(a=Blockly.utils.toolbox.convertToolboxToJSON(a)){if(!this.options.languageTree)throw Error("Existing toolbox is null.  Can't create new toolbox.");if(Blockly.utils.toolbox.hasCategories(a)){if(!this.toolbox_)throw Error("Existing toolbox has no categories.  Can't change mode.");this.options.languageTree=a;this.toolbox_.render(a)}else{if(!this.flyout_)throw Error("Existing toolbox has categories.  Can't change mode.");
	this.options.languageTree=a;this.flyout_.show(a)}}else if(this.options.languageTree)throw Error("Can't nullify an existing toolbox.");};Blockly.WorkspaceSvg.prototype.markFocused=function(){this.options.parentWorkspace?this.options.parentWorkspace.markFocused():(Blockly.mainWorkspace=this,this.setBrowserFocus())};Blockly.WorkspaceSvg.prototype.setBrowserFocus=function(){document.activeElement&&document.activeElement.blur();try{this.getParentSvg().focus({preventScroll:!0})}catch(a){try{this.getParentSvg().parentNode.setActive()}catch(b){this.getParentSvg().parentNode.focus({preventScroll:!0})}}};
	Blockly.WorkspaceSvg.prototype.zoom=function(a,b,c){c=Math.pow(this.options.zoomOptions.scaleSpeed,c);var d=this.scale*c;if(this.scale!=d){d>this.options.zoomOptions.maxScale?c=this.options.zoomOptions.maxScale/this.scale:d<this.options.zoomOptions.minScale&&(c=this.options.zoomOptions.minScale/this.scale);var e=this.getCanvas().getCTM(),f=this.getParentSvg().createSVGPoint();f.x=a;f.y=b;f=f.matrixTransform(e.inverse());a=f.x;b=f.y;e=e.translate(a*(1-c),b*(1-c)).scale(c);this.scrollX=e.e;this.scrollY=
	e.f;this.setScale(d)}};Blockly.WorkspaceSvg.prototype.zoomCenter=function(a){var b=this.getMetrics();if(this.flyout_){var c=b.svgWidth?b.svgWidth/2:0;b=b.svgHeight?b.svgHeight/2:0}else c=b.viewWidth/2+b.absoluteLeft,b=b.viewHeight/2+b.absoluteTop;this.zoom(c,b,a)};
	Blockly.WorkspaceSvg.prototype.zoomToFit=function(){if(this.isMovable()){var a=this.getMetrics(),b=a.viewWidth;a=a.viewHeight;var c=this.getBlocksBoundingBox(),d=c.right-c.left;c=c.bottom-c.top;d&&(this.flyout_&&(this.horizontalLayout?(a+=this.flyout_.getHeight(),c+=this.flyout_.getHeight()/this.scale):(b+=this.flyout_.getWidth(),d+=this.flyout_.getWidth()/this.scale)),this.setScale(Math.min(b/d,a/c)),this.scrollCenter())}else console.warn("Tried to move a non-movable workspace. This could result in blocks becoming inaccessible.")};
	Blockly.WorkspaceSvg.prototype.beginCanvasTransition=function(){Blockly.utils.dom.addClass(this.svgBlockCanvas_,"blocklyCanvasTransitioning");Blockly.utils.dom.addClass(this.svgBubbleCanvas_,"blocklyCanvasTransitioning")};Blockly.WorkspaceSvg.prototype.endCanvasTransition=function(){Blockly.utils.dom.removeClass(this.svgBlockCanvas_,"blocklyCanvasTransitioning");Blockly.utils.dom.removeClass(this.svgBubbleCanvas_,"blocklyCanvasTransitioning")};
	Blockly.WorkspaceSvg.prototype.scrollCenter=function(){if(this.isMovable()){var a=this.getMetrics(),b=(a.contentWidth-a.viewWidth)/2,c=(a.contentHeight-a.viewHeight)/2;b=-b-a.contentLeft;c=-c-a.contentTop;this.scroll(b,c)}else console.warn("Tried to move a non-movable workspace. This could result in blocks becoming inaccessible.")};
	Blockly.WorkspaceSvg.prototype.centerOnBlock=function(a){if(this.isMovable()){if(a=a?this.getBlockById(a):null){var b=a.getRelativeToSurfaceXY(),c=a.getHeightWidth(),d=this.scale;a=(b.x+(this.RTL?-1:1)*c.width/2)*d;b=(b.y+c.height/2)*d;c=this.getMetrics();this.scroll(-(a-c.viewWidth/2),-(b-c.viewHeight/2))}}else console.warn("Tried to move a non-movable workspace. This could result in blocks becoming inaccessible.")};
	Blockly.WorkspaceSvg.prototype.setScale=function(a){this.options.zoomOptions.maxScale&&a>this.options.zoomOptions.maxScale?a=this.options.zoomOptions.maxScale:this.options.zoomOptions.minScale&&a<this.options.zoomOptions.minScale&&(a=this.options.zoomOptions.minScale);this.scale=a;Blockly.hideChaff(!1);this.flyout_&&(this.flyout_.reflow(),this.recordDeleteAreas());this.grid_&&this.grid_.update(this.scale);a=this.getMetrics();this.scrollX-=a.absoluteLeft;this.scrollY-=a.absoluteTop;a.viewLeft+=a.absoluteLeft;
	a.viewTop+=a.absoluteTop;this.scroll(this.scrollX,this.scrollY);this.scrollbar&&(this.flyout_?(this.scrollbar.hScroll.resizeViewHorizontal(a),this.scrollbar.vScroll.resizeViewVertical(a)):(this.scrollbar.hScroll.resizeContentHorizontal(a),this.scrollbar.vScroll.resizeContentVertical(a)))};Blockly.WorkspaceSvg.prototype.getScale=function(){return this.options.parentWorkspace?this.options.parentWorkspace.getScale():this.scale};
	Blockly.WorkspaceSvg.prototype.scroll=function(a,b){Blockly.hideChaff(!0);var c=this.getMetrics(),d=c.contentWidth+c.contentLeft-c.viewWidth,e=c.contentHeight+c.contentTop-c.viewHeight;a=Math.min(a,-c.contentLeft);b=Math.min(b,-c.contentTop);a=Math.max(a,-d);b=Math.max(b,-e);this.scrollX=a;this.scrollY=b;this.scrollbar&&(this.scrollbar.hScroll.setHandlePosition(-(a+c.contentLeft)*this.scrollbar.hScroll.ratio),this.scrollbar.vScroll.setHandlePosition(-(b+c.contentTop)*this.scrollbar.vScroll.ratio));
	a+=c.absoluteLeft;b+=c.absoluteTop;this.translate(a,b)};Blockly.WorkspaceSvg.getDimensionsPx_=function(a){var b=0,c=0;a&&(b=a.getWidth(),c=a.getHeight());return new Blockly.utils.Size(b,c)};Blockly.WorkspaceSvg.getContentDimensions_=function(a,b){return a.isContentBounded()?Blockly.WorkspaceSvg.getContentDimensionsBounded_(a,b):Blockly.WorkspaceSvg.getContentDimensionsExact_(a)};
	Blockly.WorkspaceSvg.getContentDimensionsExact_=function(a){var b=a.getBlocksBoundingBox(),c=a.scale;a=b.top*c;var d=b.bottom*c,e=b.left*c;b=b.right*c;return{top:a,bottom:d,left:e,right:b,width:b-e,height:d-a}};
	Blockly.WorkspaceSvg.getContentDimensionsBounded_=function(a,b){a=Blockly.WorkspaceSvg.getContentDimensionsExact_(a);var c=b.width;b=b.height;var d=c/2,e=b/2,f=Math.min(a.left-d,a.right-c),g=Math.min(a.top-e,a.bottom-b);return{left:f,top:g,height:Math.max(a.bottom+e,a.top+b)-g,width:Math.max(a.right+d,a.left+c)-f}};
	Blockly.WorkspaceSvg.getTopLevelWorkspaceMetrics_=function(){var a=Blockly.WorkspaceSvg.getDimensionsPx_(this.toolbox_),b=Blockly.WorkspaceSvg.getDimensionsPx_(this.flyout_),c=Blockly.svgSize(this.getParentSvg()),d={height:c.height,width:c.width};if(this.toolbox_)if(this.toolboxPosition==Blockly.TOOLBOX_AT_TOP||this.toolboxPosition==Blockly.TOOLBOX_AT_BOTTOM)d.height-=a.height;else{if(this.toolboxPosition==Blockly.TOOLBOX_AT_LEFT||this.toolboxPosition==Blockly.TOOLBOX_AT_RIGHT)d.width-=a.width}else if(this.flyout_)if(this.toolboxPosition==
	Blockly.TOOLBOX_AT_TOP||this.toolboxPosition==Blockly.TOOLBOX_AT_BOTTOM)d.height-=b.height;else if(this.toolboxPosition==Blockly.TOOLBOX_AT_LEFT||this.toolboxPosition==Blockly.TOOLBOX_AT_RIGHT)d.width-=b.width;var e=Blockly.WorkspaceSvg.getContentDimensions_(this,d),f=0;this.toolbox_&&this.toolboxPosition==Blockly.TOOLBOX_AT_LEFT?f=a.width:this.flyout_&&this.toolboxPosition==Blockly.TOOLBOX_AT_LEFT&&(f=b.width);var g=0;this.toolbox_&&this.toolboxPosition==Blockly.TOOLBOX_AT_TOP?g=a.height:this.flyout_&&
	this.toolboxPosition==Blockly.TOOLBOX_AT_TOP&&(g=b.height);return{contentHeight:e.height,contentWidth:e.width,contentTop:e.top,contentLeft:e.left,viewHeight:d.height,viewWidth:d.width,viewTop:-this.scrollY,viewLeft:-this.scrollX,absoluteTop:g,absoluteLeft:f,svgHeight:c.height,svgWidth:c.width,toolboxWidth:a.width,toolboxHeight:a.height,toolboxPosition:this.toolboxPosition,flyoutWidth:b.width,flyoutHeight:b.height}};
	Blockly.WorkspaceSvg.setTopLevelWorkspaceMetrics_=function(a){var b=this.getMetrics();"number"==typeof a.x&&(this.scrollX=-b.contentWidth*a.x-b.contentLeft);"number"==typeof a.y&&(this.scrollY=-b.contentHeight*a.y-b.contentTop);this.translate(this.scrollX+b.absoluteLeft,this.scrollY+b.absoluteTop)};Blockly.WorkspaceSvg.prototype.getBlockById=function(a){return Blockly.WorkspaceSvg.superClass_.getBlockById.call(this,a)};
	Blockly.WorkspaceSvg.prototype.getTopBlocks=function(a){return Blockly.WorkspaceSvg.superClass_.getTopBlocks.call(this,a)};Blockly.WorkspaceSvg.prototype.addTopBlock=function(a){this.addTopBoundedElement(a);Blockly.WorkspaceSvg.superClass_.addTopBlock.call(this,a)};Blockly.WorkspaceSvg.prototype.removeTopBlock=function(a){this.removeTopBoundedElement(a);Blockly.WorkspaceSvg.superClass_.removeTopBlock.call(this,a)};
	Blockly.WorkspaceSvg.prototype.addTopComment=function(a){this.addTopBoundedElement(a);Blockly.WorkspaceSvg.superClass_.addTopComment.call(this,a)};Blockly.WorkspaceSvg.prototype.removeTopComment=function(a){this.removeTopBoundedElement(a);Blockly.WorkspaceSvg.superClass_.removeTopComment.call(this,a)};Blockly.WorkspaceSvg.prototype.addTopBoundedElement=function(a){this.topBoundedElements_.push(a)};
	Blockly.WorkspaceSvg.prototype.removeTopBoundedElement=function(a){Blockly.utils.arrayRemove(this.topBoundedElements_,a)};Blockly.WorkspaceSvg.prototype.getTopBoundedElements=function(){return[].concat(this.topBoundedElements_)};Blockly.WorkspaceSvg.prototype.setResizesEnabled=function(a){var b=!this.resizesEnabled_&&a;this.resizesEnabled_=a;b&&this.resizeContents()};
	Blockly.WorkspaceSvg.prototype.clear=function(){this.setResizesEnabled(!1);Blockly.WorkspaceSvg.superClass_.clear.call(this);this.topBoundedElements_=[];this.setResizesEnabled(!0)};Blockly.WorkspaceSvg.prototype.registerButtonCallback=function(a,b){if("function"!=typeof b)throw TypeError("Button callbacks must be functions.");this.flyoutButtonCallbacks_[a]=b};Blockly.WorkspaceSvg.prototype.getButtonCallback=function(a){return(a=this.flyoutButtonCallbacks_[a])?a:null};
	Blockly.WorkspaceSvg.prototype.removeButtonCallback=function(a){this.flyoutButtonCallbacks_[a]=null};Blockly.WorkspaceSvg.prototype.registerToolboxCategoryCallback=function(a,b){if("function"!=typeof b)throw TypeError("Toolbox category callbacks must be functions.");this.toolboxCategoryCallbacks_[a]=b};Blockly.WorkspaceSvg.prototype.getToolboxCategoryCallback=function(a){return this.toolboxCategoryCallbacks_[a]||null};
	Blockly.WorkspaceSvg.prototype.removeToolboxCategoryCallback=function(a){this.toolboxCategoryCallbacks_[a]=null};Blockly.WorkspaceSvg.prototype.getGesture=function(a){var b="mousedown"==a.type||"touchstart"==a.type||"pointerdown"==a.type,c=this.currentGesture_;return c?b&&c.hasStarted()?(console.warn("Tried to start the same gesture twice."),c.cancel(),null):c:b?this.currentGesture_=new Blockly.TouchGesture(a,this):null};
	Blockly.WorkspaceSvg.prototype.clearGesture=function(){this.currentGesture_=null};Blockly.WorkspaceSvg.prototype.cancelCurrentGesture=function(){this.currentGesture_&&this.currentGesture_.cancel()};Blockly.WorkspaceSvg.prototype.getAudioManager=function(){return this.audioManager_};Blockly.WorkspaceSvg.prototype.getGrid=function(){return this.grid_};Blockly.inject=function(a,b){Blockly.checkBlockColourConstants();"string"==typeof a&&(a=document.getElementById(a)||document.querySelector(a));if(!a||!Blockly.utils.dom.containsNode(document,a))throw Error("Error: container is not in current document.");b=new Blockly.Options(b||{});var c=document.createElement("div");c.className="injectionDiv";c.tabIndex=0;Blockly.utils.aria.setState(c,Blockly.utils.aria.State.LABEL,Blockly.Msg.WORKSPACE_ARIA_LABEL);a.appendChild(c);a=Blockly.createDom_(c,b);var d=
	new Blockly.BlockDragSurfaceSvg(c),e=new Blockly.WorkspaceDragSurfaceSvg(c),f=Blockly.createMainWorkspace_(a,b,d,e);Blockly.user.keyMap.setKeyMap(b.keyMap);Blockly.init_(f);Blockly.mainWorkspace=f;Blockly.svgResize(f);c.addEventListener("focusin",function(){Blockly.mainWorkspace=f});return f};
	Blockly.createDom_=function(a,b){a.setAttribute("dir","LTR");Blockly.Component.defaultRightToLeft=b.RTL;Blockly.Css.inject(b.hasCss,b.pathToMedia);a=Blockly.utils.dom.createSvgElement("svg",{xmlns:Blockly.utils.dom.SVG_NS,"xmlns:html":Blockly.utils.dom.HTML_NS,"xmlns:xlink":Blockly.utils.dom.XLINK_NS,version:"1.1","class":"blocklySvg",tabindex:"0"},a);var c=Blockly.utils.dom.createSvgElement("defs",{},a),d=String(Math.random()).substring(2);b.gridPattern=Blockly.Grid.createDom(d,b.gridOptions,c);
	return a};
	Blockly.createMainWorkspace_=function(a,b,c,d){b.parentWorkspace=null;var e=new Blockly.WorkspaceSvg(b,c,d);b=e.options;e.scale=b.zoomOptions.startScale;a.appendChild(e.createDom("blocklyMainBackground"));Blockly.utils.dom.addClass(e.getInjectionDiv(),e.getRenderer().getClassName());Blockly.utils.dom.addClass(e.getInjectionDiv(),e.getTheme().getClassName());!b.hasCategories&&b.languageTree&&(c=e.addFlyout("svg"),Blockly.utils.dom.insertAfter(c,a));b.hasTrashcan&&e.addTrashcan();b.zoomOptions&&b.zoomOptions.controls&&
	e.addZoomControls();e.getThemeManager().subscribe(a,"workspaceBackgroundColour","background-color");e.translate(0,0);b.readOnly||e.isMovable()||e.addChangeListener(function(a){if(!e.isDragging()&&!e.isMovable()&&-1!=Blockly.Events.BUMP_EVENTS.indexOf(a.type)){var b=Object.create(null),c=e.getMetrics(),d=e.scale;b.RTL=e.RTL;b.viewLeft=c.viewLeft/d;b.viewTop=c.viewTop/d;b.viewRight=(c.viewLeft+c.viewWidth)/d;b.viewBottom=(c.viewTop+c.viewHeight)/d;e.isContentBounded()?(c=e.getBlocksBoundingBox(),b.contentLeft=
	c.left,b.contentTop=c.top,b.contentRight=c.right,b.contentBottom=c.bottom):(b.contentLeft=c.contentLeft/d,b.contentTop=c.contentTop/d,b.contentRight=(c.contentLeft+c.contentWidth)/d,b.contentBottom=(c.contentTop+c.contentHeight)/d);if(b.contentTop<b.viewTop||b.contentBottom>b.viewBottom||b.contentLeft<b.viewLeft||b.contentRight>b.viewRight){c=null;a&&(c=Blockly.Events.getGroup(),Blockly.Events.setGroup(a.group));switch(a.type){case Blockly.Events.BLOCK_CREATE:case Blockly.Events.BLOCK_MOVE:var f=
	e.getBlockById(a.blockId);f&&(f=f.getRootBlock());break;case Blockly.Events.COMMENT_CREATE:case Blockly.Events.COMMENT_MOVE:f=e.getCommentById(a.commentId)}if(f){d=f.getBoundingRectangle();d.height=d.bottom-d.top;d.width=d.right-d.left;var m=b.viewTop,n=b.viewBottom-d.height;n=Math.max(m,n);m=Blockly.utils.math.clamp(m,d.top,n)-d.top;n=b.viewLeft;var p=b.viewRight-d.width;b.RTL?n=Math.min(p,n):p=Math.max(n,p);b=Blockly.utils.math.clamp(n,d.left,p)-d.left;f.moveBy(b,m)}a&&(!a.group&&f&&console.log("WARNING: Moved object in bounds but there was no event group. This may break undo."),
	null!==c&&Blockly.Events.setGroup(c))}}});Blockly.svgResize(e);Blockly.WidgetDiv.createDom();Blockly.DropDownDiv.createDom();Blockly.Tooltip.createDom();return e};
	Blockly.init_=function(a){var b=a.options,c=a.getParentSvg();Blockly.bindEventWithChecks_(c.parentNode,"contextmenu",null,function(a){Blockly.utils.isTargetInput(a)||a.preventDefault()});c=Blockly.bindEventWithChecks_(window,"resize",null,function(){Blockly.hideChaff(!0);Blockly.svgResize(a)});a.setResizeHandlerWrapper(c);Blockly.inject.bindDocumentEvents_();if(b.languageTree){c=a.getToolbox();var d=a.getFlyout(!0);c?c.init():d&&(d.init(a),d.show(b.languageTree),d.scrollToStart())}c=Blockly.Scrollbar.scrollbarThickness;
	b.hasTrashcan&&(c=a.trashcan.init(c));b.zoomOptions&&b.zoomOptions.controls&&a.zoomControls_.init(c);b.moveOptions&&b.moveOptions.scrollbars?(a.scrollbar=new Blockly.ScrollbarPair(a),a.scrollbar.resize()):a.setMetrics({x:.5,y:.5});b.hasSounds&&Blockly.inject.loadSounds_(b.pathToMedia,a)};
	Blockly.inject.bindDocumentEvents_=function(){Blockly.documentEventsBound_||(Blockly.bindEventWithChecks_(document,"scroll",null,function(){for(var a=Blockly.Workspace.getAll(),b=0,c;c=a[b];b++)c.updateInverseScreenCTM&&c.updateInverseScreenCTM()}),Blockly.bindEventWithChecks_(document,"keydown",null,Blockly.onKeyDown),Blockly.bindEvent_(document,"touchend",null,Blockly.longStop_),Blockly.bindEvent_(document,"touchcancel",null,Blockly.longStop_),Blockly.utils.userAgent.IPAD&&Blockly.bindEventWithChecks_(window,
	"orientationchange",document,function(){Blockly.svgResize(Blockly.getMainWorkspace())}));Blockly.documentEventsBound_=!0};
	Blockly.inject.loadSounds_=function(a,b){var c=b.getAudioManager();c.load([a+"click.mp3",a+"click.wav",a+"click.ogg"],"click");c.load([a+"disconnect.wav",a+"disconnect.mp3",a+"disconnect.ogg"],"disconnect");c.load([a+"delete.mp3",a+"delete.ogg",a+"delete.wav"],"delete");var d=[];a=function(){for(;d.length;)Blockly.unbindEvent_(d.pop());c.preload()};d.push(Blockly.bindEventWithChecks_(document,"mousemove",null,a,!0));d.push(Blockly.bindEventWithChecks_(document,"touchstart",null,a,!0))};Blockly.Names=function(a,b){this.variablePrefix_=b||"";this.reservedDict_=Object.create(null);if(a)for(a=a.split(","),b=0;b<a.length;b++)this.reservedDict_[a[b]]=!0;this.reset()};Blockly.Names.DEVELOPER_VARIABLE_TYPE="DEVELOPER_VARIABLE";Blockly.Names.prototype.reset=function(){this.db_=Object.create(null);this.dbReverse_=Object.create(null);this.variableMap_=null};Blockly.Names.prototype.setVariableMap=function(a){this.variableMap_=a};
	Blockly.Names.prototype.getNameForUserVariable_=function(a){return this.variableMap_?(a=this.variableMap_.getVariableById(a))?a.name:null:(console.log("Deprecated call to Blockly.Names.prototype.getName without defining a variable map. To fix, add the following code in your generator's init() function:\nBlockly.YourGeneratorName.variableDB_.setVariableMap(workspace.getVariableMap());"),null)};
	Blockly.Names.prototype.getName=function(a,b){if(b==Blockly.VARIABLE_CATEGORY_NAME){var c=this.getNameForUserVariable_(a);c&&(a=c)}c=a.toLowerCase()+"_"+b;var d=b==Blockly.VARIABLE_CATEGORY_NAME||b==Blockly.Names.DEVELOPER_VARIABLE_TYPE?this.variablePrefix_:"";if(c in this.db_)return d+this.db_[c];a=this.getDistinctName(a,b);this.db_[c]=a.substr(d.length);return a};
	Blockly.Names.prototype.getDistinctName=function(a,b){a=this.safeName_(a);for(var c="";this.dbReverse_[a+c]||a+c in this.reservedDict_;)c=c?c+1:2;a+=c;this.dbReverse_[a]=!0;return(b==Blockly.VARIABLE_CATEGORY_NAME||b==Blockly.Names.DEVELOPER_VARIABLE_TYPE?this.variablePrefix_:"")+a};Blockly.Names.prototype.safeName_=function(a){a?(a=encodeURI(a.replace(/ /g,"_")).replace(/[^\w]/g,"_"),-1!="0123456789".indexOf(a[0])&&(a="my_"+a)):a=Blockly.Msg.UNNAMED_KEY||"unnamed";return a};
	Blockly.Names.equals=function(a,b){return a.toLowerCase()==b.toLowerCase()};Blockly.Procedures={};Blockly.Procedures.NAME_TYPE=Blockly.PROCEDURE_CATEGORY_NAME;Blockly.Procedures.DEFAULT_ARG="x";Blockly.Procedures.allProcedures=function(a){var b=a.getBlocksByType("procedures_defnoreturn",!1).map(function(a){return a.getProcedureDef()});a=a.getBlocksByType("procedures_defreturn",!1).map(function(a){return a.getProcedureDef()});b.sort(Blockly.Procedures.procTupleComparator_);a.sort(Blockly.Procedures.procTupleComparator_);return[b,a]};
	Blockly.Procedures.procTupleComparator_=function(a,b){return a[0].toLowerCase().localeCompare(b[0].toLowerCase())};Blockly.Procedures.findLegalName=function(a,b){if(b.isInFlyout)return a;for(a=a||Blockly.Msg.UNNAMED_KEY||"unnamed";!Blockly.Procedures.isLegalName_(a,b.workspace,b);){var c=a.match(/^(.*?)(\d+)$/);a=c?c[1]+(parseInt(c[2],10)+1):a+"2"}return a};Blockly.Procedures.isLegalName_=function(a,b,c){return!Blockly.Procedures.isNameUsed(a,b,c)};
	Blockly.Procedures.isNameUsed=function(a,b,c){b=b.getAllBlocks(!1);for(var d=0;d<b.length;d++)if(b[d]!=c&&b[d].getProcedureDef){var e=b[d].getProcedureDef();if(Blockly.Names.equals(e[0],a))return!0}return!1};Blockly.Procedures.rename=function(a){a=a.trim();var b=Blockly.Procedures.findLegalName(a,this.getSourceBlock()),c=this.getValue();if(c!=a&&c!=b){a=this.getSourceBlock().workspace.getAllBlocks(!1);for(var d=0;d<a.length;d++)a[d].renameProcedure&&a[d].renameProcedure(c,b)}return b};
	Blockly.Procedures.flyoutCategory=function(a){function b(a,b){for(var d=0;d<a.length;d++){var e=a[d][0],f=a[d][1],g=Blockly.utils.xml.createElement("block");g.setAttribute("type",b);g.setAttribute("gap",16);var n=Blockly.utils.xml.createElement("mutation");n.setAttribute("name",e);g.appendChild(n);for(e=0;e<f.length;e++){var p=Blockly.utils.xml.createElement("arg");p.setAttribute("name",f[e]);n.appendChild(p)}c.push(g)}}var c=[];if(Blockly.Blocks.procedures_defnoreturn){var d=Blockly.utils.xml.createElement("block");
	d.setAttribute("type","procedures_defnoreturn");d.setAttribute("gap",16);var e=Blockly.utils.xml.createElement("field");e.setAttribute("name","NAME");e.appendChild(Blockly.utils.xml.createTextNode(Blockly.Msg.PROCEDURES_DEFNORETURN_PROCEDURE));d.appendChild(e);c.push(d)}Blockly.Blocks.procedures_defreturn&&(d=Blockly.utils.xml.createElement("block"),d.setAttribute("type","procedures_defreturn"),d.setAttribute("gap",16),e=Blockly.utils.xml.createElement("field"),e.setAttribute("name","NAME"),e.appendChild(Blockly.utils.xml.createTextNode(Blockly.Msg.PROCEDURES_DEFRETURN_PROCEDURE)),
	d.appendChild(e),c.push(d));Blockly.Blocks.procedures_ifreturn&&(d=Blockly.utils.xml.createElement("block"),d.setAttribute("type","procedures_ifreturn"),d.setAttribute("gap",16),c.push(d));c.length&&c[c.length-1].setAttribute("gap",24);a=Blockly.Procedures.allProcedures(a);b(a[0],"procedures_callnoreturn");b(a[1],"procedures_callreturn");return c};
	Blockly.Procedures.updateMutatorFlyout_=function(a){for(var b=[],c=a.getBlocksByType("procedures_mutatorarg",!1),d=0,e;e=c[d];d++)b.push(e.getFieldValue("NAME"));c=Blockly.utils.xml.createElement("xml");d=Blockly.utils.xml.createElement("block");d.setAttribute("type","procedures_mutatorarg");e=Blockly.utils.xml.createElement("field");e.setAttribute("name","NAME");b=Blockly.Variables.generateUniqueNameFromOptions(Blockly.Procedures.DEFAULT_ARG,b);b=Blockly.utils.xml.createTextNode(b);e.appendChild(b);
	d.appendChild(e);c.appendChild(d);a.updateToolbox(c)};Blockly.Procedures.mutatorOpenListener=function(a){if(a.type==Blockly.Events.UI&&"mutatorOpen"==a.element&&a.newValue){a=Blockly.Workspace.getById(a.workspaceId).getBlockById(a.blockId);var b=a.type;if("procedures_defnoreturn"==b||"procedures_defreturn"==b)a=a.mutator.getWorkspace(),Blockly.Procedures.updateMutatorFlyout_(a),a.addChangeListener(Blockly.Procedures.mutatorChangeListener_)}};
	Blockly.Procedures.mutatorChangeListener_=function(a){if(a.type==Blockly.Events.BLOCK_CREATE||a.type==Blockly.Events.BLOCK_DELETE||a.type==Blockly.Events.BLOCK_CHANGE)a=Blockly.Workspace.getById(a.workspaceId),Blockly.Procedures.updateMutatorFlyout_(a)};Blockly.Procedures.getCallers=function(a,b){var c=[];b=b.getAllBlocks(!1);for(var d=0;d<b.length;d++)if(b[d].getProcedureCall){var e=b[d].getProcedureCall();e&&Blockly.Names.equals(e,a)&&c.push(b[d])}return c};
	Blockly.Procedures.mutateCallers=function(a){var b=Blockly.Events.recordUndo,c=a.getProcedureDef()[0],d=a.mutationToDom(!0);a=Blockly.Procedures.getCallers(c,a.workspace);c=0;for(var e;e=a[c];c++){var f=e.mutationToDom();f=f&&Blockly.Xml.domToText(f);e.domToMutation(d);var g=e.mutationToDom();g=g&&Blockly.Xml.domToText(g);f!=g&&(Blockly.Events.recordUndo=!1,Blockly.Events.fire(new Blockly.Events.BlockChange(e,"mutation",null,f,g)),Blockly.Events.recordUndo=b)}};
	Blockly.Procedures.getDefinition=function(a,b){b=b.getTopBlocks(!1);for(var c=0;c<b.length;c++)if(b[c].getProcedureDef){var d=b[c].getProcedureDef();if(d&&Blockly.Names.equals(d[0],a))return b[c]}return null};Blockly.VariableModel=function(a,b,c,d){this.workspace=a;this.name=b;this.type=c||"";this.id_=d||Blockly.utils.genUid();Blockly.Events.fire(new Blockly.Events.VarCreate(this))};Blockly.VariableModel.prototype.getId=function(){return this.id_};Blockly.VariableModel.compareByName=function(a,b){a=a.name.toLowerCase();b=b.name.toLowerCase();return a<b?-1:a==b?0:1};Blockly.Variables={};Blockly.Variables.NAME_TYPE=Blockly.VARIABLE_CATEGORY_NAME;Blockly.Variables.allUsedVarModels=function(a){var b=a.getAllBlocks(!1);a=Object.create(null);for(var c=0;c<b.length;c++){var d=b[c].getVarModels();if(d)for(var e=0;e<d.length;e++){var f=d[e],g=f.getId();g&&(a[g]=f)}}b=[];for(g in a)b.push(a[g]);return b};Blockly.Variables.allUsedVariables=function(){console.warn("Deprecated call to Blockly.Variables.allUsedVariables. Use Blockly.Variables.allUsedVarModels instead.\nIf this is a major issue please file a bug on GitHub.")};
	Blockly.Variables.ALL_DEVELOPER_VARS_WARNINGS_BY_BLOCK_TYPE_={};
	Blockly.Variables.allDeveloperVariables=function(a){a=a.getAllBlocks(!1);for(var b=Object.create(null),c=0,d;d=a[c];c++){var e=d.getDeveloperVariables;!e&&d.getDeveloperVars&&(e=d.getDeveloperVars,Blockly.Variables.ALL_DEVELOPER_VARS_WARNINGS_BY_BLOCK_TYPE_[d.type]||(console.warn("Function getDeveloperVars() deprecated. Use getDeveloperVariables() (block type '"+d.type+"')"),Blockly.Variables.ALL_DEVELOPER_VARS_WARNINGS_BY_BLOCK_TYPE_[d.type]=!0));if(e)for(d=e(),e=0;e<d.length;e++)b[d[e]]=!0}return Object.keys(b)};
	Blockly.Variables.flyoutCategory=function(a){var b=[],c=document.createElement("button");c.setAttribute("text","%{BKY_NEW_VARIABLE}");c.setAttribute("callbackKey","CREATE_VARIABLE");a.registerButtonCallback("CREATE_VARIABLE",function(a){Blockly.Variables.createVariableButtonHandler(a.getTargetWorkspace())});b.push(c);a=Blockly.Variables.flyoutCategoryBlocks(a);return b=b.concat(a)};
	Blockly.Variables.flyoutCategoryBlocks=function(a){a=a.getVariablesOfType("");var b=[];if(0<a.length){var c=a[a.length-1];if(Blockly.Blocks.variables_set){var d=Blockly.utils.xml.createElement("block");d.setAttribute("type","variables_set");d.setAttribute("gap",Blockly.Blocks.math_change?8:24);d.appendChild(Blockly.Variables.generateVariableFieldDom(c));b.push(d)}Blockly.Blocks.math_change&&(d=Blockly.utils.xml.createElement("block"),d.setAttribute("type","math_change"),d.setAttribute("gap",Blockly.Blocks.variables_get?
	20:8),d.appendChild(Blockly.Variables.generateVariableFieldDom(c)),c=Blockly.Xml.textToDom('<value name="DELTA"><shadow type="math_number"><field name="NUM">1</field></shadow></value>'),d.appendChild(c),b.push(d));if(Blockly.Blocks.variables_get){a.sort(Blockly.VariableModel.compareByName);c=0;for(var e;e=a[c];c++)d=Blockly.utils.xml.createElement("block"),d.setAttribute("type","variables_get"),d.setAttribute("gap",8),d.appendChild(Blockly.Variables.generateVariableFieldDom(e)),b.push(d)}}return b};
	Blockly.Variables.VAR_LETTER_OPTIONS="ijkmnopqrstuvwxyzabcdefgh";Blockly.Variables.generateUniqueName=function(a){return Blockly.Variables.generateUniqueNameFromOptions(Blockly.Variables.VAR_LETTER_OPTIONS.charAt(0),a.getAllVariableNames())};
	Blockly.Variables.generateUniqueNameFromOptions=function(a,b){if(!b.length)return a;for(var c=Blockly.Variables.VAR_LETTER_OPTIONS,d="",e=c.indexOf(a);;){for(var f=!1,g=0;g<b.length;g++)if(b[g].toLowerCase()==a){f=!0;break}if(!f)return a;e++;e==c.length&&(e=0,d=Number(d)+1);a=c.charAt(e)+d}};
	Blockly.Variables.createVariableButtonHandler=function(a,b,c){var d=c||"",e=function(c){Blockly.Variables.promptName(Blockly.Msg.NEW_VARIABLE_TITLE,c,function(c){if(c){var f=Blockly.Variables.nameUsedWithAnyType(c,a);if(f){if(f.type==d)var g=Blockly.Msg.VARIABLE_ALREADY_EXISTS.replace("%1",f.name);else g=Blockly.Msg.VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE,g=g.replace("%1",f.name).replace("%2",f.type);Blockly.alert(g,function(){e(c)})}else a.createVariable(c,d),b&&b(c)}else b&&b(null)})};e("")};
	Blockly.Variables.createVariable=Blockly.Variables.createVariableButtonHandler;
	Blockly.Variables.renameVariable=function(a,b,c){var d=function(e){var f=Blockly.Msg.RENAME_VARIABLE_TITLE.replace("%1",b.name);Blockly.Variables.promptName(f,e,function(e){if(e){var f=Blockly.Variables.nameUsedWithOtherType_(e,b.type,a);f?(f=Blockly.Msg.VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE.replace("%1",f.name).replace("%2",f.type),Blockly.alert(f,function(){d(e)})):(a.renameVariableById(b.getId(),e),c&&c(e))}else c&&c(null)})};d("")};
	Blockly.Variables.promptName=function(a,b,c){Blockly.prompt(a,b,function(a){a&&(a=a.replace(/[\s\xa0]+/g," ").trim(),a==Blockly.Msg.RENAME_VARIABLE||a==Blockly.Msg.NEW_VARIABLE)&&(a=null);c(a)})};Blockly.Variables.nameUsedWithOtherType_=function(a,b,c){c=c.getVariableMap().getAllVariables();a=a.toLowerCase();for(var d=0,e;e=c[d];d++)if(e.name.toLowerCase()==a&&e.type!=b)return e;return null};
	Blockly.Variables.nameUsedWithAnyType=function(a,b){b=b.getVariableMap().getAllVariables();a=a.toLowerCase();for(var c=0,d;d=b[c];c++)if(d.name.toLowerCase()==a)return d;return null};Blockly.Variables.generateVariableFieldDom=function(a){var b=Blockly.utils.xml.createElement("field");b.setAttribute("name","VAR");b.setAttribute("id",a.getId());b.setAttribute("variabletype",a.type);a=Blockly.utils.xml.createTextNode(a.name);b.appendChild(a);return b};
	Blockly.Variables.getOrCreateVariablePackage=function(a,b,c,d){var e=Blockly.Variables.getVariable(a,b,c,d);e||(e=Blockly.Variables.createVariable_(a,b,c,d));return e};Blockly.Variables.getVariable=function(a,b,c,d){var e=a.getPotentialVariableMap(),f=null;if(b&&(f=a.getVariableById(b),!f&&e&&(f=e.getVariableById(b)),f))return f;if(c){if(void 0==d)throw Error("Tried to look up a variable by name without a type");f=a.getVariable(c,d);!f&&e&&(f=e.getVariable(c,d))}return f};
	Blockly.Variables.createVariable_=function(a,b,c,d){var e=a.getPotentialVariableMap();c||(c=Blockly.Variables.generateUniqueName(a.isFlyout?a.targetWorkspace:a));return e?e.createVariable(c,d,b):a.createVariable(c,d,b)};Blockly.Variables.getAddedVariables=function(a,b){a=a.getAllVariables();var c=[];if(b.length!=a.length)for(var d=0;d<a.length;d++){var e=a[d];-1==b.indexOf(e)&&c.push(e)}return c};Blockly.WidgetDiv={};Blockly.WidgetDiv.owner_=null;Blockly.WidgetDiv.dispose_=null;Blockly.WidgetDiv.rendererClassName_="";Blockly.WidgetDiv.themeClassName_="";Blockly.WidgetDiv.createDom=function(){Blockly.WidgetDiv.DIV||(Blockly.WidgetDiv.DIV=document.createElement("div"),Blockly.WidgetDiv.DIV.className="blocklyWidgetDiv",(Blockly.parentContainer||document.body).appendChild(Blockly.WidgetDiv.DIV))};
	Blockly.WidgetDiv.show=function(a,b,c){Blockly.WidgetDiv.hide();Blockly.WidgetDiv.owner_=a;Blockly.WidgetDiv.dispose_=c;a=Blockly.WidgetDiv.DIV;a.style.direction=b?"rtl":"ltr";a.style.display="block";b=Blockly.getMainWorkspace();Blockly.WidgetDiv.rendererClassName_=b.getRenderer().getClassName();Blockly.WidgetDiv.themeClassName_=b.getTheme().getClassName();Blockly.utils.dom.addClass(a,Blockly.WidgetDiv.rendererClassName_);Blockly.utils.dom.addClass(a,Blockly.WidgetDiv.themeClassName_)};
	Blockly.WidgetDiv.hide=function(){if(Blockly.WidgetDiv.isVisible()){Blockly.WidgetDiv.owner_=null;var a=Blockly.WidgetDiv.DIV;a.style.display="none";a.style.left="";a.style.top="";Blockly.WidgetDiv.dispose_&&Blockly.WidgetDiv.dispose_();Blockly.WidgetDiv.dispose_=null;a.textContent="";Blockly.WidgetDiv.rendererClassName_&&(Blockly.utils.dom.removeClass(a,Blockly.WidgetDiv.rendererClassName_),Blockly.WidgetDiv.rendererClassName_="");Blockly.WidgetDiv.themeClassName_&&(Blockly.utils.dom.removeClass(a,
	Blockly.WidgetDiv.themeClassName_),Blockly.WidgetDiv.themeClassName_="");Blockly.getMainWorkspace().markFocused()}};Blockly.WidgetDiv.isVisible=function(){return!!Blockly.WidgetDiv.owner_};Blockly.WidgetDiv.hideIfOwner=function(a){Blockly.WidgetDiv.owner_==a&&Blockly.WidgetDiv.hide()};Blockly.WidgetDiv.positionInternal_=function(a,b,c){Blockly.WidgetDiv.DIV.style.left=a+"px";Blockly.WidgetDiv.DIV.style.top=b+"px";Blockly.WidgetDiv.DIV.style.height=c+"px"};
	Blockly.WidgetDiv.positionWithAnchor=function(a,b,c,d){var e=Blockly.WidgetDiv.calculateY_(a,b,c);a=Blockly.WidgetDiv.calculateX_(a,b,c,d);0>e?Blockly.WidgetDiv.positionInternal_(a,0,c.height+e):Blockly.WidgetDiv.positionInternal_(a,e,c.height)};Blockly.WidgetDiv.calculateX_=function(a,b,c,d){if(d)return b=Math.max(b.right-c.width,a.left),Math.min(b,a.right-c.width);b=Math.min(b.left,a.right-c.width);return Math.max(b,a.left)};
	Blockly.WidgetDiv.calculateY_=function(a,b,c){return b.bottom+c.height>=a.bottom?b.top-c.height:b.bottom};Blockly.VERSION="3.20200625.2";Blockly.mainWorkspace=null;Blockly.selected=null;Blockly.draggingConnections=[];Blockly.clipboardXml_=null;Blockly.clipboardSource_=null;Blockly.clipboardTypeCounts_=null;Blockly.cache3dSupported_=null;Blockly.parentContainer=null;Blockly.svgSize=function(a){return new Blockly.utils.Size(a.cachedWidth_,a.cachedHeight_)};Blockly.resizeSvgContents=function(a){a.resizeContents()};
	Blockly.svgResize=function(a){for(;a.options.parentWorkspace;)a=a.options.parentWorkspace;var b=a.getParentSvg(),c=b.parentNode;if(c){var d=c.offsetWidth;c=c.offsetHeight;b.cachedWidth_!=d&&(b.setAttribute("width",d+"px"),b.cachedWidth_=d);b.cachedHeight_!=c&&(b.setAttribute("height",c+"px"),b.cachedHeight_=c);a.resize()}};
	Blockly.onKeyDown=function(a){var b=Blockly.mainWorkspace;if(b&&!(Blockly.utils.isTargetInput(a)||b.rendered&&!b.isVisible()))if(b.options.readOnly)Blockly.navigation.onKeyPress(a);else{var c=!1;if(a.keyCode==Blockly.utils.KeyCodes.ESC)Blockly.hideChaff(),Blockly.navigation.onBlocklyAction(Blockly.navigation.ACTION_EXIT);else{if(!Blockly.Gesture.inProgress()&&Blockly.navigation.onKeyPress(a))return;if(a.keyCode==Blockly.utils.KeyCodes.BACKSPACE||a.keyCode==Blockly.utils.KeyCodes.DELETE){a.preventDefault();
	if(Blockly.Gesture.inProgress())return;Blockly.selected&&Blockly.selected.isDeletable()&&(c=!0)}else if(a.altKey||a.ctrlKey||a.metaKey){if(Blockly.Gesture.inProgress())return;Blockly.selected&&Blockly.selected.isDeletable()&&Blockly.selected.isMovable()&&(a.keyCode==Blockly.utils.KeyCodes.C?(Blockly.hideChaff(),Blockly.copy_(Blockly.selected)):a.keyCode!=Blockly.utils.KeyCodes.X||Blockly.selected.workspace.isFlyout||(Blockly.copy_(Blockly.selected),c=!0));a.keyCode==Blockly.utils.KeyCodes.V?Blockly.clipboardXml_&&
	(a=Blockly.clipboardSource_,a.isFlyout&&(a=a.targetWorkspace),Blockly.clipboardTypeCounts_&&a.isCapacityAvailable(Blockly.clipboardTypeCounts_)&&(Blockly.Events.setGroup(!0),a.paste(Blockly.clipboardXml_),Blockly.Events.setGroup(!1))):a.keyCode==Blockly.utils.KeyCodes.Z?(Blockly.hideChaff(),b.undo(a.shiftKey)):a.ctrlKey&&a.keyCode==Blockly.utils.KeyCodes.Y&&(Blockly.hideChaff(),b.undo(!0))}}c&&!Blockly.selected.workspace.isFlyout&&(Blockly.Events.setGroup(!0),Blockly.hideChaff(),Blockly.selected.dispose(!0,
	!0),Blockly.Events.setGroup(!1))}};Blockly.copy_=function(a){a=a.toCopyData();Blockly.clipboardXml_=a.xml;Blockly.clipboardSource_=a.source;Blockly.clipboardTypeCounts_=a.typeCounts};Blockly.duplicate=function(a){var b=Blockly.clipboardXml_,c=Blockly.clipboardSource_;Blockly.copy_(a);a.workspace.paste(Blockly.clipboardXml_);Blockly.clipboardXml_=b;Blockly.clipboardSource_=c};Blockly.onContextMenu_=function(a){Blockly.utils.isTargetInput(a)||a.preventDefault()};
	Blockly.hideChaff=function(a){Blockly.Tooltip.hide();Blockly.WidgetDiv.hide();Blockly.DropDownDiv.hideWithoutAnimation();a||(a=Blockly.getMainWorkspace(),a.trashcan&&a.trashcan.flyout&&a.trashcan.flyout.hide(),(a=a.getToolbox())&&a.getFlyout()&&a.getFlyout().autoClose&&a.clearSelection())};Blockly.getMainWorkspace=function(){return Blockly.mainWorkspace};Blockly.alert=function(a,b){alert(a);b&&b()};Blockly.confirm=function(a,b){b(confirm(a))};Blockly.prompt=function(a,b,c){c(prompt(a,b))};
	Blockly.jsonInitFactory_=function(a){return function(){this.jsonInit(a)}};
	Blockly.defineBlocksWithJsonArray=function(a){for(var b=0;b<a.length;b++){var c=a[b];if(c){var d=c.type;null==d||""===d?console.warn("Block definition #"+b+" in JSON array is missing a type attribute. Skipping."):(Blockly.Blocks[d]&&console.warn("Block definition #"+b+' in JSON array overwrites prior definition of "'+d+'".'),Blockly.Blocks[d]={init:Blockly.jsonInitFactory_(c)})}else console.warn("Block definition #"+b+" in JSON array is "+c+". Skipping.")}};
	Blockly.bindEventWithChecks_=function(a,b,c,d,e,f){var g=!1,h=function(a){var b=!e;a=Blockly.Touch.splitEventByTouches(a);for(var f=0,h;h=a[f];f++)if(!b||Blockly.Touch.shouldHandleEvent(h))Blockly.Touch.setClientFromTouch(h),c?d.call(c,h):d(h),g=!0},k=[];if(Blockly.utils.global.PointerEvent&&b in Blockly.Touch.TOUCH_MAP)for(var l=0,m;m=Blockly.Touch.TOUCH_MAP[b][l];l++)a.addEventListener(m,h,!1),k.push([a,m,h]);else if(a.addEventListener(b,h,!1),k.push([a,b,h]),b in Blockly.Touch.TOUCH_MAP){var n=
	function(a){h(a);var b=!f;g&&b&&a.preventDefault()};for(l=0;m=Blockly.Touch.TOUCH_MAP[b][l];l++)a.addEventListener(m,n,!1),k.push([a,m,n])}return k};
	Blockly.bindEvent_=function(a,b,c,d){var e=function(a){c?d.call(c,a):d(a)},f=[];if(Blockly.utils.global.PointerEvent&&b in Blockly.Touch.TOUCH_MAP)for(var g=0,h;h=Blockly.Touch.TOUCH_MAP[b][g];g++)a.addEventListener(h,e,!1),f.push([a,h,e]);else if(a.addEventListener(b,e,!1),f.push([a,b,e]),b in Blockly.Touch.TOUCH_MAP){var k=function(a){if(a.changedTouches&&1==a.changedTouches.length){var b=a.changedTouches[0];a.clientX=b.clientX;a.clientY=b.clientY}e(a);a.preventDefault()};for(g=0;h=Blockly.Touch.TOUCH_MAP[b][g];g++)a.addEventListener(h,
	k,!1),f.push([a,h,k])}return f};Blockly.unbindEvent_=function(a){for(;a.length;){var b=a.pop(),c=b[2];b[0].removeEventListener(b[1],c,!1)}return c};Blockly.isNumber=function(a){return/^\s*-?\d+(\.\d+)?\s*$/.test(a)};Blockly.hueToHex=function(a){return Blockly.utils.colour.hsvToHex(a,Blockly.HSV_SATURATION,255*Blockly.HSV_VALUE)};
	Blockly.checkBlockColourConstants=function(){Blockly.checkBlockColourConstant_("LOGIC_HUE",["Blocks","logic","HUE"],void 0);Blockly.checkBlockColourConstant_("LOGIC_HUE",["Constants","Logic","HUE"],210);Blockly.checkBlockColourConstant_("LOOPS_HUE",["Blocks","loops","HUE"],void 0);Blockly.checkBlockColourConstant_("LOOPS_HUE",["Constants","Loops","HUE"],120);Blockly.checkBlockColourConstant_("MATH_HUE",["Blocks","math","HUE"],void 0);Blockly.checkBlockColourConstant_("MATH_HUE",["Constants","Math",
	"HUE"],230);Blockly.checkBlockColourConstant_("TEXTS_HUE",["Blocks","texts","HUE"],void 0);Blockly.checkBlockColourConstant_("TEXTS_HUE",["Constants","Text","HUE"],160);Blockly.checkBlockColourConstant_("LISTS_HUE",["Blocks","lists","HUE"],void 0);Blockly.checkBlockColourConstant_("LISTS_HUE",["Constants","Lists","HUE"],260);Blockly.checkBlockColourConstant_("COLOUR_HUE",["Blocks","colour","HUE"],void 0);Blockly.checkBlockColourConstant_("COLOUR_HUE",["Constants","Colour","HUE"],20);Blockly.checkBlockColourConstant_("VARIABLES_HUE",
	["Blocks","variables","HUE"],void 0);Blockly.checkBlockColourConstant_("VARIABLES_HUE",["Constants","Variables","HUE"],330);Blockly.checkBlockColourConstant_("VARIABLES_DYNAMIC_HUE",["Constants","VariablesDynamic","HUE"],310);Blockly.checkBlockColourConstant_("PROCEDURES_HUE",["Blocks","procedures","HUE"],void 0)};
	Blockly.checkBlockColourConstant_=function(a,b,c){for(var d="Blockly",e=Blockly,f=0;f<b.length;++f)d+="."+b[f],e&&(e=e[b[f]]);e&&e!==c&&(a=(void 0===c?'%1 has been removed. Use Blockly.Msg["%2"].':'%1 is deprecated and unused. Override Blockly.Msg["%2"].').replace("%1",d).replace("%2",a),console.warn(a))};Blockly.setParentContainer=function(a){Blockly.parentContainer=a};Blockly.Icon=function(a){this.block_=a};Blockly.Icon.prototype.collapseHidden=!0;Blockly.Icon.prototype.SIZE=17;Blockly.Icon.prototype.bubble_=null;Blockly.Icon.prototype.iconXY_=null;
	Blockly.Icon.prototype.createIcon=function(){this.iconGroup_||(this.iconGroup_=Blockly.utils.dom.createSvgElement("g",{"class":"blocklyIconGroup"},null),this.block_.isInFlyout&&Blockly.utils.dom.addClass(this.iconGroup_,"blocklyIconGroupReadonly"),this.drawIcon_(this.iconGroup_),this.block_.getSvgRoot().appendChild(this.iconGroup_),Blockly.bindEventWithChecks_(this.iconGroup_,"mouseup",this,this.iconClick_),this.updateEditable())};
	Blockly.Icon.prototype.dispose=function(){Blockly.utils.dom.removeNode(this.iconGroup_);this.iconGroup_=null;this.setVisible(!1);this.block_=null};Blockly.Icon.prototype.updateEditable=function(){};Blockly.Icon.prototype.isVisible=function(){return!!this.bubble_};Blockly.Icon.prototype.iconClick_=function(a){this.block_.workspace.isDragging()||this.block_.isInFlyout||Blockly.utils.isRightButton(a)||this.setVisible(!this.isVisible())};
	Blockly.Icon.prototype.applyColour=function(){this.isVisible()&&this.bubble_.setColour(this.block_.style.colourPrimary)};Blockly.Icon.prototype.setIconLocation=function(a){this.iconXY_=a;this.isVisible()&&this.bubble_.setAnchorLocation(a)};
	Blockly.Icon.prototype.computeIconLocation=function(){var a=this.block_.getRelativeToSurfaceXY(),b=Blockly.utils.getRelativeXY(this.iconGroup_);a=new Blockly.utils.Coordinate(a.x+b.x+this.SIZE/2,a.y+b.y+this.SIZE/2);Blockly.utils.Coordinate.equals(this.getIconLocation(),a)||this.setIconLocation(a)};Blockly.Icon.prototype.getIconLocation=function(){return this.iconXY_};
	Blockly.Icon.prototype.getCorrectedSize=function(){return new Blockly.utils.Size(Blockly.Icon.prototype.SIZE,Blockly.Icon.prototype.SIZE-2)};Blockly.Warning=function(a){Blockly.Warning.superClass_.constructor.call(this,a);this.createIcon();this.text_={}};Blockly.utils.object.inherits(Blockly.Warning,Blockly.Icon);Blockly.Warning.prototype.collapseHidden=!1;
	Blockly.Warning.prototype.drawIcon_=function(a){Blockly.utils.dom.createSvgElement("path",{"class":"blocklyIconShape",d:"M2,15Q-1,15 0.5,12L6.5,1.7Q8,-1 9.5,1.7L15.5,12Q17,15 14,15z"},a);Blockly.utils.dom.createSvgElement("path",{"class":"blocklyIconSymbol",d:"m7,4.8v3.16l0.27,2.27h1.46l0.27,-2.27v-3.16z"},a);Blockly.utils.dom.createSvgElement("rect",{"class":"blocklyIconSymbol",x:"7",y:"11",height:"2",width:"2"},a)};
	Blockly.Warning.textToDom_=function(a){var b=Blockly.utils.dom.createSvgElement("text",{"class":"blocklyText blocklyBubbleText blocklyNoPointerEvents",y:Blockly.Bubble.BORDER_WIDTH},null);a=a.split("\n");for(var c=0;c<a.length;c++){var d=Blockly.utils.dom.createSvgElement("tspan",{dy:"1em",x:Blockly.Bubble.BORDER_WIDTH},b),e=document.createTextNode(a[c]);d.appendChild(e)}return b};
	Blockly.Warning.prototype.setVisible=function(a){a!=this.isVisible()&&(Blockly.Events.fire(new Blockly.Events.Ui(this.block_,"warningOpen",!a,a)),a?this.createBubble():this.disposeBubble())};
	Blockly.Warning.prototype.createBubble=function(){this.paragraphElement_=Blockly.Warning.textToDom_(this.getText());this.bubble_=new Blockly.Bubble(this.block_.workspace,this.paragraphElement_,this.block_.pathObject.svgPath,this.iconXY_,null,null);this.bubble_.setSvgId(this.block_.id);if(this.block_.RTL)for(var a=this.paragraphElement_.getBBox().width,b=0,c;c=this.paragraphElement_.childNodes[b];b++)c.setAttribute("text-anchor","end"),c.setAttribute("x",a+Blockly.Bubble.BORDER_WIDTH);this.applyColour()};
	Blockly.Warning.prototype.disposeBubble=function(){this.bubble_.dispose();this.paragraphElement_=this.body_=this.bubble_=null};Blockly.Warning.prototype.setText=function(a,b){this.text_[b]!=a&&(a?this.text_[b]=a:delete this.text_[b],this.isVisible()&&(this.setVisible(!1),this.setVisible(!0)))};Blockly.Warning.prototype.getText=function(){var a=[],b;for(b in this.text_)a.push(this.text_[b]);return a.join("\n")};Blockly.Warning.prototype.dispose=function(){this.block_.warning=null;Blockly.Icon.prototype.dispose.call(this)};Blockly.Comment=function(a){Blockly.Comment.superClass_.constructor.call(this,a);this.model_=a.commentModel;this.model_.text=this.model_.text||"";this.cachedText_="";this.onInputWrapper_=this.onChangeWrapper_=this.onWheelWrapper_=this.onMouseUpWrapper_=null;this.createIcon()};Blockly.utils.object.inherits(Blockly.Comment,Blockly.Icon);
	Blockly.Comment.prototype.drawIcon_=function(a){Blockly.utils.dom.createSvgElement("circle",{"class":"blocklyIconShape",r:"8",cx:"8",cy:"8"},a);Blockly.utils.dom.createSvgElement("path",{"class":"blocklyIconSymbol",d:"m6.8,10h2c0.003,-0.617 0.271,-0.962 0.633,-1.266 2.875,-2.4050.607,-5.534 -3.765,-3.874v1.7c3.12,-1.657 3.698,0.118 2.336,1.25-1.201,0.998 -1.201,1.528 -1.204,2.19z"},a);Blockly.utils.dom.createSvgElement("rect",{"class":"blocklyIconSymbol",x:"6.8",y:"10.78",height:"2",width:"2"},a)};
	Blockly.Comment.prototype.createEditor_=function(){this.foreignObject_=Blockly.utils.dom.createSvgElement("foreignObject",{x:Blockly.Bubble.BORDER_WIDTH,y:Blockly.Bubble.BORDER_WIDTH},null);var a=document.createElementNS(Blockly.utils.dom.HTML_NS,"body");a.setAttribute("xmlns",Blockly.utils.dom.HTML_NS);a.className="blocklyMinimalBody";var b=this.textarea_=document.createElementNS(Blockly.utils.dom.HTML_NS,"textarea");b.className="blocklyCommentTextarea";b.setAttribute("dir",this.block_.RTL?"RTL":
	"LTR");b.value=this.model_.text;this.resizeTextarea_();a.appendChild(b);this.foreignObject_.appendChild(a);this.onMouseUpWrapper_=Blockly.bindEventWithChecks_(b,"mouseup",this,this.startEdit_,!0,!0);this.onWheelWrapper_=Blockly.bindEventWithChecks_(b,"wheel",this,function(a){a.stopPropagation()});this.onChangeWrapper_=Blockly.bindEventWithChecks_(b,"change",this,function(a){this.cachedText_!=this.model_.text&&Blockly.Events.fire(new Blockly.Events.BlockChange(this.block_,"comment",null,this.cachedText_,
	this.model_.text))});this.onInputWrapper_=Blockly.bindEventWithChecks_(b,"input",this,function(a){this.model_.text=b.value});setTimeout(b.focus.bind(b),0);return this.foreignObject_};Blockly.Comment.prototype.updateEditable=function(){Blockly.Comment.superClass_.updateEditable.call(this);this.isVisible()&&(this.disposeBubble_(),this.createBubble_())};Blockly.Comment.prototype.onBubbleResize_=function(){this.isVisible()&&(this.model_.size=this.bubble_.getBubbleSize(),this.resizeTextarea_())};
	Blockly.Comment.prototype.resizeTextarea_=function(){var a=this.model_.size,b=2*Blockly.Bubble.BORDER_WIDTH,c=a.width-b;a=a.height-b;this.foreignObject_.setAttribute("width",c);this.foreignObject_.setAttribute("height",a);this.textarea_.style.width=c-4+"px";this.textarea_.style.height=a-4+"px"};Blockly.Comment.prototype.setVisible=function(a){a!=this.isVisible()&&(Blockly.Events.fire(new Blockly.Events.Ui(this.block_,"commentOpen",!a,a)),(this.model_.pinned=a)?this.createBubble_():this.disposeBubble_())};
	Blockly.Comment.prototype.createBubble_=function(){!this.block_.isEditable()||Blockly.utils.userAgent.IE?this.createNonEditableBubble_():this.createEditableBubble_()};Blockly.Comment.prototype.createEditableBubble_=function(){this.bubble_=new Blockly.Bubble(this.block_.workspace,this.createEditor_(),this.block_.pathObject.svgPath,this.iconXY_,this.model_.size.width,this.model_.size.height);this.bubble_.setSvgId(this.block_.id);this.bubble_.registerResizeEvent(this.onBubbleResize_.bind(this));this.applyColour()};
	Blockly.Comment.prototype.createNonEditableBubble_=function(){Blockly.Warning.prototype.createBubble.call(this)};
	Blockly.Comment.prototype.disposeBubble_=function(){this.paragraphElement_?Blockly.Warning.prototype.disposeBubble.call(this):(this.onMouseUpWrapper_&&(Blockly.unbindEvent_(this.onMouseUpWrapper_),this.onMouseUpWrapper_=null),this.onWheelWrapper_&&(Blockly.unbindEvent_(this.onWheelWrapper_),this.onWheelWrapper_=null),this.onChangeWrapper_&&(Blockly.unbindEvent_(this.onChangeWrapper_),this.onChangeWrapper_=null),this.onInputWrapper_&&(Blockly.unbindEvent_(this.onInputWrapper_),this.onInputWrapper_=
	null),this.bubble_.dispose(),this.foreignObject_=this.textarea_=this.bubble_=null)};Blockly.Comment.prototype.startEdit_=function(a){this.bubble_.promote()&&this.textarea_.focus();this.cachedText_=this.model_.text};Blockly.Comment.prototype.getBubbleSize=function(){return this.model_.size};Blockly.Comment.prototype.setBubbleSize=function(a,b){this.bubble_?this.bubble_.setBubbleSize(a,b):(this.model_.size.width=a,this.model_.size.height=b)};
	Blockly.Comment.prototype.getText=function(){return this.model_.text||""};Blockly.Comment.prototype.setText=function(a){this.model_.text!=a&&(this.model_.text=a,this.updateText())};Blockly.Comment.prototype.updateText=function(){this.textarea_?this.textarea_.value=this.model_.text:this.paragraphElement_&&(this.paragraphElement_.firstChild.textContent=this.model_.text)};Blockly.Comment.prototype.dispose=function(){this.block_.comment=null;Blockly.Icon.prototype.dispose.call(this)};Blockly.Css.register(".blocklyCommentTextarea {,background-color: #fef49c;,border: 0;,outline: 0;,margin: 0;,padding: 3px;,resize: none;,display: block;,overflow: hidden;,}".split(","));Blockly.FlyoutCursor=function(){Blockly.FlyoutCursor.superClass_.constructor.call(this)};Blockly.utils.object.inherits(Blockly.FlyoutCursor,Blockly.Cursor);Blockly.FlyoutCursor.prototype.onBlocklyAction=function(a){switch(a.name){case Blockly.navigation.actionNames.PREVIOUS:return this.prev(),!0;case Blockly.navigation.actionNames.NEXT:return this.next(),!0;default:return!1}};
	Blockly.FlyoutCursor.prototype.next=function(){var a=this.getCurNode();if(!a)return null;(a=a.next())&&this.setCurNode(a);return a};Blockly.FlyoutCursor.prototype.in=function(){return null};Blockly.FlyoutCursor.prototype.prev=function(){var a=this.getCurNode();if(!a)return null;(a=a.prev())&&this.setCurNode(a);return a};Blockly.FlyoutCursor.prototype.out=function(){return null};Blockly.Flyout=function(a){a.getMetrics=this.getMetrics_.bind(this);a.setMetrics=this.setMetrics_.bind(this);this.workspace_=new Blockly.WorkspaceSvg(a);this.workspace_.isFlyout=!0;this.workspace_.setVisible(this.isVisible_);this.RTL=!!a.RTL;this.horizontalLayout=!1;this.toolboxPosition_=a.toolboxPosition;this.eventWrappers_=[];this.mats_=[];this.buttons_=[];this.listeners_=[];this.permanentlyDisabled_=[];this.tabWidth_=this.workspace_.getRenderer().getConstants().TAB_WIDTH;this.targetWorkspace=null};
	Blockly.Flyout.prototype.autoClose=!0;Blockly.Flyout.prototype.isVisible_=!1;Blockly.Flyout.prototype.containerVisible_=!0;Blockly.Flyout.prototype.CORNER_RADIUS=8;Blockly.Flyout.prototype.MARGIN=Blockly.Flyout.prototype.CORNER_RADIUS;Blockly.Flyout.prototype.GAP_X=3*Blockly.Flyout.prototype.MARGIN;Blockly.Flyout.prototype.GAP_Y=3*Blockly.Flyout.prototype.MARGIN;Blockly.Flyout.prototype.SCROLLBAR_PADDING=2;Blockly.Flyout.prototype.width_=0;Blockly.Flyout.prototype.height_=0;
	Blockly.Flyout.prototype.dragAngleRange_=70;
	Blockly.Flyout.prototype.createDom=function(a){this.svgGroup_=Blockly.utils.dom.createSvgElement(a,{"class":"blocklyFlyout",style:"display: none"},null);this.svgBackground_=Blockly.utils.dom.createSvgElement("path",{"class":"blocklyFlyoutBackground"},this.svgGroup_);this.svgGroup_.appendChild(this.workspace_.createDom());this.workspace_.getThemeManager().subscribe(this.svgBackground_,"flyoutBackgroundColour","fill");this.workspace_.getThemeManager().subscribe(this.svgBackground_,"flyoutOpacity","fill-opacity");
	this.workspace_.getMarkerManager().setCursor(new Blockly.FlyoutCursor);return this.svgGroup_};
	Blockly.Flyout.prototype.init=function(a){this.targetWorkspace=a;this.workspace_.targetWorkspace=a;this.scrollbar=new Blockly.Scrollbar(this.workspace_,this.horizontalLayout,!1,"blocklyFlyoutScrollbar");this.hide();Array.prototype.push.apply(this.eventWrappers_,Blockly.bindEventWithChecks_(this.svgGroup_,"wheel",this,this.wheel_));this.autoClose||(this.filterWrapper_=this.filterForCapacity_.bind(this),this.targetWorkspace.addChangeListener(this.filterWrapper_));Array.prototype.push.apply(this.eventWrappers_,
	Blockly.bindEventWithChecks_(this.svgBackground_,"mousedown",this,this.onMouseDown_));this.workspace_.getGesture=this.targetWorkspace.getGesture.bind(this.targetWorkspace);this.workspace_.setVariableMap(this.targetWorkspace.getVariableMap());this.workspace_.createPotentialVariableMap()};
	Blockly.Flyout.prototype.dispose=function(){this.hide();Blockly.unbindEvent_(this.eventWrappers_);this.filterWrapper_&&(this.targetWorkspace.removeChangeListener(this.filterWrapper_),this.filterWrapper_=null);this.scrollbar&&(this.scrollbar.dispose(),this.scrollbar=null);this.workspace_&&(this.workspace_.getThemeManager().unsubscribe(this.svgBackground_),this.workspace_.targetWorkspace=null,this.workspace_.dispose(),this.workspace_=null);this.svgGroup_&&(Blockly.utils.dom.removeNode(this.svgGroup_),
	this.svgGroup_=null);this.targetWorkspace=this.svgBackground_=null};Blockly.Flyout.prototype.getWidth=function(){return this.width_};Blockly.Flyout.prototype.getHeight=function(){return this.height_};Blockly.Flyout.prototype.getWorkspace=function(){return this.workspace_};Blockly.Flyout.prototype.isVisible=function(){return this.isVisible_};Blockly.Flyout.prototype.setVisible=function(a){var b=a!=this.isVisible();this.isVisible_=a;b&&this.updateDisplay_()};
	Blockly.Flyout.prototype.setContainerVisible=function(a){var b=a!=this.containerVisible_;this.containerVisible_=a;b&&this.updateDisplay_()};Blockly.Flyout.prototype.updateDisplay_=function(){var a=this.containerVisible_?this.isVisible():!1;this.svgGroup_.style.display=a?"block":"none";this.scrollbar.setContainerVisible(a)};
	Blockly.Flyout.prototype.positionAt_=function(a,b,c,d){this.svgGroup_.setAttribute("width",a);this.svgGroup_.setAttribute("height",b);"svg"==this.svgGroup_.tagName?Blockly.utils.dom.setCssTransform(this.svgGroup_,"translate("+c+"px,"+d+"px)"):this.svgGroup_.setAttribute("transform","translate("+c+","+d+")");this.scrollbar&&(this.scrollbar.setOrigin(c,d),this.scrollbar.resize(),this.scrollbar.setPosition(this.scrollbar.position.x,this.scrollbar.position.y))};
	Blockly.Flyout.prototype.hide=function(){if(this.isVisible()){this.setVisible(!1);for(var a=0,b;b=this.listeners_[a];a++)Blockly.unbindEvent_(b);this.listeners_.length=0;this.reflowWrapper_&&(this.workspace_.removeChangeListener(this.reflowWrapper_),this.reflowWrapper_=null)}};
	Blockly.Flyout.prototype.show=function(a){this.workspace_.setResizesEnabled(!1);this.hide();this.clearOldBlocks_();if("string"==typeof a){a=this.workspace_.targetWorkspace.getToolboxCategoryCallback(a);if("function"!=typeof a)throw TypeError("Couldn't find a callback function when opening a toolbox category.");a=a(this.workspace_.targetWorkspace);if(!Array.isArray(a))throw TypeError("Result of toolbox category callback must be an array.");}this.setVisible(!0);a=Blockly.utils.toolbox.convertToolboxToJSON(a);
	a=this.createFlyoutInfo_(a);this.layout_(a.contents,a.gaps);this.listeners_.push(Blockly.bindEventWithChecks_(this.svgBackground_,"mouseover",this,function(){for(var a=this.workspace_.getTopBlocks(!1),c=0,d;d=a[c];c++)d.removeSelect()}));this.horizontalLayout?this.height_=0:this.width_=0;this.workspace_.setResizesEnabled(!0);this.reflow();this.filterForCapacity_();this.position();this.reflowWrapper_=this.reflow.bind(this);this.workspace_.addChangeListener(this.reflowWrapper_)};
	Blockly.Flyout.prototype.createFlyoutInfo_=function(a){var b=[],c=[];this.permanentlyDisabled_.length=0;for(var d=this.horizontalLayout?this.GAP_X:this.GAP_Y,e=0,f;f=a[e];e++)switch(f.kind.toUpperCase()){case "BLOCK":var g=f,h=this.getBlockXml_(g);f=this.createBlock_(h);g=parseInt(g.gap||h.getAttribute("gap"),10);c.push(isNaN(g)?d:g);b.push({type:"block",block:f});break;case "SEP":this.addSeparatorGap_(f,c,d);break;case "LABEL":f=this.createButton_(f,!0);b.push({type:"button",button:f});c.push(d);
	break;case "BUTTON":f=this.createButton_(f,!1),b.push({type:"button",button:f}),c.push(d)}return{contents:b,gaps:c}};Blockly.Flyout.prototype.createButton_=function(a,b){if(!Blockly.FlyoutButton)throw Error("Missing require for Blockly.FlyoutButton");return new Blockly.FlyoutButton(this.workspace_,this.targetWorkspace,a,b)};Blockly.Flyout.prototype.createBlock_=function(a){a=Blockly.Xml.domToBlock(a,this.workspace_);a.isEnabled()||this.permanentlyDisabled_.push(a);return a};
	Blockly.Flyout.prototype.getBlockXml_=function(a){var b=null,c=a.blockxml;c&&"string"!=typeof c?b=c:c&&"string"==typeof c?b=Blockly.Xml.textToDom(c):a.type&&(b=Blockly.utils.xml.createElement("xml"),b.setAttribute("type",a.type),b.setAttribute("disabled",a.disabled));if(!b)throw Error("Error: Invalid block definition. Block definition must have blockxml or type.");return b};Blockly.Flyout.prototype.addSeparatorGap_=function(a,b,c){a=parseInt(a.gap,10);!isNaN(a)&&0<b.length?b[b.length-1]=a:b.push(c)};
	Blockly.Flyout.prototype.clearOldBlocks_=function(){for(var a=this.workspace_.getTopBlocks(!1),b=0,c;c=a[b];b++)c.workspace==this.workspace_&&c.dispose(!1,!1);for(b=0;b<this.mats_.length;b++)if(a=this.mats_[b])Blockly.Tooltip.unbindMouseEvents(a),Blockly.utils.dom.removeNode(a);for(b=this.mats_.length=0;a=this.buttons_[b];b++)a.dispose();this.buttons_.length=0;this.workspace_.getPotentialVariableMap().clear()};
	Blockly.Flyout.prototype.addBlockListeners_=function(a,b,c){this.listeners_.push(Blockly.bindEventWithChecks_(a,"mousedown",null,this.blockMouseDown_(b)));this.listeners_.push(Blockly.bindEventWithChecks_(c,"mousedown",null,this.blockMouseDown_(b)));this.listeners_.push(Blockly.bindEvent_(a,"mouseenter",b,b.addSelect));this.listeners_.push(Blockly.bindEvent_(a,"mouseleave",b,b.removeSelect));this.listeners_.push(Blockly.bindEvent_(c,"mouseenter",b,b.addSelect));this.listeners_.push(Blockly.bindEvent_(c,
	"mouseleave",b,b.removeSelect))};Blockly.Flyout.prototype.blockMouseDown_=function(a){var b=this;return function(c){var d=b.targetWorkspace.getGesture(c);d&&(d.setStartBlock(a),d.handleFlyoutStart(c,b))}};Blockly.Flyout.prototype.onMouseDown_=function(a){var b=this.targetWorkspace.getGesture(a);b&&b.handleFlyoutStart(a,this)};Blockly.Flyout.prototype.isBlockCreatable_=function(a){return a.isEnabled()};
	Blockly.Flyout.prototype.createBlock=function(a){var b=null;Blockly.Events.disable();var c=this.targetWorkspace.getAllVariables();this.targetWorkspace.setResizesEnabled(!1);try{b=this.placeNewBlock_(a),Blockly.hideChaff()}finally{Blockly.Events.enable()}a=Blockly.Variables.getAddedVariables(this.targetWorkspace,c);if(Blockly.Events.isEnabled())for(Blockly.Events.setGroup(!0),Blockly.Events.fire(new Blockly.Events.Create(b)),c=0;c<a.length;c++)Blockly.Events.fire(new Blockly.Events.VarCreate(a[c]));
	this.autoClose?this.hide():this.filterForCapacity_();return b};Blockly.Flyout.prototype.initFlyoutButton_=function(a,b,c){var d=a.createDom();a.moveTo(b,c);a.show();this.listeners_.push(Blockly.bindEventWithChecks_(d,"mousedown",this,this.onMouseDown_));this.buttons_.push(a)};
	Blockly.Flyout.prototype.createRect_=function(a,b,c,d,e){b=Blockly.utils.dom.createSvgElement("rect",{"fill-opacity":0,x:b,y:c,height:d.height,width:d.width},null);b.tooltip=a;Blockly.Tooltip.bindMouseEvents(b);this.workspace_.getCanvas().insertBefore(b,a.getSvgRoot());a.flyoutRect_=b;return this.mats_[e]=b};
	Blockly.Flyout.prototype.moveRectToBlock_=function(a,b){var c=b.getHeightWidth();a.setAttribute("width",c.width);a.setAttribute("height",c.height);b=b.getRelativeToSurfaceXY();a.setAttribute("y",b.y);a.setAttribute("x",this.RTL?b.x-c.width:b.x)};
	Blockly.Flyout.prototype.filterForCapacity_=function(){for(var a=this.workspace_.getTopBlocks(!1),b=0,c;c=a[b];b++)if(-1==this.permanentlyDisabled_.indexOf(c))for(var d=this.targetWorkspace.isCapacityAvailable(Blockly.utils.getBlockTypeCounts(c));c;)c.setEnabled(d),c=c.getNextBlock()};Blockly.Flyout.prototype.reflow=function(){this.reflowWrapper_&&this.workspace_.removeChangeListener(this.reflowWrapper_);this.reflowInternal_();this.reflowWrapper_&&this.workspace_.addChangeListener(this.reflowWrapper_)};
	Blockly.Flyout.prototype.isScrollable=function(){return this.scrollbar?this.scrollbar.isVisible():!1};
	Blockly.Flyout.prototype.placeNewBlock_=function(a){var b=this.targetWorkspace;if(!a.getSvgRoot())throw Error("oldBlock is not rendered.");var c=Blockly.Xml.blockToDom(a,!0);b.setResizesEnabled(!1);c=Blockly.Xml.domToBlock(c,b);if(!c.getSvgRoot())throw Error("block is not rendered.");var d=b.getOriginOffsetInPixels(),e=this.workspace_.getOriginOffsetInPixels();a=a.getRelativeToSurfaceXY();a.scale(this.workspace_.scale);a=Blockly.utils.Coordinate.sum(e,a);d=Blockly.utils.Coordinate.difference(a,d);
	d.scale(1/b.scale);c.moveBy(d.x,d.y);return c};Blockly.Flyout.prototype.onBlocklyAction=function(a){return this.workspace_.getCursor().onBlocklyAction(a)};Blockly.HorizontalFlyout=function(a){Blockly.HorizontalFlyout.superClass_.constructor.call(this,a);this.horizontalLayout=!0};Blockly.utils.object.inherits(Blockly.HorizontalFlyout,Blockly.Flyout);
	Blockly.HorizontalFlyout.prototype.getMetrics_=function(){if(!this.isVisible())return null;try{var a=this.workspace_.getCanvas().getBBox()}catch(e){a={height:0,y:0,width:0,x:0}}var b=this.SCROLLBAR_PADDING,c=this.SCROLLBAR_PADDING;this.toolboxPosition_==Blockly.TOOLBOX_AT_BOTTOM&&(b=0);var d=this.height_;this.toolboxPosition_==Blockly.TOOLBOX_AT_TOP&&(d-=this.SCROLLBAR_PADDING);return{contentHeight:(a.height+2*this.MARGIN)*this.workspace_.scale,contentWidth:(a.width+2*this.MARGIN)*this.workspace_.scale,
	contentTop:0,contentLeft:0,viewHeight:d,viewWidth:this.width_-2*this.SCROLLBAR_PADDING,viewTop:-this.workspace_.scrollY,viewLeft:-this.workspace_.scrollX,absoluteTop:b,absoluteLeft:c}};Blockly.HorizontalFlyout.prototype.setMetrics_=function(a){var b=this.getMetrics_();b&&("number"==typeof a.x&&(this.workspace_.scrollX=-b.contentWidth*a.x),this.workspace_.translate(this.workspace_.scrollX+b.absoluteLeft,this.workspace_.scrollY+b.absoluteTop))};
	Blockly.HorizontalFlyout.prototype.position=function(){if(this.isVisible()){var a=this.targetWorkspace.getMetrics();a&&(this.width_=a.viewWidth,this.setBackgroundPath_(a.viewWidth-2*this.CORNER_RADIUS,this.height_-this.CORNER_RADIUS),this.positionAt_(this.width_,this.height_,0,this.targetWorkspace.toolboxPosition==this.toolboxPosition_?a.toolboxHeight?this.toolboxPosition_==Blockly.TOOLBOX_AT_TOP?a.toolboxHeight:a.viewHeight-this.height_:this.toolboxPosition_==Blockly.TOOLBOX_AT_TOP?0:a.viewHeight:
	this.toolboxPosition_==Blockly.TOOLBOX_AT_TOP?0:a.viewHeight+a.absoluteTop-this.height_))}};
	Blockly.HorizontalFlyout.prototype.setBackgroundPath_=function(a,b){var c=this.toolboxPosition_==Blockly.TOOLBOX_AT_TOP,d=["M 0,"+(c?0:this.CORNER_RADIUS)];c?(d.push("h",a+2*this.CORNER_RADIUS),d.push("v",b),d.push("a",this.CORNER_RADIUS,this.CORNER_RADIUS,0,0,1,-this.CORNER_RADIUS,this.CORNER_RADIUS),d.push("h",-a),d.push("a",this.CORNER_RADIUS,this.CORNER_RADIUS,0,0,1,-this.CORNER_RADIUS,-this.CORNER_RADIUS)):(d.push("a",this.CORNER_RADIUS,this.CORNER_RADIUS,0,0,1,this.CORNER_RADIUS,-this.CORNER_RADIUS),
	d.push("h",a),d.push("a",this.CORNER_RADIUS,this.CORNER_RADIUS,0,0,1,this.CORNER_RADIUS,this.CORNER_RADIUS),d.push("v",b),d.push("h",-a-2*this.CORNER_RADIUS));d.push("z");this.svgBackground_.setAttribute("d",d.join(" "))};Blockly.HorizontalFlyout.prototype.scrollToStart=function(){this.scrollbar.set(this.RTL?Infinity:0)};
	Blockly.HorizontalFlyout.prototype.wheel_=function(a){var b=Blockly.utils.getScrollDeltaPixels(a),c=b.x||b.y;c&&(b=this.getMetrics_(),c=b.viewLeft+c,c=Math.min(c,b.contentWidth-b.viewWidth),c=Math.max(c,0),this.scrollbar.set(c),Blockly.WidgetDiv.hide(),Blockly.DropDownDiv.hideWithoutAnimation());a.preventDefault();a.stopPropagation()};
	Blockly.HorizontalFlyout.prototype.layout_=function(a,b){this.workspace_.scale=this.targetWorkspace.scale;var c=this.MARGIN,d=c+this.tabWidth_;this.RTL&&(a=a.reverse());for(var e=0,f;f=a[e];e++)if("block"==f.type){f=f.block;for(var g=f.getDescendants(!1),h=0,k;k=g[h];h++)k.isInFlyout=!0;f.render();g=f.getSvgRoot();h=f.getHeightWidth();k=f.outputConnection?this.tabWidth_:0;k=this.RTL?d+h.width:d-k;f.moveBy(k,c);k=this.createRect_(f,k,c,h,e);d+=h.width+b[e];this.addBlockListeners_(g,f,k)}else"button"==
	f.type&&(this.initFlyoutButton_(f.button,d,c),d+=f.button.width+b[e])};Blockly.HorizontalFlyout.prototype.isDragTowardWorkspace=function(a){a=Math.atan2(a.y,a.x)/Math.PI*180;var b=this.dragAngleRange_;return a<90+b&&a>90-b||a>-90-b&&a<-90+b?!0:!1};
	Blockly.HorizontalFlyout.prototype.getClientRect=function(){if(!this.svgGroup_)return null;var a=this.svgGroup_.getBoundingClientRect(),b=a.top;return this.toolboxPosition_==Blockly.TOOLBOX_AT_TOP?new Blockly.utils.Rect(-1E9,b+a.height,-1E9,1E9):new Blockly.utils.Rect(b,1E9,-1E9,1E9)};
	Blockly.HorizontalFlyout.prototype.reflowInternal_=function(){this.workspace_.scale=this.targetWorkspace.scale;for(var a=0,b=this.workspace_.getTopBlocks(!1),c=0,d;d=b[c];c++)a=Math.max(a,d.getHeightWidth().height);a+=1.5*this.MARGIN;a*=this.workspace_.scale;a+=Blockly.Scrollbar.scrollbarThickness;if(this.height_!=a){for(c=0;d=b[c];c++)d.flyoutRect_&&this.moveRectToBlock_(d.flyoutRect_,d);this.height_=a;this.position()}};Blockly.VerticalFlyout=function(a){Blockly.VerticalFlyout.superClass_.constructor.call(this,a)};Blockly.utils.object.inherits(Blockly.VerticalFlyout,Blockly.Flyout);
	Blockly.VerticalFlyout.prototype.getMetrics_=function(){if(!this.isVisible())return null;try{var a=this.workspace_.getCanvas().getBBox()}catch(e){a={height:0,y:0,width:0,x:0}}var b=this.SCROLLBAR_PADDING,c=this.height_-2*this.SCROLLBAR_PADDING,d=this.width_;this.RTL||(d-=this.SCROLLBAR_PADDING);return{contentHeight:a.height*this.workspace_.scale+2*this.MARGIN,contentWidth:a.width*this.workspace_.scale+2*this.MARGIN,contentTop:a.y,contentLeft:a.x,viewHeight:c,viewWidth:d,viewTop:-this.workspace_.scrollY+
	a.y,viewLeft:-this.workspace_.scrollX,absoluteTop:b,absoluteLeft:0}};Blockly.VerticalFlyout.prototype.setMetrics_=function(a){var b=this.getMetrics_();b&&("number"==typeof a.y&&(this.workspace_.scrollY=-b.contentHeight*a.y),this.workspace_.translate(this.workspace_.scrollX+b.absoluteLeft,this.workspace_.scrollY+b.absoluteTop))};
	Blockly.VerticalFlyout.prototype.position=function(){if(this.isVisible()){var a=this.targetWorkspace.getMetrics();a&&(this.height_=a.viewHeight,this.setBackgroundPath_(this.width_-this.CORNER_RADIUS,a.viewHeight-2*this.CORNER_RADIUS),this.positionAt_(this.width_,this.height_,this.targetWorkspace.toolboxPosition==this.toolboxPosition_?a.toolboxWidth?this.toolboxPosition_==Blockly.TOOLBOX_AT_LEFT?a.toolboxWidth:a.viewWidth-this.width_:this.toolboxPosition_==Blockly.TOOLBOX_AT_LEFT?0:a.viewWidth:this.toolboxPosition_==
	Blockly.TOOLBOX_AT_LEFT?0:a.viewWidth+a.absoluteLeft-this.width_,0))}};
	Blockly.VerticalFlyout.prototype.setBackgroundPath_=function(a,b){var c=this.toolboxPosition_==Blockly.TOOLBOX_AT_RIGHT,d=a+this.CORNER_RADIUS;d=["M "+(c?d:0)+",0"];d.push("h",c?-a:a);d.push("a",this.CORNER_RADIUS,this.CORNER_RADIUS,0,0,c?0:1,c?-this.CORNER_RADIUS:this.CORNER_RADIUS,this.CORNER_RADIUS);d.push("v",Math.max(0,b));d.push("a",this.CORNER_RADIUS,this.CORNER_RADIUS,0,0,c?0:1,c?this.CORNER_RADIUS:-this.CORNER_RADIUS,this.CORNER_RADIUS);d.push("h",c?a:-a);d.push("z");this.svgBackground_.setAttribute("d",
	d.join(" "))};Blockly.VerticalFlyout.prototype.scrollToStart=function(){this.scrollbar.set(0)};Blockly.VerticalFlyout.prototype.wheel_=function(a){var b=Blockly.utils.getScrollDeltaPixels(a);if(b.y){var c=this.getMetrics_();b=c.viewTop-c.contentTop+b.y;b=Math.min(b,c.contentHeight-c.viewHeight);b=Math.max(b,0);this.scrollbar.set(b);Blockly.WidgetDiv.hide();Blockly.DropDownDiv.hideWithoutAnimation()}a.preventDefault();a.stopPropagation()};
	Blockly.VerticalFlyout.prototype.layout_=function(a,b){this.workspace_.scale=this.targetWorkspace.scale;for(var c=this.MARGIN,d=this.RTL?c:c+this.tabWidth_,e=0,f;f=a[e];e++)if("block"==f.type){f=f.block;for(var g=f.getDescendants(!1),h=0,k;k=g[h];h++)k.isInFlyout=!0;f.render();g=f.getSvgRoot();h=f.getHeightWidth();k=f.outputConnection?d-this.tabWidth_:d;f.moveBy(k,c);k=this.createRect_(f,this.RTL?k-h.width:k,c,h,e);this.addBlockListeners_(g,f,k);c+=h.height+b[e]}else"button"==f.type&&(this.initFlyoutButton_(f.button,
	d,c),c+=f.button.height+b[e])};Blockly.VerticalFlyout.prototype.isDragTowardWorkspace=function(a){a=Math.atan2(a.y,a.x)/Math.PI*180;var b=this.dragAngleRange_;return a<b&&a>-b||a<-180+b||a>180-b?!0:!1};Blockly.VerticalFlyout.prototype.getClientRect=function(){if(!this.svgGroup_)return null;var a=this.svgGroup_.getBoundingClientRect(),b=a.left;return this.toolboxPosition_==Blockly.TOOLBOX_AT_LEFT?new Blockly.utils.Rect(-1E9,1E9,-1E9,b+a.width):new Blockly.utils.Rect(-1E9,1E9,b,1E9)};
	Blockly.VerticalFlyout.prototype.reflowInternal_=function(){this.workspace_.scale=this.targetWorkspace.scale;for(var a=0,b=this.workspace_.getTopBlocks(!1),c=0,d;d=b[c];c++){var e=d.getHeightWidth().width;d.outputConnection&&(e-=this.tabWidth_);a=Math.max(a,e)}for(c=0;d=this.buttons_[c];c++)a=Math.max(a,d.width);a+=1.5*this.MARGIN+this.tabWidth_;a*=this.workspace_.scale;a+=Blockly.Scrollbar.scrollbarThickness;if(this.width_!=a){for(c=0;d=b[c];c++){if(this.RTL){e=d.getRelativeToSurfaceXY().x;var f=
	a/this.workspace_.scale-this.MARGIN;d.outputConnection||(f-=this.tabWidth_);d.moveBy(f-e,0)}d.flyoutRect_&&this.moveRectToBlock_(d.flyoutRect_,d)}if(this.RTL)for(c=0;d=this.buttons_[c];c++)b=d.getPosition().y,d.moveTo(a/this.workspace_.scale-d.width-this.MARGIN-this.tabWidth_,b);this.width_=a;this.position()}};Blockly.FlyoutButton=function(a,b,c,d){this.workspace_=a;this.targetWorkspace_=b;this.text_=c.text;this.position_=new Blockly.utils.Coordinate(0,0);this.isLabel_=d;this.callbackKey_=c.callbackKey||c.callbackkey;this.cssClass_=c["web-class"]||null;this.onMouseUpWrapper_=null};Blockly.FlyoutButton.MARGIN_X=5;Blockly.FlyoutButton.MARGIN_Y=2;Blockly.FlyoutButton.prototype.width=0;Blockly.FlyoutButton.prototype.height=0;
	Blockly.FlyoutButton.prototype.createDom=function(){var a=this.isLabel_?"blocklyFlyoutLabel":"blocklyFlyoutButton";this.cssClass_&&(a+=" "+this.cssClass_);this.svgGroup_=Blockly.utils.dom.createSvgElement("g",{"class":a},this.workspace_.getCanvas());if(!this.isLabel_)var b=Blockly.utils.dom.createSvgElement("rect",{"class":"blocklyFlyoutButtonShadow",rx:4,ry:4,x:1,y:1},this.svgGroup_);a=Blockly.utils.dom.createSvgElement("rect",{"class":this.isLabel_?"blocklyFlyoutLabelBackground":"blocklyFlyoutButtonBackground",
	rx:4,ry:4},this.svgGroup_);var c=Blockly.utils.dom.createSvgElement("text",{"class":this.isLabel_?"blocklyFlyoutLabelText":"blocklyText",x:0,y:0,"text-anchor":"middle"},this.svgGroup_),d=Blockly.utils.replaceMessageReferences(this.text_);this.workspace_.RTL&&(d+="\u200f");c.textContent=d;this.isLabel_&&(this.svgText_=c,this.workspace_.getThemeManager().subscribe(this.svgText_,"flyoutForegroundColour","fill"));var e=Blockly.utils.style.getComputedStyle(c,"fontSize"),f=Blockly.utils.style.getComputedStyle(c,
	"fontWeight"),g=Blockly.utils.style.getComputedStyle(c,"fontFamily");this.width=Blockly.utils.dom.getFastTextWidthWithSizeString(c,e,f,g);d=Blockly.utils.dom.measureFontMetrics(d,e,f,g);this.height=d.height;this.isLabel_||(this.width+=2*Blockly.FlyoutButton.MARGIN_X,this.height+=2*Blockly.FlyoutButton.MARGIN_Y,b.setAttribute("width",this.width),b.setAttribute("height",this.height));a.setAttribute("width",this.width);a.setAttribute("height",this.height);c.setAttribute("x",this.width/2);c.setAttribute("y",
	this.height/2-d.height/2+d.baseline);this.updateTransform_();this.onMouseUpWrapper_=Blockly.bindEventWithChecks_(this.svgGroup_,"mouseup",this,this.onMouseUp_);return this.svgGroup_};Blockly.FlyoutButton.prototype.show=function(){this.updateTransform_();this.svgGroup_.setAttribute("display","block")};Blockly.FlyoutButton.prototype.updateTransform_=function(){this.svgGroup_.setAttribute("transform","translate("+this.position_.x+","+this.position_.y+")")};
	Blockly.FlyoutButton.prototype.moveTo=function(a,b){this.position_.x=a;this.position_.y=b;this.updateTransform_()};Blockly.FlyoutButton.prototype.getPosition=function(){return this.position_};Blockly.FlyoutButton.prototype.getTargetWorkspace=function(){return this.targetWorkspace_};Blockly.FlyoutButton.prototype.dispose=function(){this.onMouseUpWrapper_&&Blockly.unbindEvent_(this.onMouseUpWrapper_);this.svgGroup_&&Blockly.utils.dom.removeNode(this.svgGroup_);this.svgText_&&this.workspace_.getThemeManager().unsubscribe(this.svgText_)};
	Blockly.FlyoutButton.prototype.onMouseUp_=function(a){(a=this.targetWorkspace_.getGesture(a))&&a.cancel();this.isLabel_&&this.callbackKey_?console.warn("Labels should not have callbacks. Label text: "+this.text_):this.isLabel_||this.callbackKey_&&this.targetWorkspace_.getButtonCallback(this.callbackKey_)?this.isLabel_||this.targetWorkspace_.getButtonCallback(this.callbackKey_)(this):console.warn("Buttons should have callbacks. Button text: "+this.text_)};Blockly.Css.register(".blocklyFlyoutButton {,fill: #888;,cursor: default;,},.blocklyFlyoutButtonShadow {,fill: #666;,},.blocklyFlyoutButton:hover {,fill: #aaa;,},.blocklyFlyoutLabel {,cursor: default;,},.blocklyFlyoutLabelBackground {,opacity: 0;,}".split(","));Blockly.Generator=function(a){this.name_=a;this.FUNCTION_NAME_PLACEHOLDER_REGEXP_=new RegExp(this.FUNCTION_NAME_PLACEHOLDER_,"g")};Blockly.Generator.NAME_TYPE="generated_function";Blockly.Generator.prototype.INFINITE_LOOP_TRAP=null;Blockly.Generator.prototype.STATEMENT_PREFIX=null;Blockly.Generator.prototype.STATEMENT_SUFFIX=null;Blockly.Generator.prototype.INDENT="  ";Blockly.Generator.prototype.COMMENT_WRAP=60;Blockly.Generator.prototype.ORDER_OVERRIDES=[];
	Blockly.Generator.prototype.workspaceToCode=function(a){a||(console.warn("No workspace specified in workspaceToCode call.  Guessing."),a=Blockly.getMainWorkspace());var b=[];this.init(a);a=a.getTopBlocks(!0);for(var c=0,d;d=a[c];c++){var e=this.blockToCode(d);Array.isArray(e)&&(e=e[0]);e&&(d.outputConnection&&(e=this.scrubNakedValue(e),this.STATEMENT_PREFIX&&!d.suppressPrefixSuffix&&(e=this.injectId(this.STATEMENT_PREFIX,d)+e),this.STATEMENT_SUFFIX&&!d.suppressPrefixSuffix&&(e+=this.injectId(this.STATEMENT_SUFFIX,
	d))),b.push(e))}b=b.join("\n");b=this.finish(b);b=b.replace(/^\s+\n/,"");b=b.replace(/\n\s+$/,"\n");return b=b.replace(/[ \t]+\n/g,"\n")};Blockly.Generator.prototype.prefixLines=function(a,b){return b+a.replace(/(?!\n$)\n/g,"\n"+b)};Blockly.Generator.prototype.allNestedComments=function(a){var b=[];a=a.getDescendants(!0);for(var c=0;c<a.length;c++){var d=a[c].getCommentText();d&&b.push(d)}b.length&&b.push("");return b.join("\n")};
	Blockly.Generator.prototype.blockToCode=function(a,b){if(!a)return"";if(!a.isEnabled())return b?"":this.blockToCode(a.getNextBlock());if(a.isInsertionMarker())return b?"":this.blockToCode(a.getChildren(!1)[0]);var c=this[a.type];if("function"!=typeof c)throw Error('Language "'+this.name_+'" does not know how to generate  code for block type "'+a.type+'".');c=c.call(a,a);if(Array.isArray(c)){if(!a.outputConnection)throw TypeError("Expecting string from statement block: "+a.type);return[this.scrub_(a,
	c[0],b),c[1]]}if("string"==typeof c)return this.STATEMENT_PREFIX&&!a.suppressPrefixSuffix&&(c=this.injectId(this.STATEMENT_PREFIX,a)+c),this.STATEMENT_SUFFIX&&!a.suppressPrefixSuffix&&(c+=this.injectId(this.STATEMENT_SUFFIX,a)),this.scrub_(a,c,b);if(null===c)return"";throw SyntaxError("Invalid code generated: "+c);};
	Blockly.Generator.prototype.valueToCode=function(a,b,c){if(isNaN(c))throw TypeError("Expecting valid order from block: "+a.type);var d=a.getInputTargetBlock(b);if(!d)return"";b=this.blockToCode(d);if(""===b)return"";if(!Array.isArray(b))throw TypeError("Expecting tuple from value block: "+d.type);a=b[0];b=b[1];if(isNaN(b))throw TypeError("Expecting valid order from value block: "+d.type);if(!a)return"";d=!1;var e=Math.floor(c),f=Math.floor(b);if(e<=f&&(e!=f||0!=e&&99!=e))for(d=!0,e=0;e<this.ORDER_OVERRIDES.length;e++)if(this.ORDER_OVERRIDES[e][0]==
	c&&this.ORDER_OVERRIDES[e][1]==b){d=!1;break}d&&(a="("+a+")");return a};Blockly.Generator.prototype.statementToCode=function(a,b){a=a.getInputTargetBlock(b);b=this.blockToCode(a);if("string"!=typeof b)throw TypeError("Expecting code from statement block: "+(a&&a.type));b&&(b=this.prefixLines(b,this.INDENT));return b};
	Blockly.Generator.prototype.addLoopTrap=function(a,b){this.INFINITE_LOOP_TRAP&&(a=this.prefixLines(this.injectId(this.INFINITE_LOOP_TRAP,b),this.INDENT)+a);this.STATEMENT_SUFFIX&&!b.suppressPrefixSuffix&&(a=this.prefixLines(this.injectId(this.STATEMENT_SUFFIX,b),this.INDENT)+a);this.STATEMENT_PREFIX&&!b.suppressPrefixSuffix&&(a+=this.prefixLines(this.injectId(this.STATEMENT_PREFIX,b),this.INDENT));return a};
	Blockly.Generator.prototype.injectId=function(a,b){b=b.id.replace(/\$/g,"$$$$");return a.replace(/%1/g,"'"+b+"'")};Blockly.Generator.prototype.RESERVED_WORDS_="";Blockly.Generator.prototype.addReservedWords=function(a){this.RESERVED_WORDS_+=a+","};Blockly.Generator.prototype.FUNCTION_NAME_PLACEHOLDER_="{leCUI8hutHZI4480Dc}";
	Blockly.Generator.prototype.provideFunction_=function(a,b){if(!this.definitions_[a]){var c=this.variableDB_.getDistinctName(a,Blockly.PROCEDURE_CATEGORY_NAME);this.functionNames_[a]=c;b=b.join("\n").replace(this.FUNCTION_NAME_PLACEHOLDER_REGEXP_,c);for(var d;d!=b;)d=b,b=b.replace(/^(( {2})*) {2}/gm,"$1\x00");b=b.replace(/\0/g,this.INDENT);this.definitions_[a]=b}return this.functionNames_[a]};Blockly.Generator.prototype.init=function(a){};Blockly.Generator.prototype.scrub_=function(a,b,c){return b};
	Blockly.Generator.prototype.finish=function(a){return a};Blockly.Generator.prototype.scrubNakedValue=function(a){return a};Blockly.tree={};Blockly.tree.BaseNode=function(a,b){Blockly.Component.call(this);this.content=a;this.config_=b;this.expanded_=this.selected_=!1;this.depth_=-1};Blockly.utils.object.inherits(Blockly.tree.BaseNode,Blockly.Component);Blockly.tree.BaseNode.allNodes={};Blockly.tree.BaseNode.prototype.disposeInternal=function(){Blockly.tree.BaseNode.superClass_.disposeInternal.call(this);this.tree&&(this.tree=null);this.setElementInternal(null)};
	Blockly.tree.BaseNode.prototype.initAccessibility=function(){var a=this.getElement();if(a){var b=this.getLabelElement();b&&!b.id&&(b.id=this.getId()+".label");Blockly.utils.aria.setRole(a,Blockly.utils.aria.Role.TREEITEM);Blockly.utils.aria.setState(a,Blockly.utils.aria.State.SELECTED,!1);Blockly.utils.aria.setState(a,Blockly.utils.aria.State.LEVEL,this.getDepth());b&&Blockly.utils.aria.setState(a,Blockly.utils.aria.State.LABELLEDBY,b.id);(b=this.getIconElement())&&Blockly.utils.aria.setRole(b,Blockly.utils.aria.Role.PRESENTATION);
	if(b=this.getChildrenElement())if(Blockly.utils.aria.setRole(b,Blockly.utils.aria.Role.GROUP),b.hasChildNodes())for(Blockly.utils.aria.setState(a,Blockly.utils.aria.State.EXPANDED,!1),a=this.getChildCount(),b=1;b<=a;b++){var c=this.getChildAt(b-1).getElement();Blockly.utils.aria.setState(c,Blockly.utils.aria.State.SETSIZE,a);Blockly.utils.aria.setState(c,Blockly.utils.aria.State.POSINSET,b)}}};
	Blockly.tree.BaseNode.prototype.createDom=function(){var a=document.createElement("div");a.appendChild(this.toDom());this.setElementInternal(a)};Blockly.tree.BaseNode.prototype.enterDocument=function(){Blockly.tree.BaseNode.superClass_.enterDocument.call(this);Blockly.tree.BaseNode.allNodes[this.getId()]=this;this.initAccessibility()};Blockly.tree.BaseNode.prototype.exitDocument=function(){Blockly.tree.BaseNode.superClass_.exitDocument.call(this);delete Blockly.tree.BaseNode.allNodes[this.getId()]};
	Blockly.tree.BaseNode.prototype.addChildAt=function(a,b){var c=this.getChildAt(b-1),d=this.getChildAt(b);Blockly.tree.BaseNode.superClass_.addChildAt.call(this,a,b);a.previousSibling_=c;a.nextSibling_=d;c&&(c.nextSibling_=a);d&&(d.previousSibling_=a);(b=this.getTree())&&a.setTreeInternal(b);a.setDepth_(this.getDepth()+1);if(b=this.getElement())if(this.updateExpandIcon(),Blockly.utils.aria.setState(b,Blockly.utils.aria.State.EXPANDED,this.expanded_),this.expanded_){b=this.getChildrenElement();a.getElement()||
	a.createDom();var e=a.getElement(),f=d&&d.getElement();b.insertBefore(e,f);this.isInDocument()&&a.enterDocument();d||(c?c.updateExpandIcon():(Blockly.utils.style.setElementShown(b,!0),this.setExpanded(this.expanded_)))}};Blockly.tree.BaseNode.prototype.add=function(a){if(a.getParent())throw Error(Blockly.Component.Error.PARENT_UNABLE_TO_BE_SET);this.addChildAt(a,this.getChildCount())};Blockly.tree.BaseNode.prototype.getTree=function(){return null};
	Blockly.tree.BaseNode.prototype.getDepth=function(){var a=this.depth_;0>a&&(a=(a=this.getParent())?a.getDepth()+1:0,this.setDepth_(a));return a};Blockly.tree.BaseNode.prototype.setDepth_=function(a){if(a!=this.depth_){this.depth_=a;var b=this.getRowElement();if(b){var c=this.getPixelIndent_()+"px";this.rightToLeft_?b.style.paddingRight=c:b.style.paddingLeft=c}this.forEachChild(function(b){b.setDepth_(a+1)})}};Blockly.tree.BaseNode.prototype.contains=function(a){for(;a;){if(a==this)return!0;a=a.getParent()}return!1};
	Blockly.tree.BaseNode.prototype.getChildren=function(){var a=[];this.forEachChild(function(b){a.push(b)});return a};Blockly.tree.BaseNode.prototype.getParent=function(){return Blockly.tree.BaseNode.superClass_.getParent.call(this)};Blockly.tree.BaseNode.prototype.getPreviousSibling=function(){return this.previousSibling_};Blockly.tree.BaseNode.prototype.getNextSibling=function(){return this.nextSibling_};Blockly.tree.BaseNode.prototype.isLastSibling=function(){return!this.nextSibling_};
	Blockly.tree.BaseNode.prototype.isSelected=function(){return this.selected_};Blockly.tree.BaseNode.prototype.select=function(){var a=this.getTree();a&&a.setSelectedItem(this)};Blockly.tree.BaseNode.prototype.setSelected=function(a){if(this.selected_!=a){this.selected_=a;this.updateRow();var b=this.getElement();b&&(Blockly.utils.aria.setState(b,Blockly.utils.aria.State.SELECTED,a),a&&(a=this.getTree().getElement(),Blockly.utils.aria.setState(a,Blockly.utils.aria.State.ACTIVEDESCENDANT,this.getId())))}};
	Blockly.tree.BaseNode.prototype.setExpanded=function(a){var b=a!=this.expanded_,c;this.expanded_=a;var d=this.getTree(),e=this.getElement();if(this.hasChildren()){if(!a&&d&&this.contains(d.getSelectedItem())&&this.select(),e){if(c=this.getChildrenElement())Blockly.utils.style.setElementShown(c,a),Blockly.utils.aria.setState(e,Blockly.utils.aria.State.EXPANDED,a),a&&this.isInDocument()&&!c.hasChildNodes()&&(this.forEachChild(function(a){c.appendChild(a.toDom())}),this.forEachChild(function(a){a.enterDocument()}));
	this.updateExpandIcon()}}else(c=this.getChildrenElement())&&Blockly.utils.style.setElementShown(c,!1);e&&this.updateIcon_();b&&(a?this.doNodeExpanded():this.doNodeCollapsed())};Blockly.tree.BaseNode.prototype.doNodeExpanded=function(){};Blockly.tree.BaseNode.prototype.doNodeCollapsed=function(){};Blockly.tree.BaseNode.prototype.toggle=function(){this.setExpanded(!this.expanded_)};
	Blockly.tree.BaseNode.prototype.toDom=function(){var a=this.expanded_&&this.hasChildren(),b=document.createElement("div");b.style.backgroundPosition=this.getBackgroundPosition();a||(b.style.display="none");a&&this.forEachChild(function(a){b.appendChild(a.toDom())});a=document.createElement("div");a.id=this.getId();a.appendChild(this.getRowDom());a.appendChild(b);return a};Blockly.tree.BaseNode.prototype.getPixelIndent_=function(){return Math.max(0,(this.getDepth()-1)*this.config_.indentWidth)};
	Blockly.tree.BaseNode.prototype.getRowDom=function(){var a=document.createElement("div");a.className=this.getRowClassName();a.style["padding-"+(this.rightToLeft_?"right":"left")]=this.getPixelIndent_()+"px";a.appendChild(this.getIconDom());a.appendChild(this.getLabelDom());return a};Blockly.tree.BaseNode.prototype.getRowClassName=function(){var a="";this.isSelected()&&(a=" "+(this.config_.cssSelectedRow||""));return this.config_.cssTreeRow+a};
	Blockly.tree.BaseNode.prototype.getLabelDom=function(){var a=document.createElement("span");a.className=this.config_.cssItemLabel||"";a.textContent=this.content;return a};Blockly.tree.BaseNode.prototype.getIconDom=function(){var a=document.createElement("span");a.style.display="inline-block";a.className=this.getCalculatedIconClass();return a};Blockly.tree.BaseNode.prototype.getCalculatedIconClass=function(){throw Error(Blockly.Component.Error.ABSTRACT_METHOD);};
	Blockly.tree.BaseNode.prototype.getBackgroundPosition=function(){return(this.isLastSibling()?"-100":(this.getDepth()-1)*this.config_.indentWidth)+"px 0"};Blockly.tree.BaseNode.prototype.getElement=function(){var a=Blockly.tree.BaseNode.superClass_.getElement.call(this);a||(a=document.getElementById(this.getId()),this.setElementInternal(a));return a};Blockly.tree.BaseNode.prototype.getRowElement=function(){var a=this.getElement();return a?a.firstChild:null};
	Blockly.tree.BaseNode.prototype.getIconElement=function(){var a=this.getRowElement();return a?a.firstChild:null};Blockly.tree.BaseNode.prototype.getLabelElement=function(){var a=this.getRowElement();return a&&a.lastChild?a.lastChild.previousSibling:null};Blockly.tree.BaseNode.prototype.getChildrenElement=function(){var a=this.getElement();return a?a.lastChild:null};Blockly.tree.BaseNode.prototype.updateRow=function(){var a=this.getRowElement();a&&(a.className=this.getRowClassName())};
	Blockly.tree.BaseNode.prototype.updateExpandIcon=function(){var a=this.getChildrenElement();a&&(a.style.backgroundPosition=this.getBackgroundPosition())};Blockly.tree.BaseNode.prototype.updateIcon_=function(){this.getIconElement().className=this.getCalculatedIconClass()};Blockly.tree.BaseNode.prototype.onClick_=function(a){a.preventDefault()};
	Blockly.tree.BaseNode.prototype.onKeyDown=function(a){switch(a.keyCode){case Blockly.utils.KeyCodes.RIGHT:var b=this.selectChild();break;case Blockly.utils.KeyCodes.LEFT:b=this.selectParent();break;case Blockly.utils.KeyCodes.DOWN:b=this.selectNext();break;case Blockly.utils.KeyCodes.UP:b=this.selectPrevious();break;case Blockly.utils.KeyCodes.ENTER:case Blockly.utils.KeyCodes.SPACE:this.toggle();b=!0;break;default:b=!1}b&&a.preventDefault();return b};
	Blockly.tree.BaseNode.prototype.selectNext=function(){var a=this.getNextShownNode();a&&a.select();return!0};Blockly.tree.BaseNode.prototype.selectPrevious=function(){var a=this.getPreviousShownNode();a&&a.select();return!0};Blockly.tree.BaseNode.prototype.selectParent=function(){if(this.hasChildren()&&this.expanded_)this.setExpanded(!1);else{var a=this.getParent(),b=this.getTree();a&&a!=b&&a.select()}return!0};
	Blockly.tree.BaseNode.prototype.selectChild=function(){return this.hasChildren()?(this.expanded_?this.getChildAt(0).select():this.setExpanded(!0),!0):!1};Blockly.tree.BaseNode.prototype.getLastShownDescendant=function(){return this.expanded_&&this.hasChildren()?this.getChildAt(this.getChildCount()-1).getLastShownDescendant():this};
	Blockly.tree.BaseNode.prototype.getNextShownNode=function(){if(this.hasChildren()&&this.expanded_)return this.getChildAt(0);for(var a=this,b;a!=this.getTree();){b=a.getNextSibling();if(null!=b)return b;a=a.getParent()}return null};Blockly.tree.BaseNode.prototype.getPreviousShownNode=function(){var a=this.getPreviousSibling();if(null!=a)return a.getLastShownDescendant();a=this.getParent();var b=this.getTree();return a==b||this==b?null:a};
	Blockly.tree.BaseNode.prototype.setTreeInternal=function(a){this.tree!=a&&(this.tree=a,this.forEachChild(function(b){b.setTreeInternal(a)}))};Blockly.tree.TreeNode=function(a,b,c){this.toolbox_=a;Blockly.tree.BaseNode.call(this,b,c);this.onSizeChanged_=null};Blockly.utils.object.inherits(Blockly.tree.TreeNode,Blockly.tree.BaseNode);Blockly.tree.TreeNode.prototype.getTree=function(){if(this.tree)return this.tree;var a=this.getParent();return a&&(a=a.getTree())?(this.setTreeInternal(a),a):null};
	Blockly.tree.TreeNode.prototype.getCalculatedIconClass=function(){var a=this.expanded_;if(a&&this.expandedIconClass)return this.expandedIconClass;var b=this.iconClass;if(!a&&b)return b;b=this.config_;if(this.hasChildren()){if(a&&b.cssExpandedFolderIcon)return b.cssTreeIcon+" "+b.cssExpandedFolderIcon;if(!a&&b.cssCollapsedFolderIcon)return b.cssTreeIcon+" "+b.cssCollapsedFolderIcon}else if(b.cssFileIcon)return b.cssTreeIcon+" "+b.cssFileIcon;return""};
	Blockly.tree.TreeNode.prototype.onClick_=function(a){this.hasChildren()?(this.toggle(),this.select()):this.isSelected()?this.getTree().setSelectedItem(null):this.select();this.updateRow()};
	Blockly.tree.TreeNode.prototype.onKeyDown=function(a){if(this.tree.toolbox_.horizontalLayout_){var b={},c=Blockly.utils.KeyCodes.DOWN,d=Blockly.utils.KeyCodes.UP;b[Blockly.utils.KeyCodes.RIGHT]=this.rightToLeft_?d:c;b[Blockly.utils.KeyCodes.LEFT]=this.rightToLeft_?c:d;b[Blockly.utils.KeyCodes.UP]=Blockly.utils.KeyCodes.LEFT;b[Blockly.utils.KeyCodes.DOWN]=Blockly.utils.KeyCodes.RIGHT;Object.defineProperties(a,{keyCode:{value:b[a.keyCode]||a.keyCode}})}return Blockly.tree.TreeNode.superClass_.onKeyDown.call(this,
	a)};Blockly.tree.TreeNode.prototype.onSizeChanged=function(a){this.onSizeChanged_=a};Blockly.tree.TreeNode.prototype.resizeToolbox_=function(){this.onSizeChanged_&&this.onSizeChanged_.call(this.toolbox_)};Blockly.tree.TreeNode.prototype.doNodeExpanded=Blockly.tree.TreeNode.prototype.resizeToolbox_;Blockly.tree.TreeNode.prototype.doNodeCollapsed=Blockly.tree.TreeNode.prototype.resizeToolbox_;Blockly.tree.TreeControl=function(a,b){this.toolbox_=a;this.onKeydownWrapper_=this.onClickWrapper_=null;Blockly.tree.BaseNode.call(this,"",b);this.selected_=this.expanded_=!0;this.selectedItem_=this;this.onAfterSelected_=this.onBeforeSelected_=null};Blockly.utils.object.inherits(Blockly.tree.TreeControl,Blockly.tree.BaseNode);Blockly.tree.TreeControl.prototype.getTree=function(){return this};Blockly.tree.TreeControl.prototype.getToolbox=function(){return this.toolbox_};
	Blockly.tree.TreeControl.prototype.getDepth=function(){return 0};Blockly.tree.TreeControl.prototype.setExpanded=function(a){this.expanded_=a};Blockly.tree.TreeControl.prototype.getIconElement=function(){var a=this.getRowElement();return a?a.firstChild:null};Blockly.tree.TreeControl.prototype.updateExpandIcon=function(){};Blockly.tree.TreeControl.prototype.getRowClassName=function(){return Blockly.tree.TreeControl.superClass_.getRowClassName.call(this)+" "+this.config_.cssHideRoot};
	Blockly.tree.TreeControl.prototype.getCalculatedIconClass=function(){var a=this.expanded_;if(a&&this.expandedIconClass)return this.expandedIconClass;var b=this.iconClass;return!a&&b?b:""};
	Blockly.tree.TreeControl.prototype.setSelectedItem=function(a){if(a!=this.selectedItem_&&(!this.onBeforeSelected_||this.onBeforeSelected_.call(this.toolbox_,a))){var b=this.getSelectedItem();this.selectedItem_&&this.selectedItem_.setSelected(!1);(this.selectedItem_=a)&&a.setSelected(!0);this.onAfterSelected_&&this.onAfterSelected_.call(this.toolbox_,b,a)}};Blockly.tree.TreeControl.prototype.onBeforeSelected=function(a){this.onBeforeSelected_=a};
	Blockly.tree.TreeControl.prototype.onAfterSelected=function(a){this.onAfterSelected_=a};Blockly.tree.TreeControl.prototype.getSelectedItem=function(){return this.selectedItem_};Blockly.tree.TreeControl.prototype.initAccessibility=function(){Blockly.tree.TreeControl.superClass_.initAccessibility.call(this);var a=this.getElement();Blockly.utils.aria.setRole(a,Blockly.utils.aria.Role.TREE);Blockly.utils.aria.setState(a,Blockly.utils.aria.State.LABELLEDBY,this.getLabelElement().id)};
	Blockly.tree.TreeControl.prototype.enterDocument=function(){Blockly.tree.TreeControl.superClass_.enterDocument.call(this);var a=this.getElement();a.className=this.config_.cssRoot;a.setAttribute("hideFocus","true");this.attachEvents_();this.initAccessibility()};Blockly.tree.TreeControl.prototype.exitDocument=function(){Blockly.tree.TreeControl.superClass_.exitDocument.call(this);this.detachEvents_()};
	Blockly.tree.TreeControl.prototype.attachEvents_=function(){var a=this.getElement();a.tabIndex=0;this.onClickWrapper_=Blockly.bindEventWithChecks_(a,"click",this,this.handleMouseEvent_);this.onKeydownWrapper_=Blockly.bindEvent_(a,"keydown",this,this.handleKeyEvent_)};
	Blockly.tree.TreeControl.prototype.detachEvents_=function(){this.onClickWrapper_&&(Blockly.unbindEvent_(this.onClickWrapper_),this.onClickWrapper_=null);this.onKeydownWrapper_&&(Blockly.unbindEvent_(this.onKeydownWrapper_),this.onKeydownWrapper_=null)};Blockly.tree.TreeControl.prototype.handleMouseEvent_=function(a){var b=this.getNodeFromEvent_(a);if(b&&"click"==a.type)b.onClick_(a)};
	Blockly.tree.TreeControl.prototype.handleKeyEvent_=function(a){var b=!(!this.selectedItem_||!this.selectedItem_.onKeyDown(a));b&&(Blockly.utils.style.scrollIntoContainerView(this.selectedItem_.getElement(),this.getElement().parentNode),a.preventDefault());return b};Blockly.tree.TreeControl.prototype.getNodeFromEvent_=function(a){for(var b=a.target;b;){if(a=Blockly.tree.BaseNode.allNodes[b.id])return a;if(b==this.getElement())break;if(b.getAttribute("role")==Blockly.utils.aria.Role.GROUP)break;b=b.parentNode}return null};
	Blockly.tree.TreeControl.prototype.createNode=function(a){return new Blockly.tree.TreeNode(this.toolbox_,a||"",this.config_)};Blockly.Toolbox=function(a){this.workspace_=a;this.RTL=a.options.RTL;this.horizontalLayout_=a.options.horizontalLayout;this.toolboxPosition=a.options.toolboxPosition;this.config_={indentWidth:19,cssRoot:"blocklyTreeRoot",cssHideRoot:"blocklyHidden",cssTreeRow:"blocklyTreeRow",cssItemLabel:"blocklyTreeLabel",cssTreeIcon:"blocklyTreeIcon",cssExpandedFolderIcon:"blocklyTreeIconOpen",cssFileIcon:"blocklyTreeIconNone",cssSelectedRow:"blocklyTreeSelected"};this.treeSeparatorConfig_={cssTreeRow:"blocklyTreeSeparator"};
	this.horizontalLayout_&&(this.config_.cssTreeRow+=a.RTL?" blocklyHorizontalTreeRtl":" blocklyHorizontalTree",this.treeSeparatorConfig_.cssTreeRow="blocklyTreeSeparatorHorizontal "+(a.RTL?"blocklyHorizontalTreeRtl":"blocklyHorizontalTree"),this.config_.cssTreeIcon="");this.flyout_=null;this.height=this.width=0;this.lastCategory_=null};
	Blockly.Toolbox.prototype.init=function(){var a=this.workspace_,b=this.workspace_.getParentSvg();this.HtmlDiv=document.createElement("div");this.HtmlDiv.className="blocklyToolboxDiv blocklyNonSelectable";this.HtmlDiv.setAttribute("dir",a.RTL?"RTL":"LTR");b.parentNode.insertBefore(this.HtmlDiv,b);var c=a.getThemeManager();c.subscribe(this.HtmlDiv,"toolboxBackgroundColour","background-color");c.subscribe(this.HtmlDiv,"toolboxForegroundColour","color");Blockly.bindEventWithChecks_(this.HtmlDiv,"mousedown",
	this,function(a){Blockly.utils.isRightButton(a)||a.target==this.HtmlDiv?Blockly.hideChaff(!1):Blockly.hideChaff(!0);Blockly.Touch.clearTouchIdentifier()},!1,!0);c=new Blockly.Options({parentWorkspace:a,rtl:a.RTL,oneBasedIndex:a.options.oneBasedIndex,horizontalLayout:a.horizontalLayout,renderer:a.options.renderer,rendererOverrides:a.options.rendererOverrides});c.toolboxPosition=a.options.toolboxPosition;if(a.horizontalLayout){if(!Blockly.HorizontalFlyout)throw Error("Missing require for Blockly.HorizontalFlyout");
	this.flyout_=new Blockly.HorizontalFlyout(c)}else{if(!Blockly.VerticalFlyout)throw Error("Missing require for Blockly.VerticalFlyout");this.flyout_=new Blockly.VerticalFlyout(c)}if(!this.flyout_)throw Error("One of Blockly.VerticalFlyout or Blockly.Horizontal must berequired.");Blockly.utils.dom.insertAfter(this.flyout_.createDom("svg"),b);this.flyout_.init(a);this.config_.cssCollapsedFolderIcon="blocklyTreeIconClosed"+(a.RTL?"Rtl":"Ltr");this.render(a.options.languageTree)};
	Blockly.Toolbox.prototype.render=function(a){this.tree_&&(this.tree_.dispose(),this.lastCategory_=null);var b=new Blockly.tree.TreeControl(this,this.config_);this.tree_=b;b.setSelectedItem(null);b.onBeforeSelected(this.handleBeforeTreeSelected_);b.onAfterSelected(this.handleAfterTreeSelected_);var c=null;if(a){this.tree_.contents=[];this.hasColours_=!1;c=this.createTree_(a,this.tree_);if(this.tree_.contents.length)throw Error("Toolbox cannot have both blocks and categories in the root level.");this.workspace_.resizeContents()}b.render(this.HtmlDiv);
	c&&b.setSelectedItem(c);this.addColour_();this.position();this.horizontalLayout_&&Blockly.utils.aria.setState(this.tree_.getElement(),Blockly.utils.aria.State.ORIENTATION,"horizontal")};
	Blockly.Toolbox.prototype.createTree_=function(a,b){var c=null,d=null;if(!a)return null;for(var e=0,f;f=a[e];e++)switch(f.kind.toUpperCase()){case "CATEGORY":c=this.addCategory_(f,b)||c;d=f;break;case "SEP":d=this.addSeparator_(f,b,d)||d;break;case "BLOCK":case "SHADOW":case "LABEL":case "BUTTON":b.contents.push(f),d=f}return c};
	Blockly.Toolbox.prototype.addCategory_=function(a,b){var c=null,d=Blockly.utils.replaceMessageReferences(a.name),e=this.tree_.createNode(d);e.onSizeChanged(this.handleNodeSizeChanged_);e.contents=[];b.add(e);(b=a.custom)?e.contents=b:c=this.createTree_(a.contents,e)||c;this.setColourOrStyle_(a,e,d);return c=this.setExpanded_(a,e)||c};
	Blockly.Toolbox.prototype.setColourOrStyle_=function(a,b,c){var d=a.categorystyle;(a=a.colour)&&d?(b.hexColour="",console.warn('Toolbox category "'+c+'" must not have both a style and a colour')):d?this.setColourFromStyle_(d,b,c):this.setColour_(a,b,c)};Blockly.Toolbox.prototype.addSeparator_=function(a,b,c){if(c&&"CATEGORY"==c.kind.toUpperCase())b.add(new Blockly.Toolbox.TreeSeparator(this.treeSeparatorConfig_));else return b.contents.push(a),a;return null};
	Blockly.Toolbox.prototype.setExpanded_=function(a,b){var c=null;"true"==a.expanded?(b.contents.length&&(c=b),b.setExpanded(!0)):b.setExpanded(!1);return c};Blockly.Toolbox.prototype.handleBeforeTreeSelected_=function(a){if(a==this.tree_)return!1;this.lastCategory_&&(this.lastCategory_.getRowElement().style.backgroundColor="");if(a){var b=a.hexColour||"#57e";a.getRowElement().style.backgroundColor=b;this.addColour_(a)}return!0};
	Blockly.Toolbox.prototype.handleAfterTreeSelected_=function(a,b){b&&b.contents&&b.contents.length?(this.flyout_.show(b.contents),this.lastCategory_!=b&&this.flyout_.scrollToStart(),this.workspace_.keyboardAccessibilityMode&&Blockly.navigation.setState(Blockly.navigation.STATE_TOOLBOX)):(this.flyout_.hide(),!this.workspace_.keyboardAccessibilityMode||b instanceof Blockly.Toolbox.TreeSeparator||Blockly.navigation.setState(Blockly.navigation.STATE_WS));a!=b&&a!=this&&(a=new Blockly.Events.Ui(null,"category",
	a&&a.content,b&&b.content),a.workspaceId=this.workspace_.id,Blockly.Events.fire(a));b&&(this.lastCategory_=b)};Blockly.Toolbox.prototype.handleNodeSizeChanged_=function(){Blockly.svgResize(this.workspace_)};
	Blockly.Toolbox.prototype.onBlocklyAction=function(a){var b=this.tree_.getSelectedItem();if(!b)return!1;switch(a.name){case Blockly.navigation.actionNames.PREVIOUS:return b.selectPrevious();case Blockly.navigation.actionNames.OUT:return b.selectParent();case Blockly.navigation.actionNames.NEXT:return b.selectNext();case Blockly.navigation.actionNames.IN:return b.selectChild();default:return!1}};
	Blockly.Toolbox.prototype.dispose=function(){this.flyout_.dispose();this.tree_.dispose();this.workspace_.getThemeManager().unsubscribe(this.HtmlDiv);Blockly.utils.dom.removeNode(this.HtmlDiv);this.lastCategory_=null};Blockly.Toolbox.prototype.setVisible=function(a){this.HtmlDiv.style.display=a?"block":"none"};Blockly.Toolbox.prototype.getWidth=function(){return this.width};Blockly.Toolbox.prototype.getHeight=function(){return this.height};Blockly.Toolbox.prototype.getFlyout=function(){return this.flyout_};
	Blockly.Toolbox.prototype.position=function(){var a=this.HtmlDiv;if(a){var b=Blockly.svgSize(this.workspace_.getParentSvg());this.horizontalLayout_?(a.style.left="0",a.style.height="auto",a.style.width=b.width+"px",this.height=a.offsetHeight,this.toolboxPosition==Blockly.TOOLBOX_AT_TOP?a.style.top="0":a.style.bottom="0"):(this.toolboxPosition==Blockly.TOOLBOX_AT_RIGHT?a.style.right="0":a.style.left="0",a.style.height=b.height+"px",this.width=a.offsetWidth);this.flyout_.position()}};
	Blockly.Toolbox.prototype.setColour_=function(a,b,c){a=Blockly.utils.replaceMessageReferences(a);if(null===a||""===a)b.hexColour="";else{var d=Number(a);isNaN(d)?(d=Blockly.utils.colour.parse(a))?(b.hexColour=d,this.hasColours_=!0):(b.hexColour="",console.warn('Toolbox category "'+c+'" has unrecognized colour attribute: '+a)):(b.hexColour=Blockly.hueToHex(d),this.hasColours_=!0)}};
	Blockly.Toolbox.prototype.setColourFromStyle_=function(a,b,c){b.styleName=a;var d=this.workspace_.getTheme();a&&d&&((d=d.categoryStyles[a])&&d.colour?this.setColour_(d.colour,b,c):console.warn('Style "'+a+'" must exist and contain a colour value'))};Blockly.Toolbox.prototype.updateColourFromTheme_=function(a){if(a=a||this.tree_){a=a.getChildren(!1);for(var b=0,c;c=a[b];b++)c.styleName&&(this.setColourFromStyle_(c.styleName,c,""),this.addColour_()),this.updateColourFromTheme_(c)}};
	Blockly.Toolbox.prototype.refreshTheme=function(){var a=this.tree_;a&&(this.updateColourFromTheme_(a),this.updateSelectedItemColour_(a))};Blockly.Toolbox.prototype.updateSelectedItemColour_=function(a){if(a=a.getSelectedItem()){var b=a.hexColour||"#57e";a.getRowElement().style.backgroundColor=b;this.addColour_(a)}};
	Blockly.Toolbox.prototype.addColour_=function(a){a=(a||this.tree_).getChildren(!1);for(var b=0,c;c=a[b];b++){var d=c.getRowElement();if(d){var e=this.hasColours_?"8px solid "+(c.hexColour||"#ddd"):"none";this.workspace_.RTL?d.style.borderRight=e:d.style.borderLeft=e}this.addColour_(c)}};Blockly.Toolbox.prototype.clearSelection=function(){this.tree_.setSelectedItem(null)};Blockly.Toolbox.prototype.addStyle=function(a){Blockly.utils.dom.addClass(this.HtmlDiv,a)};
	Blockly.Toolbox.prototype.removeStyle=function(a){Blockly.utils.dom.removeClass(this.HtmlDiv,a)};
	Blockly.Toolbox.prototype.getClientRect=function(){if(!this.HtmlDiv)return null;var a=this.HtmlDiv.getBoundingClientRect(),b=a.top,c=b+a.height,d=a.left;a=d+a.width;return this.toolboxPosition==Blockly.TOOLBOX_AT_TOP?new Blockly.utils.Rect(-1E7,c,-1E7,1E7):this.toolboxPosition==Blockly.TOOLBOX_AT_BOTTOM?new Blockly.utils.Rect(b,1E7,-1E7,1E7):this.toolboxPosition==Blockly.TOOLBOX_AT_LEFT?new Blockly.utils.Rect(-1E7,1E7,-1E7,a):new Blockly.utils.Rect(-1E7,1E7,d,1E7)};
	Blockly.Toolbox.prototype.refreshSelection=function(){var a=this.tree_.getSelectedItem();a&&a.contents&&this.flyout_.show(a.contents)};Blockly.Toolbox.prototype.selectFirstCategory=function(){this.tree_.getSelectedItem()||this.tree_.selectChild()};Blockly.Toolbox.TreeSeparator=function(a){Blockly.tree.TreeNode.call(this,null,"",a)};Blockly.utils.object.inherits(Blockly.Toolbox.TreeSeparator,Blockly.tree.TreeNode);
	Blockly.Css.register([".blocklyToolboxDelete {",'cursor: url("<<<PATH>>>/handdelete.cur"), auto;',"}",".blocklyToolboxGrab {",'cursor: url("<<<PATH>>>/handclosed.cur"), auto;',"cursor: grabbing;","cursor: -webkit-grabbing;","}",".blocklyToolboxDiv {","background-color: #ddd;","overflow-x: visible;","overflow-y: auto;","position: absolute;","z-index: 70;","-webkit-tap-highlight-color: transparent;","}",".blocklyTreeRoot {","padding: 4px 0;","}",".blocklyTreeRoot:focus {","outline: none;","}",".blocklyTreeRow {",
	"height: 22px;","line-height: 22px;","margin-bottom: 3px;","padding-right: 8px;","white-space: nowrap;","}",".blocklyHorizontalTree {","float: left;","margin: 1px 5px 8px 0;","}",".blocklyHorizontalTreeRtl {","float: right;","margin: 1px 0 8px 5px;","}",'.blocklyToolboxDiv[dir="RTL"] .blocklyTreeRow {',"margin-left: 8px;","}",".blocklyTreeRow:not(.blocklyTreeSelected):hover {","background-color: rgba(255, 255, 255, 0.2);","}",".blocklyTreeSeparator {","border-bottom: solid #e5e5e5 1px;","height: 0;",
	"margin: 5px 0;","}",".blocklyTreeSeparatorHorizontal {","border-right: solid #e5e5e5 1px;","width: 0;","padding: 5px 0;","margin: 0 5px;","}",".blocklyTreeIcon {","background-image: url(<<<PATH>>>/sprites.png);","height: 16px;","vertical-align: middle;","width: 16px;","}",".blocklyTreeIconClosedLtr {","background-position: -32px -1px;","}",".blocklyTreeIconClosedRtl {","background-position: 0 -1px;","}",".blocklyTreeIconOpen {","background-position: -16px -1px;","}",".blocklyTreeSelected>.blocklyTreeIconClosedLtr {",
	"background-position: -32px -17px;","}",".blocklyTreeSelected>.blocklyTreeIconClosedRtl {","background-position: 0 -17px;","}",".blocklyTreeSelected>.blocklyTreeIconOpen {","background-position: -16px -17px;","}",".blocklyTreeIconNone,",".blocklyTreeSelected>.blocklyTreeIconNone {","background-position: -48px -1px;","}",".blocklyTreeLabel {","cursor: default;","font: 16px sans-serif;","padding: 0 3px;","vertical-align: middle;","}",".blocklyToolboxDelete .blocklyTreeLabel {",'cursor: url("<<<PATH>>>/handdelete.cur"), auto;',
	"}",".blocklyTreeSelected .blocklyTreeLabel {","color: #fff;","}"]);Blockly.registry.register(Blockly.registry.Type.TOOLBOX,Blockly.registry.DEFAULT,Blockly.Toolbox);Blockly.Trashcan=function(a){this.workspace_=a;this.contents_=[];this.flyout=null;if(!(0>=this.workspace_.options.maxTrashcanContents)){a=new Blockly.Options({scrollbars:!0,parentWorkspace:this.workspace_,rtl:this.workspace_.RTL,oneBasedIndex:this.workspace_.options.oneBasedIndex,renderer:this.workspace_.options.renderer,rendererOverrides:this.workspace_.options.rendererOverrides});if(this.workspace_.horizontalLayout){a.toolboxPosition=this.workspace_.toolboxPosition==Blockly.TOOLBOX_AT_TOP?Blockly.TOOLBOX_AT_BOTTOM:
	Blockly.TOOLBOX_AT_TOP;if(!Blockly.HorizontalFlyout)throw Error("Missing require for Blockly.HorizontalFlyout");this.flyout=new Blockly.HorizontalFlyout(a)}else{a.toolboxPosition=this.workspace_.toolboxPosition==Blockly.TOOLBOX_AT_RIGHT?Blockly.TOOLBOX_AT_LEFT:Blockly.TOOLBOX_AT_RIGHT;if(!Blockly.VerticalFlyout)throw Error("Missing require for Blockly.VerticalFlyout");this.flyout=new Blockly.VerticalFlyout(a)}this.workspace_.addChangeListener(this.onDelete_.bind(this))}};
	Blockly.Trashcan.prototype.WIDTH_=47;Blockly.Trashcan.prototype.BODY_HEIGHT_=44;Blockly.Trashcan.prototype.LID_HEIGHT_=16;Blockly.Trashcan.prototype.MARGIN_BOTTOM_=20;Blockly.Trashcan.prototype.MARGIN_SIDE_=20;Blockly.Trashcan.prototype.MARGIN_HOTSPOT_=10;Blockly.Trashcan.prototype.SPRITE_LEFT_=0;Blockly.Trashcan.prototype.SPRITE_TOP_=32;Blockly.Trashcan.prototype.HAS_BLOCKS_LID_ANGLE_=.1;Blockly.Trashcan.ANIMATION_LENGTH_=80;Blockly.Trashcan.ANIMATION_FRAMES_=4;Blockly.Trashcan.OPACITY_MIN_=.4;
	Blockly.Trashcan.OPACITY_MAX_=.8;Blockly.Trashcan.MAX_LID_ANGLE_=45;Blockly.Trashcan.prototype.isOpen=!1;Blockly.Trashcan.prototype.minOpenness_=0;Blockly.Trashcan.prototype.svgGroup_=null;Blockly.Trashcan.prototype.svgLid_=null;Blockly.Trashcan.prototype.lidTask_=0;Blockly.Trashcan.prototype.lidOpen_=0;Blockly.Trashcan.prototype.left_=0;Blockly.Trashcan.prototype.top_=0;
	Blockly.Trashcan.prototype.createDom=function(){this.svgGroup_=Blockly.utils.dom.createSvgElement("g",{"class":"blocklyTrash"},null);var a=String(Math.random()).substring(2);var b=Blockly.utils.dom.createSvgElement("clipPath",{id:"blocklyTrashBodyClipPath"+a},this.svgGroup_);Blockly.utils.dom.createSvgElement("rect",{width:this.WIDTH_,height:this.BODY_HEIGHT_,y:this.LID_HEIGHT_},b);var c=Blockly.utils.dom.createSvgElement("image",{width:Blockly.SPRITE.width,x:-this.SPRITE_LEFT_,height:Blockly.SPRITE.height,
	y:-this.SPRITE_TOP_,"clip-path":"url(#blocklyTrashBodyClipPath"+a+")"},this.svgGroup_);c.setAttributeNS(Blockly.utils.dom.XLINK_NS,"xlink:href",this.workspace_.options.pathToMedia+Blockly.SPRITE.url);b=Blockly.utils.dom.createSvgElement("clipPath",{id:"blocklyTrashLidClipPath"+a},this.svgGroup_);Blockly.utils.dom.createSvgElement("rect",{width:this.WIDTH_,height:this.LID_HEIGHT_},b);this.svgLid_=Blockly.utils.dom.createSvgElement("image",{width:Blockly.SPRITE.width,x:-this.SPRITE_LEFT_,height:Blockly.SPRITE.height,
	y:-this.SPRITE_TOP_,"clip-path":"url(#blocklyTrashLidClipPath"+a+")"},this.svgGroup_);this.svgLid_.setAttributeNS(Blockly.utils.dom.XLINK_NS,"xlink:href",this.workspace_.options.pathToMedia+Blockly.SPRITE.url);Blockly.bindEventWithChecks_(this.svgGroup_,"mouseup",this,this.click);Blockly.bindEvent_(c,"mouseover",this,this.mouseOver_);Blockly.bindEvent_(c,"mouseout",this,this.mouseOut_);this.animateLid_();return this.svgGroup_};
	Blockly.Trashcan.prototype.init=function(a){0<this.workspace_.options.maxTrashcanContents&&(Blockly.utils.dom.insertAfter(this.flyout.createDom("svg"),this.workspace_.getParentSvg()),this.flyout.init(this.workspace_));this.verticalSpacing_=this.MARGIN_BOTTOM_+a;this.setOpen(!1);return this.verticalSpacing_+this.BODY_HEIGHT_+this.LID_HEIGHT_};
	Blockly.Trashcan.prototype.dispose=function(){this.svgGroup_&&(Blockly.utils.dom.removeNode(this.svgGroup_),this.svgGroup_=null);this.workspace_=this.svgLid_=null;clearTimeout(this.lidTask_)};Blockly.Trashcan.prototype.contentsIsOpen=function(){return this.flyout.isVisible()};Blockly.Trashcan.prototype.emptyContents=function(){this.contents_.length&&(this.contents_.length=0,this.setMinOpenness_(0),this.contentsIsOpen()&&this.flyout.hide())};
	Blockly.Trashcan.prototype.position=function(){if(this.verticalSpacing_){var a=this.workspace_.getMetrics();a&&(this.left_=a.toolboxPosition==Blockly.TOOLBOX_AT_LEFT||this.workspace_.horizontalLayout&&!this.workspace_.RTL?a.viewWidth+a.absoluteLeft-this.WIDTH_-this.MARGIN_SIDE_-Blockly.Scrollbar.scrollbarThickness:this.MARGIN_SIDE_+Blockly.Scrollbar.scrollbarThickness,this.top_=a.toolboxPosition==Blockly.TOOLBOX_AT_BOTTOM?this.verticalSpacing_:a.viewHeight+a.absoluteTop-(this.BODY_HEIGHT_+this.LID_HEIGHT_)-
	this.verticalSpacing_,this.svgGroup_.setAttribute("transform","translate("+this.left_+","+this.top_+")"))}};Blockly.Trashcan.prototype.getClientRect=function(){if(!this.svgGroup_)return null;var a=this.svgGroup_.getBoundingClientRect(),b=a.top+this.SPRITE_TOP_-this.MARGIN_HOTSPOT_;a=a.left+this.SPRITE_LEFT_-this.MARGIN_HOTSPOT_;return new Blockly.utils.Rect(b,b+this.LID_HEIGHT_+this.BODY_HEIGHT_+2*this.MARGIN_HOTSPOT_,a,a+this.WIDTH_+2*this.MARGIN_HOTSPOT_)};
	Blockly.Trashcan.prototype.setOpen=function(a){this.isOpen!=a&&(clearTimeout(this.lidTask_),this.isOpen=a,this.animateLid_())};
	Blockly.Trashcan.prototype.animateLid_=function(){var a=Blockly.Trashcan.ANIMATION_FRAMES_,b=1/(a+1);this.lidOpen_+=this.isOpen?b:-b;this.lidOpen_=Math.min(Math.max(this.lidOpen_,this.minOpenness_),1);this.setLidAngle_(this.lidOpen_*Blockly.Trashcan.MAX_LID_ANGLE_);b=Blockly.Trashcan.OPACITY_MIN_;this.svgGroup_.style.opacity=b+this.lidOpen_*(Blockly.Trashcan.OPACITY_MAX_-b);this.lidOpen_>this.minOpenness_&&1>this.lidOpen_&&(this.lidTask_=setTimeout(this.animateLid_.bind(this),Blockly.Trashcan.ANIMATION_LENGTH_/
	a))};Blockly.Trashcan.prototype.setLidAngle_=function(a){var b=this.workspace_.toolboxPosition==Blockly.TOOLBOX_AT_RIGHT||this.workspace_.horizontalLayout&&this.workspace_.RTL;this.svgLid_.setAttribute("transform","rotate("+(b?-a:a)+","+(b?4:this.WIDTH_-4)+","+(this.LID_HEIGHT_-2)+")")};Blockly.Trashcan.prototype.setMinOpenness_=function(a){this.minOpenness_=a;this.isOpen||this.setLidAngle_(a*Blockly.Trashcan.MAX_LID_ANGLE_)};Blockly.Trashcan.prototype.close=function(){this.setOpen(!1)};
	Blockly.Trashcan.prototype.click=function(){if(this.contents_.length){for(var a=[],b=0,c;c=this.contents_[b];b++)a[b]=Blockly.Xml.textToDom(c);this.flyout.show(a)}};Blockly.Trashcan.prototype.mouseOver_=function(){this.contents_.length&&this.setOpen(!0)};Blockly.Trashcan.prototype.mouseOut_=function(){this.setOpen(!1)};
	Blockly.Trashcan.prototype.onDelete_=function(a){if(!(0>=this.workspace_.options.maxTrashcanContents)&&a.type==Blockly.Events.BLOCK_DELETE&&"shadow"!=a.oldXml.tagName.toLowerCase()&&(a=this.cleanBlockXML_(a.oldXml),-1==this.contents_.indexOf(a))){for(this.contents_.unshift(a);this.contents_.length>this.workspace_.options.maxTrashcanContents;)this.contents_.pop();this.setMinOpenness_(this.HAS_BLOCKS_LID_ANGLE_)}};
	Blockly.Trashcan.prototype.cleanBlockXML_=function(a){for(var b=a=a.cloneNode(!0);b;){b.removeAttribute&&(b.removeAttribute("x"),b.removeAttribute("y"),b.removeAttribute("id"),b.removeAttribute("disabled"),"comment"==b.nodeName&&(b.removeAttribute("h"),b.removeAttribute("w"),b.removeAttribute("pinned")));var c=b.firstChild||b.nextSibling;if(!c)for(c=b.parentNode;c;){if(c.nextSibling){c=c.nextSibling;break}c=c.parentNode}b=c}return Blockly.Xml.domToText(a)};Blockly.VariablesDynamic={};Blockly.VariablesDynamic.onCreateVariableButtonClick_String=function(a){Blockly.Variables.createVariableButtonHandler(a.getTargetWorkspace(),void 0,"String")};Blockly.VariablesDynamic.onCreateVariableButtonClick_Number=function(a){Blockly.Variables.createVariableButtonHandler(a.getTargetWorkspace(),void 0,"Number")};Blockly.VariablesDynamic.onCreateVariableButtonClick_Colour=function(a){Blockly.Variables.createVariableButtonHandler(a.getTargetWorkspace(),void 0,"Colour")};
	Blockly.VariablesDynamic.flyoutCategory=function(a){var b=[],c=document.createElement("button");c.setAttribute("text",Blockly.Msg.NEW_STRING_VARIABLE);c.setAttribute("callbackKey","CREATE_VARIABLE_STRING");b.push(c);c=document.createElement("button");c.setAttribute("text",Blockly.Msg.NEW_NUMBER_VARIABLE);c.setAttribute("callbackKey","CREATE_VARIABLE_NUMBER");b.push(c);c=document.createElement("button");c.setAttribute("text",Blockly.Msg.NEW_COLOUR_VARIABLE);c.setAttribute("callbackKey","CREATE_VARIABLE_COLOUR");
	b.push(c);a.registerButtonCallback("CREATE_VARIABLE_STRING",Blockly.VariablesDynamic.onCreateVariableButtonClick_String);a.registerButtonCallback("CREATE_VARIABLE_NUMBER",Blockly.VariablesDynamic.onCreateVariableButtonClick_Number);a.registerButtonCallback("CREATE_VARIABLE_COLOUR",Blockly.VariablesDynamic.onCreateVariableButtonClick_Colour);a=Blockly.VariablesDynamic.flyoutCategoryBlocks(a);return b=b.concat(a)};
	Blockly.VariablesDynamic.flyoutCategoryBlocks=function(a){a=a.getAllVariables();var b=[];if(0<a.length){if(Blockly.Blocks.variables_set_dynamic){var c=a[a.length-1],d=Blockly.utils.xml.createElement("block");d.setAttribute("type","variables_set_dynamic");d.setAttribute("gap",24);d.appendChild(Blockly.Variables.generateVariableFieldDom(c));b.push(d)}if(Blockly.Blocks.variables_get_dynamic){a.sort(Blockly.VariableModel.compareByName);c=0;for(var e;e=a[c];c++)d=Blockly.utils.xml.createElement("block"),
	d.setAttribute("type","variables_get_dynamic"),d.setAttribute("gap",8),d.appendChild(Blockly.Variables.generateVariableFieldDom(e)),b.push(d)}}return b};Blockly.ZoomControls=function(a){this.workspace_=a};Blockly.ZoomControls.prototype.WIDTH_=32;Blockly.ZoomControls.prototype.HEIGHT_=110;Blockly.ZoomControls.prototype.MARGIN_BOTTOM_=20;Blockly.ZoomControls.prototype.MARGIN_SIDE_=20;Blockly.ZoomControls.prototype.svgGroup_=null;Blockly.ZoomControls.prototype.left_=0;Blockly.ZoomControls.prototype.top_=0;
	Blockly.ZoomControls.prototype.createDom=function(){this.svgGroup_=Blockly.utils.dom.createSvgElement("g",{},null);var a=String(Math.random()).substring(2);this.createZoomOutSvg_(a);this.createZoomInSvg_(a);this.workspace_.isMovable()&&this.createZoomResetSvg_(a);return this.svgGroup_};Blockly.ZoomControls.prototype.init=function(a){this.verticalSpacing_=this.MARGIN_BOTTOM_+a;return this.verticalSpacing_+this.HEIGHT_};Blockly.ZoomControls.prototype.dispose=function(){this.svgGroup_&&Blockly.utils.dom.removeNode(this.svgGroup_)};
	Blockly.ZoomControls.prototype.position=function(){if(this.verticalSpacing_){var a=this.workspace_.getMetrics();a&&(this.left_=a.toolboxPosition==Blockly.TOOLBOX_AT_LEFT||this.workspace_.horizontalLayout&&!this.workspace_.RTL?a.viewWidth+a.absoluteLeft-this.WIDTH_-this.MARGIN_SIDE_-Blockly.Scrollbar.scrollbarThickness:this.MARGIN_SIDE_+Blockly.Scrollbar.scrollbarThickness,a.toolboxPosition==Blockly.TOOLBOX_AT_BOTTOM?(this.top_=this.verticalSpacing_,this.zoomInGroup_.setAttribute("transform","translate(0, 34)"),
	this.zoomResetGroup_&&this.zoomResetGroup_.setAttribute("transform","translate(0, 77)")):(this.top_=a.viewHeight+a.absoluteTop-this.HEIGHT_-this.verticalSpacing_,this.zoomInGroup_.setAttribute("transform","translate(0, 43)"),this.zoomOutGroup_.setAttribute("transform","translate(0, 77)")),this.svgGroup_.setAttribute("transform","translate("+this.left_+","+this.top_+")"))}};
	Blockly.ZoomControls.prototype.createZoomOutSvg_=function(a){var b=this.workspace_;this.zoomOutGroup_=Blockly.utils.dom.createSvgElement("g",{"class":"blocklyZoom"},this.svgGroup_);var c=Blockly.utils.dom.createSvgElement("clipPath",{id:"blocklyZoomoutClipPath"+a},this.zoomOutGroup_);Blockly.utils.dom.createSvgElement("rect",{width:32,height:32},c);a=Blockly.utils.dom.createSvgElement("image",{width:Blockly.SPRITE.width,height:Blockly.SPRITE.height,x:-64,y:-92,"clip-path":"url(#blocklyZoomoutClipPath"+
	a+")"},this.zoomOutGroup_);a.setAttributeNS(Blockly.utils.dom.XLINK_NS,"xlink:href",b.options.pathToMedia+Blockly.SPRITE.url);Blockly.bindEventWithChecks_(a,"mousedown",null,function(a){b.markFocused();b.zoomCenter(-1);Blockly.Touch.clearTouchIdentifier();a.stopPropagation();a.preventDefault()})};
	Blockly.ZoomControls.prototype.createZoomInSvg_=function(a){var b=this.workspace_;this.zoomInGroup_=Blockly.utils.dom.createSvgElement("g",{"class":"blocklyZoom"},this.svgGroup_);var c=Blockly.utils.dom.createSvgElement("clipPath",{id:"blocklyZoominClipPath"+a},this.zoomInGroup_);Blockly.utils.dom.createSvgElement("rect",{width:32,height:32},c);a=Blockly.utils.dom.createSvgElement("image",{width:Blockly.SPRITE.width,height:Blockly.SPRITE.height,x:-32,y:-92,"clip-path":"url(#blocklyZoominClipPath"+
	a+")"},this.zoomInGroup_);a.setAttributeNS(Blockly.utils.dom.XLINK_NS,"xlink:href",b.options.pathToMedia+Blockly.SPRITE.url);Blockly.bindEventWithChecks_(a,"mousedown",null,function(a){b.markFocused();b.zoomCenter(1);Blockly.Touch.clearTouchIdentifier();a.stopPropagation();a.preventDefault()})};
	Blockly.ZoomControls.prototype.createZoomResetSvg_=function(a){var b=this.workspace_;this.zoomResetGroup_=Blockly.utils.dom.createSvgElement("g",{"class":"blocklyZoom"},this.svgGroup_);var c=Blockly.utils.dom.createSvgElement("clipPath",{id:"blocklyZoomresetClipPath"+a},this.zoomResetGroup_);Blockly.utils.dom.createSvgElement("rect",{width:32,height:32},c);a=Blockly.utils.dom.createSvgElement("image",{width:Blockly.SPRITE.width,height:Blockly.SPRITE.height,y:-92,"clip-path":"url(#blocklyZoomresetClipPath"+
	a+")"},this.zoomResetGroup_);a.setAttributeNS(Blockly.utils.dom.XLINK_NS,"xlink:href",b.options.pathToMedia+Blockly.SPRITE.url);Blockly.bindEventWithChecks_(a,"mousedown",null,function(a){b.markFocused();b.setScale(b.options.zoomOptions.startScale);b.beginCanvasTransition();b.scrollCenter();setTimeout(b.endCanvasTransition.bind(b),500);Blockly.Touch.clearTouchIdentifier();a.stopPropagation();a.preventDefault()})};
	Blockly.Css.register([".blocklyZoom>image, .blocklyZoom>svg>image {","opacity: .4;","}",".blocklyZoom>image:hover, .blocklyZoom>svg>image:hover {","opacity: .6;","}",".blocklyZoom>image:active, .blocklyZoom>svg>image:active {","opacity: .8;","}"]);Blockly.Mutator=function(a){Blockly.Mutator.superClass_.constructor.call(this,null);this.quarkNames_=a};Blockly.utils.object.inherits(Blockly.Mutator,Blockly.Icon);Blockly.Mutator.prototype.workspaceWidth_=0;Blockly.Mutator.prototype.workspaceHeight_=0;Blockly.Mutator.prototype.setBlock=function(a){this.block_=a};Blockly.Mutator.prototype.getWorkspace=function(){return this.workspace_};
	Blockly.Mutator.prototype.drawIcon_=function(a){Blockly.utils.dom.createSvgElement("rect",{"class":"blocklyIconShape",rx:"4",ry:"4",height:"16",width:"16"},a);Blockly.utils.dom.createSvgElement("path",{"class":"blocklyIconSymbol",d:"m4.203,7.296 0,1.368 -0.92,0.677 -0.11,0.41 0.9,1.559 0.41,0.11 1.043,-0.457 1.187,0.683 0.127,1.134 0.3,0.3 1.8,0 0.3,-0.299 0.127,-1.138 1.185,-0.682 1.046,0.458 0.409,-0.11 0.9,-1.559 -0.11,-0.41 -0.92,-0.677 0,-1.366 0.92,-0.677 0.11,-0.41 -0.9,-1.559 -0.409,-0.109 -1.046,0.458 -1.185,-0.682 -0.127,-1.138 -0.3,-0.299 -1.8,0 -0.3,0.3 -0.126,1.135 -1.187,0.682 -1.043,-0.457 -0.41,0.11 -0.899,1.559 0.108,0.409z"},
	a);Blockly.utils.dom.createSvgElement("circle",{"class":"blocklyIconShape",r:"2.7",cx:"8",cy:"8"},a)};Blockly.Mutator.prototype.iconClick_=function(a){this.block_.isEditable()&&Blockly.Icon.prototype.iconClick_.call(this,a)};
	Blockly.Mutator.prototype.createEditor_=function(){this.svgDialog_=Blockly.utils.dom.createSvgElement("svg",{x:Blockly.Bubble.BORDER_WIDTH,y:Blockly.Bubble.BORDER_WIDTH},null);if(this.quarkNames_.length)for(var a=Blockly.utils.xml.createElement("xml"),b=0,c;c=this.quarkNames_[b];b++){var d=Blockly.utils.xml.createElement("block");d.setAttribute("type",c);a.appendChild(d)}else a=null;b=new Blockly.Options({disable:!1,parentWorkspace:this.block_.workspace,media:this.block_.workspace.options.pathToMedia,
	rtl:this.block_.RTL,horizontalLayout:!1,renderer:this.block_.workspace.options.renderer,rendererOverrides:this.block_.workspace.options.rendererOverrides});b.toolboxPosition=this.block_.RTL?Blockly.TOOLBOX_AT_RIGHT:Blockly.TOOLBOX_AT_LEFT;if(c=!!a)b.languageTree=Blockly.utils.toolbox.convertToolboxToJSON(a),b.getMetrics=this.getFlyoutMetrics_.bind(this);this.workspace_=new Blockly.WorkspaceSvg(b);this.workspace_.isMutator=!0;this.workspace_.addChangeListener(Blockly.Events.disableOrphans);a=c?this.workspace_.addFlyout("g"):
	null;b=this.workspace_.createDom("blocklyMutatorBackground");a&&b.insertBefore(a,this.workspace_.svgBlockCanvas_);this.svgDialog_.appendChild(b);return this.svgDialog_};Blockly.Mutator.prototype.updateEditable=function(){Blockly.Mutator.superClass_.updateEditable.call(this);this.block_.isInFlyout||(this.block_.isEditable()?this.iconGroup_&&Blockly.utils.dom.removeClass(this.iconGroup_,"blocklyIconGroupReadonly"):(this.setVisible(!1),this.iconGroup_&&Blockly.utils.dom.addClass(this.iconGroup_,"blocklyIconGroupReadonly")))};
	Blockly.Mutator.prototype.resizeBubble_=function(){var a=2*Blockly.Bubble.BORDER_WIDTH,b=this.workspace_.getCanvas().getBBox();var c=this.block_.RTL?-b.x:b.width+b.x;b=b.height+3*a;var d=this.workspace_.getFlyout();d&&(d=d.getMetrics_(),b=Math.max(b,d.contentHeight+20));c+=3*a;if(Math.abs(this.workspaceWidth_-c)>a||Math.abs(this.workspaceHeight_-b)>a)this.workspaceWidth_=c,this.workspaceHeight_=b,this.bubble_.setBubbleSize(c+a,b+a),this.svgDialog_.setAttribute("width",this.workspaceWidth_),this.svgDialog_.setAttribute("height",
	this.workspaceHeight_);this.block_.RTL&&(a="translate("+this.workspaceWidth_+",0)",this.workspace_.getCanvas().setAttribute("transform",a));this.workspace_.resize()};Blockly.Mutator.prototype.onBubbleMove_=function(){this.workspace_&&this.workspace_.recordDeleteAreas()};
	Blockly.Mutator.prototype.setVisible=function(a){if(a!=this.isVisible())if(Blockly.Events.fire(new Blockly.Events.Ui(this.block_,"mutatorOpen",!a,a)),a){this.bubble_=new Blockly.Bubble(this.block_.workspace,this.createEditor_(),this.block_.pathObject.svgPath,this.iconXY_,null,null);this.bubble_.setSvgId(this.block_.id);this.bubble_.registerMoveEvent(this.onBubbleMove_.bind(this));var b=this.workspace_.options.languageTree;a=this.workspace_.getFlyout();b&&(a.init(this.workspace_),a.show(b));this.rootBlock_=
	this.block_.decompose(this.workspace_);b=this.rootBlock_.getDescendants(!1);for(var c=0,d;d=b[c];c++)d.render();this.rootBlock_.setMovable(!1);this.rootBlock_.setDeletable(!1);a?(b=2*a.CORNER_RADIUS,a=a.getWidth()+b):a=b=16;this.block_.RTL&&(a=-a);this.rootBlock_.moveBy(a,b);if(this.block_.saveConnections){var e=this,f=this.block_;f.saveConnections(this.rootBlock_);this.sourceListener_=function(){f.saveConnections(e.rootBlock_)};this.block_.workspace.addChangeListener(this.sourceListener_)}this.resizeBubble_();
	this.workspace_.addChangeListener(this.workspaceChanged_.bind(this));this.applyColour()}else this.svgDialog_=null,this.workspace_.dispose(),this.rootBlock_=this.workspace_=null,this.bubble_.dispose(),this.bubble_=null,this.workspaceHeight_=this.workspaceWidth_=0,this.sourceListener_&&(this.block_.workspace.removeChangeListener(this.sourceListener_),this.sourceListener_=null)};
	Blockly.Mutator.prototype.workspaceChanged_=function(a){if(a.type!=Blockly.Events.UI&&(a.type!=Blockly.Events.CHANGE||"disabled"!=a.element)){if(!this.workspace_.isDragging())for(var b=this.workspace_.getTopBlocks(!1),c=0;a=b[c];c++){var d=a.getRelativeToSurfaceXY(),e=a.getHeightWidth();20>d.y+e.height&&a.moveBy(0,20-e.height-d.y)}this.rootBlock_.workspace==this.workspace_&&(Blockly.Events.setGroup(!0),a=this.block_,b=(b=a.mutationToDom())&&Blockly.Xml.domToText(b),a.compose(this.rootBlock_),a.initSvg(),
	a.render(),Blockly.getMainWorkspace().keyboardAccessibilityMode&&Blockly.navigation.moveCursorOnBlockMutation(a),c=(c=a.mutationToDom())&&Blockly.Xml.domToText(c),b!=c&&Blockly.Events.fire(new Blockly.Events.BlockChange(a,"mutation",null,b,c)),this.workspace_.isDragging()||this.resizeBubble_(),Blockly.Events.setGroup(!1))}};
	Blockly.Mutator.prototype.getFlyoutMetrics_=function(){return{contentHeight:0,contentWidth:0,contentTop:0,contentLeft:0,viewHeight:this.workspaceHeight_,viewWidth:this.workspaceWidth_-this.workspace_.getFlyout().getWidth(),viewTop:0,viewLeft:0,absoluteTop:0,absoluteLeft:this.workspace_.RTL?0:this.workspace_.getFlyout().getWidth()}};Blockly.Mutator.prototype.dispose=function(){this.block_.mutator=null;Blockly.Icon.prototype.dispose.call(this)};
	Blockly.Mutator.prototype.updateBlockStyle=function(){var a=this.workspace_;if(a&&a.getAllBlocks(!1)){for(var b=a.getAllBlocks(!1),c=0;c<b.length;c++){var d=b[c];d.setStyle(d.getStyleName())}a=a.getFlyout().workspace_.getAllBlocks(!1);for(c=0;c<a.length;c++)d=a[c],d.setStyle(d.getStyleName())}};
	Blockly.Mutator.reconnect=function(a,b,c){if(!a||!a.getSourceBlock().workspace)return!1;c=b.getInput(c).connection;var d=a.targetBlock();return d&&d!=b||c.targetConnection==a?!1:(c.isConnected()&&c.disconnect(),c.connect(a),!0)};Blockly.Mutator.findParentWs=function(a){var b=null;if(a&&a.options){var c=a.options.parentWorkspace;a.isFlyout?c&&c.options&&(b=c.options.parentWorkspace):c&&(b=c)}return b};Blockly.FieldTextInput=function(a,b,c){this.spellcheck_=!0;Blockly.FieldTextInput.superClass_.constructor.call(this,a,b,c);this.onKeyInputWrapper_=this.onKeyDownWrapper_=this.htmlInput_=null;this.fullBlockClickTarget_=!1;this.workspace_=null};Blockly.utils.object.inherits(Blockly.FieldTextInput,Blockly.Field);Blockly.FieldTextInput.prototype.DEFAULT_VALUE="";
	Blockly.FieldTextInput.fromJson=function(a){var b=Blockly.utils.replaceMessageReferences(a.text);return new Blockly.FieldTextInput(b,void 0,a)};Blockly.FieldTextInput.prototype.SERIALIZABLE=!0;Blockly.FieldTextInput.BORDERRADIUS=4;Blockly.FieldTextInput.prototype.CURSOR="text";Blockly.FieldTextInput.prototype.configure_=function(a){Blockly.FieldTextInput.superClass_.configure_.call(this,a);"boolean"==typeof a.spellcheck&&(this.spellcheck_=a.spellcheck)};
	Blockly.FieldTextInput.prototype.initView=function(){if(this.getConstants().FULL_BLOCK_FIELDS){for(var a=0,b=0,c=0,d;d=this.sourceBlock_.inputList[c];c++){for(var e=0;d.fieldRow[e];e++)a++;d.connection&&b++}this.fullBlockClickTarget_=1>=a&&this.sourceBlock_.outputConnection&&!b}else this.fullBlockClickTarget_=!1;this.fullBlockClickTarget_?this.clickTarget_=this.sourceBlock_.getSvgRoot():this.createBorderRect_();this.createTextElement_()};
	Blockly.FieldTextInput.prototype.doClassValidation_=function(a){return null===a||void 0===a?null:String(a)};Blockly.FieldTextInput.prototype.doValueInvalid_=function(a){this.isBeingEdited_&&(this.isTextValid_=!1,a=this.value_,this.value_=this.htmlInput_.untypedDefaultValue_,this.sourceBlock_&&Blockly.Events.isEnabled()&&Blockly.Events.fire(new Blockly.Events.BlockChange(this.sourceBlock_,"field",this.name||null,a,this.value_)))};
	Blockly.FieldTextInput.prototype.doValueUpdate_=function(a){this.isTextValid_=!0;this.value_=a;this.isBeingEdited_||(this.isDirty_=!0)};Blockly.FieldTextInput.prototype.applyColour=function(){this.sourceBlock_&&this.getConstants().FULL_BLOCK_FIELDS&&(this.borderRect_?this.borderRect_.setAttribute("stroke",this.sourceBlock_.style.colourTertiary):this.sourceBlock_.pathObject.svgPath.setAttribute("fill",this.getConstants().FIELD_BORDER_RECT_COLOUR))};
	Blockly.FieldTextInput.prototype.render_=function(){Blockly.FieldTextInput.superClass_.render_.call(this);if(this.isBeingEdited_){this.resizeEditor_();var a=this.htmlInput_;this.isTextValid_?(Blockly.utils.dom.removeClass(a,"blocklyInvalidInput"),Blockly.utils.aria.setState(a,Blockly.utils.aria.State.INVALID,!1)):(Blockly.utils.dom.addClass(a,"blocklyInvalidInput"),Blockly.utils.aria.setState(a,Blockly.utils.aria.State.INVALID,!0))}};
	Blockly.FieldTextInput.prototype.setSpellcheck=function(a){a!=this.spellcheck_&&(this.spellcheck_=a,this.htmlInput_&&this.htmlInput_.setAttribute("spellcheck",this.spellcheck_))};Blockly.FieldTextInput.prototype.showEditor_=function(a,b){this.workspace_=this.sourceBlock_.workspace;a=b||!1;!a&&(Blockly.utils.userAgent.MOBILE||Blockly.utils.userAgent.ANDROID||Blockly.utils.userAgent.IPAD)?this.showPromptEditor_():this.showInlineEditor_(a)};
	Blockly.FieldTextInput.prototype.showPromptEditor_=function(){var a=this;Blockly.prompt(Blockly.Msg.CHANGE_VALUE_TITLE,this.getText(),function(b){a.setValue(b)})};Blockly.FieldTextInput.prototype.showInlineEditor_=function(a){Blockly.WidgetDiv.show(this,this.sourceBlock_.RTL,this.widgetDispose_.bind(this));this.htmlInput_=this.widgetCreate_();this.isBeingEdited_=!0;a||(this.htmlInput_.focus({preventScroll:!0}),this.htmlInput_.select())};
	Blockly.FieldTextInput.prototype.widgetCreate_=function(){var a=Blockly.WidgetDiv.DIV;Blockly.utils.dom.addClass(this.getClickTarget_(),"editing");var b=document.createElement("input");b.className="blocklyHtmlInput";b.setAttribute("spellcheck",this.spellcheck_);var c=this.workspace_.getScale(),d=this.getConstants().FIELD_TEXT_FONTSIZE*c+"pt";a.style.fontSize=d;b.style.fontSize=d;d=Blockly.FieldTextInput.BORDERRADIUS*c+"px";if(this.fullBlockClickTarget_){d=this.getScaledBBox();d=(d.bottom-d.top)/2+
	"px";var e=this.sourceBlock_.getParent()?this.sourceBlock_.getParent().style.colourTertiary:this.sourceBlock_.style.colourTertiary;b.style.border=1*c+"px solid "+e;a.style.borderRadius=d;a.style.transition="box-shadow 0.25s ease 0s";this.getConstants().FIELD_TEXTINPUT_BOX_SHADOW&&(a.style.boxShadow="rgba(255, 255, 255, 0.3) 0px 0px 0px "+4*c+"px")}b.style.borderRadius=d;a.appendChild(b);b.value=b.defaultValue=this.getEditorText_(this.value_);b.untypedDefaultValue_=this.value_;b.oldValue_=null;this.resizeEditor_();
	this.bindInputEvents_(b);return b};Blockly.FieldTextInput.prototype.widgetDispose_=function(){this.isBeingEdited_=!1;this.isTextValid_=!0;this.forceRerender();if(this.onFinishEditing_)this.onFinishEditing_(this.value_);this.unbindInputEvents_();var a=Blockly.WidgetDiv.DIV.style;a.width="auto";a.height="auto";a.fontSize="";a.transition="";a.boxShadow="";this.htmlInput_=null;Blockly.utils.dom.removeClass(this.getClickTarget_(),"editing")};
	Blockly.FieldTextInput.prototype.bindInputEvents_=function(a){this.onKeyDownWrapper_=Blockly.bindEventWithChecks_(a,"keydown",this,this.onHtmlInputKeyDown_);this.onKeyInputWrapper_=Blockly.bindEventWithChecks_(a,"input",this,this.onHtmlInputChange_)};
	Blockly.FieldTextInput.prototype.unbindInputEvents_=function(){this.onKeyDownWrapper_&&(Blockly.unbindEvent_(this.onKeyDownWrapper_),this.onKeyDownWrapper_=null);this.onKeyInputWrapper_&&(Blockly.unbindEvent_(this.onKeyInputWrapper_),this.onKeyInputWrapper_=null)};
	Blockly.FieldTextInput.prototype.onHtmlInputKeyDown_=function(a){a.keyCode==Blockly.utils.KeyCodes.ENTER?(Blockly.WidgetDiv.hide(),Blockly.DropDownDiv.hideWithoutAnimation()):a.keyCode==Blockly.utils.KeyCodes.ESC?(this.htmlInput_.value=this.htmlInput_.defaultValue,Blockly.WidgetDiv.hide(),Blockly.DropDownDiv.hideWithoutAnimation()):a.keyCode==Blockly.utils.KeyCodes.TAB&&(Blockly.WidgetDiv.hide(),Blockly.DropDownDiv.hideWithoutAnimation(),this.sourceBlock_.tab(this,!a.shiftKey),a.preventDefault())};
	Blockly.FieldTextInput.prototype.onHtmlInputChange_=function(a){a=this.htmlInput_.value;a!==this.htmlInput_.oldValue_&&(this.htmlInput_.oldValue_=a,Blockly.Events.setGroup(!0),a=this.getValueFromEditorText_(a),this.setValue(a),this.forceRerender(),this.resizeEditor_(),Blockly.Events.setGroup(!1))};Blockly.FieldTextInput.prototype.setEditorValue_=function(a){this.isDirty_=!0;this.isBeingEdited_&&(this.htmlInput_.value=this.getEditorText_(a));this.setValue(a)};
	Blockly.FieldTextInput.prototype.resizeEditor_=function(){var a=Blockly.WidgetDiv.DIV,b=this.getScaledBBox();a.style.width=b.right-b.left+"px";a.style.height=b.bottom-b.top+"px";b=new Blockly.utils.Coordinate(this.sourceBlock_.RTL?b.right-a.offsetWidth:b.left,b.top);a.style.left=b.x+"px";a.style.top=b.y+"px"};
	Blockly.FieldTextInput.numberValidator=function(a){console.warn("Blockly.FieldTextInput.numberValidator is deprecated. Use Blockly.FieldNumber instead.");if(null===a)return null;a=String(a);a=a.replace(/O/ig,"0");a=a.replace(/,/g,"");a=Number(a||0);return isNaN(a)?null:String(a)};Blockly.FieldTextInput.nonnegativeIntegerValidator=function(a){(a=Blockly.FieldTextInput.numberValidator(a))&&(a=String(Math.max(0,Math.floor(a))));return a};Blockly.FieldTextInput.prototype.isTabNavigable=function(){return!0};
	Blockly.FieldTextInput.prototype.getText_=function(){return this.isBeingEdited_&&this.htmlInput_?this.htmlInput_.value:null};Blockly.FieldTextInput.prototype.getEditorText_=function(a){return String(a)};Blockly.FieldTextInput.prototype.getValueFromEditorText_=function(a){return a};Blockly.fieldRegistry.register("field_input",Blockly.FieldTextInput);Blockly.FieldAngle=function(a,b,c){this.clockwise_=Blockly.FieldAngle.CLOCKWISE;this.offset_=Blockly.FieldAngle.OFFSET;this.wrap_=Blockly.FieldAngle.WRAP;this.round_=Blockly.FieldAngle.ROUND;Blockly.FieldAngle.superClass_.constructor.call(this,a,b,c);this.moveSurfaceWrapper_=this.clickSurfaceWrapper_=this.clickWrapper_=this.line_=this.gauge_=null};Blockly.utils.object.inherits(Blockly.FieldAngle,Blockly.FieldTextInput);Blockly.FieldAngle.prototype.DEFAULT_VALUE=0;
	Blockly.FieldAngle.fromJson=function(a){return new Blockly.FieldAngle(a.angle,void 0,a)};Blockly.FieldAngle.prototype.SERIALIZABLE=!0;Blockly.FieldAngle.ROUND=15;Blockly.FieldAngle.HALF=50;Blockly.FieldAngle.CLOCKWISE=!1;Blockly.FieldAngle.OFFSET=0;Blockly.FieldAngle.WRAP=360;Blockly.FieldAngle.RADIUS=Blockly.FieldAngle.HALF-1;
	Blockly.FieldAngle.prototype.configure_=function(a){Blockly.FieldAngle.superClass_.configure_.call(this,a);switch(a.mode){case "compass":this.clockwise_=!0;this.offset_=90;break;case "protractor":this.clockwise_=!1,this.offset_=0}var b=a.clockwise;"boolean"==typeof b&&(this.clockwise_=b);b=a.offset;null!=b&&(b=Number(b),isNaN(b)||(this.offset_=b));b=a.wrap;null!=b&&(b=Number(b),isNaN(b)||(this.wrap_=b));a=a.round;null!=a&&(a=Number(a),isNaN(a)||(this.round_=a))};
	Blockly.FieldAngle.prototype.initView=function(){Blockly.FieldAngle.superClass_.initView.call(this);this.symbol_=Blockly.utils.dom.createSvgElement("tspan",{},null);this.symbol_.appendChild(document.createTextNode("\u00b0"));this.textElement_.appendChild(this.symbol_)};Blockly.FieldAngle.prototype.render_=function(){Blockly.FieldAngle.superClass_.render_.call(this);this.updateGraph_()};
	Blockly.FieldAngle.prototype.showEditor_=function(a){Blockly.FieldAngle.superClass_.showEditor_.call(this,a,Blockly.utils.userAgent.MOBILE||Blockly.utils.userAgent.ANDROID||Blockly.utils.userAgent.IPAD);a=this.dropdownCreate_();Blockly.DropDownDiv.getContentDiv().appendChild(a);Blockly.DropDownDiv.setColour(this.sourceBlock_.style.colourPrimary,this.sourceBlock_.style.colourTertiary);Blockly.DropDownDiv.showPositionedByField(this,this.dropdownDispose_.bind(this));this.updateGraph_()};
	Blockly.FieldAngle.prototype.dropdownCreate_=function(){var a=Blockly.utils.dom.createSvgElement("svg",{xmlns:Blockly.utils.dom.SVG_NS,"xmlns:html":Blockly.utils.dom.HTML_NS,"xmlns:xlink":Blockly.utils.dom.XLINK_NS,version:"1.1",height:2*Blockly.FieldAngle.HALF+"px",width:2*Blockly.FieldAngle.HALF+"px",style:"touch-action: none"},null),b=Blockly.utils.dom.createSvgElement("circle",{cx:Blockly.FieldAngle.HALF,cy:Blockly.FieldAngle.HALF,r:Blockly.FieldAngle.RADIUS,"class":"blocklyAngleCircle"},a);this.gauge_=
	Blockly.utils.dom.createSvgElement("path",{"class":"blocklyAngleGauge"},a);this.line_=Blockly.utils.dom.createSvgElement("line",{x1:Blockly.FieldAngle.HALF,y1:Blockly.FieldAngle.HALF,"class":"blocklyAngleLine"},a);for(var c=0;360>c;c+=15)Blockly.utils.dom.createSvgElement("line",{x1:Blockly.FieldAngle.HALF+Blockly.FieldAngle.RADIUS,y1:Blockly.FieldAngle.HALF,x2:Blockly.FieldAngle.HALF+Blockly.FieldAngle.RADIUS-(0==c%45?10:5),y2:Blockly.FieldAngle.HALF,"class":"blocklyAngleMarks",transform:"rotate("+
	c+","+Blockly.FieldAngle.HALF+","+Blockly.FieldAngle.HALF+")"},a);this.clickWrapper_=Blockly.bindEventWithChecks_(a,"click",this,this.hide_);this.clickSurfaceWrapper_=Blockly.bindEventWithChecks_(b,"click",this,this.onMouseMove_,!0,!0);this.moveSurfaceWrapper_=Blockly.bindEventWithChecks_(b,"mousemove",this,this.onMouseMove_,!0,!0);return a};
	Blockly.FieldAngle.prototype.dropdownDispose_=function(){this.clickWrapper_&&(Blockly.unbindEvent_(this.clickWrapper_),this.clickWrapper_=null);this.clickSurfaceWrapper_&&(Blockly.unbindEvent_(this.clickSurfaceWrapper_),this.clickSurfaceWrapper_=null);this.moveSurfaceWrapper_&&(Blockly.unbindEvent_(this.moveSurfaceWrapper_),this.moveSurfaceWrapper_=null);this.line_=this.gauge_=null};Blockly.FieldAngle.prototype.hide_=function(){Blockly.DropDownDiv.hideIfOwner(this);Blockly.WidgetDiv.hide()};
	Blockly.FieldAngle.prototype.onMouseMove_=function(a){var b=this.gauge_.ownerSVGElement.getBoundingClientRect(),c=a.clientX-b.left-Blockly.FieldAngle.HALF;a=a.clientY-b.top-Blockly.FieldAngle.HALF;b=Math.atan(-a/c);isNaN(b)||(b=Blockly.utils.math.toDegrees(b),0>c?b+=180:0<a&&(b+=360),b=this.clockwise_?this.offset_+360-b:360-(this.offset_-b),this.displayMouseOrKeyboardValue_(b))};
	Blockly.FieldAngle.prototype.displayMouseOrKeyboardValue_=function(a){this.round_&&(a=Math.round(a/this.round_)*this.round_);a=this.wrapValue_(a);a!=this.value_&&this.setEditorValue_(a)};
	Blockly.FieldAngle.prototype.updateGraph_=function(){if(this.gauge_){var a=Number(this.getText())+this.offset_,b=Blockly.utils.math.toRadians(a%360);a=["M ",Blockly.FieldAngle.HALF,",",Blockly.FieldAngle.HALF];var c=Blockly.FieldAngle.HALF,d=Blockly.FieldAngle.HALF;if(!isNaN(b)){var e=Number(this.clockwise_),f=Blockly.utils.math.toRadians(this.offset_),g=Math.cos(f)*Blockly.FieldAngle.RADIUS,h=Math.sin(f)*-Blockly.FieldAngle.RADIUS;e&&(b=2*f-b);c+=Math.cos(b)*Blockly.FieldAngle.RADIUS;d-=Math.sin(b)*
	Blockly.FieldAngle.RADIUS;b=Math.abs(Math.floor((b-f)/Math.PI)%2);e&&(b=1-b);a.push(" l ",g,",",h," A ",Blockly.FieldAngle.RADIUS,",",Blockly.FieldAngle.RADIUS," 0 ",b," ",e," ",c,",",d," z")}this.gauge_.setAttribute("d",a.join(""));this.line_.setAttribute("x2",c);this.line_.setAttribute("y2",d)}};
	Blockly.FieldAngle.prototype.onHtmlInputKeyDown_=function(a){Blockly.FieldAngle.superClass_.onHtmlInputKeyDown_.call(this,a);var b;a.keyCode===Blockly.utils.KeyCodes.LEFT?b=this.sourceBlock_.RTL?1:-1:a.keyCode===Blockly.utils.KeyCodes.RIGHT?b=this.sourceBlock_.RTL?-1:1:a.keyCode===Blockly.utils.KeyCodes.DOWN?b=-1:a.keyCode===Blockly.utils.KeyCodes.UP&&(b=1);if(b){var c=this.getValue();this.displayMouseOrKeyboardValue_(c+b*this.round_);a.preventDefault();a.stopPropagation()}};
	Blockly.FieldAngle.prototype.doClassValidation_=function(a){a=Number(a);return isNaN(a)||!isFinite(a)?null:this.wrapValue_(a)};Blockly.FieldAngle.prototype.wrapValue_=function(a){a%=360;0>a&&(a+=360);a>this.wrap_&&(a-=360);return a};Blockly.Css.register(".blocklyAngleCircle {,stroke: #444;,stroke-width: 1;,fill: #ddd;,fill-opacity: .8;,},.blocklyAngleMarks {,stroke: #444;,stroke-width: 1;,},.blocklyAngleGauge {,fill: #f88;,fill-opacity: .8;,pointer-events: none;,},.blocklyAngleLine {,stroke: #f00;,stroke-width: 2;,stroke-linecap: round;,pointer-events: none;,}".split(","));
	Blockly.fieldRegistry.register("field_angle",Blockly.FieldAngle);Blockly.FieldCheckbox=function(a,b,c){this.checkChar_=null;Blockly.FieldCheckbox.superClass_.constructor.call(this,a,b,c)};Blockly.utils.object.inherits(Blockly.FieldCheckbox,Blockly.Field);Blockly.FieldCheckbox.prototype.DEFAULT_VALUE=!1;Blockly.FieldCheckbox.fromJson=function(a){return new Blockly.FieldCheckbox(a.checked,void 0,a)};Blockly.FieldCheckbox.CHECK_CHAR="\u2713";Blockly.FieldCheckbox.prototype.SERIALIZABLE=!0;Blockly.FieldCheckbox.prototype.CURSOR="default";
	Blockly.FieldCheckbox.prototype.configure_=function(a){Blockly.FieldCheckbox.superClass_.configure_.call(this,a);a.checkCharacter&&(this.checkChar_=a.checkCharacter)};Blockly.FieldCheckbox.prototype.initView=function(){Blockly.FieldCheckbox.superClass_.initView.call(this);Blockly.utils.dom.addClass(this.textElement_,"blocklyCheckbox");this.textElement_.style.display=this.value_?"block":"none"};
	Blockly.FieldCheckbox.prototype.render_=function(){this.textContent_&&(this.textContent_.nodeValue=this.getDisplayText_());this.updateSize_(this.getConstants().FIELD_CHECKBOX_X_OFFSET)};Blockly.FieldCheckbox.prototype.getDisplayText_=function(){return this.checkChar_||Blockly.FieldCheckbox.CHECK_CHAR};Blockly.FieldCheckbox.prototype.setCheckCharacter=function(a){this.checkChar_=a;this.forceRerender()};Blockly.FieldCheckbox.prototype.showEditor_=function(){this.setValue(!this.value_)};
	Blockly.FieldCheckbox.prototype.doClassValidation_=function(a){return!0===a||"TRUE"===a?"TRUE":!1===a||"FALSE"===a?"FALSE":null};Blockly.FieldCheckbox.prototype.doValueUpdate_=function(a){this.value_=this.convertValueToBool_(a);this.textElement_&&(this.textElement_.style.display=this.value_?"block":"none")};Blockly.FieldCheckbox.prototype.getValue=function(){return this.value_?"TRUE":"FALSE"};Blockly.FieldCheckbox.prototype.getValueBoolean=function(){return this.value_};
	Blockly.FieldCheckbox.prototype.getText=function(){return String(this.convertValueToBool_(this.value_))};Blockly.FieldCheckbox.prototype.convertValueToBool_=function(a){return"string"==typeof a?"TRUE"==a:!!a};Blockly.fieldRegistry.register("field_checkbox",Blockly.FieldCheckbox);Blockly.FieldColour=function(a,b,c){Blockly.FieldColour.superClass_.constructor.call(this,a,b,c);this.onKeyDownWrapper_=this.onMouseLeaveWrapper_=this.onMouseEnterWrapper_=this.onMouseMoveWrapper_=this.onClickWrapper_=this.highlightedIndex_=this.picker_=null};Blockly.utils.object.inherits(Blockly.FieldColour,Blockly.Field);Blockly.FieldColour.fromJson=function(a){return new Blockly.FieldColour(a.colour,void 0,a)};Blockly.FieldColour.prototype.SERIALIZABLE=!0;Blockly.FieldColour.prototype.CURSOR="default";
	Blockly.FieldColour.prototype.isDirty_=!1;Blockly.FieldColour.prototype.colours_=null;Blockly.FieldColour.prototype.titles_=null;Blockly.FieldColour.prototype.columns_=0;Blockly.FieldColour.prototype.configure_=function(a){Blockly.FieldColour.superClass_.configure_.call(this,a);a.colourOptions&&(this.colours_=a.colourOptions,this.titles_=a.colourTitles);a.columns&&(this.columns_=a.columns)};
	Blockly.FieldColour.prototype.initView=function(){this.size_=new Blockly.utils.Size(this.getConstants().FIELD_COLOUR_DEFAULT_WIDTH,this.getConstants().FIELD_COLOUR_DEFAULT_HEIGHT);this.getConstants().FIELD_COLOUR_FULL_BLOCK?this.clickTarget_=this.sourceBlock_.getSvgRoot():(this.createBorderRect_(),this.borderRect_.style.fillOpacity="1")};
	Blockly.FieldColour.prototype.applyColour=function(){this.getConstants().FIELD_COLOUR_FULL_BLOCK?(this.sourceBlock_.pathObject.svgPath.setAttribute("fill",this.getValue()),this.sourceBlock_.pathObject.svgPath.setAttribute("stroke","#fff")):this.borderRect_&&(this.borderRect_.style.fill=this.getValue())};Blockly.FieldColour.prototype.doClassValidation_=function(a){return"string"!=typeof a?null:Blockly.utils.colour.parse(a)};
	Blockly.FieldColour.prototype.doValueUpdate_=function(a){this.value_=a;this.borderRect_?this.borderRect_.style.fill=a:this.sourceBlock_&&this.sourceBlock_.rendered&&(this.sourceBlock_.pathObject.svgPath.setAttribute("fill",a),this.sourceBlock_.pathObject.svgPath.setAttribute("stroke","#fff"))};Blockly.FieldColour.prototype.getText=function(){var a=this.value_;/^#(.)\1(.)\2(.)\3$/.test(a)&&(a="#"+a[1]+a[3]+a[5]);return a};Blockly.FieldColour.COLOURS="#ffffff #cccccc #c0c0c0 #999999 #666666 #333333 #000000 #ffcccc #ff6666 #ff0000 #cc0000 #990000 #660000 #330000 #ffcc99 #ff9966 #ff9900 #ff6600 #cc6600 #993300 #663300 #ffff99 #ffff66 #ffcc66 #ffcc33 #cc9933 #996633 #663333 #ffffcc #ffff33 #ffff00 #ffcc00 #999900 #666600 #333300 #99ff99 #66ff99 #33ff33 #33cc00 #009900 #006600 #003300 #99ffff #33ffff #66cccc #00cccc #339999 #336666 #003333 #ccffff #66ffff #33ccff #3366ff #3333ff #000099 #000066 #ccccff #9999ff #6666cc #6633ff #6600cc #333399 #330099 #ffccff #ff99ff #cc66cc #cc33cc #993399 #663366 #330033".split(" ");
	Blockly.FieldColour.prototype.DEFAULT_VALUE=Blockly.FieldColour.COLOURS[0];Blockly.FieldColour.TITLES=[];Blockly.FieldColour.COLUMNS=7;Blockly.FieldColour.prototype.setColours=function(a,b){this.colours_=a;b&&(this.titles_=b);return this};Blockly.FieldColour.prototype.setColumns=function(a){this.columns_=a;return this};
	Blockly.FieldColour.prototype.showEditor_=function(){this.picker_=this.dropdownCreate_();Blockly.DropDownDiv.getContentDiv().appendChild(this.picker_);Blockly.DropDownDiv.showPositionedByField(this,this.dropdownDispose_.bind(this));this.picker_.focus({preventScroll:!0})};Blockly.FieldColour.prototype.onClick_=function(a){a=(a=a.target)&&a.label;null!==a&&(this.setValue(a),Blockly.DropDownDiv.hideIfOwner(this))};
	Blockly.FieldColour.prototype.onKeyDown_=function(a){var b=!1;if(a.keyCode===Blockly.utils.KeyCodes.UP)this.moveHighlightBy_(0,-1),b=!0;else if(a.keyCode===Blockly.utils.KeyCodes.DOWN)this.moveHighlightBy_(0,1),b=!0;else if(a.keyCode===Blockly.utils.KeyCodes.LEFT)this.moveHighlightBy_(-1,0),b=!0;else if(a.keyCode===Blockly.utils.KeyCodes.RIGHT)this.moveHighlightBy_(1,0),b=!0;else if(a.keyCode===Blockly.utils.KeyCodes.ENTER){if(b=this.getHighlighted_())b=b&&b.label,null!==b&&this.setValue(b);Blockly.DropDownDiv.hideWithoutAnimation();
	b=!0}b&&a.stopPropagation()};Blockly.FieldColour.prototype.onBlocklyAction=function(a){if(this.picker_){if(a===Blockly.navigation.ACTION_PREVIOUS)return this.moveHighlightBy_(0,-1),!0;if(a===Blockly.navigation.ACTION_NEXT)return this.moveHighlightBy_(0,1),!0;if(a===Blockly.navigation.ACTION_OUT)return this.moveHighlightBy_(-1,0),!0;if(a===Blockly.navigation.ACTION_IN)return this.moveHighlightBy_(1,0),!0}return Blockly.FieldColour.superClass_.onBlocklyAction.call(this,a)};
	Blockly.FieldColour.prototype.moveHighlightBy_=function(a,b){var c=this.colours_||Blockly.FieldColour.COLOURS,d=this.columns_||Blockly.FieldColour.COLUMNS,e=this.highlightedIndex_%d,f=Math.floor(this.highlightedIndex_/d);e+=a;f+=b;0>a?0>e&&0<f?(e=d-1,f--):0>e&&(e=0):0<a?e>d-1&&f<Math.floor(c.length/d)-1?(e=0,f++):e>d-1&&e--:0>b?0>f&&(f=0):0<b&&f>Math.floor(c.length/d)-1&&(f=Math.floor(c.length/d)-1);this.setHighlightedCell_(this.picker_.childNodes[f].childNodes[e],f*d+e)};
	Blockly.FieldColour.prototype.onMouseMove_=function(a){var b=(a=a.target)&&Number(a.getAttribute("data-index"));null!==b&&b!==this.highlightedIndex_&&this.setHighlightedCell_(a,b)};Blockly.FieldColour.prototype.onMouseEnter_=function(){this.picker_.focus({preventScroll:!0})};Blockly.FieldColour.prototype.onMouseLeave_=function(){this.picker_.blur();var a=this.getHighlighted_();a&&Blockly.utils.dom.removeClass(a,"blocklyColourHighlighted")};
	Blockly.FieldColour.prototype.getHighlighted_=function(){var a=this.columns_||Blockly.FieldColour.COLUMNS,b=this.picker_.childNodes[Math.floor(this.highlightedIndex_/a)];return b?b.childNodes[this.highlightedIndex_%a]:null};
	Blockly.FieldColour.prototype.setHighlightedCell_=function(a,b){var c=this.getHighlighted_();c&&Blockly.utils.dom.removeClass(c,"blocklyColourHighlighted");Blockly.utils.dom.addClass(a,"blocklyColourHighlighted");this.highlightedIndex_=b;Blockly.utils.aria.setState(this.picker_,Blockly.utils.aria.State.ACTIVEDESCENDANT,a.getAttribute("id"))};
	Blockly.FieldColour.prototype.dropdownCreate_=function(){var a=this.columns_||Blockly.FieldColour.COLUMNS,b=this.colours_||Blockly.FieldColour.COLOURS,c=this.titles_||Blockly.FieldColour.TITLES,d=this.getValue(),e=document.createElement("table");e.className="blocklyColourTable";e.tabIndex=0;e.dir="ltr";Blockly.utils.aria.setRole(e,Blockly.utils.aria.Role.GRID);Blockly.utils.aria.setState(e,Blockly.utils.aria.State.EXPANDED,!0);Blockly.utils.aria.setState(e,Blockly.utils.aria.State.ROWCOUNT,Math.floor(b.length/
	a));Blockly.utils.aria.setState(e,Blockly.utils.aria.State.COLCOUNT,a);for(var f,g=0;g<b.length;g++){0==g%a&&(f=document.createElement("tr"),Blockly.utils.aria.setRole(f,Blockly.utils.aria.Role.ROW),e.appendChild(f));var h=document.createElement("td");f.appendChild(h);h.label=b[g];h.title=c[g]||b[g];h.id=Blockly.utils.IdGenerator.getNextUniqueId();h.setAttribute("data-index",g);Blockly.utils.aria.setRole(h,Blockly.utils.aria.Role.GRIDCELL);Blockly.utils.aria.setState(h,Blockly.utils.aria.State.LABEL,
	b[g]);Blockly.utils.aria.setState(h,Blockly.utils.aria.State.SELECTED,b[g]==d);h.style.backgroundColor=b[g];b[g]==d&&(h.className="blocklyColourSelected",this.highlightedIndex_=g)}this.onClickWrapper_=Blockly.bindEventWithChecks_(e,"click",this,this.onClick_,!0);this.onMouseMoveWrapper_=Blockly.bindEventWithChecks_(e,"mousemove",this,this.onMouseMove_,!0);this.onMouseEnterWrapper_=Blockly.bindEventWithChecks_(e,"mouseenter",this,this.onMouseEnter_,!0);this.onMouseLeaveWrapper_=Blockly.bindEventWithChecks_(e,
	"mouseleave",this,this.onMouseLeave_,!0);this.onKeyDownWrapper_=Blockly.bindEventWithChecks_(e,"keydown",this,this.onKeyDown_);return e};
	Blockly.FieldColour.prototype.dropdownDispose_=function(){this.onClickWrapper_&&(Blockly.unbindEvent_(this.onClickWrapper_),this.onClickWrapper_=null);this.onMouseMoveWrapper_&&(Blockly.unbindEvent_(this.onMouseMoveWrapper_),this.onMouseMoveWrapper_=null);this.onMouseEnterWrapper_&&(Blockly.unbindEvent_(this.onMouseEnterWrapper_),this.onMouseEnterWrapper_=null);this.onMouseLeaveWrapper_&&(Blockly.unbindEvent_(this.onMouseLeaveWrapper_),this.onMouseLeaveWrapper_=null);this.onKeyDownWrapper_&&(Blockly.unbindEvent_(this.onKeyDownWrapper_),
	this.onKeyDownWrapper_=null);this.highlightedIndex_=this.picker_=null};
	Blockly.Css.register([".blocklyColourTable {","border-collapse: collapse;","display: block;","outline: none;","padding: 1px;","}",".blocklyColourTable>tr>td {","border: .5px solid #888;","box-sizing: border-box;","cursor: pointer;","display: inline-block;","height: 20px;","padding: 0;","width: 20px;","}",".blocklyColourTable>tr>td.blocklyColourHighlighted {","border-color: #eee;","box-shadow: 2px 2px 7px 2px rgba(0,0,0,.3);","position: relative;","}",".blocklyColourSelected, .blocklyColourSelected:hover {",
	"border-color: #eee !important;","outline: 1px solid #333;","position: relative;","}"]);Blockly.fieldRegistry.register("field_colour",Blockly.FieldColour);Blockly.FieldDropdown=function(a,b,c){"function"!=typeof a&&Blockly.FieldDropdown.validateOptions_(a);this.menuGenerator_=a;this.suffixField=this.prefixField=this.generatedOptions_=null;this.trimOptions_();this.selectedOption_=this.getOptions(!1)[0];Blockly.FieldDropdown.superClass_.constructor.call(this,this.selectedOption_[1],b,c);this.svgArrow_=this.arrow_=this.imageElement_=this.menu_=this.selectedMenuItem_=null};Blockly.utils.object.inherits(Blockly.FieldDropdown,Blockly.Field);
	Blockly.FieldDropdown.fromJson=function(a){return new Blockly.FieldDropdown(a.options,void 0,a)};Blockly.FieldDropdown.prototype.SERIALIZABLE=!0;Blockly.FieldDropdown.CHECKMARK_OVERHANG=25;Blockly.FieldDropdown.MAX_MENU_HEIGHT_VH=.45;Blockly.FieldDropdown.IMAGE_Y_OFFSET=5;Blockly.FieldDropdown.IMAGE_Y_PADDING=2*Blockly.FieldDropdown.IMAGE_Y_OFFSET;Blockly.FieldDropdown.ARROW_CHAR=Blockly.utils.userAgent.ANDROID?"\u25bc":"\u25be";Blockly.FieldDropdown.prototype.CURSOR="default";
	Blockly.FieldDropdown.prototype.initView=function(){this.shouldAddBorderRect_()?this.createBorderRect_():this.clickTarget_=this.sourceBlock_.getSvgRoot();this.createTextElement_();this.imageElement_=Blockly.utils.dom.createSvgElement("image",{},this.fieldGroup_);this.getConstants().FIELD_DROPDOWN_SVG_ARROW?this.createSVGArrow_():this.createTextArrow_();this.borderRect_&&Blockly.utils.dom.addClass(this.borderRect_,"blocklyDropdownRect")};
	Blockly.FieldDropdown.prototype.shouldAddBorderRect_=function(){return!this.getConstants().FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW||this.getConstants().FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW&&!this.sourceBlock_.isShadow()};
	Blockly.FieldDropdown.prototype.createTextArrow_=function(){this.arrow_=Blockly.utils.dom.createSvgElement("tspan",{},this.textElement_);this.arrow_.appendChild(document.createTextNode(this.sourceBlock_.RTL?Blockly.FieldDropdown.ARROW_CHAR+" ":" "+Blockly.FieldDropdown.ARROW_CHAR));this.sourceBlock_.RTL?this.textElement_.insertBefore(this.arrow_,this.textContent_):this.textElement_.appendChild(this.arrow_)};
	Blockly.FieldDropdown.prototype.createSVGArrow_=function(){this.svgArrow_=Blockly.utils.dom.createSvgElement("image",{height:this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE+"px",width:this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE+"px"},this.fieldGroup_);this.svgArrow_.setAttributeNS(Blockly.utils.dom.XLINK_NS,"xlink:href",this.getConstants().FIELD_DROPDOWN_SVG_ARROW_DATAURI)};
	Blockly.FieldDropdown.prototype.showEditor_=function(a){this.menu_=this.dropdownCreate_();this.menu_.openingCoords=a&&"number"===typeof a.clientX?new Blockly.utils.Coordinate(a.clientX,a.clientY):null;this.menu_.render(Blockly.DropDownDiv.getContentDiv());a=this.menu_.getElement();Blockly.utils.dom.addClass(a,"blocklyDropdownMenu");if(this.getConstants().FIELD_DROPDOWN_COLOURED_DIV){a=this.sourceBlock_.isShadow()?this.sourceBlock_.getParent().getColour():this.sourceBlock_.getColour();var b=this.sourceBlock_.isShadow()?
	this.sourceBlock_.getParent().style.colourTertiary:this.sourceBlock_.style.colourTertiary;Blockly.DropDownDiv.setColour(a,b)}Blockly.DropDownDiv.showPositionedByField(this,this.dropdownDispose_.bind(this));this.menu_.focus();this.selectedMenuItem_&&this.menu_.setHighlighted(this.selectedMenuItem_);this.applyColour()};
	Blockly.FieldDropdown.prototype.dropdownCreate_=function(){var a=new Blockly.Menu;a.setRole(Blockly.utils.aria.Role.LISTBOX);var b=this.getOptions(!1);this.selectedMenuItem_=null;for(var c=0;c<b.length;c++){var d=b[c][0],e=b[c][1];if("object"==typeof d){var f=new Image(d.width,d.height);f.src=d.src;f.alt=d.alt||"";d=f}d=new Blockly.MenuItem(d,e);d.setRole(Blockly.utils.aria.Role.OPTION);d.setRightToLeft(this.sourceBlock_.RTL);d.setCheckable(!0);a.addChild(d);d.setChecked(e==this.value_);e==this.value_&&
	(this.selectedMenuItem_=d);d.onAction(this.handleMenuActionEvent_,this)}return a};Blockly.FieldDropdown.prototype.dropdownDispose_=function(){this.menu_&&this.menu_.dispose();this.selectedMenuItem_=this.menu_=null;this.applyColour()};Blockly.FieldDropdown.prototype.handleMenuActionEvent_=function(a){Blockly.DropDownDiv.hideIfOwner(this,!0);this.onItemSelected_(this.menu_,a)};Blockly.FieldDropdown.prototype.onItemSelected_=function(a,b){this.setValue(b.getValue())};
	Blockly.FieldDropdown.prototype.trimOptions_=function(){var a=this.menuGenerator_;if(Array.isArray(a)){for(var b=!1,c=0;c<a.length;c++){var d=a[c][0];"string"==typeof d?a[c][0]=Blockly.utils.replaceMessageReferences(d):(null!=d.alt&&(a[c][0].alt=Blockly.utils.replaceMessageReferences(d.alt)),b=!0)}if(!(b||2>a.length)){b=[];for(c=0;c<a.length;c++)b.push(a[c][0]);c=Blockly.utils.string.shortestStringLength(b);d=Blockly.utils.string.commonWordPrefix(b,c);var e=Blockly.utils.string.commonWordSuffix(b,
	c);!d&&!e||c<=d+e||(d&&(this.prefixField=b[0].substring(0,d-1)),e&&(this.suffixField=b[0].substr(1-e)),this.menuGenerator_=Blockly.FieldDropdown.applyTrim_(a,d,e))}}};Blockly.FieldDropdown.applyTrim_=function(a,b,c){for(var d=[],e=0;e<a.length;e++){var f=a[e][0],g=a[e][1];f=f.substring(b,f.length-c);d[e]=[f,g]}return d};Blockly.FieldDropdown.prototype.isOptionListDynamic=function(){return"function"==typeof this.menuGenerator_};
	Blockly.FieldDropdown.prototype.getOptions=function(a){return this.isOptionListDynamic()?(this.generatedOptions_&&a||(this.generatedOptions_=this.menuGenerator_.call(this),Blockly.FieldDropdown.validateOptions_(this.generatedOptions_)),this.generatedOptions_):this.menuGenerator_};
	Blockly.FieldDropdown.prototype.doClassValidation_=function(a){for(var b=!1,c=this.getOptions(!0),d=0,e;e=c[d];d++)if(e[1]==a){b=!0;break}return b?a:(this.sourceBlock_&&console.warn("Cannot set the dropdown's value to an unavailable option. Block type: "+this.sourceBlock_.type+", Field name: "+this.name+", Value: "+a),null)};
	Blockly.FieldDropdown.prototype.doValueUpdate_=function(a){Blockly.FieldDropdown.superClass_.doValueUpdate_.call(this,a);a=this.getOptions(!0);for(var b=0,c;c=a[b];b++)c[1]==this.value_&&(this.selectedOption_=c)};
	Blockly.FieldDropdown.prototype.applyColour=function(){this.borderRect_&&(this.borderRect_.setAttribute("stroke",this.sourceBlock_.style.colourTertiary),this.menu_?this.borderRect_.setAttribute("fill",this.sourceBlock_.style.colourTertiary):this.borderRect_.setAttribute("fill","transparent"));this.sourceBlock_&&this.arrow_&&(this.sourceBlock_.isShadow()?this.arrow_.style.fill=this.sourceBlock_.style.colourSecondary:this.arrow_.style.fill=this.sourceBlock_.style.colourPrimary)};
	Blockly.FieldDropdown.prototype.render_=function(){this.textContent_.nodeValue="";this.imageElement_.style.display="none";var a=this.selectedOption_&&this.selectedOption_[0];a&&"object"==typeof a?this.renderSelectedImage_(a):this.renderSelectedText_();this.positionBorderRect_()};
	Blockly.FieldDropdown.prototype.renderSelectedImage_=function(a){this.imageElement_.style.display="";this.imageElement_.setAttributeNS(Blockly.utils.dom.XLINK_NS,"xlink:href",a.src);this.imageElement_.setAttribute("height",a.height);this.imageElement_.setAttribute("width",a.width);var b=Number(a.height);a=Number(a.width);var c=!!this.borderRect_,d=Math.max(c?this.getConstants().FIELD_DROPDOWN_BORDER_RECT_HEIGHT:0,b+Blockly.FieldDropdown.IMAGE_Y_PADDING);c=c?this.getConstants().FIELD_BORDER_RECT_X_PADDING:
	0;var e=this.svgArrow_?this.positionSVGArrow_(a+c,d/2-this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE/2):Blockly.utils.dom.getFastTextWidth(this.arrow_,this.getConstants().FIELD_TEXT_FONTSIZE,this.getConstants().FIELD_TEXT_FONTWEIGHT,this.getConstants().FIELD_TEXT_FONTFAMILY);this.size_.width=a+e+2*c;this.size_.height=d;var f=0;this.sourceBlock_.RTL?this.imageElement_.setAttribute("x",c+e):(f=a+e,this.textElement_.setAttribute("text-anchor","end"),this.imageElement_.setAttribute("x",c));this.imageElement_.setAttribute("y",
	d/2-b/2);this.positionTextElement_(f+c,a+e)};
	Blockly.FieldDropdown.prototype.renderSelectedText_=function(){this.textContent_.nodeValue=this.getDisplayText_();Blockly.utils.dom.addClass(this.textElement_,"blocklyDropdownText");this.textElement_.setAttribute("text-anchor","start");var a=!!this.borderRect_,b=Math.max(a?this.getConstants().FIELD_DROPDOWN_BORDER_RECT_HEIGHT:0,this.getConstants().FIELD_TEXT_HEIGHT),c=Blockly.utils.dom.getFastTextWidth(this.textElement_,this.getConstants().FIELD_TEXT_FONTSIZE,this.getConstants().FIELD_TEXT_FONTWEIGHT,
	this.getConstants().FIELD_TEXT_FONTFAMILY);a=a?this.getConstants().FIELD_BORDER_RECT_X_PADDING:0;var d=0;this.svgArrow_&&(d=this.positionSVGArrow_(c+a,b/2-this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE/2));this.size_.width=c+d+2*a;this.size_.height=b;this.positionTextElement_(a,c)};
	Blockly.FieldDropdown.prototype.positionSVGArrow_=function(a,b){if(!this.svgArrow_)return 0;var c=this.borderRect_?this.getConstants().FIELD_BORDER_RECT_X_PADDING:0,d=this.getConstants().FIELD_DROPDOWN_SVG_ARROW_PADDING,e=this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE;this.svgArrow_.setAttribute("transform","translate("+(this.sourceBlock_.RTL?c:a+d)+","+b+")");return e+d};
	Blockly.FieldDropdown.prototype.getText_=function(){if(!this.selectedOption_)return null;var a=this.selectedOption_[0];return"object"==typeof a?a.alt:a};
	Blockly.FieldDropdown.validateOptions_=function(a){if(!Array.isArray(a))throw TypeError("FieldDropdown options must be an array.");if(!a.length)throw TypeError("FieldDropdown options must not be an empty array.");for(var b=!1,c=0;c<a.length;++c){var d=a[c];Array.isArray(d)?"string"!=typeof d[1]?(b=!0,console.error("Invalid option["+c+"]: Each FieldDropdown option id must be a string. Found "+d[1]+" in: ",d)):d[0]&&"string"!=typeof d[0]&&"string"!=typeof d[0].src&&(b=!0,console.error("Invalid option["+
	c+"]: Each FieldDropdown option must have a string label or image description. Found"+d[0]+" in: ",d)):(b=!0,console.error("Invalid option["+c+"]: Each FieldDropdown option must be an array. Found: ",d))}if(b)throw TypeError("Found invalid FieldDropdown options.");};
	Blockly.FieldDropdown.prototype.onBlocklyAction=function(a){if(this.menu_){if(a===Blockly.navigation.ACTION_PREVIOUS)return this.menu_.highlightPrevious(),!0;if(a===Blockly.navigation.ACTION_NEXT)return this.menu_.highlightNext(),!0}return Blockly.FieldDropdown.superClass_.onBlocklyAction.call(this,a)};Blockly.fieldRegistry.register("field_dropdown",Blockly.FieldDropdown);Blockly.FieldLabelSerializable=function(a,b,c){Blockly.FieldLabelSerializable.superClass_.constructor.call(this,a,b,c)};Blockly.utils.object.inherits(Blockly.FieldLabelSerializable,Blockly.FieldLabel);Blockly.FieldLabelSerializable.fromJson=function(a){var b=Blockly.utils.replaceMessageReferences(a.text);return new Blockly.FieldLabelSerializable(b,void 0,a)};Blockly.FieldLabelSerializable.prototype.EDITABLE=!1;Blockly.FieldLabelSerializable.prototype.SERIALIZABLE=!0;
	Blockly.fieldRegistry.register("field_label_serializable",Blockly.FieldLabelSerializable);Blockly.FieldImage=function(a,b,c,d,e,f,g){if(!a)throw Error("Src value of an image field is required");a=Blockly.utils.replaceMessageReferences(a);c=Number(Blockly.utils.replaceMessageReferences(c));b=Number(Blockly.utils.replaceMessageReferences(b));if(isNaN(c)||isNaN(b))throw Error("Height and width values of an image field must cast to numbers.");if(0>=c||0>=b)throw Error("Height and width values of an image field must be greater than 0.");this.flipRtl_=!1;this.altText_="";Blockly.FieldImage.superClass_.constructor.call(this,
	a,null,g);g||(this.flipRtl_=!!f,this.altText_=Blockly.utils.replaceMessageReferences(d)||"");this.size_=new Blockly.utils.Size(b,c+Blockly.FieldImage.Y_PADDING);this.imageHeight_=c;this.clickHandler_=null;"function"==typeof e&&(this.clickHandler_=e);this.imageElement_=null};Blockly.utils.object.inherits(Blockly.FieldImage,Blockly.Field);Blockly.FieldImage.prototype.DEFAULT_VALUE="";Blockly.FieldImage.fromJson=function(a){return new Blockly.FieldImage(a.src,a.width,a.height,void 0,void 0,void 0,a)};
	Blockly.FieldImage.Y_PADDING=1;Blockly.FieldImage.prototype.EDITABLE=!1;Blockly.FieldImage.prototype.isDirty_=!1;Blockly.FieldImage.prototype.configure_=function(a){Blockly.FieldImage.superClass_.configure_.call(this,a);this.flipRtl_=!!a.flipRtl;this.altText_=Blockly.utils.replaceMessageReferences(a.alt)||""};
	Blockly.FieldImage.prototype.initView=function(){this.imageElement_=Blockly.utils.dom.createSvgElement("image",{height:this.imageHeight_+"px",width:this.size_.width+"px",alt:this.altText_},this.fieldGroup_);this.imageElement_.setAttributeNS(Blockly.utils.dom.XLINK_NS,"xlink:href",this.value_);this.clickHandler_&&(this.imageElement_.style.cursor="pointer")};Blockly.FieldImage.prototype.updateSize_=function(){};
	Blockly.FieldImage.prototype.doClassValidation_=function(a){return"string"!=typeof a?null:a};Blockly.FieldImage.prototype.doValueUpdate_=function(a){this.value_=a;this.imageElement_&&this.imageElement_.setAttributeNS(Blockly.utils.dom.XLINK_NS,"xlink:href",String(this.value_))};Blockly.FieldImage.prototype.getFlipRtl=function(){return this.flipRtl_};Blockly.FieldImage.prototype.setAlt=function(a){a!=this.altText_&&(this.altText_=a||"",this.imageElement_&&this.imageElement_.setAttribute("alt",this.altText_))};
	Blockly.FieldImage.prototype.showEditor_=function(){this.clickHandler_&&this.clickHandler_(this)};Blockly.FieldImage.prototype.setOnClickHandler=function(a){this.clickHandler_=a};Blockly.FieldImage.prototype.getText_=function(){return this.altText_};Blockly.fieldRegistry.register("field_image",Blockly.FieldImage);Blockly.FieldMultilineInput=function(a,b,c){Blockly.FieldMultilineInput.superClass_.constructor.call(this,a,b,c);this.textGroup_=null};Blockly.utils.object.inherits(Blockly.FieldMultilineInput,Blockly.FieldTextInput);Blockly.FieldMultilineInput.fromJson=function(a){var b=Blockly.utils.replaceMessageReferences(a.text);return new Blockly.FieldMultilineInput(b,void 0,a)};
	Blockly.FieldMultilineInput.prototype.initView=function(){this.createBorderRect_();this.textGroup_=Blockly.utils.dom.createSvgElement("g",{"class":"blocklyEditableText"},this.fieldGroup_)};
	Blockly.FieldMultilineInput.prototype.getDisplayText_=function(){var a=this.value_;if(!a)return Blockly.Field.NBSP;var b=a.split("\n");a="";for(var c=0;c<b.length;c++){var d=b[c];d.length>this.maxDisplayLength&&(d=d.substring(0,this.maxDisplayLength-4)+"...");d=d.replace(/\s/g,Blockly.Field.NBSP);a+=d;c!==b.length-1&&(a+="\n")}this.sourceBlock_.RTL&&(a+="\u200f");return a};
	Blockly.FieldMultilineInput.prototype.render_=function(){for(var a;a=this.textGroup_.firstChild;)this.textGroup_.removeChild(a);a=this.getDisplayText_().split("\n");for(var b=0,c=0;c<a.length;c++){var d=this.getConstants().FIELD_TEXT_HEIGHT+this.getConstants().FIELD_BORDER_RECT_Y_PADDING;Blockly.utils.dom.createSvgElement("text",{"class":"blocklyText blocklyMultilineText",x:this.getConstants().FIELD_BORDER_RECT_X_PADDING,y:b+this.getConstants().FIELD_BORDER_RECT_Y_PADDING,dy:this.getConstants().FIELD_TEXT_BASELINE},
	this.textGroup_).appendChild(document.createTextNode(a[c]));b+=d}this.updateSize_();this.isBeingEdited_&&(this.sourceBlock_.RTL?setTimeout(this.resizeEditor_.bind(this),0):this.resizeEditor_(),a=this.htmlInput_,this.isTextValid_?(Blockly.utils.dom.removeClass(a,"blocklyInvalidInput"),Blockly.utils.aria.setState(a,Blockly.utils.aria.State.INVALID,!1)):(Blockly.utils.dom.addClass(a,"blocklyInvalidInput"),Blockly.utils.aria.setState(a,Blockly.utils.aria.State.INVALID,!0)))};
	Blockly.FieldMultilineInput.prototype.updateSize_=function(){for(var a=this.textGroup_.childNodes,b=0,c=0,d=0;d<a.length;d++){var e=Blockly.utils.dom.getTextWidth(a[d]);e>b&&(b=e);c+=this.getConstants().FIELD_TEXT_HEIGHT+(0<d?this.getConstants().FIELD_BORDER_RECT_Y_PADDING:0)}this.borderRect_&&(c+=2*this.getConstants().FIELD_BORDER_RECT_Y_PADDING,b+=2*this.getConstants().FIELD_BORDER_RECT_X_PADDING,this.borderRect_.setAttribute("width",b),this.borderRect_.setAttribute("height",c));this.size_.width=
	b;this.size_.height=c;this.positionBorderRect_()};
	Blockly.FieldMultilineInput.prototype.widgetCreate_=function(){var a=Blockly.WidgetDiv.DIV,b=this.workspace_.getScale(),c=document.createElement("textarea");c.className="blocklyHtmlInput blocklyHtmlTextAreaInput";c.setAttribute("spellcheck",this.spellcheck_);var d=this.getConstants().FIELD_TEXT_FONTSIZE*b+"pt";a.style.fontSize=d;c.style.fontSize=d;c.style.borderRadius=Blockly.FieldTextInput.BORDERRADIUS*b+"px";d=this.getConstants().FIELD_BORDER_RECT_X_PADDING*b;var e=this.getConstants().FIELD_BORDER_RECT_Y_PADDING*
	b/2;c.style.padding=e+"px "+d+"px "+e+"px "+d+"px";d=this.getConstants().FIELD_TEXT_HEIGHT+this.getConstants().FIELD_BORDER_RECT_Y_PADDING;c.style.lineHeight=d*b+"px";a.appendChild(c);c.value=c.defaultValue=this.getEditorText_(this.value_);c.untypedDefaultValue_=this.value_;c.oldValue_=null;Blockly.utils.userAgent.GECKO?setTimeout(this.resizeEditor_.bind(this),0):this.resizeEditor_();this.bindInputEvents_(c);return c};
	Blockly.FieldMultilineInput.prototype.onHtmlInputKeyDown_=function(a){a.keyCode!==Blockly.utils.KeyCodes.ENTER&&Blockly.FieldMultilineInput.superClass_.onHtmlInputKeyDown_.call(this,a)};Blockly.Css.register(".blocklyHtmlTextAreaInput {,font-family: monospace;,resize: none;,overflow: hidden;,height: 100%;,text-align: left;,}".split(","));Blockly.fieldRegistry.register("field_multilinetext",Blockly.FieldMultilineInput);Blockly.FieldNumber=function(a,b,c,d,e,f){this.min_=-Infinity;this.max_=Infinity;this.precision_=0;this.decimalPlaces_=null;Blockly.FieldNumber.superClass_.constructor.call(this,a,e,f);f||this.setConstraints(b,c,d)};Blockly.utils.object.inherits(Blockly.FieldNumber,Blockly.FieldTextInput);Blockly.FieldNumber.prototype.DEFAULT_VALUE=0;Blockly.FieldNumber.fromJson=function(a){return new Blockly.FieldNumber(a.value,void 0,void 0,void 0,void 0,a)};Blockly.FieldNumber.prototype.SERIALIZABLE=!0;
	Blockly.FieldNumber.prototype.configure_=function(a){Blockly.FieldNumber.superClass_.configure_.call(this,a);this.setMinInternal_(a.min);this.setMaxInternal_(a.max);this.setPrecisionInternal_(a.precision)};Blockly.FieldNumber.prototype.setConstraints=function(a,b,c){this.setMinInternal_(a);this.setMaxInternal_(b);this.setPrecisionInternal_(c);this.setValue(this.getValue())};Blockly.FieldNumber.prototype.setMin=function(a){this.setMinInternal_(a);this.setValue(this.getValue())};
	Blockly.FieldNumber.prototype.setMinInternal_=function(a){null==a?this.min_=-Infinity:(a=Number(a),isNaN(a)||(this.min_=a))};Blockly.FieldNumber.prototype.getMin=function(){return this.min_};Blockly.FieldNumber.prototype.setMax=function(a){this.setMaxInternal_(a);this.setValue(this.getValue())};Blockly.FieldNumber.prototype.setMaxInternal_=function(a){null==a?this.max_=Infinity:(a=Number(a),isNaN(a)||(this.max_=a))};Blockly.FieldNumber.prototype.getMax=function(){return this.max_};
	Blockly.FieldNumber.prototype.setPrecision=function(a){this.setPrecisionInternal_(a);this.setValue(this.getValue())};Blockly.FieldNumber.prototype.setPrecisionInternal_=function(a){null==a?this.precision_=0:(a=Number(a),isNaN(a)||(this.precision_=a));var b=this.precision_.toString(),c=b.indexOf(".");this.decimalPlaces_=-1==c?a?0:null:b.length-c-1};Blockly.FieldNumber.prototype.getPrecision=function(){return this.precision_};
	Blockly.FieldNumber.prototype.doClassValidation_=function(a){if(null===a)return null;a=String(a);a=a.replace(/O/ig,"0");a=a.replace(/,/g,"");a=a.replace(/infinity/i,"Infinity");a=Number(a||0);if(isNaN(a))return null;a=Math.min(Math.max(a,this.min_),this.max_);this.precision_&&isFinite(a)&&(a=Math.round(a/this.precision_)*this.precision_);null!=this.decimalPlaces_&&(a=Number(a.toFixed(this.decimalPlaces_)));return a};
	Blockly.FieldNumber.prototype.widgetCreate_=function(){var a=Blockly.FieldNumber.superClass_.widgetCreate_.call(this);-Infinity<this.min_&&Blockly.utils.aria.setState(a,Blockly.utils.aria.State.VALUEMIN,this.min_);Infinity>this.max_&&Blockly.utils.aria.setState(a,Blockly.utils.aria.State.VALUEMAX,this.max_);return a};Blockly.fieldRegistry.register("field_number",Blockly.FieldNumber);Blockly.FieldVariable=function(a,b,c,d,e){this.menuGenerator_=Blockly.FieldVariable.dropdownCreate;this.defaultVariableName=a||"";this.size_=new Blockly.utils.Size(0,0);e&&this.configure_(e);b&&this.setValidator(b);e||this.setTypes_(c,d)};Blockly.utils.object.inherits(Blockly.FieldVariable,Blockly.FieldDropdown);Blockly.FieldVariable.fromJson=function(a){var b=Blockly.utils.replaceMessageReferences(a.variable);return new Blockly.FieldVariable(b,void 0,void 0,void 0,a)};
	Blockly.FieldVariable.prototype.SERIALIZABLE=!0;Blockly.FieldVariable.prototype.configure_=function(a){Blockly.FieldVariable.superClass_.configure_.call(this,a);this.setTypes_(a.variableTypes,a.defaultType)};Blockly.FieldVariable.prototype.initModel=function(){if(!this.variable_){var a=Blockly.Variables.getOrCreateVariablePackage(this.sourceBlock_.workspace,null,this.defaultVariableName,this.defaultType_);this.doValueUpdate_(a.getId())}};
	Blockly.FieldVariable.prototype.shouldAddBorderRect_=function(){return Blockly.FieldVariable.superClass_.shouldAddBorderRect_.call(this)&&(!this.getConstants().FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW||"variables_get"!=this.sourceBlock_.type)};
	Blockly.FieldVariable.prototype.fromXml=function(a){var b=a.getAttribute("id"),c=a.textContent,d=a.getAttribute("variabletype")||a.getAttribute("variableType")||"";b=Blockly.Variables.getOrCreateVariablePackage(this.sourceBlock_.workspace,b,c,d);if(null!=d&&d!==b.type)throw Error("Serialized variable type with id '"+b.getId()+"' had type "+b.type+", and does not match variable field that references it: "+Blockly.Xml.domToText(a)+".");this.setValue(b.getId())};
	Blockly.FieldVariable.prototype.toXml=function(a){this.initModel();a.id=this.variable_.getId();a.textContent=this.variable_.name;this.variable_.type&&a.setAttribute("variabletype",this.variable_.type);return a};Blockly.FieldVariable.prototype.setSourceBlock=function(a){if(a.isShadow())throw Error("Variable fields are not allowed to exist on shadow blocks.");Blockly.FieldVariable.superClass_.setSourceBlock.call(this,a)};
	Blockly.FieldVariable.prototype.getValue=function(){return this.variable_?this.variable_.getId():null};Blockly.FieldVariable.prototype.getText=function(){return this.variable_?this.variable_.name:""};Blockly.FieldVariable.prototype.getVariable=function(){return this.variable_};Blockly.FieldVariable.prototype.getValidator=function(){return this.variable_?this.validator_:null};
	Blockly.FieldVariable.prototype.doClassValidation_=function(a){if(null===a)return null;var b=Blockly.Variables.getVariable(this.sourceBlock_.workspace,a);if(!b)return console.warn("Variable id doesn't point to a real variable! ID was "+a),null;b=b.type;return this.typeIsAllowed_(b)?a:(console.warn("Variable type doesn't match this field!  Type was "+b),null)};
	Blockly.FieldVariable.prototype.doValueUpdate_=function(a){this.variable_=Blockly.Variables.getVariable(this.sourceBlock_.workspace,a);Blockly.FieldVariable.superClass_.doValueUpdate_.call(this,a)};Blockly.FieldVariable.prototype.typeIsAllowed_=function(a){var b=this.getVariableTypes_();if(!b)return!0;for(var c=0;c<b.length;c++)if(a==b[c])return!0;return!1};
	Blockly.FieldVariable.prototype.getVariableTypes_=function(){var a=this.variableTypes;if(null===a&&this.sourceBlock_&&this.sourceBlock_.workspace)return this.sourceBlock_.workspace.getVariableTypes();a=a||[""];if(0==a.length)throw a=this.getText(),Error("'variableTypes' of field variable "+a+" was an empty list");return a};
	Blockly.FieldVariable.prototype.setTypes_=function(a,b){b=b||"";if(null==a||void 0==a)a=null;else if(Array.isArray(a)){for(var c=!1,d=0;d<a.length;d++)a[d]==b&&(c=!0);if(!c)throw Error("Invalid default type '"+b+"' in the definition of a FieldVariable");}else throw Error("'variableTypes' was not an array in the definition of a FieldVariable");this.defaultType_=b;this.variableTypes=a};Blockly.FieldVariable.prototype.refreshVariableName=function(){this.forceRerender()};
	Blockly.FieldVariable.dropdownCreate=function(){if(!this.variable_)throw Error("Tried to call dropdownCreate on a variable field with no variable selected.");var a=this.getText(),b=[];if(this.sourceBlock_&&this.sourceBlock_.workspace)for(var c=this.getVariableTypes_(),d=0;d<c.length;d++){var e=this.sourceBlock_.workspace.getVariablesOfType(c[d]);b=b.concat(e)}b.sort(Blockly.VariableModel.compareByName);c=[];for(d=0;d<b.length;d++)c[d]=[b[d].name,b[d].getId()];c.push([Blockly.Msg.RENAME_VARIABLE,Blockly.RENAME_VARIABLE_ID]);
	Blockly.Msg.DELETE_VARIABLE&&c.push([Blockly.Msg.DELETE_VARIABLE.replace("%1",a),Blockly.DELETE_VARIABLE_ID]);return c};Blockly.FieldVariable.prototype.onItemSelected_=function(a,b){a=b.getValue();if(this.sourceBlock_&&this.sourceBlock_.workspace){if(a==Blockly.RENAME_VARIABLE_ID){Blockly.Variables.renameVariable(this.sourceBlock_.workspace,this.variable_);return}if(a==Blockly.DELETE_VARIABLE_ID){this.sourceBlock_.workspace.deleteVariableById(this.variable_.getId());return}}this.setValue(a)};
	Blockly.FieldVariable.prototype.referencesVariables=function(){return!0};Blockly.fieldRegistry.register("field_variable",Blockly.FieldVariable);Blockly.utils.svgPaths={};Blockly.utils.svgPaths.point=function(a,b){return" "+a+","+b+" "};Blockly.utils.svgPaths.curve=function(a,b){return" "+a+b.join("")};Blockly.utils.svgPaths.moveTo=function(a,b){return" M "+a+","+b+" "};Blockly.utils.svgPaths.moveBy=function(a,b){return" m "+a+","+b+" "};Blockly.utils.svgPaths.lineTo=function(a,b){return" l "+a+","+b+" "};Blockly.utils.svgPaths.line=function(a){return" l"+a.join("")};Blockly.utils.svgPaths.lineOnAxis=function(a,b){return" "+a+" "+b+" "};
	Blockly.utils.svgPaths.arc=function(a,b,c,d){return a+" "+c+" "+c+" "+b+d};Blockly.blockRendering.ConstantProvider=function(){this.NO_PADDING=0;this.SMALL_PADDING=3;this.MEDIUM_PADDING=5;this.MEDIUM_LARGE_PADDING=8;this.LARGE_PADDING=10;this.TALL_INPUT_FIELD_OFFSET_Y=this.MEDIUM_PADDING;this.TAB_HEIGHT=15;this.TAB_OFFSET_FROM_TOP=5;this.TAB_VERTICAL_OVERLAP=2.5;this.TAB_WIDTH=8;this.NOTCH_WIDTH=15;this.NOTCH_HEIGHT=4;this.MIN_BLOCK_WIDTH=12;this.EMPTY_BLOCK_SPACER_HEIGHT=16;this.DUMMY_INPUT_SHADOW_MIN_HEIGHT=this.DUMMY_INPUT_MIN_HEIGHT=this.TAB_HEIGHT;this.CORNER_RADIUS=
	8;this.STATEMENT_INPUT_NOTCH_OFFSET=this.NOTCH_OFFSET_LEFT=15;this.STATEMENT_BOTTOM_SPACER=0;this.STATEMENT_INPUT_PADDING_LEFT=20;this.BETWEEN_STATEMENT_PADDING_Y=4;this.TOP_ROW_MIN_HEIGHT=this.MEDIUM_PADDING;this.TOP_ROW_PRECEDES_STATEMENT_MIN_HEIGHT=this.LARGE_PADDING;this.BOTTOM_ROW_MIN_HEIGHT=this.MEDIUM_PADDING;this.BOTTOM_ROW_AFTER_STATEMENT_MIN_HEIGHT=this.LARGE_PADDING;this.ADD_START_HATS=!1;this.START_HAT_HEIGHT=15;this.START_HAT_WIDTH=100;this.SPACER_DEFAULT_HEIGHT=15;this.MIN_BLOCK_HEIGHT=
	24;this.EMPTY_INLINE_INPUT_PADDING=14.5;this.EMPTY_INLINE_INPUT_HEIGHT=this.TAB_HEIGHT+11;this.EXTERNAL_VALUE_INPUT_PADDING=2;this.EMPTY_STATEMENT_INPUT_HEIGHT=this.MIN_BLOCK_HEIGHT;this.START_POINT=Blockly.utils.svgPaths.moveBy(0,0);this.JAGGED_TEETH_HEIGHT=12;this.JAGGED_TEETH_WIDTH=6;this.FIELD_TEXT_FONTSIZE=11;this.FIELD_TEXT_FONTWEIGHT="normal";this.FIELD_TEXT_FONTFAMILY="sans-serif";this.FIELD_TEXT_BASELINE=this.FIELD_TEXT_HEIGHT=-1;this.FIELD_BORDER_RECT_RADIUS=4;this.FIELD_BORDER_RECT_HEIGHT=
	16;this.FIELD_BORDER_RECT_X_PADDING=5;this.FIELD_BORDER_RECT_Y_PADDING=3;this.FIELD_BORDER_RECT_COLOUR="#fff";this.FIELD_TEXT_BASELINE_CENTER=!Blockly.utils.userAgent.IE&&!Blockly.utils.userAgent.EDGE;this.FIELD_DROPDOWN_BORDER_RECT_HEIGHT=this.FIELD_BORDER_RECT_HEIGHT;this.FIELD_DROPDOWN_SVG_ARROW=this.FIELD_DROPDOWN_COLOURED_DIV=this.FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW=!1;this.FIELD_DROPDOWN_SVG_ARROW_PADDING=this.FIELD_BORDER_RECT_X_PADDING;this.FIELD_DROPDOWN_SVG_ARROW_SIZE=12;this.FIELD_DROPDOWN_SVG_ARROW_DATAURI=
	"data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMi43MSIgaGVpZ2h0PSI4Ljc5IiB2aWV3Qm94PSIwIDAgMTIuNzEgOC43OSI+PHRpdGxlPmRyb3Bkb3duLWFycm93PC90aXRsZT48ZyBvcGFjaXR5PSIwLjEiPjxwYXRoIGQ9Ik0xMi43MSwyLjQ0QTIuNDEsMi40MSwwLDAsMSwxMiw0LjE2TDguMDgsOC4wOGEyLjQ1LDIuNDUsMCwwLDEtMy40NSwwTDAuNzIsNC4xNkEyLjQyLDIuNDIsMCwwLDEsMCwyLjQ0LDIuNDgsMi40OCwwLDAsMSwuNzEuNzFDMSwwLjQ3LDEuNDMsMCw2LjM2LDBTMTEuNzUsMC40NiwxMiwuNzFBMi40NCwyLjQ0LDAsMCwxLDEyLjcxLDIuNDRaIiBmaWxsPSIjMjMxZjIwIi8+PC9nPjxwYXRoIGQ9Ik02LjM2LDcuNzlhMS40MywxLjQzLDAsMCwxLTEtLjQyTDEuNDIsMy40NWExLjQ0LDEuNDQsMCwwLDEsMC0yYzAuNTYtLjU2LDkuMzEtMC41Niw5Ljg3LDBhMS40NCwxLjQ0LDAsMCwxLDAsMkw3LjM3LDcuMzdBMS40MywxLjQzLDAsMCwxLDYuMzYsNy43OVoiIGZpbGw9IiNmZmYiLz48L3N2Zz4=";
	this.FIELD_COLOUR_FULL_BLOCK=this.FIELD_TEXTINPUT_BOX_SHADOW=!1;this.FIELD_COLOUR_DEFAULT_WIDTH=26;this.FIELD_COLOUR_DEFAULT_HEIGHT=this.FIELD_BORDER_RECT_HEIGHT;this.FIELD_CHECKBOX_X_OFFSET=this.FIELD_BORDER_RECT_X_PADDING-3;this.randomIdentifier=String(Math.random()).substring(2);this.embossFilterId="";this.embossFilter_=null;this.disabledPatternId="";this.disabledPattern_=null;this.debugFilterId="";this.cssNode_=this.debugFilter_=null;this.CURSOR_COLOUR="#cc0a0a";this.MARKER_COLOUR="#4286f4";this.CURSOR_WS_WIDTH=
	100;this.WS_CURSOR_HEIGHT=5;this.CURSOR_STACK_PADDING=10;this.CURSOR_BLOCK_PADDING=2;this.CURSOR_STROKE_WIDTH=4;this.FULL_BLOCK_FIELDS=!1;this.INSERTION_MARKER_COLOUR="#000000";this.INSERTION_MARKER_OPACITY=.2;this.SHAPES={PUZZLE:1,NOTCH:2}};
	Blockly.blockRendering.ConstantProvider.prototype.init=function(){this.JAGGED_TEETH=this.makeJaggedTeeth();this.NOTCH=this.makeNotch();this.START_HAT=this.makeStartHat();this.PUZZLE_TAB=this.makePuzzleTab();this.INSIDE_CORNERS=this.makeInsideCorners();this.OUTSIDE_CORNERS=this.makeOutsideCorners()};Blockly.blockRendering.ConstantProvider.prototype.setTheme=function(a){this.blockStyles={};var b=a.blockStyles,c;for(c in b)this.blockStyles[c]=this.validatedBlockStyle_(b[c]);this.setDynamicProperties_(a)};
	Blockly.blockRendering.ConstantProvider.prototype.setDynamicProperties_=function(a){this.setFontConstants_(a);this.setComponentConstants_(a);this.ADD_START_HATS=null!=a.startHats?a.startHats:this.ADD_START_HATS};
	Blockly.blockRendering.ConstantProvider.prototype.setFontConstants_=function(a){this.FIELD_TEXT_FONTFAMILY=a.fontStyle&&void 0!=a.fontStyle.family?a.fontStyle.family:this.FIELD_TEXT_FONTFAMILY;this.FIELD_TEXT_FONTWEIGHT=a.fontStyle&&void 0!=a.fontStyle.weight?a.fontStyle.weight:this.FIELD_TEXT_FONTWEIGHT;this.FIELD_TEXT_FONTSIZE=a.fontStyle&&void 0!=a.fontStyle.size?a.fontStyle.size:this.FIELD_TEXT_FONTSIZE;a=Blockly.utils.dom.measureFontMetrics("Hg",this.FIELD_TEXT_FONTSIZE+"pt",this.FIELD_TEXT_FONTWEIGHT,
	this.FIELD_TEXT_FONTFAMILY);this.FIELD_TEXT_HEIGHT=a.height;this.FIELD_TEXT_BASELINE=a.baseline};
	Blockly.blockRendering.ConstantProvider.prototype.setComponentConstants_=function(a){this.CURSOR_COLOUR=a.getComponentStyle("cursorColour")||this.CURSOR_COLOUR;this.MARKER_COLOUR=a.getComponentStyle("markerColour")||this.MARKER_COLOUR;this.INSERTION_MARKER_COLOUR=a.getComponentStyle("insertionMarkerColour")||this.INSERTION_MARKER_COLOUR;this.INSERTION_MARKER_OPACITY=Number(a.getComponentStyle("insertionMarkerOpacity"))||this.INSERTION_MARKER_OPACITY};
	Blockly.blockRendering.ConstantProvider.prototype.getBlockStyleForColour=function(a){var b="auto_"+a;this.blockStyles[b]||(this.blockStyles[b]=this.createBlockStyle_(a));return{style:this.blockStyles[b],name:b}};Blockly.blockRendering.ConstantProvider.prototype.getBlockStyle=function(a){return this.blockStyles[a||""]||(a&&0==a.indexOf("auto_")?this.getBlockStyleForColour(a.substring(5)).style:this.createBlockStyle_("#000000"))};Blockly.blockRendering.ConstantProvider.prototype.createBlockStyle_=function(a){return this.validatedBlockStyle_({colourPrimary:a})};
	Blockly.blockRendering.ConstantProvider.prototype.validatedBlockStyle_=function(a){var b={};a&&Blockly.utils.object.mixin(b,a);a=Blockly.utils.parseBlockColour(b.colourPrimary||"#000");b.colourPrimary=a.hex;b.colourSecondary=b.colourSecondary?Blockly.utils.parseBlockColour(b.colourSecondary).hex:this.generateSecondaryColour_(b.colourPrimary);b.colourTertiary=b.colourTertiary?Blockly.utils.parseBlockColour(b.colourTertiary).hex:this.generateTertiaryColour_(b.colourPrimary);b.hat=b.hat||"";return b};
	Blockly.blockRendering.ConstantProvider.prototype.generateSecondaryColour_=function(a){return Blockly.utils.colour.blend("#fff",a,.6)||a};Blockly.blockRendering.ConstantProvider.prototype.generateTertiaryColour_=function(a){return Blockly.utils.colour.blend("#fff",a,.3)||a};
	Blockly.blockRendering.ConstantProvider.prototype.dispose=function(){this.embossFilter_&&Blockly.utils.dom.removeNode(this.embossFilter_);this.disabledPattern_&&Blockly.utils.dom.removeNode(this.disabledPattern_);this.debugFilter_&&Blockly.utils.dom.removeNode(this.debugFilter_);this.cssNode_=null};
	Blockly.blockRendering.ConstantProvider.prototype.makeJaggedTeeth=function(){var a=this.JAGGED_TEETH_HEIGHT,b=this.JAGGED_TEETH_WIDTH,c=Blockly.utils.svgPaths.line([Blockly.utils.svgPaths.point(b,a/4),Blockly.utils.svgPaths.point(2*-b,a/2),Blockly.utils.svgPaths.point(b,a/4)]);return{height:a,width:b,path:c}};
	Blockly.blockRendering.ConstantProvider.prototype.makeStartHat=function(){var a=this.START_HAT_HEIGHT,b=this.START_HAT_WIDTH,c=Blockly.utils.svgPaths.curve("c",[Blockly.utils.svgPaths.point(30,-a),Blockly.utils.svgPaths.point(70,-a),Blockly.utils.svgPaths.point(b,0)]);return{height:a,width:b,path:c}};
	Blockly.blockRendering.ConstantProvider.prototype.makePuzzleTab=function(){function a(a){a=a?-1:1;var d=-a,e=c/2,f=e+2.5,l=e+.5,m=Blockly.utils.svgPaths.point(-b,a*e);e=Blockly.utils.svgPaths.point(b,a*e);return Blockly.utils.svgPaths.curve("c",[Blockly.utils.svgPaths.point(0,a*f),Blockly.utils.svgPaths.point(-b,d*l),m])+Blockly.utils.svgPaths.curve("s",[Blockly.utils.svgPaths.point(b,2.5*d),e])}var b=this.TAB_WIDTH,c=this.TAB_HEIGHT,d=a(!0),e=a(!1);return{type:this.SHAPES.PUZZLE,width:b,height:c,
	pathDown:e,pathUp:d}};Blockly.blockRendering.ConstantProvider.prototype.makeNotch=function(){function a(a){return Blockly.utils.svgPaths.line([Blockly.utils.svgPaths.point(a*d,c),Blockly.utils.svgPaths.point(3*a,0),Blockly.utils.svgPaths.point(a*d,-c)])}var b=this.NOTCH_WIDTH,c=this.NOTCH_HEIGHT,d=(b-3)/2,e=a(1),f=a(-1);return{type:this.SHAPES.NOTCH,width:b,height:c,pathLeft:e,pathRight:f}};
	Blockly.blockRendering.ConstantProvider.prototype.makeInsideCorners=function(){var a=this.CORNER_RADIUS,b=Blockly.utils.svgPaths.arc("a","0 0,0",a,Blockly.utils.svgPaths.point(-a,a)),c=Blockly.utils.svgPaths.arc("a","0 0,0",a,Blockly.utils.svgPaths.point(a,a));return{width:a,height:a,pathTop:b,pathBottom:c}};
	Blockly.blockRendering.ConstantProvider.prototype.makeOutsideCorners=function(){var a=this.CORNER_RADIUS,b=Blockly.utils.svgPaths.moveBy(0,a)+Blockly.utils.svgPaths.arc("a","0 0,1",a,Blockly.utils.svgPaths.point(a,-a)),c=Blockly.utils.svgPaths.arc("a","0 0,1",a,Blockly.utils.svgPaths.point(a,a)),d=Blockly.utils.svgPaths.arc("a","0 0,1",a,Blockly.utils.svgPaths.point(-a,-a)),e=Blockly.utils.svgPaths.arc("a","0 0,1",a,Blockly.utils.svgPaths.point(-a,a));return{topLeft:b,topRight:c,bottomRight:e,bottomLeft:d,
	rightHeight:a}};Blockly.blockRendering.ConstantProvider.prototype.shapeFor=function(a){switch(a.type){case Blockly.INPUT_VALUE:case Blockly.OUTPUT_VALUE:return this.PUZZLE_TAB;case Blockly.PREVIOUS_STATEMENT:case Blockly.NEXT_STATEMENT:return this.NOTCH;default:throw Error("Unknown connection type");}};
	Blockly.blockRendering.ConstantProvider.prototype.createDom=function(a,b,c){this.injectCSS_(b,c);a=Blockly.utils.dom.createSvgElement("defs",{},a);b=Blockly.utils.dom.createSvgElement("filter",{id:"blocklyEmbossFilter"+this.randomIdentifier},a);Blockly.utils.dom.createSvgElement("feGaussianBlur",{"in":"SourceAlpha",stdDeviation:1,result:"blur"},b);c=Blockly.utils.dom.createSvgElement("feSpecularLighting",{"in":"blur",surfaceScale:1,specularConstant:.5,specularExponent:10,"lighting-color":"white",
	result:"specOut"},b);Blockly.utils.dom.createSvgElement("fePointLight",{x:-5E3,y:-1E4,z:2E4},c);Blockly.utils.dom.createSvgElement("feComposite",{"in":"specOut",in2:"SourceAlpha",operator:"in",result:"specOut"},b);Blockly.utils.dom.createSvgElement("feComposite",{"in":"SourceGraphic",in2:"specOut",operator:"arithmetic",k1:0,k2:1,k3:1,k4:0},b);this.embossFilterId=b.id;this.embossFilter_=b;b=Blockly.utils.dom.createSvgElement("pattern",{id:"blocklyDisabledPattern"+this.randomIdentifier,patternUnits:"userSpaceOnUse",
	width:10,height:10},a);Blockly.utils.dom.createSvgElement("rect",{width:10,height:10,fill:"#aaa"},b);Blockly.utils.dom.createSvgElement("path",{d:"M 0 0 L 10 10 M 10 0 L 0 10",stroke:"#cc0"},b);this.disabledPatternId=b.id;this.disabledPattern_=b;Blockly.blockRendering.Debug&&(a=Blockly.utils.dom.createSvgElement("filter",{id:"blocklyDebugFilter"+this.randomIdentifier,height:"160%",width:"180%",y:"-30%",x:"-40%"},a),b=Blockly.utils.dom.createSvgElement("feComponentTransfer",{result:"outBlur"},a),Blockly.utils.dom.createSvgElement("feFuncA",
	{type:"table",tableValues:"0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1"},b),Blockly.utils.dom.createSvgElement("feFlood",{"flood-color":"#ff0000","flood-opacity":.5,result:"outColor"},a),Blockly.utils.dom.createSvgElement("feComposite",{"in":"outColor",in2:"outBlur",operator:"in",result:"outGlow"},a),this.debugFilterId=a.id,this.debugFilter_=a)};
	Blockly.blockRendering.ConstantProvider.prototype.injectCSS_=function(a,b){b=this.getCSS_(b);a="blockly-renderer-style-"+a;this.cssNode_=document.getElementById(a);var c=b.join("\n");this.cssNode_?this.cssNode_.firstChild.textContent=c:(b=document.createElement("style"),b.id=a,a=document.createTextNode(c),b.appendChild(a),document.head.insertBefore(b,document.head.firstChild),this.cssNode_=b)};
	Blockly.blockRendering.ConstantProvider.prototype.getCSS_=function(a){return[a+" .blocklyText, ",a+" .blocklyFlyoutLabelText {","font: "+this.FIELD_TEXT_FONTWEIGHT+" "+this.FIELD_TEXT_FONTSIZE+"pt "+this.FIELD_TEXT_FONTFAMILY+";","}",a+" .blocklyText {","fill: #fff;","}",a+" .blocklyNonEditableText>rect,",a+" .blocklyEditableText>rect {","fill: "+this.FIELD_BORDER_RECT_COLOUR+";","fill-opacity: .6;","stroke: none;","}",a+" .blocklyNonEditableText>text,",a+" .blocklyEditableText>text {","fill: #000;",
	"}",a+" .blocklyFlyoutLabelText {","fill: #000;","}",a+" .blocklyText.blocklyBubbleText {","fill: #000;","}",a+" .blocklyEditableText:not(.editing):hover>rect {","stroke: #fff;","stroke-width: 2;","}",a+" .blocklyHtmlInput {","font-family: "+this.FIELD_TEXT_FONTFAMILY+";","font-weight: "+this.FIELD_TEXT_FONTWEIGHT+";","}",a+" .blocklySelected>.blocklyPath {","stroke: #fc3;","stroke-width: 3px;","}",a+" .blocklyHighlightedConnectionPath {","stroke: #fc3;","}",a+" .blocklyReplaceable .blocklyPath {",
	"fill-opacity: .5;","}",a+" .blocklyReplaceable .blocklyPathLight,",a+" .blocklyReplaceable .blocklyPathDark {","display: none;","}",a+" .blocklyInsertionMarker>.blocklyPath {","fill-opacity: "+this.INSERTION_MARKER_OPACITY+";","stroke: none;","}"]};Blockly.blockRendering.MarkerSvg=function(a,b,c){this.workspace_=a;this.marker_=c;this.parent_=null;this.constants_=b;this.currentMarkerSvg=null;a=this.isCursor()?this.constants_.CURSOR_COLOUR:this.constants_.MARKER_COLOUR;this.colour_=c.colour||a};Blockly.blockRendering.MarkerSvg.CURSOR_CLASS="blocklyCursor";Blockly.blockRendering.MarkerSvg.MARKER_CLASS="blocklyMarker";Blockly.blockRendering.MarkerSvg.HEIGHT_MULTIPLIER=.75;Blockly.blockRendering.MarkerSvg.prototype.getSvgRoot=function(){return this.svgGroup_};
	Blockly.blockRendering.MarkerSvg.prototype.getMarker=function(){return this.marker_};Blockly.blockRendering.MarkerSvg.prototype.isCursor=function(){return"cursor"==this.marker_.type};Blockly.blockRendering.MarkerSvg.prototype.createDom=function(){var a=this.isCursor()?Blockly.blockRendering.MarkerSvg.CURSOR_CLASS:Blockly.blockRendering.MarkerSvg.MARKER_CLASS;this.svgGroup_=Blockly.utils.dom.createSvgElement("g",{"class":a},null);this.createDomInternal_();return this.svgGroup_};
	Blockly.blockRendering.MarkerSvg.prototype.setParent_=function(a){this.isCursor()?(this.parent_&&this.parent_.setCursorSvg(null),a.setCursorSvg(this.getSvgRoot())):(this.parent_&&this.parent_.setMarkerSvg(null),a.setMarkerSvg(this.getSvgRoot()));this.parent_=a};
	Blockly.blockRendering.MarkerSvg.prototype.draw=function(a,b){if(b){this.constants_=this.workspace_.getRenderer().getConstants();var c=this.isCursor()?this.constants_.CURSOR_COLOUR:this.constants_.MARKER_COLOUR;this.colour_=this.marker_.colour||c;this.applyColour_(b);this.showAtLocation_(b);this.fireMarkerEvent_(a,b);a=this.currentMarkerSvg.childNodes[0];void 0!==a&&a.beginElement&&a.beginElement()}else this.hide()};
	Blockly.blockRendering.MarkerSvg.prototype.showAtLocation_=function(a){var b=a.getLocation();a.getType()==Blockly.ASTNode.types.BLOCK?this.showWithBlock_(a):a.getType()==Blockly.ASTNode.types.OUTPUT?this.showWithOutput_(a):b.type==Blockly.INPUT_VALUE?this.showWithInput_(a):b.type==Blockly.NEXT_STATEMENT?this.showWithNext_(a):a.getType()==Blockly.ASTNode.types.PREVIOUS?this.showWithPrevious_(a):a.getType()==Blockly.ASTNode.types.FIELD?this.showWithField_(a):a.getType()==Blockly.ASTNode.types.WORKSPACE?
	this.showWithCoordinates_(a):a.getType()==Blockly.ASTNode.types.STACK&&this.showWithStack_(a)};
	Blockly.blockRendering.MarkerSvg.prototype.showWithBlockPrevOutput_=function(a){a=a.getSourceBlock();var b=a.width,c=a.height,d=c*Blockly.blockRendering.MarkerSvg.HEIGHT_MULTIPLIER,e=this.constants_.CURSOR_BLOCK_PADDING;if(a.previousConnection){var f=this.constants_.shapeFor(a.previousConnection);this.positionPrevious_(b,e,d,f)}else a.outputConnection?(f=this.constants_.shapeFor(a.outputConnection),this.positionOutput_(b,c,f)):this.positionBlock_(b,e,d);this.setParent_(a);this.showCurrent_()};
	Blockly.blockRendering.MarkerSvg.prototype.showWithBlock_=function(a){this.showWithBlockPrevOutput_(a)};Blockly.blockRendering.MarkerSvg.prototype.showWithPrevious_=function(a){this.showWithBlockPrevOutput_(a)};Blockly.blockRendering.MarkerSvg.prototype.showWithOutput_=function(a){this.showWithBlockPrevOutput_(a)};
	Blockly.blockRendering.MarkerSvg.prototype.showWithCoordinates_=function(a){var b=a.getWsCoordinate();a=b.x;b=b.y;this.workspace_.RTL&&(a-=this.constants_.CURSOR_WS_WIDTH);this.positionLine_(a,b,this.constants_.CURSOR_WS_WIDTH);this.setParent_(this.workspace_);this.showCurrent_()};Blockly.blockRendering.MarkerSvg.prototype.showWithField_=function(a){a=a.getLocation();var b=a.getSize().width,c=a.getSize().height;this.positionRect_(0,0,b,c);this.setParent_(a);this.showCurrent_()};
	Blockly.blockRendering.MarkerSvg.prototype.showWithInput_=function(a){a=a.getLocation();var b=a.getSourceBlock();this.positionInput_(a);this.setParent_(b);this.showCurrent_()};Blockly.blockRendering.MarkerSvg.prototype.showWithNext_=function(a){var b=a.getLocation();a=b.getSourceBlock();var c=0;b=b.getOffsetInBlock().y;var d=a.getHeightWidth().width;this.workspace_.RTL&&(c=-d);this.positionLine_(c,b,d);this.setParent_(a);this.showCurrent_()};
	Blockly.blockRendering.MarkerSvg.prototype.showWithStack_=function(a){a=a.getLocation();var b=a.getHeightWidth(),c=b.width+this.constants_.CURSOR_STACK_PADDING;b=b.height+this.constants_.CURSOR_STACK_PADDING;var d=-this.constants_.CURSOR_STACK_PADDING/2,e=-this.constants_.CURSOR_STACK_PADDING/2,f=d;this.workspace_.RTL&&(f=-(c+d));this.positionRect_(f,e,c,b);this.setParent_(a);this.showCurrent_()};
	Blockly.blockRendering.MarkerSvg.prototype.showCurrent_=function(){this.hide();this.currentMarkerSvg.style.display=""};Blockly.blockRendering.MarkerSvg.prototype.positionBlock_=function(a,b,c){a=Blockly.utils.svgPaths.moveBy(-b,c)+Blockly.utils.svgPaths.lineOnAxis("V",-b)+Blockly.utils.svgPaths.lineOnAxis("H",a+2*b)+Blockly.utils.svgPaths.lineOnAxis("V",c);this.markerBlock_.setAttribute("d",a);this.workspace_.RTL&&this.flipRtl_(this.markerBlock_);this.currentMarkerSvg=this.markerBlock_};
	Blockly.blockRendering.MarkerSvg.prototype.positionInput_=function(a){var b=a.getOffsetInBlock().x,c=a.getOffsetInBlock().y;a=Blockly.utils.svgPaths.moveTo(0,0)+this.constants_.shapeFor(a).pathDown;this.markerInput_.setAttribute("d",a);this.markerInput_.setAttribute("transform","translate("+b+","+c+")"+(this.workspace_.RTL?" scale(-1 1)":""));this.currentMarkerSvg=this.markerInput_};
	Blockly.blockRendering.MarkerSvg.prototype.positionLine_=function(a,b,c){this.markerSvgLine_.setAttribute("x",a);this.markerSvgLine_.setAttribute("y",b);this.markerSvgLine_.setAttribute("width",c);this.currentMarkerSvg=this.markerSvgLine_};
	Blockly.blockRendering.MarkerSvg.prototype.positionOutput_=function(a,b,c){a=Blockly.utils.svgPaths.moveBy(a,0)+Blockly.utils.svgPaths.lineOnAxis("h",-(a-c.width))+Blockly.utils.svgPaths.lineOnAxis("v",this.constants_.TAB_OFFSET_FROM_TOP)+c.pathDown+Blockly.utils.svgPaths.lineOnAxis("V",b)+Blockly.utils.svgPaths.lineOnAxis("H",a);this.markerBlock_.setAttribute("d",a);this.workspace_.RTL&&this.flipRtl_(this.markerBlock_);this.currentMarkerSvg=this.markerBlock_};
	Blockly.blockRendering.MarkerSvg.prototype.positionPrevious_=function(a,b,c,d){a=Blockly.utils.svgPaths.moveBy(-b,c)+Blockly.utils.svgPaths.lineOnAxis("V",-b)+Blockly.utils.svgPaths.lineOnAxis("H",this.constants_.NOTCH_OFFSET_LEFT)+d.pathLeft+Blockly.utils.svgPaths.lineOnAxis("H",a+2*b)+Blockly.utils.svgPaths.lineOnAxis("V",c);this.markerBlock_.setAttribute("d",a);this.workspace_.RTL&&this.flipRtl_(this.markerBlock_);this.currentMarkerSvg=this.markerBlock_};
	Blockly.blockRendering.MarkerSvg.prototype.positionRect_=function(a,b,c,d){this.markerSvgRect_.setAttribute("x",a);this.markerSvgRect_.setAttribute("y",b);this.markerSvgRect_.setAttribute("width",c);this.markerSvgRect_.setAttribute("height",d);this.currentMarkerSvg=this.markerSvgRect_};Blockly.blockRendering.MarkerSvg.prototype.flipRtl_=function(a){a.setAttribute("transform","scale(-1 1)")};
	Blockly.blockRendering.MarkerSvg.prototype.hide=function(){this.markerSvgLine_.style.display="none";this.markerSvgRect_.style.display="none";this.markerInput_.style.display="none";this.markerBlock_.style.display="none"};Blockly.blockRendering.MarkerSvg.prototype.fireMarkerEvent_=function(a,b){var c=b.getSourceBlock(),d=this.isCursor()?"cursorMove":"markerMove";a=new Blockly.Events.Ui(c,d,a,b);b.getType()==Blockly.ASTNode.types.WORKSPACE&&(a.workspaceId=b.getLocation().id);Blockly.Events.fire(a)};
	Blockly.blockRendering.MarkerSvg.prototype.getBlinkProperties_=function(){return{attributeType:"XML",attributeName:"fill",dur:"1s",values:this.colour_+";transparent;transparent;",repeatCount:"indefinite"}};
	Blockly.blockRendering.MarkerSvg.prototype.createDomInternal_=function(){this.markerSvg_=Blockly.utils.dom.createSvgElement("g",{width:this.constants_.CURSOR_WS_WIDTH,height:this.constants_.WS_CURSOR_HEIGHT},this.svgGroup_);this.markerSvgLine_=Blockly.utils.dom.createSvgElement("rect",{width:this.constants_.CURSOR_WS_WIDTH,height:this.constants_.WS_CURSOR_HEIGHT,style:"display: none"},this.markerSvg_);this.markerSvgRect_=Blockly.utils.dom.createSvgElement("rect",{"class":"blocklyVerticalMarker",rx:10,
	ry:10,style:"display: none"},this.markerSvg_);this.markerInput_=Blockly.utils.dom.createSvgElement("path",{transform:"",style:"display: none"},this.markerSvg_);this.markerBlock_=Blockly.utils.dom.createSvgElement("path",{transform:"",style:"display: none",fill:"none","stroke-width":this.constants_.CURSOR_STROKE_WIDTH},this.markerSvg_);if(this.isCursor()){var a=this.getBlinkProperties_();Blockly.utils.dom.createSvgElement("animate",a,this.markerSvgLine_);Blockly.utils.dom.createSvgElement("animate",
	a,this.markerInput_);a.attributeName="stroke";Blockly.utils.dom.createSvgElement("animate",a,this.markerBlock_)}return this.markerSvg_};
	Blockly.blockRendering.MarkerSvg.prototype.applyColour_=function(a){this.markerSvgLine_.setAttribute("fill",this.colour_);this.markerSvgRect_.setAttribute("stroke",this.colour_);this.markerInput_.setAttribute("fill",this.colour_);this.markerBlock_.setAttribute("stroke",this.colour_);this.isCursor()&&(a=this.colour_+";transparent;transparent;",this.markerSvgLine_.firstChild.setAttribute("values",a),this.markerInput_.firstChild.setAttribute("values",a),this.markerBlock_.firstChild.setAttribute("values",
	a))};Blockly.blockRendering.MarkerSvg.prototype.dispose=function(){this.svgGroup_&&Blockly.utils.dom.removeNode(this.svgGroup_)};Blockly.blockRendering.Types={NONE:0,FIELD:1,HAT:2,ICON:4,SPACER:8,BETWEEN_ROW_SPACER:16,IN_ROW_SPACER:32,EXTERNAL_VALUE_INPUT:64,INPUT:128,INLINE_INPUT:256,STATEMENT_INPUT:512,CONNECTION:1024,PREVIOUS_CONNECTION:2048,NEXT_CONNECTION:4096,OUTPUT_CONNECTION:8192,CORNER:16384,LEFT_SQUARE_CORNER:32768,LEFT_ROUND_CORNER:65536,RIGHT_SQUARE_CORNER:131072,RIGHT_ROUND_CORNER:262144,JAGGED_EDGE:524288,ROW:1048576,TOP_ROW:2097152,BOTTOM_ROW:4194304,INPUT_ROW:8388608};
	Blockly.blockRendering.Types.LEFT_CORNER=Blockly.blockRendering.Types.LEFT_SQUARE_CORNER|Blockly.blockRendering.Types.LEFT_ROUND_CORNER;Blockly.blockRendering.Types.RIGHT_CORNER=Blockly.blockRendering.Types.RIGHT_SQUARE_CORNER|Blockly.blockRendering.Types.RIGHT_ROUND_CORNER;Blockly.blockRendering.Types.nextTypeValue_=16777216;
	Blockly.blockRendering.Types.getType=function(a){Blockly.blockRendering.Types.hasOwnProperty(a)||(Blockly.blockRendering.Types[a]=Blockly.blockRendering.Types.nextTypeValue_,Blockly.blockRendering.Types.nextTypeValue_<<=1);return Blockly.blockRendering.Types[a]};Blockly.blockRendering.Types.isField=function(a){return a.type&Blockly.blockRendering.Types.FIELD};Blockly.blockRendering.Types.isHat=function(a){return a.type&Blockly.blockRendering.Types.HAT};
	Blockly.blockRendering.Types.isIcon=function(a){return a.type&Blockly.blockRendering.Types.ICON};Blockly.blockRendering.Types.isSpacer=function(a){return a.type&Blockly.blockRendering.Types.SPACER};Blockly.blockRendering.Types.isInRowSpacer=function(a){return a.type&Blockly.blockRendering.Types.IN_ROW_SPACER};Blockly.blockRendering.Types.isInput=function(a){return a.type&Blockly.blockRendering.Types.INPUT};Blockly.blockRendering.Types.isExternalInput=function(a){return a.type&Blockly.blockRendering.Types.EXTERNAL_VALUE_INPUT};
	Blockly.blockRendering.Types.isInlineInput=function(a){return a.type&Blockly.blockRendering.Types.INLINE_INPUT};Blockly.blockRendering.Types.isStatementInput=function(a){return a.type&Blockly.blockRendering.Types.STATEMENT_INPUT};Blockly.blockRendering.Types.isPreviousConnection=function(a){return a.type&Blockly.blockRendering.Types.PREVIOUS_CONNECTION};Blockly.blockRendering.Types.isNextConnection=function(a){return a.type&Blockly.blockRendering.Types.NEXT_CONNECTION};
	Blockly.blockRendering.Types.isPreviousOrNextConnection=function(a){return a.type&(Blockly.blockRendering.Types.PREVIOUS_CONNECTION|Blockly.blockRendering.Types.NEXT_CONNECTION)};Blockly.blockRendering.Types.isLeftRoundedCorner=function(a){return a.type&Blockly.blockRendering.Types.LEFT_ROUND_CORNER};Blockly.blockRendering.Types.isRightRoundedCorner=function(a){return a.type&Blockly.blockRendering.Types.RIGHT_ROUND_CORNER};
	Blockly.blockRendering.Types.isLeftSquareCorner=function(a){return a.type&Blockly.blockRendering.Types.LEFT_SQUARE_CORNER};Blockly.blockRendering.Types.isRightSquareCorner=function(a){return a.type&Blockly.blockRendering.Types.RIGHT_SQUARE_CORNER};Blockly.blockRendering.Types.isCorner=function(a){return a.type&Blockly.blockRendering.Types.CORNER};Blockly.blockRendering.Types.isJaggedEdge=function(a){return a.type&Blockly.blockRendering.Types.JAGGED_EDGE};
	Blockly.blockRendering.Types.isRow=function(a){return a.type&Blockly.blockRendering.Types.ROW};Blockly.blockRendering.Types.isBetweenRowSpacer=function(a){return a.type&Blockly.blockRendering.Types.BETWEEN_ROW_SPACER};Blockly.blockRendering.Types.isTopRow=function(a){return a.type&Blockly.blockRendering.Types.TOP_ROW};Blockly.blockRendering.Types.isBottomRow=function(a){return a.type&Blockly.blockRendering.Types.BOTTOM_ROW};
	Blockly.blockRendering.Types.isTopOrBottomRow=function(a){return a.type&(Blockly.blockRendering.Types.TOP_ROW|Blockly.blockRendering.Types.BOTTOM_ROW)};Blockly.blockRendering.Types.isInputRow=function(a){return a.type&Blockly.blockRendering.Types.INPUT_ROW};Blockly.blockRendering.Measurable=function(a){this.height=this.width=0;this.type=Blockly.blockRendering.Types.NONE;this.centerline=this.xPos=0;this.constants_=a;this.notchOffset=this.constants_.NOTCH_OFFSET_LEFT};Blockly.blockRendering.Connection=function(a,b){Blockly.blockRendering.Connection.superClass_.constructor.call(this,a);this.connectionModel=b;this.shape=this.constants_.shapeFor(b);this.isDynamicShape=!!this.shape.isDynamic;this.type|=Blockly.blockRendering.Types.CONNECTION};Blockly.utils.object.inherits(Blockly.blockRendering.Connection,Blockly.blockRendering.Measurable);
	Blockly.blockRendering.OutputConnection=function(a,b){Blockly.blockRendering.OutputConnection.superClass_.constructor.call(this,a,b);this.type|=Blockly.blockRendering.Types.OUTPUT_CONNECTION;this.height=this.isDynamicShape?0:this.shape.height;this.startX=this.width=this.isDynamicShape?0:this.shape.width;this.connectionOffsetY=this.constants_.TAB_OFFSET_FROM_TOP;this.connectionOffsetX=0};Blockly.utils.object.inherits(Blockly.blockRendering.OutputConnection,Blockly.blockRendering.Connection);
	Blockly.blockRendering.PreviousConnection=function(a,b){Blockly.blockRendering.PreviousConnection.superClass_.constructor.call(this,a,b);this.type|=Blockly.blockRendering.Types.PREVIOUS_CONNECTION;this.height=this.shape.height;this.width=this.shape.width};Blockly.utils.object.inherits(Blockly.blockRendering.PreviousConnection,Blockly.blockRendering.Connection);
	Blockly.blockRendering.NextConnection=function(a,b){Blockly.blockRendering.NextConnection.superClass_.constructor.call(this,a,b);this.type|=Blockly.blockRendering.Types.NEXT_CONNECTION;this.height=this.shape.height;this.width=this.shape.width};Blockly.utils.object.inherits(Blockly.blockRendering.NextConnection,Blockly.blockRendering.Connection);Blockly.blockRendering.InputConnection=function(a,b){Blockly.blockRendering.InputConnection.superClass_.constructor.call(this,a,b.connection);this.type|=Blockly.blockRendering.Types.INPUT;this.input=b;this.align=b.align;(this.connectedBlock=b.connection&&b.connection.targetBlock()?b.connection.targetBlock():null)?(a=this.connectedBlock.getHeightWidth(),this.connectedBlockWidth=a.width,this.connectedBlockHeight=a.height):this.connectedBlockHeight=this.connectedBlockWidth=0;this.connectionOffsetY=this.connectionOffsetX=
	0};Blockly.utils.object.inherits(Blockly.blockRendering.InputConnection,Blockly.blockRendering.Connection);
	Blockly.blockRendering.InlineInput=function(a,b){Blockly.blockRendering.InlineInput.superClass_.constructor.call(this,a,b);this.type|=Blockly.blockRendering.Types.INLINE_INPUT;this.connectedBlock?(this.width=this.connectedBlockWidth,this.height=this.connectedBlockHeight):(this.height=this.constants_.EMPTY_INLINE_INPUT_HEIGHT,this.width=this.constants_.EMPTY_INLINE_INPUT_PADDING);this.connectionHeight=this.isDynamicShape?this.shape.height(this.height):this.shape.height;this.connectionWidth=this.isDynamicShape?
	this.shape.width(this.height):this.shape.width;this.connectedBlock||(this.width+=this.connectionWidth*(this.isDynamicShape?2:1));this.connectionOffsetY=this.isDynamicShape?this.shape.connectionOffsetY(this.connectionHeight):this.constants_.TAB_OFFSET_FROM_TOP;this.connectionOffsetX=this.isDynamicShape?this.shape.connectionOffsetX(this.connectionWidth):0};Blockly.utils.object.inherits(Blockly.blockRendering.InlineInput,Blockly.blockRendering.InputConnection);
	Blockly.blockRendering.StatementInput=function(a,b){Blockly.blockRendering.StatementInput.superClass_.constructor.call(this,a,b);this.type|=Blockly.blockRendering.Types.STATEMENT_INPUT;this.height=this.connectedBlock?this.connectedBlockHeight+this.constants_.STATEMENT_BOTTOM_SPACER:this.constants_.EMPTY_STATEMENT_INPUT_HEIGHT;this.width=this.constants_.STATEMENT_INPUT_NOTCH_OFFSET+this.shape.width};Blockly.utils.object.inherits(Blockly.blockRendering.StatementInput,Blockly.blockRendering.InputConnection);
	Blockly.blockRendering.ExternalValueInput=function(a,b){Blockly.blockRendering.ExternalValueInput.superClass_.constructor.call(this,a,b);this.type|=Blockly.blockRendering.Types.EXTERNAL_VALUE_INPUT;this.height=this.connectedBlock?this.connectedBlockHeight-this.constants_.TAB_OFFSET_FROM_TOP-this.constants_.MEDIUM_PADDING:this.shape.height;this.width=this.shape.width+this.constants_.EXTERNAL_VALUE_INPUT_PADDING;this.connectionOffsetY=this.constants_.TAB_OFFSET_FROM_TOP;this.connectionHeight=this.shape.height;
	this.connectionWidth=this.shape.width};Blockly.utils.object.inherits(Blockly.blockRendering.ExternalValueInput,Blockly.blockRendering.InputConnection);Blockly.blockRendering.Icon=function(a,b){Blockly.blockRendering.Icon.superClass_.constructor.call(this,a);this.icon=b;this.isVisible=b.isVisible();this.type|=Blockly.blockRendering.Types.ICON;a=b.getCorrectedSize();this.height=a.height;this.width=a.width};Blockly.utils.object.inherits(Blockly.blockRendering.Icon,Blockly.blockRendering.Measurable);
	Blockly.blockRendering.JaggedEdge=function(a){Blockly.blockRendering.JaggedEdge.superClass_.constructor.call(this,a);this.type|=Blockly.blockRendering.Types.JAGGED_EDGE;this.height=this.constants_.JAGGED_TEETH.height;this.width=this.constants_.JAGGED_TEETH.width};Blockly.utils.object.inherits(Blockly.blockRendering.JaggedEdge,Blockly.blockRendering.Measurable);
	Blockly.blockRendering.Field=function(a,b,c){Blockly.blockRendering.Field.superClass_.constructor.call(this,a);this.field=b;this.isEditable=b.EDITABLE;this.flipRtl=b.getFlipRtl();this.type|=Blockly.blockRendering.Types.FIELD;a=this.field.getSize();this.height=a.height;this.width=a.width;this.parentInput=c};Blockly.utils.object.inherits(Blockly.blockRendering.Field,Blockly.blockRendering.Measurable);
	Blockly.blockRendering.Hat=function(a){Blockly.blockRendering.Hat.superClass_.constructor.call(this,a);this.type|=Blockly.blockRendering.Types.HAT;this.height=this.constants_.START_HAT.height;this.width=this.constants_.START_HAT.width;this.ascenderHeight=this.height};Blockly.utils.object.inherits(Blockly.blockRendering.Hat,Blockly.blockRendering.Measurable);
	Blockly.blockRendering.SquareCorner=function(a,b){Blockly.blockRendering.SquareCorner.superClass_.constructor.call(this,a);this.type=(b&&"left"!=b?Blockly.blockRendering.Types.RIGHT_SQUARE_CORNER:Blockly.blockRendering.Types.LEFT_SQUARE_CORNER)|Blockly.blockRendering.Types.CORNER;this.width=this.height=this.constants_.NO_PADDING};Blockly.utils.object.inherits(Blockly.blockRendering.SquareCorner,Blockly.blockRendering.Measurable);
	Blockly.blockRendering.RoundCorner=function(a,b){Blockly.blockRendering.RoundCorner.superClass_.constructor.call(this,a);this.type=(b&&"left"!=b?Blockly.blockRendering.Types.RIGHT_ROUND_CORNER:Blockly.blockRendering.Types.LEFT_ROUND_CORNER)|Blockly.blockRendering.Types.CORNER;this.width=this.constants_.CORNER_RADIUS;this.height=this.constants_.CORNER_RADIUS/2};Blockly.utils.object.inherits(Blockly.blockRendering.RoundCorner,Blockly.blockRendering.Measurable);
	Blockly.blockRendering.InRowSpacer=function(a,b){Blockly.blockRendering.InRowSpacer.superClass_.constructor.call(this,a);this.type=this.type|Blockly.blockRendering.Types.SPACER|Blockly.blockRendering.Types.IN_ROW_SPACER;this.width=b;this.height=this.constants_.SPACER_DEFAULT_HEIGHT};Blockly.utils.object.inherits(Blockly.blockRendering.InRowSpacer,Blockly.blockRendering.Measurable);Blockly.blockRendering.Row=function(a){this.type=Blockly.blockRendering.Types.ROW;this.elements=[];this.xPos=this.yPos=this.widthWithConnectedBlocks=this.minWidth=this.minHeight=this.width=this.height=0;this.hasJaggedEdge=this.hasDummyInput=this.hasInlineInput=this.hasStatement=this.hasExternalInput=!1;this.constants_=a;this.notchOffset=this.constants_.NOTCH_OFFSET_LEFT;this.align=null};
	Blockly.blockRendering.Row.prototype.measure=function(){throw Error("Unexpected attempt to measure a base Row.");};Blockly.blockRendering.Row.prototype.getLastInput=function(){for(var a=this.elements.length-1,b;b=this.elements[a];a--)if(Blockly.blockRendering.Types.isInput(b))return b;return null};Blockly.blockRendering.Row.prototype.startsWithElemSpacer=function(){return!0};Blockly.blockRendering.Row.prototype.endsWithElemSpacer=function(){return!0};
	Blockly.blockRendering.Row.prototype.getFirstSpacer=function(){for(var a=0,b;b=this.elements[a];a++)if(Blockly.blockRendering.Types.isSpacer(b))return b;return null};Blockly.blockRendering.Row.prototype.getLastSpacer=function(){for(var a=this.elements.length-1,b;b=this.elements[a];a--)if(Blockly.blockRendering.Types.isSpacer(b))return b;return null};
	Blockly.blockRendering.TopRow=function(a){Blockly.blockRendering.TopRow.superClass_.constructor.call(this,a);this.type|=Blockly.blockRendering.Types.TOP_ROW;this.ascenderHeight=this.capline=0;this.hasPreviousConnection=!1;this.connection=null};Blockly.utils.object.inherits(Blockly.blockRendering.TopRow,Blockly.blockRendering.Row);
	Blockly.blockRendering.TopRow.prototype.hasLeftSquareCorner=function(a){var b=(a.hat?"cap"===a.hat:this.constants_.ADD_START_HATS)&&!a.outputConnection&&!a.previousConnection,c=a.getPreviousBlock();return!!a.outputConnection||b||(c?c.getNextBlock()==a:!1)};Blockly.blockRendering.TopRow.prototype.hasRightSquareCorner=function(a){return!0};
	Blockly.blockRendering.TopRow.prototype.measure=function(){for(var a=0,b=0,c=0,d=0,e;e=this.elements[d];d++)b+=e.width,Blockly.blockRendering.Types.isSpacer(e)||(Blockly.blockRendering.Types.isHat(e)?c=Math.max(c,e.ascenderHeight):a=Math.max(a,e.height));this.width=Math.max(this.minWidth,b);this.height=Math.max(this.minHeight,a)+c;this.capline=this.ascenderHeight=c;this.widthWithConnectedBlocks=this.width};Blockly.blockRendering.TopRow.prototype.startsWithElemSpacer=function(){return!1};
	Blockly.blockRendering.TopRow.prototype.endsWithElemSpacer=function(){return!1};Blockly.blockRendering.BottomRow=function(a){Blockly.blockRendering.BottomRow.superClass_.constructor.call(this,a);this.type|=Blockly.blockRendering.Types.BOTTOM_ROW;this.hasNextConnection=!1;this.connection=null;this.baseline=this.descenderHeight=0};Blockly.utils.object.inherits(Blockly.blockRendering.BottomRow,Blockly.blockRendering.Row);
	Blockly.blockRendering.BottomRow.prototype.hasLeftSquareCorner=function(a){return!!a.outputConnection||!!a.getNextBlock()};Blockly.blockRendering.BottomRow.prototype.hasRightSquareCorner=function(a){return!0};
	Blockly.blockRendering.BottomRow.prototype.measure=function(){for(var a=0,b=0,c=0,d=0,e;e=this.elements[d];d++)b+=e.width,Blockly.blockRendering.Types.isSpacer(e)||(Blockly.blockRendering.Types.isNextConnection(e)?c=Math.max(c,e.height):a=Math.max(a,e.height));this.width=Math.max(this.minWidth,b);this.height=Math.max(this.minHeight,a)+c;this.descenderHeight=c;this.widthWithConnectedBlocks=this.width};Blockly.blockRendering.BottomRow.prototype.startsWithElemSpacer=function(){return!1};
	Blockly.blockRendering.BottomRow.prototype.endsWithElemSpacer=function(){return!1};Blockly.blockRendering.SpacerRow=function(a,b,c){Blockly.blockRendering.SpacerRow.superClass_.constructor.call(this,a);this.type=this.type|Blockly.blockRendering.Types.SPACER|Blockly.blockRendering.Types.BETWEEN_ROW_SPACER;this.width=c;this.height=b;this.followsStatement=!1;this.widthWithConnectedBlocks=0;this.elements=[new Blockly.blockRendering.InRowSpacer(this.constants_,c)]};
	Blockly.utils.object.inherits(Blockly.blockRendering.SpacerRow,Blockly.blockRendering.Row);Blockly.blockRendering.SpacerRow.prototype.measure=function(){};Blockly.blockRendering.InputRow=function(a){Blockly.blockRendering.InputRow.superClass_.constructor.call(this,a);this.type|=Blockly.blockRendering.Types.INPUT_ROW;this.connectedBlockWidths=0};Blockly.utils.object.inherits(Blockly.blockRendering.InputRow,Blockly.blockRendering.Row);
	Blockly.blockRendering.InputRow.prototype.measure=function(){this.width=this.minWidth;this.height=this.minHeight;for(var a=0,b=0,c;c=this.elements[b];b++)this.width+=c.width,Blockly.blockRendering.Types.isInput(c)&&(Blockly.blockRendering.Types.isStatementInput(c)?a+=c.connectedBlockWidth:Blockly.blockRendering.Types.isExternalInput(c)&&0!=c.connectedBlockWidth&&(a+=c.connectedBlockWidth-c.connectionWidth)),Blockly.blockRendering.Types.isSpacer(c)||(this.height=Math.max(this.height,c.height));this.connectedBlockWidths=
	a;this.widthWithConnectedBlocks=this.width+a};Blockly.blockRendering.InputRow.prototype.endsWithElemSpacer=function(){return!this.hasExternalInput&&!this.hasStatement};Blockly.blockRendering.RenderInfo=function(a,b){this.block_=b;this.renderer_=a;this.constants_=this.renderer_.getConstants();this.outputConnection=b.outputConnection?new Blockly.blockRendering.OutputConnection(this.constants_,b.outputConnection):null;this.isInline=b.getInputsInline()&&!b.isCollapsed();this.isCollapsed=b.isCollapsed();this.isInsertionMarker=b.isInsertionMarker();this.RTL=b.RTL;this.statementEdge=this.width=this.widthWithChildren=this.height=0;this.rows=[];this.inputRows=[];this.hiddenIcons=
	[];this.topRow=new Blockly.blockRendering.TopRow(this.constants_);this.bottomRow=new Blockly.blockRendering.BottomRow(this.constants_);this.startY=this.startX=0};Blockly.blockRendering.RenderInfo.prototype.getRenderer=function(){return this.renderer_};Blockly.blockRendering.RenderInfo.prototype.measure=function(){this.createRows_();this.addElemSpacing_();this.addRowSpacing_();this.computeBounds_();this.alignRowElements_();this.finalize_()};
	Blockly.blockRendering.RenderInfo.prototype.createRows_=function(){this.populateTopRow_();this.rows.push(this.topRow);var a=new Blockly.blockRendering.InputRow(this.constants_);this.inputRows.push(a);var b=this.block_.getIcons();if(b.length)for(var c=0,d;d=b[c];c++){var e=new Blockly.blockRendering.Icon(this.constants_,d);this.isCollapsed&&d.collapseHidden?this.hiddenIcons.push(e):a.elements.push(e)}d=null;for(c=0;b=this.block_.inputList[c];c++)if(b.isVisible()){this.shouldStartNewRow_(b,d)&&(this.rows.push(a),
	a=new Blockly.blockRendering.InputRow(this.constants_),this.inputRows.push(a));for(d=0;e=b.fieldRow[d];d++)a.elements.push(new Blockly.blockRendering.Field(this.constants_,e,b));this.addInput_(b,a);d=b}this.isCollapsed&&(a.hasJaggedEdge=!0,a.elements.push(new Blockly.blockRendering.JaggedEdge(this.constants_)));(a.elements.length||a.hasDummyInput)&&this.rows.push(a);this.populateBottomRow_();this.rows.push(this.bottomRow)};
	Blockly.blockRendering.RenderInfo.prototype.populateTopRow_=function(){var a=!!this.block_.previousConnection,b=(this.block_.hat?"cap"===this.block_.hat:this.constants_.ADD_START_HATS)&&!this.outputConnection&&!a;this.topRow.hasLeftSquareCorner(this.block_)?this.topRow.elements.push(new Blockly.blockRendering.SquareCorner(this.constants_)):this.topRow.elements.push(new Blockly.blockRendering.RoundCorner(this.constants_));b?(a=new Blockly.blockRendering.Hat(this.constants_),this.topRow.elements.push(a),
	this.topRow.capline=a.ascenderHeight):a&&(this.topRow.hasPreviousConnection=!0,this.topRow.connection=new Blockly.blockRendering.PreviousConnection(this.constants_,this.block_.previousConnection),this.topRow.elements.push(this.topRow.connection));this.block_.inputList.length&&this.block_.inputList[0].type==Blockly.NEXT_STATEMENT&&!this.block_.isCollapsed()?this.topRow.minHeight=this.constants_.TOP_ROW_PRECEDES_STATEMENT_MIN_HEIGHT:this.topRow.minHeight=this.constants_.TOP_ROW_MIN_HEIGHT;this.topRow.hasRightSquareCorner(this.block_)?
	this.topRow.elements.push(new Blockly.blockRendering.SquareCorner(this.constants_,"right")):this.topRow.elements.push(new Blockly.blockRendering.RoundCorner(this.constants_,"right"))};
	Blockly.blockRendering.RenderInfo.prototype.populateBottomRow_=function(){this.bottomRow.hasNextConnection=!!this.block_.nextConnection;this.bottomRow.minHeight=this.block_.inputList.length&&this.block_.inputList[this.block_.inputList.length-1].type==Blockly.NEXT_STATEMENT?this.constants_.BOTTOM_ROW_AFTER_STATEMENT_MIN_HEIGHT:this.constants_.BOTTOM_ROW_MIN_HEIGHT;this.bottomRow.hasLeftSquareCorner(this.block_)?this.bottomRow.elements.push(new Blockly.blockRendering.SquareCorner(this.constants_)):
	this.bottomRow.elements.push(new Blockly.blockRendering.RoundCorner(this.constants_));this.bottomRow.hasNextConnection&&(this.bottomRow.connection=new Blockly.blockRendering.NextConnection(this.constants_,this.block_.nextConnection),this.bottomRow.elements.push(this.bottomRow.connection));this.bottomRow.hasRightSquareCorner(this.block_)?this.bottomRow.elements.push(new Blockly.blockRendering.SquareCorner(this.constants_,"right")):this.bottomRow.elements.push(new Blockly.blockRendering.RoundCorner(this.constants_,
	"right"))};
	Blockly.blockRendering.RenderInfo.prototype.addInput_=function(a,b){this.isInline&&a.type==Blockly.INPUT_VALUE?(b.elements.push(new Blockly.blockRendering.InlineInput(this.constants_,a)),b.hasInlineInput=!0):a.type==Blockly.NEXT_STATEMENT?(b.elements.push(new Blockly.blockRendering.StatementInput(this.constants_,a)),b.hasStatement=!0):a.type==Blockly.INPUT_VALUE?(b.elements.push(new Blockly.blockRendering.ExternalValueInput(this.constants_,a)),b.hasExternalInput=!0):a.type==Blockly.DUMMY_INPUT&&(b.minHeight=
	Math.max(b.minHeight,a.getSourceBlock()&&a.getSourceBlock().isShadow()?this.constants_.DUMMY_INPUT_SHADOW_MIN_HEIGHT:this.constants_.DUMMY_INPUT_MIN_HEIGHT),b.hasDummyInput=!0);null==b.align&&(b.align=a.align)};Blockly.blockRendering.RenderInfo.prototype.shouldStartNewRow_=function(a,b){return b?a.type==Blockly.NEXT_STATEMENT||b.type==Blockly.NEXT_STATEMENT?!0:a.type==Blockly.INPUT_VALUE||a.type==Blockly.DUMMY_INPUT?!this.isInline:!1:!1};
	Blockly.blockRendering.RenderInfo.prototype.addElemSpacing_=function(){for(var a=0,b;b=this.rows[a];a++){var c=b.elements;b.elements=[];b.startsWithElemSpacer()&&b.elements.push(new Blockly.blockRendering.InRowSpacer(this.constants_,this.getInRowSpacing_(null,c[0])));if(c.length){for(var d=0;d<c.length-1;d++){b.elements.push(c[d]);var e=this.getInRowSpacing_(c[d],c[d+1]);b.elements.push(new Blockly.blockRendering.InRowSpacer(this.constants_,e))}b.elements.push(c[c.length-1]);b.endsWithElemSpacer()&&
	b.elements.push(new Blockly.blockRendering.InRowSpacer(this.constants_,this.getInRowSpacing_(c[c.length-1],null)))}}};
	Blockly.blockRendering.RenderInfo.prototype.getInRowSpacing_=function(a,b){if(!a&&b&&Blockly.blockRendering.Types.isStatementInput(b))return this.constants_.STATEMENT_INPUT_PADDING_LEFT;if(a&&Blockly.blockRendering.Types.isInput(a)&&!b){if(Blockly.blockRendering.Types.isExternalInput(a))return this.constants_.NO_PADDING;if(Blockly.blockRendering.Types.isInlineInput(a))return this.constants_.LARGE_PADDING;if(Blockly.blockRendering.Types.isStatementInput(a))return this.constants_.NO_PADDING}return a&&
	Blockly.blockRendering.Types.isLeftSquareCorner(a)&&b&&(Blockly.blockRendering.Types.isPreviousConnection(b)||Blockly.blockRendering.Types.isNextConnection(b))?b.notchOffset:a&&Blockly.blockRendering.Types.isLeftRoundedCorner(a)&&b&&(Blockly.blockRendering.Types.isPreviousConnection(b)||Blockly.blockRendering.Types.isNextConnection(b))?b.notchOffset-this.constants_.CORNER_RADIUS:this.constants_.MEDIUM_PADDING};
	Blockly.blockRendering.RenderInfo.prototype.computeBounds_=function(){for(var a=0,b=0,c=0,d=0,e;e=this.rows[d];d++){e.measure();b=Math.max(b,e.width);if(e.hasStatement){var f=e.getLastInput();a=Math.max(a,e.width-f.width)}c=Math.max(c,e.widthWithConnectedBlocks)}this.statementEdge=a;this.width=b;for(d=0;e=this.rows[d];d++)e.hasStatement&&(e.statementEdge=this.statementEdge);this.widthWithChildren=Math.max(b,c);this.outputConnection&&(this.startX=this.outputConnection.width,this.width+=this.outputConnection.width,
	this.widthWithChildren+=this.outputConnection.width)};Blockly.blockRendering.RenderInfo.prototype.alignRowElements_=function(){for(var a=0,b;b=this.rows[a];a++)if(b.hasStatement)this.alignStatementRow_(b);else{var c=b.width;c=this.getDesiredRowWidth_(b)-c;0<c&&this.addAlignmentPadding_(b,c);Blockly.blockRendering.Types.isTopOrBottomRow(b)&&(b.widthWithConnectedBlocks=b.width)}};Blockly.blockRendering.RenderInfo.prototype.getDesiredRowWidth_=function(a){return this.width-this.startX};
	Blockly.blockRendering.RenderInfo.prototype.addAlignmentPadding_=function(a,b){var c=a.getFirstSpacer(),d=a.getLastSpacer();if(a.hasExternalInput||a.hasStatement)a.widthWithConnectedBlocks+=b;a.align==Blockly.ALIGN_LEFT?d.width+=b:a.align==Blockly.ALIGN_CENTRE?(c.width+=b/2,d.width+=b/2):a.align==Blockly.ALIGN_RIGHT?c.width+=b:d.width+=b;a.width+=b};
	Blockly.blockRendering.RenderInfo.prototype.alignStatementRow_=function(a){var b=a.getLastInput(),c=a.width-b.width,d=this.statementEdge;c=d-c;0<c&&this.addAlignmentPadding_(a,c);c=a.width;d=this.getDesiredRowWidth_(a);b.width+=d-c;b.height=Math.max(b.height,a.height);a.width+=d-c;a.widthWithConnectedBlocks=Math.max(a.width,this.statementEdge+a.connectedBlockWidths)};
	Blockly.blockRendering.RenderInfo.prototype.addRowSpacing_=function(){var a=this.rows;this.rows=[];for(var b=0;b<a.length;b++)this.rows.push(a[b]),b!=a.length-1&&this.rows.push(this.makeSpacerRow_(a[b],a[b+1]))};Blockly.blockRendering.RenderInfo.prototype.makeSpacerRow_=function(a,b){var c=this.getSpacerRowHeight_(a,b),d=this.getSpacerRowWidth_(a,b);c=new Blockly.blockRendering.SpacerRow(this.constants_,c,d);a.hasStatement&&(c.followsStatement=!0);b.hasStatement&&(c.precedesStatement=!0);return c};
	Blockly.blockRendering.RenderInfo.prototype.getSpacerRowWidth_=function(a,b){return this.width-this.startX};Blockly.blockRendering.RenderInfo.prototype.getSpacerRowHeight_=function(a,b){return this.constants_.MEDIUM_PADDING};
	Blockly.blockRendering.RenderInfo.prototype.getElemCenterline_=function(a,b){return Blockly.blockRendering.Types.isSpacer(b)?a.yPos+b.height/2:Blockly.blockRendering.Types.isBottomRow(a)?(a=a.yPos+a.height-a.descenderHeight,Blockly.blockRendering.Types.isNextConnection(b)?a+b.height/2:a-b.height/2):Blockly.blockRendering.Types.isTopRow(a)?Blockly.blockRendering.Types.isHat(b)?a.capline-b.height/2:a.capline+b.height/2:a.yPos+a.height/2};
	Blockly.blockRendering.RenderInfo.prototype.recordElemPositions_=function(a){for(var b=a.xPos,c=0,d;d=a.elements[c];c++)Blockly.blockRendering.Types.isSpacer(d)&&(d.height=a.height),d.xPos=b,d.centerline=this.getElemCenterline_(a,d),b+=d.width};
	Blockly.blockRendering.RenderInfo.prototype.finalize_=function(){for(var a=0,b=0,c=0,d;d=this.rows[c];c++)d.yPos=b,d.xPos=this.startX,b+=d.height,a=Math.max(a,d.widthWithConnectedBlocks),this.recordElemPositions_(d);this.outputConnection&&this.block_.nextConnection&&this.block_.nextConnection.isConnected()&&(a=Math.max(a,this.block_.nextConnection.targetBlock().getHeightWidth().width));this.widthWithChildren=a+this.startX;this.height=b;this.startY=this.topRow.capline;this.bottomRow.baseline=b-this.bottomRow.descenderHeight};Blockly.blockRendering.Drawer=function(a,b){this.block_=a;this.info_=b;this.topLeft_=a.getRelativeToSurfaceXY();this.inlinePath_=this.outlinePath_="";this.constants_=b.getRenderer().getConstants()};
	Blockly.blockRendering.Drawer.prototype.draw=function(){this.hideHiddenIcons_();this.drawOutline_();this.drawInternals_();this.block_.pathObject.setPath(this.outlinePath_+"\n"+this.inlinePath_);this.info_.RTL&&this.block_.pathObject.flipRTL();Blockly.blockRendering.useDebugger&&this.block_.renderingDebugger.drawDebug(this.block_,this.info_);this.recordSizeOnBlock_()};Blockly.blockRendering.Drawer.prototype.recordSizeOnBlock_=function(){this.block_.height=this.info_.height;this.block_.width=this.info_.widthWithChildren};
	Blockly.blockRendering.Drawer.prototype.hideHiddenIcons_=function(){for(var a=0,b;b=this.info_.hiddenIcons[a];a++)b.icon.iconGroup_.setAttribute("display","none")};Blockly.blockRendering.Drawer.prototype.drawOutline_=function(){this.drawTop_();for(var a=1;a<this.info_.rows.length-1;a++){var b=this.info_.rows[a];b.hasJaggedEdge?this.drawJaggedEdge_(b):b.hasStatement?this.drawStatementInput_(b):b.hasExternalInput?this.drawValueInput_(b):this.drawRightSideRow_(b)}this.drawBottom_();this.drawLeft_()};
	Blockly.blockRendering.Drawer.prototype.drawTop_=function(){var a=this.info_.topRow,b=a.elements;this.positionPreviousConnection_();this.outlinePath_+=Blockly.utils.svgPaths.moveBy(a.xPos,this.info_.startY);for(var c=0,d;d=b[c];c++)Blockly.blockRendering.Types.isLeftRoundedCorner(d)?this.outlinePath_+=this.constants_.OUTSIDE_CORNERS.topLeft:Blockly.blockRendering.Types.isRightRoundedCorner(d)?this.outlinePath_+=this.constants_.OUTSIDE_CORNERS.topRight:Blockly.blockRendering.Types.isPreviousConnection(d)?
	this.outlinePath_+=d.shape.pathLeft:Blockly.blockRendering.Types.isHat(d)?this.outlinePath_+=this.constants_.START_HAT.path:Blockly.blockRendering.Types.isSpacer(d)&&(this.outlinePath_+=Blockly.utils.svgPaths.lineOnAxis("h",d.width));this.outlinePath_+=Blockly.utils.svgPaths.lineOnAxis("v",a.height)};Blockly.blockRendering.Drawer.prototype.drawJaggedEdge_=function(a){this.outlinePath_+=this.constants_.JAGGED_TEETH.path+Blockly.utils.svgPaths.lineOnAxis("v",a.height-this.constants_.JAGGED_TEETH.height)};
	Blockly.blockRendering.Drawer.prototype.drawValueInput_=function(a){var b=a.getLastInput();this.positionExternalValueConnection_(a);var c="function"==typeof b.shape.pathDown?b.shape.pathDown(b.height):b.shape.pathDown;this.outlinePath_+=Blockly.utils.svgPaths.lineOnAxis("H",b.xPos+b.width)+c+Blockly.utils.svgPaths.lineOnAxis("v",a.height-b.connectionHeight)};
	Blockly.blockRendering.Drawer.prototype.drawStatementInput_=function(a){var b=a.getLastInput(),c=b.xPos+b.notchOffset+b.shape.width;b=b.shape.pathRight+Blockly.utils.svgPaths.lineOnAxis("h",-(b.notchOffset-this.constants_.INSIDE_CORNERS.width))+this.constants_.INSIDE_CORNERS.pathTop;var d=a.height-2*this.constants_.INSIDE_CORNERS.height;this.outlinePath_+=Blockly.utils.svgPaths.lineOnAxis("H",c)+b+Blockly.utils.svgPaths.lineOnAxis("v",d)+this.constants_.INSIDE_CORNERS.pathBottom+Blockly.utils.svgPaths.lineOnAxis("H",
	a.xPos+a.width);this.positionStatementInputConnection_(a)};Blockly.blockRendering.Drawer.prototype.drawRightSideRow_=function(a){this.outlinePath_+=Blockly.utils.svgPaths.lineOnAxis("V",a.yPos+a.height)};
	Blockly.blockRendering.Drawer.prototype.drawBottom_=function(){var a=this.info_.bottomRow,b=a.elements;this.positionNextConnection_();for(var c=0,d="",e=b.length-1,f;f=b[e];e--)Blockly.blockRendering.Types.isNextConnection(f)?d+=f.shape.pathRight:Blockly.blockRendering.Types.isLeftSquareCorner(f)?d+=Blockly.utils.svgPaths.lineOnAxis("H",a.xPos):Blockly.blockRendering.Types.isLeftRoundedCorner(f)?d+=this.constants_.OUTSIDE_CORNERS.bottomLeft:Blockly.blockRendering.Types.isRightRoundedCorner(f)?(d+=
	this.constants_.OUTSIDE_CORNERS.bottomRight,c=this.constants_.OUTSIDE_CORNERS.rightHeight):Blockly.blockRendering.Types.isSpacer(f)&&(d+=Blockly.utils.svgPaths.lineOnAxis("h",-1*f.width));this.outlinePath_+=Blockly.utils.svgPaths.lineOnAxis("V",a.baseline-c);this.outlinePath_+=d};
	Blockly.blockRendering.Drawer.prototype.drawLeft_=function(){var a=this.info_.outputConnection;this.positionOutputConnection_();if(a){var b=a.connectionOffsetY+a.height;a="function"==typeof a.shape.pathUp?a.shape.pathUp(a.height):a.shape.pathUp;this.outlinePath_+=Blockly.utils.svgPaths.lineOnAxis("V",b)+a}this.outlinePath_+="z"};
	Blockly.blockRendering.Drawer.prototype.drawInternals_=function(){for(var a=0,b;b=this.info_.rows[a];a++)for(var c=0,d;d=b.elements[c];c++)Blockly.blockRendering.Types.isInlineInput(d)?this.drawInlineInput_(d):(Blockly.blockRendering.Types.isIcon(d)||Blockly.blockRendering.Types.isField(d))&&this.layoutField_(d)};
	Blockly.blockRendering.Drawer.prototype.layoutField_=function(a){if(Blockly.blockRendering.Types.isField(a))var b=a.field.getSvgRoot();else Blockly.blockRendering.Types.isIcon(a)&&(b=a.icon.iconGroup_);var c=a.centerline-a.height/2,d=a.xPos,e="";this.info_.RTL&&(d=-(d+a.width),a.flipRtl&&(d+=a.width,e="scale(-1 1)"));Blockly.blockRendering.Types.isIcon(a)?(b.setAttribute("display","block"),b.setAttribute("transform","translate("+d+","+c+")"),a.icon.computeIconLocation()):b.setAttribute("transform",
	"translate("+d+","+c+")"+e);this.info_.isInsertionMarker&&b.setAttribute("display","none")};
	Blockly.blockRendering.Drawer.prototype.drawInlineInput_=function(a){var b=a.width,c=a.height,d=a.connectionOffsetY,e=a.connectionHeight+d;this.inlinePath_+=Blockly.utils.svgPaths.moveTo(a.xPos+a.connectionWidth,a.centerline-c/2)+Blockly.utils.svgPaths.lineOnAxis("v",d)+a.shape.pathDown+Blockly.utils.svgPaths.lineOnAxis("v",c-e)+Blockly.utils.svgPaths.lineOnAxis("h",b-a.connectionWidth)+Blockly.utils.svgPaths.lineOnAxis("v",-c)+"z";this.positionInlineInputConnection_(a)};
	Blockly.blockRendering.Drawer.prototype.positionInlineInputConnection_=function(a){var b=a.centerline-a.height/2;if(a.connectionModel){var c=a.xPos+a.connectionWidth+a.connectionOffsetX;this.info_.RTL&&(c*=-1);a.connectionModel.setOffsetInBlock(c,b+a.connectionOffsetY)}};
	Blockly.blockRendering.Drawer.prototype.positionStatementInputConnection_=function(a){var b=a.getLastInput();if(b.connectionModel){var c=a.xPos+a.statementEdge+b.notchOffset;this.info_.RTL&&(c*=-1);b.connectionModel.setOffsetInBlock(c,a.yPos)}};Blockly.blockRendering.Drawer.prototype.positionExternalValueConnection_=function(a){var b=a.getLastInput();if(b.connectionModel){var c=a.xPos+a.width;this.info_.RTL&&(c*=-1);b.connectionModel.setOffsetInBlock(c,a.yPos)}};
	Blockly.blockRendering.Drawer.prototype.positionPreviousConnection_=function(){var a=this.info_.topRow;if(a.connection){var b=a.xPos+a.notchOffset;a.connection.connectionModel.setOffsetInBlock(this.info_.RTL?-b:b,0)}};Blockly.blockRendering.Drawer.prototype.positionNextConnection_=function(){var a=this.info_.bottomRow;if(a.connection){var b=a.connection,c=b.xPos;b.connectionModel.setOffsetInBlock(this.info_.RTL?-c:c,a.baseline)}};
	Blockly.blockRendering.Drawer.prototype.positionOutputConnection_=function(){if(this.info_.outputConnection){var a=this.info_.startX+this.info_.outputConnection.connectionOffsetX;this.block_.outputConnection.setOffsetInBlock(this.info_.RTL?-a:a,this.info_.outputConnection.connectionOffsetY)}};Blockly.blockRendering.PathObject=function(a,b,c){this.constants=c;this.svgRoot=a;this.svgPath=Blockly.utils.dom.createSvgElement("path",{"class":"blocklyPath"},this.svgRoot);this.style=b;this.markerSvg=this.cursorSvg=null};Blockly.blockRendering.PathObject.prototype.setPath=function(a){this.svgPath.setAttribute("d",a)};Blockly.blockRendering.PathObject.prototype.flipRTL=function(){this.svgPath.setAttribute("transform","scale(-1 1)")};
	Blockly.blockRendering.PathObject.prototype.setCursorSvg=function(a){a?(this.svgRoot.appendChild(a),this.cursorSvg=a):this.cursorSvg=null};Blockly.blockRendering.PathObject.prototype.setMarkerSvg=function(a){a?(this.cursorSvg?this.svgRoot.insertBefore(a,this.cursorSvg):this.svgRoot.appendChild(a),this.markerSvg=a):this.markerSvg=null};
	Blockly.blockRendering.PathObject.prototype.applyColour=function(a){this.svgPath.setAttribute("stroke",this.style.colourTertiary);this.svgPath.setAttribute("fill",this.style.colourPrimary);this.updateShadow_(a.isShadow());this.updateDisabled_(!a.isEnabled()||a.getInheritedDisabled())};Blockly.blockRendering.PathObject.prototype.setStyle=function(a){this.style=a};
	Blockly.blockRendering.PathObject.prototype.setClass_=function(a,b){b?Blockly.utils.dom.addClass(this.svgRoot,a):Blockly.utils.dom.removeClass(this.svgRoot,a)};Blockly.blockRendering.PathObject.prototype.updateHighlighted=function(a){a?this.svgPath.setAttribute("filter","url(#"+this.constants.embossFilterId+")"):this.svgPath.setAttribute("filter","none")};
	Blockly.blockRendering.PathObject.prototype.updateShadow_=function(a){a&&(this.svgPath.setAttribute("stroke","none"),this.svgPath.setAttribute("fill",this.style.colourSecondary))};Blockly.blockRendering.PathObject.prototype.updateDisabled_=function(a){this.setClass_("blocklyDisabled",a);a&&this.svgPath.setAttribute("fill","url(#"+this.constants.disabledPatternId+")")};Blockly.blockRendering.PathObject.prototype.updateSelected=function(a){this.setClass_("blocklySelected",a)};
	Blockly.blockRendering.PathObject.prototype.updateDraggingDelete=function(a){this.setClass_("blocklyDraggingDelete",a)};Blockly.blockRendering.PathObject.prototype.updateInsertionMarker=function(a){this.setClass_("blocklyInsertionMarker",a)};Blockly.blockRendering.PathObject.prototype.updateMovable=function(a){this.setClass_("blocklyDraggable",a)};Blockly.blockRendering.PathObject.prototype.updateReplacementFade=function(a){this.setClass_("blocklyReplaceable",a)};
	Blockly.blockRendering.PathObject.prototype.updateShapeForInputHighlight=function(a,b){};Blockly.blockRendering.Renderer=function(a){this.name=a;this.overrides=this.constants_=null};Blockly.blockRendering.Renderer.prototype.getClassName=function(){return this.name+"-renderer"};Blockly.blockRendering.Renderer.prototype.init=function(a,b){this.constants_=this.makeConstants_();b&&(this.overrides=b,Blockly.utils.object.mixin(this.constants_,b));this.constants_.setTheme(a);this.constants_.init()};
	Blockly.blockRendering.Renderer.prototype.createDom=function(a,b){this.constants_.createDom(a,this.name+"-"+b.name,"."+this.getClassName()+"."+b.getClassName())};Blockly.blockRendering.Renderer.prototype.refreshDom=function(a,b){var c=this.getConstants();c.dispose();this.constants_=this.makeConstants_();this.overrides&&Blockly.utils.object.mixin(this.constants_,this.overrides);this.constants_.randomIdentifier=c.randomIdentifier;this.constants_.setTheme(b);this.constants_.init();this.createDom(a,b)};
	Blockly.blockRendering.Renderer.prototype.dispose=function(){this.constants_&&this.constants_.dispose()};Blockly.blockRendering.Renderer.prototype.makeConstants_=function(){return new Blockly.blockRendering.ConstantProvider};Blockly.blockRendering.Renderer.prototype.makeRenderInfo_=function(a){return new Blockly.blockRendering.RenderInfo(this,a)};Blockly.blockRendering.Renderer.prototype.makeDrawer_=function(a,b){return new Blockly.blockRendering.Drawer(a,b)};
	Blockly.blockRendering.Renderer.prototype.makeDebugger_=function(){if(!Blockly.blockRendering.Debug)throw Error("Missing require for Blockly.blockRendering.Debug");return new Blockly.blockRendering.Debug(this.getConstants())};Blockly.blockRendering.Renderer.prototype.makeMarkerDrawer=function(a,b){return new Blockly.blockRendering.MarkerSvg(a,this.getConstants(),b)};Blockly.blockRendering.Renderer.prototype.makePathObject=function(a,b){return new Blockly.blockRendering.PathObject(a,b,this.constants_)};
	Blockly.blockRendering.Renderer.prototype.getConstants=function(){return this.constants_};Blockly.blockRendering.Renderer.prototype.shouldHighlightConnection=function(a){return!0};Blockly.blockRendering.Renderer.prototype.orphanCanConnectAtEnd=function(a,b,c){c==Blockly.OUTPUT_VALUE?(c=b.outputConnection,a=Blockly.Connection.lastConnectionInRow(a,b)):(c=b.previousConnection,a=a.lastConnectionInStack());return a?c.checkType(a):!1};
	Blockly.blockRendering.Renderer.prototype.getConnectionPreviewMethod=function(a,b,c){return b.type==Blockly.OUTPUT_VALUE||b.type==Blockly.PREVIOUS_STATEMENT?!a.isConnected()||this.orphanCanConnectAtEnd(c,a.targetBlock(),b.type)?Blockly.InsertionMarkerManager.PREVIEW_TYPE.INSERTION_MARKER:Blockly.InsertionMarkerManager.PREVIEW_TYPE.REPLACEMENT_FADE:Blockly.InsertionMarkerManager.PREVIEW_TYPE.INSERTION_MARKER};
	Blockly.blockRendering.Renderer.prototype.render=function(a){Blockly.blockRendering.useDebugger&&!a.renderingDebugger&&(a.renderingDebugger=this.makeDebugger_());var b=this.makeRenderInfo_(a);b.measure();this.makeDrawer_(a,b).draw()};Blockly.geras={};Blockly.geras.ConstantProvider=function(){Blockly.geras.ConstantProvider.superClass_.constructor.call(this);this.FIELD_TEXT_BASELINE_CENTER=!1;this.DARK_PATH_OFFSET=1;this.MAX_BOTTOM_WIDTH=30};Blockly.utils.object.inherits(Blockly.geras.ConstantProvider,Blockly.blockRendering.ConstantProvider);
	Blockly.geras.ConstantProvider.prototype.getCSS_=function(a){return Blockly.geras.ConstantProvider.superClass_.getCSS_.call(this,a).concat([a+" .blocklyInsertionMarker>.blocklyPathLight,",a+" .blocklyInsertionMarker>.blocklyPathDark {","fill-opacity: "+this.INSERTION_MARKER_OPACITY+";","stroke: none;","}"])};Blockly.geras.Highlighter=function(a){this.info_=a;this.inlineSteps_=this.steps_="";this.RTL_=this.info_.RTL;a=a.getRenderer();this.constants_=a.getConstants();this.highlightConstants_=a.getHighlightConstants();this.highlightOffset_=this.highlightConstants_.OFFSET;this.outsideCornerPaths_=this.highlightConstants_.OUTSIDE_CORNER;this.insideCornerPaths_=this.highlightConstants_.INSIDE_CORNER;this.puzzleTabPaths_=this.highlightConstants_.PUZZLE_TAB;this.notchPaths_=this.highlightConstants_.NOTCH;this.startPaths_=
	this.highlightConstants_.START_HAT;this.jaggedTeethPaths_=this.highlightConstants_.JAGGED_TEETH};Blockly.geras.Highlighter.prototype.getPath=function(){return this.steps_+"\n"+this.inlineSteps_};
	Blockly.geras.Highlighter.prototype.drawTopCorner=function(a){this.steps_+=Blockly.utils.svgPaths.moveBy(a.xPos,this.info_.startY);for(var b=0,c;c=a.elements[b];b++)Blockly.blockRendering.Types.isLeftSquareCorner(c)?this.steps_+=this.highlightConstants_.START_POINT:Blockly.blockRendering.Types.isLeftRoundedCorner(c)?this.steps_+=this.outsideCornerPaths_.topLeft(this.RTL_):Blockly.blockRendering.Types.isPreviousConnection(c)?this.steps_+=this.notchPaths_.pathLeft:Blockly.blockRendering.Types.isHat(c)?
	this.steps_+=this.startPaths_.path(this.RTL_):Blockly.blockRendering.Types.isSpacer(c)&&0!=c.width&&(this.steps_+=Blockly.utils.svgPaths.lineOnAxis("H",c.xPos+c.width-this.highlightOffset_));this.steps_+=Blockly.utils.svgPaths.lineOnAxis("H",a.xPos+a.width-this.highlightOffset_)};Blockly.geras.Highlighter.prototype.drawJaggedEdge_=function(a){this.info_.RTL&&(this.steps_+=this.jaggedTeethPaths_.pathLeft+Blockly.utils.svgPaths.lineOnAxis("v",a.height-this.jaggedTeethPaths_.height-this.highlightOffset_))};
	Blockly.geras.Highlighter.prototype.drawValueInput=function(a){var b=a.getLastInput();if(this.RTL_){var c=a.height-b.connectionHeight;this.steps_+=Blockly.utils.svgPaths.moveTo(b.xPos+b.width-this.highlightOffset_,a.yPos)+this.puzzleTabPaths_.pathDown(this.RTL_)+Blockly.utils.svgPaths.lineOnAxis("v",c)}else this.steps_+=Blockly.utils.svgPaths.moveTo(b.xPos+b.width,a.yPos)+this.puzzleTabPaths_.pathDown(this.RTL_)};
	Blockly.geras.Highlighter.prototype.drawStatementInput=function(a){var b=a.getLastInput();if(this.RTL_){var c=a.height-2*this.insideCornerPaths_.height;this.steps_+=Blockly.utils.svgPaths.moveTo(b.xPos,a.yPos)+this.insideCornerPaths_.pathTop(this.RTL_)+Blockly.utils.svgPaths.lineOnAxis("v",c)+this.insideCornerPaths_.pathBottom(this.RTL_)+Blockly.utils.svgPaths.lineTo(a.width-b.xPos-this.insideCornerPaths_.width,0)}else this.steps_+=Blockly.utils.svgPaths.moveTo(b.xPos,a.yPos+a.height)+this.insideCornerPaths_.pathBottom(this.RTL_)+
	Blockly.utils.svgPaths.lineTo(a.width-b.xPos-this.insideCornerPaths_.width,0)};Blockly.geras.Highlighter.prototype.drawRightSideRow=function(a){var b=a.xPos+a.width-this.highlightOffset_;a.followsStatement&&(this.steps_+=Blockly.utils.svgPaths.lineOnAxis("H",b));this.RTL_&&(this.steps_+=Blockly.utils.svgPaths.lineOnAxis("H",b),a.height>this.highlightOffset_&&(this.steps_+=Blockly.utils.svgPaths.lineOnAxis("V",a.yPos+a.height-this.highlightOffset_)))};
	Blockly.geras.Highlighter.prototype.drawBottomRow=function(a){if(this.RTL_)this.steps_+=Blockly.utils.svgPaths.lineOnAxis("V",a.baseline-this.highlightOffset_);else{var b=this.info_.bottomRow.elements[0];Blockly.blockRendering.Types.isLeftSquareCorner(b)?this.steps_+=Blockly.utils.svgPaths.moveTo(a.xPos+this.highlightOffset_,a.baseline-this.highlightOffset_):Blockly.blockRendering.Types.isLeftRoundedCorner(b)&&(this.steps_+=Blockly.utils.svgPaths.moveTo(a.xPos,a.baseline),this.steps_+=this.outsideCornerPaths_.bottomLeft())}};
	Blockly.geras.Highlighter.prototype.drawLeft=function(){var a=this.info_.outputConnection;a&&(a=a.connectionOffsetY+a.height,this.RTL_?this.steps_+=Blockly.utils.svgPaths.moveTo(this.info_.startX,a):(this.steps_+=Blockly.utils.svgPaths.moveTo(this.info_.startX+this.highlightOffset_,this.info_.bottomRow.baseline-this.highlightOffset_),this.steps_+=Blockly.utils.svgPaths.lineOnAxis("V",a)),this.steps_+=this.puzzleTabPaths_.pathUp(this.RTL_));this.RTL_||(a=this.info_.topRow,Blockly.blockRendering.Types.isLeftRoundedCorner(a.elements[0])?
	this.steps_+=Blockly.utils.svgPaths.lineOnAxis("V",this.outsideCornerPaths_.height):this.steps_+=Blockly.utils.svgPaths.lineOnAxis("V",a.capline+this.highlightOffset_))};
	Blockly.geras.Highlighter.prototype.drawInlineInput=function(a){var b=this.highlightOffset_,c=a.xPos+a.connectionWidth,d=a.centerline-a.height/2,e=a.width-a.connectionWidth,f=d+b;this.RTL_?(d=a.connectionOffsetY-b,a=a.height-(a.connectionOffsetY+a.connectionHeight)+b,this.inlineSteps_+=Blockly.utils.svgPaths.moveTo(c-b,f)+Blockly.utils.svgPaths.lineOnAxis("v",d)+this.puzzleTabPaths_.pathDown(this.RTL_)+Blockly.utils.svgPaths.lineOnAxis("v",a)+Blockly.utils.svgPaths.lineOnAxis("h",e)):this.inlineSteps_+=
	Blockly.utils.svgPaths.moveTo(a.xPos+a.width+b,f)+Blockly.utils.svgPaths.lineOnAxis("v",a.height)+Blockly.utils.svgPaths.lineOnAxis("h",-e)+Blockly.utils.svgPaths.moveTo(c,d+a.connectionOffsetY)+this.puzzleTabPaths_.pathDown(this.RTL_)};Blockly.geras.InlineInput=function(a,b){Blockly.geras.InlineInput.superClass_.constructor.call(this,a,b);this.connectedBlock&&(this.width+=this.constants_.DARK_PATH_OFFSET,this.height+=this.constants_.DARK_PATH_OFFSET)};Blockly.utils.object.inherits(Blockly.geras.InlineInput,Blockly.blockRendering.InlineInput);Blockly.geras.StatementInput=function(a,b){Blockly.geras.StatementInput.superClass_.constructor.call(this,a,b);this.connectedBlock&&(this.height+=this.constants_.DARK_PATH_OFFSET)};
	Blockly.utils.object.inherits(Blockly.geras.StatementInput,Blockly.blockRendering.StatementInput);Blockly.geras.RenderInfo=function(a,b){Blockly.geras.RenderInfo.superClass_.constructor.call(this,a,b)};Blockly.utils.object.inherits(Blockly.geras.RenderInfo,Blockly.blockRendering.RenderInfo);Blockly.geras.RenderInfo.prototype.getRenderer=function(){return this.renderer_};
	Blockly.geras.RenderInfo.prototype.populateBottomRow_=function(){Blockly.geras.RenderInfo.superClass_.populateBottomRow_.call(this);this.block_.inputList.length&&this.block_.inputList[this.block_.inputList.length-1].type==Blockly.NEXT_STATEMENT||(this.bottomRow.minHeight=this.constants_.MEDIUM_PADDING-this.constants_.DARK_PATH_OFFSET)};
	Blockly.geras.RenderInfo.prototype.addInput_=function(a,b){this.isInline&&a.type==Blockly.INPUT_VALUE?(b.elements.push(new Blockly.geras.InlineInput(this.constants_,a)),b.hasInlineInput=!0):a.type==Blockly.NEXT_STATEMENT?(b.elements.push(new Blockly.geras.StatementInput(this.constants_,a)),b.hasStatement=!0):a.type==Blockly.INPUT_VALUE?(b.elements.push(new Blockly.blockRendering.ExternalValueInput(this.constants_,a)),b.hasExternalInput=!0):a.type==Blockly.DUMMY_INPUT&&(b.minHeight=Math.max(b.minHeight,
	this.constants_.DUMMY_INPUT_MIN_HEIGHT),b.hasDummyInput=!0);this.isInline||null!=b.align||(b.align=a.align)};
	Blockly.geras.RenderInfo.prototype.addElemSpacing_=function(){for(var a=!1,b=0,c;c=this.rows[b];b++)c.hasExternalInput&&(a=!0);for(b=0;c=this.rows[b];b++){var d=c.elements;c.elements=[];c.startsWithElemSpacer()&&c.elements.push(new Blockly.blockRendering.InRowSpacer(this.constants_,this.getInRowSpacing_(null,d[0])));if(d.length){for(var e=0;e<d.length-1;e++){c.elements.push(d[e]);var f=this.getInRowSpacing_(d[e],d[e+1]);c.elements.push(new Blockly.blockRendering.InRowSpacer(this.constants_,f))}c.elements.push(d[d.length-
	1]);c.endsWithElemSpacer()&&(f=this.getInRowSpacing_(d[d.length-1],null),a&&c.hasDummyInput&&(f+=this.constants_.TAB_WIDTH),c.elements.push(new Blockly.blockRendering.InRowSpacer(this.constants_,f)))}}};
	Blockly.geras.RenderInfo.prototype.getInRowSpacing_=function(a,b){if(!a)return b&&Blockly.blockRendering.Types.isField(b)&&b.isEditable?this.constants_.MEDIUM_PADDING:b&&Blockly.blockRendering.Types.isInlineInput(b)?this.constants_.MEDIUM_LARGE_PADDING:b&&Blockly.blockRendering.Types.isStatementInput(b)?this.constants_.STATEMENT_INPUT_PADDING_LEFT:this.constants_.LARGE_PADDING;if(!Blockly.blockRendering.Types.isInput(a)&&(!b||Blockly.blockRendering.Types.isStatementInput(b)))return Blockly.blockRendering.Types.isField(a)&&
	a.isEditable?this.constants_.MEDIUM_PADDING:Blockly.blockRendering.Types.isIcon(a)?2*this.constants_.LARGE_PADDING+1:Blockly.blockRendering.Types.isHat(a)?this.constants_.NO_PADDING:Blockly.blockRendering.Types.isPreviousOrNextConnection(a)?this.constants_.LARGE_PADDING:Blockly.blockRendering.Types.isLeftRoundedCorner(a)?this.constants_.MIN_BLOCK_WIDTH:Blockly.blockRendering.Types.isJaggedEdge(a)?this.constants_.NO_PADDING:this.constants_.LARGE_PADDING;if(Blockly.blockRendering.Types.isInput(a)&&
	!b){if(Blockly.blockRendering.Types.isExternalInput(a))return this.constants_.NO_PADDING;if(Blockly.blockRendering.Types.isInlineInput(a))return this.constants_.LARGE_PADDING;if(Blockly.blockRendering.Types.isStatementInput(a))return this.constants_.NO_PADDING}if(!Blockly.blockRendering.Types.isInput(a)&&b&&Blockly.blockRendering.Types.isInput(b)){if(Blockly.blockRendering.Types.isField(a)&&a.isEditable){if(Blockly.blockRendering.Types.isInlineInput(b)||Blockly.blockRendering.Types.isExternalInput(b))return this.constants_.SMALL_PADDING}else{if(Blockly.blockRendering.Types.isInlineInput(b)||
	Blockly.blockRendering.Types.isExternalInput(b))return this.constants_.MEDIUM_LARGE_PADDING;if(Blockly.blockRendering.Types.isStatementInput(b))return this.constants_.LARGE_PADDING}return this.constants_.LARGE_PADDING-1}if(Blockly.blockRendering.Types.isIcon(a)&&b&&!Blockly.blockRendering.Types.isInput(b))return this.constants_.LARGE_PADDING;if(Blockly.blockRendering.Types.isInlineInput(a)&&b&&Blockly.blockRendering.Types.isField(b))return b.isEditable?this.constants_.MEDIUM_PADDING:this.constants_.LARGE_PADDING;
	if(Blockly.blockRendering.Types.isLeftSquareCorner(a)&&b){if(Blockly.blockRendering.Types.isHat(b))return this.constants_.NO_PADDING;if(Blockly.blockRendering.Types.isPreviousConnection(b))return b.notchOffset;if(Blockly.blockRendering.Types.isNextConnection(b))return a=(this.RTL?1:-1)*this.constants_.DARK_PATH_OFFSET/2,b.notchOffset+a}if(Blockly.blockRendering.Types.isLeftRoundedCorner(a)&&b){if(Blockly.blockRendering.Types.isPreviousConnection(b))return b.notchOffset-this.constants_.CORNER_RADIUS;
	if(Blockly.blockRendering.Types.isNextConnection(b))return a=(this.RTL?1:-1)*this.constants_.DARK_PATH_OFFSET/2,b.notchOffset-this.constants_.CORNER_RADIUS+a}return Blockly.blockRendering.Types.isField(a)&&b&&Blockly.blockRendering.Types.isField(b)&&a.isEditable==b.isEditable||b&&Blockly.blockRendering.Types.isJaggedEdge(b)?this.constants_.LARGE_PADDING:this.constants_.MEDIUM_PADDING};
	Blockly.geras.RenderInfo.prototype.getSpacerRowHeight_=function(a,b){return Blockly.blockRendering.Types.isTopRow(a)&&Blockly.blockRendering.Types.isBottomRow(b)?this.constants_.EMPTY_BLOCK_SPACER_HEIGHT:Blockly.blockRendering.Types.isTopRow(a)||Blockly.blockRendering.Types.isBottomRow(b)?this.constants_.NO_PADDING:a.hasExternalInput&&b.hasExternalInput?this.constants_.LARGE_PADDING:!a.hasStatement&&b.hasStatement?this.constants_.BETWEEN_STATEMENT_PADDING_Y:a.hasStatement&&b.hasStatement||!a.hasStatement&&
	b.hasDummyInput||a.hasDummyInput?this.constants_.LARGE_PADDING:this.constants_.MEDIUM_PADDING};
	Blockly.geras.RenderInfo.prototype.getElemCenterline_=function(a,b){if(Blockly.blockRendering.Types.isSpacer(b))return a.yPos+b.height/2;if(Blockly.blockRendering.Types.isBottomRow(a))return a=a.yPos+a.height-a.descenderHeight,Blockly.blockRendering.Types.isNextConnection(b)?a+b.height/2:a-b.height/2;if(Blockly.blockRendering.Types.isTopRow(a))return Blockly.blockRendering.Types.isHat(b)?a.capline-b.height/2:a.capline+b.height/2;var c=a.yPos;Blockly.blockRendering.Types.isField(b)||Blockly.blockRendering.Types.isIcon(b)?
	(c+=b.height/2,(a.hasInlineInput||a.hasStatement)&&b.height+this.constants_.TALL_INPUT_FIELD_OFFSET_Y<=a.height&&(c+=this.constants_.TALL_INPUT_FIELD_OFFSET_Y)):c=Blockly.blockRendering.Types.isInlineInput(b)?c+b.height/2:c+a.height/2;return c};
	Blockly.geras.RenderInfo.prototype.alignRowElements_=function(){if(this.isInline){for(var a=0,b=null,c=this.rows.length-1,d;d=this.rows[c];c--)d.nextRightEdge=a,Blockly.blockRendering.Types.isInputRow(d)&&(d.hasStatement&&this.alignStatementRow_(d),b&&b.hasStatement&&d.width<b.width?d.nextRightEdge=b.width:a=d.width,b=d);for(c=a=0;d=this.rows[c];c++)d.hasStatement?a=this.getDesiredRowWidth_(d):Blockly.blockRendering.Types.isSpacer(d)?d.width=Math.max(a,d.nextRightEdge):(a=Math.max(a,d.nextRightEdge)-
	d.width,0<a&&this.addAlignmentPadding_(d,a),a=d.width)}else Blockly.geras.RenderInfo.superClass_.alignRowElements_.call(this)};Blockly.geras.RenderInfo.prototype.getDesiredRowWidth_=function(a){return this.isInline&&a.hasStatement?this.statementEdge+this.constants_.MAX_BOTTOM_WIDTH+this.startX:Blockly.geras.RenderInfo.superClass_.getDesiredRowWidth_.call(this,a)};
	Blockly.geras.RenderInfo.prototype.finalize_=function(){for(var a=0,b=0,c=0,d;d=this.rows[c];c++){d.yPos=b;d.xPos=this.startX;b+=d.height;a=Math.max(a,d.widthWithConnectedBlocks);var e=b-this.topRow.ascenderHeight;d==this.bottomRow&&e<this.constants_.MIN_BLOCK_HEIGHT&&(e=this.constants_.MIN_BLOCK_HEIGHT-e,this.bottomRow.height+=e,b+=e);this.recordElemPositions_(d)}this.outputConnection&&this.block_.nextConnection&&this.block_.nextConnection.isConnected()&&(a=Math.max(a,this.block_.nextConnection.targetBlock().getHeightWidth().width-
	this.constants_.DARK_PATH_OFFSET));this.bottomRow.baseline=b-this.bottomRow.descenderHeight;this.widthWithChildren=a+this.startX+this.constants_.DARK_PATH_OFFSET;this.width+=this.constants_.DARK_PATH_OFFSET;this.height=b+this.constants_.DARK_PATH_OFFSET;this.startY=this.topRow.capline};Blockly.geras.Drawer=function(a,b){Blockly.geras.Drawer.superClass_.constructor.call(this,a,b);this.highlighter_=new Blockly.geras.Highlighter(b)};Blockly.utils.object.inherits(Blockly.geras.Drawer,Blockly.blockRendering.Drawer);
	Blockly.geras.Drawer.prototype.draw=function(){this.hideHiddenIcons_();this.drawOutline_();this.drawInternals_();var a=this.block_.pathObject;a.setPath(this.outlinePath_+"\n"+this.inlinePath_);a.setHighlightPath(this.highlighter_.getPath());this.info_.RTL&&a.flipRTL();Blockly.blockRendering.useDebugger&&this.block_.renderingDebugger.drawDebug(this.block_,this.info_);this.recordSizeOnBlock_()};
	Blockly.geras.Drawer.prototype.drawTop_=function(){this.highlighter_.drawTopCorner(this.info_.topRow);this.highlighter_.drawRightSideRow(this.info_.topRow);Blockly.geras.Drawer.superClass_.drawTop_.call(this)};Blockly.geras.Drawer.prototype.drawJaggedEdge_=function(a){this.highlighter_.drawJaggedEdge_(a);Blockly.geras.Drawer.superClass_.drawJaggedEdge_.call(this,a)};
	Blockly.geras.Drawer.prototype.drawValueInput_=function(a){this.highlighter_.drawValueInput(a);Blockly.geras.Drawer.superClass_.drawValueInput_.call(this,a)};Blockly.geras.Drawer.prototype.drawStatementInput_=function(a){this.highlighter_.drawStatementInput(a);Blockly.geras.Drawer.superClass_.drawStatementInput_.call(this,a)};
	Blockly.geras.Drawer.prototype.drawRightSideRow_=function(a){this.highlighter_.drawRightSideRow(a);this.outlinePath_+=Blockly.utils.svgPaths.lineOnAxis("H",a.xPos+a.width)+Blockly.utils.svgPaths.lineOnAxis("V",a.yPos+a.height)};Blockly.geras.Drawer.prototype.drawBottom_=function(){this.highlighter_.drawBottomRow(this.info_.bottomRow);Blockly.geras.Drawer.superClass_.drawBottom_.call(this)};Blockly.geras.Drawer.prototype.drawLeft_=function(){this.highlighter_.drawLeft();Blockly.geras.Drawer.superClass_.drawLeft_.call(this)};
	Blockly.geras.Drawer.prototype.drawInlineInput_=function(a){this.highlighter_.drawInlineInput(a);Blockly.geras.Drawer.superClass_.drawInlineInput_.call(this,a)};Blockly.geras.Drawer.prototype.positionInlineInputConnection_=function(a){var b=a.centerline-a.height/2;if(a.connectionModel){var c=a.xPos+a.connectionWidth+this.constants_.DARK_PATH_OFFSET;this.info_.RTL&&(c*=-1);a.connectionModel.setOffsetInBlock(c,b+a.connectionOffsetY+this.constants_.DARK_PATH_OFFSET)}};
	Blockly.geras.Drawer.prototype.positionStatementInputConnection_=function(a){var b=a.getLastInput();if(b.connectionModel){var c=a.xPos+a.statementEdge+b.notchOffset;c=this.info_.RTL?-1*c:c+this.constants_.DARK_PATH_OFFSET;b.connectionModel.setOffsetInBlock(c,a.yPos+this.constants_.DARK_PATH_OFFSET)}};
	Blockly.geras.Drawer.prototype.positionExternalValueConnection_=function(a){var b=a.getLastInput();if(b.connectionModel){var c=a.xPos+a.width+this.constants_.DARK_PATH_OFFSET;this.info_.RTL&&(c*=-1);b.connectionModel.setOffsetInBlock(c,a.yPos)}};Blockly.geras.Drawer.prototype.positionNextConnection_=function(){var a=this.info_.bottomRow;if(a.connection){var b=a.connection,c=b.xPos;b.connectionModel.setOffsetInBlock((this.info_.RTL?-c:c)+this.constants_.DARK_PATH_OFFSET/2,a.baseline+this.constants_.DARK_PATH_OFFSET)}};Blockly.geras.HighlightConstantProvider=function(a){this.constantProvider=a;this.OFFSET=.5;this.START_POINT=Blockly.utils.svgPaths.moveBy(this.OFFSET,this.OFFSET)};Blockly.geras.HighlightConstantProvider.prototype.init=function(){this.INSIDE_CORNER=this.makeInsideCorner();this.OUTSIDE_CORNER=this.makeOutsideCorner();this.PUZZLE_TAB=this.makePuzzleTab();this.NOTCH=this.makeNotch();this.JAGGED_TEETH=this.makeJaggedTeeth();this.START_HAT=this.makeStartHat()};
	Blockly.geras.HighlightConstantProvider.prototype.makeInsideCorner=function(){var a=this.constantProvider.CORNER_RADIUS,b=this.OFFSET,c=(1-Math.SQRT1_2)*(a+b)-b,d=Blockly.utils.svgPaths.moveBy(c,c)+Blockly.utils.svgPaths.arc("a","0 0,0",a,Blockly.utils.svgPaths.point(-c-b,a-c)),e=Blockly.utils.svgPaths.arc("a","0 0,0",a+b,Blockly.utils.svgPaths.point(a+b,a+b)),f=Blockly.utils.svgPaths.moveBy(c,-c)+Blockly.utils.svgPaths.arc("a","0 0,0",a+b,Blockly.utils.svgPaths.point(a-c,c+b));return{width:a+b,height:a,
	pathTop:function(a){return a?d:""},pathBottom:function(a){return a?e:f}}};
	Blockly.geras.HighlightConstantProvider.prototype.makeOutsideCorner=function(){var a=this.constantProvider.CORNER_RADIUS,b=this.OFFSET,c=(1-Math.SQRT1_2)*(a-b)+b,d=Blockly.utils.svgPaths.moveBy(c,c)+Blockly.utils.svgPaths.arc("a","0 0,1",a-b,Blockly.utils.svgPaths.point(a-c,-c+b)),e=Blockly.utils.svgPaths.moveBy(b,a)+Blockly.utils.svgPaths.arc("a","0 0,1",a-b,Blockly.utils.svgPaths.point(a,-a+b)),f=-c,g=Blockly.utils.svgPaths.moveBy(c,f)+Blockly.utils.svgPaths.arc("a","0 0,1",a-b,Blockly.utils.svgPaths.point(-c+
	b,-f-a));return{height:a,topLeft:function(a){return a?d:e},bottomLeft:function(){return g}}};
	Blockly.geras.HighlightConstantProvider.prototype.makePuzzleTab=function(){var a=this.constantProvider.TAB_WIDTH,b=this.constantProvider.TAB_HEIGHT,c=Blockly.utils.svgPaths.moveBy(-2,-b+3.4)+Blockly.utils.svgPaths.lineTo(-.45*a,-2.1),d=Blockly.utils.svgPaths.lineOnAxis("v",2.5)+Blockly.utils.svgPaths.moveBy(.97*-a,2.5)+Blockly.utils.svgPaths.curve("q",[Blockly.utils.svgPaths.point(.05*-a,10),Blockly.utils.svgPaths.point(.3*a,9.5)])+Blockly.utils.svgPaths.moveBy(.67*a,-1.9)+Blockly.utils.svgPaths.lineOnAxis("v",
	2.5),e=Blockly.utils.svgPaths.lineOnAxis("v",-1.5)+Blockly.utils.svgPaths.moveBy(-.92*a,-.5)+Blockly.utils.svgPaths.curve("q",[Blockly.utils.svgPaths.point(-.19*a,-5.5),Blockly.utils.svgPaths.point(0,-11)])+Blockly.utils.svgPaths.moveBy(.92*a,1),f=Blockly.utils.svgPaths.moveBy(-5,b-.7)+Blockly.utils.svgPaths.lineTo(.46*a,-2.1);return{width:a,height:b,pathUp:function(a){return a?c:e},pathDown:function(a){return a?d:f}}};
	Blockly.geras.HighlightConstantProvider.prototype.makeNotch=function(){return{pathLeft:Blockly.utils.svgPaths.lineOnAxis("h",this.OFFSET)+this.constantProvider.NOTCH.pathLeft}};Blockly.geras.HighlightConstantProvider.prototype.makeJaggedTeeth=function(){return{pathLeft:Blockly.utils.svgPaths.lineTo(5.1,2.6)+Blockly.utils.svgPaths.moveBy(-10.2,6.8)+Blockly.utils.svgPaths.lineTo(5.1,2.6),height:12,width:10.2}};
	Blockly.geras.HighlightConstantProvider.prototype.makeStartHat=function(){var a=this.constantProvider.START_HAT.height,b=Blockly.utils.svgPaths.moveBy(25,-8.7)+Blockly.utils.svgPaths.curve("c",[Blockly.utils.svgPaths.point(29.7,-6.2),Blockly.utils.svgPaths.point(57.2,-.5),Blockly.utils.svgPaths.point(75,8.7)]),c=Blockly.utils.svgPaths.curve("c",[Blockly.utils.svgPaths.point(17.8,-9.2),Blockly.utils.svgPaths.point(45.3,-14.9),Blockly.utils.svgPaths.point(75,-8.7)])+Blockly.utils.svgPaths.moveTo(100.5,
	a+.5);return{path:function(a){return a?b:c}}};Blockly.geras.PathObject=function(a,b,c){this.constants=c;this.svgRoot=a;this.svgPathDark=Blockly.utils.dom.createSvgElement("path",{"class":"blocklyPathDark",transform:"translate(1,1)"},this.svgRoot);this.svgPath=Blockly.utils.dom.createSvgElement("path",{"class":"blocklyPath"},this.svgRoot);this.svgPathLight=Blockly.utils.dom.createSvgElement("path",{"class":"blocklyPathLight"},this.svgRoot);this.colourDark="#000000";this.style=b};Blockly.utils.object.inherits(Blockly.geras.PathObject,Blockly.blockRendering.PathObject);
	Blockly.geras.PathObject.prototype.setPath=function(a){this.svgPath.setAttribute("d",a);this.svgPathDark.setAttribute("d",a)};Blockly.geras.PathObject.prototype.setHighlightPath=function(a){this.svgPathLight.setAttribute("d",a)};Blockly.geras.PathObject.prototype.flipRTL=function(){this.svgPath.setAttribute("transform","scale(-1 1)");this.svgPathLight.setAttribute("transform","scale(-1 1)");this.svgPathDark.setAttribute("transform","translate(1,1) scale(-1 1)")};
	Blockly.geras.PathObject.prototype.applyColour=function(a){this.svgPathLight.style.display="";this.svgPathDark.style.display="";this.svgPathLight.setAttribute("stroke",this.style.colourTertiary);this.svgPathDark.setAttribute("fill",this.colourDark);Blockly.geras.PathObject.superClass_.applyColour.call(this,a);this.svgPath.setAttribute("stroke","none")};
	Blockly.geras.PathObject.prototype.setStyle=function(a){this.style=a;this.colourDark=Blockly.utils.colour.blend("#000",this.style.colourPrimary,.2)||this.colourDark};Blockly.geras.PathObject.prototype.updateHighlighted=function(a){a?(this.svgPath.setAttribute("filter","url(#"+this.constants.embossFilterId+")"),this.svgPathLight.style.display="none"):(this.svgPath.setAttribute("filter","none"),this.svgPathLight.style.display="inline")};
	Blockly.geras.PathObject.prototype.updateShadow_=function(a){a&&(this.svgPathLight.style.display="none",this.svgPathDark.setAttribute("fill",this.style.colourSecondary),this.svgPath.setAttribute("stroke","none"),this.svgPath.setAttribute("fill",this.style.colourSecondary))};Blockly.geras.PathObject.prototype.updateDisabled_=function(a){Blockly.geras.PathObject.superClass_.updateDisabled_.call(this,a);a&&this.svgPath.setAttribute("stroke","none")};Blockly.geras.Renderer=function(a){Blockly.geras.Renderer.superClass_.constructor.call(this,a);this.highlightConstants_=null};Blockly.utils.object.inherits(Blockly.geras.Renderer,Blockly.blockRendering.Renderer);Blockly.geras.Renderer.prototype.init=function(a,b){Blockly.geras.Renderer.superClass_.init.call(this,a,b);this.highlightConstants_=this.makeHighlightConstants_();this.highlightConstants_.init()};
	Blockly.geras.Renderer.prototype.refreshDom=function(a,b){Blockly.geras.Renderer.superClass_.refreshDom.call(this,a,b);this.getHighlightConstants().init()};Blockly.geras.Renderer.prototype.makeConstants_=function(){return new Blockly.geras.ConstantProvider};Blockly.geras.Renderer.prototype.makeRenderInfo_=function(a){return new Blockly.geras.RenderInfo(this,a)};Blockly.geras.Renderer.prototype.makeDrawer_=function(a,b){return new Blockly.geras.Drawer(a,b)};
	Blockly.geras.Renderer.prototype.makePathObject=function(a,b){return new Blockly.geras.PathObject(a,b,this.getConstants())};Blockly.geras.Renderer.prototype.makeHighlightConstants_=function(){return new Blockly.geras.HighlightConstantProvider(this.getConstants())};Blockly.geras.Renderer.prototype.getHighlightConstants=function(){return this.highlightConstants_};Blockly.blockRendering.register("geras",Blockly.geras.Renderer);Blockly.thrasos={};Blockly.thrasos.RenderInfo=function(a,b){Blockly.thrasos.RenderInfo.superClass_.constructor.call(this,a,b)};Blockly.utils.object.inherits(Blockly.thrasos.RenderInfo,Blockly.blockRendering.RenderInfo);Blockly.thrasos.RenderInfo.prototype.getRenderer=function(){return this.renderer_};
	Blockly.thrasos.RenderInfo.prototype.addElemSpacing_=function(){for(var a=!1,b=0,c;c=this.rows[b];b++)c.hasExternalInput&&(a=!0);for(b=0;c=this.rows[b];b++){var d=c.elements;c.elements=[];c.startsWithElemSpacer()&&c.elements.push(new Blockly.blockRendering.InRowSpacer(this.constants_,this.getInRowSpacing_(null,d[0])));for(var e=0;e<d.length-1;e++){c.elements.push(d[e]);var f=this.getInRowSpacing_(d[e],d[e+1]);c.elements.push(new Blockly.blockRendering.InRowSpacer(this.constants_,f))}c.elements.push(d[d.length-
	1]);c.endsWithElemSpacer()&&(f=this.getInRowSpacing_(d[d.length-1],null),a&&c.hasDummyInput&&(f+=this.constants_.TAB_WIDTH),c.elements.push(new Blockly.blockRendering.InRowSpacer(this.constants_,f)))}};
	Blockly.thrasos.RenderInfo.prototype.getInRowSpacing_=function(a,b){if(!a)return b&&Blockly.blockRendering.Types.isField(b)&&b.isEditable?this.constants_.MEDIUM_PADDING:b&&Blockly.blockRendering.Types.isInlineInput(b)?this.constants_.MEDIUM_LARGE_PADDING:b&&Blockly.blockRendering.Types.isStatementInput(b)?this.constants_.STATEMENT_INPUT_PADDING_LEFT:this.constants_.LARGE_PADDING;if(!Blockly.blockRendering.Types.isInput(a)&&!b)return Blockly.blockRendering.Types.isField(a)&&a.isEditable?this.constants_.MEDIUM_PADDING:
	Blockly.blockRendering.Types.isIcon(a)?2*this.constants_.LARGE_PADDING+1:Blockly.blockRendering.Types.isHat(a)?this.constants_.NO_PADDING:Blockly.blockRendering.Types.isPreviousOrNextConnection(a)?this.constants_.LARGE_PADDING:Blockly.blockRendering.Types.isLeftRoundedCorner(a)?this.constants_.MIN_BLOCK_WIDTH:Blockly.blockRendering.Types.isJaggedEdge(a)?this.constants_.NO_PADDING:this.constants_.LARGE_PADDING;if(Blockly.blockRendering.Types.isInput(a)&&!b){if(Blockly.blockRendering.Types.isExternalInput(a))return this.constants_.NO_PADDING;
	if(Blockly.blockRendering.Types.isInlineInput(a))return this.constants_.LARGE_PADDING;if(Blockly.blockRendering.Types.isStatementInput(a))return this.constants_.NO_PADDING}if(!Blockly.blockRendering.Types.isInput(a)&&b&&Blockly.blockRendering.Types.isInput(b)){if(Blockly.blockRendering.Types.isField(a)&&a.isEditable){if(Blockly.blockRendering.Types.isInlineInput(b)||Blockly.blockRendering.Types.isExternalInput(b))return this.constants_.SMALL_PADDING}else{if(Blockly.blockRendering.Types.isInlineInput(b)||
	Blockly.blockRendering.Types.isExternalInput(b))return this.constants_.MEDIUM_LARGE_PADDING;if(Blockly.blockRendering.Types.isStatementInput(b))return this.constants_.LARGE_PADDING}return this.constants_.LARGE_PADDING-1}if(Blockly.blockRendering.Types.isIcon(a)&&b&&!Blockly.blockRendering.Types.isInput(b))return this.constants_.LARGE_PADDING;if(Blockly.blockRendering.Types.isInlineInput(a)&&b&&Blockly.blockRendering.Types.isField(b))return b.isEditable?this.constants_.MEDIUM_PADDING:this.constants_.LARGE_PADDING;
	if(Blockly.blockRendering.Types.isLeftSquareCorner(a)&&b){if(Blockly.blockRendering.Types.isHat(b))return this.constants_.NO_PADDING;if(Blockly.blockRendering.Types.isPreviousConnection(b)||Blockly.blockRendering.Types.isNextConnection(b))return b.notchOffset}return Blockly.blockRendering.Types.isLeftRoundedCorner(a)&&b?b.notchOffset-this.constants_.CORNER_RADIUS:Blockly.blockRendering.Types.isField(a)&&b&&Blockly.blockRendering.Types.isField(b)&&a.isEditable==b.isEditable||b&&Blockly.blockRendering.Types.isJaggedEdge(b)?
	this.constants_.LARGE_PADDING:this.constants_.MEDIUM_PADDING};
	Blockly.thrasos.RenderInfo.prototype.getSpacerRowHeight_=function(a,b){return Blockly.blockRendering.Types.isTopRow(a)&&Blockly.blockRendering.Types.isBottomRow(b)?this.constants_.EMPTY_BLOCK_SPACER_HEIGHT:Blockly.blockRendering.Types.isTopRow(a)||Blockly.blockRendering.Types.isBottomRow(b)?this.constants_.NO_PADDING:a.hasExternalInput&&b.hasExternalInput?this.constants_.LARGE_PADDING:!a.hasStatement&&b.hasStatement?this.constants_.BETWEEN_STATEMENT_PADDING_Y:a.hasStatement&&b.hasStatement||a.hasDummyInput||
	b.hasDummyInput?this.constants_.LARGE_PADDING:this.constants_.MEDIUM_PADDING};
	Blockly.thrasos.RenderInfo.prototype.getElemCenterline_=function(a,b){if(Blockly.blockRendering.Types.isSpacer(b))return a.yPos+b.height/2;if(Blockly.blockRendering.Types.isBottomRow(a))return a=a.yPos+a.height-a.descenderHeight,Blockly.blockRendering.Types.isNextConnection(b)?a+b.height/2:a-b.height/2;if(Blockly.blockRendering.Types.isTopRow(a))return Blockly.blockRendering.Types.isHat(b)?a.capline-b.height/2:a.capline+b.height/2;var c=a.yPos;return c=Blockly.blockRendering.Types.isField(b)&&a.hasStatement?
	c+(this.constants_.TALL_INPUT_FIELD_OFFSET_Y+b.height/2):c+a.height/2};
	Blockly.thrasos.RenderInfo.prototype.finalize_=function(){for(var a=0,b=0,c=0,d;d=this.rows[c];c++){d.yPos=b;d.xPos=this.startX;b+=d.height;a=Math.max(a,d.widthWithConnectedBlocks);var e=b-this.topRow.ascenderHeight;d==this.bottomRow&&e<this.constants_.MIN_BLOCK_HEIGHT&&(e=this.constants_.MIN_BLOCK_HEIGHT-e,this.bottomRow.height+=e,b+=e);this.recordElemPositions_(d)}this.outputConnection&&this.block_.nextConnection&&this.block_.nextConnection.isConnected()&&(a=Math.max(a,this.block_.nextConnection.targetBlock().getHeightWidth().width));
	this.bottomRow.baseline=b-this.bottomRow.descenderHeight;this.widthWithChildren=a+this.startX;this.height=b;this.startY=this.topRow.capline};Blockly.thrasos.Renderer=function(a){Blockly.thrasos.Renderer.superClass_.constructor.call(this,a)};Blockly.utils.object.inherits(Blockly.thrasos.Renderer,Blockly.blockRendering.Renderer);Blockly.thrasos.Renderer.prototype.makeRenderInfo_=function(a){return new Blockly.thrasos.RenderInfo(this,a)};Blockly.blockRendering.register("thrasos",Blockly.thrasos.Renderer);Blockly.zelos={};
	Blockly.zelos.ConstantProvider=function(){Blockly.zelos.ConstantProvider.superClass_.constructor.call(this);this.SMALL_PADDING=this.GRID_UNIT=4;this.MEDIUM_PADDING=2*this.GRID_UNIT;this.MEDIUM_LARGE_PADDING=3*this.GRID_UNIT;this.LARGE_PADDING=4*this.GRID_UNIT;this.CORNER_RADIUS=1*this.GRID_UNIT;this.NOTCH_WIDTH=9*this.GRID_UNIT;this.NOTCH_HEIGHT=2*this.GRID_UNIT;this.STATEMENT_INPUT_NOTCH_OFFSET=this.NOTCH_OFFSET_LEFT=3*this.GRID_UNIT;this.MIN_BLOCK_WIDTH=2*this.GRID_UNIT;this.MIN_BLOCK_HEIGHT=12*
	this.GRID_UNIT;this.EMPTY_STATEMENT_INPUT_HEIGHT=6*this.GRID_UNIT;this.TAB_OFFSET_FROM_TOP=0;this.TOP_ROW_MIN_HEIGHT=this.CORNER_RADIUS;this.TOP_ROW_PRECEDES_STATEMENT_MIN_HEIGHT=this.LARGE_PADDING;this.BOTTOM_ROW_MIN_HEIGHT=this.CORNER_RADIUS;this.BOTTOM_ROW_AFTER_STATEMENT_MIN_HEIGHT=6*this.GRID_UNIT;this.STATEMENT_BOTTOM_SPACER=-this.NOTCH_HEIGHT;this.STATEMENT_INPUT_SPACER_MIN_WIDTH=40*this.GRID_UNIT;this.STATEMENT_INPUT_PADDING_LEFT=4*this.GRID_UNIT;this.EMPTY_INLINE_INPUT_PADDING=4*this.GRID_UNIT;
	this.EMPTY_INLINE_INPUT_HEIGHT=8*this.GRID_UNIT;this.DUMMY_INPUT_MIN_HEIGHT=8*this.GRID_UNIT;this.DUMMY_INPUT_SHADOW_MIN_HEIGHT=6*this.GRID_UNIT;this.CURSOR_WS_WIDTH=20*this.GRID_UNIT;this.CURSOR_COLOUR="#ffa200";this.CURSOR_RADIUS=5;this.JAGGED_TEETH_WIDTH=this.JAGGED_TEETH_HEIGHT=0;this.START_HAT_HEIGHT=22;this.START_HAT_WIDTH=96;this.SHAPES={HEXAGONAL:1,ROUND:2,SQUARE:3,PUZZLE:4,NOTCH:5};this.SHAPE_IN_SHAPE_PADDING={1:{0:5*this.GRID_UNIT,1:2*this.GRID_UNIT,2:5*this.GRID_UNIT,3:5*this.GRID_UNIT},
	2:{0:3*this.GRID_UNIT,1:3*this.GRID_UNIT,2:1*this.GRID_UNIT,3:2*this.GRID_UNIT},3:{0:2*this.GRID_UNIT,1:2*this.GRID_UNIT,2:2*this.GRID_UNIT,3:2*this.GRID_UNIT}};this.FULL_BLOCK_FIELDS=!0;this.FIELD_TEXT_FONTSIZE=3*this.GRID_UNIT;this.FIELD_TEXT_FONTWEIGHT="bold";this.FIELD_TEXT_FONTFAMILY='"Helvetica Neue", "Segoe UI", Helvetica, sans-serif';this.FIELD_BORDER_RECT_RADIUS=this.CORNER_RADIUS;this.FIELD_BORDER_RECT_X_PADDING=2*this.GRID_UNIT;this.FIELD_BORDER_RECT_Y_PADDING=1.625*this.GRID_UNIT;this.FIELD_BORDER_RECT_HEIGHT=
	8*this.GRID_UNIT;this.FIELD_DROPDOWN_BORDER_RECT_HEIGHT=8*this.GRID_UNIT;this.FIELD_DROPDOWN_SVG_ARROW=this.FIELD_DROPDOWN_COLOURED_DIV=this.FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW=!0;this.FIELD_DROPDOWN_SVG_ARROW_PADDING=this.FIELD_BORDER_RECT_X_PADDING;this.FIELD_COLOUR_FULL_BLOCK=this.FIELD_TEXTINPUT_BOX_SHADOW=!0;this.FIELD_COLOUR_DEFAULT_WIDTH=2*this.GRID_UNIT;this.FIELD_COLOUR_DEFAULT_HEIGHT=4*this.GRID_UNIT;this.FIELD_CHECKBOX_X_OFFSET=1*this.GRID_UNIT;this.MAX_DYNAMIC_CONNECTION_SHAPE_WIDTH=
	12*this.GRID_UNIT;this.SELECTED_GLOW_COLOUR="#fff200";this.SELECTED_GLOW_SIZE=.5;this.REPLACEMENT_GLOW_COLOUR="#fff200";this.REPLACEMENT_GLOW_SIZE=2;this.selectedGlowFilterId="";this.selectedGlowFilter_=null;this.replacementGlowFilterId="";this.replacementGlowFilter_=null};Blockly.utils.object.inherits(Blockly.zelos.ConstantProvider,Blockly.blockRendering.ConstantProvider);
	Blockly.zelos.ConstantProvider.prototype.setFontConstants_=function(a){Blockly.zelos.ConstantProvider.superClass_.setFontConstants_.call(this,a);this.FIELD_DROPDOWN_BORDER_RECT_HEIGHT=this.FIELD_BORDER_RECT_HEIGHT=this.FIELD_TEXT_HEIGHT+2*this.FIELD_BORDER_RECT_Y_PADDING};
	Blockly.zelos.ConstantProvider.prototype.init=function(){Blockly.zelos.ConstantProvider.superClass_.init.call(this);this.HEXAGONAL=this.makeHexagonal();this.ROUNDED=this.makeRounded();this.SQUARED=this.makeSquared();this.STATEMENT_INPUT_NOTCH_OFFSET=this.NOTCH_OFFSET_LEFT+this.INSIDE_CORNERS.rightWidth};
	Blockly.zelos.ConstantProvider.prototype.setDynamicProperties_=function(a){Blockly.zelos.ConstantProvider.superClass_.setDynamicProperties_.call(this,a);this.SELECTED_GLOW_COLOUR=a.getComponentStyle("selectedGlowColour")||this.SELECTED_GLOW_COLOUR;var b=Number(a.getComponentStyle("selectedGlowSize"));this.SELECTED_GLOW_SIZE=b&&!isNaN(b)?b:this.SELECTED_GLOW_SIZE;this.REPLACEMENT_GLOW_COLOUR=a.getComponentStyle("replacementGlowColour")||this.REPLACEMENT_GLOW_COLOUR;this.REPLACEMENT_GLOW_SIZE=(a=Number(a.getComponentStyle("replacementGlowSize")))&&
	!isNaN(a)?a:this.REPLACEMENT_GLOW_SIZE};Blockly.zelos.ConstantProvider.prototype.dispose=function(){Blockly.zelos.ConstantProvider.superClass_.dispose.call(this);this.selectedGlowFilter_&&Blockly.utils.dom.removeNode(this.selectedGlowFilter_);this.replacementGlowFilter_&&Blockly.utils.dom.removeNode(this.replacementGlowFilter_)};
	Blockly.zelos.ConstantProvider.prototype.makeStartHat=function(){var a=this.START_HAT_HEIGHT,b=this.START_HAT_WIDTH,c=Blockly.utils.svgPaths.curve("c",[Blockly.utils.svgPaths.point(25,-a),Blockly.utils.svgPaths.point(71,-a),Blockly.utils.svgPaths.point(b,0)]);return{height:a,width:b,path:c}};
	Blockly.zelos.ConstantProvider.prototype.makeHexagonal=function(){function a(a,d,e){var c=a/2;c=c>b?b:c;e=e?-1:1;a=(d?-1:1)*a/2;return Blockly.utils.svgPaths.lineTo(-e*c,a)+Blockly.utils.svgPaths.lineTo(e*c,a)}var b=this.MAX_DYNAMIC_CONNECTION_SHAPE_WIDTH;return{type:this.SHAPES.HEXAGONAL,isDynamic:!0,width:function(a){a/=2;return a>b?b:a},height:function(a){return a},connectionOffsetY:function(a){return a/2},connectionOffsetX:function(a){return-a},pathDown:function(b){return a(b,!1,!1)},pathUp:function(b){return a(b,
	!0,!1)},pathRightDown:function(b){return a(b,!1,!0)},pathRightUp:function(b){return a(b,!1,!0)}}};
	Blockly.zelos.ConstantProvider.prototype.makeRounded=function(){function a(a,b,f){var d=a>c?a-c:0;a=(a>c?c:a)/2;return Blockly.utils.svgPaths.arc("a","0 0,1",a,Blockly.utils.svgPaths.point((b?-1:1)*a,(b?-1:1)*a))+Blockly.utils.svgPaths.lineOnAxis("v",(f?1:-1)*d)+Blockly.utils.svgPaths.arc("a","0 0,1",a,Blockly.utils.svgPaths.point((b?1:-1)*a,(b?-1:1)*a))}var b=this.MAX_DYNAMIC_CONNECTION_SHAPE_WIDTH,c=2*b;return{type:this.SHAPES.ROUND,isDynamic:!0,width:function(a){a/=2;return a>b?b:a},height:function(a){return a},
	connectionOffsetY:function(a){return a/2},connectionOffsetX:function(a){return-a},pathDown:function(b){return a(b,!1,!1)},pathUp:function(b){return a(b,!0,!1)},pathRightDown:function(b){return a(b,!1,!0)},pathRightUp:function(b){return a(b,!1,!0)}}};
	Blockly.zelos.ConstantProvider.prototype.makeSquared=function(){function a(a,d,e){a-=2*b;return Blockly.utils.svgPaths.arc("a","0 0,1",b,Blockly.utils.svgPaths.point((d?-1:1)*b,(d?-1:1)*b))+Blockly.utils.svgPaths.lineOnAxis("v",(e?1:-1)*a)+Blockly.utils.svgPaths.arc("a","0 0,1",b,Blockly.utils.svgPaths.point((d?1:-1)*b,(d?-1:1)*b))}var b=this.CORNER_RADIUS;return{type:this.SHAPES.SQUARE,isDynamic:!0,width:function(a){return b},height:function(a){return a},connectionOffsetY:function(a){return a/2},
	connectionOffsetX:function(a){return-a},pathDown:function(b){return a(b,!1,!1)},pathUp:function(b){return a(b,!0,!1)},pathRightDown:function(b){return a(b,!1,!0)},pathRightUp:function(b){return a(b,!1,!0)}}};
	Blockly.zelos.ConstantProvider.prototype.shapeFor=function(a){var b=a.getCheck();!b&&a.targetConnection&&(b=a.targetConnection.getCheck());switch(a.type){case Blockly.INPUT_VALUE:case Blockly.OUTPUT_VALUE:a=a.getSourceBlock().getOutputShape();if(null!=a)switch(a){case this.SHAPES.HEXAGONAL:return this.HEXAGONAL;case this.SHAPES.ROUND:return this.ROUNDED;case this.SHAPES.SQUARE:return this.SQUARED}if(b&&-1!=b.indexOf("Boolean"))return this.HEXAGONAL;if(b&&-1!=b.indexOf("Number"))return this.ROUNDED;
	b&&b.indexOf("String");return this.ROUNDED;case Blockly.PREVIOUS_STATEMENT:case Blockly.NEXT_STATEMENT:return this.NOTCH;default:throw Error("Unknown type");}};
	Blockly.zelos.ConstantProvider.prototype.makeNotch=function(){function a(a){return Blockly.utils.svgPaths.curve("c",[Blockly.utils.svgPaths.point(a*e/2,0),Blockly.utils.svgPaths.point(a*e*3/4,g/2),Blockly.utils.svgPaths.point(a*e,g)])+Blockly.utils.svgPaths.line([Blockly.utils.svgPaths.point(a*e,f)])+Blockly.utils.svgPaths.curve("c",[Blockly.utils.svgPaths.point(a*e/4,g/2),Blockly.utils.svgPaths.point(a*e/2,g),Blockly.utils.svgPaths.point(a*e,g)])+Blockly.utils.svgPaths.lineOnAxis("h",a*d)+Blockly.utils.svgPaths.curve("c",
	[Blockly.utils.svgPaths.point(a*e/2,0),Blockly.utils.svgPaths.point(a*e*3/4,-(g/2)),Blockly.utils.svgPaths.point(a*e,-g)])+Blockly.utils.svgPaths.line([Blockly.utils.svgPaths.point(a*e,-f)])+Blockly.utils.svgPaths.curve("c",[Blockly.utils.svgPaths.point(a*e/4,-(g/2)),Blockly.utils.svgPaths.point(a*e/2,-g),Blockly.utils.svgPaths.point(a*e,-g)])}var b=this.NOTCH_WIDTH,c=this.NOTCH_HEIGHT,d=b/3,e=d/3,f=c/2,g=f/2,h=a(1),k=a(-1);return{type:this.SHAPES.NOTCH,width:b,height:c,pathLeft:h,pathRight:k}};
	Blockly.zelos.ConstantProvider.prototype.makeInsideCorners=function(){var a=this.CORNER_RADIUS,b=Blockly.utils.svgPaths.arc("a","0 0,0",a,Blockly.utils.svgPaths.point(-a,a)),c=Blockly.utils.svgPaths.arc("a","0 0,1",a,Blockly.utils.svgPaths.point(-a,a)),d=Blockly.utils.svgPaths.arc("a","0 0,0",a,Blockly.utils.svgPaths.point(a,a)),e=Blockly.utils.svgPaths.arc("a","0 0,1",a,Blockly.utils.svgPaths.point(a,a));return{width:a,height:a,pathTop:b,pathBottom:d,rightWidth:a,rightHeight:a,pathTopRight:c,pathBottomRight:e}};
	Blockly.zelos.ConstantProvider.prototype.generateSecondaryColour_=function(a){return Blockly.utils.colour.blend("#000",a,.15)||a};Blockly.zelos.ConstantProvider.prototype.generateTertiaryColour_=function(a){return Blockly.utils.colour.blend("#000",a,.25)||a};
	Blockly.zelos.ConstantProvider.prototype.createDom=function(a,b,c){Blockly.zelos.ConstantProvider.superClass_.createDom.call(this,a,b,c);a=Blockly.utils.dom.createSvgElement("defs",{},a);b=Blockly.utils.dom.createSvgElement("filter",{id:"blocklySelectedGlowFilter"+this.randomIdentifier,height:"160%",width:"180%",y:"-30%",x:"-40%"},a);Blockly.utils.dom.createSvgElement("feGaussianBlur",{"in":"SourceGraphic",stdDeviation:this.SELECTED_GLOW_SIZE},b);c=Blockly.utils.dom.createSvgElement("feComponentTransfer",
	{result:"outBlur"},b);Blockly.utils.dom.createSvgElement("feFuncA",{type:"table",tableValues:"0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1"},c);Blockly.utils.dom.createSvgElement("feFlood",{"flood-color":this.SELECTED_GLOW_COLOUR,"flood-opacity":1,result:"outColor"},b);Blockly.utils.dom.createSvgElement("feComposite",{"in":"outColor",in2:"outBlur",operator:"in",result:"outGlow"},b);this.selectedGlowFilterId=b.id;this.selectedGlowFilter_=b;a=Blockly.utils.dom.createSvgElement("filter",{id:"blocklyReplacementGlowFilter"+
	this.randomIdentifier,height:"160%",width:"180%",y:"-30%",x:"-40%"},a);Blockly.utils.dom.createSvgElement("feGaussianBlur",{"in":"SourceGraphic",stdDeviation:this.REPLACEMENT_GLOW_SIZE},a);b=Blockly.utils.dom.createSvgElement("feComponentTransfer",{result:"outBlur"},a);Blockly.utils.dom.createSvgElement("feFuncA",{type:"table",tableValues:"0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1"},b);Blockly.utils.dom.createSvgElement("feFlood",{"flood-color":this.REPLACEMENT_GLOW_COLOUR,"flood-opacity":1,result:"outColor"},
	a);Blockly.utils.dom.createSvgElement("feComposite",{"in":"outColor",in2:"outBlur",operator:"in",result:"outGlow"},a);Blockly.utils.dom.createSvgElement("feComposite",{"in":"SourceGraphic",in2:"outGlow",operator:"over"},a);this.replacementGlowFilterId=a.id;this.replacementGlowFilter_=a};
	Blockly.zelos.ConstantProvider.prototype.getCSS_=function(a){return[a+" .blocklyText,",a+" .blocklyFlyoutLabelText {","font: "+this.FIELD_TEXT_FONTWEIGHT+" "+this.FIELD_TEXT_FONTSIZE+"pt "+this.FIELD_TEXT_FONTFAMILY+";","}",a+" .blocklyText {","fill: #fff;","}",a+" .blocklyNonEditableText>rect:not(.blocklyDropdownRect),",a+" .blocklyEditableText>rect:not(.blocklyDropdownRect) {","fill: "+this.FIELD_BORDER_RECT_COLOUR+";","}",a+" .blocklyNonEditableText>text,",a+" .blocklyEditableText>text,",a+" .blocklyNonEditableText>g>text,",
	a+" .blocklyEditableText>g>text {","fill: #575E75;","}",a+" .blocklyFlyoutLabelText {","fill: #575E75;","}",a+" .blocklyText.blocklyBubbleText {","fill: #575E75;","}",a+" .blocklyDraggable:not(.blocklyDisabled)"," .blocklyEditableText:not(.editing):hover>rect,",a+" .blocklyDraggable:not(.blocklyDisabled)"," .blocklyEditableText:not(.editing):hover>.blocklyPath {","stroke: #fff;","stroke-width: 2;","}",a+" .blocklyHtmlInput {","font-family: "+this.FIELD_TEXT_FONTFAMILY+";","font-weight: "+this.FIELD_TEXT_FONTWEIGHT+
	";","color: #575E75;","}",a+" .blocklyDropdownText {","fill: #fff !important;","}",a+".blocklyWidgetDiv .goog-menuitem,",a+".blocklyDropDownDiv .goog-menuitem {","font-family: "+this.FIELD_TEXT_FONTFAMILY+";","}",a+".blocklyDropDownDiv .goog-menuitem-content {","color: #fff;","}",a+" .blocklyHighlightedConnectionPath {","stroke: "+this.SELECTED_GLOW_COLOUR+";","}",a+" .blocklyDisabled > .blocklyOutlinePath {","fill: url(#blocklyDisabledPattern"+this.randomIdentifier+")","}",a+" .blocklyInsertionMarker>.blocklyPath {",
	"fill-opacity: "+this.INSERTION_MARKER_OPACITY+";","stroke: none;","}"]};Blockly.zelos.TopRow=function(a){Blockly.zelos.TopRow.superClass_.constructor.call(this,a)};Blockly.utils.object.inherits(Blockly.zelos.TopRow,Blockly.blockRendering.TopRow);Blockly.zelos.TopRow.prototype.endsWithElemSpacer=function(){return!1};Blockly.zelos.TopRow.prototype.hasLeftSquareCorner=function(a){var b=(a.hat?"cap"===a.hat:this.constants_.ADD_START_HATS)&&!a.outputConnection&&!a.previousConnection;return!!a.outputConnection||b};
	Blockly.zelos.TopRow.prototype.hasRightSquareCorner=function(a){return!!a.outputConnection&&!a.statementInputCount&&!a.nextConnection};Blockly.zelos.BottomRow=function(a){Blockly.zelos.BottomRow.superClass_.constructor.call(this,a)};Blockly.utils.object.inherits(Blockly.zelos.BottomRow,Blockly.blockRendering.BottomRow);Blockly.zelos.BottomRow.prototype.endsWithElemSpacer=function(){return!1};Blockly.zelos.BottomRow.prototype.hasLeftSquareCorner=function(a){return!!a.outputConnection};
	Blockly.zelos.BottomRow.prototype.hasRightSquareCorner=function(a){return!!a.outputConnection&&!a.statementInputCount&&!a.nextConnection};Blockly.zelos.RightConnectionShape=function(a){Blockly.zelos.RightConnectionShape.superClass_.constructor.call(this,a);this.type|=Blockly.blockRendering.Types.getType("RIGHT_CONNECTION");this.width=this.height=0};Blockly.utils.object.inherits(Blockly.zelos.RightConnectionShape,Blockly.blockRendering.Measurable);Blockly.zelos.StatementInput=function(a,b){Blockly.zelos.StatementInput.superClass_.constructor.call(this,a,b);if(this.connectedBlock){for(a=this.connectedBlock;a.getNextBlock();)a=a.getNextBlock();a.nextConnection||(this.height=this.connectedBlockHeight,this.connectedBottomNextConnection=!0)}};Blockly.utils.object.inherits(Blockly.zelos.StatementInput,Blockly.blockRendering.StatementInput);Blockly.zelos.RenderInfo=function(a,b){Blockly.zelos.RenderInfo.superClass_.constructor.call(this,a,b);this.topRow=new Blockly.zelos.TopRow(this.constants_);this.bottomRow=new Blockly.zelos.BottomRow(this.constants_);this.isInline=!0;this.isMultiRow=!b.getInputsInline()||b.isCollapsed();this.hasStatementInput=0<b.statementInputCount;this.rightSide=this.outputConnection?new Blockly.zelos.RightConnectionShape(this.constants_):null};Blockly.utils.object.inherits(Blockly.zelos.RenderInfo,Blockly.blockRendering.RenderInfo);
	Blockly.zelos.RenderInfo.prototype.getRenderer=function(){return this.renderer_};Blockly.zelos.RenderInfo.prototype.measure=function(){this.createRows_();this.addElemSpacing_();this.addRowSpacing_();this.adjustXPosition_();this.computeBounds_();this.alignRowElements_();this.finalize_()};
	Blockly.zelos.RenderInfo.prototype.shouldStartNewRow_=function(a,b){return b?a.type==Blockly.NEXT_STATEMENT||b.type==Blockly.NEXT_STATEMENT?!0:a.type==Blockly.INPUT_VALUE||a.type==Blockly.DUMMY_INPUT?!this.isInline||this.isMultiRow:!1:!1};Blockly.zelos.RenderInfo.prototype.getDesiredRowWidth_=function(a){return a.hasStatement?this.width-this.startX-(this.constants_.INSIDE_CORNERS.rightWidth||0):Blockly.zelos.RenderInfo.superClass_.getDesiredRowWidth_.call(this,a)};
	Blockly.zelos.RenderInfo.prototype.getInRowSpacing_=function(a,b){return a&&b||!this.outputConnection||!this.outputConnection.isDynamicShape||this.hasStatementInput||this.bottomRow.hasNextConnection?!a&&b&&Blockly.blockRendering.Types.isStatementInput(b)?this.constants_.STATEMENT_INPUT_PADDING_LEFT:a&&Blockly.blockRendering.Types.isLeftRoundedCorner(a)&&b&&(Blockly.blockRendering.Types.isPreviousConnection(b)||Blockly.blockRendering.Types.isNextConnection(b))?b.notchOffset-this.constants_.CORNER_RADIUS:
	a&&Blockly.blockRendering.Types.isLeftSquareCorner(a)&&b&&Blockly.blockRendering.Types.isHat(b)?this.constants_.NO_PADDING:this.constants_.MEDIUM_PADDING:this.constants_.NO_PADDING};
	Blockly.zelos.RenderInfo.prototype.getSpacerRowHeight_=function(a,b){if(Blockly.blockRendering.Types.isTopRow(a)&&Blockly.blockRendering.Types.isBottomRow(b))return this.constants_.EMPTY_BLOCK_SPACER_HEIGHT;var c=Blockly.blockRendering.Types.isInputRow(a)&&a.hasStatement,d=Blockly.blockRendering.Types.isInputRow(b)&&b.hasStatement;return d||c?(a=Math.max(this.constants_.NOTCH_HEIGHT,this.constants_.INSIDE_CORNERS.rightHeight||0),d&&c?Math.max(a,this.constants_.DUMMY_INPUT_MIN_HEIGHT):a):Blockly.blockRendering.Types.isTopRow(a)?
	a.hasPreviousConnection||this.outputConnection&&!this.hasStatementInput?this.constants_.NO_PADDING:Math.abs(this.constants_.NOTCH_HEIGHT-this.constants_.CORNER_RADIUS):Blockly.blockRendering.Types.isBottomRow(b)?this.outputConnection?!b.hasNextConnection&&this.hasStatementInput?Math.abs(this.constants_.NOTCH_HEIGHT-this.constants_.CORNER_RADIUS):this.constants_.NO_PADDING:Math.max(this.topRow.minHeight,Math.max(this.constants_.NOTCH_HEIGHT,this.constants_.CORNER_RADIUS))-this.constants_.CORNER_RADIUS:
	this.constants_.MEDIUM_PADDING};Blockly.zelos.RenderInfo.prototype.getSpacerRowWidth_=function(a,b){var c=this.width-this.startX;return Blockly.blockRendering.Types.isInputRow(a)&&a.hasStatement||Blockly.blockRendering.Types.isInputRow(b)&&b.hasStatement?Math.max(c,this.constants_.STATEMENT_INPUT_SPACER_MIN_WIDTH):c};
	Blockly.zelos.RenderInfo.prototype.getElemCenterline_=function(a,b){if(a.hasStatement&&!Blockly.blockRendering.Types.isSpacer(b)&&!Blockly.blockRendering.Types.isStatementInput(b))return a.yPos+this.constants_.EMPTY_STATEMENT_INPUT_HEIGHT/2;if(Blockly.blockRendering.Types.isInlineInput(b)){var c=b.connectedBlock;if(c&&c.outputConnection&&c.nextConnection)return a.yPos+c.height/2}return Blockly.zelos.RenderInfo.superClass_.getElemCenterline_.call(this,a,b)};
	Blockly.zelos.RenderInfo.prototype.addInput_=function(a,b){a.type==Blockly.DUMMY_INPUT&&b.hasDummyInput&&b.align==Blockly.ALIGN_LEFT&&a.align==Blockly.ALIGN_RIGHT&&(b.rightAlignedDummyInput=a);Blockly.zelos.RenderInfo.superClass_.addInput_.call(this,a,b)};
	Blockly.zelos.RenderInfo.prototype.addAlignmentPadding_=function(a,b){if(a.rightAlignedDummyInput){for(var c,d=0,e;(e=a.elements[d])&&(Blockly.blockRendering.Types.isSpacer(e)&&(c=e),!Blockly.blockRendering.Types.isField(e)||e.parentInput!=a.rightAlignedDummyInput);d++);if(c){c.width+=b;a.width+=b;return}}Blockly.zelos.RenderInfo.superClass_.addAlignmentPadding_.call(this,a,b)};
	Blockly.zelos.RenderInfo.prototype.adjustXPosition_=function(){for(var a=this.constants_.NOTCH_OFFSET_LEFT+this.constants_.NOTCH_WIDTH,b=a,c=2;c<this.rows.length-1;c+=2){var d=this.rows[c-1],e=this.rows[c],f=this.rows[c+1];d=2==c?!!this.topRow.hasPreviousConnection:!!d.followsStatement;f=c+2>=this.rows.length-1?!!this.bottomRow.hasNextConnection:!!f.precedesStatement;if(Blockly.blockRendering.Types.isInputRow(e)&&e.hasStatement)e.measure(),b=e.width-e.getLastInput().width+a;else if(d&&(2==c||f)&&
	Blockly.blockRendering.Types.isInputRow(e)&&!e.hasStatement){f=e.xPos;d=null;for(var g=0,h;h=e.elements[g];g++)Blockly.blockRendering.Types.isSpacer(h)&&(d=h),!(d&&(Blockly.blockRendering.Types.isField(h)||Blockly.blockRendering.Types.isInput(h))&&f<b)||Blockly.blockRendering.Types.isField(h)&&(h.field instanceof Blockly.FieldLabel||h.field instanceof Blockly.FieldImage)||(d.width+=b-f),f+=h.width}}};
	Blockly.zelos.RenderInfo.prototype.finalizeOutputConnection_=function(){if(this.outputConnection&&this.outputConnection.isDynamicShape){for(var a=0,b=0,c;c=this.rows[b];b++)c.yPos=a,a+=c.height;this.height=a;b=this.bottomRow.hasNextConnection?this.height-this.bottomRow.descenderHeight:this.height;a=this.outputConnection.shape.height(b);b=this.outputConnection.shape.width(b);this.outputConnection.height=a;this.outputConnection.width=b;this.outputConnection.startX=b;this.outputConnection.connectionOffsetY=
	this.outputConnection.shape.connectionOffsetY(a);this.outputConnection.connectionOffsetX=this.outputConnection.shape.connectionOffsetX(b);c=0;this.hasStatementInput||this.bottomRow.hasNextConnection||(c=b,this.rightSide.height=a,this.rightSide.width=c,this.rightSide.centerline=a/2,this.rightSide.xPos=this.width+c);this.startX=b;this.width+=b+c;this.widthWithChildren+=b+c}};
	Blockly.zelos.RenderInfo.prototype.finalizeHorizontalAlignment_=function(){if(this.outputConnection&&!this.hasStatementInput&&!this.bottomRow.hasNextConnection){for(var a=0,b=0,c;c=this.rows[b];b++)if(Blockly.blockRendering.Types.isInputRow(c)){a=c.elements[c.elements.length-2];var d=this.getNegativeSpacing_(c.elements[1]),e=this.getNegativeSpacing_(a);a=d+e;var f=this.constants_.MIN_BLOCK_WIDTH+2*this.outputConnection.width;this.width-a<f&&(a=this.width-f,d=a/2,e=a/2);c.elements.unshift(new Blockly.blockRendering.InRowSpacer(this.constants_,
	-d));c.elements.push(new Blockly.blockRendering.InRowSpacer(this.constants_,-e))}if(a)for(this.width-=a,this.widthWithChildren-=a,this.rightSide.xPos-=a,b=0;c=this.rows[b];b++)Blockly.blockRendering.Types.isTopOrBottomRow(c)&&(c.elements[1].width-=a,c.elements[1].widthWithConnectedBlocks-=a),c.width-=a,c.widthWithConnectedBlocks-=a}};
	Blockly.zelos.RenderInfo.prototype.getNegativeSpacing_=function(a){if(!a)return 0;var b=this.outputConnection.width,c=this.outputConnection.shape.type,d=this.constants_;if(this.isMultiRow&&1<this.inputRows.length)switch(c){case d.SHAPES.ROUND:return c=this.constants_.MAX_DYNAMIC_CONNECTION_SHAPE_WIDTH,c=this.height/2>c?c:this.height/2,b-c*(1-Math.sin(Math.acos((c-this.constants_.SMALL_PADDING)/c)));default:return 0}if(Blockly.blockRendering.Types.isInlineInput(a)){var e=a.connectedBlock;a=e?e.pathObject.outputShapeType:
	a.shape.type;return e&&e.outputConnection&&(e.statementInputCount||e.nextConnection)||c==d.SHAPES.HEXAGONAL&&c!=a?0:b-this.constants_.SHAPE_IN_SHAPE_PADDING[c][a]}return Blockly.blockRendering.Types.isField(a)?c==d.SHAPES.ROUND&&a.field instanceof Blockly.FieldTextInput?b-2.75*d.GRID_UNIT:b-this.constants_.SHAPE_IN_SHAPE_PADDING[c][0]:Blockly.blockRendering.Types.isIcon(a)?this.constants_.SMALL_PADDING:0};
	Blockly.zelos.RenderInfo.prototype.finalizeVerticalAlignment_=function(){if(!this.outputConnection)for(var a=2;a<this.rows.length-1;a+=2){var b=this.rows[a-1],c=this.rows[a],d=this.rows[a+1],e=2==a,f=a+2>=this.rows.length-1?!!this.bottomRow.hasNextConnection:!!d.precedesStatement;if(e?this.topRow.hasPreviousConnection:b.followsStatement){var g=3==c.elements.length&&(c.elements[1].field instanceof Blockly.FieldLabel||c.elements[1].field instanceof Blockly.FieldImage);if(!e&&g)b.height-=this.constants_.SMALL_PADDING,
	d.height-=this.constants_.SMALL_PADDING,c.height-=this.constants_.MEDIUM_PADDING;else if(!e&&!f)b.height+=this.constants_.SMALL_PADDING;else if(f){e=!1;for(f=0;g=c.elements[f];f++)if(Blockly.blockRendering.Types.isInlineInput(g)&&g.connectedBlock&&!g.connectedBlock.isShadow()&&40<=g.connectedBlock.getHeightWidth().height){e=!0;break}e&&(b.height-=this.constants_.SMALL_PADDING,d.height-=this.constants_.SMALL_PADDING)}}}};
	Blockly.zelos.RenderInfo.prototype.finalize_=function(){this.finalizeOutputConnection_();this.finalizeHorizontalAlignment_();this.finalizeVerticalAlignment_();Blockly.zelos.RenderInfo.superClass_.finalize_.call(this);this.rightSide&&(this.widthWithChildren+=this.rightSide.width)};Blockly.zelos.Drawer=function(a,b){Blockly.zelos.Drawer.superClass_.constructor.call(this,a,b)};Blockly.utils.object.inherits(Blockly.zelos.Drawer,Blockly.blockRendering.Drawer);
	Blockly.zelos.Drawer.prototype.draw=function(){var a=this.block_.pathObject;a.beginDrawing();this.hideHiddenIcons_();this.drawOutline_();this.drawInternals_();a.setPath(this.outlinePath_+"\n"+this.inlinePath_);this.info_.RTL&&a.flipRTL();Blockly.blockRendering.useDebugger&&this.block_.renderingDebugger.drawDebug(this.block_,this.info_);this.recordSizeOnBlock_();this.info_.outputConnection&&(a.outputShapeType=this.info_.outputConnection.shape.type);a.endDrawing()};
	Blockly.zelos.Drawer.prototype.drawOutline_=function(){this.info_.outputConnection&&this.info_.outputConnection.isDynamicShape&&!this.info_.hasStatementInput&&!this.info_.bottomRow.hasNextConnection?(this.drawFlatTop_(),this.drawRightDynamicConnection_(),this.drawFlatBottom_(),this.drawLeftDynamicConnection_()):Blockly.zelos.Drawer.superClass_.drawOutline_.call(this)};
	Blockly.zelos.Drawer.prototype.drawLeft_=function(){this.info_.outputConnection&&this.info_.outputConnection.isDynamicShape?this.drawLeftDynamicConnection_():Blockly.zelos.Drawer.superClass_.drawLeft_.call(this)};
	Blockly.zelos.Drawer.prototype.drawRightSideRow_=function(a){if(!(0>=a.height))if(a.precedesStatement||a.followsStatement){var b=this.constants_.INSIDE_CORNERS.rightHeight;b=a.height-(a.precedesStatement?b:0);this.outlinePath_+=(a.followsStatement?this.constants_.INSIDE_CORNERS.pathBottomRight:"")+(0<b?Blockly.utils.svgPaths.lineOnAxis("V",a.yPos+b):"")+(a.precedesStatement?this.constants_.INSIDE_CORNERS.pathTopRight:"")}else this.outlinePath_+=Blockly.utils.svgPaths.lineOnAxis("V",a.yPos+a.height)};
	Blockly.zelos.Drawer.prototype.drawRightDynamicConnection_=function(){this.outlinePath_+=this.info_.outputConnection.shape.pathRightDown(this.info_.outputConnection.height)};Blockly.zelos.Drawer.prototype.drawLeftDynamicConnection_=function(){this.positionOutputConnection_();this.outlinePath_+=this.info_.outputConnection.shape.pathUp(this.info_.outputConnection.height);this.outlinePath_+="z"};
	Blockly.zelos.Drawer.prototype.drawFlatTop_=function(){var a=this.info_.topRow;this.positionPreviousConnection_();this.outlinePath_+=Blockly.utils.svgPaths.moveBy(a.xPos,this.info_.startY);this.outlinePath_+=Blockly.utils.svgPaths.lineOnAxis("h",a.width)};Blockly.zelos.Drawer.prototype.drawFlatBottom_=function(){var a=this.info_.bottomRow;this.positionNextConnection_();this.outlinePath_+=Blockly.utils.svgPaths.lineOnAxis("V",a.baseline);this.outlinePath_+=Blockly.utils.svgPaths.lineOnAxis("h",-a.width)};
	Blockly.zelos.Drawer.prototype.drawInlineInput_=function(a){this.positionInlineInputConnection_(a);var b=a.input.name;if(!a.connectedBlock&&!this.info_.isInsertionMarker){var c=a.width-2*a.connectionWidth;a=Blockly.utils.svgPaths.moveTo(a.xPos+a.connectionWidth,a.centerline-a.height/2)+Blockly.utils.svgPaths.lineOnAxis("h",c)+a.shape.pathRightDown(a.height)+Blockly.utils.svgPaths.lineOnAxis("h",-c)+a.shape.pathUp(a.height)+"z";this.block_.pathObject.setOutlinePath(b,a)}};
	Blockly.zelos.Drawer.prototype.drawStatementInput_=function(a){var b=a.getLastInput(),c=b.xPos+b.notchOffset+b.shape.width,d=b.shape.pathRight+Blockly.utils.svgPaths.lineOnAxis("h",-(b.notchOffset-this.constants_.INSIDE_CORNERS.width))+this.constants_.INSIDE_CORNERS.pathTop,e=a.height-2*this.constants_.INSIDE_CORNERS.height;b=this.constants_.INSIDE_CORNERS.pathBottom+Blockly.utils.svgPaths.lineOnAxis("h",b.notchOffset-this.constants_.INSIDE_CORNERS.width)+(b.connectedBottomNextConnection?"":b.shape.pathLeft);
	this.outlinePath_+=Blockly.utils.svgPaths.lineOnAxis("H",c)+d+Blockly.utils.svgPaths.lineOnAxis("v",e)+b+Blockly.utils.svgPaths.lineOnAxis("H",a.xPos+a.width);this.positionStatementInputConnection_(a)};Blockly.zelos.PathObject=function(a,b,c){Blockly.zelos.PathObject.superClass_.constructor.call(this,a,b,c);this.constants=c;this.svgPathSelected_=null;this.outlines_={};this.outputShapeType=this.remainingOutlines_=null};Blockly.utils.object.inherits(Blockly.zelos.PathObject,Blockly.blockRendering.PathObject);Blockly.zelos.PathObject.prototype.setPath=function(a){Blockly.zelos.PathObject.superClass_.setPath.call(this,a);this.svgPathSelected_&&this.svgPathSelected_.setAttribute("d",a)};
	Blockly.zelos.PathObject.prototype.applyColour=function(a){Blockly.zelos.PathObject.superClass_.applyColour.call(this,a);a.isShadow()&&a.getParent()&&this.svgPath.setAttribute("stroke",a.getParent().style.colourTertiary);a=0;for(var b=Object.keys(this.outlines_),c;c=b[a];a++)this.outlines_[c].setAttribute("fill",this.style.colourTertiary)};
	Blockly.zelos.PathObject.prototype.flipRTL=function(){Blockly.zelos.PathObject.superClass_.flipRTL.call(this);for(var a=0,b=Object.keys(this.outlines_),c;c=b[a];a++)this.outlines_[c].setAttribute("transform","scale(-1 1)")};
	Blockly.zelos.PathObject.prototype.updateSelected=function(a){this.setClass_("blocklySelected",a);a?this.svgPathSelected_||(this.svgPathSelected_=this.svgPath.cloneNode(!0),this.svgPathSelected_.setAttribute("fill","none"),this.svgPathSelected_.setAttribute("filter","url(#"+this.constants.selectedGlowFilterId+")"),this.svgRoot.appendChild(this.svgPathSelected_)):this.svgPathSelected_&&(this.svgRoot.removeChild(this.svgPathSelected_),this.svgPathSelected_=null)};
	Blockly.zelos.PathObject.prototype.updateReplacementFade=function(a){this.setClass_("blocklyReplaceable",a);a?this.svgPath.setAttribute("filter","url(#"+this.constants.replacementGlowFilterId+")"):this.svgPath.removeAttribute("filter")};Blockly.zelos.PathObject.prototype.updateShapeForInputHighlight=function(a,b){a=a.getParentInput().name;(a=this.getOutlinePath_(a))&&(b?a.setAttribute("filter","url(#"+this.constants.replacementGlowFilterId+")"):a.removeAttribute("filter"))};
	Blockly.zelos.PathObject.prototype.beginDrawing=function(){this.remainingOutlines_={};for(var a=0,b=Object.keys(this.outlines_),c;c=b[a];a++)this.remainingOutlines_[c]=1};Blockly.zelos.PathObject.prototype.endDrawing=function(){if(this.remainingOutlines_)for(var a=0,b=Object.keys(this.remainingOutlines_),c;c=b[a];a++)this.removeOutlinePath_(c);this.remainingOutlines_=null};
	Blockly.zelos.PathObject.prototype.setOutlinePath=function(a,b){a=this.getOutlinePath_(a);a.setAttribute("d",b);a.setAttribute("fill",this.style.colourTertiary)};Blockly.zelos.PathObject.prototype.getOutlinePath_=function(a){this.outlines_[a]||(this.outlines_[a]=Blockly.utils.dom.createSvgElement("path",{"class":"blocklyOutlinePath",d:""},this.svgRoot));this.remainingOutlines_&&delete this.remainingOutlines_[a];return this.outlines_[a]};
	Blockly.zelos.PathObject.prototype.removeOutlinePath_=function(a){this.outlines_[a].parentNode.removeChild(this.outlines_[a]);delete this.outlines_[a]};Blockly.zelos.MarkerSvg=function(a,b,c){Blockly.zelos.MarkerSvg.superClass_.constructor.call(this,a,b,c)};Blockly.utils.object.inherits(Blockly.zelos.MarkerSvg,Blockly.blockRendering.MarkerSvg);Blockly.zelos.MarkerSvg.prototype.showWithInputOutput_=function(a){var b=a.getSourceBlock();a=a.getLocation().getOffsetInBlock();this.positionCircle_(a.x,a.y);this.setParent_(b);this.showCurrent_()};Blockly.zelos.MarkerSvg.prototype.showWithOutput_=function(a){this.showWithInputOutput_(a)};
	Blockly.zelos.MarkerSvg.prototype.showWithInput_=function(a){this.showWithInputOutput_(a)};Blockly.zelos.MarkerSvg.prototype.showWithBlock_=function(a){a=a.getLocation();var b=a.getHeightWidth();this.positionRect_(0,0,b.width,b.height);this.setParent_(a);this.showCurrent_()};Blockly.zelos.MarkerSvg.prototype.positionCircle_=function(a,b){this.markerCircle_.setAttribute("cx",a);this.markerCircle_.setAttribute("cy",b);this.currentMarkerSvg=this.markerCircle_};
	Blockly.zelos.MarkerSvg.prototype.hide=function(){Blockly.zelos.MarkerSvg.superClass_.hide.call(this);this.markerCircle_.style.display="none"};
	Blockly.zelos.MarkerSvg.prototype.createDomInternal_=function(){Blockly.zelos.MarkerSvg.superClass_.createDomInternal_.call(this);this.markerCircle_=Blockly.utils.dom.createSvgElement("circle",{r:this.constants_.CURSOR_RADIUS,style:"display: none","stroke-width":this.constants_.CURSOR_STROKE_WIDTH},this.markerSvg_);if(this.isCursor()){var a=this.getBlinkProperties_();Blockly.utils.dom.createSvgElement("animate",a,this.markerCircle_)}return this.markerSvg_};
	Blockly.zelos.MarkerSvg.prototype.applyColour_=function(a){Blockly.zelos.MarkerSvg.superClass_.applyColour_.call(this,a);this.markerCircle_.setAttribute("fill",this.colour_);this.markerCircle_.setAttribute("stroke",this.colour_);this.isCursor()&&this.markerCircle_.firstChild.setAttribute("values",this.colour_+";transparent;transparent;")};Blockly.zelos.Renderer=function(a){Blockly.zelos.Renderer.superClass_.constructor.call(this,a)};Blockly.utils.object.inherits(Blockly.zelos.Renderer,Blockly.blockRendering.Renderer);Blockly.zelos.Renderer.prototype.makeConstants_=function(){return new Blockly.zelos.ConstantProvider};Blockly.zelos.Renderer.prototype.makeRenderInfo_=function(a){return new Blockly.zelos.RenderInfo(this,a)};Blockly.zelos.Renderer.prototype.makeDrawer_=function(a,b){return new Blockly.zelos.Drawer(a,b)};
	Blockly.zelos.Renderer.prototype.makeMarkerDrawer=function(a,b){return new Blockly.zelos.MarkerSvg(a,this.getConstants(),b)};Blockly.zelos.Renderer.prototype.makePathObject=function(a,b){return new Blockly.zelos.PathObject(a,b,this.getConstants())};Blockly.zelos.Renderer.prototype.shouldHighlightConnection=function(a){return a.type!=Blockly.INPUT_VALUE&&a.type!==Blockly.OUTPUT_VALUE};
	Blockly.zelos.Renderer.prototype.getConnectionPreviewMethod=function(a,b,c){return b.type==Blockly.OUTPUT_VALUE?a.isConnected()?Blockly.InsertionMarkerManager.PREVIEW_TYPE.REPLACEMENT_FADE:Blockly.InsertionMarkerManager.PREVIEW_TYPE.INPUT_OUTLINE:Blockly.zelos.Renderer.superClass_.getConnectionPreviewMethod(a,b,c)};Blockly.blockRendering.register("zelos",Blockly.zelos.Renderer);Blockly.Themes.Dark=Blockly.Theme.defineTheme("dark",{base:Blockly.Themes.Classic,componentStyles:{workspaceBackgroundColour:"#1e1e1e",toolboxBackgroundColour:"#333",toolboxForegroundColour:"#fff",flyoutBackgroundColour:"#252526",flyoutForegroundColour:"#ccc",flyoutOpacity:1,scrollbarColour:"#797979",insertionMarkerColour:"#fff",insertionMarkerOpacity:.3,scrollbarOpacity:.4,cursorColour:"#d0d0d0"}});Blockly.Themes.Deuteranopia={};
	Blockly.Themes.Deuteranopia.defaultBlockStyles={colour_blocks:{colourPrimary:"#f2a72c",colourSecondary:"#f1c172",colourTertiary:"#da921c"},list_blocks:{colourPrimary:"#7d65ab",colourSecondary:"#a88be0",colourTertiary:"#66518e"},logic_blocks:{colourPrimary:"#9fd2f1",colourSecondary:"#c0e0f4",colourTertiary:"#74bae5"},loop_blocks:{colourPrimary:"#795a07",colourSecondary:"#ac8726",colourTertiary:"#c4a03f"},math_blocks:{colourPrimary:"#e6da39",colourSecondary:"#f3ec8e",colourTertiary:"#f2eeb7"},procedure_blocks:{colourPrimary:"#590721",
	colourSecondary:"#8c475d",colourTertiary:"#885464"},text_blocks:{colourPrimary:"#058863",colourSecondary:"#5ecfaf",colourTertiary:"#04684c"},variable_blocks:{colourPrimary:"#47025a",colourSecondary:"#820fa1",colourTertiary:"#8e579d"},variable_dynamic_blocks:{colourPrimary:"#47025a",colourSecondary:"#820fa1",colourTertiary:"#8e579d"}};
	Blockly.Themes.Deuteranopia.categoryStyles={colour_category:{colour:"#f2a72c"},list_category:{colour:"#7d65ab"},logic_category:{colour:"#9fd2f1"},loop_category:{colour:"#795a07"},math_category:{colour:"#e6da39"},procedure_category:{colour:"#590721"},text_category:{colour:"#058863"},variable_category:{colour:"#47025a"},variable_dynamic_category:{colour:"#47025a"}};Blockly.Themes.Deuteranopia=new Blockly.Theme("deuteranopia",Blockly.Themes.Deuteranopia.defaultBlockStyles,Blockly.Themes.Deuteranopia.categoryStyles);Blockly.Themes.HighContrast={};
	Blockly.Themes.HighContrast.defaultBlockStyles={colour_blocks:{colourPrimary:"#a52714",colourSecondary:"#FB9B8C",colourTertiary:"#FBE1DD"},list_blocks:{colourPrimary:"#4a148c",colourSecondary:"#AD7BE9",colourTertiary:"#CDB6E9"},logic_blocks:{colourPrimary:"#01579b",colourSecondary:"#64C7FF",colourTertiary:"#C5EAFF"},loop_blocks:{colourPrimary:"#33691e",colourSecondary:"#9AFF78",colourTertiary:"#E1FFD7"},math_blocks:{colourPrimary:"#1a237e",colourSecondary:"#8A9EFF",colourTertiary:"#DCE2FF"},procedure_blocks:{colourPrimary:"#006064",
	colourSecondary:"#77E6EE",colourTertiary:"#CFECEE"},text_blocks:{colourPrimary:"#004d40",colourSecondary:"#5ae27c",colourTertiary:"#D2FFDD"},variable_blocks:{colourPrimary:"#880e4f",colourSecondary:"#FF73BE",colourTertiary:"#FFD4EB"},variable_dynamic_blocks:{colourPrimary:"#880e4f",colourSecondary:"#FF73BE",colourTertiary:"#FFD4EB"},hat_blocks:{colourPrimary:"#880e4f",colourSecondary:"#FF73BE",colourTertiary:"#FFD4EB",hat:"cap"}};
	Blockly.Themes.HighContrast.categoryStyles={colour_category:{colour:"#a52714"},list_category:{colour:"#4a148c"},logic_category:{colour:"#01579b"},loop_category:{colour:"#33691e"},math_category:{colour:"#1a237e"},procedure_category:{colour:"#006064"},text_category:{colour:"#004d40"},variable_category:{colour:"#880e4f"},variable_dynamic_category:{colour:"#880e4f"}};Blockly.Themes.HighContrast=new Blockly.Theme("highcontrast",Blockly.Themes.HighContrast.defaultBlockStyles,Blockly.Themes.HighContrast.categoryStyles);
	Blockly.Themes.HighContrast.setComponentStyle("selectedGlowColour","#000000");Blockly.Themes.HighContrast.setComponentStyle("selectedGlowSize",1);Blockly.Themes.HighContrast.setComponentStyle("replacementGlowColour","#000000");Blockly.Themes.HighContrast.setFontStyle({family:null,weight:null,size:16});Blockly.Themes.Tritanopia={};
	Blockly.Themes.Tritanopia.defaultBlockStyles={colour_blocks:{colourPrimary:"#05427f",colourSecondary:"#2974c0",colourTertiary:"#2d74bb"},list_blocks:{colourPrimary:"#b69ce8",colourSecondary:"#ccbaef",colourTertiary:"#9176c5"},logic_blocks:{colourPrimary:"#9fd2f1",colourSecondary:"#c0e0f4",colourTertiary:"#74bae5"},loop_blocks:{colourPrimary:"#aa1846",colourSecondary:"#d36185",colourTertiary:"#7c1636"},math_blocks:{colourPrimary:"#e6da39",colourSecondary:"#f3ec8e",colourTertiary:"#f2eeb7"},procedure_blocks:{colourPrimary:"#590721",
	colourSecondary:"#8c475d",colourTertiary:"#885464"},text_blocks:{colourPrimary:"#058863",colourSecondary:"#5ecfaf",colourTertiary:"#04684c"},variable_blocks:{colourPrimary:"#4b2d84",colourSecondary:"#816ea7",colourTertiary:"#83759e"},variable_dynamic_blocks:{colourPrimary:"#4b2d84",colourSecondary:"#816ea7",colourTertiary:"#83759e"}};
	Blockly.Themes.Tritanopia.categoryStyles={colour_category:{colour:"#05427f"},list_category:{colour:"#b69ce8"},logic_category:{colour:"#9fd2f1"},loop_category:{colour:"#aa1846"},math_category:{colour:"#e6da39"},procedure_category:{colour:"#590721"},text_category:{colour:"#058863"},variable_category:{colour:"#4b2d84"},variable_dynamic_category:{colour:"#4b2d84"}};Blockly.Themes.Tritanopia=new Blockly.Theme("tritanopia",Blockly.Themes.Tritanopia.defaultBlockStyles,Blockly.Themes.Tritanopia.categoryStyles);Blockly.requires={};
	return Blockly;
	}));
	
	
	//# sourceMappingURL=blockly_compressed.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* eslint-disable */
	;(function(root, factory) {
	  if (true) { // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(28)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') { // Node.js
	    module.exports = factory(require('../core'));
	  } else { // Browser
	    root.Blockly.Msg = factory(root.Blockly);
	  }
	}(this, function(Blockly) {
	
	      var Blockly = {};Blockly.Msg={};// This file was automatically generated.  Do not modify.
	
	'use strict';
	
	Blockly.Msg["ADD_COMMENT"] = "Add Comment";
	Blockly.Msg["CANNOT_DELETE_VARIABLE_PROCEDURE"] = "Can't delete the variable '%1' because it's part of the definition of the function '%2'";
	Blockly.Msg["CHANGE_VALUE_TITLE"] = "Change value:";
	Blockly.Msg["CLEAN_UP"] = "Clean up Blocks";
	Blockly.Msg["COLLAPSED_WARNINGS_WARNING"] = "Collapsed blocks contain warnings.";
	Blockly.Msg["COLLAPSE_ALL"] = "Collapse Blocks";
	Blockly.Msg["COLLAPSE_BLOCK"] = "Collapse Block";
	Blockly.Msg["COLOUR_BLEND_COLOUR1"] = "colour 1";
	Blockly.Msg["COLOUR_BLEND_COLOUR2"] = "colour 2";
	Blockly.Msg["COLOUR_BLEND_HELPURL"] = "https://meyerweb.com/eric/tools/color-blend/#:::rgbp";
	Blockly.Msg["COLOUR_BLEND_RATIO"] = "ratio";
	Blockly.Msg["COLOUR_BLEND_TITLE"] = "blend";
	Blockly.Msg["COLOUR_BLEND_TOOLTIP"] = "Blends two colours together with a given ratio (0.0 - 1.0).";
	Blockly.Msg["COLOUR_PICKER_HELPURL"] = "https://en.wikipedia.org/wiki/Color";
	Blockly.Msg["COLOUR_PICKER_TOOLTIP"] = "Choose a colour from the palette.";
	Blockly.Msg["COLOUR_RANDOM_HELPURL"] = "http://randomcolour.com";
	Blockly.Msg["COLOUR_RANDOM_TITLE"] = "random colour";
	Blockly.Msg["COLOUR_RANDOM_TOOLTIP"] = "Choose a colour at random.";
	Blockly.Msg["COLOUR_RGB_BLUE"] = "blue";
	Blockly.Msg["COLOUR_RGB_GREEN"] = "green";
	Blockly.Msg["COLOUR_RGB_HELPURL"] = "https://www.december.com/html/spec/colorpercompact.html";
	Blockly.Msg["COLOUR_RGB_RED"] = "red";
	Blockly.Msg["COLOUR_RGB_TITLE"] = "colour with";
	Blockly.Msg["COLOUR_RGB_TOOLTIP"] = "Create a colour with the specified amount of red, green, and blue. All values must be between 0 and 100.";
	Blockly.Msg["CONTROLS_FLOW_STATEMENTS_HELPURL"] = "https://github.com/google/blockly/wiki/Loops#loop-termination-blocks";
	Blockly.Msg["CONTROLS_FLOW_STATEMENTS_OPERATOR_BREAK"] = "break out of loop";
	Blockly.Msg["CONTROLS_FLOW_STATEMENTS_OPERATOR_CONTINUE"] = "continue with next iteration of loop";
	Blockly.Msg["CONTROLS_FLOW_STATEMENTS_TOOLTIP_BREAK"] = "Break out of the containing loop.";
	Blockly.Msg["CONTROLS_FLOW_STATEMENTS_TOOLTIP_CONTINUE"] = "Skip the rest of this loop, and continue with the next iteration.";
	Blockly.Msg["CONTROLS_FLOW_STATEMENTS_WARNING"] = "Warning: This block may only be used within a loop.";
	Blockly.Msg["CONTROLS_FOREACH_HELPURL"] = "https://github.com/google/blockly/wiki/Loops#for-each";
	Blockly.Msg["CONTROLS_FOREACH_TITLE"] = "for each item %1 in list %2";
	Blockly.Msg["CONTROLS_FOREACH_TOOLTIP"] = "For each item in a list, set the variable '%1' to the item, and then do some statements.";
	Blockly.Msg["CONTROLS_FOR_HELPURL"] = "https://github.com/google/blockly/wiki/Loops#count-with";
	Blockly.Msg["CONTROLS_FOR_TITLE"] = "count with %1 from %2 to %3 by %4";
	Blockly.Msg["CONTROLS_FOR_TOOLTIP"] = "Have the variable '%1' take on the values from the start number to the end number, counting by the specified interval, and do the specified blocks.";
	Blockly.Msg["CONTROLS_IF_ELSEIF_TOOLTIP"] = "Add a condition to the if block.";
	Blockly.Msg["CONTROLS_IF_ELSE_TOOLTIP"] = "Add a final, catch-all condition to the if block.";
	Blockly.Msg["CONTROLS_IF_HELPURL"] = "https://github.com/google/blockly/wiki/IfElse";
	Blockly.Msg["CONTROLS_IF_IF_TOOLTIP"] = "Add, remove, or reorder sections to reconfigure this if block.";
	Blockly.Msg["CONTROLS_IF_MSG_ELSE"] = "else";
	Blockly.Msg["CONTROLS_IF_MSG_ELSEIF"] = "else if";
	Blockly.Msg["CONTROLS_IF_MSG_IF"] = "if";
	Blockly.Msg["CONTROLS_IF_TOOLTIP_1"] = "If a value is true, then do some statements.";
	Blockly.Msg["CONTROLS_IF_TOOLTIP_2"] = "If a value is true, then do the first block of statements. Otherwise, do the second block of statements.";
	Blockly.Msg["CONTROLS_IF_TOOLTIP_3"] = "If the first value is true, then do the first block of statements. Otherwise, if the second value is true, do the second block of statements.";
	Blockly.Msg["CONTROLS_IF_TOOLTIP_4"] = "If the first value is true, then do the first block of statements. Otherwise, if the second value is true, do the second block of statements. If none of the values are true, do the last block of statements.";
	Blockly.Msg["CONTROLS_REPEAT_HELPURL"] = "https://en.wikipedia.org/wiki/For_loop";
	Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"] = "do";
	Blockly.Msg["CONTROLS_REPEAT_TITLE"] = "repeat %1 times";
	Blockly.Msg["CONTROLS_REPEAT_TOOLTIP"] = "Do some statements several times.";
	Blockly.Msg["CONTROLS_WHILEUNTIL_HELPURL"] = "https://github.com/google/blockly/wiki/Loops#repeat";
	Blockly.Msg["CONTROLS_WHILEUNTIL_OPERATOR_UNTIL"] = "repeat until";
	Blockly.Msg["CONTROLS_WHILEUNTIL_OPERATOR_WHILE"] = "repeat while";
	Blockly.Msg["CONTROLS_WHILEUNTIL_TOOLTIP_UNTIL"] = "While a value is false, then do some statements.";
	Blockly.Msg["CONTROLS_WHILEUNTIL_TOOLTIP_WHILE"] = "While a value is true, then do some statements.";
	Blockly.Msg["DELETE_ALL_BLOCKS"] = "Delete all %1 blocks?";
	Blockly.Msg["DELETE_BLOCK"] = "Delete Block";
	Blockly.Msg["DELETE_VARIABLE"] = "Delete the '%1' variable";
	Blockly.Msg["DELETE_VARIABLE_CONFIRMATION"] = "Delete %1 uses of the '%2' variable?";
	Blockly.Msg["DELETE_X_BLOCKS"] = "Delete %1 Blocks";
	Blockly.Msg["DISABLE_BLOCK"] = "Disable Block";
	Blockly.Msg["DUPLICATE_BLOCK"] = "Duplicate";
	Blockly.Msg["DUPLICATE_COMMENT"] = "Duplicate Comment";
	Blockly.Msg["ENABLE_BLOCK"] = "Enable Block";
	Blockly.Msg["EXPAND_ALL"] = "Expand Blocks";
	Blockly.Msg["EXPAND_BLOCK"] = "Expand Block";
	Blockly.Msg["EXTERNAL_INPUTS"] = "External Inputs";
	Blockly.Msg["HELP"] = "Help";
	Blockly.Msg["INLINE_INPUTS"] = "Inline Inputs";
	Blockly.Msg["IOS_CANCEL"] = "Cancel";
	Blockly.Msg["IOS_ERROR"] = "Error";
	Blockly.Msg["IOS_OK"] = "OK";
	Blockly.Msg["IOS_PROCEDURES_ADD_INPUT"] = "+ Add Input";
	Blockly.Msg["IOS_PROCEDURES_ALLOW_STATEMENTS"] = "Allow statements";
	Blockly.Msg["IOS_PROCEDURES_DUPLICATE_INPUTS_ERROR"] = "This function has duplicate inputs.";
	Blockly.Msg["IOS_PROCEDURES_INPUTS"] = "INPUTS";
	Blockly.Msg["IOS_VARIABLES_ADD_BUTTON"] = "Add";
	Blockly.Msg["IOS_VARIABLES_ADD_VARIABLE"] = "+ Add Variable";
	Blockly.Msg["IOS_VARIABLES_DELETE_BUTTON"] = "Delete";
	Blockly.Msg["IOS_VARIABLES_EMPTY_NAME_ERROR"] = "You can't use an empty variable name.";
	Blockly.Msg["IOS_VARIABLES_RENAME_BUTTON"] = "Rename";
	Blockly.Msg["IOS_VARIABLES_VARIABLE_NAME"] = "Variable name";
	Blockly.Msg["LISTS_CREATE_EMPTY_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#create-empty-list";
	Blockly.Msg["LISTS_CREATE_EMPTY_TITLE"] = "create empty list";
	Blockly.Msg["LISTS_CREATE_EMPTY_TOOLTIP"] = "Returns a list, of length 0, containing no data records";
	Blockly.Msg["LISTS_CREATE_WITH_CONTAINER_TITLE_ADD"] = "list";
	Blockly.Msg["LISTS_CREATE_WITH_CONTAINER_TOOLTIP"] = "Add, remove, or reorder sections to reconfigure this list block.";
	Blockly.Msg["LISTS_CREATE_WITH_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#create-list-with";
	Blockly.Msg["LISTS_CREATE_WITH_INPUT_WITH"] = "create list with";
	Blockly.Msg["LISTS_CREATE_WITH_ITEM_TOOLTIP"] = "Add an item to the list.";
	Blockly.Msg["LISTS_CREATE_WITH_TOOLTIP"] = "Create a list with any number of items.";
	Blockly.Msg["LISTS_GET_INDEX_FIRST"] = "first";
	Blockly.Msg["LISTS_GET_INDEX_FROM_END"] = "# from end";
	Blockly.Msg["LISTS_GET_INDEX_FROM_START"] = "#";
	Blockly.Msg["LISTS_GET_INDEX_GET"] = "get";
	Blockly.Msg["LISTS_GET_INDEX_GET_REMOVE"] = "get and remove";
	Blockly.Msg["LISTS_GET_INDEX_LAST"] = "last";
	Blockly.Msg["LISTS_GET_INDEX_RANDOM"] = "random";
	Blockly.Msg["LISTS_GET_INDEX_REMOVE"] = "remove";
	Blockly.Msg["LISTS_GET_INDEX_TAIL"] = "";
	Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_FIRST"] = "Returns the first item in a list.";
	Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_FROM"] = "Returns the item at the specified position in a list.";
	Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_LAST"] = "Returns the last item in a list.";
	Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_RANDOM"] = "Returns a random item in a list.";
	Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FIRST"] = "Removes and returns the first item in a list.";
	Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FROM"] = "Removes and returns the item at the specified position in a list.";
	Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_LAST"] = "Removes and returns the last item in a list.";
	Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_RANDOM"] = "Removes and returns a random item in a list.";
	Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_FIRST"] = "Removes the first item in a list.";
	Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_FROM"] = "Removes the item at the specified position in a list.";
	Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_LAST"] = "Removes the last item in a list.";
	Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_RANDOM"] = "Removes a random item in a list.";
	Blockly.Msg["LISTS_GET_SUBLIST_END_FROM_END"] = "to # from end";
	Blockly.Msg["LISTS_GET_SUBLIST_END_FROM_START"] = "to #";
	Blockly.Msg["LISTS_GET_SUBLIST_END_LAST"] = "to last";
	Blockly.Msg["LISTS_GET_SUBLIST_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#getting-a-sublist";
	Blockly.Msg["LISTS_GET_SUBLIST_START_FIRST"] = "get sub-list from first";
	Blockly.Msg["LISTS_GET_SUBLIST_START_FROM_END"] = "get sub-list from # from end";
	Blockly.Msg["LISTS_GET_SUBLIST_START_FROM_START"] = "get sub-list from #";
	Blockly.Msg["LISTS_GET_SUBLIST_TAIL"] = "";
	Blockly.Msg["LISTS_GET_SUBLIST_TOOLTIP"] = "Creates a copy of the specified portion of a list.";
	Blockly.Msg["LISTS_INDEX_FROM_END_TOOLTIP"] = "%1 is the last item.";
	Blockly.Msg["LISTS_INDEX_FROM_START_TOOLTIP"] = "%1 is the first item.";
	Blockly.Msg["LISTS_INDEX_OF_FIRST"] = "find first occurrence of item";
	Blockly.Msg["LISTS_INDEX_OF_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#getting-items-from-a-list";
	Blockly.Msg["LISTS_INDEX_OF_LAST"] = "find last occurrence of item";
	Blockly.Msg["LISTS_INDEX_OF_TOOLTIP"] = "Returns the index of the first/last occurrence of the item in the list. Returns %1 if item is not found.";
	Blockly.Msg["LISTS_INLIST"] = "in list";
	Blockly.Msg["LISTS_ISEMPTY_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#is-empty";
	Blockly.Msg["LISTS_ISEMPTY_TITLE"] = "%1 is empty";
	Blockly.Msg["LISTS_ISEMPTY_TOOLTIP"] = "Returns true if the list is empty.";
	Blockly.Msg["LISTS_LENGTH_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#length-of";
	Blockly.Msg["LISTS_LENGTH_TITLE"] = "length of %1";
	Blockly.Msg["LISTS_LENGTH_TOOLTIP"] = "Returns the length of a list.";
	Blockly.Msg["LISTS_REPEAT_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#create-list-with";
	Blockly.Msg["LISTS_REPEAT_TITLE"] = "create list with item %1 repeated %2 times";
	Blockly.Msg["LISTS_REPEAT_TOOLTIP"] = "Creates a list consisting of the given value repeated the specified number of times.";
	Blockly.Msg["LISTS_REVERSE_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#reversing-a-list";
	Blockly.Msg["LISTS_REVERSE_MESSAGE0"] = "reverse %1";
	Blockly.Msg["LISTS_REVERSE_TOOLTIP"] = "Reverse a copy of a list.";
	Blockly.Msg["LISTS_SET_INDEX_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#in-list--set";
	Blockly.Msg["LISTS_SET_INDEX_INPUT_TO"] = "as";
	Blockly.Msg["LISTS_SET_INDEX_INSERT"] = "insert at";
	Blockly.Msg["LISTS_SET_INDEX_SET"] = "set";
	Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_FIRST"] = "Inserts the item at the start of a list.";
	Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_FROM"] = "Inserts the item at the specified position in a list.";
	Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_LAST"] = "Append the item to the end of a list.";
	Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_RANDOM"] = "Inserts the item randomly in a list.";
	Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_FIRST"] = "Sets the first item in a list.";
	Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_FROM"] = "Sets the item at the specified position in a list.";
	Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_LAST"] = "Sets the last item in a list.";
	Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_RANDOM"] = "Sets a random item in a list.";
	Blockly.Msg["LISTS_SORT_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#sorting-a-list";
	Blockly.Msg["LISTS_SORT_ORDER_ASCENDING"] = "ascending";
	Blockly.Msg["LISTS_SORT_ORDER_DESCENDING"] = "descending";
	Blockly.Msg["LISTS_SORT_TITLE"] = "sort %1 %2 %3";
	Blockly.Msg["LISTS_SORT_TOOLTIP"] = "Sort a copy of a list.";
	Blockly.Msg["LISTS_SORT_TYPE_IGNORECASE"] = "alphabetic, ignore case";
	Blockly.Msg["LISTS_SORT_TYPE_NUMERIC"] = "numeric";
	Blockly.Msg["LISTS_SORT_TYPE_TEXT"] = "alphabetic";
	Blockly.Msg["LISTS_SPLIT_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#splitting-strings-and-joining-lists";
	Blockly.Msg["LISTS_SPLIT_LIST_FROM_TEXT"] = "make list from text";
	Blockly.Msg["LISTS_SPLIT_TEXT_FROM_LIST"] = "make text from list";
	Blockly.Msg["LISTS_SPLIT_TOOLTIP_JOIN"] = "Join a list of texts into one text, separated by a delimiter.";
	Blockly.Msg["LISTS_SPLIT_TOOLTIP_SPLIT"] = "Split text into a list of texts, breaking at each delimiter.";
	Blockly.Msg["LISTS_SPLIT_WITH_DELIMITER"] = "with delimiter";
	Blockly.Msg["LOGIC_BOOLEAN_FALSE"] = "false";
	Blockly.Msg["LOGIC_BOOLEAN_HELPURL"] = "https://github.com/google/blockly/wiki/Logic#values";
	Blockly.Msg["LOGIC_BOOLEAN_TOOLTIP"] = "Returns either true or false.";
	Blockly.Msg["LOGIC_BOOLEAN_TRUE"] = "true";
	Blockly.Msg["LOGIC_COMPARE_HELPURL"] = "https://en.wikipedia.org/wiki/Inequality_(mathematics)";
	Blockly.Msg["LOGIC_COMPARE_TOOLTIP_EQ"] = "Return true if both inputs equal each other.";
	Blockly.Msg["LOGIC_COMPARE_TOOLTIP_GT"] = "Return true if the first input is greater than the second input.";
	Blockly.Msg["LOGIC_COMPARE_TOOLTIP_GTE"] = "Return true if the first input is greater than or equal to the second input.";
	Blockly.Msg["LOGIC_COMPARE_TOOLTIP_LT"] = "Return true if the first input is smaller than the second input.";
	Blockly.Msg["LOGIC_COMPARE_TOOLTIP_LTE"] = "Return true if the first input is smaller than or equal to the second input.";
	Blockly.Msg["LOGIC_COMPARE_TOOLTIP_NEQ"] = "Return true if both inputs are not equal to each other.";
	Blockly.Msg["LOGIC_NEGATE_HELPURL"] = "https://github.com/google/blockly/wiki/Logic#not";
	Blockly.Msg["LOGIC_NEGATE_TITLE"] = "not %1";
	Blockly.Msg["LOGIC_NEGATE_TOOLTIP"] = "Returns true if the input is false. Returns false if the input is true.";
	Blockly.Msg["LOGIC_NULL"] = "null";
	Blockly.Msg["LOGIC_NULL_HELPURL"] = "https://en.wikipedia.org/wiki/Nullable_type";
	Blockly.Msg["LOGIC_NULL_TOOLTIP"] = "Returns null.";
	Blockly.Msg["LOGIC_OPERATION_AND"] = "and";
	Blockly.Msg["LOGIC_OPERATION_HELPURL"] = "https://github.com/google/blockly/wiki/Logic#logical-operations";
	Blockly.Msg["LOGIC_OPERATION_OR"] = "or";
	Blockly.Msg["LOGIC_OPERATION_TOOLTIP_AND"] = "Return true if both inputs are true.";
	Blockly.Msg["LOGIC_OPERATION_TOOLTIP_OR"] = "Return true if at least one of the inputs is true.";
	Blockly.Msg["LOGIC_TERNARY_CONDITION"] = "test";
	Blockly.Msg["LOGIC_TERNARY_HELPURL"] = "https://en.wikipedia.org/wiki/%3F:";
	Blockly.Msg["LOGIC_TERNARY_IF_FALSE"] = "if false";
	Blockly.Msg["LOGIC_TERNARY_IF_TRUE"] = "if true";
	Blockly.Msg["LOGIC_TERNARY_TOOLTIP"] = "Check the condition in 'test'. If the condition is true, returns the 'if true' value; otherwise returns the 'if false' value.";
	Blockly.Msg["MATH_ADDITION_SYMBOL"] = "+";
	Blockly.Msg["MATH_ARITHMETIC_HELPURL"] = "https://en.wikipedia.org/wiki/Arithmetic";
	Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_ADD"] = "Return the sum of the two numbers.";
	Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_DIVIDE"] = "Return the quotient of the two numbers.";
	Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_MINUS"] = "Return the difference of the two numbers.";
	Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_MULTIPLY"] = "Return the product of the two numbers.";
	Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_POWER"] = "Return the first number raised to the power of the second number.";
	Blockly.Msg["MATH_ATAN2_HELPURL"] = "https://en.wikipedia.org/wiki/Atan2";
	Blockly.Msg["MATH_ATAN2_TITLE"] = "atan2 of X:%1 Y:%2";
	Blockly.Msg["MATH_ATAN2_TOOLTIP"] = "Return the arctangent of point (X, Y) in degrees from -180 to 180.";
	Blockly.Msg["MATH_CHANGE_HELPURL"] = "https://en.wikipedia.org/wiki/Programming_idiom#Incrementing_a_counter";
	Blockly.Msg["MATH_CHANGE_TITLE"] = "change %1 by %2";
	Blockly.Msg["MATH_CHANGE_TOOLTIP"] = "Add a number to variable '%1'.";
	Blockly.Msg["MATH_CONSTANT_HELPURL"] = "https://en.wikipedia.org/wiki/Mathematical_constant";
	Blockly.Msg["MATH_CONSTANT_TOOLTIP"] = "Return one of the common constants: π (3.141…), e (2.718…), φ (1.618…), sqrt(2) (1.414…), sqrt(½) (0.707…), or ∞ (infinity).";
	Blockly.Msg["MATH_CONSTRAIN_HELPURL"] = "https://en.wikipedia.org/wiki/Clamping_(graphics)";
	Blockly.Msg["MATH_CONSTRAIN_TITLE"] = "constrain %1 low %2 high %3";
	Blockly.Msg["MATH_CONSTRAIN_TOOLTIP"] = "Constrain a number to be between the specified limits (inclusive).";
	Blockly.Msg["MATH_DIVISION_SYMBOL"] = "÷";
	Blockly.Msg["MATH_IS_DIVISIBLE_BY"] = "is divisible by";
	Blockly.Msg["MATH_IS_EVEN"] = "is even";
	Blockly.Msg["MATH_IS_NEGATIVE"] = "is negative";
	Blockly.Msg["MATH_IS_ODD"] = "is odd";
	Blockly.Msg["MATH_IS_POSITIVE"] = "is positive";
	Blockly.Msg["MATH_IS_PRIME"] = "is prime";
	Blockly.Msg["MATH_IS_TOOLTIP"] = "Check if a number is an even, odd, prime, whole, positive, negative, or if it is divisible by certain number. Returns true or false.";
	Blockly.Msg["MATH_IS_WHOLE"] = "is whole";
	Blockly.Msg["MATH_MODULO_HELPURL"] = "https://en.wikipedia.org/wiki/Modulo_operation";
	Blockly.Msg["MATH_MODULO_TITLE"] = "remainder of %1 ÷ %2";
	Blockly.Msg["MATH_MODULO_TOOLTIP"] = "Return the remainder from dividing the two numbers.";
	Blockly.Msg["MATH_MULTIPLICATION_SYMBOL"] = "×";
	Blockly.Msg["MATH_NUMBER_HELPURL"] = "https://en.wikipedia.org/wiki/Number";
	Blockly.Msg["MATH_NUMBER_TOOLTIP"] = "A number.";
	Blockly.Msg["MATH_ONLIST_HELPURL"] = "";
	Blockly.Msg["MATH_ONLIST_OPERATOR_AVERAGE"] = "average of list";
	Blockly.Msg["MATH_ONLIST_OPERATOR_MAX"] = "max of list";
	Blockly.Msg["MATH_ONLIST_OPERATOR_MEDIAN"] = "median of list";
	Blockly.Msg["MATH_ONLIST_OPERATOR_MIN"] = "min of list";
	Blockly.Msg["MATH_ONLIST_OPERATOR_MODE"] = "modes of list";
	Blockly.Msg["MATH_ONLIST_OPERATOR_RANDOM"] = "random item of list";
	Blockly.Msg["MATH_ONLIST_OPERATOR_STD_DEV"] = "standard deviation of list";
	Blockly.Msg["MATH_ONLIST_OPERATOR_SUM"] = "sum of list";
	Blockly.Msg["MATH_ONLIST_TOOLTIP_AVERAGE"] = "Return the average (arithmetic mean) of the numeric values in the list.";
	Blockly.Msg["MATH_ONLIST_TOOLTIP_MAX"] = "Return the largest number in the list.";
	Blockly.Msg["MATH_ONLIST_TOOLTIP_MEDIAN"] = "Return the median number in the list.";
	Blockly.Msg["MATH_ONLIST_TOOLTIP_MIN"] = "Return the smallest number in the list.";
	Blockly.Msg["MATH_ONLIST_TOOLTIP_MODE"] = "Return a list of the most common item(s) in the list.";
	Blockly.Msg["MATH_ONLIST_TOOLTIP_RANDOM"] = "Return a random element from the list.";
	Blockly.Msg["MATH_ONLIST_TOOLTIP_STD_DEV"] = "Return the standard deviation of the list.";
	Blockly.Msg["MATH_ONLIST_TOOLTIP_SUM"] = "Return the sum of all the numbers in the list.";
	Blockly.Msg["MATH_POWER_SYMBOL"] = "^";
	Blockly.Msg["MATH_RANDOM_FLOAT_HELPURL"] = "https://en.wikipedia.org/wiki/Random_number_generation";
	Blockly.Msg["MATH_RANDOM_FLOAT_TITLE_RANDOM"] = "random fraction";
	Blockly.Msg["MATH_RANDOM_FLOAT_TOOLTIP"] = "Return a random fraction between 0.0 (inclusive) and 1.0 (exclusive).";
	Blockly.Msg["MATH_RANDOM_INT_HELPURL"] = "https://en.wikipedia.org/wiki/Random_number_generation";
	Blockly.Msg["MATH_RANDOM_INT_TITLE"] = "random integer from %1 to %2";
	Blockly.Msg["MATH_RANDOM_INT_TOOLTIP"] = "Return a random integer between the two specified limits, inclusive.";
	Blockly.Msg["MATH_ROUND_HELPURL"] = "https://en.wikipedia.org/wiki/Rounding";
	Blockly.Msg["MATH_ROUND_OPERATOR_ROUND"] = "round";
	Blockly.Msg["MATH_ROUND_OPERATOR_ROUNDDOWN"] = "round down";
	Blockly.Msg["MATH_ROUND_OPERATOR_ROUNDUP"] = "round up";
	Blockly.Msg["MATH_ROUND_TOOLTIP"] = "Round a number up or down.";
	Blockly.Msg["MATH_SINGLE_HELPURL"] = "https://en.wikipedia.org/wiki/Square_root";
	Blockly.Msg["MATH_SINGLE_OP_ABSOLUTE"] = "absolute";
	Blockly.Msg["MATH_SINGLE_OP_ROOT"] = "square root";
	Blockly.Msg["MATH_SINGLE_TOOLTIP_ABS"] = "Return the absolute value of a number.";
	Blockly.Msg["MATH_SINGLE_TOOLTIP_EXP"] = "Return e to the power of a number.";
	Blockly.Msg["MATH_SINGLE_TOOLTIP_LN"] = "Return the natural logarithm of a number.";
	Blockly.Msg["MATH_SINGLE_TOOLTIP_LOG10"] = "Return the base 10 logarithm of a number.";
	Blockly.Msg["MATH_SINGLE_TOOLTIP_NEG"] = "Return the negation of a number.";
	Blockly.Msg["MATH_SINGLE_TOOLTIP_POW10"] = "Return 10 to the power of a number.";
	Blockly.Msg["MATH_SINGLE_TOOLTIP_ROOT"] = "Return the square root of a number.";
	Blockly.Msg["MATH_SUBTRACTION_SYMBOL"] = "-";
	Blockly.Msg["MATH_TRIG_ACOS"] = "acos";
	Blockly.Msg["MATH_TRIG_ASIN"] = "asin";
	Blockly.Msg["MATH_TRIG_ATAN"] = "atan";
	Blockly.Msg["MATH_TRIG_COS"] = "cos";
	Blockly.Msg["MATH_TRIG_HELPURL"] = "https://en.wikipedia.org/wiki/Trigonometric_functions";
	Blockly.Msg["MATH_TRIG_SIN"] = "sin";
	Blockly.Msg["MATH_TRIG_TAN"] = "tan";
	Blockly.Msg["MATH_TRIG_TOOLTIP_ACOS"] = "Return the arccosine of a number.";
	Blockly.Msg["MATH_TRIG_TOOLTIP_ASIN"] = "Return the arcsine of a number.";
	Blockly.Msg["MATH_TRIG_TOOLTIP_ATAN"] = "Return the arctangent of a number.";
	Blockly.Msg["MATH_TRIG_TOOLTIP_COS"] = "Return the cosine of a degree (not radian).";
	Blockly.Msg["MATH_TRIG_TOOLTIP_SIN"] = "Return the sine of a degree (not radian).";
	Blockly.Msg["MATH_TRIG_TOOLTIP_TAN"] = "Return the tangent of a degree (not radian).";
	Blockly.Msg["NEW_COLOUR_VARIABLE"] = "Create colour variable...";
	Blockly.Msg["NEW_NUMBER_VARIABLE"] = "Create number variable...";
	Blockly.Msg["NEW_STRING_VARIABLE"] = "Create string variable...";
	Blockly.Msg["NEW_VARIABLE"] = "Create variable...";
	Blockly.Msg["NEW_VARIABLE_TITLE"] = "New variable name:";
	Blockly.Msg["NEW_VARIABLE_TYPE_TITLE"] = "New variable type:";
	Blockly.Msg["ORDINAL_NUMBER_SUFFIX"] = "";
	Blockly.Msg["PROCEDURES_ALLOW_STATEMENTS"] = "allow statements";
	Blockly.Msg["PROCEDURES_BEFORE_PARAMS"] = "with:";
	Blockly.Msg["PROCEDURES_CALLNORETURN_HELPURL"] = "https://en.wikipedia.org/wiki/Subroutine";
	Blockly.Msg["PROCEDURES_CALLNORETURN_TOOLTIP"] = "Run the user-defined function '%1'.";
	Blockly.Msg["PROCEDURES_CALLRETURN_HELPURL"] = "https://en.wikipedia.org/wiki/Subroutine";
	Blockly.Msg["PROCEDURES_CALLRETURN_TOOLTIP"] = "Run the user-defined function '%1' and use its output.";
	Blockly.Msg["PROCEDURES_CALL_BEFORE_PARAMS"] = "with:";
	Blockly.Msg["PROCEDURES_CREATE_DO"] = "Create '%1'";
	Blockly.Msg["PROCEDURES_DEFNORETURN_COMMENT"] = "Describe this function...";
	Blockly.Msg["PROCEDURES_DEFNORETURN_DO"] = "";
	Blockly.Msg["PROCEDURES_DEFNORETURN_HELPURL"] = "https://en.wikipedia.org/wiki/Subroutine";
	Blockly.Msg["PROCEDURES_DEFNORETURN_PROCEDURE"] = "do something";
	Blockly.Msg["PROCEDURES_DEFNORETURN_TITLE"] = "to";
	Blockly.Msg["PROCEDURES_DEFNORETURN_TOOLTIP"] = "Creates a function with no output.";
	Blockly.Msg["PROCEDURES_DEFRETURN_HELPURL"] = "https://en.wikipedia.org/wiki/Subroutine";
	Blockly.Msg["PROCEDURES_DEFRETURN_RETURN"] = "return";
	Blockly.Msg["PROCEDURES_DEFRETURN_TOOLTIP"] = "Creates a function with an output.";
	Blockly.Msg["PROCEDURES_DEF_DUPLICATE_WARNING"] = "Warning: This function has duplicate parameters.";
	Blockly.Msg["PROCEDURES_HIGHLIGHT_DEF"] = "Highlight function definition";
	Blockly.Msg["PROCEDURES_IFRETURN_HELPURL"] = "http://c2.com/cgi/wiki?GuardClause";
	Blockly.Msg["PROCEDURES_IFRETURN_TOOLTIP"] = "If a value is true, then return a second value.";
	Blockly.Msg["PROCEDURES_IFRETURN_WARNING"] = "Warning: This block may be used only within a function definition.";
	Blockly.Msg["PROCEDURES_MUTATORARG_TITLE"] = "input name:";
	Blockly.Msg["PROCEDURES_MUTATORARG_TOOLTIP"] = "Add an input to the function.";
	Blockly.Msg["PROCEDURES_MUTATORCONTAINER_TITLE"] = "inputs";
	Blockly.Msg["PROCEDURES_MUTATORCONTAINER_TOOLTIP"] = "Add, remove, or reorder inputs to this function.";
	Blockly.Msg["REDO"] = "Redo";
	Blockly.Msg["REMOVE_COMMENT"] = "Remove Comment";
	Blockly.Msg["RENAME_VARIABLE"] = "Rename variable...";
	Blockly.Msg["RENAME_VARIABLE_TITLE"] = "Rename all '%1' variables to:";
	Blockly.Msg["TEXT_APPEND_HELPURL"] = "https://github.com/google/blockly/wiki/Text#text-modification";
	Blockly.Msg["TEXT_APPEND_TITLE"] = "to %1 append text %2";
	Blockly.Msg["TEXT_APPEND_TOOLTIP"] = "Append some text to variable '%1'.";
	Blockly.Msg["TEXT_CHANGECASE_HELPURL"] = "https://github.com/google/blockly/wiki/Text#adjusting-text-case";
	Blockly.Msg["TEXT_CHANGECASE_OPERATOR_LOWERCASE"] = "to lower case";
	Blockly.Msg["TEXT_CHANGECASE_OPERATOR_TITLECASE"] = "to Title Case";
	Blockly.Msg["TEXT_CHANGECASE_OPERATOR_UPPERCASE"] = "to UPPER CASE";
	Blockly.Msg["TEXT_CHANGECASE_TOOLTIP"] = "Return a copy of the text in a different case.";
	Blockly.Msg["TEXT_CHARAT_FIRST"] = "get first letter";
	Blockly.Msg["TEXT_CHARAT_FROM_END"] = "get letter # from end";
	Blockly.Msg["TEXT_CHARAT_FROM_START"] = "get letter #";
	Blockly.Msg["TEXT_CHARAT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#extracting-text";
	Blockly.Msg["TEXT_CHARAT_LAST"] = "get last letter";
	Blockly.Msg["TEXT_CHARAT_RANDOM"] = "get random letter";
	Blockly.Msg["TEXT_CHARAT_TAIL"] = "";
	Blockly.Msg["TEXT_CHARAT_TITLE"] = "in text %1 %2";
	Blockly.Msg["TEXT_CHARAT_TOOLTIP"] = "Returns the letter at the specified position.";
	Blockly.Msg["TEXT_COUNT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#counting-substrings";
	Blockly.Msg["TEXT_COUNT_MESSAGE0"] = "count %1 in %2";
	Blockly.Msg["TEXT_COUNT_TOOLTIP"] = "Count how many times some text occurs within some other text.";
	Blockly.Msg["TEXT_CREATE_JOIN_ITEM_TOOLTIP"] = "Add an item to the text.";
	Blockly.Msg["TEXT_CREATE_JOIN_TITLE_JOIN"] = "join";
	Blockly.Msg["TEXT_CREATE_JOIN_TOOLTIP"] = "Add, remove, or reorder sections to reconfigure this text block.";
	Blockly.Msg["TEXT_GET_SUBSTRING_END_FROM_END"] = "to letter # from end";
	Blockly.Msg["TEXT_GET_SUBSTRING_END_FROM_START"] = "to letter #";
	Blockly.Msg["TEXT_GET_SUBSTRING_END_LAST"] = "to last letter";
	Blockly.Msg["TEXT_GET_SUBSTRING_HELPURL"] = "https://github.com/google/blockly/wiki/Text#extracting-a-region-of-text";
	Blockly.Msg["TEXT_GET_SUBSTRING_INPUT_IN_TEXT"] = "in text";
	Blockly.Msg["TEXT_GET_SUBSTRING_START_FIRST"] = "get substring from first letter";
	Blockly.Msg["TEXT_GET_SUBSTRING_START_FROM_END"] = "get substring from letter # from end";
	Blockly.Msg["TEXT_GET_SUBSTRING_START_FROM_START"] = "get substring from letter #";
	Blockly.Msg["TEXT_GET_SUBSTRING_TAIL"] = "";
	Blockly.Msg["TEXT_GET_SUBSTRING_TOOLTIP"] = "Returns a specified portion of the text.";
	Blockly.Msg["TEXT_INDEXOF_HELPURL"] = "https://github.com/google/blockly/wiki/Text#finding-text";
	Blockly.Msg["TEXT_INDEXOF_OPERATOR_FIRST"] = "find first occurrence of text";
	Blockly.Msg["TEXT_INDEXOF_OPERATOR_LAST"] = "find last occurrence of text";
	Blockly.Msg["TEXT_INDEXOF_TITLE"] = "in text %1 %2 %3";
	Blockly.Msg["TEXT_INDEXOF_TOOLTIP"] = "Returns the index of the first/last occurrence of the first text in the second text. Returns %1 if text is not found.";
	Blockly.Msg["TEXT_ISEMPTY_HELPURL"] = "https://github.com/google/blockly/wiki/Text#checking-for-empty-text";
	Blockly.Msg["TEXT_ISEMPTY_TITLE"] = "%1 is empty";
	Blockly.Msg["TEXT_ISEMPTY_TOOLTIP"] = "Returns true if the provided text is empty.";
	Blockly.Msg["TEXT_JOIN_HELPURL"] = "https://github.com/google/blockly/wiki/Text#text-creation";
	Blockly.Msg["TEXT_JOIN_TITLE_CREATEWITH"] = "create text with";
	Blockly.Msg["TEXT_JOIN_TOOLTIP"] = "Create a piece of text by joining together any number of items.";
	Blockly.Msg["TEXT_LENGTH_HELPURL"] = "https://github.com/google/blockly/wiki/Text#text-modification";
	Blockly.Msg["TEXT_LENGTH_TITLE"] = "length of %1";
	Blockly.Msg["TEXT_LENGTH_TOOLTIP"] = "Returns the number of letters (including spaces) in the provided text.";
	Blockly.Msg["TEXT_PRINT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#printing-text";
	Blockly.Msg["TEXT_PRINT_TITLE"] = "print %1";
	Blockly.Msg["TEXT_PRINT_TOOLTIP"] = "Print the specified text, number or other value.";
	Blockly.Msg["TEXT_PROMPT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#getting-input-from-the-user";
	Blockly.Msg["TEXT_PROMPT_TOOLTIP_NUMBER"] = "Prompt for user for a number.";
	Blockly.Msg["TEXT_PROMPT_TOOLTIP_TEXT"] = "Prompt for user for some text.";
	Blockly.Msg["TEXT_PROMPT_TYPE_NUMBER"] = "prompt for number with message";
	Blockly.Msg["TEXT_PROMPT_TYPE_TEXT"] = "prompt for text with message";
	Blockly.Msg["TEXT_REPLACE_HELPURL"] = "https://github.com/google/blockly/wiki/Text#replacing-substrings";
	Blockly.Msg["TEXT_REPLACE_MESSAGE0"] = "replace %1 with %2 in %3";
	Blockly.Msg["TEXT_REPLACE_TOOLTIP"] = "Replace all occurances of some text within some other text.";
	Blockly.Msg["TEXT_REVERSE_HELPURL"] = "https://github.com/google/blockly/wiki/Text#reversing-text";
	Blockly.Msg["TEXT_REVERSE_MESSAGE0"] = "reverse %1";
	Blockly.Msg["TEXT_REVERSE_TOOLTIP"] = "Reverses the order of the characters in the text.";
	Blockly.Msg["TEXT_TEXT_HELPURL"] = "https://en.wikipedia.org/wiki/String_(computer_science)";
	Blockly.Msg["TEXT_TEXT_TOOLTIP"] = "A letter, word, or line of text.";
	Blockly.Msg["TEXT_TRIM_HELPURL"] = "https://github.com/google/blockly/wiki/Text#trimming-removing-spaces";
	Blockly.Msg["TEXT_TRIM_OPERATOR_BOTH"] = "trim spaces from both sides of";
	Blockly.Msg["TEXT_TRIM_OPERATOR_LEFT"] = "trim spaces from left side of";
	Blockly.Msg["TEXT_TRIM_OPERATOR_RIGHT"] = "trim spaces from right side of";
	Blockly.Msg["TEXT_TRIM_TOOLTIP"] = "Return a copy of the text with spaces removed from one or both ends.";
	Blockly.Msg["TODAY"] = "Today";
	Blockly.Msg["UNDO"] = "Undo";
	Blockly.Msg["UNNAMED_KEY"] = "unnamed";
	Blockly.Msg["VARIABLES_DEFAULT_NAME"] = "item";
	Blockly.Msg["VARIABLES_GET_CREATE_SET"] = "Create 'set %1'";
	Blockly.Msg["VARIABLES_GET_HELPURL"] = "https://github.com/google/blockly/wiki/Variables#get";
	Blockly.Msg["VARIABLES_GET_TOOLTIP"] = "Returns the value of this variable.";
	Blockly.Msg["VARIABLES_SET"] = "set %1 to %2";
	Blockly.Msg["VARIABLES_SET_CREATE_GET"] = "Create 'get %1'";
	Blockly.Msg["VARIABLES_SET_HELPURL"] = "https://github.com/google/blockly/wiki/Variables#set";
	Blockly.Msg["VARIABLES_SET_TOOLTIP"] = "Sets this variable to be equal to the input.";
	Blockly.Msg["VARIABLE_ALREADY_EXISTS"] = "A variable named '%1' already exists.";
	Blockly.Msg["VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE"] = "A variable named '%1' already exists for another type: '%2'.";
	Blockly.Msg["WORKSPACE_ARIA_LABEL"] = "Blockly Workspace";
	Blockly.Msg["WORKSPACE_COMMENT_DEFAULT_TEXT"] = "Say something...";
	Blockly.Msg["CONTROLS_FOREACH_INPUT_DO"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
	Blockly.Msg["CONTROLS_FOR_INPUT_DO"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
	Blockly.Msg["CONTROLS_IF_ELSEIF_TITLE_ELSEIF"] = Blockly.Msg["CONTROLS_IF_MSG_ELSEIF"];
	Blockly.Msg["CONTROLS_IF_ELSE_TITLE_ELSE"] = Blockly.Msg["CONTROLS_IF_MSG_ELSE"];
	Blockly.Msg["CONTROLS_IF_IF_TITLE_IF"] = Blockly.Msg["CONTROLS_IF_MSG_IF"];
	Blockly.Msg["CONTROLS_IF_MSG_THEN"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
	Blockly.Msg["CONTROLS_WHILEUNTIL_INPUT_DO"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
	Blockly.Msg["LISTS_CREATE_WITH_ITEM_TITLE"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];
	Blockly.Msg["LISTS_GET_INDEX_HELPURL"] = Blockly.Msg["LISTS_INDEX_OF_HELPURL"];
	Blockly.Msg["LISTS_GET_INDEX_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
	Blockly.Msg["LISTS_GET_SUBLIST_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
	Blockly.Msg["LISTS_INDEX_OF_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
	Blockly.Msg["LISTS_SET_INDEX_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
	Blockly.Msg["MATH_CHANGE_TITLE_ITEM"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];
	Blockly.Msg["PROCEDURES_DEFRETURN_COMMENT"] = Blockly.Msg["PROCEDURES_DEFNORETURN_COMMENT"];
	Blockly.Msg["PROCEDURES_DEFRETURN_DO"] = Blockly.Msg["PROCEDURES_DEFNORETURN_DO"];
	Blockly.Msg["PROCEDURES_DEFRETURN_PROCEDURE"] = Blockly.Msg["PROCEDURES_DEFNORETURN_PROCEDURE"];
	Blockly.Msg["PROCEDURES_DEFRETURN_TITLE"] = Blockly.Msg["PROCEDURES_DEFNORETURN_TITLE"];
	Blockly.Msg["TEXT_APPEND_VARIABLE"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];
	Blockly.Msg["TEXT_CREATE_JOIN_ITEM_TITLE_ITEM"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];
	
	Blockly.Msg["MATH_HUE"] = "230";
	Blockly.Msg["LOOPS_HUE"] = "120";
	Blockly.Msg["LISTS_HUE"] = "260";
	Blockly.Msg["LOGIC_HUE"] = "210";
	Blockly.Msg["VARIABLES_HUE"] = "330";
	Blockly.Msg["TEXTS_HUE"] = "160";
	Blockly.Msg["PROCEDURES_HUE"] = "290";
	Blockly.Msg["COLOUR_HUE"] = "20";
	Blockly.Msg["VARIABLES_DYNAMIC_HUE"] = "310";
	return Blockly.Msg;
	})); 


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* eslint-disable */
	;(function(root, factory) {
	  if (true) { // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(33)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') { // Node.js
	    module.exports = factory(require('./blocks_compressed'));
	  } else { // Browser
	    root.Blockly.Blocks = factory(root.Blockly);
	  }
	}(this, function(Blockly) {
	/**
	 * @license
	 * Copyright 2020 Google LLC
	 * SPDX-License-Identifier: Apache-2.0
	 */
	
	/**
	 * @fileoverview Blockly Blocks module.
	 */
	
	/* eslint-disable */
	'use strict';
	
	Blockly.Blocks = {};
	
	return Blockly.Blocks;
	})); 


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Do not edit this file; automatically generated by gulp.
	
	/* eslint-disable */
	;(function(root, factory) {
	  if (true) { // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') { // Node.js
	    module.exports = factory(require('./blockly_compressed.js'));
	  } else { // Browser
	    root.Blockly.Blocks = factory(root.Blockly);
	  }
	}(this, function(Blockly) {
	  'use strict';Blockly.Blocks.colour={};Blockly.Constants={};Blockly.Constants.Colour={};Blockly.Constants.Colour.HUE=20;
	Blockly.defineBlocksWithJsonArray([{type:"colour_picker",message0:"%1",args0:[{type:"field_colour",name:"COLOUR",colour:"#ff0000"}],output:"Colour",helpUrl:"%{BKY_COLOUR_PICKER_HELPURL}",style:"colour_blocks",tooltip:"%{BKY_COLOUR_PICKER_TOOLTIP}",extensions:["parent_tooltip_when_inline"]},{type:"colour_random",message0:"%{BKY_COLOUR_RANDOM_TITLE}",output:"Colour",helpUrl:"%{BKY_COLOUR_RANDOM_HELPURL}",style:"colour_blocks",tooltip:"%{BKY_COLOUR_RANDOM_TOOLTIP}"},{type:"colour_rgb",message0:"%{BKY_COLOUR_RGB_TITLE} %{BKY_COLOUR_RGB_RED} %1 %{BKY_COLOUR_RGB_GREEN} %2 %{BKY_COLOUR_RGB_BLUE} %3",
	args0:[{type:"input_value",name:"RED",check:"Number",align:"RIGHT"},{type:"input_value",name:"GREEN",check:"Number",align:"RIGHT"},{type:"input_value",name:"BLUE",check:"Number",align:"RIGHT"}],output:"Colour",helpUrl:"%{BKY_COLOUR_RGB_HELPURL}",style:"colour_blocks",tooltip:"%{BKY_COLOUR_RGB_TOOLTIP}"},{type:"colour_blend",message0:"%{BKY_COLOUR_BLEND_TITLE} %{BKY_COLOUR_BLEND_COLOUR1} %1 %{BKY_COLOUR_BLEND_COLOUR2} %2 %{BKY_COLOUR_BLEND_RATIO} %3",args0:[{type:"input_value",name:"COLOUR1",check:"Colour",
	align:"RIGHT"},{type:"input_value",name:"COLOUR2",check:"Colour",align:"RIGHT"},{type:"input_value",name:"RATIO",check:"Number",align:"RIGHT"}],output:"Colour",helpUrl:"%{BKY_COLOUR_BLEND_HELPURL}",style:"colour_blocks",tooltip:"%{BKY_COLOUR_BLEND_TOOLTIP}"}]);Blockly.Blocks.lists={};Blockly.Constants.Lists={};Blockly.Constants.Lists.HUE=260;
	Blockly.defineBlocksWithJsonArray([{type:"lists_create_empty",message0:"%{BKY_LISTS_CREATE_EMPTY_TITLE}",output:"Array",style:"list_blocks",tooltip:"%{BKY_LISTS_CREATE_EMPTY_TOOLTIP}",helpUrl:"%{BKY_LISTS_CREATE_EMPTY_HELPURL}"},{type:"lists_repeat",message0:"%{BKY_LISTS_REPEAT_TITLE}",args0:[{type:"input_value",name:"ITEM"},{type:"input_value",name:"NUM",check:"Number"}],output:"Array",style:"list_blocks",tooltip:"%{BKY_LISTS_REPEAT_TOOLTIP}",helpUrl:"%{BKY_LISTS_REPEAT_HELPURL}"},{type:"lists_reverse",
	message0:"%{BKY_LISTS_REVERSE_MESSAGE0}",args0:[{type:"input_value",name:"LIST",check:"Array"}],output:"Array",inputsInline:!0,style:"list_blocks",tooltip:"%{BKY_LISTS_REVERSE_TOOLTIP}",helpUrl:"%{BKY_LISTS_REVERSE_HELPURL}"},{type:"lists_isEmpty",message0:"%{BKY_LISTS_ISEMPTY_TITLE}",args0:[{type:"input_value",name:"VALUE",check:["String","Array"]}],output:"Boolean",style:"list_blocks",tooltip:"%{BKY_LISTS_ISEMPTY_TOOLTIP}",helpUrl:"%{BKY_LISTS_ISEMPTY_HELPURL}"},{type:"lists_length",message0:"%{BKY_LISTS_LENGTH_TITLE}",
	args0:[{type:"input_value",name:"VALUE",check:["String","Array"]}],output:"Number",style:"list_blocks",tooltip:"%{BKY_LISTS_LENGTH_TOOLTIP}",helpUrl:"%{BKY_LISTS_LENGTH_HELPURL}"}]);
	Blockly.Blocks.lists_create_with={init:function(){this.setHelpUrl(Blockly.Msg.LISTS_CREATE_WITH_HELPURL);this.setStyle("list_blocks");this.itemCount_=3;this.updateShape_();this.setOutput(!0,"Array");this.setMutator(new Blockly.Mutator(["lists_create_with_item"]));this.setTooltip(Blockly.Msg.LISTS_CREATE_WITH_TOOLTIP)},mutationToDom:function(){var a=Blockly.utils.xml.createElement("mutation");a.setAttribute("items",this.itemCount_);return a},domToMutation:function(a){this.itemCount_=parseInt(a.getAttribute("items"),
	10);this.updateShape_()},decompose:function(a){var b=a.newBlock("lists_create_with_container");b.initSvg();for(var c=b.getInput("STACK").connection,d=0;d<this.itemCount_;d++){var e=a.newBlock("lists_create_with_item");e.initSvg();c.connect(e.previousConnection);c=e.nextConnection}return b},compose:function(a){var b=a.getInputTargetBlock("STACK");for(a=[];b;)a.push(b.valueConnection_),b=b.nextConnection&&b.nextConnection.targetBlock();for(b=0;b<this.itemCount_;b++){var c=this.getInput("ADD"+b).connection.targetConnection;
	c&&-1==a.indexOf(c)&&c.disconnect()}this.itemCount_=a.length;this.updateShape_();for(b=0;b<this.itemCount_;b++)Blockly.Mutator.reconnect(a[b],this,"ADD"+b)},saveConnections:function(a){a=a.getInputTargetBlock("STACK");for(var b=0;a;){var c=this.getInput("ADD"+b);a.valueConnection_=c&&c.connection.targetConnection;b++;a=a.nextConnection&&a.nextConnection.targetBlock()}},updateShape_:function(){this.itemCount_&&this.getInput("EMPTY")?this.removeInput("EMPTY"):this.itemCount_||this.getInput("EMPTY")||
	this.appendDummyInput("EMPTY").appendField(Blockly.Msg.LISTS_CREATE_EMPTY_TITLE);for(var a=0;a<this.itemCount_;a++)if(!this.getInput("ADD"+a)){var b=this.appendValueInput("ADD"+a).setAlign(Blockly.ALIGN_RIGHT);0==a&&b.appendField(Blockly.Msg.LISTS_CREATE_WITH_INPUT_WITH)}for(;this.getInput("ADD"+a);)this.removeInput("ADD"+a),a++}};
	Blockly.Blocks.lists_create_with_container={init:function(){this.setStyle("list_blocks");this.appendDummyInput().appendField(Blockly.Msg.LISTS_CREATE_WITH_CONTAINER_TITLE_ADD);this.appendStatementInput("STACK");this.setTooltip(Blockly.Msg.LISTS_CREATE_WITH_CONTAINER_TOOLTIP);this.contextMenu=!1}};
	Blockly.Blocks.lists_create_with_item={init:function(){this.setStyle("list_blocks");this.appendDummyInput().appendField(Blockly.Msg.LISTS_CREATE_WITH_ITEM_TITLE);this.setPreviousStatement(!0);this.setNextStatement(!0);this.setTooltip(Blockly.Msg.LISTS_CREATE_WITH_ITEM_TOOLTIP);this.contextMenu=!1}};
	Blockly.Blocks.lists_indexOf={init:function(){var a=[[Blockly.Msg.LISTS_INDEX_OF_FIRST,"FIRST"],[Blockly.Msg.LISTS_INDEX_OF_LAST,"LAST"]];this.setHelpUrl(Blockly.Msg.LISTS_INDEX_OF_HELPURL);this.setStyle("list_blocks");this.setOutput(!0,"Number");this.appendValueInput("VALUE").setCheck("Array").appendField(Blockly.Msg.LISTS_INDEX_OF_INPUT_IN_LIST);this.appendValueInput("FIND").appendField(new Blockly.FieldDropdown(a),"END");this.setInputsInline(!0);var b=this;this.setTooltip(function(){return Blockly.Msg.LISTS_INDEX_OF_TOOLTIP.replace("%1",
	b.workspace.options.oneBasedIndex?"0":"-1")})}};
	Blockly.Blocks.lists_getIndex={init:function(){var a=[[Blockly.Msg.LISTS_GET_INDEX_GET,"GET"],[Blockly.Msg.LISTS_GET_INDEX_GET_REMOVE,"GET_REMOVE"],[Blockly.Msg.LISTS_GET_INDEX_REMOVE,"REMOVE"]];this.WHERE_OPTIONS=[[Blockly.Msg.LISTS_GET_INDEX_FROM_START,"FROM_START"],[Blockly.Msg.LISTS_GET_INDEX_FROM_END,"FROM_END"],[Blockly.Msg.LISTS_GET_INDEX_FIRST,"FIRST"],[Blockly.Msg.LISTS_GET_INDEX_LAST,"LAST"],[Blockly.Msg.LISTS_GET_INDEX_RANDOM,"RANDOM"]];this.setHelpUrl(Blockly.Msg.LISTS_GET_INDEX_HELPURL);this.setStyle("list_blocks");
	a=new Blockly.FieldDropdown(a,function(a){a="REMOVE"==a;this.getSourceBlock().updateStatement_(a)});this.appendValueInput("VALUE").setCheck("Array").appendField(Blockly.Msg.LISTS_GET_INDEX_INPUT_IN_LIST);this.appendDummyInput().appendField(a,"MODE").appendField("","SPACE");this.appendDummyInput("AT");Blockly.Msg.LISTS_GET_INDEX_TAIL&&this.appendDummyInput("TAIL").appendField(Blockly.Msg.LISTS_GET_INDEX_TAIL);this.setInputsInline(!0);this.setOutput(!0);this.updateAt_(!0);var b=this;this.setTooltip(function(){var a=
	b.getFieldValue("MODE"),d=b.getFieldValue("WHERE"),e="";switch(a+" "+d){case "GET FROM_START":case "GET FROM_END":e=Blockly.Msg.LISTS_GET_INDEX_TOOLTIP_GET_FROM;break;case "GET FIRST":e=Blockly.Msg.LISTS_GET_INDEX_TOOLTIP_GET_FIRST;break;case "GET LAST":e=Blockly.Msg.LISTS_GET_INDEX_TOOLTIP_GET_LAST;break;case "GET RANDOM":e=Blockly.Msg.LISTS_GET_INDEX_TOOLTIP_GET_RANDOM;break;case "GET_REMOVE FROM_START":case "GET_REMOVE FROM_END":e=Blockly.Msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FROM;break;case "GET_REMOVE FIRST":e=
	Blockly.Msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FIRST;break;case "GET_REMOVE LAST":e=Blockly.Msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_LAST;break;case "GET_REMOVE RANDOM":e=Blockly.Msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_RANDOM;break;case "REMOVE FROM_START":case "REMOVE FROM_END":e=Blockly.Msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_FROM;break;case "REMOVE FIRST":e=Blockly.Msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_FIRST;break;case "REMOVE LAST":e=Blockly.Msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_LAST;break;case "REMOVE RANDOM":e=
	Blockly.Msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_RANDOM}if("FROM_START"==d||"FROM_END"==d)e+="  "+("FROM_START"==d?Blockly.Msg.LISTS_INDEX_FROM_START_TOOLTIP:Blockly.Msg.LISTS_INDEX_FROM_END_TOOLTIP).replace("%1",b.workspace.options.oneBasedIndex?"#1":"#0");return e})},mutationToDom:function(){var a=Blockly.utils.xml.createElement("mutation");a.setAttribute("statement",!this.outputConnection);var b=this.getInput("AT").type==Blockly.INPUT_VALUE;a.setAttribute("at",b);return a},domToMutation:function(a){var b=
	"true"==a.getAttribute("statement");this.updateStatement_(b);a="false"!=a.getAttribute("at");this.updateAt_(a)},updateStatement_:function(a){a!=!this.outputConnection&&(this.unplug(!0,!0),a?(this.setOutput(!1),this.setPreviousStatement(!0),this.setNextStatement(!0)):(this.setPreviousStatement(!1),this.setNextStatement(!1),this.setOutput(!0)))},updateAt_:function(a){this.removeInput("AT");this.removeInput("ORDINAL",!0);a?(this.appendValueInput("AT").setCheck("Number"),Blockly.Msg.ORDINAL_NUMBER_SUFFIX&&
	this.appendDummyInput("ORDINAL").appendField(Blockly.Msg.ORDINAL_NUMBER_SUFFIX)):this.appendDummyInput("AT");var b=new Blockly.FieldDropdown(this.WHERE_OPTIONS,function(b){var c="FROM_START"==b||"FROM_END"==b;if(c!=a){var e=this.getSourceBlock();e.updateAt_(c);e.setFieldValue(b,"WHERE");return null}});this.getInput("AT").appendField(b,"WHERE");Blockly.Msg.LISTS_GET_INDEX_TAIL&&this.moveInputBefore("TAIL",null)}};
	Blockly.Blocks.lists_setIndex={init:function(){var a=[[Blockly.Msg.LISTS_SET_INDEX_SET,"SET"],[Blockly.Msg.LISTS_SET_INDEX_INSERT,"INSERT"]];this.WHERE_OPTIONS=[[Blockly.Msg.LISTS_GET_INDEX_FROM_START,"FROM_START"],[Blockly.Msg.LISTS_GET_INDEX_FROM_END,"FROM_END"],[Blockly.Msg.LISTS_GET_INDEX_FIRST,"FIRST"],[Blockly.Msg.LISTS_GET_INDEX_LAST,"LAST"],[Blockly.Msg.LISTS_GET_INDEX_RANDOM,"RANDOM"]];this.setHelpUrl(Blockly.Msg.LISTS_SET_INDEX_HELPURL);this.setStyle("list_blocks");this.appendValueInput("LIST").setCheck("Array").appendField(Blockly.Msg.LISTS_SET_INDEX_INPUT_IN_LIST);
	this.appendDummyInput().appendField(new Blockly.FieldDropdown(a),"MODE").appendField("","SPACE");this.appendDummyInput("AT");this.appendValueInput("TO").appendField(Blockly.Msg.LISTS_SET_INDEX_INPUT_TO);this.setInputsInline(!0);this.setPreviousStatement(!0);this.setNextStatement(!0);this.setTooltip(Blockly.Msg.LISTS_SET_INDEX_TOOLTIP);this.updateAt_(!0);var b=this;this.setTooltip(function(){var a=b.getFieldValue("MODE"),d=b.getFieldValue("WHERE"),e="";switch(a+" "+d){case "SET FROM_START":case "SET FROM_END":e=
	Blockly.Msg.LISTS_SET_INDEX_TOOLTIP_SET_FROM;break;case "SET FIRST":e=Blockly.Msg.LISTS_SET_INDEX_TOOLTIP_SET_FIRST;break;case "SET LAST":e=Blockly.Msg.LISTS_SET_INDEX_TOOLTIP_SET_LAST;break;case "SET RANDOM":e=Blockly.Msg.LISTS_SET_INDEX_TOOLTIP_SET_RANDOM;break;case "INSERT FROM_START":case "INSERT FROM_END":e=Blockly.Msg.LISTS_SET_INDEX_TOOLTIP_INSERT_FROM;break;case "INSERT FIRST":e=Blockly.Msg.LISTS_SET_INDEX_TOOLTIP_INSERT_FIRST;break;case "INSERT LAST":e=Blockly.Msg.LISTS_SET_INDEX_TOOLTIP_INSERT_LAST;
	break;case "INSERT RANDOM":e=Blockly.Msg.LISTS_SET_INDEX_TOOLTIP_INSERT_RANDOM}if("FROM_START"==d||"FROM_END"==d)e+="  "+Blockly.Msg.LISTS_INDEX_FROM_START_TOOLTIP.replace("%1",b.workspace.options.oneBasedIndex?"#1":"#0");return e})},mutationToDom:function(){var a=Blockly.utils.xml.createElement("mutation"),b=this.getInput("AT").type==Blockly.INPUT_VALUE;a.setAttribute("at",b);return a},domToMutation:function(a){a="false"!=a.getAttribute("at");this.updateAt_(a)},updateAt_:function(a){this.removeInput("AT");
	this.removeInput("ORDINAL",!0);a?(this.appendValueInput("AT").setCheck("Number"),Blockly.Msg.ORDINAL_NUMBER_SUFFIX&&this.appendDummyInput("ORDINAL").appendField(Blockly.Msg.ORDINAL_NUMBER_SUFFIX)):this.appendDummyInput("AT");var b=new Blockly.FieldDropdown(this.WHERE_OPTIONS,function(b){var c="FROM_START"==b||"FROM_END"==b;if(c!=a){var e=this.getSourceBlock();e.updateAt_(c);e.setFieldValue(b,"WHERE");return null}});this.moveInputBefore("AT","TO");this.getInput("ORDINAL")&&this.moveInputBefore("ORDINAL",
	"TO");this.getInput("AT").appendField(b,"WHERE")}};
	Blockly.Blocks.lists_getSublist={init:function(){this.WHERE_OPTIONS_1=[[Blockly.Msg.LISTS_GET_SUBLIST_START_FROM_START,"FROM_START"],[Blockly.Msg.LISTS_GET_SUBLIST_START_FROM_END,"FROM_END"],[Blockly.Msg.LISTS_GET_SUBLIST_START_FIRST,"FIRST"]];this.WHERE_OPTIONS_2=[[Blockly.Msg.LISTS_GET_SUBLIST_END_FROM_START,"FROM_START"],[Blockly.Msg.LISTS_GET_SUBLIST_END_FROM_END,"FROM_END"],[Blockly.Msg.LISTS_GET_SUBLIST_END_LAST,"LAST"]];this.setHelpUrl(Blockly.Msg.LISTS_GET_SUBLIST_HELPURL);this.setStyle("list_blocks");
	this.appendValueInput("LIST").setCheck("Array").appendField(Blockly.Msg.LISTS_GET_SUBLIST_INPUT_IN_LIST);this.appendDummyInput("AT1");this.appendDummyInput("AT2");Blockly.Msg.LISTS_GET_SUBLIST_TAIL&&this.appendDummyInput("TAIL").appendField(Blockly.Msg.LISTS_GET_SUBLIST_TAIL);this.setInputsInline(!0);this.setOutput(!0,"Array");this.updateAt_(1,!0);this.updateAt_(2,!0);this.setTooltip(Blockly.Msg.LISTS_GET_SUBLIST_TOOLTIP)},mutationToDom:function(){var a=Blockly.utils.xml.createElement("mutation"),
	b=this.getInput("AT1").type==Blockly.INPUT_VALUE;a.setAttribute("at1",b);b=this.getInput("AT2").type==Blockly.INPUT_VALUE;a.setAttribute("at2",b);return a},domToMutation:function(a){var b="true"==a.getAttribute("at1");a="true"==a.getAttribute("at2");this.updateAt_(1,b);this.updateAt_(2,a)},updateAt_:function(a,b){this.removeInput("AT"+a);this.removeInput("ORDINAL"+a,!0);b?(this.appendValueInput("AT"+a).setCheck("Number"),Blockly.Msg.ORDINAL_NUMBER_SUFFIX&&this.appendDummyInput("ORDINAL"+a).appendField(Blockly.Msg.ORDINAL_NUMBER_SUFFIX)):
	this.appendDummyInput("AT"+a);var c=new Blockly.FieldDropdown(this["WHERE_OPTIONS_"+a],function(c){var e="FROM_START"==c||"FROM_END"==c;if(e!=b){var d=this.getSourceBlock();d.updateAt_(a,e);d.setFieldValue(c,"WHERE"+a);return null}});this.getInput("AT"+a).appendField(c,"WHERE"+a);1==a&&(this.moveInputBefore("AT1","AT2"),this.getInput("ORDINAL1")&&this.moveInputBefore("ORDINAL1","AT2"));Blockly.Msg.LISTS_GET_SUBLIST_TAIL&&this.moveInputBefore("TAIL",null)}};
	Blockly.Blocks.lists_sort={init:function(){this.jsonInit({message0:Blockly.Msg.LISTS_SORT_TITLE,args0:[{type:"field_dropdown",name:"TYPE",options:[[Blockly.Msg.LISTS_SORT_TYPE_NUMERIC,"NUMERIC"],[Blockly.Msg.LISTS_SORT_TYPE_TEXT,"TEXT"],[Blockly.Msg.LISTS_SORT_TYPE_IGNORECASE,"IGNORE_CASE"]]},{type:"field_dropdown",name:"DIRECTION",options:[[Blockly.Msg.LISTS_SORT_ORDER_ASCENDING,"1"],[Blockly.Msg.LISTS_SORT_ORDER_DESCENDING,"-1"]]},{type:"input_value",name:"LIST",check:"Array"}],output:"Array",style:"list_blocks",
	tooltip:Blockly.Msg.LISTS_SORT_TOOLTIP,helpUrl:Blockly.Msg.LISTS_SORT_HELPURL})}};
	Blockly.Blocks.lists_split={init:function(){var a=this,b=new Blockly.FieldDropdown([[Blockly.Msg.LISTS_SPLIT_LIST_FROM_TEXT,"SPLIT"],[Blockly.Msg.LISTS_SPLIT_TEXT_FROM_LIST,"JOIN"]],function(b){a.updateType_(b)});this.setHelpUrl(Blockly.Msg.LISTS_SPLIT_HELPURL);this.setStyle("list_blocks");this.appendValueInput("INPUT").setCheck("String").appendField(b,"MODE");this.appendValueInput("DELIM").setCheck("String").appendField(Blockly.Msg.LISTS_SPLIT_WITH_DELIMITER);this.setInputsInline(!0);this.setOutput(!0,
	"Array");this.setTooltip(function(){var b=a.getFieldValue("MODE");if("SPLIT"==b)return Blockly.Msg.LISTS_SPLIT_TOOLTIP_SPLIT;if("JOIN"==b)return Blockly.Msg.LISTS_SPLIT_TOOLTIP_JOIN;throw Error("Unknown mode: "+b);})},updateType_:function(a){if(this.getFieldValue("MODE")!=a){var b=this.getInput("INPUT").connection;b.setShadowDom(null);var c=b.targetBlock();c&&(b.disconnect(),c.isShadow()?c.dispose():this.bumpNeighbours())}"SPLIT"==a?(this.outputConnection.setCheck("Array"),this.getInput("INPUT").setCheck("String")):
	(this.outputConnection.setCheck("String"),this.getInput("INPUT").setCheck("Array"))},mutationToDom:function(){var a=Blockly.utils.xml.createElement("mutation");a.setAttribute("mode",this.getFieldValue("MODE"));return a},domToMutation:function(a){this.updateType_(a.getAttribute("mode"))}};Blockly.Blocks.logic={};Blockly.Constants.Logic={};Blockly.Constants.Logic.HUE=210;
	Blockly.defineBlocksWithJsonArray([{type:"logic_boolean",message0:"%1",args0:[{type:"field_dropdown",name:"BOOL",options:[["%{BKY_LOGIC_BOOLEAN_TRUE}","TRUE"],["%{BKY_LOGIC_BOOLEAN_FALSE}","FALSE"]]}],output:"Boolean",style:"logic_blocks",tooltip:"%{BKY_LOGIC_BOOLEAN_TOOLTIP}",helpUrl:"%{BKY_LOGIC_BOOLEAN_HELPURL}"},{type:"controls_if",message0:"%{BKY_CONTROLS_IF_MSG_IF} %1",args0:[{type:"input_value",name:"IF0",check:"Boolean"}],message1:"%{BKY_CONTROLS_IF_MSG_THEN} %1",args1:[{type:"input_statement",
	name:"DO0"}],previousStatement:null,nextStatement:null,style:"logic_blocks",helpUrl:"%{BKY_CONTROLS_IF_HELPURL}",mutator:"controls_if_mutator",extensions:["controls_if_tooltip"]},{type:"controls_ifelse",message0:"%{BKY_CONTROLS_IF_MSG_IF} %1",args0:[{type:"input_value",name:"IF0",check:"Boolean"}],message1:"%{BKY_CONTROLS_IF_MSG_THEN} %1",args1:[{type:"input_statement",name:"DO0"}],message2:"%{BKY_CONTROLS_IF_MSG_ELSE} %1",args2:[{type:"input_statement",name:"ELSE"}],previousStatement:null,nextStatement:null,
	style:"logic_blocks",tooltip:"%{BKYCONTROLS_IF_TOOLTIP_2}",helpUrl:"%{BKY_CONTROLS_IF_HELPURL}",extensions:["controls_if_tooltip"]},{type:"logic_compare",message0:"%1 %2 %3",args0:[{type:"input_value",name:"A"},{type:"field_dropdown",name:"OP",options:[["=","EQ"],["\u2260","NEQ"],["\u200f<","LT"],["\u200f\u2264","LTE"],["\u200f>","GT"],["\u200f\u2265","GTE"]]},{type:"input_value",name:"B"}],inputsInline:!0,output:"Boolean",style:"logic_blocks",helpUrl:"%{BKY_LOGIC_COMPARE_HELPURL}",extensions:["logic_compare",
	"logic_op_tooltip"]},{type:"logic_operation",message0:"%1 %2 %3",args0:[{type:"input_value",name:"A",check:"Boolean"},{type:"field_dropdown",name:"OP",options:[["%{BKY_LOGIC_OPERATION_AND}","AND"],["%{BKY_LOGIC_OPERATION_OR}","OR"]]},{type:"input_value",name:"B",check:"Boolean"}],inputsInline:!0,output:"Boolean",style:"logic_blocks",helpUrl:"%{BKY_LOGIC_OPERATION_HELPURL}",extensions:["logic_op_tooltip"]},{type:"logic_negate",message0:"%{BKY_LOGIC_NEGATE_TITLE}",args0:[{type:"input_value",name:"BOOL",
	check:"Boolean"}],output:"Boolean",style:"logic_blocks",tooltip:"%{BKY_LOGIC_NEGATE_TOOLTIP}",helpUrl:"%{BKY_LOGIC_NEGATE_HELPURL}"},{type:"logic_null",message0:"%{BKY_LOGIC_NULL}",output:null,style:"logic_blocks",tooltip:"%{BKY_LOGIC_NULL_TOOLTIP}",helpUrl:"%{BKY_LOGIC_NULL_HELPURL}"},{type:"logic_ternary",message0:"%{BKY_LOGIC_TERNARY_CONDITION} %1",args0:[{type:"input_value",name:"IF",check:"Boolean"}],message1:"%{BKY_LOGIC_TERNARY_IF_TRUE} %1",args1:[{type:"input_value",name:"THEN"}],message2:"%{BKY_LOGIC_TERNARY_IF_FALSE} %1",
	args2:[{type:"input_value",name:"ELSE"}],output:null,style:"logic_blocks",tooltip:"%{BKY_LOGIC_TERNARY_TOOLTIP}",helpUrl:"%{BKY_LOGIC_TERNARY_HELPURL}",extensions:["logic_ternary"]}]);
	Blockly.defineBlocksWithJsonArray([{type:"controls_if_if",message0:"%{BKY_CONTROLS_IF_IF_TITLE_IF}",nextStatement:null,enableContextMenu:!1,style:"logic_blocks",tooltip:"%{BKY_CONTROLS_IF_IF_TOOLTIP}"},{type:"controls_if_elseif",message0:"%{BKY_CONTROLS_IF_ELSEIF_TITLE_ELSEIF}",previousStatement:null,nextStatement:null,enableContextMenu:!1,style:"logic_blocks",tooltip:"%{BKY_CONTROLS_IF_ELSEIF_TOOLTIP}"},{type:"controls_if_else",message0:"%{BKY_CONTROLS_IF_ELSE_TITLE_ELSE}",previousStatement:null,
	enableContextMenu:!1,style:"logic_blocks",tooltip:"%{BKY_CONTROLS_IF_ELSE_TOOLTIP}"}]);Blockly.Constants.Logic.TOOLTIPS_BY_OP={EQ:"%{BKY_LOGIC_COMPARE_TOOLTIP_EQ}",NEQ:"%{BKY_LOGIC_COMPARE_TOOLTIP_NEQ}",LT:"%{BKY_LOGIC_COMPARE_TOOLTIP_LT}",LTE:"%{BKY_LOGIC_COMPARE_TOOLTIP_LTE}",GT:"%{BKY_LOGIC_COMPARE_TOOLTIP_GT}",GTE:"%{BKY_LOGIC_COMPARE_TOOLTIP_GTE}",AND:"%{BKY_LOGIC_OPERATION_TOOLTIP_AND}",OR:"%{BKY_LOGIC_OPERATION_TOOLTIP_OR}"};
	Blockly.Extensions.register("logic_op_tooltip",Blockly.Extensions.buildTooltipForDropdown("OP",Blockly.Constants.Logic.TOOLTIPS_BY_OP));
	Blockly.Constants.Logic.CONTROLS_IF_MUTATOR_MIXIN={elseifCount_:0,elseCount_:0,suppressPrefixSuffix:!0,mutationToDom:function(){if(!this.elseifCount_&&!this.elseCount_)return null;var a=Blockly.utils.xml.createElement("mutation");this.elseifCount_&&a.setAttribute("elseif",this.elseifCount_);this.elseCount_&&a.setAttribute("else",1);return a},domToMutation:function(a){this.elseifCount_=parseInt(a.getAttribute("elseif"),10)||0;this.elseCount_=parseInt(a.getAttribute("else"),10)||0;this.rebuildShape_()},
	decompose:function(a){var b=a.newBlock("controls_if_if");b.initSvg();for(var c=b.nextConnection,d=1;d<=this.elseifCount_;d++){var e=a.newBlock("controls_if_elseif");e.initSvg();c.connect(e.previousConnection);c=e.nextConnection}this.elseCount_&&(a=a.newBlock("controls_if_else"),a.initSvg(),c.connect(a.previousConnection));return b},compose:function(a){a=a.nextConnection.targetBlock();this.elseCount_=this.elseifCount_=0;for(var b=[null],c=[null],d=null;a;){switch(a.type){case "controls_if_elseif":this.elseifCount_++;
	b.push(a.valueConnection_);c.push(a.statementConnection_);break;case "controls_if_else":this.elseCount_++;d=a.statementConnection_;break;default:throw TypeError("Unknown block type: "+a.type);}a=a.nextConnection&&a.nextConnection.targetBlock()}this.updateShape_();this.reconnectChildBlocks_(b,c,d)},saveConnections:function(a){a=a.nextConnection.targetBlock();for(var b=1;a;){switch(a.type){case "controls_if_elseif":var c=this.getInput("IF"+b),d=this.getInput("DO"+b);a.valueConnection_=c&&c.connection.targetConnection;
	a.statementConnection_=d&&d.connection.targetConnection;b++;break;case "controls_if_else":d=this.getInput("ELSE");a.statementConnection_=d&&d.connection.targetConnection;break;default:throw TypeError("Unknown block type: "+a.type);}a=a.nextConnection&&a.nextConnection.targetBlock()}},rebuildShape_:function(){var a=[null],b=[null],c=null;this.getInput("ELSE")&&(c=this.getInput("ELSE").connection.targetConnection);for(var d=1;this.getInput("IF"+d);){var e=this.getInput("IF"+d),f=this.getInput("DO"+
	d);a.push(e.connection.targetConnection);b.push(f.connection.targetConnection);d++}this.updateShape_();this.reconnectChildBlocks_(a,b,c)},updateShape_:function(){this.getInput("ELSE")&&this.removeInput("ELSE");for(var a=1;this.getInput("IF"+a);)this.removeInput("IF"+a),this.removeInput("DO"+a),a++;for(a=1;a<=this.elseifCount_;a++)this.appendValueInput("IF"+a).setCheck("Boolean").appendField(Blockly.Msg.CONTROLS_IF_MSG_ELSEIF),this.appendStatementInput("DO"+a).appendField(Blockly.Msg.CONTROLS_IF_MSG_THEN);
	this.elseCount_&&this.appendStatementInput("ELSE").appendField(Blockly.Msg.CONTROLS_IF_MSG_ELSE)},reconnectChildBlocks_:function(a,b,c){for(var d=1;d<=this.elseifCount_;d++)Blockly.Mutator.reconnect(a[d],this,"IF"+d),Blockly.Mutator.reconnect(b[d],this,"DO"+d);Blockly.Mutator.reconnect(c,this,"ELSE")}};Blockly.Extensions.registerMutator("controls_if_mutator",Blockly.Constants.Logic.CONTROLS_IF_MUTATOR_MIXIN,null,["controls_if_elseif","controls_if_else"]);
	Blockly.Constants.Logic.CONTROLS_IF_TOOLTIP_EXTENSION=function(){this.setTooltip(function(){if(this.elseifCount_||this.elseCount_){if(!this.elseifCount_&&this.elseCount_)return Blockly.Msg.CONTROLS_IF_TOOLTIP_2;if(this.elseifCount_&&!this.elseCount_)return Blockly.Msg.CONTROLS_IF_TOOLTIP_3;if(this.elseifCount_&&this.elseCount_)return Blockly.Msg.CONTROLS_IF_TOOLTIP_4}else return Blockly.Msg.CONTROLS_IF_TOOLTIP_1;return""}.bind(this))};Blockly.Extensions.register("controls_if_tooltip",Blockly.Constants.Logic.CONTROLS_IF_TOOLTIP_EXTENSION);
	Blockly.Constants.Logic.LOGIC_COMPARE_ONCHANGE_MIXIN={onchange:function(a){this.prevBlocks_||(this.prevBlocks_=[null,null]);var b=this.getInputTargetBlock("A"),c=this.getInputTargetBlock("B");b&&c&&!b.outputConnection.checkType(c.outputConnection)&&(Blockly.Events.setGroup(a.group),a=this.prevBlocks_[0],a!==b&&(b.unplug(),!a||a.isDisposed()||a.isShadow()||this.getInput("A").connection.connect(a.outputConnection)),b=this.prevBlocks_[1],b!==c&&(c.unplug(),!b||b.isDisposed()||b.isShadow()||this.getInput("B").connection.connect(b.outputConnection)),
	this.bumpNeighbours(),Blockly.Events.setGroup(!1));this.prevBlocks_[0]=this.getInputTargetBlock("A");this.prevBlocks_[1]=this.getInputTargetBlock("B")}};Blockly.Constants.Logic.LOGIC_COMPARE_EXTENSION=function(){this.mixin(Blockly.Constants.Logic.LOGIC_COMPARE_ONCHANGE_MIXIN)};Blockly.Extensions.register("logic_compare",Blockly.Constants.Logic.LOGIC_COMPARE_EXTENSION);
	Blockly.Constants.Logic.LOGIC_TERNARY_ONCHANGE_MIXIN={prevParentConnection_:null,onchange:function(a){var b=this.getInputTargetBlock("THEN"),c=this.getInputTargetBlock("ELSE"),d=this.outputConnection.targetConnection;if((b||c)&&d)for(var e=0;2>e;e++){var f=1==e?b:c;f&&!f.outputConnection.checkType(d)&&(Blockly.Events.setGroup(a.group),d===this.prevParentConnection_?(this.unplug(),d.getSourceBlock().bumpNeighbours()):(f.unplug(),f.bumpNeighbours()),Blockly.Events.setGroup(!1))}this.prevParentConnection_=
	d}};Blockly.Extensions.registerMixin("logic_ternary",Blockly.Constants.Logic.LOGIC_TERNARY_ONCHANGE_MIXIN);Blockly.Blocks.loops={};Blockly.Constants.Loops={};Blockly.Constants.Loops.HUE=120;
	Blockly.defineBlocksWithJsonArray([{type:"controls_repeat_ext",message0:"%{BKY_CONTROLS_REPEAT_TITLE}",args0:[{type:"input_value",name:"TIMES",check:"Number"}],message1:"%{BKY_CONTROLS_REPEAT_INPUT_DO} %1",args1:[{type:"input_statement",name:"DO"}],previousStatement:null,nextStatement:null,style:"loop_blocks",tooltip:"%{BKY_CONTROLS_REPEAT_TOOLTIP}",helpUrl:"%{BKY_CONTROLS_REPEAT_HELPURL}"},{type:"controls_repeat",message0:"%{BKY_CONTROLS_REPEAT_TITLE}",args0:[{type:"field_number",name:"TIMES",value:10,
	min:0,precision:1}],message1:"%{BKY_CONTROLS_REPEAT_INPUT_DO} %1",args1:[{type:"input_statement",name:"DO"}],previousStatement:null,nextStatement:null,style:"loop_blocks",tooltip:"%{BKY_CONTROLS_REPEAT_TOOLTIP}",helpUrl:"%{BKY_CONTROLS_REPEAT_HELPURL}"},{type:"controls_whileUntil",message0:"%1 %2",args0:[{type:"field_dropdown",name:"MODE",options:[["%{BKY_CONTROLS_WHILEUNTIL_OPERATOR_WHILE}","WHILE"],["%{BKY_CONTROLS_WHILEUNTIL_OPERATOR_UNTIL}","UNTIL"]]},{type:"input_value",name:"BOOL",check:"Boolean"}],
	message1:"%{BKY_CONTROLS_REPEAT_INPUT_DO} %1",args1:[{type:"input_statement",name:"DO"}],previousStatement:null,nextStatement:null,style:"loop_blocks",helpUrl:"%{BKY_CONTROLS_WHILEUNTIL_HELPURL}",extensions:["controls_whileUntil_tooltip"]},{type:"controls_for",message0:"%{BKY_CONTROLS_FOR_TITLE}",args0:[{type:"field_variable",name:"VAR",variable:null},{type:"input_value",name:"FROM",check:"Number",align:"RIGHT"},{type:"input_value",name:"TO",check:"Number",align:"RIGHT"},{type:"input_value",name:"BY",
	check:"Number",align:"RIGHT"}],message1:"%{BKY_CONTROLS_REPEAT_INPUT_DO} %1",args1:[{type:"input_statement",name:"DO"}],inputsInline:!0,previousStatement:null,nextStatement:null,style:"loop_blocks",helpUrl:"%{BKY_CONTROLS_FOR_HELPURL}",extensions:["contextMenu_newGetVariableBlock","controls_for_tooltip"]},{type:"controls_forEach",message0:"%{BKY_CONTROLS_FOREACH_TITLE}",args0:[{type:"field_variable",name:"VAR",variable:null},{type:"input_value",name:"LIST",check:"Array"}],message1:"%{BKY_CONTROLS_REPEAT_INPUT_DO} %1",
	args1:[{type:"input_statement",name:"DO"}],previousStatement:null,nextStatement:null,style:"loop_blocks",helpUrl:"%{BKY_CONTROLS_FOREACH_HELPURL}",extensions:["contextMenu_newGetVariableBlock","controls_forEach_tooltip"]},{type:"controls_flow_statements",message0:"%1",args0:[{type:"field_dropdown",name:"FLOW",options:[["%{BKY_CONTROLS_FLOW_STATEMENTS_OPERATOR_BREAK}","BREAK"],["%{BKY_CONTROLS_FLOW_STATEMENTS_OPERATOR_CONTINUE}","CONTINUE"]]}],previousStatement:null,style:"loop_blocks",helpUrl:"%{BKY_CONTROLS_FLOW_STATEMENTS_HELPURL}",
	extensions:["controls_flow_tooltip","controls_flow_in_loop_check"]}]);Blockly.Constants.Loops.WHILE_UNTIL_TOOLTIPS={WHILE:"%{BKY_CONTROLS_WHILEUNTIL_TOOLTIP_WHILE}",UNTIL:"%{BKY_CONTROLS_WHILEUNTIL_TOOLTIP_UNTIL}"};Blockly.Extensions.register("controls_whileUntil_tooltip",Blockly.Extensions.buildTooltipForDropdown("MODE",Blockly.Constants.Loops.WHILE_UNTIL_TOOLTIPS));Blockly.Constants.Loops.BREAK_CONTINUE_TOOLTIPS={BREAK:"%{BKY_CONTROLS_FLOW_STATEMENTS_TOOLTIP_BREAK}",CONTINUE:"%{BKY_CONTROLS_FLOW_STATEMENTS_TOOLTIP_CONTINUE}"};
	Blockly.Extensions.register("controls_flow_tooltip",Blockly.Extensions.buildTooltipForDropdown("FLOW",Blockly.Constants.Loops.BREAK_CONTINUE_TOOLTIPS));
	Blockly.Constants.Loops.CUSTOM_CONTEXT_MENU_CREATE_VARIABLES_GET_MIXIN={customContextMenu:function(a){if(!this.isInFlyout){var b=this.getField("VAR").getVariable(),c=b.name;if(!this.isCollapsed()&&null!=c){var d={enabled:!0};d.text=Blockly.Msg.VARIABLES_SET_CREATE_GET.replace("%1",c);b=Blockly.Variables.generateVariableFieldDom(b);c=Blockly.utils.xml.createElement("block");c.setAttribute("type","variables_get");c.appendChild(b);d.callback=Blockly.ContextMenu.callbackFactory(this,c);a.push(d)}}}};
	Blockly.Extensions.registerMixin("contextMenu_newGetVariableBlock",Blockly.Constants.Loops.CUSTOM_CONTEXT_MENU_CREATE_VARIABLES_GET_MIXIN);Blockly.Extensions.register("controls_for_tooltip",Blockly.Extensions.buildTooltipWithFieldText("%{BKY_CONTROLS_FOR_TOOLTIP}","VAR"));Blockly.Extensions.register("controls_forEach_tooltip",Blockly.Extensions.buildTooltipWithFieldText("%{BKY_CONTROLS_FOREACH_TOOLTIP}","VAR"));
	Blockly.Constants.Loops.CONTROL_FLOW_IN_LOOP_CHECK_MIXIN={LOOP_TYPES:["controls_repeat","controls_repeat_ext","controls_forEach","controls_for","controls_whileUntil"],suppressPrefixSuffix:!0,getSurroundLoop:function(a){do{if(-1!=Blockly.Constants.Loops.CONTROL_FLOW_IN_LOOP_CHECK_MIXIN.LOOP_TYPES.indexOf(a.type))return a;a=a.getSurroundParent()}while(a);return null},onchange:function(a){if(this.workspace.isDragging&&!this.workspace.isDragging()&&a.type==Blockly.Events.BLOCK_MOVE&&a.blockId==this.id){var b=
	Blockly.Constants.Loops.CONTROL_FLOW_IN_LOOP_CHECK_MIXIN.getSurroundLoop(this);this.setWarningText(b?null:Blockly.Msg.CONTROLS_FLOW_STATEMENTS_WARNING);if(!this.isInFlyout){var c=Blockly.Events.getGroup();Blockly.Events.setGroup(a.group);this.setEnabled(b);Blockly.Events.setGroup(c)}}}};Blockly.Extensions.registerMixin("controls_flow_in_loop_check",Blockly.Constants.Loops.CONTROL_FLOW_IN_LOOP_CHECK_MIXIN);Blockly.Blocks.math={};Blockly.Constants.Math={};Blockly.Constants.Math.HUE=230;
	Blockly.defineBlocksWithJsonArray([{type:"math_number",message0:"%1",args0:[{type:"field_number",name:"NUM",value:0}],output:"Number",helpUrl:"%{BKY_MATH_NUMBER_HELPURL}",style:"math_blocks",tooltip:"%{BKY_MATH_NUMBER_TOOLTIP}",extensions:["parent_tooltip_when_inline"]},{type:"math_arithmetic",message0:"%1 %2 %3",args0:[{type:"input_value",name:"A",check:"Number"},{type:"field_dropdown",name:"OP",options:[["%{BKY_MATH_ADDITION_SYMBOL}","ADD"],["%{BKY_MATH_SUBTRACTION_SYMBOL}","MINUS"],["%{BKY_MATH_MULTIPLICATION_SYMBOL}",
	"MULTIPLY"],["%{BKY_MATH_DIVISION_SYMBOL}","DIVIDE"],["%{BKY_MATH_POWER_SYMBOL}","POWER"]]},{type:"input_value",name:"B",check:"Number"}],inputsInline:!0,output:"Number",style:"math_blocks",helpUrl:"%{BKY_MATH_ARITHMETIC_HELPURL}",extensions:["math_op_tooltip"]},{type:"math_single",message0:"%1 %2",args0:[{type:"field_dropdown",name:"OP",options:[["%{BKY_MATH_SINGLE_OP_ROOT}","ROOT"],["%{BKY_MATH_SINGLE_OP_ABSOLUTE}","ABS"],["-","NEG"],["ln","LN"],["log10","LOG10"],["e^","EXP"],["10^","POW10"]]},
	{type:"input_value",name:"NUM",check:"Number"}],output:"Number",style:"math_blocks",helpUrl:"%{BKY_MATH_SINGLE_HELPURL}",extensions:["math_op_tooltip"]},{type:"math_trig",message0:"%1 %2",args0:[{type:"field_dropdown",name:"OP",options:[["%{BKY_MATH_TRIG_SIN}","SIN"],["%{BKY_MATH_TRIG_COS}","COS"],["%{BKY_MATH_TRIG_TAN}","TAN"],["%{BKY_MATH_TRIG_ASIN}","ASIN"],["%{BKY_MATH_TRIG_ACOS}","ACOS"],["%{BKY_MATH_TRIG_ATAN}","ATAN"]]},{type:"input_value",name:"NUM",check:"Number"}],output:"Number",style:"math_blocks",
	helpUrl:"%{BKY_MATH_TRIG_HELPURL}",extensions:["math_op_tooltip"]},{type:"math_constant",message0:"%1",args0:[{type:"field_dropdown",name:"CONSTANT",options:[["\u03c0","PI"],["e","E"],["\u03c6","GOLDEN_RATIO"],["sqrt(2)","SQRT2"],["sqrt(\u00bd)","SQRT1_2"],["\u221e","INFINITY"]]}],output:"Number",style:"math_blocks",tooltip:"%{BKY_MATH_CONSTANT_TOOLTIP}",helpUrl:"%{BKY_MATH_CONSTANT_HELPURL}"},{type:"math_number_property",message0:"%1 %2",args0:[{type:"input_value",name:"NUMBER_TO_CHECK",check:"Number"},
	{type:"field_dropdown",name:"PROPERTY",options:[["%{BKY_MATH_IS_EVEN}","EVEN"],["%{BKY_MATH_IS_ODD}","ODD"],["%{BKY_MATH_IS_PRIME}","PRIME"],["%{BKY_MATH_IS_WHOLE}","WHOLE"],["%{BKY_MATH_IS_POSITIVE}","POSITIVE"],["%{BKY_MATH_IS_NEGATIVE}","NEGATIVE"],["%{BKY_MATH_IS_DIVISIBLE_BY}","DIVISIBLE_BY"]]}],inputsInline:!0,output:"Boolean",style:"math_blocks",tooltip:"%{BKY_MATH_IS_TOOLTIP}",mutator:"math_is_divisibleby_mutator"},{type:"math_change",message0:"%{BKY_MATH_CHANGE_TITLE}",args0:[{type:"field_variable",
	name:"VAR",variable:"%{BKY_MATH_CHANGE_TITLE_ITEM}"},{type:"input_value",name:"DELTA",check:"Number"}],previousStatement:null,nextStatement:null,style:"variable_blocks",helpUrl:"%{BKY_MATH_CHANGE_HELPURL}",extensions:["math_change_tooltip"]},{type:"math_round",message0:"%1 %2",args0:[{type:"field_dropdown",name:"OP",options:[["%{BKY_MATH_ROUND_OPERATOR_ROUND}","ROUND"],["%{BKY_MATH_ROUND_OPERATOR_ROUNDUP}","ROUNDUP"],["%{BKY_MATH_ROUND_OPERATOR_ROUNDDOWN}","ROUNDDOWN"]]},{type:"input_value",name:"NUM",
	check:"Number"}],output:"Number",style:"math_blocks",helpUrl:"%{BKY_MATH_ROUND_HELPURL}",tooltip:"%{BKY_MATH_ROUND_TOOLTIP}"},{type:"math_on_list",message0:"%1 %2",args0:[{type:"field_dropdown",name:"OP",options:[["%{BKY_MATH_ONLIST_OPERATOR_SUM}","SUM"],["%{BKY_MATH_ONLIST_OPERATOR_MIN}","MIN"],["%{BKY_MATH_ONLIST_OPERATOR_MAX}","MAX"],["%{BKY_MATH_ONLIST_OPERATOR_AVERAGE}","AVERAGE"],["%{BKY_MATH_ONLIST_OPERATOR_MEDIAN}","MEDIAN"],["%{BKY_MATH_ONLIST_OPERATOR_MODE}","MODE"],["%{BKY_MATH_ONLIST_OPERATOR_STD_DEV}",
	"STD_DEV"],["%{BKY_MATH_ONLIST_OPERATOR_RANDOM}","RANDOM"]]},{type:"input_value",name:"LIST",check:"Array"}],output:"Number",style:"math_blocks",helpUrl:"%{BKY_MATH_ONLIST_HELPURL}",mutator:"math_modes_of_list_mutator",extensions:["math_op_tooltip"]},{type:"math_modulo",message0:"%{BKY_MATH_MODULO_TITLE}",args0:[{type:"input_value",name:"DIVIDEND",check:"Number"},{type:"input_value",name:"DIVISOR",check:"Number"}],inputsInline:!0,output:"Number",style:"math_blocks",tooltip:"%{BKY_MATH_MODULO_TOOLTIP}",
	helpUrl:"%{BKY_MATH_MODULO_HELPURL}"},{type:"math_constrain",message0:"%{BKY_MATH_CONSTRAIN_TITLE}",args0:[{type:"input_value",name:"VALUE",check:"Number"},{type:"input_value",name:"LOW",check:"Number"},{type:"input_value",name:"HIGH",check:"Number"}],inputsInline:!0,output:"Number",style:"math_blocks",tooltip:"%{BKY_MATH_CONSTRAIN_TOOLTIP}",helpUrl:"%{BKY_MATH_CONSTRAIN_HELPURL}"},{type:"math_random_int",message0:"%{BKY_MATH_RANDOM_INT_TITLE}",args0:[{type:"input_value",name:"FROM",check:"Number"},
	{type:"input_value",name:"TO",check:"Number"}],inputsInline:!0,output:"Number",style:"math_blocks",tooltip:"%{BKY_MATH_RANDOM_INT_TOOLTIP}",helpUrl:"%{BKY_MATH_RANDOM_INT_HELPURL}"},{type:"math_random_float",message0:"%{BKY_MATH_RANDOM_FLOAT_TITLE_RANDOM}",output:"Number",style:"math_blocks",tooltip:"%{BKY_MATH_RANDOM_FLOAT_TOOLTIP}",helpUrl:"%{BKY_MATH_RANDOM_FLOAT_HELPURL}"},{type:"math_atan2",message0:"%{BKY_MATH_ATAN2_TITLE}",args0:[{type:"input_value",name:"X",check:"Number"},{type:"input_value",
	name:"Y",check:"Number"}],inputsInline:!0,output:"Number",style:"math_blocks",tooltip:"%{BKY_MATH_ATAN2_TOOLTIP}",helpUrl:"%{BKY_MATH_ATAN2_HELPURL}"}]);
	Blockly.Constants.Math.TOOLTIPS_BY_OP={ADD:"%{BKY_MATH_ARITHMETIC_TOOLTIP_ADD}",MINUS:"%{BKY_MATH_ARITHMETIC_TOOLTIP_MINUS}",MULTIPLY:"%{BKY_MATH_ARITHMETIC_TOOLTIP_MULTIPLY}",DIVIDE:"%{BKY_MATH_ARITHMETIC_TOOLTIP_DIVIDE}",POWER:"%{BKY_MATH_ARITHMETIC_TOOLTIP_POWER}",ROOT:"%{BKY_MATH_SINGLE_TOOLTIP_ROOT}",ABS:"%{BKY_MATH_SINGLE_TOOLTIP_ABS}",NEG:"%{BKY_MATH_SINGLE_TOOLTIP_NEG}",LN:"%{BKY_MATH_SINGLE_TOOLTIP_LN}",LOG10:"%{BKY_MATH_SINGLE_TOOLTIP_LOG10}",EXP:"%{BKY_MATH_SINGLE_TOOLTIP_EXP}",POW10:"%{BKY_MATH_SINGLE_TOOLTIP_POW10}",
	SIN:"%{BKY_MATH_TRIG_TOOLTIP_SIN}",COS:"%{BKY_MATH_TRIG_TOOLTIP_COS}",TAN:"%{BKY_MATH_TRIG_TOOLTIP_TAN}",ASIN:"%{BKY_MATH_TRIG_TOOLTIP_ASIN}",ACOS:"%{BKY_MATH_TRIG_TOOLTIP_ACOS}",ATAN:"%{BKY_MATH_TRIG_TOOLTIP_ATAN}",SUM:"%{BKY_MATH_ONLIST_TOOLTIP_SUM}",MIN:"%{BKY_MATH_ONLIST_TOOLTIP_MIN}",MAX:"%{BKY_MATH_ONLIST_TOOLTIP_MAX}",AVERAGE:"%{BKY_MATH_ONLIST_TOOLTIP_AVERAGE}",MEDIAN:"%{BKY_MATH_ONLIST_TOOLTIP_MEDIAN}",MODE:"%{BKY_MATH_ONLIST_TOOLTIP_MODE}",STD_DEV:"%{BKY_MATH_ONLIST_TOOLTIP_STD_DEV}",RANDOM:"%{BKY_MATH_ONLIST_TOOLTIP_RANDOM}"};
	Blockly.Extensions.register("math_op_tooltip",Blockly.Extensions.buildTooltipForDropdown("OP",Blockly.Constants.Math.TOOLTIPS_BY_OP));
	Blockly.Constants.Math.IS_DIVISIBLEBY_MUTATOR_MIXIN={mutationToDom:function(){var a=Blockly.utils.xml.createElement("mutation"),b="DIVISIBLE_BY"==this.getFieldValue("PROPERTY");a.setAttribute("divisor_input",b);return a},domToMutation:function(a){a="true"==a.getAttribute("divisor_input");this.updateShape_(a)},updateShape_:function(a){var b=this.getInput("DIVISOR");a?b||this.appendValueInput("DIVISOR").setCheck("Number"):b&&this.removeInput("DIVISOR")}};
	Blockly.Constants.Math.IS_DIVISIBLE_MUTATOR_EXTENSION=function(){this.getField("PROPERTY").setValidator(function(a){a="DIVISIBLE_BY"==a;this.getSourceBlock().updateShape_(a)})};Blockly.Extensions.registerMutator("math_is_divisibleby_mutator",Blockly.Constants.Math.IS_DIVISIBLEBY_MUTATOR_MIXIN,Blockly.Constants.Math.IS_DIVISIBLE_MUTATOR_EXTENSION);Blockly.Extensions.register("math_change_tooltip",Blockly.Extensions.buildTooltipWithFieldText("%{BKY_MATH_CHANGE_TOOLTIP}","VAR"));
	Blockly.Constants.Math.LIST_MODES_MUTATOR_MIXIN={updateType_:function(a){"MODE"==a?this.outputConnection.setCheck("Array"):this.outputConnection.setCheck("Number")},mutationToDom:function(){var a=Blockly.utils.xml.createElement("mutation");a.setAttribute("op",this.getFieldValue("OP"));return a},domToMutation:function(a){this.updateType_(a.getAttribute("op"))}};Blockly.Constants.Math.LIST_MODES_MUTATOR_EXTENSION=function(){this.getField("OP").setValidator(function(a){this.updateType_(a)}.bind(this))};
	Blockly.Extensions.registerMutator("math_modes_of_list_mutator",Blockly.Constants.Math.LIST_MODES_MUTATOR_MIXIN,Blockly.Constants.Math.LIST_MODES_MUTATOR_EXTENSION);Blockly.Blocks.procedures={};
	Blockly.Blocks.procedures_defnoreturn={init:function(){var a=new Blockly.FieldTextInput("",Blockly.Procedures.rename);a.setSpellcheck(!1);this.appendDummyInput().appendField(Blockly.Msg.PROCEDURES_DEFNORETURN_TITLE).appendField(a,"NAME").appendField("","PARAMS");this.setMutator(new Blockly.Mutator(["procedures_mutatorarg"]));(this.workspace.options.comments||this.workspace.options.parentWorkspace&&this.workspace.options.parentWorkspace.options.comments)&&Blockly.Msg.PROCEDURES_DEFNORETURN_COMMENT&&this.setCommentText(Blockly.Msg.PROCEDURES_DEFNORETURN_COMMENT);
	this.setStyle("procedure_blocks");this.setTooltip(Blockly.Msg.PROCEDURES_DEFNORETURN_TOOLTIP);this.setHelpUrl(Blockly.Msg.PROCEDURES_DEFNORETURN_HELPURL);this.arguments_=[];this.argumentVarModels_=[];this.setStatements_(!0);this.statementConnection_=null},setStatements_:function(a){this.hasStatements_!==a&&(a?(this.appendStatementInput("STACK").appendField(Blockly.Msg.PROCEDURES_DEFNORETURN_DO),this.getInput("RETURN")&&this.moveInputBefore("STACK","RETURN")):this.removeInput("STACK",!0),this.hasStatements_=
	a)},updateParams_:function(){var a="";this.arguments_.length&&(a=Blockly.Msg.PROCEDURES_BEFORE_PARAMS+" "+this.arguments_.join(", "));Blockly.Events.disable();try{this.setFieldValue(a,"PARAMS")}finally{Blockly.Events.enable()}},mutationToDom:function(a){var b=Blockly.utils.xml.createElement("mutation");a&&b.setAttribute("name",this.getFieldValue("NAME"));for(var c=0;c<this.argumentVarModels_.length;c++){var d=Blockly.utils.xml.createElement("arg"),e=this.argumentVarModels_[c];d.setAttribute("name",
	e.name);d.setAttribute("varid",e.getId());a&&this.paramIds_&&d.setAttribute("paramId",this.paramIds_[c]);b.appendChild(d)}this.hasStatements_||b.setAttribute("statements","false");return b},domToMutation:function(a){this.arguments_=[];this.argumentVarModels_=[];for(var b=0,c;c=a.childNodes[b];b++)if("arg"==c.nodeName.toLowerCase()){var d=c.getAttribute("name");c=c.getAttribute("varid")||c.getAttribute("varId");this.arguments_.push(d);c=Blockly.Variables.getOrCreateVariablePackage(this.workspace,c,
	d,"");null!=c?this.argumentVarModels_.push(c):console.log("Failed to create a variable with name "+d+", ignoring.")}this.updateParams_();Blockly.Procedures.mutateCallers(this);this.setStatements_("false"!==a.getAttribute("statements"))},decompose:function(a){var b=Blockly.utils.xml.createElement("block");b.setAttribute("type","procedures_mutatorcontainer");var c=Blockly.utils.xml.createElement("statement");c.setAttribute("name","STACK");b.appendChild(c);for(var d=0;d<this.arguments_.length;d++){var e=
	Blockly.utils.xml.createElement("block");e.setAttribute("type","procedures_mutatorarg");var f=Blockly.utils.xml.createElement("field");f.setAttribute("name","NAME");var g=Blockly.utils.xml.createTextNode(this.arguments_[d]);f.appendChild(g);e.appendChild(f);f=Blockly.utils.xml.createElement("next");e.appendChild(f);c.appendChild(e);c=f}a=Blockly.Xml.domToBlock(b,a);"procedures_defreturn"==this.type?a.setFieldValue(this.hasStatements_,"STATEMENTS"):a.removeInput("STATEMENT_INPUT");Blockly.Procedures.mutateCallers(this);
	return a},compose:function(a){this.arguments_=[];this.paramIds_=[];this.argumentVarModels_=[];for(var b=a.getInputTargetBlock("STACK");b;){var c=b.getFieldValue("NAME");this.arguments_.push(c);c=this.workspace.getVariable(c,"");this.argumentVarModels_.push(c);this.paramIds_.push(b.id);b=b.nextConnection&&b.nextConnection.targetBlock()}this.updateParams_();Blockly.Procedures.mutateCallers(this);a=a.getFieldValue("STATEMENTS");if(null!==a&&(a="TRUE"==a,this.hasStatements_!=a))if(a)this.setStatements_(!0),
	Blockly.Mutator.reconnect(this.statementConnection_,this,"STACK"),this.statementConnection_=null;else{a=this.getInput("STACK").connection;if(this.statementConnection_=a.targetConnection)a=a.targetBlock(),a.unplug(),a.bumpNeighbours();this.setStatements_(!1)}},getProcedureDef:function(){return[this.getFieldValue("NAME"),this.arguments_,!1]},getVars:function(){return this.arguments_},getVarModels:function(){return this.argumentVarModels_},renameVarById:function(a,b){var c=this.workspace.getVariableById(a);
	if(""==c.type){c=c.name;b=this.workspace.getVariableById(b);for(var d=!1,e=0;e<this.argumentVarModels_.length;e++)this.argumentVarModels_[e].getId()==a&&(this.arguments_[e]=b.name,this.argumentVarModels_[e]=b,d=!0);d&&(this.displayRenamedVar_(c,b.name),Blockly.Procedures.mutateCallers(this))}},updateVarName:function(a){for(var b=a.name,c=!1,d=0;d<this.argumentVarModels_.length;d++)if(this.argumentVarModels_[d].getId()==a.getId()){var e=this.arguments_[d];this.arguments_[d]=b;c=!0}c&&(this.displayRenamedVar_(e,
	b),Blockly.Procedures.mutateCallers(this))},displayRenamedVar_:function(a,b){this.updateParams_();if(this.mutator&&this.mutator.isVisible())for(var c=this.mutator.workspace_.getAllBlocks(!1),d=0,e;e=c[d];d++)"procedures_mutatorarg"==e.type&&Blockly.Names.equals(a,e.getFieldValue("NAME"))&&e.setFieldValue(b,"NAME")},customContextMenu:function(a){if(!this.isInFlyout){var b={enabled:!0},c=this.getFieldValue("NAME");b.text=Blockly.Msg.PROCEDURES_CREATE_DO.replace("%1",c);var d=Blockly.utils.xml.createElement("mutation");
	d.setAttribute("name",c);for(c=0;c<this.arguments_.length;c++){var e=Blockly.utils.xml.createElement("arg");e.setAttribute("name",this.arguments_[c]);d.appendChild(e)}c=Blockly.utils.xml.createElement("block");c.setAttribute("type",this.callType_);c.appendChild(d);b.callback=Blockly.ContextMenu.callbackFactory(this,c);a.push(b);if(!this.isCollapsed())for(c=0;c<this.argumentVarModels_.length;c++)b={enabled:!0},d=this.argumentVarModels_[c],b.text=Blockly.Msg.VARIABLES_SET_CREATE_GET.replace("%1",d.name),
	d=Blockly.Variables.generateVariableFieldDom(d),e=Blockly.utils.xml.createElement("block"),e.setAttribute("type","variables_get"),e.appendChild(d),b.callback=Blockly.ContextMenu.callbackFactory(this,e),a.push(b)}},callType_:"procedures_callnoreturn"};
	Blockly.Blocks.procedures_defreturn={init:function(){var a=new Blockly.FieldTextInput("",Blockly.Procedures.rename);a.setSpellcheck(!1);this.appendDummyInput().appendField(Blockly.Msg.PROCEDURES_DEFRETURN_TITLE).appendField(a,"NAME").appendField("","PARAMS");this.appendValueInput("RETURN").setAlign(Blockly.ALIGN_RIGHT).appendField(Blockly.Msg.PROCEDURES_DEFRETURN_RETURN);this.setMutator(new Blockly.Mutator(["procedures_mutatorarg"]));(this.workspace.options.comments||this.workspace.options.parentWorkspace&&
	this.workspace.options.parentWorkspace.options.comments)&&Blockly.Msg.PROCEDURES_DEFRETURN_COMMENT&&this.setCommentText(Blockly.Msg.PROCEDURES_DEFRETURN_COMMENT);this.setStyle("procedure_blocks");this.setTooltip(Blockly.Msg.PROCEDURES_DEFRETURN_TOOLTIP);this.setHelpUrl(Blockly.Msg.PROCEDURES_DEFRETURN_HELPURL);this.arguments_=[];this.argumentVarModels_=[];this.setStatements_(!0);this.statementConnection_=null},setStatements_:Blockly.Blocks.procedures_defnoreturn.setStatements_,updateParams_:Blockly.Blocks.procedures_defnoreturn.updateParams_,
	mutationToDom:Blockly.Blocks.procedures_defnoreturn.mutationToDom,domToMutation:Blockly.Blocks.procedures_defnoreturn.domToMutation,decompose:Blockly.Blocks.procedures_defnoreturn.decompose,compose:Blockly.Blocks.procedures_defnoreturn.compose,getProcedureDef:function(){return[this.getFieldValue("NAME"),this.arguments_,!0]},getVars:Blockly.Blocks.procedures_defnoreturn.getVars,getVarModels:Blockly.Blocks.procedures_defnoreturn.getVarModels,renameVarById:Blockly.Blocks.procedures_defnoreturn.renameVarById,
	updateVarName:Blockly.Blocks.procedures_defnoreturn.updateVarName,displayRenamedVar_:Blockly.Blocks.procedures_defnoreturn.displayRenamedVar_,customContextMenu:Blockly.Blocks.procedures_defnoreturn.customContextMenu,callType_:"procedures_callreturn"};
	Blockly.Blocks.procedures_mutatorcontainer={init:function(){this.appendDummyInput().appendField(Blockly.Msg.PROCEDURES_MUTATORCONTAINER_TITLE);this.appendStatementInput("STACK");this.appendDummyInput("STATEMENT_INPUT").appendField(Blockly.Msg.PROCEDURES_ALLOW_STATEMENTS).appendField(new Blockly.FieldCheckbox("TRUE"),"STATEMENTS");this.setStyle("procedure_blocks");this.setTooltip(Blockly.Msg.PROCEDURES_MUTATORCONTAINER_TOOLTIP);this.contextMenu=!1}};
	Blockly.Blocks.procedures_mutatorarg={init:function(){var a=new Blockly.FieldTextInput(Blockly.Procedures.DEFAULT_ARG,this.validator_);a.oldShowEditorFn_=a.showEditor_;a.showEditor_=function(){this.createdVariables_=[];this.oldShowEditorFn_()};this.appendDummyInput().appendField(Blockly.Msg.PROCEDURES_MUTATORARG_TITLE).appendField(a,"NAME");this.setPreviousStatement(!0);this.setNextStatement(!0);this.setStyle("procedure_blocks");this.setTooltip(Blockly.Msg.PROCEDURES_MUTATORARG_TOOLTIP);this.contextMenu=
	!1;a.onFinishEditing_=this.deleteIntermediateVars_;a.createdVariables_=[];a.onFinishEditing_("x")},validator_:function(a){var b=this.getSourceBlock(),c=Blockly.Mutator.findParentWs(b.workspace);a=a.replace(/[\s\xa0]+/g," ").replace(/^ | $/g,"");if(!a)return null;for(var d=(b.workspace.targetWorkspace||b.workspace).getAllBlocks(!1),e=a.toLowerCase(),f=0;f<d.length;f++)if(d[f].id!=this.getSourceBlock().id){var g=d[f].getFieldValue("NAME");if(g&&g.toLowerCase()==e)return null}if(b.isInFlyout)return a;
	(b=c.getVariable(a,""))&&b.name!=a&&c.renameVariableById(b.getId(),a);b||(b=c.createVariable(a,""))&&this.createdVariables_&&this.createdVariables_.push(b);return a},deleteIntermediateVars_:function(a){var b=Blockly.Mutator.findParentWs(this.getSourceBlock().workspace);if(b)for(var c=0;c<this.createdVariables_.length;c++){var d=this.createdVariables_[c];d.name!=a&&b.deleteVariableById(d.getId())}}};
	Blockly.Blocks.procedures_callnoreturn={init:function(){this.appendDummyInput("TOPROW").appendField(this.id,"NAME");this.setPreviousStatement(!0);this.setNextStatement(!0);this.setStyle("procedure_blocks");this.setHelpUrl(Blockly.Msg.PROCEDURES_CALLNORETURN_HELPURL);this.arguments_=[];this.argumentVarModels_=[];this.quarkConnections_={};this.quarkIds_=null;this.previousEnabledState_=!0},getProcedureCall:function(){return this.getFieldValue("NAME")},renameProcedure:function(a,b){Blockly.Names.equals(a,
	this.getProcedureCall())&&(this.setFieldValue(b,"NAME"),this.setTooltip((this.outputConnection?Blockly.Msg.PROCEDURES_CALLRETURN_TOOLTIP:Blockly.Msg.PROCEDURES_CALLNORETURN_TOOLTIP).replace("%1",b)))},setProcedureParameters_:function(a,b){var c=Blockly.Procedures.getDefinition(this.getProcedureCall(),this.workspace),d=c&&c.mutator&&c.mutator.isVisible();d||(this.quarkConnections_={},this.quarkIds_=null);if(b)if(a.join("\n")==this.arguments_.join("\n"))this.quarkIds_=b;else{if(b.length!=a.length)throw RangeError("paramNames and paramIds must be the same length.");
	this.setCollapsed(!1);this.quarkIds_||(this.quarkConnections_={},this.quarkIds_=[]);c=this.rendered;this.rendered=!1;for(var e=0;e<this.arguments_.length;e++){var f=this.getInput("ARG"+e);f&&(f=f.connection.targetConnection,this.quarkConnections_[this.quarkIds_[e]]=f,d&&f&&-1==b.indexOf(this.quarkIds_[e])&&(f.disconnect(),f.getSourceBlock().bumpNeighbours()))}this.arguments_=[].concat(a);this.argumentVarModels_=[];for(e=0;e<this.arguments_.length;e++)a=Blockly.Variables.getOrCreateVariablePackage(this.workspace,
	null,this.arguments_[e],""),this.argumentVarModels_.push(a);this.updateShape_();if(this.quarkIds_=b)for(e=0;e<this.arguments_.length;e++)b=this.quarkIds_[e],b in this.quarkConnections_&&(f=this.quarkConnections_[b],Blockly.Mutator.reconnect(f,this,"ARG"+e)||delete this.quarkConnections_[b]);(this.rendered=c)&&this.render()}},updateShape_:function(){for(var a=0;a<this.arguments_.length;a++){var b=this.getField("ARGNAME"+a);if(b){Blockly.Events.disable();try{b.setValue(this.arguments_[a])}finally{Blockly.Events.enable()}}else b=
	new Blockly.FieldLabel(this.arguments_[a]),this.appendValueInput("ARG"+a).setAlign(Blockly.ALIGN_RIGHT).appendField(b,"ARGNAME"+a).init()}for(;this.getInput("ARG"+a);)this.removeInput("ARG"+a),a++;if(a=this.getInput("TOPROW"))this.arguments_.length?this.getField("WITH")||(a.appendField(Blockly.Msg.PROCEDURES_CALL_BEFORE_PARAMS,"WITH"),a.init()):this.getField("WITH")&&a.removeField("WITH")},mutationToDom:function(){var a=Blockly.utils.xml.createElement("mutation");a.setAttribute("name",this.getProcedureCall());
	for(var b=0;b<this.arguments_.length;b++){var c=Blockly.utils.xml.createElement("arg");c.setAttribute("name",this.arguments_[b]);a.appendChild(c)}return a},domToMutation:function(a){var b=a.getAttribute("name");this.renameProcedure(this.getProcedureCall(),b);b=[];for(var c=[],d=0,e;e=a.childNodes[d];d++)"arg"==e.nodeName.toLowerCase()&&(b.push(e.getAttribute("name")),c.push(e.getAttribute("paramId")));this.setProcedureParameters_(b,c)},getVars:function(){return this.arguments_},getVarModels:function(){return this.argumentVarModels_},
	onchange:function(a){if(this.workspace&&!this.workspace.isFlyout&&a.recordUndo)if(a.type==Blockly.Events.BLOCK_CREATE&&-1!=a.ids.indexOf(this.id)){var b=this.getProcedureCall();b=Blockly.Procedures.getDefinition(b,this.workspace);!b||b.type==this.defType_&&JSON.stringify(b.getVars())==JSON.stringify(this.arguments_)||(b=null);if(!b){Blockly.Events.setGroup(a.group);a=Blockly.utils.xml.createElement("xml");b=Blockly.utils.xml.createElement("block");b.setAttribute("type",this.defType_);var c=this.getRelativeToSurfaceXY(),
	d=c.y+2*Blockly.SNAP_RADIUS;b.setAttribute("x",c.x+Blockly.SNAP_RADIUS*(this.RTL?-1:1));b.setAttribute("y",d);c=this.mutationToDom();b.appendChild(c);c=Blockly.utils.xml.createElement("field");c.setAttribute("name","NAME");c.appendChild(Blockly.utils.xml.createTextNode(this.getProcedureCall()));b.appendChild(c);a.appendChild(b);Blockly.Xml.domToWorkspace(a,this.workspace);Blockly.Events.setGroup(!1)}}else a.type==Blockly.Events.BLOCK_DELETE?(b=this.getProcedureCall(),b=Blockly.Procedures.getDefinition(b,
	this.workspace),b||(Blockly.Events.setGroup(a.group),this.dispose(!0),Blockly.Events.setGroup(!1))):a.type==Blockly.Events.CHANGE&&"disabled"==a.element&&(b=this.getProcedureCall(),(b=Blockly.Procedures.getDefinition(b,this.workspace))&&b.id==a.blockId&&((b=Blockly.Events.getGroup())&&console.log("Saw an existing group while responding to a definition change"),Blockly.Events.setGroup(a.group),a.newValue?(this.previousEnabledState_=this.isEnabled(),this.setEnabled(!1)):this.setEnabled(this.previousEnabledState_),
	Blockly.Events.setGroup(b)))},customContextMenu:function(a){if(this.workspace.isMovable()){var b={enabled:!0};b.text=Blockly.Msg.PROCEDURES_HIGHLIGHT_DEF;var c=this.getProcedureCall(),d=this.workspace;b.callback=function(){var a=Blockly.Procedures.getDefinition(c,d);a&&(d.centerOnBlock(a.id),a.select())};a.push(b)}},defType_:"procedures_defnoreturn"};
	Blockly.Blocks.procedures_callreturn={init:function(){this.appendDummyInput("TOPROW").appendField("","NAME");this.setOutput(!0);this.setStyle("procedure_blocks");this.setHelpUrl(Blockly.Msg.PROCEDURES_CALLRETURN_HELPURL);this.arguments_=[];this.quarkConnections_={};this.quarkIds_=null;this.previousEnabledState_=!0},getProcedureCall:Blockly.Blocks.procedures_callnoreturn.getProcedureCall,renameProcedure:Blockly.Blocks.procedures_callnoreturn.renameProcedure,setProcedureParameters_:Blockly.Blocks.procedures_callnoreturn.setProcedureParameters_,
	updateShape_:Blockly.Blocks.procedures_callnoreturn.updateShape_,mutationToDom:Blockly.Blocks.procedures_callnoreturn.mutationToDom,domToMutation:Blockly.Blocks.procedures_callnoreturn.domToMutation,getVars:Blockly.Blocks.procedures_callnoreturn.getVars,getVarModels:Blockly.Blocks.procedures_callnoreturn.getVarModels,onchange:Blockly.Blocks.procedures_callnoreturn.onchange,customContextMenu:Blockly.Blocks.procedures_callnoreturn.customContextMenu,defType_:"procedures_defreturn"};
	Blockly.Blocks.procedures_ifreturn={init:function(){this.appendValueInput("CONDITION").setCheck("Boolean").appendField(Blockly.Msg.CONTROLS_IF_MSG_IF);this.appendValueInput("VALUE").appendField(Blockly.Msg.PROCEDURES_DEFRETURN_RETURN);this.setInputsInline(!0);this.setPreviousStatement(!0);this.setNextStatement(!0);this.setStyle("procedure_blocks");this.setTooltip(Blockly.Msg.PROCEDURES_IFRETURN_TOOLTIP);this.setHelpUrl(Blockly.Msg.PROCEDURES_IFRETURN_HELPURL);this.hasReturnValue_=!0},mutationToDom:function(){var a=
	Blockly.utils.xml.createElement("mutation");a.setAttribute("value",Number(this.hasReturnValue_));return a},domToMutation:function(a){this.hasReturnValue_=1==a.getAttribute("value");this.hasReturnValue_||(this.removeInput("VALUE"),this.appendDummyInput("VALUE").appendField(Blockly.Msg.PROCEDURES_DEFRETURN_RETURN))},onchange:function(a){if(this.workspace.isDragging&&!this.workspace.isDragging()){a=!1;var b=this;do{if(-1!=this.FUNCTION_TYPES.indexOf(b.type)){a=!0;break}b=b.getSurroundParent()}while(b);
	a?("procedures_defnoreturn"==b.type&&this.hasReturnValue_?(this.removeInput("VALUE"),this.appendDummyInput("VALUE").appendField(Blockly.Msg.PROCEDURES_DEFRETURN_RETURN),this.hasReturnValue_=!1):"procedures_defreturn"!=b.type||this.hasReturnValue_||(this.removeInput("VALUE"),this.appendValueInput("VALUE").appendField(Blockly.Msg.PROCEDURES_DEFRETURN_RETURN),this.hasReturnValue_=!0),this.setWarningText(null),this.isInFlyout||this.setEnabled(!0)):(this.setWarningText(Blockly.Msg.PROCEDURES_IFRETURN_WARNING),
	this.isInFlyout||this.getInheritedDisabled()||this.setEnabled(!1))}},FUNCTION_TYPES:["procedures_defnoreturn","procedures_defreturn"]};Blockly.Blocks.texts={};Blockly.Constants.Text={};Blockly.Constants.Text.HUE=160;
	Blockly.defineBlocksWithJsonArray([{type:"text",message0:"%1",args0:[{type:"field_input",name:"TEXT",text:""}],output:"String",style:"text_blocks",helpUrl:"%{BKY_TEXT_TEXT_HELPURL}",tooltip:"%{BKY_TEXT_TEXT_TOOLTIP}",extensions:["text_quotes","parent_tooltip_when_inline"]},{type:"text_multiline",message0:"%1 %2",args0:[{type:"field_image",src:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAARCAYAAADpPU2iAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAAdhgAAHYYBXaITgQAAABh0RVh0U29mdHdhcmUAcGFpbnQubmV0IDQuMS42/U4J6AAAAP1JREFUOE+Vks0KQUEYhjmRIja4ABtZ2dm5A3t3Ia6AUm7CylYuQRaUhZSlLZJiQbFAyRnPN33y01HOW08z8873zpwzM4F3GWOCruvGIE4/rLaV+Nq1hVGMBqzhqlxgCys4wJA65xnogMHsQ5lujnYHTejBBCK2mE4abjCgMGhNxHgDFWjDSG07kdfVa2pZMf4ZyMAdWmpZMfYOsLiDMYMjlMB+K613QISRhTnITnsYg5yUd0DETmEoMlkFOeIT/A58iyK5E18BuTBfgYXfwNJv4P9/oEBerLylOnRhygmGdPpTTBZAPkde61lbQe4moWUvYUZYLfUNftIY4zwA5X2Z9AYnQrEAAAAASUVORK5CYII=",width:12,
	height:17,alt:"\u00b6"},{type:"field_multilinetext",name:"TEXT",text:""}],output:"String",style:"text_blocks",helpUrl:"%{BKY_TEXT_TEXT_HELPURL}",tooltip:"%{BKY_TEXT_TEXT_TOOLTIP}",extensions:["parent_tooltip_when_inline"]},{type:"text_join",message0:"",output:"String",style:"text_blocks",helpUrl:"%{BKY_TEXT_JOIN_HELPURL}",tooltip:"%{BKY_TEXT_JOIN_TOOLTIP}",mutator:"text_join_mutator"},{type:"text_create_join_container",message0:"%{BKY_TEXT_CREATE_JOIN_TITLE_JOIN} %1 %2",args0:[{type:"input_dummy"},
	{type:"input_statement",name:"STACK"}],style:"text_blocks",tooltip:"%{BKY_TEXT_CREATE_JOIN_TOOLTIP}",enableContextMenu:!1},{type:"text_create_join_item",message0:"%{BKY_TEXT_CREATE_JOIN_ITEM_TITLE_ITEM}",previousStatement:null,nextStatement:null,style:"text_blocks",tooltip:"%{BKY_TEXT_CREATE_JOIN_ITEM_TOOLTIP}",enableContextMenu:!1},{type:"text_append",message0:"%{BKY_TEXT_APPEND_TITLE}",args0:[{type:"field_variable",name:"VAR",variable:"%{BKY_TEXT_APPEND_VARIABLE}"},{type:"input_value",name:"TEXT"}],
	previousStatement:null,nextStatement:null,style:"text_blocks",extensions:["text_append_tooltip"]},{type:"text_length",message0:"%{BKY_TEXT_LENGTH_TITLE}",args0:[{type:"input_value",name:"VALUE",check:["String","Array"]}],output:"Number",style:"text_blocks",tooltip:"%{BKY_TEXT_LENGTH_TOOLTIP}",helpUrl:"%{BKY_TEXT_LENGTH_HELPURL}"},{type:"text_isEmpty",message0:"%{BKY_TEXT_ISEMPTY_TITLE}",args0:[{type:"input_value",name:"VALUE",check:["String","Array"]}],output:"Boolean",style:"text_blocks",tooltip:"%{BKY_TEXT_ISEMPTY_TOOLTIP}",
	helpUrl:"%{BKY_TEXT_ISEMPTY_HELPURL}"},{type:"text_indexOf",message0:"%{BKY_TEXT_INDEXOF_TITLE}",args0:[{type:"input_value",name:"VALUE",check:"String"},{type:"field_dropdown",name:"END",options:[["%{BKY_TEXT_INDEXOF_OPERATOR_FIRST}","FIRST"],["%{BKY_TEXT_INDEXOF_OPERATOR_LAST}","LAST"]]},{type:"input_value",name:"FIND",check:"String"}],output:"Number",style:"text_blocks",helpUrl:"%{BKY_TEXT_INDEXOF_HELPURL}",inputsInline:!0,extensions:["text_indexOf_tooltip"]},{type:"text_charAt",message0:"%{BKY_TEXT_CHARAT_TITLE}",
	args0:[{type:"input_value",name:"VALUE",check:"String"},{type:"field_dropdown",name:"WHERE",options:[["%{BKY_TEXT_CHARAT_FROM_START}","FROM_START"],["%{BKY_TEXT_CHARAT_FROM_END}","FROM_END"],["%{BKY_TEXT_CHARAT_FIRST}","FIRST"],["%{BKY_TEXT_CHARAT_LAST}","LAST"],["%{BKY_TEXT_CHARAT_RANDOM}","RANDOM"]]}],output:"String",style:"text_blocks",helpUrl:"%{BKY_TEXT_CHARAT_HELPURL}",inputsInline:!0,mutator:"text_charAt_mutator"}]);
	Blockly.Blocks.text_getSubstring={init:function(){this.WHERE_OPTIONS_1=[[Blockly.Msg.TEXT_GET_SUBSTRING_START_FROM_START,"FROM_START"],[Blockly.Msg.TEXT_GET_SUBSTRING_START_FROM_END,"FROM_END"],[Blockly.Msg.TEXT_GET_SUBSTRING_START_FIRST,"FIRST"]];this.WHERE_OPTIONS_2=[[Blockly.Msg.TEXT_GET_SUBSTRING_END_FROM_START,"FROM_START"],[Blockly.Msg.TEXT_GET_SUBSTRING_END_FROM_END,"FROM_END"],[Blockly.Msg.TEXT_GET_SUBSTRING_END_LAST,"LAST"]];this.setHelpUrl(Blockly.Msg.TEXT_GET_SUBSTRING_HELPURL);this.setStyle("text_blocks");
	this.appendValueInput("STRING").setCheck("String").appendField(Blockly.Msg.TEXT_GET_SUBSTRING_INPUT_IN_TEXT);this.appendDummyInput("AT1");this.appendDummyInput("AT2");Blockly.Msg.TEXT_GET_SUBSTRING_TAIL&&this.appendDummyInput("TAIL").appendField(Blockly.Msg.TEXT_GET_SUBSTRING_TAIL);this.setInputsInline(!0);this.setOutput(!0,"String");this.updateAt_(1,!0);this.updateAt_(2,!0);this.setTooltip(Blockly.Msg.TEXT_GET_SUBSTRING_TOOLTIP)},mutationToDom:function(){var a=Blockly.utils.xml.createElement("mutation"),
	b=this.getInput("AT1").type==Blockly.INPUT_VALUE;a.setAttribute("at1",b);b=this.getInput("AT2").type==Blockly.INPUT_VALUE;a.setAttribute("at2",b);return a},domToMutation:function(a){var b="true"==a.getAttribute("at1");a="true"==a.getAttribute("at2");this.updateAt_(1,b);this.updateAt_(2,a)},updateAt_:function(a,b){this.removeInput("AT"+a);this.removeInput("ORDINAL"+a,!0);b?(this.appendValueInput("AT"+a).setCheck("Number"),Blockly.Msg.ORDINAL_NUMBER_SUFFIX&&this.appendDummyInput("ORDINAL"+a).appendField(Blockly.Msg.ORDINAL_NUMBER_SUFFIX)):
	this.appendDummyInput("AT"+a);2==a&&Blockly.Msg.TEXT_GET_SUBSTRING_TAIL&&(this.removeInput("TAIL",!0),this.appendDummyInput("TAIL").appendField(Blockly.Msg.TEXT_GET_SUBSTRING_TAIL));var c=new Blockly.FieldDropdown(this["WHERE_OPTIONS_"+a],function(c){var e="FROM_START"==c||"FROM_END"==c;if(e!=b){var d=this.getSourceBlock();d.updateAt_(a,e);d.setFieldValue(c,"WHERE"+a);return null}});this.getInput("AT"+a).appendField(c,"WHERE"+a);1==a&&(this.moveInputBefore("AT1","AT2"),this.getInput("ORDINAL1")&&
	this.moveInputBefore("ORDINAL1","AT2"))}};Blockly.Blocks.text_changeCase={init:function(){var a=[[Blockly.Msg.TEXT_CHANGECASE_OPERATOR_UPPERCASE,"UPPERCASE"],[Blockly.Msg.TEXT_CHANGECASE_OPERATOR_LOWERCASE,"LOWERCASE"],[Blockly.Msg.TEXT_CHANGECASE_OPERATOR_TITLECASE,"TITLECASE"]];this.setHelpUrl(Blockly.Msg.TEXT_CHANGECASE_HELPURL);this.setStyle("text_blocks");this.appendValueInput("TEXT").setCheck("String").appendField(new Blockly.FieldDropdown(a),"CASE");this.setOutput(!0,"String");this.setTooltip(Blockly.Msg.TEXT_CHANGECASE_TOOLTIP)}};
	Blockly.Blocks.text_trim={init:function(){var a=[[Blockly.Msg.TEXT_TRIM_OPERATOR_BOTH,"BOTH"],[Blockly.Msg.TEXT_TRIM_OPERATOR_LEFT,"LEFT"],[Blockly.Msg.TEXT_TRIM_OPERATOR_RIGHT,"RIGHT"]];this.setHelpUrl(Blockly.Msg.TEXT_TRIM_HELPURL);this.setStyle("text_blocks");this.appendValueInput("TEXT").setCheck("String").appendField(new Blockly.FieldDropdown(a),"MODE");this.setOutput(!0,"String");this.setTooltip(Blockly.Msg.TEXT_TRIM_TOOLTIP)}};
	Blockly.Blocks.text_print={init:function(){this.jsonInit({message0:Blockly.Msg.TEXT_PRINT_TITLE,args0:[{type:"input_value",name:"TEXT"}],previousStatement:null,nextStatement:null,style:"text_blocks",tooltip:Blockly.Msg.TEXT_PRINT_TOOLTIP,helpUrl:Blockly.Msg.TEXT_PRINT_HELPURL})}};
	Blockly.Blocks.text_prompt_ext={init:function(){var a=[[Blockly.Msg.TEXT_PROMPT_TYPE_TEXT,"TEXT"],[Blockly.Msg.TEXT_PROMPT_TYPE_NUMBER,"NUMBER"]];this.setHelpUrl(Blockly.Msg.TEXT_PROMPT_HELPURL);this.setStyle("text_blocks");var b=this;a=new Blockly.FieldDropdown(a,function(a){b.updateType_(a)});this.appendValueInput("TEXT").appendField(a,"TYPE");this.setOutput(!0,"String");this.setTooltip(function(){return"TEXT"==b.getFieldValue("TYPE")?Blockly.Msg.TEXT_PROMPT_TOOLTIP_TEXT:Blockly.Msg.TEXT_PROMPT_TOOLTIP_NUMBER})},
	updateType_:function(a){this.outputConnection.setCheck("NUMBER"==a?"Number":"String")},mutationToDom:function(){var a=Blockly.utils.xml.createElement("mutation");a.setAttribute("type",this.getFieldValue("TYPE"));return a},domToMutation:function(a){this.updateType_(a.getAttribute("type"))}};
	Blockly.Blocks.text_prompt={init:function(){this.mixin(Blockly.Constants.Text.QUOTE_IMAGE_MIXIN);var a=[[Blockly.Msg.TEXT_PROMPT_TYPE_TEXT,"TEXT"],[Blockly.Msg.TEXT_PROMPT_TYPE_NUMBER,"NUMBER"]],b=this;this.setHelpUrl(Blockly.Msg.TEXT_PROMPT_HELPURL);this.setStyle("text_blocks");a=new Blockly.FieldDropdown(a,function(a){b.updateType_(a)});this.appendDummyInput().appendField(a,"TYPE").appendField(this.newQuote_(!0)).appendField(new Blockly.FieldTextInput(""),"TEXT").appendField(this.newQuote_(!1));
	this.setOutput(!0,"String");this.setTooltip(function(){return"TEXT"==b.getFieldValue("TYPE")?Blockly.Msg.TEXT_PROMPT_TOOLTIP_TEXT:Blockly.Msg.TEXT_PROMPT_TOOLTIP_NUMBER})},updateType_:Blockly.Blocks.text_prompt_ext.updateType_,mutationToDom:Blockly.Blocks.text_prompt_ext.mutationToDom,domToMutation:Blockly.Blocks.text_prompt_ext.domToMutation};
	Blockly.Blocks.text_count={init:function(){this.jsonInit({message0:Blockly.Msg.TEXT_COUNT_MESSAGE0,args0:[{type:"input_value",name:"SUB",check:"String"},{type:"input_value",name:"TEXT",check:"String"}],output:"Number",inputsInline:!0,style:"text_blocks",tooltip:Blockly.Msg.TEXT_COUNT_TOOLTIP,helpUrl:Blockly.Msg.TEXT_COUNT_HELPURL})}};
	Blockly.Blocks.text_replace={init:function(){this.jsonInit({message0:Blockly.Msg.TEXT_REPLACE_MESSAGE0,args0:[{type:"input_value",name:"FROM",check:"String"},{type:"input_value",name:"TO",check:"String"},{type:"input_value",name:"TEXT",check:"String"}],output:"String",inputsInline:!0,style:"text_blocks",tooltip:Blockly.Msg.TEXT_REPLACE_TOOLTIP,helpUrl:Blockly.Msg.TEXT_REPLACE_HELPURL})}};
	Blockly.Blocks.text_reverse={init:function(){this.jsonInit({message0:Blockly.Msg.TEXT_REVERSE_MESSAGE0,args0:[{type:"input_value",name:"TEXT",check:"String"}],output:"String",inputsInline:!0,style:"text_blocks",tooltip:Blockly.Msg.TEXT_REVERSE_TOOLTIP,helpUrl:Blockly.Msg.TEXT_REVERSE_HELPURL})}};
	Blockly.Constants.Text.QUOTE_IMAGE_MIXIN={QUOTE_IMAGE_LEFT_DATAURI:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAQAAAAqJXdxAAAAn0lEQVQI1z3OMa5BURSF4f/cQhAKjUQhuQmFNwGJEUi0RKN5rU7FHKhpjEH3TEMtkdBSCY1EIv8r7nFX9e29V7EBAOvu7RPjwmWGH/VuF8CyN9/OAdvqIXYLvtRaNjx9mMTDyo+NjAN1HNcl9ZQ5oQMM3dgDUqDo1l8DzvwmtZN7mnD+PkmLa+4mhrxVA9fRowBWmVBhFy5gYEjKMfz9AylsaRRgGzvZAAAAAElFTkSuQmCC",QUOTE_IMAGE_RIGHT_DATAURI:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAQAAAAqJXdxAAAAqUlEQVQI1z3KvUpCcRiA8ef9E4JNHhI0aFEacm1o0BsI0Slx8wa8gLauoDnoBhq7DcfWhggONDmJJgqCPA7neJ7p934EOOKOnM8Q7PDElo/4x4lFb2DmuUjcUzS3URnGib9qaPNbuXvBO3sGPHJDRG6fGVdMSeWDP2q99FQdFrz26Gu5Tq7dFMzUvbXy8KXeAj57cOklgA+u1B5AoslLtGIHQMaCVnwDnADZIFIrXsoXrgAAAABJRU5ErkJggg==",
	QUOTE_IMAGE_WIDTH:12,QUOTE_IMAGE_HEIGHT:12,quoteField_:function(a){for(var b=0,c;c=this.inputList[b];b++)for(var d=0,e;e=c.fieldRow[d];d++)if(a==e.name){c.insertFieldAt(d,this.newQuote_(!0));c.insertFieldAt(d+2,this.newQuote_(!1));return}console.warn('field named "'+a+'" not found in '+this.toDevString())},newQuote_:function(a){a=this.RTL?!a:a;return new Blockly.FieldImage(a?this.QUOTE_IMAGE_LEFT_DATAURI:this.QUOTE_IMAGE_RIGHT_DATAURI,this.QUOTE_IMAGE_WIDTH,this.QUOTE_IMAGE_HEIGHT,a?"\u201c":"\u201d")}};
	Blockly.Constants.Text.TEXT_QUOTES_EXTENSION=function(){this.mixin(Blockly.Constants.Text.QUOTE_IMAGE_MIXIN);this.quoteField_("TEXT")};
	Blockly.Constants.Text.TEXT_JOIN_MUTATOR_MIXIN={mutationToDom:function(){var a=Blockly.utils.xml.createElement("mutation");a.setAttribute("items",this.itemCount_);return a},domToMutation:function(a){this.itemCount_=parseInt(a.getAttribute("items"),10);this.updateShape_()},decompose:function(a){var b=a.newBlock("text_create_join_container");b.initSvg();for(var c=b.getInput("STACK").connection,d=0;d<this.itemCount_;d++){var e=a.newBlock("text_create_join_item");e.initSvg();c.connect(e.previousConnection);
	c=e.nextConnection}return b},compose:function(a){var b=a.getInputTargetBlock("STACK");for(a=[];b;)a.push(b.valueConnection_),b=b.nextConnection&&b.nextConnection.targetBlock();for(b=0;b<this.itemCount_;b++){var c=this.getInput("ADD"+b).connection.targetConnection;c&&-1==a.indexOf(c)&&c.disconnect()}this.itemCount_=a.length;this.updateShape_();for(b=0;b<this.itemCount_;b++)Blockly.Mutator.reconnect(a[b],this,"ADD"+b)},saveConnections:function(a){a=a.getInputTargetBlock("STACK");for(var b=0;a;){var c=
	this.getInput("ADD"+b);a.valueConnection_=c&&c.connection.targetConnection;b++;a=a.nextConnection&&a.nextConnection.targetBlock()}},updateShape_:function(){this.itemCount_&&this.getInput("EMPTY")?this.removeInput("EMPTY"):this.itemCount_||this.getInput("EMPTY")||this.appendDummyInput("EMPTY").appendField(this.newQuote_(!0)).appendField(this.newQuote_(!1));for(var a=0;a<this.itemCount_;a++)if(!this.getInput("ADD"+a)){var b=this.appendValueInput("ADD"+a).setAlign(Blockly.ALIGN_RIGHT);0==a&&b.appendField(Blockly.Msg.TEXT_JOIN_TITLE_CREATEWITH)}for(;this.getInput("ADD"+
	a);)this.removeInput("ADD"+a),a++}};Blockly.Constants.Text.TEXT_JOIN_EXTENSION=function(){this.mixin(Blockly.Constants.Text.QUOTE_IMAGE_MIXIN);this.itemCount_=2;this.updateShape_();this.setMutator(new Blockly.Mutator(["text_create_join_item"]))};Blockly.Extensions.register("text_append_tooltip",Blockly.Extensions.buildTooltipWithFieldText("%{BKY_TEXT_APPEND_TOOLTIP}","VAR"));
	Blockly.Constants.Text.TEXT_INDEXOF_TOOLTIP_EXTENSION=function(){var a=this;this.setTooltip(function(){return Blockly.Msg.TEXT_INDEXOF_TOOLTIP.replace("%1",a.workspace.options.oneBasedIndex?"0":"-1")})};
	Blockly.Constants.Text.TEXT_CHARAT_MUTATOR_MIXIN={mutationToDom:function(){var a=Blockly.utils.xml.createElement("mutation");a.setAttribute("at",!!this.isAt_);return a},domToMutation:function(a){a="false"!=a.getAttribute("at");this.updateAt_(a)},updateAt_:function(a){this.removeInput("AT",!0);this.removeInput("ORDINAL",!0);a&&(this.appendValueInput("AT").setCheck("Number"),Blockly.Msg.ORDINAL_NUMBER_SUFFIX&&this.appendDummyInput("ORDINAL").appendField(Blockly.Msg.ORDINAL_NUMBER_SUFFIX));Blockly.Msg.TEXT_CHARAT_TAIL&&
	(this.removeInput("TAIL",!0),this.appendDummyInput("TAIL").appendField(Blockly.Msg.TEXT_CHARAT_TAIL));this.isAt_=a}};
	Blockly.Constants.Text.TEXT_CHARAT_EXTENSION=function(){this.getField("WHERE").setValidator(function(a){a="FROM_START"==a||"FROM_END"==a;a!=this.isAt_&&this.getSourceBlock().updateAt_(a)});this.updateAt_(!0);var a=this;this.setTooltip(function(){var b=a.getFieldValue("WHERE"),c=Blockly.Msg.TEXT_CHARAT_TOOLTIP;("FROM_START"==b||"FROM_END"==b)&&(b="FROM_START"==b?Blockly.Msg.LISTS_INDEX_FROM_START_TOOLTIP:Blockly.Msg.LISTS_INDEX_FROM_END_TOOLTIP)&&(c+="  "+b.replace("%1",a.workspace.options.oneBasedIndex?
	"#1":"#0"));return c})};Blockly.Extensions.register("text_indexOf_tooltip",Blockly.Constants.Text.TEXT_INDEXOF_TOOLTIP_EXTENSION);Blockly.Extensions.register("text_quotes",Blockly.Constants.Text.TEXT_QUOTES_EXTENSION);Blockly.Extensions.registerMutator("text_join_mutator",Blockly.Constants.Text.TEXT_JOIN_MUTATOR_MIXIN,Blockly.Constants.Text.TEXT_JOIN_EXTENSION);Blockly.Extensions.registerMutator("text_charAt_mutator",Blockly.Constants.Text.TEXT_CHARAT_MUTATOR_MIXIN,Blockly.Constants.Text.TEXT_CHARAT_EXTENSION);Blockly.Blocks.variables={};Blockly.Constants.Variables={};Blockly.Constants.Variables.HUE=330;
	Blockly.defineBlocksWithJsonArray([{type:"variables_get",message0:"%1",args0:[{type:"field_variable",name:"VAR",variable:"%{BKY_VARIABLES_DEFAULT_NAME}"}],output:null,style:"variable_blocks",helpUrl:"%{BKY_VARIABLES_GET_HELPURL}",tooltip:"%{BKY_VARIABLES_GET_TOOLTIP}",extensions:["contextMenu_variableSetterGetter"]},{type:"variables_set",message0:"%{BKY_VARIABLES_SET}",args0:[{type:"field_variable",name:"VAR",variable:"%{BKY_VARIABLES_DEFAULT_NAME}"},{type:"input_value",name:"VALUE"}],previousStatement:null,
	nextStatement:null,style:"variable_blocks",tooltip:"%{BKY_VARIABLES_SET_TOOLTIP}",helpUrl:"%{BKY_VARIABLES_SET_HELPURL}",extensions:["contextMenu_variableSetterGetter"]}]);
	Blockly.Constants.Variables.CUSTOM_CONTEXT_MENU_VARIABLE_GETTER_SETTER_MIXIN={customContextMenu:function(a){if(!this.isInFlyout){if("variables_get"==this.type)var b="variables_set",c=Blockly.Msg.VARIABLES_GET_CREATE_SET;else b="variables_get",c=Blockly.Msg.VARIABLES_SET_CREATE_GET;var d={enabled:0<this.workspace.remainingCapacity()},e=this.getField("VAR").getText();d.text=c.replace("%1",e);c=Blockly.utils.xml.createElement("field");c.setAttribute("name","VAR");c.appendChild(Blockly.utils.xml.createTextNode(e));
	e=Blockly.utils.xml.createElement("block");e.setAttribute("type",b);e.appendChild(c);d.callback=Blockly.ContextMenu.callbackFactory(this,e);a.push(d)}else if("variables_get"==this.type||"variables_get_reporter"==this.type)b={text:Blockly.Msg.RENAME_VARIABLE,enabled:!0,callback:Blockly.Constants.Variables.RENAME_OPTION_CALLBACK_FACTORY(this)},e=this.getField("VAR").getText(),d={text:Blockly.Msg.DELETE_VARIABLE.replace("%1",e),enabled:!0,callback:Blockly.Constants.Variables.DELETE_OPTION_CALLBACK_FACTORY(this)},
	a.unshift(b),a.unshift(d)}};Blockly.Constants.Variables.RENAME_OPTION_CALLBACK_FACTORY=function(a){return function(){var b=a.workspace,c=a.getField("VAR").getVariable();Blockly.Variables.renameVariable(b,c)}};Blockly.Constants.Variables.DELETE_OPTION_CALLBACK_FACTORY=function(a){return function(){var b=a.workspace,c=a.getField("VAR").getVariable();b.deleteVariableById(c.getId());b.refreshToolboxSelection()}};Blockly.Extensions.registerMixin("contextMenu_variableSetterGetter",Blockly.Constants.Variables.CUSTOM_CONTEXT_MENU_VARIABLE_GETTER_SETTER_MIXIN);Blockly.Constants.VariablesDynamic={};Blockly.Constants.VariablesDynamic.HUE=310;
	Blockly.defineBlocksWithJsonArray([{type:"variables_get_dynamic",message0:"%1",args0:[{type:"field_variable",name:"VAR",variable:"%{BKY_VARIABLES_DEFAULT_NAME}"}],output:null,style:"variable_dynamic_blocks",helpUrl:"%{BKY_VARIABLES_GET_HELPURL}",tooltip:"%{BKY_VARIABLES_GET_TOOLTIP}",extensions:["contextMenu_variableDynamicSetterGetter"]},{type:"variables_set_dynamic",message0:"%{BKY_VARIABLES_SET}",args0:[{type:"field_variable",name:"VAR",variable:"%{BKY_VARIABLES_DEFAULT_NAME}"},{type:"input_value",
	name:"VALUE"}],previousStatement:null,nextStatement:null,style:"variable_dynamic_blocks",tooltip:"%{BKY_VARIABLES_SET_TOOLTIP}",helpUrl:"%{BKY_VARIABLES_SET_HELPURL}",extensions:["contextMenu_variableDynamicSetterGetter"]}]);
	Blockly.Constants.VariablesDynamic.CUSTOM_CONTEXT_MENU_VARIABLE_GETTER_SETTER_MIXIN={customContextMenu:function(a){if(!this.isInFlyout){var b=this.getFieldValue("VAR");var c=this.workspace.getVariableById(b).type;if("variables_get_dynamic"==this.type){b="variables_set_dynamic";var d=Blockly.Msg.VARIABLES_GET_CREATE_SET}else b="variables_get_dynamic",d=Blockly.Msg.VARIABLES_SET_CREATE_GET;var e={enabled:0<this.workspace.remainingCapacity()},f=this.getField("VAR").getText();e.text=d.replace("%1",f);
	d=Blockly.utils.xml.createElement("field");d.setAttribute("name","VAR");d.setAttribute("variabletype",c);d.appendChild(Blockly.utils.xml.createTextNode(f));f=Blockly.utils.xml.createElement("block");f.setAttribute("type",b);f.appendChild(d);e.callback=Blockly.ContextMenu.callbackFactory(this,f);a.push(e)}else if("variables_get_dynamic"==this.type||"variables_get_reporter_dynamic"==this.type)b={text:Blockly.Msg.RENAME_VARIABLE,enabled:!0,callback:Blockly.Constants.Variables.RENAME_OPTION_CALLBACK_FACTORY(this)},
	f=this.getField("VAR").getText(),e={text:Blockly.Msg.DELETE_VARIABLE.replace("%1",f),enabled:!0,callback:Blockly.Constants.Variables.DELETE_OPTION_CALLBACK_FACTORY(this)},a.unshift(b),a.unshift(e)},onchange:function(a){a=this.getFieldValue("VAR");a=Blockly.Variables.getVariable(this.workspace,a);"variables_get_dynamic"==this.type?this.outputConnection.setCheck(a.type):this.getInput("VALUE").connection.setCheck(a.type)}};
	Blockly.Constants.VariablesDynamic.RENAME_OPTION_CALLBACK_FACTORY=function(a){return function(){var b=a.workspace,c=a.getField("VAR").getVariable();Blockly.Variables.renameVariable(b,c)}};Blockly.Constants.VariablesDynamic.DELETE_OPTION_CALLBACK_FACTORY=function(a){return function(){var b=a.workspace,c=a.getField("VAR").getVariable();b.deleteVariableById(c.getId());b.refreshToolboxSelection()}};Blockly.Extensions.registerMixin("contextMenu_variableDynamicSetterGetter",Blockly.Constants.VariablesDynamic.CUSTOM_CONTEXT_MENU_VARIABLE_GETTER_SETTER_MIXIN);
	return Blockly.Blocks;
	}));
	
	
	//# sourceMappingURL=blocks_compressed.js.map


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* eslint-disable */
	;(function(root, factory) {
	  if (true) { // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(28), __webpack_require__(35)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') { // Node.js
	    module.exports = factory(require('./core'), require('./javascript_compressed.js'));
	  } else { // Browser
	    root.BlocklyJavaScript = factory(root.Blockly, root.BlocklyJavaScript);
	  }
	}(this, function(Blockly, BlocklyJavaScript) {
	/**
	 * @license
	 * Copyright 2020 Google LLC
	 * SPDX-License-Identifier: Apache-2.0
	 */
	
	/**
	 * @fileoverview JavaScript Generator module.
	 */
	
	/* eslint-disable */
	'use strict';
	
	Blockly.JavaScript = BlocklyJavaScript;
	
	return BlocklyJavaScript;
	})); 


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Do not edit this file; automatically generated by gulp.
	
	/* eslint-disable */
	;(function(root, factory) {
	  if (true) { // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(30)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') { // Node.js
	    module.exports = factory(require('./blockly_compressed.js'));
	  } else { // Browser
	    root.Blockly.JavaScript = factory(root.Blockly);
	  }
	}(this, function(Blockly) {
	  'use strict';Blockly.JavaScript=new Blockly.Generator("JavaScript");Blockly.JavaScript.addReservedWords("break,case,catch,class,const,continue,debugger,default,delete,do,else,export,extends,finally,for,function,if,import,in,instanceof,new,return,super,switch,this,throw,try,typeof,var,void,while,with,yield,enum,implements,interface,let,package,private,protected,public,static,await,null,true,false,arguments,"+Object.getOwnPropertyNames(Blockly.utils.global).join(","));
	Blockly.JavaScript.ORDER_ATOMIC=0;Blockly.JavaScript.ORDER_NEW=1.1;Blockly.JavaScript.ORDER_MEMBER=1.2;Blockly.JavaScript.ORDER_FUNCTION_CALL=2;Blockly.JavaScript.ORDER_INCREMENT=3;Blockly.JavaScript.ORDER_DECREMENT=3;Blockly.JavaScript.ORDER_BITWISE_NOT=4.1;Blockly.JavaScript.ORDER_UNARY_PLUS=4.2;Blockly.JavaScript.ORDER_UNARY_NEGATION=4.3;Blockly.JavaScript.ORDER_LOGICAL_NOT=4.4;Blockly.JavaScript.ORDER_TYPEOF=4.5;Blockly.JavaScript.ORDER_VOID=4.6;Blockly.JavaScript.ORDER_DELETE=4.7;
	Blockly.JavaScript.ORDER_AWAIT=4.8;Blockly.JavaScript.ORDER_EXPONENTIATION=5;Blockly.JavaScript.ORDER_MULTIPLICATION=5.1;Blockly.JavaScript.ORDER_DIVISION=5.2;Blockly.JavaScript.ORDER_MODULUS=5.3;Blockly.JavaScript.ORDER_SUBTRACTION=6.1;Blockly.JavaScript.ORDER_ADDITION=6.2;Blockly.JavaScript.ORDER_BITWISE_SHIFT=7;Blockly.JavaScript.ORDER_RELATIONAL=8;Blockly.JavaScript.ORDER_IN=8;Blockly.JavaScript.ORDER_INSTANCEOF=8;Blockly.JavaScript.ORDER_EQUALITY=9;Blockly.JavaScript.ORDER_BITWISE_AND=10;
	Blockly.JavaScript.ORDER_BITWISE_XOR=11;Blockly.JavaScript.ORDER_BITWISE_OR=12;Blockly.JavaScript.ORDER_LOGICAL_AND=13;Blockly.JavaScript.ORDER_LOGICAL_OR=14;Blockly.JavaScript.ORDER_CONDITIONAL=15;Blockly.JavaScript.ORDER_ASSIGNMENT=16;Blockly.JavaScript.ORDER_YIELD=17;Blockly.JavaScript.ORDER_COMMA=18;Blockly.JavaScript.ORDER_NONE=99;
	Blockly.JavaScript.ORDER_OVERRIDES=[[Blockly.JavaScript.ORDER_FUNCTION_CALL,Blockly.JavaScript.ORDER_MEMBER],[Blockly.JavaScript.ORDER_FUNCTION_CALL,Blockly.JavaScript.ORDER_FUNCTION_CALL],[Blockly.JavaScript.ORDER_MEMBER,Blockly.JavaScript.ORDER_MEMBER],[Blockly.JavaScript.ORDER_MEMBER,Blockly.JavaScript.ORDER_FUNCTION_CALL],[Blockly.JavaScript.ORDER_LOGICAL_NOT,Blockly.JavaScript.ORDER_LOGICAL_NOT],[Blockly.JavaScript.ORDER_MULTIPLICATION,Blockly.JavaScript.ORDER_MULTIPLICATION],[Blockly.JavaScript.ORDER_ADDITION,
	Blockly.JavaScript.ORDER_ADDITION],[Blockly.JavaScript.ORDER_LOGICAL_AND,Blockly.JavaScript.ORDER_LOGICAL_AND],[Blockly.JavaScript.ORDER_LOGICAL_OR,Blockly.JavaScript.ORDER_LOGICAL_OR]];
	Blockly.JavaScript.init=function(a){Blockly.JavaScript.definitions_=Object.create(null);Blockly.JavaScript.functionNames_=Object.create(null);Blockly.JavaScript.variableDB_?Blockly.JavaScript.variableDB_.reset():Blockly.JavaScript.variableDB_=new Blockly.Names(Blockly.JavaScript.RESERVED_WORDS_);Blockly.JavaScript.variableDB_.setVariableMap(a.getVariableMap());for(var b=[],c=Blockly.Variables.allDeveloperVariables(a),d=0;d<c.length;d++)b.push(Blockly.JavaScript.variableDB_.getName(c[d],Blockly.Names.DEVELOPER_VARIABLE_TYPE));
	a=Blockly.Variables.allUsedVarModels(a);for(d=0;d<a.length;d++)b.push(Blockly.JavaScript.variableDB_.getName(a[d].getId(),Blockly.VARIABLE_CATEGORY_NAME));b.length&&(Blockly.JavaScript.definitions_.variables="var "+b.join(", ")+";")};
	Blockly.JavaScript.finish=function(a){var b=[],c;for(c in Blockly.JavaScript.definitions_)b.push(Blockly.JavaScript.definitions_[c]);delete Blockly.JavaScript.definitions_;delete Blockly.JavaScript.functionNames_;Blockly.JavaScript.variableDB_.reset();return b.join("\n\n")+"\n\n\n"+a};Blockly.JavaScript.scrubNakedValue=function(a){return a+";\n"};Blockly.JavaScript.quote_=function(a){a=a.replace(/\\/g,"\\\\").replace(/\n/g,"\\\n").replace(/'/g,"\\'");return"'"+a+"'"};
	Blockly.JavaScript.multiline_quote_=function(a){return a.split(/\n/g).map(Blockly.JavaScript.quote_).join(" + '\\n' +\n")};
	Blockly.JavaScript.scrub_=function(a,b,c){var d="";if(!a.outputConnection||!a.outputConnection.targetConnection){var e=a.getCommentText();e&&(e=Blockly.utils.string.wrap(e,Blockly.JavaScript.COMMENT_WRAP-3),d+=Blockly.JavaScript.prefixLines(e+"\n","// "));for(var f=0;f<a.inputList.length;f++)a.inputList[f].type==Blockly.INPUT_VALUE&&(e=a.inputList[f].connection.targetBlock())&&(e=Blockly.JavaScript.allNestedComments(e))&&(d+=Blockly.JavaScript.prefixLines(e,"// "))}a=a.nextConnection&&a.nextConnection.targetBlock();
	c=c?"":Blockly.JavaScript.blockToCode(a);return d+b+c};
	Blockly.JavaScript.getAdjusted=function(a,b,c,d,e){c=c||0;e=e||Blockly.JavaScript.ORDER_NONE;a.workspace.options.oneBasedIndex&&c--;var f=a.workspace.options.oneBasedIndex?"1":"0";a=0<c?Blockly.JavaScript.valueToCode(a,b,Blockly.JavaScript.ORDER_ADDITION)||f:0>c?Blockly.JavaScript.valueToCode(a,b,Blockly.JavaScript.ORDER_SUBTRACTION)||f:d?Blockly.JavaScript.valueToCode(a,b,Blockly.JavaScript.ORDER_UNARY_NEGATION)||f:Blockly.JavaScript.valueToCode(a,b,e)||f;if(Blockly.isNumber(a))a=Number(a)+c,d&&
	(a=-a);else{if(0<c){a=a+" + "+c;var g=Blockly.JavaScript.ORDER_ADDITION}else 0>c&&(a=a+" - "+-c,g=Blockly.JavaScript.ORDER_SUBTRACTION);d&&(a=c?"-("+a+")":"-"+a,g=Blockly.JavaScript.ORDER_UNARY_NEGATION);g=Math.floor(g);e=Math.floor(e);g&&e>=g&&(a="("+a+")")}return a};Blockly.JavaScript.colour={};Blockly.JavaScript.colour_picker=function(a){return[Blockly.JavaScript.quote_(a.getFieldValue("COLOUR")),Blockly.JavaScript.ORDER_ATOMIC]};Blockly.JavaScript.colour_random=function(a){return[Blockly.JavaScript.provideFunction_("colourRandom",["function "+Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_+"() {","  var num = Math.floor(Math.random() * Math.pow(2, 24));","  return '#' + ('00000' + num.toString(16)).substr(-6);","}"])+"()",Blockly.JavaScript.ORDER_FUNCTION_CALL]};
	Blockly.JavaScript.colour_rgb=function(a){var b=Blockly.JavaScript.valueToCode(a,"RED",Blockly.JavaScript.ORDER_COMMA)||0,c=Blockly.JavaScript.valueToCode(a,"GREEN",Blockly.JavaScript.ORDER_COMMA)||0;a=Blockly.JavaScript.valueToCode(a,"BLUE",Blockly.JavaScript.ORDER_COMMA)||0;return[Blockly.JavaScript.provideFunction_("colourRgb",["function "+Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_+"(r, g, b) {","  r = Math.max(Math.min(Number(r), 100), 0) * 2.55;","  g = Math.max(Math.min(Number(g), 100), 0) * 2.55;",
	"  b = Math.max(Math.min(Number(b), 100), 0) * 2.55;","  r = ('0' + (Math.round(r) || 0).toString(16)).slice(-2);","  g = ('0' + (Math.round(g) || 0).toString(16)).slice(-2);","  b = ('0' + (Math.round(b) || 0).toString(16)).slice(-2);","  return '#' + r + g + b;","}"])+"("+b+", "+c+", "+a+")",Blockly.JavaScript.ORDER_FUNCTION_CALL]};
	Blockly.JavaScript.colour_blend=function(a){var b=Blockly.JavaScript.valueToCode(a,"COLOUR1",Blockly.JavaScript.ORDER_COMMA)||"'#000000'",c=Blockly.JavaScript.valueToCode(a,"COLOUR2",Blockly.JavaScript.ORDER_COMMA)||"'#000000'";a=Blockly.JavaScript.valueToCode(a,"RATIO",Blockly.JavaScript.ORDER_COMMA)||.5;return[Blockly.JavaScript.provideFunction_("colourBlend",["function "+Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_+"(c1, c2, ratio) {","  ratio = Math.max(Math.min(Number(ratio), 1), 0);","  var r1 = parseInt(c1.substring(1, 3), 16);",
	"  var g1 = parseInt(c1.substring(3, 5), 16);","  var b1 = parseInt(c1.substring(5, 7), 16);","  var r2 = parseInt(c2.substring(1, 3), 16);","  var g2 = parseInt(c2.substring(3, 5), 16);","  var b2 = parseInt(c2.substring(5, 7), 16);","  var r = Math.round(r1 * (1 - ratio) + r2 * ratio);","  var g = Math.round(g1 * (1 - ratio) + g2 * ratio);","  var b = Math.round(b1 * (1 - ratio) + b2 * ratio);","  r = ('0' + (r || 0).toString(16)).slice(-2);","  g = ('0' + (g || 0).toString(16)).slice(-2);","  b = ('0' + (b || 0).toString(16)).slice(-2);",
	"  return '#' + r + g + b;","}"])+"("+b+", "+c+", "+a+")",Blockly.JavaScript.ORDER_FUNCTION_CALL]};Blockly.JavaScript.lists={};Blockly.JavaScript.lists_create_empty=function(a){return["[]",Blockly.JavaScript.ORDER_ATOMIC]};Blockly.JavaScript.lists_create_with=function(a){for(var b=Array(a.itemCount_),c=0;c<a.itemCount_;c++)b[c]=Blockly.JavaScript.valueToCode(a,"ADD"+c,Blockly.JavaScript.ORDER_COMMA)||"null";return["["+b.join(", ")+"]",Blockly.JavaScript.ORDER_ATOMIC]};
	Blockly.JavaScript.lists_repeat=function(a){var b=Blockly.JavaScript.provideFunction_("listsRepeat",["function "+Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_+"(value, n) {","  var array = [];","  for (var i = 0; i < n; i++) {","    array[i] = value;","  }","  return array;","}"]),c=Blockly.JavaScript.valueToCode(a,"ITEM",Blockly.JavaScript.ORDER_COMMA)||"null";a=Blockly.JavaScript.valueToCode(a,"NUM",Blockly.JavaScript.ORDER_COMMA)||"0";return[b+"("+c+", "+a+")",Blockly.JavaScript.ORDER_FUNCTION_CALL]};
	Blockly.JavaScript.lists_length=function(a){return[(Blockly.JavaScript.valueToCode(a,"VALUE",Blockly.JavaScript.ORDER_MEMBER)||"[]")+".length",Blockly.JavaScript.ORDER_MEMBER]};Blockly.JavaScript.lists_isEmpty=function(a){return["!"+(Blockly.JavaScript.valueToCode(a,"VALUE",Blockly.JavaScript.ORDER_MEMBER)||"[]")+".length",Blockly.JavaScript.ORDER_LOGICAL_NOT]};
	Blockly.JavaScript.lists_indexOf=function(a){var b="FIRST"==a.getFieldValue("END")?"indexOf":"lastIndexOf",c=Blockly.JavaScript.valueToCode(a,"FIND",Blockly.JavaScript.ORDER_NONE)||"''";b=(Blockly.JavaScript.valueToCode(a,"VALUE",Blockly.JavaScript.ORDER_MEMBER)||"[]")+"."+b+"("+c+")";return a.workspace.options.oneBasedIndex?[b+" + 1",Blockly.JavaScript.ORDER_ADDITION]:[b,Blockly.JavaScript.ORDER_FUNCTION_CALL]};
	Blockly.JavaScript.lists_getIndex=function(a){var b=a.getFieldValue("MODE")||"GET",c=a.getFieldValue("WHERE")||"FROM_START",d=Blockly.JavaScript.valueToCode(a,"VALUE","RANDOM"==c?Blockly.JavaScript.ORDER_COMMA:Blockly.JavaScript.ORDER_MEMBER)||"[]";switch(c){case "FIRST":if("GET"==b)return[d+"[0]",Blockly.JavaScript.ORDER_MEMBER];if("GET_REMOVE"==b)return[d+".shift()",Blockly.JavaScript.ORDER_MEMBER];if("REMOVE"==b)return d+".shift();\n";break;case "LAST":if("GET"==b)return[d+".slice(-1)[0]",Blockly.JavaScript.ORDER_MEMBER];
	if("GET_REMOVE"==b)return[d+".pop()",Blockly.JavaScript.ORDER_MEMBER];if("REMOVE"==b)return d+".pop();\n";break;case "FROM_START":a=Blockly.JavaScript.getAdjusted(a,"AT");if("GET"==b)return[d+"["+a+"]",Blockly.JavaScript.ORDER_MEMBER];if("GET_REMOVE"==b)return[d+".splice("+a+", 1)[0]",Blockly.JavaScript.ORDER_FUNCTION_CALL];if("REMOVE"==b)return d+".splice("+a+", 1);\n";break;case "FROM_END":a=Blockly.JavaScript.getAdjusted(a,"AT",1,!0);if("GET"==b)return[d+".slice("+a+")[0]",Blockly.JavaScript.ORDER_FUNCTION_CALL];
	if("GET_REMOVE"==b)return[d+".splice("+a+", 1)[0]",Blockly.JavaScript.ORDER_FUNCTION_CALL];if("REMOVE"==b)return d+".splice("+a+", 1);";break;case "RANDOM":d=Blockly.JavaScript.provideFunction_("listsGetRandomItem",["function "+Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_+"(list, remove) {","  var x = Math.floor(Math.random() * list.length);","  if (remove) {","    return list.splice(x, 1)[0];","  } else {","    return list[x];","  }","}"])+"("+d+", "+("GET"!=b)+")";if("GET"==b||"GET_REMOVE"==b)return[d,
	Blockly.JavaScript.ORDER_FUNCTION_CALL];if("REMOVE"==b)return d+";\n"}throw Error("Unhandled combination (lists_getIndex).");};
	Blockly.JavaScript.lists_setIndex=function(a){function b(){if(c.match(/^\w+$/))return"";var a=Blockly.JavaScript.variableDB_.getDistinctName("tmpList",Blockly.VARIABLE_CATEGORY_NAME),b="var "+a+" = "+c+";\n";c=a;return b}var c=Blockly.JavaScript.valueToCode(a,"LIST",Blockly.JavaScript.ORDER_MEMBER)||"[]",d=a.getFieldValue("MODE")||"GET",e=a.getFieldValue("WHERE")||"FROM_START",f=Blockly.JavaScript.valueToCode(a,"TO",Blockly.JavaScript.ORDER_ASSIGNMENT)||"null";switch(e){case "FIRST":if("SET"==d)return c+
	"[0] = "+f+";\n";if("INSERT"==d)return c+".unshift("+f+");\n";break;case "LAST":if("SET"==d)return a=b(),a+(c+"["+c+".length - 1] = "+f+";\n");if("INSERT"==d)return c+".push("+f+");\n";break;case "FROM_START":e=Blockly.JavaScript.getAdjusted(a,"AT");if("SET"==d)return c+"["+e+"] = "+f+";\n";if("INSERT"==d)return c+".splice("+e+", 0, "+f+");\n";break;case "FROM_END":e=Blockly.JavaScript.getAdjusted(a,"AT",1,!1,Blockly.JavaScript.ORDER_SUBTRACTION);a=b();if("SET"==d)return a+(c+"["+c+".length - "+e+
	"] = "+f+";\n");if("INSERT"==d)return a+(c+".splice("+c+".length - "+e+", 0, "+f+");\n");break;case "RANDOM":a=b();e=Blockly.JavaScript.variableDB_.getDistinctName("tmpX",Blockly.VARIABLE_CATEGORY_NAME);a+="var "+e+" = Math.floor(Math.random() * "+c+".length);\n";if("SET"==d)return a+(c+"["+e+"] = "+f+";\n");if("INSERT"==d)return a+(c+".splice("+e+", 0, "+f+");\n")}throw Error("Unhandled combination (lists_setIndex).");};
	Blockly.JavaScript.lists.getIndex_=function(a,b,c){return"FIRST"==b?"0":"FROM_END"==b?a+".length - 1 - "+c:"LAST"==b?a+".length - 1":c};
	Blockly.JavaScript.lists_getSublist=function(a){var b=Blockly.JavaScript.valueToCode(a,"LIST",Blockly.JavaScript.ORDER_MEMBER)||"[]",c=a.getFieldValue("WHERE1"),d=a.getFieldValue("WHERE2");if("FIRST"==c&&"LAST"==d)b+=".slice(0)";else if(b.match(/^\w+$/)||"FROM_END"!=c&&"FROM_START"==d){switch(c){case "FROM_START":var e=Blockly.JavaScript.getAdjusted(a,"AT1");break;case "FROM_END":e=Blockly.JavaScript.getAdjusted(a,"AT1",1,!1,Blockly.JavaScript.ORDER_SUBTRACTION);e=b+".length - "+e;break;case "FIRST":e=
	"0";break;default:throw Error("Unhandled option (lists_getSublist).");}switch(d){case "FROM_START":a=Blockly.JavaScript.getAdjusted(a,"AT2",1);break;case "FROM_END":a=Blockly.JavaScript.getAdjusted(a,"AT2",0,!1,Blockly.JavaScript.ORDER_SUBTRACTION);a=b+".length - "+a;break;case "LAST":a=b+".length";break;default:throw Error("Unhandled option (lists_getSublist).");}b=b+".slice("+e+", "+a+")"}else{e=Blockly.JavaScript.getAdjusted(a,"AT1");a=Blockly.JavaScript.getAdjusted(a,"AT2");var f=Blockly.JavaScript.lists.getIndex_,
	g={FIRST:"First",LAST:"Last",FROM_START:"FromStart",FROM_END:"FromEnd"};b=Blockly.JavaScript.provideFunction_("subsequence"+g[c]+g[d],["function "+Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_+"(sequence"+("FROM_END"==c||"FROM_START"==c?", at1":"")+("FROM_END"==d||"FROM_START"==d?", at2":"")+") {","  var start = "+f("sequence",c,"at1")+";","  var end = "+f("sequence",d,"at2")+" + 1;","  return sequence.slice(start, end);","}"])+"("+b+("FROM_END"==c||"FROM_START"==c?", "+e:"")+("FROM_END"==d||"FROM_START"==
	d?", "+a:"")+")"}return[b,Blockly.JavaScript.ORDER_FUNCTION_CALL]};
	Blockly.JavaScript.lists_sort=function(a){var b=Blockly.JavaScript.valueToCode(a,"LIST",Blockly.JavaScript.ORDER_FUNCTION_CALL)||"[]",c="1"===a.getFieldValue("DIRECTION")?1:-1;a=a.getFieldValue("TYPE");var d=Blockly.JavaScript.provideFunction_("listsGetSortCompare",["function "+Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_+"(type, direction) {","  var compareFuncs = {",'    "NUMERIC": function(a, b) {',"        return Number(a) - Number(b); },",'    "TEXT": function(a, b) {',"        return a.toString() > b.toString() ? 1 : -1; },",
	'    "IGNORE_CASE": function(a, b) {',"        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },","  };","  var compare = compareFuncs[type];","  return function(a, b) { return compare(a, b) * direction; }","}"]);return[b+".slice().sort("+d+'("'+a+'", '+c+"))",Blockly.JavaScript.ORDER_FUNCTION_CALL]};
	Blockly.JavaScript.lists_split=function(a){var b=Blockly.JavaScript.valueToCode(a,"INPUT",Blockly.JavaScript.ORDER_MEMBER),c=Blockly.JavaScript.valueToCode(a,"DELIM",Blockly.JavaScript.ORDER_NONE)||"''";a=a.getFieldValue("MODE");if("SPLIT"==a)b||(b="''"),a="split";else if("JOIN"==a)b||(b="[]"),a="join";else throw Error("Unknown mode: "+a);return[b+"."+a+"("+c+")",Blockly.JavaScript.ORDER_FUNCTION_CALL]};
	Blockly.JavaScript.lists_reverse=function(a){return[(Blockly.JavaScript.valueToCode(a,"LIST",Blockly.JavaScript.ORDER_FUNCTION_CALL)||"[]")+".slice().reverse()",Blockly.JavaScript.ORDER_FUNCTION_CALL]};Blockly.JavaScript.logic={};
	Blockly.JavaScript.controls_if=function(a){var b=0,c="";Blockly.JavaScript.STATEMENT_PREFIX&&(c+=Blockly.JavaScript.injectId(Blockly.JavaScript.STATEMENT_PREFIX,a));do{var d=Blockly.JavaScript.valueToCode(a,"IF"+b,Blockly.JavaScript.ORDER_NONE)||"false";var e=Blockly.JavaScript.statementToCode(a,"DO"+b);Blockly.JavaScript.STATEMENT_SUFFIX&&(e=Blockly.JavaScript.prefixLines(Blockly.JavaScript.injectId(Blockly.JavaScript.STATEMENT_SUFFIX,a),Blockly.JavaScript.INDENT)+e);c+=(0<b?" else ":"")+"if ("+
	d+") {\n"+e+"}";++b}while(a.getInput("IF"+b));if(a.getInput("ELSE")||Blockly.JavaScript.STATEMENT_SUFFIX)e=Blockly.JavaScript.statementToCode(a,"ELSE"),Blockly.JavaScript.STATEMENT_SUFFIX&&(e=Blockly.JavaScript.prefixLines(Blockly.JavaScript.injectId(Blockly.JavaScript.STATEMENT_SUFFIX,a),Blockly.JavaScript.INDENT)+e),c+=" else {\n"+e+"}";return c+"\n"};Blockly.JavaScript.controls_ifelse=Blockly.JavaScript.controls_if;
	Blockly.JavaScript.logic_compare=function(a){var b={EQ:"==",NEQ:"!=",LT:"<",LTE:"<=",GT:">",GTE:">="}[a.getFieldValue("OP")],c="=="==b||"!="==b?Blockly.JavaScript.ORDER_EQUALITY:Blockly.JavaScript.ORDER_RELATIONAL,d=Blockly.JavaScript.valueToCode(a,"A",c)||"0";a=Blockly.JavaScript.valueToCode(a,"B",c)||"0";return[d+" "+b+" "+a,c]};
	Blockly.JavaScript.logic_operation=function(a){var b="AND"==a.getFieldValue("OP")?"&&":"||",c="&&"==b?Blockly.JavaScript.ORDER_LOGICAL_AND:Blockly.JavaScript.ORDER_LOGICAL_OR,d=Blockly.JavaScript.valueToCode(a,"A",c);a=Blockly.JavaScript.valueToCode(a,"B",c);if(d||a){var e="&&"==b?"true":"false";d||(d=e);a||(a=e)}else a=d="false";return[d+" "+b+" "+a,c]};
	Blockly.JavaScript.logic_negate=function(a){var b=Blockly.JavaScript.ORDER_LOGICAL_NOT;return["!"+(Blockly.JavaScript.valueToCode(a,"BOOL",b)||"true"),b]};Blockly.JavaScript.logic_boolean=function(a){return["TRUE"==a.getFieldValue("BOOL")?"true":"false",Blockly.JavaScript.ORDER_ATOMIC]};Blockly.JavaScript.logic_null=function(a){return["null",Blockly.JavaScript.ORDER_ATOMIC]};
	Blockly.JavaScript.logic_ternary=function(a){var b=Blockly.JavaScript.valueToCode(a,"IF",Blockly.JavaScript.ORDER_CONDITIONAL)||"false",c=Blockly.JavaScript.valueToCode(a,"THEN",Blockly.JavaScript.ORDER_CONDITIONAL)||"null";a=Blockly.JavaScript.valueToCode(a,"ELSE",Blockly.JavaScript.ORDER_CONDITIONAL)||"null";return[b+" ? "+c+" : "+a,Blockly.JavaScript.ORDER_CONDITIONAL]};Blockly.JavaScript.loops={};
	Blockly.JavaScript.controls_repeat_ext=function(a){var b=a.getField("TIMES")?String(Number(a.getFieldValue("TIMES"))):Blockly.JavaScript.valueToCode(a,"TIMES",Blockly.JavaScript.ORDER_ASSIGNMENT)||"0",c=Blockly.JavaScript.statementToCode(a,"DO");c=Blockly.JavaScript.addLoopTrap(c,a);a="";var d=Blockly.JavaScript.variableDB_.getDistinctName("count",Blockly.VARIABLE_CATEGORY_NAME),e=b;b.match(/^\w+$/)||Blockly.isNumber(b)||(e=Blockly.JavaScript.variableDB_.getDistinctName("repeat_end",Blockly.VARIABLE_CATEGORY_NAME),
	a+="var "+e+" = "+b+";\n");return a+("for (var "+d+" = 0; "+d+" < "+e+"; "+d+"++) {\n"+c+"}\n")};Blockly.JavaScript.controls_repeat=Blockly.JavaScript.controls_repeat_ext;
	Blockly.JavaScript.controls_whileUntil=function(a){var b="UNTIL"==a.getFieldValue("MODE"),c=Blockly.JavaScript.valueToCode(a,"BOOL",b?Blockly.JavaScript.ORDER_LOGICAL_NOT:Blockly.JavaScript.ORDER_NONE)||"false",d=Blockly.JavaScript.statementToCode(a,"DO");d=Blockly.JavaScript.addLoopTrap(d,a);b&&(c="!"+c);return"while ("+c+") {\n"+d+"}\n"};
	Blockly.JavaScript.controls_for=function(a){var b=Blockly.JavaScript.variableDB_.getName(a.getFieldValue("VAR"),Blockly.VARIABLE_CATEGORY_NAME),c=Blockly.JavaScript.valueToCode(a,"FROM",Blockly.JavaScript.ORDER_ASSIGNMENT)||"0",d=Blockly.JavaScript.valueToCode(a,"TO",Blockly.JavaScript.ORDER_ASSIGNMENT)||"0",e=Blockly.JavaScript.valueToCode(a,"BY",Blockly.JavaScript.ORDER_ASSIGNMENT)||"1",f=Blockly.JavaScript.statementToCode(a,"DO");f=Blockly.JavaScript.addLoopTrap(f,a);if(Blockly.isNumber(c)&&Blockly.isNumber(d)&&
	Blockly.isNumber(e)){var g=Number(c)<=Number(d);a="for ("+b+" = "+c+"; "+b+(g?" <= ":" >= ")+d+"; "+b;b=Math.abs(Number(e));a=(1==b?a+(g?"++":"--"):a+((g?" += ":" -= ")+b))+(") {\n"+f+"}\n")}else a="",g=c,c.match(/^\w+$/)||Blockly.isNumber(c)||(g=Blockly.JavaScript.variableDB_.getDistinctName(b+"_start",Blockly.VARIABLE_CATEGORY_NAME),a+="var "+g+" = "+c+";\n"),c=d,d.match(/^\w+$/)||Blockly.isNumber(d)||(c=Blockly.JavaScript.variableDB_.getDistinctName(b+"_end",Blockly.VARIABLE_CATEGORY_NAME),a+=
	"var "+c+" = "+d+";\n"),d=Blockly.JavaScript.variableDB_.getDistinctName(b+"_inc",Blockly.VARIABLE_CATEGORY_NAME),a+="var "+d+" = ",a=Blockly.isNumber(e)?a+(Math.abs(e)+";\n"):a+("Math.abs("+e+");\n"),a=a+("if ("+g+" > "+c+") {\n")+(Blockly.JavaScript.INDENT+d+" = -"+d+";\n"),a+="}\n",a+="for ("+b+" = "+g+"; "+d+" >= 0 ? "+b+" <= "+c+" : "+b+" >= "+c+"; "+b+" += "+d+") {\n"+f+"}\n";return a};
	Blockly.JavaScript.controls_forEach=function(a){var b=Blockly.JavaScript.variableDB_.getName(a.getFieldValue("VAR"),Blockly.VARIABLE_CATEGORY_NAME),c=Blockly.JavaScript.valueToCode(a,"LIST",Blockly.JavaScript.ORDER_ASSIGNMENT)||"[]",d=Blockly.JavaScript.statementToCode(a,"DO");d=Blockly.JavaScript.addLoopTrap(d,a);a="";var e=c;c.match(/^\w+$/)||(e=Blockly.JavaScript.variableDB_.getDistinctName(b+"_list",Blockly.VARIABLE_CATEGORY_NAME),a+="var "+e+" = "+c+";\n");c=Blockly.JavaScript.variableDB_.getDistinctName(b+
	"_index",Blockly.VARIABLE_CATEGORY_NAME);d=Blockly.JavaScript.INDENT+b+" = "+e+"["+c+"];\n"+d;return a+("for (var "+c+" in "+e+") {\n"+d+"}\n")};
	Blockly.JavaScript.controls_flow_statements=function(a){var b="";Blockly.JavaScript.STATEMENT_PREFIX&&(b+=Blockly.JavaScript.injectId(Blockly.JavaScript.STATEMENT_PREFIX,a));Blockly.JavaScript.STATEMENT_SUFFIX&&(b+=Blockly.JavaScript.injectId(Blockly.JavaScript.STATEMENT_SUFFIX,a));if(Blockly.JavaScript.STATEMENT_PREFIX){var c=Blockly.Constants.Loops.CONTROL_FLOW_IN_LOOP_CHECK_MIXIN.getSurroundLoop(a);c&&!c.suppressPrefixSuffix&&(b+=Blockly.JavaScript.injectId(Blockly.JavaScript.STATEMENT_PREFIX,
	c))}switch(a.getFieldValue("FLOW")){case "BREAK":return b+"break;\n";case "CONTINUE":return b+"continue;\n"}throw Error("Unknown flow statement.");};Blockly.JavaScript.math={};Blockly.JavaScript.math_number=function(a){a=Number(a.getFieldValue("NUM"));return[a,0<=a?Blockly.JavaScript.ORDER_ATOMIC:Blockly.JavaScript.ORDER_UNARY_NEGATION]};
	Blockly.JavaScript.math_arithmetic=function(a){var b={ADD:[" + ",Blockly.JavaScript.ORDER_ADDITION],MINUS:[" - ",Blockly.JavaScript.ORDER_SUBTRACTION],MULTIPLY:[" * ",Blockly.JavaScript.ORDER_MULTIPLICATION],DIVIDE:[" / ",Blockly.JavaScript.ORDER_DIVISION],POWER:[null,Blockly.JavaScript.ORDER_COMMA]}[a.getFieldValue("OP")],c=b[0];b=b[1];var d=Blockly.JavaScript.valueToCode(a,"A",b)||"0";a=Blockly.JavaScript.valueToCode(a,"B",b)||"0";return c?[d+c+a,b]:["Math.pow("+d+", "+a+")",Blockly.JavaScript.ORDER_FUNCTION_CALL]};
	Blockly.JavaScript.math_single=function(a){var b=a.getFieldValue("OP");if("NEG"==b)return a=Blockly.JavaScript.valueToCode(a,"NUM",Blockly.JavaScript.ORDER_UNARY_NEGATION)||"0","-"==a[0]&&(a=" "+a),["-"+a,Blockly.JavaScript.ORDER_UNARY_NEGATION];a="SIN"==b||"COS"==b||"TAN"==b?Blockly.JavaScript.valueToCode(a,"NUM",Blockly.JavaScript.ORDER_DIVISION)||"0":Blockly.JavaScript.valueToCode(a,"NUM",Blockly.JavaScript.ORDER_NONE)||"0";switch(b){case "ABS":var c="Math.abs("+a+")";break;case "ROOT":c="Math.sqrt("+
	a+")";break;case "LN":c="Math.log("+a+")";break;case "EXP":c="Math.exp("+a+")";break;case "POW10":c="Math.pow(10,"+a+")";break;case "ROUND":c="Math.round("+a+")";break;case "ROUNDUP":c="Math.ceil("+a+")";break;case "ROUNDDOWN":c="Math.floor("+a+")";break;case "SIN":c="Math.sin("+a+" / 180 * Math.PI)";break;case "COS":c="Math.cos("+a+" / 180 * Math.PI)";break;case "TAN":c="Math.tan("+a+" / 180 * Math.PI)"}if(c)return[c,Blockly.JavaScript.ORDER_FUNCTION_CALL];switch(b){case "LOG10":c="Math.log("+a+
	") / Math.log(10)";break;case "ASIN":c="Math.asin("+a+") / Math.PI * 180";break;case "ACOS":c="Math.acos("+a+") / Math.PI * 180";break;case "ATAN":c="Math.atan("+a+") / Math.PI * 180";break;default:throw Error("Unknown math operator: "+b);}return[c,Blockly.JavaScript.ORDER_DIVISION]};
	Blockly.JavaScript.math_constant=function(a){return{PI:["Math.PI",Blockly.JavaScript.ORDER_MEMBER],E:["Math.E",Blockly.JavaScript.ORDER_MEMBER],GOLDEN_RATIO:["(1 + Math.sqrt(5)) / 2",Blockly.JavaScript.ORDER_DIVISION],SQRT2:["Math.SQRT2",Blockly.JavaScript.ORDER_MEMBER],SQRT1_2:["Math.SQRT1_2",Blockly.JavaScript.ORDER_MEMBER],INFINITY:["Infinity",Blockly.JavaScript.ORDER_ATOMIC]}[a.getFieldValue("CONSTANT")]};
	Blockly.JavaScript.math_number_property=function(a){var b=Blockly.JavaScript.valueToCode(a,"NUMBER_TO_CHECK",Blockly.JavaScript.ORDER_MODULUS)||"0",c=a.getFieldValue("PROPERTY");if("PRIME"==c)return[Blockly.JavaScript.provideFunction_("mathIsPrime",["function "+Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_+"(n) {","  // https://en.wikipedia.org/wiki/Primality_test#Naive_methods","  if (n == 2 || n == 3) {","    return true;","  }","  // False if n is NaN, negative, is 1, or not whole.","  // And false if n is divisible by 2 or 3.",
	"  if (isNaN(n) || n <= 1 || n % 1 != 0 || n % 2 == 0 || n % 3 == 0) {","    return false;","  }","  // Check all the numbers of form 6k +/- 1, up to sqrt(n).","  for (var x = 6; x <= Math.sqrt(n) + 1; x += 6) {","    if (n % (x - 1) == 0 || n % (x + 1) == 0) {","      return false;","    }","  }","  return true;","}"])+"("+b+")",Blockly.JavaScript.ORDER_FUNCTION_CALL];switch(c){case "EVEN":var d=b+" % 2 == 0";break;case "ODD":d=b+" % 2 == 1";break;case "WHOLE":d=b+" % 1 == 0";break;case "POSITIVE":d=
	b+" > 0";break;case "NEGATIVE":d=b+" < 0";break;case "DIVISIBLE_BY":a=Blockly.JavaScript.valueToCode(a,"DIVISOR",Blockly.JavaScript.ORDER_MODULUS)||"0",d=b+" % "+a+" == 0"}return[d,Blockly.JavaScript.ORDER_EQUALITY]};
	Blockly.JavaScript.math_change=function(a){var b=Blockly.JavaScript.valueToCode(a,"DELTA",Blockly.JavaScript.ORDER_ADDITION)||"0";a=Blockly.JavaScript.variableDB_.getName(a.getFieldValue("VAR"),Blockly.VARIABLE_CATEGORY_NAME);return a+" = (typeof "+a+" == 'number' ? "+a+" : 0) + "+b+";\n"};Blockly.JavaScript.math_round=Blockly.JavaScript.math_single;Blockly.JavaScript.math_trig=Blockly.JavaScript.math_single;
	Blockly.JavaScript.math_on_list=function(a){var b=a.getFieldValue("OP");switch(b){case "SUM":a=Blockly.JavaScript.valueToCode(a,"LIST",Blockly.JavaScript.ORDER_MEMBER)||"[]";a+=".reduce(function(x, y) {return x + y;})";break;case "MIN":a=Blockly.JavaScript.valueToCode(a,"LIST",Blockly.JavaScript.ORDER_COMMA)||"[]";a="Math.min.apply(null, "+a+")";break;case "MAX":a=Blockly.JavaScript.valueToCode(a,"LIST",Blockly.JavaScript.ORDER_COMMA)||"[]";a="Math.max.apply(null, "+a+")";break;case "AVERAGE":b=Blockly.JavaScript.provideFunction_("mathMean",
	["function "+Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_+"(myList) {","  return myList.reduce(function(x, y) {return x + y;}) / myList.length;","}"]);a=Blockly.JavaScript.valueToCode(a,"LIST",Blockly.JavaScript.ORDER_NONE)||"[]";a=b+"("+a+")";break;case "MEDIAN":b=Blockly.JavaScript.provideFunction_("mathMedian",["function "+Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_+"(myList) {","  var localList = myList.filter(function (x) {return typeof x == 'number';});","  if (!localList.length) return null;",
	"  localList.sort(function(a, b) {return b - a;});","  if (localList.length % 2 == 0) {","    return (localList[localList.length / 2 - 1] + localList[localList.length / 2]) / 2;","  } else {","    return localList[(localList.length - 1) / 2];","  }","}"]);a=Blockly.JavaScript.valueToCode(a,"LIST",Blockly.JavaScript.ORDER_NONE)||"[]";a=b+"("+a+")";break;case "MODE":b=Blockly.JavaScript.provideFunction_("mathModes",["function "+Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_+"(values) {","  var modes = [];",
	"  var counts = [];","  var maxCount = 0;","  for (var i = 0; i < values.length; i++) {","    var value = values[i];","    var found = false;","    var thisCount;","    for (var j = 0; j < counts.length; j++) {","      if (counts[j][0] === value) {","        thisCount = ++counts[j][1];","        found = true;","        break;","      }","    }","    if (!found) {","      counts.push([value, 1]);","      thisCount = 1;","    }","    maxCount = Math.max(thisCount, maxCount);","  }","  for (var j = 0; j < counts.length; j++) {",
	"    if (counts[j][1] == maxCount) {","        modes.push(counts[j][0]);","    }","  }","  return modes;","}"]);a=Blockly.JavaScript.valueToCode(a,"LIST",Blockly.JavaScript.ORDER_NONE)||"[]";a=b+"("+a+")";break;case "STD_DEV":b=Blockly.JavaScript.provideFunction_("mathStandardDeviation",["function "+Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_+"(numbers) {","  var n = numbers.length;","  if (!n) return null;","  var mean = numbers.reduce(function(x, y) {return x + y;}) / n;","  var variance = 0;",
	"  for (var j = 0; j < n; j++) {","    variance += Math.pow(numbers[j] - mean, 2);","  }","  variance = variance / n;","  return Math.sqrt(variance);","}"]);a=Blockly.JavaScript.valueToCode(a,"LIST",Blockly.JavaScript.ORDER_NONE)||"[]";a=b+"("+a+")";break;case "RANDOM":b=Blockly.JavaScript.provideFunction_("mathRandomList",["function "+Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_+"(list) {","  var x = Math.floor(Math.random() * list.length);","  return list[x];","}"]);a=Blockly.JavaScript.valueToCode(a,
	"LIST",Blockly.JavaScript.ORDER_NONE)||"[]";a=b+"("+a+")";break;default:throw Error("Unknown operator: "+b);}return[a,Blockly.JavaScript.ORDER_FUNCTION_CALL]};Blockly.JavaScript.math_modulo=function(a){var b=Blockly.JavaScript.valueToCode(a,"DIVIDEND",Blockly.JavaScript.ORDER_MODULUS)||"0";a=Blockly.JavaScript.valueToCode(a,"DIVISOR",Blockly.JavaScript.ORDER_MODULUS)||"0";return[b+" % "+a,Blockly.JavaScript.ORDER_MODULUS]};
	Blockly.JavaScript.math_constrain=function(a){var b=Blockly.JavaScript.valueToCode(a,"VALUE",Blockly.JavaScript.ORDER_COMMA)||"0",c=Blockly.JavaScript.valueToCode(a,"LOW",Blockly.JavaScript.ORDER_COMMA)||"0";a=Blockly.JavaScript.valueToCode(a,"HIGH",Blockly.JavaScript.ORDER_COMMA)||"Infinity";return["Math.min(Math.max("+b+", "+c+"), "+a+")",Blockly.JavaScript.ORDER_FUNCTION_CALL]};
	Blockly.JavaScript.math_random_int=function(a){var b=Blockly.JavaScript.valueToCode(a,"FROM",Blockly.JavaScript.ORDER_COMMA)||"0";a=Blockly.JavaScript.valueToCode(a,"TO",Blockly.JavaScript.ORDER_COMMA)||"0";return[Blockly.JavaScript.provideFunction_("mathRandomInt",["function "+Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_+"(a, b) {","  if (a > b) {","    // Swap a and b to ensure a is smaller.","    var c = a;","    a = b;","    b = c;","  }","  return Math.floor(Math.random() * (b - a + 1) + a);",
	"}"])+"("+b+", "+a+")",Blockly.JavaScript.ORDER_FUNCTION_CALL]};Blockly.JavaScript.math_random_float=function(a){return["Math.random()",Blockly.JavaScript.ORDER_FUNCTION_CALL]};Blockly.JavaScript.math_atan2=function(a){var b=Blockly.JavaScript.valueToCode(a,"X",Blockly.JavaScript.ORDER_COMMA)||"0";return["Math.atan2("+(Blockly.JavaScript.valueToCode(a,"Y",Blockly.JavaScript.ORDER_COMMA)||"0")+", "+b+") / Math.PI * 180",Blockly.JavaScript.ORDER_DIVISION]};Blockly.JavaScript.procedures={};
	Blockly.JavaScript.procedures_defreturn=function(a){var b=Blockly.JavaScript.variableDB_.getName(a.getFieldValue("NAME"),Blockly.PROCEDURE_CATEGORY_NAME),c="";Blockly.JavaScript.STATEMENT_PREFIX&&(c+=Blockly.JavaScript.injectId(Blockly.JavaScript.STATEMENT_PREFIX,a));Blockly.JavaScript.STATEMENT_SUFFIX&&(c+=Blockly.JavaScript.injectId(Blockly.JavaScript.STATEMENT_SUFFIX,a));c&&(c=Blockly.JavaScript.prefixLines(c,Blockly.JavaScript.INDENT));var d="";Blockly.JavaScript.INFINITE_LOOP_TRAP&&(d=Blockly.JavaScript.prefixLines(Blockly.JavaScript.injectId(Blockly.JavaScript.INFINITE_LOOP_TRAP,
	a),Blockly.JavaScript.INDENT));var e=Blockly.JavaScript.statementToCode(a,"STACK"),f=Blockly.JavaScript.valueToCode(a,"RETURN",Blockly.JavaScript.ORDER_NONE)||"",g="";e&&f&&(g=c);f&&(f=Blockly.JavaScript.INDENT+"return "+f+";\n");for(var k=[],l=a.getVars(),h=0;h<l.length;h++)k[h]=Blockly.JavaScript.variableDB_.getName(l[h],Blockly.VARIABLE_CATEGORY_NAME);c="function "+b+"("+k.join(", ")+") {\n"+c+d+e+g+f+"}";c=Blockly.JavaScript.scrub_(a,c);Blockly.JavaScript.definitions_["%"+b]=c;return null};
	Blockly.JavaScript.procedures_defnoreturn=Blockly.JavaScript.procedures_defreturn;Blockly.JavaScript.procedures_callreturn=function(a){for(var b=Blockly.JavaScript.variableDB_.getName(a.getFieldValue("NAME"),Blockly.PROCEDURE_CATEGORY_NAME),c=[],d=a.getVars(),e=0;e<d.length;e++)c[e]=Blockly.JavaScript.valueToCode(a,"ARG"+e,Blockly.JavaScript.ORDER_COMMA)||"null";return[b+"("+c.join(", ")+")",Blockly.JavaScript.ORDER_FUNCTION_CALL]};
	Blockly.JavaScript.procedures_callnoreturn=function(a){return Blockly.JavaScript.procedures_callreturn(a)[0]+";\n"};
	Blockly.JavaScript.procedures_ifreturn=function(a){var b="if ("+(Blockly.JavaScript.valueToCode(a,"CONDITION",Blockly.JavaScript.ORDER_NONE)||"false")+") {\n";Blockly.JavaScript.STATEMENT_SUFFIX&&(b+=Blockly.JavaScript.prefixLines(Blockly.JavaScript.injectId(Blockly.JavaScript.STATEMENT_SUFFIX,a),Blockly.JavaScript.INDENT));a.hasReturnValue_?(a=Blockly.JavaScript.valueToCode(a,"VALUE",Blockly.JavaScript.ORDER_NONE)||"null",b+=Blockly.JavaScript.INDENT+"return "+a+";\n"):b+=Blockly.JavaScript.INDENT+
	"return;\n";return b+"}\n"};Blockly.JavaScript.texts={};Blockly.JavaScript.text=function(a){return[Blockly.JavaScript.quote_(a.getFieldValue("TEXT")),Blockly.JavaScript.ORDER_ATOMIC]};Blockly.JavaScript.text_multiline=function(a){a=Blockly.JavaScript.multiline_quote_(a.getFieldValue("TEXT"));-1!=a.indexOf("\n")&&(a="("+a+")");return[a,Blockly.JavaScript.ORDER_ATOMIC]};Blockly.JavaScript.text.forceString_=function(a){return Blockly.JavaScript.text.forceString_.strRegExp.test(a)?a:"String("+a+")"};
	Blockly.JavaScript.text.forceString_.strRegExp=/^\s*'([^']|\\')*'\s*$/;
	Blockly.JavaScript.text_join=function(a){switch(a.itemCount_){case 0:return["''",Blockly.JavaScript.ORDER_ATOMIC];case 1:return a=Blockly.JavaScript.valueToCode(a,"ADD0",Blockly.JavaScript.ORDER_NONE)||"''",a=Blockly.JavaScript.text.forceString_(a),[a,Blockly.JavaScript.ORDER_FUNCTION_CALL];case 2:var b=Blockly.JavaScript.valueToCode(a,"ADD0",Blockly.JavaScript.ORDER_NONE)||"''";a=Blockly.JavaScript.valueToCode(a,"ADD1",Blockly.JavaScript.ORDER_NONE)||"''";a=Blockly.JavaScript.text.forceString_(b)+
	" + "+Blockly.JavaScript.text.forceString_(a);return[a,Blockly.JavaScript.ORDER_ADDITION];default:b=Array(a.itemCount_);for(var c=0;c<a.itemCount_;c++)b[c]=Blockly.JavaScript.valueToCode(a,"ADD"+c,Blockly.JavaScript.ORDER_COMMA)||"''";a="["+b.join(",")+"].join('')";return[a,Blockly.JavaScript.ORDER_FUNCTION_CALL]}};
	Blockly.JavaScript.text_append=function(a){var b=Blockly.JavaScript.variableDB_.getName(a.getFieldValue("VAR"),Blockly.VARIABLE_CATEGORY_NAME);a=Blockly.JavaScript.valueToCode(a,"TEXT",Blockly.JavaScript.ORDER_NONE)||"''";return b+" += "+Blockly.JavaScript.text.forceString_(a)+";\n"};Blockly.JavaScript.text_length=function(a){return[(Blockly.JavaScript.valueToCode(a,"VALUE",Blockly.JavaScript.ORDER_FUNCTION_CALL)||"''")+".length",Blockly.JavaScript.ORDER_MEMBER]};
	Blockly.JavaScript.text_isEmpty=function(a){return["!"+(Blockly.JavaScript.valueToCode(a,"VALUE",Blockly.JavaScript.ORDER_MEMBER)||"''")+".length",Blockly.JavaScript.ORDER_LOGICAL_NOT]};
	Blockly.JavaScript.text_indexOf=function(a){var b="FIRST"==a.getFieldValue("END")?"indexOf":"lastIndexOf",c=Blockly.JavaScript.valueToCode(a,"FIND",Blockly.JavaScript.ORDER_NONE)||"''";b=(Blockly.JavaScript.valueToCode(a,"VALUE",Blockly.JavaScript.ORDER_MEMBER)||"''")+"."+b+"("+c+")";return a.workspace.options.oneBasedIndex?[b+" + 1",Blockly.JavaScript.ORDER_ADDITION]:[b,Blockly.JavaScript.ORDER_FUNCTION_CALL]};
	Blockly.JavaScript.text_charAt=function(a){var b=a.getFieldValue("WHERE")||"FROM_START",c=Blockly.JavaScript.valueToCode(a,"VALUE","RANDOM"==b?Blockly.JavaScript.ORDER_NONE:Blockly.JavaScript.ORDER_MEMBER)||"''";switch(b){case "FIRST":return[c+".charAt(0)",Blockly.JavaScript.ORDER_FUNCTION_CALL];case "LAST":return[c+".slice(-1)",Blockly.JavaScript.ORDER_FUNCTION_CALL];case "FROM_START":return a=Blockly.JavaScript.getAdjusted(a,"AT"),[c+".charAt("+a+")",Blockly.JavaScript.ORDER_FUNCTION_CALL];case "FROM_END":return a=
	Blockly.JavaScript.getAdjusted(a,"AT",1,!0),[c+".slice("+a+").charAt(0)",Blockly.JavaScript.ORDER_FUNCTION_CALL];case "RANDOM":return[Blockly.JavaScript.provideFunction_("textRandomLetter",["function "+Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_+"(text) {","  var x = Math.floor(Math.random() * text.length);","  return text[x];","}"])+"("+c+")",Blockly.JavaScript.ORDER_FUNCTION_CALL]}throw Error("Unhandled option (text_charAt).");};
	Blockly.JavaScript.text.getIndex_=function(a,b,c){return"FIRST"==b?"0":"FROM_END"==b?a+".length - 1 - "+c:"LAST"==b?a+".length - 1":c};
	Blockly.JavaScript.text_getSubstring=function(a){var b=Blockly.JavaScript.valueToCode(a,"STRING",Blockly.JavaScript.ORDER_FUNCTION_CALL)||"''",c=a.getFieldValue("WHERE1"),d=a.getFieldValue("WHERE2");if("FIRST"!=c||"LAST"!=d)if(b.match(/^'?\w+'?$/)||"FROM_END"!=c&&"LAST"!=c&&"FROM_END"!=d&&"LAST"!=d){switch(c){case "FROM_START":var e=Blockly.JavaScript.getAdjusted(a,"AT1");break;case "FROM_END":e=Blockly.JavaScript.getAdjusted(a,"AT1",1,!1,Blockly.JavaScript.ORDER_SUBTRACTION);e=b+".length - "+e;break;
	case "FIRST":e="0";break;default:throw Error("Unhandled option (text_getSubstring).");}switch(d){case "FROM_START":a=Blockly.JavaScript.getAdjusted(a,"AT2",1);break;case "FROM_END":a=Blockly.JavaScript.getAdjusted(a,"AT2",0,!1,Blockly.JavaScript.ORDER_SUBTRACTION);a=b+".length - "+a;break;case "LAST":a=b+".length";break;default:throw Error("Unhandled option (text_getSubstring).");}b=b+".slice("+e+", "+a+")"}else{e=Blockly.JavaScript.getAdjusted(a,"AT1");a=Blockly.JavaScript.getAdjusted(a,"AT2");var f=
	Blockly.JavaScript.text.getIndex_,g={FIRST:"First",LAST:"Last",FROM_START:"FromStart",FROM_END:"FromEnd"};b=Blockly.JavaScript.provideFunction_("subsequence"+g[c]+g[d],["function "+Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_+"(sequence"+("FROM_END"==c||"FROM_START"==c?", at1":"")+("FROM_END"==d||"FROM_START"==d?", at2":"")+") {","  var start = "+f("sequence",c,"at1")+";","  var end = "+f("sequence",d,"at2")+" + 1;","  return sequence.slice(start, end);","}"])+"("+b+("FROM_END"==c||"FROM_START"==
	c?", "+e:"")+("FROM_END"==d||"FROM_START"==d?", "+a:"")+")"}return[b,Blockly.JavaScript.ORDER_FUNCTION_CALL]};
	Blockly.JavaScript.text_changeCase=function(a){var b={UPPERCASE:".toUpperCase()",LOWERCASE:".toLowerCase()",TITLECASE:null}[a.getFieldValue("CASE")];a=Blockly.JavaScript.valueToCode(a,"TEXT",b?Blockly.JavaScript.ORDER_MEMBER:Blockly.JavaScript.ORDER_NONE)||"''";return[b?a+b:Blockly.JavaScript.provideFunction_("textToTitleCase",["function "+Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_+"(str) {","  return str.replace(/\\S+/g,","      function(txt) {return txt[0].toUpperCase() + txt.substring(1).toLowerCase();});",
	"}"])+"("+a+")",Blockly.JavaScript.ORDER_FUNCTION_CALL]};Blockly.JavaScript.text_trim=function(a){var b={LEFT:".replace(/^[\\s\\xa0]+/, '')",RIGHT:".replace(/[\\s\\xa0]+$/, '')",BOTH:".trim()"}[a.getFieldValue("MODE")];return[(Blockly.JavaScript.valueToCode(a,"TEXT",Blockly.JavaScript.ORDER_MEMBER)||"''")+b,Blockly.JavaScript.ORDER_FUNCTION_CALL]};Blockly.JavaScript.text_print=function(a){return"window.alert("+(Blockly.JavaScript.valueToCode(a,"TEXT",Blockly.JavaScript.ORDER_NONE)||"''")+");\n"};
	Blockly.JavaScript.text_prompt_ext=function(a){var b="window.prompt("+(a.getField("TEXT")?Blockly.JavaScript.quote_(a.getFieldValue("TEXT")):Blockly.JavaScript.valueToCode(a,"TEXT",Blockly.JavaScript.ORDER_NONE)||"''")+")";"NUMBER"==a.getFieldValue("TYPE")&&(b="Number("+b+")");return[b,Blockly.JavaScript.ORDER_FUNCTION_CALL]};Blockly.JavaScript.text_prompt=Blockly.JavaScript.text_prompt_ext;
	Blockly.JavaScript.text_count=function(a){var b=Blockly.JavaScript.valueToCode(a,"TEXT",Blockly.JavaScript.ORDER_MEMBER)||"''";a=Blockly.JavaScript.valueToCode(a,"SUB",Blockly.JavaScript.ORDER_NONE)||"''";return[Blockly.JavaScript.provideFunction_("textCount",["function "+Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_+"(haystack, needle) {","  if (needle.length === 0) {","    return haystack.length + 1;","  } else {","    return haystack.split(needle).length - 1;","  }","}"])+"("+b+", "+a+")",Blockly.JavaScript.ORDER_SUBTRACTION]};
	Blockly.JavaScript.text_replace=function(a){var b=Blockly.JavaScript.valueToCode(a,"TEXT",Blockly.JavaScript.ORDER_MEMBER)||"''",c=Blockly.JavaScript.valueToCode(a,"FROM",Blockly.JavaScript.ORDER_NONE)||"''";a=Blockly.JavaScript.valueToCode(a,"TO",Blockly.JavaScript.ORDER_NONE)||"''";return[Blockly.JavaScript.provideFunction_("textReplace",["function "+Blockly.JavaScript.FUNCTION_NAME_PLACEHOLDER_+"(haystack, needle, replacement) {",'  needle = needle.replace(/([-()\\[\\]{}+?*.$\\^|,:#<!\\\\])/g,"\\\\$1")',
	'                 .replace(/\\x08/g,"\\\\x08");',"  return haystack.replace(new RegExp(needle, 'g'), replacement);","}"])+"("+b+", "+c+", "+a+")",Blockly.JavaScript.ORDER_MEMBER]};Blockly.JavaScript.text_reverse=function(a){return[(Blockly.JavaScript.valueToCode(a,"TEXT",Blockly.JavaScript.ORDER_MEMBER)||"''")+".split('').reverse().join('')",Blockly.JavaScript.ORDER_MEMBER]};Blockly.JavaScript.variables={};Blockly.JavaScript.variables_get=function(a){return[Blockly.JavaScript.variableDB_.getName(a.getFieldValue("VAR"),Blockly.VARIABLE_CATEGORY_NAME),Blockly.JavaScript.ORDER_ATOMIC]};Blockly.JavaScript.variables_set=function(a){var b=Blockly.JavaScript.valueToCode(a,"VALUE",Blockly.JavaScript.ORDER_ASSIGNMENT)||"0";return Blockly.JavaScript.variableDB_.getName(a.getFieldValue("VAR"),Blockly.VARIABLE_CATEGORY_NAME)+" = "+b+";\n"};Blockly.JavaScript.variablesDynamic={};Blockly.JavaScript.variables_get_dynamic=Blockly.JavaScript.variables_get;Blockly.JavaScript.variables_set_dynamic=Blockly.JavaScript.variables_set;
	return Blockly.JavaScript;
	}));
	
	
	//# sourceMappingURL=javascript_compressed.js.map


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var _ = __webpack_require__(23);
	var angular = __webpack_require__(1);
	var Blockly = __webpack_require__(26);
	var api_connection_constants_1 = __webpack_require__(37);
	window['Blockly1'] = Blockly;
	__webpack_require__(38);
	__webpack_require__(112);
	__webpack_require__(113);
	var PropertyDetail = {
	    "Label": [["Hidden", "hidden"], ["Font Family", "font-family"], ["Font Size", "font-size"], ["Font Weight", "font-weight"], ["Font Style", "font-style"], ["Text Decoration", "text-decoration"], ["Text Align", "text-align"], ["Color", "color"], ["Background Color", "background-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Text", "text"]],
	    "Button": [["Hidden", "hidden"], ["Font Family", "font-family"], ["Font Size", "font-size"], ["Font Weight", "font-weight"], ["Font Style", "font-style"], ["Text Decoration", "text-decoration"], ["Text Align", "text-align"], ["Color", "color"], ["Background Color", "background-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Tooltip", "tooltip"], ["Read-only", "readOnly"], ['Text', 'text'], ["Width", "width"], ["Height", "height"]],
	    "DisplayField": [["Background Color", "background-color"], ["Hidden", "hidden"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Control Font Weight", "control-font-weight"], ["Control Font Style", "control-font-style"], ["Control Text Decoration", "control-text-decoration"], ["Control Text Align", "control-text-align"], ["Control Color", "control-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Label", "label"]],
	    "Textbox": [["Background Color", "background-color"], ["Required", "required"], ["Placeholder", "placeHolder"], ["Read-only", "readOnly"], ["Hidden", "hidden"], ["Char-Limit", "charLimit"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Control Font Weight", "control-font-weight"], ["Control Font Style", "control-font-style"], ["Control Text Decoration", "control-text-decoration"], ["Control Text Align", "control-text-align"], ["Control Color", "control-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Tooltip", "tooltip"], ["Format", "validate"], ["Label", "label"]],
	    "Textarea": [["Hidden", "hidden"], ["Background Color", "background-color"], ["Required", "required"], ["Placeholder", "placeHolder"], ["Read-only", "readOnly"], ["Char-Limit", "charLimit"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Control Font Weight", "control-font-weight"], ["Control Font Style", "control-font-style"], ["Control Text Decoration", "control-text-decoration"], ["Control Text Align", "control-text-align"], ["Control Color", "control-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Tooltip", "tooltip"], ["Format", "validate"], ["Size", "size"], ["Label", "label"]],
	    "RichTextArea": [["Hidden", "hidden"], ["Background Color", "background-color"], ["Required", "required"], ["Read-only", "readOnly"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Label", "label"]],
	    "Dropdown": [["Hidden", "hidden"], ["Background Color", "background-color"], ["Required", "required"], ["Multi Select", "multiSelect"], ["Read-only", "readOnly"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Control Font Weight", "control-font-weight"], ["Control Font Style", "control-font-style"], ["Control Text Decoration", "control-text-decoration"], ["Control Text Align", "control-text-align"], ["Control Color", "control-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Tooltip", "tooltip"], ["Options", "options"], ["Label", "label"]],
	    "Checkbox": [["Hidden", "hidden"], ["Background Color", "background-color"], ["Required", "required"], ["Read-only", "readOnly"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Control Font Weight", "control-font-weight"], ["Control Font Style", "control-font-style"], ["Control Text Decoration", "control-text-decoration"], ["Control Text Align", "control-text-align"], ["Control Color", "control-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Options", "options"], ["Label", "label"]],
	    "Radio": [["Hidden", "hidden"], ["Background Color", "background-color"], ["Required", "required"], ["Read-only", "readOnly"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Control Font Weight", "control-font-weight"], ["Control Font Style", "control-font-style"], ["Control Text Decoration", "control-text-decoration"], ["Control Text Align", "control-text-align"], ["Control Color", "control-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Options", "options"], ["Label", "label"]],
	    "Datepicker": [["Hidden", "hidden"], ["Background Color", "background-color"], ["Required", "required"], ["Read-only", "readOnly"], ["Display Format", "displayFormat"], ["Time", "time"], ["Time Format", "hourFormat"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Control Font Weight", "control-font-weight"], ["Control Font Style", "control-font-style"], ["Control Text Decoration", "control-text-decoration"], ["Control Text Align", "control-text-align"], ["Control Color", "control-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Tooltip", "tooltip"], ["Label", "label"]],
	    "Map": [["Hidden", "hidden"], ["Background Color", "background-color"], ["Required", "required"], ["Read-only", "readOnly"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Control Font Weight", "control-font-weight"], ["Control Font Style", "control-font-style"], ["Control Text Decoration", "control-text-decoration"], ["Control Text Align", "control-text-align"], ["Control Color", "control-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Label", "label"]],
	    "Image": [["Hidden", "hidden"], ["Font Family", "font-family"], ["Font Size", "font-size"], ["Font Weight", "font-weight"], ["Font Style", "font-style"], ["Text Decoration", "text-decoration"], ["Text Align", "text-align"], ["Color", "color"], ["Background Color", "background-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Width", "width"], ["Height", "height"], ["URL", "url"]],
	    "Signature": [["Hidden", "hidden"], ["Background Color", "background-color"], ["Required", "required"], ["Read-only", "readOnly"], ["Font Family", "font-family"], ["Font Size", "font-size"], ["Font Weight", "font-weight"], ["Font Style", "font-style"], ["Text Decoration", "text-decoration"], ["Text Align", "text-align"], ["Color", "color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Label", "label"]],
	    "Attachment": [["Hidden", "hidden"], ["Background Color", "background-color"], ["Required", "required"], ["Read-only", "readOnly"], ["Font Family", "font-family"], ["Font Size", "font-size"], ["Font Weight", "font-weight"], ["Font Style", "font-style"], ["Text Decoration", "text-decoration"], ["Text Align", "text-align"], ["Color", "color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Label", "label"]],
	    "Line": [["Background Color", "background-color"], ["Border Color", "border-top-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"]],
	    "Layout": [["Border Width", "layoutBorderWidth"], ["Background Color", "background-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Hidden", "hidden"]],
	    "Table": [["Background Color", "background-color"], ["Border Width", "borderWidth"], ["Border Color", "borderColor"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Hidden", "hidden"]],
	    "RepeatingTable": [["Background Color", "background-color"], ["Border Width", "reapeatingBorderWidth"], ["Border Color", "reapeatingBorderColor"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Hidden", "hidden"], ["Show Insert Button", "show_insert_button"], ["Show Remove Button", "show_remove_button"], ["Even Row Background Color", "backgroundcoloreven"], ["Odd Row Background Color", "backgroundcolorodd"]],
	    "ToggleButton": [["Background Color", "background-color"], ["Read-only", "readOnly"], ["Hidden", "hidden"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Control Font Weight", "control-font-weight"], ["Control Font Style", "control-font-style"], ["Control Text Decoration", "control-text-decoration"], ["Control Text Align", "control-text-align"], ["Control Color", "control-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Tooltip", "tooltip"], ["Label", "label"], ["Background Color On", "background-color-on"], ["Background Color Off", "background-color-off"], ["Label Off", "label-off"], ["Label On", "label-on"]],
	    "Hyperlink": [["Background Color", "background-color"], ["Hidden", "hidden"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Control Font Weight", "control-font-weight"], ["Control Font Style", "control-font-style"], ["Control Text Decoration", "control-text-decoration"], ["Control Text Align", "control-text-align"], ["Control Color", "control-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Tooltip", "tooltip"], ["Label", "label"], ["Display Label", "displayLabel"]],
	    "MultiDropdown": [["Hidden", "hidden"], ["Background Color", "background-color"], ["Required", "required"], ["Read-only", "readOnly"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Control Font Weight", "control-font-weight"], ["Control Font Style", "control-font-style"], ["Control Text Decoration", "control-text-decoration"], ["Control Text Align", "control-text-align"], ["Control Color", "control-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Tooltip", "tooltip"], ["Options", "options"], ["Label", "label"]],
	    "Timepicker": [["Hidden", "hidden"], ["Background Color", "background-color"], ["Required", "required"], ["Read-only", "readOnly"], ["Time Format", "hourFormat"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Control Font Weight", "control-font-weight"], ["Control Font Style", "control-font-style"], ["Control Text Decoration", "control-text-decoration"], ["Control Text Align", "control-text-align"], ["Control Color", "control-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Tooltip", "tooltip"], ["Label", "label"]],
	    "Rating": [["Background Color", "background-color"], ["Required", "required"], ["Placeholder", "placeHolder"], ["Read-only", "readOnly"], ["Hidden", "hidden"], ["Char-Limit", "charLimit"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Label Font Weight", "label-font-weight"], ["Label Font Style", "label-font-style"], ["Label Text Decoration", "label-text-decoration"], ["Label Text Align", "label-text-align"], ["Label Color", "label-color"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Control Font Weight", "control-font-weight"], ["Control Font Style", "control-font-style"], ["Control Text Decoration", "control-text-decoration"], ["Control Text Align", "control-text-align"], ["Control Color", "control-color"], ["Padding Top", "padding-top"], ["Padding Bottom", "padding-bottom"], ["Padding Left", "padding-left"], ["Padding Right", "padding-right"], ["Tooltip", "tooltip"], ["Format", "validate"], ["Label", "label"]],
	    "InlineAssocFiles": [["Hidden", "hidden"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Read-only", "readOnly"], ['Text', 'text'], ['Required', 'required']],
	    "InlineAssocApps": [["Hidden", "hidden"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"], ["Read-only", "readOnly"], ['Text', 'text'], ['Required', 'required']],
	    "ViewAssociations": [["Hidden", "hidden"], ["Label Font Family", "label-font-family"], ["Label Font Size", "label-font-size"], ["Control Font Family", "control-font-family"], ["Control Font Size", "control-font-size"]],
	};
	var PropertyType = {
	    "value": "STRING",
	    "text": "STRING",
	    "label": "STRING",
	    "placeHolder": "STRING",
	    "tooltip": "STRING",
	    "options": "STRING",
	    "hidden": "BOOLEAN",
	    "required": "BOOLEAN",
	    "readOnly": "BOOLEAN",
	    "multiSelect": "BOOLEAN",
	    "show_insert_button": 'BOOLEAN',
	    "show_remove_button": 'BOOLEAN',
	    "time": "BOOLEAN",
	    "font-size": "NUMBER",
	    "label-font-size": "NUMBER",
	    "control-font-size": "NUMBER",
	    "padding-top": "NUMBER",
	    "padding-bottom": "NUMBER",
	    "padding-left": "NUMBER",
	    "padding-right": "NUMBER",
	    "width": "NUMBER",
	    "height": "NUMBER",
	    "borderWidth": "NUMBER",
	    "reapeatingBorderWidth": "NUMBER",
	    "charLimit": "NUMBER",
	    "size": "NUMBER",
	    "layoutColumns": "LAYOUT_COLUMNS_DROPDOWN",
	    "layoutBorderWidth": "BORDER_WIDTH_DROPDOWN",
	    "font-family": "FONT_FAMILY_DROPDOWN",
	    "label-font-family": "FONT_FAMILY_DROPDOWN",
	    "control-font-family": "FONT_FAMILY_DROPDOWN",
	    "font-weight": "FONT_WEIGHT_DROPDOWN",
	    "label-font-weight": "FONT_WEIGHT_DROPDOWN",
	    "control-font-weight": "FONT_WEIGHT_DROPDOWN",
	    "font-style": "FONT_STYLE_DROPDOWN",
	    "label-font-style": "FONT_STYLE_DROPDOWN",
	    "control-font-style": "FONT_STYLE_DROPDOWN",
	    "text-decoration": "TEXT_DECORATION_DROPDOWN",
	    "label-text-decoration": "TEXT_DECORATION_DROPDOWN",
	    "control-text-decoration": "TEXT_DECORATION_DROPDOWN",
	    "text-align": "TEXT_ALIGN_DROPDOWN",
	    "label-text-align": "TEXT_ALIGN_DROPDOWN",
	    "control-text-align": "TEXT_ALIGN_DROPDOWN",
	    "validate": "VALIDATE_DROPDOWN",
	    "displayFormat": "DATE_FORMAT_DROPDOWN",
	    "hourFormat": "TIME_FORMAT_DROPDOWN",
	    "color": "COLOR_PICKER",
	    "background-color": "COLOR_PICKER",
	    "label-color": "COLOR_PICKER",
	    "control-color": "COLOR_PICKER",
	    "border-top-color": "COLOR_PICKER",
	    "borderColor": "COLOR_PICKER",
	    "reapeatingBorderColor": "COLOR_PICKER",
	    "background-color-on": "COLOR_PICKER",
	    "background-color-off": "COLOR_PICKER",
	    "displayLabel": 'STRING',
	    "url": "STRING",
	    "backgroundcoloreven": "COLOR_PICKER",
	    "backgroundcolorodd": "COLOR_PICKER"
	};
	var PropertyTypeDropdown = {
	    "FONT_FAMILY_DROPDOWN": [['Arial', 'Arial'], ['Helvetica', 'Helvetica'], ['Times New Roman', 'Times New Roman'], ['Times', 'Times'], ['Courier New', 'Courier New'], ['Courier', 'Courier'], ['Verdana', 'Verdana'], ['Georgia', 'Georgia'], ['Palatino Linotype', 'Palatino Linotype'], ['Garamond', 'Garamond'], ['Bookman Old Style', 'Bookman Old Style'], ['Comic Sans MS', 'Comic Sans MS'], ['Trebuchet MS', 'Trebuchet MS'], ['Arial Black', 'Arial Black'], ['Impact', 'Impact'], ['Calibri', 'Calibri'], ['Century Gothic', 'Century Gothic'], ['Sans Serif', 'Sans Serif'], ['Sofia Pro Regular', 'Sofia Pro Regular'], ['Sofia Pro Semi Bold', 'Sofia Pro Semi Bold']],
	    "FONT_WEIGHT_DROPDOWN": [['Normal', ''], ['Bold', 'bold']],
	    "FONT_STYLE_DROPDOWN": [['Normal', ''], ['Italic', 'italic']],
	    "TEXT_DECORATION_DROPDOWN": [['Normal', ''], ['Underline', 'underline']],
	    "TEXT_ALIGN_DROPDOWN": [['Left', 'left'], ['Right', 'right'], ['Center', 'center']],
	    "VALIDATE_DROPDOWN": [['None', ''], ['Integer', 'Integer'], ['Decimal', 'Decimal'], ['Letters and Numbers', 'Alphanumeric'], ['Letters', 'Letters'], ['Email', 'Email']],
	    "DATE_FORMAT_DROPDOWN": [['Default', 'default'], ['dd-mmm-yyyy', 'DD-MMM-YYYY'], ['dd-mm-yyyy', 'DD-MM-YYYY'], ['dd-mm-yy', 'DD-MM-YY'], ['mm-dd-yyyy', 'MM-DD-YYYY'], ['mm-dd-yy', 'MM-DD-YY'], ['dd/mm/yy', 'DD/MM/YY'], ['dd/mm/yyyy', 'DD/MM/YYYY']],
	    "TIME_FORMAT_DROPDOWN": [['12Hrs', 'true'], ['24Hrs', 'false']],
	    "BORDER_WIDTH_DROPDOWN": [["0", "0px solid #ccc"], ["1", "1px solid #ccc"], ["2", "2px solid #ccc"], ["3", "3px solid #ccc"], ["4", "4px solid #ccc"], ["5", "5px solid #ccc"], ["6", "6px solid #ccc"], ["7", "7px solid #ccc"], ["8", "8px solid #ccc"], ["9", "9px solid #ccc"], ["10", "10px solid #ccc"]],
	    "LAYOUT_COLUMNS_DROPDOWN": [["1", "col-md-12/1"], ["2", "col-md-6/2"], ["3", "col-md-4/3"], ["4", "col-md-3/4"], ["5", "col-md-5/5"], ["6", "col-md-2/6"], ["7", "col-md-7/7"], ["8", "col-md-8/8"], ["9", "col-md-9/9"], ["10", "col-md-10/10"], ["11", "col-md-11/11"], ["12", "col-md-1/12"]]
	};
	var ExcludedSystemFields = ['DS_PRINTEDBY', 'DS_PRINTEDON'];
	var DateSystemFields = ['DS_CLOSEDUEDATE', 'DS_DATEOFISSUE', 'DS_MSGDATE'];
	var BooleanSystemFields = ['DS_ATTACHMENTS_ORI', 'DS_DOC_ASSOCIATIONS_ORI', 'DS_FORM_ASSOCIATIONS_ORI'];
	exports.ControlBlocklyBlocks = function (options) {
	    var newOption = options;
	    var customFields = options.fieldNames;
	    var dataFieldNames = options.dataFieldNames;
	    var systemSingleValue = options.systemSingleValue;
	    var apiNames = options.apiNames;
	    var responseDataOptions = [['Please select', '']];
	    var ControlNameOptions = [['Select Control Name...', '']];
	    var RepeatingTableControlNameOptions = [['Select Control Name...', '']];
	    var sourceFields = [['Select Source Field', ''], ['Form ID', 'fixed_DS_FORMID']];
	    var destinationFields = [['Select Target Field', '']];
	    var projectsLists = options.projects;
	    var currentProject = options.projectName;
	    var currentProjectID = options.projectId;
	    var viewNames = options.viewNames;
	    var ViewNamesList = [['Select View Name...', '']];
	    var sortSourceFields = [];
	    var dateFieldName = [['Select Control Name...', ''], ['Current Date', 'currentdate']];
	    var sortCutomFields = _.sortBy(customFields, function (field) {
	        return field.key.toLowerCase();
	    });
	    sortCutomFields.forEach(function (field) {
	        ControlNameOptions.push([field.key, field.key]);
	        if (field.type == "RepeatingTable") {
	            RepeatingTableControlNameOptions.push([field.key, field.key]);
	        }
	        if (field.type == "Datepicker") {
	            dateFieldName.push([field.key, field.key]);
	        }
	    });
	    viewNames.forEach(function (field) {
	        ViewNamesList.push([field.name, field.value]);
	    });
	    var DateControlNameOptions = [['Select Control Name...', '']];
	    var DateTimeControlOptions = [['Select Control Name...', '']];
	    var DateTimeFormatOptions = [['Select Time Format...', ''], ['HH:MM', 'HH:MM'], ['HH', 'HH']];
	    var ControlDataFieldNameOptions = [['Select Control Name...', '']];
	    var APINameOptions = [['Select API Name...', '']];
	    if (apiNames && apiNames.length > 0) {
	        apiNames.forEach(function (field) {
	            APINameOptions.push([field.name, field.name]);
	        });
	    }
	    var sortCutomDataFields = _.sortBy(dataFieldNames, function (field) {
	        return field.key.toLowerCase();
	    });
	    var AutoNumberControlNameOptions = [['Select Control Name...', '']];
	    sortCutomDataFields.forEach(function (field) {
	        ControlDataFieldNameOptions.push([field.key, field.key]);
	        if (field.type == "Datepicker") {
	            field.isTimeEnabled && DateTimeControlOptions.push([field.key, field.key]);
	            DateControlNameOptions.push([field.key, field.key]);
	        }
	        if (field.type == "Textbox" && field.parent != 'repeating-table') {
	            AutoNumberControlNameOptions.push([field.key, field.key]);
	        }
	        if (field.parent == 'repeating-table') {
	            sortSourceFields.push([field.key + ' ( ' + field.parentFieldName + ' ) ', field.key]);
	        }
	        else {
	            sortSourceFields.push([field.key, field.key]);
	        }
	    });
	    sortSourceFields = _.sortBy(sortSourceFields, [function (sourceField) { return sourceField[0].toLowerCase(); }], ['asce']);
	    sortSourceFields.map(function (array) { return sourceFields.push(array); });
	    var functionalityOptions = [["Select Type....", ""], ["Auto Insert Row", "insertRow"], ["Auto Delete Row", "deleteRow"], ["Make Read Only", "readOnly"], ["Show Row", "showRow"]];
	    var AutoHasIndexOptions = [['#', 'randomRow']];
	    var AutoHasIndexOptionUpdate = [["#", "randomRow"], ["All", "allRow"]];
	    var controlsInsideRT = [['Select Control', 'Select Control']];
	    var allSystemFieldsDataType = {};
	    var allSystemFieldsData = [];
	    systemSingleValue.forEach(function (systemField) {
	        if (ExcludedSystemFields.indexOf(systemField.value) == -1) {
	            allSystemFieldsData.push({ key: systemField.key, value: systemField.value });
	            var type = 'STRING';
	            if (DateSystemFields.indexOf(systemField.value) != -1) {
	                type = 'DATE';
	            }
	            else if (BooleanSystemFields.indexOf(systemField.value) != -1) {
	                type = 'BOOLEAN';
	            }
	            allSystemFieldsDataType[systemField.value] = type;
	        }
	    });
	    var projectNames = [['Select Project', '']];
	    var appbuilderID = [['Select Form Name', '']];
	    if (projectsLists && projectsLists.length > 0) {
	        projectsLists.splice(projectsLists.findIndex(function (el) { return el.value === 'Project Templates'; }), 1);
	        projectNames.push(['Current Project', 'Current Project']);
	        var sortProject = [];
	        for (var i = 0; i < projectsLists.length; i++) {
	            sortProject.push([projectsLists[i].value, projectsLists[i].value]);
	        }
	        sortProject = _.sortBy(sortProject, [function (project) { return project[0].toLowerCase(); }], ['asce']);
	        sortProject.map(function (array) { return projectNames.push(array); });
	    }
	    var spUserDetailsOptions = [['Select Type', ''], ['Username & Organisation', 'Value2'], ['Organisation', 'Value3'], ['User Role', 'Value4'], ['Contact No', 'Value5'], ['Email', 'Value6'], ['First Name', 'Value7'], ['Middle Name', 'Value9'], ['Last Name', 'Value8'], ['Designation', 'Name']];
	    var SystemFieldNameOptions = [['Select System Field Name...', '']];
	    var sortSystemFields = _.sortBy(allSystemFieldsData, function (field) {
	        return field.key.toLowerCase();
	    });
	    sortSystemFields.forEach(function (field) {
	        SystemFieldNameOptions.push([field.key, field.value]);
	    });
	    var CurrentDateFieldOptions = [['Select Type...', ''], ['Date', 'date'], ['Date & Time', 'datetime'], ['Time', 'time']];
	    var PropertyNameOptions = {};
	    var _loop_1 = function(key) {
	        var sortProperties = _.sortBy(PropertyDetail[key]);
	        PropertyNameOptions[key] = [];
	        sortProperties.forEach(function (item) {
	            PropertyNameOptions[key].push(item);
	        });
	    };
	    for (var key in PropertyDetail) {
	        _loop_1(key);
	    }
	    var isRepeatingTableControl = function (controlName, list) {
	        var isTableControl = false;
	        if (controlName) {
	            list.some(function (field) {
	                if (field.key === controlName && field.parent == 'repeating-table') {
	                    isTableControl = true;
	                    return true;
	                }
	            });
	        }
	        return isTableControl;
	    };
	    var refreshScopeInputField = function (control, oldControlName, newControlName, list) {
	        if (isRepeatingTableControl(oldControlName, list) && !isRepeatingTableControl(newControlName, list)) {
	            control.removeInput('SCOPE_DATA', true);
	        }
	        else if (!isRepeatingTableControl(oldControlName, list) && isRepeatingTableControl(newControlName, list)) {
	            control.appendValueInput('SCOPE_DATA').appendField("   Scope: ", 'SCOPE');
	        }
	    };
	    var getControlType = function (controlName) {
	        var controlType = '';
	        if (controlName) {
	            customFields.some(function (field) {
	                if (!controlType && field.key === controlName) {
	                    controlType = field.type;
	                    return true;
	                }
	            });
	        }
	        return controlType;
	    };
	    var refreshDropdownInputField = function (block) {
	        var input = block.getInput('CUSTOM_RESPONSE');
	        if (block && block.parentBlock_) {
	            var propName = block.parentBlock_ ? block.parentBlock_.getFieldValue('PROPERTY_NAME') : ' ';
	            if (propName == 'options') {
	                if (block && block.childBlocks_ && block.childBlocks_[0] && block.childBlocks_[0].getVarModels()[0] && block.childBlocks_[0].getVarModels()[0]['responseDataFromAPI']) {
	                    if (!block.getField('KEY_NAME')) {
	                        input.appendField(" Option Map ", 'SET_KEY');
	                        input.appendField(new Blockly.FieldDropdown(block.generateOptions.bind(block)), 'KEY_NAME');
	                    }
	                }
	            }
	            else {
	                input.removeField("SET_KEY", true);
	                input.removeField("KEY_NAME", true);
	            }
	        }
	    };
	    var refreshDropdownNewInputField = function (block) {
	        var inputNew = block.getInput('New_CUSTOM_RESPONSE');
	        if (block && block.parentBlock_) {
	            var propName = block.parentBlock_ ? block.parentBlock_.getFieldValue('PROPERTY_NAME') : ' ';
	            if (propName == 'options' && inputNew) {
	                if (block && block.childBlocks_ && block.childBlocks_[0] && block.childBlocks_[0].getVarModels()[0] && block.childBlocks_[0].getVarModels()[0]['responseDataFromAPI']) {
	                    if (!block.getField('VALUE_NAME')) {
	                        inputNew.appendField(" Value", 'SET_VALUE');
	                        inputNew.appendField(new Blockly.FieldDropdown(block.generateOptions.bind(block)), 'VALUE_NAME');
	                    }
	                    if (!block.getField('NAME_MAP')) {
	                        inputNew.appendField(" Display Name", 'SET_KEY_NAME');
	                        inputNew.appendField(new Blockly.FieldDropdown(block.generateOptions.bind(block)), 'NAME_MAP');
	                    }
	                }
	            }
	            else {
	                inputNew.removeField("SET_VALUE", true);
	                inputNew.removeField("VALUE_NAME", true);
	                inputNew.removeField("SET_KEY_NAME", true);
	                inputNew.removeField("NAME_MAP", true);
	            }
	        }
	    };
	    /**
	     * Custom property setter block
	     */
	    Blockly.Blocks['custom-property-setter'] = {
	        init: function () {
	            this.appendDummyInput('CUSTOM_PROP_SETTER_DUMMY_INPUT')
	                .appendField("Setter : Control Name:")
	                .appendField(new Blockly.FieldDropdown(ControlNameOptions, this.validateControlName), 'CONTROL_NAME')
	                .appendField("Property Name:")
	                .appendField(new Blockly.FieldDropdown([['', '']], this.validatePropertyName), "PROPERTY_NAME")
	                .appendField("Value:")
	                .appendField(new Blockly.FieldTextInput(""), "PROPERTY_VALUE");
	            this.setInputsInline(true);
	            this.setPreviousStatement(true, null);
	            this.setNextStatement(true, null);
	            this.setColour(Blockly.Msg.PROCEDURES_HUE);
	            this.setTooltip("Set element custom property value");
	            this.setHelpUrl("");
	        },
	        validateControlName: function (controlName) {
	            var block = this.getSourceBlock();
	            if (block.controlName != controlName) {
	                var oldControlName_1 = block.controlName;
	                block.controlName = controlName;
	                if (!oldControlName_1) {
	                    block.onControlNameChanged(controlName, oldControlName_1);
	                }
	                else {
	                    setTimeout(function () {
	                        block.onControlNameChanged(controlName, oldControlName_1);
	                    }, 50);
	                }
	            }
	            return controlName;
	        },
	        validatePropertyName: function (propName) {
	            var block = this.getSourceBlock();
	            var oldPropName = block.propName;
	            block.propName = propName;
	            if (!oldPropName) {
	                block.appendPropertyValueField(propName);
	            }
	            else {
	                setTimeout(function () {
	                    block.appendPropertyValueField(propName);
	                }, 50);
	            }
	            return propName;
	        },
	        onControlNameChanged: function (controlName, oldControlName) {
	            var input = this.getInput('CUSTOM_PROP_SETTER_DUMMY_INPUT');
	            input.removeField('PROPERTY_NAME', true);
	            var options = this.getPropertyNameOptions(controlName);
	            if (options[0][1] != '') {
	                input.insertFieldAt(3, new Blockly.FieldDropdown(options, this.validatePropertyName), "PROPERTY_NAME");
	            }
	            this.appendPropertyValueField(options[0][1]);
	            refreshScopeInputField(this, oldControlName, controlName, customFields);
	        },
	        getPropertyNameOptions: function (controlName) {
	            var controlType = getControlType(controlName);
	            var options = angular.copy(PropertyNameOptions[controlType] || [['', '']]);
	            if (controlType == 'Radio' || controlType == 'Dropdown' || controlType == 'Checkbox') {
	                options.some(function (otion, index) {
	                    if (otion[0] == 'Options') {
	                        options.splice(index, 1);
	                        return true;
	                    }
	                });
	            }
	            return options;
	        },
	        appendPropertyValueField: function (propertyName) {
	            var input = this.getInput('CUSTOM_PROP_SETTER_DUMMY_INPUT');
	            input.removeField('PROPERTY_VALUE', true);
	            input.removeField('PROPERTY_VALUE_MONTH', true);
	            input.removeField('PROPERTY_VALUE_YEAR', true);
	            input.removeField('PROPERTY_VALUE_HOUR', true);
	            input.removeField('PROPERTY_VALUE_MINUTES', true);
	            input.removeField('PROPERTY_VALUE_MERIDIAN', true);
	            input.removeField('DATE', true);
	            input.removeField('MONTH', true);
	            input.removeField('YEAR', true);
	            input.removeField('HOUR', true);
	            input.removeField('MINUTES', true);
	            input.removeField('MERIDIAN', true);
	            if (!propertyName) {
	                return;
	            }
	            var type = PropertyType[propertyName] || '';
	            if (type == 'BOOLEAN') {
	                input.appendField(new Blockly.FieldCheckbox(true), 'PROPERTY_VALUE');
	                return;
	            }
	            if (type == 'NUMBER') {
	                var number = 0;
	                if (propertyName == 'font-size' || propertyName == 'label-font-size' || propertyName == 'control-font-size') {
	                    number = 16;
	                }
	                else if (propertyName == 'padding-top' || propertyName == 'padding-bottom' || propertyName == 'padding-left' || propertyName == 'padding-right') {
	                    number = 5;
	                }
	                else if (propertyName == 'borderWidth') {
	                    number = 1;
	                }
	                else if (propertyName == 'width' || propertyName == 'height') {
	                    number = 100;
	                }
	                else if (propertyName == 'charLimit') {
	                    number = 25;
	                }
	                else if (propertyName == 'size') {
	                    number = 3;
	                }
	                input.appendField(new Blockly.FieldNumber(number, 0, Infinity, 1), 'PROPERTY_VALUE');
	                return;
	            }
	            if (type.indexOf('_DROPDOWN') != -1) {
	                input.appendField(new Blockly.FieldDropdown(PropertyTypeDropdown[type]), 'PROPERTY_VALUE');
	                return;
	            }
	            if (type == 'COLOR_PICKER') {
	                input.appendField(new Blockly.FieldColour('#ffffff'), 'PROPERTY_VALUE');
	                return;
	            }
	            var controlType = getControlType(this.controlName);
	            if (controlType == 'Textarea' || controlType == 'RichTextArea') {
	                input.appendField(new Blockly.FieldMultilineInput(""), "PROPERTY_VALUE");
	                return;
	            }
	            if (controlType == 'Datepicker' && propertyName == 'value') {
	                var date = new Date();
	                input.appendField("Date", 'DATE');
	                input.appendField(new Blockly.FieldNumber(date.getDate(), 0, 31, 1), "PROPERTY_VALUE");
	                input.appendField("Month", 'MONTH');
	                input.appendField(new Blockly.FieldNumber(date.getMonth() + 1, 1, 12, 1), "PROPERTY_VALUE_MONTH");
	                input.appendField("Year", 'YEAR');
	                input.appendField(new Blockly.FieldNumber(date.getFullYear(), 0, 9999, 1), "PROPERTY_VALUE_YEAR");
	                input.appendField("Hour", 'HOUR');
	                input.appendField(new Blockly.FieldNumber(date.getHours(), 0, 12, 1), "PROPERTY_VALUE_HOUR");
	                input.appendField("Minutes", 'MINUTES');
	                input.appendField(new Blockly.FieldNumber(date.getMinutes(), 0, 60, 1), "PROPERTY_VALUE_MINUTES");
	                input.appendField("AM/PM", 'MERIDIAN');
	                input.appendField(new Blockly.FieldDropdown([['AM', 'AM'], ['PM', 'PM']]), "PROPERTY_VALUE_MERIDIAN");
	                return;
	            }
	            if (controlType == 'Timepicker' && propertyName == 'value') {
	                var date = new Date();
	                input.appendField("Hour", 'HOUR');
	                input.appendField(new Blockly.FieldNumber(date.getHours(), 0, 12, 1), "PROPERTY_VALUE_HOUR");
	                input.appendField("Minutes", 'MINUTES');
	                input.appendField(new Blockly.FieldNumber(date.getMinutes(), 0, 60, 1), "PROPERTY_VALUE_MINUTES");
	                input.appendField("AM/PM", 'MERIDIAN');
	                input.appendField(new Blockly.FieldDropdown([['AM', 'AM'], ['PM', 'PM']]), "PROPERTY_VALUE_MERIDIAN");
	                return;
	            }
	            input.appendField(new Blockly.FieldTextInput(""), "PROPERTY_VALUE");
	        }
	    };
	    Blockly['JavaScript']['custom-property-setter'] = function (block) {
	        var controlName = block.getFieldValue('CONTROL_NAME') || '';
	        var propName = block.getFieldValue('PROPERTY_NAME') || '';
	        var propValue;
	        if (block.getFieldValue('PROPERTY_VALUE') == 0) {
	            propValue = 0;
	        }
	        else {
	            propValue = block.getFieldValue('PROPERTY_VALUE') || '';
	        }
	        var scopeData = Blockly['JavaScript'].valueToCode(block, 'SCOPE_DATA', Blockly['JavaScript'].ORDER_NONE) || '';
	        var code = '';
	        if (PropertyType[propName] == 'BOOLEAN') {
	            propValue = (propValue == 'TRUE') ? true : false;
	            code = " (window.setPropValue && window.setPropValue('" + controlName + "', '" + propName + "', " + propValue + ", " + scopeData + "));\n";
	        }
	        else if (PropertyType[propName] == 'NUMBER') {
	            code = " (window.setPropValue && window.setPropValue('" + controlName + "', '" + propName + "', " + propValue + ", " + scopeData + "));\n";
	        }
	        else if (PropertyType[propName] == 'FONT_WEIGHT_DROPDOWN' || PropertyType[propName] == 'FONT_STYLE_DROPDOWN' || PropertyType[propName] == 'TEXT_DECORATION_DROPDOWN') {
	            propValue = (propValue == '') ? false : true;
	            code = " (window.setPropValue && window.setPropValue('" + controlName + "', '" + propName + "', " + propValue + ", " + scopeData + "));\n";
	        }
	        else if (getControlType(controlName) == 'Datepicker' && propName == 'value') {
	            var year = block.getFieldValue('PROPERTY_VALUE_YEAR');
	            var month = block.getFieldValue('PROPERTY_VALUE_MONTH');
	            var hours = block.getFieldValue('PROPERTY_VALUE_HOUR');
	            var minutes = block.getFieldValue('PROPERTY_VALUE_MINUTES');
	            var meridian = block.getFieldValue('PROPERTY_VALUE_MERIDIAN');
	            if (propValue != 0 && month != 0 && year != 0) {
	                propValue = year + "-" + month + "-" + propValue + " " + hours + ":" + minutes + " " + meridian;
	            }
	            else {
	                propValue = '';
	            }
	            code = " (window.setPropValue && window.setPropValue('" + controlName + "', '" + propName + "', \"" + propValue + "\", " + scopeData + "));\n";
	        }
	        else if (getControlType(controlName) == 'Timepicker' && propName == 'value') {
	            var year = new Date().getFullYear();
	            var month = new Date().getMonth();
	            var date = new Date().getDate();
	            var hours = block.getFieldValue('PROPERTY_VALUE_HOUR');
	            var minutes = block.getFieldValue('PROPERTY_VALUE_MINUTES');
	            var meridian = block.getFieldValue('PROPERTY_VALUE_MERIDIAN');
	            if ((hours || hours == 0) && (minutes || minutes == 0)) {
	                propValue = year + "-" + month + "-" + date + " " + hours + ":" + minutes + " " + meridian;
	            }
	            else {
	                propValue = '';
	            }
	            code = " (window.setPropValue && window.setPropValue('" + controlName + "', '" + propName + "', \"" + propValue + "\", " + scopeData + "));\n";
	        }
	        else {
	            if (propValue.search && propValue.search(/\n/) != -1) {
	                var controlType = getControlType(controlName);
	                if (controlType == 'RichTextArea') {
	                    propValue = propValue.replace(/\n/g, '<br />');
	                }
	                else {
	                    propValue = propValue.replace(/\n/g, '$#$#$#');
	                }
	            }
	            code = " (window.setPropValue && window.setPropValue('" + controlName + "', '" + propName + "', \"" + propValue + "\", " + scopeData + "));\n";
	        }
	        return code;
	    };
	    /**
	     * Custom property setter block using any getter method
	     */
	    Blockly.Blocks['custom-property-setter_by_getter'] = {
	        init: function () {
	            this.appendDummyInput('CUSTOM_PROP_SETTER_DUMMY_INPUT')
	                .appendField("Setter : Control Name:")
	                .appendField(new Blockly.FieldDropdown(ControlNameOptions, this.validateControlName), 'CONTROL_NAME')
	                .appendField("Property Name:")
	                .appendField(new Blockly.FieldDropdown([['', '']]), "PROPERTY_NAME")
	                .appendField("Value:");
	            this.appendValueInput('PROPERTY_VALUE_INPUT').setCheck(null);
	            this.setInputsInline(true);
	            this.setPreviousStatement(true, null);
	            this.setNextStatement(true, null);
	            this.setColour(Blockly.Msg.PROCEDURES_HUE);
	            this.setTooltip("Set element custom property value using getter method");
	            this.setHelpUrl("");
	        },
	        validateControlName: function (controlName) {
	            var _this = this;
	            if (this.controlName != controlName) {
	                var oldControlName_2 = this.controlName;
	                this.controlName = controlName;
	                if (!oldControlName_2) {
	                    this.getSourceBlock().onControlNameChanged(controlName, oldControlName_2);
	                }
	                else {
	                    setTimeout(function () {
	                        _this.getSourceBlock().onControlNameChanged(controlName, oldControlName_2);
	                    }, 50);
	                }
	            }
	            return controlName;
	        },
	        onControlNameChanged: function (controlName, oldControlName) {
	            var input = this.getInput('CUSTOM_PROP_SETTER_DUMMY_INPUT');
	            input.removeField('PROPERTY_NAME', true);
	            var options = this.getPropertyNameOptions(controlName);
	            if (options[0][1] != '') {
	                var controlType = getControlType(controlName);
	                if (controlType == 'Dropdown' || controlType == 'MultiDropdown') {
	                    options[0][0] = 'Options';
	                    options[0][1] = 'options';
	                }
	                input.insertFieldAt(3, new Blockly.FieldDropdown(options), "PROPERTY_NAME");
	            }
	            refreshScopeInputField(this, oldControlName, controlName, customFields);
	        },
	        getPropertyNameOptions: function (controlName) {
	            var controlType = getControlType(controlName);
	            return angular.copy(PropertyNameOptions[controlType] || [['', '']]);
	        }
	    };
	    Blockly['JavaScript']['custom-property-setter_by_getter'] = function (block) {
	        var controlName = block.getFieldValue('CONTROL_NAME') || '';
	        var propName = block.getFieldValue('PROPERTY_NAME') || '';
	        var propValue = Blockly['JavaScript'].valueToCode(block, 'PROPERTY_VALUE_INPUT', Blockly['JavaScript'].ORDER_NONE) || '';
	        var scopeData = Blockly['JavaScript'].valueToCode(block, 'SCOPE_DATA', Blockly['JavaScript'].ORDER_NONE) || '';
	        var code = '';
	        if (propValue.indexOf('window.') != -1) {
	            code = " (window.setPropValue && window.setPropValue('" + controlName + "', '" + propName + "', " + propValue + ", " + scopeData + ")); \n";
	        }
	        else {
	            if (PropertyType[propName] == 'BOOLEAN') {
	                propValue = (propValue == 'TRUE' || propValue == 'true' || propValue == true) ? true : false;
	            }
	            else if (PropertyType[propName] == 'NUMBER') {
	                propValue = parseInt(propValue);
	            }
	            else if (PropertyType[propName] == 'FONT_WEIGHT_DROPDOWN' || PropertyType[propName] == 'FONT_STYLE_DROPDOWN' || PropertyType[propName] == 'TEXT_DECORATION_DROPDOWN') {
	                propValue = (propValue == '' || propValue == 'false' || propValue == false) ? false : true;
	            }
	            code = " (window.setPropValue && window.setPropValue('" + controlName + "', '" + propName + "', " + propValue + ", " + scopeData + "));\n";
	        }
	        return code;
	    };
	    /**
	     * Custom property setter block using any getter method
	     */
	    Blockly.Blocks['custom-property-value-setter'] = {
	        init: function () {
	            this.appendDummyInput('CUSTOM_PROP_VALUE_SETTER_DUMMY_INPUT')
	                .appendField("Set Value : Control Name:")
	                .appendField(new Blockly.FieldDropdown(ControlDataFieldNameOptions, this.validateControlName), 'CONTROL_NAME')
	                .appendField("Value:");
	            this.appendValueInput('PROPERTY_VALUE_INPUT').setCheck(null);
	            this.appendDummyInput('CUSTOM_PROP_VALUE_SETTER_DUMMY_INPUT_FOR_DATE');
	            this.setInputsInline(true);
	            this.setPreviousStatement(true, null);
	            this.setNextStatement(true, null);
	            this.setColour(Blockly.Msg.PROCEDURES_HUE);
	            this.setTooltip("Set element custom property value.");
	            this.setHelpUrl("");
	        },
	        validateControlName: function (controlName) {
	            var block = this.getSourceBlock();
	            if (block.controlName != controlName) {
	                var oldControlName_3 = block.controlName;
	                block.controlName = controlName;
	                if (!oldControlName_3) {
	                    block.appendPropertyValueField(controlName, oldControlName_3);
	                }
	                else {
	                    setTimeout(function () {
	                        block.appendPropertyValueField(controlName, oldControlName_3);
	                    }, 50);
	                }
	            }
	            return controlName;
	        },
	        getTwelveHourTime: function () {
	            var date = new Date(); //  For converting 24 hour time to 12 hour clock time.
	            var twelveHourTime;
	            if (date.getHours() < 13) {
	                twelveHourTime = date.getHours();
	            }
	            else {
	                twelveHourTime = date.getHours() - 12;
	            }
	            return twelveHourTime;
	        },
	        getAdjustedTimeObjectForAmPm: function () {
	            var date = new Date(); //  For getting PM or AM object as per current time returned by getHours()
	            var AmPmObject; //  To be used for automatic default selection of AM or PM in dropdown.
	            if (date.getHours() < 12) {
	                AmPmObject = ['AM', 'AM'];
	            }
	            else {
	                AmPmObject = ['PM', 'PM'];
	            }
	            return AmPmObject;
	        },
	        appendPropertyValueField: function (controlName, oldControlName) {
	            var input = this.getInput('CUSTOM_PROP_VALUE_SETTER_DUMMY_INPUT_FOR_DATE');
	            var controlType = getControlType(controlName);
	            var isDatePickerControl = controlType == 'Datepicker';
	            var isTimePickerControl = controlType == 'Timepicker';
	            refreshScopeInputField(this, oldControlName, controlName, dataFieldNames);
	            if (!controlName || isDatePickerControl != this.isDatePickerControl || isTimePickerControl != this.isTimePickerControl) {
	                input.removeField('PROPERTY_VALUE', true);
	                input.removeField('PROPERTY_VALUE_MONTH', true);
	                input.removeField('PROPERTY_VALUE_YEAR', true);
	                input.removeField('PROPERTY_VALUE_HOUR', true);
	                input.removeField('PROPERTY_VALUE_MINUTES', true);
	                input.removeField('PROPERTY_VALUE_MERIDIAN', true);
	                input.removeField('DATE', true);
	                input.removeField('MONTH', true);
	                input.removeField('YEAR', true);
	                input.removeField('HOUR', true);
	                input.removeField('MINUTES', true);
	                input.removeField('MERIDIAN', true);
	                input.removeField('OR', true);
	            }
	            if (!controlName || (this.isDatePickerControl == isDatePickerControl && !isTimePickerControl)) {
	                return;
	            }
	            this.isDatePickerControl = isDatePickerControl;
	            if (isDatePickerControl) {
	                var date = new Date();
	                input.appendField("   OR   ", 'OR');
	                input.appendField("Date", 'DATE');
	                input.appendField(new Blockly.FieldNumber(date.getDate(), 0, 31, 1), "PROPERTY_VALUE");
	                input.appendField("Month", 'MONTH');
	                input.appendField(new Blockly.FieldNumber(date.getMonth() + 1, 0, 12, 1), "PROPERTY_VALUE_MONTH");
	                input.appendField("Year", 'YEAR');
	                input.appendField(new Blockly.FieldNumber(date.getFullYear(), 0, 9999, 1), "PROPERTY_VALUE_YEAR");
	                input.appendField("Hour", 'HOUR');
	                input.appendField(new Blockly.FieldNumber(this.getTwelveHourTime(), 0, 12, 1), "PROPERTY_VALUE_HOUR");
	                input.appendField("Minutes", 'MINUTES');
	                input.appendField(new Blockly.FieldNumber(date.getMinutes(), 0, 60, 1), "PROPERTY_VALUE_MINUTES");
	                input.appendField("AM/PM", 'MERIDIAN');
	                if (this.getAdjustedTimeObjectForAmPm()[0] == 'AM') {
	                    input.appendField(new Blockly.FieldDropdown([['AM', 'AM'], ['PM', 'PM']]), "PROPERTY_VALUE_MERIDIAN");
	                }
	                else {
	                    input.appendField(new Blockly.FieldDropdown([['PM', 'PM'], ['AM', 'AM']]), "PROPERTY_VALUE_MERIDIAN");
	                }
	                input.fieldRow[12].selectedOption_ = this.getAdjustedTimeObjectForAmPm(); //  For setting the selected value of dropdown field 
	                input.fieldRow[12].value_ = input.fieldRow[12].selectedOption_[0]; //  with AM or PM as per current time.
	            }
	            if (!controlName || this.isTimePickerControl == isTimePickerControl) {
	                return;
	            }
	            this.isTimePickerControl = isTimePickerControl;
	            if (isTimePickerControl) {
	                var date = new Date();
	                input.appendField("   OR   ", 'OR');
	                input.appendField("Hour", 'HOUR');
	                input.appendField(new Blockly.FieldNumber(this.getTwelveHourTime(), 0, 12, 1), "PROPERTY_VALUE_HOUR");
	                input.appendField("Minutes", 'MINUTES');
	                input.appendField(new Blockly.FieldNumber(date.getMinutes(), 0, 60, 1), "PROPERTY_VALUE_MINUTES");
	                input.appendField("AM/PM", 'MERIDIAN');
	                if (this.getAdjustedTimeObjectForAmPm()[0] == 'AM') {
	                    input.appendField(new Blockly.FieldDropdown([['AM', 'AM'], ['PM', 'PM']]), "PROPERTY_VALUE_MERIDIAN");
	                }
	                else {
	                    input.appendField(new Blockly.FieldDropdown([['PM', 'PM'], ['AM', 'AM']]), "PROPERTY_VALUE_MERIDIAN");
	                }
	                input.fieldRow[6].selectedOption_ = this.getAdjustedTimeObjectForAmPm(); //  For setting the selected value of dropdown field
	                input.fieldRow[6].value_ = input.fieldRow[6].selectedOption_[0]; //  with AM or PM as per current time.
	            }
	        }
	    };
	    Blockly['JavaScript']['custom-property-value-setter'] = function (block) {
	        var controlName = block.getFieldValue('CONTROL_NAME') || '';
	        var propValue = Blockly['JavaScript'].valueToCode(block, 'PROPERTY_VALUE_INPUT', Blockly['JavaScript'].ORDER_NONE) || '';
	        var code = '';
	        var scopeData = Blockly['JavaScript'].valueToCode(block, 'SCOPE_DATA', Blockly['JavaScript'].ORDER_NONE) || '';
	        if (getControlType(controlName) == 'Datepicker') {
	            var year = block.getFieldValue('PROPERTY_VALUE_YEAR');
	            var month = block.getFieldValue('PROPERTY_VALUE_MONTH');
	            var date = block.getFieldValue('PROPERTY_VALUE');
	            var hours = block.getFieldValue('PROPERTY_VALUE_HOUR');
	            var minutes = block.getFieldValue('PROPERTY_VALUE_MINUTES');
	            var meridian = block.getFieldValue('PROPERTY_VALUE_MERIDIAN');
	            var propValueTrimLength = propValue && propValue.replace && propValue.replace(/'/g, '').trim().length;
	            if (propValueTrimLength) {
	                code = " (window.setPropValueByDataFieldName && window.setPropValueByDataFieldName('" + controlName + "', " + propValue + ",'', " + scopeData + "));\n";
	            }
	            else if (date != 0 && month != 0 && year != 0) {
	                propValue = year + "-" + month + "-" + date + " " + hours + ":" + minutes + " " + meridian;
	                code = " (window.setPropValueByDataFieldName && window.setPropValueByDataFieldName('" + controlName + "', \"" + propValue + "\",'', " + scopeData + "));\n";
	            }
	            else {
	                code = " (window.setPropValueByDataFieldName && window.setPropValueByDataFieldName('" + controlName + "', '', " + scopeData + "));\n";
	            }
	        }
	        else if (getControlType(controlName) == 'Timepicker') {
	            var year = new Date().getFullYear();
	            ;
	            var month = new Date().getMonth();
	            ;
	            var date = new Date().getDate();
	            var hours = block.getFieldValue('PROPERTY_VALUE_HOUR');
	            var minutes = block.getFieldValue('PROPERTY_VALUE_MINUTES');
	            var meridian = block.getFieldValue('PROPERTY_VALUE_MERIDIAN');
	            var propValueTrimLength = propValue && propValue.replace && propValue.replace(/'/g, '').trim().length;
	            if (propValueTrimLength) {
	                code = " (window.setPropValueByDataFieldName && window.setPropValueByDataFieldName('" + controlName + "', " + propValue + ", ''," + scopeData + "));\n";
	            }
	            else if ((hours || hours == 0) && (minutes || minutes == 0)) {
	                propValue = year + "-" + month + "-" + date + " " + hours + ":" + minutes + " " + meridian;
	                code = " (window.setPropValueByDataFieldName && window.setPropValueByDataFieldName('" + controlName + "', \"" + propValue + "\",'', " + scopeData + "));\n";
	            }
	            else {
	                code = " (window.setPropValueByDataFieldName && window.setPropValueByDataFieldName('" + controlName + "', '', " + scopeData + "));\n";
	            }
	        }
	        else {
	            if (propValue.indexOf('window.') != -1) {
	                code = " (window.setPropValueByDataFieldName && window.setPropValueByDataFieldName('" + controlName + "', " + propValue + ",'', " + scopeData + ")); \n";
	            }
	            else {
	                code = " (window.setPropValueByDataFieldName && window.setPropValueByDataFieldName('" + controlName + "', " + propValue + ",'', " + scopeData + "));\n";
	            }
	        }
	        return code;
	    };
	    /**
	     * Custom property getter block
	     */
	    Blockly.Blocks['custom-property-getter'] = {
	        init: function () {
	            this.appendDummyInput("CUSTOM_PROP_GETTER_DUMMY_INPUT")
	                .appendField("Getter: Control Name:")
	                .appendField(new Blockly.FieldDropdown(ControlNameOptions, this.validateControlName), 'CONTROL_NAME')
	                .appendField("Property Name:")
	                .appendField(new Blockly.FieldDropdown([['', '']]), "PROPERTY_NAME");
	            this.setInputsInline(true);
	            this.setOutput(true);
	            this.setColour(Blockly.Msg.PROCEDURES_HUE);
	            this.setTooltip("Get element custom property value");
	            this.setHelpUrl("");
	        },
	        validateControlName: function (controlName) {
	            var _this = this;
	            if (this.controlName != controlName) {
	                var oldControlName_4 = this.controlName;
	                this.controlName = controlName;
	                if (!oldControlName_4) {
	                    this.getSourceBlock().updateConnections(controlName, oldControlName_4);
	                }
	                else {
	                    setTimeout(function () {
	                        _this.getSourceBlock().updateConnections(controlName, oldControlName_4);
	                    }, 50);
	                }
	            }
	            return controlName;
	        },
	        updateConnections: function (controlName, oldControlName) {
	            var input = this.getInput('CUSTOM_PROP_GETTER_DUMMY_INPUT');
	            input.removeField('PROPERTY_NAME', true);
	            var options = this.getPropertyNameOptions(controlName);
	            if (options[0][1] != '') {
	                input.appendField(new Blockly.FieldDropdown(options), "PROPERTY_NAME");
	            }
	            refreshScopeInputField(this, oldControlName, controlName, customFields);
	        },
	        getPropertyNameOptions: function (controlName) {
	            return PropertyNameOptions[getControlType(controlName)] || [['', '']];
	        }
	    };
	    Blockly['JavaScript']['custom-property-getter'] = function (block) {
	        var controlName = block.getFieldValue('CONTROL_NAME') || '';
	        var propName = block.getFieldValue('PROPERTY_NAME') || '';
	        var scopeData = Blockly['JavaScript'].valueToCode(block, 'SCOPE_DATA', Blockly['JavaScript'].ORDER_NONE) || '';
	        var code = " (window.getPropValue && window.getPropValue('" + controlName + "', '" + propName + "', " + scopeData + ")) ";
	        return [code, Blockly['JavaScript'].ORDER_VOID];
	    };
	    /**
	    * Custom property value getter block
	    */
	    Blockly.Blocks['custom-property-value-getter'] = {
	        init: function () {
	            this.appendDummyInput("CUSTOM_PROP_VALUE_GETTER_DUMMY_INPUT")
	                .appendField("Get Value: Control Name:")
	                .appendField(new Blockly.FieldDropdown(ControlDataFieldNameOptions, this.validateControlName), 'CONTROL_NAME');
	            this.setInputsInline(true);
	            this.setOutput(true);
	            this.setColour(Blockly.Msg.PROCEDURES_HUE);
	            this.setTooltip("Get element custom property value");
	            this.setHelpUrl("");
	        },
	        validateControlName: function (controlName) {
	            var _this = this;
	            if (this.controlName != controlName) {
	                var oldControlName_5 = this.controlName;
	                this.controlName = controlName;
	                if (!oldControlName_5) {
	                    this.getSourceBlock().updateConnections(controlName, oldControlName_5);
	                }
	                else {
	                    setTimeout(function () {
	                        _this.getSourceBlock().updateConnections(controlName, oldControlName_5);
	                    }, 50);
	                }
	            }
	            return controlName;
	        },
	        updateConnections: function (controlName, oldControlName) {
	            refreshScopeInputField(this, oldControlName, controlName, dataFieldNames);
	        }
	    };
	    Blockly['JavaScript']['custom-property-value-getter'] = function (block) {
	        var controlName = block.getFieldValue('CONTROL_NAME') || '';
	        var scopeData = Blockly['JavaScript'].valueToCode(block, 'SCOPE_DATA', Blockly['JavaScript'].ORDER_NONE) || '';
	        var code = " (window.getPropValueByDataFieldName && window.getPropValueByDataFieldName('" + controlName + "', " + scopeData + ")) ";
	        return [code, Blockly['JavaScript'].ORDER_VOID];
	    };
	    /**
	* RepeatingTable Sequence blockly
	*/
	    Blockly.Blocks['repeating-table-control-sequence'] = {
	        init: function () {
	            this.appendDummyInput('REPEATING_TABLE_SEQUENCE')
	                .appendField("Repeating Table Row Sequence")
	                .appendField(new Blockly.FieldDropdown(RepeatingTableControlNameOptions, this.validateControlName), 'TABLE_NAME')
	                .appendField("ControlName ")
	                .appendField(new Blockly.FieldDropdown(controlsInsideRT), 'CONTROLS_INSIDE_RT')
	                .appendField("Start Number: ")
	                .appendField(new Blockly.FieldNumber(0, 0, 2000, 1), "START_NUMBER");
	            this.setInputsInline(true);
	            this.setPreviousStatement(true, null);
	            this.setNextStatement(true, null);
	            this.setColour(120);
	            this.setTooltip("repeating table sequence.");
	            this.setHelpUrl("");
	        },
	        validateControlName: function (controlName) {
	            var _this = this;
	            if (this.controlName != controlName) {
	                var oldControlName_6 = this.controlName;
	                this.controlName = controlName;
	                if (!oldControlName_6) {
	                    this.getSourceBlock().updateConnections(controlName, oldControlName_6);
	                    this.getSourceBlock().onControlNameChanged(controlName);
	                }
	                else {
	                    setTimeout(function () {
	                        _this.getSourceBlock().updateConnections(controlName, oldControlName_6);
	                        _this.getSourceBlock().onControlNameChanged(controlName);
	                    }, 50);
	                }
	            }
	            return controlName;
	        },
	        updateConnections: function (controlName, oldControlName) {
	            refreshScopeInputField(this, oldControlName, controlName, customFields);
	        },
	        onControlNameChanged: function (controlName, oldControlName) {
	            var input = this.getInput('REPEATING_TABLE_SEQUENCE');
	            var controls = customFields.filter(function (control) { return control.type == 'Textbox' || control.type == 'Textarea'; });
	            if (!controlName || !controls || !controls.length) {
	                input.removeField('CONTROLS_INSIDE_RT', true);
	                input.insertFieldAt(3, new Blockly.FieldDropdown([['Select Control', 'Select Control']]), "CONTROLS_INSIDE_RT");
	            }
	            else {
	                controlsInsideRT = controls.map(function (item) { return [item.key, item.key]; });
	                input.removeField('CONTROLS_INSIDE_RT', true);
	                input.insertFieldAt(3, new Blockly.FieldDropdown(controlsInsideRT), "CONTROLS_INSIDE_RT");
	            }
	        },
	    };
	    Blockly['JavaScript']['repeating-table-control-sequence'] = function (block) {
	        var TableName = block.getFieldValue('TABLE_NAME') || '';
	        var controlName = block.getFieldValue('CONTROLS_INSIDE_RT');
	        var startNumber = block.getFieldValue('START_NUMBER');
	        var scopeData = Blockly['JavaScript'].valueToCode(block, 'SCOPE_DATA', Blockly['JavaScript'].ORDER_NONE) || 'null';
	        var code = " window.repeatingTableInsertNumber && window.repeatingTableInsertNumber('" + TableName + "','" + controlName + "','" + (startNumber - 1) + "'," + scopeData + ");\n ";
	        return code;
	    };
	    /**
	     * Custom control to reset repeating table value
	     */
	    Blockly.Blocks['custom-reset-repeating-table'] = {
	        init: function () {
	            this.appendDummyInput('CUSTOM_REPEATING_TABLE_DUMMY_INPUT')
	                .appendField("Reset Repeating Table : Control Name:")
	                .appendField(new Blockly.FieldDropdown(RepeatingTableControlNameOptions), 'CONTROL_NAME');
	            this.setInputsInline(true);
	            this.setPreviousStatement(true, null);
	            this.setNextStatement(true, null);
	            this.setColour(120);
	            this.setTooltip("Reset selected repeating table value.");
	            this.setHelpUrl("");
	        }
	    };
	    Blockly['JavaScript']['custom-reset-repeating-table'] = function (block) {
	        var controlName = block.getFieldValue('CONTROL_NAME') || '';
	        var code = " (window.resetRepeatingTableValue && window.resetRepeatingTableValue('" + controlName + "')); \n ";
	        return code;
	    };
	    /**
	     * Custom console.log blog
	     */
	    Blockly.Blocks['text_console'] = {
	        init: function () {
	            this.appendValueInput("TEXT")
	                .setCheck(null)
	                .appendField("Console Log");
	            this.setInputsInline(true);
	            this.setPreviousStatement(true, null);
	            this.setNextStatement(true, null);
	            this.setColour(160);
	            this.setTooltip("");
	            this.setHelpUrl("");
	        }
	    };
	    Blockly['JavaScript']['text_console'] = function (block) {
	        var value_name = Blockly['JavaScript'].valueToCode(block, 'TEXT', Blockly['JavaScript'].ORDER_ATOMIC);
	        return " window.console && window.console.log && window.console.log(" + value_name + "); \n";
	    };
	    /**
	     * Custom Json stringify and parser block
	     */
	    Blockly.Blocks['json_stringify'] = {
	        init: function () {
	            this.appendValueInput("STING_JSON_CONVERTER")
	                .setCheck(null)
	                .appendField("Convert To:")
	                .appendField(new Blockly.FieldDropdown([["String", "STRING"], ["JSON", "JSON"]]), "CONVERT_TYPE");
	            this.setInputsInline(true);
	            this.setOutput(true, null);
	            this.setColour(160);
	            this.setTooltip("");
	            this.setHelpUrl("");
	        }
	    };
	    Blockly['JavaScript']['json_stringify'] = function (block) {
	        var convertType = block.getFieldValue('CONVERT_TYPE');
	        var value = Blockly['JavaScript'].valueToCode(block, 'STING_JSON_CONVERTER', Blockly['JavaScript'].ORDER_ATOMIC);
	        var code = '';
	        if (convertType == 'STRING') {
	            code = ' JSON.stringify(' + value + ') ';
	        }
	        else {
	            code = ' JSON.parse(' + value + ') ';
	        }
	        return [code, Blockly['JavaScript'].ORDER_NONE];
	    };
	    /**
	     * Parse string to number
	     */
	    Blockly.Blocks['parse_to_number'] = {
	        init: function () {
	            this.appendValueInput("PARSE_TO_NUMBER")
	                .setCheck(null)
	                .appendField("Parse To Number:");
	            this.setInputsInline(true);
	            this.setOutput(true, null);
	            this.setColour(230);
	            this.setTooltip("It parses a string and returns a number.");
	            this.setHelpUrl("");
	        }
	    };
	    Blockly['JavaScript']['parse_to_number'] = function (block) {
	        var value = Blockly['JavaScript'].valueToCode(block, 'PARSE_TO_NUMBER', Blockly['JavaScript'].ORDER_ATOMIC);
	        var code = " isNaN(parseFloat(" + value + ")) ? " + value + " : parseFloat(" + value + ") ";
	        return [code, Blockly['JavaScript'].ORDER_NONE];
	    };
	    /**
	     * Custom Blockly component to set time out to execute some block of script code
	     */
	    Blockly.Blocks['set_timeout'] = {
	        init: function () {
	            this.appendDummyInput()
	                .appendField("setTimeout by")
	                .appendField(new Blockly.FieldNumber(0, 0, 60000, 1), "TIME");
	            this.appendStatementInput("TIMEOUT_HANDLER")
	                .setCheck(null);
	            this.setInputsInline(false);
	            this.setOutput(true, null);
	            this.setColour(290);
	            this.setTooltip("");
	            this.setHelpUrl("");
	        }
	    };
	    Blockly['JavaScript']['set_timeout'] = function (block) {
	        var time = block.getFieldValue('TIME');
	        var timeoutHhandler = Blockly['JavaScript'].statementToCode(block, 'TIMEOUT_HANDLER');
	        var code = " window.setTimeout(function() {\n      " + timeoutHhandler + "\n    }, " + time + ") ";
	        return [code, Blockly['JavaScript'].ORDER_NONE];
	    };
	    /**
	     * Custom Blockly component to set some interval to execute some block of script code
	     */
	    Blockly.Blocks['set_time_interval'] = {
	        init: function () {
	            this.appendDummyInput()
	                .appendField("setInterval by")
	                .appendField(new Blockly.FieldNumber(0, 0, 60000, 1), "TIME");
	            this.appendStatementInput("TIMEINTERVAL_HANDLER")
	                .setCheck(null);
	            this.setInputsInline(false);
	            this.setOutput(true, null);
	            this.setColour(290);
	            this.setTooltip("");
	            this.setHelpUrl("");
	        }
	    };
	    Blockly['JavaScript']['set_time_interval'] = function (block) {
	        var time = block.getFieldValue('TIME');
	        var timeoutHhandler = Blockly['JavaScript'].statementToCode(block, 'TIMEINTERVAL_HANDLER');
	        var code = " window.setInterval(function() {\n      " + timeoutHhandler + "\n    }, " + time + ") ";
	        return [code, Blockly['JavaScript'].ORDER_NONE];
	    };
	    /**
	     * Custom Blockly component to clear time out
	     */
	    Blockly.Blocks['clear_timeout'] = {
	        init: function () {
	            this.appendValueInput("TIMEOUT_ID")
	                .setCheck(null)
	                .appendField("Clear timeout ");
	            this.setInputsInline(true);
	            this.setPreviousStatement(true, null);
	            this.setNextStatement(true, null);
	            this.setColour(290);
	            this.setTooltip("");
	            this.setHelpUrl("");
	        }
	    };
	    Blockly['JavaScript']['clear_timeout'] = function (block) {
	        var timerId = Blockly['JavaScript'].valueToCode(block, 'TIMEOUT_ID', Blockly['JavaScript'].ORDER_ATOMIC);
	        return " window.clearTimeout(" + timerId + ") \n";
	    };
	    /**
	     * Custom Blockly component to clear time interval
	     */
	    Blockly.Blocks['clear_time_interval'] = {
	        init: function () {
	            this.appendValueInput("TIMEOUT_ID")
	                .setCheck(null)
	                .appendField("Clear interval ");
	            this.setInputsInline(true);
	            this.setPreviousStatement(true, null);
	            this.setNextStatement(true, null);
	            this.setColour(290);
	            this.setTooltip("");
	            this.setHelpUrl("");
	        }
	    };
	    Blockly['JavaScript']['clear_time_interval'] = function (block) {
	        var timerId = Blockly['JavaScript'].valueToCode(block, 'TIMEOUT_ID', Blockly['JavaScript'].ORDER_ATOMIC);
	        return " window.clearInterval(" + timerId + ") \n";
	    };
	    /**
	     * Custom date difference in days block
	     */
	    Blockly.Blocks['custom-date-diff'] = {
	        init: function () {
	            this.appendDummyInput()
	                .appendField("Get Date Difference: Date1 ")
	                .appendField(new Blockly.FieldDropdown(DateControlNameOptions), "DATE1")
	                .appendField("Date2 ")
	                .appendField(new Blockly.FieldDropdown(DateControlNameOptions), "DATE2");
	            this.setOutput(true, null);
	            this.setColour(290);
	            this.setTooltip("Get date difference in days");
	            this.setHelpUrl("");
	        }
	    };
	    Blockly['JavaScript']['custom-date-diff'] = function (block) {
	        var datecontrolName1 = block.getFieldValue('DATE1');
	        var datecontrolName2 = block.getFieldValue('DATE2');
	        var code = " window.getDateDifference && window.getDateDifference('DateDataFieldName####" + datecontrolName1 + "####', 'DateDataFieldName####" + datecontrolName2 + "####') ";
	        return [code, Blockly['JavaScript'].ORDER_NONE];
	    };
	    // DateTime Difference 
	    Blockly.Blocks['custom-date-time-diff'] = {
	        init: function () {
	            this.appendDummyInput()
	                .appendField("Get Date Time Difference: Date Time1 ")
	                .appendField(new Blockly.FieldDropdown(DateTimeControlOptions), "DATETIME1")
	                .appendField("Date Time2 ")
	                .appendField(new Blockly.FieldDropdown(DateTimeControlOptions), "DATETIME2")
	                .appendField("Time Format ")
	                .appendField(new Blockly.FieldDropdown(DateTimeFormatOptions), "DATETIMEFORMAT");
	            this.setOutput(true, null);
	            this.setColour(290);
	            this.setTooltip("Get date time difference in HH:MM or HH");
	            this.setHelpUrl("");
	        }
	    };
	    Blockly['JavaScript']['custom-date-time-diff'] = function (block) {
	        var datetimecontrolName1 = block.getFieldValue('DATETIME1');
	        var datetimecontrolName2 = block.getFieldValue('DATETIME2');
	        var dateTimeFormat = block.getFieldValue('DATETIMEFORMAT');
	        var code = " window.getDateTimeDifference && window.getDateTimeDifference('DateDataFieldName####" + datetimecontrolName1 + "####', 'DateDataFieldName####" + datetimecontrolName2 + "####', 'TimeFormat####" + dateTimeFormat + "####') ";
	        return [code, Blockly['JavaScript'].ORDER_NONE];
	    };
	    Blockly.Blocks['custom-date-add-subtract'] = {
	        init: function () {
	            this.appendValueInput("DAYS")
	                .setCheck(null)
	                .appendField("Add / Subtract Days: Date")
	                .appendField(new Blockly.FieldDropdown(DateControlNameOptions), "CONTROL_NAME")
	                .appendField(new Blockly.FieldDropdown([["+", "ADD"], ["-", "SUBTRACT"]]), "OPERATOR")
	                .appendField(" No of days");
	            this.setInputsInline(true);
	            this.setOutput(true, null);
	            this.setColour(290);
	            this.setTooltip("Add / Subtract days to a date to derive a new date. Please make sure you have enter valid integer numbers in days.");
	            this.setHelpUrl("");
	        }
	    };
	    Blockly['JavaScript']['custom-date-add-subtract'] = function (block) {
	        var date = block.getFieldValue('CONTROL_NAME');
	        var operator = block.getFieldValue('OPERATOR');
	        var days = Blockly['JavaScript'].valueToCode(block, 'DAYS', Blockly['JavaScript'].ORDER_ATOMIC);
	        var code = " window.addOrSubtractDate && window.addOrSubtractDate('" + date + "', '" + operator + "', " + days + ") ";
	        return [code, Blockly['JavaScript'].ORDER_NONE];
	    };
	    Blockly.Blocks['custom-date-add-working-days'] = {
	        init: function () {
	            this.appendValueInput("NAME")
	                .setCheck(null)
	                .appendField("Set Working Days : Current Date")
	                .appendField(new Blockly.FieldDropdown(DateControlNameOptions), "CONTROL_NAME")
	                .appendField(new Blockly.FieldDropdown([["+", "ADD"]]), "OPERATOR")
	                .appendField("No of days");
	            this.setInputsInline(true);
	            this.setPreviousStatement(true, null);
	            this.setNextStatement(true, null);
	            this.setColour(290);
	            this.setTooltip("");
	            this.setHelpUrl("");
	        }
	    };
	    Blockly['JavaScript']['custom-date-add-working-days'] = function (block, generator) {
	        var control_name = block.getFieldValue('CONTROL_NAME');
	        var dropdown_operator = block.getFieldValue('OPERATOR');
	        var Days = Blockly['JavaScript'].valueToCode(block, 'NAME', Blockly['JavaScript'].ORDER_ATOMIC);
	        var code = "window.addWorkingDays && window.addWorkingDays('" + control_name + "', '" + dropdown_operator + "', " + Days + ");";
	        return code;
	    };
	    Blockly.Blocks['field-custom-date-add-working-days'] = {
	        init: function () {
	            this.appendDummyInput()
	                .appendField("Set Project Working Days : Source field : ")
	                .appendField(new Blockly.FieldDropdown(dateFieldName), "SOURCE_FIELD_NAME")
	                .appendField(new Blockly.FieldDropdown([["+", "ADD"]]), "OPERATOR")
	                .appendField(" No of days : ");
	            this.appendValueInput("NAME")
	                .setCheck(null);
	            this.appendDummyInput()
	                .appendField("Apply to field : ")
	                .appendField(new Blockly.FieldDropdown(DateControlNameOptions), "CONTROL_NAME");
	            this.setInputsInline(true);
	            this.setPreviousStatement(true, null);
	            this.setNextStatement(true, null);
	            this.setColour(290);
	            this.setTooltip("Field name will be displayed in the Source Field Dropdown and Data field name will be displayed in the Apply To Field Dropdown");
	            this.setHelpUrl("");
	        }
	    };
	    Blockly['JavaScript']['field-custom-date-add-working-days'] = function (block, generator) {
	        var source_field_name = block.getFieldValue('SOURCE_FIELD_NAME');
	        var control_name = block.getFieldValue('CONTROL_NAME');
	        var dropdown_operator = block.getFieldValue('OPERATOR');
	        var Days = Blockly['JavaScript'].valueToCode(block, 'NAME', Blockly['JavaScript'].ORDER_ATOMIC);
	        var code = "window.addWorkingDaysForCustomDate && window.addWorkingDaysForCustomDate('" + source_field_name + "', '" + control_name + "', '" + dropdown_operator + "', " + Days + ");";
	        return code;
	    };
	    /*
	     * Custom block to get System Field value
	     */
	    Blockly.Blocks['sp_value_getter'] = {
	        init: function () {
	            this.appendDummyInput("CUSTOM_SP_VALUE_COMPARATOR_DUMMY_INPUT")
	                .appendField("Get System Field Value: ")
	                .appendField(new Blockly.FieldDropdown(SystemFieldNameOptions), "SP_NAME");
	            this.setInputsInline(true);
	            this.setOutput(true);
	            this.setColour(290);
	            this.setTooltip("Get system field value");
	            this.setHelpUrl("");
	        }
	    };
	    Blockly['JavaScript']['sp_value_getter'] = function (block) {
	        var sp_name = block.getFieldValue('SP_NAME');
	        var code = " window.getSystemFieldValue && window.getSystemFieldValue('" + sp_name + "') ";
	        return [code, Blockly['JavaScript'].ORDER_NONE];
	    };
	    // sp user details
	    Blockly.Blocks['sp_user_details_getter'] = {
	        init: function () {
	            this.appendDummyInput("Get User Details")
	                .appendField("Get User Details: ")
	                .appendField(new Blockly.FieldDropdown(spUserDetailsOptions), "USER_DETAIL_OPTION");
	            this.setInputsInline(true);
	            this.setOutput(true);
	            this.setColour(290);
	            this.setTooltip("Get User Details");
	            this.setHelpUrl("");
	        }
	    };
	    Blockly['JavaScript']['sp_user_details_getter'] = function (block) {
	        var selectedOption = block.getFieldValue('USER_DETAIL_OPTION');
	        var code = " window.getUserDetailsFromSelectedOption && window.getUserDetailsFromSelectedOption('DS_USERDETAILS_FILTERED', '" + selectedOption + "') ";
	        return [code, Blockly['JavaScript'].ORDER_NONE];
	    };
	    /*
	     * Custom block to get Current Date and Time
	     */
	    Blockly.Blocks['cur_datetime_value_getter'] = {
	        init: function () {
	            this.appendDummyInput("CUSTOM_TIME_VALUE_DUMMY_INPUT")
	                .appendField("Get Current Date/Time:")
	                .appendField(new Blockly.FieldDropdown(CurrentDateFieldOptions, this.validateFormatType), "DATE_TYPE");
	            this.setInputsInline(true);
	            this.setOutput(true);
	            this.setColour(290);
	            this.setTooltip("Get Current Date/Time");
	            this.setHelpUrl("");
	        },
	        validateFormatType: function (formatType) {
	            var block = this.getSourceBlock();
	            var oldFormatType = block.formatType;
	            block.formatType = formatType;
	            if (!oldFormatType) {
	                block.appendPropertyValueField(formatType);
	            }
	            else {
	                setTimeout(function () {
	                    block.appendPropertyValueField(formatType);
	                }, 50);
	            }
	            return formatType;
	        },
	        appendPropertyValueField: function (formatType) {
	            var input = this.getInput('CUSTOM_TIME_VALUE_DUMMY_INPUT');
	            input.removeField("SHOW_MERIDIAN", true);
	            input.removeField("MERIDIAN_VALUE", true);
	            if (!formatType) {
	                return;
	            }
	            var type = formatType || '';
	            if (type != 'date') {
	                input.appendField("Show Meridian", 'SHOW_MERIDIAN');
	                input.appendField(new Blockly.FieldCheckbox(true), 'MERIDIAN_VALUE');
	                return;
	            }
	        }
	    };
	    Blockly['JavaScript']['cur_datetime_value_getter'] = function (block) {
	        var dateType = block.getFieldValue('DATE_TYPE');
	        var showMeridian = block.getFieldValue('MERIDIAN_VALUE');
	        var code = " window.getCurrentDateTime && window.getCurrentDateTime('" + dateType + "', '" + showMeridian + "') ";
	        return [code, Blockly['JavaScript'].ORDER_NONE];
	    };
	    /**
	     * Custom block to compate System Field value
	     */
	    Blockly.Blocks['sp_value_comparator'] = {
	        init: function () {
	            this.appendDummyInput("CUSTOM_SP_VALUE_COMPARATOR_DUMMY_INPUT")
	                .appendField("Compare System Field Value: ")
	                .appendField(new Blockly.FieldDropdown(SystemFieldNameOptions, this.validateSystemFieldName), "SP_NAME")
	                .appendField(new Blockly.FieldDropdown([["==", "=="], ["!=", "!="]]), "COMPARATOR_NAME")
	                .appendField(new Blockly.FieldTextInput(""), "SP_VALUE");
	            this.setInputsInline(true);
	            this.setOutput(true, "Boolean");
	            this.setColour(290);
	            this.setTooltip("Compare system field value");
	            this.setHelpUrl("");
	        },
	        validateSystemFieldName: function (systemFieldName) {
	            var block = this.getSourceBlock();
	            if (block.systemFieldName != systemFieldName) {
	                var oldSystemFieldName = block.systemFieldName;
	                block.systemFieldName = systemFieldName;
	                if (!oldSystemFieldName) {
	                    block.onControlNameChanged(systemFieldName);
	                }
	                else {
	                    setTimeout(function () {
	                        block.onControlNameChanged(systemFieldName);
	                    }, 50);
	                }
	            }
	            return systemFieldName;
	        },
	        onControlNameChanged: function (systemFieldName) {
	            var input = this.getInput('CUSTOM_SP_VALUE_COMPARATOR_DUMMY_INPUT');
	            if (!systemFieldName) {
	                input.removeField('LOADING', true);
	                input.removeField('SP_VALUE', true);
	                input.removeField('SP_VALUE_MONTH', true);
	                input.removeField('SP_VALUE_YEAR', true);
	                input.removeField('DATE', true);
	                input.removeField('MONTH', true);
	                input.removeField('YEAR', true);
	                input.removeField('CONFIRM_LABEL', true);
	                return;
	            }
	            var newSystemFieldType = allSystemFieldsDataType[systemFieldName];
	            if (this.prevSystemFieldType == newSystemFieldType) {
	                return;
	            }
	            input.removeField('SP_VALUE', true);
	            input.removeField('COMPARATOR_NAME', true);
	            if (this.prevSystemFieldType == 'DATE') {
	                input.removeField('SP_VALUE_MONTH', true);
	                input.removeField('SP_VALUE_YEAR', true);
	                input.removeField('DATE', true);
	                input.removeField('MONTH', true);
	                input.removeField('YEAR', true);
	            }
	            else if (this.prevSystemFieldType == 'BOOLEAN') {
	                input.removeField('CONFIRM_LABEL', true);
	            }
	            this.prevSystemFieldType = newSystemFieldType;
	            if (newSystemFieldType == 'DATE') {
	                input.appendField(new Blockly.FieldDropdown([["==", "=="], ["!=", "!="], ["<", "<"], ["<=", "<="], [">", ">"], [">=", ">="]]), "COMPARATOR_NAME");
	            }
	            else {
	                input.appendField(new Blockly.FieldDropdown([["==", "=="], ["!=", "!="]]), "COMPARATOR_NAME");
	            }
	            if (newSystemFieldType == 'DATE') {
	                var date = new Date();
	                input.appendField(" Date", 'DATE');
	                input.appendField(new Blockly.FieldNumber(date.getDate(), 0, 31, 1), "SP_VALUE");
	                input.appendField("Month", 'MONTH');
	                input.appendField(new Blockly.FieldNumber(date.getMonth() + 1, 1, 12, 1), "SP_VALUE_MONTH");
	                input.appendField("Year", 'YEAR');
	                input.appendField(new Blockly.FieldNumber(date.getFullYear(), 1970, 9999, 1), "SP_VALUE_YEAR");
	            }
	            else if (newSystemFieldType == 'BOOLEAN') {
	                input.appendField(new Blockly.FieldCheckbox(true), "SP_VALUE");
	                input.appendField("Yes", 'CONFIRM_LABEL');
	            }
	            else {
	                input.appendField(new Blockly.FieldTextInput(""), "SP_VALUE");
	            }
	        }
	    };
	    Blockly['JavaScript']['sp_value_comparator'] = function (block) {
	        var sp_name = block.getFieldValue('SP_NAME');
	        var comparator_name = block.getFieldValue('COMPARATOR_NAME');
	        var sp_value = block.getFieldValue('SP_VALUE');
	        if (this.prevSystemFieldType == 'DATE') {
	            sp_value = block.getFieldValue('SP_VALUE_YEAR') + '-' + block.getFieldValue('SP_VALUE_MONTH') + '-' + sp_value;
	        }
	        var code = " window.compareSystemFieldValue && window.compareSystemFieldValue(\"" + sp_name + "\", \"" + comparator_name + "\", \"" + sp_value + "\", \"" + this.prevSystemFieldType + "\") ";
	        return [code, Blockly['JavaScript'].ORDER_NONE];
	    };
	    Blockly.Blocks['auto_next_number_block'] = {
	        init: function () {
	            this.appendDummyInput('CUSTOM_AUTO_NEXT_NUMBER_DUMMY_INPUT')
	                .appendField("Auto Numbering: ")
	                .appendField(new Blockly.FieldDropdown(AutoNumberControlNameOptions), "AUTO_NUMBER_FIELD")
	                .appendField("Length: ")
	                .appendField(new Blockly.FieldNumber(3, 1, 25, 1, this.autoNumbeLengthChanged), "AUTO_NUMBER_LENGTH")
	                .appendField("Start: ")
	                .appendField(new Blockly.FieldTextInput('000', this.validateStartFrom), "AUTO_NUMBER_START_FROM")
	                .appendField("Position: ")
	                .appendField(new Blockly.FieldDropdown([["Suffix", "POSTFIX"]]), "AUTO_NUMBER_POSITION")
	                .appendField("Separator: ")
	                .appendField(new Blockly.FieldDropdown([["-", "-"]]), "AUTO_NUMBER_SEPARATOR")
	                .appendField("String Check: ")
	                .appendField(new Blockly.FieldDropdown([["YES", "YES"], ["NO", "NO"]]), "AUTO_NUMBER_STRINGCHECK")
	                .appendField("AutoNumbering")
	                .appendField(new Blockly.FieldDropdown([["YES", "YES"], ["NO", "NO"]]), "EXECUTE_AUTO_NUMBER")
	                .appendField(" Value");
	            this.appendValueInput("AUTO_NUMBER_TITLE")
	                .setCheck(null);
	            this.setInputsInline(true);
	            this.setPreviousStatement(true, null);
	            this.setNextStatement(true, null);
	            this.setColour(290);
	            this.setTooltip("Set auto numbering on selected data field name control.");
	            this.setHelpUrl("");
	        },
	        autoNumbeLengthChanged: function (autoNumberLength) {
	            var block = this.getSourceBlock();
	            if (block) {
	                var input = block.getInput('CUSTOM_AUTO_NEXT_NUMBER_DUMMY_INPUT');
	                input.removeField('AUTO_NUMBER_START_FROM', true);
	                var startFromVal = '';
	                for (var i = 0; i < autoNumberLength; i++) {
	                    startFromVal += '0';
	                }
	                input.insertFieldAt(5, new Blockly.FieldTextInput(startFromVal, block.validateStartFrom), "AUTO_NUMBER_START_FROM");
	            }
	        },
	        validateStartFrom: function (newValue) {
	            if (newValue.indexOf(".") != -1 || newValue.indexOf("+") != -1 || newValue.indexOf("-") != -1 || isNaN(+newValue)) {
	                return null;
	            }
	            var block = this.getSourceBlock();
	            var seqLength = block.getFieldValue('AUTO_NUMBER_LENGTH');
	            if (seqLength != newValue.length) {
	                return null;
	            }
	            return newValue;
	        },
	    };
	    Blockly['JavaScript']['auto_next_number_block'] = function (block) {
	        var autoNumberField = block.getFieldValue('AUTO_NUMBER_FIELD');
	        var autoNumberLength = block.getFieldValue('AUTO_NUMBER_LENGTH');
	        var autoNumberStartFrom = +(block.getFieldValue('AUTO_NUMBER_START_FROM'));
	        var autoNumberPosition = block.getFieldValue('AUTO_NUMBER_POSITION');
	        var autoNumberSeparator = block.getFieldValue('AUTO_NUMBER_SEPARATOR');
	        var autoNumberStringCheck = block.getFieldValue('AUTO_NUMBER_STRINGCHECK');
	        var isAutoNumbering = block.getFieldValue('EXECUTE_AUTO_NUMBER');
	        var autoNumberTitle = Blockly['JavaScript'].valueToCode(block, 'AUTO_NUMBER_TITLE', Blockly['JavaScript'].ORDER_ATOMIC) || 'null';
	        var code = " window.setAutoNumbering && window.setAutoNumbering('" + autoNumberField + "', " + autoNumberLength + ", " + (autoNumberStartFrom - 1) + ", '" + autoNumberPosition + "', '" + autoNumberSeparator + "', '" + autoNumberStringCheck + "', " + autoNumberTitle + ", '" + isAutoNumbering + "'); \n ";
	        return code;
	    };
	    /**
	    * suffix block for autonumbering
	    */
	    Blockly.Blocks['auto_next_number_suffix_block'] = {
	        init: function () {
	            this.appendDummyInput('CUSTOM_AUTO_NEXT_NUMBER_DUMMY_INPUT')
	                .appendField("Advance Auto-Numbering")
	                .appendField(new Blockly.FieldDropdown(AutoNumberControlNameOptions), "AUTO_NUMBER_FIELD")
	                .appendField("Length: ")
	                .appendField(new Blockly.FieldNumber(3, 1, 25, 1, this.autoNumbeLengthChanged), "AUTO_NUMBER_LENGTH")
	                .appendField("Start: ")
	                .appendField(new Blockly.FieldTextInput('000', this.validateStartFrom), "AUTO_NUMBER_START_FROM")
	                .appendField("Position: ")
	                .appendField(new Blockly.FieldDropdown([["Suffix", "POSTFIX"]]), "AUTO_NUMBER_POSITION")
	                .appendField("Separator: ")
	                .appendField(new Blockly.FieldDropdown([["-", "-"]]), "AUTO_NUMBER_SEPARATOR")
	                .appendField("String Check: ")
	                .appendField(new Blockly.FieldDropdown([["YES", "YES"], ["NO", "NO"]]), "AUTO_NUMBER_STRINGCHECK")
	                .appendField("AutoNumbering")
	                .appendField(new Blockly.FieldDropdown([["YES", "YES"], ["NO", "NO"]]), "EXECUTE_AUTO_NUMBER")
	                .appendField("Value");
	            this.appendValueInput("AUTO_NUMBER_TITLE");
	            this.appendDummyInput(null)
	                .appendField("AutoNumber Generator: ");
	            this.appendValueInput("GENERATE_NUMBER");
	            this.appendDummyInput(null)
	                .appendField("Suffix: ");
	            this.appendValueInput("SUFFIX_VALUE")
	                .setCheck(null);
	            this.setInputsInline(true);
	            this.setPreviousStatement(true, null);
	            this.setNextStatement(true, null);
	            this.setColour(290);
	            this.setTooltip("Set auto numbering on selected data field name control.");
	            this.setHelpUrl("");
	        },
	        autoNumbeLengthChanged: function (autoNumberLength) {
	            var block = this.getSourceBlock();
	            if (block) {
	                var input = block.getInput('CUSTOM_AUTO_NEXT_NUMBER_DUMMY_INPUT');
	                input.removeField('AUTO_NUMBER_START_FROM', true);
	                var startFromVal = '';
	                for (var i = 0; i < autoNumberLength; i++) {
	                    startFromVal += '0';
	                }
	                input.insertFieldAt(5, new Blockly.FieldTextInput(startFromVal, block.validateStartFrom), "AUTO_NUMBER_START_FROM");
	            }
	        },
	        validateStartFrom: function (newValue) {
	            if (newValue.indexOf(".") != -1 || newValue.indexOf("+") != -1 || newValue.indexOf("-") != -1 || isNaN(+newValue)) {
	                return null;
	            }
	            var block = this.getSourceBlock();
	            var seqLength = block.getFieldValue('AUTO_NUMBER_LENGTH');
	            if (seqLength != newValue.length) {
	                return null;
	            }
	            return newValue;
	        },
	    };
	    Blockly['JavaScript']['auto_next_number_suffix_block'] = function (block) {
	        var autoNumberField = block.getFieldValue('AUTO_NUMBER_FIELD');
	        var autoNumberLength = block.getFieldValue('AUTO_NUMBER_LENGTH');
	        var autoNumberStartFrom = +(block.getFieldValue('AUTO_NUMBER_START_FROM'));
	        var autoNumberPosition = block.getFieldValue('AUTO_NUMBER_POSITION');
	        var autoNumberSeparator = block.getFieldValue('AUTO_NUMBER_SEPARATOR');
	        var autoNumberStringCheck = block.getFieldValue('AUTO_NUMBER_STRINGCHECK');
	        var isAutoNumbering = block.getFieldValue('EXECUTE_AUTO_NUMBER');
	        var autoNumberTitle = Blockly['JavaScript'].valueToCode(block, 'AUTO_NUMBER_TITLE', Blockly['JavaScript'].ORDER_ATOMIC) || 'null';
	        var suffix = Blockly['JavaScript'].valueToCode(block, 'GENERATE_NUMBER', Blockly['JavaScript'].ORDER_ATOMIC) || 'null';
	        var postfix = Blockly['JavaScript'].valueToCode(block, 'SUFFIX_VALUE', Blockly['JavaScript'].ORDER_ATOMIC) || 'null';
	        var code = " window.setAutoNumberingSuffix && window.setAutoNumberingSuffix('" + autoNumberField + "', " + autoNumberLength + ", " + (autoNumberStartFrom - 1) + ", '" + autoNumberPosition + "', '" + autoNumberSeparator + "', '" + autoNumberStringCheck + "', " + autoNumberTitle + ", '" + isAutoNumbering + "', " + suffix + ", " + postfix + " ); \n ";
	        return code;
	    };
	    /**
	     * Custom block to fix floating point value
	     */
	    Blockly.Blocks['custom_math_to_fixed'] = {
	        init: function () {
	            this.appendValueInput("TO_FIXED_INPUT")
	                .setCheck(null)
	                .appendField("toFixed by ")
	                .appendField(new Blockly.FieldNumber(2, 0, 10, 1), "TO_FIXED_NUMBER")
	                .appendField(" ");
	            this.setInputsInline(true);
	            this.setOutput(true, null);
	            this.setColour(230);
	            this.setTooltip("It is rounding the number to keep only passed number of decimals");
	            this.setHelpUrl("");
	        }
	    };
	    Blockly['JavaScript']['custom_math_to_fixed'] = function (block) {
	        var fixedNumberVaue = block.getFieldValue('TO_FIXED_NUMBER');
	        var value = Blockly['JavaScript'].valueToCode(block, 'TO_FIXED_INPUT', Blockly['JavaScript'].ORDER_ATOMIC);
	        var code = " isNaN(parseFloat(" + value + ")) ? '' : (+" + value + ").toFixed(" + fixedNumberVaue + ") ";
	        return [code, Blockly['JavaScript'].ORDER_NONE];
	    };
	    /**
	     * Custom repeating table value getter
	     */
	    Blockly.Blocks['custom-get-repeating-table-rows'] = {
	        init: function () {
	            this.appendDummyInput("CUSTOM_GET_REPEATING_TABLE_ROWS")
	                .appendField("Get Repeating Table Value :")
	                .appendField(new Blockly.FieldDropdown(RepeatingTableControlNameOptions, this.validateControlName), "CONTROL_NAME");
	            this.setInputsInline(true);
	            this.setOutput(true);
	            this.setColour(120);
	            this.setTooltip("Get repeating table value");
	            this.setHelpUrl("");
	        },
	        validateControlName: function (controlName) {
	            var _this = this;
	            if (this.controlName != controlName) {
	                var oldControlName_7 = this.controlName;
	                this.controlName = controlName;
	                if (!oldControlName_7) {
	                    this.getSourceBlock().updateConnections(controlName, oldControlName_7);
	                }
	                else {
	                    setTimeout(function () {
	                        _this.getSourceBlock().updateConnections(controlName, oldControlName_7);
	                    }, 50);
	                }
	            }
	            return controlName;
	        },
	        updateConnections: function (controlName, oldControlName) {
	            refreshScopeInputField(this, oldControlName, controlName, customFields);
	        }
	    };
	    Blockly['JavaScript']['custom-get-repeating-table-rows'] = function (block) {
	        var ct_name = block.getFieldValue('CONTROL_NAME');
	        var scopeData = Blockly['JavaScript'].valueToCode(block, 'SCOPE_DATA', Blockly['JavaScript'].ORDER_NONE) || '';
	        var code = " window.getRepeatingTableValue && window.getRepeatingTableValue('" + ct_name + "', " + scopeData + ") ";
	        return [code, Blockly['JavaScript'].ORDER_NONE];
	    };
	    Blockly['JavaScript']['minmax_datevalue'] = function (block) {
	        var minmax_datevalue = block.getFieldValue('minmax');
	        var gVal = [];
	        var elements = [];
	        for (var i = 0; i < block.itemCount_; i++) {
	            elements[i] = Blockly['JavaScript'].valueToCode(block, 'ADD' + i, Blockly['JavaScript'].ORDER_NONE) || 'null';
	        }
	        console.log(elements);
	        for (var i = 0; i < elements.length; i++) {
	            if (elements[i].indexOf('window.getPropValueByDataFieldName') != -1) {
	                gVal.push(elements[i].split("'")[1]);
	            }
	            else {
	                gVal.push('otherValue');
	            }
	        }
	        var code = " window.getMinmaxDateValue && window.getMinmaxDateValue('" + minmax_datevalue + "', '" + gVal.join('##') + "', " + elements + ")  ";
	        return [code, Blockly['JavaScript'].ORDER_NONE];
	    };
	    Blockly.Blocks['set_api_data'] = {
	        init: function () {
	            this.appendStatementInput("SET_API_DATA")
	                .appendField("Select API ")
	                .appendField(new Blockly.FieldDropdown(APINameOptions, this.validateAPIName), "API_NAME")
	                .appendField(new Blockly.FieldVariable(null), "RESPONSE_DATA_VAR");
	            this.setInputsInline(true);
	            this.setPreviousStatement(true, null);
	            this.setNextStatement(true, null);
	            this.setColour(230);
	            this.setTooltip("Get the API response");
	            this.setHelpUrl("");
	        },
	        validateAPIName: function (apiName) {
	            var block = this.getSourceBlock();
	            var input = block.getInput('SET_API_DATA');
	            if (block.apiName != apiName) {
	                block.apiName = apiName;
	                setTimeout(function () {
	                    if (block.apiName != "") {
	                        block.getApiConnectionData(block.apiName, block, input);
	                    }
	                }, 500);
	            }
	            return apiName;
	        },
	        getApiConnectionData: function (apiname, block, input) {
	            if (block.workspace)
	                block.workspace['isAPIInProgress'] = true;
	            var apiConnection = newOption.apiNames.find(function (obj) {
	                return obj.name == apiname;
	            });
	            var myHeaders, queryString;
	            if (apiConnection.externalApi) {
	                var parameters = angular.copy(apiConnection.parameters);
	                parameters.params = parameters.params.map(function (item) {
	                    item.value = item.testValue;
	                    return item;
	                });
	                parameters.headers = parameters.headers.map(function (item) {
	                    item.value = item.testValue;
	                    return item;
	                });
	                parameters.bodyParams = parameters.bodyParams.map(function (item) {
	                    item.value = item.testValue;
	                    return item;
	                });
	                var datas = Object.assign({}, apiConnection);
	                datas.parameters = angular.copy(parameters);
	                datas.url = datas.testUrl;
	                // pass int unhashed projectId in case of OAuth checked
	                if (apiConnection.authType === api_connection_constants_1.AuthType.OAuth) {
	                    datas.projectId = parseInt(currentProjectID.split("$$")[0]) || datas.projectId;
	                }
	                var url = window.properties.service.commonApiUrl.replace('/commonapi/', '/adoddle/') + '/apps?action_id=858&externalApi=true';
	                var req = {
	                    'url': url,
	                    'method': 'POST',
	                    'withCredentials': true,
	                    data: JSON.stringify(datas),
	                };
	                newOption.$http(req).then(function (response) {
	                    if (block.workspace)
	                        block.workspace['isAPIInProgress'] = false;
	                    response = response.data || response;
	                    block['responseDataFromAPI'] = response;
	                    if (block.getField('RESPONSE_DATA_VAR') && block.getField('RESPONSE_DATA_VAR').getVariable()) {
	                        block.getField('RESPONSE_DATA_VAR').getVariable()['responseDataFromAPI'] = response;
	                    }
	                }, function (error) {
	                    if (block.workspace)
	                        block.workspace['isAPIInProgress'] = false;
	                    console.log("err", error);
	                    return error;
	                });
	            }
	            else {
	                var currentProjectName_1 = "";
	                var findProject = projectsLists.filter(function (item) { return item.id == currentProjectID; });
	                currentProjectName_1 = findProject.length ? findProject[0].value : "";
	                var selectedAsiteApiId_1 = apiConnection.userSelectedAsiteApiId;
	                var selectedApi = newOption.apiNames.find(function (item) {
	                    return item.asiteApiId == selectedAsiteApiId_1;
	                });
	                var queryString_1 = '';
	                var headers = apiConnection.parameters.filter(function (el) { return el.header == true; });
	                headers = headers.reduce(function (prev, curr) {
	                    if (curr.name !== '') {
	                        //prev[curr.name] = self.USP.aSessionId || '';
	                        return prev;
	                    }
	                }, {});
	                var data = apiConnection.parameters.filter(function (el) { return el.header == false; });
	                var operatorObject = {};
	                // create object for the operator fiedname
	                operatorObject = data.reduce(function (prev, curr) {
	                    if (curr.name != "isComingFormApiConnection") {
	                        if (curr.operator == 'IN')
	                            prev["operator_" + curr.name] = "CONTAINS";
	                        else if (curr.operator == 'NOT IN')
	                            prev["operator_" + curr.name] = "NOT_CONTAIN";
	                        else if (curr.operator == '!=')
	                            prev["operator_" + curr.name] = "NOT_EQUALS";
	                        else
	                            prev["operator_" + curr.name] = "EQUALS";
	                    }
	                    return prev;
	                }, {});
	                // create a object for the key value for pair from the array
	                var queryObject = {};
	                queryObject = data.reduce(function (prev, curr) {
	                    if (curr.name !== '') {
	                        if (curr.name == 'projectId') {
	                            prev[curr.name] = newOption.config.formID.projectId;
	                        }
	                        else if (curr.name == 'formTypeId') {
	                            prev[curr.name] = newOption.config.formID.formTypeId;
	                        }
	                        else if (curr.name == 'ProjectName') {
	                            prev[curr.name] = curr.testValue.replaceAll("{{Current Project}}", currentProjectName_1);
	                        }
	                        else
	                            prev[curr.name] = curr.testValue;
	                        return prev;
	                    }
	                }, {});
	                // create a query string from the obect to pass it to the api as queryparam
	                var finalQueryObject_1 = Object.assign({}, queryObject, operatorObject);
	                if (finalQueryObject_1) {
	                    queryString_1 = Object.keys(finalQueryObject_1)
	                        .map(function (name) { return (encodeURIComponent(name) + "=" + encodeURIComponent(finalQueryObject_1[name])); })
	                        .join('&');
	                }
	                // send hasOldDelimiter in app api call
	                var isOldDelimiter = true;
	                if (apiConnection.hasOwnProperty('hasOldDelimiter')) {
	                    isOldDelimiter = apiConnection.hasOldDelimiter;
	                }
	                var internalAPiUrl = window.properties.service.commonApiUrl.replace('/commonapi/', '/adoddle/') + 'apps?action_id=858&hasOldDelimiter=' + isOldDelimiter;
	                queryString_1 = queryString_1 + '&externalApi=false&apiUrl=' + apiConnection.url;
	                var req = {
	                    'url': queryString_1 == '' ? internalAPiUrl : internalAPiUrl + '&' + queryString_1,
	                    'method': apiConnection.requestType,
	                    'withCredentials': true,
	                    'headers': (headers && Object.keys(headers).length === 0) ? {} : headers,
	                };
	                newOption.$http(req).then(function (response) {
	                    if (block.workspace)
	                        block.workspace['isAPIInProgress'] = false;
	                    response = response.data || response;
	                    block['responseDataFromAPI'] = response;
	                    if (block.getField('RESPONSE_DATA_VAR') && block.getField('RESPONSE_DATA_VAR').getVariable()) {
	                        block.getField('RESPONSE_DATA_VAR').getVariable()['responseDataFromAPI'] = response;
	                    }
	                }, function (error) {
	                    if (block.workspace)
	                        block.workspace['isAPIInProgress'] = false;
	                });
	            }
	        }
	    };
	    Blockly['JavaScript']['set_api_data'] = function (block) {
	        var apiName = block.getFieldValue('API_NAME');
	        var apiHandler = Blockly['JavaScript'].statementToCode(block, 'SET_API_DATA');
	        var responseDataVar = Blockly['JavaScript'].variableDB_.getName(block.getFieldValue('RESPONSE_DATA_VAR'), Blockly.VARIABLE_CATEGORY_NAME);
	        var code = "window.mergeDataFromAPI('" + apiName + "',\n      function(responseData) {\n        " + responseDataVar + " = responseData;\n        " + apiHandler + "\n      }\n    );\n";
	        return code;
	    };
	    Blockly.Blocks['location_association'] = {
	        init: function () {
	            this.appendStatementInput("LOCATION_ASSOCIATION")
	                .appendField("Location Association ");
	            this.setInputsInline(true);
	            this.setPreviousStatement(true, null);
	            this.setNextStatement(true, null);
	            this.setColour(230);
	            this.setTooltip("Use while associating location from Projects Tab");
	            this.setHelpUrl("");
	        },
	    };
	    Blockly['JavaScript']['location_association'] = function (block) {
	        var logicHandler = Blockly['JavaScript'].statementToCode(block, 'LOCATION_ASSOCIATION');
	        var code = "function locationAssociationCallback(){\n      " + logicHandler + "\n    };\n";
	        return code;
	    };
	    Blockly.Blocks['get-custom-response'] = {
	        init: function () {
	            this.appendValueInput('RESPONSE_DATA').setCheck(null).appendField("  API Data", "API_DATA_KEY");
	            this.appendDummyInput("CUSTOM_RESPONSE")
	                .appendField("Select field ")
	                .appendField(new Blockly.FieldDropdown(this.generateOptions.bind(this), this.validateFieldOptions), "FIELD_NAME")
	                .appendField(" Option Map ", 'SET_KEY')
	                .appendField(new Blockly.FieldDropdown(this.generateOptions.bind(this), this.validateFieldOptionsMap), 'KEY_NAME');
	            this.setInputsInline(true);
	            this.setOutput(true);
	            this.setColour(290);
	            this.setTooltip("Fetch field data from API response");
	            this.setHelpUrl("");
	            this.jsonInit({ "mutator": "dropdown_mutator" });
	        },
	        generateOptions: function () {
	            var responseDataOptions1 = [['Please select', 'Please select']];
	            var block = this;
	            if (block && block.childBlocks_ && block.childBlocks_[0] && block.childBlocks_[0].getVarModels()[0] && block.childBlocks_[0].getVarModels()[0]['responseDataFromAPI']) {
	                var options_1 = block.recursionOnResponseData(responseDataOptions1, block.childBlocks_[0].getVarModels()[0]['responseDataFromAPI']);
	                return options_1;
	            }
	            else {
	                if (block && block.type == 'get-custom-response' && block.parentBlock_) {
	                    var apiBLock = block.findAPIBlock(block.parentBlock_);
	                    if (apiBLock && apiBLock.responseDataFromAPI) {
	                        var options_2 = block.recursionOnResponseData(responseDataOptions1, apiBLock.responseDataFromAPI);
	                        return options_2;
	                    }
	                }
	            }
	            return responseDataOptions1;
	        },
	        findAPIBlock: function (block) {
	            if (block && block.type == 'set_api_data') {
	                return block;
	            }
	            else {
	                if (block)
	                    return this.findAPIBlock(block.parentBlock_);
	            }
	        },
	        recursionOnResponseData: function (arr, responseData, parentkey, parentArrPathKey) {
	            try {
	                if (responseData && responseData.length > 0) {
	                    responseData = responseData[0];
	                }
	                for (var key in responseData) {
	                    if (responseData.hasOwnProperty(key)) {
	                        var elemVal = responseData[key];
	                        if ((elemVal == null) || (typeof (elemVal) != 'object')) {
	                            if (parentkey) {
	                                arr.push([parentkey + '.' + key, parentkey + '.' + key]);
	                            }
	                            else if (parentArrPathKey) {
	                                var keyPath = parentArrPathKey + '["' + key + '"]';
	                                arr.push([keyPath, key]);
	                            }
	                            else {
	                                arr.push([key, key]);
	                            }
	                        }
	                        else if (elemVal != null && typeof (elemVal) == 'object' && elemVal.length > 0) {
	                            var parentkeynew = parentkey ? parentkey + '.' + key : key;
	                            arr.push([parentkeynew, parentkeynew]);
	                            this.recursionOnResponseData(arr, elemVal[0], '', parentkeynew);
	                        }
	                        else {
	                            var parentkeynew = parentkey ? parentkey + '.' + key : key;
	                            this.recursionOnResponseData(arr, elemVal, parentkeynew);
	                        }
	                    }
	                }
	                return arr;
	            }
	            catch (error) {
	                console.log("Error in recursionOnResponseData: ", error);
	            }
	        },
	        validateFieldOptions: function (fieldName) {
	            var _this = this;
	            var block = this.getSourceBlock();
	            if (this.fieldName != fieldName) {
	                var oldfieldName = this.fieldName;
	                this.fieldName = fieldName;
	                if (!oldfieldName) {
	                    this.getSourceBlock().onFieldNameChanged(block);
	                }
	                else {
	                    setTimeout(function () {
	                        _this.getSourceBlock().onFieldNameChanged(block);
	                    }, 500);
	                }
	            }
	            return fieldName;
	        },
	        validateFieldOptionsMap: function (fieldName) {
	            var block = this.getSourceBlock();
	            if (block.getFieldValue('FIELD_NAME') === 'Please select') {
	                return block.getFieldValue('FIELD_NAME');
	            }
	            return fieldName;
	        },
	        onFieldNameChanged: function (block) {
	            refreshDropdownInputField(block);
	        },
	    };
	    Blockly['JavaScript']['get-custom-response'] = function (block) {
	        var ct_name = block.getFieldValue('FIELD_NAME');
	        var optionMap = block.getFieldValue('KEY_NAME');
	        var responseData = Blockly['JavaScript'].valueToCode(block, 'RESPONSE_DATA', Blockly['JavaScript'].ORDER_NONE) || 'null';
	        var code = "window.getCustomResponse && window.getCustomResponse('" + ct_name + "'," + responseData + ", '" + optionMap + "')\n ";
	        return [code, Blockly['JavaScript'].ORDER_NONE];
	    };
	    Blockly['JavaScript']['custom_dropdownoptions'] = function (block) {
	        var custom_dropdownoptions = block.getFieldValue('DROPDOWN_OPTIONS');
	        var separator_val = block.getFieldValue('OPTION_SEPARATOR');
	        var gVal = [];
	        var elements = [];
	        for (var i = 0; i < block.itemCount_; i++) {
	            elements[i] = Blockly['JavaScript'].valueToCode(block, 'ADD' + i, Blockly['JavaScript'].ORDER_NONE) || 'null';
	        }
	        console.log(elements);
	        for (var i = 0; i < elements.length; i++) {
	            gVal.push(elements[i]);
	        }
	        var code = "(window.getCustomDropdownOptions && window.getCustomDropdownOptions(responseData,'" + custom_dropdownoptions + "', '" + separator_val + "', \"" + gVal.join('##') + "\"))\n ";
	        return [code, Blockly['JavaScript'].ORDER_NONE];
	    };
	    Blockly.Blocks['custom_dropdown'] = {
	        init: function () {
	            this.appendDummyInput("CUSTOM_DROPDOWN")
	                .appendField("Select field ")
	                .appendField(new Blockly.FieldDropdown(this.generateOptions.bind(this), this.validateFieldOptions), "FIELD_NAME");
	            this.setInputsInline(true);
	            this.setOutput(true);
	            this.setColour(290);
	            this.setTooltip("Get filtered fields");
	            this.setHelpUrl("");
	            this.jsonInit({ "mutator": "dropdown_mutator" });
	        },
	        generateOptions: function () {
	            var responseDataOptions1 = [['Please select', '']];
	            var block = this, selectedCollection;
	            if (block && block.type == 'custom_dropdown' && block.parentBlock_) {
	                if (block.parentBlock_ && block.parentBlock_.type == 'custom_dropdownoptions') {
	                    var multipleoptiondropdownBLock = block.parentBlock_;
	                    selectedCollection = multipleoptiondropdownBLock.getFieldValue('DROPDOWN_OPTIONS');
	                }
	                var apiBLock = block.findAPIBlock(block.parentBlock_);
	                if (apiBLock && apiBLock.responseDataFromAPI) {
	                    // custom_dropdownoptions wraps array responses as { root: [...] } the first
	                    // time its own dropdown regenerates, and selectedCollection paths (e.g.
	                    // "root.field1") are relative to that shape. On reload that wrap may not have
	                    // happened yet, so mirror it here instead of relying on the parent having run.
	                    var sourceData = Array.isArray(apiBLock.responseDataFromAPI)
	                        ? { root: apiBLock.responseDataFromAPI }
	                        : apiBLock.responseDataFromAPI;
	                    var filteredData = block.deepFind(sourceData, selectedCollection);
	                    var options_3 = block.recursionOnResponseData(responseDataOptions1, filteredData);
	                    return options_3;
	                }
	            }
	            return responseDataOptions1;
	        },
	        deepFind: function (obj, path) {
	            var current = '';
	            if (obj && path) {
	                var paths = path.split('.'), i;
	                current = obj;
	                for (i = 0; i < paths.length; ++i) {
	                    if (current[paths[i]] == undefined) {
	                        return undefined;
	                    }
	                    else {
	                        current = current[paths[i]];
	                    }
	                }
	            }
	            return current;
	        },
	        findAPIBlock: function (block) {
	            if (block && block.type == 'set_api_data') {
	                return block;
	            }
	            else {
	                if (block)
	                    return this.findAPIBlock(block.parentBlock_);
	            }
	        },
	        recursionOnResponseData: function (arr, responseData, parentkey, parentArrPathKey) {
	            try {
	                if (responseData && responseData.length > 0) {
	                    responseData = responseData[0];
	                }
	                for (var key in responseData) {
	                    if (responseData.hasOwnProperty(key)) {
	                        var elemVal = responseData[key];
	                        if ((elemVal == null) || (typeof (elemVal) != 'object')) {
	                            if (parentkey) {
	                                arr.push([parentkey + '.' + key, parentkey + '.' + key]);
	                            }
	                            else if (parentArrPathKey) {
	                                var keyPath = parentArrPathKey + '["' + key + '"]';
	                                arr.push([keyPath, key]);
	                            }
	                            else {
	                                arr.push([key, key]);
	                            }
	                        }
	                        else if (elemVal != null && typeof (elemVal) == 'object' && elemVal.length > 0) {
	                            var parentkeynew = parentkey ? parentkey + '.' + key : key;
	                            arr.push([parentkeynew, parentkeynew]);
	                            this.recursionOnResponseData(arr, elemVal[0], '', parentkeynew);
	                        }
	                        else {
	                            var parentkeynew = parentkey ? parentkey + '.' + key : key;
	                            this.recursionOnResponseData(arr, elemVal, parentkeynew);
	                        }
	                    }
	                }
	                return arr;
	            }
	            catch (error) {
	                console.log('Error while recursionOnResponseData', error);
	            }
	        },
	        validateFieldOptions: function (fieldName) {
	            if (this.fieldName != fieldName) {
	                this.fieldName = fieldName;
	            }
	            return fieldName;
	        },
	    };
	    Blockly['JavaScript']['custom_dropdown'] = function (block) {
	        var ct_name = block.getFieldValue('FIELD_NAME');
	        return [ct_name, Blockly['JavaScript'].ORDER_ATOMIC];
	        ;
	    };
	    Blockly.Blocks['custom-getter-from-api-for-repeating-table'] = {
	        init: function () {
	            this.appendDummyInput("CUSTOM_REPEATING_RESPONSE")
	                .appendField("Select field ")
	                .appendField(new Blockly.FieldDropdown(this.generateOptions.bind(this), this.validateFieldOptions), "COLLECTION_NAME")
	                .appendField("Option Map ", 'R_KEY_LABEL')
	                .appendField(new Blockly.FieldDropdown(this.generateOptionsForFilteredData.bind(this)), 'R_KEY_NAME');
	            this.appendValueInput('INDEX_DATA').setCheck(null).appendField("Index at", "ROW_INDEX");
	            this.setInputsInline(true);
	            this.setOutput(true);
	            this.setColour(290);
	            this.setTooltip("Fetch data from API response from collection");
	            this.setHelpUrl("");
	            this.jsonInit({ "mutator": "dropdown_mutator" });
	        },
	        generateOptions: function () {
	            var responseDataOptions1 = [['Please select', '']];
	            var block = this;
	            if (block && block.childBlocks_ && block.childBlocks_[0] && block.childBlocks_[0].getVarModels()[0] && block.childBlocks_[0].getVarModels()[0]['responseDataFromAPI']) {
	                var options_4 = block.recursionOnResponseData(responseDataOptions1, block.childBlocks_[0].getVarModels()[0]['responseDataFromAPI']);
	                return options_4;
	            }
	            else {
	                if (block && block.type == 'custom-getter-from-api-for-repeating-table' && block.parentBlock_) {
	                    var apiBLock = block.findAPIBlock(block.parentBlock_);
	                    if (apiBLock && apiBLock.responseDataFromAPI) {
	                        var options_5 = block.recursionOnResponseData(responseDataOptions1, apiBLock.responseDataFromAPI);
	                        return options_5;
	                    }
	                }
	            }
	            return responseDataOptions1;
	        },
	        generateOptionsForFilteredData: function () {
	            var responseDataOptions1 = [['Please select', '']];
	            var block = this, selectedCollection;
	            if (block && block.parentBlock_ && block.getFieldValue('COLLECTION_NAME')) {
	                selectedCollection = block.getFieldValue('COLLECTION_NAME');
	                var apiBlock = block.findAPIBlock(block.parentBlock_);
	                if (apiBlock && apiBlock.responseDataFromAPI) {
	                    var filteredData = block.deepFind(apiBlock.responseDataFromAPI, selectedCollection);
	                    var options_6 = block.recursionOnResponseData(responseDataOptions1, filteredData);
	                    return options_6;
	                }
	            }
	            return responseDataOptions1;
	        },
	        deepFind: function (obj, path) {
	            var current = '';
	            if (obj && path) {
	                var paths = path.split('.'), i;
	                current = obj;
	                for (i = 0; i < paths.length; ++i) {
	                    if (current[paths[i]] == undefined) {
	                        return undefined;
	                    }
	                    else {
	                        current = current[paths[i]];
	                    }
	                }
	            }
	            return current;
	        },
	        findAPIBlock: function (block) {
	            if (block && block.type == 'set_api_data') {
	                return block;
	            }
	            else {
	                if (block)
	                    return this.findAPIBlock(block.parentBlock_);
	            }
	        },
	        recursionOnResponseData: function (arr, responseData, parentkey, parentArrPathKey) {
	            try {
	                if (responseData && responseData.length > 0) {
	                    responseData = responseData[0];
	                }
	                for (var key in responseData) {
	                    if (responseData.hasOwnProperty(key)) {
	                        var elemVal = responseData[key];
	                        if ((elemVal == null) || (typeof (elemVal) != 'object')) {
	                            if (parentkey) {
	                                arr.push([parentkey + '.' + key, parentkey + '.' + key]);
	                            }
	                            else if (parentArrPathKey) {
	                                var keyPath = parentArrPathKey + '["' + key + '"]';
	                                arr.push([keyPath, key]);
	                            }
	                            else {
	                                arr.push([key, key]);
	                            }
	                        }
	                        else if (elemVal != null && typeof (elemVal) == 'object' && elemVal.length > 0) {
	                            var parentkeynew = parentkey ? parentkey + '.' + key : key;
	                            arr.push([parentkeynew, parentkeynew]);
	                            this.recursionOnResponseData(arr, elemVal[0], '', parentkeynew);
	                        }
	                        else {
	                            var parentkeynew = parentkey ? parentkey + '.' + key : key;
	                            this.recursionOnResponseData(arr, elemVal, parentkeynew);
	                        }
	                    }
	                }
	                return arr;
	            }
	            catch (error) {
	                console.log('Error while recursionOnResponseData', error);
	            }
	        },
	        validateFieldOptions: function (fieldName) {
	            if (this.fieldName != fieldName) {
	                this.fieldName = fieldName;
	            }
	            return fieldName;
	        },
	    };
	    Blockly['JavaScript']['custom-getter-from-api-for-repeating-table'] = function (block) {
	        var ct_name = block.getFieldValue('COLLECTION_NAME');
	        var optionMap = block.getFieldValue('R_KEY_NAME');
	        var indexAt = Blockly['JavaScript'].valueToCode(block, 'INDEX_DATA', Blockly['JavaScript'].ORDER_NONE) || 'null';
	        var code = "window.getCustomResponseForRepeatingTable && window.getCustomResponseForRepeatingTable(responseData,'" + ct_name + "'," + indexAt + ", '" + optionMap + "') \n ";
	        return [code, Blockly['JavaScript'].ORDER_NONE];
	    };
	    /**
	     * Auto inserting row in repeating table block
	     */
	    Blockly.Blocks['repeating-table-functionality'] = {
	        init: function () {
	            this.appendDummyInput('REPEATING_TABLE_FUNCTIONALITY')
	                .appendField("Set Repeating Table Functionality : ")
	                .appendField(new Blockly.FieldDropdown(functionalityOptions, this.validateFunctionOption), "FUNCTIONALITY")
	                .appendField(" Control Name :")
	                .appendField(new Blockly.FieldDropdown(RepeatingTableControlNameOptions, this.validateControlName), 'CONTROL_NAME');
	            // .appendField(new Blockly.FieldDropdown(AutoHasIndexOptions, this.validateNumber), "IndexValue")
	            // this.appendValueInput('ROW_DATA').setCheck(null);
	            this.setInputsInline(true);
	            this.setPreviousStatement(true, null);
	            this.setNextStatement(true, null);
	            this.setColour(120);
	            this.setTooltip("repeating table functionality.");
	            this.setHelpUrl("");
	        },
	        validateFunctionOption: function (controlName) {
	            var _this = this;
	            if (this.controlName != controlName) {
	                var oldControlName = this.controlName;
	                this.controlName = controlName;
	                if (!oldControlName) {
	                    this.getSourceBlock().onFunctionalityChange(controlName);
	                }
	                else {
	                    setTimeout(function () {
	                        _this.getSourceBlock().onFunctionalityChange(controlName);
	                    }, 50);
	                }
	            }
	            return controlName;
	        },
	        onFunctionalityChange: function (controlName) {
	            var input = this.getInput('REPEATING_TABLE_FUNCTIONALITY');
	            input.removeField('VALUE_CHECKBOX', true);
	            input.removeField('READONLY_CHECKBOX', true);
	            if (controlName != "insertRow") {
	                input.removeField('INDEX_VALUE', true);
	                input.appendField(new Blockly.FieldDropdown(AutoHasIndexOptionUpdate, this.validateIndexNumber), "INDEX_VALUE");
	            }
	            if (controlName == "insertRow") {
	                input.removeField('INDEX_VALUE', true);
	                input.appendField(new Blockly.FieldDropdown(AutoHasIndexOptions, this.validateIndexNumber), "INDEX_VALUE");
	            }
	            if (controlName == "showRow") {
	                input.appendField(new Blockly.FieldCheckbox(true), 'VALUE_CHECKBOX');
	            }
	            if (controlName == "readOnly") {
	                input.appendField(new Blockly.FieldCheckbox(true), 'READONLY_CHECKBOX');
	            }
	        },
	        validateIndexNumber: function (controlName) {
	            var _this = this;
	            if (this.controlName != controlName) {
	                var oldControlName = this.controlName;
	                this.controlName = controlName;
	                if (!oldControlName) {
	                    this.getSourceBlock().onIndexChange(controlName);
	                }
	                else {
	                    setTimeout(function () {
	                        _this.getSourceBlock().onIndexChange(controlName);
	                    }, 50);
	                }
	            }
	            return controlName;
	        },
	        onIndexChange: function (controlName) {
	            var input = this.getInput('REPEATING_TABLE_FUNCTIONALITY');
	            if (controlName != "allRow") {
	                this.removeInput("ROW_DATA", true);
	                this.removeInput('SCOPE_DATA', true);
	                this.appendValueInput("ROW_DATA").setCheck(null);
	                // if(this.getInput('SCOPE_DATA', true)){
	                // }
	                var inp = this.getFieldValue('CONTROL_NAME');
	                if (isRepeatingTableControl(inp, customFields)) {
	                    this.appendValueInput('SCOPE_DATA').appendField("   Scope: ", 'SCOPE');
	                }
	            }
	            if (controlName == "allRow") {
	                this.removeInput("ROW_DATA", true);
	            }
	        },
	        validateControlName: function (controlName) {
	            var _this = this;
	            if (this.controlName != controlName) {
	                var oldControlName_8 = this.controlName;
	                this.controlName = controlName;
	                if (!oldControlName_8) {
	                    this.getSourceBlock().updateConnections(controlName, oldControlName_8);
	                }
	                else {
	                    setTimeout(function () {
	                        _this.getSourceBlock().updateConnections(controlName, oldControlName_8);
	                    }, 50);
	                }
	            }
	            return controlName;
	        },
	        updateConnections: function (controlName, oldControlName) {
	            refreshScopeInputField(this, oldControlName, controlName, customFields);
	        },
	    };
	    Blockly['JavaScript']['repeating-table-functionality'] = function (block) {
	        var functionality = block.getFieldValue('FUNCTIONALITY');
	        var controlName = block.getFieldValue('CONTROL_NAME') || '';
	        var IndexValue = block.getFieldValue('INDEX_VALUE') || '';
	        var showCheck = block.getFieldValue('VALUE_CHECKBOX');
	        var ReadOnlyCheck = block.getFieldValue('READONLY_CHECKBOX');
	        var index = Blockly['JavaScript'].valueToCode(block, 'ROW_DATA', Blockly['JavaScript'].ORDER_NONE) || 'null';
	        var scopeData = Blockly['JavaScript'].valueToCode(block, 'SCOPE_DATA', Blockly['JavaScript'].ORDER_NONE) || 'null';
	        var code = " window.repeatingTableFunctionality && window.repeatingTableFunctionality('" + functionality + "', 'RepeatingTable####" + controlName + "####', " + index + ", " + scopeData + ", '" + IndexValue + "', '" + showCheck + "', '" + ReadOnlyCheck + "');\n ";
	        return code;
	    };
	    /** @description Detect if the response data structure is nested or flat */
	    var detectStructureType = function (myFields) {
	        // Check if there's a FORM_CUSTOM_FIELDS key (indicator of nested structure)
	        if (myFields['FORM_CUSTOM_FIELDS']) {
	            return 'nested';
	        }
	        return 'flat';
	    };
	    /** @description Extract fields from nested structure (Format 1) */
	    var extractFieldsFromNestedStructure = function (responseData, sortDestinationField) {
	        var myFields = responseData.myFields;
	        var rootKey = Object.keys(responseData)[0];
	        // Process FORM_CUSTOM_FIELDS
	        if (myFields.FORM_CUSTOM_FIELDS) {
	            for (var groupKey in myFields.FORM_CUSTOM_FIELDS) {
	                var group = myFields.FORM_CUSTOM_FIELDS[groupKey];
	                if (typeof group === 'object' && !Array.isArray(group)) {
	                    for (var fieldKey in group) {
	                        var fieldValue = group[fieldKey];
	                        // Handle repeating tables (arrays)
	                        if (Array.isArray(fieldValue)) {
	                            var xpath = "/my:" + rootKey + "/my:FORM_CUSTOM_FIELDS/my:" + groupKey + "/my:" + fieldKey;
	                            sortDestinationField.push([
	                                (fieldKey + " ( " + groupKey + " )"),
	                                xpath + JSON.stringify(fieldValue)
	                            ]);
	                        }
	                        else if (typeof fieldValue === 'object' && fieldValue !== null) {
	                            for (var nestedKey in fieldValue) {
	                                var nestedValue = fieldValue[nestedKey];
	                                var xpath = "/my:" + rootKey + "/my:FORM_CUSTOM_FIELDS/my:" + groupKey + "/my:" + fieldKey + "/my:" + nestedKey;
	                                if (Array.isArray(nestedValue)) {
	                                    sortDestinationField.push([
	                                        (nestedKey + " ( " + fieldKey + " )"),
	                                        xpath + JSON.stringify(nestedValue)
	                                    ]);
	                                }
	                                else {
	                                    sortDestinationField.push([
	                                        (nestedKey + " ( " + groupKey + " )"),
	                                        xpath
	                                    ]);
	                                }
	                            }
	                        }
	                        else {
	                            var xpath = "/my:" + rootKey + "/my:FORM_CUSTOM_FIELDS/my:" + groupKey + "/my:" + fieldKey;
	                            sortDestinationField.push([
	                                (fieldKey + " ( " + groupKey + " )"),
	                                xpath
	                            ]);
	                        }
	                    }
	                }
	            }
	        }
	        // Skip Asite_System_Data_Read_Write and Asite_System_Data_Read_Only (filtered out like in flat structure)
	    };
	    Blockly.Blocks['api_call'] = {
	        init: function () {
	            this.appendStatementInput("API_CALL")
	                .appendField('Launch Form - Target Setup')
	                .appendField(new Blockly.FieldDropdown(this.generateOptions.bind(this), this.validateprojectNames_), "projectName")
	                .appendField(new Blockly.FieldDropdown(this.generateOption.bind(this), this.validateappbuilderID_), "appbuilderID");
	            this.appendDummyInput("FLAG4");
	            this.appendDummyInput("BR1");
	            this.appendDummyInput("FLAG1");
	            this.appendDummyInput("FLAG2");
	            this.appendDummyInput("FLAG10");
	            this.appendDummyInput("FLAG11");
	            this.appendDummyInput("BR2");
	            this.appendDummyInput("FLAG5");
	            this.appendDummyInput("FLAG12");
	            this.appendDummyInput("FLAG13");
	            this.appendDummyInput("FLAG6");
	            this.appendDummyInput("BR3");
	            this.appendDummyInput("FLAG3");
	            this.appendDummyInput("FLAG7");
	            this.appendDummyInput("FLAG8");
	            this.appendDummyInput("FLAG9");
	            this.setPreviousStatement(true, null);
	            this.setNextStatement(true, null);
	            this.setColour(290);
	            this.setTooltip("Get the API reponse");
	            this.setHelpUrl("");
	            this.jsonInit({ "mutator": "dropdown_mutator" });
	        },
	        generateOptions: function () {
	            return projectNames;
	        },
	        generateOption: function () {
	            return appbuilderID;
	        },
	        validateUser_: function (selectedProjectName, block) {
	            var input = block.getInput("FLAG1");
	            var input2 = block.getInput("FLAG2");
	            var input3 = block.getInput("FLAG3");
	            var input4 = block.getInput("FLAG4");
	            var input5 = block.getInput("FLAG5");
	            var input6 = block.getInput("FLAG6");
	            var input7 = block.getInput("FLAG7");
	            var input8 = block.getInput("FLAG8");
	            var input9 = block.getInput("FLAG9");
	            var input10 = block.getInput("FLAG10");
	            var input11 = block.getInput("FLAG11");
	            var input12 = block.getInput("FLAG12");
	            var input13 = block.getInput("FLAG13");
	            var br1 = block.getInput("BR1");
	            var br2 = block.getInput("BR1");
	            var br3 = block.getInput("BR1");
	            if (currentProject && (selectedProjectName == 'Current Project' || currentProject == selectedProjectName)) {
	                input.removeField("cp1", true);
	                input.removeField("DP_DOC_ASSOC", true);
	                input2.removeField("cp2", true);
	                input2.removeField("DP_ORI_FWD_DOC_ASSOC", true);
	                input3.removeField("cp3", true);
	                input3.removeField("DP_FORM_ASSOC", true);
	                input4.removeField("cp4", true);
	                input4.removeField("DP_FORM_ASSOC_CURRENT", true);
	                input5.removeField("cp5", true);
	                input5.removeField("DS_ATTACH_AUTOASSOCIATE_MSG", true);
	                input6.removeField("cp6", true);
	                input6.removeField("DP_ATTACH_ALL_MSG", true);
	                input7.removeField("cp7", true);
	                input7.removeField("DP_FORM_ASSOC_ORI", true);
	                input8.removeField("cp8", true);
	                input8.removeField("DP_All_FORM_ASSOC_CURRENT", true);
	                input9.removeField("cp9", true);
	                input9.removeField("DP_ALL_FORM_ASSOC", true);
	                input10.removeField("cp10", true);
	                input10.removeField("DP_DOC_ASSOC_CURRENT", true);
	                input11.removeField("cp11", true);
	                input11.removeField("DP_DOC_ASSOC_ALL_MSG", true);
	                input12.removeField("cp12", true);
	                input12.removeField("DP_ATTACH_ORI_MSG", true);
	                input13.removeField("cp13", true);
	                input13.removeField("DP_ATTACH_CURRENT_MSG", true);
	                br1.removeField("BR_1", true);
	                br2.removeField("BR_2", true);
	                br3.removeField("BR_3", true);
	                input4.appendField("Associate Source Form", 'cp4').appendField(new Blockly.FieldCheckbox(false), 'DP_FORM_ASSOC_CURRENT');
	                input.appendField("Copy All Document Associations from Latest Message", 'cp1').appendField(new Blockly.FieldCheckbox(false, this.validateAllDocAssoc_), 'DP_DOC_ASSOC');
	                input2.appendField("Copy All Document Associations from ORI Message", 'cp2').appendField(new Blockly.FieldCheckbox(false, this.validateAllDocAssoc_), 'DP_ORI_FWD_DOC_ASSOC');
	                var label1 = new Blockly.FieldLabel('Copy All Document Associations from Current Message');
	                label1.setTooltip('Copy All Document Associations from Current Message');
	                input10.appendField(label1, 'cp10').appendField(new Blockly.FieldCheckbox(false, this.validateAllDocAssoc_), 'DP_DOC_ASSOC_CURRENT');
	                input11.appendField("Copy All Document Associations from All Messages", 'cp11').appendField(new Blockly.FieldCheckbox(false, this.validateDocumentAssociation_), 'DP_DOC_ASSOC_ALL_MSG');
	                input5.appendField("Copy All Attachments from Latest Message", 'cp5').appendField(new Blockly.FieldCheckbox(false, this.validateAllAttach_), 'DS_ATTACH_AUTOASSOCIATE_MSG');
	                input12.appendField("Copy All Attachments from ORI Message", 'cp12').appendField(new Blockly.FieldCheckbox(false, this.validateAllAttach_), 'DP_ATTACH_ORI_MSG');
	                input13.appendField("Copy All Attachments from Current Message", 'cp13').appendField(new Blockly.FieldCheckbox(false, this.validateAllAttach_), 'DP_ATTACH_CURRENT_MSG');
	                input6.appendField("Copy All Attachments from All Messages", 'cp6').appendField(new Blockly.FieldCheckbox(false, this.validateAttachments_), 'DP_ATTACH_ALL_MSG');
	                input3.appendField("Copy All Form Associations from Latest Message", 'cp3').appendField(new Blockly.FieldCheckbox(false, this.validateAllFormAssoc_), 'DP_FORM_ASSOC');
	                input7.appendField("Copy All Form Associations from ORI Message", 'cp7').appendField(new Blockly.FieldCheckbox(false, this.validateAllFormAssoc_), 'DP_FORM_ASSOC_ORI');
	                input8.appendField("Copy All Form Associations from Current Message", 'cp8').appendField(new Blockly.FieldCheckbox(false, this.validateAllFormAssoc_), 'DP_All_FORM_ASSOC_CURRENT');
	                input9.appendField("Copy All Form Associations from All Messages", 'cp9').appendField(new Blockly.FieldCheckbox(false, this.validateFormAssociations_), 'DP_ALL_FORM_ASSOC');
	                br1.appendField('', 'BR_1');
	                br2.appendField('', 'BR_2');
	                br3.appendField('', 'BR_3');
	            }
	            else {
	                input.removeField("cp1", true);
	                input.removeField("DP_DOC_ASSOC", true);
	                input2.removeField("cp2", true);
	                input2.removeField("DP_ORI_FWD_DOC_ASSOC", true);
	                input3.removeField("cp3", true);
	                input3.removeField("DP_FORM_ASSOC", true);
	                input4.removeField("cp4", true);
	                input4.removeField("DP_FORM_ASSOC_CURRENT", true);
	                input5.removeField("cp5", true);
	                input5.removeField("DS_ATTACH_AUTOASSOCIATE_MSG", true);
	                input6.removeField("cp6", true);
	                input6.removeField("DP_ATTACH_ALL_MSG", true);
	                input7.removeField("cp7", true);
	                input7.removeField("DP_FORM_ASSOC_ORI", true);
	                input8.removeField("cp8", true);
	                input8.removeField("DP_All_FORM_ASSOC_CURRENT", true);
	                input9.removeField("cp9", true);
	                input9.removeField("DP_ALL_FORM_ASSOC", true);
	                input10.removeField("cp10", true);
	                input10.removeField("DP_DOC_ASSOC_CURRENT", true);
	                input11.removeField("cp11", true);
	                input11.removeField("DP_DOC_ASSOC_ALL_MSG", true);
	                input12.removeField("cp12", true);
	                input12.removeField("DP_ATTACH_ORI_MSG", true);
	                input13.removeField("cp13", true);
	                input13.removeField("DP_ATTACH_CURRENT_MSG", true);
	                br1.removeField("BR_1", true);
	                br2.removeField("BR_2", true);
	                br3.removeField("BR_3", true);
	            }
	        },
	        // Function calls on select of project
	        validateprojectNames_: function (projectName) {
	            var appCode = [], sortingFormID = [];
	            var block = this.getSourceBlock();
	            this.getSourceBlock().validateUser_(projectName, block);
	            this.block = projectName;
	            console.log('selected project', projectName);
	            if (this.projectName != projectName) {
	                var oldProjectName = this.projectName;
	                this.projectName = projectName;
	                if (oldProjectName != undefined) {
	                    refreshoptionsDestinationFields_('', block);
	                    block.refreshoptions_(projectName);
	                }
	            }
	            appbuilderID.splice(1, appbuilderID.length - 1);
	            if (projectName != null && projectName != '' && projectName != undefined) {
	                var projectid = void 0, findProject = projectsLists.filter(function (item) { return item.value == projectName; });
	                currentProject && projectName == 'Current Project' ? projectid = currentProjectID : projectid = findProject[0] ? findProject[0].id : findProject;
	                var formNameList = options.Util.getAppBuilderID(projectid);
	                formNameList.then(function (filterData) {
	                    console.log("filterData", filterData);
	                    if (filterData && filterData.length > 0) {
	                        for (var j = 0; j < filterData.length; j++) {
	                            appCode.push(filterData[j].appBuilderFormIDCode);
	                            if (appCode[j] == "") {
	                                appCode[j] = "null#" + +j;
	                            }
	                        }
	                        for (var i = 0; i < filterData.length; i++) {
	                            sortingFormID.push([filterData[i].formTypeName, appCode[i]]);
	                        }
	                        sortingFormID = sortingFormID.sort(function (a, b) {
	                            if (a[0].toLowerCase() > b[0].toLowerCase()) {
	                                return 1;
	                            }
	                            else {
	                                return -1;
	                            }
	                        });
	                        sortingFormID.map(function (array) { return appbuilderID.push(array); });
	                    }
	                });
	            }
	            if (projectName == "") {
	                appbuilderID = [['Select Form Name', '']];
	                block.refreshoptions_(projectName);
	                if (block.childBlocks_[0]) {
	                    destinationFields = [['Select Target Field', '']];
	                    refreshoptionsDestinationFields_('', block);
	                }
	            }
	            return projectName;
	        },
	        refreshoptions_: function (projectName) {
	            var inputFields = this.getInput("API_CALL");
	            inputFields.removeField("appbuilderID", true);
	            inputFields.appendField(new Blockly.FieldDropdown(this.generateOption.bind(this), this.validateappbuilderID_), "appbuilderID");
	        },
	        // Function call when we select the Form name
	        validateappbuilderID_: function (appbuilderCode) {
	            var xpath, sortDestinationField = [];
	            var block = this.getSourceBlock();
	            this.block = appbuilderCode;
	            var input = block.getInput('API_CALL');
	            var projecTName = block.getFieldValue('projectName');
	            if (this.appbuilderCode != appbuilderCode) {
	                var oldAppbuilderCode = this.appbuilderCode;
	                this.appbuilderCode = appbuilderCode;
	                if (oldAppbuilderCode != undefined) {
	                    refreshoptionsDestinationFields_('', block);
	                }
	            }
	            destinationFields.splice(0, destinationFields.length - 1);
	            if (appbuilderCode) {
	                appbuilderCode = appbuilderCode.split('#')[0];
	                var projectid = void 0, findProject = projectsLists.filter(function (item) { return item.value == projecTName; });
	                if (appbuilderCode == 'null') {
	                    options.Notification.error({ message: 'AppBuilder FormID Code is mandatory field in Form Settings, please add it for both Source and Target forms', positionX: 'center', replaceMessage: true });
	                    return;
	                }
	                else {
	                    currentProject && projecTName == 'Current Project' ? projectid = currentProjectID : projectid = findProject[0] ? findProject[0].id : findProject;
	                    var apiCloneBlock = this;
	                    var fieldNameList = options.Util.getDestinationFieldName(projectid, appbuilderCode);
	                    fieldNameList.then(function (responseData) {
	                        updateData(apiCloneBlock);
	                        // Detect structure type and handle accordingly
	                        var structureType = detectStructureType(responseData.myFields);
	                        if (structureType === 'nested') {
	                            // Handle nested structure (Format 1)
	                            extractFieldsFromNestedStructure(responseData, sortDestinationField);
	                        }
	                        else {
	                            // Handle flat structure (Format 2) - EXISTING LOGIC
	                            var filterDatas = Object.keys(responseData.myFields);
	                            if (filterDatas && filterDatas.length > 0) {
	                                filterDatas = filterDatas.filter(function (elem) {
	                                    return elem != 'extraParams' && elem != 'Asite_System_Data_Read_Write' && elem != 'Asite_System_Data_Read_Only' && elem != 'DS_AUTONUMBER_GENERATOR' && elem != 'DS_AUTONUMBER_SUFFIX';
	                                });
	                                for (var i = 0; i < filterDatas.length; i++) {
	                                    xpath = "/my:" + Object.keys(responseData) + "/my:" + filterDatas[i];
	                                    sortDestinationField.push([filterDatas[i], xpath]);
	                                }
	                            }
	                        }
	                        // Handle repeating tables (only for flat structure)
	                        if (structureType === 'flat') {
	                            for (var name in responseData.myFields) {
	                                var rtableFields = void 0;
	                                if (responseData.myFields[name] && responseData.myFields[name].value) {
	                                    var responseDataRT = Object.keys(responseData.myFields[name].value[0]);
	                                    for (var _i = 0, responseDataRT_1 = responseDataRT; _i < responseDataRT_1.length; _i++) {
	                                        var element = responseDataRT_1[_i];
	                                        rtableFields = element;
	                                        if (Array.isArray(responseData.myFields[name].value[0][rtableFields]) == true) {
	                                            responseData.myFields[name].value[0][rtableFields] = '';
	                                        }
	                                        //For Repeating table inside Repeating table
	                                        if (responseData.myFields[name].value[0][rtableFields].value) {
	                                            xpath = "/my:" + Object.keys(responseData) + "/my:" + name + "/my:" + Object.keys(responseData.myFields[name])[2] + "/my:" + rtableFields + "/my:" + Object.keys(responseData.myFields[name].value[0][rtableFields])[2] + JSON.stringify(responseData.myFields[name].value[0][rtableFields].value);
	                                            // sortDestinationField.push([rtableFields + ('(RepeatingTable)'), xpath]);
	                                            // Now the destinationFields controls which are repeating table they having the name of the RT along with the control name. 
	                                            sortDestinationField.push([rtableFields + ' ( ' + name + ' )', xpath]);
	                                            var temp = Object.keys(responseData.myFields[name].value[0][rtableFields].value[0]);
	                                            for (var _a = 0, temp_1 = temp; _a < temp_1.length; _a++) {
	                                                var element_1 = temp_1[_a];
	                                                var tempf = element_1;
	                                                if (Array.isArray(responseData.myFields[name].value[0][rtableFields].value[0][tempf]) == true) {
	                                                    responseData.myFields[name].value[0][rtableFields].value[0][tempf] = '';
	                                                }
	                                                xpath = "/my:" + Object.keys(responseData) + "/my:" + name + "/my:" + Object.keys(responseData.myFields[name])[2] + "/my:" + rtableFields + "/my:" + Object.keys(responseData.myFields[name].value[0][rtableFields])[2] + "/my:" + tempf;
	                                                sortDestinationField.push([tempf + ' ( ' + rtableFields + ' )', xpath]);
	                                            }
	                                        }
	                                        else {
	                                            xpath = "/my:" + Object.keys(responseData) + "/my:" + name + "/my:" + Object.keys(responseData.myFields[name])[2] + "/my:" + rtableFields;
	                                            sortDestinationField.push([rtableFields + ' ( ' + name + ' )', xpath]);
	                                        }
	                                    }
	                                }
	                                if (responseData.myFields[name] && responseData.myFields[name].value) {
	                                    for (var j = 0; j < sortDestinationField.length; j++) {
	                                        if (name == sortDestinationField[j][0]) {
	                                            sortDestinationField[j] = [name, "/my:" + Object.keys(responseData) + "/my:" + name + "/my:" + Object.keys(responseData.myFields[name])[2] + JSON.stringify(responseData.myFields[name].value)];
	                                        }
	                                    }
	                                }
	                            }
	                        }
	                        // Sort and update destination fields
	                        sortDestinationField.sort(function (a, b) {
	                            if (a[0].toLowerCase() > b[0].toLowerCase()) {
	                                return 1;
	                            }
	                            else {
	                                return -1;
	                            }
	                        });
	                        sortDestinationField.map(function (array) { return destinationFields.push(array); });
	                        updateData(apiCloneBlock);
	                    });
	                }
	            }
	            if (appbuilderCode == "" && block.childBlocks_[0]) {
	                destinationFields = [['Select Target Field', '']];
	                refreshoptionsDestinationFields_(appbuilderCode, block);
	            }
	            return appbuilderCode;
	        },
	        validateDocumentAssociation_: function (flagName) {
	            var block = this.getSourceBlock();
	            if (flagName && flagName == "TRUE") {
	                block.setFieldValue(false, 'DP_DOC_ASSOC');
	                block.setFieldValue(false, 'DP_ORI_FWD_DOC_ASSOC');
	                block.setFieldValue(false, 'DP_DOC_ASSOC_CURRENT');
	            }
	        },
	        validateAttachments_: function (flagName) {
	            var block = this.getSourceBlock();
	            if (flagName && flagName == "TRUE") {
	                block.setFieldValue(false, 'DS_ATTACH_AUTOASSOCIATE_MSG');
	                block.setFieldValue(false, 'DP_ATTACH_ORI_MSG');
	                block.setFieldValue(false, 'DP_ATTACH_CURRENT_MSG');
	            }
	        },
	        validateFormAssociations_: function (flagName) {
	            var block = this.getSourceBlock();
	            if (flagName && flagName == "TRUE") {
	                block.setFieldValue(false, 'DP_FORM_ASSOC');
	                block.setFieldValue(false, 'DP_FORM_ASSOC_ORI');
	                block.setFieldValue(false, 'DP_All_FORM_ASSOC_CURRENT');
	            }
	        },
	        validateAllDocAssoc_: function (flagName) {
	            var block = this.getSourceBlock();
	            if (flagName && flagName == "TRUE") {
	                block.setFieldValue(false, 'DP_DOC_ASSOC_ALL_MSG');
	            }
	        },
	        validateAllAttach_: function (flagName) {
	            var block = this.getSourceBlock();
	            if (flagName && flagName == "TRUE") {
	                block.setFieldValue(false, 'DP_ATTACH_ALL_MSG');
	            }
	        },
	        validateAllFormAssoc_: function (flagName) {
	            var block = this.getSourceBlock();
	            if (flagName && flagName == "TRUE") {
	                block.setFieldValue(false, 'DP_ALL_FORM_ASSOC');
	            }
	        }
	    };
	    function updateData(block) {
	        try {
	            var childBlock = void 0;
	            if (block.sourceBlock_) {
	                childBlock = block.sourceBlock_.childBlocks_[0];
	            }
	            else
	                childBlock = block.childBlocks_[0];
	            if (!childBlock) {
	                return;
	            }
	            var inputFields_1 = childBlock.getField('destinationName');
	            if (inputFields_1) {
	                if (inputFields_1.selectedOption_[1].indexOf("/my:myFields") == -1) {
	                    if (inputFields_1.selectedOption_[1].startsWith('[') && inputFields_1.selectedOption_[1].endsWith(']')) {
	                        inputFields_1.selectedOption_[1] = "/my:myFields/my:" + inputFields_1.selectedOption_[0] + "/my:value" + inputFields_1.selectedOption_[1];
	                        inputFields_1.value_ = inputFields_1.selectedOption_[1];
	                    }
	                    else {
	                        inputFields_1.selectedOption_[1] = "/my:myFields/my:" + inputFields_1.selectedOption_[1];
	                        inputFields_1.value_ = inputFields_1.selectedOption_[1];
	                    }
	                }
	                if (destinationFields.length > 1) {
	                    var field = void 0, index = destinationFields.findIndex(function (array) { return inputFields_1.selectedOption_[0] === array[0]; });
	                    field = destinationFields[index];
	                    if (field && inputFields_1.value_ != field[1]) {
	                        inputFields_1.selectedOption_[1] = field[1];
	                        inputFields_1.value_ = field[1];
	                    }
	                }
	            }
	            updateData(childBlock);
	        }
	        catch (e) {
	            console.log("updateData", e);
	        }
	    }
	    function refreshoptionsDestinationFields_(appbuilderCode, block) {
	        var childBlock = block.childBlocks_[0];
	        if (!childBlock) {
	            return;
	        }
	        var inputFields = childBlock.getInput('API_DATA_CLONE');
	        inputFields.removeField("sourceCntName", true);
	        inputFields.removeField("destinationName", true);
	        inputFields.appendField(new Blockly.FieldDropdown(sourceFields), "sourceCntName")
	            .appendField(new Blockly.FieldDropdown(childBlock.generateOptions.bind(childBlock)), "destinationName");
	        refreshoptionsDestinationFields_(appbuilderCode, childBlock);
	    }
	    Blockly['JavaScript']['api_call'] = function (block) {
	        var projectName = block.getFieldValue('projectName');
	        var appbuilderID = block.getFieldValue('appbuilderID');
	        var dp_DOC_ASSOC = block.getFieldValue('DP_DOC_ASSOC');
	        var dp_ORI_FWD_DOC_ASSOC = block.getFieldValue('DP_ORI_FWD_DOC_ASSOC');
	        var dp_FORM_ASSOC = block.getFieldValue('DP_FORM_ASSOC');
	        var dp_FORM_ASSOC_CURRENT = block.getFieldValue('DP_FORM_ASSOC_CURRENT');
	        var ds_ATTACH_AUTOASSOCIATE_MSG = block.getFieldValue('DS_ATTACH_AUTOASSOCIATE_MSG');
	        var dp_ATTACH_ALL_MSG = block.getFieldValue('DP_ATTACH_ALL_MSG');
	        var dp_FORM_ASSOC_ORI = block.getFieldValue("DP_FORM_ASSOC_ORI");
	        var dp_All_FORM_ASSOC_CURRENT = block.getFieldValue("DP_All_FORM_ASSOC_CURRENT");
	        var dp_ALL_FORM_ASSOC = block.getFieldValue("DP_ALL_FORM_ASSOC");
	        var dp_DOC_ASSOC_CURRENT = block.getFieldValue("DP_DOC_ASSOC_CURRENT");
	        var dp_DOC_ASSOC_ALL_MSG = block.getFieldValue("DP_DOC_ASSOC_ALL_MSG");
	        var dp_ATTACH_ORI_MSG = block.getFieldValue("DP_ATTACH_ORI_MSG");
	        var dp_ATTACH_CURRENT_MSG = block.getFieldValue("DP_ATTACH_CURRENT_MSG");
	        var apiHandler = Blockly['JavaScript'].statementToCode(block, 'API_CALL');
	        var code = "window.getFormViewDetail('" + projectName + "','" + appbuilderID + "','" + dp_DOC_ASSOC + "','" + dp_ORI_FWD_DOC_ASSOC + "','" + dp_FORM_ASSOC + "','" + dp_FORM_ASSOC_CURRENT + "','" + ds_ATTACH_AUTOASSOCIATE_MSG + "','" + dp_ATTACH_ALL_MSG + "',\n    function() {\n      var temp = [];\n      " + apiHandler + "\n      return temp;\n      },\n      '" + dp_FORM_ASSOC_ORI + "', '" + dp_All_FORM_ASSOC_CURRENT + "', '" + dp_ALL_FORM_ASSOC + "', '" + dp_DOC_ASSOC_CURRENT + "', '" + dp_DOC_ASSOC_ALL_MSG + "', '" + dp_ATTACH_ORI_MSG + "', '" + dp_ATTACH_CURRENT_MSG + "'\n      );\n";
	        return code;
	    };
	    Blockly.Blocks['api_data_clone'] = {
	        init: function () {
	            this.appendDummyInput("API_DATA_CLONE")
	                .appendField('Launch Form Field Mapping')
	                .appendField(new Blockly.FieldDropdown(sourceFields), "sourceCntName")
	                .appendField(new Blockly.FieldDropdown(this.generateOptions.bind(this)), "destinationName");
	            this.setInputsInline(true);
	            this.setPreviousStatement(true, null);
	            this.setNextStatement(true, null);
	            this.setColour(290);
	            this.setTooltip("data swipe");
	            this.setHelpUrl("");
	            this.jsonInit({ "mutator": "dropdown_mutator" });
	        },
	        generateOptions: function () {
	            return destinationFields;
	        }
	    };
	    Blockly['JavaScript']['api_data_clone'] = function (block) {
	        var scr_Name = block.getFieldValue('sourceCntName');
	        var des_Name = block.getFieldValue('destinationName');
	        console.log(scr_Name, des_Name);
	        var code = " temp.push({source : '" + scr_Name + "', destination : '" + des_Name + "'})\n ";
	        return code;
	    };
	    /** New Colour picker Block with enhancement to support 0 to 255 numbers*/
	    Blockly.Blocks['new_colour_rgb'] = {
	        init: function () {
	            this.appendValueInput("RED")
	                .setAlign(Blockly.ALIGN_RIGHT)
	                .appendField("colour with red");
	            this.appendValueInput("GREEN")
	                .setAlign(Blockly.ALIGN_RIGHT)
	                .appendField("green");
	            this.appendValueInput("BLUE")
	                .setAlign(Blockly.ALIGN_RIGHT)
	                .appendField("blue");
	            this.setInputsInline(false);
	            this.setOutput(true, Array);
	            this.setColour(20);
	            this.setTooltip("Create a colour with the specified amount of red, green and blue. All the values must be between 0 and 255");
	            this.setHelpUrl("");
	        },
	    };
	    Blockly['JavaScript']['new_colour_rgb'] = function (block) {
	        // Compose a colour from RGB components expressed as percentages.
	        var red = Blockly['JavaScript'].valueToCode(block, 'RED', Blockly['JavaScript'].ORDER_COMMA) || 0;
	        var green = Blockly['JavaScript'].valueToCode(block, 'GREEN', Blockly['JavaScript'].ORDER_COMMA) || 0;
	        var blue = Blockly['JavaScript'].valueToCode(block, 'BLUE', Blockly['JavaScript'].ORDER_COMMA) || 0;
	        var functionName = Blockly['JavaScript'].provideFunction_('new_colourRgb', ['function ' + Blockly['JavaScript'].FUNCTION_NAME_PLACEHOLDER_ +
	                '(r, g, b) {',
	            '  r = Math.max(Math.min(Number(r), 255), 0);',
	            '  g = Math.max(Math.min(Number(g), 255), 0);',
	            '  b = Math.max(Math.min(Number(b), 255), 0);',
	            '  r = (\'0\' + (Math.round(r) || 0).toString(16)).slice(-2);',
	            '  g = (\'0\' + (Math.round(g) || 0).toString(16)).slice(-2);',
	            '  b = (\'0\' + (Math.round(b) || 0).toString(16)).slice(-2);',
	            '  return \'#\' + r + g + b;',
	            '}']);
	        var code = functionName + '(' + red + ', ' + green + ', ' + blue + ')';
	        return [code, Blockly['JavaScript'].ORDER_FUNCTION_CALL];
	    };
	    Blockly.Blocks['get-new-custom-response'] = {
	        init: function () {
	            this.appendValueInput('NEW_RESPONSE_DATA').setCheck(null).appendField("  API Data", "NEW_API_DATA_KEY");
	            this.appendDummyInput("New_CUSTOM_RESPONSE")
	                .appendField("Select field ")
	                .appendField(new Blockly.FieldDropdown(this.generateOptions.bind(this), this.validateFieldOptions), "NEW_FIELD_NAME")
	                .appendField(" Value", 'SET_VALUE')
	                .appendField(new Blockly.FieldDropdown(this.generateOptions.bind(this)), 'VALUE_NAME')
	                .appendField(" Display Name", 'SET_KEY_NAME')
	                .appendField(new Blockly.FieldDropdown(this.generateOptions.bind(this)), 'NAME_MAP');
	            this.setInputsInline(true);
	            this.setOutput(true);
	            this.setColour(290);
	            this.setTooltip("Fetch field data from API response");
	            this.setHelpUrl("");
	            this.jsonInit({ "mutator": "dropdown_mutator" });
	        },
	        generateOptions: function () {
	            var responseDataOptionsNew = [['Please select', 'Please select']];
	            var block = this;
	            if (block && block.childBlocks_ && block.childBlocks_[0] && block.childBlocks_[0].getVarModels()[0] && block.childBlocks_[0].getVarModels()[0]['responseDataFromAPI']) {
	                var options_7 = block.recursionOnResponseData(responseDataOptionsNew, block.childBlocks_[0].getVarModels()[0]['responseDataFromAPI']);
	                return options_7;
	            }
	            else {
	                if (block && block.type == 'get-new-custom-response' && block.parentBlock_) {
	                    var apiBLock = block.findAPIBlock(block.parentBlock_);
	                    if (apiBLock && apiBLock.responseDataFromAPI) {
	                        var options_8 = block.recursionOnResponseData(responseDataOptionsNew, apiBLock.responseDataFromAPI);
	                        return options_8;
	                    }
	                }
	            }
	            return responseDataOptionsNew;
	        },
	        findAPIBlock: function (block) {
	            if (block && block.type == 'set_api_data') {
	                return block;
	            }
	            else {
	                if (block)
	                    return this.findAPIBlock(block.parentBlock_);
	            }
	        },
	        recursionOnResponseData: function (arr, responseData, parentkey, parentArrPathKey) {
	            if (responseData.length > 0) {
	                responseData = responseData[0];
	            }
	            for (var key in responseData) {
	                if (responseData.hasOwnProperty(key)) {
	                    var elemVal = responseData[key];
	                    if ((elemVal == null) || (typeof (elemVal) != 'object')) {
	                        if (parentkey) {
	                            arr.push([parentkey + '.' + key, parentkey + '.' + key]);
	                        }
	                        else if (parentArrPathKey) {
	                            var keyPath = parentArrPathKey + '["' + key + '"]';
	                            arr.push([keyPath, key]);
	                        }
	                        else {
	                            arr.push([key, key]);
	                        }
	                    }
	                    else if (elemVal != null && typeof (elemVal) == 'object' && elemVal.length > 0) {
	                        var parentkeynew = parentkey ? parentkey + '.' + key : key;
	                        arr.push([parentkeynew, parentkeynew]);
	                        this.recursionOnResponseData(arr, elemVal[0], '', parentkeynew);
	                    }
	                    else {
	                        var parentkeynew = parentkey ? parentkey + '.' + key : key;
	                        this.recursionOnResponseData(arr, elemVal, parentkeynew);
	                    }
	                }
	            }
	            return arr;
	        },
	        validateFieldOptions: function (fieldName) {
	            var _this = this;
	            var block = this.getSourceBlock();
	            if (this.fieldName != fieldName) {
	                var oldfieldName = this.fieldName;
	                this.fieldName = fieldName;
	                if (!oldfieldName) {
	                    this.getSourceBlock().onFieldNameChanged(block);
	                }
	                else {
	                    setTimeout(function () {
	                        _this.getSourceBlock().onFieldNameChanged(block);
	                    }, 500);
	                }
	            }
	            return fieldName;
	        },
	        onFieldNameChanged: function (block) {
	            refreshDropdownNewInputField(block);
	        },
	    };
	    Blockly['JavaScript']['get-new-custom-response'] = function (block) {
	        var ct_name = block.getFieldValue('NEW_FIELD_NAME');
	        var optionMap = block.getFieldValue('VALUE_NAME');
	        var optionMapName = block.getFieldValue('NAME_MAP');
	        var responseData = Blockly['JavaScript'].valueToCode(block, 'NEW_RESPONSE_DATA', Blockly['JavaScript'].ORDER_NONE) || 'null';
	        var code = "window.getCustomResponse && window.getCustomResponse('" + ct_name + "'," + responseData + ", '" + optionMap + "' , '" + optionMapName + "')\n ";
	        return [code, Blockly['JavaScript'].ORDER_NONE];
	    };
	    Blockly.Blocks['custom-set-alert-msg'] = {
	        init: function () {
	            this.appendDummyInput('CUSTOM_PROP_SETTER_DUMMY_INPUT')
	                .appendField("Set Alert Message : ");
	            this.appendValueInput('MSG_VALUE_INPUT').setCheck(null);
	            this.setInputsInline(true);
	            this.setPreviousStatement(true, null);
	            this.setNextStatement(true, null);
	            this.setColour(Blockly.Msg.PROCEDURES_HUE);
	            this.setTooltip("Set msg");
	            this.setHelpUrl("");
	        },
	    };
	    Blockly['JavaScript']['custom-set-alert-msg'] = function (block) {
	        var msgText = Blockly['JavaScript'].valueToCode(block, 'MSG_VALUE_INPUT', Blockly['JavaScript'].ORDER_NONE) || '';
	        var code = "window.setAlertMsg && window.setAlertMsg(" + msgText + ")\n ";
	        return code;
	    };
	    Blockly.Blocks['check_for_external_associations'] = {
	        init: function () {
	            this.appendStatementInput("EXTERNAL_ASSOCIATIONS")
	                .appendField("Check for Associations ");
	            this.setInputsInline(true);
	            this.setPreviousStatement(true, null);
	            this.setNextStatement(true, null);
	            this.setColour(230);
	            this.setTooltip("Use this function block to check for external associations");
	            this.setHelpUrl("");
	        },
	    };
	    Blockly['JavaScript']['check_for_external_associations'] = function (block) {
	        var logicHandler = Blockly['JavaScript'].statementToCode(block, 'EXTERNAL_ASSOCIATIONS');
	        var code = "function checkForExternalAssociations(){\n      " + logicHandler + "\n    };\n";
	        return code;
	    };
	    Blockly.Blocks['check_for_association_external_by_view'] = {
	        init: function () {
	            this.appendDummyInput("CHECK_FOR_VIEW_ASSOC")
	                .appendField('Select view')
	                .appendField(new Blockly.FieldDropdown(ViewNamesList), "VIEW_NAME")
	                .appendField('Select Type')
	                .appendField(new Blockly.FieldDropdown([['Please select', 'Please select'], ['Files', 'Files'], ['Apps', 'Apps']]), "ASSOC_TYPE");
	            this.setInputsInline(true);
	            this.setOutput(true);
	            this.setColour(290);
	            this.setTooltip("check_for_association_external_by_view");
	            this.setHelpUrl("");
	        },
	    };
	    Blockly['JavaScript']['check_for_association_external_by_view'] = function (block) {
	        var viewName = block.getFieldValue('VIEW_NAME');
	        var assocType = block.getFieldValue('ASSOC_TYPE');
	        var code = "window.setAndVerifyDocAssocForView && window.setAndVerifyDocAssocForView(\"" + viewName + "\",\"" + assocType + "\")\n ";
	        return [code, Blockly['JavaScript'].ORDER_VOID];
	    };
	};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

	'use strict';
	var Api_Ids = {
	    FORM_SEARCH_API_ID: 1,
	    USER_SEARCH_API_ID: 2
	};
	exports.Api_Ids = Api_Ids;
	/*** @description Authentication type enum for API connections */
	var AuthType;
	(function (AuthType) {
	    AuthType[AuthType["None"] = 0] = "None";
	    AuthType[AuthType["OAuth"] = 1] = "OAuth";
	})(AuthType || (AuthType = {}));
	exports.AuthType = AuthType;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _core = __webpack_require__(28);
	
	var _core2 = _interopRequireDefault(_core);
	
	var _field_plus = __webpack_require__(39);
	
	var _field_minus = __webpack_require__(40);
	
	var _promise = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Delete original block because there's no way to unregister it:
	// https://github.com/google/blockly-samples/issues/768#issuecomment-885663394
	//  delete Blockly.Blocks['lists_create_with'];
	
	/* eslint-disable quotes */
	/**
	 * @license
	 * Copyright 2020 Google LLC
	 * SPDX-License-Identifier: Apache-2.0
	 */
	
	/**
	 * @fileoverview Changes the list_create block to use a +/- mutator UI.
	 */
	
	_core2.default.defineBlocksWithJsonArray([{
	  "type": "minmax_datevalue",
	  "appendfield": "Get %1 %2",
	  "message0": "%{MINMAX_DATEVALUE_TITLE} %1",
	  "args0": [{
	    "type": "input_dummy",
	    "name": "EMPTY"
	  }],
	  "args1": [{
	    "type": "field_dropdown",
	    "name": "minmax",
	    "options": [["min", "minval"], ["max", "maxval"]]
	  }, {
	    "type": "input_value",
	    "name": "Min_Max",
	    "align": "CENTRE"
	  }],
	  "output": "Array",
	  "style": "list_blocks",
	  "helpUrl": "%{MINMAX_DATEVALUE_HELPURL}",
	  "tooltip": "%{MINMAX_DATEVALUE_TOOLTIP}",
	  "mutator": "new_minmax_datevalue_mutator"
	}]);
	/* eslint-enable quotes */
	
	var minmaxdateMutator = {
	  /**
	   * Number of item inputs the block has.
	   * @type {number}
	   */
	  itemCount_: 0,
	
	  /**
	   * Creates XML to represent number of text inputs.
	   * @return {!Element} XML storage element.
	   * @this {Blockly.Block}
	   */
	  mutationToDom: function mutationToDom() {
	    var container = _core2.default.utils.xml.createElement('mutation');
	    container.setAttribute('items', this.itemCount_);
	    return container;
	  },
	  /**
	   * Parses XML to restore the text inputs.
	   * @param {!Element} xmlElement XML storage element.
	   * @this {Blockly.Block}
	   */
	  domToMutation: function domToMutation(xmlElement) {
	    var targetCount = parseInt(xmlElement.getAttribute('items'), 10);
	    this.updateShape_(targetCount);
	  },
	
	  /**
	   * Adds inputs to the block until it reaches the target number of inputs.
	   * @param {number} targetCount The target number of inputs for the block.
	   * @this {Blockly.Block}
	   * @private
	   */
	  updateShape_: function updateShape_(targetCount) {
	    while (this.itemCount_ < targetCount) {
	      this.addPart_();
	    }
	    while (this.itemCount_ > targetCount) {
	      this.removePart_();
	    }
	    this.updateMinus_();
	  },
	
	  /**
	   * Callback for the plus image. Adds an input to the end of the block and
	   * updates the state of the minus.
	   */
	  plus: function plus() {
	    this.addPart_();
	    this.updateMinus_();
	  },
	
	  /**
	   * Callback for the minus image. Removes an input from the end of the block
	   * and updates the state of the minus.
	   */
	  minus: function minus() {
	    if (this.itemCount_ == 0) {
	      return;
	    }
	    this.removePart_();
	    this.updateMinus_();
	  },
	
	  // To properly keep track of indices we have to increment before/after adding
	  // the inputs, and decrement the opposite.
	  // Because we want our first input to be ADD0 (not ADD1) we increment after.
	
	  /**
	   * Adds an input to the end of the block. If the block currently has no
	   * inputs it updates the top 'EMPTY' input to receive a block.
	   * @this {Blockly.Block}
	   * @private
	   */
	  addPart_: function addPart_() {
	    if (this.itemCount_ == 0) {
	      this.removeInput('EMPTY');
	      this.topInput_ = this.appendValueInput('ADD' + this.itemCount_).appendField((0, _field_plus.createPlusField)(), 'PLUS').appendField("Get ")
	      //    .appendField(Blockly.Msg['LISTS_CREATE_WITH_INPUT_WITH'])
	      .appendField(new _core2.default.FieldDropdown([["min", "minval"], ["max", "maxval"]]), "minmax").appendField(" Date ");
	    } else {
	      this.appendValueInput('ADD' + this.itemCount_);
	    }
	    this.itemCount_++;
	  },
	
	  /**
	   * Removes an input from the end of the block. If we are removing the last
	   * input this updates the block to have an 'EMPTY' top input.
	   * @this {Blockly.Block}
	   * @private
	   */
	  removePart_: function removePart_() {
	    this.itemCount_--;
	    this.removeInput('ADD' + this.itemCount_);
	    if (this.itemCount_ == 0) {
	      this.topInput_ = this.appendDummyInput('EMPTY').appendField((0, _field_plus.createPlusField)(), 'PLUS').appendField(_core2.default.Msg['Date']);
	    }
	  },
	
	  /**
	   * Makes it so the minus is visible iff there is an input available to remove.
	   * @private
	   */
	  updateMinus_: function updateMinus_() {
	    var minusField = this.getField('MINUS');
	    if (!minusField && this.itemCount_ > 0) {
	      this.topInput_.insertFieldAt(1, (0, _field_minus.createMinusField)(), 'MINUS');
	    } else if (minusField && this.itemCount_ < 1) {
	      this.topInput_.removeField('MINUS');
	    }
	  },
	
	  MinMaxDate: function MinMaxDate(Data, Inputs) {}
	};
	
	/**
	 * Updates the shape of the block to have 3 inputs if no mutation is provided.
	 * @this {Blockly.Block}
	 */
	var minmaxdateHelper = function minmaxdateHelper() {
	  this.getInput('EMPTY').insertFieldAt(0, (0, _field_plus.createPlusField)(), 'PLUS');
	  this.updateShape_(3);
	};
	
	_core2.default.Extensions.registerMutator('new_minmax_datevalue_mutator', minmaxdateMutator, minmaxdateHelper);
	
	// export { default as DefaultExport } from 'MinMax_DateValue.js';
	// export default all;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/**
	 * @license
	 * Copyright 2020 Google LLC
	 * SPDX-License-Identifier: Apache-2.0
	 */
	
	/**
	 * @fileoverview A field for a plus button used for mutation.
	 */
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createPlusField = createPlusField;
	
	var _core = __webpack_require__(28);
	
	var Blockly = _interopRequireWildcard(_core);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * Creates a plus image field used for mutation.
	 * @param {Object=} args Untyped args passed to block.minus when the field
	 *     is clicked.
	 * @return {Blockly.FieldImage} The Plus field.
	 */
	function createPlusField() {
	  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
	
	  var plus = new Blockly.FieldImage(plusImage, 15, 15, undefined, onClick_);
	  /**
	   * Untyped args passed to block.plus when the field is clicked.
	   * @type {?(Object|undefined)}
	   * @private
	   */
	  plus.args_ = args;
	  return plus;
	}
	
	/**
	 * Calls block.plus(args) when the plus field is clicked.
	 * @param {!Blockly.FieldImage} plusField The field being clicked.
	 * @private
	 */
	function onClick_(plusField) {
	  // TODO: This is a dupe of the mutator code, anyway to unify?
	  var block = plusField.getSourceBlock();
	
	  if (block.isInFlyout) {
	    return;
	  }
	
	  Blockly.Events.setGroup(true);
	
	  var oldMutationDom = block.mutationToDom();
	  var oldMutation = oldMutationDom && Blockly.Xml.domToText(oldMutationDom);
	
	  block.plus(plusField.args_);
	
	  var newMutationDom = block.mutationToDom();
	  var newMutation = newMutationDom && Blockly.Xml.domToText(newMutationDom);
	
	  if (oldMutation != newMutation) {
	    Blockly.Events.fire(new Blockly.Events.BlockChange(block, 'mutation', null, oldMutation, newMutation));
	  }
	  Blockly.Events.setGroup(false);
	}
	
	var plusImage = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC' + '9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij48cGF0aCBkPSJNMT' + 'ggMTBoLTR2LTRjMC0xLjEwNC0uODk2LTItMi0ycy0yIC44OTYtMiAybC4wNzEgNGgtNC4wNz' + 'FjLTEuMTA0IDAtMiAuODk2LTIgMnMuODk2IDIgMiAybDQuMDcxLS4wNzEtLjA3MSA0LjA3MW' + 'MwIDEuMTA0Ljg5NiAyIDIgMnMyLS44OTYgMi0ydi00LjA3MWw0IC4wNzFjMS4xMDQgMCAyLS' + '44OTYgMi0ycy0uODk2LTItMi0yeiIgZmlsbD0id2hpdGUiIC8+PC9zdmc+Cg==';

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Copyright 2020 Google LLC
	 * SPDX-License-Identifier: Apache-2.0
	 */
	
	/**
	 * @fileoverview A function that creates a minus button used for mutation.
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createMinusField = createMinusField;
	
	var _core = __webpack_require__(28);
	
	var Blockly = _interopRequireWildcard(_core);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * Creates a minus image field used for mutation.
	 * @param {Object=} args Untyped args passed to block.minus when the field
	 *     is clicked.
	 * @return {Blockly.FieldImage} The minus field.
	 */
	function createMinusField() {
	  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
	
	  var minus = new Blockly.FieldImage(minusImage, 15, 15, undefined, onClick_);
	  /**
	   * Untyped args passed to block.minus when the field is clicked.
	   * @type {?(Object|undefined)}
	   * @private
	   */
	  minus.args_ = args;
	  return minus;
	}
	
	/**
	 * Calls block.minus(args) when the minus field is clicked.
	 * @param {Blockly.FieldImage} minusField The field being clicked.
	 * @private
	 */
	function onClick_(minusField) {
	  // TODO: This is a dupe of the mutator code, anyway to unify?
	  var block = minusField.getSourceBlock();
	
	  if (block.isInFlyout) {
	    return;
	  }
	
	  Blockly.Events.setGroup(true);
	
	  var oldMutationDom = block.mutationToDom();
	  var oldMutation = oldMutationDom && Blockly.Xml.domToText(oldMutationDom);
	
	  block.minus(minusField.args_);
	
	  var newMutationDom = block.mutationToDom();
	  var newMutation = newMutationDom && Blockly.Xml.domToText(newMutationDom);
	
	  if (oldMutation != newMutation) {
	    Blockly.Events.fire(new Blockly.Events.BlockChange(block, 'mutation', null, oldMutation, newMutation));
	  }
	  Blockly.Events.setGroup(false);
	}
	
	var minusImage = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAw' + 'MC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij48cGF0aCBkPS' + 'JNMTggMTFoLTEyYy0xLjEwNCAwLTIgLjg5Ni0yIDJzLjg5NiAyIDIgMmgxMmMxLjEwNCAw' + 'IDItLjg5NiAyLTJzLS44OTYtMi0yLTJ6IiBmaWxsPSJ3aGl0ZSIgLz48L3N2Zz4K';

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(42);
	__webpack_require__(64);
	__webpack_require__(89);
	__webpack_require__(93);
	__webpack_require__(110);
	__webpack_require__(111);
	module.exports = __webpack_require__(47).Promise;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(43);
	var test = {};
	test[__webpack_require__(45)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(51)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(44);
	var TAG = __webpack_require__(45)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 44 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(46)('wks');
	var uid = __webpack_require__(50);
	var Symbol = __webpack_require__(48).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(47);
	var global = __webpack_require__(48);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(49) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 47 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 48 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 49 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 50 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(48);
	var hide = __webpack_require__(52);
	var has = __webpack_require__(62);
	var SRC = __webpack_require__(50)('src');
	var $toString = __webpack_require__(63);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(47).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(53);
	var createDesc = __webpack_require__(61);
	module.exports = __webpack_require__(57) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(54);
	var IE8_DOM_DEFINE = __webpack_require__(56);
	var toPrimitive = __webpack_require__(60);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(57) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(55);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 55 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(57) && !__webpack_require__(58)(function () {
	  return Object.defineProperty(__webpack_require__(59)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(58)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 58 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(55);
	var document = __webpack_require__(48).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(55);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 62 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(46)('native-function-to-string', Function.toString);


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(65)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(68)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(66);
	var defined = __webpack_require__(67);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 66 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(49);
	var $export = __webpack_require__(69);
	var redefine = __webpack_require__(51);
	var hide = __webpack_require__(52);
	var Iterators = __webpack_require__(72);
	var $iterCreate = __webpack_require__(73);
	var setToStringTag = __webpack_require__(86);
	var getPrototypeOf = __webpack_require__(87);
	var ITERATOR = __webpack_require__(45)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(48);
	var core = __webpack_require__(47);
	var hide = __webpack_require__(52);
	var redefine = __webpack_require__(51);
	var ctx = __webpack_require__(70);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(71);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 71 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(74);
	var descriptor = __webpack_require__(61);
	var setToStringTag = __webpack_require__(86);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(52)(IteratorPrototype, __webpack_require__(45)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(54);
	var dPs = __webpack_require__(75);
	var enumBugKeys = __webpack_require__(84);
	var IE_PROTO = __webpack_require__(83)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(59)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(85).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(53);
	var anObject = __webpack_require__(54);
	var getKeys = __webpack_require__(76);
	
	module.exports = __webpack_require__(57) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(77);
	var enumBugKeys = __webpack_require__(84);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(62);
	var toIObject = __webpack_require__(78);
	var arrayIndexOf = __webpack_require__(80)(false);
	var IE_PROTO = __webpack_require__(83)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(79);
	var defined = __webpack_require__(67);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(44);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(78);
	var toLength = __webpack_require__(81);
	var toAbsoluteIndex = __webpack_require__(82);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(66);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(66);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(46)('keys');
	var uid = __webpack_require__(50);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(48).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(53).f;
	var has = __webpack_require__(62);
	var TAG = __webpack_require__(45)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(62);
	var toObject = __webpack_require__(88);
	var IE_PROTO = __webpack_require__(83)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(67);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(90);
	var getKeys = __webpack_require__(76);
	var redefine = __webpack_require__(51);
	var global = __webpack_require__(48);
	var hide = __webpack_require__(52);
	var Iterators = __webpack_require__(72);
	var wks = __webpack_require__(45);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(91);
	var step = __webpack_require__(92);
	var Iterators = __webpack_require__(72);
	var toIObject = __webpack_require__(78);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(68)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(45)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(52)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 92 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(49);
	var global = __webpack_require__(48);
	var ctx = __webpack_require__(70);
	var classof = __webpack_require__(43);
	var $export = __webpack_require__(69);
	var isObject = __webpack_require__(55);
	var aFunction = __webpack_require__(71);
	var anInstance = __webpack_require__(94);
	var forOf = __webpack_require__(95);
	var speciesConstructor = __webpack_require__(99);
	var task = __webpack_require__(100).set;
	var microtask = __webpack_require__(102)();
	var newPromiseCapabilityModule = __webpack_require__(103);
	var perform = __webpack_require__(104);
	var userAgent = __webpack_require__(105);
	var promiseResolve = __webpack_require__(106);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(45)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(107)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(86)($Promise, PROMISE);
	__webpack_require__(108)(PROMISE);
	Wrapper = __webpack_require__(47)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(109)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 94 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(70);
	var call = __webpack_require__(96);
	var isArrayIter = __webpack_require__(97);
	var anObject = __webpack_require__(54);
	var toLength = __webpack_require__(81);
	var getIterFn = __webpack_require__(98);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(54);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(72);
	var ITERATOR = __webpack_require__(45)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(43);
	var ITERATOR = __webpack_require__(45)('iterator');
	var Iterators = __webpack_require__(72);
	module.exports = __webpack_require__(47).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(54);
	var aFunction = __webpack_require__(71);
	var SPECIES = __webpack_require__(45)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(70);
	var invoke = __webpack_require__(101);
	var html = __webpack_require__(85);
	var cel = __webpack_require__(59);
	var global = __webpack_require__(48);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(44)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 101 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(48);
	var macrotask = __webpack_require__(100).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(44)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(71);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 104 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(48);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(54);
	var isObject = __webpack_require__(55);
	var newPromiseCapability = __webpack_require__(103);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(51);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(48);
	var dP = __webpack_require__(53);
	var DESCRIPTORS = __webpack_require__(57);
	var SPECIES = __webpack_require__(45)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(45)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(69);
	var core = __webpack_require__(47);
	var global = __webpack_require__(48);
	var speciesConstructor = __webpack_require__(99);
	var promiseResolve = __webpack_require__(106);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(69);
	var newPromiseCapability = __webpack_require__(103);
	var perform = __webpack_require__(104);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _core = __webpack_require__(28);
	
	var _core2 = _interopRequireDefault(_core);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dropdownMutator = {
	    mutationToDom: function mutationToDom() {
	        var container = _core2.default.utils.xml.createElement("mutation");
	
	        // Save the currently selected option
	        container.setAttribute("value", this.getFieldValue("FIELD_NAME"));
	        container.setAttribute("keyValue", this.getFieldValue("KEY_NAME"));
	        container.setAttribute("collectionValue", this.getFieldValue("COLLECTION_NAME"));
	        container.setAttribute("mapValue", this.getFieldValue("R_KEY_NAME"));
	        container.setAttribute("projectNameValues", this.getFieldValue("projectName"));
	        container.setAttribute("appbuilderIDValues", this.getFieldValue("appbuilderID"));
	        container.setAttribute("destinationFieldVlaues", this.getFieldValue("destinationName"));
	        container.setAttribute("newValue", this.getFieldValue("NEW_FIELD_NAME"));
	        container.setAttribute("newNameValue", this.getFieldValue("VALUE_NAME"));
	        container.setAttribute("nameValue", this.getFieldValue("NAME_MAP"));
	        // save all the options here
	        var options = [];
	        if (this.getField("FIELD_NAME")) {
	            options = this.getField("FIELD_NAME").getOptions(false);
	            for (var i = 0; i < options.length; i++) {
	                var option_element = _core2.default.utils.xml.createElement("option");
	                option_element.setAttribute("display-value", options[i][0]);
	                option_element.setAttribute("neutral-value", options[i][1]);
	                container.appendChild(option_element);
	            }
	        } else if (this.getField("COLLECTION_NAME")) {
	            options = this.getField("COLLECTION_NAME").getOptions(false);
	            for (var i = 0; i < options.length; i++) {
	                var option_element = _core2.default.utils.xml.createElement("option1");
	                option_element.setAttribute("display-value", options[i][0]);
	                option_element.setAttribute("neutral-value", options[i][1]);
	                container.appendChild(option_element);
	            }
	        }
	        if (this.getField("R_KEY_NAME")) {
	            options = this.getField("R_KEY_NAME").getOptions(false);
	            for (var i = 0; i < options.length; i++) {
	                var option_element = _core2.default.utils.xml.createElement("option2");
	                option_element.setAttribute("display-value", options[i][0]);
	                option_element.setAttribute("neutral-value", options[i][1]);
	                container.appendChild(option_element);
	            }
	        }
	        if (this.getField("projectName")) {
	            options = this.getField("projectName").getOptions(false);
	            for (var i = 0; i < options.length; i++) {
	                var option_element = _core2.default.utils.xml.createElement("option3");
	                option_element.setAttribute("display-value", options[i][0]);
	                option_element.setAttribute("neutral-value", options[i][1]);
	                container.appendChild(option_element);
	            }
	        }
	        if (this.getField("appbuilderID")) {
	            options = this.getField("appbuilderID").getOptions(false);
	            for (var i = 0; i < options.length; i++) {
	                var option_element = _core2.default.utils.xml.createElement("option4");
	                option_element.setAttribute("display-value", options[i][0]);
	                option_element.setAttribute("neutral-value", options[i][1]);
	                container.appendChild(option_element);
	            }
	        }
	        if (this.getField("destinationName")) {
	            options = this.getField("destinationName").getOptions(false);
	            for (var i = 0; i < options.length; i++) {
	                var option_element = _core2.default.utils.xml.createElement("option5");
	                option_element.setAttribute("display-value", options[i][0]);
	                option_element.setAttribute("neutral-value", options[i][1]);
	                container.appendChild(option_element);
	            }
	        }
	        if (this.getField("NEW_FIELD_NAME")) {
	            options = this.getField("NEW_FIELD_NAME").getOptions(false);
	            for (var i = 0; i < options.length; i++) {
	                var option_element = _core2.default.utils.xml.createElement("option");
	                option_element.setAttribute("display-value", options[i][0]);
	                option_element.setAttribute("neutral-value", options[i][1]);
	                container.appendChild(option_element);
	            }
	        }
	
	        // For debugging
	        console.log("mutationToDom");
	        console.dirxml(container);
	
	        return container;
	    },
	
	    domToMutation: function domToMutation(containerElement) {
	        // If set then used by generateOptions in order to provide the list of options 
	        this.mutator_saved = [["none", "none"]];
	
	        // Add all the saved options to the mutator-saved list;
	        for (var i = 0; i < containerElement.childNodes.length; i++) {
	            if (containerElement.childNodes[i] && containerElement.childNodes[i].nodeName != '#text') {
	                var option_element = containerElement.childNodes[i];
	                this.mutator_saved.push([option_element.getAttribute("display-value"), option_element.getAttribute("neutral-value")]);
	            }
	        }
	
	        // Force set the currently selected option
	        if (this.getField("FIELD_NAME")) {
	            this.getField("FIELD_NAME").generatedOptions_ = this.mutator_saved;
	        }
	        if (this.getField("COLLECTION_NAME")) {
	            this.getField("COLLECTION_NAME").generatedOptions_ = this.mutator_saved;
	        }
	
	        if (this.getField("R_KEY_NAME")) {
	            this.getField("R_KEY_NAME").generatedOptions_ = this.mutator_saved;
	        }
	        if (this.getField("KEY_NAME") && containerElement.getAttribute("keyValue") != 'null' && containerElement.getAttribute("keyValue") != '') {
	            this.getField("KEY_NAME").generatedOptions_ = this.mutator_saved;
	        } else {
	            if (this.getInput('CUSTOM_RESPONSE')) {
	                this.getInput('CUSTOM_RESPONSE').removeField('KEY_NAME', true);
	                this.getInput('CUSTOM_RESPONSE').removeField("SET_KEY", true);
	            }
	        }
	        if (this.getField("projectName")) {
	            this.getField("projectName").generatedOptions_ = this.mutator_saved;
	        }
	        if (this.getField("appbuilderID")) {
	            this.getField("appbuilderID").generatedOptions_ = this.mutator_saved;
	        }
	        if (this.getField("destinationName")) {
	            this.getField("destinationName").generatedOptions_ = this.mutator_saved;
	        }
	        if (this.getField("NEW_FIELD_NAME")) {
	            this.getField("NEW_FIELD_NAME").generatedOptions_ = this.mutator_saved;
	        }
	        if (this.getField("VALUE_NAME") && containerElement.getAttribute("newNameValue") != 'null' && containerElement.getAttribute("newNameValue") != '') {
	            this.getField("VALUE_NAME").generatedOptions_ = this.mutator_saved;
	        } else {
	            if (this.getInput('New_CUSTOM_RESPONSE')) {
	                this.getInput('New_CUSTOM_RESPONSE').removeField('VALUE_NAME', true);
	                this.getInput('New_CUSTOM_RESPONSE').removeField("SET_VALUE", true);
	            }
	        }
	        if (this.getField("NAME_MAP") && containerElement.getAttribute("nameValue") != 'null' && containerElement.getAttribute("nameValue") != '') {
	            this.getField("NAME_MAP").generatedOptions_ = this.mutator_saved;
	        } else {
	            if (this.getInput('New_CUSTOM_RESPONSE')) {
	                this.getInput('New_CUSTOM_RESPONSE').removeField('NAME_MAP', true);
	                this.getInput('New_CUSTOM_RESPONSE').removeField("SET_KEY_NAME", true);
	            }
	        }
	    }
	};
	
	_core2.default.Extensions.registerMutator("dropdown_mutator", dropdownMutator);

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
	                                                                                                                                                                                                                                                                               * @license
	                                                                                                                                                                                                                                                                               * Copyright 2020 Google LLC
	                                                                                                                                                                                                                                                                               * SPDX-License-Identifier: Apache-2.0
	                                                                                                                                                                                                                                                                               */
	
	/**
	 * @fileoverview Add dropdown options of multiple key value.
	 */
	
	var _core = __webpack_require__(28);
	
	var _core2 = _interopRequireDefault(_core);
	
	var _field_plus = __webpack_require__(39);
	
	var _field_minus = __webpack_require__(40);
	
	var _promise = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable quotes */
	_core2.default.defineBlocksWithJsonArray([{
	  "type": "custom_dropdownoptions",
	  "appendfield": "Get %1 %2",
	  "message0": "%{DROPDOWN_OPTIONS} %1",
	  "args0": [{
	    "type": "input_dummy",
	    "name": "EMPTY"
	  }],
	  "args1": [{
	    "type": "field_dropdown",
	    "name": "DROPDOWN_OPTIONS"
	  }, {
	    "type": "input_value",
	    "name": "CUSTOM_OPTIONS",
	    "align": "CENTRE"
	  }],
	  "output": "Array",
	  "style": "list_blocks",
	  "helpUrl": "",
	  "tooltip": "Set multiple values in the display of dropdown",
	  "mutator": "multiple_option_mutator"
	}]);
	/* eslint-enable quotes */
	
	var multipleOptionMutator = {
	  /**
	   * Number of item inputs the block has.
	   * @type {number}
	   */
	  itemCount_: 0,
	
	  /**
	   * Creates XML to represent number of text inputs.
	   * @return {!Element} XML storage element.
	   * @this {Blockly.Block}
	   */
	  mutationToDom: function mutationToDom() {
	    var container = _core2.default.utils.xml.createElement('mutation');
	    container.setAttribute('items', this.itemCount_);
	    container.setAttribute("dropdown_options", this.getFieldValue("DROPDOWN_OPTIONS"));
	    var options = [];
	    if (this.getField("DROPDOWN_OPTIONS")) {
	      options = this.getField("DROPDOWN_OPTIONS").getOptions(false);
	      for (var i = 0; i < options.length; i++) {
	        var option_element = _core2.default.utils.xml.createElement("option");
	        option_element.setAttribute("display-value", options[i][0]);
	        option_element.setAttribute("neutral-value", options[i][1]);
	        container.appendChild(option_element);
	      }
	    }
	    return container;
	  },
	  /**
	   * Parses XML to restore the text inputs.
	   * @param {!Element} xmlElement XML storage element.
	   * @this {Blockly.Block}
	   */
	  domToMutation: function domToMutation(xmlElement) {
	    var targetCount = parseInt(xmlElement.getAttribute('items'), 10);
	
	    this.mutator_saved = [["none", "none"]];
	
	    // Add all the saved options to the mutator-saved list;
	    for (var i = 0; i < xmlElement.childNodes.length; i++) {
	      var option_element = xmlElement.childNodes[i];
	      this.mutator_saved.push([option_element.getAttribute("display-value"), option_element.getAttribute("neutral-value")]);
	    }
	
	    if (this.getField("DROPDOWN_OPTIONS")) {
	      this.getField("DROPDOWN_OPTIONS").generatedOptions_ = this.mutator_saved;
	    }
	    this.updateShape_(targetCount);
	  },
	
	  /**
	   * Adds inputs to the block until it reaches the target number of inputs.
	   * @param {number} targetCount The target number of inputs for the block.
	   * @this {Blockly.Block}
	   * @private
	   */
	  updateShape_: function updateShape_(targetCount) {
	    while (this.itemCount_ < targetCount) {
	      this.addPart_();
	    }
	    while (this.itemCount_ > targetCount) {
	      this.removePart_();
	    }
	    this.updateMinus_();
	  },
	
	  /**
	   * Callback for the plus image. Adds an input to the end of the block and
	   * updates the state of the minus.
	   */
	  plus: function plus() {
	    this.addPart_();
	    this.updateMinus_();
	  },
	
	  /**
	   * Callback for the minus image. Removes an input from the end of the block
	   * and updates the state of the minus.
	   */
	  minus: function minus() {
	    if (this.itemCount_ == 0) {
	      return;
	    }
	    this.removePart_();
	    this.updateMinus_();
	  },
	
	  // To properly keep track of indices we have to increment before/after adding
	  // the inputs, and decrement the opposite.
	  // Because we want our first input to be ADD0 (not ADD1) we increment after.
	
	  /**
	   * Adds an input to the end of the block. If the block currently has no
	   * inputs it updates the top 'EMPTY' input to receive a block.
	   * @this {Blockly.Block}
	   * @private
	   */
	  addPart_: function addPart_() {
	    if (this.itemCount_ == 0) {
	      this.removeInput('EMPTY');
	      this.topInput_ = this.appendValueInput('ADD' + this.itemCount_).appendField((0, _field_plus.createPlusField)(), 'PLUS').appendField("Select Collection Name").appendField(new _core2.default.FieldDropdown(this.generateOptions.bind(this), this.validateFieldOption), "DROPDOWN_OPTIONS").appendField("Separator: ").appendField(new _core2.default.FieldDropdown([["-", "-"], ["_", "_"], [",", ","]]), "OPTION_SEPARATOR").appendField(" Map field ");
	    } else {
	      this.appendValueInput('ADD' + this.itemCount_);
	    }
	    this.itemCount_++;
	  },
	
	  generateOptions: function generateOptions() {
	    var responseDataOptions1 = [['Please select', '']];
	    var block = this;
	    if (block && block.type == 'custom_dropdownoptions' && block.parentBlock_) {
	      var apiBLock = block.findAPIBlock(block.parentBlock_);
	      if (apiBLock && apiBLock.responseDataFromAPI) {
	        var responseData = block.getCollectionNameResponseData(apiBLock.responseDataFromAPI);
	        apiBLock.responseDataFromAPI = responseData;
	        var options = block.recursionOnResponseData(responseDataOptions1, responseData);
	        return options;
	      }
	    }
	    return responseDataOptions1;
	  },
	  findAPIBlock: function findAPIBlock(block) {
	    if (block && block.type == 'set_api_data') {
	      return block;
	    } else {
	      if (block) return this.findAPIBlock(block.parentBlock_);
	    }
	  },
	
	  getCollectionNameResponseData: function getCollectionNameResponseData(responseData) {
	    if (Array.isArray(responseData)) {
	      return {
	        root: responseData
	      };
	    }
	    return responseData;
	  },
	
	  recursionOnResponseData: function recursionOnResponseData(arr, responseData, parentkey, parentArrPathKey) {
	    if (responseData.length > 0) {
	      responseData = responseData[0];
	    }
	    for (var key in responseData) {
	
	      if (responseData.hasOwnProperty(key)) {
	        var elemVal = responseData[key];
	        if (elemVal == null || (typeof elemVal === 'undefined' ? 'undefined' : _typeof(elemVal)) != 'object') {
	          if (parentkey) {
	            arr.push([parentkey + '.' + key, parentkey + '.' + key]);
	          } else if (parentArrPathKey) {
	            var keyPath = parentArrPathKey + '["' + key + '"]';
	            arr.push([keyPath, key]);
	          } else {
	            arr.push([key, key]);
	          }
	        } else if (elemVal != null && (typeof elemVal === 'undefined' ? 'undefined' : _typeof(elemVal)) == 'object' && elemVal.length > 0) {
	          var parentkeynew = parentkey ? parentkey + '.' + key : key;
	          arr.push([parentkeynew, parentkeynew]);
	          this.recursionOnResponseData(arr, elemVal[0], '', parentkeynew);
	        } else {
	          var _parentkeynew = parentkey ? parentkey + '.' + key : key;
	          this.recursionOnResponseData(arr, elemVal, _parentkeynew);
	        }
	      }
	    }
	    return arr;
	  },
	  validateFieldOptions: function validateFieldOptions(fieldName) {
	    return fieldName;
	  },
	
	  /**
	   * Removes an input from the end of the block. If we are removing the last
	   * input this updates the block to have an 'EMPTY' top input.
	   * @this {Blockly.Block}
	   * @private
	   */
	  removePart_: function removePart_() {
	    this.itemCount_--;
	    this.removeInput('ADD' + this.itemCount_);
	    if (this.itemCount_ == 0) {
	      this.topInput_ = this.appendDummyInput('EMPTY').appendField((0, _field_plus.createPlusField)(), 'PLUS').appendField(_core2.default.Msg['Map field ']);
	    }
	  },
	
	  /**
	   * Makes it so the minus is visible iff there is an input available to remove.
	   * @private
	   */
	  updateMinus_: function updateMinus_() {
	    var minusField = this.getField('MINUS');
	    if (!minusField && this.itemCount_ > 0) {
	      this.topInput_.insertFieldAt(1, (0, _field_minus.createMinusField)(), 'MINUS');
	    } else if (minusField && this.itemCount_ < 1) {
	      this.topInput_.removeField('MINUS');
	    }
	  }
	
	};
	
	/**
	 * Updates the shape of the block to have 3 inputs if no mutation is provided.
	 * @this {Blockly.Block}
	 */
	var multipleoptionHelper = function multipleoptionHelper() {
	  this.getInput('EMPTY').insertFieldAt(0, (0, _field_plus.createPlusField)(), 'PLUS');
	  this.updateShape_(3);
	};
	
	_core2.default.Extensions.registerMutator('multiple_option_mutator', multipleOptionMutator, multipleoptionHelper);

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	module.exports = "<xml id=\"toolbox\" style=\"display: none\">\n    <category id=\"catLogic\" colour=\"210\" name=\"{{'logic'|translate}}\">\n      <block type=\"controls_if\"></block>\n      <block type=\"logic_compare\"></block>\n      <block type=\"logic_operation\"></block>\n      <block type=\"logic_negate\"></block>\n      <block type=\"logic_boolean\"></block>\n      <block type=\"logic_null\"></block>\n      <block type=\"logic_ternary\"></block>\n    </category>\n    <category id=\"catLoops\" colour=\"120\" name=\"{{'loops'|translate}}\">\n      <block type=\"controls_repeat_ext\">\n        <value name=\"TIMES\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">10</field>\n          </shadow>\n        </value>\n      </block>\n      <block type=\"controls_whileUntil\"></block>\n      <block type=\"controls_for\">\n        <value name=\"FROM\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">1</field>\n          </shadow>\n        </value>\n        <value name=\"TO\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">10</field>\n          </shadow>\n        </value>\n        <value name=\"BY\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">1</field>\n          </shadow>\n        </value>\n      </block>\n      <block type=\"controls_forEach\"></block>\n      <block type=\"controls_flow_statements\"></block>\n    </category>\n    <category id=\"catMath\" colour=\"230\" name=\"{{'math'|translate}}\">\n      <block type=\"math_number\"></block>\n      <block type=\"parse_to_number\"></block>\n      <block type=\"custom_math_to_fixed\"></block>\n      <block type=\"math_arithmetic\">\n        <value name=\"A\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">1</field>\n          </shadow>\n        </value>\n        <value name=\"B\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">1</field>\n          </shadow>\n        </value>\n      </block>\n      <block type=\"math_single\">\n        <value name=\"NUM\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">9</field>\n          </shadow>\n        </value>\n      </block>\n      <block type=\"math_trig\">\n        <value name=\"NUM\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">45</field>\n          </shadow>\n        </value>\n      </block>\n      <block type=\"math_constant\"></block>\n      <block type=\"math_number_property\">\n        <value name=\"NUMBER_TO_CHECK\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">0</field>\n          </shadow>\n        </value>\n      </block>\n      <block type=\"math_change\">\n        <value name=\"DELTA\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">1</field>\n          </shadow>\n        </value>\n      </block>\n      <block type=\"math_round\">\n        <value name=\"NUM\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">3.1</field>\n          </shadow>\n        </value>\n      </block>\n      <block type=\"math_on_list\"></block>\n      <block type=\"math_modulo\">\n        <value name=\"DIVIDEND\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">64</field>\n          </shadow>\n        </value>\n        <value name=\"DIVISOR\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">10</field>\n          </shadow>\n        </value>\n      </block>\n      <block type=\"math_constrain\">\n        <value name=\"VALUE\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">50</field>\n          </shadow>\n        </value>\n        <value name=\"LOW\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">1</field>\n          </shadow>\n        </value>\n        <value name=\"HIGH\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">100</field>\n          </shadow>\n        </value>\n      </block>\n      <block type=\"math_random_int\">\n        <value name=\"FROM\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">1</field>\n          </shadow>\n        </value>\n        <value name=\"TO\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">100</field>\n          </shadow>\n        </value>\n      </block>\n      <block type=\"math_random_float\"></block>\n    </category>\n    <category id=\"catText\" colour=\"160\" name=\"{{'text'|translate}}\">\n      <block type=\"text\"></block>\n      <block type=\"text_join\"></block>\n      <block type=\"text_append\">\n        <value name=\"TEXT\">\n          <shadow type=\"text\"></shadow>\n        </value>\n      </block>\n      <block type=\"text_length\">\n        <value name=\"VALUE\">\n          <shadow type=\"text\">\n            <field name=\"TEXT\">abc</field>\n          </shadow>\n        </value>\n      </block>\n      <block type=\"text_isEmpty\">\n        <value name=\"VALUE\">\n          <shadow type=\"text\">\n            <field name=\"TEXT\"></field>\n          </shadow>\n        </value>\n      </block>\n      <block type=\"text_indexOf\">\n        <value name=\"VALUE\">\n          <block type=\"variables_get\">\n            <field name=\"VAR\">text</field>\n          </block>\n        </value>\n        <value name=\"FIND\">\n          <shadow type=\"text\">\n            <field name=\"TEXT\">abc</field>\n          </shadow>\n        </value>\n      </block>\n      <block type=\"text_charAt\">\n        <value name=\"VALUE\">\n          <block type=\"variables_get\">\n            <field name=\"VAR\">text</field>\n          </block>\n        </value>\n      </block>\n      <block type=\"text_getSubstring\">\n        <value name=\"STRING\">\n          <block type=\"variables_get\">\n            <field name=\"VAR\">text</field>\n          </block>\n        </value>\n      </block>\n      <block type=\"text_changeCase\">\n        <value name=\"TEXT\">\n          <shadow type=\"text\">\n            <field name=\"TEXT\">abc</field>\n          </shadow>\n        </value>\n      </block>\n      <block type=\"text_trim\">\n        <value name=\"TEXT\">\n          <shadow type=\"text\">\n            <field name=\"TEXT\">abc</field>\n          </shadow>\n        </value>\n      </block>\n      <block type=\"text_console\">\n        <value name=\"TEXT\">\n          <shadow type=\"text\">\n            <field name=\"TEXT\">abc</field>\n          </shadow>\n        </value>\n      </block>\n      <block type=\"json_stringify\">\n        <value name=\"VALUE\">\n          <shadow type=\"text\"></shadow>\n        </value>\n      </block>\n      <!-- <block type=\"text_print\">\n        <value name=\"TEXT\">\n          <shadow type=\"text\">\n            <field name=\"TEXT\">abc</field>\n          </shadow>\n        </value>\n      </block> -->\n      <block type=\"text_prompt_ext\">\n        <value name=\"TEXT\">\n          <shadow type=\"text\">\n            <field name=\"TEXT\">abc</field>\n          </shadow>\n        </value>\n      </block>\n    </category>\n    <category id=\"catLists\" colour=\"260\" name=\"{{'lists'|translate}}\">\n      <block type=\"lists_create_with\">\n        <mutation items=\"0\"></mutation>\n      </block>\n      <block type=\"lists_create_with\"></block>\n      <block type=\"lists_repeat\">\n        <value name=\"NUM\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">5</field>\n          </shadow>\n        </value>\n      </block>\n      <block type=\"lists_length\"></block>\n      <block type=\"lists_isEmpty\"></block>\n      <block type=\"lists_indexOf\">\n        <value name=\"VALUE\">\n          <block type=\"variables_get\">\n            <field name=\"VAR\">list</field>\n          </block>\n        </value>\n      </block>\n      <block type=\"lists_getIndex\">\n        <value name=\"VALUE\">\n          <block type=\"variables_get\">\n            <field name=\"VAR\">list</field>\n          </block>\n        </value>\n      </block>\n      <block type=\"lists_setIndex\">\n        <value name=\"LIST\">\n          <block type=\"variables_get\">\n            <field name=\"VAR\">list</field>\n          </block>\n        </value>\n      </block>\n      <block type=\"lists_getSublist\">\n        <value name=\"LIST\">\n          <block type=\"variables_get\">\n            <field name=\"VAR\">list</field>\n          </block>\n        </value>\n      </block>\n      <block type=\"lists_split\">\n        <value name=\"DELIM\">\n          <shadow type=\"text\">\n            <field name=\"TEXT\">,</field>\n          </shadow>\n        </value>\n      </block>\n      <block type=\"lists_sort\"></block>\n    </category>\n    <category id=\"catColour\" colour=\"20\" name=\"{{'color'|translate}}\">\n      <block type=\"colour_picker\"></block>\n      <block type=\"colour_random\"></block>\n      <block type=\"new_colour_rgb\">\n        <value name=\"RED\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">100</field>\n          </shadow>\n        </value>\n        <value name=\"GREEN\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">50</field>\n          </shadow>\n        </value>\n        <value name=\"BLUE\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">0</field>\n          </shadow>\n        </value>\n      </block>\n      <block type=\"colour_blend\">\n        <value name=\"COLOUR1\">\n          <shadow type=\"colour_picker\">\n            <field name=\"COLOUR\">#ff0000</field>\n          </shadow>\n        </value>\n        <value name=\"COLOUR2\">\n          <shadow type=\"colour_picker\">\n            <field name=\"COLOUR\">#3333ff</field>\n          </shadow>\n        </value>\n        <value name=\"RATIO\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">0.5</field>\n          </shadow>\n        </value>\n      </block>\n    </category>\n    <sep></sep>\n    <category id=\"catVariables\" colour=\"330\" custom=\"VARIABLE\" name=\"{{'variables'|translate}}\"></category>\n    <category id=\"catFunctions\" colour=\"290\" custom=\"PROCEDURE\" name=\"{{'functions'|translate}}\"></category>\n    <category id=\"catGlobleFunctions\" colour=\"290\" name=\"{{'custom.functions'|translate}}\">\n      <block type=\"custom-property-getter\"></block>\n      <block type=\"custom-property-value-getter\"></block>\n      <block type=\"custom-property-setter\"></block>\n      <block type=\"location_association\"></block>\n      <block type=\"custom-property-setter_by_getter\">\n        <value name=\"PROPERTY_VALUE_INPUT\">\n          <shadow type=\"custom-property-getter\"></shadow>\n        </value>\n      </block>\n      <block type=\"custom-property-value-setter\">\n        <value name=\"PROPERTY_VALUE_INPUT\">\n          <shadow type=\"text\"></shadow>\n        </value>\n      </block>\n      \n      <!-- <block type=\"custom-reset-repeating-table\"></block>\n      <block type=\"custom-get-repeating-table-rows\"></block> -->\n      <block type=\"custom-date-diff\"></block>\n      <block type=\"custom-date-time-diff\"></block>\n      <block type=\"custom-date-add-subtract\">\n        <value name=\"DAYS\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">0</field>\n          </shadow>\n        </value>\n      </block>\n\n      <block type=\"custom-date-add-working-days\">\n        <value name=\"NAME\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">0</field>\n          </shadow>\n        </value>\n      </block>\n\n      <block type=\"field-custom-date-add-working-days\">\n        <value name=\"NAME\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">0</field>\n          </shadow>\n        </value>\n      </block>\n      \n      <block type=\"sp_value_getter\"></block>\n      <block type=\"sp_user_details_getter\"></block>\n      <block type=\"sp_value_comparator\"></block>\n      <block type=\"auto_next_number_block\"></block>\n      <block type=\"cur_datetime_value_getter\"></block>\n      <block type=\"auto_next_number_suffix_block\"></block>\n      \n      <!-- <block type=\"set_timeout\"></block>\n      <block type=\"clear_timeout\"></block>\n      <block type=\"set_time_interval\"></block>\n      <block type=\"clear_time_interval\"></block> -->\n      <block  ng-repeat=\"value in $ctrl.globleMethods\" type=\"{{value}}\"></block>\n      <block type=\"minmax_datevalue\">\n        <mutation items=\"2\"></mutation>\n      </block>\n      <block type=\"api_call\"></block>\n      <block type=\"api_data_clone\"></block>\n      <block type=\"custom-set-alert-msg\">\n        <value name=\"MSG_VALUE_INPUT\">\n          <shadow type=\"text\"></shadow>\n        </value>\n      </block>\n      <block type=\"check_for_external_associations\"></block>\n      <block type=\"check_for_association_external_by_view\"></block>\n    </category>\n    <category id=\"catAPIWindow\" colour=\"120\" name=\"Custom API Blocks\">\n      <block type=\"set_api_data\"></block>\n      <block type=\"get-custom-response\"></block>\n      <block type=\"get-new-custom-response\"></block>\n      <block type=\"custom_dropdownoptions\">\n        <mutation items=\"1\"></mutation>\n      </block>\n      <block type=\"custom_dropdown\"></block>\n      <block type=\"custom-getter-from-api-for-repeating-table\">\n      </block>\n    </category>\n    <category id=\"catRepeatingTable\" colour=\"120\" name=\"{{'Repeating Table'|translate}}\">\n      <block type=\"custom-reset-repeating-table\"></block>\n      <block type=\"custom-get-repeating-table-rows\"></block>\n      <block type=\"repeating-table-control-sequence\"></block>\n      <block type=\"repeating-table-functionality\">\n        <value name=\"ROW_DATA\">\n          <shadow type=\"math_number\">\n            <field name=\"NUM\">0</field>\n          </shadow>\n        </value>\n      </block>\n    </category>\n    <category id=\"catRedymadeBlock\" colour=\"120\" name=\"{{'Block Library'|translate}}\">\n      <!-- 1. summation of fieldValue of repeatingtable -->\n      <variables>\n        <variable id=\"C7-Qg@T;t`)M-AXn(4Ap\">Total</variable>\n        <variable id=\";?mm=4{c2XbuUxV[|]q;\">i</variable>\n      </variables>\n      <block type=\"procedures_defnoreturn\" id=\"Gt*dbi9kXrt.J`#Za:=R\" x=\"208\" y=\"125\">\n        <field name=\"NAME\">Blockly_summation_of_fieldValue_of_repeatingtable</field>\n        <comment pinned=\"false\" h=\"80\" w=\"160\">Describe this function...</comment>\n        <statement name=\"STACK\">\n          <block type=\"variables_set\" id=\"rkwURp,sc.7jdc)1v%Dw\">\n            <field name=\"VAR\" id=\"C7-Qg@T;t`)M-AXn(4Ap\">Total</field>\n            <value name=\"VALUE\">\n              <block type=\"math_number\" id=\"zzQ5{k_Htp~R$#th3#1G\">\n                <field name=\"NUM\">0</field>\n              </block>\n            </value>\n            <next>\n              <block type=\"controls_forEach\" id=\"PAx3N`qT!ny5J/{S~`P(\">\n                <field name=\"VAR\" id=\";?mm=4{c2XbuUxV[|]q;\">i</field>\n                <value name=\"LIST\">\n                  <block type=\"custom-get-repeating-table-rows\" id=\"PcI=2WA*H#qQVTza;X:x\">\n                    <field name=\"CONTROL_NAME\"></field>\n                  </block>\n                </value>\n                <statement name=\"DO\">\n                  <block type=\"controls_if\" id=\"wm7%ZXfUNCPb8:`XLdK2\">\n                    <value name=\"IF0\">\n                      <block type=\"logic_compare\" id=\"U9Saj:=P?=b)U]PQ2d4J\">\n                        <field name=\"OP\">NEQ</field>\n                        <value name=\"A\">\n                          <block type=\"custom-property-value-getter\" id=\"+Rj9GAeB07}UvbYMsQ*s\">\n                            <field name=\"CONTROL_NAME\"></field>\n                          </block>\n                        </value>\n                        <value name=\"B\">\n                          <block type=\"text\" id=\"J4u`%XZ7xa212M7`gLmW\">\n                            <field name=\"TEXT\"></field>\n                          </block>\n                        </value>\n                      </block>\n                    </value>\n                    <statement name=\"DO0\">\n                      <block type=\"math_change\" id=\"VA2Wb)o#18U.[|+OY.@P\">\n                        <field name=\"VAR\" id=\"C7-Qg@T;t`)M-AXn(4Ap\">Total</field>\n                        <value name=\"DELTA\">\n                          <shadow xmlns=\"http://www.w3.org/1999/xhtml\" type=\"math_number\" id=\"y%.++/mOjRPA0Pu4tWvg\">\n                            <field name=\"NUM\">1</field>\n                          </shadow>\n                          <block type=\"parse_to_number\" id=\"Pi@u`cIoTg:Y=fMlp=3q\">\n                            <value name=\"PARSE_TO_NUMBER\">\n                              <block type=\"custom-property-value-getter\" id=\"q]2=L/gA.cFBZnMDE5$B\">\n                                <field name=\"CONTROL_NAME\"></field>\n                              </block>\n                            </value>\n                          </block>\n                        </value>\n                      </block>\n                    </statement>\n                  </block>\n                </statement>\n                <next>\n                  <block type=\"custom-property-value-setter\" id=\"^{Rd]6/LJ5SOM{.zBlk2\">\n                    <field name=\"CONTROL_NAME\"></field>\n                    <value name=\"PROPERTY_VALUE_INPUT\">\n                      <shadow type=\"text\" id=\"/9XCv]py*9?vyJV*pEMQ\">\n                        <field name=\"TEXT\"></field>\n                      </shadow>\n                      <block type=\"variables_get\" id=\";L{;T{6Yr~y?-kpq?H,c\">\n                        <field name=\"VAR\" id=\"C7-Qg@T;t`)M-AXn(4Ap\">Total</field>\n                      </block>\n                    </value>\n                  </block>\n                </next>\n              </block>\n            </next>\n          </block>\n        </statement>\n      </block>\n    \n      <!-- 2. set field property basedOn condition -->\n      <block type=\"procedures_defnoreturn\" id=\"[xMve4Bt::`SLUyb}^Pq\" x=\"135\" y=\"61\">\n        <field name=\"NAME\">Blockly_set_field_property_basedOn_condition</field>\n        <comment pinned=\"false\" h=\"80\" w=\"160\">Describe this function...</comment>\n        <statement name=\"STACK\">\n          <block type=\"controls_if\" id=\"{Y]zD9_HE^ag$*DfPk[M\">\n            <mutation else=\"1\"></mutation>\n            <value name=\"IF0\">\n              <block type=\"logic_compare\" id=\"xSeoGPbO3Sx!-leB(n/X\">\n                <field name=\"OP\">EQ</field>\n                <value name=\"A\">\n                  <block type=\"custom-property-value-getter\" id=\"AIlFXuHr[[!a4uk^Dwe:\">\n                    <field name=\"CONTROL_NAME\"></field>\n                  </block>\n                </value>\n                <value name=\"B\">\n                  <block type=\"text\" id=\"a,b!5.g5SMzJ~Fy]z;zO\">\n                    <field name=\"TEXT\"></field>\n                  </block>\n                </value>\n              </block>\n            </value>\n            <statement name=\"DO0\">\n              <block type=\"custom-property-setter\" id=\"_cghU.D90Xr0:A}P:i/c\">\n                <field name=\"CONTROL_NAME\"></field>\n              </block>\n            </statement>\n            <statement name=\"ELSE\">\n              <block type=\"custom-property-setter\" id=\"|(R%Hv=6E-VkI,V}6)Ul\">\n                <field name=\"CONTROL_NAME\"></field>\n              </block>\n            </statement>\n          </block>\n        </statement>\n      </block>\n    \n      <!-- 3. auto selecting data in One field based On another -->\n      <block type=\"procedures_defnoreturn\" id=\"H(Mks@J*1]WcLk.(1IA}\" x=\"82\" y=\"80\">\n        <field name=\"NAME\">Blockly_auto_selecting_data_inOne_field_basedOn_another</field>\n        <comment pinned=\"false\" h=\"80\" w=\"160\">Describe this function...</comment>\n        <statement name=\"STACK\">\n          <block type=\"controls_if\" id=\":KXm`1gmgat+:kG=8cA,\">\n            <mutation elseif=\"1\"></mutation>\n            <value name=\"IF0\">\n              <block type=\"logic_compare\" id=\"HPh.PzJS~}5p/wKS$#2D\">\n                <field name=\"OP\">EQ</field>\n                <value name=\"A\">\n                  <block type=\"custom-property-value-getter\" id=\"hpiDtsE*e!oB_:Cr5Jc4\">\n                    <field name=\"CONTROL_NAME\"></field>\n                  </block>\n                </value>\n                <value name=\"B\">\n                  <block type=\"text\" id=\"M)6cESBp9[M?=B|p}z`a\">\n                    <field name=\"TEXT\"></field>\n                  </block>\n                </value>\n              </block>\n            </value>\n            <statement name=\"DO0\">\n              <block type=\"custom-property-value-setter\" id=\"LPK}!3QLHPB|U[0rDd,,\">\n                <field name=\"CONTROL_NAME\" ></field>\n                <value name=\"PROPERTY_VALUE_INPUT\">\n                  <shadow type=\"text\" id=\"Z}r0utnA#18Jf[Pjuqci\">\n                    <field name=\"TEXT\"></field>\n                  </shadow>\n                </value>\n              </block>\n            </statement>\n            <value name=\"IF1\">\n              <block type=\"logic_compare\" id=\"Lfu);P.pZZ4GY.=06[G~\">\n                <field name=\"OP\">EQ</field>\n                <value name=\"A\">\n                  <block type=\"custom-property-value-getter\" id=\"..M-u)yNq;rWLyJh%C+Q\">\n                    <field name=\"CONTROL_NAME\"></field>\n                  </block>\n                </value>\n                <value name=\"B\">\n                  <block type=\"text\" id=\"N|imCW@@q`--H;tE!6cc\">\n                    <field name=\"TEXT\"></field>\n                  </block>\n                </value>\n              </block>\n            </value>\n            <statement name=\"DO1\">\n              <block type=\"custom-property-value-setter\" id=\"`hR+g7cZ5(7nu#y+q+#,\">\n                <field name=\"CONTROL_NAME\"></field>\n                <value name=\"PROPERTY_VALUE_INPUT\">\n                  <shadow type=\"text\" id=\"*!wpIpJe|sH8koW7Pr_P\">\n                    <field name=\"TEXT\"></field>\n                  </shadow>\n                </value>\n              </block>\n            </statement>\n          </block>\n        </statement>\n      </block>\n    \n      <!-- 4. set field mandatory if any them has Values (Or condition block)-->\n      <block type=\"procedures_defnoreturn\" id=\"H(Mks@J*1]WcLk.(1IA}\" x=\"70\" y=\"-19\">\n        <field name=\"NAME\">Blockly_set_field_mandatory_if_any_them_hasValues</field>\n        <comment pinned=\"false\" h=\"80\" w=\"160\">Describe this function...</comment>\n        <statement name=\"STACK\">\n          <block type=\"controls_if\" id=\"Rs+mRKfg{F/Z/gx{[j4d\">\n            <mutation else=\"1\"></mutation>\n            <value name=\"IF0\">\n              <block type=\"logic_operation\" id=\"F%.b-n6CG1ub;m20(#3a\">\n                <field name=\"OP\">OR</field>\n                <value name=\"A\">\n                  <block type=\"logic_operation\" id=\"W~(+`#qW27z22nl*^p;Z\">\n                    <field name=\"OP\">OR</field>\n                    <value name=\"A\">\n                      <block type=\"logic_negate\" id=\"+T@NAU-dpDi`@~W*|ez5\">\n                        <value name=\"BOOL\">\n                          <block type=\"text_isEmpty\" id=\"|qJLXpU}T[sI?h@T~lN!\">\n                            <value name=\"VALUE\">\n                              <shadow type=\"text\" id=\"|./*sv10^:MK6peB~0:*\">\n                                <field name=\"TEXT\"></field>\n                              </shadow>\n                              <block type=\"custom-property-value-getter\" id=\"kC0@O}-td8S!.SuCx1Pf\">\n                                <field name=\"CONTROL_NAME\"></field>\n                              </block>\n                            </value>\n                          </block>\n                        </value>\n                      </block>\n                    </value>\n                    <value name=\"B\">\n                      <block type=\"logic_negate\" id=\"@b}TVu![pxppIT.AmooU\">\n                        <value name=\"BOOL\">\n                          <block type=\"text_isEmpty\" id=\"MOb*UY:}Z+,e)#kt/C#`\">\n                            <value name=\"VALUE\">\n                              <shadow type=\"text\" id=\"V2`ld3m95jF+;=5,?)tW\">\n                                <field name=\"TEXT\"></field>\n                              </shadow>\n                              <block type=\"custom-property-value-getter\" id=\"(Iz8W6|Sxoy2jg#j#p(W\">\n                                <field name=\"CONTROL_NAME\"></field>\n                              </block>\n                            </value>\n                          </block>\n                        </value>\n                      </block>\n                    </value>\n                  </block>\n                </value>\n                <value name=\"B\">\n                  <block type=\"logic_negate\" id=\"$u|u.Of=(/jk.m17Z7*P\">\n                    <value name=\"BOOL\">\n                      <block type=\"text_isEmpty\" id=\"Njo/Dsn4RwqzclR9Ha}4\">\n                        <value name=\"VALUE\">\n                          <shadow type=\"text\">\n                            <field name=\"TEXT\"></field>\n                          </shadow>\n                          <block type=\"custom-property-value-getter\" id=\"?3UlPLITQANOqDNMEjI:\">\n                            <field name=\"CONTROL_NAME\"></field>\n                          </block>\n                        </value>\n                      </block>\n                    </value>\n                  </block>\n                </value>\n              </block>\n            </value>\n            <statement name=\"DO0\">\n              <block type=\"custom-property-setter\" id=\"GQH[Q+S4}Q`Kzqm^YZGa\">\n                <field name=\"CONTROL_NAME\"></field>\n              </block>\n            </statement>\n            <statement name=\"ELSE\">\n              <block type=\"custom-property-setter\" id=\"Abu](`B8~}txDD1.p|ra\">\n                <field name=\"CONTROL_NAME\"></field>\n              </block>\n            </statement>\n          </block>\n        </statement>\n      </block>\n    \n      <!-- 5. set field value if any them has Values (Or condition block)-->\n      <block type=\"procedures_defnoreturn\" id=\"{eCA%t*)n0`fx@,+wPdW\" x=\"108\" y=\"123\">\n        <field name=\"NAME\">Blockly_set_field_value_if_any_them_hasValues</field>\n        <comment pinned=\"false\" h=\"80\" w=\"160\">Describe this function...</comment>\n        <statement name=\"STACK\">\n          <block type=\"controls_if\" id=\"8G4;0C[erS#Yt(rg}w+q\">\n            <mutation else=\"1\"></mutation>\n            <value name=\"IF0\">\n              <block type=\"logic_operation\" id=\"-Ut.;%4r}z[){pU@L|8i\">\n                <field name=\"OP\">OR</field>\n                <value name=\"A\">\n                  <block type=\"logic_operation\" id=\"IsY5t_Zo}e}jK3z24o/Z\">\n                    <field name=\"OP\">OR</field>\n                    <value name=\"A\">\n                      <block type=\"logic_negate\" id=\"+WsaGBUNWNVE}mPa=4ap\">\n                        <value name=\"BOOL\">\n                          <block type=\"text_isEmpty\" id=\",VP_#-*ya!4,Vb~Om@vb\">\n                            <value name=\"VALUE\">\n                              <shadow xmlns=\"http://www.w3.org/1999/xhtml\" type=\"text\" id=\"|./*sv10^:MK6peB~0:*\">\n                                <field name=\"TEXT\"></field>\n                              </shadow>\n                              <block type=\"custom-property-value-getter\" id=\"@=.0|~]PZjsL/02e5%}E\">\n                                <field name=\"CONTROL_NAME\"></field>\n                              </block>\n                            </value>\n                          </block>\n                        </value>\n                      </block>\n                    </value>\n                    <value name=\"B\">\n                      <block type=\"logic_negate\" id=\"FM|OhCc]^%OUyy=Ls`)!\">\n                        <value name=\"BOOL\">\n                          <block type=\"text_isEmpty\" id=\"b:#rI8v|R]Wz)fpfEF0a\">\n                            <value name=\"VALUE\">\n                              <shadow xmlns=\"http://www.w3.org/1999/xhtml\" type=\"text\" id=\"V2`ld3m95jF+;=5,?)tW\">\n                                <field name=\"TEXT\"></field>\n                              </shadow>\n                              <block type=\"custom-property-value-getter\" id=\"0|E;rDO$bFRHah2[rL$e\">\n                                <field name=\"CONTROL_NAME\"></field>\n                              </block>\n                            </value>\n                          </block>\n                        </value>\n                      </block>\n                    </value>\n                  </block>\n                </value>\n                <value name=\"B\">\n                  <block type=\"logic_negate\" id=\"]N7uH/O+^kcgCby*|ij3\">\n                    <value name=\"BOOL\">\n                      <block type=\"text_isEmpty\" id=\"FS[)Mu*~OwO;LJ59u5Dl\">\n                        <value name=\"VALUE\">\n                          <shadow xmlns=\"http://www.w3.org/1999/xhtml\" type=\"text\">\n                            <field name=\"TEXT\"></field>\n                          </shadow>\n                          <block type=\"custom-property-value-getter\" id=\"wI)Mv^39zPTDOz!w6-na\">\n                            <field name=\"CONTROL_NAME\"></field>\n                          </block>\n                        </value>\n                      </block>\n                    </value>\n                  </block>\n                </value>\n              </block>\n            </value>\n            <statement name=\"DO0\">\n              <block type=\"custom-property-value-setter\" id=\"Q?Zx^6-)l@~fgh9+!dfu\">\n                <field name=\"CONTROL_NAME\"></field>\n                <value name=\"PROPERTY_VALUE_INPUT\">\n                  <shadow type=\"text\" id=\"WT]k3AF4C4bO!^vpp_1`\">\n                    <field name=\"TEXT\"></field>\n                  </shadow>\n                </value>\n              </block>\n            </statement>\n            <statement name=\"ELSE\">\n              <block type=\"custom-property-value-setter\" id=\"4DJCoj;5`@$9q;cs;)}@\">\n                <field name=\"CONTROL_NAME\"></field>\n                <value name=\"PROPERTY_VALUE_INPUT\">\n                  <shadow type=\"text\" id=\"0y]W4{V.x`0p|=Hqt.-@\">\n                    <field name=\"TEXT\"></field>\n                  </shadow>\n                </value>\n              </block>\n            </statement>\n          </block>\n        </statement>\n      </block>\n\n      <!-- 6. set field mandatory if all them has Values (And condition block)-->\n      <block type=\"procedures_defnoreturn\" id=\"{eCA%t*)n0`fx@,+wPdW\" x=\"108\" y=\"123\">\n        <field name=\"NAME\">Blockly_set_field_mandatory_if_all_them_hasValues</field>\n        <comment pinned=\"false\" h=\"80\" w=\"160\">Describe this function...</comment>\n        <statement name=\"STACK\">\n          <block type=\"controls_if\" id=\"8G4;0C[erS#Yt(rg}w+q\">\n            <mutation else=\"1\"></mutation>\n            <value name=\"IF0\">\n              <block type=\"logic_operation\" id=\"-Ut.;%4r}z[){pU@L|8i\">\n                <field name=\"OP\">AND</field>\n                <value name=\"A\">\n                  <block type=\"logic_operation\" id=\"IsY5t_Zo}e}jK3z24o/Z\">\n                    <field name=\"OP\">AND</field>\n                    <value name=\"A\">\n                      <block type=\"logic_negate\" id=\"+WsaGBUNWNVE}mPa=4ap\">\n                        <value name=\"BOOL\">\n                          <block type=\"text_isEmpty\" id=\",VP_#-*ya!4,Vb~Om@vb\">\n                            <value name=\"VALUE\">\n                              <shadow xmlns=\"http://www.w3.org/1999/xhtml\" type=\"text\" id=\"|./*sv10^:MK6peB~0:*\">\n                                <field name=\"TEXT\"></field>\n                              </shadow>\n                              <block type=\"custom-property-value-getter\" id=\"@=.0|~]PZjsL/02e5%}E\">\n                                <field name=\"CONTROL_NAME\"></field>\n                              </block>\n                            </value>\n                          </block>\n                        </value>\n                      </block>\n                    </value>\n                    <value name=\"B\">\n                      <block type=\"logic_negate\" id=\"FM|OhCc]^%OUyy=Ls`)!\">\n                        <value name=\"BOOL\">\n                          <block type=\"text_isEmpty\" id=\"b:#rI8v|R]Wz)fpfEF0a\">\n                            <value name=\"VALUE\">\n                              <shadow xmlns=\"http://www.w3.org/1999/xhtml\" type=\"text\" id=\"V2`ld3m95jF+;=5,?)tW\">\n                                <field name=\"TEXT\"></field>\n                              </shadow>\n                              <block type=\"custom-property-value-getter\" id=\"0|E;rDO$bFRHah2[rL$e\">\n                                <field name=\"CONTROL_NAME\"></field>\n                              </block>\n                            </value>\n                          </block>\n                        </value>\n                      </block>\n                    </value>\n                  </block>\n                </value>\n                <value name=\"B\">\n                  <block type=\"logic_negate\" id=\"]N7uH/O+^kcgCby*|ij3\">\n                    <value name=\"BOOL\">\n                      <block type=\"text_isEmpty\" id=\"FS[)Mu*~OwO;LJ59u5Dl\">\n                        <value name=\"VALUE\">\n                          <shadow xmlns=\"http://www.w3.org/1999/xhtml\" type=\"text\">\n                            <field name=\"TEXT\"></field>\n                          </shadow>\n                          <block type=\"custom-property-value-getter\" id=\"wI)Mv^39zPTDOz!w6-na\">\n                            <field name=\"CONTROL_NAME\"></field>\n                          </block>\n                        </value>\n                      </block>\n                    </value>\n                  </block>\n                </value>\n              </block>\n            </value>\n            <statement name=\"DO0\">\n              <block type=\"custom-property-setter\" id=\"!w[4_eB0Xf,ru*$heq5E\">\n                <field name=\"CONTROL_NAME\"></field>\n              </block>\n            </statement>\n            <statement name=\"ELSE\">\n              <block type=\"custom-property-setter\" id=\"FATbX4L}Sya?NmvfGHEn\">\n                <field name=\"CONTROL_NAME\"></field>\n              </block>\n            </statement>\n          </block>\n        </statement>\n      </block>\n\n      <!-- 7. set field value if all them has Values (And condition block)-->\n      <block type=\"procedures_defnoreturn\" id=\"{eCA%t*)n0`fx@,+wPdW\" x=\"108\" y=\"123\">\n        <field name=\"NAME\">Blockly_set_field_value_if_all_them_hasValues</field>\n        <comment pinned=\"false\" h=\"80\" w=\"160\">Describe this function...</comment>\n        <statement name=\"STACK\">\n          <block type=\"controls_if\" id=\"8G4;0C[erS#Yt(rg}w+q\">\n            <mutation else=\"1\"></mutation>\n            <value name=\"IF0\">\n              <block type=\"logic_operation\" id=\"-Ut.;%4r}z[){pU@L|8i\">\n                <field name=\"OP\">AND</field>\n                <value name=\"A\">\n                  <block type=\"logic_operation\" id=\"IsY5t_Zo}e}jK3z24o/Z\">\n                    <field name=\"OP\">AND</field>\n                    <value name=\"A\">\n                      <block type=\"logic_negate\" id=\"+WsaGBUNWNVE}mPa=4ap\">\n                        <value name=\"BOOL\">\n                          <block type=\"text_isEmpty\" id=\",VP_#-*ya!4,Vb~Om@vb\">\n                            <value name=\"VALUE\">\n                              <shadow xmlns=\"http://www.w3.org/1999/xhtml\" type=\"text\" id=\"|./*sv10^:MK6peB~0:*\">\n                                <field name=\"TEXT\"></field>\n                              </shadow>\n                              <block type=\"custom-property-value-getter\" id=\"@=.0|~]PZjsL/02e5%}E\">\n                                <field name=\"CONTROL_NAME\"></field>\n                              </block>\n                            </value>\n                          </block>\n                        </value>\n                      </block>\n                    </value>\n                    <value name=\"B\">\n                      <block type=\"logic_negate\" id=\"FM|OhCc]^%OUyy=Ls`)!\">\n                        <value name=\"BOOL\">\n                          <block type=\"text_isEmpty\" id=\"b:#rI8v|R]Wz)fpfEF0a\">\n                            <value name=\"VALUE\">\n                              <shadow xmlns=\"http://www.w3.org/1999/xhtml\" type=\"text\" id=\"V2`ld3m95jF+;=5,?)tW\">\n                                <field name=\"TEXT\"></field>\n                              </shadow>\n                              <block type=\"custom-property-value-getter\" id=\"0|E;rDO$bFRHah2[rL$e\">\n                                <field name=\"CONTROL_NAME\"></field>\n                              </block>\n                            </value>\n                          </block>\n                        </value>\n                      </block>\n                    </value>\n                  </block>\n                </value>\n                <value name=\"B\">\n                  <block type=\"logic_negate\" id=\"]N7uH/O+^kcgCby*|ij3\">\n                    <value name=\"BOOL\">\n                      <block type=\"text_isEmpty\" id=\"FS[)Mu*~OwO;LJ59u5Dl\">\n                        <value name=\"VALUE\">\n                          <shadow xmlns=\"http://www.w3.org/1999/xhtml\" type=\"text\">\n                            <field name=\"TEXT\"></field>\n                          </shadow>\n                          <block type=\"custom-property-value-getter\" id=\"wI)Mv^39zPTDOz!w6-na\">\n                            <field name=\"CONTROL_NAME\"></field>\n                          </block>\n                        </value>\n                      </block>\n                    </value>\n                  </block>\n                </value>\n              </block>\n            </value>\n            <statement name=\"DO0\">\n              <block type=\"custom-property-value-setter\" id=\"Q?Zx^6-)l@~fgh9+!dfu\">\n                <field name=\"CONTROL_NAME\"></field>\n                <value name=\"PROPERTY_VALUE_INPUT\">\n                  <shadow type=\"text\" id=\"WT]k3AF4C4bO!^vpp_1`\">\n                    <field name=\"TEXT\"></field>\n                  </shadow>\n                </value>\n              </block>\n            </statement>\n            <statement name=\"ELSE\">\n              <block type=\"custom-property-value-setter\" id=\"4DJCoj;5`@$9q;cs;)}@\">\n                <field name=\"CONTROL_NAME\"></field>\n                <value name=\"PROPERTY_VALUE_INPUT\">\n                  <shadow type=\"text\" id=\"0y]W4{V.x`0p|=Hqt.-@\">\n                    <field name=\"TEXT\"></field>\n                  </shadow>\n                </value>\n              </block>\n            </statement>\n          </block>\n        </statement>\n      </block>\n\n      <!-- 8. Auto Calculation (based on a selected value from a different field)-->\n      <block type=\"procedures_defnoreturn\" id=\"n(_#zO#Hup!JZ[nUZ)lm\" x=\"90\" y=\"49\">\n        <field name=\"NAME\">Blockly_Auto_Calculation</field>\n        <comment pinned=\"false\" h=\"80\" w=\"160\">Describe this function...</comment>\n        <statement name=\"STACK\">\n          <block type=\"controls_if\" id=\"`r:7h+~/@,#{;!O}#C%h\">\n            <mutation elseif=\"1\"></mutation>\n            <value name=\"IF0\">\n              <block type=\"logic_compare\" id=\"`C_^y;XyO[Q6:GI%Kqz9\">\n                <field name=\"OP\">EQ</field>\n                <value name=\"A\">\n                  <block type=\"custom-property-value-getter\" id=\";6t9Wb_HG@*IY0I=L]$9\">\n                    <field name=\"CONTROL_NAME\"></field>\n                  </block>\n                </value>\n                <value name=\"B\">\n                  <block type=\"text\" id=\"eXzR%+s2`SBl2VOZ@5LK\">\n                    <field name=\"TEXT\"></field>\n                  </block>\n                </value>\n              </block>\n            </value>\n            <statement name=\"DO0\">\n              <block type=\"custom-property-value-setter\" id=\"];9(n-kh.Ge.Y_*-[wSL\">\n                <field name=\"CONTROL_NAME\"></field>\n                <value name=\"PROPERTY_VALUE_INPUT\">\n                  <shadow type=\"text\" id=\";!jb;v+bFhxzs_,`e-}9\">\n                    <field name=\"TEXT\"></field>\n                  </shadow>\n                  <block type=\"math_arithmetic\" id=\"=!+Arox{Z5BEYd7W(%c+\">\n                    <field name=\"OP\">MULTIPLY</field>\n                    <value name=\"A\">\n                      <shadow type=\"math_number\" id=\"4!S~8V(y:Y~uW;}ftxuX\">\n                        <field name=\"NUM\">1</field>\n                      </shadow>\n                      <block type=\"custom-property-value-getter\" id=\"ILW|RR%k+m#T#l[._IZ3\">\n                        <field name=\"CONTROL_NAME\"></field>\n                      </block>\n                    </value>\n                    <value name=\"B\">\n                      <shadow type=\"math_number\" id=\"yOJ5u4QfF9$b}:IR.Hxu\">\n                        <field name=\"NUM\">1</field>\n                      </shadow>\n                    </value>\n                  </block>\n                </value>\n              </block>\n            </statement>\n            <value name=\"IF1\">\n              <block type=\"logic_compare\" id=\"mMPNqq!7j(nT3`Bl?We9\">\n                <field name=\"OP\">EQ</field>\n                <value name=\"A\">\n                  <block type=\"custom-property-value-getter\" id=\"4iIg|L;ugX*aZ}ur7p8z\">\n                    <field name=\"CONTROL_NAME\"></field>\n                  </block>\n                </value>\n                <value name=\"B\">\n                  <block type=\"text\" id=\"=bt;/({SH%^8m4[c!a7N\">\n                    <field name=\"TEXT\"></field>\n                  </block>\n                </value>\n              </block>\n            </value>\n            <statement name=\"DO1\">\n              <block type=\"custom-property-value-setter\" id=\"=.2J(iVR@J!`FF+{4k[/\">\n                <field name=\"CONTROL_NAME\"></field>\n                <value name=\"PROPERTY_VALUE_INPUT\">\n                  <shadow type=\"text\">\n                    <field name=\"TEXT\"></field>\n                  </shadow>\n                  <block type=\"math_arithmetic\" id=\"UoH/rmj|zFD;T$qx_DL0\">\n                    <field name=\"OP\">MULTIPLY</field>\n                    <value name=\"A\">\n                      <shadow type=\"math_number\">\n                        <field name=\"NUM\">1</field>\n                      </shadow>\n                      <block type=\"custom-property-value-getter\" id=\"9!@|l7z+ClfC(r+fZy:G\">\n                        <field name=\"CONTROL_NAME\"></field>\n                      </block>\n                    </value>\n                    <value name=\"B\">\n                      <shadow type=\"math_number\" id=\"G_kOyz|,rwsHsQT;:.Pp\">\n                        <field name=\"NUM\">1</field>\n                      </shadow>\n                    </value>\n                  </block>\n                </value>\n              </block>\n            </statement>\n          </block>\n        </statement>\n      </block>\n\n      <!-- 9. insert delete row Of repeatingtable base On Condition-->\n      <block type=\"procedures_defnoreturn\" id=\"9=t!QDV7oiyTn?3a{M!H\" x=\"147\" y=\"82\">\n        <field name=\"NAME\">Blockly_insert_delete_rowOf_repeatingtable_baseOnCondition</field>\n        <comment pinned=\"false\" h=\"80\" w=\"160\">Describe this function...</comment>\n        <statement name=\"STACK\">\n          <block type=\"controls_if\" id=\"_XMfFt-=o2/tn2gv1uo.\">\n            <value name=\"IF0\">\n              <block type=\"logic_operation\" id=\"tH3oKZb#:f%X%r*npl6C\">\n                <field name=\"OP\">AND</field>\n                <value name=\"A\">\n                  <block type=\"logic_compare\" id=\"s}d0_`!qpsM3QJQ(*QJa\">\n                    <field name=\"OP\">GTE</field>\n                    <value name=\"A\">\n                      <block type=\"lists_length\" id=\"2@^WL,`WhEuQ!1aFR+S{\">\n                        <value name=\"VALUE\">\n                          <block type=\"custom-get-repeating-table-rows\" id=\"utI]H|h~}I`q6iyq^Cpj\">\n                            <field name=\"CONTROL_NAME\"></field>\n                          </block>\n                        </value>\n                      </block>\n                    </value>\n                    <value name=\"B\">\n                      <block type=\"math_number\" id=\"nK}uC6P24qkr%3]kWYQ$\">\n                        <field name=\"NUM\">0</field>\n                      </block>\n                    </value>\n                  </block>\n                </value>\n                <value name=\"B\">\n                  <block type=\"logic_compare\" id=\"tG)UH.0xyenY}iY[x/(A\">\n                    <field name=\"OP\">NEQ</field>\n                    <value name=\"A\">\n                      <block type=\"custom-property-value-getter\" id=\"r6cI-ETX^D(]{O?s`bu\">\n                        <field name=\"CONTROL_NAME\"></field>\n                      </block>\n                    </value>\n                    <value name=\"B\">\n                      <block type=\"text\" id=\"TS6s13sH;@|Pmb`G`%]i\">\n                        <field name=\"TEXT\"></field>\n                      </block>\n                    </value>\n                  </block>\n                </value>\n              </block>\n            </value>\n            <statement name=\"DO0\">\n              <block type=\"repeating-table-functionality\" id=\"V.(-r]^SX_Gm?}{mOLr.\">\n                <field name=\"FUNCTIONALITY\">deleteRow</field>\n                <field name=\"CONTROL_NAME\"></field>\n                <field name=\"INDEX_VALUE\">randomRow</field>\n              </block>\n            </statement>\n          </block>\n        </statement>\n      </block>\n\n      <!-- 10. show hide row OF RepeatingTable Based On Condition-->\n      <variables>\n        <variable id=\";RPGjDy{+zPJa1l+!M2Z\">index</variable>\n        <variable id=\";?mm=4{c2XbuUxV[|]q;\">i</variable>\n      </variables>\n      <block type=\"procedures_defnoreturn\" id=\"7y@R/29O{^5P{%04%9vy\" x=\"16\" y=\"24\">\n        <field name=\"NAME\">Blockly_show_hide_rowOF_RepeatingTable_BasedOnCondition</field>\n        <comment pinned=\"false\" h=\"80\" w=\"160\">Describe this function...</comment>\n        <statement name=\"STACK\">\n          <block type=\"variables_set\" id=\"|s6jJCom}rh=cuW)E);-\">\n            <field name=\"VAR\" id=\";RPGjDy{+zPJa1l+!M2Z\">index</field>\n            <value name=\"VALUE\">\n              <block type=\"math_number\" id=\"z(K._uf8+z|*Ag:6Ve(A\">\n                <field name=\"NUM\">1</field>\n              </block>\n            </value>\n            <next>\n              <block type=\"controls_forEach\" id=\"6U+awA@@TjT*6Hi6hs)]\">\n                <field name=\"VAR\" id=\";?mm=4{c2XbuUxV[|]q;\">i</field>\n                <value name=\"LIST\">\n                  <block type=\"custom-get-repeating-table-rows\" id=\"4AFTiz.5@W.:{:fJ$/,d\">\n                    <field name=\"CONTROL_NAME\"></field>\n                  </block>\n                </value>\n                <statement name=\"DO\">\n                  <block type=\"controls_if\" id=\"3xh:?EUOBhL/pL6RTwE(\">\n                    <value name=\"IF0\">\n                      <block type=\"logic_compare\" id=\"kLAHRe$[#tI~]hrrzK7:\">\n                        <field name=\"OP\">LTE</field>\n                        <value name=\"A\">\n                          <block type=\"variables_get\" id=\"5~9+1=tRkE$YB~?8*O.j\">\n                            <field name=\"VAR\" id=\";RPGjDy{+zPJa1l+!M2Z\">index</field>\n                          </block>\n                        </value>\n                        <value name=\"B\">\n                          <block type=\"lists_length\" id=\"lkIK3kg}clugW!g/:|{|\">\n                            <value name=\"VALUE\">\n                              <block type=\"custom-get-repeating-table-rows\" id=\"HSj;HAm/u8]WzSm[S%tX\">\n                                <field name=\"CONTROL_NAME\"></field>\n                              </block>\n                            </value>\n                          </block>\n                        </value>\n                      </block>\n                    </value>\n                    <statement name=\"DO0\">\n                      <block type=\"controls_if\" id=\"iMsrh;pE0vcn[o,d[DbT\">\n                        <mutation else=\"1\"></mutation>\n                        <value name=\"IF0\">\n                          <block type=\"logic_compare\" id=\"2e9vev[?RCb9H}`!(LwQ\">\n                            <field name=\"OP\">NEQ</field>\n                            <value name=\"A\">\n                              <block type=\"custom-property-value-getter\" id=\"C/*qQgc{I3$XTf0/[67/\">\n                                <field name=\"CONTROL_NAME\"></field>\n                              </block>\n                            </value>\n                            <value name=\"B\">\n                              <block type=\"text\" id=\"WKzW5q%7FiaICxI=eDl=\">\n                                <field name=\"TEXT\"></field>\n                              </block>\n                            </value>\n                          </block>\n                        </value>\n                        <statement name=\"DO0\">\n                          <block type=\"repeating-table-functionality\" id=\"Av}+NaH:ST+QPWGVE/G_\">\n                            <field name=\"FUNCTIONALITY\">showRow</field>\n                            <field name=\"CONTROL_NAME\"></field>\n                            <field name=\"INDEX_VALUE\">randomRow</field>\n                            <field name=\"VALUE_CHECKBOX\">FALSE</field>\n                            <value name=\"ROW_DATA\">\n                              <block type=\"variables_get\" id=\"K)X?^G#*%fz7mEz4_aur\">\n                                <field name=\"VAR\" id=\";RPGjDy{+zPJa1l+!M2Z\">index</field>\n                              </block>\n                            </value>\n                          </block>\n                        </statement>\n                        <statement name=\"ELSE\">\n                          <block type=\"repeating-table-functionality\" id=\"jcK{Q~/n@yMvg}Py`$]A\">\n                            <field name=\"FUNCTIONALITY\">showRow</field>\n                            <field name=\"CONTROL_NAME\"></field>\n                            <field name=\"INDEX_VALUE\">randomRow</field>\n                            <field name=\"VALUE_CHECKBOX\">TRUE</field>\n                            <value name=\"ROW_DATA\">\n                              <block type=\"variables_get\" id=\"9Jlo=k[7RQgMB2VP]/@,\">\n                                <field name=\"VAR\" id=\";RPGjDy{+zPJa1l+!M2Z\">index</field>\n                              </block>\n                            </value>\n                          </block>\n                        </statement>\n                      </block>\n                    </statement>\n                    <next>\n                      <block type=\"variables_set\" id=\"xq/B`k[9H:Nn%*YF]IkB\">\n                        <field name=\"VAR\" id=\";RPGjDy{+zPJa1l+!M2Z\">index</field>\n                        <value name=\"VALUE\">\n                          <block type=\"math_arithmetic\" id=\"n;V8w.FXcj|c22KMo?y_\">\n                            <field name=\"OP\">ADD</field>\n                            <value name=\"A\">\n                              <shadow xmlns=\"http://www.w3.org/1999/xhtml\" type=\"math_number\" id=\"Aet8@wwfv!noB3EekNO]\">\n                                <field name=\"NUM\">1</field>\n                              </shadow>\n                              <block type=\"variables_get\" id=\"v+6fbAE;Wq7i!L8L.Ve=\">\n                                <field name=\"VAR\" id=\";RPGjDy{+zPJa1l+!M2Z\">index</field>\n                              </block>\n                            </value>\n                            <value name=\"B\">\n                              <shadow xmlns=\"http://www.w3.org/1999/xhtml\" type=\"math_number\" id=\"L=U;.0DbIV-M}cz{bpI{\">\n                                <field name=\"NUM\">1</field>\n                              </shadow>\n                              <block type=\"math_number\" id=\"0/~D9l%OW_B2l]yzl=}!\">\n                                <field name=\"NUM\">1</field>\n                              </block>\n                            </value>\n                          </block>\n                        </value>\n                      </block>\n                    </next>\n                  </block>\n                </statement>\n              </block>\n            </next>\n          </block>\n        </statement>\n      </block>\n      <!-- 11. LOCATION ASSOCIATION-->\n      <block type=\"location_association\" id=\"mASK:fDb8q...F?#5mka\" x=\"147\" y=\"88\">\n        <statement name=\"LOCATION_ASSOCIATION\">\n          <block type=\"custom-property-value-setter\" id=\"y@G+Bq/oNwq|RPEE)Vro\">\n            <field name=\"CONTROL_NAME\"></field>\n            <value name=\"PROPERTY_VALUE_INPUT\">\n              <shadow type=\"text\" id=\"1@wZqV{,Rc4Ux*s:,9sk\">\n                <field name=\"TEXT\"></field>\n              </shadow>\n              <block type=\"sp_value_getter\" id=\"8.OUfnVO]nz2uQKhoaX8\">\n                <field name=\"SP_NAME\"></field>\n              </block>\n            </value>\n          </block>\n        </statement>\n      </block>\n\n      <!-- 12. set autonumber In Fields from multiple FieldValue-->\n      <block type=\"procedures_defnoreturn\" id=\"U[oAmI~%vn9Kon8L=61@\" x=\"82\" y=\"95\">\n        <field name=\"NAME\">Blockly_set_autonumber_InFields_from_multiple_FieldValue</field>\n        <comment pinned=\"false\" h=\"80\" w=\"160\">Describe this function...</comment>\n        <statement name=\"STACK\">\n          <block type=\"custom-property-value-setter\" id=\"V(gUfhaQg:mNDA/~PtOv\">\n            <field name=\"CONTROL_NAME\"></field>\n            <value name=\"PROPERTY_VALUE_INPUT\">\n              <shadow xmlns=\"http://www.w3.org/1999/xhtml\" type=\"text\" id=\"+Q|@Y_gWRg4{W|-/+jM#\">\n                <field name=\"TEXT\"></field>\n              </shadow>\n              <block type=\"text_join\" id=\"x$rCD?o8O}_RW|IJzMcl\">\n                <mutation items=\"2\"></mutation>\n                <value name=\"ADD0\">\n                  <block type=\"text_getSubstring\" id=\"kL9xoO:D#c[hUAL6jGQ:\">\n                    <mutation at1=\"false\" at2=\"true\"></mutation>\n                    <field name=\"WHERE1\">FIRST</field>\n                    <field name=\"WHERE2\">FROM_START</field>\n                    <value name=\"STRING\">\n                      <block type=\"custom-property-value-getter\" id=\"J|ouYr]beI}%dG?*)tHY\">\n                        <field name=\"CONTROL_NAME\"></field>\n                      </block>\n                    </value>\n                    <value name=\"AT2\">\n                      <block type=\"math_arithmetic\" id=\"J/g2,n=}Qe]`D%F3pgmm\">\n                        <field name=\"OP\">MINUS</field>\n                        <value name=\"A\">\n                          <shadow xmlns=\"http://www.w3.org/1999/xhtml\" type=\"math_number\" id=\"L4x.Q[JB$glgEt(c)OM7\">\n                            <field name=\"NUM\">1</field>\n                          </shadow>\n                          <block type=\"parse_to_number\" id=\"Pfkt|w@aY)23E:DWQ?0c\">\n                            <value name=\"PARSE_TO_NUMBER\">\n                              <block type=\"text_indexOf\" id=\"CoGT)+Eglwqy/|+$h1gp\">\n                                <field name=\"END\">FIRST</field>\n                                <value name=\"VALUE\">\n                                  <block type=\"custom-property-value-getter\" id=\"{.{/j`84cXsbq}E0!Jl:\">\n                                    <field name=\"CONTROL_NAME\"></field>\n                                  </block>\n                                </value>\n                                <value name=\"FIND\">\n                                  <shadow type=\"text\" id=\"]|`CD88xjyS~%WI!pRq@\">\n                                    <field name=\"TEXT\">abc</field>\n                                  </shadow>\n                                </value>\n                              </block>\n                            </value>\n                          </block>\n                        </value>\n                        <value name=\"B\">\n                          <shadow type=\"math_number\" id=\"p{N9p.p,kh1sL_QvOGV9\">\n                            <field name=\"NUM\">1</field>\n                          </shadow>\n                        </value>\n                      </block>\n                    </value>\n                  </block>\n                </value>\n                <value name=\"ADD1\">\n                  <block type=\"text\" id=\"kBqB,V|^PVc0~%#r:dh:\">\n                    <field name=\"TEXT\">-</field>\n                  </block>\n                </value>\n              </block>\n            </value>\n            <next>\n              <block type=\"auto_next_number_block\" id=\"Qm16*9L,tG?=HiW=|Pfu\">\n                <field name=\"AUTO_NUMBER_FIELD\"></field>\n                <field name=\"AUTO_NUMBER_LENGTH\">3</field>\n                <field name=\"AUTO_NUMBER_START_FROM\">000</field>\n                <field name=\"AUTO_NUMBER_POSITION\">POSTFIX</field>\n                <field name=\"AUTO_NUMBER_SEPARATOR\">-</field>\n                <field name=\"AUTO_NUMBER_STRINGCHECK\">YES</field>\n                <field name=\"EXECUTE_AUTO_NUMBER\">YES</field>\n                <value name=\"AUTO_NUMBER_TITLE\">\n                  <block type=\"text_join\" id=\"u!ulg9_[gTIr*n^gvumm\">\n                    <mutation items=\"2\"></mutation>\n                    <value name=\"ADD0\">\n                      <block type=\"text_getSubstring\" id=\"zMF]VL@y3hf@7q7ZXTsF\">\n                        <mutation at1=\"false\" at2=\"true\"></mutation>\n                        <field name=\"WHERE1\">FIRST</field>\n                        <field name=\"WHERE2\">FROM_START</field>\n                        <value name=\"STRING\">\n                          <block type=\"custom-property-value-getter\" id=\"{$L*)q2MTAQWcS#~!DjS\">\n                            <field name=\"CONTROL_NAME\"></field>\n                          </block>\n                        </value>\n                        <value name=\"AT2\">\n                          <block type=\"math_arithmetic\" id=\"lRoaB+t#?8V|7^#ShC;i\">\n                            <field name=\"OP\">MINUS</field>\n                            <value name=\"A\">\n                              <shadow xmlns=\"http://www.w3.org/1999/xhtml\" type=\"math_number\" id=\"L4x.Q[JB$glgEt(c)OM7\">\n                                <field name=\"NUM\">1</field>\n                              </shadow>\n                              <block type=\"parse_to_number\" id=\"C3R5Zlr4ABV6zRsHn*l(\">\n                                <value name=\"PARSE_TO_NUMBER\">\n                                  <block type=\"text_indexOf\" id=\"}f314-AaDpMDV.#iSg*g\">\n                                    <field name=\"END\">FIRST</field>\n                                    <value name=\"VALUE\">\n                                      <block type=\"custom-property-value-getter\" id=\"z~0F*]I,vXg+p:3u8;NJ\">\n                                        <field name=\"CONTROL_NAME\"></field>\n                                      </block>\n                                    </value>\n                                    <value name=\"FIND\">\n                                      <shadow type=\"text\" id=\"kE2ZVi3r-kF0?3PKepaS\">\n                                        <field name=\"TEXT\">abc</field>\n                                      </shadow>\n                                    </value>\n                                  </block>\n                                </value>\n                              </block>\n                            </value>\n                            <value name=\"B\">\n                              <shadow type=\"math_number\" id=\"HW0bE!_ls38}[0-!($eO\">\n                                <field name=\"NUM\">1</field>\n                              </shadow>\n                            </value>\n                          </block>\n                        </value>\n                      </block>\n                    </value>\n                    <value name=\"ADD1\">\n                      <block type=\"text\" id=\"Ol/Gx1Uo]Ph8BYV_Duw3\">\n                        <field name=\"TEXT\">-</field>\n                      </block>\n                    </value>\n                  </block>\n                </value>\n              </block>\n            </next>\n          </block>\n        </statement>\n      </block>\n\n      <!-- 13. set Options in Dropdown which is Inside RepeatingTable-->\n      <block type=\"procedures_defnoreturn\" id=\"C!={qQX_lv*s/]~Iimlv\" x=\"203\" y=\"118\">\n        <field name=\"NAME\">Blockly_setOption_inDropdown_InsideRepeatingTable</field>\n        <comment pinned=\"false\" h=\"80\" w=\"160\">Describe this function...</comment>\n        <statement name=\"STACK\">\n          <block type=\"controls_forEach\" id=\"o7_N^3L!;DNm7qF3=#lM\">\n            <field name=\"VAR\" id=\"r#Y^`1Pu?cN`tCNTI__I\">i</field>\n            <value name=\"LIST\">\n              <block type=\"custom-get-repeating-table-rows\" id=\"zoXHD6zjx]Bo.P$1L)3g\">\n                <field name=\"CONTROL_NAME\"></field>\n              </block>\n            </value>\n            <statement name=\"DO\">\n              <block type=\"controls_if\" id=\"?iq,tW(!}4E6)Qa5`0xV\">\n                <value name=\"IF0\">\n                  <block type=\"logic_compare\" id=\"hgh#A3NG%~jO+Q`S0U]Y\">\n                    <field name=\"OP\">EQ</field>\n                    <value name=\"A\">\n                      <block type=\"custom-property-value-getter\" id=\"{sK,ZL;@Hx2:P3zaBA2v\">\n                        <field name=\"CONTROL_NAME\"></field>\n                      </block>\n                    </value>\n                    <value name=\"B\">\n                      <block type=\"text\" id=\"K-ZUM{%m=CS]f|n^$MM^\">\n                        <field name=\"TEXT\"></field>\n                      </block>\n                    </value>\n                  </block>\n                </value>\n                <statement name=\"DO0\">\n                  <block type=\"custom-property-setter_by_getter\" id=\"qZ50skaFW{e:|@GMJ9@s\">\n                    <field name=\"CONTROL_NAME\"></field>\n                    <value name=\"PROPERTY_VALUE_INPUT\">\n                      <shadow type=\"custom-property-getter\" id=\"_(l6%==WP?F)r!Q#M`;W\">\n                        <field name=\"CONTROL_NAME\"></field>\n                      </shadow>\n                      <block type=\"custom-property-value-getter\" id=\"Q8(rw5FPjAJ,eSD:9LAJ\">\n                        <field name=\"CONTROL_NAME\"></field>\n                      </block>\n                    </value>\n                  </block>\n                </statement>\n              </block>\n            </statement>\n          </block>\n        </statement>\n      </block>\n\n      <!-- 14. form search api connection-->\n      <variables>\n        <variable id=\";?mm=4{c2XbuUxV[|]q;\">i</variable>\n        <variable id=\"D8vNC`PN/j^yTP/WPOxf\">repeatingTableData</variable>\n        <variable id=\"^bm3HGDWO?V-+0CHz_rP\">RowIndex</variable>\n        <variable id=\"?T*.f2_`T7B-[-`WX}B^\">j</variable>\n      </variables>\n      <block type=\"set_api_data\" id=\"[#e*,+.!{bms%r}$vs@w\" x=\"16\" y=\"151\">\n        <field name=\"API_NAME\"></field>\n        <field name=\"RESPONSE_DATA_VAR\" id=\";?mm=4{c2XbuUxV[|]q;\">i</field>\n        <statement name=\"SET_API_DATA\">\n          <block type=\"custom-property-setter_by_getter\" id=\"F?q)i6{k[Ln_2iO/=nH+\">\n            <field name=\"CONTROL_NAME\"></field>\n            <value name=\"PROPERTY_VALUE_INPUT\">\n              <shadow xmlns=\"http://www.w3.org/1999/xhtml\" type=\"custom-property-getter\" id=\"@KF)OxAf14v#L2?FFuL+\">\n                <field name=\"CONTROL_NAME\"></field>\n              </shadow>\n              <block type=\"get-custom-response\" id=\"7kcx@;c-x3(3_-!]=V9y\">\n                <mutation value=\"Please select\" keyValue=\"null\" collectionValue=\"null\" mapValue=\"null\" projectNameValues=\"null\" appbuilderIDValues=\"null\" destinationFieldVlaues=\"null\" newValue=\"null\" newNameValue=\"null\" nameValue=\"null\">\n                  <option display-value=\"Please select\" neutral-value=\"Please select\"></option>\n                </mutation>\n                <field name=\"FIELD_NAME\">Please select</field>\n                <value name=\"RESPONSE_DATA\">\n                  <block type=\"lists_getIndex\" id=\"hF@kXi0gF(|UI[+#)9$2\">\n                    <mutation statement=\"false\" at=\"true\"></mutation>\n                    <field name=\"MODE\">GET</field>\n                    <field name=\"WHERE\">FROM_START</field>\n                    <value name=\"VALUE\">\n                      <block type=\"get-custom-response\" id=\"Jh9+AaF8o^muo+Gr]?8O\">\n                        <mutation value=\"Please select\" keyValue=\"null\" collectionValue=\"null\" mapValue=\"null\" projectNameValues=\"null\" appbuilderIDValues=\"null\" destinationFieldVlaues=\"null\" newValue=\"null\" newNameValue=\"null\" nameValue=\"null\">\n                          <option display-value=\"Please select\" neutral-value=\"Please select\"></option>\n                        </mutation>\n                        <field name=\"FIELD_NAME\">Please select</field>\n                        <value name=\"RESPONSE_DATA\">\n                          <block type=\"variables_get\" id=\"G/{2]hQs?hpsNptQN7#v\">\n                            <field name=\"VAR\" id=\";?mm=4{c2XbuUxV[|]q;\">i</field>\n                          </block>\n                        </value>\n                      </block>\n                    </value>\n                    <value name=\"AT\">\n                      <block type=\"math_number\" id=\"Y8L5QmC!}E2-d%2UB)Rt\">\n                        <field name=\"NUM\">1</field>\n                      </block>\n                    </value>\n                  </block>\n                </value>\n              </block>\n            </value>\n            <next>\n              <block type=\"custom-property-value-setter\" id=\"F5Pqsk4]Q5J*VtO{r`oI\">\n                <field name=\"CONTROL_NAME\"></field>\n                <value name=\"PROPERTY_VALUE_INPUT\">\n                  <shadow xmlns=\"http://www.w3.org/1999/xhtml\" type=\"text\" id=\"`Fa75p+o.tcMZ]h5sduk\">\n                    <field name=\"TEXT\"></field>\n                  </shadow>\n                  <block type=\"get-custom-response\" id=\"ei`q}$U:S7L|z%*Mjhr?\">\n                    <mutation value=\"Please select\" keyValue=\"null\" collectionValue=\"null\" mapValue=\"null\" projectNameValues=\"null\" appbuilderIDValues=\"null\" destinationFieldVlaues=\"null\" newValue=\"null\" newNameValue=\"null\" nameValue=\"null\">\n                      <option display-value=\"Please select\" neutral-value=\"Please select\"></option>\n                    </mutation>\n                    <field name=\"FIELD_NAME\">Please select</field>\n                    <value name=\"RESPONSE_DATA\">\n                      <block type=\"lists_getIndex\" id=\"hEI:OB]D.5D_0U,eHRIp\">\n                        <mutation statement=\"false\" at=\"true\"></mutation>\n                        <field name=\"MODE\">GET</field>\n                        <field name=\"WHERE\">FROM_START</field>\n                        <value name=\"VALUE\">\n                          <block type=\"get-custom-response\" id=\"LTN)_+#kISq:K9uzaRvb\">\n                            <mutation value=\"Please select\" keyValue=\"null\" collectionValue=\"null\" mapValue=\"null\" projectNameValues=\"null\" appbuilderIDValues=\"null\" destinationFieldVlaues=\"null\" newValue=\"null\" newNameValue=\"null\" nameValue=\"null\">\n                              <option display-value=\"Please select\" neutral-value=\"Please select\"></option>\n                            </mutation>\n                            <field name=\"FIELD_NAME\">Please select</field>\n                            <value name=\"RESPONSE_DATA\">\n                              <block type=\"variables_get\" id=\";Z]g2}~c_R9gQX3fDsS)\">\n                                <field name=\"VAR\" id=\";?mm=4{c2XbuUxV[|]q;\">i</field>\n                              </block>\n                            </value>\n                          </block>\n                        </value>\n                        <value name=\"AT\">\n                          <block type=\"math_number\" id=\"f`}/yD8ex-4rj%nnn=sn\">\n                            <field name=\"NUM\">1</field>\n                          </block>\n                        </value>\n                      </block>\n                    </value>\n                  </block>\n                </value>\n                <next>\n                  <block type=\"variables_set\" id=\"mW`U#Hy@p+;kf?B:n1Oj\">\n                    <field name=\"VAR\" id=\"D8vNC`PN/j^yTP/WPOxf\">repeatingTableData</field>\n                    <value name=\"VALUE\">\n                      <block type=\"get-custom-response\" id=\"JU0wP@58@)IrZBF{i;A]\">\n                        <mutation value=\"Please select\" keyValue=\"null\" collectionValue=\"null\" mapValue=\"null\" projectNameValues=\"null\" appbuilderIDValues=\"null\" destinationFieldVlaues=\"null\" newValue=\"null\" newNameValue=\"null\" nameValue=\"null\">\n                          <option display-value=\"Please select\" neutral-value=\"Please select\"></option>\n                        </mutation>\n                        <field name=\"FIELD_NAME\">Please select</field>\n                        <value name=\"RESPONSE_DATA\">\n                          <block type=\"lists_getIndex\" id=\"pD91m:8]`Js*OO=goN7B\">\n                            <mutation statement=\"false\" at=\"true\"></mutation>\n                            <field name=\"MODE\">GET</field>\n                            <field name=\"WHERE\">FROM_START</field>\n                            <value name=\"VALUE\">\n                              <block type=\"get-custom-response\" id=\"A_:1:x~}i4!7%|QC$NHg\">\n                                <mutation value=\"Please select\" keyValue=\"null\" collectionValue=\"null\" mapValue=\"null\" projectNameValues=\"null\" appbuilderIDValues=\"null\" destinationFieldVlaues=\"null\" newValue=\"null\" newNameValue=\"null\" nameValue=\"null\">\n                                  <option display-value=\"Please select\" neutral-value=\"Please select\"></option>\n                                </mutation>\n                                <field name=\"FIELD_NAME\">Please select</field>\n                                <value name=\"RESPONSE_DATA\">\n                                  <block type=\"variables_get\" id=\"y{KL^Gnn.S8fCK(Q**uF\">\n                                    <field name=\"VAR\" id=\";?mm=4{c2XbuUxV[|]q;\">i</field>\n                                  </block>\n                                </value>\n                              </block>\n                            </value>\n                            <value name=\"AT\">\n                              <block type=\"math_number\" id=\"mbhF_wZM;{gH~yLKV+Qp\">\n                                <field name=\"NUM\">1</field>\n                              </block>\n                            </value>\n                          </block>\n                        </value>\n                      </block>\n                    </value>\n                    <next>\n                      <block type=\"controls_repeat_ext\" id=\"m/3~ESjX7Qqrc?h*={Nx\">\n                        <value name=\"TIMES\">\n                          <shadow xmlns=\"http://www.w3.org/1999/xhtml\" type=\"math_number\" id=\"/]yP*p+4g=d|m)YepN4`\">\n                            <field name=\"NUM\">10</field>\n                          </shadow>\n                          <block type=\"math_arithmetic\" id=\"k(]y^u6Fd5zkbXr|B}6s\">\n                            <field name=\"OP\">MINUS</field>\n                            <value name=\"A\">\n                              <shadow xmlns=\"http://www.w3.org/1999/xhtml\" type=\"math_number\" id=\"@7Y:Uo^~eO}`|qp^JGeB\">\n                                <field name=\"NUM\">1</field>\n                              </shadow>\n                              <block type=\"lists_length\" id=\"(IGrP[X$PR!Etb;/ZjEM\">\n                                <value name=\"VALUE\">\n                                  <block type=\"variables_get\" id=\"ZNdV[RzBeBQs%q9-P1km\">\n                                    <field name=\"VAR\" id=\"D8vNC`PN/j^yTP/WPOxf\">repeatingTableData</field>\n                                  </block>\n                                </value>\n                              </block>\n                            </value>\n                            <value name=\"B\">\n                              <shadow type=\"math_number\" id=\"a3]cAFv=rJX!PG2bxF#l\">\n                                <field name=\"NUM\">0</field>\n                              </shadow>\n                              <block type=\"math_number\" id=\"o6Vx1+w!G5d~E.ReRPD8\">\n                                <field name=\"NUM\">1</field>\n                              </block>\n                            </value>\n                          </block>\n                        </value>\n                        <statement name=\"DO\">\n                          <block type=\"repeating-table-functionality\" id=\"U!Gh)`oBYbt!Ih+[26R6\">\n                            <field name=\"FUNCTIONALITY\">insertRow</field>\n                            <field name=\"CONTROL_NAME\"></field>\n                            <field name=\"INDEX_VALUE\">randomRow</field>\n                          </block>\n                        </statement>\n                        <next>\n                          <block type=\"variables_set\" id=\"qhk$M_Z?vIe8.)|.k^V(\">\n                            <field name=\"VAR\" id=\"^bm3HGDWO?V-+0CHz_rP\">RowIndex</field>\n                            <value name=\"VALUE\">\n                              <block type=\"math_number\" id=\"!-4O+P@dw%q]LlQqp;}J\">\n                                <field name=\"NUM\">1</field>\n                              </block>\n                            </value>\n                            <next>\n                              <block type=\"controls_forEach\" id=\"C5kARH~3bW1b~39]KiaS\">\n                                <field name=\"VAR\" id=\"?T*.f2_`T7B-[-`WX}B^\">j</field>\n                                <value name=\"LIST\">\n                                  <block type=\"custom-get-repeating-table-rows\" id=\"mBncNK}$%tOvSX{Nc[3C\">\n                                    <field name=\"CONTROL_NAME\"></field>\n                                  </block>\n                                </value>\n                                <statement name=\"DO\">\n                                  <block type=\"controls_if\" id=\"w{#.P^e{$xJ*eIP?lqsr\">\n                                    <value name=\"IF0\">\n                                      <block type=\"logic_compare\" id=\"2@|s6E/qh$BT{n=7;S.+\">\n                                        <field name=\"OP\">EQ</field>\n                                        <value name=\"A\">\n                                          <block type=\"custom-property-value-getter\" id=\"PKX4)nC+*ZD}jmdwF4+Y\">\n                                            <field name=\"CONTROL_NAME\"></field>\n                                          </block>\n                                        </value>\n                                        <value name=\"B\">\n                                          <block type=\"get-custom-response\" id=\"[g@wc_9:~DhZCWliny]?\">\n                                            <mutation value=\"Please select\" keyValue=\"null\" collectionValue=\"null\" mapValue=\"null\" projectNameValues=\"null\" appbuilderIDValues=\"null\" destinationFieldVlaues=\"null\" newValue=\"null\" newNameValue=\"null\" nameValue=\"null\">\n                                              <option display-value=\"Please select\" neutral-value=\"Please select\"></option>\n                                            </mutation>\n                                            <field name=\"FIELD_NAME\">Please select</field>\n                                            <value name=\"RESPONSE_DATA\">\n                                              <block type=\"lists_getIndex\" id=\")%#;c%R0-;LtHXNQFehB\">\n                                                <mutation statement=\"false\" at=\"true\"></mutation>\n                                                <field name=\"MODE\">GET</field>\n                                                <field name=\"WHERE\">FROM_START</field>\n                                                <value name=\"VALUE\">\n                                                  <block type=\"variables_get\" id=\"}wD*pK(=ETPN;0{o#2lA\">\n                                                    <field name=\"VAR\" id=\"D8vNC`PN/j^yTP/WPOxf\">repeatingTableData</field>\n                                                  </block>\n                                                </value>\n                                                <value name=\"AT\">\n                                                  <block type=\"variables_get\" id=\"[%Dc_`+TxUv|X19N/.Ao\">\n                                                    <field name=\"VAR\" id=\"^bm3HGDWO?V-+0CHz_rP\">RowIndex</field>\n                                                  </block>\n                                                </value>\n                                              </block>\n                                            </value>\n                                          </block>\n                                        </value>\n                                      </block>\n                                    </value>\n                                    <statement name=\"DO0\">\n                                      <block type=\"custom-property-value-setter\" id=\"g{Dd356JIk/ps8;(*x^X\">\n                                        <field name=\"CONTROL_NAME\"></field>\n                                        <value name=\"PROPERTY_VALUE_INPUT\">\n                                          <shadow xmlns=\"http://www.w3.org/1999/xhtml\" type=\"text\" id=\"`Fa75p+o.tcMZ]h5sduk\">\n                                            <field name=\"TEXT\"></field>\n                                          </shadow>\n                                          <block type=\"get-custom-response\" id=\"Csh0pI9D}q;yN4#%s*Jo\">\n                                            <mutation value=\"Please select\" keyValue=\"null\" collectionValue=\"null\" mapValue=\"null\" projectNameValues=\"null\" appbuilderIDValues=\"null\" destinationFieldVlaues=\"null\" newValue=\"null\" newNameValue=\"null\" nameValue=\"null\">\n                                              <option display-value=\"Please select\" neutral-value=\"Please select\"></option>\n                                            </mutation>\n                                            <field name=\"FIELD_NAME\">Please select</field>\n                                            <value name=\"RESPONSE_DATA\">\n                                              <block type=\"lists_getIndex\" id=\")~0*Samq#GBq[c%9DtjK\">\n                                                <mutation statement=\"false\" at=\"true\"></mutation>\n                                                <field name=\"MODE\">GET</field>\n                                                <field name=\"WHERE\">FROM_START</field>\n                                                <value name=\"VALUE\">\n                                                  <block type=\"variables_get\" id=\"MCn:[k)#^{[`H5*N^]7`\">\n                                                    <field name=\"VAR\" id=\"D8vNC`PN/j^yTP/WPOxf\">repeatingTableData</field>\n                                                  </block>\n                                                </value>\n                                                <value name=\"AT\">\n                                                  <block type=\"variables_get\" id=\"/Hp4/nTy##WHrmcV]j-c\">\n                                                    <field name=\"VAR\" id=\"^bm3HGDWO?V-+0CHz_rP\">RowIndex</field>\n                                                  </block>\n                                                </value>\n                                              </block>\n                                            </value>\n                                          </block>\n                                        </value>\n                                      </block>\n                                    </statement>\n                                    <next>\n                                      <block type=\"variables_set\" id=\"n4TF/vt7}mv!d6PEa.hc\">\n                                        <field name=\"VAR\" id=\"^bm3HGDWO?V-+0CHz_rP\">RowIndex</field>\n                                        <value name=\"VALUE\">\n                                          <block type=\"math_arithmetic\" id=\"Ph+U*zjJPhKWvME-1Fbe\">\n                                            <field name=\"OP\">ADD</field>\n                                            <value name=\"A\">\n                                              <shadow xmlns=\"http://www.w3.org/1999/xhtml\" type=\"math_number\" id=\"TSakxjN8(jV[0k*W6c9J\">\n                                                <field name=\"NUM\">1</field>\n                                              </shadow>\n                                              <block type=\"variables_get\" id=\"z/1@m3fE8`uecDtJbGfW\">\n                                                <field name=\"VAR\" id=\"^bm3HGDWO?V-+0CHz_rP\">RowIndex</field>\n                                              </block>\n                                            </value>\n                                            <value name=\"B\">\n                                              <shadow type=\"math_number\" id=\"X[Cx@YEx`/8w^0gxiV}y\">\n                                                <field name=\"NUM\">1</field>\n                                              </shadow>\n                                            </value>\n                                          </block>\n                                        </value>\n                                      </block>\n                                    </next>\n                                  </block>\n                                </statement>\n                              </block>\n                            </next>\n                          </block>\n                        </next>\n                      </block>\n                    </next>\n                  </block>\n                </next>\n              </block>\n            </next>\n          </block>\n        </statement>\n      </block>\n    </category>\n    <sep></sep>\n</xml>\n<div id=\"codeEditorWindow\" style=\"height: 500px;\"></div>"

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.30.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i,
	            arrLen = arr.length;
	        for (i = 0; i < arrLen; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        var flags = null,
	            parsedParts = false,
	            isNowValid = m._d && !isNaN(m._d.getTime());
	        if (isNowValid) {
	            flags = getParsingFlags(m);
	            parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            isNowValid =
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidEra &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	        }
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        } else {
	            return isNowValid;
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i,
	            prop,
	            val,
	            momentPropertiesLen = momentProperties.length;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentPropertiesLen > 0) {
	            for (i = 0; i < momentPropertiesLen; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key,
	                    argLen = arguments.length;
	                for (i = 0; i < argLen; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens =
	            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {
	        D: 'date',
	        dates: 'date',
	        date: 'date',
	        d: 'day',
	        days: 'day',
	        day: 'day',
	        e: 'weekday',
	        weekdays: 'weekday',
	        weekday: 'weekday',
	        E: 'isoWeekday',
	        isoweekdays: 'isoWeekday',
	        isoweekday: 'isoWeekday',
	        DDD: 'dayOfYear',
	        dayofyears: 'dayOfYear',
	        dayofyear: 'dayOfYear',
	        h: 'hour',
	        hours: 'hour',
	        hour: 'hour',
	        ms: 'millisecond',
	        milliseconds: 'millisecond',
	        millisecond: 'millisecond',
	        m: 'minute',
	        minutes: 'minute',
	        minute: 'minute',
	        M: 'month',
	        months: 'month',
	        month: 'month',
	        Q: 'quarter',
	        quarters: 'quarter',
	        quarter: 'quarter',
	        s: 'second',
	        seconds: 'second',
	        second: 'second',
	        gg: 'weekYear',
	        weekyears: 'weekYear',
	        weekyear: 'weekYear',
	        GG: 'isoWeekYear',
	        isoweekyears: 'isoWeekYear',
	        isoweekyear: 'isoWeekYear',
	        w: 'week',
	        weeks: 'week',
	        week: 'week',
	        W: 'isoWeek',
	        isoweeks: 'isoWeek',
	        isoweek: 'isoWeek',
	        y: 'year',
	        years: 'year',
	        year: 'year',
	    };
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {
	        date: 9,
	        day: 11,
	        weekday: 11,
	        isoWeekday: 11,
	        dayOfYear: 4,
	        hour: 13,
	        millisecond: 16,
	        minute: 14,
	        month: 8,
	        quarter: 7,
	        second: 15,
	        weekYear: 1,
	        isoWeekYear: 1,
	        week: 5,
	        isoWeek: 5,
	        year: 1,
	    };
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord =
	            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
	        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(
	                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                    function (matched, p1, p2, p3, p4) {
	                        return p1 || p2 || p3 || p4;
	                    }
	                )
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback,
	            tokenLen;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        tokenLen = token.length;
	        for (i = 0; i < tokenLen; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        if (!mom.isValid()) {
	            return NaN;
	        }
	
	        var d = mom._d,
	            isUTC = mom._isUTC;
	
	        switch (unit) {
	            case 'Milliseconds':
	                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
	            case 'Seconds':
	                return isUTC ? d.getUTCSeconds() : d.getSeconds();
	            case 'Minutes':
	                return isUTC ? d.getUTCMinutes() : d.getMinutes();
	            case 'Hours':
	                return isUTC ? d.getUTCHours() : d.getHours();
	            case 'Date':
	                return isUTC ? d.getUTCDate() : d.getDate();
	            case 'Day':
	                return isUTC ? d.getUTCDay() : d.getDay();
	            case 'Month':
	                return isUTC ? d.getUTCMonth() : d.getMonth();
	            case 'FullYear':
	                return isUTC ? d.getUTCFullYear() : d.getFullYear();
	            default:
	                return NaN; // Just in case
	        }
	    }
	
	    function set$1(mom, unit, value) {
	        var d, isUTC, year, month, date;
	
	        if (!mom.isValid() || isNaN(value)) {
	            return;
	        }
	
	        d = mom._d;
	        isUTC = mom._isUTC;
	
	        switch (unit) {
	            case 'Milliseconds':
	                return void (isUTC
	                    ? d.setUTCMilliseconds(value)
	                    : d.setMilliseconds(value));
	            case 'Seconds':
	                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
	            case 'Minutes':
	                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
	            case 'Hours':
	                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
	            case 'Date':
	                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
	            // case 'Day': // Not real
	            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
	            // case 'Month': // Not used because we need to pass two variables
	            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
	            case 'FullYear':
	                break; // See below ...
	            default:
	                return; // Just in case
	        }
	
	        year = value;
	        month = mom.month();
	        date = mom.date();
	        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
	        void (isUTC
	            ? d.setUTCFullYear(year, month, date)
	            : d.setFullYear(year, month, date));
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i,
	                prioritizedLen = prioritized.length;
	            for (i = 0; i < prioritizedLen; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // PARSING
	
	    addRegexToken('M', match1to2, match1to2NoLeadingZero);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths =
	            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                '_'
	            ),
	        defaultLocaleMonthsShort =
	            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        var month = value,
	            date = mom.date();
	
	        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
	        void (mom._isUTC
	            ? mom._d.setUTCMonth(month, date)
	            : mom._d.setMonth(month, date));
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            shortP,
	            longP;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortP = regexEscape(this.monthsShort(mom, ''));
	            longP = regexEscape(this.months(mom, ''));
	            shortPieces.push(shortP);
	            longPieces.push(longP);
	            mixedPieces.push(longP);
	            mixedPieces.push(shortP);
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // PARSING
	
	    addRegexToken('w', match1to2, match1to2NoLeadingZero);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2, match1to2NoLeadingZero);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(
	        ['w', 'ww', 'W', 'WW'],
	        function (input, week, config, token) {
	            week[token.substr(0, 1)] = toInt(input);
	        }
	    );
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays =
	            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	              ? weekdays[m.day()]
	              : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	              ? this._weekdaysShort[m.day()]
	              : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	              ? this._weekdaysMin[m.day()]
	              : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        var day = get(this, 'Day');
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2, match1to2HasZero);
	    addRegexToken('h', match1to2, match1to2NoLeadingZero);
	    addRegexToken('k', match1to2, match1to2NoLeadingZero);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function isLocaleNameSane(name) {
	        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	        // Ensure name is available and function returns boolean
	        return !!(name && name.match('^[^/\\\\]*$'));
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports &&
	            isLocaleNameSane(name)
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(116)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                      ? DATE
	                      : a[HOUR] < 0 ||
	                          a[HOUR] > 24 ||
	                          (a[HOUR] === 24 &&
	                              (a[MINUTE] !== 0 ||
	                                  a[SECOND] !== 0 ||
	                                  a[MILLISECOND] !== 0))
	                        ? HOUR
	                        : a[MINUTE] < 0 || a[MINUTE] > 59
	                          ? MINUTE
	                          : a[SECOND] < 0 || a[SECOND] > 59
	                            ? SECOND
	                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                              ? MILLISECOND
	                              : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 =
	            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat,
	            isoDatesLen = isoDates.length,
	            isoTimesLen = isoTimes.length;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDatesLen; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimesLen; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^()]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era,
	            tokenLen;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	        tokenLen = tokens.length;
	        for (i = 0; i < tokenLen; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false,
	            configfLen = config._f.length;
	
	        if (configfLen === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < configfLen; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i,
	            orderLen = ordering.length;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < orderLen; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex =
	            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property,
	            propertyLen = properties.length;
	
	        for (i = 0; i < propertyLen; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	              ? 'lastWeek'
	              : diff < 0
	                ? 'lastDay'
	                : diff < 1
	                  ? 'sameDay'
	                  : diff < 2
	                    ? 'nextDay'
	                    : diff < 7
	                      ? 'nextWeek'
	                      : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(
	        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	        function (input, array, config, token) {
	            var era = config._locale.erasParse(input, token, config._strict);
	            if (era) {
	                getParsingFlags(config).era = era;
	            } else {
	                getParsingFlags(config).invalidEra = input;
	            }
	        }
	    );
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            erasName,
	            erasAbbr,
	            erasNarrow,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            erasName = regexEscape(eras[i].name);
	            erasAbbr = regexEscape(eras[i].abbr);
	            erasNarrow = regexEscape(eras[i].narrow);
	
	            namePieces.push(erasName);
	            abbrPieces.push(erasAbbr);
	            narrowPieces.push(erasNarrow);
	            mixedPieces.push(erasName);
	            mixedPieces.push(erasAbbr);
	            mixedPieces.push(erasNarrow);
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(
	        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	        function (input, week, config, token) {
	            week[token.substr(0, 2)] = toInt(input);
	        }
	    );
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday() + this.localeData()._week.dow,
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // PARSING
	
	    addRegexToken('D', match1to2, match1to2NoLeadingZero);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // PARSING
	
	    addRegexToken('m', match1to2, match1to2HasZero);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // PARSING
	
	    addRegexToken('s', match1to2, match1to2HasZero);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y'),
	        valueOf$1 = asMilliseconds;
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.30.1';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)(module)))

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 117,
		"./af.js": 117,
		"./ar": 118,
		"./ar-dz": 119,
		"./ar-dz.js": 119,
		"./ar-kw": 120,
		"./ar-kw.js": 120,
		"./ar-ly": 121,
		"./ar-ly.js": 121,
		"./ar-ma": 122,
		"./ar-ma.js": 122,
		"./ar-ps": 123,
		"./ar-ps.js": 123,
		"./ar-sa": 124,
		"./ar-sa.js": 124,
		"./ar-tn": 125,
		"./ar-tn.js": 125,
		"./ar.js": 118,
		"./az": 126,
		"./az.js": 126,
		"./be": 127,
		"./be.js": 127,
		"./bg": 128,
		"./bg.js": 128,
		"./bm": 129,
		"./bm.js": 129,
		"./bn": 130,
		"./bn-bd": 131,
		"./bn-bd.js": 131,
		"./bn.js": 130,
		"./bo": 132,
		"./bo.js": 132,
		"./br": 133,
		"./br.js": 133,
		"./bs": 134,
		"./bs.js": 134,
		"./ca": 135,
		"./ca.js": 135,
		"./cs": 136,
		"./cs.js": 136,
		"./cv": 137,
		"./cv.js": 137,
		"./cy": 138,
		"./cy.js": 138,
		"./da": 139,
		"./da.js": 139,
		"./de": 140,
		"./de-at": 141,
		"./de-at.js": 141,
		"./de-ch": 142,
		"./de-ch.js": 142,
		"./de.js": 140,
		"./dv": 143,
		"./dv.js": 143,
		"./el": 144,
		"./el.js": 144,
		"./en-au": 145,
		"./en-au.js": 145,
		"./en-ca": 146,
		"./en-ca.js": 146,
		"./en-gb": 147,
		"./en-gb.js": 147,
		"./en-ie": 148,
		"./en-ie.js": 148,
		"./en-il": 149,
		"./en-il.js": 149,
		"./en-in": 150,
		"./en-in.js": 150,
		"./en-nz": 151,
		"./en-nz.js": 151,
		"./en-sg": 152,
		"./en-sg.js": 152,
		"./eo": 153,
		"./eo.js": 153,
		"./es": 154,
		"./es-do": 155,
		"./es-do.js": 155,
		"./es-mx": 156,
		"./es-mx.js": 156,
		"./es-us": 157,
		"./es-us.js": 157,
		"./es.js": 154,
		"./et": 158,
		"./et.js": 158,
		"./eu": 159,
		"./eu.js": 159,
		"./fa": 160,
		"./fa.js": 160,
		"./fi": 161,
		"./fi.js": 161,
		"./fil": 162,
		"./fil.js": 162,
		"./fo": 163,
		"./fo.js": 163,
		"./fr": 164,
		"./fr-ca": 165,
		"./fr-ca.js": 165,
		"./fr-ch": 166,
		"./fr-ch.js": 166,
		"./fr.js": 164,
		"./fy": 167,
		"./fy.js": 167,
		"./ga": 168,
		"./ga.js": 168,
		"./gd": 169,
		"./gd.js": 169,
		"./gl": 170,
		"./gl.js": 170,
		"./gom-deva": 171,
		"./gom-deva.js": 171,
		"./gom-latn": 172,
		"./gom-latn.js": 172,
		"./gu": 173,
		"./gu.js": 173,
		"./he": 174,
		"./he.js": 174,
		"./hi": 175,
		"./hi.js": 175,
		"./hr": 176,
		"./hr.js": 176,
		"./hu": 177,
		"./hu.js": 177,
		"./hy-am": 178,
		"./hy-am.js": 178,
		"./id": 179,
		"./id.js": 179,
		"./is": 180,
		"./is.js": 180,
		"./it": 181,
		"./it-ch": 182,
		"./it-ch.js": 182,
		"./it.js": 181,
		"./ja": 183,
		"./ja.js": 183,
		"./jv": 184,
		"./jv.js": 184,
		"./ka": 185,
		"./ka.js": 185,
		"./kk": 186,
		"./kk.js": 186,
		"./km": 187,
		"./km.js": 187,
		"./kn": 188,
		"./kn.js": 188,
		"./ko": 189,
		"./ko.js": 189,
		"./ku": 190,
		"./ku-kmr": 191,
		"./ku-kmr.js": 191,
		"./ku.js": 190,
		"./ky": 192,
		"./ky.js": 192,
		"./lb": 193,
		"./lb.js": 193,
		"./lo": 194,
		"./lo.js": 194,
		"./lt": 195,
		"./lt.js": 195,
		"./lv": 196,
		"./lv.js": 196,
		"./me": 197,
		"./me.js": 197,
		"./mi": 198,
		"./mi.js": 198,
		"./mk": 199,
		"./mk.js": 199,
		"./ml": 200,
		"./ml.js": 200,
		"./mn": 201,
		"./mn.js": 201,
		"./mr": 202,
		"./mr.js": 202,
		"./ms": 203,
		"./ms-my": 204,
		"./ms-my.js": 204,
		"./ms.js": 203,
		"./mt": 205,
		"./mt.js": 205,
		"./my": 206,
		"./my.js": 206,
		"./nb": 207,
		"./nb.js": 207,
		"./ne": 208,
		"./ne.js": 208,
		"./nl": 209,
		"./nl-be": 210,
		"./nl-be.js": 210,
		"./nl.js": 209,
		"./nn": 211,
		"./nn.js": 211,
		"./oc-lnc": 212,
		"./oc-lnc.js": 212,
		"./pa-in": 213,
		"./pa-in.js": 213,
		"./pl": 214,
		"./pl.js": 214,
		"./pt": 215,
		"./pt-br": 216,
		"./pt-br.js": 216,
		"./pt.js": 215,
		"./ro": 217,
		"./ro.js": 217,
		"./ru": 218,
		"./ru.js": 218,
		"./sd": 219,
		"./sd.js": 219,
		"./se": 220,
		"./se.js": 220,
		"./si": 221,
		"./si.js": 221,
		"./sk": 222,
		"./sk.js": 222,
		"./sl": 223,
		"./sl.js": 223,
		"./sq": 224,
		"./sq.js": 224,
		"./sr": 225,
		"./sr-cyrl": 226,
		"./sr-cyrl.js": 226,
		"./sr.js": 225,
		"./ss": 227,
		"./ss.js": 227,
		"./sv": 228,
		"./sv.js": 228,
		"./sw": 229,
		"./sw.js": 229,
		"./ta": 230,
		"./ta.js": 230,
		"./te": 231,
		"./te.js": 231,
		"./tet": 232,
		"./tet.js": 232,
		"./tg": 233,
		"./tg.js": 233,
		"./th": 234,
		"./th.js": 234,
		"./tk": 235,
		"./tk.js": 235,
		"./tl-ph": 236,
		"./tl-ph.js": 236,
		"./tlh": 237,
		"./tlh.js": 237,
		"./tr": 238,
		"./tr.js": 238,
		"./tzl": 239,
		"./tzl.js": 239,
		"./tzm": 240,
		"./tzm-latn": 241,
		"./tzm-latn.js": 241,
		"./tzm.js": 240,
		"./ug-cn": 242,
		"./ug-cn.js": 242,
		"./uk": 243,
		"./uk.js": 243,
		"./ur": 244,
		"./ur.js": 244,
		"./uz": 245,
		"./uz-latn": 246,
		"./uz-latn.js": 246,
		"./uz.js": 245,
		"./vi": 247,
		"./vi.js": 247,
		"./x-pseudo": 248,
		"./x-pseudo.js": 248,
		"./yo": 249,
		"./yo.js": 249,
		"./zh-cn": 250,
		"./zh-cn.js": 250,
		"./zh-hk": 251,
		"./zh-hk.js": 251,
		"./zh-mo": 252,
		"./zh-mo.js": 252,
		"./zh-tw": 253,
		"./zh-tw.js": 253
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 116;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                  ? 1
	                  : n === 2
	                    ? 2
	                    : n % 100 >= 3 && n % 100 <= 10
	                      ? 3
	                      : n % 100 >= 11
	                        ? 4
	                        : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                  ? 1
	                  : n === 2
	                    ? 2
	                    : n % 100 >= 3 && n % 100 <= 10
	                      ? 3
	                      : n % 100 >= 11
	                        ? 4
	                        : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Libya) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                  ? 1
	                  : n === 2
	                    ? 2
	                    : n % 100 >= 3 && n % 100 <= 10
	                      ? 3
	                      : n % 100 >= 11
	                        ? 4
	                        : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Palestine) [ar-ps]
	//! author : Majd Al-Shihabi : https://github.com/majdal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arPs = moment.defineLocale('ar-ps', {
	        months: 'كانون الثاني_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_تشري الأوّل_تشرين الثاني_كانون الأوّل'.split(
	            '_'
	        ),
	        monthsShort:
	            'ك٢_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_ت١_ت٢_ك١'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .split('') // reversed since negative lookbehind not supported everywhere
	                .reverse()
	                .join('')
	                .replace(/[١٢](?![\u062a\u0643])/g, function (match) {
	                    return numberMap[match];
	                })
	                .split('')
	                .reverse()
	                .join('')
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arPs;
	
	})));


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays:
	            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	                '_'
	            ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	              ? forms[1]
	              : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone:
	                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone:
	                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                    '_'
	                ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	                '_'
	            ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays:
	            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	                '_'
	            ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex =
	            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! author : Rasid Redzic : https://github.com/rasidre
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 'm':
	                return withoutSuffix
	                    ? 'jedna minuta'
	                    : isFuture
	                      ? 'jednu minutu'
	                      : 'jedne minute';
	        }
	    }
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jedan sat';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: processRelativeTime,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone:
	                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                    '_'
	                ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	                '_'
	            ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                      ? 'n'
	                      : number === 3
	                        ? 'r'
	                        : number === 4
	                          ? 't'
	                          : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = {
	            standalone:
	                'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	                    '_'
	                ),
	            format: 'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
	                '_'
	            ),
	            isFormat: /DD?[o.]?(\[[^\[\]]*\]|\s)+MMMM/,
	        },
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex =
	            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex:
	            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex:
	            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays:
	            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	                '_'
	            ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                      ? 'тан'
	                      : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays:
	            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl:
	            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	                '_'
	            ),
	        monthsGenitiveEl:
	            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	                '_'
	            ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays:
	            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	                '_'
	            ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort:
	            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	                '_'
	            ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	                '_'
	            ),
	        weekdays:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast =
	            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	                ' '
	            ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort:
	            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	                '_'
	            ),
	        weekdays:
	            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	                '_'
	            ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex =
	            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort:
	            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone:
	                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                    '_'
	                ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone:
	                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                    '_'
	                ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort:
	            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort:
	            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse:
	            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        },
	        monthsParse = [
	            /^जन/i,
	            /^फ़र|फर/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सितं|सित/i,
	            /^अक्टू/i,
	            /^नव|नवं/i,
	            /^दिसं|दिस/i,
	        ],
	        shortMonthsParse = [
	            /^जन/i,
	            /^फ़र/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सित/i,
	            /^अक्टू/i,
	            /^नव/i,
	            /^दिस/i,
	        ];
	
	    var hi = moment.defineLocale('hi', {
	        months: {
	            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	                '_'
	            ),
	            standalone:
	                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: shortMonthsParse,
	
	        monthsRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsShortRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsStrictRegex:
	            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
	
	        monthsShortStrictRegex:
	            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
	
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone:
	                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings =
	        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone:
	                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays:
	            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	                '_'
	            ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                  ? ' '
	                                  : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                  ? ' '
	                                  : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone:
	                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                    '_'
	                ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(
	                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
	                    function ($0, $1, $2) {
	                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                    }
	                );
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort:
	            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	                '_'
	            ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort:
	            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays:
	            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Kurdish [ku-kmr]
	//! authors : Mazlum Özdogan : https://github.com/mergehez
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(num, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['çend sanîye', 'çend sanîyeyan'],
	            ss: [num + ' sanîye', num + ' sanîyeyan'],
	            m: ['deqîqeyek', 'deqîqeyekê'],
	            mm: [num + ' deqîqe', num + ' deqîqeyan'],
	            h: ['saetek', 'saetekê'],
	            hh: [num + ' saet', num + ' saetan'],
	            d: ['rojek', 'rojekê'],
	            dd: [num + ' roj', num + ' rojan'],
	            w: ['hefteyek', 'hefteyekê'],
	            ww: [num + ' hefte', num + ' hefteyan'],
	            M: ['mehek', 'mehekê'],
	            MM: [num + ' meh', num + ' mehan'],
	            y: ['salek', 'salekê'],
	            yy: [num + ' sal', num + ' salan'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    // function obliqueNumSuffix(num) {
	    //     if(num.includes(':'))
	    //         num = parseInt(num.split(':')[0]);
	    //     else
	    //         num = parseInt(num);
	    //     return num == 0 || num % 10 == 1 ? 'ê'
	    //                         : (num > 10 && num % 10 == 0 ? 'î' : 'an');
	    // }
	    function ezafeNumSuffix(num) {
	        num = '' + num;
	        var l = num.substring(num.length - 1),
	            ll = num.length > 1 ? num.substring(num.length - 2) : '';
	        if (
	            !(ll == 12 || ll == 13) &&
	            (l == '2' || l == '3' || ll == '50' || l == '70' || l == '80')
	        )
	            return 'yê';
	        return 'ê';
	    }
	
	    var kuKmr = moment.defineLocale('ku-kmr', {
	        // According to the spelling rules defined by the work group of Weqfa Mezopotamyayê (Mesopotamia Foundation)
	        // this should be: 'Kanûna Paşîn_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Çirîya Pêşîn_Çirîya Paşîn_Kanûna Pêşîn'
	        // But the names below are more well known and handy
	        months: 'Rêbendan_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Cotmeh_Mijdar_Berfanbar'.split(
	            '_'
	        ),
	        monthsShort: 'Rêb_Sib_Ada_Nîs_Gul_Hez_Tîr_Teb_Îlo_Cot_Mij_Ber'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'Yekşem_Duşem_Sêşem_Çarşem_Pêncşem_În_Şemî'.split('_'),
	        weekdaysShort: 'Yek_Du_Sê_Çar_Pên_În_Şem'.split('_'),
	        weekdaysMin: 'Ye_Du_Sê_Ça_Pê_În_Şe'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'bn' : 'BN';
	            } else {
	                return isLower ? 'pn' : 'PN';
	            }
	        },
	        meridiemParse: /bn|BN|pn|PN/,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[a] YYYY[an]',
	            LLL: 'Do MMMM[a] YYYY[an] HH:mm',
	            LLLL: 'dddd, Do MMMM[a] YYYY[an] HH:mm',
	            ll: 'Do MMM[.] YYYY[an]',
	            lll: 'Do MMM[.] YYYY[an] HH:mm',
	            llll: 'ddd[.], Do MMM[.] YYYY[an] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Îro di saet] LT [de]',
	            nextDay: '[Sibê di saet] LT [de]',
	            nextWeek: 'dddd [di saet] LT [de]',
	            lastDay: '[Duh di saet] LT [de]',
	            lastWeek: 'dddd[a borî di saet] LT [de]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'di %s de',
	            past: 'berî %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(?:yê|ê|\.)/,
	        ordinal: function (num, period) {
	            var p = period.toLowerCase();
	            if (p.includes('w') || p.includes('m')) return num + '.';
	
	            return num + ezafeNumSuffix(num);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return kuKmr;
	
	})));


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	                '_'
	            ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	              ? forms(key)[1]
	              : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone:
	                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                    '_'
	                ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone:
	                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                    '_'
	                ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays:
	            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                  ? wordKey[1]
	                  : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort:
	            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	                '_'
	            ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	                '_'
	            ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort:
	            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays:
	            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	                '_'
	            ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'én time',
	            hh: '%d timer',
	            d: 'én dag',
	            dd: '%d dager',
	            w: 'én uke',
	            ww: '%d uker',
	            M: 'én måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^(maart|mrt\.?)$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^(maart|mrt\.?)$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone:
	                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                    '_'
	                ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                      ? 'n'
	                      : number === 3
	                        ? 'r'
	                        : number === 4
	                          ? 't'
	                          : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	                '_'
	            ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative =
	            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	                '_'
	            ),
	        monthsSubjective =
	            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	                '_'
	            ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays:
	            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort:
	            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	              ? forms[1]
	              : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone:
	                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                    '_'
	                ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone:
	                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                    '_'
	                ),
	        },
	        weekdays: {
	            standalone:
	                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                    '_'
	                ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex:
	            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex:
	            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort:
	            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays:
	            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	                '_'
	            ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays:
	            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	                '_'
	            ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months =
	            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	                '_'
	            ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            d: ['jedan dan', 'jednog dana'],
	            dd: ['dan', 'dana', 'dana'],
	            M: ['jedan mesec', 'jednog meseca'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            y: ['jednu godinu', 'jedne godine'],
	            yy: ['godinu', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'jedna godina';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'godinu') {
	                return number + ' godina';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једног минута'],
	            mm: ['минут', 'минута', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            d: ['један дан', 'једног дана'],
	            dd: ['дан', 'дана', 'дана'],
	            M: ['један месец', 'једног месеца'],
	            MM: ['месец', 'месеца', 'месеци'],
	            y: ['једну годину', 'једне године'],
	            yy: ['годину', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'једна година';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'годину') {
	                return number + ' година';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort:
	            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays:
	            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	                '_'
	            ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                          ? ':a'
	                          : b === 2
	                            ? ':a'
	                            : b === 3
	                              ? ':e'
	                              : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays:
	            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	                '_'
	            ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort:
	            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	                '_'
	            ),
	        weekdays:
	            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	                '_'
	            ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort:
	            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	                '_'
	            ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone:
	                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort:
	            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                  ? time.slice(0, -3) + 'waQ'
	                  : output.indexOf('DIS') !== -1
	                    ? time.slice(0, -3) + 'nem'
	                    : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                  ? time.slice(0, -3) + 'wen'
	                  : output.indexOf('DIS') !== -1
	                    ? time.slice(0, -3) + 'ben'
	                    : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort:
	            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	              ? format[key][0]
	              : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	                '_'
	            ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort:
	            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	                '_'
	            ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	                '_'
	            ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	              ? forms[1]
	              : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative:
	                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                        '_'
	                    ),
	                accusative:
	                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                        '_'
	                    ),
	                genitive:
	                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                        '_'
	                    ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	              ? 'genitive'
	              : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone:
	                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays:
	            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	                '_'
	            ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort:
	            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort:
	            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	                '_'
	            ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 254 */
/***/ (function(module, exports) {

	module.exports = "<div ng-hide=\"!hideProperties\" class=\"show-properties-btn-wrapper\">\n\t<button type=\"button\" class=\"btn show-properties-btn\" ng-click=\"hideProperties = !hideProperties\">\n\t\t<span translate=\"properties\">PROPERTIES</span>\n\t\t<i class=\"fa fa-chevron-up\"></i>\n\t</button>\n</div>\n\n\n<div class=\"property-box\" ng-hide=\"hideProperties\">\n\t<div class=\"header-container\">\n\t\t<div class=\"header\">\n\t\t\t<span translate=\"properties\">PROPERTIES</span>&nbsp;(&nbsp;\n\t\t\t<span ng-bind=\"$ctrl.getSelectedItem().label | translate\"></span>&nbsp;)\n\t\t\t<i class=\"fa hide-properties-btn fa-chevron-right\" ng-click=\"hideProperties = !hideProperties\"></i>\n\t\t</div>\n\t\t<div id=\"switch\" ng-hide=\"$ctrl.isDivhide()\"\n\t\t\tng-init=\"style={'background-color' : 'cornflowerblue', 'color' : 'white'}\">\n\t\t\t<button id=\"basic\" type=\"button\" ng-style=\"$ctrl.basicSelected == false ? style : {} \"\n\t\t\t\tng-click=\"$ctrl.basicSelected=false\">{{'Basic' | translate}}</button>\n\t\t\t<button id=\"advanced\" type=\"button\" ng-style=\"$ctrl.basicSelected == true ? style : {}\"\n\t\t\t\tng-click=\"$ctrl.basicSelected=true\">{{'Advanced' | translate}}</button>\n\t\t</div>\n\t</div>\n\t<div class=\"scroller-outer\">\n\t\t<div class=\"scroller\">\n\t\t\t<div class=\"scroller-inner\">\n\t\t\t\t<div class=\"property-container\" ng-repeat=\"(key, values) in $ctrl.getSelectedItemProperties()\"\n\t\t\t\t\tng-if=\"!values.Name.hideSection && $ctrl.getSelectedButtonProperties(values)\">\n\t\t\t\t\t<div class=\"property-row\">\n\t\t\t\t\t\t<div class=\"property-header\">\n\t\t\t\t\t\t\t{{values.Name.selectedValue || key | translate}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"property-content\">\n\t\t\t\t\t\t\t<div class=\"property-body\">\n\t\t\t\t\t\t\t\t<table class=\"property-table\">\n\t\t\t\t\t\t\t\t\t<tr ng-repeat=\"value in values\" ng-if=\"!value.hidden && value.type\">\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type != 'table' && value.type != 'style-group' && value.type != 'button' && value.type != 'button-group' && value.name != 'hour_12_format' && value.name != 'caption.position' && value.name != 'caption' && value.name != 'thumbnail.size' && value.name != 'embeddedAttachment' && value.name != 'fit.to.screen' && value.name != 'working-days'\" \n\t\t\t\t\t\t\t\t\t\t\ttranslate=\"{{value.name}}\" class=\"{{value.extraClass}}\" ng-class=\"{overflowLabel : value.name == 'closed.date'}\" title=\"{{ value.name != 'closed.date' ? '' : value.name | translate}}\">\n\t\t\t\t\t\t\t\t\t\t\t{{value.name}}</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.name == 'fit.to.screen'\" class=\"{{value.extraClass}}\">\n\t\t\t\t\t\t\t\t\t\t\t{{value.name | translate}}\n\t\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default btn-xs addOnButton\"\n\t\t\t\t\t\t\t\t\t\t\t\t uib-popover-html=\"htmlPopoverForFitScreen\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tpopover-trigger=\"'mouseenter'\" popover-placement=\"bottom-left\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tpopover-class=\"popover-fit-screen\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"{{value.icon}}\"></i>\n\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.name == 'working-days'\" class=\"{{value.extraClass}}\">\n\t\t\t\t\t\t\t\t\t\t\t{{value.name | translate}}\n\t\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default btn-xs addOnButton\"\n\t\t\t\t\t\t\t\t\t\t\t uib-popover-html=\"htmlPopoverForWorkingDays\"\n\t\t\t\t\t\t\t\t\t\t\t\tpopover-trigger=\"'mouseenter'\" popover-placement=\"bottom-left\"\n\t\t\t\t\t\t\t\t\t\t\t\tpopover-class=\"popover-fit-screen\">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"{{value.icon}}\"></i>\n\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'textbox' && value.name !='field.name' && value.name != 'Data-Field-Name' && value.name != 'displayLabel' && value.name != 'linkAddress'\" \n\t\t\t\t\t\t\t\t\t\t\tng-class=\"{'add-on-button-wrapper': value.addOnButton}\">\n\t\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default btn-xs addOnButton\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-if=\"value.addOnButton\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-click=\"$ctrl[value.onClickFunction || noop](values,value)\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class={{value.addOnButton}}></i>\n\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t<input type=\"{{value.type}}\" id=\"{{value.name}}\" name=\"{{value.name}}\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-model=\"value.selectedValue\"\n\t\t\t\t\t\t\t\t\t\t\t\tcontenteditable\n\t\t\t\t\t\t\t\t\t\t\t\tng-class=\"{'required': !value.selectedValue && (value.name == 'value.on' || value.name == 'value.off')}\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-change=\"$ctrl[value.onChangeFunction || noop](values,value.name); $ctrl.onPropValueChanged();\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\" ng-readonly=\"value.readonly\">\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'textbox' && (value.name == 'displayLabel' || value.name == 'linkAddress')\"\n\t\t\t\t\t\t\t\t\t\t\tng-class=\"{'add-on-button-wrapper': value.addOnButton}\">\n\t\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default btn-xs addOnButton\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-if=\"value.addOnButton\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-click=\"$ctrl[value.onClickFunction || noop](values,value)\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class={{value.addOnButton}}></i>\n\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t<input type=\"{{value.type}}\" id=\"{{value.name}}\" name=\"{{value.name}}\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-model=\"value.selectedValue\"\n\t\t\t\t\t\t\t\t\t\t\t\tcontenteditable\n\t\t\t\t\t\t\t\t\t\t\t\tng-change=\"$ctrl[value.onChangeFunction || noop](value.selectedValue,value.name); $ctrl.onPropValueChanged();\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-class=\"{'required': !value.selectedValue}\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\" ng-readonly=\"value.readonly\"\n\t\t\t\t\t\t\t\t\t\t\t\tplaceholder=\"{{value.placeholder}}\">\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'div'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"formulaDiv\">{{value.selectedValue}}</div>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'textbox' && value.name == 'field.name'\"\n\t\t\t\t\t\t\t\t\t\t\tng-class=\"{'add-on-button-wrapper': value.addOnButton}\">\n\t\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default btn-xs addOnButton\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-if=\"value.addOnButton\" uib-popover-html=\"htmlPopover\"\n\t\t\t\t\t\t\t\t\t\t\t\tpopover-trigger=\"'mouseenter'\" popover-placement=\"bottom-right\"\n\t\t\t\t\t\t\t\t\t\t\t\tpopover-class=\"ristrict-msg\" ng-disabled=\"value.disable || values.forceToDisabled\">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class={{value.addOnButton}}></i>\n\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t<input type=\"{{value.type}}\" id=\"{{value.name}}\" name=\"{{value.name}}\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-model=\"value.selectedValue\"\n\t\t\t\t\t\t\t\t\t\t\t\tcontenteditable\n\t\t\t\t\t\t\t\t\t\t\t\tng-blur=\"$ctrl[value.onChangeFunction || noop](value.selectedValue, value.prevSelectedValue);$ctrl.onPropValueChanged();\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-class=\"{'required': !value.selectedValue}\" \n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\" \n\t\t\t\t\t\t\t\t\t\t\t\tng-change=\"$ctrl.updateFieldName(value.selectedValue,'{{value.selectedValue}}',$ctrl.getSelectedItem().uid)\">\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'textbox' && value.name == 'Data-Field-Name'\"\n\t\t\t\t\t\t\t\t\t\t\tng-class=\"{'add-on-button-wrapper': value.addOnButton}\">\n\t\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default btn-xs addOnButton\" ng-if=\"value.addOnButton\"\n\t\t\t\t\t\t\t\t\t\t\t\tuib-popover-html=\"htmlPopoverForDataFieldName\" popover-trigger=\"'mouseenter'\" popover-placement=\"bottom-right\"\n\t\t\t\t\t\t\t\t\t\t\t\tpopover-class=\"ristrict-msg\" ng-disabled=\"value.disable || values.forceToDisabled\">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class={{value.addOnButton}}></i>\n\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t<input type=\"{{value.type}}\" id=\"{{value.name}}\" name=\"{{value.name}}\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-model=\"value.selectedValue\"\n\t\t\t\t\t\t\t\t\t\t\t\tcontenteditable\n\t\t\t\t\t\t\t\t\t\t\t\tng-blur=\"$ctrl[value.onChangeFunction || noop](value.selectedValue, value.prevSelectedValue); $ctrl.onPropValueChanged();\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-class=\"{'required': !value.selectedValue}\" ng-disabled=\"value.disable || values.forceToDisabled\" >\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'checkbox' && !(value.name == 'time' || value.name == 'generate-thumbnail'|| value.name == 'caption' || value.name == 'show.mic' || value.name == 'embeddedAttachment')\">\n\t\t\t\t\t\t\t\t\t\t\t<input type=\"{{value.type}}\" id=\"{{value.name}}\" name=\"{{value.name}}\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-model=\"value.selectedValue\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-change=\"$ctrl[value.onChangeFunction || noop](values, value);$ctrl.onPropValueChanged(); $ctrl.getSelectedItemProperties().Basic.Default.dateType = $ctrl.getSelectedItemProperties().Advance['Closed Date'].selectedValue ? '2': $ctrl.getSelectedItemProperties().Basic.Default.dateType;\n\t\t\t\t\t\t\t\t\t\t\t\t$ctrl.getSelectedItemProperties().Advance['Closed Date'].selectedValue ? $ctrl.getSelectedItemProperties().Basic['Working Days'].hidden = false : properties['Working Days'].hidden = true;\n\t\t\t\t\t\t\t\t\t\t\t\tvalue.name == 'closed.date' && value.selectedValue == false ? $ctrl.getSelectedItemProperties().Basic['Working Days'].selectedValue = false : properties.Basic['Working Days'].selectedValue;\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\">\n\t\t\t\t\t\t\t\t\t\t\t<i ng-if=\"value.addOnButton\" \n\t\t\t\t\t\t\t\t\t\t\t\tclass={{value.addOnButton}} \n\t\t\t\t\t\t\t\t\t\t\t\tng-class=\"{disabled : value.disable}\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-click=\"$ctrl[value.onClickFunction || noop](values, value)\"></i>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'checkbox' && (value.name == 'time' || value.name == 'generate-thumbnail' || value.name == 'show.mic')\">\n\t\t\t\t\t\t\t\t\t\t\t<input type=\"{{value.type}}\" id=\"{{value.name}}\" name=\"{{value.name}}\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-model=\"value.selectedValue\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-change=\"$ctrl[value.onChangeFunction || noop](value.selectedValue, values);$ctrl.onPropValueChanged();\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\">\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"(value.name == 'caption.position' || value.name == 'caption') && values['Generate Thumbnail'].selectedValue == true\" translate=\"{{value.name}}\">{{value.name}}</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.name == 'embeddedAttachment'\">\n\t\t\t\t\t\t\t\t\t\t\t{{value.name | translate}}\n\t\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default btn-xs addOnButton\"\n\t\t\t\t\t\t\t\t\t\t\t uib-popover-html=\"htmlPopoverForEmbeddedAttachment\"\n\t\t\t\t\t\t\t\t\t\t\t\tpopover-trigger=\"'mouseenter'\" popover-placement=\"bottom-left\"\n\t\t\t\t\t\t\t\t\t\t\t\tpopover-class=\"popover-fit-screen\">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"{{value.icon}}\"></i>\n\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'checkbox' && (value.name == 'embeddedAttachment')\">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type=\"checkbox\"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-model=\"value.selectedValue\"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-disabled=\"value.disable || values.forceToDisabled\"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-change= \"$ctrl[value.onChangeFunction || noop](value,event)\" \n\t\t\t\t\t\t\t\t\t\t\t\t ng-focus=\"event=$event\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-disable=\"value.disable\" >\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'checkbox' && (value.name == 'caption') && values['Generate Thumbnail'].selectedValue == true\">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type=\"checkbox\"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-model=\"value.selectedValue\"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-disabled=\"value.disable || values.forceToDisabled\"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-change= \"$ctrl[value.onChangeFunction || noop](value,event)\" \n\t\t\t\t\t\t\t\t\t\t\t\t ng-focus=\"event=$event\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-disable=\"value.disable\" >\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'dd' && (value.name == 'caption.position') && values['Generate Thumbnail'].selectedValue == true\">\n\t\t\t\t\t\t\t\t\t\t\t\t<select id=\"{{value.name}}\" ng-model=\"value.selectedValue\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-change=\"$ctrl[value.onChangeFunction || noop](value.selectedValue, values); $ctrl.onPropValueChanged();\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<option value=\"{{v.value}}\" ng-repeat=\"v in value.options\">{{v.key|translate}}\n\t\t\t\t\t\t\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"(value.name == 'thumbnail.size') && values['Generate Thumbnail'].selectedValue == true\" translate=\"{{value.name}}\">{{value.name}}</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'dd' && (value.name == 'thumbnail.size') && values['Generate Thumbnail'].selectedValue == true\">\n\t\t\t\t\t\t\t\t\t\t\t\t<select id=\"{{value.name}}\" ng-model=\"value.selectedValue\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-change=\"$ctrl[value.onChangeFunction || noop](value.selectedValue, values); $ctrl.onPropValueChanged();\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<option value=\"{{v.value}}\" ng-repeat=\"v in value.options\">{{v.key|translate}}\n\t\t\t\t\t\t\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'datepicker' && value.dateType\"\n\t\t\t\t\t\t\t\t\t\t\tclass=\"date-picker-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"radio\" ng-if=\"!$ctrl.getSelectedItemProperties().Advance['Closed Date'].selectedValue\">\n\t\t\t\t\t\t\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<input name=\"radioDateType\" type=\"radio\" ng-model=\"value.dateType\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tvalue=\"1\" ng-disabled=\"value.disable || values.forceToDisabled\" ng-click=\"$ctrl[value.onChangeFunction || noop]('1', values)\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if=\"values['Time'].selectedValue == true\">{{'specific.datetime' | translate}}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if=\"values['Time'].selectedValue == false\">{{'specific.date' | translate}}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t<div ng-if=\"value.dateType == 1\" class=\"add-on-button-wrapper\" type=\"{{$ctrl.getSelectedItem().type}}\" ng-init=\"$ctrl.getDatePickerOptions(values)\" >\n\t\t\t\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default btn-xs addOnButton date-btn\" ng-click=\"$ctrl.openDatepicker(values)\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"glyphicon glyphicon-calendar\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<input  ng-disabled=\"value.disable || values.forceToDisabled\" picker-id=\"p_{{$ctrl.getSelectedItem().uid}}\" type=\"text\" ng-model=\"value.selectedValue\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tdatetimepicker datetimepicker-options=\"values.pickerOptions\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-change=\"$ctrl.getParsedDate(values); $ctrl.onPropValueChanged();\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-blur=\"$ctrl.checkValidInputDate(values);\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-keyup=\"$ctrl.updatePickerDisplay($event,values);\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tname=\"time\">\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"radio\">\n\t\t\t\t\t\t\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<input name=\"radioDateType\" type=\"radio\" ng-model=\"value.dateType\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tvalue=\"2\" ng-disabled=\"value.disable || values.forceToDisabled\" ng-click=\"$ctrl[value.onChangeFunction || noop]('2', values)\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{'current.date' | translate}} <span ng-if=\"value.dateType == 2\">+\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input type=\"number\" ng-disabled=\"value.disable || values.forceToDisabled\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-model=\"value.days\" value=\"0\" min=\"0\" /> d</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'datepicker' && !value.dateType\"\n\t\t\t\t\t\t\t\t\t\t\tclass=\"date-picker-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t<input type=\"text\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-init=\"value.dateObj = $ctrl.Util.getDateObj(value.dateObj)\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\" datepicker-options=\"$ctrl.dateOptions\"\n\t\t\t\t\t\t\t\t\t\t\t\tpopup-placement=\"bottom-right\"\n\t\t\t\t\t\t\t\t\t\t\t\tuib-datepicker-popup=\"{{$ctrl.Util.getDateFormat(values['Display Format'].selectedValue)}}\"\n\t\t\t\t\t\t\t\t\t\t\t\tis-open=\"opened\" ng-click=\"opened = true\" ng-model=\"value.dateObj\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-change=\"value.selectedValue = $ctrl.Util.formatDate($ctrl.Util.getLanguageSpecificDateFormat(values['Display Format'].selectedValue), value.dateObj);$ctrl.onPropValueChanged();\" />\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'timepicker'\" >\n\t\t\t\t\t\t\t\t\t\t\t<select  ng-model=\"value.timeType\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\">\n\t\t\t\t\t\t\t\t\t\t\t\t<option value=\"1\">{{'custom.time' | translate}}\n\t\t\t\t\t\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t\t\t\t\t\t\t<option value=\"2\">{{'current.time' | translate}}\n\t\t\t\t\t\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"add-on-button-wrapper custom-time\" ng-if=\"value.timeType == 1 \" ng-init = \"$ctrl.setTimeFormat(values)\">\n\t\t\t\t\t\t\t\t\t\t\t\t<button ng-disabled=\"value.disable || values.forceToDisabled\" type=\"button\" class=\"btn btn-default btn-xs addOnButton date-btn\" ng-click=\"values.showFlag1 = true\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-clock-o\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<input  ng-disabled=\"value.disable || values.forceToDisabled\"\n\t\t\t\t\t\t\t\t\t\t\t\t\ttype=\"text\" datetime-picker=\"{{values.timeFormat}}\" enable-date=\"false\" \n\t\t\t\t\t\t\t\t\t\t\t\t\ttimepicker-options = \"$ctrl.getTimePickerOptions(values)\" \n\t\t\t\t\t\t\t\t\t\t\t\t\tng-focus=\"values.showFlag1 = true\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-change=\"$ctrl.onPropValueChanged();\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-blur=\"$ctrl[value.onChangeFunction || noop]($event,values);\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-model=\"values['Default'].selectedValue\" is-open=\"values.showFlag1\">\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'radio' && value.name == 'source'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"radio\" ng-repeat=\"list in value.list\">\n\t\t\t\t\t\t\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<input name=\"radio{{value.name}}\" type=\"radio\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-model=\"value.selectedValue\" value=\"{{list.value}}\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click=\"$ctrl.sourceChanged(list.value, values); $ctrl.onPropValueChanged();\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{list.name|translate}}\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-info-circle\" ng-if=\"list.tooltip\"\n\t\t\t\t\t\t\t\t\t\t\t\t\ttitle=\"{{::list.tooltip}}\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default btn-xs pull-right\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-click=\"$ctrl.editDataSource(list.value, values)\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-if=\"value.selectedValue == list.value\"\n\t\t\t\t\t\t\t\t\t\t\t\t\ttitle=\"{{ 'edit' | translate }}\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-pencil\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'radio' && value.name != 'source'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"radio\" ng-repeat=\"list in value.list\">\n\t\t\t\t\t\t\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<input name=\"radio{{value.name}}\" type=\"radio\"  \n\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\" \n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-model=\"value.selectedValue\" value=\"{{list.value}}\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t{{list.name}}\n\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'number' && value.name !='number.columns'\" ng-form=\"test\" ng-class=\"{'add-on-button-wrapper': value.addOnButton}\">\n\t\t\t\t\t\t\t\t\t\t\t<button ng-if=\"value.addOnButton && (value.name == 'min' || value.name == 'max')\" type=\"button\" class=\"btn btn-default btn-xs addOnButton ng-scope\" uib-popover-html=\"htmlPopoverForRatingProps\" popover-trigger=\"'mouseenter'\" popover-placement=\"bottom-right\" popover-class=\"ristrict-msg\" ng-disabled=\"value.disable || values.forceToDisabled\">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-info\"></i>\n\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t<button ng-if=\"value.addOnButton && value.name == 'value'\" type=\"button\" class=\"btn btn-default btn-xs addOnButton ng-scope\" uib-popover-html=\"htmlPopoverForRatingValueProps\" popover-trigger=\"'mouseenter'\" popover-placement=\"bottom-right\" popover-class=\"ristrict-msg\" ng-disabled=\"value.disable || values.forceToDisabled\">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-info\"></i>\n\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t<input type=\"{{value.type}}\" string-to-number id=\"{{value.name}}\"\n\t\t\t\t\t\t\t\t\t\t\t\tname=\"{{value.name}}\" ng-model=\"value.selectedValue\"\n\t\t\t\t\t\t\t\t\t\t\t\tcontenteditable\n\t\t\t\t\t\t\t\t\t\t\t\tng-change=\"$ctrl[value.onChangeFunction || noop](values); $ctrl.onPropValueChanged();\" min=\"{{value.min}}\"\n\t\t\t\t\t\t\t\t\t\t\t\tmax=\"{{value.max}}\" ng-blur=\"$ctrl.validPattern($event,value)\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\">\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'number' && value.name=='number.columns'\" ng-form=\"test\">\n\t\t\t\t\t\t\t\t\t\t\t<input type=\"{{value.type}}\" string-to-number id=\"{{value.name}}\"\n\t\t\t\t\t\t\t\t\t\t\t\tname=\"{{value.name}}\" ng-model=\"value.selectedValue\"\n\t\t\t\t\t\t\t\t\t\t\t\tcontenteditable\n\t\t\t\t\t\t\t\t\t\t\t\tng-change=\"$ctrl[value.onChangeFunction || noop](); $ctrl.onPropValueChanged();\" min=\"{{value.min}}\"\n\t\t\t\t\t\t\t\t\t\t\t\tmax=\"{{value.max}}\" ng-blur=\"$ctrl.setNumberField($event,values)\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\">\n\t\t\t\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.name == 'hour_12_format' && (values['Time'].selectedValue == true || values['ControlType'] == 'Timepicker')\" translate=\"{{value.name}}\">{{value.name}}</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'dd' && value.name == 'hour_12_format' && (values['Time'].selectedValue == true || values['ControlType'] == 'Timepicker')\">\n\t\t\t\t\t\t\t\t\t\t\t<select id=\"{{value.name}}\" ng-model=\"value.selectedValue\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-change=\"$ctrl[value.onChangeFunction || noop](value.selectedValue, values);$ctrl.onPropValueChanged();\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\">\n\t\t\t\t\t\t\t\t\t\t\t\t<option value=\"{{v.value}}\" ng-repeat=\"v in value.options\">{{v.key|translate}}\n\t\t\t\t\t\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'dd' && value.name == 'display.format'\">\n\t\t\t\t\t\t\t\t\t\t\t <select  ng-model=\"value.selectedValue\"\n\t\t\t\t\t\t\t\t\t\t\t ng-change=\"$ctrl[value.onChangeFunction || noop](value.selectedValue, values); $ctrl.onPropValueChanged();\"\n\t\t\t\t\t\t\t\t\t\t\t ng-disabled=\"value.disable || values.forceToDisabled\" ng-if=\"values.ControlType == 'Datepicker'\">\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"{{v.value}}\" ng-repeat=\"v in value.options\" >\n\t\t\t\t\t\t\t\t\t\t\t\t{{v.key|translate}}  \n\t\t\t\t\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t\t\t\t\t</select> \n\t\t\t\t\t\t\t\t\t\t<div uib-dropdown keyboard-nav ng-if=\"values.ControlType == 'Radio'|| values.ControlType =='Checkbox'\"> \n\t\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default dropdown-toggle-btn option-format-cls\" uib-dropdown-toggle  \n\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"{{value.selectedIcon}}-selected\"></div>\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"selected-radio-style\">{{value.selectedName}}\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"caret\"></span>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t<ul class=\"dropdown-menu dropdown-menu-right\" id=\"display-dd\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"split-buttonv\">\n\t\t\t\t\t\t\t\t\t\t\t\t<li role=\"menuitem\" ng-click=\"$ctrl[value.onChangeFunction || noop](v.icon,v.value, values)\"selected ng-repeat=\"v in value.options\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"{{v.icon}}\"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<a>{{v.key|translate}}</a>\n\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t</div> \n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'dd' && !(value.name == 'display.format' || value.name == 'hour_12_format' || value.name == 'caption.position' || value.name == 'assoc.type'|| value.name == 'msg.type' || value.name == 'thumbnail.size')\">\n\t\t\t\t\t\t\t\t\t\t\t<select id=\"{{value.name}}\" ng-model=\"value.selectedValue\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-change=\"$ctrl[value.onChangeFunction || noop](value.selectedValue, values); $ctrl.onPropValueChanged();\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\">\n\t\t\t\t\t\t\t\t\t\t\t\t<option value=\"{{v.value}}\" ng-repeat=\"v in value.options\">{{v.key|translate}}\n\t\t\t\t\t\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'dd' && (value.name == 'assoc.type'|| value.name == 'msg.type')\">\n\t\t\t\t\t\t\t\t\t\t\t<select id=\"{{value.name}}\" ng-model=\"value.selectedValue\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-change=\"$ctrl[value.onChangeFunction || noop](value.selectedValue, values); $ctrl.onPropValueChanged();\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-class=\"{'required': !value.selectedValue}\" ng-disabled=\"value.disable || values.forceToDisabled\">\n\t\t\t\t\t\t\t\t\t\t\t\t<option value=\"{{v.value}}\" ng-repeat=\"v in value.options\">{{v.key|translate}}\n\t\t\t\t\t\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'table'\" colspan=\"2\">\n\t\t\t\t\t\t\t\t\t\t\t<table class=\"property-table\">\n\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td ng-repeat=\"header in value.headers\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\ttranslate=\"{{header.toLowerCase()}}\">{{header}}</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td ng-hide=\"value.hideRemovebtn\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href=\"\" title=\"Clear Default\" ng-disabled=\"value.disable || values.forceToDisabled\" \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click=\"$ctrl.removeDefault(value.list);\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-times pull-left\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if=\"value.list && value.list.length && value.list[0].showUpdateOptions\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if=\"value.list && value.list.length && value.list[0].showUpdateOptions\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<tr ng-repeat=\"item in value.list\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td ng-repeat=\"(k, v) in item\" ng-if=\"k !='id' && k!='relation' && k!='showUpdateOptions'\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input ng-if=\"v.type != 'radio' && !v.hidden\" name=\"v.name\" \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\ttype=\"{{v.type}}\" ng-model=\"v.name\" ng-disabled=\"v.disable || values.forceToDisabled\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\ttitle=\"{{v.type == 'text' ? v.name : ''}}\" ng-blur=\"$ctrl.removeDuplicateData(value)\" />\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input ng-if=\"v.type == 'radio' && !v.hidden\" name=\"v.name\" \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\ttype=\"{{v.type}}\" ng-model=\"v.name\" ng-value=\"true\" ng-disabled=\"v.disable || values.forceToDisabled\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-change=\"$ctrl[v.onChangeFunction || noop](v, value.list); $ctrl.onPropValueChanged();\" />\n\t\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td ng-hide=\"value.hideRemovebtn\"></td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td ng-if=\"item.showUpdateOptions\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-plus\" ng-hide=\"value.disable || values.forceToDisabled\" \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click=\"$ctrl.addIntoList($index, item, value.list)\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td ng-if=\"item.showUpdateOptions\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i ng-if=\"value.list.length > 1\" class=\"fa fa-minus\" ng-hide=\"value.disable || values.forceToDisabled\" \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click=\"$ctrl.removeFromList($index, value.list)\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'style-group'\" class=\"style-group\">\n\t\t\t\t\t\t\t\t\t\t\t<span ng-repeat=\"(key, member) in value.members\">\n\t\t\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default btn-sm\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-class=\"{'active': member.selectedValue}\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-if=\"member.type == 'btn-toggle'\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\" \n\t\t\t\t\t\t\t\t\t\t\t\t\tng-click=\"member.selectedValue = !member.selectedValue;$ctrl[member.onChangeFunction || noop](key); $ctrl.onPropValueChanged();\"\n\t\t\t\t\t\t\t\t\t\t\t\t\ttitle=\"{{ member.title | translate }}\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"{{ member.icon }}\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t<select ng-model=\"member.selectedValue\" ng-if=\"member.type == 'dd'\"\n\t\t\t\t\t\t\t\t\t\t\t\t\ttitle=\"{{ member.title | translate }}\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\" \n\t\t\t\t\t\t\t\t\t\t\t\t\tng-change=\"$ctrl[member.onChangeFunction || noop](key); $ctrl.onPropValueChanged();\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<option value=\"{{v}}\" ng-repeat=\"v in member.options\">{{v}}</option>\n\t\t\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t\t\t\t<input type=\"number\" string-to-number ng-model=\"member.selectedValue\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tcontenteditable\n\t\t\t\t\t\t\t\t\t\t\t\t\tmin=\"{{member.min}}\" max=\"{{member.max}}\" ng-if=\"member.type == 'number'\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-blur=\"$ctrl.validPattern($event,member)\"\n\t\t\t\t\t\t\t\t\t\t\t\t\ttitle=\"{{ member.title | translate }}\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled || member.disable\" \n\t\t\t\t\t\t\t\t\t\t\t\t\tng-change=\"$ctrl[member.onChangeFunction || noop](key); $ctrl.onPropValueChanged();\">\n\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if=\"member.type == 'radio-btn'\" class=\"radio-btn-group\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<label ng-repeat=\"option in member.options\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\ttitle=\"{{ option.title | translate }}\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input type=\"radio\" name=\"{{option.name || 'alignment'}}\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\" \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tvalue=\"{{option.value}}\" ng-model=\"member.selectedValue\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default btn-sm\" \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\" \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click=\"member.selectedValue = option.value;$ctrl[option.onChangeFunction || noop](key)\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"{{ option.icon }}\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if=\"member.type == 'color-picker'\" class=\"color-picker\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<spectrum-colorpicker options=\"$ctrl.colorPickerOptions\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tformat=\"'rgb'\" \n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\" \n\t\t\t\t\t\t\t\t\t\t\t\t\t\ton-change=\"$ctrl.colorPickerEventApi.onChange(key); $ctrl.onPropValueChanged();\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-model=\"member.selectedValue\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t</spectrum-colorpicker>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default btn-sm\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-class= \"{'color-picker-toggle': member.name == 'backgroundcoloron' || member.name == 'backgroundcoloroff' || member.name == 'backgroundcoloreven' || member.name == 'backgroundcolorodd'}\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click=\"$ctrl.showColorPicker($event)\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\ttitle=\"{{ member.title | translate }}\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"{{ member.icon }}\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-style=\"{'border-bottom': '3px solid ' + member.selectedValue }\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'button' && value.title == 'Add Setup'\">\n\t\t\t\t\t\t\t\t\t\t\t<button class=\"btn btn-danger\" \n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-click=\"$ctrl[value.onClickFunction || noop](key)\"\n\t\t\t\t\t\t\t\t\t\t\t\tdata-clickFun=\"{{$ctrl[value.onClickFunction]}}\"\n\t\t\t\t\t\t\t\t\t\t\t\ttitle=\"{{ value.title | translate }}\"\n\t\t\t\t\t\t\t\t\t\t\t\tstyle=\"width: 100%;\">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"{{ value.icon }}\"></i>   {{value.clicked == false ? value.title : 'Edit Setup'}}\n\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'button' && value.title != 'Add Setup'\">\n\t\t\t\t\t\t\t\t\t\t\t<button class=\"btn btn-default btn-sm\" \n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\" \n\t\t\t\t\t\t\t\t\t\t\t\tng-click=\"$ctrl[value.onClickFunction || noop](key)\"\n\t\t\t\t\t\t\t\t\t\t\t\ttitle=\"{{ value.title | translate }}\">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"{{ value.icon }}\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'button-group'\">\n\t\t\t\t\t\t\t\t\t\t\t<span ng-repeat=\"(key, member) in value.members\">\n\t\t\t\t\t\t\t\t\t\t\t\t<button class=\"btn btn-default btn-sm\" \n\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\" \n\t\t\t\t\t\t\t\t\t\t\t\t\tng-click=\"$ctrl[member.onClickFunction || noop](key)\"\n\t\t\t\t\t\t\t\t\t\t\t\t\ttitle=\"{{ member.title | translate }}\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"{{ member.icon }}\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'button-group'\"></td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'event'\">\n\t\t\t\t\t\t\t\t\t\t\t<button class=\"btn btn-default btn-xs\" ng-click=\"$ctrl[value.onClickFunction](value)\" \n\t\t\t\t\t\t\t\t\t\t\t\ttitle=\"{{ 'open-code-editor-tooltip' | translate }}\" ng-disabled=\"value.disable || values.forceToDisabled\">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-code\" style=\"font-weight: bold;\"></i>\n\t\t\t\t\t\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t\t\t\t\t\t<input type=\"text\" ng-if=\"!value.disable && !values.forceToDisabled && value.selectedValue\" disabled ng-model=\"value.selectedValue\" class=\"code-editor-val\" />\n\t\t\t\t\t\t\t\t\t\t\t<input type=\"text\" ng-if=\"(value.disable || values.forceToDisabled) && value.selectedValueReadonly\" disabled ng-model=\"value.selectedValueReadonly\" class=\"code-editor-val\" />\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"cell-color property-container\"  ng-if=\"$ctrl.getSelectedItemCell() && !$ctrl.basicSelected\">\n\t\t\t\t\t<div class=\"property-row\">\n\t\t\t\t\t\t<div class=\"property-header\">\n\t\t\t\t\t\t\t{{ 'cell.color' | translate }}\n\t\t\t\t\t\t</div>    \n\t\t\t\t\t\t<div class=\"property-content\">\n\t\t\t\t\t\t\t<table class=\"property-table\">\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class=\"style-group\">\n\t\t\t\t\t\t\t\t\t\t<span class=\"color-picker\">\n\t\t\t\t\t\t\t\t\t\t\t<spectrum-colorpicker options=\"$ctrl.colorPickerOptions\"\n\t\t\t\t\t\t\t\t\t\t\t\tformat=\"'rgb'\" \n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"!$ctrl.getSelectedItemCell()\" \n\t\t\t\t\t\t\t\t\t\t\t\ton-change=\"$ctrl.colorPickerEventApi.onChange($ctrl.cellColor); $ctrl.onPropValueChanged();\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-change=\"$ctrl.setBackgroundColor();\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-model=\"$ctrl.cellColor\">\n\t\t\t\t\t\t\t\t\t\t\t</spectrum-colorpicker>\n\t\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default btn-sm\" style=\"position: inherit;\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-class= \"color-picker-toggle\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"\" \n\t\t\t\t\t\t\t\t\t\t\t\tng-click=\"$ctrl.colorPickerEventApi.onChange($ctrl.cellColor); $ctrl.showColorPicker($event, $ctrl);$ctrl.getInitialColor();\"\n\t\t\t\t\t\t\t\t\t\t\t\ttitle=\"{{ 'cell.color' | translate }}\">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-paint-brush\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-style=\"{'border-bottom': $ctrl.cellColor.match('rgba') ? '3px solid rgb(255, 255, 255)' : '3px solid ' + $ctrl.cellColor}\"></i>\n\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t<span class=\"\" style=\"position: relative\">\n\t\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default btn-sm\"  style=\"position: inherit;\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-class= \"color-picker-toggle\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"\" \n\t\t\t\t\t\t\t\t\t\t\t\tng-click=\" $ctrl.removeCellColor()\"\n\t\t\t\t\t\t\t\t\t\t\t\ttitle=\"{{ 'remove.cell.color' | translate }}\">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-eraser\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-style=\"{'border-bottom': '3px solid '}\"></i>\n\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n<script type=\"text/ng-template\" id=\"dataSource.html\">\n\t<div class=\"modal-header\">\n\t\t<h3 class=\"modal-title inline-block\">{{$ctrl.sourceType == '6' ? 'Select Attributes' : $ctrl.sourceType == '7' ? 'Select Fields' : 'Data Source';}}</h3>\n\t\t<a class=\"ds-help pull-right inline-block\"  ng-if=\"$ctrl.sourceType == 4\" ng-click=\"$ctrl.openDSHelp()\" title=\"{{ 'help' | translate }}\"><i class=\"fa fa-question\"></i></a>\n\t</div>\n\t<div class=\"modal-body\">\n\t\t<div ng-if=\"$ctrl.sourceType == 1\">\n\t\t\t<div class=\"form-group\">\n\t\t\t\t<label>Url*:</label>\n\t\t\t\t<div class=\"auto-complete\">\n\t\t\t\t\t<input type=\"text\" class=\"form-control\" ng-class=\"{'required': !$ctrl.isObject($ctrl.properties.Url.selectedValue)}\" ng-model=\"$ctrl.properties.Url.selectedValue\" typeahead-no-results=\"noResults\" uib-typeahead=\"option as option.key for option in $ctrl.urls | filter:$viewValue | limitTo:8\" >\n\t\t\t\t\t<i class=\"fa fa-remove\" ng-if=\"$ctrl.isObject($ctrl.properties.Url.selectedValue)\" ng-click=\"$ctrl.properties.Url.selectedValue = ''\"></i>\n\t\t\t\t</div>\n\t\t\t\t<p class=\"note\" ng-show=\"noResults\" translate=\"no.results.found\">No Results Found.</p>\n\t\t\t</div>\n\t\t\t<div class=\"form-group\">\n\t\t\t\t<label>Parameters:</label>\n\t\t\t\t<table class=\"table\">\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th>Key</th>\n\t\t\t\t\t\t<th>Value</th>\n\t\t\t\t\t\t<th></th>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr ng-repeat=\"item in $ctrl.parameterList\">\n\t\t\t\t\t\t<td ng-repeat=\"(k, v) in item\">\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control input-sm\" ng-model=\"v.name\" />\n\t\t\t\t\t\t</td>\n\t\t\t\t\t\t<td><button class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"$ctrl.addIntoList($index, item, $ctrl.parameterList)\"><i class=\"fa fa-plus\"></i></button>\n\t\t\t\t\t\t<button ng-if=\"$ctrl.parameterList.length > 1\" class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"$ctrl.removeFromList($index, $ctrl.parameterList)\"><i class=\"fa fa-minus\"></i></button></td>\n\t\t\t\t\t</tr>\n\t\t\t\t</table>\n\t\t\t</div>\n\t\t</div>\n\t\t<div ng-if=\"$ctrl.sourceType == 4\">\n\t\t\t<div class=\"form-group\">\n\t\t\t\t<div class=\"auto-complete\">\n\t\t\t\t\t<input type=\"text\" class=\"form-control\" typeahead-min-length=\"0\" ng-class=\"{'required': !$ctrl.isObject($ctrl.properties.fixedFieldUrl.selectedValue)}\" ng-model=\"$ctrl.properties.fixedFieldUrl.selectedValue\" typeahead-no-results=\"noResults\" uib-typeahead=\"option as option.key for option in $ctrl.urls | filter:$viewValue | limitTo:8\" autofocus=\"true\">\n\t\t\t\t\t<i class=\"fa fa-remove\" ng-if=\"$ctrl.isObject($ctrl.properties.fixedFieldUrl.selectedValue)\" ng-click=\"$ctrl.properties.fixedFieldUrl.selectedValue = ''\"></i>\n\t\t\t\t</div>\n\t\t\t\t<p class=\"note\" ng-show=\"noResults\" translate=\"no.results.found\">No Results Found.</p>\n\t\t\t</div>\n\t\t</div>\n\t\t<div ng-if=\"$ctrl.sourceType == 5\" class=\"custom-attr\">\n\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label>Attribute Name</label>\n\t\t\t\t\t<input type=\"text\" class=\"form-control\" typeahead-min-length=\"0\" ng-class=\"{'required': !$ctrl.properties.customAttr.selectedValue}\" ng-model=\"$ctrl.properties.customAttr.selectedValue\" typeahead-no-results=\"noResults\" uib-typeahead=\"option as option.key for option in $ctrl.urls | filter:$viewValue | limitTo:8\" autofocus=\"true\" typeahead-on-select=\"$ctrl.onChangeFunctionAttributeName()\" ng-change=\"$ctrl.onChangeFunctionAttributeName()\">\n\t\t\t\t\t<i class=\"fa fa-remove\" ng-if=\"$ctrl.properties.customAttr.selectedValue\" ng-click=\"$ctrl.clearAttributeSet()\"></i>\n\t\t\t</div>\n\t\t\t<div class=\"form-group\">\n\t\t\t\t<label>Display</label>\n\t\t\t\t<select class=\"form-control\" ng-model=\"$ctrl.properties.customAttr.displayVal\">\n\t\t\t\t\t<option value=\"1\">Attribute Code</option>\n\t\t\t\t\t<option value=\"2\">Attribute Value</option>\n\t\t\t\t\t<option value=\"3\">Both</option>\n\t\t\t\t</select>\n\t\t\t</div>\n\t\t\t<p class=\"note\">Note: Dropdown will be blank if attribute name does not match.</p>\n\t\t\t<div ng-if=\"$ctrl.designType == 'Direct-Design'\">\n\t\t\t\t<br/>\n\t\t\t\t<span>Set Attributes hierarchy:</span> &nbsp;\n\t\t\t\t<span><input type=\"checkbox\" ng-model=\"$ctrl.properties.customAttr.hierarchyApplied\" /></span>\n\t\t\t\t<br/>\n\t\t\t\t\t\t<div class=\"form-group\" ng-if=\"$ctrl.properties.customAttr.hierarchyApplied\">\n\t\t\t\t\t\t\t<table class=\"table\">\n\t\t\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td>Attribute Set</td>\n\t\t\t\t\t\t\t\t\t<td>Child Attribute Field</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr ng-repeat=\"item in $ctrl.hierarchyData\">\n\t\t\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t\t\t<select class=\"form-control\" \n\t\t\t\t\t\t\t\t\t\t\tng-model=\"item.attributeSetData\"\n\t\t\t\t\t\t\t\t\t\t\tng-change='$ctrl.getDropdowns(item.attributeSetData)'>\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"\" disable>Please Select</option>\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"{{set.attributeSetId}}\" ng-repeat=\"set in $ctrl.firstDropdownOptions track by $index\">{{set.attributeName}}</option>\n\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t\t\t<select class=\"form-control\" ng-model= \"item.childDropdown\">\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"\" disable>Please Select</option>\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"{{state}}\" ng-repeat=\"state in $ctrl.getDropdowns(item.attributeSetData) track by $index\">{{state.slice(state.indexOf(':')+2, state.indexOf(',')-1)}}</option>\n\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t\t\t<button class=\"btn btn-default btn-sm fa fa-plus\" type=\"button\" ng-click=\"$ctrl.addInList($index+1, $ctrl.hierarchyData)\"></button>\n\t\t\t\t\t\t\t\t\t\t<button ng-if=\"$ctrl.hierarchyData.length > 1\" class=\"btn btn-default btn-sm fa fa-minus\" type=\"button\" ng-click=\"$ctrl.removeFromListDD($index, $ctrl.hierarchyData)\"></button>\n\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t</div>\n\t\t<div ng-if=\"$ctrl.sourceType == 3\">\n\t\t\t<table class=\"table\">\n\t\t\t\t<tr>\n\t\t\t\t\t<th ng-repeat=\"header in $ctrl.properties.table.headers\" translate=\"{{ header.toLowerCase() }}\">{{header}}</th>\n\t\t\t\t\t<th></th>\n\t\t\t\t</tr>\n\t\t\t\t<tr ng-repeat=\"item in $ctrl.list\">\n\n\t\t\t\t\t<td ng-repeat=\"(k, v) in item\" ng-if=\"k !='id' && k!='relation' && k != 'showUpdateOptions'\">\n\n\t\t\t\t\t\t<input ng-if=\"v.type == 'text'\" type=\"v.type\" class=\"form-control input-sm\" ng-model=\"v.name\" ng-disabled=\"v.disable\" autofocus=\"true\" />\n\n\t\t\t\t\t\t<input ng-if=\"v.type == 'checkbox' && $ctrl.multipleSelectedValue == true\" name=\"v.name\"  type=\"{{v.type}}\" ng-model=\"v.name\" />\n\n\t\t\t\t\t\t<input ng-if=\"$ctrl.multipleSelectedValue == false && v.type != 'text' && k !== 'isSelected'\" type=\"radio\" name=\"dataSourceGroup\" ng-model=\"v.name\" ng-value=\"true\" ng-change=\"$ctrl.resetDefaultForRadio(v, $ctrl.list)\">\n\n\t\t\t\t\t</td>\n\t\t\t\t\t<td ng-if=\"item.showUpdateOptions\"><button class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"$ctrl.addIntoList($index, item, $ctrl.list)\" title=\"{{ 'add' | translate }}\"><i class=\"fa fa-plus\"></i></button>\n\t\t\t\t\t<button ng-if=\"$ctrl.list.length > 1\" class=\"btn btn-default btn-sm\" type=\"button\" ng-click=\"$ctrl.removeFromList($index, $ctrl.list)\" title=\"{{ 'delete' | translate }}\"><i class=\"fa fa-minus\"></i></button></td>\n\t\t\t\t</tr>\n\t\t\t</table>\n\t\t</div>\n\t\t<div ng-if=\"$ctrl.sourceType == 6 || $ctrl.sourceType == 7 || $ctrl.sourceType == 8\">\n            <div class=\"select-field-main\">\n                <div class=\"default-row\" ng-if=\"item.id == 1\" ng-repeat=\"item in $ctrl.list\">\n\n                    <div class=\"glyphicon glyphicon-remove cross-icon\" style=\"visibility: hidden;\"></div>\n\n                    <div class=\"select-item\" ng-repeat=\"(k, v) in item\" ng-if=\"k !='id' && k!='relation' && k != 'showUpdateOptions'\">\n\n                        <select class=\"form-control\" \n                                data-index=\"{{$index}}\"\n                                ng-if=\"v.type == 'dropdown'\">\n                            <option value=\"{{v.name.id}}\" name=\"{{v.name}}\" selected=\"selected\" disabled=\"true\">{{v.name.colDisplayName}}</option>\n                        </select>\n                        <div class=\"select-option\">\n                            <input  ng-if=\"v.type == 'radio'\" type=\"radio\" name=\"v.name\" ng-disable=\"v.disable || v.forceToDisabled\" ng-model=\"v.list[0].value\" ng-value=\"'1'\" ng-change=\"$ctrl.selectSortOrder(v, '1')\" ng-init=\"$ctrl.selectDefaultSortOrd(v, '1')\">\n\t\t\t\t\t\t\t<label  ng-if=\"v.type == 'radio'\" for=\"dis\" style=\"padding-right: 30px;\">  Descending   </label>\n                            <input  ng-if=\"v.type == 'radio'\" type=\"radio\" name=\"v.name\" ng-model=\"v.selectedValue\" ng-value=\"'0'\" ng-change=\"$ctrl.selectSortOrder(v, '0')\">\n                            <label  ng-if=\"v.type == 'radio'\" for=\"dis\">  Ascending</label>\n                        </div>                      \n                    </div>\n                </div>\n                <div class=\"custom-row\" ng-if=\"item.id != 1\" ng-repeat=\"item in $ctrl.list\">\n\n                    <div class=\"cross-icon\" ng-if=\"item.showUpdateOptions\">\n                        <span ng-if=\"$ctrl.list.length\" class=\"glyphicon glyphicon-remove\" style=\"color: #dc3545\" ng-click=\"$ctrl.removeFromList($index, $ctrl.list)\"></span>\n\t\t\t\t\t</div>\n\n                    <div class=\"select-item\" ng-repeat=\"(k, v) in item\" ng-if=\"k !='id' && k!='relation' && k != 'showUpdateOptions'\">\n\n                        <input ng-if=\"v.type == 'text'\" type=\"v.type\" class=\"form-control input-sm\" ng-model=\"v.name\" ng-disabled=\"v.disable\" autofocus=\"true\" />\n\n                        <input ng-if=\"v.type == 'checkbox'\" name=\"v.name\"  type=\"{{v.type}}\" ng-model=\"v.name\" />\n\n                        <select class=\"form-control\"\n                                ng-if=\"v.type == 'dropdown'\"\n                                ng-model= \"v.value\"\n                                ng-change=\"$ctrl.getSelectedDropdownOption(v, v.value)\">\n                            <option value=\"\" disable>Please Select</option>\n                            <option ng-if=\"ele.colDisplayName != ''\" value=\"{{ele.id}}\" name=\"{{ele.colDisplayName}}\" ng-repeat=\"ele in $ctrl.columnList\">{{ele.colDisplayName}}</option>\n                        </select>\n                        \n\t\t\t\t\t\t<div class=\"select-option\">\n\t\t\t\t\t\t\t<input ng-show=\"item.Value.name.isSortSupported == true\" ng-if=\"v.type == 'radio'\" type=\"radio\" name=\"v.name\" ng-model=\"v.selectedValue\" ng-value=\"v.list[0].value\" ng-change=\"$ctrl.selectSortOrder(v, v.list[0].value)\">\n                        \t<label ng-show=\"item.Value.name.isSortSupported == true\" ng-if=\"v.type == 'radio'\" for=\"dis\" style=\"padding-right: 30px;\">  Descending   </label>\n                        \t<input ng-show=\"item.Value.name.isSortSupported == true\" ng-if=\"v.type == 'radio'\" type=\"radio\" name=\"v.name\" ng-model=\"v.selectedValue\" ng-value=\"v.list[1].value\" ng-change=\"$ctrl.selectSortOrder(v, v.list[1].value)\">\n                        \t<label ng-show=\"item.Value.name.isSortSupported == true\" ng-if=\"v.type == 'radio'\" for=\"dis\">  Ascending</label>\n\t\t\t\t\t\t</div>\n                        \n                    </div>\n                </div>\n            </div>\n\t\t\t<button class=\"btn btn-danger\" type=\"button\" ng-click=\"$ctrl.addAssocRowInList($ctrl.list.length, $ctrl.list[0], $ctrl.list)\" title=\"{{ 'add' | translate }}\"><i class=\"fa fa-plus\"></i> {{$ctrl.sourceType == 6 ? 'Add Attributes' : 'Add Fields'}}</button>\n        </div>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button class=\"btn btn-danger\" type=\"button\" ng-click=\"$ctrl.save()\" ng-dblclick=\"return\" translate=\"ok\">OK</button>\n\t\t<button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.cancel()\" translate=\"cancel\">Cancel</button>\n\t</div>\n</script>\n\n<script type=\"text/ng-template\" id=\"languageModal.html\">\n\t<div class=\"modal-header\">\n\t\t<h3 class=\"modal-title\" translate=\"languages\">Languages</h3>\n\t</div>\n\t<div class=\"modal-body language-modal\">\n\t\t<table class=\"table\">\n\t\t\t<tr>\n\t\t\t\t<th translate=\"languages\">Languages</th>\n\t\t\t\t<th translate=\"translation\">Translation</th>\n\t\t\t</tr>\n\t\t\t<tr ng-repeat=\"(key, value) in $ctrl.languageObj\">\n\t\t\t\t<td ng-if=\"key != 'Default'\"><img title=\"{{value.displayLanguage}} ({{value.displayCountry}})\" alt=\"{{value.displayLanguage}} ({{value.displayCountry}})\" style=\"width: 24px;\"\n\t\t\t\tng-src=\"/assets/images/flags/{{(value.languageId || '').trim()}}.png\">\n\t\t\t\t{{value.displayLanguage}} ({{value.displayCountry}})</td>\n\t\t\t\t<td ng-if=\"key == 'Default'\" translate=\"default\"></td>\n\t\t\t\t<td><input type=\"text\" ng-model=\"value.label\"></td>\n\t\t\t</tr>\n\t\t</table>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button class=\"btn btn-danger\" type=\"button\" ng-click=\"$ctrl.save()\" ng-dblclick=\"return\" translate=\"ok\">OK</button>\n\t\t<button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.cancel()\" translate=\"cancel\">Cancel</button>\n\t</div>\n</script>\n\n<script type=\"text/ng-template\" id=\"languageNumberSeparatorModal.html\">\n\t<div class=\"modal-header\">\n\t\t<h3 class=\"modal-title\" translate=\"languages\">Decimal/Separator</h3>\n\t</div>\n\t<div class=\"modal-body decimal-separator-modal\">\n\t\t<table class=\"table\">\n\t\t\t<tr>\n\t\t\t\t<th translate=\"languages\">Languages</th>\n\t\t\t\t<th translate=\"decimal\" ng-if=\"$ctrl.allowDecimalSeparator\">Decimal</th>\n\t\t\t\t<th translate=\"separator\">Separator</th>\n\t\t\t</tr>\n\t\t\t<tr ng-repeat=\"(key, value) in $ctrl.languageObj\">\n\t\t\t\t<td ng-if=\"key != 'Default'\">\n\t\t\t\t\t<img title=\"{{value.displayLanguage}} ({{value.displayCountry}})\" \n\t\t\t\t\talt=\"{{value.displayLanguage}} ({{value.displayCountry}})\" style=\"width: 24px;\"\n\t\t\t\t\tng-src=\"/assets/images/flags/{{(value.languageId || '').trim()}}.png\">\n\t\t\t\t{{value.displayLanguage}} ({{value.displayCountry}})</td>\n\t\t\t\t<td ng-if=\"key == 'Default'\" translate=\"default\"></td>\n\n\t\t\t\t<td ng-if=\"$ctrl.allowDecimalSeparator\">\n\t\t\t\t\t<select class=\"form-control\" ng-model=\"value.decimal\">\n\t\t\t\t\t\t<option value=\"\">Please Select</option>\n\t\t\t\t\t\t<option value=\".\">. (Dot)</option>\n\t\t\t\t\t\t<option value=\",\">, (Comma)</option>\n\t\t\t\t\t</select>\n\t\t\t\t\t<!-- <input type=\"text\" ng-model=\"value.decimal\" ng-pattern=\"/^[.,]?$/\" ng-trim ng-trim maxlength=\"1\"\n\t\t\t\t\ttitle=\"Allowed Separator is : Dot or Comma only\"> -->\n\n\t\t\t\t</td>\n\n\t\t\t\t<td>\n\t\t\t\t\t<select class=\"form-control\" ng-model=\"value.thousand\">\n\t\t\t\t\t\t<option value=\"\">Please Select</option>\n\t\t\t\t\t\t<option value=\".\">. (Dot)</option>\n\t\t\t\t\t\t<option value=\",\">, (Comma)</option>\n\t\t\t\t\t\t<option value=\"'\">' (Apostrophe)</option>\n\t\t\t\t\t\t<option value=\"SPACE\">Space</option>\n\t\t\t\t\t</select>\n\n\n\t\t\t\t\t<!-- <input type=\"text\" ng-model=\"value.thousand\" ng-trim=false ng-pattern=\"/^[.,' ]?$/\" ng-trim maxlength=\"1\"\n\t\t\t\t\ttitle=\"Allowed Separator is : Dot or Comma or Space or Apostrophe only\"> -->\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t</table>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button class=\"btn btn-danger\" type=\"button\" ng-click=\"$ctrl.save()\" ng-dblclick=\"return\" translate=\"ok\">OK</button>\n\t\t<button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.cancel()\" translate=\"cancel\">Cancel</button>\n\t</div>\n</script>\n\n<script type=\"text/ng-template\" id=\"typeahead-item.html\">\n  <div class=\"typeahead-group-header\" ng-if=\"match.model.firstInGroup\" style=\"font-weight: bold;margin: 10px;\" >{{match.model.group}} Fields</div>\n  <a>\n    <span ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"></span>\n  </a>\n</script>\n\n<script type=\"text/ng-template\" id=\"existingDataField.html\">\n\t<div class=\"modal-header\">\n\t\t<h3 class=\"modal-title inline-block\" translate=\"value\">Value</h3>\n\t\t<a class=\"ds-help pull-right inline-block\" ng-click=\"$ctrl.openDSHelp()\" title=\"{{ 'help' | translate }}\"><i class=\"fa fa-question\"></i></a>\n\t</div>\n\t<div class=\"modal-body\">\n\t\t<div class=\"FormNav\" ng-if=\"$ctrl.properties.Type.calculation == ''\">\n\t\t\t<div class=\"navTabDiv\" ng-model=\"$ctrl.properties.DSName.selectedValue\" ng-class=\"{'active': $ctrl.properties.DSName.selectedValue != 'calculated'}\" ng-click=\"$ctrl.showcurrenttabdiv($ctrl.properties.DSName.selectedValue)\">\n\t\t\t\t<a class=\"navTab\" href=\"javascript:void(0)\">{{'system.field' | translate}}</a>\n\t\t\t</div>\n\t\t\t<div class=\"navTabDiv\" ng-model=\"$ctrl.properties.DSName.selectedValue\" ng-class=\"{'active': $ctrl.properties.DSName.selectedValue == 'calculated'}\" ng-click=\"$ctrl.showcurrenttabdiv($ctrl.properties.DSName.selectedValue)\">\n\t\t\t\t<a id=\"calculatedFieldTab\" class=\"navTab\" href=\"javascript:void(0)\">{{'calculated.field' | translate}}</a>\n\t\t\t</div>\n\t\t</div>\t\t\t\n\t\t<div class=\"toggleCalculation\" ng-if=\"$ctrl.properties.Type.number && $ctrl.properties.Type.calculation == 'advance'\" ng-click=\"$ctrl.showCalculationMethod($event)\">{{'Back' | translate}}</div>\n\t\t<div class=\"control-group rules-container\" id=\"advanceDiv\" ng-if=\"$ctrl.properties.Type.number && $ctrl.properties.Type.calculation == 'advance'\" >  \n\t\t\t<label class=\"control-label\">{{'Advanced Query' | translate}}:</label>\n\t\t\t<div class=\"controls\">\n\t\t\t\t<div class=\"auto-complete\" id=\"advanceFormulaInput\">\n\t\t\t\t\t<input type=\"text\" class=\"form-control\" id=\"inputQuery\" typeahead-template-url=\"typeahead-item.html\" ng-model=\"$ctrl.properties.formula.advanceQuery\"  typeahead-min-length=\"0\" typeahead-no-results=\"noResults\" uib-typeahead=\"option as option.key for option in $ctrl.getFieldsByGroup($viewValue,'fromadvance') | limitTo:8\" placeholder=\"Enter calculation query\" typeahead-on-select=\"$ctrl.setQueryVal($event)\" autocomplete=\"off\">\n\t\t\t\t\t<i class=\"fa fa-remove\" ng-if=\"$ctrl.properties.formula.advanceQuery != ''\" ng-click=\"$ctrl.properties.formula.advanceQuery = ''\"></i>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"control-group rules-container\" id=\"conditonsDiv\" ng-if=\"$ctrl.properties.DSName.selectedValue == 'calculated'\" style=\"display:none\">\n\t\t\t<label class=\"control-label\">{{'condition' | translate}}:</label>\n\t\t\t<div class=\"controls\">\n\t\t\t\t<div id=\"rule-engine-container\">\n\t\t\t\t\t<div class=\"rules-engine single-row\">\n\t\t\t\t\t\t<div class=\"rules-header clearfix\">\n\t\t\t\t\t\t\t<div class=\"handle-header\"></div>\n\t\t\t\t\t\t\t<div class=\"field-header\">{{'field' | translate}}</div>\n\t\t\t\t\t\t\t<div class=\"operator-header\">{{'operator' | translate}}</div>\n\t\t\t\t\t\t\t<div class=\"value-header\">{{'target' | translate}}</div>\n\t\t\t\t\t\t\t<div class=\"conjunction-header\" ng-if=\"!$ctrl.properties.list.listItem[0].conjuction.hidden\">{{'conjunction' | translate}}</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<ul class=\"rules-list ui-sortable ui-sortable-disabled\" dnd-list=\"$ctrl.properties.list.listItem\" dnd-inserted=\"$ctrl.logListEvent(index)\">\n\t\t\t\t\t\t\t<li class=\"clearfix rule-item last-row\" ng-repeat='(key,item) in $ctrl.properties.list.listItem' dnd-draggable=\"item\" dnd-moved=\"$ctrl.properties.list.listItem.splice($index, 1)\" dnd-dragstart=\"$ctrl.onDragStart(item)\">\n\t\t\t\t\t\t\t\t<div title=\"{{'drag' | translate}}\" name=\"{{item.drag.name}}{{key}}\" class=\"handle icon icon-th\" dnd-handle><i class=\"fa fa-th\"></i></div>\n\t\t\t\t\t\t\t\t<dnd-nodrag>\n\t\t\t\t\t\t\t\t\t<div class=\"auto-complete field\">\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" typeahead-template-url=\"typeahead-item.html\" ng-model=\"item.field.value\"  typeahead-min-length=\"0\" typeahead-no-results=\"noResults\" uib-typeahead=\"option as option.key for option in $ctrl.getFieldsByGroup($viewValue,'field') | limitTo:8\" id=\"{{item.field.name}}{{key}}\" placeholder=\"{{'select.type' | translate}}\" name=\"{{item.field.name}}{{key}}\"  selectedType=\"{{item.field.value}}\">\n\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-remove\" ng-if=\"$ctrl.isObject(item.field.value)\" ng-click=\"item.field.value = ''\" autocomplete=\"off\"></i>\n\t\t\t\t\t\t\t\t\t\t<p class=\"note\" ng-show=\"noResults\" translate=\"no.results.found\">No Results Found.</p>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class=\"operator\">\n\t\t\t\t\t\t\t\t\t\t<select name=\"{{item.operator.name}}{{key}}\" id=\"{{item.operator.name}}{{key}}\" class=\"form-control\" ng-model=\"item.operator.options.value\" ng-init=\"$ctrl.initialSelectedOption(item.operator.options)\" ng-change=\"$ctrl.updateOperatorValue(item.operator.options.value,key)\">\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"{{option.value}}\" ng-repeat=\"(optionkey,option) in item.operator.options\" >{{option.key}}</option>\n\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class=\"target\">\n\t\t\t\t\t\t\t\t\t\t<input type=\"number\" class=\"form-control\" name=\"{{item.target.name}}{{key}}\" id=\"{{item.target.name}}{{key}}\" ng-model=\"item.target.value\" ng-change=\"$ctrl.convertNumber(key)\" ng-disabled='item.target.disable' />\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class=\"conjunction\" ng-if=\"!item.conjuction.hidden\">\n\t\t\t\t\t\t\t\t\t\t<select name=\"{{item.conjuction.name}}{{key}}\" id=\"{{item.conjuction.name}}\" class=\"form-control\">\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"{{option.value}}\" ng-repeat=\"option in item.conjuction.options\">{{option.key}}</option>\n\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class=\"action\">\n\t\t\t\t\t\t\t\t\t\t<a href=\"javascript:void(0);\" title=\"{{item.add.title | translate}}\" class=\"add-button\" ng-click=\"$ctrl.addNewRuleDiv($index, item, $ctrl.properties.list.listItem)\">+</a>\n\t\t\t\t\t\t\t\t\t\t<a href=\"javascript:void(0);\" title=\"{{item.remove.title | translate}}\" class=\"remove-button\" ng-if=\"!item.remove.hidden\" ng-click=\"$ctrl.removeFromList($index, $ctrl.properties.list.listItem)\" >-</a>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</dnd-nodrag>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"control-group rules-container\" ng-show=\"$ctrl.properties.DSName.selectedValue == 'calculated'\">\n\t\t\t<label class=\"control-label\">{{'calculations' | translate}}:</label>\n\t\t\t<div ng-model=\"$ctrl.properties.formula.edit\" ng-click=\"$ctrl.EnableEditing($ctrl.properties.formula.editText)\" class=\"editFormula\">{{$ctrl.properties.formula.editText}}</div>\n\t\t\t<div class=\"controls\">\n\t\t\t\t<div ng-if=\"$ctrl.properties.formula.edit\">\n\t\t\t\t\t<textarea class=\"form-control\" ng-model=\"$ctrl.properties.Value.selectedValue\" >{{$ctrl.properties.Value.selectedValue}}</textarea>\n\t\t\t\t</div>\n\t\t\t\t<table style=\"width:100%\" ng-if=\"!$ctrl.properties.formula.edit\">\t\t\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td style=\"width:100%\">\n\t\t\t\t\t\t\t<div class=\"auto-complete\">\n\t\t\t\t\t\t\t\t<input id=\"addField\" type=\"text\" class=\"form-control\" typeahead-template-url=\"typeahead-item.html\" ng-model=\"$ctrl.properties.list.listItem[0].addField.value\" typeahead-min-length=\"0\" typeahead-no-results=\"noResults\" uib-typeahead=\"option as option.key for option in $ctrl.getFieldsByGroup($viewValue) | limitTo:8\" autocomplete=\"off\" typeahead-on-select=\"$ctrl.setaddType($ctrl.properties.list.listItem[0].addField.value)\" placeholder=\"{{'select.type' | translate}}\">\n\t\t\t\t\t\t\t\t<i class=\"fa fa-remove\" id=\"addfieldremove\" ng-if=\"$ctrl.isObject($ctrl.properties.list.listItem[0].addField.value)\" ng-click=\"$ctrl.properties.list.listItem[0].addField.value = '';$ctrl.properties.list.listItem[0].addField.disable = true;$ctrl.properties.list.listItem[0].addSum.disable = true\"></i>\n\t\t\t\t\t\t\t\t<p class=\"note\" ng-show=\"noResults\" translate=\"no.results.found\">No Results Found.</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div id=\"calculationFormulaDiv\" ng-bind-html=\"$ctrl.properties.formula.html\"></div>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t\t<td style=\"vertical-align: top;min-width:135px;\">\n\t\t\t\t\t\t\t<button class=\"btn btn-primary btn-sm calculationBtn\" ng-click=\"$ctrl.num($ctrl.properties.list.listItem[0].addField.value,'field')\" ng-disabled=\"$ctrl.properties.list.listItem[0].addField.disable\">{{'add.field' | translate}}</button>\n\t\t\t\t\t\t\t<button ng-if=\"!$ctrl.properties.Type.numberUnderRepeatingTable || $ctrl.properties.parentNode.footer\" class=\"btn btn-primary btn-sm calculationBtn\" id=\"sumBtn\" ng-click=\"$ctrl.addSum($ctrl.properties.list.listItem[0].addField.value)\" ng-disabled=\"$ctrl.properties.list.listItem[0].addSum.disable\">{{'add.sum' | translate}}</button>\n\t\t\t\t\t\t\t<div class=\"calculator\">\n\t\t\t\t\t\t\t\t<div class=\"controls\">\n\t\t\t\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t\t\t\t<button class=\"btn\" ng-click=\"$ctrl.clear()\"><i class=\"fa fa-arrow-left\"></i></button>\n\t\t\t\t\t\t\t\t\t\t<button class=\"btn\" ng-click=\"$ctrl.num('(','braces')\">(</button>\n\t\t\t\t\t\t\t\t\t\t<button class=\"btn\" ng-click=\"$ctrl.num(')','braces')\">)</button>\n\t\t\t\t\t\t\t\t\t\t<button class=\"btn\" ng-click=\"$ctrl.num('*','operator')\">*</button>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t\t\t\t<button class=\"btn\" ng-click=\"$ctrl.num('7')\">7</button>\n\t\t\t\t\t\t\t\t\t\t<button class=\"btn\" ng-click=\"$ctrl.num('8')\">8</button>\n\t\t\t\t\t\t\t\t\t\t<button class=\"btn\" ng-click=\"$ctrl.num('9')\">9</button>\n\t\t\t\t\t\t\t\t\t\t<button class=\"btn\" ng-click=\"$ctrl.num('-','operator')\">-</button>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t\t\t\t<button class=\"btn\" ng-click=\"$ctrl.num('4')\">4</button>\n\t\t\t\t\t\t\t\t\t\t<button class=\"btn\" ng-click=\"$ctrl.num('5')\">5</button>\n\t\t\t\t\t\t\t\t\t\t<button class=\"btn\" ng-click=\"$ctrl.num('6')\">6</button>\n\t\t\t\t\t\t\t\t\t\t<button class=\"btn\" ng-click=\"$ctrl.num('+','operator')\">+</button>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t\t\t\t<button class=\"btn\" ng-click=\"$ctrl.num('1')\">1</button>\n\t\t\t\t\t\t\t\t\t\t<button class=\"btn\" ng-click=\"$ctrl.num('2')\">2</button>\n\t\t\t\t\t\t\t\t\t\t<button class=\"btn\" ng-click=\"$ctrl.num('3')\">3</button>\n\t\t\t\t\t\t\t\t\t\t<button class=\"btn\" ng-click=\"$ctrl.num('/','operator')\">/</button>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t\t\t\t<button class=\"btn\" ng-click=\"$ctrl.num('0')\">0</button>\n\t\t\t\t\t\t\t\t\t\t<button class=\"btn\" ng-click=\"$ctrl.num('.')\" >.</button>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</td>\n\t\t\t\t\t</tr>\t\t\t\t\t\n\t\t\t\t</table>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"auto-complete\" ng-show=\"$ctrl.properties.DSName.selectedValue != 'calculated'\" >\n\t\t\t<input type=\"text\" class=\"form-control\"  typeahead-template-url=\"typeahead-item.html\" ng-class=\"{'required': !$ctrl.isObject($ctrl.Value)}\" ng-model=\"$ctrl.Value\" typeahead-min-length=\"0\" typeahead-no-results=\"noResults\" uib-typeahead=\"option as option.key for option in $ctrl.getFieldsByGroup($viewValue) | limitTo:8\" autofocus=\"{'required': !$ctrl.isObject($ctrl.Value)}\">\n\t\t\t<i class=\"fa fa-remove\" ng-if=\"$ctrl.isObject($ctrl.Value)\" ng-click=\"$ctrl.Value = ''\"></i>\n\t\t</div>\n\t\t<p class=\"note\" ng-show=\"noResults\" translate=\"no.results.found\">No Results Found.</p>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button class=\"btn btn-danger\" type=\"button\" ng-click=\"$ctrl.save()\" ng-dblclick=\"return\" translate=\"ok\">OK</button>\n\t\t<button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.cancel()\" translate=\"cancel\">Cancel</button>\n\t</div>\n</script>\n\n<script type=\"text/ng-template\" id=\"image.html\">\n\t<div class=\"modal-header\">\n\t\t<h3 class=\"modal-title inline-block\" translate=\"source\">Source</h3>\n\t</div>\n\t<div class=\"modal-body\">\n\t\t<div ng-if=\"$ctrl.sourceType == 0\">\n\t\t\t\t<input type=\"text\" ng-model=\"$ctrl.source\" class=\"form-control\" placeholder=\"Enter URL\"> \n\t\t\t\t<div class=\"image-source-wrapper\">\n\t\t\t\t\t<img class=\"image-control\" ng-if=\"$ctrl.source\" onerror=\"this.src='assets/images/image.png'\" ng-src=\"{{$ctrl.source}}\"/>\n\t\t\t\t</div>\n\t\t</div>\n\t\t<div ng-if=\"$ctrl.sourceType == 1\">\n\t\t\t\t<span class=\"btn btn-default upload-btn\">\n\t\t\t\t\t<i class=\"fa fa-upload\"></i>\n\t\t\t\t\t<span>{{ $ctrl.image.file.name || 'Select Image' }}</span>\n\t\t\t\t\t<input id=\"inputImage\" type=\"file\" accept=\"image/*\" image=\"$ctrl.image\" size=\"2097152\"/>\n\t\t\t\t</span>\n\t\t\t\t<span ng-if=\"$ctrl.image.sizeExp\" class=\"exp\">File size exceeded.</span>\n\t\t\t\t<span ng-if=\"$ctrl.image.typeExp\" class=\"exp\">File type not supported.</span>\n\t\t\t\t<div class=\"image-source-wrapper\">\n\t\t\t\t\t<img class=\"image-control\" ng-show=\"$ctrl.image\" src=\"{{$ctrl.image.dataURL}}\" onerror=\"this.src='assets/images/image.png'\"/>\n\t\t\t\t\t<img class=\"image-control\" ng-if=\"$ctrl.source && !$ctrl.image\" onerror=\"this.src='assets/images/image.png'\" ng-src=\"{{$ctrl.source}}\"/>\n\t\t\t\t\t<p>You can upload logo in any image format (e.g. .jpg, .jpeg, .png, etc..). File size should not exceed 2MB.</p>\n\t\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button class=\"btn btn-danger\" type=\"button\" ng-click=\"$ctrl.save($ctrl.sourceType == 0 ? $ctrl.source : $ctrl.image.dataURL)\" translate=\"save\" ng-disabled=\"$ctrl.image.sizeExp || $ctrl.image.typeExp\">Save</button>\n\t\t<button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.cancel()\" translate=\"cancel\">Cancel</button>\n\t</div>\n</script>\n\n\n<script type=\"text/ng-template\" id=\"codeEditor.html\">\n\t<div class=\"modal-header\">\n\t\t<h3 class=\"modal-title\">Code Editor</h3>\n\t\t<button class=\"btn btn-default resize-btn\" type=\"button\" ng-if=\"!$ctrl.maximized\" title=\"Maximize\" ng-click=\"$ctrl.maximize()\">\n            <i class=\"fa fa-expand\"></i>\n        </button>\n        <button class=\"btn btn-default resize-btn\" type=\"button\" ng-if=\"$ctrl.maximized\" title=\"Minimize\" ng-click=\"$ctrl.minimize()\">\n            <i class=\"fa fa-compress\"></i>\n        </button>\n\t\t<button class=\"btn btn-default resize-btn\" type=\"button\" ng-disabled=\"$ctrl.isPasteDisabled()\" ng-click=\"$ctrl.pasteBlockly()\" title=\"Paste\"><i class=\"fa fa-lg fa-paste\"></i></button>\n\t\t<button class=\"btn btn-default resize-btn\" type=\"button\" ng-click=\"$ctrl.copyBlockly()\" title=\"Copy\"><i class=\"fa fa-lg fa-copy\"></i></button>\n\t</div>\n\t<div class=\"modal-body code-editor-modal\" ng-class=\"{'loading': $ctrl.showSpinner }\">\n\t\t<asite-blockly id=\"blocklyCodeEditor\" maximized=\"$ctrl.maximized\"></asite-blockly>\n\t</div>\n\n\t<div class=\"modal-footer\">\n\t\t<button class=\"btn btn-danger\" type=\"button\" ng-click=\"$ctrl.save()\" translate=\"ok\">OK</button>\n\t\t<button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.cancel()\" translate=\"cancel\">Cancel</button>\n\t</div>\n</script>"

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var angular = __webpack_require__(1);
	var _ = __webpack_require__(23);
	/**
	 * Toolbox for adding controls into view.
	 *
	 * @export
	 * @class ToolboxComponent
	 */
	var ToolboxComponent = (function () {
	    /**
	     * Creates an instance of ToolboxComponent.
	     *
	     * @param {any} localStorage
	     *
	     * @memberOf ToolboxComponent
	     */
	    ToolboxComponent.$inject = ['localStorage', 'Util', 'counterService'];
	    function ToolboxComponent(localStorage, Util, counterService) {
	        var _this = this;
	        this.counter = {};
	        this.$onInit = function () {
	            if (this.showsection.components) {
	                this.selectedType = 'components';
	            }
	        };
	        this.store = localStorage;
	        this.models = angular.copy(this.store.get('components'));
	        this.templateComponents = angular.copy(this.store.get('templates'));
	        this.selectedView = this.store.get('selectedView');
	        this.counter = counterService.counter;
	        this.selectedType = 'controls';
	        counterService.removeCallBacks();
	        counterService.setCallBack(function () {
	            for (var i = 0; i < _this.models.items.length; i++) {
	                _this.setFieldName(_this.models.items[i]);
	            }
	        });
	        this.searchText = '';
	        this.Util = Util;
	    }
	    ToolboxComponent.prototype.onDragstart = function () {
	        var selected = this.Util.returnSelected(this.selectedView.view.controls.A);
	        if (selected.length) {
	            for (var i = 0; i < selected.length; i++) {
	                selected[i].selected = false;
	            }
	        }
	    };
	    ToolboxComponent.prototype.setFieldName = function (item) {
	        if (this.Util.controlsWithoutFieldName.indexOf(item.type) != -1 || this.counter[item.type] == undefined) {
	            return;
	        }
	        var fieldName = _.get(item, "properties.Basic['Field Name'].selectedValue", '');
	        fieldName = fieldName.split('_');
	        if (!isNaN(parseInt(fieldName[fieldName.length - 1]))) {
	            fieldName.pop();
	        }
	        if (this.counter[item.type] == 0) {
	            fieldName = "" + fieldName.join('_');
	        }
	        else {
	            fieldName = fieldName.join('_') + "_" + this.counter[item.type];
	        }
	        _.set(item, "properties.Basic['Field Name'].selectedValue", fieldName);
	        _.set(item, "properties.Basic['Field Name'].prevSelectedValue", fieldName);
	        if (item.properties && item.properties.Basic && item.properties.Basic['Data Field Name']) {
	            _.set(item, "properties.Basic['Data Field Name'].selectedValue", fieldName);
	            _.set(item, "properties.Basic['Data Field Name'].prevSelectedValue", fieldName);
	        }
	    };
	    ToolboxComponent.prototype.updateFieldName = function (item) {
	        if (this.Util.controlsWithoutFieldName.indexOf(item.type) != -1) {
	            return;
	        }
	        if (this.counter[item.type] == undefined) {
	            this.counter[item.type] = 0;
	        }
	        this.counter[item.type]++;
	        var fieldName = _.get(item, "properties.Basic['Field Name'].selectedValue", '');
	        fieldName = fieldName.split('_');
	        if (!isNaN(parseInt(fieldName[fieldName.length - 1]))) {
	            fieldName.pop();
	        }
	        if (this.counter[item.type] == 0) {
	            fieldName = "" + fieldName.join('_');
	        }
	        else {
	            fieldName = fieldName.join('_') + "_" + this.counter[item.type];
	        }
	        _.set(item, "properties.Basic['Field Name'].selectedValue", fieldName);
	        _.set(item, "properties.Basic['Field Name'].prevSelectedValue", fieldName);
	        if (item.properties && item.properties.Basic && item.properties.Basic['Data Field Name']) {
	            _.set(item, "properties.Basic['Data Field Name'].selectedValue", fieldName);
	            _.set(item, "properties.Basic['Data Field Name'].prevSelectedValue", fieldName);
	        }
	    };
	    return ToolboxComponent;
	}());
	exports.ToolboxComponent = ToolboxComponent;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('directives.toolbox', [])
	    .component('toolbox', {
	    template: __webpack_require__(256),
	    controller: ToolboxComponent,
	    bindings: {
	        opendialog: '&',
	        showsection: '<'
	    }
	})
	    .name;


/***/ }),
/* 256 */
/***/ (function(module, exports) {

	module.exports = "<ul class=\"nav nav-tabs a-tabs\">\n    <li class=\"nav-item control-tab\" ng-if=\"!$ctrl.showsection.components\">\n        <a class=\"nav-link active\" ng-click=\"$ctrl.selectedType ='controls'\" aria-current=\"page\" href=\"#\"\n            translate=\"controls\">CONTROLS</a>\n    </li>\n    <li class=\"nav-item component-tab\" ng-if=\"($ctrl.showsection.components)\">\n        <a class=\"nav-link\" ng-click=\"$ctrl.selectedType ='components'\" href=\"#\">COMPONENTS</a>\n    </li>\n</ul>\n<div class=\"scroller-outer\" ng-if=\"$ctrl.selectedType =='controls' && !$ctrl.showsection.components\">\n    <div class=\"scroller\">\n        <div class=\"scroller-inner\">\n            <div class=\"control-items-wrapper\">\n                <div ng-repeat=\"item in $ctrl.models.items | filter: {type: $ctrl.searchText} \"\n                    ng-if=\"item.type != 'Section'\"\n                    dnd-dragstart=\"$ctrl.onDragstart()\" dnd-draggable=\"item\" dnd-effect-allowed=\"copy\"\n                    dnd-copied=\"item.id = item.id + 1;$ctrl.updateFieldName(item)\" class=\"control-items\">\n                    <i ng-class=\"item.cssclass\"></i>\n                    <p class=\"menu-item\">{{item.label | translate}}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"scroller-outer\" ng-if=\"$ctrl.selectedType == 'components'\">\n    <div class=\"scroller\">\n        <div class=\"scroller-inner\">\n            <div class=\"control-items-wrapper\">\n                <div ng-repeat=\"template in $ctrl.templateComponents.items\"\n                ng-style=\"$ctrl.selectedType == 'components' && {'cursor': 'pointer'}\"\n                    ng-click=\"$ctrl.opendialog({templateItem : template.name})\" class=\"control-items\">\n                    <i ng-class=\"template.cssclass\"></i>\n                    <p class=\"menu-item\">{{template.label | translate}}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var angular = __webpack_require__(1);
	var ReviewComponent = (function () {
	    ReviewComponent.$inject = ['localStorage', '$http', '$filter', 'Notification', '$uibModal', '$document', 'Util', '$window', '$translate', '$rootScope', 'config', '$scope', '$sce', '$timeout'];
	    function ReviewComponent(localStorage, $http, $filter, Notification, $uibModal, $document, Util, $window, $translate, $rootScope, config, $scope, $sce, $timeout) {
	        this.reviewSections = [];
	        this.summary = false;
	        this.isValid = true;
	        this.totalSearchable = 0;
	        this.reviewSecArr = [
	            {
	                sectionTitle: '',
	                sectionSearchable: false,
	                sectionWeightage: 0,
	                questions: [{
	                        reviewquestion: '',
	                        reviewoptions: ['rating', 'yes-no'],
	                        reviewanswer: '',
	                        showComment: false
	                    }]
	            }
	        ];
	        this.$onInit = function () {
	            if (this.resolve.modalData.config.sectionAvailibility && this.resolve.modalData.config.sectionAvailibility.components) {
	                this.hideORITitle();
	            }
	            if (this.resolve.modalData.selectedView.view.controls.A && this.resolve.modalData.selectedView.view.controls.A.length > 1) {
	                var existingSecs = this.getExistingSections(this.resolve.modalData.selectedView.view.controls.A);
	                if (!this.resolve.modalData.hasOwnProperty('summary')) {
	                    this.resolve.modalData.summary = this.resolve.modalData.selectedView.view.controls.A.some(function (element) {
	                        var fieldName = element['properties']['Basic']['Field Name'].selectedValue;
	                        return fieldName === 'DescriptionTextarea0';
	                    });
	                }
	                this.resolve.modalData.summary && (this.summary = this.resolve.modalData.summary);
	                if (existingSecs.length > 0) {
	                    for (var i = 0; i < existingSecs.length; i++) {
	                        var questionSections = this.getExistingSections(existingSecs[i].data.elems[0], 'Question_Section'), questionList = [];
	                        for (var j = 0; j < questionSections.length; j++) {
	                            questionList.push(this.getQuestionSection(questionSections[j]));
	                        }
	                        var sectitle = existingSecs[i].data.elems[0][0].data[0].elems[0][0].properties['Basic'];
	                        var secSearch = existingSecs[i].data.elems[0][0].data[1].elems[0][1];
	                        var sectionObj = {
	                            sectionTitle: sectitle['Text'] ? sectitle['Text'].selectedValue : sectitle['Label'].selectedValue,
	                            sectionWeightage: existingSecs[i].data.elems[0][0].data[1].elems[0][0].properties['Basic'].Value.selectedValue,
	                            sectionSearchable: false,
	                            questions: questionList
	                        };
	                        if (secSearch) {
	                            var secSearchVal = secSearch.properties['Data Source'].table.list[0].Default.name;
	                            sectionObj.sectionSearchable = secSearchVal;
	                            if (sectionObj.sectionSearchable && sectionObj.sectionSearchable) {
	                                this.totalSearchable = this.totalSearchable + 1;
	                            }
	                        }
	                        this.reviewSections.push(sectionObj);
	                    }
	                }
	                else {
	                    this.reviewSections = this.reviewSecArr;
	                }
	            }
	            else {
	                this.reviewSections = this.reviewSecArr;
	            }
	        };
	        this.ngNotification = Notification;
	    }
	    ReviewComponent.prototype.hideORITitle = function () {
	        var oriControl = this.resolve.modalData.selectedView.view.controls.A[0];
	        oriControl.properties['Display']['Hidden'].selectedValue = true;
	    };
	    ReviewComponent.prototype.save = function (myForm) {
	        if (myForm.$invalid) {
	            this.isValid = false;
	            return;
	        }
	        this.isValid = true;
	        var isEmoji = false;
	        var weightage = 0;
	        var controlLength = this.resolve.modalData.selectedView.view.controls.A.length;
	        var selectedItems = this.resolve.modalData.selectedView.view.controls.A;
	        var existingSecs = this.getExistingSections(this.resolve.modalData.selectedView.view.controls.A);
	        for (var k = 0; k < this.reviewSections.length; k++) {
	            isEmoji = this.validateForEmojies(this.reviewSections[k].sectionTitle);
	            if (isEmoji) {
	                return;
	            }
	            if (this.reviewSections[k].questions.length) {
	                for (var _i = 0, _a = this.reviewSections[k].questions; _i < _a.length; _i++) {
	                    var question = _a[_i];
	                    isEmoji = this.validateForEmojies(question.reviewquestion);
	                    if (isEmoji) {
	                        return;
	                    }
	                }
	            }
	            if (+this.reviewSections[k].sectionWeightage != 0) {
	                weightage = weightage + +this.reviewSections[k].sectionWeightage;
	            }
	            else {
	                this.ngNotification.error({ message: 'Weightage is mandatory.', positionX: 'center', replaceMessage: true });
	                return;
	            }
	        }
	        if (+weightage.toFixed(2) === 1.00) {
	            if (existingSecs.length > 0 && this.reviewSections.length > 0) {
	                selectedItems.splice(1, controlLength - 1);
	            }
	            var reviewOrgField = this.getControl(0, 'Review For:', 'Display field', null, 'Reviewee_Org_Name');
	            reviewOrgField.properties['Basic']['DSName'].selectedValue = 'DS_ASI_SPMREVIEWEEORGID';
	            reviewOrgField.properties['Basic']['Value'].selectedValue = '{{DS_ASI_SPMREVIEWEEORGID}}';
	            reviewOrgField.properties['Style']['font-style-group'].members['font-size'].selectedValue = 14;
	            reviewOrgField.properties['Style']['style-group'].members['bold'].selectedValue = false;
	            reviewOrgField.properties['ControlStyle']['font-style-group'].members['font-size'].selectedValue = 14;
	            reviewOrgField.properties['ControlStyle']['style-group'].members['bold'].selectedValue = false;
	            selectedItems.push(reviewOrgField);
	            for (var i = 0; i < this.reviewSections.length; i++) {
	                weightage = weightage + this.reviewSections[i].sectionWeightage;
	                var sectionField = this.getSections(this.reviewSections[i], i);
	                selectedItems.push(sectionField);
	            }
	            var summaryField = this.getControl(0, 'Summary', 'Text-Area', '', 'DescriptionTextarea');
	            var summaryAttachmentField = this.getControl(0, '', 'Attachment', '', 'DescriptionAddFiles');
	            if (this.summary) {
	                selectedItems.push(summaryField);
	                selectedItems.push(summaryAttachmentField);
	            }
	            var approversComment = this.getControl('', 'Review Comment (only visible when approving/rejecting reviews)', 'Text-Area', '', 'approversComment');
	            approversComment.properties['Display']['Hidden'].selectedValue = true;
	            selectedItems.push(approversComment);
	            this.resolve.modalData.globleScript = {
	                "scriptVal": " window.console && window.console.log && window.console.log(( window.getSystemFieldValue && window.getSystemFieldValue('DS_SPM_TEMPLATE_DETAILS') ));\n",
	                "xmlVal": "<xml xmlns=\"https://developers.google.com/blockly/xml\"><block type=\"text_console\" id=\"5CRL8DMCK%Zfm(bHjun]\" x=\"29\" y=\"149\"><value name=\"TEXT\"><shadow type=\"text\" id=\"G{-4B_k[#a%:H`*t8$Bo\"><field name=\"TEXT\">abc</field></shadow><block type=\"sp_value_getter\" id=\"c33oG|/ghhW*%-SMj#yc\"><field name=\"SP_NAME\">DS_SPM_TEMPLATE_DETAILS</field></block></value></block></xml>",
	                "systemFields": [
	                    "DS_SPM_TEMPLATE_DETAILS"
	                ],
	                "autoNumberFieldDetail": {},
	                "isAPIInProgress": false
	            };
	            this.resolve.modalData.summary = this.summary;
	            this.modalInstance.close(this.reviewSections);
	        }
	        else {
	            this.ngNotification.error({ message: 'Total weightage should be 1', positionX: 'center', replaceMessage: true });
	        }
	    };
	    ;
	    ReviewComponent.prototype.validateForEmojies = function (str) {
	        var regexToFindEmoji = new RegExp('[\\u{1F600}-\\u{1F64F}\\u{2700}-\\u{27BF}\\u{1F680}-\\u{1F6FF}\\u{24C2}-\\u{1F251}\\u{1F30D}-\\u{1F567}\\u{1F900}-\\u{1F9FF}\\u{1F300}-\\u{1F5FF}]', 'gu');
	        if (regexToFindEmoji.test(str)) {
	            this.ngNotification.error({ message: 'Emojis not allowed!', positionX: 'center', replaceMessage: true });
	            return true;
	        }
	        return false;
	    };
	    ReviewComponent.prototype.selectSearch = function (sectionData) {
	        if (sectionData.sectionSearchable) {
	            this.totalSearchable = this.totalSearchable + 1;
	        }
	        else {
	            this.totalSearchable = this.totalSearchable - 1;
	        }
	        if (this.totalSearchable > 2) {
	            sectionData.sectionSearchable = false;
	            this.totalSearchable = this.totalSearchable - 1;
	            this.ngNotification.primary({
	                message: "Max 2 section can be set as 'Searchable'. Please de-select one to select this section.",
	                positionX: 'center',
	                replaceMessage: true
	            });
	        }
	    };
	    ReviewComponent.prototype.getWeightage = function (sections) {
	        var weightage = 0;
	        for (var i = 0; i < sections.length; i++) {
	            var weigthVal = sections[i].data.elems[0][0].data[1].elems[0][0].properties['Basic'].Value.selectedValue;
	            weightage = parseFloat(weigthVal) + weightage;
	        }
	        return weightage;
	    };
	    ReviewComponent.prototype.getExistingSections = function (controls, questionSecStr) {
	        var sectionStr = questionSecStr ? questionSecStr : 'Review_Section';
	        var filteredControls = controls.filter(function (sec) { return sec.type == 'Section'; });
	        var sections = filteredControls.filter(function (ctrl) { return (ctrl.properties.Basic['Field Name'].selectedValue).indexOf(sectionStr) != -1; });
	        return sections;
	    };
	    ReviewComponent.prototype.getSections = function (section, idx) {
	        var sectionItm = this.getControl(idx, section.sectionTitle, 'Section', '', 'Review_Section');
	        var sectionItmTitle = this.getControl(idx, section.sectionTitle, 'Display field', '', 'Section_Title');
	        var sectionItmLayout = this.getControl(idx, section.sectionTitle, 'Layout', '', 'Section_Layout');
	        var sectionWeightage = this.getControl(idx, section.sectionTitle, 'Textbox', '', 'Section_Weightage');
	        sectionWeightage.properties['Basic'].Value.selectedValue = section.sectionWeightage;
	        sectionWeightage.properties['Display']['Read-only'].selectedValue = true;
	        sectionWeightage.properties['Basic']['Validate'].selectedValue = "Decimal";
	        sectionWeightage.properties.Basic.Required.selectedValue = true;
	        sectionWeightage.properties['Display']['Hidden'].selectedValue = true; // Hiding the section weightage 
	        sectionWeightage.properties['Basic']['Label'].selectedValue = 'Weightage';
	        var sectionSearchable = this.getControl(idx, section.sectionTitle, 'Checkbox', '', 'Section_Searchable');
	        if (section.sectionSearchable) {
	            sectionSearchable.properties['Data Source'].table.list[0].Default.name = section.sectionSearchable;
	            sectionSearchable.properties['Data Source'].table.list[0].selectedValue.name = section.sectionSearchable;
	        }
	        sectionSearchable.properties['Display']['Hidden'].selectedValue = true;
	        sectionItmLayout.data[0].elems[0].push(sectionItmTitle);
	        sectionItmLayout.data[1].elems[0].push(sectionWeightage);
	        sectionItmLayout.data[1].elems[0].push(sectionSearchable);
	        sectionItm.data.elems[0].push(sectionItmLayout);
	        var lineItem = angular.copy(this.resolve.modalData.models.items.filter(function (val) { return val.type == "Line"; })[0]);
	        sectionItm.data.elems[0].push(lineItem);
	        if (section.questions.length && section.questions.length > 0) {
	            for (var j = 0; j < section.questions.length; j++) {
	                var questionItem = this.getQuestions(section.questions[j], idx, j);
	                sectionItm.data.elems[0].push(questionItem);
	            }
	        }
	        return sectionItm;
	    };
	    ReviewComponent.prototype.getQuestionSection = function (question) {
	        var questionControl = question.data.elems[0][0].data[0].elems[0][0];
	        var questionObj = {
	            reviewquestion: questionControl.properties['Basic']['Label'].selectedValue,
	            reviewoptions: ['rating', 'yes-no'],
	            reviewanswer: questionControl.type == 'Rating' ? 'rating' : 'yes-no',
	            showComment: false
	        };
	        if (question.data.elems[0][0].data[1] && question.data.elems[0][0].data[1].elems[0][0] && question.data.elems[0][0].data[1].elems[0][0].optionsList[0][0]["Value"].name === 'addComment') {
	            questionObj.showComment = true;
	        }
	        if (question.data.elems[0][1].type === 'Layout' && question.data.elems[0][1].data.length === 4 && question.data.elems[0][1].data[3].elems[0]) {
	            questionObj.showComment = true;
	        }
	        return questionObj;
	    };
	    ReviewComponent.prototype.getQuestions = function (question, idx, j) {
	        var questionTitle = question.reviewquestion;
	        var questionItem = this.getControl(idx, questionTitle, 'Section', j, 'Question_Section');
	        var layoutItem = this.getControl(idx, questionTitle, 'Layout', j, 'Question_Layout');
	        var ratingCommentLayout = this.getControl(idx, questionTitle, 'Layout', j, 'rating_comment_layout');
	        var radioItem = this.getControl(idx, questionTitle, 'Radio', j, 'Question');
	        var ratingItem = this.getControl(idx, questionTitle, 'Rating', j, 'Question');
	        var addCommentCheckboxItem = this.getControl(idx, 'Add_Comment', 'Checkbox', j, 'Add_Comment');
	        var textAreaItem = this.getControl(idx, 'Comment', 'Text-Area', j, 'Comments');
	        var attachmentItem = this.getControl(idx, 'Attachment', 'Attachment', j, 'Attachment');
	        var checkboxItem = this.getControl(idx, questionTitle, 'Checkbox', j, 'Weightage_Not_Applicable');
	        var lineItem = angular.copy(this.resolve.modalData.models.items.filter(function (val) { return val.type == "Line"; })[0]);
	        if (question.reviewanswer == 'yes-no') {
	            layoutItem.data[0].elems[0].push(radioItem);
	            if (question.showComment) {
	                layoutItem.data[1].elems[0].push(addCommentCheckboxItem);
	            }
	        }
	        else if (question.showComment && question.reviewanswer === 'rating') {
	            layoutItem.data[0].elems[0].push(ratingItem);
	            ratingCommentLayout.data[0].elems[0].push(checkboxItem);
	            ratingCommentLayout.data[3].elems[0].push(addCommentCheckboxItem);
	        }
	        else {
	            layoutItem.data[0].elems[0].push(ratingItem);
	            layoutItem.data[1].elems[0].push(checkboxItem);
	        }
	        questionItem.data.elems[0].push(layoutItem);
	        question.showComment && question.reviewanswer === 'rating' && questionItem.data.elems[0].push(ratingCommentLayout);
	        question.showComment && questionItem.data.elems[0].push(textAreaItem);
	        question.showComment && questionItem.data.elems[0].push(attachmentItem);
	        questionItem.data.elems[0].push(lineItem);
	        return questionItem;
	    };
	    ReviewComponent.prototype.getControl = function (idx, title, type, questionIndex, fieldName) {
	        if (questionIndex >= 0 && questionIndex != '') {
	            idx = idx + '_' + questionIndex;
	        }
	        switch (type) {
	            case 'Section':
	                var sectionControl = angular.copy(this.resolve.modalData.models.items.filter(function (val) { return val.type == type; })[0]);
	                if (sectionControl && sectionControl.properties) {
	                    sectionControl.properties['Basic']['Field Name'].selectedValue = fieldName + idx;
	                    sectionControl.properties['Basic']['Data Field Name'].selectedValue = fieldName + idx;
	                    sectionControl.uid = this.resolve.modalData.Util.getGUID();
	                }
	                return sectionControl;
	            case 'Label':
	                var labelControl = angular.copy(this.resolve.modalData.models.items.filter(function (val) { return val.type == type; })[0]);
	                if (labelControl && labelControl.properties) {
	                    labelControl.properties['Basic']['Field Name'].selectedValue = fieldName + idx;
	                    labelControl.properties['Basic']['Text'].selectedValue = title;
	                    labelControl.uid = this.resolve.modalData.Util.getGUID();
	                }
	                return labelControl;
	            case 'Display field':
	                var displayFieldControl = angular.copy(this.resolve.modalData.models.items.filter(function (val) { return val.type == type; })[0]);
	                if (displayFieldControl && displayFieldControl.properties) {
	                    displayFieldControl.properties['Basic']['Field Name'].selectedValue = fieldName + idx;
	                    displayFieldControl.properties['Basic']['Label'].selectedValue = title;
	                    displayFieldControl.properties['Style']['font-style-group'].members['font-size'].selectedValue = 24;
	                    displayFieldControl.properties['Style']['style-group'].members['bold'].selectedValue = true;
	                    displayFieldControl.uid = this.resolve.modalData.Util.getGUID();
	                }
	                return displayFieldControl;
	            case 'Layout':
	                var layoutControl = angular.copy(this.resolve.modalData.models.items.filter(function (val) { return val.type == type; })[0]);
	                if (layoutControl && layoutControl.properties) {
	                    layoutControl.properties['Basic']['Field Name'].selectedValue = fieldName + idx;
	                    layoutControl.width = { 0: '79%' };
	                    layoutControl.properties['Display']['Border'].selectedValue = "0px solid #ccc";
	                    layoutControl.uid = this.resolve.modalData.Util.getGUID();
	                    if (fieldName === "rating_comment_layout") {
	                        layoutControl.width = {};
	                        layoutControl.data.push({ elems: [[]] });
	                        layoutControl.data.push({ elems: [[]] });
	                    }
	                }
	                return layoutControl;
	            case 'Textbox':
	                var textboxControl = angular.copy(this.resolve.modalData.models.items.filter(function (val) { return val.type == type; })[0]);
	                if (textboxControl && textboxControl.properties) {
	                    textboxControl.properties['Basic']['Field Name'].selectedValue = fieldName + idx;
	                    textboxControl.properties['Basic']['Data Field Name'].selectedValue = fieldName + idx;
	                    textboxControl.properties['Basic']['Label'].selectedValue = '';
	                    textboxControl.uid = this.resolve.modalData.Util.getGUID();
	                }
	                return textboxControl;
	            case 'Radio':
	                var radioControl = angular.copy(this.resolve.modalData.models.items.filter(function (val) { return val.type == type; })[0]);
	                if (radioControl && radioControl.properties) {
	                    radioControl.properties['Basic']['Field Name'].selectedValue = fieldName + idx;
	                    radioControl.properties['Basic']['Data Field Name'].selectedValue = fieldName + idx;
	                    radioControl.properties['Basic']['Number'].selectedValue = 3;
	                    radioControl.properties['Basic']['Label'].selectedValue = title;
	                    radioControl.properties['Style']['style-group'].members['bold'].selectedValue = true;
	                    radioControl.properties['Margin']['margin-right'].selectedValue = 155;
	                    radioControl.properties.Basic.Required.selectedValue = true;
	                    radioControl.uid = this.resolve.modalData.Util.getGUID();
	                    if (questionIndex >= 0) {
	                        var optionItem = radioControl.properties['Data Source'].table.list[0];
	                        var optionArr = [];
	                        for (var i = 0; i <= 2; i++) {
	                            var copyItem = angular.copy(optionItem);
	                            if (i == 0) {
	                                copyItem.Label.name = 'Yes';
	                                copyItem.Value.name = 'yes';
	                            }
	                            else if (i == 1) {
	                                copyItem.Label.name = 'No';
	                                copyItem.Value.name = 'no';
	                            }
	                            else if (i == 2) {
	                                copyItem.Label.name = 'Not Applicable';
	                                copyItem.Value.name = 'na';
	                            }
	                            optionArr.push(copyItem);
	                        }
	                        radioControl.properties['Data Source'].table.list = optionArr;
	                    }
	                }
	                return radioControl;
	            case 'Checkbox':
	                var checkboxControl = angular.copy(this.resolve.modalData.models.items.filter(function (val) { return val.type == type; })[0]);
	                if (checkboxControl && checkboxControl.properties) {
	                    checkboxControl.properties['Basic']['Field Name'].selectedValue = fieldName + idx;
	                    checkboxControl.properties['Basic']['Data Field Name'].selectedValue = fieldName + idx;
	                    checkboxControl.properties['Basic']['Label'].selectedValue = '';
	                    if (fieldName.indexOf('Section_Searchable') >= 0) {
	                        var item = checkboxControl.properties['Data Source'].table.list.pop();
	                        item.Label.name = 'searchable';
	                        item.Value.name = 'searchable';
	                        checkboxControl.properties['Data Source'].table.list[0] = item;
	                    }
	                    if (fieldName.indexOf('Add_Comment') >= 0) {
	                        var item = checkboxControl.properties['Data Source'].table.list.pop();
	                        item.Label.name = 'Add Comment';
	                        item.Value.name = 'addComment';
	                        checkboxControl.properties['Data Source'].table.list[0] = item;
	                        var datafieldNameCheckbox = fieldName + idx;
	                        var fieldNameTextArea = 'Comments' + idx;
	                        var fieldNameAttachment = 'Attachment' + idx;
	                        checkboxControl.properties.Events.load.name = 'onLoad';
	                        checkboxControl.properties.Events.load.selectedValue = "if ( (window.getPropValueByDataFieldName && window.getPropValueByDataFieldName('" + datafieldNameCheckbox + "', ))  == 'addComment') {   (window.setPropValue && window.setPropValue('" + fieldNameAttachment + "', 'hidden', false, ));   (window.setPropValue && window.setPropValue('" + fieldNameTextArea + "', 'hidden', false, ));} else {   (window.setPropValue && window.setPropValue('" + fieldNameAttachment + "', 'hidden', true, ));   (window.setPropValue && window.setPropValue('" + fieldNameTextArea + "', 'hidden', true, ));}";
	                        checkboxControl.properties.Events.change.name = 'onChange';
	                        checkboxControl.properties.Events.change.selectedValue = "if ( (window.getPropValueByDataFieldName && window.getPropValueByDataFieldName('" + datafieldNameCheckbox + "', ))  == 'addComment') {   (window.setPropValue && window.setPropValue('" + fieldNameAttachment + "', 'hidden', false, ));   (window.setPropValue && window.setPropValue('" + fieldNameTextArea + "', 'hidden', false, ));} else {   (window.setPropValue && window.setPropValue('" + fieldNameAttachment + "', 'hidden', true, ));   (window.setPropValue && window.setPropValue('" + fieldNameTextArea + "', 'hidden', true, )); (window.setPropValueByDataFieldName && window.setPropValueByDataFieldName('" + fieldNameTextArea + "', '','', )); (window.setPropValueByDataFieldName && window.setPropValueByDataFieldName('" + fieldNameAttachment + "', '','', ));}";
	                    }
	                    if (fieldName.indexOf('Weightage_Not_Applicable') >= 0) {
	                        checkboxControl.properties['Margin']['margin-top'].selectedValue = 0;
	                        checkboxControl.properties['Margin']['margin-right'].selectedValue = 3;
	                        checkboxControl.uid = this.resolve.modalData.Util.getGUID();
	                        if (questionIndex >= 0) {
	                            var item = checkboxControl.properties['Data Source'].table.list.pop();
	                            item.Label.name = 'Not Applicable';
	                            item.Value.name = 'na';
	                            checkboxControl.properties['Data Source'].table.list[0] = item;
	                            var datafieldNameCheckbox = checkboxControl.properties['Basic']['Data Field Name'].selectedValue;
	                            var fieldNameRadio = 'Question' + idx;
	                            checkboxControl.properties.Events.change.name = 'onChange';
	                            checkboxControl.properties.Events.change.selectedValue = "if ( (window.getPropValueByDataFieldName && window.getPropValueByDataFieldName('" + datafieldNameCheckbox + "', ))  == 'na') {   (window.setPropValue && window.setPropValue('" + fieldNameRadio + "', 'readOnly', true, )); (window.setPropValueByDataFieldName && window.setPropValueByDataFieldName('" + fieldNameRadio + "', 1,'', ));} else {   (window.setPropValue && window.setPropValue('" + fieldNameRadio + "', 'readOnly', false, ));}";
	                            checkboxControl.properties.Events.change.name = 'onLoad';
	                            checkboxControl.properties.Events.load.selectedValue = "if ( (window.getPropValueByDataFieldName && window.getPropValueByDataFieldName('" + datafieldNameCheckbox + "', ))  == 'na') {   (window.setPropValue && window.setPropValue('" + fieldNameRadio + "', 'readOnly', true, )); (window.setPropValueByDataFieldName && window.setPropValueByDataFieldName('" + fieldNameRadio + "', 1,'', ));} else {   (window.setPropValue && window.setPropValue('" + fieldNameRadio + "', 'readOnly', false, ));}";
	                        }
	                    }
	                }
	                return checkboxControl;
	            case 'Rating':
	                var ratingControl = angular.copy(this.resolve.modalData.models.items.filter(function (val) { return val.type == type; })[0]);
	                if (ratingControl && ratingControl.properties) {
	                    ratingControl.properties['Basic']['Field Name'].selectedValue = fieldName + idx;
	                    ratingControl.properties['Basic']['Data Field Name'].selectedValue = fieldName + idx;
	                    ratingControl.properties['Basic']['Label'].selectedValue = title;
	                    ratingControl.properties['Style']['style-group'].members['bold'].selectedValue = true;
	                    ratingControl.properties.Basic.Value.selectedValue = 1;
	                    ratingControl.properties.Basic.Min.selectedValue = 1;
	                    ratingControl.properties.Basic.Required.selectedValue = true;
	                    if (this.resolve.modalData.config && this.resolve.modalData.config.sectionAvailibility.components) {
	                        ratingControl.properties.Basic.Max.selectedValue = this.resolve.modalData.config.formDetail.reviewScale ? this.resolve.modalData.config.formDetail.reviewScale : 5;
	                    }
	                    ratingControl.uid = this.resolve.modalData.Util.getGUID();
	                }
	                return ratingControl;
	            case 'Attachment':
	                var attachmentControl = angular.copy(this.resolve.modalData.models.items.filter(function (val) { return val.type == type; })[0]);
	                if (attachmentControl && attachmentControl.properties) {
	                    attachmentControl.properties['Basic']['Field Name'].selectedValue = fieldName + idx;
	                    attachmentControl.properties['Basic']['Data Field Name'].selectedValue = fieldName + idx;
	                    attachmentControl.properties['Basic']['Label'].selectedValue = '';
	                    attachmentControl.uid = this.resolve.modalData.Util.getGUID();
	                }
	                return attachmentControl;
	            case 'Text-Area':
	                var textboxAreaControl = angular.copy(this.resolve.modalData.models.items.filter(function (val) { return val.type == type; })[0]);
	                if (textboxAreaControl && textboxAreaControl.properties) {
	                    textboxAreaControl.properties['Basic']['Field Name'].selectedValue = fieldName + idx;
	                    textboxAreaControl.properties['Basic']['Data Field Name'].selectedValue = fieldName + idx;
	                    textboxAreaControl.properties['Basic']['Label'].selectedValue = title;
	                    textboxAreaControl.properties['Style']['style-group'].members['bold'].selectedValue = true;
	                    textboxAreaControl.uid = this.resolve.modalData.Util.getGUID();
	                }
	                return textboxAreaControl;
	        }
	    };
	    ReviewComponent.prototype.cancel = function () {
	        console.info("in handle dismiss");
	        this.modalInstance.dismiss("cancel");
	    };
	    ;
	    ReviewComponent.prototype.addQuestion = function (index) {
	        this.reviewSections[index].questions.push({
	            reviewquestion: '',
	            reviewoptions: ['rating', 'yes-no'],
	            reviewanswer: '',
	            showComment: false
	        });
	    };
	    ReviewComponent.prototype.addReviewSection = function () {
	        this.reviewSections.push({
	            sectionTitle: '',
	            sectionWeightage: 0,
	            sectionSearchable: false,
	            questions: [{
	                    reviewquestion: '',
	                    reviewoptions: ['rating', 'yes-no'],
	                    reviewanswer: '',
	                    showComment: false
	                }]
	        });
	    };
	    ReviewComponent.prototype.removeQuestion = function (secIdx, index) {
	        this.reviewSections[secIdx].questions.splice(index, 1);
	    };
	    ReviewComponent.prototype.removeReviewSection = function (index) {
	        this.reviewSections.splice(index, 1);
	    };
	    ReviewComponent.prototype.removeInvalidChars = function (e) {
	        if (e.shiftKey === true) {
	            if (e.which == 9) {
	                return true;
	            }
	            e.preventDefault();
	            return false;
	        }
	        if (e.which > 57 || e.which == 45 || e.which == 43) {
	            e.preventDefault();
	            return false;
	        }
	        return true;
	    };
	    ReviewComponent.prototype.onChangeHandler = function (section) {
	        if (!section.sectionWeightage) {
	            return;
	        }
	        var floatValue = parseFloat(section.sectionWeightage);
	        var hasMoreThanTwoDecimals = /\.\d{3,}/.test(section.sectionWeightage);
	        if (isNaN(floatValue) || floatValue < 0 || floatValue > 1) {
	            section.sectionWeightage = 0;
	            return;
	        }
	        section.sectionWeightage = hasMoreThanTwoDecimals ? Math.floor(parseFloat(section.sectionWeightage) * 100) / 100 : section.sectionWeightage;
	    };
	    return ReviewComponent;
	}());
	exports.ReviewComponent = ReviewComponent;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('nodeApp.reviewcomponent', [])
	    .component('reviewcomponent', {
	    template: __webpack_require__(258),
	    css: __webpack_require__(259),
	    controller: ReviewComponent,
	    controllerAs: 'reviewtemplatectrl',
	    bindings: {
	        modalInstance: "<",
	        resolve: "<"
	    },
	})
	    .name;


/***/ }),
/* 258 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"reviewtemplatectrl.cancel()\"><i class=\"fa fa-close\"></i></button>\n    <h3 class=\"modal-title\" translate=\"review-template\">Review Template</h3>\n</div>\n<form class=\"form-group\" name=\"myForm\" novalidate>\n    </div>\n    <div class=\"modal-body r-body\">\n        <div ng-repeat=\"section in reviewtemplatectrl.reviewSections track by $index;\" ng-init=\"$rowIndex = $index\">\n            <span style=\"position: absolute;right:10px;\"><a ng-if=\"reviewtemplatectrl.reviewSections.length > 1\" ng-click=\"reviewtemplatectrl.removeReviewSection($index)\"><i\n                        class=\"fa fa-close\"></i></a></span>\n            <div>\n                <div class=\"form-group\">\n                    <div class=\"section-title sec-mar-10\" style=\"display: inline-block;\">\n                        <label>Add a section title<i class=\"red\">*</i></label>\n                        <div class=\"input-outer\"><input required type=\"text\" ng-model=\"section.sectionTitle\" maxlength=\"50\"\n                                class=\"form-control\" placeholder=\"Add a section title\" ng-class=\"{'required': !section.sectionTitle && !reviewtemplatectrl.isValid}\">\n                            <i class=\"fa fa-remove close-icon\" ng-if=\"section.sectionTitle\"\n                                ng-click=\"section.sectionTitle = ''\"></i>\n                        </div>\n                    </div>\n                    <div class=\"section-weightage sec-mar-10\" style=\"display: inline-block;\">\n                        <label>Weightage<i class=\"red\">*</i></label>\n                        <div class=\"input-outer\">\n                            <input required type=\"text\" ng-model=\"section.sectionWeightage\" class=\"form-control\" ng-class=\"{'required': !section.sectionWeightage && !reviewtemplatectrl.isValid}\" \n                            placeholder=\"Enter Weightage\" ng-change=\"reviewtemplatectrl.onChangeHandler(section)\" ng-keypress=\"reviewtemplatectrl.removeInvalidChars($event)\">\n                        </div>\n                    </div>\n                    <div style=\"display: inline-block;width:21%;\">\n                        <input style=\"margin-right: 8px;\" type=\"checkbox\" ng-model=\"section.sectionSearchable\" ng-change=\"reviewtemplatectrl.selectSearch(section)\" class=\"section-search\"><label>Searchable</label>\n                     </div>\n                </div>\n                <hr>\n                <div ng-repeat=\"question in section.questions track by $index;\">\n                    <span style=\"position: absolute;right:10px;\"><a ng-if=\"section.questions.length > 1\"\n                            ng-click=\"reviewtemplatectrl.removeQuestion($rowIndex,$index)\"><i\n                                class=\"fa fa-close\"></i></a></span>\n                    <div class=\"form-group\">\n                        <div class=\"section-title sec-mar-10\" style=\"display: inline-block;\">\n                            <label>Add review question<i class=\"red\">*</i></label>\n                            <div class=\"input-outer\"><input required type=\"text\" ng-model=\"question.reviewquestion\" ng-class=\"{'required': !question.reviewquestion && !reviewtemplatectrl.isValid}\"\n                                    class=\"form-control\" placeholder=\"Add a question\" />\n                                <i class=\"fa fa-remove close-icon\" ng-if=\"question.reviewquestion\"\n                                    ng-click=\"question.reviewquestion = ''\"></i>\n                            </div>\n                        </div>\n                        <div style=\"display: inline-block;\">\n                            <input style=\"margin-right: 8px;\" type=\"checkbox\" ng-model=\"question.showComment\" class=\"section-search\"><label>Add Comment</label>\n                         </div>\n\n                    </div>\n                    <div class=\"form-group\">\n                        <div class=\"section-title sec-mar-10\">\n                            <label class=\"modal-radio\"><input required type=\"radio\" ng-model=\"question.reviewanswer\"\n                                    value=\"{{question.reviewoptions[0]}}\"><span>{{question.reviewoptions[0] |\n                                    translate}}</span></label>\n                            <label class=\"modal-radio\"><input required type=\"radio\" ng-model=\"question.reviewanswer\"\n                                    value=\"{{question.reviewoptions[1]}}\"><span>{{question.reviewoptions[1] |\n                                    translate}}</span></label>\n                        <p ng-if=\"!question.reviewanswer && !reviewtemplatectrl.isValid\" class=\"red\">Please select either of the options.</p>\n                        </div>\n                    </div>\n\n                </div>\n                <div>\n                    <div class=\"btn modal-add-button sec-mar-10\" ng-click=\"reviewtemplatectrl.addQuestion($index)\">Add\n                        Question<i class=\"fa fa-plus icon-cls\"></i></div>\n                </div>\n            </div>\n            <hr>\n        </div>\n        <div>\n\n        </div>\n    </div>\n\n    <div class=\"modal-footer\">\n        <div class=\"summary-container\">\n            <input type=\"checkbox\" ng-model=\"reviewtemplatectrl.summary\"  class=\"section-search\">\n            <label>Add Summary</label>\n        </div>\n        <div class=\"btn modal-add-button\" ng-click=\"reviewtemplatectrl.addReviewSection()\">Add New Section<i\n                class=\"fa fa-plus icon-cls\"></i></div>\n        <button class=\"btn btn-primary\" type=\"button\" ng-click=\"reviewtemplatectrl.save(myForm)\">Save & Review</button>\n    </div>\n</form>"

/***/ }),
/* 259 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var angular = __webpack_require__(1);
	/**
	 * Manage Views (Add, Edit (View Name), Remove)
	 *
	 * @export
	 * @class ManageViewComponent
	 */
	var ManageViewComponent = (function () {
	    /**
	     * Creates an instance of ManageViewComponent.
	     *
	     * @param {any} localStorage
	     *
	     * @memberOf ManageViewComponent
	     */
	    ManageViewComponent.$inject = ['localStorage', '$uibModal', '$document', 'Util', '$rootScope', 'Notification', '$translate', '$scope'];
	    function ManageViewComponent(localStorage, $uibModal, $document, Util, $rootScope, Notification, $translate, $scope) {
	        /**
	         *
	         *
	         *
	         * @memberOf ManageViewComponent
	         */
	        this.defaultView = {
	            editing: false,
	            controls: {
	                'A': []
	            },
	            viewName: ''
	        };
	        this.$document = $document;
	        this.$uibModal = $uibModal;
	        this.Util = Util;
	        this.store = localStorage;
	        this.views = this.store.get('views');
	        this.viewName = '';
	        this.selectedView = this.store.get('selectedView');
	        this.availableViews = this.Util.getViewNames();
	        this.$rootScope = $rootScope;
	        this.$scope = $scope;
	        this.ngNotification = Notification;
	        this.$translate = $translate;
	    }
	    /**
	     * To add new view.
	     *
	     * @param {*} keyEvent
	     * @param {*} form
	     * @returns {void}
	     *
	     * @memberOf ManageViewComponent
	     */
	    ManageViewComponent.prototype.addView = function (keyEvent, form) {
	        this.clearValidationErrors(form, undefined);
	        if (keyEvent && keyEvent.which != 13) {
	            return;
	        }
	        if (!this.viewName) {
	            form["viewName"].$error.required = true;
	            return;
	        }
	        if (this.views[this.viewName]) {
	            form["viewName"].$error.sameViewNameValidation = true;
	            return;
	        }
	        this.views[this.viewName] = angular.copy(this.defaultView);
	        this.views[this.viewName].viewName = this.viewName;
	        this.viewName = '';
	    };
	    /**
	     * To update selected view name.
	     *
	     * @param {string} key
	     * @param {*} value
	     * @param {*} form
	     * @param {string} index
	     * @param {*} keyEvent
	     * @returns {void}
	     *
	     * @memberOf ManageViewComponent
	     */
	    ManageViewComponent.prototype.updateViewName = function (key, value, form, index, keyEvent) {
	        this.clearValidationErrors(form, index);
	        if (keyEvent && keyEvent.which != 13) {
	            return;
	        }
	        if (!value.key) {
	            form["viewName" + index].$error.required = true;
	            return;
	        }
	        if (key == value.key) {
	            this.views[value.key].editing = false;
	            return;
	        }
	        if (this.views[value.key]) {
	            form["viewName" + index].$error.sameViewNameValidation = true;
	            return;
	        }
	        var temp = angular.copy(this.views[key]);
	        delete this.views[key];
	        this.views[value.key] = temp;
	        this.views[value.key].editing = false;
	        delete this.views[value.key].key;
	        this.selectedView.view = this.views[value.key];
	    };
	    /**
	     * To remove selected view.
	     *
	     * @param {string} key
	     *
	     * @memberOf ManageViewComponent
	     */
	    ManageViewComponent.prototype.deleteView = function (key) {
	        this.ngNotification.warning({
	            message: 'warning.before.remove.view', positionX: 'center', replaceMessage: true, templateUrl: "warning_before_remove_view.html", scope: this.$scope
	        });
	    };
	    ManageViewComponent.prototype.removeView = function (key) {
	        key = key.viewName;
	        var allViews = Object.keys(this.views);
	        var viewControlData;
	        var originalControl = [];
	        if (Object.keys(this.views).length > 0) {
	            // Original control form the deleting view.
	            for (var i = 0; i < this.views[key].controls.A.length; i++) {
	                // Repeating Table, Table, Button and Image
	                if ((this.views[key].controls.A[i].type == "RepeatingTable" && !this.views[key].controls.A[i].hasOwnProperty("copiedFrom") &&
	                    !this.views[key].controls.A[i].hasOwnProperty("pasteAsCalculatedFrom") &&
	                    !this.views[key].controls.A[i].hasOwnProperty("derivedFromFieldName")) ||
	                    ((this.views[key].controls.A[i].type == "Table" || this.views[key].controls.A[i].type == "Button" || this.views[key].controls.A[i].type == "SiteLocationButton" || this.views[key].controls.A[i].type == "Image") &&
	                        (!this.views[key].controls.A[i].hasOwnProperty("copiedFrom") && !this.views[key].controls.A[i].hasOwnProperty("pasteAsCalculatedFrom")))) {
	                    viewControlData = angular.copy(this.views[key].controls.A[i]);
	                    originalControl.push(viewControlData);
	                }
	                else if ((this.views[key].controls.A[i].type == "Label" || this.views[key].controls.A[i].type == "Layout" || this.views[key].controls.A[i].type == "Display field") &&
	                    (!this.views[key].controls.A[i].hasOwnProperty("copiedFrom") && !this.views[key].controls.A[i].hasOwnProperty("forceToReadOnly") && !this.views[key].controls.A[i].hasOwnProperty("pasteAsCalculatedFrom"))) {
	                    viewControlData = angular.copy(this.views[key].controls.A[i]);
	                    originalControl.push(viewControlData);
	                }
	                else if (!this.views[key].controls.A[i].hasOwnProperty("copiedFrom") && this.views[key].controls.A[i].hasOwnProperty("pasteAsCalculated") != true &&
	                    !this.views[key].controls.A[i].hasOwnProperty("pasteAsCalculatedFrom") && !this.views[key].controls.A[i].hasOwnProperty("derivedFromFieldName") && this.views[key].controls.A[i].type != "Line") {
	                    viewControlData = angular.copy(this.views[key].controls.A[i]);
	                    originalControl.push(viewControlData);
	                }
	            }
	            // Logic to check all the view and find the Paste type controls and delete them accordingly.
	            if (originalControl.length) {
	                for (var j = 0; j < allViews.length; j++) {
	                    if (allViews[j] != this.views[key].viewName) {
	                        var currentViewControlLength = this.views[allViews[j]].controls.A.length;
	                        for (var a = 0; a < originalControl.length; a++) {
	                            for (var k = 0; k < currentViewControlLength; k++) {
	                                if (this.views[allViews[j]].controls.A.length > 0 && this.views[allViews[j]].controls.A[k]) {
	                                    // For Paste as ReadOnly Controls.
	                                    if (this.views[allViews[j]].controls.A[k].copiedFrom && originalControl[a].properties.Basic["Field Name"] && this.views[allViews[j]].controls.A[k].copiedFrom == originalControl[a].properties.Basic["Field Name"].selectedValue) {
	                                        this.views[allViews[j]].controls.A.splice(k, 1);
	                                        k--;
	                                    }
	                                    else if (this.views[allViews[j]].controls.A[k].pasteAsCalculated && originalControl[a].properties.Basic["Field Name"] &&
	                                        this.views[allViews[j]].controls.A[k].pasteAsCalculatedFrom == originalControl[a].properties.Basic["Field Name"].selectedValue && this.views[allViews[j]].controls.A[k].type == "Display field") {
	                                        this.views[allViews[j]].controls.A.splice(k, 1);
	                                        k--;
	                                    }
	                                    else if (!this.views[allViews[j]].controls.A[k].hasOwnProperty("pasteAsCalculatedFrom") && this.views[allViews[j]].controls.A[k].pasteAsCalculated && originalControl[a].properties.Basic["Data Field Name"] &&
	                                        this.views[allViews[j]].controls.A[k].properties.Basic.DSName.selectedValue == originalControl[a].properties.Basic["Data Field Name"].selectedValue &&
	                                        this.views[allViews[j]].controls.A[k].type == "Display field") {
	                                        this.views[allViews[j]].controls.A.splice(k, 1);
	                                        k--;
	                                    }
	                                    else if (this.views[allViews[j]].controls.A[k].copiedFrom && originalControl[a].properties.Basic["Field Name"] &&
	                                        this.views[allViews[j]].controls.A[k].copiedFrom == originalControl[a].properties.Basic["Field Name"].selectedValue) {
	                                        this.views[allViews[j]].controls.A.splice(k, 1);
	                                        k--;
	                                    }
	                                    else if (this.views[allViews[j]].controls.A[k].pasteAsCalculatedFrom && originalControl[a].properties.Basic["Field Name"] &&
	                                        this.views[allViews[j]].controls.A[k].pasteAsCalculatedFrom == originalControl[a].properties.Basic["Field Name"].selectedValue) {
	                                        this.views[allViews[j]].controls.A.splice(k, 1);
	                                        k--;
	                                    }
	                                    else if (this.views[allViews[j]].controls.A[k].type == "Hyperlink" && this.views[allViews[j]].controls.A[k].hasOwnProperty("copiedFrom") &&
	                                        !this.views[allViews[j]].controls.A[k].hasOwnProperty("pasteAsCalculatedFrom") && originalControl[a].properties.Basic["Field Name"] && this.views[allViews[j]].controls.A[k].properties.Basic["Field Name"] &&
	                                        this.views[allViews[j]].controls.A[k].properties.Basic["Field Name"].selectedValue == originalControl[a].properties.Basic["Field Name"].selectedValue) {
	                                        this.views[allViews[j]].controls.A.splice(k, 1);
	                                        k--;
	                                    }
	                                    else if (this.views[allViews[j]].controls.A[k].type == "RepeatingTable") {
	                                        // Repeating table Paste as ReadOnly. [ if control having copiedFrom && copiedFromRepeatingTable properties then its paste as ReadOnly control]
	                                        if ((this.views[allViews[j]].controls.A[k].copiedFrom) &&
	                                            (this.views[allViews[j]].controls.A[k].properties.Basic["Field Name"].selectedValue == originalControl[a].properties.Basic["Field Name"].selectedValue)) {
	                                            this.views[allViews[j]].controls.A.splice(k, 1);
	                                            k--;
	                                        }
	                                        else if (this.views[allViews[j]].controls.A[k].derivedFromFieldName == originalControl[a].properties.Basic["Field Name"].selectedValue &&
	                                            this.views[allViews[j]].controls.A[k].properties.Basic.DSName.selectedValue == originalControl[a].properties.Basic["Field Name"].selectedValue) {
	                                            this.views[allViews[j]].controls.A.splice(k, 1);
	                                            k--;
	                                        }
	                                        else if (this.views[allViews[j]].controls.A[k].copiedFromRepeatingTable &&
	                                            this.views[allViews[j]].controls.A[k].properties.Basic["Field Name"].selectedValue == originalControl[a].properties.Basic["Field Name"].selectedValue) {
	                                            delete this.views[allViews[j]].controls.A[k].copiedFromRepeatingTable;
	                                        }
	                                    }
	                                    else if (this.views[allViews[j]].controls.A[k].copiedFromInlieAssoc &&
	                                        this.views[allViews[j]].controls.A[k].properties.Basic["Field Name"].selectedValue == originalControl[a].properties.Basic["Field Name"].selectedValue) {
	                                        delete this.views[allViews[j]].controls.A[k].copiedFromInlieAssoc;
	                                    }
	                                    else if ((this.views[allViews[j]].controls.A[k].type == "Table" || this.views[allViews[j]].controls.A[k].type == "Hyperlink" || this.views[allViews[j]].controls.A[k].type == "Button" || this.views[allViews[j]].controls.A[k].type == "Image")) {
	                                        // For Paste as ReadOnly Controls.
	                                        if (this.views[allViews[j]].controls.A[k].copiedFrom && originalControl[a].properties.Basic["Field Name"] && this.views[allViews[j]].controls.A[k].copiedFrom == originalControl[a].properties.Basic["Field Name"].selectedValue) {
	                                            this.views[allViews[j]].controls.A.splice(k, 1);
	                                            k--;
	                                        }
	                                        else if (_.get(this.views[allViews[j]].controls.A[k], 'data[0][0].elems[0][0]') && _.get(originalControl[a], 'data[0][0].elems[0][0].properties.Basic["Data Field Name"]') && this.views[allViews[j]].controls.A[k].data[0][0].elems[0][0].derivedFromFieldName == originalControl[a].data[0][0].elems[0][0].properties.Basic["Data Field Name"].selectedValue) {
	                                            var controlMatch = false;
	                                            for (var y = 0; y < this.views[allViews[j]].controls.A[k].data.length; y++) {
	                                                for (var z = 0; z < this.views[allViews[j]].controls.A[k].data[y].length; z++) {
	                                                    if (this.views[allViews[j]].controls.A[k].data[y][z].elems[0][0] && this.views[allViews[j]].controls.A[k].data[y][z].elems[0][0].derivedFromFieldName == originalControl[a].data[y][z].elems[0][0].properties.Basic["Data Field Name"].selectedValue) {
	                                                        controlMatch = true;
	                                                    }
	                                                    else {
	                                                        controlMatch = false;
	                                                        break;
	                                                    }
	                                                }
	                                                if (controlMatch == false) {
	                                                    break;
	                                                }
	                                            }
	                                            if (controlMatch == true) {
	                                                this.views[allViews[j]].controls.A.splice(k, 1);
	                                                k--;
	                                            }
	                                        }
	                                    }
	                                    else if (this.views[allViews[j]].controls.A[k].type == "Layout") {
	                                        // For Paste as ReadOnly Controls.
	                                        if (this.views[allViews[j]].controls.A[k].copiedFrom && originalControl[a].properties.Basic["Field Name"] && this.views[allViews[j]].controls.A[k].copiedFrom == originalControl[a].properties.Basic["Field Name"].selectedValue) {
	                                            this.views[allViews[j]].controls.A.splice(k, 1);
	                                            k--;
	                                        }
	                                        else if (_.get(this.views[allViews[j]].controls.A[k], 'data[0].elems[0][0]') && _.get(originalControl[a], 'data[0].elems[0][0].properties.Basic["Data Field Name"]') &&
	                                            !this.views[allViews[j]].controls.A[k].hasOwnProperty("pasteAsCalculatedFrom") &&
	                                            this.views[allViews[j]].controls.A[k].data[0].elems[0][0].derivedFromFieldName == originalControl[a].data[0].elems[0][0].properties.Basic["Data Field Name"].selectedValue) {
	                                            for (var y = 0; y < this.views[allViews[j]].controls.A[k].data.length; y++) {
	                                                if (this.views[allViews[j]].controls.A[k].data[y].elems[0][0] &&
	                                                    this.views[allViews[j]].controls.A[k].data[y].elems[0][0].derivedFromFieldName == originalControl[a].data[y].elems[0][0].properties.Basic["Data Field Name"].selectedValue) {
	                                                    this.views[allViews[j]].controls.A[k].data[y].elems[0] = [];
	                                                }
	                                            }
	                                        }
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        delete this.views[key];
	        if (Object.keys(this.views).length == 0) {
	            var defaultView = angular.copy(this.defaultView);
	            defaultView.viewName = 'ORI_VIEW';
	            this.views['ORI_VIEW'] = defaultView;
	            this.Util.addSubjectField(this.views.ORI_VIEW);
	        }
	        ;
	        this.selectedView.view = this.views[Object.keys(this.views)[0]];
	    };
	    /**
	     * To select view.
	     *
	     * @param {string} key
	     *
	     * @memberOf ManageViewComponent
	     */
	    ManageViewComponent.prototype.selectView = function (key) {
	        this.selectedView.view = this.views[key];
	    };
	    /**
	     * To clear view name validation for selected view.
	     *
	     * @param {*} form
	     * @param {string} [index='']
	     *
	     * @memberOf ManageViewComponent
	     */
	    ManageViewComponent.prototype.clearValidationErrors = function (form, index) {
	        if (index === void 0) { index = ''; }
	        form["viewName" + index].$error.sameViewNameValidation = false;
	        form["viewName" + index].$error.required = false;
	    };
	    ManageViewComponent.prototype.getLanguageSpecificViewName = function (viewName) {
	        return this.Util.getLanguageSpecificViewName(viewName);
	    };
	    ManageViewComponent.prototype.isCustomView = function (viewName) {
	        return !this.availableViews.filter(function (value) {
	            return value.value == viewName;
	        }).length;
	    };
	    ManageViewComponent.prototype.openAddView = function (viewName, update) {
	        if (viewName === void 0) { viewName = ''; }
	        if (update === void 0) { update = false; }
	        var selectedView = this.availableViews.filter(function (value) {
	            return value.value == viewName;
	        });
	        var viewFound = selectedView.length ? selectedView[0] : viewName;
	        var self = this;
	        var modalInstance = this.$uibModal.open({
	            animation: true,
	            ariaLabelledBy: 'modal-title',
	            ariaDescribedBy: 'modal-body',
	            templateUrl: 'addView.html',
	            backdrop: 'static',
	            keyboard: false,
	            controllerAs: '$ctrl',
	            appendTo: angular.element(self.$document[0].querySelector('.manager-view')),
	            controller: function () {
	                this.viewExist = false;
	                this.Value = viewFound;
	                this.availableViews = [];
	                var currentAddedViews = [];
	                var _loop_1 = function(view) {
	                    var selectedView_1 = self.availableViews.filter(function (value) {
	                        return value.value == view;
	                    });
	                    if (selectedView_1.length) {
	                        if (viewName.toLowerCase() != selectedView_1[0].value.toLowerCase()) {
	                            currentAddedViews.push(selectedView_1[0].key.toLowerCase());
	                            currentAddedViews.push(selectedView_1[0].value.toLowerCase());
	                        }
	                    }
	                    else {
	                        if (viewName.toLowerCase() != view.toLowerCase()) {
	                            currentAddedViews.push(view.toLowerCase());
	                        }
	                    }
	                };
	                for (var view in self.views) {
	                    _loop_1(view);
	                }
	                if (self.availableViews.length) {
	                    for (var i = 0; i < self.availableViews.length; i++) {
	                        var view = self.availableViews[i];
	                        if (currentAddedViews.indexOf(view.value.toLowerCase()) == -1) {
	                            this.availableViews.push(view);
	                        }
	                    }
	                }
	                this.save = function () {
	                    var updatedViewName = this.Value;
	                    if (angular.isObject(this.Value)) {
	                        updatedViewName = this.Value.value;
	                    }
	                    else {
	                        var selectedView_2 = self.availableViews.filter(function (value) {
	                            return value.key.toLowerCase() == updatedViewName.toLowerCase();
	                        });
	                        if (selectedView_2.length) {
	                            updatedViewName = selectedView_2[0].value;
	                        }
	                        else {
	                            var validText = self.Util.isValidXMLTagName(updatedViewName);
	                            if (!validText) {
	                                var msg = self.$translate.instant('field.name.validation');
	                                self.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
	                                return;
	                            }
	                        }
	                    }
	                    if (currentAddedViews.indexOf(updatedViewName.toLowerCase()) != -1) {
	                        this.viewExist = true;
	                        return;
	                    }
	                    if (update) {
	                        var temp = angular.copy(self.views[viewName]);
	                        delete self.views[viewName];
	                        self.views[updatedViewName] = temp;
	                        self.views[updatedViewName].editing = false;
	                        self.views[updatedViewName].viewName = updatedViewName;
	                        self.selectedView.view = self.views[updatedViewName];
	                    }
	                    else {
	                        var defaultView = angular.copy(self.defaultView);
	                        defaultView.viewName = updatedViewName;
	                        if (updatedViewName) {
	                            self.views[updatedViewName] = defaultView;
	                            updatedViewName == "ORI_VIEW" && self.Util.addSubjectField(defaultView);
	                        }
	                    }
	                    this.cancel();
	                    self.$rootScope.$broadcast('designViewAdded', { viewName: updatedViewName });
	                };
	                this.cancel = function () {
	                    modalInstance.dismiss('cancel');
	                };
	                this.isObject = angular.isObject;
	            }
	        });
	    };
	    ManageViewComponent.prototype.viewChangeHander = function () {
	        this.$rootScope.$broadcast('onViewChange');
	    };
	    return ManageViewComponent;
	}());
	exports.ManageViewComponent = ManageViewComponent;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('directives.manageview', [])
	    .component('manageview', {
	    template: __webpack_require__(264),
	    controller: ManageViewComponent,
	    bindings: {
	        active: '@',
	        onToolbarClick: '@'
	    }
	})
	    .name;


/***/ }),
/* 264 */
/***/ (function(module, exports) {

	module.exports = "<form class=\"manager-view\" name=\"managerViewForm\">\n    <ul>\n        <li class=\"menu-header\">\n            <span translate=\"views\">VIEWS</span>\n            <a href=\"javascript:void(0)\" ng-click=\"$ctrl.openAddView()\" title=\"{{ 'add.view' | translate }}\" class=\"pull-right add-view\">\n                <i class=\"fa fa-plus-circle\"></i>\n            </a>\n        </li>\n        <li class=\"input-add-view\">\n            <select class=\"form-control\" name=\"viewName\" ng-options=\"view as $ctrl.getLanguageSpecificViewName(key) for (key, view) in $ctrl.views\"\n                ng-model=\"$ctrl.selectedView.view\" ng-change=\"$ctrl.viewChangeHandler();\">\n            </select>\n        </li>\n        <li ng-repeat=\"(key, value) in $ctrl.views\" ng-if=\"$ctrl.selectedView.view == value\" class=\"active\">\n            <div class=\"view-settings-container\">\n                <a href=\"javascript:void(0)\" class=\"settings-icon\" ng-click=\"$ctrl.openAddView(key, true)\" ng-if=\"!value.editing && $ctrl.isCustomView(key)\"\n                    title=\"{{ 'edit' | translate }}\">\n                    <i class=\"fa fa-pencil\"></i>\n                </a>\n                <a href=\"javascript:void(0)\" class=\"settings-icon\" ng-click=\"$ctrl.deleteView(key)\" ng-if=\"!value.editing && value.viewName != 'ORI_VIEW'\" title=\"{{ 'delete' | translate }}\">\n                    <i class=\"fa fa-trash\"></i>\n                </a>\n            </div>\n            <a ng-if=\"!value.editing\" ng-click=\"$ctrl.selectView(key)\">\n                <span class=\"menu-item\" title=\"{{$ctrl.getLanguageSpecificViewName(key)}}\">{{$ctrl.getLanguageSpecificViewName(key)}}</span>\n            </a>\n        </li>\n    </ul>\n</form>\n\n<script type=\"text/ng-template\" id=\"addView.html\">\n\t<div class=\"modal-header\">\n\t\t<h3 class=\"modal-title\" translate=\"view\">View</h3>\n\t</div>\n\t<div class=\"modal-body\"> \n\t\t<div class=\"form-group\">\n\t\t\t<div class=\"auto-complete\">\n\t\t\t\t<input autofocus type=\"text\" class=\"form-control\" ng-model=\"$ctrl.Value\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" uib-typeahead=\"option as option.key for option in $ctrl.availableViews | filter:$viewValue | limitTo:8\" >\n\t\t\t\t<i class=\"fa fa-remove\" ng-if=\"$ctrl.isObject($ctrl.Value)\" ng-click=\"$ctrl.Value = ''\"></i>\n\t\t\t</div>\n            <p class=\"note\" ng-show=\"$ctrl.viewExist\" translate=\"view.exist\">View already exist.</p>\n\t\t</div>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button class=\"btn btn-danger\" type=\"button\" ng-click=\"$ctrl.save()\" ng-dblclick=\"return\" translate=\"ok\">OK</button>\n\t\t<button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.cancel()\" translate=\"cancel\">Cancel</button>\n\t</div>\n</script>\n\n<script type=\"text/ng-template\" id=\"warning_before_remove_view.html\">\n    <div class=\"ui-notification \">\n        <div class=\"message\">\n          <p>You are about to delete {{$ctrl.getLanguageSpecificViewName($ctrl.selectedView.view.viewName)}}, there might be fields and controls referenced to other view/s. Following action will be taken across all views if the view is deleted: </p>\n          <p>1. Controls copied using 'Paste as read only' from this View will be deleted. </p>\n          <p>2. Controls copied using 'Paste as calculated value' from this View will be deleted. </p>\n          <p>3. Value reference will be cleared for all the fields referring to this View. </p>\n          <p>Click on 'Continue' to delete the View, or 'Cancel' to cancel the operation.</p>\n        </div>\n        <div class=\"message clearfix\">\n            <a class=\"btn btn-sm btn-danger pull-right\" ng-click=\"\">Cancel</a>\n            <a class=\"btn btn-sm btn-danger pull-right\" style=\"margin-right: 8px;\" ng-model=\"$ctrl.selectedView.view\" ng-click=\"$ctrl.removeView($ctrl.selectedView.view)\">Continue</a>\n        </div>\n    </div>\n</script>"

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var angular = __webpack_require__(1);
	var HierarchyComponent = (function () {
	    HierarchyComponent.$inject = ['localStorage', '$scope', '$http', '$filter', 'Notification', '$uibModal', '$document', 'Util', '$window', '$rootScope'];
	    function HierarchyComponent(localStorage, $scope, $http, $filter, Notification, $uibModal, $document, Util, $window, $rootScope) {
	        var self = this;
	        this.Util = Util;
	        this.scope = $scope;
	        this.$document = $document;
	        this.$uibModal = $uibModal;
	        this.store = localStorage;
	        this.filter = $filter;
	        this.selectedView = this.store.get('selectedView');
	        this.arrayHierarchy = ['dropdown', 'radio', 'checkbox', 'multidropdown'];
	        this.ngNotification = Notification;
	    }
	    HierarchyComponent.prototype.createRelation = function () {
	        var self = this;
	        var relationModal = this.$uibModal.open({
	            animation: true,
	            ariaLabelledBy: 'modal-title',
	            ariaDescribedBy: 'modal-body',
	            templateUrl: 'Relation.html',
	            backdrop: 'static',
	            keyboard: false,
	            controllerAs: '$hierarchyModal',
	            appendTo: angular.element(self.$document[0].querySelector('.form-builder')),
	            controller: function () {
	                this.oneAtATime = true;
	                this.allElement = {};
	                this.totalRelation = {};
	                this.isTotalRelationLengthExceedOne = false;
	                this.arrayHierarchy = self.arrayHierarchy;
	                this.isObject = angular.isObject;
	                var hierarchyObj = {
	                    selectedParent: '',
	                    selectedChild: '',
	                    parentAttribute: {},
	                    childAttribute: {},
	                    parentList: [],
	                    childList: [],
	                    relationArray: [],
	                    objDataBind: {}
	                };
	                var init = function (_this) {
	                    for (var index = 0, allAttr = self.Util.getIteams(self.selectedView.view.controls.A); index < allAttr.length; index++) {
	                        var element = allAttr[index];
	                        if (_this.arrayHierarchy.indexOf(element.label) > -1) {
	                            _this.allElement[element.properties.Basic["Field Name"].selectedValue || element.label] = element;
	                        }
	                    }
	                    for (var key in _this.allElement) {
	                        onLoadRelation(_this.allElement[key], key);
	                    }
	                    if (Object.keys(_this.totalRelation).length == 0) {
	                        _this.totalRelation['pRow_' + (Object.keys(_this.totalRelation).length + 1)] = angular.copy(hierarchyObj);
	                    }
	                };
	                this.changeParentDropdown = function (obj) {
	                    obj.parentAttribute = this.allElement[obj.selectedParent];
	                    obj.parentList = obj.parentAttribute.properties['Data Source'].table.list;
	                    currentContext.changeChildDropdown(obj);
	                };
	                this.changeChildDropdown = function (obj) {
	                    obj.childAttribute = this.allElement[obj.selectedChild];
	                    if (obj.childAttribute && validateRelation(this.totalRelation)) {
	                        obj.childList = obj.childAttribute.properties['Data Source'].table.list;
	                        createDatabindJson(obj);
	                    }
	                };
	                var isTotalRelationLengthGreaterThanOne = function (obj) {
	                    var objLength = Object.keys(obj);
	                    return objLength.length && objLength.length > 1;
	                };
	                var createDatabindJson = function (obj) {
	                    var relationArray = [];
	                    obj.objDataBind = {};
	                    var count = 0;
	                    for (var index = 0; index < obj.parentList.length; index++) {
	                        var element = obj.parentList[index].relation;
	                        if (element[obj.selectedChild]) {
	                            obj.objDataBind[obj.selectedParent + count] = obj.parentList[index];
	                            obj.objDataBind[obj.selectedChild + count] = element[obj.selectedChild];
	                            relationArray.push('row_' + count);
	                            count++;
	                        }
	                    }
	                    if (relationArray.length == 0) {
	                        relationArray = ['row_0'];
	                    }
	                    obj.relationArray = relationArray;
	                };
	                var onLoadRelation = function (paramObj, parent) {
	                    var relationList = paramObj.properties['Data Source'].table.list, childList = [], hierarchyJson;
	                    for (var index = 0; index < relationList.length; index++) {
	                        for (var key in relationList[index].relation) {
	                            if (key && childList.indexOf(key) < 0) {
	                                childList.push(key);
	                                hierarchyJson = angular.copy(hierarchyObj);
	                                hierarchyJson.selectedParent = parent;
	                                hierarchyJson.selectedChild = key;
	                                currentContext.changeParentDropdown(hierarchyJson);
	                                currentContext.totalRelation['pRow_' + (Object.keys(currentContext.totalRelation).length + 1)] = hierarchyJson;
	                            }
	                        }
	                    }
	                    currentContext.isTotalRelationLengthExceedOne = isTotalRelationLengthGreaterThanOne(currentContext.totalRelation);
	                };
	                this.addParentRow = function (e, index) {
	                    e.preventDefault();
	                    e.stopPropagation();
	                    this.totalRelation['pRow_' + (parseInt(index) + 1)] = angular.copy(hierarchyObj);
	                    this.isTotalRelationLengthExceedOne = isTotalRelationLengthGreaterThanOne(this.totalRelation);
	                };
	                this.removeParentRow = function (e, index) {
	                    e.preventDefault();
	                    e.stopPropagation();
	                    var parentList = this.totalRelation[index].parentList;
	                    for (var i = 0; i < parentList.length; i++) {
	                        parentList[i].relation = {};
	                    }
	                    delete this.totalRelation[index];
	                    this.isTotalRelationLengthExceedOne = isTotalRelationLengthGreaterThanOne(this.totalRelation);
	                };
	                this.filterParentList = function (objParam) {
	                    var parentObj = [];
	                    for (var index = 0; index < objParam.parentList.length; index++) {
	                        var element = objParam.parentList[index];
	                        if (element != objParam.objDataBind[objParam.selectedParent + index]) {
	                            parentObj.push(element);
	                        }
	                    }
	                    return parentObj;
	                };
	                this.addIntoList = function (index, objParam) {
	                    for (var i = 0; i < objParam.parentList.length; i++) {
	                        if (objParam.relationArray.indexOf('row_' + i) < 0) {
	                            objParam.relationArray.push('row_' + i);
	                            break;
	                        }
	                    }
	                };
	                this.removeFromList = function (index, objParam) {
	                    for (var i = 0; i < objParam.relationArray.length; i++) {
	                        if (objParam.relationArray[i] == 'row_' + index) {
	                            objParam.relationArray.splice(i, 1);
	                            delete objParam.objDataBind[objParam.selectedParent + index];
	                            delete objParam.objDataBind[objParam.selectedChild + index];
	                        }
	                    }
	                };
	                this.cancel = function () {
	                    relationModal.close(false);
	                };
	                var validateRelation = function (paramObj) {
	                    for (var key in paramObj) {
	                        for (var key1 in paramObj) {
	                            if (key1 != key) {
	                                if (paramObj[key].selectedChild == paramObj[key1].selectedChild && paramObj[key].selectedParent == paramObj[key1].selectedParent) {
	                                    self.ngNotification.error({
	                                        message: "Same Relation Already Defined", positionX: 'center', replaceMessage: true
	                                    });
	                                    return false;
	                                }
	                                if (paramObj[key].selectedChild == paramObj[key1].selectedParent && paramObj[key].selectedParent == paramObj[key1].selectedChild) {
	                                    self.ngNotification.error({
	                                        message: "Child is not become parent", positionX: 'center', replaceMessage: true
	                                    });
	                                    return false;
	                                }
	                            }
	                        }
	                    }
	                    return true;
	                };
	                this.submitHierarchyData = function () {
	                    for (var key in this.totalRelation) {
	                        var objList = this.totalRelation[key];
	                        if (objList.selectedParent && objList.selectedChild) {
	                            var parentAttrList = this.allElement[objList.selectedParent].properties['Data Source'].table.list;
	                            for (var index = 0; index < parentAttrList.length; index++) {
	                                delete parentAttrList[index].relation[objList.selectedChild];
	                            }
	                            for (var index = 0; index < objList.relationArray.length; index++) {
	                                if (objList.objDataBind[objList.selectedChild + index] != undefined) {
	                                    if (objList.objDataBind[objList.selectedParent + index]) {
	                                        if (objList.objDataBind[objList.selectedChild + index].length > 0) {
	                                            objList.objDataBind[objList.selectedParent + index].relation[objList.selectedChild] = objList.objDataBind[objList.selectedChild + index];
	                                        }
	                                        else {
	                                            self.ngNotification.error({ message: 'No Value(s) selected for Child Attribute(s)', positionX: 'center', replaceMessage: true });
	                                            return;
	                                        }
	                                    }
	                                }
	                                else {
	                                    self.ngNotification.error({ message: 'No Value(s) selected for Child Attribute(s)', positionX: 'center', replaceMessage: true });
	                                    return;
	                                }
	                            }
	                        }
	                    }
	                    this.cancel();
	                };
	                var currentContext = this;
	                init(currentContext);
	            }
	        });
	    };
	    return HierarchyComponent;
	}());
	exports.HierarchyComponent = HierarchyComponent;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('directives.hierarchy', [])
	    .component('hierarchy', {
	    template: __webpack_require__(266),
	    controller: HierarchyComponent,
	    controllerAs: 'attrCtrl'
	}).name;


/***/ }),
/* 266 */
/***/ (function(module, exports) {

	module.exports = "<button id=\"createRelation\" type=\"button\" class=\"btn btn-default\" ng-click=\"attrCtrl.createRelation()\" title=\"Manage Attributes\"><i class=\"fa fa-link\"></i></button>                    \n<script type=\"text/ng-template\" id=\"Relation.html\">\n    <div class=\"modal-header\">\n\t\t<div class=\"modal-title header\"  translate=\"manage.attribute\">Manage Attributes</div>\n\t</div>\n\t<div class=\"modal-body language-modal hierarchy-modal\"> \n\t\t<uib-accordion close-others=\"$hierarchyModal.oneAtATime\">\n            <div uib-accordion-group class=\"panel-default\" ng-repeat=\"(key,objParam) in $hierarchyModal.totalRelation\" ng-init=\"pIndex = key\">\n                <uib-accordion-heading>\n                    <div class=\"attribute_header\">\n                        {{objParam.selectedParent || '-'}} / {{objParam.selectedChild || '-'}} \t\n                        <i ng-if=\"$last\" class=\"fa fa-plus pull-right\" ng-click=\"$hierarchyModal.addParentRow($event,pIndex.split('_')[1]);\"></i>\n                        <i ng-if=\"$hierarchyModal.isTotalRelationLengthExceedOne\" class=\"fa fa-times pull-right\" ng-click=\"$hierarchyModal.removeParentRow($event,pIndex);\"></i>\n                    </div>\n                </uib-accordion-heading>\n                <table class=\"table\" style=\"table-layout: fixed;\" >\n                    <tr>\n                        <td colspan=\"2\">\n                            <select ng-model=\"objParam.selectedParent\" ng-change=\"$hierarchyModal.changeParentDropdown(objParam)\">\n                                <option ng-if=\"$hierarchyModal.arrayHierarchy.indexOf(value.label) > -1 && key != objParam.selectedChild\" ng-repeat=\"(key,value) in $hierarchyModal.allElement\">{{key}}</option>\n                            </select>\n                        </td>\n\n                        <td colspan=\"3\">\n                            <select ng-model=\"objParam.selectedChild\" ng-change=\"$hierarchyModal.changeChildDropdown(objParam)\">\n                                <option ng-if=\"$hierarchyModal.arrayHierarchy.indexOf(value.label) > -1 && key != objParam.selectedParent\" ng-repeat=\"(key,value) in $hierarchyModal.allElement\">{{key}}</option>\n                            </select>\n                        </td>\n                        <td></td>\n                    </tr>\n                    \n                    <tr  ng-repeat=\"list in objParam.relationArray\" class=\"multipleId\" ng-init=\"myVar=list.split('_')[1]\">\n                        <td colspan=\"2\">\n                            <input type=\"text\" ng-model=\"objParam.objDataBind[objParam.selectedParent+myVar]\" typeahead-wait-ms=\"1000\" uib-typeahead=\"option as option.Label.name for option in $hierarchyModal.filterParentList(objParam)\" class=\"form-control\" typeahead-min-length=\"0\">\n                            <i class=\"fa fa-remove removeOption\" ng-if=\"$hierarchyModal.isObject(objParam.objDataBind[objParam.selectedParent+myVar])\" ng-click=\"objParam.objDataBind[objParam.selectedParent+myVar] = ''\"></i>\n                        </td>\n                        <td colspan=\"3\">\n                        <ui-select ng-model=\"objParam.objDataBind[objParam.selectedChild+myVar]\" theme=\"bootstrap\" tagging tagging-label=\"false\" multiple style=\"width:100%;\" >\n                                <ui-select-match >{{$item.Label.name}}</ui-select-match>\n                                <ui-select-choices repeat=\"option.id as option in objParam.childList\">\n                                    <div ng-bind=\"option.Label.name\"></div>\n                                </ui-select-cfhoices>\n                            </ui-select>\n                        </td>\n                        \n                        <td>\n                            <button class=\"btn btn-default btn-sm\" ng-hide=\"objParam.relationArray.length == objParam.parentList.length\" ng-if=\"$last\" type=\"button\"  ng-click=\"$hierarchyModal.addIntoList(myVar,objParam)\" title=\"Add\"><i class=\"fa fa-plus\"></i></button>\n                            <button class=\"btn btn-default btn-sm\" ng-hide=\"objParam.relationArray.length == 1\" type=\"button\" ng-click=\"$hierarchyModal.removeFromList(myVar,objParam)\" title=\"Delete\"><i class=\"fa fa-minus\"></i></button>\n                        </td>\n                    </tr>\n                </table>\n            </div>\n        </uib-accordion>    \n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button class=\"btn btn-danger\" type=\"button\" ng-click=\"$hierarchyModal.submitHierarchyData()\">OK</button>\n\t\t<button class=\"btn btn-default\" type=\"button\" ng-click=\"$hierarchyModal.cancel()\" translate=\"cancel\">Cancel</button>\n\t</div>\n</script>\n\n"

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props_1 = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var CommonPropertyBoxComponent = (function () {
	    CommonPropertyBoxComponent.$inject = ['localStorage', '$scope', '$http', '$filter', 'Notification', '$uibModal', '$document', 'Util', '$window', '$rootScope'];
	    function CommonPropertyBoxComponent(localStorage, $scope, $http, $filter, Notification, $uibModal, $document, Util, $window, $rootScope) {
	        this.showMultiselectPropertybox = function () {
	            var selected = this.Util.returnSelected(this.selectedView.view.controls.A); //  Button to be shown ONLY when atleast one control is selected.
	            return (selected.length == 0);
	        };
	        var self = this;
	        this.Util = Util;
	        this.scope = $scope;
	        this.$document = $document;
	        this.$uibModal = $uibModal;
	        this.store = localStorage;
	        this.filter = $filter;
	        this.selectedView = this.store.get('selectedView');
	        this.ngNotification = Notification;
	        this.StyleObject = Props_1.controlStyleObject;
	        this.MarginObject = Props_1.marginObject;
	        this.LabelObject = Props_1.labelStyleObject;
	        this.PopupPropertiesObject = {
	            Basic: {
	                'Required': {
	                    name: 'required',
	                    selectedValue: false,
	                    type: 'checkbox'
	                }
	            },
	            Display: {
	                'Read-only': {
	                    name: 'read.only',
	                    selectedValue: false,
	                    type: 'checkbox'
	                },
	                'Hidden': {
	                    name: 'hidden',
	                    selectedValue: false,
	                    type: 'checkbox'
	                }
	            },
	            Style: angular.copy(this.LabelObject),
	            ControlStyle: angular.copy(this.StyleObject),
	            Margin: angular.copy(this.MarginObject),
	        };
	    }
	    CommonPropertyBoxComponent.prototype.multiselectPopupProperties = function () {
	        var self = this;
	        var relationModal1 = this.$uibModal.open({
	            animation: true,
	            ariaLabelledBy: 'modal-title',
	            ariaDescribedBy: 'modal-body',
	            templateUrl: 'multiselectPopupProperties.html',
	            backdrop: 'static',
	            keyboard: false,
	            controllerAs: '$commonpropertyboxModal',
	            appendTo: angular.element(self.$document[0].querySelector('.form-builder')),
	            controller: function () {
	                this.cancel = function () {
	                    relationModal1.close(false);
	                };
	                this.popupProperties = self.PopupPropertiesObject;
	                this.submitPopuppropertiesData = function () {
	                    var selectedControlsProperties = self.Util.returnSelected(self.selectedView.view.controls.A); //  Fetching the properties of selected controls.
	                    var mergeExisting = function (controlObject, commonPropertyObject) {
	                        var mutableObject1 = Object.assign({}, controlObject); //  which already exist in the selected controls.
	                        var mutableObject2 = Object.assign({}, commonPropertyObject);
	                        mergeFunction(mutableObject1, mutableObject2);
	                        return mutableObject1;
	                    };
	                    var mergeFunction = function (controlObject, commonPropertyObject) {
	                        Object.keys(commonPropertyObject).forEach(function (key) {
	                            if (key in controlObject) {
	                                if (typeof controlObject[key] === 'object') {
	                                    if (key != 'Name' && key != '$$hashKey') {
	                                        mergeFunction(controlObject[key], commonPropertyObject[key]);
	                                    }
	                                }
	                                else {
	                                    if (key != 'Name' && key != '$$hashKey') {
	                                        controlObject[key] = commonPropertyObject[key];
	                                    }
	                                }
	                            }
	                        });
	                    };
	                    for (var i = 0; i < selectedControlsProperties.length; i++) {
	                        mergeExisting(selectedControlsProperties[i].properties, this.popupProperties);
	                    }
	                    this.cancel();
	                };
	            }
	        });
	    };
	    return CommonPropertyBoxComponent;
	}());
	exports.CommonPropertyBoxComponent = CommonPropertyBoxComponent;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('directives.commonpropertybox', [])
	    .component('commonpropertybox', {
	    template: __webpack_require__(269),
	    controller: CommonPropertyBoxComponent,
	    controllerAs: 'attrCtrl'
	}).name;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var angular = __webpack_require__(1);
	var Searchable = {
	    name: 'searchable',
	    selectedValue: true,
	    type: 'checkbox'
	};
	exports.Searchable = Searchable;
	var Reportable = {
	    name: 'reportable',
	    selectedValue: true,
	    type: 'checkbox'
	};
	exports.Reportable = Reportable;
	var Customizable = {
	    name: 'customizable.column',
	    selectedValue: true,
	    type: 'checkbox'
	};
	exports.Customizable = Customizable;
	var FieldName = {
	    name: 'field.name',
	    selectedValue: '',
	    prevSelectedValue: '',
	    type: 'textbox',
	    onChangeFunction: 'restrictChar',
	    addOnButton: 'fa fa-info'
	};
	function getFieldName(selectedValue) {
	    var fieldName = angular.copy(FieldName);
	    fieldName.selectedValue = selectedValue;
	    fieldName.prevSelectedValue = selectedValue;
	    return fieldName;
	}
	exports.getFieldName = getFieldName;
	var DataFieldName = {
	    name: 'Data-Field-Name',
	    selectedValue: '',
	    prevSelectedValue: '',
	    type: 'textbox',
	    onChangeFunction: 'restrictCharInDataFieldName',
	    addOnButton: 'fa fa-info'
	};
	function getDataFieldName(selectedValue) {
	    var dataFieldName = angular.copy(DataFieldName);
	    dataFieldName.selectedValue = selectedValue;
	    dataFieldName.prevSelectedValue = selectedValue;
	    return dataFieldName;
	}
	exports.getDataFieldName = getDataFieldName;
	var marginObject = {
	    'margin-top': {
	        name: 'top',
	        type: 'number',
	        title: 'margin.size',
	        selectedValue: 5,
	        min: 5,
	        max: 999,
	        default: 0
	    },
	    'margin-bottom': {
	        name: 'bottom',
	        type: 'number',
	        title: 'margin.size',
	        selectedValue: 5,
	        min: 5,
	        max: 999,
	        default: 0
	    },
	    'margin-left': {
	        name: 'left',
	        type: 'number',
	        title: 'margin.size',
	        selectedValue: 5,
	        min: 5,
	        max: 999,
	        default: 0
	    },
	    'margin-right': {
	        name: 'right',
	        type: 'number',
	        title: 'margin.size',
	        selectedValue: 5,
	        min: 5,
	        max: 999,
	        default: 0
	    },
	    'Name': {
	        selectedValue: 'padding',
	        hidden: true
	    }
	};
	exports.marginObject = marginObject;
	var styleObject = {
	    'font-style-group': {
	        type: 'style-group',
	        members: {
	            'font-family': {
	                type: 'dd',
	                title: 'font.family',
	                selectedValue: 'Helvetica',
	                options: ['Arial', 'Arial Black', 'Bookman Old Style', 'Calibri', 'Century Gothic', 'Comic Sans MS', 'Courier', 'Courier New', 'Garamond', 'Georgia', 'Helvetica', 'Impact', 'Palatino Linotype', 'Sans Serif', 'Sofia Pro Regular', 'Sofia Pro Semi Bold', 'Times', 'Times New Roman', 'Trebuchet MS', 'Verdana']
	            },
	            'font-size': {
	                type: 'number',
	                title: 'font.size',
	                selectedValue: 14,
	                min: '1',
	                max: '99',
	                default: 16
	            },
	            'background-color': {
	                type: 'color-picker',
	                title: 'background.color',
	                selectedValue: '#ffffff',
	                icon: 'fa fa-paint-brush'
	            }
	        }
	    },
	    'style-group': {
	        type: 'style-group',
	        members: {
	            'bold': {
	                type: 'btn-toggle',
	                title: 'bold',
	                icon: 'fa fa-bold',
	                selectedValue: false
	            }, 'italic': {
	                type: 'btn-toggle',
	                title: 'italic',
	                icon: 'fa fa-italic',
	                selectedValue: false
	            }, 'underline': {
	                type: 'btn-toggle',
	                title: 'underline',
	                icon: 'fa fa-underline',
	                selectedValue: false
	            },
	            'alignment': {
	                type: 'radio-btn',
	                selectedValue: 'left',
	                options: [{
	                        value: 'left',
	                        title: 'align.left',
	                        icon: 'fa fa-align-left',
	                        name: 'alignment'
	                    }, {
	                        value: 'center',
	                        title: 'align.center',
	                        icon: 'fa fa-align-justify',
	                        name: 'alignment'
	                    }, {
	                        value: 'right',
	                        title: 'align.right',
	                        icon: 'fa fa-align-right',
	                        name: 'alignment'
	                    }]
	            },
	            'font-color': {
	                type: 'color-picker',
	                title: 'font.color',
	                selectedValue: '#000000',
	                icon: 'fa fa-font'
	            }
	        }
	    },
	    'Name': {
	        selectedValue: 'style',
	        hidden: true
	    }
	};
	exports.styleObject = styleObject;
	var eventsObject = {
	    Name: {
	        selectedValue: 'Events',
	        hideSection: false,
	        hidden: true
	    },
	    load: {
	        name: 'onLoad',
	        type: 'event',
	        selectedValue: '',
	        xmlValue: '',
	        systemFields: [],
	        onClickFunction: 'openCodeEditorDialog'
	    },
	    change: {
	        name: 'onChange',
	        type: 'event',
	        selectedValue: '',
	        xmlValue: '',
	        systemFields: [],
	        onClickFunction: 'openCodeEditorDialog'
	    },
	    focus: {
	        name: 'onFocus',
	        type: 'event',
	        selectedValue: '',
	        xmlValue: '',
	        systemFields: [],
	        onClickFunction: 'openCodeEditorDialog'
	    },
	    blur: {
	        name: 'onBlur',
	        type: 'event',
	        selectedValue: '',
	        xmlValue: '',
	        systemFields: [],
	        onClickFunction: 'openCodeEditorDialog'
	    },
	    enter: {
	        name: 'onEnter',
	        type: 'event',
	        selectedValue: '',
	        xmlValue: '',
	        systemFields: [],
	        onClickFunction: 'openCodeEditorDialog'
	    }
	};
	var labelStyleObject = angular.copy(styleObject);
	exports.labelStyleObject = labelStyleObject;
	labelStyleObject.Name.selectedValue = 'label.style';
	var controlStyleObject = angular.copy(styleObject);
	exports.controlStyleObject = controlStyleObject;
	var alignmentRadioOptions = controlStyleObject['style-group'].members.alignment.options;
	controlStyleObject.Name.selectedValue = 'control.style';
	delete controlStyleObject['font-style-group'].members['background-color'];
	for (var i = 0; i < alignmentRadioOptions.length; i++) {
	    var element = alignmentRadioOptions[i];
	    element.name = 'controlAlignment';
	}
	var elementEventsObject = angular.copy(eventsObject);
	exports.elementEventsObject = elementEventsObject;
	var InsertButtonStyleObj = angular.copy(controlStyleObject);
	exports.InsertButtonStyleObj = InsertButtonStyleObj;
	InsertButtonStyleObj['Name'].selectedValue = 'insert.button.style';
	InsertButtonStyleObj['style-group'].members['font-color']['selectedValue'] = '#337ab7';
	InsertButtonStyleObj['font-style-group'].members['font-size']['selectedValue'] = 12;


/***/ }),
/* 269 */
/***/ (function(module, exports) {

	module.exports = "<button id=\"multiselectPopupProperties\" ng-hide=\"attrCtrl.showMultiselectPropertybox()\" type=\"button\"\n\tclass=\"btn btn-default\" ng-click=\"attrCtrl.multiselectPopupProperties()\"\n\ttitle=\"{{'multiselectProperties'|translate}}\"><i class=\"fa fa-font\"></i></button>\n\t\n<script type=\"text/ng-template\" id=\"multiselectPopupProperties.html\">\n\t<div class=\"property-box-popup\">\n\t\t<div class=\"header-container\">\n\t\t\t<div class=\"header\">\n\t\t\t\t<span translate=\"multiselectProperties\"></span>&nbsp;\n\t\t\t\t<span ng-bind=\"$ctrl.getSelectedItem().label | translate\"></span>\n\t\t\t</div>\n\t\t</div>\n\t<div class=\"popupscroller-outer\">\n\t\t<div class=\"scroller\">\n\t\t\t<div class=\"scroller-inner\">\n\t<div class=\"property-container\" ng-repeat=\"(key, values) in $commonpropertyboxModal.popupProperties\">\n\t\t\t\t\t<div class=\"property-row\">\n\t\t\t\t\t\t<div class=\"property-header\">\n\t\t\t\t\t\t\t{{values.Name.selectedValue || key | translate}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"property-content\">\n\t\t\t\t\t\t\t<div class=\"property-body\">\n\t\t\t\t\t\t\t\t<table class=\"property-table\">\n\t\t\t\t\t\t\t\t\t<tr ng-repeat=\"value in values\" ng-if=\"!value.hidden && value.type\">\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type != 'table' && value.type != 'style-group' && value.type != 'button' && value.type != 'button-group'\"\n\t\t\t\t\t\t\t\t\t\t\ttranslate=\"{{value.name}}\" class=\"{{value.extraClass}}\" ng-class=\"{overflowLabel : value.name == 'closed.date'}\" title=\"{{ value.name != 'closed.date' ? '' : value.name | translate}}\">\n\t\t\t\t\t\t\t\t\t\t\t{{value.name}}</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'div'\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"formulaDiv\">{{value.selectedValue}}</div>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'checkbox' && (value.name == 'wrap.text')\">\n\t\t\t\t\t\t\t\t\t\t\t<input type=\"checkbox\"\n\t\t\t\t\t\t\t\t\t\t\t ng-model=\"value.selectedValue\"\n\t\t\t\t\t\t\t\t\t\t\t ng-disabled=\"value.disable || values.forceToDisabled\"\n\t\t\t\t\t\t\t\t\t\t\t ng-change= \"$ctrl[value.onChangeFunction || noop](value,event)\" \n\t\t\t\t\t\t\t\t\t\t\t ng-focus=\"event=$event\"\n\t\t\t\t\t\t\t\t\t\t\tng-disable=\"value.disable\" >\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'checkbox'\">\n\t\t\t\t\t\t\t\t\t\t\t<input type=\"{{value.type}}\" id=\"{{value.name}}\" name=\"{{value.name}}\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-model=\"value.selectedValue\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-change=\"$ctrl[value.onChangeFunction || noop](values, value); $ctrl.onPropValueChanged(); $ctrl.getSelectedItemProperties().Basic.Default.dateType = $ctrl.getSelectedItemProperties().Advance['Closed Date'].selectedValue ? '2': $ctrl.getSelectedItemProperties().Basic.Default.dateType;\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\">\n\n\t\t\t\t\t\t\t\t\t\t\t\t<i ng-if=\"value.addOnButton\" \n\t\t\t\t\t\t\t\t\t\t\t\t\tclass={{value.addOnButton}} ng-disabled=\"value.disable || values.forceToDisabled\" \n\t\t\t\t\t\t\t\t\t\t\t\t\tng-class=\"{disabled : value.disable || values.forceToDisabled}\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-click=\"$ctrl[value.onClickFunction || noop](values, value)\"></i>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'number' && value.name !='number.columns'\" ng-form=\"test\">\n\t\t\t\t\t\t\t\t\t\t\t<input type=\"{{value.type}}\" string-to-number id=\"{{value.name}}\"\n\t\t\t\t\t\t\t\t\t\t\t\tname=\"{{value.name}}\" ng-model=\"value.selectedValue\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-change=\"$ctrl[value.onChangeFunction || noop](); $ctrl.onPropValueChanged();\" min=\"{{value.min}}\"\n\t\t\t\t\t\t\t\t\t\t\t\tmax=\"{{value.max}}\" ng-blur=\"$ctrl.validPattern($event,value)\"\n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\">\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'style-group'\" class=\"style-group\">\n\t\t\t\t\t\t\t\t\t\t\t<span ng-repeat=\"(key, member) in value.members\">\n\t\t\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default btn-sm\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-class=\"{'active': member.selectedValue}\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-if=\"member.type == 'btn-toggle'\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\" \n\t\t\t\t\t\t\t\t\t\t\t\t\tng-click=\"member.selectedValue = !member.selectedValue;$ctrl[member.onChangeFunction || noop](key); $ctrl.onPropValueChanged();\"\n\t\t\t\t\t\t\t\t\t\t\t\t\ttitle=\"{{ member.title | translate }}\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"{{ member.icon }}\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t<select ng-model=\"member.selectedValue\" ng-if=\"member.type == 'dd'\"\n\t\t\t\t\t\t\t\t\t\t\t\t\ttitle=\"{{ member.title | translate }}\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\" \n\t\t\t\t\t\t\t\t\t\t\t\t\tng-change=\"$ctrl[member.onChangeFunction || noop](key); $ctrl.onPropValueChanged();\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<option value=\"{{v}}\" ng-repeat=\"v in member.options\">{{v}}</option>\n\t\t\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t\t\t\t<input type=\"number\" string-to-number ng-model=\"member.selectedValue\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tmin=\"0\" max=\"99\" ng-if=\"member.type == 'number'\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-blur=\"$ctrl.validPattern($event,member)\"\n\t\t\t\t\t\t\t\t\t\t\t\t\ttitle=\"{{ member.title | translate }}\"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\" \n\t\t\t\t\t\t\t\t\t\t\t\t\tng-change=\"$ctrl[member.onChangeFunction || noop](key); $ctrl.onPropValueChanged();\">\n\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if=\"member.type == 'radio-btn'\" class=\"radio-btn-group\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<label ng-repeat=\"option in member.options\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\ttitle=\"{{ option.title | translate }}\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input type=\"radio\" name=\"{{option.name || 'alignment'}}\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\" \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tvalue=\"{{option.value}}\" ng-model=\"member.selectedValue\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default btn-sm\" \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\" \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click=\"member.selectedValue = option.value;$ctrl[option.onChangeFunction || noop](key)\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"{{ option.icon }}\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if=\"member.type == 'color-picker'\" class=\"color-picker\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<spectrum-colorpicker options=\"$ctrl.colorPickerOptions\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tformat=\"'rgb'\" \n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\" \n\t\t\t\t\t\t\t\t\t\t\t\t\t\ton-change=\"$ctrl.colorPickerEventApi.onChange(key); $ctrl.onPropValueChanged();\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-model=\"member.selectedValue\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t</spectrum-colorpicker>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default btn-sm\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-class= \"{'color-picker-toggle': member.name == 'backgroundcoloron' || member.name == 'backgroundcoloroff'}\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\" \n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click=\"$ctrl.showColorPicker($event)\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\ttitle=\"{{ member.title | translate }}\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"{{ member.icon }}\"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-style=\"{'border-bottom': '3px solid ' + member.selectedValue }\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'button'\">\n\t\t\t\t\t\t\t\t\t\t\t<button class=\"btn btn-default btn-sm\" \n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\" \n\t\t\t\t\t\t\t\t\t\t\t\tng-click=\"$ctrl[value.onClickFunction || noop](key)\"\n\t\t\t\t\t\t\t\t\t\t\t\ttitle=\"{{ value.title | translate }}\">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"{{ value.icon }}\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'button-group'\">\n\t\t\t\t\t\t\t\t\t\t\t<span ng-repeat=\"(key, member) in value.members\">\n\t\t\t\t\t\t\t\t\t\t\t\t<button class=\"btn btn-default btn-sm\" \n\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled=\"value.disable || values.forceToDisabled\" \n\t\t\t\t\t\t\t\t\t\t\t\t\tng-click=\"$ctrl[member.onClickFunction || noop](key)\"\n\t\t\t\t\t\t\t\t\t\t\t\t\ttitle=\"{{ member.title | translate }}\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"{{ member.icon }}\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if=\"value.type == 'button-group'\"></td>\n\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t<div class=\"modal-footer\">\n\t\t<button class=\"btn btn-danger\" type=\"button\" ng-click=\"$commonpropertyboxModal.submitPopuppropertiesData()\" translate=\"ok\">OK</button>\n\t\t<button class=\"btn btn-default\" type=\"button\" ng-click=\"$commonpropertyboxModal.cancel()\" translate=\"cancel\">Cancel</button>\n\t</div>\n</div>\n</div>\n</div>\n</div>\n</script>"

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var angular = __webpack_require__(1);
	var UndoRedoComponent = (function () {
	    UndoRedoComponent.$inject = ['localStorage', '$scope', '$rootScope'];
	    function UndoRedoComponent(localStorage, $scope, $rootScope) {
	        var _this = this;
	        this.stack = [];
	        this.position = 0;
	        this.limit = 11;
	        var self = this;
	        this.scope = $scope;
	        this.store = localStorage;
	        this.selectedView = this.store.get('selectedView');
	        this.views = this.store.get('views');
	        this.$rootScope = $rootScope;
	        this.$rootScope.$on('newDesgin', function (event, args) {
	            self.clear();
	        });
	        this.$rootScope.$on('designChanged', function (event, args) {
	            self.remember();
	        });
	        this.$rootScope.$on('designViewAdded', function (event, args) {
	            //this.stack[args.viewName] = [[]];
	            //this.position[args.viewName] = 1;
	        });
	        this.$rootScope.$on('undoRedo', function (event, args) {
	            if (args === 'UNDO') {
	                _this.undo();
	            }
	            else if (args === 'REDO') {
	                _this.redo();
	            }
	            _this.scope.$apply();
	        });
	        this.stack = [];
	        this.position = -1;
	    }
	    UndoRedoComponent.prototype.getCurrentViewName = function () {
	        return this.selectedView.view.viewName;
	    };
	    UndoRedoComponent.prototype.remember = function () {
	        var self = this;
	        var object = {};
	        for (var view in self.views) {
	            var currentView = self.views[view].viewName;
	            object[currentView] = angular.copy(self.views[view].controls.A);
	        }
	        this.stack.splice(this.position, this.limit);
	        this.stack.push(object);
	        this.stack.splice(0, this.stack.length - this.limit);
	        this.position = this.stack.length;
	    };
	    UndoRedoComponent.prototype.undo = function () {
	        var self = this;
	        if (this.position > 1) {
	            this.position--;
	            var value = this.stack[this.position - 1];
	            for (var view in self.views) {
	                var currentView = self.views[view].viewName;
	                if (value[currentView] !== undefined) {
	                    self.views[view].controls.A = angular.copy(value[currentView]);
	                }
	            }
	        }
	    };
	    UndoRedoComponent.prototype.redo = function () {
	        var self = this;
	        if (this.position < this.stack.length) {
	            this.position++;
	            var value = this.stack[this.position - 1];
	            for (var view in self.views) {
	                var currentView = self.views[view].viewName;
	                if (value[currentView] !== undefined) {
	                    self.views[view].controls.A = angular.copy(value[currentView]);
	                }
	            }
	        }
	    };
	    UndoRedoComponent.prototype.clear = function () {
	        this.stack = [];
	        this.position = 0;
	    };
	    return UndoRedoComponent;
	}());
	exports.UndoRedoComponent = UndoRedoComponent;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('directives.undoredo', [])
	    .component('undoredo', {
	    template: __webpack_require__(271),
	    controller: UndoRedoComponent,
	    controllerAs: 'UndoCtrl'
	}).name;


/***/ }),
/* 271 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"btn-group pull-right\">\n    <button type=\"button\" class=\"btn btn-default\" style=\"margin-right: 1px;border-right-color: #ccc;\" ng-click=\"UndoCtrl.undo()\" ng-disabled=\"false\" title=\"{{ 'undo' | translate }}\"><i class=\"fa fa-undo\"></i></button>\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"UndoCtrl.redo()\" ng-disabled=\"false\" title=\"{{ 'redo' | translate }}\"><i class=\"fa fa-repeat\"></i></button>                          \n</div>"

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var angular = __webpack_require__(1);
	var action_constants_1 = __webpack_require__(19);
	var LoginComponent = (function () {
	    LoginComponent.$inject = ['$rootScope', '$http', '$interval', 'Util'];
	    function LoginComponent($rootScope, $http, $interval, Util) {
	        var _this = this;
	        this.saving = false;
	        this.error = {
	            hasError: false,
	            msg: ''
	        };
	        this.errorCode = {
	            0: 'Error while processing your request.',
	            1: 'Password is empty.',
	            2: 'Your account is locked.',
	            3: 'Password is incorrect.',
	            4: 'Adoddle does not have a valid session to activate for this user account. Please restart your browser and try signing in again.',
	            5: 'Error while processing your request.',
	            6: 'Error while processing your request.',
	            7: 'Cookie not found.',
	            8: 'Email is empty.',
	            9: 'Password is empty.'
	        };
	        this.USP = $rootScope.USP;
	        this.email = this.USP.email;
	        this.Util = Util;
	        this.$http = $http;
	        this.$interval = $interval;
	        this.interval = $interval(function () { _this.checkSessionTimeout(); }, 500);
	    }
	    LoginComponent.prototype.checkSessionTimeout = function () {
	        var sessionState = window.localStorage.getItem('sessionState');
	        if (sessionState == 'Active') {
	            this.$interval.cancel(this.interval);
	            window.setsessionTimoutTimer();
	            this['close']();
	        }
	    };
	    LoginComponent.prototype.login = function () {
	        var _this = this;
	        var self = this;
	        this.saving = true;
	        this.error.hasError = false;
	        self.$http({
	            'url': window.properties.service.commonApiUrl + action_constants_1.Ids.ACTIVATE_USER_SESSION,
	            'method': 'POST',
	            'data': {
	                email: self.email,
	                password: self.password,
	                ASessionID: self.USP.aSessionId || ''
	            },
	            'headers': {
	                'Content-Type': 'application/x-www-form-urlencoded'
	            },
	            'withCredentials': true,
	            transformRequest: function (obj) {
	                var str = [];
	                for (var p in obj)
	                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
	                return str.join("&");
	            }
	        }).then(function (data) {
	            data = data.data;
	            self.saving = false;
	            if (data) {
	                if (data.success || data.errorCode == 6) {
	                    window.localStorage.setItem('sessionState', 'Active');
	                    window.setsessionTimoutTimer();
	                    try {
	                        window.top && window.top.opener && window.top.opener.setSessionState && window.top.opener.setSessionState('sessionState', 'Active');
	                    }
	                    catch (e) { }
	                    _this['close']();
	                }
	                else {
	                    self.error.hasError = true;
	                    self.error.msg = self.errorCode[data.errorCode];
	                }
	            }
	        }, function (response) {
	            self.saving = false;
	            self.error.hasError = true;
	            self.error.msg = self.errorCode[0];
	        });
	    };
	    LoginComponent.prototype.onEnter = function ($event) {
	        if ($event.keyCode == 13 && this.email && this.password) {
	            this.login();
	        }
	    };
	    return LoginComponent;
	}());
	exports.LoginComponent = LoginComponent;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('directives.login', [])
	    .component('login', {
	    template: __webpack_require__(273),
	    controller: LoginComponent,
	    controllerAs: 'LoginCtrl',
	    bindings: {
	        close: '&'
	    }
	}).name;


/***/ }),
/* 273 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"login-wrapper\">\n    <div class=\"login-header branding-Bg-color\">{{ ('session-timeout' | translate) }}</div>\n    <div class=\"login-body\" ng-class=\"{ 'saving': LoginCtrl.saving }\">\n        <p class=\"error-msg\">{{ ('session-expired' | translate) + ' ' + ('must-login-msg' | translate) }}</p>\n        <p class=\"error-msg\" ng-if=\"LoginCtrl.error.hasError\">{{ error.msg }}</p>\n        <div>\n            <label>{{ ('username' | translate) }}</label>\n            <input type=\"text\" class=\"form-control\" ng-model=\"LoginCtrl.email\" readonly>\n        </div>\n        <div>\n            <label>{{ ('password' | translate) }}</label>\n            <input type=\"password\" class=\"form-control\" placeholder=\"Password\" autocomplete=\"off\" ng-model=\"LoginCtrl.password\" ng-keydown=\"LoginCtrl.onEnter($event)\">\n        </div>\n        <button type=\"button\" class=\"btn btn-danger\" ng-disabled=\"!LoginCtrl.password\" ng-click=\"LoginCtrl.login()\">Login</button>\n    </div>\n</div>"

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var angular = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('nodeApp.multiCellSelect', [])
	    .directive('multiCellSelect', ['$window', '$document', function ($window, $document) {
	        return {
	            scope: {
	                multiCellIds: '=',
	                resetCells: '=',
	                columnsWidth: '=',
	                selectedRows: '=',
	                selectedColumns: '=',
	                selectAll: '='
	            },
	            link: function (scope, element, attrs) {
	                scope.$watch('resetCells', function () {
	                    element.find(".eng-selected-item").removeClass("eng-selected-item");
	                    scope.multiCellIds = [];
	                    scope.resetCells = false;
	                });
	                setTimeout(function () {
	                    element.find('td')
	                        .resizable({
	                        resizeHeight: false,
	                        // we use the column as handle and filter
	                        // by the contained .resizer element
	                        handleSelector: "> .resizer",
	                        onDragStart: function (e, $el, opt) {
	                            // only drag resizer
	                            if (!$(e.target).hasClass("resizer")) {
	                                return false;
	                            }
	                            return true;
	                        },
	                        onDragEnd: function (e, $el, opt) {
	                        },
	                        onDrag: function (e, $el, newWidth, newHeight, opt) {
	                            //console.log($el.find('div.column'));
	                            var column = parseInt($el.prop('id').split('-')[1], 10);
	                            scope.columnsWidth[column] = newWidth;
	                            //$el.find('div.column').width(newWidth);
	                            // explicitly return **false** if you don't want 
	                            // auto-height computation to occur
	                            return true;
	                        }
	                    });
	                });
	            },
	            /**
	             * Directive Controller Function
	             *
	             * @param      {<type>}  $scope    The scope
	             * @param      {<type>}  $element  The element
	             * @return     {Object}
	             */
	            controller: ['$scope', '$element', '$window', '$document', function ($scope, $element, $window, $document) {
	                    var clearFlag = false;
	                    var startCell = null;
	                    var dragging = false;
	                    var finalCell = null;
	                    var flag = false;
	                    /**
	                     * MouseDown Event Callback
	                     *
	                     * @param      {<type>}  el      { DOM element }
	                     */
	                    function mouseDown(el) {
	                        if (!flag) {
	                            flag = true;
	                            if (!startCell) {
	                                setStartCell(el);
	                            }
	                            dragging = true;
	                            setStartCell(el);
	                            setRangeArea(startCell, el);
	                        }
	                    }
	                    /**
	                     * MouseUp Event Callback
	                     *
	                     * @param      {<type>}  el      { DOM element }
	                     */
	                    function mouseUp(el) {
	                        if (flag) {
	                            dragging = false;
	                            finalCell = el;
	                            setSelectedCells(startCell, finalCell);
	                            if (clearFlag) {
	                                clearCells(startCell, finalCell);
	                                clearFlag = false;
	                            }
	                        }
	                        flag = false;
	                        setStartCell(null);
	                    }
	                    /**
	                     * MouseLeave Event Callback
	                     *
	                     * @param      {<type>}  el      { DOM element }
	                     */
	                    function mouseLeave(el) {
	                        if (dragging) {
	                            if (el.hasClass('hover-area')) {
	                                var cellsObj = cellsBetween(startCell, el);
	                                if (cellsObj) {
	                                    cellsObj.each(function () {
	                                        var el = angular.element(this);
	                                        el.toggleClass('hover-area').addClass('ui-state-default');
	                                    });
	                                }
	                                if (startCell == el) {
	                                    el.toggleClass('hover-area').addClass('ui-state-default');
	                                }
	                            }
	                        }
	                        else {
	                            return;
	                        }
	                    }
	                    /**
	                     * MouseEnter Event Callback
	                     *
	                     * @param      {<type>}  el      { DOM element }
	                     */
	                    function mouseEnter(el) {
	                        if (dragging) {
	                            setRangeArea(startCell, el);
	                        }
	                        else {
	                            return;
	                        }
	                    }
	                    /**
	                     * Sets the start cell element.
	                     *
	                     * @param      {<type>}  el      { DOM element }
	                     */
	                    function setStartCell(el) {
	                        startCell = el;
	                    }
	                    /**
	                     * Sets the range area.
	                     *
	                     * @param      {<type>}  start   The start
	                     * @param      {<type>}  el      { DOM element }
	                     */
	                    function setRangeArea(start, el) {
	                        if (start[0] && el[0]) {
	                            var cellsObj = cellsBetween(startCell, el);
	                            if (dragging && cellsObj) {
	                                if (el.hasClass('ui-state-default')) {
	                                    cellsObj.each(function () {
	                                        var el = angular.element(this);
	                                        el.addClass('hover-area');
	                                    });
	                                }
	                                else if (el.hasClass('hover-area') || el.hasClass('ui-state-default')) {
	                                    cellsObj.each(function () {
	                                        var el = angular.element(this);
	                                        el.toggleClass('hover-area').addClass('ui-state-default');
	                                    });
	                                }
	                                if (!start.hasClass('eng-selected-item')) {
	                                    cellsObj.each(function () {
	                                        var el = angular.element(this);
	                                        if (el.hasClass('eng-selected-item')) {
	                                            clearFlag = true;
	                                        }
	                                    });
	                                }
	                            }
	                        }
	                    }
	                    /**
	                     * Sets the selected cells.
	                     *
	                     * @param      {<type>}  start   The start
	                     * @param      {<type>}  end     The end
	                     */
	                    function setSelectedCells(start, end) {
	                        if (start[0] && end[0]) {
	                            var cellsObj = cellsBetween(start, end); //jQuery object
	                            if (cellsObj) {
	                                cellsObj.each(function () {
	                                    var el = angular.element(this);
	                                    if (el.hasClass('eng-selected-item')) {
	                                        el.removeClass('eng-selected-item');
	                                        if (el.hasClass('hover-area')) {
	                                            el.removeClass('hover-area');
	                                        }
	                                        var id = el.attr('id');
	                                        var index = $scope.multiCellIds.indexOf(id);
	                                        if ($scope.multiCellIds.indexOf(el.attr('id')) > -1) {
	                                            $scope.multiCellIds.splice(index, 1);
	                                        }
	                                    }
	                                    else if (!el.hasClass('eng-selected-item')) {
	                                        el.addClass('eng-selected-item');
	                                        if (el.hasClass('hover-area')) {
	                                            el.removeClass('hover-area');
	                                        }
	                                        if ($scope.multiCellIds.indexOf(el.attr('id')) == -1 && el.is(':visible')) {
	                                            $scope.multiCellIds.push(el.attr('id'));
	                                        }
	                                    }
	                                });
	                            }
	                        }
	                    }
	                    /**
	                     * Clear Cells between given start/end
	                     *
	                     * @param      {<type>}  start   The start
	                     * @param      {<type>}  end     The end
	                     */
	                    function clearCells(start, end) {
	                        if (start[0] && end[0]) {
	                            var cellsObj = cellsBetween(start, end);
	                            if (cellsObj) {
	                                cellsObj.each(function () {
	                                    var el = angular.element(this);
	                                    el.removeClass('eng-selected-item');
	                                    el.removeClass('hover-area');
	                                    var id = el.attr('id');
	                                    var index = $scope.multiCellIds.indexOf(id);
	                                    if ($scope.multiCellIds.indexOf(el.attr('id')) > -1) {
	                                        $scope.multiCellIds.splice(index, 1);
	                                    }
	                                });
	                            }
	                        }
	                    }
	                    /**
	                     * Calculate and return cells between range
	                     *
	                     * @param      {<type>}  start   The start
	                     * @param      {<type>}  end     The end
	                     * @return     {<Object>}
	                     */
	                    function cellsBetween(start, end) {
	                        var coordsStart = getCoords(start);
	                        var coordsEnd = getCoords(end);
	                        var topLeft = {
	                            column: $window.Math.min(coordsStart.column, coordsEnd.column),
	                            row: $window.Math.min(coordsStart.row, coordsEnd.row),
	                        };
	                        var bottomRight = {
	                            column: $window.Math.max(coordsStart.column, coordsEnd.column),
	                            row: $window.Math.max(coordsStart.row, coordsEnd.row),
	                        };
	                        var ele = $element.find('tr td').not($element.find('table tr td'));
	                        if (ele[0].parentElement.parentElement == start[0].parentElement.parentElement) {
	                            ele = ele.filter(function () {
	                                var el = angular.element(this);
	                                var coords = getCoords(el);
	                                return coords.column >= topLeft.column && coords.column <= bottomRight.column && coords.row >= topLeft.row && coords.row <= bottomRight.row;
	                            });
	                            return ele;
	                        }
	                        else {
	                            return null;
	                        }
	                    }
	                    /**
	                     * Gets the coordinates.
	                     *
	                     * @param      {<type>}  cell    The cell
	                     * @return     {Object}  The coordinates.
	                     */
	                    function getCoords(cell) {
	                        return {
	                            column: cell[0].cellIndex,
	                            row: cell[0].parentElement.rowIndex
	                        };
	                    }
	                    function rowClick(el) {
	                        var row = parseInt(el.attr('row-id'), 10), rowSelected = el.attr('row-selected');
	                        var objTr = $element.find('tr');
	                        objTr.each(function (x) {
	                            if (objTr[x].firstElementChild == el[0].parentElement) {
	                                if (rowSelected === "true") {
	                                    el.attr('row-selected', false);
	                                    var rowIndex = $scope.selectedRows.indexOf(row);
	                                    $scope.selectedRows.splice(rowIndex, 1);
	                                }
	                                else {
	                                    el.attr('row-selected', true);
	                                    $scope.selectedRows.push(row);
	                                }
	                                //setRangeArea(objTr[x].firstElementChild, objTr[x].lastElementChild);
	                                var start = { '0': objTr[x].firstElementChild };
	                                var end = { '0': objTr[x].lastElementChild };
	                                setSelectedCells(start, end);
	                            }
	                        });
	                    }
	                    function colClick(el) {
	                        var col = parseInt(el.attr('col-id'), 10), colSelected = el.attr('col-selected');
	                        var objTd = $element.find('td');
	                        var start;
	                        var end;
	                        objTd.each(function (x) {
	                            if (objTd[x].parentElement.parentElement == el[0].parentElement.parentElement.parentElement
	                                && objTd[x].cellIndex == el[0].parentElement.cellIndex) {
	                                //console.log("objTd[x]: ", objTd[x]);
	                                if (!start)
	                                    start = { '0': objTd[x] };
	                                end = { '0': objTd[x] };
	                            }
	                        });
	                        if (colSelected === "true") {
	                            //ele.addClass('hover-area');
	                            el.attr('col-selected', false);
	                        }
	                        else {
	                            //ele.not('.eng-selected-item').addClass('hover-area');
	                            el.attr('col-selected', true);
	                        }
	                        //setRangeArea(objTr[x].firstElementChild, objTr[x].lastElementChild);
	                        setSelectedCells(start, end);
	                    }
	                    function selectAllTable(el, isSelected) {
	                        var objTable = el[0].firstElementChild;
	                        var start = { '0': objTable.firstElementChild.firstElementChild };
	                        var end = { '0': objTable.lastElementChild.lastElementChild };
	                        if (!isSelected) {
	                            //$element.find('td').addClass('hover-area');
	                            el.attr('select-all', false);
	                        }
	                        else {
	                            //$element.find('td').not('.eng-selected-item').addClass('hover-area');
	                            el.attr('select-all', true);
	                        }
	                        setSelectedCells(start, end);
	                    }
	                    function clearAll() {
	                        var ele = angular.element('.canvas').find('.eng-selected-item');
	                        if (ele.length) {
	                            for (var i = 0; i < ele.length; i++) {
	                                ele.removeClass('eng-selected-item');
	                            }
	                        }
	                        // resetting the values on control selection
	                        $scope.multiCellIds = [];
	                        $scope.resetCells = false;
	                    }
	                    /**
	                     * Wrap function
	                     *
	                     * @param      {Function}  fn      The function
	                     * @return     {<Function>}    { event function }
	                     */
	                    function wrap(fn, withShift) {
	                        if (withShift === void 0) { withShift = true; }
	                        return function (event) {
	                            //event.stopPropagation();
	                            if (event.shiftKey != withShift) {
	                                return;
	                            }
	                            var el = angular.element(this);
	                            $scope.$apply(function () {
	                                fn(el);
	                            });
	                            if (fn == clearAll) {
	                                $scope.$apply(function () {
	                                    fn();
	                                });
	                            }
	                            else {
	                                var el = angular.element(this);
	                                if (el[0].offsetParent.classList.contains("selected") || el[0].offsetParent.offsetParent.classList.contains("selected")) {
	                                    $scope.$apply(function () {
	                                        fn(el);
	                                    });
	                                }
	                            }
	                        };
	                    }
	                    $element.delegate('td', 'mousedown', wrap(mouseDown));
	                    $element.delegate('td', 'mouseenter', wrap(mouseEnter));
	                    $element.delegate('td', 'mouseleave', wrap(mouseLeave));
	                    $element.delegate('td', 'mouseup', wrap(mouseUp));
	                    $element.delegate('.row-selector-handler', 'click', wrap(rowClick, false));
	                    $element.delegate('.column-selector-handler', 'click', wrap(colClick, false));
	                    $element.delegate('.table-select-all', 'click', wrap(selectAllTable, false));
	                    $element.delegate('.column', 'click', wrap(clearAll, false));
	                    $scope.$watch('selectAll', function (scope) {
	                        selectAllTable($element, $scope.selectAll);
	                    });
	                }]
	        };
	    }]).name;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var angular = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('nodeApp.datetimepicker', [])
	    .directive('datetimepicker', ['$window', '$document', function ($window, $document) {
	        return {
	            require: '?ngModel',
	            restrict: 'AE',
	            scope: {
	                datetimepickerOptions: '&'
	            },
	            link: function (scope, elem, attrs, ngModelCtrl) {
	                var passed_in_options = scope.datetimepickerOptions();
	                var options = jQuery.extend({}, {}, passed_in_options);
	                elem.on('dp.show', function (e) {
	                    var datepicker = $('body').find('.bootstrap-datetimepicker-widget:last'), position = datepicker.offset(), parent = datepicker.parent(), parentPos = parent.offset(), width = datepicker.width(), parentWid = parent.width();
	                    // move datepicker to the exact same place it was but attached to body
	                    datepicker.appendTo('body');
	                    datepicker.css({
	                        position: 'absolute',
	                        top: position.top,
	                        bottom: 'auto',
	                        left: position.left,
	                        right: 'auto',
	                        zIndex: '99999999999'
	                    });
	                    // if datepicker is wider than the thing it is attached to then move it so the centers line up
	                    if (parentPos.left + parentWid < position.left + width) {
	                        var newLeft = parentPos.left;
	                        newLeft += parentWid / 2;
	                        newLeft -= width / 2;
	                        datepicker.css({ left: newLeft });
	                    }
	                });
	                elem.on('dp.change', function (e) {
	                    if (ngModelCtrl) {
	                        // $timeout(function () {
	                        ngModelCtrl.$setViewValue(e.target.value);
	                    }
	                });
	                elem.datetimepicker(options);
	                //   {
	                //   format:'DD-MMM-YY',
	                //   showClear:true,
	                //   showClose:true,
	                //   showTodayButton:true,
	                //   allowInputToggle:true,
	                //   keepOpen:true,
	                // }
	                // );
	                //Local event change
	                elem.on('blur', function () {
	                    /*// returns moments.js format object
	                    scope.dateTime = new Date(elem.data("DateTimePicker").getDate().format());
	                    // Global change propagation
	      
	                    $rootScope.$broadcast("emit:dateTimePicker", {
	                        location: scope.location,
	                        action: 'changed',
	                        dateTime: scope.dateTime,
	                        example: scope.useCurrent
	                    });
	                    scope.$apply();*/
	                });
	            }
	        };
	    }]).name;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var angular = __webpack_require__(1);
	var uiRouter = __webpack_require__(5);
	var main_routes_1 = __webpack_require__(277);
	var action_constants_1 = __webpack_require__(19);
	var MainController = (function () {
	    /*@ngInject*/
	    MainController.$inject = ['$http', '$scope', '$uibModal', '$state', '$window', 'Util', 'config', 'Notification'];
	    function MainController($http, $scope, $uibModal, $state, $window, Util, config, Notification) {
	        var self = this;
	        this.config = config;
	        this.Util = Util;
	        this.$scope = $scope;
	        this.unauthorized = false;
	        this.unauthorizedMessage = "";
	        this.showSpinner = true;
	        this.validListMessage = "";
	        this.$state = $state;
	        this.$uibModal = $uibModal;
	        this.$http = $http;
	        this.$window = $window;
	        this.totalItems = 0;
	        this.pageNo = 0;
	        this.recordSize = 10;
	        this.maxSize = 8;
	        this.currentPage = 1;
	        this.pagedItems = [];
	        this.oldSearchVal = "";
	        this.isPagedChange = false;
	        this.ngNotification = Notification;
	        var initalized;
	        if (config.showListing == true) {
	            initalized = Promise.all([Util.initServerCalls(), this.listingAjaxCall({ "page": 0, "size": 10, "sortColumn": "formName", "sortType": "ASC" })]);
	        }
	        else {
	            if (config.initServerCalls == true) {
	                initalized = Util.initServerCalls(config);
	            }
	            else {
	                initalized = Promise.all([]);
	            }
	        }
	        initalized.then(function () {
	            Util.setsessionTimoutTimer();
	            self.showSpinner = false;
	            self.$scope.$digest();
	            if (config.showListing == false) {
	                self.$state.go('create', {
	                    params: {
	                        id: config.formDetail.id,
	                        formName: config.formDetail.formName,
	                        description: config.formDetail.description
	                    }
	                });
	            }
	        }, function () {
	            self.showSpinner = false;
	        });
	        window.onbeforeunload = function () {
	            return null;
	        };
	    }
	    /* Get listing data*/
	    MainController.prototype.listingAjaxCall = function (data) {
	        var self = this;
	        self.validListMessage = "";
	        return new Promise(function (resolve, reject) {
	            self.$http({
	                'url': window.properties.service.uri + action_constants_1.Ids.SEARCH_TEMPLATE,
	                'method': 'POST',
	                'data': data,
	                'headers': {
	                    'Content-Type': 'application/json;charset=UTF-8'
	                },
	                'withCredentials': true
	            }).then(function (response) {
	                self.successCallback(response.data);
	                resolve();
	            }, function errorCallback(response) {
	                switch (response.status) {
	                    case 401:
	                        self.unauthorized = true;
	                        self.unauthorizedMessage = "Unauthorized access";
	                        break;
	                    case 503:
	                        self.validListMessage = "Service Temporary unavailable";
	                        break;
	                    case 500:
	                        self.validListMessage = "Internal Server Error";
	                        break;
	                    case -1:
	                        self.unauthorized = true;
	                        self.unauthorizedMessage = "Connectivity Issue";
	                        break;
	                }
	                reject();
	            });
	        });
	    };
	    /* Success callback of the listing data */
	    MainController.prototype.successCallback = function (data) {
	        var self = this;
	        self.pagedItems = data.entity.records;
	        self.totalItems = data.entity.totalRecords;
	        self.pageNo = data.entity.page + 1;
	        self.recordSize = data.entity.size;
	        self.maxSize = 8;
	        self.currentPage = self.currentPage;
	        if (self.pagedItems.length == 0) {
	            self.validListMessage = "No Data Available.";
	        }
	    };
	    /* openModal create template modal */
	    MainController.prototype.openModal = function (editTemplate) {
	        var that = this;
	        var modalInstance = this.$uibModal.open({
	            animation: true,
	            ariaLabelledBy: 'modal-title',
	            ariaDescribedBy: 'modal-body',
	            templateUrl: 'myModalContent.html',
	            backdrop: 'static',
	            keyboard: false,
	            controllerAs: '$ctrl',
	            controller: function () {
	                this.msg = '';
	                this.edit = editTemplate;
	                this.inputName = that.currentData && that.currentData.formName;
	                this.inputDesc = that.currentData && that.currentData.description;
	                this.inputChk = true;
	                this.showTemplateSpinner = false;
	                this.restrictChar = function ($event) {
	                    this.msg = '';
	                    var value = $event.target.value;
	                    if (value == "") {
	                        this.msg = "Template Name is required.";
	                    }
	                    else {
	                        if (value.match(/[|<>\\/:?*"'$#]/gi)) {
	                            this.msg = 'Template Name cannot contain any of the following characters: # \\ / : * ? " < > | $ \' ';
	                            $event.preventDefault();
	                            return false;
	                        }
	                    }
	                };
	                this.ok = function () {
	                    var _this = this;
	                    var self = this;
	                    var data;
	                    self.showTemplateSpinner = true;
	                    if (that.currentData) {
	                        data = {
	                            "id": that.currentData.id,
	                            "description": this.inputDesc,
	                            "formName": this.inputName
	                        };
	                    }
	                    else {
	                        data = {
	                            "description": this.inputDesc,
	                            "formName": this.inputName
	                        };
	                    }
	                    that.$http({
	                        'url': window.properties.service.uri + action_constants_1.Ids.CREATE_TEMPLATE,
	                        'method': 'POST',
	                        'data': data,
	                        'headers': {
	                            'Content-Type': 'application/json;charset=UTF-8'
	                        },
	                        'withCredentials': true
	                    }).then(function (response) {
	                        self.showTemplateSpinner = false;
	                        // modalInstance.dismiss('cancel');
	                        modalInstance.close(false);
	                        if (_this.inputChk) {
	                            that.$state.go('create', {
	                                params: response.data.entity
	                            });
	                        }
	                        else {
	                            _this.currentPage = 1;
	                            that.listingAjaxCall({ "page": 0, "size": 10, "sortColumn": "formName", "sortType": "ASC" });
	                        }
	                    }, function errorCallback(response) {
	                        self.showTemplateSpinner = false;
	                        self.msg = response.data && response.data.message;
	                        self.inputName = "";
	                    });
	                };
	                this.cancel = function () {
	                    // modalInstance.dismiss('cancel');
	                    modalInstance.close(false);
	                };
	            }
	        });
	        modalInstance.result.then(function (selectedItem) {
	        }, function () {
	        });
	    };
	    // open template Modal
	    MainController.prototype.openTemplate = function () {
	        this.currentData = "";
	        this.openModal(false);
	    };
	    // Edit selected Template
	    MainController.prototype.editTemplate = function (items) {
	        this.currentData = items;
	        this.openModal(true);
	    };
	    // create design template
	    MainController.prototype.designTemplate = function (items) {
	        this.$state.go('create', {
	            params: items
	        });
	    };
	    // Download zip file
	    MainController.prototype.downloadZip = function (data) {
	        if (data.formName.match(/[|<>\\/:?*"'$#]/gi)) {
	            this.ngNotification.error({ message: 'Template Name cannot contain any of the following characters: # \\ / : * ? " < > | $ \' ', positionX: 'center', replaceMessage: true });
	            return;
	        }
	        var timeStamp = new Date().getTime();
	        var apidata = {
	            "id": data.id,
	            "name": data.formName,
	            "timeStamp": timeStamp
	        };
	        var downloadURL = 'download';
	        this.Util.downloadZip(downloadURL, apidata);
	    };
	    // Delete selected Template
	    MainController.prototype.deleteTemplate = function (id) {
	        var _this = this;
	        var x = confirm("Are you sure you want to delete?");
	        if (x) {
	            this.$http({
	                'url': window.properties.service.uri + action_constants_1.Ids.DELETE_TEMPLATE,
	                'method': 'POST',
	                'data': id,
	                'headers': {
	                    'Content-Type': 'application/json;charset=UTF-8'
	                },
	                'withCredentials': true
	            }).then(function (response) {
	                _this.listingAjaxCall({ "page": 0, "size": 10, "sortColumn": "formName", "sortType": "ASC" });
	            });
	        }
	        else {
	            return false;
	        }
	    };
	    // Delete multiple  selected template
	    MainController.prototype.multipleDeleteTemplate = function () {
	        if (this.pagedItems.length > 0) {
	            var jsonData = [];
	            angular.forEach(this.pagedItems, function (item) {
	                if (item.selected) {
	                    jsonData.push(item.id);
	                }
	            });
	            jsonData.length > 0 && this.deleteTemplate(jsonData);
	        }
	    };
	    // search template criteria	
	    MainController.prototype.searchTempKeyEvent = function (keyEvent) {
	        if (keyEvent && keyEvent.which == 13) {
	            this.searchTemplate();
	        }
	    };
	    // Search template value
	    MainController.prototype.searchTemplate = function () {
	        var searchVal = this.searchVal;
	        var currentPageNo = this.isPagedChange ? this.currentPage - 1 : 0;
	        if ((searchVal != this.oldSearchVal) || this.isPagedChange) {
	            var data = {
	                "page": currentPageNo,
	                "size": 10,
	                "sortColumn": "formName",
	                "sortType": "ASC",
	                "filters": [{
	                        "column": "formName",
	                        "operator": "CONTAIN",
	                        "values": [searchVal]
	                    }, {
	                        "column": "description",
	                        "operator": "CONTAIN",
	                        "values": [searchVal]
	                    }],
	            };
	            this.oldSearchVal = searchVal;
	            this.listingAjaxCall(data);
	            if (this.isPagedChange == false) {
	                this.currentPage = 1;
	            }
	            this.isPagedChange = false;
	        }
	    };
	    // change the page then call this
	    MainController.prototype.pageChanged = function () {
	        this.isPagedChange = true;
	        this.searchTemplate();
	    };
	    // click on row - selected checkbox is chcked or not
	    MainController.prototype.rowClicked = function (item) {
	        item.selected = item.selected ? false : true;
	    };
	    // Check and Uncheck checkboxx
	    MainController.prototype.checkAll = function () {
	        var isSelected;
	        this.selectedAll = this.selectedAll ? true : false;
	        isSelected = this.selectedAll;
	        angular.forEach(this.pagedItems, function (item) {
	            item.selected = isSelected;
	        });
	    };
	    return MainController;
	}());
	exports.MainController = MainController;
	;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('nodeApp.main', [
	    uiRouter])
	    .config(main_routes_1.default)
	    .component('main', {
	    template: __webpack_require__(278),
	    controller: MainController
	})
	    .name;


/***/ }),
/* 277 */
/***/ (function(module, exports) {

	'use strict';
	routes.$inject = ['$stateProvider'];
	function routes($stateProvider) {
	    'ngInject';
	    $stateProvider
	        .state('main', {
	        url: '/appbuilder',
	        template: '<main></main>'
	    });
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = routes;
	;


/***/ }),
/* 278 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unauthorized-access\" ng-if=\"$ctrl.unauthorized\">\n    <div>{{$ctrl.unauthorizedMessage}}</div> \n</div>\n<div class=\"manage-form-design\" ng-if=\"!$ctrl.unauthorized\" ng-class=\"{'loading': !$ctrl.config.showListing && $ctrl.showSpinner}\">   \n            <div class=\"form-header\">\n                <span translate=\"manage.forms\">Manage Apps</span>\n                 <button type=\"button\" ng-if=\"$ctrl.pagedItems.length > 0\" class=\"hidden-lg  btn btn-danger pull-right btn-sm\"  title=\"{{ 'delete' | translate }}\" ng-model=\"deleteModel\" ng-click=\"$ctrl.multipleDeleteTemplate()\"> <i class=\"fa fa-trash-o\" ></i></button>\n                 <button  type=\"button\" class=\"hidden-lg  btn btn-danger pull-right btn-sm\" title=\"{{ 'create.form.template' | translate }}\" ng-model=\"singleModel\" ng-click=\"$ctrl.openTemplate()\" ><i class=\"fa fa-plus\" ></i></button>\n            </div>\n             <div class=\"container\">\n                <table class=\"table\"  >\n                    <thead> \n                        <tr>\n                            <th colspan=\"9\">\n                                <form class=\"form-inline \">\n                                  <div class=\"form-group search-group\">\n                                    <label class=\"sr-only\" for=\"searchButton\" translate=\"search\">Search</label>\n                                    <div class=\"input-group\">\n                                      <input type=\"text\" class=\"form-control\" id=\"searchButton\" ng-model=\"$ctrl.searchVal\" placeholder=\"{{ 'search' | translate }}\" ng-trim=\"false\" ng-keypress=\"$ctrl.searchTempKeyEvent($event)\" ng-blur=\"$ctrl.searchTemplate()\">\n\n                                      <div class=\"input-group-addon\" >\n                                             <a href=\"javascript:void(0)\" ng-click=\"$ctrl.searchTemplate()\" class=\"btn btn-danger\" title=\"{{ 'search' | translate }}\">\n                                                <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\n                                             </a>\n                                      </div>\n                                    </div>\n                                  </div>\n\n                                     <button type=\"button\" ng-if=\"$ctrl.pagedItems.length > 0\" class=\"visible-lg btn btn-danger pull-right btn-sm\"  title=\"{{ 'delete' | translate }}\" ng-model=\"deleteModel\" ng-click=\"$ctrl.multipleDeleteTemplate()\"> <i class=\"fa fa-trash-o\" ></i></button>\n                                    <button  type=\"button\" class=\"visible-lg btn btn-danger pull-right btn-sm\" title=\"{{ 'create.form.template' | translate }}\" ng-model=\"singleModel\" ng-click=\"$ctrl.openTemplate()\" ><i class=\"fa fa-plus\" ></i></button>\n                                </form>\n                            </th>\n                        </tr>\n\n                        <tr ng-if=\"$ctrl.pagedItems.length && !$ctrl.showSpinner\">\n                        \t<th class=\"header-width\"><input type=\"checkbox\" ng-model=\"$ctrl.selectedAll\" ng-click=\"$ctrl.checkAll()\" ></th>\n                            <th translate=\"template.name\">Template Name</th>\n                            <th translate=\"description\">Description</th>\n                            <th translate=\"created.on\">Created On</th>\n                            <th translate=\"last.update.on\">Last Update On</th>\n                            <th class=\"header-width\"></th>\n                            <th class=\"header-width\"></th>\n                            <th class=\"header-width\"></th>\n                            <th class=\"header-width\"></th>\n                        </tr>\n                    </thead>\n                    <tbody>\n                        <tr ng-if=\"$ctrl.pagedItems.length && !$ctrl.showSpinner\" ng-click=\"$ctrl.rowClicked(item)\" ng-repeat=\"item in $ctrl.pagedItems | limitTo:$ctrl.recordSize\" >\n                        \t<td><input type=\"checkbox\"  ng-checked=\"item.selected\"  ></td>\n                            <td>{{item.formName | limitTo: 40}} {{ item.formName && item.formName.length > 40 ? '...' : ''}}</td>\n                            <td>{{item.description | limitTo: 40}} {{ item.description && item.description.length > 40 ? '...' : ''}}</td>\n                            <td>{{ (item.createdLocalDate || '').split('#')[0] }}</td>\n                            <td>{{ (item.updatedLocalDate || '').split('#')[0] }}</td>\n                            <td class=\"header-width\">\n                                <a href=\"javascript:void(0)\" title=\"{{ 'edit' | translate }}\" ng-click=\"$ctrl.editTemplate(item)\">\n                                    <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n                                </a>\n                            </td>\n                            <td class=\"header-width\">\n                                <a href=\"javascript:void(0)\" title=\"{{ 'edit.form.design' | translate }}\" ng-click=\"$ctrl.designTemplate(item)\">\n                                    <i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i>\n                                </a>\n                            </td>\n    \t\t\t\t\t\t<td class=\"header-width\">\n                                <a href=\"javascript:void(0)\" title=\"{{ 'download' | translate }}\" ng-click=\"$ctrl.downloadZip(item)\">\n                                    <i class=\"fa fa-download\" aria-hidden=\"true\"></i>\n                                </a>\n                            </td>\n                             <td class=\"header-width\">\n                                <a href=\"javascript:void(0)\" title=\"{{ 'delete' | translate }}\" ng-click=\"$ctrl.deleteTemplate([item.id])\">\n                                    <i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i>\n                                </a>\n                            </td>\n                        </tr>\n                        <tr class=\"\" ng-if=\"$ctrl.validListMessage != '' \">\n                            <td colspan=\"9\"  class=\"valid-form-group\">\n                                <div>{{$ctrl.validListMessage}}</div>\n                            </td>\n                        </tr>\n                        <tr ng-if=\"$ctrl.config.showListing && $ctrl.showSpinner\">\n                            <td colspan=\"9\">\n                                <div class=\"loading\"></div>\n                            </td>    \n                        </tr>\n                    </tbody>\n                    <tfoot ng-if=\"$ctrl.pagedItems.length && !$ctrl.showSpinner\">\n                        <td colspan=\"9\">\n                            <ul uib-pagination total-items=\"$ctrl.totalItems\" ng-model=\"$ctrl.currentPage\" max-size=\"$ctrl.maxSize\" class=\"pagination-sm\" ng-change=\"$ctrl.pageChanged()\" boundary-links=\"false\" num-pages=\"$ctrl.pageNo\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" ></ul>                                                      \n                        </td>\n                    </tfoot>\n                </table>\n             </div>   \n            <div class=\"modal-demo\">\n                <script type=\"text/ng-template\" id=\"myModalContent.html\">\n                  <form  name=\"templateForm\"  novalidate >\n                    <div class=\"modal-header\">\n                        <h3 class=\"modal-title\" id=\"modal-title\" translate=\"create.template\" ng-if=\"!$ctrl.edit\">Create Template</h3>\n                        <h3 class=\"modal-title\" id=\"modal-title\" translate=\"edit.template\" ng-if=\"$ctrl.edit\">Edit Template</h3>\n                    </div>\n                    <div class=\"modal-body template-modal\" id=\"modal-body\"> \n                        <div ng-if=\"!$ctrl.showTemplateSpinner\">\n                           <p class=\"text-danger\" id=\"error-message\">{{$ctrl.msg}}</p>                            \n                            <div class=\"form-group\">\n                                <label for=\"inputName\" translate=\"name\">Name</label>\n                                <input autofocus type=\"text\"  class=\"form-control\" id=\"inputName\" name=\"inputName\" ng-model=\"$ctrl.inputName\"  ng-blur=\"$ctrl.restrictChar($event)\"  required=\"required\" >                    \n                            </div>\n                            <div class=\"form-group\">\n                                <label for=\"inputDesc\" translate=\"description\">Description</label>\n                                <textarea class=\"form-control\" id=\"inputDesc\" ng-model=\"$ctrl.inputDesc\" rows=\"4\"></textarea>\n\n                            </div>\n                            <div class=\"form-group\">\n                                <input type=\"checkbox\" id=\"cbox2\" ng-model=\"$ctrl.inputChk\" ng-checked=\"true\" value=\"second_checkbox\">\n                                <label for=\"cbox2\" translate=\"init.form.design\"> Initiate Form Design</label>\n                            </div>      \n                        </div>\n                         <div class=\"loading\" ng-if=\"$ctrl.showTemplateSpinner\"></div>\n                    </div>\n                    <div class=\"modal-footer\">\n                        <button class=\"btn btn-default cancel\" type=\"button\" ng-click=\"$ctrl.cancel()\" translate=\"cancel\">Cancel</button>\n                        <button class=\"btn btn-danger ok-btn\" type=\"button\" ng-click=\"$ctrl.ok()\"  ng-dblclick=\"return\" ng-disabled=\"templateForm.$invalid || $ctrl.msg != ''\" translate=\"ok\">OK</button>\n                    </div>\n                   </form> \n                </script>           \n    </div>\n</div>"

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var angular = __webpack_require__(1);
	var uiRouter = __webpack_require__(5);
	var help_routes_1 = __webpack_require__(280);
	var MainController = (function () {
	    /*@ngInject*/
	    MainController.$inject = ['Util', '$scope'];
	    function MainController(Util, $scope) {
	        this.DSFields = [];
	        this.searchText = '';
	        this.DSType = {
	            Single: 'single',
	            Multiple: 'multiple'
	        };
	        var self = this;
	        this.$scope = $scope;
	        this.loading = true;
	        this.getDFFields = Util.getFixedFieldsFromServer();
	        this.getDFFields.then(function (response) {
	            self.setData(response);
	        }, function () {
	            self.loading = false;
	            self.$scope.$digest();
	        });
	    }
	    MainController.prototype.setData = function (response) {
	        var self = this;
	        if (response && response.data && response.data.entity) {
	            this.DSFields = this.DSFields.concat(response.data.entity.multiValueFixedFields.map(function (val, index) {
	                val.type = self.DSType.Multiple;
	                return val;
	            }));
	            this.DSFields = this.DSFields.concat(response.data.entity.singleValueFixedFields.map(function (val, index) {
	                val.type = self.DSType.Single;
	                return val;
	            }));
	            this.DSFields = this.DSFields.map(function (val, index) {
	                val.id = index;
	                delete val.name;
	                return val;
	            });
	        }
	        self.loading = false;
	        self.$scope.$digest();
	    };
	    return MainController;
	}());
	exports.MainController = MainController;
	;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('nodeApp.help', [
	    uiRouter])
	    .config(help_routes_1.default)
	    .component('help', {
	    template: __webpack_require__(281),
	    controller: MainController
	})
	    .name;


/***/ }),
/* 280 */
/***/ (function(module, exports) {

	'use strict';
	routes.$inject = ['$stateProvider'];
	function routes($stateProvider) {
	    'ngInject';
	    $stateProvider
	        .state('help', {
	        url: '/help',
	        template: '<help></help>'
	    });
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = routes;
	;


/***/ }),
/* 281 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"manage-form-design\">\n    <div class=\"form-header navbar-fixed-top\">\n        <span class=\"header-text\">Available Data Sources</span>\n        <input type=\"text\" class=\"form-control pull-right search\" placeholder=\"Search\" ng-model=\"$ctrl.searchText\" ng-model-options=\"{debounce: 300}\">\n    </div>\n    <div class=\"contianer\" ng-class=\"{loading: $ctrl.loading}\">\n        <p ng-if=\"!$ctrl.DSFields.length\">No Data found.</p>\n        <table class=\"table\" ng-if=\"$ctrl.DSFields.length\">\n            <thead>\n                <tr>\n                    <th class=\"field-name\">Name</th>\n                    <th class=\"field-type\">Applicable Field Type</th>\n                    <th class=\"field-desc\">Description</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat=\"item in $ctrl.DSFields | filter: $ctrl.searchText track by item.id\">\n                    <td ng-bind=\"::item.value\"></td>\n                    <td translate=\"{{ ::item.type }}\"></td>\n                    <td ng-bind=\"::item.description\"></td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>"

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var angular = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('nodeApp.constants', [])
	    .constant('appConfig', {})
	    .name;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	customLoader.$inject = ['$rootScope', '$http', '$q'];
	var angular = __webpack_require__(1);
	var action_constants_1 = __webpack_require__(19);
	/**
	 * @brief      Load Json from server-side for translation
	 *
	 * @param      $rootScope  The root scope
	 * @param      $http       The http
	 * @param      $q          The quarter
	 *
	 * @return     API
	 */
	function customLoader($rootScope, $http, $q) {
	    /**
	     * @brief      Load method of this factory
	     *
	     * @return     promise for custom loader
	     */
	    function load() {
	        var deferred = $q.defer();
	        $http({
	            'url': window.properties.service.uri + action_constants_1.Ids.GET_LANGUAGE_KEYS,
	            'method': 'GET',
	            'headers': {
	                'Content-Type': 'application/json;charset=UTF-8'
	            },
	            'withCredentials': true
	        }).then(function (response) {
	            var data = response.data.entity;
	            deferred.resolve(data);
	        });
	        return deferred.promise;
	    }
	    // Public API here
	    return load;
	}
	exports.customLoader = customLoader;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('nodeApp.customLoader', [])
	    .factory('customLoader', customLoader)
	    .name;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var angular = __webpack_require__(1);
	/*@ngInject*/
	function counterService() {
	    this.counter = {};
	    this.callBacks = [];
	    this.setCallBack = function (callback) {
	        this.callBacks.push(callback);
	    };
	    this.triggerChangeCallBack = function () {
	        for (var i = 0; i < this.callBacks.length; i++) {
	            this.callBacks[i]();
	        }
	    };
	    this.removeCallBacks = function () {
	        this.callBacks = [];
	    };
	}
	exports.counterService = counterService;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('nodeApp.counterService', [])
	    .service('counterService', counterService)
	    .name;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var angular = __webpack_require__(1);
	var util_service_1 = __webpack_require__(286);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('nodeApp.util', [])
	    .factory('Util', util_service_1.UtilService)
	    .name;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	UtilService.$inject = ['$window', '$http', 'localStorage', '$rootScope', 'config', '$uibModal', '$timeout', '$httpParamSerializer'];
	var angular = __webpack_require__(1);
	var _ = __webpack_require__(23);
	var action_constants_1 = __webpack_require__(19);
	/**
	 * The Util service is for thin, globally reusable, utility functions
	 */
	function UtilService($window, $http, localStorage, $rootScope, config, $uibModal, $timeout, $httpParamSerializer) {
	    'ngInject';
	    var languageSpecificDateFormat = { "en_GB": "dd-M-yy", "fr_FR": "d M yy", "es_ES": "dd-M-yy", "ru_RU": "dd.mm.yy", "en_AU": "dd/mm/yy", "en_CA": "d-M-yy", "en_US": "M d, yy", "zh_CN": "yy-m-d", "de_DE": "dd.mm.yy", "ga_IE": "d M yy", "en_ZA": "dd M yy", "ja_JP": "yy/mm/dd", "ar_SA": "dd/mm/yy", "en_IE": "dd-M-yy", "it_IT": "dd/mm/yy" };
	    var _ticksTo1970 = (((1970 - 1) * 365 + Math.floor(1970 / 4) - Math.floor(1970 / 100) + Math.floor(1970 / 400)) * 24 * 60 * 60 * 10000000);
	    var loginModal;
	    var timer;
	    var Util = {
	        controlsWithoutFieldName: ['Line'],
	        /**
	         * Return a callback or noop function
	         *
	         * @param  {Function|*} cb - a 'potential' function
	         * @return {Function}
	         */
	        safeCb: function (cb) {
	            return (angular.isFunction(cb)) ? cb : angular.noop;
	        },
	        /**
	         * Parse a given url with the use of an anchor element
	         *
	         * @param  {String} url - the url to parse
	         * @return {Object}     - the parsed url, anchor element
	         */
	        urlParse: function (url) {
	            var a = document.createElement('a');
	            a.href = url;
	            // Special treatment for IE, see http://stackoverflow.com/a/13405933 for details
	            if (a.host === '') {
	                a.href = a.href;
	            }
	            return a;
	        },
	        /**
	         * Test whether or not a given url is same origin
	         *
	         * @param  {String}           url       - url to test
	         * @param  {String|String[]}  [origins] - additional origins to test against
	         * @return {Boolean}                    - true if url is same origin
	         */
	        isSameOrigin: function (url, origins) {
	            url = Util.urlParse(url);
	            origins = (origins && [].concat(origins)) || [];
	            origins = origins.map(Util.urlParse);
	            origins.push($window.location);
	            origins = origins.filter(function (o) {
	                var hostnameCheck = url.hostname === o.hostname;
	                var protocolCheck = url.protocol === o.protocol;
	                // 2nd part of the special treatment for IE fix (see above):
	                // This part is when using well-known ports 80 or 443 with IE,
	                // when $window.location.port==='' instead of the real port number.
	                // Probably the same cause as this IE bug: https://goo.gl/J9hRta
	                var portCheck = url.port === o.port || (o.port === '' && (url.port === '80' || url.port === '443'));
	                return hostnameCheck && protocolCheck && portCheck;
	            });
	            return origins.length >= 1;
	        },
	        accessTableElements: function (list, callback) {
	            var rows = list.data;
	            if (rows.length) {
	                for (var j = 0; j < rows.length; j++) {
	                    var columns = rows[j];
	                    if (columns.length) {
	                        for (var k = 0; k < columns.length; k++) {
	                            var elems = columns[k].elems[0];
	                            if (elems.length) {
	                                callback(elems);
	                            }
	                        }
	                    }
	                }
	            }
	        },
	        accessLayoutElements: function (list, callback) {
	            var data = list.data;
	            if (data.length) {
	                for (var j = 0; j < data.length; j++) {
	                    var elems = data[j].elems[0];
	                    if (elems.length) {
	                        callback(elems);
	                    }
	                }
	            }
	        },
	        accessRepeatingTableElements: function (list, callback, excludeRepeatData) {
	            var columns = list.data[0];
	            if (columns.length && !excludeRepeatData) {
	                for (var k = 0; k < columns.length; k++) {
	                    var elems = columns[k].elems[0];
	                    if (elems.length) {
	                        callback(elems);
	                    }
	                }
	            }
	            var headerColumns = list.header_data[0];
	            if (headerColumns.length) {
	                for (var k = 0; k < headerColumns.length; k++) {
	                    var elems = headerColumns[k].elems[0];
	                    if (elems.length) {
	                        callback(elems);
	                    }
	                }
	            }
	            var footerColumns = list.footer_data[0];
	            if (footerColumns.length) {
	                for (var k = 0; k < footerColumns.length; k++) {
	                    var elems = footerColumns[k].elems[0];
	                    if (elems.length) {
	                        callback(elems);
	                    }
	                }
	            }
	        },
	        accessSectionElements: function (list, callback) {
	            var elems = list.data.elems[0];
	            if (elems.length) {
	                callback(elems);
	            }
	        },
	        recursionForRepeatingTable: function (data, name, callback, stopOnMatch) {
	            var self = this;
	            for (var key in data) {
	                if (data.hasOwnProperty(key)) {
	                    var element = data[key];
	                    if (element.type === "RepeatingTable" && element.data.length > 0 && !element.derivedFromFieldName) {
	                        for (var j = 0; j < element.data.length; j++) {
	                            var ev = element.data[0][0].elems[0][0];
	                            var fieldName = ev.properties['Basic']['Field Name'].selectedValue;
	                            if (ev && fieldName == name) {
	                                callback(element.data, element);
	                                if (stopOnMatch) {
	                                    return true;
	                                }
	                            }
	                            else if (ev) {
	                                self.recursionForRepeatingTable(ev, name, callback, stopOnMatch);
	                            }
	                        }
	                    }
	                }
	            }
	        },
	        getIteams: function (list, finalArray, parent, excludeRepeatData, parentFieldName) {
	            if (finalArray === void 0) { finalArray = []; }
	            if (parent === void 0) { parent = ''; }
	            if (excludeRepeatData === void 0) { excludeRepeatData = false; }
	            if (parentFieldName === void 0) { parentFieldName = ''; }
	            var self = this;
	            var fieldName;
	            if (list.length) {
	                for (var i = 0; i < list.length; i++) {
	                    (parent || parent == '') && (list[i].parent = parent);
	                    parentFieldName && (list[i].parentFieldName = parentFieldName);
	                    fieldName = list[i].properties.Basic && list[i].properties.Basic['Field Name'].selectedValue;
	                    finalArray.push(list[i]);
	                    if (list[i].type == "Layout") {
	                        this.accessLayoutElements(list[i], function (elems) {
	                            self.getIteams(elems, finalArray, parent, excludeRepeatData);
	                        });
	                    }
	                    if (list[i].type == "Table") {
	                        this.accessTableElements(list[i], function (elems) {
	                            self.getIteams(elems, finalArray, parent, excludeRepeatData);
	                        });
	                    }
	                    if (list[i].type == "RepeatingTable") {
	                        this.accessRepeatingTableElements(list[i], function (elems) {
	                            self.getIteams(elems, finalArray, 'repeating-table', excludeRepeatData, fieldName);
	                        }, excludeRepeatData);
	                    }
	                    if (list[i].type == "Section") {
	                        this.accessSectionElements(list[i], function (elems) {
	                            self.getIteams(elems, finalArray, 'section');
	                        });
	                    }
	                }
	            }
	            return finalArray;
	        },
	        getIteamsByType: function (list, finalArray, type, parent, parentFieldName) {
	            if (finalArray === void 0) { finalArray = []; }
	            if (parent === void 0) { parent = ''; }
	            if (parentFieldName === void 0) { parentFieldName = ''; }
	            var self = this;
	            var fieldName;
	            if (list.length) {
	                for (var i = 0; i < list.length; i++) {
	                    parent && (list[i].parent = parent);
	                    parentFieldName && (list[i].parentFieldName = parentFieldName);
	                    fieldName = list[i].properties.Basic && list[i].properties.Basic['Field Name'].selectedValue;
	                    if (type.indexOf(list[i].type) != -1) {
	                        finalArray.push(list[i]);
	                    }
	                    if (list[i].type == "Table") {
	                        this.accessTableElements(list[i], function (elems) {
	                            self.getIteamsByType(elems, finalArray, type);
	                        });
	                    }
	                    /*if (list[i].type == "Section") {
	                      this.accessSectionElements(list[i], function (elems) {
	                        self.getIteamsByType(elems, finalArray, type);
	                      });
	                    }*/
	                    if (list[i].type == "Layout") {
	                        this.accessLayoutElements(list[i], function (elems) {
	                            self.getIteamsByType(elems, finalArray, type);
	                        });
	                    }
	                    if (list[i].type == "RepeatingTable") {
	                        this.accessRepeatingTableElements(list[i], function (elems) {
	                            self.getIteamsByType(elems, finalArray, type, 'repeating-table', fieldName);
	                        });
	                    }
	                }
	            }
	            return finalArray;
	        },
	        returnSelected: function (list) {
	            var controls = this.getIteams(list);
	            return controls.filter(function (item) {
	                return item.selected && item.selected == true;
	            });
	        },
	        returnSelectedForCopy: function (list, finalArray, includeSubItems, copyAll) {
	            if (finalArray === void 0) { finalArray = []; }
	            if (includeSubItems === void 0) { includeSubItems = true; }
	            if (copyAll === void 0) { copyAll = false; }
	            var self = this;
	            if (list.length) {
	                for (var i = 0; i < list.length; i++) {
	                    if (list[i].selected || copyAll) {
	                        finalArray.push(list[i]);
	                    }
	                    if (list[i].type == "Layout" && !list[i].selected && includeSubItems) {
	                        this.accessLayoutElements(list[i], function (elems) {
	                            self.returnSelectedForCopy(elems, finalArray, includeSubItems);
	                        });
	                    }
	                    if (list[i].type == "Table" && !list[i].selected && includeSubItems) {
	                        this.accessTableElements(list[i], function (elems) {
	                            self.returnSelectedForCopy(elems, finalArray, includeSubItems);
	                        });
	                    }
	                    if (list[i].type == "RepeatingTable" && !list[i].selected && includeSubItems) {
	                        this.accessRepeatingTableElements(list[i], function (elems) {
	                            self.returnSelectedForCopy(elems, finalArray, includeSubItems);
	                        });
	                    }
	                    if (list[i].type == "Section" && !list[i].selected && includeSubItems) {
	                        this.accessSectionElements(list[i], function (elems) {
	                            self.returnSelectedForCopy(elems, finalArray, includeSubItems);
	                        });
	                    }
	                }
	            }
	            return finalArray;
	        },
	        getProjectCustomAttributeSet: function (projectId) {
	            $http({
	                'url': window.properties.service.commonApiUrl + 'manageAttribute/getProjectCustomAttributeSet',
	                'method': 'POST',
	                'withCredentials': true,
	                'data': $httpParamSerializer({ projectId: projectId, isRequiredHierarchyAttributes: 'true', callingArea: 'form' }),
	                'headers': {
	                    'Content-Type': 'application/x-www-form-urlencoded'
	                }
	            }).then(function (response) {
	                if (response.data) {
	                    var data = response.data;
	                    $rootScope.ProjectCustomAttributeSet = data;
	                }
	                else {
	                    $rootScope.ProjectCustomAttributeSet = {};
	                }
	            }, function (err) {
	                console.log("Error occuring during API call!");
	            });
	        },
	        /**
	         * Replace all matches with new string value
	         * @param message - Message string
	         * @param curText - Current text which will be replaces with new text
	         * @param newText - New text
	         * @return {String} message - New message in which new text with repalce with currrent text
	         */
	        replaceAllMatches: function (message, curText, newText) {
	            while (message.indexOf(curText) != -1) {
	                message = message.replace(curText, newText);
	            }
	            return message;
	        },
	        replaceUnderscoresValue: function (value) {
	            if (value && typeof value == 'string' && value.indexOf('___') != -1) {
	                return value.replace(/___+/g, '__');
	            }
	            return value;
	        },
	        getUSP: function () {
	            var self = this;
	            return new Promise(function (resolve, reject) {
	                $http({
	                    'url': window.properties.service.uri + action_constants_1.Ids.GET_USP,
	                    'method': 'GET',
	                    'data': {},
	                    'headers': {
	                        'Content-Type': 'application/json;charset=UTF-8'
	                    },
	                    'withCredentials': true
	                }).then(function (response) {
	                    if (response.data && response.data.entity) {
	                        var data = response.data.entity;
	                        $rootScope.USP = data;
	                    }
	                    else {
	                        $rootScope.USP = {};
	                    }
	                    resolve();
	                }, function (response) {
	                    console.log(response);
	                    reject();
	                });
	            });
	        },
	        getAvailableDSFromServer: function () {
	            var self = this;
	            $http({
	                'url': window.properties.service.uri + action_constants_1.Ids.GET_AVAILABLE_SECONDARY_DS,
	                'method': 'GET',
	                'data': {},
	                'headers': {
	                    'Content-Type': 'application/json;charset=UTF-8'
	                },
	                'withCredentials': true
	            }).then(function (response) {
	                if (response.data && response.data.entity && response.data.entity.length) {
	                    self.availableDS = response.data.entity;
	                }
	            }, function (response) {
	                console.log(response);
	            });
	        },
	        getFixedFieldsFromServer: function () {
	            var self = this;
	            return new Promise(function (resolve, reject) {
	                $http({
	                    'url': window.properties.service.uri + action_constants_1.Ids.GET_APPS_LOOKUP_DATA,
	                    'method': 'GET',
	                    'data': {},
	                    'headers': {
	                        'Content-Type': 'application/json;charset=UTF-8'
	                    },
	                    'withCredentials': true
	                }).then(function (response) {
	                    if (response.data && response.data.entity) {
	                        self.multiValueFixedFields = response.data.entity.multiValueFixedFields;
	                        self.singleValueFixedFields = response.data.entity.singleValueFixedFields;
	                        self.singleValueFixedFields.push({
	                            name: "DS_locationName_PF",
	                            value: "Location Name",
	                            description: "Returns form location details"
	                        });
	                        self.singleValueFixedFields.push({
	                            name: "DS_locationPath_PF",
	                            value: "Location Path",
	                            description: "Returns form location details"
	                        });
	                        var item = self.multiValueFixedFields.filter(function (item) { return item.name === "DS_INCOMPLETE_ACTIONS_BYMSG" || item.name === "DS_INCOMPLETE_ACTIONS"; }).map(function (item) { return JSON.parse(JSON.stringify(item)); });
	                        if (item) {
	                            (_a = self.singleValueFixedFields).push.apply(_a, item);
	                        }
	                        self.viewNames = response.data.entity.views;
	                    }
	                    resolve(response);
	                    var _a;
	                }, function (response) {
	                    console.log(response);
	                    resolve();
	                });
	            });
	        },
	        getValueOfOnLoadData: function (id) {
	            var element = document.getElementById(id);
	            if (!element) {
	                return;
	            }
	            var val = '';
	            if (element.value == '') {
	                return val;
	            }
	            val = element.value;
	            try {
	                val = JSON.parse(val).Items.Item;
	                if (val.length == 1 && !val[0].Name && !val[0].Value) {
	                    return [];
	                }
	                return val;
	            }
	            catch (e) {
	                return val;
	            }
	        },
	        getAvailableDS: function () {
	            var options = [];
	            if (this.availableDS && this.availableDS.length) {
	                for (var i = 0; i < this.availableDS.length; i++) {
	                    options.push({
	                        key: this.availableDS[i].name,
	                        value: this.availableDS[i].uri + '/' + this.availableDS[i].name
	                    });
	                }
	            }
	            return options;
	        },
	        getFixedFields: function (singleValue) {
	            var availableFF = singleValue ? this.singleValueFixedFields : this.multiValueFixedFields;
	            var options = [];
	            if (availableFF.length) {
	                for (var i = 0; i < availableFF.length; i++) {
	                    options.push({
	                        key: availableFF[i].value,
	                        value: availableFF[i].name == 'DS_WORKINGUSERROLE' ? 'DS_WORKINGUSER_ALL_ROLES' : availableFF[i].name,
	                        group: 'System'
	                    });
	                }
	            }
	            return options;
	        },
	        getViewNames: function () {
	            var viewNames = this.viewNames;
	            var options = [];
	            if (viewNames && viewNames.length) {
	                for (var i = 0; i < viewNames.length; i++) {
	                    var element = viewNames[i];
	                    options.push({
	                        key: element.value,
	                        value: element.name
	                    });
	                }
	            }
	            return options;
	        },
	        getCurrentFormViewNames: function () {
	            var views = localStorage.get('views');
	            var output = [];
	            var _loop_1 = function(viewName) {
	                var found = this_1.viewNames.find(function (obj) { return obj.name === viewName; });
	                if (found) {
	                    output.push({
	                        name: found.value,
	                        value: found.name
	                    });
	                }
	                else {
	                    output.push({
	                        name: viewName,
	                        value: viewName
	                    });
	                }
	            };
	            var this_1 = this;
	            for (var viewName in views) {
	                _loop_1(viewName);
	            }
	            return output;
	        },
	        getProtectedParamsFromServer: function () {
	            var self = this;
	            return new Promise(function (resolve, reject) {
	                $http({
	                    'url': window.properties.service.uri + action_constants_1.Ids.GET_PROTECTED_PARAMS,
	                    'method': 'GET',
	                    'data': {},
	                    'headers': {
	                        'Content-Type': 'application/json;charset=UTF-8'
	                    },
	                    'withCredentials': true
	                }).then(function (response) {
	                    if (response.data && response.data.entity) {
	                        self.protectedParams = Object.keys(response.data.entity.entity || {}).map(function (elm) { return elm.toLowerCase(); }) || [];
	                    }
	                    resolve(response);
	                }, function (response) {
	                    console.log(response);
	                    resolve();
	                });
	            });
	        },
	        getProtectedParams: function () {
	            return this.protectedParams;
	        },
	        getCustomAttributesFromServer: function (config) {
	            var self = this;
	            return new Promise(function (resolve, reject) {
	                var projectId = _.get(config, 'formDetail.id.projectId', '');
	                if (!projectId) {
	                    resolve();
	                    return;
	                }
	                $http({
	                    'url': "" + window.properties.service.commonApiUrl + action_constants_1.Ids.GET_CUSTOM_ATTR_NAMES + "?projectId=" + projectId,
	                    'method': 'GET',
	                    'data': {},
	                    'headers': {
	                        'Content-Type': 'application/json;charset=UTF-8'
	                    },
	                    'withCredentials': true
	                }).then(function (response) {
	                    self.customAttributes = response.data || [];
	                    resolve(response);
	                }, function (response) {
	                    console.log(response);
	                    resolve();
	                });
	            });
	        },
	        getCustomAttributes: function () {
	            var availableCA = this.customAttributes || [];
	            var options = [];
	            if (availableCA.length) {
	                for (var i = 0; i < availableCA.length; i++) {
	                    options.push({
	                        key: availableCA[i],
	                        value: availableCA[i]
	                    });
	                }
	            }
	            return options;
	        },
	        initServerCalls: function (config) {
	            var self = this;
	            if (this.initialized)
	                return Promise.all([]);
	            this.initialized = true;
	            //this.getAvailableDSFromServer();
	            var USP = this.getUSP();
	            return USP.then(function () {
	                return Promise.all([self.getFixedFieldsFromServer(), self.getSupportedLanguages(), self.getProtectedParamsFromServer(), self.getCustomAttributesFromServer(config), self.getDocColumnList(), self.getAppColumnList()]);
	            });
	        },
	        getAllControls: function (excludeRepeatingTableVal) {
	            if (excludeRepeatingTableVal === void 0) { excludeRepeatingTableVal = false; }
	            var views = localStorage.get('views');
	            var totalItems = [];
	            for (var view in views) {
	                totalItems = totalItems.concat(this.getIteams(views[view].controls.A, [], '', excludeRepeatingTableVal));
	            }
	            return totalItems;
	        },
	        getControlsByType: function (type) {
	            var views = localStorage.get('views');
	            var totalItems = [];
	            for (var view in views) {
	                totalItems = totalItems.concat(this.getIteamsByType(views[view].controls.A, [], type));
	            }
	            return totalItems;
	        },
	        getFieldNames: function (controlType) {
	            var totalItems = this.getAllControls();
	            var fieldNames = [];
	            if (totalItems.length) {
	                for (var i = 0; i < totalItems.length; i++) {
	                    if ((!controlType || controlType == totalItems[i].type) && this.controlsWithoutFieldName.indexOf(totalItems[i].type) == -1 && totalItems[i].properties.Basic && totalItems[i].properties.Basic['Field Name']) {
	                        var fieldName = totalItems[i].properties.Basic && totalItems[i].properties.Basic['Field Name'].selectedValue;
	                        var copiedReadonlyField = totalItems[i].copiedFrom ? true : false;
	                        var type = totalItems[i].properties.Basic.ControlType || '';
	                        var parent_1 = totalItems[i].parent || '';
	                        if (type) {
	                            fieldName = fieldName + '$$' + type + '$$' + parent_1;
	                        }
	                        fieldName && !copiedReadonlyField && fieldNames.indexOf(fieldName) == -1 && fieldNames.push(fieldName);
	                    }
	                }
	            }
	            return fieldNames.map(function (val) {
	                var fieldName = val.split('$$')[0];
	                var typeName = val.split('$$')[1] || '';
	                var parentName = val.split('$$')[2] || '';
	                return { key: fieldName, value: fieldName, type: typeName, parent: parentName, group: 'Custom' };
	            });
	        },
	        getDataFieldNames: function (excludeRepeatingTableVal) {
	            var totalItems = this.getAllControls(excludeRepeatingTableVal);
	            var fieldNames = [];
	            if (totalItems.length) {
	                var onlyFieldNames = [];
	                for (var i = 0; i < totalItems.length; i++) {
	                    if (this.controlsWithoutFieldName.indexOf(totalItems[i].type) == -1 && totalItems[i].properties.Basic && totalItems[i].properties.Basic['Data Field Name']) {
	                        if (totalItems[i].type == "InlineAssocFiles" || totalItems[i].type == "InlineAssocApps" || totalItems[i].type == "ViewAssociations") {
	                            continue;
	                        }
	                        var fieldName = totalItems[i].properties.Basic && totalItems[i].properties.Basic['Data Field Name'].selectedValue;
	                        if (fieldName && onlyFieldNames.indexOf(fieldName) == -1) {
	                            onlyFieldNames.push(fieldName);
	                            var type = totalItems[i].properties.Basic.ControlType || '';
	                            var parent_2 = totalItems[i].parent || '';
	                            var parentFieldName = totalItems[i].parentFieldName || '';
	                            var dateWithTime = totalItems[i].properties.Basic.Time && totalItems[i].properties.Basic.Time['selectedValue'] || "";
	                            fieldName = fieldName + '$$' + type + '$$' + parent_2 + '$$' + parentFieldName + '$$' + dateWithTime;
	                            fieldNames.push(fieldName);
	                        }
	                    }
	                }
	            }
	            return fieldNames.map(function (val) {
	                var fieldName = val.split('$$')[0];
	                var typeName = val.split('$$')[1] || '';
	                var parentName = val.split('$$')[2] || '';
	                var parentFieldName = val.split('$$')[3] || '';
	                var isTimeEnabled = val.split('$$')[4] || '';
	                return { key: fieldName, value: fieldName, type: typeName, parent: parentName, group: 'Custom', parentFieldName: parentFieldName, isTimeEnabled: isTimeEnabled };
	            });
	        },
	        getNumberFieldNames: function () {
	            var totalItems = this.getAllControls();
	            var fieldNames = [];
	            var totalNumOptions = [];
	            var selectedType = [];
	            var selectedParent = [];
	            for (var totalItem in totalItems) {
	                if ((totalItems[totalItem].type.toLowerCase() == "textbox" &&
	                    totalItems[totalItem].properties.Basic.Validate.selectedValue != "" &&
	                    (totalItems[totalItem].properties.Basic.Validate.selectedValue == "Integer" ||
	                        totalItems[totalItem].properties.Basic.Validate.selectedValue == "Decimal") ||
	                    totalItems[totalItem].type.toLowerCase() == "display field" &&
	                        !totalItems[totalItem].properties.Basic.Label.isSelected)) {
	                    totalNumOptions.push(totalItems[totalItem]);
	                }
	            }
	            if (totalNumOptions.length) {
	                for (var i = 0; i < totalNumOptions.length; i++) {
	                    var fieldName = totalNumOptions[i].properties.Basic && totalNumOptions[i].properties.Basic['Field Name'] && totalNumOptions[i].properties.Basic['Field Name'].selectedValue;
	                    if (totalNumOptions[i].type.toLowerCase() == "textbox")
	                        selectedType.push(totalNumOptions[i].properties.Basic.Validate.selectedValue);
	                    fieldName && fieldNames.indexOf(fieldName) == -1 && fieldNames.push(fieldName);
	                    if (totalNumOptions[i].parent && totalNumOptions[i].parent == "repeating-table" && (totalNumOptions[i].type.toLowerCase() == "textbox" || totalNumOptions[i].type.toLowerCase() == "display field"))
	                        selectedParent.push(1);
	                    else
	                        selectedParent.push(0);
	                }
	            }
	            return fieldNames.map(function (val, key) { return { key: val, value: val, type: selectedType[key], parent: selectedParent[key] }; });
	        },
	        replaceFieldNameInCodeEditor: function (controls, oldFieldName, newFieldName) {
	            var _this = this;
	            if (!controls) {
	                controls = this.getAllControls();
	            }
	            //Replace in controls events code editor
	            controls.forEach(function (control) {
	                if (control.properties && control.properties.Events) {
	                    for (var event_1 in control.properties.Events) {
	                        var eventDetail = control.properties.Events[event_1];
	                        if (event_1 != 'Name' && event_1 != 'forceToDisabled' && eventDetail.selectedValue) {
	                            eventDetail.selectedValue = _this.replaceAllMatches(eventDetail.selectedValue, "PropValue('" + oldFieldName + "'", "PropValue('" + newFieldName + "'");
	                            eventDetail.selectedValue = _this.replaceAllMatches(eventDetail.selectedValue, "resetRepeatingTableValue('" + oldFieldName + "'", "resetRepeatingTableValue('" + newFieldName + "'");
	                            eventDetail.selectedValue = _this.replaceAllMatches(eventDetail.selectedValue, "getRepeatingTableValue('" + oldFieldName + "'", "getRepeatingTableValue('" + newFieldName + "'");
	                            eventDetail.selectedValue = _this.replaceAllMatches(eventDetail.selectedValue, "addWorkingDaysForCustomDate('" + oldFieldName + "'", "addWorkingDaysForCustomDate('" + newFieldName + "'");
	                            eventDetail.xmlValue = _this.replaceAllMatches(eventDetail.xmlValue, "<field name=\"CONTROL_NAME\">" + oldFieldName + "</field><field name=\"PROPERTY_NAME\">", "<field name=\"CONTROL_NAME\">" + newFieldName + "</field><field name=\"PROPERTY_NAME\">");
	                            eventDetail.xmlValue = _this.replaceAllMatches(eventDetail.xmlValue, "<field name=\"CONTROL_NAME\">" + oldFieldName + "</field></block>", "<field name=\"CONTROL_NAME\">" + newFieldName + "</field></block>");
	                            eventDetail.xmlValue = _this.replaceAllMatches(eventDetail.xmlValue, "<field name=\"SOURCE_FIELD_NAME\">" + oldFieldName + "</field><field name=\"OPERATOR\">", "<field name=\"SOURCE_FIELD_NAME\">" + newFieldName + "</field><field name=\"OPERATOR\">");
	                        }
	                    }
	                }
	            });
	            //Replace in Globle code editor
	            if (window['globle'].scriptVal) {
	                window['globle'].scriptVal = this.replaceAllMatches(window['globle'].scriptVal, "PropValue('" + oldFieldName + "'", "PropValue('" + newFieldName + "'");
	                window['globle'].scriptVal = this.replaceAllMatches(window['globle'].scriptVal, "resetRepeatingTableValue('" + oldFieldName + "'", "resetRepeatingTableValue('" + newFieldName + "'");
	                window['globle'].scriptVal = this.replaceAllMatches(window['globle'].scriptVal, "getRepeatingTableValue('" + oldFieldName + "'", "getRepeatingTableValue('" + newFieldName + "'");
	                window['globle'].scriptVal = this.replaceAllMatches(window['globle'].scriptVal, "addWorkingDaysForCustomDate('" + oldFieldName + "'", "addWorkingDaysForCustomDate('" + newFieldName + "'");
	                window['globle'].xmlVal = this.replaceAllMatches(window['globle'].xmlVal, "<field name=\"CONTROL_NAME\">" + oldFieldName + "</field><field name=\"PROPERTY_NAME\">", "<field name=\"CONTROL_NAME\">" + newFieldName + "</field><field name=\"PROPERTY_NAME\">");
	                window['globle'].xmlVal = this.replaceAllMatches(window['globle'].xmlVal, "<field name=\"CONTROL_NAME\">" + oldFieldName + "</field></block>", "<field name=\"CONTROL_NAME\">" + newFieldName + "</field></block>");
	                window['globle'].xmlVal = this.replaceAllMatches(window['globle'].xmlVal, "<field name=\"SOURCE_FIELD_NAME\">" + oldFieldName + "</field><field name=\"OPERATOR\">", "<field name=\"SOURCE_FIELD_NAME\">" + newFieldName + "</field><field name=\"OPERATOR\">");
	            }
	        },
	        replaceDataFieldNameInCodeEditor: function (controls, oldFieldName, newFieldName) {
	            var _this = this;
	            if (!controls) {
	                controls = this.getAllControls();
	            }
	            //Replace in controls events code editor
	            //Replace in controls events code editor
	            controls.forEach(function (control) {
	                if (control.properties && control.properties.Events) {
	                    for (var event_2 in control.properties.Events) {
	                        var eventDetail = control.properties.Events[event_2];
	                        if (event_2 != 'Name' && event_2 != 'forceToDisabled' && eventDetail.selectedValue) {
	                            var value_1 = eventDetail.selectedValue;
	                            if (value_1.includes("window.addWorkingDaysForCustomDate")) {
	                                var parts = value_1.split(',');
	                                var firstPart = parts[0];
	                                var remainingParts = parts.slice(1).join(',');
	                                var updatedRemainingParts = _this.replaceAllMatches(remainingParts, oldFieldName + "',", newFieldName + "',");
	                                eventDetail.selectedValue = firstPart + "," + updatedRemainingParts;
	                            }
	                            eventDetail.selectedValue = _this.replaceAllMatches(eventDetail.selectedValue, "PropValueByDataFieldName('" + oldFieldName + "'", "PropValueByDataFieldName('" + newFieldName + "'");
	                            eventDetail.selectedValue = _this.replaceAllMatches(eventDetail.selectedValue, "'DateDataFieldName###" + oldFieldName + "###'", "'DateDataFieldName###" + newFieldName + "###'");
	                            eventDetail.selectedValue = _this.replaceAllMatches(eventDetail.selectedValue, "'TimeDataFieldName###" + oldFieldName + "###'", "'TimeDataFieldName###" + newFieldName + "###'");
	                            eventDetail.selectedValue = _this.replaceAllMatches(eventDetail.selectedValue, "addOrSubtractDate('" + oldFieldName + "'", "addOrSubtractDate('" + newFieldName + "'");
	                            eventDetail.selectedValue = _this.replaceAllMatches(eventDetail.selectedValue, "setAutoNumbering('" + oldFieldName + "'", "setAutoNumbering('" + newFieldName + "'");
	                            eventDetail.selectedValue = _this.replaceAllMatches(eventDetail.selectedValue, "addWorkingDays('" + oldFieldName + "'", "addWorkingDays('" + newFieldName + "'");
	                            eventDetail.xmlValue = _this.replaceAllMatches(eventDetail.xmlValue, "<field name=\"AUTO_NUMBER_FIELD\">" + oldFieldName + "</field>", "<field name=\"AUTO_NUMBER_FIELD\">" + newFieldName + "</field>");
	                            eventDetail.xmlValue = _this.replaceAllMatches(eventDetail.xmlValue, "<field name=\"CONTROL_NAME\">" + oldFieldName + "</field></block>", "<field name=\"CONTROL_NAME\">" + newFieldName + "</field></block>");
	                            eventDetail.xmlValue = _this.replaceAllMatches(eventDetail.xmlValue, "<field name=\"CONTROL_NAME\">" + oldFieldName + "</field><value name=\"PROPERTY_VALUE_INPUT\">", "<field name=\"CONTROL_NAME\">" + newFieldName + "</field><value name=\"PROPERTY_VALUE_INPUT\">");
	                            eventDetail.xmlValue = _this.replaceAllMatches(eventDetail.xmlValue, "<field name=\"CONTROL_NAME\">" + oldFieldName + "</field><field name=\"PROPERTY_VALUE\">", "<field name=\"CONTROL_NAME\">" + newFieldName + "</field><field name=\"PROPERTY_VALUE\">");
	                            eventDetail.xmlValue = _this.replaceAllMatches(eventDetail.xmlValue, "<field name=\"DATE1\">" + oldFieldName + "</field>", "<field name=\"DATE1\">" + newFieldName + "</field>");
	                            eventDetail.xmlValue = _this.replaceAllMatches(eventDetail.xmlValue, "<field name=\"DATE2\">" + oldFieldName + "</field>", "<field name=\"DATE2\">" + newFieldName + "</field>");
	                            eventDetail.xmlValue = _this.replaceAllMatches(eventDetail.xmlValue, "<field name=\"CONTROL_NAME\">" + oldFieldName + "</field><value name=\"NAME\">", "<field name=\"CONTROL_NAME\">" + newFieldName + "</field><value name=\"NAME\">"); //addWorkingDaysForCustomDate
	                            eventDetail.xmlValue = _this.replaceAllMatches(eventDetail.xmlValue, "<field name=\"CONTROL_NAME\">" + oldFieldName + "</field><field name=\"OPERATOR\">", "<field name=\"CONTROL_NAME\">" + newFieldName + "</field><field name=\"OPERATOR\">"); //addWorkingDays
	                        }
	                    }
	                }
	            });
	            //Replace in Globle code editor
	            //Replace in Globle code editor
	            if (window['globle'].scriptVal) {
	                var value = window['globle'].scriptVal;
	                if (value.indexOf("window.addWorkingDaysForCustomDate") != -1) {
	                    var beforeFunc = value.split('window.addWorkingDaysForCustomDate')[0];
	                    var afterFunc = value.split('window.addWorkingDaysForCustomDate')[1];
	                    var firstFieldName = afterFunc.split(',')[0];
	                    var remainingParts = afterFunc.split(',').slice(1).join(',');
	                    remainingParts = this.replaceAllMatches(remainingParts, oldFieldName + "',", newFieldName + "',");
	                    window['globle'].scriptVal = beforeFunc + 'window.addWorkingDaysForCustomDate' + firstFieldName + ',' + remainingParts;
	                }
	                window['globle'].scriptVal = this.replaceAllMatches(window['globle'].scriptVal, "PropValueByDataFieldName('" + oldFieldName + "'", "PropValueByDataFieldName('" + newFieldName + "'");
	                window['globle'].scriptVal = this.replaceAllMatches(window['globle'].scriptVal, "'DateDataFieldName###" + oldFieldName + "###'", "'DateDataFieldName###" + newFieldName + "###'");
	                window['globle'].scriptVal = this.replaceAllMatches(window['globle'].scriptVal, "'TimeDataFieldName###" + oldFieldName + "###'", "'TimeDataFieldName###" + newFieldName + "###'");
	                window['globle'].scriptVal = this.replaceAllMatches(window['globle'].scriptVal, "addOrSubtractDate('" + oldFieldName + "'", "addOrSubtractDate('" + newFieldName + "'");
	                window['globle'].scriptVal = this.replaceAllMatches(window['globle'].scriptVal, "setAutoNumbering('" + oldFieldName + "'", "setAutoNumbering('" + newFieldName + "'");
	                window['globle'].scriptVal = this.replaceAllMatches(window['globle'].scriptVal, "addWorkingDays('" + oldFieldName + "'", "addWorkingDays('" + newFieldName + "'");
	                window['globle'].xmlVal = this.replaceAllMatches(window['globle'].xmlVal, "<field name=\"AUTO_NUMBER_FIELD\">" + oldFieldName + "</field>", "<field name=\"AUTO_NUMBER_FIELD\">" + newFieldName + "</field>");
	                window['globle'].xmlVal = this.replaceAllMatches(window['globle'].xmlVal, "<field name=\"CONTROL_NAME\">" + oldFieldName + "</field></block>", "<field name=\"CONTROL_NAME\">" + newFieldName + "</field></block>");
	                window['globle'].xmlVal = this.replaceAllMatches(window['globle'].xmlVal, "<field name=\"CONTROL_NAME\">" + oldFieldName + "</field><value name=\"PROPERTY_VALUE_INPUT\">", "<field name=\"CONTROL_NAME\">" + newFieldName + "</field><value name=\"PROPERTY_VALUE_INPUT\">");
	                window['globle'].xmlVal = this.replaceAllMatches(window['globle'].xmlVal, "<field name=\"CONTROL_NAME\">" + oldFieldName + "</field><field name=\"PROPERTY_VALUE\">", "<field name=\"CONTROL_NAME\">" + newFieldName + "</field><field name=\"PROPERTY_VALUE\">");
	                window['globle'].xmlVal = this.replaceAllMatches(window['globle'].xmlVal, "<field name=\"DATE1\">" + oldFieldName + "</field>", "<field name=\"DATE1\">" + newFieldName + "</field>");
	                window['globle'].xmlVal = this.replaceAllMatches(window['globle'].xmlVal, "<field name=\"DATE2\">" + oldFieldName + "</field>", "<field name=\"DATE2\">" + newFieldName + "</field>");
	                window['globle'].xmlVal = this.replaceAllMatches(window['globle'].xmlVal, "<field name=\"CONTROL_NAME\">" + oldFieldName + "</field><value name=\"NAME\">", "<field name=\"CONTROL_NAME\">" + newFieldName + "</field><value name=\"NAME\">"); //addWorkingDaysForCustomDate
	                window['globle'].xmlVal = this.replaceAllMatches(window['globle'].xmlVal, "<field name=\"CONTROL_NAME\">" + oldFieldName + "</field><field name=\"OPERATOR\">", "<field name=\"CONTROL_NAME\">" + newFieldName + "</field><field name=\"OPERATOR\">"); //addWorkingDays
	            }
	        },
	        getNumberFieldNamesunderRepeatingTbl: function (totalItems, totalNumOptionsinRepeatingTable, parentNodeId) {
	            var fieldNames = [];
	            var selectedItems = [];
	            if (!totalItems) {
	                totalItems = [];
	            }
	            if (!totalNumOptionsinRepeatingTable)
	                totalNumOptionsinRepeatingTable = [];
	            var selectedType = [];
	            var selectedParent = [];
	            if (!totalItems.length) {
	                totalItems = this.getAllControls();
	            }
	            for (var totalItem = 0; totalItem < totalItems.length; totalItem++) {
	                if (totalItems[totalItem].type.toLowerCase() == "repeatingtable") {
	                    selectedItems = totalItems[totalItem].data[0];
	                    for (var j = 0; j < selectedItems.length; j++) {
	                        var selectedcolumn = selectedItems[j].elems[0];
	                        this.getAllchildNumberFieldNames(selectedcolumn, totalNumOptionsinRepeatingTable, parentNodeId);
	                    }
	                }
	            }
	            if (totalNumOptionsinRepeatingTable.length) {
	                for (var i = 0; i < totalNumOptionsinRepeatingTable.length; i++) {
	                    var fieldName = totalNumOptionsinRepeatingTable[i].properties.Basic && totalNumOptionsinRepeatingTable[i].properties.Basic['Field Name'].selectedValue;
	                    if (totalNumOptionsinRepeatingTable[i].type.toLowerCase() == "textbox")
	                        selectedType.push(totalNumOptionsinRepeatingTable[i].properties.Basic.Validate.selectedValue);
	                    else
	                        selectedType.push(null);
	                    if (totalNumOptionsinRepeatingTable[i].parent && totalNumOptionsinRepeatingTable[i].parent == "repeating-table" && (totalNumOptionsinRepeatingTable[i].type.toLowerCase() == "textbox" || totalNumOptionsinRepeatingTable[i].type.toLowerCase() == "display field") && !parentNodeId)
	                        selectedParent.push("underRT");
	                    else
	                        selectedParent.push("outsideRT");
	                    fieldName && fieldNames.indexOf(fieldName) == -1 && fieldNames.push(fieldName);
	                }
	            }
	            return fieldNames.map(function (val, key) { return { key: val, value: val, type: selectedType[key], parent: selectedParent[key] }; });
	        },
	        getAllchildNumberFieldNames: function (selectedcolumn, totalNumOptionsinRepeatingTable, parentNodeId) {
	            for (var k = 0; k < selectedcolumn.length; k++) {
	                if (((selectedcolumn[k].type.toLowerCase() == "textbox" &&
	                    selectedcolumn[k].properties.Basic.Validate.selectedValue != "" &&
	                    (selectedcolumn[k].properties.Basic.Validate.selectedValue == "Integer" ||
	                        selectedcolumn[k].properties.Basic.Validate.selectedValue == "Decimal")) ||
	                    selectedcolumn[k].type.toLowerCase() == "display field" && !selectedcolumn[k].properties.Basic.Label.isSelected) &&
	                    (!parentNodeId || (parentNodeId && selectedcolumn[k].properties.Basic.parentNode.id == parentNodeId))) {
	                    totalNumOptionsinRepeatingTable.push(selectedcolumn[k]);
	                }
	                else if (selectedcolumn[k].type.toLowerCase() == "repeatingtable") {
	                    this.getNumberFieldNamesunderRepeatingTbl(selectedcolumn, totalNumOptionsinRepeatingTable, parentNodeId);
	                }
	            }
	        },
	        isValidXMLTagName: function (tag) {
	            var t = !/^[xX][mM][lL]*/.test(tag);
	            t = t && /^[a-zA-Z_]*/.test(tag);
	            t = t && /^[a-zA-Z_]+[a-zA-Z0-9_]*$/.test(tag);
	            t = t && tag.indexOf('___') == -1;
	            return t;
	        },
	        /**
	         * @brief      check for the valid text.
	         * @return     boolena based on entered text valid or not.
	         */
	        isValidString: function (value) {
	            var SCRIPT_REGEX = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
	            value = value.replace(/\r/g, " ").replace(/\n/g, " ").toLowerCase();
	            value = value.replace(/\/\*.*?\*\//g, ''); // remove all the coomented code.
	            // value = value.replace(SCRIPT_REGEX, "");
	            var isValidString = true;
	            if (value) {
	                for (var i = 0; i < value.length; i++) {
	                    if (value.charCodeAt(i) < 32) {
	                        isValidString = false;
	                        break;
	                    }
	                }
	                var invalidStringArray = ['javascript:', '<script', '</script>', 'vbscript:',
	                    'livescript:', '<img', 'onload=', '<input', '<select', '<textarea', '<form', '<head', '<body', '<html', 'datasrc=', '<iframe', 'text/javascript',
	                    'eval(', 'expression(', 'url(', '&#', '&{[', 'document.cookie', 'window.location', 'window.open(', 'alert=', 'alert(', 'alert`', 'onclick=', 'prompt=', 'prompt`', 'prompt(',
	                    'oncopy=', 'oncut=', 'onpaste=', 'ondbllclick=', 'onmouseover=', 'onmousedown=', 'onmouseenter=', 'onmouseleave=', 'onmousemove=', 'onmouseout=', 'onmouseup=', 'window.replace',
	                    'onscroll=', 'ontouchcancel=', 'ontouchend=', 'ontouchmove=', 'ontouchstart=', 'confirm`', 'confirm(', 'confirm=', 'oninput=', 'location.', 'document.', 'angular.', '<meta', 'xss', '<noembed', '<noscript', '<xmp', 'window.name'];
	                for (var i = 0; i < invalidStringArray.length; i++) {
	                    if (value.indexOf(invalidStringArray[i]) != -1) {
	                        isValidString = false;
	                        break;
	                    }
	                }
	            }
	            return isValidString;
	        },
	        /**
	         * @brief      Gets the supported languages.
	         * @return     The supported languages.
	         */
	        getSupportedLanguages: function () {
	            var self = this;
	            return new Promise(function (resolve, reject) {
	                $http({
	                    'url': window.properties.service.uri + action_constants_1.Ids.GET_ALL_LANGUAGES,
	                    'method': 'GET',
	                    'data': {},
	                    'headers': {
	                        'Content-Type': 'application/json;charset=UTF-8'
	                    },
	                    'withCredentials': true
	                }).then(function (response) {
	                    if (response.data && response.data.entity && response.data.entity.length) {
	                        var data = JSON.parse(response.data.entity);
	                        self.supportedLanguages = data.jsonLocales;
	                    }
	                    resolve();
	                }, function (response) {
	                    console.log(response);
	                    reject();
	                });
	            });
	        },
	        getGUID: function () {
	            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
	                return v.toString(16);
	            });
	        },
	        downloadZip: function (url, data) {
	            var hiddenIFrameID = 'hiddenDownloader', iframe = document.getElementById(hiddenIFrameID);
	            if (iframe === null) {
	                iframe = document.createElement('iframe');
	                iframe.setAttribute('name', 'sample-iframe');
	                iframe.id = hiddenIFrameID;
	                iframe.style.display = 'none';
	                document.body.appendChild(iframe);
	            }
	            var form = document.createElement('form');
	            form.action = url;
	            form.method = 'POST';
	            form.target = "sample-iframe";
	            for (var key in data) {
	                var input = document.createElement('input');
	                input.type = 'hidden';
	                input.name = key;
	                input.value = data[key];
	                form.appendChild(input);
	            }
	            document.body.appendChild(form);
	            form.submit();
	            angular.element(form).remove();
	        },
	        formatDate: function (format, date) {
	            if (!date) {
	                return "";
	            }
	            var iFormat, dayNamesShort = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], monthNamesShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], 
	            // Check whether a format character is doubled
	            lookAhead = function (match) {
	                var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) === match);
	                if (matches) {
	                    iFormat++;
	                }
	                return matches;
	            }, 
	            // Format a number, with leading zero if necessary
	            formatNumber = function (match, value, len) {
	                var num = "" + value;
	                if (lookAhead(match)) {
	                    while (num.length < len) {
	                        num = "0" + num;
	                    }
	                }
	                return num;
	            }, 
	            // Format a name, short or long as requested
	            formatName = function (match, value, shortNames, longNames) {
	                return (lookAhead(match) ? longNames[value] : shortNames[value]);
	            }, output = "", literal = false;
	            if (date) {
	                for (iFormat = 0; iFormat < format.length; iFormat++) {
	                    if (literal) {
	                        if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
	                            literal = false;
	                        }
	                        else {
	                            output += format.charAt(iFormat);
	                        }
	                    }
	                    else {
	                        switch (format.charAt(iFormat)) {
	                            case "d":
	                                output += formatNumber("d", date.getDate(), 2);
	                                break;
	                            case "D":
	                                output += formatName("D", date.getDay(), dayNamesShort, dayNames);
	                                break;
	                            case "o":
	                                output += formatNumber("o", Math.round((new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() - new Date(date.getFullYear(), 0, 0).getTime()) / 86400000), 3);
	                                break;
	                            case "m":
	                                output += formatNumber("m", date.getMonth() + 1, 2);
	                                break;
	                            case "M":
	                                output += formatName("M", date.getMonth(), monthNamesShort, monthNames);
	                                break;
	                            case "y":
	                                output += (lookAhead("y") ? date.getFullYear() :
	                                    (date.getYear() % 100 < 10 ? "0" : "") + date.getYear() % 100);
	                                break;
	                            case "@":
	                                output += date.getTime();
	                                break;
	                            case "!":
	                                output += date.getTime() * 10000 + _ticksTo1970;
	                                break;
	                            case "'":
	                                if (lookAhead("'")) {
	                                    output += "'";
	                                }
	                                else {
	                                    literal = true;
	                                }
	                                break;
	                            default:
	                                output += format.charAt(iFormat);
	                        }
	                    }
	                }
	            }
	            return output;
	        },
	        parseDate: function (format, value, settings) {
	            if (format == null || value == null) {
	                throw "Invalid arguments";
	            }
	            value = (typeof value === "object" ? value.toString() : value + "");
	            if (value === "") {
	                return null;
	            }
	            var iFormat, dim, extra, iValue = 0, shortYearCutoff = 26, dayNamesShort = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], monthNamesShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], year = -1, month = -1, day = -1, doy = -1, literal = false, date, 
	            // Check whether a format character is doubled
	            lookAhead = function (match) {
	                var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) === match);
	                if (matches) {
	                    iFormat++;
	                }
	                return matches;
	            }, 
	            // Extract a number from the string value
	            getNumber = function (match) {
	                var isDoubled = lookAhead(match), size = (match === "@" ? 14 : (match === "!" ? 20 :
	                    (match === "y" && isDoubled ? 4 : (match === "o" ? 3 : 2)))), minSize = (match === "y" ? size : 1), digits = new RegExp("^\\d{" + minSize + "," + size + "}"), num = value.substring(iValue).match(digits);
	                if (!num) {
	                    throw "Missing number at position " + iValue;
	                }
	                iValue += num[0].length;
	                return parseInt(num[0], 10);
	            }, 
	            // Extract a name from the string value and convert to an index
	            getName = function (match, shortNames, longNames) {
	                var index = -1, names = lookAhead(match) ? longNames : shortNames;
	                names = names.map(function (v, k) {
	                    return [k, v];
	                });
	                names.sort(function (a, b) {
	                    return -(a[1].length - b[1].length);
	                });
	                for (var pair in names) {
	                    var name = names[pair][1];
	                    if (value.substr(iValue, name.length).toLowerCase() === name.toLowerCase()) {
	                        index = names[pair][0];
	                        iValue += name.length;
	                    }
	                }
	                if (index !== -1) {
	                    return index + 1;
	                }
	                else {
	                    throw "Unknown name at position " + iValue;
	                }
	            }, 
	            // Confirm that a literal character matches the string value
	            checkLiteral = function () {
	                if (value.charAt(iValue) !== format.charAt(iFormat)) {
	                    throw "Unexpected literal at position " + iValue;
	                }
	                iValue++;
	            };
	            for (iFormat = 0; iFormat < format.length; iFormat++) {
	                if (literal) {
	                    if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
	                        literal = false;
	                    }
	                    else {
	                        checkLiteral();
	                    }
	                }
	                else {
	                    switch (format.charAt(iFormat)) {
	                        case "d":
	                            day = getNumber("d");
	                            break;
	                        case "D":
	                            getName("D", dayNamesShort, dayNames);
	                            break;
	                        case "o":
	                            doy = getNumber("o");
	                            break;
	                        case "m":
	                            month = getNumber("m");
	                            break;
	                        case "M":
	                            month = getName("M", monthNamesShort, monthNames);
	                            break;
	                        case "y":
	                            year = getNumber("y");
	                            break;
	                        case "@":
	                            date = new Date(getNumber("@"));
	                            year = date.getFullYear();
	                            month = date.getMonth() + 1;
	                            day = date.getDate();
	                            break;
	                        case "!":
	                            date = new Date((getNumber("!") - _ticksTo1970) / 10000);
	                            year = date.getFullYear();
	                            month = date.getMonth() + 1;
	                            day = date.getDate();
	                            break;
	                        case "'":
	                            if (lookAhead("'")) {
	                                checkLiteral();
	                            }
	                            else {
	                                literal = true;
	                            }
	                            break;
	                        default:
	                            checkLiteral();
	                    }
	                }
	            }
	            if (iValue < value.length) {
	                extra = value.substr(iValue);
	                if (!/^\s+/.test(extra)) {
	                    throw "Extra/unparsed characters found in date: " + extra;
	                }
	            }
	            if (year === -1) {
	                year = new Date().getFullYear();
	            }
	            else if (year < 100) {
	                year += new Date().getFullYear() - new Date().getFullYear() % 100 +
	                    (year <= shortYearCutoff ? 0 : -100);
	            }
	            var _daylightSavingAdjust = function (date) {
	                if (!date) {
	                    return null;
	                }
	                date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
	                return date;
	            };
	            var _getDaysInMonth = function (year, month) {
	                return 32 - _daylightSavingAdjust(new Date(year, month, 32)).getDate();
	            };
	            if (doy > -1) {
	                month = 1;
	                day = doy;
	                do {
	                    dim = _getDaysInMonth(year, month - 1);
	                    if (day <= dim) {
	                        break;
	                    }
	                    month++;
	                    day -= dim;
	                } while (true);
	            }
	            date = _daylightSavingAdjust(new Date(year, month - 1, day));
	            if (date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day) {
	                throw "Invalid date"; // E.g. 31/02/00
	            }
	            return date;
	        },
	        getDateFormat: function (format) {
	            var datepickerFormat = {
	                "dd-M-yy": 'dd-MMM-yyyy',
	                "d M yy": 'd MMM yyyy',
	                "dd.mm.yy": 'dd.MM.yyyy',
	                "dd/mm/yy": 'dd/MM/yyyy',
	                "d-M-yy": 'd-MMM-yyyy',
	                "M d, yy": 'MMM d, yyyy',
	                "yy-m-d": "yyyy-M-d",
	                "dd M yy": "dd MMM yyyy",
	                "yy/mm/dd": "yyyy/MM/dd",
	                "dd-mm-yy": 'dd-MM-yyyy',
	                "dd-mm-y": 'dd-MM-yy',
	                "mm-dd-yy": 'MM-dd-yyyy',
	                "mm-dd-y": 'MM-dd-yy',
	                "dd/mm/y": 'dd/MM/yy'
	            };
	            if (format == 'default') {
	                var langugageSpecificFormat = languageSpecificDateFormat[config.languageId] ? languageSpecificDateFormat[config.languageId] : "dd-M-yy";
	                return datepickerFormat[langugageSpecificFormat] || 'dd-MMM-yyyy';
	            }
	            else {
	                return datepickerFormat[format] || 'dd-MMM-yyyy';
	            }
	        },
	        getNewDateFormat: function (format) {
	            var datepickerFormat = {
	                "dd-M-yy": 'DD-MMM-YYYY',
	                "d M yy": 'D MMM YYYY',
	                "dd.mm.yy": 'DD.MM.YYYY',
	                "dd/mm/yy": 'DD/MM/YYYY',
	                "d-M-yy": 'DD-MMM-YYYY',
	                "M d, yy": 'MMM DD, YYYY',
	                "yy-m-d": "YYYY-M-D",
	                "dd M yy": "DD MMM YYYY",
	                "yy/mm/dd": "YYYY/MM/DD",
	                "dd-mm-yy": 'DD-MM-YYYY',
	                "dd-mm-y": 'DD-MM-YY',
	                "mm-dd-yy": 'MM-DD-YYYY',
	                "mm-dd-y": 'MM-DD-YY',
	                "dd/mm/y": 'DD/MM/YY'
	            };
	            if (format == 'default') {
	                var langugageSpecificFormat = languageSpecificDateFormat[config.languageId] ? languageSpecificDateFormat[config.languageId] : "dd-M-yy";
	                return datepickerFormat[langugageSpecificFormat] || 'DD-MMM-YYYY';
	            }
	            else {
	                return datepickerFormat[format] || 'DD-MMM-YYYY';
	            }
	        },
	        getLanguageSpecificDateFormat: function (format) {
	            if (format == 'default') {
	                return languageSpecificDateFormat[config.languageId] ? languageSpecificDateFormat[config.languageId] : "dd-M-yy";
	            }
	            else {
	                return format;
	            }
	        },
	        getDateObj: function (date) {
	            return date ? new Date(date) : '';
	        },
	        addSubjectField: function (view) {
	            var components = localStorage.get('components');
	            var controls = components.items.filter(function (val) { return val.type == 'Textbox'; });
	            var Textbox;
	            if (controls.length) {
	                Textbox = angular.copy(controls[0]);
	                _.set(Textbox.properties, "Basic['Field Name']['selectedValue']", 'ORI_FORMTITLE');
	                _.set(Textbox.properties, "Basic['Field Name']['prevSelectedValue']", 'ORI_FORMTITLE');
	                _.set(Textbox.properties, "Basic['Data Field Name']['selectedValue']", 'ORI_FORMTITLE');
	                _.set(Textbox.properties, "Basic['Data Field Name']['prevSelectedValue']", 'ORI_FORMTITLE');
	                _.set(Textbox.properties, "Basic['Label']['selectedValue']", 'Title');
	                _.set(Textbox.properties, "Basic['Required']['selectedValue']", true);
	                Textbox.uid = this.getGUID();
	                Textbox.viewName = "ORI_VIEW";
	            }
	            view.controls.A.push(Textbox);
	        },
	        validate: function (list, valid) {
	            var self = this;
	            valid.defaulValuetMissing = [];
	            if (list.length) {
	                for (var i = 0; i < list.length; i++) {
	                    if (list[i].type == "Layout") {
	                        self.accessLayoutElements(list[i], function (elems) {
	                            valid = self.validate(elems, valid);
	                        });
	                    }
	                    else if (list[i].type == "Table") {
	                        self.accessTableElements(list[i], function (elems) {
	                            valid = self.validate(elems, valid);
	                        });
	                    }
	                    else if (list[i].type == "RepeatingTable") {
	                        self.accessRepeatingTableElements(list[i], function (elems) {
	                            valid = self.validate(elems, valid);
	                        });
	                    }
	                    else if (list[i].type == "Section") {
	                        self.accessSectionElements(list[i], function (elems) {
	                            valid = self.validate(elems, valid);
	                        });
	                    }
	                    else {
	                        var properties = list[i].properties;
	                        var required = _.get(properties, 'Basic.Required.selectedValue', false);
	                        var validPattern = _.get(properties, 'Basic.Validate.selectedValue', '0');
	                        var validationMap = {
	                            '7': 'Integer',
	                            '8': 'Decimal',
	                            '9': 'Email',
	                            '10': 'Alphanumeric',
	                            '11': 'Letters',
	                            '0': ''
	                        };
	                        validPattern = validationMap[validPattern] || validPattern;
	                        if (required || validPattern != "") {
	                            var defaultVal = '';
	                            switch (list[i].type) {
	                                /* case 'Text-Area': */
	                                case 'Textbox':
	                                    defaultVal = _.get(properties, 'Basic.Value.selectedValue', '');
	                                    required = false;
	                                    if (validPattern != "" && defaultVal) {
	                                        var regex = '';
	                                        switch (validPattern) {
	                                            case 'Numeric':
	                                                regex = /^-?\\d+(\\.\\d+)?$/;
	                                                break;
	                                            case 'Alphanumeric':
	                                                regex = /^[a-zA-Z0-9-\\._]+$/;
	                                                break;
	                                            case "Email":
	                                                regex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
	                                                break;
	                                            case "Integer":
	                                                regex = /^(-)?\d+$/;
	                                                break;
	                                            case "Decimal":
	                                                regex = /^(-)?(?:\d*\.)?\d+$/;
	                                                break;
	                                            case "Letters":
	                                                regex = /^[a-zA-Z-\\._]+$/i;
	                                                break;
	                                        }
	                                        if (regex) {
	                                            var isValidInput = regex.test(defaultVal);
	                                            if (!isValidInput) {
	                                                valid.valid = false;
	                                                valid.notValidInput.push(_.get(properties, 'Basic.Label.selectedValue', ''));
	                                            }
	                                        }
	                                    }
	                                    break;
	                                case 'Checkbox':
	                                    var cList = properties['Data Source'].table.list;
	                                    for (var index = 0; index < cList.length; index++) {
	                                        if (cList[index].Default.name && cList[index].selectedValue.name != cList[index].Default.name) {
	                                            valid.valid = false;
	                                            valid.defaulValuetMissing.push(properties.Basic.Label.selectedValue);
	                                        }
	                                    }
	                                    var ds = _.get(properties, '["Data Source"].table.list', []);
	                                    ds.length && (defaultVal = ds.filter(function (val) { return val.selectedValue && val.selectedValue.name; }));
	                                    break;
	                                case 'Dropdown':
	                                    var dList = properties['Data Source'].table.list;
	                                    for (var index = 0; index < dList.length; index++) {
	                                        if (dList[index].Default.name && _.get(list[i].properties, 'Basic.Value.selectedValue', '').indexOf(dList[index].Value.name) < 0) {
	                                            valid.valid = false;
	                                            valid.defaulValuetMissing.push(properties.Basic.Label.selectedValue);
	                                        }
	                                        defaultVal = _.get(properties, 'Basic.Value.selectedValue', []);
	                                    }
	                                    break;
	                                case 'MultiDropdown':
	                                    var dList = properties['Data Source'].table.list;
	                                    for (var index = 0; index < dList.length; index++) {
	                                        if (dList[index].Default.name && _.get(list[i].properties, 'Basic.Value.selectedValue', '').indexOf(dList[index].Value.name) < 0) {
	                                            valid.valid = false;
	                                            valid.defaulValuetMissing.push(properties.Basic.Label.selectedValue);
	                                        }
	                                        defaultVal = _.get(properties, 'Basic.Value.selectedValue', []);
	                                    }
	                                    break;
	                                case 'Datepicker':
	                                    defaultVal = _.get(properties, 'Basic.Default.selectedValue', '');
	                                    required = false;
	                                    break;
	                                case 'Timepicker':
	                                    defaultVal = _.get(properties, 'Basic.Default.selectedValue', '');
	                                    required = false;
	                                    break;
	                                case 'Radio':
	                                    var dr = _.get(properties, '["Data Source"].table.list', []);
	                                    dr.length && (defaultVal = dr.filter(function (val) { return val.selectedValue && val.selectedValue.name; }));
	                                    required = false;
	                                    break;
	                                case 'Map':
	                                    defaultVal = _.get(properties, 'Basic.Default.selectedValue', '');
	                                    required = false;
	                                    break;
	                            }
	                            if (required && !defaultVal.length) {
	                                valid.valid = false;
	                                valid.defaultMissing.push(_.get(properties, 'Basic.Label.selectedValue', ''));
	                            }
	                        }
	                    }
	                }
	            }
	            return valid;
	        },
	        getControlByFieldName: function (fieldName) {
	            var totalItems = this.getAllControls();
	            var matchedControl = [];
	            if (totalItems.length) {
	                totalItems.some(function (control) {
	                    if (control.properties && control.properties.Basic) {
	                        var controlFieldName = control.properties.Basic['Field Name'] && control.properties.Basic['Field Name'].selectedValue;
	                        if (fieldName == controlFieldName && !control.copiedFrom && !control.pasteAsCalculatedFrom) {
	                            matchedControl = control;
	                            return true;
	                        }
	                    }
	                });
	            }
	            return matchedControl;
	        },
	        getReadOnlyControls: function (fieldName) {
	            var totalItems = this.getAllControls();
	            var readOnlyControls = [];
	            if (totalItems.length) {
	                totalItems.forEach(function (control) {
	                    if (control.properties && control.properties.Basic) {
	                        var controlFieldName = control.properties.Basic['Field Name'] && control.properties.Basic['Field Name'].selectedValue;
	                        if (fieldName == controlFieldName && control.copiedFrom) {
	                            readOnlyControls.push(control);
	                        }
	                    }
	                });
	            }
	            return readOnlyControls;
	        },
	        markAllPropertiesAsDisabled: function (properties) {
	            for (var key in properties) {
	                properties[key].forceToDisabled = true;
	            }
	        },
	        refreshReadOnlyControlsPropeties: function (fieldName) {
	            var self = this;
	            var allReadOnlyControls = self.getReadOnlyControls(fieldName);
	            if (!allReadOnlyControls.length) {
	                return;
	            }
	            var originalControl = self.getControlByFieldName(fieldName);
	            allReadOnlyControls.forEach(function (control) {
	                self.markAllPropertiesAsReadonly(control, originalControl ? originalControl.properties : {});
	            });
	        },
	        markAllPropertiesAsReadonly: function (control, properties) {
	            var self = this;
	            if (!properties) {
	                properties = {};
	            }
	            if (control.type == "Table" || control.type == "Layout" || control.type == "RepeatingTable") {
	                for (var key in properties) {
	                    var subProperties = angular.copy(properties[key]);
	                    if (key == "Events") {
	                        for (var event_3 in subProperties) {
	                            if (event_3 != 'Name' && event_3 != 'forceToDisabled') {
	                                subProperties[event_3].selectedValueReadonly = subProperties[event_3].selectedValueReadonly || subProperties[event_3].selectedValue;
	                                subProperties[event_3].selectedValue = '';
	                            }
	                        }
	                        control.properties[key] = subProperties;
	                    }
	                    else if (key == "Basic") {
	                        if (subProperties.hasOwnProperty('Insert_Button_Text')) {
	                            _.set(subProperties, "['Insert_Button_Text'].hidden", true);
	                        }
	                        _.set(subProperties, "['Field Name'].disable", true);
	                        if (control.type == "RepeatingTable") {
	                            _.set(subProperties, "['Data Field Name'].disable", true);
	                        }
	                        control.properties[key] = subProperties;
	                    }
	                    else if (key == 'Display' && subProperties.hasOwnProperty('Fit-to-Screen')) {
	                        _.set(control.properties, "Display['Fit-to-Screen'].selectedValue", subProperties['Fit-to-Screen'].selectedValue);
	                    }
	                }
	                _.set(control.properties, "Display.Hidden.hidden", true);
	                control.propMigrated = true;
	                return;
	            }
	            for (var key in properties) {
	                var subProperties = angular.copy(properties[key]);
	                if (key == "Events") {
	                    for (var event_4 in subProperties) {
	                        if (event_4 != 'Name' && event_4 != 'forceToDisabled') {
	                            subProperties[event_4].selectedValueReadonly = subProperties[event_4].selectedValueReadonly || subProperties[event_4].selectedValue;
	                            subProperties[event_4].selectedValue = '';
	                        }
	                    }
	                }
	                else if (key == "Basic" && subProperties.hasOwnProperty('Insert_Button_Text')) {
	                    _.set(subProperties, "['Insert_Button_Text'].hidden", true);
	                }
	                else if (key == "Display" && subProperties.hasOwnProperty('Read-only')) {
	                    _.set(subProperties, "['Read-only'].selectedValue", true);
	                }
	                else if (key == "Data Source" && subProperties.hasOwnProperty('table')) {
	                    _.set(subProperties, "table.hideRemovebtn", true);
	                }
	                control.properties[key] = subProperties;
	            }
	            self.markAllPropertiesAsDisabled(control.properties);
	            control.propMigrated = true;
	        },
	        getLanguageSpecificViewName: function (viewName) {
	            if (!this.viewNames) {
	                return viewName;
	            }
	            var viewDetail = this.viewNames.filter(function (value) { return value.name == viewName; });
	            if (viewDetail.length) {
	                return viewDetail[0].value;
	            }
	            return viewName;
	        },
	        finddeep: function (items, attrs) {
	            function match(value) {
	                try {
	                    for (var key in attrs) {
	                        if (!_.isUndefined(value)) {
	                            if (attrs[key] !== value[key]) {
	                                return false;
	                            }
	                        }
	                    }
	                    return true;
	                }
	                catch (err) {
	                }
	            }
	            function traverse(value) {
	                var result;
	                _.forEach(value, function (val) {
	                    if (match(val)) {
	                        result = val;
	                        return false;
	                    }
	                    if (_.isObject(val) || _.isArray(val)) {
	                        result = traverse(val);
	                    }
	                    if (result) {
	                        return false;
	                    }
	                });
	                return result;
	            }
	            return traverse(items);
	        },
	        openLoginModal: function () {
	            if (loginModal) {
	                return;
	            }
	            // Return when SSO login
	            if ($rootScope.USP && $rootScope.USP.loginMethodType === 2) {
	                return;
	            }
	            $timeout(function () {
	                loginModal = $uibModal.open({
	                    component: 'login',
	                    keyboard: false,
	                    backdrop: 'static',
	                    windowClass: 'login-modal',
	                    backdropClass: 'login-backdrop'
	                });
	                loginModal.closed.then(function () {
	                    loginModal = null;
	                });
	            }, 100);
	        },
	        setsessionTimoutTimer: function (duration) {
	            // Return when SSO login
	            if ($rootScope.USP && $rootScope.USP.loginMethodType === 2) {
	                return;
	            }
	            timer && $timeout.cancel(timer);
	            if ($rootScope.USP && $rootScope.USP.sessionTimeoutDuration) {
	                if (duration && parseFloat(duration) > 0) {
	                    timer = $timeout(Util.checkSessionTimeout, parseFloat(duration) * 60000);
	                }
	                else {
	                    timer = $timeout(Util.checkSessionTimeout, parseFloat($rootScope.USP.sessionTimeoutDuration) * 60000);
	                }
	            }
	        },
	        hasDuplicates: function (arr) {
	            return new Set(arr).size !== arr.length;
	        },
	        checkSessionTimeout: function () {
	            $http({
	                'url': window.properties.service.commonApiUrl + action_constants_1.Ids.GET_SESSION_TIMEOUT_DETAILS,
	                'method': 'GET',
	                'data': {},
	                'headers': {
	                    'Content-Type': 'application/json;charset=UTF-8'
	                },
	                'withCredentials': true
	            }).then(function (response) {
	                window.localStorage.setItem('sessionState', !response.data.timeout ? 'Active' : 'Inactive');
	                window.top && window.top.opener && window.top.opener.setSessionState && window.top.opener.setSessionState('sessionState', !response.data.timeout ? 'Active' : 'Inactive');
	                if (response.data.timeout) {
	                    Util.openLoginModal();
	                }
	                else {
	                    Util.setsessionTimoutTimer(parseFloat(response.data.remainingMilliSecond) / 60000);
	                }
	            }, function (response) {
	                if (!navigator.onLine) {
	                    Util.setsessionTimoutTimer(parseFloat('10000') / 60000);
	                }
	            });
	        },
	        getAllAPIConnections: function (formId, instanceGroupId, projectId) {
	            var queryParams = '';
	            if (instanceGroupId && projectId) {
	                queryParams = '?instanceGroupId=' + instanceGroupId + '&projectId=' + projectId;
	            }
	            else {
	                queryParams = '?formId=' + formId;
	            }
	            return new Promise(function (resolve, reject) {
	                $http({
	                    'url': window.properties.service.uri + action_constants_1.Ids.GET_API_CONNECTION_LIST + queryParams,
	                    'method': 'GET',
	                    'withCredentials': true,
	                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	                }).then(function (response) {
	                    resolve(response);
	                }, function (response) {
	                    resolve(response);
	                });
	            });
	        },
	        getProjectList: function () {
	            return new Promise(function (resolve, reject) {
	                $http({
	                    'url': window.properties.service.commonApiUrl.replace('/commonapi/', '/adoddle/') + action_constants_1.Ids.GET_ALL_PROJECTS,
	                    'method': 'POST',
	                    data: $httpParamSerializer({ action_id: 1001, recordBatchSize: -1 }),
	                    'withCredentials': true,
	                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
	                }).then(function (response) {
	                    var projects = [];
	                    if (response.data.totalDocs > 0) {
	                        projects = response.data.data;
	                    }
	                    resolve(projects);
	                }, function (response) {
	                    resolve(response);
	                });
	            });
	        },
	        getAppBuilderID: function (projectId) {
	            return new Promise(function (resolve, reject) {
	                $http({
	                    'url': window.properties.service.commonApiUrl.replace('/commonapi/', '/adoddle/') + 'projects',
	                    'method': 'POST',
	                    'withCredentials': true,
	                    data: $httpParamSerializer({ projectId: projectId, action_id: 1018, dcId: 1, currentPageNo: 1, recordStartFrom: 0, recordBatchSize: 100, iFormACLFlag: 2 }),
	                    // data: {project_name : projectName // projectId: projectID, action_id: action_id, dcId: dcId, currentPageNo: currentPageNo, recordStartFrom: recordStartFrom, recordBatchSize: recordBatchSize, iFormACLFlag: iFormACLFlag},
	                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	                }).then(function (response) {
	                    var filterData = response.data.data;
	                    filterData = filterData.filter(function (item) { return !(item.is_active == false); });
	                    resolve(filterData);
	                }, function (response) {
	                    console.log("error");
	                });
	            });
	        },
	        getDestinationFieldName: function (projectId, appBuildercode) {
	            appBuildercode = encodeURIComponent(appBuildercode);
	            return new Promise(function (resolve, reject) {
	                $http({
	                    'url': window.properties.service.commonApiUrl + 'form' + '/getFormTemplate' + '?projectId=' + projectId + '&appBuilderCode=' + appBuildercode,
	                    'method': 'POST',
	                    'withCredentials': true,
	                    data: $httpParamSerializer({ projectId: projectId, appBuilderCode: appBuildercode }),
	                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	                }).then(function (response) {
	                    var filterData = response.data.fieldJson;
	                    resolve(filterData);
	                }, function (response) {
	                    console.log("error");
	                });
	            });
	        },
	        setBlocklyBlock: function (valObJ) {
	            window.localStorage.removeItem('domXml');
	            var domXml = valObJ.xmlVal;
	            var xmlDoc = $($.parseXML(domXml));
	            var domXmlData = xmlDoc[0].children[0].innerHTML;
	            window.localStorage.setItem("domXml", domXmlData);
	        },
	        getBlocklyBlock: function () {
	            var blockfromstorage = window.localStorage.getItem("domXml");
	            var xmlData = "<xml xmlns=\"https://Developers.google.com/blockly/xml\">" + blockfromstorage + "</xml>";
	            return xmlData;
	        },
	        updateCalculatedControls: function (CalculatedCtrl, selectedItem, currentFieldName, flag) {
	            var _this = this;
	            CalculatedCtrl.forEach(function (control) {
	                _this.updateCalculatedFieldProperties(control, selectedItem, currentFieldName, flag);
	            });
	        },
	        updateCalculatedFieldProperties: function (control, referencedItem, currentFieldName, flag) {
	            if (!control) {
	                return;
	            }
	            var controlType = referencedItem.type;
	            flag === "FieldName" && control.pasteAsCalculatedFrom && (control.pasteAsCalculatedFrom = currentFieldName);
	            if (controlType == 'Attachment' || controlType == 'Image' || controlType == 'Label' || controlType == 'Button' || controlType == 'SiteLocationButton' || controlType == 'Hyperlink' || controlType == 'InlineAssocFiles' || controlType == 'InlineAssocApps' || controlType == 'ViewAssociations' || controlType === 'Layout' || controlType === 'Table') {
	                return;
	            }
	            if (flag === 'DataFieldName' && control.type === "RepeatingTable") {
	                var rptFieldName = _.get(referencedItem, 'properties.Basic["Field Name"].selectedValue');
	                _.set(control, 'properties.Basic.Value.selectedValue', "{{" + rptFieldName + "}}");
	                _.set(control, 'properties.Basic.DSName.selectedValue', rptFieldName);
	                control.derivedFromFieldName = rptFieldName;
	                _.set(control, 'properties.Basic["Data Field Name"].selectedValue', currentFieldName);
	                _.set(control, 'properties.Basic["Data Field Name"].prevSelectedValue', currentFieldName);
	                return;
	            }
	            if (flag === 'DataFieldName') {
	                control.derivedFromFieldName = currentFieldName;
	                return;
	            }
	            if (controlType === 'Datepicker' && flag === 'FieldName') {
	                _.set(control, 'properties.Basic.RefFieldName', currentFieldName);
	                return;
	            }
	            // update repeating table properties if fieldname is changed
	            if (controlType === 'RepeatingTable' && flag === 'FieldName') {
	                _.set(control, 'properties.Basic.Value.selectedValue', "{{" + currentFieldName + "}}");
	                _.set(control, 'properties.Basic.DSName.selectedValue', currentFieldName);
	                control.derivedFromFieldName = currentFieldName;
	                return;
	            }
	            // for calculated Value control
	            if (controlType === "Display field" && flag === "FieldName") {
	                var DSName = _.get(referencedItem, 'properties.Basic.DSName.selectedValue');
	                _.set(control, 'properties.Basic.Value.selectedValue', "{{" + currentFieldName + "}}");
	                DSName && _.set(control, 'properties.Basic.DSName.selectedValue', DSName);
	                control.derivedFromFieldName = currentFieldName;
	            }
	        },
	        getDocColumnList: function () {
	            var self = this;
	            var projectId = _.get(config, 'formDetail.id.projectId', '');
	            return new Promise(function (resolve, reject) {
	                $http({
	                    'url': window.properties.service.commonApiUrl.replace('/commonapi/', '/adoddle/') + 'configcontroller',
	                    'method': 'POST',
	                    data: $httpParamSerializer({ action_id: 1722, listingType: 184, projectId: projectId }),
	                    'withCredentials': true,
	                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
	                }).then(function (response) {
	                    console.log('doc', response);
	                    self.docColData = response.data || [];
	                    resolve(response);
	                }, function (response) {
	                    resolve(response);
	                });
	            });
	        },
	        getAppColumnList: function () {
	            var self = this;
	            return new Promise(function (resolve, reject) {
	                $http({
	                    'url': window.properties.service.commonApiUrl.replace('/commonapi/', '/adoddle/') + 'configcontroller',
	                    'method': 'POST',
	                    data: $httpParamSerializer({ action_id: 1722, listingType: 185 }),
	                    'withCredentials': true,
	                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
	                }).then(function (response) {
	                    console.log('app', response);
	                    self.appColData = response.data || [];
	                    resolve(response);
	                }, function (response) {
	                    resolve(response);
	                });
	            });
	        },
	        getControlsByDataFieldName: function (dataFieldName) {
	            var views = localStorage.get('views');
	            ;
	            if (!views) {
	                return;
	            }
	            var controls = this.getAllControls();
	            var controlList = [];
	            controls.length && controls.forEach(function (control) {
	                if (!control.forceToReadOnly && !control.readOnly && control.properties.Basic && control.properties.Basic['Data Field Name'] && control.properties.Basic['Data Field Name'].selectedValue == dataFieldName) {
	                    controlList.push(control);
	                }
	            });
	            return controlList;
	        }
	    };
	    window.openLoginModal = Util.openLoginModal;
	    window.setsessionTimoutTimer = Util.setsessionTimoutTimer;
	    return Util;
	}
	exports.UtilService = UtilService;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var angular = __webpack_require__(1);
	/**
	 * Signature component.
	 * This module will initialize the Signature component for angular application.
	 * @module Signature
	 */
	var SignatureComponent = (function () {
	    SignatureComponent.$inject = ['$element', '$translate'];
	    function SignatureComponent($element, $translate) {
	        this.ignoreValChangeEvent = false;
	        this.initialized = false;
	        this.$translate = $translate;
	        this.signature = $element.find('div');
	    }
	    SignatureComponent.prototype.$onInit = function () {
	        if (!this.signatureItem) {
	            return;
	        }
	        this.draw();
	        this.initialized = true;
	        var resetBtn = this.signature.find('.reset');
	        resetBtn[0].innerHTML = this.$translate.instant('reset');
	        var undoBtn = this.signature.find('.undo');
	        undoBtn[0].innerHTML = this.$translate.instant('undo');
	    };
	    SignatureComponent.prototype.$onChanges = function (changedProps) {
	        if (!this.initialized || !changedProps) {
	            return;
	        }
	        if (changedProps.signatureDisabled != undefined) {
	            if (this.signatureDisabled) {
	                this.signature.jSignature('disable', true);
	                this.signature.find('.reset, .undo').attr('disabled', true);
	            }
	            else {
	                this.signature.jSignature('enable', true);
	                this.signature.find('.reset, .undo').attr('disabled', false);
	            }
	        }
	        if (changedProps.signatureVal != undefined) {
	            if (this.ignoreValChangeEvent) {
	                this.ignoreValChangeEvent = false;
	                return;
	            }
	            this.draw();
	        }
	    };
	    SignatureComponent.prototype.draw = function () {
	        var _this = this;
	        this.ignoreValChangeEvent = false;
	        this.signature.unbind('change');
	        this.set();
	        var emptySVS = '<?xml version="1.0" encoding="UTF-8" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="0" viewBox="0 0 0 0" ></svg>';
	        var datapair = this.signatureItem.properties.Basic.Value.selectedValue;
	        if (datapair && datapair[1] != "" && datapair[1] != emptySVS) {
	            this.signature.find('canvas').remove();
	            this.signature.append(datapair[1]);
	            this.signature.find('svg').css({ 'width': 'auto', 'margin': '18px' });
	            this.signature.find('.reset').css({
	                'position': 'absolute',
	                'float': 'right',
	                'right': '89px',
	                'top': '0px'
	            }).attr('disabled', false).unbind('click').bind('click', function () {
	                _this.reset();
	            });
	        }
	    };
	    SignatureComponent.prototype.set = function () {
	        var _this = this;
	        this.signature.empty();
	        this.signature.jSignature({
	            UndoButton: !this.signatureDisabled,
	            ResetButton: !this.signatureDisabled,
	            width: '100%',
	            lineWidth: 2,
	            height: '100px'
	        });
	        if (this.signatureDisabled) {
	            this.signature.jSignature('disable', true);
	        }
	        this.signature.unbind('change').bind('change', function () {
	            _this.ignoreValChangeEvent = true;
	            _this.signatureItem.properties.Basic.Value.selectedValue = _this.signatureVal = _this.signature.jSignature('getData', 'svg');
	            _this.validateRequiredField();
	            _this.signatureChanged();
	        });
	    };
	    SignatureComponent.prototype.reset = function () {
	        this.ignoreValChangeEvent = true;
	        this.signatureItem.properties.Basic.Value.selectedValue = this.signatureVal = '';
	        this.set();
	    };
	    SignatureComponent.prototype.validateRequiredField = function () {
	        var isModified = this.signature.jSignature("isModified");
	        var data = this.signature.jSignature('getData', 'svg');
	        var emptyCanvas = ["image/svg+xml", '<?xml version="1.0" encoding="UTF-8" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="0" height="0"></svg>'];
	        if (!isModified && (data == "" || JSON.stringify(data) == JSON.stringify(emptyCanvas))) {
	            this.signatureItem.properties.Basic.Value.selectedValue = this.signatureVal = '';
	        }
	    };
	    return SignatureComponent;
	}());
	exports.SignatureComponent = SignatureComponent;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('directives.asiteSignature', [])
	    .component('asiteSignature', {
	    template: "<div ng-style=\"{'background-color': '#f5f5f5',width: '100%','overflow-x':'auto'}\" class=\"clearfix\"></div>",
	    controller: SignatureComponent,
	    controllerAs: 'signCtrl',
	    bindings: {
	        signatureItem: '<',
	        signatureColor: '<',
	        signatureDisabled: '<',
	        signatureVal: '<',
	        signatureChanged: '&'
	    }
	}).name;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var angular = __webpack_require__(1);
	/**
	 * Signature component.
	 * This module will initialize the Signature component for angular application.
	 * @module Stepper
	 */
	var StepperComponent = (function () {
	    StepperComponent.$inject = ['$element', '$translate'];
	    function StepperComponent($element, $translate) {
	        this.data = [{
	                'title': 'Basic Information',
	                'step': 1
	            }, {
	                'title': 'Filters',
	                'step': 2
	            }, {
	                'title': 'Response',
	                'step': 3
	            }];
	        this.$translate = $translate;
	    }
	    StepperComponent.prototype.$onChanges = function (changes) {
	        if (changes.currentStep && changes.currentStep.currentValue) {
	            this.currentStep = parseInt(changes.currentStep.currentValue);
	        }
	    };
	    return StepperComponent;
	}());
	exports.StepperComponent = StepperComponent;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('directives.stepper', [])
	    .component('stepper', {
	    template: __webpack_require__(289),
	    controller: StepperComponent,
	    // scope:{},
	    bindings: {
	        currentStep: '@',
	        updateparent: '&',
	        stepClick: '&stepClick'
	    }
	}).name;


/***/ }),
/* 289 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"stepwizard\">\n  <div class=\"stepwizard-row setup-panel\">\n    <div class=\"stepwizard-step\" ng-repeat=\"item in $ctrl.data\" ng-class=\"[{'active': $ctrl.currentStep === item.step}, {'disabled': $ctrl.currentStep < item.step}, {'completed': $ctrl.currentStep > item.step}]\">\n        <p>{{item.title}}</p>\n        <a ng-click=\"$ctrl.stepClick({step: item.step})\" type=\"button\" class=\"btn btn-primary btn-circle\"  ng-class=\"[{'active': $ctrl.currentStep === item.step}, {'disabled': $ctrl.currentStep < item.step}, {'completed': $ctrl.currentStep > item.step}]\"></a>\n    </div>\n  </div>\n</div>"

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var angular = __webpack_require__(1);
	var _ = __webpack_require__(23);
	var moment = __webpack_require__(115);
	var action_constants_1 = __webpack_require__(19);
	var api_connection_constants_1 = __webpack_require__(37);
	var MainController = (function () {
	    MainController.$inject = ['localStorage', '$scope', '$http', '$stateParams', '$httpParamSerializer', 'Notification', '$uibModal', '$document', 'Util', '$window', '$rootScope', 'config', 'PROJECTNAME'];
	    function MainController(localStorage, $scope, $http, $stateParams, $httpParamSerializer, Notification, $uibModal, $document, Util, $window, $rootScope, config, PROJECTNAME) {
	        var self = this;
	        this.Util = Util;
	        this.$scope = $scope;
	        this.$document = $document;
	        this.$uibModal = $uibModal;
	        this.store = localStorage;
	        this.ngNotification = Notification;
	        this.USP = $rootScope.USP;
	        this.$http = $http;
	        this.params = $stateParams.params;
	        this.$httpParamSerializer = $httpParamSerializer;
	        // this.showSpinner = false;
	        this.connectionLists = [];
	        this.showAddConnectionForm = false;
	        this.baseUrl = config.baseUrl;
	        this.currentProject = PROJECTNAME.replaceAll("&#39;", "'");
	        this.currentProjectId = config.formDetail ? config.formDetail.id.projectId : "";
	    }
	    MainController.prototype.IsCustomData = function (controlFields, item) {
	        return controlFields.find(function (el) { return el.value === item.value; });
	    };
	    MainController.prototype.openAPIConfigurationDialog = function () {
	        var self = this;
	        var apiConfigurationModalInstance = self.$uibModal.open({
	            animation: true,
	            ariaLabelledBy: 'modal-title',
	            ariaDescribedBy: 'modal-body',
	            // template: '<apiconnection  dismiss="$ctrl.cancel()"></apiconnection>',
	            templateUrl: 'apiConnections.html',
	            backdrop: 'static',
	            keyboard: false,
	            controllerAs: '$apictrl',
	            windowClass: 'api-connection-modal',
	            appendTo: angular.element(self.$document[0].querySelector('.canvas')),
	            controller: ['$scope', 'Notification', "$window", "config", function ($scope, Notification, $window, config) {
	                    var _this = this;
	                    angular.element(window).on('resize', function () {
	                        _this.apiEditorResizeHandler();
	                    });
	                    window.setTimeout(function () {
	                        _this.apiEditorResizeHandler();
	                    }, 10);
	                    document.body.style.overflow = 'hidden';
	                    this.apiEditorResizeHandler = function () {
	                        var width = Math.min(1280, window.innerWidth);
	                        var height = Math.min(600, window.innerHeight);
	                        var margin = (width <= 768) ? 10 : 30;
	                        angular.element('.api-connection-modal .modal-dialog').css({
	                            'width': (width - (margin * 2)) + 'px',
	                            'height': (height - (margin * 2)) + 'px',
	                            'marginTop': margin + 'px',
	                            'marginBottom': margin + 'px'
	                        });
	                    };
	                    this.setDataType = function (item) {
	                        item.dataType = 'custom';
	                    };
	                    this.userSearchApiId = api_connection_constants_1.Api_Ids.USER_SEARCH_API_ID;
	                    this.config = config;
	                    this.$scope = $scope;
	                    this.selectedStep = 1;
	                    this.showAddConnectionForm = false;
	                    this.isTestConnection = false;
	                    this.externalApi = false;
	                    this.showTestResult = false;
	                    var fieldNames = [];
	                    this.controlDataFieldNames = self.Util.getDataFieldNames();
	                    this.apiData = [];
	                    this.optionalFields = [];
	                    this.showSpinner = false;
	                    this.isDuplicate = false;
	                    this.specialCharacter = false;
	                    this.ngNotification = Notification;
	                    this.$window = $window;
	                    this.objParam = {
	                        name: '',
	                        externalApi: false,
	                        apiId: '',
	                        description: '',
	                        bodyParamsType: '',
	                        status: 'Not Connected',
	                        authType: api_connection_constants_1.AuthType.None
	                    };
	                    this.authType = api_connection_constants_1.AuthType.None;
	                    this.AuthType = api_connection_constants_1.AuthType;
	                    this.fetchUsersTypeId = [
	                        {
	                            key: 'Project Distribution',
	                            value: 1
	                        },
	                        {
	                            key: 'Project Organisations',
	                            value: 2
	                        },
	                        {
	                            key: 'Project Roles',
	                            value: 3
	                        },
	                        {
	                            key: 'User Email Address',
	                            value: 4
	                        },
	                        {
	                            key: 'User Details',
	                            value: 5
	                        }
	                    ];
	                    this.formSearchIsActive = [
	                        {
	                            key: 'Active',
	                            value: 'Active'
	                        },
	                        {
	                            key: 'Inactive',
	                            value: 'Inactive'
	                        },
	                        {
	                            key: 'All',
	                            value: 'All'
	                        }
	                    ];
	                    this.multiValueParameters = [];
	                    this.connectionLists = [];
	                    this.operatoFieldrArray = [{
	                            key: '==',
	                            value: '=='
	                        },
	                        {
	                            key: '!=',
	                            value: '!='
	                        },
	                        {
	                            key: 'IN',
	                            value: 'IN'
	                        },
	                        {
	                            key: 'NOT IN',
	                            value: 'NOT IN'
	                        }];
	                    this.parameters = [];
	                    this.externalApiMethods = [{
	                            key: 'GET',
	                            value: 'GET'
	                        },
	                        {
	                            key: 'POST',
	                            value: 'POST'
	                        }];
	                    this.externapAPIData = {
	                        params: [],
	                        headers: [],
	                        bodyParams: []
	                    };
	                    this.projects = [];
	                    this.selectedProjects = [];
	                    this.selectedProjectIds = [];
	                    this.selectedFormsTypesId = [];
	                    this.formTypes = [];
	                    this.customFormFields = [];
	                    this.customAttrOptions = [];
	                    this.optionalFieldsCopy = [];
	                    this.formStatuses = [];
	                    this.selectedStatuses = [];
	                    this.currentProjectSelected = false;
	                    this.removeConnectionObject = {};
	                    this.regex = /^[^`~!@#$%\^&*={}|[\]\\:';"<>?,./]*$/;
	                    this.getApiconnectionLists = function () {
	                        var _this = this;
	                        this.selectedStep = 1;
	                        this.showSpinner = true;
	                        this.showTestResult = false;
	                        this.isTestConnection = false;
	                        this.testResults = [];
	                        this.externapAPIData = angular.copy({
	                            params: [],
	                            headers: [],
	                            bodyParams: []
	                        });
	                        var instanceGroupId = self.params.id.instanceGroupId || null;
	                        var projectId = self.params.id.projectId || null;
	                        var formId = self.params.id || null;
	                        var queryParams = '';
	                        if (instanceGroupId && projectId) {
	                            queryParams = '?instanceGroupId=' + instanceGroupId + '&projectId=' + projectId;
	                        }
	                        else {
	                            queryParams = '?formId=' + formId;
	                        }
	                        self.$http({
	                            'url': window.properties.service.uri + action_constants_1.Ids.GET_API_CONNECTION_LIST + queryParams,
	                            'method': 'GET',
	                            'withCredentials': true,
	                            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	                        }).then(function (response) {
	                            _this.connectionLists = response.data.entity;
	                            _this.showSpinner = false;
	                        }, function (response) {
	                            _this.ngNotification.error({ message: 'Error while getting api connection data', positionX: 'center', replaceMessage: true });
	                            _this.showSpinner = false;
	                        });
	                    };
	                    this.getAsiteSupportedAPi = function () {
	                        var _this = this;
	                        this.showSpinner = true;
	                        self.$http({
	                            'url': window.properties.service.uri + action_constants_1.Ids.GET_ALL_FORMS,
	                            'method': 'GET',
	                            'data': {},
	                            'withCredentials': true,
	                            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	                        }).then(function (response) {
	                            _this.apiData = response.data;
	                            _this.showSpinner = false;
	                        }, function (response) {
	                            _this.ngNotification.error({ message: 'Error while getting AsiteSupportedAPi data', positionX: 'center', replaceMessage: true });
	                            _this.showSpinner = false;
	                        });
	                    };
	                    this.getAllProjectes = function () {
	                        var _this = this;
	                        this.showSpinner = true;
	                        self.$http({
	                            'url': window.properties.service.commonApiUrl.replace('/commonapi/', '/adoddle/') + action_constants_1.Ids.GET_ALL_PROJECTS,
	                            'method': 'POST',
	                            data: self.$httpParamSerializer({ action_id: 1001, recordBatchSize: -1 }),
	                            'withCredentials': true,
	                            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
	                        }).then(function (response) {
	                            // console.log("response", response);
	                            var projects = [];
	                            if (response.data.totalDocs > 0) {
	                                projects = response.data.data;
	                            }
	                            else {
	                                projects = [];
	                            }
	                            _this.projects = projects.map(function (item) {
	                                item.isSelected = false;
	                                return item;
	                            });
	                            _this.projects.unshift({ value: '{{Current Project}}', id: 0, isSelected: false });
	                            _this.projects.splice(_this.projects.findIndex(function (el) { return el.value === 'Project Templates'; }), 1);
	                            _this.showSpinner = false;
	                        }, function (response) {
	                            _this.showSpinner = false;
	                            _this.ngNotification.error({ message: 'Error while getting projects data', positionX: 'center', replaceMessage: true });
	                        });
	                    };
	                    this.getFormsTypesId = function (projectIds) {
	                        var _this = this;
	                        this.showSpinner = true;
	                        self.$http({
	                            'url': window.properties.service.commonApiUrl + action_constants_1.Ids.GET_FORMSTYPEBYPROJECTS + '?projectIds=' + projectIds,
	                            'method': 'POST',
	                            'withCredentials': true,
	                            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
	                        }).then(function (response) {
	                            // console.log("response", response);
	                            _this.formTypes = response.data;
	                            _this.showSpinner = false;
	                            var formTypeValue = _this.parameters.find(function (e) { return e.name == 'FormName' && e.value != ""; });
	                            if (formTypeValue && formTypeValue.value) {
	                                var exists = _this.formTypes.find(function (e) { return e.formTypeName == formTypeValue.value; });
	                                if (!exists) {
	                                    var params = angular.copy(_this.parameters);
	                                    params = params.map(function (item) {
	                                        if (item.name == 'FormName') {
	                                            item.value = '';
	                                        }
	                                        return item;
	                                    });
	                                    _this.parameters = angular.copy(params);
	                                }
	                            }
	                            if (formTypeValue && formTypeValue.value) {
	                                var customFormFormTypeId = response.data.filter(function (item) {
	                                    return item.formTypeName == formTypeValue.value;
	                                });
	                                if (customFormFormTypeId.length > 0) {
	                                    var selectedProjectId = customFormFormTypeId[0].hashedProjectId;
	                                    customFormFormTypeId = customFormFormTypeId[0].formTypeID.split("$$")[0];
	                                    _this.getCustomFormFieldsWithFormTypeIds(selectedProjectId, customFormFormTypeId);
	                                }
	                                else {
	                                    _this.onChangeFormType(_this.parameters);
	                                }
	                            }
	                        }, function (response) {
	                            _this.ngNotification.error({ message: 'Error while getting formTypes data', positionX: 'center', replaceMessage: true });
	                            _this.showSpinner = false;
	                        });
	                    };
	                    this.getCustomFormFieldsWithFormTypeIds = function (selectedProjectIds, selectedFormsTypesId) {
	                        var _this = this;
	                        this.showSpinner = true;
	                        self.$http({
	                            'url': window.properties.service.commonApiUrl + action_constants_1.Ids.GET_CUSTOMFORMFIELDS + '?projectId=' + selectedProjectIds + '&formTypeIds=' + selectedFormsTypesId,
	                            'method': 'GET',
	                            'withCredentials': true,
	                            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
	                        }).then(function (response) {
	                            _this.showSpinner = false;
	                            var responseData = response.data;
	                            if (responseData) {
	                                // filter for controls not to show in the custom fields.
	                                responseData = responseData.filter(function (x) {
	                                    return x.type != 'SiteLocationButton' && x.type != 'Button' && x.type != 'Section' && x.type != 'Layout' && x.type != 'Table' && x.type != 'RepeatingTable' && x.type != 'Attachment' && x.type != 'Rating' && x.type != 'ToggleButton' && x.type != 'InlineAssocFiles' && x.type != 'InlineAssocApps' && x.type != 'ViewAssociations';
	                                });
	                                _this.customFormFields = responseData.map(function (val) {
	                                    var obj = {
	                                        name: "",
	                                        displayFieldName: "",
	                                        dataType: "",
	                                        operator: "",
	                                        value: null,
	                                        testValue: null,
	                                        conjunction: null,
	                                        hidden: false,
	                                        mandatory: false,
	                                        header: false,
	                                        encrypted: false,
	                                        isDataSelected: false,
	                                    };
	                                    obj.name = val.fieldXPath;
	                                    obj.displayFieldName = val.formFieldName;
	                                    return obj;
	                                });
	                                // Filter the controls like Layout, Table, Repeating Table controls [ controls which does not havre the name property]
	                                _this.customFormFields = _this.customFormFields.filter(function (x) {
	                                    return x.name;
	                                });
	                                if (_this.optionalFieldsCopy.length == 0) {
	                                    _this.optionalFieldsCopy = angular.copy(_this.optionalFields);
	                                }
	                                _this.optionalFields = _this.optionalFieldsCopy.concat(_this.customFormFields);
	                            }
	                        }, function (response) {
	                            _this.ngNotification.error({ message: 'Error while getting CustomFormFields data', positionX: 'center', replaceMessage: true });
	                            _this.showSpinner = false;
	                        });
	                    };
	                    this.getFormsStatuses = function (projectIds, formTypeId) {
	                        var _this = this;
	                        this.showSpinner = true;
	                        self.$http({
	                            'url': window.properties.service.commonApiUrl + action_constants_1.Ids.GET_FORMSTATUS_BY_PROJECTS + '?projectIds=' + projectIds,
	                            'method': 'POST',
	                            'withCredentials': true,
	                            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
	                        }).then(function (response) {
	                            // console.log("response", response);
	                            if (response.data && response.data.length > 0) {
	                                var statusList = response.data.map(function (item, i) {
	                                    return {
	                                        id: i,
	                                        value: item
	                                    };
	                                });
	                                _this.formStatuses = angular.copy(statusList);
	                                _this.showSpinner = false;
	                            }
	                        }, function (response) {
	                            _this.ngNotification.error({ message: 'Error while getting formStatus data', positionX: 'center', replaceMessage: true });
	                            _this.showSpinner = false;
	                        });
	                    };
	                    this.getAsiteSupportedAPi();
	                    this.getApiconnectionLists();
	                    this.getAllProjectes();
	                    this.changeAsiteApi = function () {
	                        this.parameters = [];
	                    };
	                    this.addConnection = function () {
	                        this.objParam = {
	                            name: '',
	                            externalApi: false,
	                            apiId: '',
	                            description: '',
	                            bodyParamsType: '',
	                            status: 'Not Connected',
	                            authType: api_connection_constants_1.AuthType.None
	                        };
	                        this.authType = api_connection_constants_1.AuthType.None;
	                        this.externapAPIData = angular.copy({
	                            params: [],
	                            headers: [],
	                            bodyParams: []
	                        });
	                        this.showAddConnectionForm = true;
	                        this.selectedStep = 1;
	                        this.testResults = [];
	                        this.parameters = [];
	                        this.currentProjectSelected = false;
	                        this.testFilters = [];
	                        this.isDuplicate = false;
	                        this.specialCharacter = false;
	                        this.isTestConnection = false;
	                    };
	                    this.save = function () {
	                        var _this = this;
	                        this.showSpinner = true;
	                        var data = angular.copy(this.objParam);
	                        data.instanceGroupId = self.params.id.instanceGroupId || null;
	                        data.projectId = self.params.id.projectId || null;
	                        data.formId = (!self.params.id.projectId && !self.params.id.instanceGroupId) ? self.params.id : null;
	                        if (data && data.externalApi) {
	                            data.parameters = angular.copy(this.externapAPIData);
	                            this.externapAPIData = angular.copy(this.testFilters);
	                            var controlDataFieldNames_1 = this.controlDataFieldNames;
	                            // check for the headers data if key has value or not if value check if valu is custom type or text
	                            var headersArray = angular.copy(this.externapAPIData.headers);
	                            headersArray = this.externapAPIData.headers.filter(function (el) { return el['name'] != ''; });
	                            var newHeadersArray = headersArray.map(function (item) {
	                                var a = self.IsCustomData(controlDataFieldNames_1, item);
	                                if (a)
	                                    item.dataType = 'custom';
	                                else
	                                    item.dataType = 'text';
	                                return item;
	                            });
	                            // check for the params data if key has value or not if value check if valu is custom type or text
	                            var paramsArray = angular.copy(this.externapAPIData.params);
	                            paramsArray = this.externapAPIData.params.filter(function (el) { return el['name'] != ''; });
	                            var newParamssArray = paramsArray.map(function (item) {
	                                var a = self.IsCustomData(controlDataFieldNames_1, item);
	                                if (a)
	                                    item.dataType = 'custom';
	                                else
	                                    item.dataType = 'text';
	                                return item;
	                            });
	                            // check for the BodyParams data if key has value or not if value check if valu is custom type or text
	                            var bodyParamsArray = angular.copy(this.externapAPIData.bodyParams);
	                            bodyParamsArray = this.externapAPIData.bodyParams.filter(function (el) { return el['name'] != ''; });
	                            var newBodyParamsArray = bodyParamsArray.map(function (item) {
	                                var a = self.IsCustomData(controlDataFieldNames_1, item);
	                                if (a)
	                                    item.dataType = 'custom';
	                                else
	                                    item.dataType = 'text';
	                                return item;
	                            });
	                            data.parameters.headers = newHeadersArray;
	                            data.parameters.params = newParamssArray;
	                            data.parameters.bodyParams = newBodyParamsArray;
	                            data.testUrl = this.testFilters.testUrl;
	                            data.authType = this.authType;
	                        }
	                        else {
	                            var param = angular.copy(this.testFilters);
	                            var controlDataFieldNames_2 = this.controlDataFieldNames;
	                            param = param.map(function (item) {
	                                if (item.name == 'ProjectName' || item.name == 'FormStatus') {
	                                    delete item.searchText;
	                                    delete item.isOpen;
	                                    delete item.isLimited;
	                                    delete item.isLimited;
	                                    delete item.selectedValues;
	                                }
	                                var a = self.IsCustomData(controlDataFieldNames_2, item);
	                                if (a)
	                                    item.dataType = 'custom';
	                                else
	                                    item.dataType = 'text';
	                                item.asiteApiId = parseInt(item.asiteApiId);
	                                if (item.multiValue) {
	                                    item.multiValue = null;
	                                }
	                                return item;
	                            });
	                            data.parameters = angular.copy(param);
	                            var selectedAsiteApiId_1 = this.objParam.asiteApiId;
	                            var selectedApi = this.apiData.find(function (item) {
	                                return item.asiteApiId == selectedAsiteApiId_1;
	                            });
	                            data.url = selectedApi.url;
	                            data.requestType = selectedApi.requestType;
	                        }
	                        if (this.objParam.hasOwnProperty('apiId') && this.objParam.apiId != '') {
	                            data.hasOldDelimiter = data.hasOldDelimiter ? data.hasOldDelimiter : true;
	                        }
	                        else {
	                            data.hasOldDelimiter = false;
	                        }
	                        var queryString = '';
	                        if (data.instanceGroupId && data.projectId) {
	                            queryString = '?instanceGroupId=' + data.instanceGroupId + '&projectId=' + data.projectId;
	                        }
	                        else {
	                            queryString = '?formId=' + data.formId;
	                        }
	                        // console.log("savedd data", data);
	                        delete data.instanceGroupId;
	                        delete data.projectId;
	                        delete data.formId;
	                        self.$http({
	                            'url': window.properties.service.uri + action_constants_1.Ids.SAVE_API_CONNECTION + queryString,
	                            'method': "POST",
	                            data: self.$httpParamSerializer({ "apiData": data }),
	                            'withCredentials': true,
	                            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
	                        }).then(function (response) {
	                            _this.showSpinner = false;
	                            if (response.data.httpCode == 200 && response.data.message == 'SUCCESS') {
	                                // console.log("saving data", response);
	                                _this.getApiconnectionLists();
	                                _this.showAddConnectionForm = false;
	                            }
	                            else {
	                                _this.ngNotification.error({ message: response.data.message, positionX: 'center', replaceMessage: true });
	                            }
	                        }, function (err) {
	                            // console.log("errro saving data", err);
	                            _this.showSpinner = false;
	                        });
	                        // making the optional fields isDataSelected to false at time of save. its making issue at time of add connection 
	                        for (var m = 0; m < this.optionalFields.length; m++) {
	                            if (this.optionalFields[m].isDataSelected) {
	                                this.optionalFields[m].isDataSelected = false;
	                            }
	                        }
	                    };
	                    this.isParamtersValid = function () {
	                        var mandatoryParam = this.parameters.filter(function (obj) { return obj.mandatory && !obj.hidden; });
	                        return mandatoryParam.filter(function (obj) {
	                            return obj.value ? false : true;
	                        });
	                    };
	                    this.check = function (name) {
	                        // var reg = /^[^`~!@#$%\^&*()_+={}|[\]\\:';"<>?,./]*$/;
	                        var reg = /^[^`~!@#$%\^&*={}|\\:';"<>?,./]*$/;
	                        if (name && !name.match(reg)) {
	                            this.specialCharacter = true;
	                        }
	                        else {
	                            this.specialCharacter = false;
	                        }
	                        this.isDuplicate = false;
	                    };
	                    this.isAlreadyExists = function (name, id) {
	                        var isExists = this.connectionLists.some(function (obj) {
	                            return obj.name == name && obj.apiId != id;
	                        });
	                        if (isExists) {
	                            this.isDuplicate = true;
	                        }
	                        else {
	                            this.isDuplicate = false;
	                        }
	                    };
	                    this.next = function () {
	                        var _this = this;
	                        // add scroll to auto
	                        var modalElement = $('.api-connection-modal');
	                        modalElement[0].style.overflowY = "auto";
	                        if (this.selectedStep == 1) {
	                            var isExists = this.isAlreadyExists(this.objParam);
	                            if (isExists || this.specialCharacter) {
	                                this.ngNotification.error({ message: 'This form contains validation errors or mandatory fields are not specified. Please filled in and try again.', positionX: 'center', replaceMessage: true });
	                                return false;
	                            }
	                        }
	                        if (this.selectedStep == 2 && !this.objParam.externalApi) {
	                            var valid = this.isParamtersValid().length == 0;
	                            if (!valid) {
	                                this.ngNotification.error({ message: 'This form contains validation errors or mandatory fields are not specified. Please filled in and try again.', positionX: 'center', replaceMessage: true });
	                                return false;
	                            }
	                        }
	                        this.selectedStep = this.selectedStep + 1;
	                        if (this.selectedStep === 2) {
	                            if (this.objParam.externalApi && (this.objParam.apiId || this.objParam.isCopyData)) {
	                                this.externapAPIData = angular.copy(this.objParam.parameters);
	                            }
	                            if (!this.objParam.externalApi) {
	                                var selectedApi_1 = this.objParam.asiteApiId;
	                                var filterData = this.apiData.filter(function (item) {
	                                    return item.asiteApiId == selectedApi_1;
	                                });
	                                var param = filterData[0].parameters.map(function (el) {
	                                    if (el.name == 'ProjectName' || el.name == 'FormStatus') {
	                                        el.selectedValues = [];
	                                    }
	                                    delete el.paramId;
	                                    return el;
	                                });
	                                var requiredFields = param.filter(function (item) {
	                                    return item.mandatory == true;
	                                });
	                                this.optionalFields = param.filter(function (item) {
	                                    return item.mandatory == false && item.hidden === false;
	                                });
	                                // filter the param which having the multiValue property.
	                                var multiValueData = filterData[0].parameters.filter(function (item) {
	                                    return item.mandatory == false && item.multiValue;
	                                });
	                                var isOldDelimiter_1 = this.objParam.hasOwnProperty('hasOldDelimiter') && this.objParam.hasOldDelimiter ? true : false;
	                                // param multiValue property string to object.
	                                this.multiValueParameters = multiValueData.reduce(function (acc, curr) {
	                                    acc[curr.name] = curr.multiValue.split('#').reduce(function (acc, curr) {
	                                        var _a = curr.split(':'), key = _a[0], value = _a[1];
	                                        acc.push({
	                                            key: key,
	                                            value: value,
	                                        });
	                                        return acc;
	                                    }, []);
	                                    return acc;
	                                }, {});
	                                if (this.objParam.apiId) {
	                                    this.optionalFields = this.optionalFields.concat(this.customFormFields);
	                                }
	                                if (this.parameters.length > 0) {
	                                    var parameters_1 = angular.copy(this.parameters);
	                                    requiredFields.forEach(function (data) {
	                                        var index = parameters_1.findIndex(function (x) { return x.name == data.name; });
	                                        if (index === -1) {
	                                            parameters_1.push(data);
	                                        }
	                                    });
	                                    this.parameters = parameters_1;
	                                }
	                                else {
	                                    this.parameters = angular.copy(requiredFields);
	                                }
	                                this.parameters = this.parameters.map(function (item) {
	                                    var object = item;
	                                    if (object.name == 'ProjectName' || object.name == 'FormStatus') {
	                                        if (object.value && object.value != "") {
	                                            if (isOldDelimiter_1)
	                                                object.selectedValues = item.value.split(',');
	                                            else
	                                                object.selectedValues = item.value.split('###');
	                                        }
	                                        else {
	                                            object.selectedValues = [];
	                                        }
	                                    }
	                                    object.operator = object.operator ? object.operator : '==';
	                                    return object;
	                                });
	                                var mandatoryFalse = this.parameters.filter(function (obj) {
	                                    return obj.mandatory == false;
	                                });
	                                if (mandatoryFalse) {
	                                    for (var j = 0; j < this.optionalFields.length; j++) {
	                                        for (var i = 0; i < mandatoryFalse.length; i++) {
	                                            if (this.optionalFields[j].name == mandatoryFalse[i].name) {
	                                                this.optionalFields[j].isDataSelected = true;
	                                                break;
	                                            }
	                                            else
	                                                this.optionalFields[j].isDataSelected = false;
	                                        }
	                                    }
	                                }
	                                if (selectedApi_1 == api_connection_constants_1.Api_Ids.FORM_SEARCH_API_ID) {
	                                    this.parameters = _.orderBy(this.parameters, 'name', 'desc');
	                                    this.parameters = _.orderBy(this.parameters, 'mandatory', 'desc');
	                                }
	                            }
	                            if (this.objParam.externalApi) {
	                                // add data in array if no object in the array
	                                if (this.externapAPIData.headers.length == 0)
	                                    this.externapAPIData.headers.push({ name: '', value: '' });
	                                if (this.externapAPIData.params.length == 0)
	                                    this.externapAPIData.params.push({ name: '', value: '' });
	                                if (this.externapAPIData.bodyParams.length == 0)
	                                    this.externapAPIData.bodyParams.push({ name: '', value: '' });
	                            }
	                        }
	                        if (this.selectedStep == 3) {
	                            // do test result data blank
	                            this.testResults = [];
	                            this.showTestResult = false;
	                            if (!this.objParam.externalApi) {
	                                this.testFilters = angular.copy(this.parameters);
	                                this.testFilters = this.testFilters.filter(function (el) { return el.name != ""; });
	                                this.testFilters = this.testFilters.map(function (item) {
	                                    item.testValue = item.value && self.IsCustomData(_this.controlDataFieldNames, item) ? '' : item.value;
	                                    return item;
	                                });
	                            }
	                            else {
	                                this.testFilters = angular.copy(this.externapAPIData);
	                                this.testFilters.testUrl = this.objParam.url;
	                                this.testFilters.params = this.testFilters.params.map(function (item) {
	                                    item.testValue = item.value && self.IsCustomData(_this.controlDataFieldNames, item) ? '' : item.value;
	                                    return item;
	                                }).filter(function (data) {
	                                    return data.name != '';
	                                });
	                                this.testFilters.headers = this.testFilters.headers.map(function (item) {
	                                    item.testValue = item.value && self.IsCustomData(_this.controlDataFieldNames, item) ? '' : item.value;
	                                    return item;
	                                }).filter(function (data) {
	                                    return data.name != '';
	                                });
	                                ;
	                                this.testFilters.bodyParams = this.testFilters.bodyParams.map(function (item) {
	                                    item.testValue = item.value && self.IsCustomData(_this.controlDataFieldNames, item) ? '' : item.value;
	                                    return item;
	                                }).filter(function (data) {
	                                    return data.name != '';
	                                });
	                            }
	                        }
	                    };
	                    this.back = function () {
	                        this.selectedStep = this.selectedStep - 1;
	                        var modalElement = $('.api-connection-modal');
	                        modalElement[0].style.overflowY = "auto";
	                    };
	                    this.stepClickHandler = function (clickedStep) {
	                        // this.selectedStep = clickedStep;
	                    };
	                    this.changeAPI = function () {
	                        this.objParam.externalApi = !this.objParam.externalApi;
	                        if (this.objParam.externalApi) {
	                            this.parameters = [];
	                        }
	                        else {
	                            this.externapAPIData = {
	                                params: [],
	                                headers: [],
	                                bodyParams: []
	                            };
	                            this.authType = api_connection_constants_1.AuthType.None;
	                            this.objParam.authType = api_connection_constants_1.AuthType.None;
	                        }
	                    };
	                    this.onAuthenticationChange = function (checked) {
	                        this.authType = checked ? api_connection_constants_1.AuthType.OAuth : api_connection_constants_1.AuthType.None;
	                        this.objParam.authType = this.authType;
	                    };
	                    this.isAuthenticationEnabled = function () {
	                        return this.authType !== api_connection_constants_1.AuthType.None;
	                    };
	                    this.onToggle = function () {
	                        if (this.objParam.apiId || this.parameters.length > 0 || (this.externapAPIData.headers.length > 0 || this.externapAPIData.params.length > 0 || this.externapAPIData.bodyParams.length > 0)) {
	                            this.ngNotification.warning({
	                                message: 'Filter and Response section might have field added as per the selection, would you like to change', positionX: 'center', replaceMessage: true, templateUrl: "warning_before_changeData.html", scope: this.$scope
	                            });
	                        }
	                        else {
	                            this.objParam.externalApi = !this.objParam.externalApi;
	                        }
	                    };
	                    this.addNewFilter = function (listFilters, $event) {
	                        var index = Object.keys(this.parameters).length;
	                        this.parameters.push({
	                            name: '',
	                            operator: '',
	                            value: '',
	                            conjuction: ''
	                        });
	                    };
	                    this.removeFilter = function (filter) {
	                        var index = this.parameters.indexOf(filter);
	                        var filteredData = this.optionalFields.find(function (response) {
	                            return response.displayFieldName === filter.displayFieldName;
	                        });
	                        if (filteredData) {
	                            filteredData.isDataSelected = false;
	                        }
	                        if (index >= 0)
	                            this.parameters.splice(index, 1);
	                    };
	                    this.addNewMapping = function ($event) {
	                        var index = Object.keys(this.listMappings).length;
	                        this.listMappings.push({
	                            sourceData: '',
	                            mapto: '',
	                        });
	                    };
	                    this.removeMapping = function (item) {
	                        var index = this.listMappings.indexOf(item);
	                        if (index >= 0)
	                            this.listMappings.splice(index, 1);
	                    };
	                    this.testConnection = function (data) {
	                        this.showTestResult = false;
	                        this.showAddConnectionForm = true;
	                        this.isTestConnection = true;
	                        this.testResults = [];
	                        this.selectedStep = 2;
	                        this.objParam = data;
	                        this.authType = data.authType || api_connection_constants_1.AuthType.None;
	                        if (data.externalApi) {
	                            this.externapAPIData = angular.copy(data.parameters);
	                        }
	                        else {
	                            this.parameters = angular.copy(data.parameters);
	                            var selectedApi_2 = data.asiteApiId;
	                            var filterData = this.apiData.filter(function (item) {
	                                return item.asiteApiId == selectedApi_2;
	                            });
	                            // filter the param which having the multiValue property.
	                            var multiValueData = filterData[0].parameters.filter(function (item) {
	                                return item.mandatory == false && item.multiValue;
	                            });
	                            // param multiValue property string to object.
	                            this.multiValueParameters = multiValueData.reduce(function (acc, curr) {
	                                acc[curr.name] = curr.multiValue.split('#').reduce(function (acc, curr) {
	                                    var _a = curr.split(':'), key = _a[0], value = _a[1];
	                                    acc.push({
	                                        key: key,
	                                        value: value,
	                                    });
	                                    return acc;
	                                }, []);
	                                return acc;
	                            }, {});
	                        }
	                        this.next();
	                    };
	                    this.testRun = function () {
	                        var _this = this;
	                        this.isTestConnection = false;
	                        var configData = this.config;
	                        var myHeaders = {};
	                        var queryString = '';
	                        if (this.objParam.externalApi) {
	                            var parameters = angular.copy(this.testFilters);
	                            parameters.params = parameters.params.map(function (item) {
	                                item.value = item.testValue;
	                                return item;
	                            });
	                            parameters.headers = parameters.headers.map(function (item) {
	                                item.value = item.testValue;
	                                return item;
	                            });
	                            parameters.bodyParams = parameters.bodyParams.map(function (item) {
	                                item.value = item.testValue;
	                                return item;
	                            });
	                            var datas = Object.assign({}, this.objParam);
	                            datas.parameters = angular.copy(parameters);
	                            datas.url = datas.parameters.testUrl;
	                            delete datas.parameters.testUrl;
	                            datas.authType = this.authType;
	                            // pass int unhashed projectId in case of OAuth checked
	                            if (this.authType === api_connection_constants_1.AuthType.OAuth) {
	                                datas.projectId = parseInt(self.params.id.projectId.split("$$")[0]) || null;
	                            }
	                            var url = window.properties.service.commonApiUrl.replace('/commonapi/', '/adoddle/') + 'apps?action_id=858&externalApi=true';
	                            var req = {
	                                'url': url,
	                                'method': 'POST',
	                                'withCredentials': true,
	                                data: JSON.stringify(datas),
	                            };
	                            this.showSpinner = true;
	                            self.$http(req).then(function (response) {
	                                _this.testResults = response.data;
	                                _this.showSpinner = false;
	                                _this.showTestResult = true;
	                                if (response.data && response.data.status != 'fail') {
	                                    _this.objParam.status = 'Established';
	                                }
	                                else {
	                                    _this.objParam.status = 'Failed';
	                                    _this.ngNotification.error({ message: 'Test Run failed', positionX: 'center', replaceMessage: true });
	                                }
	                            }, function (error) {
	                                // console.log("err", error);
	                                _this.showSpinner = false;
	                                _this.showTestResult = true;
	                                _this.objParam.status = 'Failed';
	                                _this.ngNotification.error({ message: 'Test Run failed', positionX: 'center', replaceMessage: true });
	                            });
	                        }
	                        else {
	                            var selectedAsiteApiId_2 = this.objParam.asiteApiId;
	                            var selectedApi = this.apiData.find(function (item) {
	                                return item.asiteApiId == selectedAsiteApiId_2;
	                            });
	                            var queryString_1 = '';
	                            var headers = this.testFilters.filter(function (el) { return el.header == true; });
	                            headers = headers.reduce(function (prev, curr) {
	                                if (curr.name !== '') {
	                                    prev[curr.name] = self.USP.aSessionId || '';
	                                    return prev;
	                                }
	                            }, {});
	                            var data = this.testFilters.filter(function (el) { return el.header == false; });
	                            var operatorObject = {};
	                            // create object for the operator fiedname
	                            operatorObject = data.reduce(function (prev, curr) {
	                                if (curr.name != "isComingFormApiConnection") {
	                                    if (curr.operator == 'IN')
	                                        prev["operator_" + curr.name] = "CONTAINS";
	                                    else if (curr.operator == 'NOT IN')
	                                        prev["operator_" + curr.name] = "NOT_CONTAIN";
	                                    else if (curr.operator == '!=')
	                                        prev["operator_" + curr.name] = "NOT_EQUALS";
	                                    else
	                                        prev["operator_" + curr.name] = "EQUALS";
	                                }
	                                return prev;
	                            }, {});
	                            // create a object for the key value for pair from the array
	                            var queryObject = {};
	                            queryObject = data.reduce(function (prev, curr) {
	                                if (curr.name !== '') {
	                                    if (curr.name == 'projectId') {
	                                        prev[curr.name] = configData.formID.projectId;
	                                    }
	                                    else if (curr.name == 'formTypeId') {
	                                        prev[curr.name] = configData.formID.formTypeId;
	                                    }
	                                    else if (curr.name == 'ProjectName') {
	                                        prev[curr.name] = curr.testValue.replaceAll("{{Current Project}}", self.currentProject);
	                                    }
	                                    else
	                                        prev[curr.name] = curr.testValue;
	                                    return prev;
	                                }
	                            }, {});
	                            // create a query string from the obect to pass it to the api as queryparam
	                            var finalQueryObject_1 = Object.assign({}, queryObject, operatorObject);
	                            if (finalQueryObject_1) {
	                                queryString_1 = Object.keys(finalQueryObject_1)
	                                    .map(function (name) { return (encodeURIComponent(name) + "=" + encodeURIComponent(finalQueryObject_1[name])); })
	                                    .join('&');
	                            }
	                            this.objParam.url = selectedApi.url;
	                            this.objParam.requestType = selectedApi.requestType;
	                            var baseUrl = self.baseUrl;
	                            // send hasOldDelimiter in app api call
	                            var isOldDelimiter = true;
	                            if (this.objParam.hasOwnProperty('hasOldDelimiter')) {
	                                isOldDelimiter = this.objParam.hasOldDelimiter;
	                            }
	                            if (!this.objParam.apiId)
	                                isOldDelimiter = false;
	                            var internalAPiUrl = window.properties.service.commonApiUrl.replace('/commonapi/', '/adoddle/') + 'apps?action_id=858&hasOldDelimiter=' + isOldDelimiter;
	                            queryString_1 = queryString_1 + '&externalApi=false&apiUrl=' + this.objParam.url;
	                            var req = {
	                                'url': queryString_1 == '' ? internalAPiUrl : internalAPiUrl + '&' + queryString_1,
	                                'method': this.objParam.requestType,
	                                'withCredentials': true,
	                                'headers': (headers && Object.keys(headers).length === 0) ? {} : headers,
	                            };
	                            this.showSpinner = true;
	                            self.$http(req).then(function (response) {
	                                _this.testResults = response.data;
	                                _this.showSpinner = false;
	                                _this.showTestResult = true;
	                                if (response.data && response.data.status != 'fail') {
	                                    _this.objParam.status = 'Established';
	                                }
	                                else {
	                                    _this.objParam.status = 'Failed';
	                                    _this.ngNotification.error({ message: 'Test Run failed', positionX: 'center', replaceMessage: true });
	                                }
	                            }, function (error) {
	                                _this.showSpinner = false;
	                                _this.showTestResult = true;
	                                _this.objParam.status = 'Failed';
	                                _this.ngNotification.error({ message: 'Test Run failed', positionX: 'center', replaceMessage: true });
	                            });
	                        }
	                    };
	                    this.editConnection = function (item) {
	                        this.selectedStep = 1;
	                        this.objParam = angular.copy(item);
	                        this.showAddConnectionForm = true;
	                        this.testResults = [];
	                        this.isDuplicate = false;
	                        this.specialCharacter = false;
	                        this.isTestConnection = false;
	                        this.parameters = angular.copy(this.objParam.parameters);
	                        this.authType = this.objParam.authType || api_connection_constants_1.AuthType.None;
	                        if (!this.objParam.externalApi && item.asiteApiId == api_connection_constants_1.Api_Ids.FORM_SEARCH_API_ID) {
	                            this.objParam.asiteApiId = parseInt(this.objParam.asiteApiId);
	                            var selectedValues = this.parameters.find(function (el) { return el.name === 'ProjectName'; }).value;
	                            var projectArray = (this.objParam.hasOwnProperty('hasOldDelimiter') && this.objParam.hasOldDelimiter == true) ? selectedValues && selectedValues.split(',') : selectedValues && selectedValues.split('###');
	                            if (projectArray.length > 0 && (!projectArray.includes('{{Current Project}}') || self.currentProject)) {
	                                var selectedProjects_1 = [];
	                                var selectedProjectNames_1 = [];
	                                var projects_1 = this.projects;
	                                projectArray.forEach(function (element) {
	                                    var selectElement = element;
	                                    var val = projects_1.find(function (el) { return el.value == selectElement; });
	                                    if (val) {
	                                        selectedProjects_1.push(val.id);
	                                        selectedProjectNames_1.push(val.value);
	                                    }
	                                });
	                                selectedProjects_1.forEach(function (part, index, theArray) {
	                                    if (theArray[index] == "0") {
	                                        theArray[index] = self.currentProjectId;
	                                    }
	                                });
	                                var projectIds = selectedProjects_1.join(',');
	                                // remove the projects from params if not available in projectlist
	                                var isOldDelimiter_2 = this.objParam.hasOwnProperty('hasOldDelimiter') && this.objParam.hasOldDelimiter == true ? true : false;
	                                this.parameters = this.parameters.map(function (item) {
	                                    // delete item.id;
	                                    if (item.name == "ProjectName") {
	                                        if (isOldDelimiter_2)
	                                            item.value = selectedProjectNames_1.join(',');
	                                        else
	                                            item.value = selectedProjectNames_1.join('###');
	                                    }
	                                    return item;
	                                });
	                                // End remove the projects from params if not available in projectlist
	                                this.getFormsTypesId(projectIds);
	                                this.getFormsStatuses(projectIds, '');
	                            }
	                            else {
	                                this.currentProjectSelected = true;
	                            }
	                        }
	                    };
	                    this.copy = function (item) {
	                        var copyData = angular.copy(item);
	                        copyData.name = '';
	                        delete copyData.apiId;
	                        copyData.status = "Not Connected";
	                        copyData.isCopyData = true;
	                        if (copyData.externalApi) {
	                            var params = angular.copy(copyData.parameters.params);
	                            params = params.map(function (item) {
	                                delete item.id;
	                                return item;
	                            });
	                            var headers = angular.copy(copyData.parameters.headers);
	                            headers = headers.map(function (item) {
	                                delete item.id;
	                                return item;
	                            });
	                            var bodyParams = angular.copy(copyData.parameters.bodyParams);
	                            bodyParams = bodyParams.map(function (item) {
	                                delete item.id;
	                                return item;
	                            });
	                            copyData.parameters.params = angular.copy(params);
	                            copyData.parameters.headers = angular.copy(headers);
	                            copyData.parameters.bodyParams = angular.copy(bodyParams);
	                        }
	                        else {
	                            var parameters = angular.copy(copyData.parameters);
	                            parameters = parameters.map(function (item) {
	                                delete item.paramId;
	                                return item;
	                            });
	                            copyData.parameters = angular.copy(parameters);
	                        }
	                        this.editConnection(copyData);
	                    };
	                    this.removeConnection = function () {
	                        var _this = this;
	                        var item = angular.copy(this.removeConnectionObject);
	                        self.$http({
	                            'url': window.properties.service.uri + action_constants_1.Ids.REMOVE_API_CONNECTION + '?apiId=' + item.apiId,
	                            'method': "POST",
	                            'withCredentials': true,
	                            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
	                        }).then(function (response) {
	                            // console.log("remove data", response);
	                            _this.showSpinner = false;
	                            _this.getApiconnectionLists();
	                            _this.showAddConnectionForm = false;
	                        }, function (err) {
	                            // console.log("errro copy data", err);
	                            _this.ngNotification.error({ message: 'Error while removing api connection data', positionX: 'center', replaceMessage: true });
	                            _this.showSpinner = false;
	                        });
	                    };
	                    this.remove = function (item) {
	                        this.removeConnectionObject = item;
	                        this.ngNotification.warning({
	                            message: 'Please confirm if you wish to remove the API connection?', positionX: 'center', replaceMessage: true, templateUrl: "warning_before_remove_connection.html", scope: this.$scope
	                        });
	                    };
	                    this.addNewParams = function ($event) {
	                        var index = Object.keys(this.externapAPIData.params).length;
	                        this.externapAPIData.params.push({
	                            name: '',
	                            value: '',
	                        });
	                    };
	                    this.removeParams = function (item) {
	                        var index = this.externapAPIData.params.indexOf(item);
	                        if (index >= 0)
	                            this.externapAPIData.params.splice(index, 1);
	                    };
	                    this.addNewHeaders = function ($event) {
	                        var index = Object.keys(this.externapAPIData.headers).length;
	                        this.externapAPIData.headers.push({
	                            name: '',
	                            value: '',
	                        });
	                    };
	                    this.removeHeaders = function (item) {
	                        var index = this.externapAPIData.headers.indexOf(item);
	                        if (index >= 0)
	                            this.externapAPIData.headers.splice(index, 1);
	                    };
	                    this.addNewBodyParams = function ($event) {
	                        var index = Object.keys(this.externapAPIData.bodyParams).length;
	                        this.externapAPIData.bodyParams.push({
	                            name: '',
	                            value: '',
	                        });
	                    };
	                    this.removeBodyParams = function (item) {
	                        var index = this.externapAPIData.bodyParams.indexOf(item);
	                        if (index >= 0)
	                            this.externapAPIData.bodyParams.splice(index, 1);
	                    };
	                    /**
	                     * @brief      Close dialog
	                     * @return     NULL
	                     */
	                    this.dismiss = function () {
	                        // apiConfigurationModalInstance.dismiss('cancel');
	                        apiConfigurationModalInstance.close(false);
	                        self.apiConnectionClosed();
	                    };
	                    this.cancel = function () {
	                        this.ngNotification.warning({
	                            message: 'There is some unsaved data, would you like to cancel it?', positionX: 'center', replaceMessage: true, templateUrl: "warning_before_cancel.html", scope: this.$scope
	                        });
	                    };
	                    this.initialDropdownPosition = function (item) {
	                        //calculate position for multidropdown display if at the end of the screen / or not sufficient space
	                        var minHeight = 78, pos;
	                        var listLen = item.name == 'ProjectName' ? (this.projects).length : (this.formStatuses).length;
	                        var curDropdownHeight = minHeight + (28 * listLen);
	                        curDropdownHeight = curDropdownHeight > 347 ? 359 : curDropdownHeight;
	                        var windowHeight = $(window).innerHeight();
	                        var pageScroll = $('.modal-dialog').scrollTop();
	                        var curElement = angular.element('div[data-name=' + item.name + ']');
	                        var offset = curElement.offset();
	                        var toppos = offset.top;
	                        var space = windowHeight - (offset.top - pageScroll);
	                        // if (space < curDropdownHeight) {
	                        //   pos = (toppos - curDropdownHeight) + 'px';
	                        // } else {
	                        //   pos = (toppos + 34) + 'px';
	                        // }
	                        pos = (toppos + 34) + 'px';
	                        var dropdownMenuElem = angular.element('div[data-name=dd_' + item.name + ']');
	                        dropdownMenuElem[0].style.top = pos;
	                        var modalElement = $('.api-connection-modal');
	                        // make scroll hidden when multi dropdown open
	                        if (item.isOpen) {
	                            modalElement[0].style.overflowY = "hidden";
	                        }
	                        else {
	                            modalElement[0].style.overflowY = "auto";
	                        }
	                    };
	                    this.onMultiDropdownToggle = function (item, $event) {
	                        var selectionArr = [], nonSelectedArr = [];
	                        item.isLimited = false;
	                        var options = [];
	                        if (item.name == 'ProjectName')
	                            options = this.projects;
	                        else if (item.name == 'FormStatus')
	                            options = this.formStatuses;
	                        if (item.isOpen) {
	                            item.searchText = '';
	                            for (var i = 0; i < options.length; i++) {
	                                if ((item.selectedValues).includes(options[i].value)) {
	                                    options[i].isSelected = true;
	                                }
	                                else {
	                                    options[i].isSelected = false;
	                                }
	                            }
	                            for (var y = 0; y < options.length; y++) {
	                                if (options[y].isSelected) {
	                                    selectionArr.push(options[y]);
	                                }
	                                else {
	                                    nonSelectedArr.push(options[y]);
	                                }
	                            }
	                            if (item.name == 'ProjectName')
	                                this.projects = selectionArr.concat(nonSelectedArr);
	                            else if (item.name == 'FormStatus')
	                                this.formStatuses = selectionArr.concat(nonSelectedArr);
	                        }
	                        this.initialDropdownPosition(item);
	                    };
	                    this.onChangeFormType = function (data) {
	                        var _this = this;
	                        if (data) {
	                            this.parameters = this.parameters.filter(function (el) {
	                                return el.mandatory == true;
	                            });
	                            var formNameData_1 = data.filter(function (item) {
	                                return item.name == "FormName";
	                            });
	                            // projectIdData = projectIdData[0].value.split(",");
	                            var projectId = void 0;
	                            // for (let i = 0; i < projectIdData.length; i++) {
	                            //   projectId = this.projects.filter((item) => {
	                            //     return item.value === projectIdData[i];
	                            //   });
	                            // }
	                            // if(projectId.length > 0){
	                            //   projectId = projectId[0].id;
	                            // }
	                            var formTypeID = this.formTypes.filter(function (item) {
	                                return item.formTypeName === formNameData_1[0].value;
	                            });
	                            if (formTypeID && formTypeID.length > 0) {
	                                projectId = formTypeID[0].hashedProjectId;
	                            }
	                            if (formTypeID && formTypeID.length > 0) {
	                                formTypeID = formTypeID[0].formTypeID.split("$$")[0];
	                            }
	                            if (projectId && formTypeID && formTypeID.length > 0) {
	                                this.getCustomFormFieldsWithFormTypeIds(projectId, formTypeID);
	                            }
	                            // Filter the optionalFields if the form name not selected / select the please select in form name.
	                            if (formTypeID.length === 0 || formTypeID && formTypeID.length > 0) {
	                                this.optionalFields = this.optionalFields.filter(function (item) { return !_this.customFormFields.includes(item); });
	                            }
	                        }
	                    };
	                    this.clearMultiDropdownSearch = function (item) {
	                        //clear search value
	                        item.searchText = '';
	                        item.isLimited = false;
	                        // this.initialDropdownPosition(item);
	                    };
	                    this.clearMultiDropdown = function (item) {
	                        // to pass in setMultiDDSelection function parameter.
	                        var selectedItem = {
	                            'isSelected': true
	                        };
	                        //clear selection
	                        item.selectedValues = [];
	                        item.value = "";
	                        if (item.name === 'ProjectName') {
	                            for (var i = 0; i < this.projects.length; i++) {
	                                this.projects[i].isSelected = false;
	                            }
	                        }
	                        else if (item.name === 'FormStatus') {
	                            for (var i = 0; i < this.formStatuses.length; i++) {
	                                this.formStatuses[i].isSelected = false;
	                            }
	                        }
	                        // call the function to clear the option selected in Form Name and other below fields on click of "clear" button in Project Name value dropdown.
	                        this.setMultiDDSelection(item, selectedItem);
	                    };
	                    this.closeMultiDropdown = function (item) {
	                        item.isOpen = false;
	                        item.isLimited = false;
	                        var modalElement = $('.api-connection-modal');
	                        // make scroll hidden when multi dropdown open
	                        modalElement[0].style.overflowY = "auto";
	                    };
	                    this.showAll = function (item) {
	                        item.isLimited = true;
	                        //calculate position for multidropdown display if at the end of the screen / or not sufficient space
	                        var minHeight = 78, pos;
	                        var listLen = item.name == 'ProjectName' ? (this.projects).length : (this.formStatuses).length;
	                        var curDropdownHeight = minHeight + (28 * listLen);
	                        curDropdownHeight = curDropdownHeight > 347 ? 359 : curDropdownHeight;
	                        var windowHeight = $(window).innerHeight();
	                        var pageScroll = $('.modal-dialog').scrollTop();
	                        var curElement = angular.element('div[data-name=' + item.name + ']');
	                        var offset = curElement.offset();
	                        var toppos = offset.top;
	                        var space = windowHeight - (offset.top - pageScroll);
	                        // if (space < curDropdownHeight) {
	                        //   pos = (toppos - curDropdownHeight) + 'px';
	                        // } else {
	                        //   pos = (toppos + 34) + 'px';
	                        // }
	                        pos = (toppos + 34) + 'px';
	                        var dropdownMenuElem = angular.element('div[data-name=dd_' + item.name + ']');
	                        dropdownMenuElem[0].style.top = pos;
	                    };
	                    this.setMultiDDSelection = function (item, selectedItem) {
	                        selectedItem['isSelected'] = selectedItem.isSelected == undefined ? true : !selectedItem.isSelected;
	                        if (selectedItem.isSelected) {
	                            item.selectedValues.push(selectedItem.value);
	                            if (this.objParam.hasOwnProperty('hasOldDelimiter') && this.objParam.hasOldDelimiter) {
	                                item.value = item.selectedValues.map(function (item) { return item; }).join(',');
	                            }
	                            else
	                                item.value = item.selectedValues.map(function (item) { return item; }).join('###');
	                        }
	                        else {
	                            for (var i = 0; i < item.selectedValues.length; i++) {
	                                var sitem = item.selectedValues[i];
	                                if (selectedItem.value == sitem) {
	                                    item.selectedValues.splice(i, 1);
	                                    break;
	                                }
	                            }
	                            if (this.objParam.hasOwnProperty('hasOldDelimiter') && this.objParam.hasOldDelimiter) {
	                                item.value = item.selectedValues.map(function (item) { return item; }).join(',');
	                            }
	                            else
	                                item.value = item.selectedValues.map(function (item) { return item; }).join('###');
	                        }
	                        // call getfromType and formStatus api based on selected projects
	                        if (item.selectedValues.length > 0 && item.name === 'ProjectName') {
	                            var projectIds = this.projects.filter(function (res) { return res.isSelected; }).map(function (ele) { return ele.id; }).join(',');
	                            if (item.selectedValues.includes('{{Current Project}}') && !self.currentProject) {
	                                this.currentProjectSelected = true;
	                            }
	                            else {
	                                this.currentProjectSelected = false;
	                                if (projectIds) {
	                                    var selecteProj = projectIds.split(",");
	                                    selecteProj.forEach(function (part, index, theArray) {
	                                        if (theArray[index] == "0") {
	                                            theArray[index] = self.currentProjectId;
	                                        }
	                                    });
	                                    selecteProj = selecteProj.join(",");
	                                    this.getFormsTypesId(selecteProj);
	                                    this.getFormsStatuses(selecteProj, "");
	                                }
	                            }
	                        }
	                        else if (item.selectedValues.length == 0) {
	                            // empty the Form Name option on change of Project Name
	                            this.formTypes = [];
	                            this.onChangeFormType(this.parameters);
	                        }
	                    };
	                    this.multiSelectToggled = function (item) {
	                        var modalElement = $('.api-connection-modal');
	                        // make scroll hidden when multi dropdown open
	                        if (item.isOpen) {
	                            modalElement[0].style.overflowY = "hidden";
	                        }
	                        else {
	                            modalElement[0].style.overflowY = "auto";
	                        }
	                    };
	                    this.onChangeFieldValue = function (item, param, index) {
	                        var filteredData = this.optionalFields.find(function (response) {
	                            return response.name === item;
	                        });
	                        if (filteredData) {
	                            this.parameters[index] = angular.copy(filteredData);
	                            this.parameters[index].operator = '==';
	                            delete this.parameters[index].paramId;
	                        }
	                        var mandatoryFalse = this.parameters.filter(function (obj) {
	                            return obj.mandatory == false;
	                        });
	                        if (mandatoryFalse) {
	                            for (var j = 0; j < this.optionalFields.length; j++) {
	                                for (var i = 0; i < mandatoryFalse.length; i++) {
	                                    if (this.optionalFields[j].name == mandatoryFalse[i].name) {
	                                        this.optionalFields[j].isDataSelected = true;
	                                        break;
	                                    }
	                                    else
	                                        this.optionalFields[j].isDataSelected = false;
	                                }
	                            }
	                        }
	                        filteredData.isDataSelected = true;
	                    };
	                    this.openHelpPage = function () {
	                        this.$window.open(window.properties.service.helpUrl);
	                    };
	                    this.showDatepicker = function ($event) {
	                        var myElem = angular.element($event.currentTarget.previousElementSibling);
	                        if (myElem.length > 0) {
	                            myElem.datetimepicker('show');
	                        }
	                    };
	                    this.getDatePickerOptions = function (properties) {
	                        return this.datePickerOptions;
	                    };
	                    this.timePickerOptions = {
	                        showMeridian: true,
	                    };
	                    this.getParsedDate = function (param) {
	                        var dateTimeFormat = self.Util.getNewDateFormat('default');
	                        var itemVal = param.value;
	                        itemVal = moment(itemVal, dateTimeFormat).toDate();
	                        if (itemVal == 'Invalid Date') {
	                            param.value = '';
	                        }
	                    };
	                    this.datePickerOptions = {
	                        format: self.Util.getNewDateFormat('default'),
	                        showClear: true,
	                        showClose: true,
	                        showTodayButton: true,
	                        sideBySide: true,
	                        keepOpen: false,
	                        useCurrent: false,
	                        toolbarPlacement: "bottom",
	                        locale: window.navigator.language.split('_')[0],
	                        icons: {
	                            close: 'closeText',
	                            clear: 'clearText',
	                            today: 'todayText'
	                        }
	                    };
	                    this.addAppendUrlValue = function (selectedVal) {
	                        if (angular.isObject(selectedVal)) {
	                            var appendValue = '{{' + selectedVal.value + '}}';
	                            this.objParam.url = this.objParam.url ? this.objParam.url + appendValue : appendValue;
	                        }
	                        else {
	                            var appendValue = selectedVal;
	                            this.objParam.url = this.objParam.url ? this.objParam.url + appendValue : appendValue;
	                        }
	                        this.appendUrlValue = '';
	                    };
	                    this.isEmpty = function (obj) {
	                        return Object.keys(obj).length == 0;
	                    };
	                }]
	        });
	    };
	    return MainController;
	}());
	exports.MainController = MainController;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('directives.apiconnection', [])
	    .component('apiconnection', {
	    template: __webpack_require__(291),
	    controller: MainController,
	    bindings: {
	        apiConnectionClosed: '&apiConnectionClosed'
	    }
	})
	    .name;


/***/ }),
/* 291 */
/***/ (function(module, exports) {

	module.exports = "<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.openAPIConfigurationDialog()\" title=\"API Configurations\" >\n    <i class=\"fa fa-ellipsis-v\"></i>&nbsp;\n</button>\n<script type=\"text/ng-template\" id=\"apiConnections.html\">\n<div class=\"modal-header\">\n    <h3 class=\"modal-title\" ng-if=\"!$apictrl.showAddConnectionForm\">API Connection</h3>\n    <h3 class=\"modal-title\" ng-if=\"$apictrl.showAddConnectionForm && !$apictrl.objParam.apiId\">Create API Connection</h3>\n    <h3 class=\"modal-title\" ng-if=\"$apictrl.showAddConnectionForm && $apictrl.objParam.apiId\">Edit API Connection</h3>\n    <div class=\"pull-right\">\n        <span ng-if=\"!$apictrl.showAddConnectionForm && $apictrl.connectionLists.length > 0\" class=\"add-link\">\n            <!-- <a href=\"javascript:void(0)\" class=\"add-link\" ng-click=\"$apictrl.addConnection()\">Add Connection +</a> -->\n            <button class=\"btn btn-danger\" type=\"button\" ng-click=\"$apictrl.addConnection()\" translate=\"Add Connection\">Add Connection</button>\n        </span>\n        <span class=\"icon\" ng-click=\"$apictrl.openHelpPage()\">\n            <i class=\"fa fa-question-circle\"></i>\n        </span>\n        <span class=\"icon\" ng-click=\"$apictrl.dismiss()\">\n            <i class=\"fa fa-remove\"></i>\n        </span>\n    </div>\n</div>\n<div class=\"modal-body api-connection-modal\" ng-if=\"!$apictrl.showAddConnectionForm\" ng-class=\"{'loading': $apictrl.showSpinner }\">\n    <div class=\"no-connection\" ng-if=\"!$apictrl.showSpinner && $apictrl.connectionLists.length <=0\">\n        <h4>No API Connection available</h4>\n        <!-- <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard</p> -->\n        <div>\n            <img class=\"image-control\"  src=\"assets/images/Wavy_Tech.png\"/>\n        </div>\n        <button class=\"btn btn-danger\" type=\"button\" ng-click=\"$apictrl.addConnection()\" translate=\"Add Connection\">Add Connection</button>\n    </div>\n    <div class=\"connection-lists\" ng-if=\"!$apictrl.showSpinner && $apictrl.connectionLists.length > 0\">\n        <table class=\"table\">\n            <tr>\n                <th>\n                    Connection Name\n                </th>\n                <th>\n                    Connection Status\n                </th>\n                <th>\n                    Connection Type\n                </th>\n                <th>\n                </th>\n                \n            </tr>\n            <tr ng-repeat=\"(i,connection) in $apictrl.connectionLists track by $index\">\n                <td class=\"api-title\" title={{connection.name}}>{{connection.name}}</td>\n                <td>{{connection.status}}</td>\n                <td>{{connection.externalApi ? 'External' : 'Internal'}}</td>\n                <td class=\"icons\">\n                    <a href=\"javascript:void(0)\" title=\"{{ 'edit' | translate }}\" ng-click=\"$apictrl.editConnection(connection)\">\n                        <img class=\"image-control\"  src=\"assets/images/edit.png\"/>\n                    </a>&nbsp;\n                    <a href=\"javascript:void(0)\" class=\"console\" title=\"{{ 'Test Run' | translate }}\" ng-click=\"$apictrl.testConnection(connection)\">\n                        <img class=\"image-control\"  src=\"assets/images/console.png\"/>\n                    </a>\n                    <span class=\"btn-group\" uib-dropdown keyboard-nav>\n                        <a href=\"javascript:void(0)\" class=\"btn dropdown-toggle-btn\" uib-dropdown-toggle>\n                            <img class=\"image-control\"  src=\"assets/images/fi_more-vertical.png\"/>\n                        </a>\n                        <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"split-buttonv\">\n                            <!-- <li role=\"menuitem\">\n                                <a href=\"#\" ng-click=\"$apictrl.copy(connection)\">  <i class=\"fa fa-file-text\"></i>&nbsp;Reference</a>\n                            </li> -->\n                            <li role=\"menuitem\">\n                                <a href=\"#\" ng-click=\"$apictrl.copy(connection)\">  <i class=\"fa fa-copy\"></i>&nbsp;Copy</a>\n                            </li>\n                            <li role=\"menuitem\">\n                                <a href=\"#\" ng-click=\"$apictrl.remove(connection)\"> <i class=\"fa fa-close\"></i>&nbsp;Remove</a>\n                            </li>\n                        </ul>\n                </td>\n            </tr>\n        </table>\n    </div>\n</div>\n<div ng-if=\"$apictrl.showAddConnectionForm\" class=\"container\">\n    <div ng-if=\"$apictrl.selectedStep > 1\">   \n        <h4 class=\"title\">{{$apictrl.objParam.name}}</h4>\n    </div>\n    <div>\n        <stepper current-step={{$apictrl.selectedStep}} step-click=\"$apictrl.stepClickHandler(step)\"></stepper>\n    </div>\n    <div ng-if=\"$apictrl.selectedStep === 1\" ng-class=\"{'loading': $apictrl.showSpinner }\">\n        <form name=\"frm\" method=\"post\"\n                novalidate autocomplete=\"off\" ng-if=\"!$apictrl.showSpinner\" class=\"filters\">\n        <div class=\"modal-body api-connection-modal\">\n            <div>\n                <div class=\"form-group\">\n                    <label for=\"inputName\" translate=\"name\">Name</label>\n                    <input autofocus type=\"text\"  class=\"form-control\" id=\"inputName\" name=\"name\" ng-model=\"$apictrl.objParam.name\" required\n                    maxlength=\"100\" ng-blur=\"$apictrl.isAlreadyExists($apictrl.objParam.name, $apictrl.objParam.apiId)\" ng-change=\"$apictrl.check($apictrl.objParam.name)\" ng-class=\"{'required': $apictrl.isDuplicate || $apictrl.specialCharacter}\">                    \n                    <div class=\"text-danger\" ng-messages=\"frm.name.$error\" ng-if='frm.name.$touched &&frm.name.$invalid' ng-cloak>\n                        <div ng-message=\"required\" ng-if=\"frm.name.$invalid && !frm.name.$error.duplicate\">Please enter valid API Name</div>\n                    </div>\n                    <div class=\"text-danger\" ng-messages=\"frm.name.$error\" ng-message=\"required\" ng-if='$apictrl.isDuplicate'>Duplicate API Name</div>\n                    <div class=\"text-danger\" ng-messages=\"frm.name.$error\" ng-message=\"required\" ng-if='$apictrl.specialCharacter'>API Name cannot contain any of the following characters: # \\\\ / : * ? \" < > | $ ~ ! @ {}</div>\n                </div>\n                <div class=\"form-group\">\n                    <div class=\"form-inline api-field\">\n                        <label for=\"inputName\" translate=\"API Link\">API Link</label>\n                        <div class=\"toggle-button\">\n                            <label for=\"External API\" translate=\"External API\" style=\"vertical-align: bottom;\">External API</label>\n                                <fieldset class=\"btn-switch\"\n                                ng-class=\"{'btn-switch--on':$apictrl.objParam.externalApi}\"\n                                title=\"External API\"\n                                ng-model=\"$apictrl.objParam.externalApi\"\n                                ng-click=\"$apictrl.onToggle();\"\n                                >\n                            <div class=\"btn-switch-circle\" ng-class=\"{'btn-switch-circle--on':$apictrl.objParam.externalApi}\"\n                                ng-model=\"$apictrl.objParam.externalApi\"></div>\n    \n                            </fieldset>\n                        </div>\n                    </div>\n                    <div class=\"form-inline\" ng-if=\"!$apictrl.objParam.externalApi\">\n                        <select \n                            class=\"form-control api-select\"\n                            ng-model=\"$apictrl.objParam.asiteApiId\"\n                            name=\"asiteApiId\" \n                            required=\"!$apictrl.objParam.externalApi\"\n                            ng-options=\"i.asiteApiId as i.name for i in $apictrl.apiData\"\n                            ng-change=\"$apictrl.changeAsiteApi()\"> \n                            <option value=\"\" disable>Please Select</option>\n                        </select>\n                        <div class=\"text-danger\" ng-messages=\"frm.asiteApiId.$error\" ng-if='frm.asiteApiId.$touched &&frm.asiteApiId.$invalid' ng-cloak>\n                            <div ng-message=\"required\">Please select API Name</div>\n                        </div>\n                    </div>\n                </div>\n                <div ng-if=\"$apictrl.objParam.externalApi\">\n                    <div class=\"form-group\">\n                        <div class=\"form-inline\">\n                            <span class=\"externalMethod\">\n                                <select class=\"form-control api-methods\" name=\"requestType\" ng-model=\"$apictrl.objParam.requestType\" required>\n                                    <option ng-repeat=\"item in $apictrl.externalApiMethods\">{{item.key}}</option>\n                                </select>\n                            </span>\n                            <span class=\"externalUrl\">\n                                <input style=\"width: 100%;\" type=\"url\" placeholder=\"Enter request URL\" ng-model=\"$apictrl.objParam.url\" class=\"form-control\" id=\"inputName\" name=\"url\"  required=\"required\" >\n                            </span>\n                            <div class=\"text-danger\" ng-messages=\"frm.requestType.$error\" ng-if='frm.requestType.$touched &&frm.requestType.$invalid' ng-cloak>\n                                <div ng-message=\"required\">Please select Request Type</div>\n                            </div>\n                            <div class=\"text-danger\" ng-messages=\"frm.url.$error\" ng-if='frm.url.$touched &&frm.url.$invalid' ng-cloak>\n                                <div ng-message=\"required\">Please enter valid URL</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"auto-complete\">\n                        <div class=\"form-group auto-complete\">\n                            <span class=\"form-inline form-group auto-complete\" style=\"width:20%\">\n                            <label for=\"Append Url\" translate=\"Append Url\">Append Url</label>\n                            <input autofocus type=\"text\" class=\"form-control\" ng-model=\"$apictrl.appendUrlValue\" typeahead-no-results=\"noResults\"  typeahead-min-length=\"0\" uib-typeahead=\"option as option.key for option in $apictrl.controlDataFieldNames\" >\n                            <i class=\"fa fa-remove\" id=\"addfieldremove\" ng-if=\"$ctrl.isObject($apictrl.appendUrlValue)\" ng-click=\"$apictrl.appendUrlValue = '';\"></i>\n\t\t\t\t\t\t\t<p class=\"note\" ng-show=\"noResults\" translate=\"no.results.found\">No Results Found.</p>\n                            </span>\n                            <span>\n                                <a href=\"javascript:void(0)\" title=\"add append url\" ng-click=\"$apictrl.addAppendUrlValue($apictrl.appendUrlValue)\">\n                                    <img class=\"image-control\"  src=\"assets/images/fi_plus.png\"/>\n                                </a>\n                            </span>                            \n                        </div>\n                    </div>\n                    <div class=\"form-group\" ng-if=\"$apictrl.objParam.externalApi\">\n                        <label style=\"display: inline-flex; align-items: center; cursor: pointer; gap: 8px;\">\n                            <span translate=\"OAuth\">OAuth</span>\n                            <input type=\"checkbox\" ng-model=\"$apictrl.authType\" ng-true-value=\"{{$apictrl.AuthType.OAuth}}\" ng-false-value=\"{{$apictrl.AuthType.None}}\" ng-change=\"$apictrl.onAuthenticationChange($apictrl.authType !== $apictrl.AuthType.None)\" style=\"margin-top: 1px;\">\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"$apictrl.showTestRunmsg\"><span>Connection Established successfully</span></div>\n                <div class=\"form-group\">\n                    <label for=\"inputDesc\" translate=\"description\">Description</label>\n                    <textarea class=\"form-control\" id=\"inputDesc\" rows=\"4\" ng-model=\"$apictrl.objParam.description\"></textarea>\n                </div>\n            </div>\n        </div>\n        <div class=\"modal-footer\">\n            <button class=\"btn btn-default\" type=\"button\" ng-click=\"$apictrl.cancel()\" translate=\"cancel\">Cancel</button>\n            <button class=\"btn btn-danger\" type=\"button\" ng-click=\"$apictrl.next()\" translate=\"Next\" ng-disabled=\"frm.$invalid || $apictrl.isDuplicate\">Next</button>\n        </div>\n    </form>\n    </div>\n    <div ng-if=\"$apictrl.selectedStep === 2\" ng-class=\"{'loading': $apictrl.showSpinner }\">\n        <div style=\"text-align: right;padding: 0 15px;\">\n            <span ng-if=\"!$apictrl.objParam.hasOldDelimiter\">Please use \"###\" as separator for filtering mulitple values</span>\n            <span ng-if=\"$apictrl.objParam.hasOldDelimiter\">Please use \",\" (comma) as separator for filtering mulitple values</span>\n        </div>\n        <form name=\"parametersForm\" class=\"tab-form filters\">\n            <div class=\"modal-body api-connection-modal\">\n                <div ng-if=\"!$apictrl.objParam.externalApi\">\n                    <div class=\"mapping\">\n                        <fieldset class=\"box\">\n                            <table class=\"table filters\" style=\"table-layout: fixed;\" >\n                                <tr>\n                                    <td class=\"icon\" style=\"width: 5%;\">\n                                    </td>\n                                    <td>\n                                        Field\n                                    </td>\n                                    <td style=\"width: 10%;\">\n                                        Operator\n                                    </td>\n                                    <td>\n                                        Value\n                                    </td>\n                                    <td class=\"icon\" style=\"width: 5%;\">\n                                    </td>\n                                </tr>\n                                <tr ng-repeat=\"param in $apictrl.parameters track by $index\" ng-if=\"!param.hidden\">\n                                    <td class=\"icon\">\n                                        <a href=\"javascript:void(0)\" ng-if=\"(!param.mandatory || param.mandatory == false)\" title=\"remove\" ng-click=\"$apictrl.parameters.length > 1 && $apictrl.removeFilter(param)\">\n                                            <img class=\"image-control\"  src=\"assets/images/fi_x.png\"/>\n                                        </a>\n                                    </td>\n                                    <td ng-show=\"param.mandatory == true\">\n                                        <input ng-disabled=\"param.mandatory == true\" autofocus type=\"text\" value=\"{{param.displayFieldName}}\"  class=\"form-control\" id=\"inputName\"  ng-model=\"$apictrl.parameters[$index].displayFieldName\" required=\"required\" >\n                                    </td>\n                                    <td ng-show=\"(!param.mandatory || param.mandatory == false)\">\n                                        <select class=\"form-control api-select\" ng-model=\"$apictrl.parameters[$index].name\" \n                                        ng-change=\"$apictrl.onChangeFieldValue($apictrl.parameters[$index].name, param, $index, $apictrl.parameters);\"\n                                        ng-required=\"param.mandatory\"\n                                        >\n                                        <option value=\"\" disable>Please Select</option>    \n                                        <option ng-repeat=\"item in  $apictrl.optionalFields\" value=\"{{item.name}}\" ng-show=\"!item.isDataSelected\">{{item.displayFieldName}}</option>\n                                        </select>\n\n                                    </td>\n                                    <td>\n                                        <select ng-required=\"param.mandatory\" class=\"form-control api-select\" ng-model=\"$apictrl.parameters[$index].operator\" \n                                                ng-init=\"$apictrl.parameters[$index].operator = $apictrl.parameters[$index].operator || options[0].value\"\n                                                ng-options=\"option.value as option.key for option in $apictrl.operatoFieldrArray\" \n                                                ng-disabled=\"$apictrl.objParam.asiteApiId == $apictrl.userSearchApiId || param.name == 'orderBy' || param.name == 'sortBy' || param.name == 'IsDraft' || param.name == 'recordLimit' || param.name == 'ProjectName' || param.name == 'FormName'\">\n                                        </select>\n                                    </td>\n                                    <td>\n                                        <div ng-if=\"param.name == 'ProjectName'\" style=\"width: 100%;\">\n                                            <div style=\"width: 100%;\" data-name=\"{{param.name}}\" class=\"btn-group dropdown filter-dd\" uib-dropdown is-open=\"param.isOpen\" dropdown-append-to-body auto-close=\"outsideClick\" on-toggle=\"$apictrl.multiSelectToggled(param)\">\n                                                \n                                                <button  style=\"width: 100%;text-align: left;\" ng-style=\"$apictrl.getIndividualStyleObj(item.properties, 'ControlStyle')\"\n                                                class=\"btn btn-default dropdown-toggle\" ng-class=\"{'required': param.mandatory && param.selectedValues.length == 0}\" type=\"button\" uib-dropdown-toggle ng-click=\"$apictrl.onMultiDropdownToggle(param, $event);\">\n                                                <span ng-if=\"param.selectedValues.length > 0\" style=\"max-width:250px;display: inline-block;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;\">\n                                                        <span ng-repeat=\"list in $apictrl.projects\">\n                                                            <span ng-repeat=\"selectedValue in param.selectedValues track by $index\">\n                                                                <span ng-if=\"selectedValue == list.value\">{{list.value}}<span ng-if=\"param.selectedValues.length > $index + 1\">,</span></span>                            \n                                                            </span>\n                                                        </span>\n                                                    </span>\n                                                    <span ng-if=\"param.selectedValues.length == 0\">Please Select</span>\n                                                    <span class=\"caret\"></span>\n                                                </button>\n                                                <div data-name=\"dd_{{param.name}}\" class=\"dropdown-menu filter-dd-menu\" style=\"z-index: 1500;\" uib-dropdown-menu>\n                                                    <div>\n                                                        <div class=\"inpt-wrap clearfix\">\n                                                            <input type=\"text\" class=\"form-control\" ng-model=\"param.searchText\" ng-keyup=\"$apictrl.updateDropdownPosition(param)\"/>\n                                                            <i class=\"icon-search fa\" ng-click=\"$apictrl.clearMultiDropdownSearch(param)\" ng-class=\"{'fa-search': !param.searchText, 'fa-close': param.searchText}\"></i>\n                                                        </div>\n                                                        <div class=\"link-wrap clearfix\">\n                                                            <a  style=\"cursor: pointer;\" ng-show=\"!item.properties.Basic.searchText\" class=\"pull-left\" ng-click=\"$apictrl.clearMultiDropdown(param);$apictrl.onChangeModelValue(item.uid, item.properties.Basic.ControlType, item.properties.Basic['Data Field Name'].selectedValue, item.properties.Basic.Value.selectedValue);\">{{ 'clear' | translate }}</a>\n                                                            <a style=\"cursor: pointer;\" ng-show=\"!item.properties.Basic.searchText\" class=\"pull-right\" ng-click=\"$apictrl.closeMultiDropdown(param)\">{{ 'close' | translate }}</a>\n                                                            <a style=\"margin-left:15%; cursor: pointer;\" ng-show=\"param.searchText && !param.isLimited\" ng-click=\"$apictrl.showAll(param)\">{{ 'show-all' | translate }}</a>\n                                                        </div>\n                                                        <ul class=\"opt-list\">\n                                                            <li ng-if=\"!param.isLimited\" ng-repeat=\"list in $apictrl.projects | filter: param.searchText | limitTo: 10\"><a ng-style=\"$apictrl.getIndividualStyleObj(item.properties, 'ControlStyle')\" href=\"javascript:void(0)\" ng-class=\"{checked: list.isSelected}\" ng-click=\"$apictrl.setMultiDDSelection(param,list);$apictrl.setDropDownOption(param);\" title=\"{{list.value}}\"> <span>{{list.value}}</span></a></li>\n                                                            <li ng-if=\"param.isLimited\" ng-repeat=\"list in $apictrl.projects | filter: param.searchText\"><a ng-style=\"$apictrl.getIndividualStyleObj(item.properties, 'ControlStyle')\" href=\"javascript:void(0)\" ng-class=\"{checked: list.isSelected}\" ng-click=\"$apictrl.setMultiDDSelection(param,list);$apictrl.setDropDownOption(param);\" title=\"{{list.value}}\"><span>{{list.value}}</span></a></li>\n                                                        </ul>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div ng-if=\"param.name == 'FormName' && !$apictrl.currentProjectSelected\">\n                                            <select ng-required=\"param.mandatory\" \n                                            class=\"form-control api-select\" \n                                            ng-model=\"$apictrl.parameters[$index].value\" \n                                            ng-change=\"$apictrl.onChangeFormType($apictrl.parameters);\">\n                                                <option value=\"\" disable>Please Select</option>\n                                                <option value={{item.formTypeName}} ng-repeat=\"item in  $apictrl.formTypes\">{{item.formTypeName}}</option>\n                                            </select>\n                                        </div>\n\n                                        <div ng-if=\"param.name == 'fetchUsersTypeId' && !$apictrl.currentProjectSelected\">\n                                            <select class=\"form-control api-select\" \n                                            ng-model=\"$apictrl.parameters[$index].value\" >\n                                                <option value=\"\" disable>Please Select</option>\n                                                <option value={{item.value}} ng-repeat=\"item in  $apictrl.fetchUsersTypeId\">{{item.key}}</option>\n                                            </select>\n                                        </div>\n                                        \n                                        <div ng-if=\"param.name == 'isActive'\">\n                                            <select class=\"form-control api-select\" \n                                            ng-model=\"$apictrl.parameters[$index].value\" ng-init=\"$apictrl.parameters[$index].value = $apictrl.parameters[$index].value || $apictrl.formSearchIsActive[0].value\">\n                                                <option value={{item.value}} ng-repeat=\"item in  $apictrl.formSearchIsActive\">{{item.key}}</option>\n                                            </select>\n                                        </div>\n                                        \n                                        <div ng-if=\"param.name == 'IsDraft'\">\n                                            <select class=\"form-control api-select\" \n                                            ng-model=\"$apictrl.parameters[$index].value\" ng-init=\"$apictrl.parameters[$index].value = $apictrl.parameters[$index].value || $apictrl.multiValueParameters.IsDraft[0].value\">\n                                                <option value={{item.value}} ng-repeat=\"item in  $apictrl.multiValueParameters.IsDraft\">{{item.key}}</option>\n                                            </select>\n                                        </div>\n\n                                        <div ng-if=\"param.name == 'orderBy'\">\n                                            <select class=\"form-control api-select\" \n                                            ng-model=\"$apictrl.parameters[$index].value\" ng-init=\"$apictrl.parameters[$index].value = $apictrl.parameters[$index].value || $apictrl.multiValueParameters.orderBy[0].value\">\n                                                <option value={{item.value}} ng-repeat=\"item in  $apictrl.multiValueParameters.orderBy\">{{item.key}}</option>\n                                            </select>\n                                        </div>\n\n                                        <div ng-if=\"param.name == 'sortBy'\">\n                                            <select class=\"form-control api-select\" \n                                            ng-model=\"$apictrl.parameters[$index].value\" ng-init=\"$apictrl.parameters[$index].value = $apictrl.parameters[$index].value || $apictrl.multiValueParameters.sortBy[0].value\">\n                                                <option value={{item.value}} ng-repeat=\"item in  $apictrl.multiValueParameters.sortBy\">{{item.key}}</option>\n                                            </select>\n                                        </div>\n                                        \n                                        <div ng-if=\"param.name == 'projectId' && !$apictrl.currentProjectSelected\">\n                                            <select ng-required=\"param.mandatory\" class=\"form-control api-select\" ng-model=\"$apictrl.parameters[$index].value\">\n                                                <option value=\"\" disable>Please Select</option>\n                                                <option value={{item.id}} ng-repeat=\"item in  $apictrl.projects\">{{item.value}}</option>\n                                            </select>\n                                        </div>\n                                        <div class=\"auto-complete\" ng-if=\"((param.name != 'projectId' && param.name !='ProjectName' && param.name !='FormName' && param.name != 'FormStatus' && param.dataType != 'date' && param.name != 'fetchUsersTypeId' && param.name != 'isActive' && param.name != 'orderBy' && param.name != 'sortBy' && param.name != 'IsDraft') || ($apictrl.currentProjectSelected && (param.name =='FormName' || param.name == 'FormStatus')))\">\n                                            <input autofocus type=\"text\" class=\"form-control\" ng-model=\"$apictrl.parameters[$index].value\" typeahead-no-results=\"noResults\" typeahead-on-select=\"$apictrl.setDataType($apictrl.parameters[$index])\" typeahead-min-length=\"0\" uib-typeahead=\"option.value for option in $apictrl.controlDataFieldNames | filter:$viewValue\" >\n                                            <i class=\"fa fa-remove\" ng-if=\"$apictrl.isObject($apictrl.listFilters[$index].fieldValue)\" ng-click=\"$apictrl.listFilters[$index].fieldValue = '';\"></i>\n                                        </div>\n                                        <div ng-if=\"param.name == 'FormStatus' && !$apictrl.currentProjectSelected\" style=\"width: 100%;\">\n                                            <div style=\"width: 100%;\" data-name=\"{{param.name}}\" class=\"btn-group dropdown filter-dd\" uib-dropdown is-open=\"param.isOpen\" dropdown-append-to-body auto-close=\"outsideClick\" on-toggle=\"$apictrl.multiSelectToggled(param)\">\n                                                \n                                                <button  style=\"width: 100%;text-align: left;\"ng-style=\"$apictrl.getIndividualStyleObj(item.properties, 'ControlStyle')\"\n                                                class=\"btn btn-default dropdown-toggle\" type=\"button\" uib-dropdown-toggle ng-click=\"$apictrl.onMultiDropdownToggle(param, $event)\">\n                                                <span ng-if=\"param.selectedValues.length > 0\" style=\"max-width:250px;display: inline-block;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;\">\n                                                        <span ng-repeat=\"list in $apictrl.formStatuses\">\n                                                            <span ng-repeat=\"selectedValue in param.selectedValues track by $index\">\n                                                                <span ng-if=\"selectedValue == list.value\">{{list.value}}<span ng-if=\"param.selectedValues.length > $index + 1\">,</span></span>                            \n                                                            </span>\n                                                        </span>\n                                                    </span>\n                                                    <span ng-if=\"param.selectedValues.length == 0\">Please Select</span>\n                                                    <span class=\"caret\"></span>\n                                                </button>\n                                                <div data-name=\"dd_{{param.name}}\" class=\"dropdown-menu filter-dd-menu\" style=\"z-index: 1500;\" uib-dropdown-menu>\n                                                    <div>\n                                                        <div class=\"inpt-wrap clearfix\">\n                                                            <input type=\"text\" class=\"form-control\" ng-model=\"param.searchText\" ng-keyup=\"$apictrl.updateDropdownPosition(param)\"/>\n                                                            <i class=\"icon-search fa\" ng-click=\"$apictrl.clearMultiDropdownSearch(param)\" ng-class=\"{'fa-search': !param.searchText, 'fa-close': param.searchText}\"></i>\n                                                        </div>\n                                                        <div class=\"link-wrap clearfix\">\n                                                            <a  style=\"cursor: pointer;\" ng-show=\"!item.properties.Basic.searchText\" class=\"pull-left\" ng-click=\"$apictrl.clearMultiDropdown(param);$apictrl.onChangeModelValue(item.uid, item.properties.Basic.ControlType, item.properties.Basic['Data Field Name'].selectedValue, item.properties.Basic.Value.selectedValue);\">{{ 'clear' | translate }}</a>\n                                                            <a style=\"cursor: pointer;\" ng-show=\"!item.properties.Basic.searchText\" class=\"pull-right\" ng-click=\"$apictrl.closeMultiDropdown(param)\">{{ 'close' | translate }}</a>\n                                                            <a style=\"margin-left:15%; cursor: pointer;\" ng-show=\"param.searchText && !param.isLimited\" ng-click=\"$apictrl.showAll(param)\">{{ 'show-all' | translate }}</a>\n                                                        </div>\n                                                        <ul class=\"opt-list\">\n                                                            <li ng-if=\"!param.isLimited\" ng-repeat=\"list in $apictrl.formStatuses | filter: param.searchText | limitTo: 10\"><a ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\" href=\"javascript:void(0)\" ng-class=\"{checked: list.isSelected}\" ng-click=\"$apictrl.setMultiDDSelection(param,list);$apictrl.setDropDownOption(item); $apictrl.onChangeModelValue(param.uid, item.properties.Basic.ControlType, item.properties.Basic['Data Field Name'].selectedValue, item.properties.Basic.Value.selectedValue);\" title=\"{{list.value}}\"> <span>{{list.value}}</span></a></li>\n                                                            <li ng-if=\"param.isLimited\" ng-repeat=\"list in $apictrl.formStatuses | filter: param.searchText\"><a ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\" href=\"javascript:void(0)\" ng-class=\"{checked: list.isSelected}\" ng-click=\"$apictrl.setMultiDDSelection(param,list);$apictrl.setDropDownOption(item); $apictrl.onChangeModelValue(item.uid, item.properties.Basic.ControlType, item.properties.Basic['Data Field Name'].selectedValue, item.properties.Basic.Value.selectedValue);\" title=\"{{list.value}}\"><span>{{list.value}}</span></a></li>\n                                                        </ul>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div class=\"autofocus a-date-picker date-picker-wrapper\" type=\"Datepicker\" ng-if=\"(param.dataType == 'date')\">\n                                            <input  picker-id=\"{{param.name}}\" type=\"text\" id=\"dt1\" class=\"form-control\" ng-model=\"$apictrl.parameters[$index].value\"\n                                                title=\"{{param.properties.Advance.Tooltip.selectedValue}}\"  \n                                                datetimepicker datetimepicker-options=\"$apictrl.datePickerOptions\"\n                                                ng-change=\"$apictrl.getParsedDate($apictrl.parameters[$index]);\"\n                                                name=\"time\"\n                                                >\n                                            <i class=\"fa fa-calendar\" style=\"cursor: pointer\" ng-click=\"$apictrl.showDatepicker($event)\"></i>\n                                        </div>\n                                        </td>\n                                    <td colspan=\"1\" class=\"icon\">\n                                        <a href=\"javascript:void(0)\" title=\"add\" ng-if=\"$apictrl.objParam.asiteApiId != $apictrl.userSearchApiId\" ng-click=\"$apictrl.addNewFilter()\">\n                                            <img class=\"image-control\"  src=\"assets/images/fi_plus.png\"/>\n                                        </a>\n                                    </td>\n                                </tr>\n                            </table>\n                    </fieldset>\n                    </div>\n                    <fieldset class=\"box\" style=\"margin-top: 25px;\" ng-if=\"!$apictrl.objParam.externalApi\">  \n                        <div style=\"padding:20px;\">\n                            <div class=\"filter-rule\" ng-repeat=\"(i,paras) in $apictrl.parameters | filter: param.hidden\">\n                                <div ng-if=\"!$apictrl.parameters[i].hidden\">\n                                    <span style=\"color:green\">{{$apictrl.parameters[i].displayFieldName}}</span>\n                                    <span>{{$apictrl.parameters[i].operator}}</span>\n                                    <span ng-if=\"!$apictrl.parameters[i].selectedValues\">'{{$apictrl.parameters[i].value}}'</span>\n                                    <span ng-if=\"$apictrl.parameters[i].selectedValues && $apictrl.parameters[i].selectedValues.length > 0\">\n                                        '<span ng-repeat=\"item in $apictrl.parameters[i].selectedValues\">{{item}}\n                                            <span ng-if=\"$apictrl.parameters[i].selectedValues.length > $index + 1\">,</span>\n                                        </span>'                            \n                                    </span>\n                                    <span ng-if=\"$apictrl.parameters.length > i+1 && !$apictrl.parameters[i].hidden\">AND</span>\n                                </div>\n                            </div>\n                        </div>\n                    </fieldset>\n                </div>\n                <div class=\"external-api-data\" ng-if=\"$apictrl.objParam.externalApi\">\n                    <div>\n                            <uib-tabset active=\"activeForm\">\n                            <uib-tab index=\"0\" heading=\"Params\">\n                                \n                                <table class=\"table\" style=\"table-layout: fixed;\" >\n                                    <tr>\n                                        <td class=\"header-width\">\n                                        </td>\n                                        <td>\n                                            KEY\n                                        </td>\n                                        <td>\n                                            VALUE\n                                        </td>\n                                        <td class=\"icon header-width\">\n                                        </td>\n                                    </tr>\n                                    <tr ng-repeat=\"item in $apictrl.externapAPIData.params track by $index\">\n                                        <td class=\"icon\">\n                                            <a href=\"javascript:void(0)\" title=\"remove\" ng-click=\"$apictrl.removeParams(item)\" ng-if=\"$apictrl.externapAPIData.params.length > 1\">\n                                                <img class=\"image-control\"  src=\"assets/images/fi_x.png\"/>\n                                            </a>\n                                        </td>\n                                        <td>\n                                            <input autofocus type=\"text\"  class=\"form-control\" id=\"inputName\" name=\"$apictrl.externapAPIData.params[$index].name\" ng-model=\"$apictrl.externapAPIData.params[$index].name\" >\n                                        </td>\n                                        <td>\n                                            <input autofocus type=\"text\" class=\"form-control\" ng-model=\"$apictrl.externapAPIData.params[$index].value\" typeahead-no-results=\"noResults\" typeahead-on-select=\"$apictrl.setDataType($apictrl.externapAPIData.params[$index])\" typeahead-min-length=\"0\" uib-typeahead=\"option.value for option in $apictrl.controlDataFieldNames | filter:$viewValue\" >\n                                            <i class=\"fa fa-remove\" ng-if=\"$apictrl.isObject($apictrl.listFilters[i].fieldValue)\" ng-click=\"$apictrl.listFilters[i].fieldValue = '';\"></i>\n                                        </td>\n                                        <td colspan=\"1\" class=\"icon\">\n                                            <a href=\"javascript:void(0)\" title=\"add\" ng-click=\"$apictrl.addNewParams()\">\n                                                <img class=\"image-control\"  src=\"assets/images/fi_plus.png\"/>\n                                            </a>\n                                        </td>\n                                    </tr>\n                                </table>\n                            </uib-tab>\n                            <uib-tab index=\"1\" heading=\"Headers\">\n                                <table class=\"table\" style=\"table-layout: fixed;\" >\n                                    <tr>\n                                        <td class=\"icon header-width\">\n                                        </td>\n                                        <td>\n                                            KEY\n                                        </td>\n                                        <td>\n                                            VALUE\n                                        </td>\n                                        <td class=\"icon header-width\">\n                                        </td>\n                                    </tr>\n                                    <tr ng-repeat=\"item in $apictrl.externapAPIData.headers track by $index\">\n                                        <td class=\"icon\">\n                                            <a href=\"javascript:void(0)\" title=\"remove\" ng-click=\"$apictrl.removeHeaders(item)\" ng-if=\"$apictrl.externapAPIData.headers.length > 1\">\n                                                <img class=\"image-control\"  src=\"assets/images/fi_x.png\"/>\n                                            </a>\n                                        </td>\n                                        <td>\n                                            <input autofocus type=\"text\"  class=\"form-control\" id=\"inputName\" name=\"$apictrl.externapAPIData.headers[$index].name\" ng-model=\"$apictrl.externapAPIData.headers[$index].name\" >\n                                        </td>\n                                        <td>\n                                            <input autofocus type=\"text\" class=\"form-control\" ng-model=\"$apictrl.externapAPIData.headers[$index].value\" typeahead-on-select=\"$apictrl.setDataType($apictrl.externapAPIData.headers[$index])\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\"  uib-typeahead=\"option.value for option in $apictrl.controlDataFieldNames | filter:$viewValue\" >\n                                            <i class=\"fa fa-remove\" ng-if=\"$apictrl.isObject($apictrl.listFilters[i].fieldValue)\" ng-click=\"$apictrl.listFilters[i].fieldValue = ''\"></i>\n                                        </td>\n                                        <td colspan=\"1\" class=\"icon\">\n                                            <a href=\"javascript:void(0)\" title=\"add\" ng-click=\"$apictrl.addNewHeaders()\">\n                                                <img class=\"image-control\"  src=\"assets/images/fi_plus.png\"/>\n                                            </a>\n                                        </td>\n                                    </tr>\n                                </table>\n                            </uib-tab>\n                            <uib-tab index=\"2\" heading=\"Body\">\n                                <div class=\"form-group\">\n                                    <label for=\"form-data\"><input type=\"radio\" id =\"form-data\" ng-model=\"$apictrl.objParam.bodyParamsType\" value=\"form-data\"/> form-data</label>\n                                    <label for=\"raw\"><input type=\"radio\" id =\"raw\" ng-model=\"$apictrl.objParam.bodyParamsType\" value=\"raw\"/> Raw</label>\n                                    <label for=\"raw\"><input type=\"radio\" id =\"urlencoded\" ng-model=\"$apictrl.objParam.bodyParamsType\" value=\"urlencoded\"/> x-www-form-urlencoded</label>\n                                </div>\n                                <div class=\"form-group\">\n                                    <table class=\"table\" style=\"table-layout: fixed;\" >\n                                        <tr>\n                                            <td class=\"icon header-width\">\n                                            </td>\n                                            <td>\n                                                KEY\n                                            </td>\n                                            <td>\n                                                VALUE\n                                            </td>\n                                            <td class=\"icon header-width\">\n                                            </td>\n                                        </tr>\n                                        <tr ng-repeat=\"item in $apictrl.externapAPIData.bodyParams track by $index\">\n                                            <td class=\"icon\">\n                                                <a href=\"javascript:void(0)\" title=\"remove\" ng-click=\"$apictrl.removeBodyParams(item)\" ng-if=\"$apictrl.externapAPIData.bodyParams.length > 1\">\n                                                    <img class=\"image-control\"  src=\"assets/images/fi_x.png\"/>\n                                                </a>\n                                            </td>\n                                            <td>\n                                                <input autofocus type=\"text\"  class=\"form-control\" id=\"inputName\" name=\"$apictrl.externapAPIData.bodyParams[$index].name\" ng-model=\"$apictrl.externapAPIData.bodyParams[$index].name\" >\n                                            </td>\n                                            <td>\n                                                <input autofocus type=\"text\" class=\"form-control\" ng-model=\"$apictrl.externapAPIData.bodyParams[$index].value\" typeahead-on-select=\"$apictrl.setDataType($apictrl.externapAPIData.bodyParams[$index])\" typeahead-no-results=\"noResults\" typeahead-min-length=\"0\" uib-typeahead=\"option.value for option in $apictrl.controlDataFieldNames | filter:$viewValue\" >\n                                            <i class=\"fa fa-remove\" ng-if=\"$apictrl.isObject($apictrl.listFilters[i].fieldValue)\" ng-click=\"$apictrl.listFilters[i].fieldValue = ''\"></i>\n                                            </td>\n                                            <td colspan=\"1\" class=\"icon\">\n                                                <a href=\"javascript:void(0)\" title=\"add\" ng-click=\"$apictrl.addNewBodyParams()\" ng-if=\"$apictrl.objParam.bodyParamsType!='raw'\">\n                                                    <img class=\"image-control\"  src=\"assets/images/fi_plus.png\"/>\n                                                </a>\n                                            </td>\n                                        </tr>\n                                    </table>\n                                </div>\n                            </uib-tab>\n                            </uib-tabset>\n                        </div>\n                </div>\n            </div>\n            <div class=\"modal-footer\">\n                <button class=\"btn btn-default pull-left\" type=\"button\" ng-click=\"$apictrl.back()\" translate=\"Back\">Back</button>\n                <button class=\"btn btn-default\" type=\"button\" ng-click=\"$apictrl.cancel()\" translate=\"cancel\">Cancel</button>\n                <button class=\"btn btn-danger\" type=\"button\" ng-click=\"$apictrl.next()\" ng-disabled=\"parametersForm.$invalid\" translate=\"Next\">Next</button>\n            </div>\n        </form>\n    </div>\n    <div ng-if=\"$apictrl.selectedStep === 3\" ng-class=\"{'loading': $apictrl.showSpinner }\">\n        <form name=\"stepThird\">\n        <div class=\"modal-body api-connection-modal\">\n            <div ng-if=\"!$apictrl.objParam.externalApi\">\n                <h3>Filters</h3>\n                <span style=\"float: right;\" ng-if=\"!$apictrl.objParam.hasOldDelimiter\">Please use \"###\" as separator for filtering mulitple values</span>\n                <span style=\"float: right;\" ng-if=\"$apictrl.objParam.hasOldDelimiter\">Please use \",\" (comma) as separator for filtering mulitple values</span>\n                <fieldset  class=\"response box\">\n                    <table class=\"table\" style=\"table-layout: fixed;\">\n                        <tr>\n                            <th>\n                                Field\n                            </th>\n                            <th>\n                            Operator\n                            </th>\n                            <th>\n                            Value\n                            </th>\n                        </tr>\n                        <tr  ng-repeat=\"(i,mapping) in $apictrl.testFilters track by $index\" ng-if=\"!mapping.hidden && mapping.name!= 'fetchUsersTypeId'\">\n                            <td class=\"icon\">\n                                {{mapping.displayFieldName}}\n                            </td>\n                            <td>\n                                {{mapping.operator}}\n                            </td>\n                            <td ng-if=\"mapping.name == 'orderBy' || mapping.name == 'sortBy' \">\n                                <div ng-if=\"mapping.name == 'orderBy'\">\n                                    <select class=\"form-control api-select\"\n                                    ng-model=\"$apictrl.testFilters[i].testValue\" ng-disabled=\"true\"> \n                                        <option value={{item.value}} ng-repeat=\"item in  $apictrl.multiValueParameters.orderBy\">{{item.key}}</option>\n                                    </select>\n                                </div>\n                                <div ng-if=\"mapping.name == 'sortBy'\">\n                                    <select class=\"form-control api-select\" \n                                    ng-model=\"$apictrl.testFilters[i].testValue\" ng-disabled=\"true\">\n                                        <option value={{item.value}} ng-repeat=\"item in  $apictrl.multiValueParameters.sortBy\">{{item.key}}</option>\n                                    </select>\n                                </div>\n                            </td>\n                            <td ng-if=\"mapping.name != 'orderBy' && mapping.name != 'sortBy'\">\n                                <input ng-disabled=\"(((mapping.mandatory == 'true' || mapping.name == 'FormStatus' || mapping.name == 'FormName' || mapping.name == 'ProjectName') && !$apictrl.currentProjectSelected) || (mapping.name == 'isActive') || (mapping.name == 'IsDraft') || (mapping.name == 'orderBy') || (mapping.name == 'sortBy'))\" autofocus type=\"text\"  class=\"form-control\" id=\"inputName\" name=\"$apictrl.testFilters[i].testValue\" ng-model=\"$apictrl.testFilters[i].testValue\" required=\"required\" value=\"{{$apictrl.testFilters.params[$index].value}}\">\n                            </td>\n                        </tr>\n                    </table>\n                </fieldset>\n            </div>\n            <div class=\"external-api-data\" ng-if=\"$apictrl.objParam.externalApi\">\n                <h3>Filters</h3>\n                <fieldset class=\"response box\">\n                    <div>\n                        <label for=\"Test API Url\" translate=\"Test API Url\">Test API Url</label>\n                        <input autofocus type=\"text\"  class=\"form-control\" id=\"inputName\" ng-model=\"$apictrl.testFilters.testUrl\" >\n                    </div>\n                    <uib-tabset active=\"activeForm\">\n                        <uib-tab index=\"0\" heading=\"Params\">\n                            <table class=\"table\" style=\"table-layout: fixed;\" ng-show=\"$apictrl.testFilters.params.length > 0\">\n                                <tr>\n                                    <td>\n                                        KEY\n                                    </td>\n                                    <td>\n                                        VALUE\n                                    </td>\n                                </tr>\n                                <tr ng-repeat=\"item in $apictrl.testFilters.params track by $index\">\n                                    <td> \n                                        {{$apictrl.testFilters.params[$index].name}}\n                                    </td>\n                                    <td >\n                                        <input autofocus type=\"text\"  class=\"form-control\" id=\"inputName\" name=\"$apictrl.testFilters.params[$index].testValue\" ng-model=\"$apictrl.testFilters.params[$index].testValue\" value=\"{{$apictrl.testFilters.params[$index].value}}\">\n                                    </td>\n                                </tr>\n                            </table>\n                        </uib-tab>\n                        <uib-tab index=\"1\" heading=\"Headers\">\n                            <table class=\"table\" style=\"table-layout: fixed;\" >\n                                <tr>\n                                    <td>\n                                        KEY\n                                    </td>\n                                    <td>\n                                        VALUE\n                                    </td>\n                                </tr>\n                                <tr ng-repeat=\"item in $apictrl.testFilters.headers track by $index\">\n                                    <td>\n                                        {{$apictrl.testFilters.headers[$index].name}}\n                                    </td>\n                                    <td >\n                                        <input autofocus type=\"text\"  class=\"form-control\" id=\"inputName\" ng-model=\"$apictrl.testFilters.headers[$index].testValue\" required=\"required\" >\n                                    </td>\n                                </tr>\n                            </table>\n                        </uib-tab>\n                        <uib-tab index=\"2\" heading=\"Body\">\n                            <div class=\"form-group\" style=\"10px 0px 20px 0px;\">\n                            bodyParamsType: <span style=\"font-weight:bold\">{{$apictrl.objParam.bodyParamsType}}</span>\n                            </div>\n                            <div class=\"form-group\">\n                                <table class=\"table\" style=\"table-layout: fixed;\" >\n                                    <tr>\n                                        <td>\n                                            KEY\n                                        </td>\n                                        <td>\n                                            VALUE\n                                        </td>\n                                    </tr>\n                                    <tr ng-repeat=\"item in $apictrl.testFilters.bodyParams track by $index\">\n                                        <td>\n                                            {{$apictrl.testFilters.bodyParams[$index].name}}\n                                        </td>\n                                        <td>\n                                            <input autofocus type=\"text\"  class=\"form-control\" id=\"inputName\" ng-model=\"$apictrl.testFilters.bodyParams[$index].testValue\" required=\"required\" >\n                                        </td>\n                                    </tr>\n                                </table>\n                            </div>\n                        </uib-tab>\n                    </uib-tabset>\n                </fieldset>\n            </div>\n            <div class=\"btn-testrun\">\n                <button class=\"btn btn-danger pull-right\" ng-class=\"{'secondary-btn' : !$apictrl.isEmpty($apictrl.testResults) }\" type=\"button\" ng-click=\"$apictrl.testRun()\" ng-disabled=\"stepThird.$invalid\" translate=\"Test Run\">Test Run</button>\n            </div>\n            <fieldset ng-if=\"$apictrl.showTestResult\" style=\"margin-top:15px;\">\n                <div>Results</div>\n                <div style=\"height: 340px;overflow-y: scroll;\">\n                    <pre>{{$apictrl.testResults | json }}</pre>\n                </div>\n            </fieldset>\n        </div>\n        <div class=\"modal-footer\">\n            <button ng-if=\"!$apictrl.isTestConnection\" class=\"btn btn-default pull-left\" type=\"button\" ng-click=\"$apictrl.back()\" translate=\"Back\">Back</button>\n            <button class=\"btn btn-default\" type=\"button\" ng-click=\"$apictrl.cancel()\" translate=\"cancel\">Cancel</button>\n            <button class=\"btn btn-danger\" type=\"button\" ng-click=\"$apictrl.save()\" ng-disabled=\"stepThird.$invalid || ($apictrl.isAuthenticationEnabled() && $apictrl.objParam.status !== 'Established')\" translate=\"Save\" ng-class=\"{'secondary-btn' : $apictrl.testResults.length == 0, 'secondary-btn-rmv' : $apictrl.testResults.length > 0}\">Save</button>\n        </div>\n    </form>\n    </div>\n    \n</div>\n</script>\n<script type=\"text/ng-template\" id=\"warning_before_remove_connection.html\">\n    <div class=\"ui-notification \" style=\"max-height:95vh;overflow: auto;\">\n        <div class=\"message\" ng-bind=\"message | translate\">{{$apictrl.operatoFieldrArray}}</div>\n        <div class=\"message clearfix\">\n            <a class=\"btn btn-sm btn-danger pull-right\" ng-click=\"\">No</a>\n            <a class=\"btn btn-sm btn-danger pull-right\" style=\"margin-right: 8px;\" ng-click=\"$apictrl.removeConnection()\">Yes</a>\n        </div>\n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"warning_before_cancel.html\">\n    <div class=\"ui-notification \" style=\"max-height:95vh;overflow: auto;\">\n        <div class=\"message\" ng-bind=\"message | translate\">{{$apictrl.operatoFieldrArray}}</div>\n        <div class=\"message clearfix\">\n            <a class=\"btn btn-sm btn-danger pull-right\" ng-click=\"\">No</a>\n            <a class=\"btn btn-sm btn-danger pull-right\" style=\"margin-right: 8px;\" ng-click=\"$apictrl.showAddConnectionForm=false;\">Yes</a>\n        </div>\n    </div>\n</script>\n\n<script type=\"text/ng-template\" id=\"warning_before_changeData.html\">\n    <div class=\"ui-notification \" style=\"max-height:95vh;overflow: auto;\">\n        <div class=\"message\" ng-bind=\"message | translate\">{{$apictrl.operatoFieldrArray}}</div>\n        <div class=\"message clearfix\">\n            <a class=\"btn btn-sm btn-danger pull-right\" ng-click=\"\">No</a>\n            <a class=\"btn btn-sm btn-danger pull-right\" style=\"margin-right: 8px;\" ng-click=\"$apictrl.changeAPI()\">Yes</a>\n        </div>\n    </div>\n</script>\n"

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var angular = __webpack_require__(1);
	/**
	 * Filter for search
	 *
	 */
	function searchFilter() {
	    return function (items, searchText) {
	        if (!searchText || searchText == '') {
	            return items;
	        }
	        var filtered = [];
	        //  filter stuff here
	        angular.forEach(items, function (item) {
	            if (item && item.Label) {
	                if (item.Label.name.toLowerCase().indexOf(searchText.toLowerCase()) != -1) {
	                    filtered.push(item);
	                }
	            }
	        });
	        return filtered;
	    };
	}
	exports.searchFilter = searchFilter;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('nodeApp.searchFilter', [])
	    .filter('searchFilter', searchFilter)
	    .name;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var angular = __webpack_require__(1);
	var uiRouter = __webpack_require__(5);
	var dashboard_routes_1 = __webpack_require__(294);
	var DashboardComponent = (function () {
	    /*@ngInject*/
	    function DashboardComponent() {
	    }
	    return DashboardComponent;
	}());
	exports.DashboardComponent = DashboardComponent;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('nodeApp.dashboard', [uiRouter])
	    .config(dashboard_routes_1.default)
	    .component('dashboard', {
	    template: __webpack_require__(295),
	    controller: DashboardComponent,
	    controllerAs: 'dashboardCtrl'
	})
	    .name;


/***/ }),
/* 294 */
/***/ (function(module, exports) {

	'use strict';
	default_1.$inject = ['$stateProvider'];
	function default_1($stateProvider) {
	    'ngInject';
	    $stateProvider
	        .state('dashboard', {
	        url: '/dashboard',
	        template: '<dashboard></dashboard>'
	    });
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;


/***/ }),
/* 295 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid\">\n    <div class=\"row\">\n        <button ui-sref=\"create\" class=\"btn btn-primary col-md-offset-6\">Create</button>\n    </div>\n</div>\n"

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var angular = __webpack_require__(1);
	var ControlProperties = __webpack_require__(297);
	var Props = __webpack_require__(268);
	var uiRouter = __webpack_require__(5);
	var geoTools = __webpack_require__(326);
	var _ = __webpack_require__(23);
	// Angular Drag and drop library (https://github.com/marceljuenemann/angular-drag-and-drop-lists)
	__webpack_require__(327);
	var create_routes_1 = __webpack_require__(328);
	var html_source_component_1 = __webpack_require__(329);
	var action_constants_1 = __webpack_require__(19);
	var moment = __webpack_require__(115);
	window.validate = function () { };
	window.getData = function () { };
	window.noopMethod = function () { };
	window.getPropValue = function (controlName, propName) { };
	window.setPropValue = function (controlName, propName, propValue) { };
	window.getPropValueByDataFieldName = function (controlName) { };
	window.setPropValueByDataFieldName = function (controlName, propValue, uid, force) { };
	window.resetRepeatingTableValue = function (controlName) { };
	window.getDateDifference = function (dateControlName1, dateControlName2) { };
	window.getDateTimeDifference = function (dateTimeControlName1, dateTimeControlName2, dateTimeFormat) { };
	window.addOrSubtractDate = function (dateControlName, operator, days) { };
	window.getSystemFieldValue = function (systemField) { };
	window.compareSystemFieldValue = function (systemField, comparator, value, type) { };
	window.setAutoNumbering = function (autoNumberField, autoNumberLength, autoNumberStartFrom, autoNumberPosition, autoNumberSeparator, autoNumberTitle, isAutoNumbering) { };
	window.globleMethod = function (dateControlName, operator, days) { };
	window.getMinmaxDateValue = function (minmax_datevalue, controlStr) { };
	window.repeatingTableFunctionality = function (functionality, controlName, index, scopeData, IndexValue, showCheck, ReadOnlyCheck) { };
	window.getFormViewDetail = function (projectName, appbuilderID, dp_DOC_ASSOC, dp_ORI_FWD_DOC_ASSOC, dp_FORM_ASSOC, dp_FORM_ASSOC_CURRENT, ds_ATTACH_AUTOASSOCIATE_MSG, dp_ATTACH_ALL_MSG, callbackFn, dp_FORM_ASSOC_ORI, dp_All_FORM_ASSOC_CURRENT, dp_ALL_FORM_ASSOC, dp_DOC_ASSOC_CURRENT, dp_DOC_ASSOC_ALL_MSG, dp_ATTACH_ORI_MSG, dp_ATTACH_CURRENT_MSG) { };
	window.mergeDataFromAPI = function (apiName, callbackFn) { };
	window.locationAssociationCallback = function (callbackFn) { };
	window.getCustomResponse = function (prop, responseData, optionMap, optionMapName) { };
	window.setAlertMsg = function (msgText) { };
	window.checkForExternalAssociations = function (callbackFn) { };
	window.addWorkingDays = function (control_name, dropdown_operator, Days) { };
	window.addWorkingDaysForCustomDate = function (source_field_name, control_name, dropdown_operator, Days) { };
	var CreateComponent = (function () {
	    /*@ngInject*/
	    CreateComponent.$inject = ['localStorage', '$http', '$window', '$stateParams', 'Notification', '$state', '$filter', '$scope', 'Util', '$rootScope', 'config', '$uibModal', '$document', '$anchorScroll', '$location', '$timeout', 'counterService', '$translate'];
	    function CreateComponent(localStorage, $http, $window, $stateParams, Notification, $state, $filter, $scope, Util, $rootScope, config, $uibModal, $document, $anchorScroll, $location, $timeout, counterService, $translate) {
	        this.defaultView = {
	            editing: false,
	            controls: {
	                'A': []
	            },
	            viewName: ''
	        };
	        this.dateOptions = {
	            formatDay: 'dd',
	            formatMonth: 'MMM',
	            formatYear: 'yyyy',
	            showWeeks: false
	        };
	        this.timeFormat = 'HH:mm';
	        this._googleMapsLoadPromise = null;
	        this.savedChanges = true;
	        this.hideSideBar = true;
	        this.printTypeText = '';
	        this.showScrollToTop = false;
	        this.validatorRegEx = {
	            Alphanumeric: /^[\w-\\.\s]+$/,
	            Numeric: /^-?\\d+(\\.\\d+)?$/,
	            Email: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
	            Decimal: /^(-)?(?:\d*\.)?\d+$/,
	            Integer: /^(-)?\d+$/,
	            Letters: /^[a-zA-Z-\\._\s]+$/i
	        };
	        this.numberFormatEnabled = false;
	        this.showFlag = false;
	        this.pasteAsCalculatedWithoutFlag = ['Layout', 'Section', 'Table', 'RepeatingTable'];
	        this.typeWiseDataFieldNameAllowed = {
	            'Attachment': ['Attachment'],
	            'Signature': ['Signature'],
	            'Rich-Text-Box': ['Rich-Text-Box'],
	            'Textbox': ['Textbox', 'Text-Area'],
	            'Text-Area': ['Textbox', 'Text-Area'],
	            'Map': ['Map'],
	            'Dropdown': ['Dropdown'],
	            'Datepicker': ['Datepicker'],
	            'Checkbox': ['Checkbox'],
	            'Radio': ['Radio'],
	            'ToggleButton': ['ToggleButton'],
	            'MultiDropdown': ['MultiDropdown'],
	            'Timepicker': ['Timepicker'],
	            'InlineAssocFiles': ['InlineAssocFiles'],
	            'InlineAssocApps': ['InlineAssocApps'],
	            'ViewAssociations': ['ViewAssociations']
	        };
	        this.proeprtyPathMap = {
	            "value": "Basic.Value.selectedValue",
	            "text": "Basic.Text.selectedValue",
	            "label": "Basic.Label.selectedValue",
	            "required": "Basic.Required.selectedValue",
	            "multiSelect": "Basic.Multi-Select.selectedValue",
	            "displayFormat": "Basic['Display Format'].selectedValue",
	            "time": "Basic['Time'].selectedValue",
	            "hourFormat": "Basic['Time Format'].selectedValue",
	            "readOnly": "Display['Read-only'].selectedValue",
	            "hidden": "Display.Hidden.selectedValue",
	            "options": "['Data Source'].table.list",
	            "placeHolder": "Display['Place Holder'].selectedValue",
	            "charLimit": "Display.Char-Limit.selectedValue",
	            "size": "Size.Rows.selectedValue",
	            "width": "Size.Width.selectedValue",
	            "height": "Size.Height.selectedValue",
	            "border-top-color": "Style.style-group.members.font-color",
	            "borderColor": "Borders.border-style-group.members.border-color.selectedValue",
	            "borderWidth": "Borders.border-style-group.members.border-width.selectedValue",
	            "reapeatingBorderColor": "Borders.border-style-group.members.border-color.selectedValue",
	            "reapeatingBorderWidth": "Borders.border-style-group.members.border-width.selectedValue",
	            "layoutBorderWidth": "Display.Border.selectedValue",
	            "tooltip": "Advance.Tooltip.selectedValue",
	            "validate": "Advance.Basic.selectedValue",
	            "padding-top": "Margin.margin-top.selectedValue",
	            "padding-bottom": "Margin.margin-bottom.selectedValue",
	            "padding-left": "Margin.margin-left.selectedValue",
	            "padding-right": "Margin.margin-right.selectedValue",
	            "font-size": "Style.font-style-group.members.font-size.selectedValue",
	            "font-family": "Style.font-style-group.members.font-family.selectedValue",
	            "font-weight": "Style.style-group.members.bold.selectedValue",
	            "font-style": "Style.style-group.members.italic.selectedValue",
	            "text-decoration": "Style.style-group.members.underline.selectedValue",
	            "text-align": "Style.style-group.members.alignment.selectedValue",
	            "background-color": "Style.font-style-group.members.background-color.selectedValue",
	            "color": "Style.style-group.members.font-color.selectedValue",
	            "label-font-size": "Style.font-style-group.members.font-size.selectedValue",
	            "label-font-family": "Style.font-style-group.members.font-family.selectedValue",
	            "label-font-weight": "Style.style-group.members.bold.selectedValue",
	            "label-font-style": "Style.style-group.members.italic.selectedValue",
	            "label-text-decoration": "Style.style-group.members.underline.selectedValue",
	            "label-text-align": "Style.style-group.members.alignment.selectedValue",
	            "label-background-color": "Style.font-style-group.members.background-color.selectedValue",
	            "label-color": "Style.style-group.members.font-color.selectedValue",
	            "control-font-size": "ControlStyle.font-style-group.members.font-size.selectedValue",
	            "control-font-family": "ControlStyle.font-style-group.members.font-family.selectedValue",
	            "control-font-weight": "ControlStyle.style-group.members.bold.selectedValue",
	            "control-font-style": "ControlStyle.style-group.members.italic.selectedValue",
	            "control-text-decoration": "ControlStyle.style-group.members.underline.selectedValue",
	            "control-text-align": "ControlStyle.style-group.members.alignment.selectedValue",
	            "control-color": "ControlStyle.style-group.members.font-color.selectedValue",
	            "background-color-on": "SwitchToggleStyle.background-color-on.selectedValue",
	            "background-color-off": "SwitchToggleStyle.background-color-off.selectedValue",
	            "background-color-even": "EvenOddRowStyle.background-color-on.selectedValue",
	            "background-color-odd": "EvenOddRowStyle.background-color-off.selectedValue",
	            "label-on": "Basic.LabelOn.selectedValue",
	            "label-off": "Basic.LabelOff.selectedValue",
	            "value-on": "Basic.ValueOn.selectedValue",
	            "value-off": "Basic.ValueOff.selectedValue",
	            "displayLabel": "Basic.DisplayLabel.selectedValue",
	        };
	        this.selectedTheme = 1;
	        this.themeChanged = 0;
	        this.isPuppeteerViewEnabled = "false";
	        this.addAppType = 0;
	        this.isLandscape = "false";
	        this.formProperties = {
	            "theme": 1,
	            "isThemeChanged": 0,
	            "addAppType": 0,
	            "isPuppeteerWithAngularViewEnabled": false,
	            "isLandscape": "false"
	        };
	        this.designStyle = {};
	        this.readOnlyControlsToUpdate = [];
	        this.selectedItemDomain = [];
	        this.publishWarn = false;
	        this.changeTheme = function (theme) {
	            var self = this;
	            var formElement = angular.element(document.querySelector(".container-fluid"));
	            formElement.removeClass('formdesigner-advanced');
	            var bodyElement = angular.element(document.querySelector("body"));
	            bodyElement.removeClass('formdesigner-advanced');
	            if (theme)
	                this.selectedTheme = theme;
	            else {
	                console.log(this.selectedTheme);
	                this.selectedTheme = this.selectedTheme == 1 ? 2 : 1;
	            }
	            if (self.config.for == 'Marketplace') {
	                this.selectedTheme = 1;
	            }
	            if (this.selectedTheme == this.designStyle.ADVANCED) {
	                formElement.addClass('formdesigner-advanced');
	                bodyElement.addClass('formdesigner-advanced');
	            }
	        };
	        this.maximizedCodeEditor = false;
	        /**
	         * Map of old and new field names
	         */
	        this.renamedFieldNames = {};
	        /**
	         * Map of old and new data field names
	         */
	        this.renamedDataFieldNames = {};
	        this.incrementCount = 0;
	        this.getHeightRTextToolbar = function (controldata) {
	            var targetElement = angular.element('.form-builder').find("[rta-field-name=\"" + controldata + "\"]").find('[text-angular-toolbar');
	            var style = {
	                position: 'absolute',
	                right: '1rem',
	            };
	            return style['margin-top'] = targetElement && targetElement[0] && targetElement[0].clientHeight + 24, style;
	        };
	        var self = this;
	        this.counterService = counterService;
	        this.$location = $location;
	        this.$anchorScroll = $anchorScroll;
	        this.showHelpPopup = false;
	        this.$uibModal = $uibModal;
	        this.$document = $document;
	        this.config = config;
	        this.$rootScope = $rootScope;
	        this.Util = Util;
	        this.$scope = $scope;
	        this.$filter = $filter;
	        this.params = $stateParams.params;
	        this.published = false;
	        this.editTempName = false;
	        this.tempTemplateName = '';
	        this.$state = $state;
	        this.copiedItems = [];
	        this.mousemoved = true;
	        this.$translate = $translate;
	        if (!this.params) {
	            this.$state.go('main');
	            return;
	        }
	        this.external = config.external;
	        this.$window = $window;
	        this.$http = $http;
	        this.$timeout = $timeout;
	        this.store = localStorage;
	        this.models = this.store.get('components');
	        this.templateComponents = this.store.get('templates');
	        this.selectedType = 'controls';
	        this.models.selected = null;
	        this.selectedView = this.store.get('selectedView');
	        this.views = this.store.get('views');
	        this.selectedView.view = this.views[Object.keys(this.views)[0]];
	        this.ngNotification = Notification;
	        this.loading = false;
	        this.LanguageObject = this.store.get('Languages');
	        this.viewsDataFromServer = '';
	        this.getNumberFormatingEnabledData(function () {
	            self.getFormDesignData();
	        });
	        this.multiHeight = 9;
	        this.filterOption = {
	            objAttrList: {},
	            objRelationList: {},
	            resetOption: {},
	            filterList: {}
	        };
	        this.timePickerOptions = {
	            showMeridian: true,
	        };
	        this.datePickerOptions = {
	            format: this.Util.getNewDateFormat('default'),
	            showClear: true,
	            showClose: true,
	            showTodayButton: true,
	            sideBySide: true,
	            useCurrent: false,
	            toolbarPlacement: "bottom",
	            locale: window.navigator.language.split('_')[0],
	            icons: {
	                close: 'closeText',
	                clear: 'clearText',
	                today: 'todayText'
	            }
	        };
	        $rootScope.$on('onViewChange', function (event) {
	            $timeout(function () {
	                self.gotoTop();
	            }, 500);
	        });
	        self.controlPropertyChangedDebouncer = _.debounce(function () {
	            self.processToUpdateReadOnlyControlProperties();
	        }, 3000);
	        self.$rootScope.$on('controlPropertyChanged', function (event, fieldName) {
	            if (fieldName && self.readOnlyControlsToUpdate.indexOf(fieldName) == -1) {
	                self.readOnlyControlsToUpdate.push(fieldName);
	            }
	            self.controlPropertyChangedDebouncer();
	        });
	        this.oldformatOptions = [
	            {
	                value: 'default',
	                key: 'Default'
	            }, {
	                value: 'dd-M-yy',
	                key: 'dd-mmm-yyyy'
	            }, {
	                value: 'dd-mm-yy',
	                key: 'dd-mm-yyyy'
	            }, {
	                value: 'dd-mm-y',
	                key: 'dd-mm-yy'
	            }, {
	                value: 'mm-dd-yy',
	                key: 'mm-dd-yyyy'
	            }, {
	                value: 'mm-dd-y',
	                key: 'mm-dd-yy'
	            }, {
	                value: 'dd/mm/y',
	                key: 'dd/mm/yy'
	            }, {
	                value: 'dd/mm/yy',
	                key: 'dd/mm/yyyy'
	            }];
	        var numberReg = /^-?\d+\.?\d*$/;
	        this.$document.off('dragover.g dragenter.g').on('dragover.g dragenter.g', function (e) {
	            self.setStyle(e);
	        });
	        this.$document.off('mousemove.g').on('mousemove.g', function (e) {
	            self.removeStyle(e);
	        });
	        $timeout(function () {
	            var scrollTimeout;
	            angular.element('.dnd-main-container .scroller').bind('scroll', function (e) {
	                var scrollTop = e.target.scrollTop;
	                scrollTimeout && $timeout.cancel(scrollTimeout);
	                scrollTimeout = $timeout(function () {
	                    self.showScrollToTop = scrollTop == 0 ? false : true;
	                }, 100);
	            });
	            // getting the control drop area
	            var keyupElement = angular.element(document.querySelector('.container-fluid .row.drop-area'));
	            keyupElement[0].focus();
	            keyupElement.on('keydown', function (event) {
	                var isEditable = event.target.isContentEditable;
	                // Check if the platform is macOS
	                var isMac = navigator.platform.includes('Mac');
	                // Determine the correct modifier key based on the OS
	                var modifierKey = isMac ? event.metaKey : event.ctrlKey;
	                if (self.config.for != 'Marketplace' && !isEditable && modifierKey && event.key === 'c' || event.key === 'C') {
	                    self.copy(false);
	                }
	                else if (self.config.for != 'Marketplace' && !isEditable && event.ctrlKey && event.key === 'v') {
	                    self.paste();
	                }
	            });
	        }, 100);
	        window.validate = function () {
	            var valid = {
	                valid: true,
	                defaultMissing: [],
	                notValidInput: [],
	                defaulValuetMissing: []
	            };
	            if (self.views && self.views.ORI_VIEW) {
	                var controls = self.views.ORI_VIEW.controls.A;
	                valid = self.Util.validate(controls, valid);
	            }
	            return valid;
	        };
	        window.getData = function () {
	            var views = angular.copy(self.views);
	            /* if (angular.equals(angular.copy(self.viewsDataFromServer), views)) {
	              return '';
	            } */
	            return views;
	        };
	        self.$window.localStorage.getItem('domXml') && self.$window.localStorage.removeItem('domXml'); // Removes the previous set blockly from the localStorage
	        window.removeEventListener('message', this.messageHandler, false);
	        window.addEventListener('message', this.messageHandler, false);
	        window.getPropValue = function (controlName, propName) {
	            if (!controlName || !propName) {
	                console.error('Please pass valid control name or property name. ', controlName, propName);
	                return '';
	            }
	            var propPath = self.proeprtyPathMap[propName] || '';
	            if (!propPath) {
	                console.error('Can not found property path from property name. Property name: ', controlName, propName);
	                return '';
	            }
	            var properties = self.getPropertiesFromControlName(controlName);
	            if (!properties) {
	                console.error('Can not found properties from control name. Control Name: ', controlName);
	                return '';
	            }
	            if (propName == 'value') {
	                var controlType = properties.Basic.ControlType;
	                if (controlType == 'Checkbox' || controlType == 'Radio') {
	                    var options = _.get(properties, "['Data Source'].table.list", []);
	                    var selectedItemsVal_1 = [];
	                    options.forEach(function (item) {
	                        if (item.selectedValue && item.selectedValue.name) {
	                            selectedItemsVal_1.push(item.Value.name);
	                        }
	                    });
	                    return selectedItemsVal_1.join(', ');
	                }
	                else if (controlType == 'Map' || controlType == 'Datepicker' || controlType == 'Timepicker') {
	                    propPath = "Basic.Default.selectedValue";
	                }
	                var val = angular.copy(_.get(properties, propPath, ''));
	                return val;
	            }
	            return angular.copy(_.get(properties, propPath, ''));
	        };
	        window.getPropValueByDataFieldName = function (dataFieldName) {
	            if (!dataFieldName) {
	                console.error('Please pass valid data field name. ', dataFieldName);
	                return;
	            }
	            var controlList = self.getControlsByDataFieldName(dataFieldName);
	            if (controlList.length) {
	                var fieldName = controlList[0].properties.Basic && controlList[0].properties.Basic['Field Name'] && controlList[0].properties.Basic['Field Name'].selectedValue;
	                return window.getPropValue(fieldName, 'value');
	            }
	        };
	        var setControlPropValue = function (properties, propName, propValue, control) {
	            if (!properties || !propName) {
	                console.error('Please pass valid properties or property name. ', properties, propName);
	                return;
	            }
	            var propPath = self.proeprtyPathMap[propName] || '';
	            if (!propPath) {
	                console.error('Can not found property path from property name. Property name: ', propName);
	                return;
	            }
	            if (propValue == undefined) {
	                propValue = '';
	            }
	            var controlType = properties.Basic.ControlType;
	            var oldVal;
	            if (propName == 'value') {
	                if (controlType == 'Map') {
	                    propPath = "Basic.Default.selectedValue";
	                }
	                if (propValue.indexOf && propValue.indexOf('$#$#$#') != -1) {
	                    propValue = propValue.replace(/\$\#\$\#\$\#/g, '\n');
	                }
	                if (controlType == 'Radio' || controlType == 'Checkbox') {
	                    oldVal = _.get(properties, propPath, []);
	                    var oldPropValue_1 = propValue || '';
	                    propPath = "['Data Source'].table.list";
	                    propValue = angular.copy(_.get(properties, "['Data Source'].table.list", []));
	                    propValue.forEach(function (item) {
	                        if (oldPropValue_1.indexOf(item.Value.name) != -1) {
	                            item.selectedValue.name = true;
	                        }
	                        else {
	                            item.selectedValue.name = '';
	                        }
	                    });
	                }
	                else if (controlType == 'Datepicker') {
	                    propPath = "Basic.Default.dateObj";
	                    oldVal = _.get(properties, propPath, '');
	                    var dateTimeFormat = properties.Basic['Display Format'].selectedValue == 'default' ? 'DD-MMM-YYYY' : properties.Basic['Display Format'].selectedValue;
	                    if (properties.Basic['Time'] && properties.Basic['Time'].selectedValue) {
	                        dateTimeFormat = properties.Basic['Time Format'].selectedValue == 'true' ? dateTimeFormat + ' hh:mm A' : dateTimeFormat + ' HH:mm';
	                    }
	                    var dateVal = moment(propValue).format(dateTimeFormat);
	                    if (dateVal == 'Invalid date') {
	                        dateVal = '';
	                        propValue = dateVal;
	                    }
	                    _.set(properties, 'Basic.Default.selectedValue', dateVal);
	                }
	                else if (controlType == 'Timepicker') {
	                    propPath = "Basic.Default.selectedValue";
	                    oldVal = _.get(properties, propPath, '');
	                }
	                else if (controlType == 'Attachment') {
	                    oldVal = _.get(properties, propPath, '');
	                    if (typeof propValue != 'object' || propValue['@inline'] == undefined || propValue['content'] == undefined) {
	                        propValue = '';
	                    }
	                }
	                else if (controlType == 'Signature') {
	                    oldVal = _.get(properties, propPath, '');
	                    if (typeof propValue != 'object' || propValue.length != 2) {
	                        propValue = '';
	                    }
	                }
	                else if (controlType == 'MultiDropdown') {
	                    oldVal = _.get(properties, propPath, []);
	                    var newVal = [];
	                    var controlOptions = angular.copy(_.get(properties, "['Data Source'].table.list", []));
	                    var _loop_1 = function(i) {
	                        if (controlOptions.some(function (item) { return (item.Value.name).includes(propValue[i]); })) {
	                            newVal.push(propValue[i]);
	                        }
	                    };
	                    for (var i = 0; i < propValue.length; i++) {
	                        _loop_1(i);
	                    }
	                    propValue = newVal;
	                }
	                else {
	                    oldVal = _.get(properties, propPath, '');
	                }
	            }
	            if (propName == 'options') {
	                oldVal = _.get(properties, propPath, []);
	                var newOptios_1 = propValue;
	                if (typeof propValue == 'string') {
	                    if (propValue.indexOf('[') != -1 && propValue.indexOf(']') != -1) {
	                        propValue = propValue.replace('[', '').replace(']', '');
	                        var valArray = propValue.split(',');
	                        newOptios_1 = [];
	                        valArray.forEach(function (item) {
	                            newOptios_1.push(item.replace(/'/g, '').trim());
	                        });
	                    }
	                    else {
	                        newOptios_1 = propValue.split(',');
	                    }
	                }
	                if (newOptios_1.length == 0 || !newOptios_1.forEach) {
	                    return;
	                }
	                propValue = [];
	                newOptios_1.forEach(function (name, index) {
	                    var option = angular.copy(oldVal[0]);
	                    option.id = index;
	                    option.Label.name = name;
	                    option.Value.name = name;
	                    option.selectedValue && (option.selectedValue.name = false);
	                    propValue.push(option);
	                });
	                if (controlType == 'Dropdown' || controlType == 'MultiDropdown') {
	                    var valPropPath = self.proeprtyPathMap['value'];
	                    _.set(properties, valPropPath, '');
	                }
	            }
	            _.set(properties, propPath, propValue);
	            if (controlType == 'Checkbox' || controlType == 'Radio') {
	                self.getListItems(control, properties);
	            }
	            //Don't set any proerpty via script logic as of now so mark this line as commented
	            /* if(propName == 'value' && properties.Events && properties.Events.change && !angular.equals(oldVal, propValue)) {
	              $timeout(function() {
	                self.onEvent(properties.Events.change.selectedValue);
	              }, 100);
	            } */
	        };
	        window.getSystemFieldValue = function (systemField) {
	            return self.Util.getValueOfOnLoadData(systemField);
	        };
	        window.setPropValueByDataFieldName = function (dataFieldName, propValue, excludedControlId, force) {
	            //Don't set any proerpty via script logic as of now so mark this line as commented
	            if (!force) {
	                return;
	            }
	            if (!dataFieldName) {
	                console.error('Please pass valid data field name. ', dataFieldName);
	                return;
	            }
	            var controlList = self.getControlsByDataFieldName(dataFieldName);
	            controlList.forEach(function (control) {
	                if (excludedControlId && (control.uid == excludedControlId)) {
	                    return;
	                }
	                setControlPropValue(control.properties, 'value', propValue, control);
	            });
	        };
	        if (!this.config.external) {
	            window.onbeforeunload = function (e) {
	                var dialogText = "There may be unsaved data. Please save before you leave else your changes will be lost.";
	                e.returnValue = dialogText;
	                return dialogText;
	            };
	        }
	        this.$scope.goBack = function () {
	            if (self.config.showListing == true) {
	                self.$state.go('main');
	            }
	            else if (self.config.for == 'Marketplace') {
	                window.top.postMessage('closeWindowMarketplace', "*");
	            }
	            else {
	                window.onbeforeunload = function () { };
	                self.$window.close();
	            }
	        };
	        this.$scope.publish = function () {
	            self.publish();
	        };
	        this.$scope.publishWarn = function () {
	            self.publishWarn = false;
	        };
	        var formID = this.params.id || null;
	        var projectId = this.params.id.projectId ? this.params.id.projectId : undefined;
	        var instanceGroupId = this.params.id.instanceGroupId;
	        if (this.config.for != 'Marketplace' && this.config.for != 'Meta-Data') {
	            var apiList = self.Util.getAllAPIConnections(formID, instanceGroupId, projectId);
	            // let apiConnections = [];
	            apiList.then(function (response) {
	                var data = angular.copy(response.data.entity) || [];
	                self.apiConnections = data;
	            }, function (err) {
	                console.log(err);
	                self.apiConnections = [];
	            });
	        }
	        this.designStyle = action_constants_1.Ids.DESIGN_STYLE;
	        self.$document.on('keyup', function (event) {
	            self.onKeyUp(event);
	            self.$scope.$apply();
	        });
	        this.$document.on('keydown', function (event) {
	            self.onKeyDown(event);
	            self.$scope.$apply();
	        });
	    }
	    CreateComponent.prototype.messageHandler = function (e) {
	        if (!e.data || typeof e.data !== 'string') {
	            return;
	        }
	        if (e.data.indexOf('callAppDesigner|') > -1) {
	            var result = JSON.parse(e.data.split('|')[1]);
	            if (result.funcName) {
	                var fn = window[result.funcName];
	                if (fn) {
	                    result.data = fn();
	                    e.source.postMessage('callAppDesigner|' + JSON.stringify(result), e.origin);
	                }
	            }
	        }
	    };
	    ;
	    CreateComponent.prototype.processToUpdateReadOnlyControlProperties = function (clearDebouncer) {
	        var self = this;
	        self.$timeout(function () {
	            self.readOnlyControlsToUpdate.forEach(function (fieldName) {
	                self.Util.refreshReadOnlyControlsPropeties(fieldName);
	            });
	            if (clearDebouncer && self.controlPropertyChangedDebouncer) {
	                self.controlPropertyChangedDebouncer.cancel();
	            }
	            self.readOnlyControlsToUpdate.length = 0;
	        });
	    };
	    CreateComponent.prototype.getPropertiesFromControlName = function (controlName) {
	        var self = this;
	        if (!self.views) {
	            return;
	        }
	        var controls = self.Util.getAllControls();
	        var properties = undefined;
	        controls.length && controls.forEach(function (control) {
	            if (!control.forceToReadOnly && !control.readOnly && control.properties.Basic && control.properties.Basic['Field Name'].selectedValue == controlName) {
	                properties = control.properties;
	            }
	        });
	        return properties;
	    };
	    ;
	    CreateComponent.prototype.getPropertiesFromDataFieldName = function (dataFieldName) {
	        var self = this;
	        if (!self.views) {
	            return;
	        }
	        var controls = self.Util.getAllControls();
	        var properties = undefined;
	        controls.length && controls.forEach(function (control) {
	            if (!control.forceToReadOnly && !control.readOnly && control.properties.Basic && control.properties.Basic['Data Field Name'] && control.properties.Basic['Data Field Name'].selectedValue == dataFieldName) {
	                properties = control.properties;
	            }
	        });
	        return properties;
	    };
	    ;
	    CreateComponent.prototype.getControlsByFieldName = function (fieldName) {
	        var self = this;
	        if (!self.views) {
	            return;
	        }
	        var controls = self.Util.getAllControls();
	        var controlList = [];
	        controls.length && controls.forEach(function (control) {
	            if (!control.forceToReadOnly && !control.readOnly && control.properties.Basic && control.properties.Basic['Field Name'] && control.properties.Basic['Field Name'].selectedValue == fieldName) {
	                controlList.push(control);
	            }
	        });
	        return controlList;
	    };
	    CreateComponent.prototype.getControlsByDataFieldName = function (dataFieldName) {
	        var self = this;
	        if (!self.views) {
	            return;
	        }
	        var controls = self.Util.getAllControls();
	        var controlList = [];
	        controls.length && controls.forEach(function (control) {
	            if (!control.forceToReadOnly && !control.readOnly && control.properties.Basic && control.properties.Basic['Data Field Name'] && control.properties.Basic['Data Field Name'].selectedValue == dataFieldName) {
	                controlList.push(control);
	            }
	        });
	        return controlList;
	    };
	    CreateComponent.prototype.getControlType = function (controlName) {
	        var self = this;
	        if (!self.views) {
	            return;
	        }
	        var controlType = undefined;
	        var controls = self.Util.getAllControls();
	        controls.length && controls.forEach(function (control) {
	            if (control.properties.Basic && control.properties.Basic['Field Name'].selectedValue == controlName) {
	                controlType = control.properties.Basic.ControlType;
	            }
	        });
	        return controlType;
	    };
	    ;
	    CreateComponent.prototype.gotoTop = function () {
	        document.getElementById('top').focus();
	    };
	    ;
	    CreateComponent.prototype.getSelectedItemsIncluding = function (list, item) {
	        if (this.config.for == 'Marketplace') {
	            this.ngNotification.error({
	                message: 'Dragging not allowed.', positionX: 'center', replaceMessage: true
	            });
	            return;
	        }
	        item.selected = true;
	        var selected = this.Util.returnSelected(this.selectedView.view.controls.A);
	        if (selected.length) {
	            for (var i = 0; i < selected.length; i++) {
	                selected[i].dragging = true;
	            }
	        }
	        this.$rootScope.$broadcast('closeTimepickerToggle');
	        return selected;
	    };
	    ;
	    /**
	       * @brief      Gets the selected item.
	       *
	       * @return     The selected item.
	       */
	    CreateComponent.prototype.getSelectedItem = function () {
	        var selected = this.Util.returnSelected(this.selectedView.view.controls.A);
	        return (selected.length == 1) ? selected[0] : {};
	    };
	    CreateComponent.prototype.selectItem = function (item, event, list, index) {
	        this.selectedItemDomain = list;
	        this.selectedItemIndex = index;
	        this.selectedItemView = this.selectedView.view.viewName;
	        this.deselectAllOtherViews();
	        //setting parent node id for textbox or display field if added under repeating table    
	        if (item && (item.type.toLowerCase() == "textbox" || item.type.toLowerCase() == "display field"))
	            this.updateChildId(item, event);
	        // Check if the platform is macOS
	        var isMac = navigator.platform.includes('Mac');
	        // Determine the correct modifier key based on the OS
	        var modifierKey = isMac ? event.metaKey : event.ctrlKey;
	        if (!modifierKey) {
	            var selected = this.Util.returnSelected(this.selectedView.view.controls.A);
	            if (selected.length && !event.shiftKey) {
	                for (var i = 0; i < selected.length; i++) {
	                    selected[i].selected = false;
	                    if (item.properties.Basic['Field Name'].selectedValue != selected[i].properties.Basic['Field Name'].selectedValue) {
	                        this.clearAllCell();
	                    }
	                }
	            }
	            if (!event.shiftKey) {
	                item.selected = true;
	            }
	            else if (selected.length == 0 && (item.type == "Table" || item.type == "RepeatingTable" || item.type == "Layout")) {
	                item.selected = true;
	            }
	        }
	        else {
	            item.selected = !item.selected;
	        }
	        this.$rootScope.$broadcast('controlChanged');
	    };
	    CreateComponent.prototype.broadcastDesignChange = function () {
	        this.$rootScope.$broadcast('designChanged');
	    };
	    CreateComponent.prototype.broadcastNewDesign = function () {
	        this.$rootScope.$broadcast('newDesgin');
	    };
	    CreateComponent.prototype.onDrop = function (list, items, index) {
	        var self = this;
	        var viewName = this.selectedView.view.viewName || '';
	        this.savedChanges = false;
	        if (angular.isArray(items)) {
	            for (var i = 0; i < items.length; i++) {
	                delete items[i].dragging;
	                items[i].selected = false;
	                list.splice(parseInt(index) + i, 0, items[i]);
	                items[i].viewName = viewName;
	                if (items[i] && (items[i].type.toLowerCase() == "textbox" || items[i].type.toLowerCase() == "display field"))
	                    this.updateChildId(items[i], event);
	                else if (items[i] && (items[i].type.toLowerCase() == "repeatingtable")) {
	                    var tableElems = angular.element("div[type=RepeatingTable]");
	                    var tableElemsIDs = [];
	                    for (var i_1 = 0; i_1 < tableElems.length; i_1++) {
	                        var currentTblId = parseInt(angular.element(tableElems[i_1]).attr("repeating-table-id"));
	                        if (tableElemsIDs.indexOf(currentTblId) == -1)
	                            tableElemsIDs.push(currentTblId);
	                    }
	                    if (tableElemsIDs.indexOf(items[i].id) != -1)
	                        items[i].id = tableElems.length + 1;
	                }
	            }
	        }
	        else {
	            delete items.dragging;
	            items.selected = false;
	            list.splice(index, 0, items);
	            (!items.uid) ? items.uid = self.Util.getGUID() : '';
	            items.viewName = viewName;
	            if (items && (items.type.toLowerCase() == "textbox" || items.type.toLowerCase() == "display field"))
	                this.updateChildId(items, event);
	            else if (items && (items.type.toLowerCase() == "repeatingtable")) {
	                var tableElems = angular.element("div[type=RepeatingTable]");
	                var tableElemsIDs = [];
	                for (var i = 0; i < tableElems.length; i++) {
	                    var currentTblId = parseInt(angular.element(tableElems[i]).attr("repeating-table-id"));
	                    if (tableElemsIDs.indexOf(currentTblId) == -1)
	                        tableElemsIDs.push(currentTblId);
	                }
	                if (tableElemsIDs.indexOf(items.id) != -1)
	                    items.id = tableElems.length + 1;
	            }
	        }
	        return true;
	    };
	    CreateComponent.prototype.removeDragging = function () {
	        var selected = this.Util.returnSelected(this.selectedView.view.controls.A);
	        if (selected.length) {
	            for (var i = 0; i < selected.length; i++) {
	                delete selected[i].dragging;
	            }
	        }
	    };
	    CreateComponent.prototype.removeDraggedItems = function (field) {
	        var self = this;
	        switch (field.type) {
	            case 'Layout':
	                self.Util.accessLayoutElements(field, function (elems) {
	                    for (var i = elems.length - 1; i >= 0; i--) {
	                        if (elems[i].dragging) {
	                            elems.splice(i, 1);
	                            continue;
	                        }
	                        else {
	                            self.removeDraggedItems(elems[i]);
	                        }
	                    }
	                });
	                break;
	            case 'Table':
	                self.Util.accessTableElements(field, function (elems) {
	                    for (var i = elems.length - 1; i >= 0; i--) {
	                        if (elems[i].dragging) {
	                            elems.splice(i, 1);
	                            continue;
	                        }
	                        else {
	                            self.removeDraggedItems(elems[i]);
	                        }
	                    }
	                });
	                break;
	            case 'RepeatingTable':
	                self.Util.accessRepeatingTableElements(field, function (elems) {
	                    for (var i = elems.length - 1; i >= 0; i--) {
	                        if (elems[i].dragging) {
	                            elems.splice(i, 1);
	                            continue;
	                        }
	                        else {
	                            self.removeDraggedItems(elems[i]);
	                        }
	                    }
	                });
	                break;
	            case 'Section':
	                self.Util.accessSectionElements(field, function (elems) {
	                    for (var i = elems.length - 1; i >= 0; i--) {
	                        if (elems[i].dragging) {
	                            elems.splice(i, 1);
	                            continue;
	                        }
	                        else {
	                            self.removeDraggedItems(elems[i]);
	                        }
	                    }
	                });
	                break;
	        }
	    };
	    CreateComponent.prototype.onMoved = function () {
	        var list = this.selectedView.view.controls.A;
	        if (list.length) {
	            for (var i = list.length - 1; i >= 0; i--) {
	                if (list[i].dragging) {
	                    list.splice(i, 1);
	                    continue;
	                }
	                else {
	                    this.removeDraggedItems(list[i]);
	                }
	                if (list[i].parent)
	                    delete list[i].parent;
	            }
	        }
	        this.selectedView.view.controls.A = list;
	        this.savedChanges = false;
	        this.broadcastDesignChange();
	    };
	    CreateComponent.prototype.executeGlobleScript = function () {
	        var self = this;
	        if (self.globleScript && self.globleScript.scriptVal) {
	            try {
	                window.eval(self.globleScript.scriptVal);
	            }
	            catch (e) {
	                console.error('Error when execute on globle scripts: ', e);
	            }
	        }
	        window['globle'] = self.globleScript;
	    };
	    CreateComponent.prototype.getNumberFormatingEnabledData = function (callback) {
	        var _this = this;
	        this.$http({
	            'url': window.properties.service.commonApiUrl.replace('/commonapi/', '/adoddle/') + action_constants_1.Ids.GET_NUMBER_FORMAT_ENABLED_DETAIL,
	            'method': "POST",
	            'withCredentials': true,
	            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	        }).then(function (response) {
	            var isEnabled = (response.data == "true" || response.data == true);
	            _this.store.set("numberFormatEnabled", isEnabled);
	            _this.numberFormatEnabled = isEnabled;
	            _this.$rootScope.$broadcast('numberFormatEnabledChanged');
	            callback();
	        }, function (response) {
	            _this.store.set("numberFormatEnabled", false);
	            _this.numberFormatEnabled = false;
	            _this.$rootScope.$broadcast('numberFormatEnabledChanged');
	            callback();
	        });
	    };
	    CreateComponent.prototype.getFormDesignData = function () {
	        var _this = this;
	        var self = this;
	        var data = {};
	        var method = 'GET';
	        var url = window.properties.service.uri + action_constants_1.Ids.GET_FORM_VIEW_JSON + this.params.id + '?ver=' + Math.random();
	        if (self.params.id.projectId) {
	            self.params.formName = decodeURIComponent(self.params.formName);
	        }
	        else {
	            self.params.formName = decodeURIComponent(encodeURIComponent(self.params.formName));
	        }
	        self.params.extraParams = this.config && this.config.for == 'Marketplace' ? this.config.formDetail.extra : '';
	        self.config['formID'] = self.params.id;
	        if (self.config.for == "Meta-Data") {
	            url = window.properties.service.commonApiUrl + action_constants_1.Ids.GET_FOLDER_META_DATA;
	            method = 'POST';
	            data = {
	                projectId: this.params.id.projectId,
	                folderId: this.params.id.folderId,
	                isForEdit: this.params.id.isForEdit
	            };
	            if (data.folderId == 0 || data.folderId == '0') {
	                delete data.folderId;
	            }
	        }
	        if (self.config.for == "Direct-Design" || self.config.for == "Marketplace") {
	            var formTypeId = this.params.id.formTypeId || this.params.id.formTypeID;
	            url = window.properties.service.commonApiUrl + action_constants_1.Ids.GET_FORM_VIEW_JSON_BY_FORM_TYPE + formTypeId + '/' + this.params.id.projectId + '?ver=' + Math.random();
	        }
	        if (self.config.for == "Direct-Design") {
	            self.Util.getProjectCustomAttributeSet(this.params.id.projectId);
	        }
	        this.loading = true;
	        this.$http({
	            'url': url,
	            'method': method,
	            'data': data,
	            'withCredentials': true,
	            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	            transformRequest: function (obj) {
	                var str = [];
	                for (var p in obj)
	                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
	                return str.join("&");
	            },
	        }).then(function (response) {
	            self.$timeout(function () {
	                self.loading = false;
	                self.gotoTop();
	            }, 500);
	            var data = response.data.entity;
	            self.published = data.published;
	            var views = Object.keys(self.views);
	            var languageData = JSON.parse(data.languageData);
	            _this.setCounter(data);
	            // for new style design changes
	            var formProperties = data.formProperties ? JSON.parse(data.formProperties) : {};
	            self.isPuppeteerViewEnabled = formProperties.hasOwnProperty('isPuppeteerWithAngularViewEnabled') ? JSON.stringify(formProperties.isPuppeteerWithAngularViewEnabled) : self.isPuppeteerViewEnabled;
	            self.printTypeText = JSON.parse(self.isPuppeteerViewEnabled) ? 'advance.printing' : 'basic.printing';
	            self.addAppType = formProperties.hasOwnProperty("addAppType") ? formProperties.addAppType : 0;
	            self.isLandscape = formProperties.hasOwnProperty("isLandscape") ? JSON.stringify(formProperties.isLandscape) : self.isLandscape;
	            var theme = 1;
	            if (formProperties && formProperties.hasOwnProperty("addAppType")) {
	                theme = 2;
	            }
	            theme = formProperties.hasOwnProperty("theme") ? formProperties.theme : theme;
	            var isThemeChanged = formProperties.hasOwnProperty("isThemeChanged") ? formProperties.isThemeChanged : 0;
	            self.themeChanged = formProperties.hasOwnProperty("isThemeChanged") ? formProperties.isThemeChanged : 0;
	            self.changeTheme(theme);
	            if (views.length) {
	                for (var i = 0; i < views.length; i++) {
	                    delete self.views[views[i]];
	                }
	            }
	            if (data.formViewJson) {
	                var viewsFromJson = JSON.parse(data.formViewJson);
	                var controlsWithProperties = _this.models.items;
	                if (Object.keys(viewsFromJson).length) {
	                    for (var view in viewsFromJson) {
	                        if (!viewsFromJson[view].removeOnLoad) {
	                            self.views[view] = viewsFromJson[view];
	                        }
	                        else {
	                            self.removeLanguageLabels(view, languageData);
	                        }
	                    }
	                }
	            }
	            else {
	                var defaultName = angular.copy(self.defaultView);
	                defaultName.viewName = 'ORI_VIEW';
	                self.views['ORI_VIEW'] = defaultName;
	                self.Util.addSubjectField(self.views['ORI_VIEW']);
	            }
	            if (data.formScript) {
	                try {
	                    self.globleScript = JSON.parse(data.formScript) || {};
	                }
	                catch (e) {
	                    self.globleScript = {};
	                }
	            }
	            else {
	                self.globleScript = {};
	            }
	            //Set here to update code during migration step
	            window['globle'] = self.globleScript;
	            //Do migration for all views control one time
	            self.doInitialMigration();
	            self.executeGlobleScript();
	            self.viewsDataFromServer = angular.copy(self.views);
	            self.store.set('Languages', languageData);
	            self.selectedView.view = self.views[Object.keys(self.views)[0]];
	            _this.prepareJsonForHierarchy(_this.selectedView.view.controls.A);
	            _this.broadcastNewDesign();
	            _this.broadcastDesignChange();
	            window.top.postMessage('appDesignerLoadingComplete', "*");
	            self.$timeout(function () {
	                if (self.config.sectionAvailibility && self.config.sectionAvailibility.components) {
	                    if (angular.element("div[id='ORI_FORMTITLE']").length > 0) {
	                        angular.element("div[id='ORI_FORMTITLE']").hide();
	                    }
	                    if (self.config.for == 'Marketplace') {
	                        window.top.postMessage('loadingComplete', "*");
	                    }
	                    self.openTemplateDialog('reviewcomponent');
	                }
	            }, 500);
	        }, function (response) {
	            self.loading = false;
	            switch (response.status) {
	                case 401:
	                    self.ngNotification.error({ message: 'Unauthorized access', positionX: 'center', replaceMessage: true });
	                    break;
	                case 503:
	                    self.ngNotification.error({ message: 'Service Temporary unavailable', positionX: 'center', replaceMessage: true });
	                    break;
	                case 500:
	                    self.ngNotification.error({ message: 'Internal Server Error', positionX: 'center', replaceMessage: true });
	                    break;
	                case -1:
	                    self.ngNotification.error({ message: 'Connectivity Issue', positionX: 'center', replaceMessage: true });
	                    break;
	                case 403:
	                    self.ngNotification.error({ message: 'Session Timeout', positionX: 'center', replaceMessage: true });
	                    break;
	            }
	        });
	    };
	    CreateComponent.prototype.setCounter = function (data) {
	        for (var control in this.counterService.counter) {
	            if (this.counterService.counter.hasOwnProperty(control)) {
	                delete this.counterService.counter[control];
	            }
	        }
	        if (data.counter) {
	            angular.merge(this.counterService.counter, JSON.parse(data.counter));
	        }
	        this.counterService.triggerChangeCallBack();
	    };
	    CreateComponent.prototype.mergeProperties = function (controls, controlsWithProperties) {
	        var self = this;
	        if (controls.length) {
	            var _loop_2 = function(i) {
	                var control = controlsWithProperties.filter(function (val) {
	                    return val.type == controls[i].type;
	                });
	                controls[i] = angular.merge({}, control[0], controls[i]);
	                if (controls[i].type == "Layout") {
	                    self.Util.accessLayoutElements(controls[i], function (elems) {
	                        self.mergeProperties(elems, controlsWithProperties);
	                    });
	                }
	                if (controls[i].type == "Table") {
	                    self.Util.accessTableElements(controls[i], function (elems) {
	                        self.mergeProperties(elems, controlsWithProperties);
	                    });
	                }
	                if (controls[i].type == "RepeatingTable") {
	                    self.Util.accessRepeatingTableElements(controls[i], function (elems) {
	                        self.mergeProperties(elems, controlsWithProperties);
	                    });
	                }
	                if (controls[i].type == "Section") {
	                    self.Util.accessSectionElements(controls[i], function (elems) {
	                        self.mergeProperties(elems, controlsWithProperties);
	                    });
	                }
	            };
	            for (var i = 0; i < controls.length; i++) {
	                _loop_2(i);
	            }
	        }
	    };
	    CreateComponent.prototype.logEvent = function (message, event) {
	        console.log(message, '(triggered by the following', event.type, 'event)');
	        console.log(event);
	    };
	    ;
	    CreateComponent.prototype.removeFromList = function (item, list) {
	        var self = this;
	        if (angular.isArray(item) && item.length) {
	            var _loop_3 = function(i) {
	                var index;
	                list.filter(function (val, j) {
	                    if (val == item[i])
	                        index = j;
	                });
	                typeof index != "undefined" && list.splice(index, 1);
	            };
	            for (var i = 0; i < item.length; i++) {
	                _loop_3(i);
	            }
	        }
	        else {
	            this.controlToRemove = {
	                item: item,
	                list: list
	            };
	            this.$scope.removeTitle = function () {
	                self.removeTitle();
	            };
	            this.$scope.removeCopied = function () {
	                self.removeCopied();
	            };
	            if (_.get(item, "properties.Basic['Data Field Name'].selectedValue", '') == 'ORI_FORMTITLE') {
	                var msg = self.$translate.instant('warning.before.remove.title');
	                this.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
	            }
	            else {
	                var fieldValue = _.get(item, "properties.Basic['Field Name'].selectedValue", '');
	                var isThisCopied = this.Util.finddeep(this.views, { copiedFrom: fieldValue });
	                var isThisDeriveded = this.Util.finddeep(this.views, { selectedValue: "{{" + fieldValue + "}}" });
	                if ((isThisCopied || isThisDeriveded) && fieldValue !== '') {
	                    this.ngNotification.warning({
	                        message: 'warning.before.remove.copied', positionX: 'center', replaceMessage: true, templateUrl: "warning_before_remove_copied.html", scope: this.$scope
	                    });
	                }
	                else {
	                    this.ngNotification.warning({
	                        message: 'warning.before.remove.control', positionX: 'center', replaceMessage: true, templateUrl: "warning_before_remove_control.html", scope: this.$scope
	                    });
	                }
	            }
	        }
	        self.$rootScope.$broadcast('closeTimepickerToggle');
	    };
	    CreateComponent.prototype.removeTitle = function () {
	        this.removeCopied(true);
	    };
	    CreateComponent.prototype.removeCopied = function (exclude, broadcast) {
	        if (broadcast === void 0) { broadcast = true; }
	        var self = this;
	        var controlToRemoveCopied = self.controlToRemove;
	        if (!controlToRemoveCopied) {
	            return;
	        }
	        var index;
	        controlToRemoveCopied.list.filter(function (val, i) {
	            if (val == controlToRemoveCopied.item)
	                index = i;
	        });
	        var extraFieldTobeReset = [];
	        var allChilds = [];
	        if (controlToRemoveCopied.item && !controlToRemoveCopied.item.copiedFrom && controlToRemoveCopied.item.type == 'Layout') {
	            self.Util.accessLayoutElements(controlToRemoveCopied.item, function (elems) {
	                allChilds = self.Util.getIteams(elems, allChilds);
	                allChilds.forEach(function (childElem) {
	                    extraFieldTobeReset.push(_.get(childElem, "properties.Basic['Field Name'].selectedValue", ''));
	                });
	            });
	        }
	        if (controlToRemoveCopied.item && !controlToRemoveCopied.item.copiedFrom && controlToRemoveCopied.item.type == 'Table') {
	            self.Util.accessTableElements(controlToRemoveCopied.item, function (elems) {
	                allChilds = self.Util.getIteams(elems, allChilds);
	                allChilds.forEach(function (childElem) {
	                    extraFieldTobeReset.push(_.get(childElem, "properties.Basic['Field Name'].selectedValue", ''));
	                });
	            });
	        }
	        if (controlToRemoveCopied.item && !controlToRemoveCopied.item.copiedFrom && controlToRemoveCopied.item.type == 'RepeatingTable') {
	            self.Util.accessRepeatingTableElements(controlToRemoveCopied.item, function (elems) {
	                allChilds = self.Util.getIteams(elems, allChilds);
	                allChilds.forEach(function (childElem) {
	                    extraFieldTobeReset.push(_.get(childElem, "properties.Basic['Field Name'].selectedValue", ''));
	                });
	            });
	        }
	        if (controlToRemoveCopied.item && !controlToRemoveCopied.item.copiedFrom && controlToRemoveCopied.item.type == 'Section') {
	            self.Util.accessSectionElements(controlToRemoveCopied.item, function (elems) {
	                allChilds = self.Util.getIteams(elems, allChilds);
	                allChilds.forEach(function (childElem) {
	                    extraFieldTobeReset.push(_.get(childElem, "properties.Basic['Field Name'].selectedValue", ''));
	                });
	            });
	        }
	        typeof index != "undefined" && controlToRemoveCopied.list.splice(index, 1);
	        if (!controlToRemoveCopied.item.copiedFrom) {
	            var fieldValue = _.get(controlToRemoveCopied.item, "properties.Basic['Field Name'].selectedValue", '');
	            for (var view in self.views) {
	                var controls = self.views[view].controls.A;
	                if (!exclude) {
	                    controls = self.removeObj(controls, fieldValue);
	                }
	                extraFieldTobeReset.forEach(function (fieldName) {
	                    if (fieldName) {
	                        controls = self.removeObj(controls, fieldName);
	                    }
	                });
	                self.views[view].controls.A = controls;
	            }
	        }
	        if (controlToRemoveCopied.item.copiedFrom && index == undefined) {
	            controlToRemoveCopied.list.filter(function (val, i) {
	                if (self.pasteAsCalculatedWithoutFlag.indexOf(val.type) > -1) {
	                    if (val.type === 'Layout') {
	                        _.forEach(val.data, function (column) {
	                            column.elems[0] = _.filter(column.elems[0], function (control) {
	                                if (control == controlToRemoveCopied.item) {
	                                    return false;
	                                }
	                                return true;
	                            });
	                        });
	                    }
	                    else if (val.type === 'Section') {
	                        val.data.elems[0] = _.filter(val.data.elems[0], function (control) {
	                            if (control == controlToRemoveCopied.item) {
	                                return false;
	                            }
	                            return true;
	                        });
	                    }
	                    else if (val.type === 'Table') {
	                        _.forEach(val.data, function (row) {
	                            _.forEach(row, function (column) {
	                                column.elems[0] = _.filter(column.elems[0], function (control) {
	                                    if (control == controlToRemoveCopied.item) {
	                                        return false;
	                                    }
	                                    return true;
	                                });
	                            });
	                        });
	                    }
	                    else if (val.type === 'RepeatingTable') {
	                        _.forEach(val.data, function (row) {
	                            _.forEach(row, function (column) {
	                                column.elems[0] = _.filter(column.elems[0], function (control) {
	                                    if (control == controlToRemoveCopied.item) {
	                                        return false;
	                                    }
	                                    return true;
	                                });
	                            });
	                        });
	                        _.forEach(val.footer_data, function (row) {
	                            _.forEach(row, function (column) {
	                                column.elems[0] = _.filter(column.elems[0], function (control) {
	                                    if (control == controlToRemoveCopied.item) {
	                                        return false;
	                                    }
	                                    return true;
	                                });
	                            });
	                        });
	                        _.forEach(val.header_data, function (row) {
	                            _.forEach(row, function (column) {
	                                column.elems[0] = _.filter(column.elems[0], function (control) {
	                                    if (control == controlToRemoveCopied.item) {
	                                        return false;
	                                    }
	                                    return true;
	                                });
	                            });
	                        });
	                    }
	                }
	            });
	        }
	        if (broadcast) {
	            self.broadcastDesignChange();
	        }
	    };
	    CreateComponent.prototype.removeObj = function (list, fieldValue) {
	        var self = this;
	        var controlToRemoveCopied = self.controlToRemove;
	        var result = _.filter(list, function (control) {
	            if ((control == controlToRemoveCopied.item) ||
	                (control.copiedFrom && !control.pasteAsCalculated && control.copiedFrom === fieldValue) ||
	                (control.pasteAsCalculatedFrom && control.pasteAsCalculated && control.pasteAsCalculatedFrom === fieldValue) ||
	                (control.pasteAsCalculatedFrom && self.pasteAsCalculatedWithoutFlag.indexOf(control.type) > -1 && control.pasteAsCalculatedFrom === fieldValue)) {
	                return false;
	            }
	            else {
	                if (control.type === 'Table') {
	                    _.forEach(control.data, function (row) {
	                        _.forEach(row, function (column) {
	                            column.elems[0] = self.removeObj(column.elems[0], fieldValue);
	                        });
	                    });
	                }
	                if (control.type === 'Layout') {
	                    _.forEach(control.data, function (column) {
	                        column.elems[0] = self.removeObj(column.elems[0], fieldValue);
	                    });
	                }
	                if (control.type === 'Section') {
	                    control.data.elems[0] = self.removeObj(control.data.elems[0], fieldValue);
	                }
	                if (control.type === 'RepeatingTable') {
	                    _.forEach(control.data, function (row) {
	                        _.forEach(row, function (column) {
	                            column.elems[0] = self.removeObj(column.elems[0], fieldValue);
	                        });
	                    });
	                    _.forEach(control.footer_data, function (row) {
	                        _.forEach(row, function (column) {
	                            column.elems[0] = self.removeObj(column.elems[0], fieldValue);
	                        });
	                    });
	                    _.forEach(control.header_data, function (row) {
	                        _.forEach(row, function (column) {
	                            column.elems[0] = self.removeObj(column.elems[0], fieldValue);
	                        });
	                    });
	                }
	                if (_.get(control, "properties.Basic['Value'].selectedValue", '') === "{{" + fieldValue + "}}") {
	                    /*if (control.type === 'Display field'){
	                       _.set(control, "derivedFromFieldName", '');
	                    }
	                    if (control.type === 'RepeatingTable'){
	                      _.set(control, "properties.Basic['DSName'].selectedValue", '');
	                   }
	                    return _.set(control, "properties.Basic['Value'].selectedValue", '');*/
	                    return false;
	                }
	                return control.copiedFrom !== fieldValue;
	            }
	        });
	        return result;
	    };
	    CreateComponent.prototype.showPropertybox = function () {
	        var selected = this.Util.returnSelected(this.selectedView.view.controls.A);
	        if (this.config.for == 'Meta-Data' && selected.length == 1 && (selected[0].type == 'Datepicker' || selected[0].type == 'Map' || selected[0].type == 'Radio' || selected[0].type == 'Timepicker')) {
	            return false;
	        }
	        return (selected.length == 1);
	    };
	    CreateComponent.prototype.onToggle = function (property) {
	        property.Basic.Value.selectedValue = !property.Basic.Value.selectedValue;
	    };
	    CreateComponent.prototype.setMultiDDSelection = function (item, selectedItem) {
	        selectedItem['isSelected'] = selectedItem.isSelected == undefined ? true : !selectedItem.isSelected;
	        if (selectedItem.isSelected) {
	            if (item.properties.Basic.ControlType === "Dropdown") {
	                if (item.properties.Basic["Multi-Select"].selectedValue) {
	                    if (!item.properties.Basic.Value.selectedValue.includes(selectedItem.Value.name))
	                        item.properties.Basic.Value.selectedValue.push(selectedItem.Value.name);
	                    else {
	                        var index = item.properties.Basic.Value.selectedValue.indexOf(selectedItem.Value.name);
	                        if (index > -1) {
	                            item.properties.Basic.Value.selectedValue.splice(index, 1);
	                        }
	                    }
	                }
	                else {
	                    item.properties.Basic.Value.selectedValue = [];
	                    item.properties.Basic.Value.selectedValue.push(selectedItem.Value.name);
	                }
	                if (!item.properties.Basic["Multi-Select"].selectedValue) {
	                    item.properties["Data Source"].table.list.forEach(function (element) {
	                        if (element.id != selectedItem.id)
	                            element.isSelected = false;
	                    });
	                }
	            }
	            else {
	                item.properties.Basic.Value.selectedValue.push(selectedItem.Value.name);
	            }
	        }
	        else {
	            for (var i = 0; i < item.properties.Basic.Value.selectedValue.length; i++) {
	                var sitem = item.properties.Basic.Value.selectedValue[i];
	                if (selectedItem.Value.name == sitem) {
	                    item.properties.Basic.Value.selectedValue.splice(i, 1);
	                    break;
	                }
	            }
	        }
	    };
	    CreateComponent.prototype.clearMultiDropdownSearch = function (item) {
	        //clear search value
	        item.properties.Basic.searchText = '';
	        item.properties.Basic.isLimited = true;
	        this.initialDropdownPosition(item);
	    };
	    CreateComponent.prototype.clearMultiDropdown = function (item) {
	        //clear selection
	        item.properties.Basic.Value.selectedValue = [];
	        var options = item.properties["Data Source"].table.list;
	        for (var i = 0; i < options.length; i++) {
	            options[i].isSelected = false;
	        }
	    };
	    CreateComponent.prototype.closeMultiDropdown = function (item, clickPoint) {
	        if (!(clickPoint == 'dropdownList' && item.properties.Basic["Multi-Select"].selectedValue)) {
	            item.properties.Basic.isOpen = false;
	            item.properties.Basic.isLimited = true;
	        }
	    };
	    CreateComponent.prototype.onMultiDropdownToggle = function (item, event) {
	        var selectionArr = [], nonSelectedArr = [];
	        item.properties.Basic.isLimited = true;
	        var options = item.properties["Data Source"].table.list;
	        if (item.properties.Basic.isOpen) {
	            item.properties.Basic.searchText = '';
	            for (var i = 0; i < options.length; i++) {
	                if ((item.properties.Basic.Value.selectedValue).includes(options[i].Value.name)) {
	                    options[i].isSelected = true;
	                }
	                else {
	                    options[i].isSelected = false;
	                }
	            }
	            for (var y = 0; y < options.length; y++) {
	                if (options[y].isSelected) {
	                    selectionArr.push(options[y]);
	                }
	                else {
	                    nonSelectedArr.push(options[y]);
	                }
	            }
	            item.properties["Data Source"].table.list = selectionArr.concat(nonSelectedArr);
	        }
	        this.initialDropdownPosition(item);
	    };
	    CreateComponent.prototype.initialDropdownPosition = function (item) {
	        //calculate position for multidropdown display if at the end of the screen / or not sufficient space
	        var minHeight = 78, pos, listLen = (item.properties["Data Source"].table.list).length;
	        var curDropdownHeight = minHeight + (28 * listLen);
	        curDropdownHeight = curDropdownHeight > 347 ? 359 : curDropdownHeight;
	        var windowHeight = $(window).innerHeight();
	        var pageScroll = $('body').scrollTop();
	        var curElement = angular.element('div[data-name=' + item.uid + ']');
	        var offset = curElement.offset();
	        var toppos = offset.top;
	        var space = windowHeight - (offset.top - pageScroll);
	        if (space < curDropdownHeight) {
	            pos = (toppos - curDropdownHeight) + 'px';
	        }
	        else {
	            pos = (toppos + 34) + 'px';
	        }
	        var dropdownMenuElem = angular.element('div[data-name=dd_' + item.uid + ']');
	        dropdownMenuElem[0].style.top = pos;
	    };
	    CreateComponent.prototype.showAll = function (item) {
	        item.properties.Basic.isLimited = false;
	        //calculate position for multidropdown display if at the end of the screen / or not sufficient space
	        var minHeight = 78, pos, listLen = (item.properties["Data Source"].table.list).length;
	        var curDropdownHeight = minHeight + (28 * listLen);
	        curDropdownHeight = curDropdownHeight > 397 ? 397 : curDropdownHeight;
	        var windowHeight = $(window).innerHeight();
	        var pageScroll = $('body').scrollTop();
	        var curElement = angular.element('div[data-name=' + item.uid + ']');
	        var offset = curElement.offset();
	        var toppos = offset.top;
	        var space = windowHeight - (offset.top - pageScroll);
	        if (space < curDropdownHeight) {
	            pos = (toppos - curDropdownHeight) + 'px';
	        }
	        else {
	            pos = (toppos + 34) + 'px';
	        }
	        var dropdownMenuElem = angular.element('div[data-name=dd_' + item.uid + ']');
	        dropdownMenuElem[0].style.top = pos;
	    };
	    CreateComponent.prototype.updateDropdownPosition = function (item) {
	        this.postionDropdownOnSearch(item);
	    };
	    CreateComponent.prototype.postionDropdownOnSearch = function (item) {
	        //calculate position for multidropdown display if at the end of the screen / or not sufficient space
	        var dropdownMenuElem = angular.element('div[data-name=dd_' + item.uid + ']');
	        var minHeight = 78, pos, listLen = (item.properties["Data Source"].table.list).length;
	        var curDropdownHeight = minHeight + (28 * listLen);
	        curDropdownHeight = curDropdownHeight > 347 ? 359 : curDropdownHeight;
	        var windowHeight = $(window).innerHeight();
	        var pageScroll = $('body').scrollTop();
	        var curElement = angular.element('div[data-name=' + item.uid + ']');
	        var offset = curElement.offset();
	        var toppos = offset.top;
	        var space = windowHeight - (offset.top - pageScroll);
	        if (space < curDropdownHeight) {
	            if (dropdownMenuElem.height()) {
	                pos = (toppos - (dropdownMenuElem.height()) - 10) + 'px';
	            }
	            else {
	                pos = (toppos - curDropdownHeight) + 'px';
	            }
	        }
	        else {
	            pos = (toppos + 34) + 'px';
	        }
	        dropdownMenuElem[0].style.top = pos;
	    };
	    CreateComponent.prototype.downloadZip = function () {
	        var self = this;
	        if (self.editTempName) {
	            self.editTempNameCancle();
	        }
	        if (self.params.formName.match(/[|<>\\/:?*"'$#]/gi)) {
	            self.ngNotification.error({ message: 'Template Name cannot contain any of the following characters: # \\ / : * ? " < > | $ \' ', positionX: 'center', replaceMessage: true });
	            return;
	        }
	        var timeStamp = new Date().getTime();
	        this.validateAndSave(function () {
	            var data;
	            var downloadURL;
	            if (self.config.for == "Direct-Design" || self.config.for == "Marketplace") {
	                var formTypeID = self.params.id.formTypeId || self.params.id.formTypeID;
	                var instanceGroupId = self.params.id.instanceGroupId;
	                var extraParams = self.params.extraParams ? JSON.stringify(self.params.extraParams) : '';
	                self.formProperties.theme = self.selectedTheme ? parseInt(self.selectedTheme) : 1;
	                self.formProperties.isThemeChanged = self.themeChanged ? parseInt(self.themeChanged) : 0;
	                self.formProperties.addAppType = self.addAppType ? self.addAppType : 0;
	                data = {
	                    "timeStamp": timeStamp,
	                    "formTypeId": formTypeID,
	                    "projectId": self.params.id.projectId,
	                    "instanceGroupId": instanceGroupId,
	                    "for": self.config.for,
	                    "name": self.params.formName,
	                    "extraParams": extraParams,
	                    "formProperties": JSON.stringify(self.formProperties)
	                };
	            }
	            else {
	                self.formProperties.theme = self.selectedTheme ? parseInt(self.selectedTheme) : 1;
	                self.formProperties.isThemeChanged = self.themeChanged ? parseInt(self.themeChanged) : 0;
	                self.formProperties.addAppType = self.addAppType ? self.addAppType : 0;
	                self.formProperties.isPuppeteerWithAngularViewEnabled = self.isPuppeteerViewEnabled && JSON.parse(self.isPuppeteerViewEnabled);
	                self.formProperties.isLandscape = self.isLandscape && JSON.parse(self.isLandscape);
	                data = {
	                    "id": self.params.id,
	                    "name": self.params.formName,
	                    "timeStamp": timeStamp,
	                    "formProperties": JSON.stringify(self.formProperties)
	                };
	            }
	            downloadURL = 'download';
	            self.Util.downloadZip(downloadURL, data);
	        }, true);
	    };
	    CreateComponent.prototype.validate = function (viewData) {
	        if (viewData === void 0) { viewData = {}; }
	        var _this = this;
	        var protectedParams = this.Util.getProtectedParams();
	        var isValid = true;
	        var message = [];
	        var detectAutoNumbering = {
	            oldAutoNumbering: false,
	            advanceAutoNumbering: false
	        };
	        var allControls = [];
	        if (_this.globleScript && _this.globleScript.hasOwnProperty('scriptVal') && _this.globleScript.scriptVal.includes('window.setAutoNumbering && window.setAutoNumbering(')) {
	            detectAutoNumbering.oldAutoNumbering = true;
	        }
	        if (_this.globleScript && _this.globleScript.hasOwnProperty('scriptVal') && _this.globleScript.scriptVal.includes('window.setAutoNumberingSuffix && window.setAutoNumberingSuffix(')) {
	            detectAutoNumbering.advanceAutoNumbering = true;
	        }
	        if (detectAutoNumbering.oldAutoNumbering && detectAutoNumbering.advanceAutoNumbering) {
	            return { status: false, message: 'Only one Auto-Numbering block can be used, please delete the required block to publish/save/download the zip', allControls: [], hasTwoAutoNumbering: true };
	        }
	        if (Object.keys(viewData).length) {
	            var fieldNameAcrossViews = [], allcontrolsAry = [];
	            for (var view in viewData) {
	                for (var v = 0; v < this.Util.getIteams(viewData[view].controls.A).length; v++) {
	                    allcontrolsAry.push(this.Util.getIteams(viewData[view].controls.A)[v]);
	                }
	            }
	            var _loop_4 = function(view) {
	                var controls = this_1.Util.getIteams(viewData[view].controls.A);
	                var viewName = this_1.Util.getLanguageSpecificViewName(view);
	                if (controls.length) {
	                    var fieldNames = [];
	                    var dataFieldNames = [];
	                    var _loop_5 = function(i) {
	                        var syncappstatus = false, synccloseddate = false;
	                        var control = controls[i];
	                        // checking for the autonumbering events on the controls
	                        if (control.properties && control.properties.Events) {
	                            var eventsCopy = angular.copy(control.properties.Events);
	                            for (var _i = 0, _a = Object.entries(eventsCopy); _i < _a.length; _i++) {
	                                var _b = _a[_i], event_1 = _b[0], eventData = _b[1];
	                                var selectedValue = eventData.selectedValue;
	                                if (selectedValue && selectedValue.includes('window.setAutoNumbering && window.setAutoNumbering(')) {
	                                    detectAutoNumbering.oldAutoNumbering = true;
	                                }
	                                if (selectedValue && selectedValue.includes('window.setAutoNumberingSuffix && window.setAutoNumberingSuffix(')) {
	                                    detectAutoNumbering.advanceAutoNumbering = true;
	                                }
	                                if (detectAutoNumbering.oldAutoNumbering && detectAutoNumbering.advanceAutoNumbering) {
	                                    return { value: { status: false, message: 'Only one Auto-Numbering block can be used, please delete the required block to publish/save/download the zip', allControls: [], hasTwoAutoNumbering: true } };
	                                }
	                            }
	                        }
	                        var label = control.properties.Basic && (control.properties.Basic.Label || control.properties.Basic.Text) && (control.properties.Basic.Label || control.properties.Basic.Text).selectedValue || '';
	                        if (this_1.Util.controlsWithoutFieldName.indexOf(control.type) == -1) {
	                            if (control.type == "Dropdown" && control.properties.Advance['App Status']) {
	                                syncappstatus = control.properties.Advance['App Status'].selectedValue;
	                            }
	                            //If more than one datepicker is used with enable closed date sync, setting this validation msg
	                            if (control.type == "Datepicker" && control.properties.Advance['Closed Date']) {
	                                synccloseddate = control.properties.Advance['Closed Date'].selectedValue;
	                                if (synccloseddate) {
	                                    try {
	                                        //validate closed due date for past dates
	                                        if (control.properties.Basic.Default.selectedValue != "" && control.properties.Basic.Default.dateType == 1) {
	                                            dateformat = (control.properties.Basic["Display Format"].selectedValue == "default") ? "DD-MMM-YYYY" : control.properties.Basic["Display Format"].selectedValue;
	                                            formatedDate = moment(control.properties.Basic.Default.selectedValue, dateformat).toDate();
	                                            if (formatedDate.setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
	                                                message.push("'Close Due Date' cannot be a past date. <br>");
	                                            }
	                                        }
	                                    }
	                                    catch (e) { }
	                                }
	                            }
	                            var fieldName = control.properties.Basic && control.properties.Basic['Field Name'] && control.properties.Basic['Field Name'].selectedValue;
	                            labelAndFieldName = label ? (fieldName ? label + ' - ' + fieldName : label) : fieldName;
	                            if (fieldName) {
	                                if (fieldNameAcrossViews.indexOf(fieldName) != -1 && (!control.copiedFrom)) {
	                                    labelField = label ? label : fieldName;
	                                    message.push('Duplicate Field Name in ' + viewName + ': ' + labelAndFieldName + ' <br>');
	                                }
	                                //ignore this validation if app status sync and closed date sync are enabled
	                                if (!syncappstatus && !synccloseddate && (fieldName.startsWith("DS_") || fieldName.startsWith("DSI_")) && !control.forceToReadOnly && !control.readOnly) {
	                                    message.push('"DS_" OR "DSI_" not allowed in field name ' + viewName + ': ' + labelAndFieldName + ' <br>');
	                                }
	                                fieldNames.push(fieldName);
	                                (!control.copiedFrom) && fieldNameAcrossViews.push(fieldName);
	                                if (!this_1.Util.isValidXMLTagName(fieldName)) {
	                                    message.push('Field Name is not valid. ' + viewName + ': ' + labelAndFieldName + ' <br>');
	                                }
	                                if (protectedParams.indexOf(fieldName.toLowerCase()) > -1) {
	                                    var labelfield = label ? label : fieldName;
	                                    message.push('System reserved keyword used as field name in ' + viewName + ': ' + labelAndFieldName + ' <br>');
	                                }
	                            }
	                            if (control.properties.Basic && control.properties.Basic['Field Name'] && !control.properties.Basic['Field Name'].selectedValue) {
	                                !fieldName && message.push('Field Name missing in ' + viewName + ': ' + labelAndFieldName + '<br>');
	                            }
	                            var dataFieldName_1 = control.properties.Basic && control.properties.Basic['Data Field Name'] && control.properties.Basic['Data Field Name'].selectedValue;
	                            if (dataFieldName_1) {
	                                //ignore this validation if app status sync and closed date sync are enabled
	                                if (!syncappstatus && !synccloseddate && (dataFieldName_1.startsWith("DS_") || dataFieldName_1.startsWith("DSI_")) && !control.forceToReadOnly && !control.readOnly) {
	                                    message.push('"DS_" OR "DSI_" not allowed in data field name ' + viewName + ': ' + labelAndFieldName + ' <br>');
	                                }
	                                if (!this_1.Util.isValidXMLTagName(dataFieldName_1)) {
	                                    message.push('Data Field Name is not valid. ' + viewName + ': ' + labelAndFieldName + ' <br>');
	                                }
	                                if (protectedParams.indexOf(dataFieldName_1.toLowerCase()) > -1) {
	                                    message.push('System reserved keyword used as data field name in ' + viewName + ': ' + labelAndFieldName + ' <br>');
	                                }
	                                dataFieldNames.push(dataFieldName_1);
	                                controls.forEach(function (item) {
	                                    if (control.type != item.type) {
	                                        var itemDataFieldName = item.properties.Basic && item.properties.Basic['Data Field Name'] && item.properties.Basic['Data Field Name'].selectedValue;
	                                        if (dataFieldName_1 && dataFieldName_1 == itemDataFieldName && (_this.typeWiseDataFieldNameAllowed[control.type].indexOf(item.type) == -1)) {
	                                            var controlLable = item.properties.Basic && (item.properties.Basic.Label || item.properties.Basic.Text) && (item.properties.Basic.Label || item.properties.Basic.Text).selectedValue || '';
	                                            message.push(control.type + " data field name is set in \"" + viewName + "\" : \"" + controlLable + "\". which type is not a " + _this.typeWiseDataFieldNameAllowed[control.type].join(', ') + ".<br>");
	                                        }
	                                    }
	                                });
	                            }
	                            if (control.properties.Basic && control.properties.Basic['Data Field Name'] && !control.properties.Basic['Data Field Name'].selectedValue) {
	                                !dataFieldName_1 && message.push('Data Field Name missing in ' + viewName + ': ' + labelAndFieldName + '<br>');
	                            }
	                            if (control.properties.Basic && control.properties.Basic.ControlType == 'Hyperlink' && ((control.properties.Basic['DisplayLabel'] && control.properties.Basic['DisplayLabel'].selectedValue == '') ||
	                                (control.properties.Basic['Value'] && control.properties.Basic['Value'].selectedValue == ''))) {
	                                message.push('Link Address/Display Label is missing in ' + viewName + ': ' + labelAndFieldName + ' <br>');
	                            }
	                            if (control.properties.Basic && control.properties.Basic.ControlType == 'ToggleButton' && ((control.properties.Basic['ValueOn'] && control.properties.Basic['ValueOn'].selectedValue == '') ||
	                                (control.properties.Basic['ValueOff'] && control.properties.Basic['ValueOff'].selectedValue == ''))) {
	                                message.push('Value On/Value Off is missing in ' + viewName + ': ' + labelAndFieldName + ' <br>');
	                            }
	                            if (control.type == 'ViewAssociations' && control.properties.Basic && (!control.properties.Basic['Assoc Type'].selectedValue || !control.properties.Basic['Message Type'].selectedValue)) {
	                                message.push('Assoc Type/Message Type missing in ' + viewName + ': ' + labelAndFieldName + '<br>');
	                            }
	                        }
	                        var list = [];
	                        switch (control.type) {
	                            case 'Dropdown':
	                                var staticData = _.get(control.properties, '["Data Source"].Source.selectedValue');
	                                if (staticData == '3') {
	                                    list = _.get(control.properties, '["Data Source"].table.list');
	                                    if (list.length) {
	                                        var withOutVal = list.filter(function (val) {
	                                            return (val.Label.name == '' || val.Value.name == '');
	                                        });
	                                        if (withOutVal.length) {
	                                            message.push('Label/Value for options missing in ' + viewName + ': ' + labelAndFieldName + ' <br>');
	                                        }
	                                    }
	                                }
	                                break;
	                            case 'MultiDropdown':
	                                var mstaticData = _.get(control.properties, '["Data Source"].Source.selectedValue');
	                                if (mstaticData == '3') {
	                                    list = _.get(control.properties, '["Data Source"].table.list');
	                                    if (list.length) {
	                                        var withOutVal = list.filter(function (val) {
	                                            return (val.Label.name == '' || val.Value.name == '');
	                                        });
	                                        if (withOutVal.length) {
	                                            message.push('Label/Value for options missing in ' + viewName + ': ' + labelAndFieldName + ' <br>');
	                                        }
	                                    }
	                                }
	                                break;
	                            case 'Radio':
	                            case 'Checkbox':
	                                list = _.get(control.properties, '["Data Source"].table.list');
	                                if (list.length) {
	                                    var withOutVal = list.filter(function (val) {
	                                        return (val.Label.name == '' || val.Value.name == '');
	                                    });
	                                    if (withOutVal.length) {
	                                        message.push('Label/Value for options missing in ' + viewName + ': ' + labelAndFieldName + ' <br>');
	                                    }
	                                }
	                                break;
	                        }
	                    };
	                    for (var i = 0; i < controls.length; i++) {
	                        var state_4 = _loop_5(i);
	                        if (typeof state_4 === "object") return state_4;
	                    }
	                    var self_1 = this_1;
	                    allControls = allControls.concat(controls.filter(function (val) {
	                        val.viewName = view;
	                        return self_1.Util.controlsWithoutFieldName.indexOf(val.type) == -1;
	                    }));
	                    if (view == "ORI_VIEW" && dataFieldNames.indexOf('ORI_FORMTITLE') == -1) {
	                        message.push('Form Title missing in ' + viewName + '. Add \'ORI_FORMTITLE\' in Data field name property.');
	                    }
	                }
	                else if (view == "ORI_VIEW") {
	                    message.push('Form Title missing in ' + viewName + '. Add \'ORI_FORMTITLE\' in Data field name property.');
	                }
	            };
	            var this_1 = this;
	            var dateformat, formatedDate, labelAndFieldName, labelField;
	            for (var view in viewData) {
	                var state_5 = _loop_4(view);
	                if (typeof state_5 === "object") return state_5.value;
	            }
	        }
	        message.length && (isValid = false);
	        return {
	            status: isValid,
	            message: message.join(''),
	            allControls: allControls
	        };
	    };
	    CreateComponent.prototype.validateAndSave = function (callBack, download, publish) {
	        if (download === void 0) { download = false; }
	        if (publish === void 0) { publish = false; }
	        var self = this;
	        this.deselectAll(null);
	        this.deselectAllOtherViews();
	        if (self.config.for == 'Marketplace') {
	            if (this.views.ORI_VIEW.controls.A.length == 1) {
	                this.ngNotification.error({
	                    message: 'The view is empty with no controls. Please add some content in the form.', positionX: 'center', replaceMessage: true
	                });
	                return;
	            }
	        }
	        var viewData = angular.copy(this.views);
	        var validation = this.validate(viewData);
	        this.$scope.save = function () {
	            self.save(undefined, validation, viewData);
	        };
	        if (!validation.status) {
	            if (download || validation.hasTwoAutoNumbering) {
	                this.ngNotification.error({
	                    message: validation.message, positionX: 'center', replaceMessage: true
	                });
	            }
	            else {
	                this.ngNotification.warning({
	                    message: validation.message, positionX: 'center', replaceMessage: true, templateUrl: "validation_template.html", scope: this.$scope
	                });
	            }
	            return;
	        }
	        if (+self.checkSectionandWeightage().toFixed(2) > 1.00) {
	            this.ngNotification.error({
	                message: 'Total sections weightage is greater than 1', positionX: 'center', replaceMessage: true
	            });
	            return;
	        }
	        this.save(callBack, validation, viewData, publish);
	    };
	    CreateComponent.prototype.loadData = function (data) {
	        var self = this;
	        self.loading = false;
	        self.apiConnections = angular.copy(data.entity);
	    };
	    CreateComponent.prototype.apiConnectionClosed = function () {
	        var self = this;
	        // this.loading = true;
	        var formID = this.params.id || null;
	        var projectId = this.params.id.projectId ? this.params.id.projectId : undefined;
	        var instanceGroupId = this.params.id.instanceGroupId || this.params.id.instanceGroupId;
	        var apiList = self.Util.getAllAPIConnections(formID, instanceGroupId, projectId);
	        // let apiConnections = [];
	        apiList.then(function (response) {
	            self.loadData(response.data);
	        }, function (err) {
	            console.log(err);
	        });
	    };
	    CreateComponent.prototype.checkSectionandWeightage = function () {
	        var controls = this.Util.getAllControls();
	        var filteredControls = controls.filter(function (sec) { return sec.type == 'Section'; });
	        var reviewSections = filteredControls.filter(function (ctrl) { return (ctrl.properties.Basic['Field Name'].selectedValue).indexOf('Review_Section') != -1; });
	        var weightage = 0;
	        if (reviewSections.length > 0) {
	            for (var i = 0; i < reviewSections.length; i++) {
	                var weigthVal = reviewSections[i].data.elems[0][0].data[1].elems[0][0].properties['Basic'].Value.selectedValue;
	                weightage = parseFloat(weigthVal) + weightage;
	            }
	        }
	        return weightage;
	    };
	    CreateComponent.prototype.save = function (callBack, validation, viewData, publish) {
	        if (publish === void 0) { publish = false; }
	        var self = this;
	        var languageData = angular.copy(this.store.get('Languages'));
	        var supportedLanguages = angular.copy(self.Util.supportedLanguages);
	        if (!languageData) {
	            languageData = { 'Default': {} };
	            for (var index = 0; index < supportedLanguages.length; index++) {
	                languageData[supportedLanguages[index]['languageId']] = {};
	            }
	        }
	        if (validation.allControls.length) {
	            for (var index = 0; index < validation.allControls.length; index++) {
	                var element = validation.allControls[index];
	                var fieldName = element.uid;
	                var value = '';
	                if (element.properties.Basic && element.properties.Basic.LabelOn) {
	                    value = element.properties.Basic.LabelOn.selectedValue;
	                    !languageData['Default'] && (languageData['Default'] = {});
	                    languageData['Default'][element.viewName + '_labelon_' + fieldName] = value;
	                }
	                if (element.properties.Basic && element.properties.Basic.LabelOff) {
	                    value = element.properties.Basic.LabelOff.selectedValue;
	                    !languageData['Default'] && (languageData['Default'] = {});
	                    languageData['Default'][element.viewName + '_labeloff_' + fieldName] = value;
	                }
	                if (element.properties.Basic && element.properties.Basic.DisplayLabel) {
	                    value = element.properties.Basic.DisplayLabel.selectedValue;
	                    !languageData['Default'] && (languageData['Default'] = {});
	                    languageData['Default'][element.viewName + '_displayLabel_' + fieldName] = value;
	                }
	                if ((element.properties.Basic && element.properties.Basic.Label) || (element.properties.Basic && element.properties.Basic.Text)) {
	                    if (element.properties.Basic && element.properties.Basic.Label) {
	                        value = element.properties.Basic.Label.selectedValue;
	                    }
	                    else if (element.properties.Basic && element.properties.Basic.Text) {
	                        value = element.properties.Basic.Text.selectedValue;
	                    }
	                    !languageData['Default'] && (languageData['Default'] = {});
	                    languageData['Default'][element.viewName + '_' + fieldName] = value;
	                }
	            }
	        }
	        self.processToUpdateReadOnlyControlProperties(true);
	        this.store.set('Languages', languageData);
	        this.getPrintViewJson(viewData, languageData);
	        self.executeGlobleScript();
	        self.formProperties.theme = self.selectedTheme ? parseInt(self.selectedTheme) : 1;
	        self.formProperties.isThemeChanged = self.themeChanged ? parseInt(self.themeChanged) : 0;
	        self.formProperties.addAppType = self.addAppType ? self.addAppType : 0;
	        self.formProperties.isPuppeteerWithAngularViewEnabled = self.isPuppeteerViewEnabled && JSON.parse(self.isPuppeteerViewEnabled);
	        self.formProperties.isLandscape = self.isLandscape && JSON.parse(self.isLandscape);
	        var data = {
	            "id": this.params.id,
	            "description": this.params.description,
	            "formName": this.params.formName,
	            "formViewJson": JSON.stringify(viewData),
	            "languageData": JSON.stringify(languageData),
	            "formScript": JSON.stringify(self.globleScript),
	            "counter": angular.toJson(this.counterService.counter),
	            "apiConnections": JSON.stringify(self.apiConnections),
	            "formProperties": JSON.stringify(self.formProperties)
	        };
	        var httpParams = {
	            'url': window.properties.service.uri + action_constants_1.Ids.SAVE_DESIGN,
	            'method': 'POST',
	            'data': data,
	            'headers': {
	                'Content-Type': 'application/json;charset=UTF-8'
	            },
	            'withCredentials': true
	        };
	        if (self.config.for == "Direct-Design" || self.config.for == "Marketplace") {
	            httpParams.url = window.properties.service.commonApiUrl + action_constants_1.Ids.SAVE_DESIGN_BY_FORM_TYPE;
	            delete data.id;
	            delete data.description;
	            delete data.formName;
	            data.formTypeId = this.params.id.formTypeId || this.params.id.formTypeID;
	            data.projectId = this.params.id.projectId;
	            httpParams.headers['Content-Type'] = 'application/x-www-form-urlencoded';
	            httpParams.transformRequest = function (obj) {
	                var str = [];
	                for (var p in obj)
	                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
	                return str.join("&");
	            };
	        }
	        this.loading = true;
	        this.$http(httpParams).then(function (response) {
	            self.loading = false;
	            callBack && callBack();
	            var msg = self.$translate.instant('operation.successful');
	            !publish && self.ngNotification.success({ message: msg, positionX: 'center', replaceMessage: true });
	            self.published = false;
	            self.savedChanges = true;
	        }, function errorCallback(response) {
	            var msg = self.$translate.instant('error.while.processing.request');
	            self.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
	            self.loading = false;
	        });
	    };
	    CreateComponent.prototype.closeDropdown = function (event) {
	        var activeElement = document.activeElement;
	        if (activeElement && activeElement instanceof HTMLElement && activeElement.tagName.toLowerCase() == 'select') {
	            activeElement.blur();
	        }
	    };
	    CreateComponent.prototype.hideColorPicker = function ($event) {
	        //trigger spectrum cancel to hide the colorpicker on selecting any form element
	        angular.element('.spectrum-color-picker-container').not('.sp-hidden').find(".sp-cancel").trigger("click");
	    };
	    CreateComponent.prototype.stopPropagation = function (event) {
	        event.stopPropagation();
	    };
	    CreateComponent.prototype.goBack = function () {
	        var msg = this.$translate.instant('warning.for.go.back');
	        if (!this.savedChanges) {
	            this.ngNotification.warning({
	                message: msg, positionX: 'center', replaceMessage: true, templateUrl: "warning_before_leave_template.html", scope: this.$scope
	            });
	        }
	        else {
	            this.$scope.goBack();
	        }
	    };
	    CreateComponent.prototype.openHelpPage = function () {
	        this.$window.open(window.properties.service.helpUrl);
	    };
	    CreateComponent.prototype.openELearning = function () {
	        var commonApi = window.properties.service.commonApiUrl;
	        ;
	        this.$window.open(commonApi.replace('commonapi/', '') + 'adoddle/view/externalapp/elearning.jsp');
	    };
	    CreateComponent.prototype.remove = function (removeAll) {
	        var self = this;
	        var selectedItems = [];
	        if (removeAll) {
	            selectedItems = this.Util.returnSelectedForCopy(this.selectedView.view.controls.A, [], false, true);
	        }
	        else {
	            selectedItems = this.Util.returnSelectedForCopy(this.selectedView.view.controls.A);
	        }
	        selectedItems = selectedItems.filter(function (el) { return el != ""; });
	        this.$scope.removeSelectedOrAll = function () {
	            self.removeSelectedOrAll();
	        };
	        if (selectedItems.length > 0) {
	            if (removeAll) {
	                this.ngNotification.warning({
	                    message: 'warning.before.remove.all', positionX: 'center', replaceMessage: true, templateUrl: "warning_before_delete_all.html", scope: this.$scope
	                });
	            }
	            else {
	                this.ngNotification.warning({
	                    message: 'warning.before.remove.selected', positionX: 'center', replaceMessage: true, templateUrl: "warning_before_delete_selected.html", scope: this.$scope
	                });
	            }
	        }
	        this.selectedControlToRemove = {
	            item: selectedItems
	        };
	    };
	    CreateComponent.prototype.removeSelectedOrAll = function () {
	        var self = this;
	        for (var key in this.selectedControlToRemove.item) {
	            var element = this.selectedControlToRemove.item[key];
	            if (_.get(element, "properties.Basic['Data Field Name'].selectedValue", '') != 'ORI_FORMTITLE') {
	                var list = this.selectedView.view.controls.A;
	                this.controlToRemove = {
	                    item: element,
	                    list: list
	                };
	                this.removeCopied(null, false);
	            }
	        }
	        self.broadcastDesignChange();
	    };
	    CreateComponent.prototype.copy = function (copyAll) {
	        var selectedItems = [];
	        if (copyAll) {
	            selectedItems = this.Util.returnSelectedForCopy(this.selectedView.view.controls.A, [], false, true);
	        }
	        else {
	            selectedItems = this.Util.returnSelectedForCopy(this.selectedView.view.controls.A);
	        }
	        selectedItems = selectedItems.filter(function (el) { return el != ""; });
	        this.copiedItems = angular.copy(selectedItems);
	        this.ngNotification.success({ message: selectedItems.length + (selectedItems.length <= 1 ? ' item copied.' : ' items copied.'), positionX: 'center', replaceMessage: true });
	    };
	    CreateComponent.prototype.paste = function () {
	        var _this = this;
	        var self = this;
	        var copiedItems = angular.copy(this.copiedItems);
	        for (var i = 0; i < copiedItems.length; i++) {
	            var field = copiedItems[i];
	            field.selected = false;
	            var fieldName = _.get(copiedItems[i], 'properties.Basic["Field Name"].selectedValue', '');
	            if (copiedItems[i].uid && copiedItems[i].type == 'ViewAssociations') {
	                this.convertToReadOnly(copiedItems[i]);
	            }
	            if (copiedItems[i].uid && copiedItems[i].type == "RepeatingTable") {
	                this.Util.accessRepeatingTableElements(field, function (elems) {
	                    for (var i_2 = 0; i_2 < elems.length; i_2++) {
	                        if (elems[i_2].type == 'ViewAssociations') {
	                            self.convertToReadOnly(elems[i_2]);
	                        }
	                    }
	                });
	                field.copiedFromRepeatingTable = fieldName;
	                this.addFlagIfInlineAssocExist(field);
	            }
	            if (copiedItems[i].uid && (copiedItems[i].type == "Table" || copiedItems[i].type == "Layout")) {
	                if (copiedItems[i].type == "Table") {
	                    this.Util.accessTableElements(field, function (elems) {
	                        for (var i_3 = 0; i_3 < elems.length; i_3++) {
	                            if (elems[i_3].type == 'ViewAssociations') {
	                                self.convertToReadOnly(elems[i_3]);
	                            }
	                        }
	                    });
	                }
	                if (copiedItems[i].type == "Layout") {
	                    this.Util.accessLayoutElements(field, function (elems) {
	                        for (var i_4 = 0; i_4 < elems.length; i_4++) {
	                            if (elems[i_4].type == 'ViewAssociations') {
	                                self.convertToReadOnly(elems[i_4]);
	                            }
	                        }
	                    });
	                }
	                this.addFlagIfInlineAssocExist(field);
	            }
	            if (copiedItems[i].uid && (copiedItems[i].type == "InlineAssocFiles" || copiedItems[i].type == "InlineAssocApps")) {
	                field.copiedFromInlieAssoc = fieldName;
	            }
	            if (field.parent) {
	                delete field.parent;
	            }
	            if (copiedItems[i].type != 'ViewAssociations') {
	                this.updateUid(field);
	            }
	        }
	        if (this.selectedItemDomain && this.selectedItemDomain.length && this.selectedItemView == this.selectedView.view.viewName) {
	            copiedItems.forEach(function (copiedItem, i) {
	                _this.selectedItemDomain.splice(_this.selectedItemIndex + i + 1, 0, copiedItem);
	            }, this);
	        }
	        else {
	            this.selectedView.view.controls.A = this.selectedView.view.controls.A.concat(copiedItems);
	        }
	        this.broadcastDesignChange();
	    };
	    CreateComponent.prototype.addFlagIfInlineAssocExist = function (field) {
	        for (var _i = 0, _a = field.data; _i < _a.length; _i++) {
	            var el = _a[_i];
	            if (el.elems) {
	                var inlineControl = el.elems[0][0];
	                if (inlineControl && inlineControl.uid && (inlineControl.type == "InlineAssocFiles" || inlineControl.type == "InlineAssocApps")) {
	                    inlineControl.copiedFromInlieAssoc = _.get(inlineControl, 'properties.Basic["Field Name"].selectedValue', '');
	                }
	                if (inlineControl && inlineControl.uid && (inlineControl.type == "RepeatingTable" || inlineControl.type == "Table" || inlineControl.type == "Layout")) {
	                    this.addFlagIfInlineAssocExist(inlineControl);
	                }
	            }
	            else {
	                for (var _b = 0, el_1 = el; _b < el_1.length; _b++) {
	                    var item = el_1[_b];
	                    var inlineControl = item.elems[0][0];
	                    if (inlineControl && inlineControl.uid && (inlineControl.type == "InlineAssocFiles" || inlineControl.type == "InlineAssocApps")) {
	                        inlineControl.copiedFromInlieAssoc = _.get(inlineControl, 'properties.Basic["Field Name"].selectedValue', '');
	                    }
	                    if (inlineControl && inlineControl.uid && (inlineControl.type == "RepeatingTable" || inlineControl.type == "Table" || inlineControl.type == "Layout")) {
	                        this.addFlagIfInlineAssocExist(inlineControl);
	                    }
	                }
	            }
	        }
	    };
	    CreateComponent.prototype.convertToCalculatedField = function (field, readOnly, viewName, languageData) {
	        if (readOnly === void 0) { readOnly = false; }
	        var self = this;
	        var fieldName = _.get(field, 'properties.Basic["Field Name"].selectedValue', '');
	        if (fieldName !== '') {
	            field.pasteAsCalculatedFrom = fieldName;
	        }
	        if (field.type == 'Attachment' || field.type == 'Image' || field.type == 'Label' || field.type == 'Button' || field.type == 'SiteLocationButton' || field.type == 'Hyperlink' || field.type == 'InlineAssocFiles' || field.type == 'InlineAssocApps' || field.type == 'ViewAssociations') {
	            self.convertToReadOnly(field);
	            return;
	        }
	        var readOnlyField = angular.copy(this.models.items.filter(function (val) { return val.type == "Display field"; })[0]);
	        self.resetsEventLogic(field.properties);
	        if (field.parent) {
	            delete field.parent;
	        }
	        _.set(field, 'properties.Display.Hidden.selectedValue', false);
	        _.set(field, 'properties.Events.Name.hideSection', true);
	        var controlFieldName = '';
	        switch (field.type) {
	            case 'Layout':
	                controlFieldName = _.get(field, "properties.Basic['Field Name'].selectedValue", '') + '_Copy';
	                _.set(field, 'properties.Basic["Field Name"].selectedValue', controlFieldName);
	                _.set(field, 'properties.Basic["Field Name"].prevSelectedValue', controlFieldName);
	                field.uid = self.Util.getGUID();
	                self.Util.accessLayoutElements(field, function (elems) {
	                    for (var i = 0; i < elems.length; i++) {
	                        self.convertToCalculatedField(elems[i], readOnly, viewName, languageData);
	                    }
	                });
	                break;
	            case 'Table':
	                controlFieldName = _.get(field, "properties.Basic['Field Name'].selectedValue", '') + '_Copy';
	                _.set(field, 'properties.Basic["Field Name"].selectedValue', controlFieldName);
	                _.set(field, 'properties.Basic["Field Name"].prevSelectedValue', controlFieldName);
	                field.uid = self.Util.getGUID();
	                self.Util.accessTableElements(field, function (elems) {
	                    for (var i = 0; i < elems.length; i++) {
	                        self.convertToCalculatedField(elems[i], readOnly, viewName, languageData);
	                    }
	                });
	                break;
	            case 'RepeatingTable':
	                var rptFieldName = _.get(field, "properties.Basic['Field Name'].selectedValue", '');
	                controlFieldName = rptFieldName + '_Copy';
	                _.set(field, 'properties.Basic["Field Name"].selectedValue', controlFieldName);
	                _.set(field, 'properties.Basic["Field Name"].prevSelectedValue', controlFieldName);
	                _.set(field, 'properties.Basic["Data Field Name"].hidden', true);
	                _.set(field, 'properties.Basic.Insert_Button_Text.hidden', true);
	                _.set(field, 'properties.Basic.Columns.hidden', true);
	                _.set(field, 'properties.Basic.Include_Header.hidden', true);
	                _.set(field, 'properties.Basic.Include_Footer.hidden', true);
	                _.set(field, 'properties.Basic.Insert_Button_Text.selectedValue', '');
	                _.set(field, 'properties.Basic.Value', {
	                    name: 'value',
	                    selectedValue: '{{' + rptFieldName + '}}',
	                    type: 'textbox',
	                    hidden: true,
	                    disable: true
	                });
	                _.set(field, 'properties.Basic.DSName', {
	                    selectedValue: rptFieldName,
	                    hidden: true
	                });
	                field.uid = self.Util.getGUID();
	                field.derivedControlType = field.type;
	                field.derivedFromFieldName = rptFieldName;
	                self.Util.accessRepeatingTableElements(field, function (elems) {
	                    for (var i = 0; i < elems.length; i++) {
	                        self.convertToCalculatedField(elems[i], readOnly, viewName, languageData);
	                    }
	                });
	                break;
	            case 'Section':
	                controlFieldName = _.get(field, "properties.Basic['Field Name'].selectedValue", '') + '_Copy';
	                _.set(field, 'properties.Basic["Field Name"].selectedValue', controlFieldName);
	                _.set(field, 'properties.Basic["Field Name"].prevSelectedValue', controlFieldName);
	                field.uid = self.Util.getGUID();
	                self.Util.accessSectionElements(field, function (elems) {
	                    for (var i = 0; i < elems.length; i++) {
	                        self.convertToCalculatedField(elems[i], readOnly, viewName, languageData);
	                    }
	                });
	                break;
	            case 'Line':
	                _.set(field, 'properties.Display.Name.hideSection', true);
	                field.uid = self.Util.getGUID();
	                field.viewName = viewName;
	                break;
	            case 'Map':
	                readOnlyField.mapType = _.get(field, 'properties.Basic.Type.selectedValue', '35');
	            default:
	                _.set(readOnlyField, 'readOnly', readOnly);
	                _.set(readOnlyField, 'autoGenerated', true);
	                _.set(readOnlyField, 'properties.Display.Hidden.selectedValue', false);
	                _.set(readOnlyField, 'pasteAsCalculated', true);
	                _.set(readOnlyField, 'forceToReadOnly', true);
	                var fieldName_1 = field.properties.Basic['Field Name'].selectedValue;
	                var dataFieldName = field.properties.Basic && field.properties.Basic['Data Field Name'] && field.properties.Basic['Data Field Name'].selectedValue || fieldName_1;
	                if (readOnly) {
	                    readOnlyField.properties.Basic['Field Name'].selectedValue = fieldName_1;
	                    readOnlyField.properties.Basic['Field Name'].prevSelectedValue = fieldName_1;
	                    readOnlyField.properties.Basic['Field Name'].disable = true;
	                    readOnlyField.properties.Basic.Value.disable = true;
	                    readOnlyField.properties.Basic.Value.addOnButton = '';
	                }
	                else {
	                    var cnt = 0;
	                    if ((field.type.toLowerCase() == "dropdown" &&
	                        field.properties.Advance["App Status"] &&
	                        field.properties.Advance["App Status"].selectedValue == true) ||
	                        field.type == "Datepicker" &&
	                            field.properties.Advance["Closed Date"] &&
	                            field.properties.Advance["Closed Date"].selectedValue == true) {
	                        if (this.counterService.counter) {
	                            if (this.counterService.counter[field.type] == undefined) {
	                                this.counterService.counter[field.type] = 0;
	                            }
	                            this.counterService.counter[field.type]++;
	                            cnt = this.counterService.counter[field.type];
	                        }
	                        var type = this.Util.replaceAllMatches(field.type, '-', '_');
	                        readOnlyField.properties.Basic['Field Name'].selectedValue = ("" + type + (cnt ? ('_' + cnt) : '')) + '_Copy';
	                        readOnlyField.properties.Basic['Field Name'].prevSelectedValue = readOnlyField.properties.Basic['Field Name'].selectedValue;
	                    }
	                    else {
	                        readOnlyField.properties.Basic['Field Name'].selectedValue = fieldName_1 + '_Copy';
	                        readOnlyField.properties.Basic['Field Name'].prevSelectedValue = readOnlyField.properties.Basic['Field Name'].selectedValue;
	                    }
	                    if (field.properties.Basic.DSName && field.properties.Basic.DSName.selectedValue) {
	                        readOnlyField.properties.Basic.DSName.selectedValue = field.properties.Basic.DSName.selectedValue;
	                    }
	                    else {
	                        readOnlyField.properties.Basic.DSName.selectedValue = dataFieldName;
	                    }
	                }
	                if ((field.type == "Dropdown" || field.type == "MultiDropdown") && field.forceToReadOnly) {
	                    var sourceType = _.get(field, 'properties["Data Source"].Source.selectedValue', '');
	                    if (sourceType == 4) {
	                        var fixedFieldUrl = _.get(field, "properties['Data Source']['fixedFieldUrl'].selectedValue", {});
	                        if (typeof fixedFieldUrl != 'string') {
	                            readOnlyField.properties.Basic.DSName.selectedValue = fixedFieldUrl.value;
	                        }
	                    }
	                }
	                if (field.type == "Datepicker") {
	                    readOnlyField.properties.Basic.RefFieldName = field.properties.Basic['Field Name'].selectedValue;
	                }
	                readOnlyField.properties.Basic.Value.selectedValue = '{{' + dataFieldName + '}}';
	                var label = field.properties.Basic.Label.selectedValue;
	                readOnlyField.properties.Basic.Label.selectedValue = label;
	                readOnlyField.uid = self.Util.getGUID();
	                readOnlyField.derivedControlType = field.type;
	                readOnlyField.derivedFromFieldName = dataFieldName;
	                if (field.type == "Dropdown" || field.type == "MultiDropdown") {
	                    var sourceType = _.get(field, 'properties["Data Source"].Source.selectedValue', '');
	                    if (sourceType == 5) {
	                        var customAttr = _.get(field, "properties['Data Source']['customAttr'].selectedValue", '');
	                        if (customAttr) {
	                            readOnlyField.derivedFromCA = customAttr;
	                        }
	                    }
	                }
	                this.copyLabels(field.viewName, field.uid, readOnlyField.uid, viewName, languageData);
	                if (field.properties.Style && readOnlyField.properties.Style) {
	                    angular.merge(readOnlyField.properties.Style, field.properties.Style);
	                }
	                for (var key in field) {
	                    if (key !== 'pasteAsCalculatedFrom') {
	                        delete field[key];
	                    }
	                }
	                field.viewName = viewName;
	                angular.merge(field, readOnlyField);
	                break;
	        }
	    };
	    CreateComponent.prototype.pasteAsReadOnly = function () {
	        var _this = this;
	        var copiedItems = angular.copy(this.copiedItems);
	        for (var i = 0; i < copiedItems.length; i++) {
	            copiedItems[i].selected = false;
	            var field = copiedItems[i];
	            var fieldName = _.get(copiedItems[i], 'properties.Basic["Field Name"].selectedValue', '');
	            if (copiedItems[i].uid && copiedItems[i].type == "RepeatingTable") {
	                this.addFlagIfInlineAssocExist(field);
	            }
	            if (copiedItems[i].uid && (copiedItems[i].type == "Table" || copiedItems[i].type == "Layout")) {
	                this.addFlagIfInlineAssocExist(field);
	            }
	            if (copiedItems[i].uid && (copiedItems[i].type == "InlineAssocFiles" || copiedItems[i].type == "InlineAssocApps")) {
	                field.copiedFromInlieAssoc = fieldName;
	            }
	            this.convertToReadOnly(copiedItems[i]);
	        }
	        if (this.selectedItemDomain && this.selectedItemDomain.length && this.selectedItemView == this.selectedView.view.viewName) {
	            copiedItems.forEach(function (copiedItem, i) {
	                _this.selectedItemDomain.splice(_this.selectedItemIndex + i + 1, 0, copiedItem);
	            }, this);
	        }
	        else {
	            this.selectedView.view.controls.A = this.selectedView.view.controls.A.concat(copiedItems);
	        }
	        this.broadcastDesignChange();
	        setTimeout(function () {
	            for (var i = 0; i < copiedItems.length; i++) {
	                var textareaId = copiedItems[i].uid;
	                var textele = angular.element("textarea[textarea-id=" + textareaId + "]");
	                for (var j = 0; j < textele.length; j++) {
	                    textele[j].style.height = 35 + 'px';
	                    textele[j].style.height = textele[j].scrollHeight + 'px';
	                    textele[j].style.whiteSpace = 'normal';
	                }
	            }
	        }, 100);
	    };
	    CreateComponent.prototype.convertToReadOnly = function (field, isPaste) {
	        var self = this;
	        field.forceToReadOnly = true;
	        var fieldName = _.get(field, 'properties.Basic["Field Name"].selectedValue', '');
	        if (fieldName !== '') {
	            field.copiedFrom = fieldName;
	        }
	        if (field.parent) {
	            delete field.parent;
	        }
	        switch (field.type) {
	            case 'Layout':
	                self.Util.accessLayoutElements(field, function (elems) {
	                    for (var i = 0; i < elems.length; i++) {
	                        self.convertToReadOnly(elems[i], isPaste);
	                    }
	                });
	                break;
	            case 'Table':
	                self.Util.accessTableElements(field, function (elems) {
	                    for (var i = 0; i < elems.length; i++) {
	                        self.convertToReadOnly(elems[i], isPaste);
	                    }
	                });
	                break;
	            case 'RepeatingTable':
	                self.Util.accessRepeatingTableElements(field, function (elems) {
	                    for (var i = 0; i < elems.length; i++) {
	                        self.convertToReadOnly(elems[i], isPaste);
	                    }
	                });
	                break;
	            case 'Section':
	                self.Util.accessSectionElements(field, function (elems) {
	                    for (var i = 0; i < elems.length; i++) {
	                        self.convertToReadOnly(elems[i], isPaste);
	                    }
	                });
	                break;
	        }
	        if (field.type != 'Line') {
	            self.Util.markAllPropertiesAsReadonly(field, field.properties);
	        }
	    };
	    CreateComponent.prototype.resetsEventLogic = function (properties) {
	        var eventsDetail = _.get(properties, 'Events', {});
	        for (var event_2 in eventsDetail) {
	            if (event_2 != 'Name' && event_2 != 'forceToDisabled') {
	                eventsDetail[event_2].selectedValueReadonly = eventsDetail[event_2].selectedValue;
	                eventsDetail[event_2].disable = true;
	                eventsDetail[event_2].selectedValue = '';
	            }
	        }
	    };
	    CreateComponent.prototype.pasteAsCalculatedField = function () {
	        var _this = this;
	        var copiedItems = angular.copy(this.copiedItems);
	        var viewName = this.selectedView.view.viewName || '';
	        for (var i = 0; i < copiedItems.length; i++) {
	            copiedItems[i].selected = false;
	            this.convertToCalculatedField(copiedItems[i], undefined, viewName, undefined);
	        }
	        if (this.selectedItemDomain && this.selectedItemDomain.length && this.selectedItemView == this.selectedView.view.viewName) {
	            copiedItems.forEach(function (copiedItem, i) {
	                _this.selectedItemDomain.splice(_this.selectedItemIndex + i + 1, 0, copiedItem);
	            }, this);
	        }
	        else {
	            this.selectedView.view.controls.A = this.selectedView.view.controls.A.concat(copiedItems);
	        }
	        this.broadcastDesignChange();
	    };
	    /**
	     * @brief      Open model dialog which contains code editor as body content
	     *
	     * @return     null
	     */
	    CreateComponent.prototype.openCodeEditorDialog = function () {
	        var self = this;
	        var codeEditorModalInstance = self.$uibModal.open({
	            animation: true,
	            ariaLabelledBy: 'modal-title',
	            ariaDescribedBy: 'modal-body',
	            templateUrl: 'globleCodeEditor.html',
	            backdrop: 'static',
	            keyboard: false,
	            controllerAs: '$ctrl',
	            windowClass: 'code-editor-modal',
	            appendTo: angular.element(self.$document[0].querySelector('.canvas')),
	            controller: function () {
	                var _this = this;
	                this.maximized = false;
	                this.showSpinner = true;
	                self.maximizedCodeEditor = false;
	                angular.element(window).on('resize', function () {
	                    self.codeEditorResizeHandler();
	                });
	                var globleMethodsDetails = {};
	                window.setTimeout(function () {
	                    self.codeEditorResizeHandler();
	                    self.codeEditor = angular.element(self.$document[0].querySelector('#globleBlocklyCodeEditor')).data('$asiteBlocklyController');
	                    self.codeEditor.setVal(self.globleScript.xmlVal);
	                    globleMethodsDetails = self.codeEditor.getGlobleMethodsDetail();
	                }, 10);
	                document.body.style.overflow = 'hidden';
	                this.isPasteDisabled = function () {
	                    if (self.$window.localStorage.getItem('domXml')) {
	                        return false;
	                    }
	                    return true;
	                };
	                this.pasteGlobalBlockly = function () {
	                    try {
	                        self.codeEditor = angular.element(self.$document[0].querySelector('#globleBlocklyCodeEditor')).data('$asiteBlocklyController');
	                        var newDomBlock = self.Util.getBlocklyBlock();
	                        self.codeEditor.setVal(newDomBlock);
	                    }
	                    catch (error) {
	                        self.ngNotification.error({ message: error.message.split('and')[0], positionX: 'center', replaceMessage: true });
	                    }
	                };
	                this.save = function () {
	                    //Read and Validate value from Blockly Eitor and save it
	                    self.globleScript = self.codeEditor.getVal(true);
	                    if (self.globleScript && self.globleScript.isAPIInProgress) {
	                        self.ngNotification.error({ message: 'API call is in progress ', positionX: 'center', replaceMessage: true });
	                        return;
	                    }
	                    self.executeGlobleScript();
	                    self.replaceUpdatedGlobleMethodName(globleMethodsDetails, self.codeEditor.getGlobleMethodsDetail());
	                    codeEditorModalInstance.close();
	                    self.destroyCodeEditor();
	                };
	                /**
	                 * @brief      Close dialog
	                 * @return     NULL
	                 */
	                this.cancel = function () {
	                    // codeEditorModalInstance.dismiss('cancel');
	                    codeEditorModalInstance.close(false);
	                    self.destroyCodeEditor();
	                };
	                this.maximize = function () {
	                    _this.maximized = true;
	                    self.maximizedCodeEditor = true;
	                    self.codeEditorResizeHandler();
	                };
	                this.minimize = function () {
	                    _this.maximized = false;
	                    self.maximizedCodeEditor = false;
	                    self.codeEditorResizeHandler();
	                };
	            }
	        });
	    };
	    CreateComponent.prototype.replaceUpdatedGlobleMethodName = function (oldMethods, newMethods) {
	        var _this = this;
	        var _loop_6 = function(methodId) {
	            if (newMethods[methodId] != oldMethods[methodId]) {
	                var controls = this_2.Util.getAllControls();
	                //Replace in controls events code editor
	                controls.forEach(function (control) {
	                    if (control.properties && control.properties.Events) {
	                        for (var event_3 in control.properties.Events) {
	                            var eventDetail = control.properties.Events[event_3];
	                            if (event_3 != 'Name' && eventDetail.selectedValue) {
	                                if (newMethods[methodId]) {
	                                    eventDetail.xmlValue = _this.Util.replaceAllMatches(eventDetail.xmlValue, '"fn_' + oldMethods[methodId] + '"', '"fn_' + newMethods[methodId] + '"');
	                                    eventDetail.xmlValue = _this.Util.replaceAllMatches(eventDetail.xmlValue, ">" + oldMethods[methodId] + "<", ">" + newMethods[methodId] + "<");
	                                    var oldVal = oldMethods[methodId].replace(/ /g, "_");
	                                    var newVal = newMethods[methodId].replace(/ /g, "_");
	                                    eventDetail.selectedValue = _this.Util.replaceAllMatches(eventDetail.selectedValue, '(' + oldVal + ' && ' + oldVal + '())', '(' + newVal + ' && ' + newVal + '())');
	                                }
	                                else {
	                                    eventDetail.xmlValue = _this.Util.replaceAllMatches(eventDetail.xmlValue, '"fn_' + oldMethods[methodId] + '"', '"fn_noopMethod"');
	                                    eventDetail.xmlValue = _this.Util.replaceAllMatches(eventDetail.xmlValue, ">" + oldMethods[methodId] + "<", ">noopMethod<");
	                                    var oldVal = oldMethods[methodId].replace(/ /g, "_");
	                                    eventDetail.selectedValue = _this.Util.replaceAllMatches(eventDetail.selectedValue, '(' + oldVal + ' && ' + oldVal + '());', '');
	                                }
	                            }
	                        }
	                    }
	                });
	            }
	        };
	        var this_2 = this;
	        for (var methodId in oldMethods) {
	            _loop_6(methodId);
	        }
	    };
	    CreateComponent.prototype.codeEditorResizeHandler = function () {
	        var width = (this.maximizedCodeEditor) ? window.innerWidth : Math.min(1280, window.innerWidth);
	        var height = (this.maximizedCodeEditor) ? window.innerHeight : Math.min(600, window.innerHeight);
	        var margin = (this.maximizedCodeEditor) ? 10 : (width <= 768) ? 10 : 30;
	        angular.element('.canvas .code-editor-modal .modal-dialog').css({
	            'width': (width - (margin * 2)) + 'px',
	            'height': (height - (margin * 2)) + 'px',
	            'marginTop': margin + 'px',
	            'marginBottom': margin + 'px'
	        });
	    };
	    /**
	     * @brief      Destroy existing code editer intanceview.
	     *
	     * @return     null
	     */
	    CreateComponent.prototype.destroyCodeEditor = function () {
	        var self = this;
	        document.body.style.overflow = '';
	        self.codeEditor.destroyCodeEditor();
	        self.codeEditor = undefined;
	        angular.element(window).off('resize');
	    };
	    CreateComponent.prototype.updateUid = function (field) {
	        var self = this, childElems = [];
	        var viewName = this.selectedView.view.viewName || '';
	        var newUid = self.Util.getGUID();
	        switch (field.type) {
	            case 'Layout':
	                self.Util.accessLayoutElements(field, function (elems) {
	                    for (var i = 0; i < elems.length; i++) {
	                        if (elems[i].type != 'ViewAssociations') {
	                            self.updateUid(elems[i]);
	                        }
	                    }
	                });
	                if (field.properties.Basic['Field Name'] && field.properties.Basic['Field Name'].selectedValue) {
	                    field.properties.Basic['Field Name'].selectedValue = field.properties.Basic['Field Name'].selectedValue + '_Copy';
	                    field.properties.Basic['Field Name'].prevSelectedValue = field.properties.Basic['Field Name'].selectedValue;
	                    this.copyLabels(field.viewName, field.uid, newUid, undefined, undefined);
	                }
	                field.uid = newUid;
	                field.viewName = viewName;
	                break;
	            case 'Table':
	                self.Util.accessTableElements(field, function (elems) {
	                    for (var i = 0; i < elems.length; i++) {
	                        if (elems[i].type != 'ViewAssociations') {
	                            self.updateUid(elems[i]);
	                        }
	                    }
	                });
	                if (field.properties.Basic['Field Name'] && field.properties.Basic['Field Name'].selectedValue) {
	                    field.properties.Basic['Field Name'].selectedValue = field.properties.Basic['Field Name'].selectedValue + '_Copy';
	                    field.properties.Basic['Field Name'].prevSelectedValue = field.properties.Basic['Field Name'].selectedValue;
	                    this.copyLabels(field.viewName, field.uid, newUid, undefined, undefined);
	                }
	                field.uid = newUid;
	                field.viewName = viewName;
	                break;
	            case 'RepeatingTable':
	                childElems = [];
	                self.Util.accessRepeatingTableElements(field, function (elems) {
	                    for (var i = 0; i < elems.length; i++) {
	                        if (elems[i].type != 'ViewAssociations') {
	                            self.updateUid(elems[i]);
	                        }
	                        if (childElems.indexOf(elems[i]) == -1)
	                            childElems.push(elems[i]);
	                    }
	                });
	                this.updateCalUidAry(childElems);
	                field.copiedFromRepeatingTable = field.properties.Basic['Field Name'].selectedValue;
	                if (field.properties.Basic['Field Name'] && field.properties.Basic['Field Name'].selectedValue) {
	                    field.properties.Basic['Field Name'].selectedValue = field.properties.Basic['Field Name'].selectedValue + '_Copy';
	                    field.properties.Basic['Field Name'].prevSelectedValue = field.properties.Basic['Field Name'].selectedValue;
	                    this.copyLabels(field.viewName, field.uid, newUid, undefined, undefined);
	                }
	                field.uid = newUid;
	                field.viewName = viewName;
	                break;
	            case 'Section':
	                self.Util.accessSectionElements(field, function (elems) {
	                    for (var i = 0; i < elems.length; i++) {
	                        if (elems[i].type != 'ViewAssociations') {
	                            self.updateUid(elems[i]);
	                        }
	                    }
	                });
	                if (field.properties.Basic['Field Name'] && field.properties.Basic['Field Name'].selectedValue) {
	                    field.properties.Basic['Field Name'].selectedValue = field.properties.Basic['Field Name'].selectedValue + '_Copy';
	                    field.properties.Basic['Field Name'].prevSelectedValue = field.properties.Basic['Field Name'].selectedValue;
	                    this.copyLabels(field.viewName, field.uid, newUid, undefined, undefined);
	                }
	                field.uid = newUid;
	                field.viewName = viewName;
	                break;
	            default:
	                if (self.Util.controlsWithoutFieldName.indexOf(field.type) == -1) {
	                    field.properties.Basic['Field Name'].selectedValue = field.properties.Basic['Field Name'].selectedValue + '_Copy';
	                    field.properties.Basic['Field Name'].prevSelectedValue = field.properties.Basic['Field Name'].selectedValue;
	                    this.copyLabels(field.viewName, field.uid, newUid, undefined, undefined);
	                }
	                if (field.parent && field.type.toLowerCase() == "display field" && field.properties["Basic"]["DSName"].selectedValue == "calculated") {
	                    field.properties["Basic"].Value.selectedValue = field.properties["Basic"].Value.selectedValue.replace(/\}/g, "_Copy}");
	                    field.properties["Basic"].formula.html = field.properties["Basic"].formula.html.replace(/\}/g, "_Copy}");
	                    field.properties["Basic"]["DSName"].selectedValue = "calculated";
	                }
	                field.uid = newUid;
	                field.viewName = viewName;
	                break;
	        }
	    };
	    CreateComponent.prototype.updateCalUidAry = function (childElems) {
	        if (childElems.length) {
	            var calcField = void 0, existingUidAry = void 0, UidArry_1 = [];
	            for (var c = 0; c < childElems.length; c++) {
	                calcField = childElems[c];
	                if (calcField.type == "Display field" && calcField.properties["Basic"]["DSName"].selectedValue == "calculated") {
	                    var splitAry = calcField.properties["Basic"].Value.selectedValue.split(" "), fieldCount = 0;
	                    var _loop_7 = function(i) {
	                        if (!parseFloat(splitAry[i])) {
	                            fieldCount += 1;
	                            var str_1 = angular.element.trim(splitAry[i].replace("sum(", "").replace(")", "").replace("{", "").replace("}", ""));
	                            childElems.forEach(function (elem) {
	                                if ((elem.type == "Textbox" || elem.type == "Display field") && elem.properties.Basic["Field Name"].selectedValue == str_1) {
	                                    if (UidArry_1.indexOf(elem.uid) == -1)
	                                        UidArry_1.push(elem.uid);
	                                }
	                            });
	                        }
	                    };
	                    for (var i = 0; i < splitAry.length; i++) {
	                        _loop_7(i);
	                    }
	                    calcField.properties["Basic"].formula.uids = UidArry_1;
	                }
	            }
	        }
	    };
	    CreateComponent.prototype.copyLabels = function (refViewName, refUid, newUid, selectedViewName, selectedLanguageData) {
	        var viewName = selectedViewName || this.selectedView.view.viewName;
	        var languageData = selectedLanguageData || this.store.get('Languages');
	        var supportedLanguages = angular.copy(this.Util.supportedLanguages);
	        if (!languageData) {
	            languageData = {};
	            for (var index = 0; index < supportedLanguages.length; index++) {
	                languageData[supportedLanguages[index]['languageId']] = {};
	            }
	        }
	        for (var language in languageData) {
	            if (languageData[language][refViewName + '_' + refUid]) {
	                languageData[language][viewName + '_' + newUid] = languageData[language][refViewName + '_' + refUid];
	            }
	            if (languageData[language][refViewName + '_InlineAssoc_' + refUid]) {
	                languageData[language][viewName + '_InlineAssoc_' + newUid] = languageData[language][refViewName + '_InlineAssoc_' + refUid];
	            }
	        }
	        !selectedLanguageData && this.store.set('Languages', languageData);
	    };
	    CreateComponent.prototype.prepareJsonForHierarchy = function (allAttr) {
	        allAttr = this.Util.getIteams(allAttr);
	        for (var index = 0, hierarchyArray = ["Dropdown", "Checkbox", "MultiDropdown"]; index < allAttr.length; index++) {
	            var parentAttr = allAttr[index];
	            if (hierarchyArray.indexOf(parentAttr.type) > -1) {
	                var currentElement = parentAttr.properties.Basic["Field Name"].selectedValue;
	                this.filterOption.objAttrList[currentElement] = parentAttr;
	                this.filterOption.objRelationList[currentElement] = {};
	                this.filterOption.resetOption[currentElement] = [];
	                var parentList = parentAttr.properties['Data Source'].table.list;
	                for (var cindex = 0; cindex < parentList.length; cindex++) {
	                    if (parentList[cindex]) {
	                        var currentRelation = parentList[cindex].relation || {};
	                        for (var key in currentRelation) {
	                            if (currentRelation.hasOwnProperty(key) && this.filterOption.resetOption[currentElement].indexOf(key) < 0) {
	                                this.filterOption.resetOption[currentElement].push(key);
	                            }
	                            this.filterOption.objRelationList[currentElement][parentList[cindex].Value.name] = currentRelation;
	                        }
	                    }
	                }
	            }
	        }
	        this.onloadFilteroption(this.filterOption.objAttrList);
	    };
	    CreateComponent.prototype.onloadFilteroption = function (objAttr) {
	        for (var key in objAttr) {
	            if (objAttr[key].type == "Dropdown" || objAttr[key].type == "MultiDropdown") {
	                this.setDropDownOption(objAttr[key]);
	            }
	            else {
	                this.setCheckBoxOption(objAttr[key]);
	            }
	        }
	    };
	    CreateComponent.prototype.getDropDownHeight = function (item) {
	        var dh = 'auto', list = item.properties["Data Source"].table.list.length;
	        if (this.external && (list > this.multiHeight)) {
	            dh = this.multiHeight * (this.multiHeight * 2) + 'px';
	        }
	        return angular.merge(this.getIndividualStyleObj(item.properties, 'ControlStyle'), {
	            'min-height': dh
	        });
	    };
	    CreateComponent.prototype.getRadioCheckboxWidth = function (item) {
	        var columnsCount = 1;
	        var columnWidth = '100%';
	        if (item.properties['Basic']['Number']) {
	            columnsCount = item.properties['Basic']['Number'].selectedValue;
	            columnWidth = (100 / columnsCount) + '%';
	        }
	        return columnWidth;
	    };
	    CreateComponent.prototype.getHeightWidthOfToggleSwitch = function (item) {
	        var switchHeight = _.get(item, "properties.Size.Height.selectedValue", 25);
	        return {
	            'width': (switchHeight - 2) + 'px',
	            'height': (switchHeight - 2) + 'px',
	        };
	    };
	    CreateComponent.prototype.linkModelFunc = function (event, url) {
	        event.preventDefault();
	        this.$window.open(url);
	    };
	    CreateComponent.prototype.setDropDownOption = function (parentAttr) {
	        var attrName = parentAttr.properties.Basic["Field Name"].selectedValue;
	        this.resetElement(attrName);
	        if (this.filterOption.objRelationList[attrName] && parentAttr.properties.Basic.Value) {
	            var selectedValue = [];
	            if (angular.isArray(parentAttr.properties.Basic.Value.selectedValue)) {
	                selectedValue = parentAttr.properties.Basic.Value.selectedValue;
	            }
	            else {
	                selectedValue.push(parentAttr.properties.Basic.Value.selectedValue);
	            }
	            for (var index = 0, pcRelation; index < selectedValue.length; index++) {
	                pcRelation = this.filterOption.objRelationList[attrName][selectedValue[index]] || {};
	                if (Object.keys(pcRelation).length == 0) {
	                    this.resetElement(attrName);
	                    break;
	                }
	                else {
	                    for (var key in pcRelation) {
	                        if (!this.filterOption.filterList[key]) {
	                            this.filterOption.filterList[key] = [];
	                        }
	                        for (var i = 0; i < pcRelation[key].length; i++) {
	                            this.filterOption.filterList[key].push(pcRelation[key][i]);
	                        }
	                    }
	                }
	            }
	        }
	    };
	    CreateComponent.prototype.setCheckBoxOption = function (parentAttr) {
	        var attrName = parentAttr.properties.Basic["Field Name"].selectedValue;
	        this.resetElement(attrName);
	        if (this.filterOption.objRelationList[attrName]) {
	            var selectedValue = [];
	            for (var index = 0, list = parentAttr.properties["Data Source"].table.list; index < list.length; index++) {
	                if (list[index].selectedValue.name) {
	                    selectedValue.push(list[index].Value.name);
	                }
	            }
	            for (var index = 0, pcRelation; index < selectedValue.length; index++) {
	                pcRelation = this.filterOption.objRelationList[attrName][selectedValue[index]] || {};
	                if (Object.keys(pcRelation).length == 0) {
	                    this.resetElement(attrName);
	                    break;
	                }
	                else {
	                    for (var key in pcRelation) {
	                        if (!this.filterOption.filterList[key]) {
	                            this.filterOption.filterList[key] = [];
	                        }
	                        for (var i = 0; i < pcRelation[key].length; i++) {
	                            this.filterOption.filterList[key].push(pcRelation[key][i]);
	                        }
	                    }
	                }
	            }
	        }
	    };
	    CreateComponent.prototype.resetElement = function (attrName) {
	        var pcRelation = this.filterOption.resetOption[attrName] || [];
	        for (var index = 0; index < pcRelation.length; index++) {
	            this.filterOption.filterList[pcRelation[index]] = [];
	        }
	    };
	    CreateComponent.prototype.filterElementOption = function (parentAttr, list) {
	        if (list.id && this.filterOption.filterList && Object.keys(this.filterOption.filterList).length > 0) {
	            var filterList = this.filterOption.filterList[parentAttr.properties.Basic["Field Name"].selectedValue] || [];
	            if (filterList.length > 0 && filterList.indexOf(list.id) < 0) {
	                if (parentAttr.type == "Checkbox") {
	                    list.selectedValue.name = false;
	                }
	                return true;
	            }
	            else {
	                return false;
	            }
	        }
	    };
	    CreateComponent.prototype.hasScriptLogic = function (events) {
	        if (!events) {
	            return false;
	        }
	        var scriptLogic = false;
	        for (var event_4 in events) {
	            if (!scriptLogic && event_4 != 'Name' && event_4 != 'forceToDisabled' && (events[event_4].selectedValue || events[event_4].selectedValueReadonly)) {
	                scriptLogic = true;
	            }
	        }
	        return scriptLogic;
	    };
	    CreateComponent.prototype.getDatePickerOptions = function (properties) {
	        properties.Basic['Display Format'].selectedValue = this.getDisplayFormat(properties);
	        var dateTimeFormat = properties.Basic['Display Format'].selectedValue == 'default' ? this.Util.getNewDateFormat('default') : properties.Basic['Display Format'].selectedValue;
	        if (properties.Basic['Time'] && properties.Basic['Time'].selectedValue) {
	            dateTimeFormat = properties.Basic['Time Format'].selectedValue == 'true' ? dateTimeFormat + ' hh:mm A' : dateTimeFormat + ' HH:mm';
	        }
	        this.datePickerOptions.format = dateTimeFormat;
	        return this.datePickerOptions;
	    };
	    CreateComponent.prototype.getDisplayFormat = function (properties) {
	        try {
	            var oldOptionsArr = this.oldformatOptions;
	            var selectedObj = void 0, newDisplayFormat = properties.Basic['Display Format'].selectedValue;
	            if (newDisplayFormat != 'default') {
	                for (var i = 0; i < oldOptionsArr.length; i++) {
	                    if ((properties.Basic['Display Format'].selectedValue) == oldOptionsArr[i].value) {
	                        selectedObj = oldOptionsArr[i];
	                        break;
	                    }
	                }
	                if (selectedObj) {
	                    for (var j = 0; j < properties.Basic['Display Format'].options.length; j++) {
	                        if (selectedObj.key == properties.Basic['Display Format'].options[j].key) {
	                            newDisplayFormat = properties.Basic['Display Format'].options[j].value;
	                        }
	                    }
	                }
	            }
	            return newDisplayFormat;
	        }
	        catch (e) {
	            return properties.Basic['Display Format'].selectedValue;
	        }
	    };
	    CreateComponent.prototype.getParsedDate = function (properties) {
	        var dateTimeFormat = properties.Basic['Display Format'].selectedValue == 'default' ? this.Util.getNewDateFormat('default') : properties.Basic['Display Format'].selectedValue;
	        if (properties.Basic['Time'] && properties.Basic['Time'].selectedValue) {
	            dateTimeFormat = properties.Basic['Time Format'].selectedValue == 'true' ? dateTimeFormat + ' hh:mm A' : dateTimeFormat + ' HH:mm';
	        }
	        var itemVal = properties.Basic['Default'].selectedValue;
	        itemVal = moment(itemVal, dateTimeFormat).toDate();
	        if (itemVal != 'Invalid Date') {
	            properties.Basic['Default'].dateObj = moment(itemVal, dateTimeFormat).toDate();
	        }
	        else if (properties.Basic['Default'].selectedValue == '' || properties.Basic['Default'].selectedValue == undefined) {
	            properties.Basic['Default'].dateObj = '';
	        }
	    };
	    CreateComponent.prototype.showDatepicker = function ($event) {
	        var myElem = angular.element($event.currentTarget.previousElementSibling);
	        if (myElem.length > 0)
	            myElem.datetimepicker('show');
	    };
	    CreateComponent.prototype.checkValidInput = function (event, item) {
	        if (event.currentTarget) {
	            if (event.currentTarget.className.indexOf('ng-invalid') != -1) {
	                item.properties.Basic.Default.selectedValue = null;
	            }
	        }
	    };
	    CreateComponent.prototype.checkValidInputDate = function (event, properties) {
	        var dateTimeFormat = properties.Basic['Display Format'].selectedValue == 'default' ? this.Util.getNewDateFormat('default') : properties.Basic['Display Format'].selectedValue;
	        if (properties.Basic['Time'] && properties.Basic['Time'].selectedValue) {
	            dateTimeFormat = properties.Basic['Time Format'].selectedValue == 'true' ? dateTimeFormat + ' hh:mm A' : dateTimeFormat + ' HH:mm';
	        }
	        var itemVal = properties.Basic['Default'].selectedValue;
	        itemVal = new Date(itemVal);
	        if (itemVal == 'Invalid Date') {
	            if (properties.Basic['Default']['dateObj']) {
	                properties.Basic['Default'].selectedValue = moment(properties.Basic['Default']['dateObj']).format(dateTimeFormat);
	            }
	            else {
	                properties.Basic['Default'].selectedValue = '';
	            }
	        }
	        else if (itemVal != 'Invalid Date' && properties.Basic['Default']['dateObj']) {
	            properties.Basic['Default'].selectedValue = moment(properties.Basic['Default']['dateObj']).format(dateTimeFormat);
	        }
	    };
	    CreateComponent.prototype.updatePickerDisplay = function (event, item) {
	        event.preventDefault();
	        var dateElemPicker = angular.element(event.currentTarget);
	        dateElemPicker.data("DateTimePicker").keyBinds({ 't': null });
	        var dateobj = item.properties['Basic']['Default'].dateObj;
	        var curFormat = dateElemPicker.data("DateTimePicker").options().format;
	        if (dateobj) {
	            if ((item.properties['Basic']['Default'].selectedValue && item.properties['Basic']['Default'].selectedValue.length) == curFormat.length) {
	                dateElemPicker.data('DateTimePicker').date(dateobj);
	            }
	        }
	    };
	    CreateComponent.prototype.setTimeFormat = function (item) {
	        var timeFormat = item.properties['Basic']['Time Format'].selectedValue == 'true' ? 'hh:mm a' : 'HH:mm';
	        item.timeFormat = timeFormat;
	    };
	    CreateComponent.prototype.getRows = function (properties) {
	        var columnsCount = properties['Basic']['Number'] ? properties['Basic']['Number'].selectedValue : 1;
	        if (columnsCount <= 0)
	            columnsCount = 1;
	        var rowsCount = properties['Data Source'].table.list.length;
	        rowsCount = Math.ceil(rowsCount / columnsCount);
	        return rowsCount;
	    };
	    CreateComponent.prototype.getListItems = function (item, properties) {
	        var selectedItem = item;
	        var columnCount = properties['Basic']['Number'] ? properties['Basic']['Number'].selectedValue : 1;
	        if (columnCount <= 0)
	            columnCount = 1;
	        var rows = this.getRows(properties);
	        var items = [];
	        for (var i = 0; i < rows; i++) {
	            var rowItems = [];
	            for (var j = 0; j < columnCount; j++) {
	                if (properties['Data Source'].table.list[j + (i * columnCount)]) {
	                    rowItems.push(properties['Data Source'].table.list[j + (i * columnCount)]);
	                }
	            }
	            items.push(rowItems);
	        }
	        selectedItem.optionsList = items;
	    };
	    CreateComponent.prototype.getTimePickerOptions = function (properties) {
	        this.timePickerOptions.showMeridian = properties['Basic']['Time Format'].selectedValue;
	        return this.timePickerOptions;
	    };
	    CreateComponent.prototype.getTimeFormat = function (properties) {
	        this.timeFormat = properties['Basic']['Time Format'].selectedValue == true ? 'hh:MM A' : 'HH:mm';
	        return this.timeFormat;
	    };
	    CreateComponent.prototype.getIndividualStyleObj = function (properties, item) {
	        if (!properties.ControlStyle && !properties['InsertButtonStyle']) {
	            return {};
	        }
	        return this.getStyleObject(properties, item);
	    };
	    CreateComponent.prototype.getStyleObject = function (properties, item) {
	        var props = properties[item];
	        var readOnlyField = false;
	        ;
	        if (properties.Display['Read-only']) {
	            readOnlyField = properties.Display['Read-only'].selectedValue;
	        }
	        var styleProperties = angular.merge({}, props['font-style-group'], props['style-group'], props['border-style-group']);
	        var styleObject = {
	            'font-family': _.get(styleProperties.members, "['font-family']['selectedValue']", 'initial'),
	            'font-size': _.get(styleProperties.members, "['font-size']['selectedValue']", '16') + 'px',
	            'font-weight': _.get(styleProperties.members, "['bold']['selectedValue']", false) ? 'bold' : 'normal',
	            'font-style': _.get(styleProperties.members, "['italic']['selectedValue']", false) ? 'italic' : 'normal',
	            'text-decoration': _.get(styleProperties.members, "['underline']['selectedValue']", false) ? 'underline' : 'none',
	            'text-align-last': _.get(styleProperties.members, "['alignment']['selectedValue']", 'left'),
	            'text-align': _.get(styleProperties.members, "['alignment']['selectedValue']", 'left'),
	            'color': _.get(styleProperties.members, "['font-color']['selectedValue']", 'black'),
	            'pointer-events': readOnlyField ? 'none' : 'auto'
	        };
	        if ((properties['Basic']['ControlType'] == 'Radio' || properties['Basic']['ControlType'] == 'Checkbox') && item == 'ControlStyle') {
	            styleObject['text-align-last'] = 'left';
	            styleObject['text-align'] = 'left';
	            styleObject['justify-content'] = _.get(styleProperties.members, "['alignment']['selectedValue']", 'left');
	        }
	        if ((properties['Basic']['ControlType'] == 'InlineAssocFiles') || (properties['Basic']['ControlType'] == 'InlineAssocApps')) {
	            styleObject['background-color'] = _.get(styleProperties.members, "['background-color']['selectedValue']", 'white');
	        }
	        return styleObject;
	    };
	    CreateComponent.prototype.getButtonStyle = function (properties, item) {
	        var styleObj = this.getStyleObject(properties, item);
	        styleObj['background-color'] = _.get(properties.Style['font-style-group'].members, "['background-color']['selectedValue']", 'white');
	        styleObj['height'] = _.get(properties.Size, "Height.selectedValue", 'auto');
	        styleObj['width'] = _.get(properties.Size, "Width.selectedValue", 'auto');
	        return styleObj;
	    };
	    CreateComponent.prototype.getStyleObect = function (item) {
	        if (!item.properties.Style) {
	            return {};
	        }
	        var control = item.type;
	        var props = item.properties.Style;
	        var marginProps = item.properties.Margin;
	        var properties = angular.merge({}, props['font-style-group'], props['style-group'], props['border-style-group']);
	        if (item.type == "Button" || item.type == "SiteLocationButton") {
	            var styleObj_1 = {
	                'padding': '5px'
	            };
	            return styleObj_1;
	        }
	        /*
	         * Apply Style for individual cell for TABLE
	         */
	        if (item.ids || item.properties.ControlStyle) {
	            item.ids && this.applyCellStyle(item);
	            return {
	                'background-color': _.get(properties.members, "['background-color']['selectedValue']", 'white'),
	                'padding-top': _.get(marginProps, "['margin-top']['selectedValue']", 0) + 'px',
	                'padding-bottom': _.get(marginProps, "['margin-bottom']['selectedValue']", 0) + 'px',
	                'padding-right': _.get(marginProps, "['margin-right']['selectedValue']", 5) + 'px',
	                'padding-left': _.get(marginProps, "['margin-left']['selectedValue']", 5) + 'px'
	            };
	        }
	        var styleObj = {
	            'font-family': _.get(properties.members, "['font-family']['selectedValue']", 'initial'),
	            'font-size': _.get(properties.members, "['font-size']['selectedValue']", '16') + 'px',
	            'background-color': _.get(properties.members, "['background-color']['selectedValue']", 'white'),
	            'font-weight': _.get(properties.members, "['bold']['selectedValue']", false) ? 'bold' : 'normal',
	            'font-style': _.get(properties.members, "['italic']['selectedValue']", false) ? 'italic' : 'normal',
	            'text-decoration': _.get(properties.members, "['underline']['selectedValue']", false) ? 'underline' : 'none',
	            'text-align-last': _.get(properties.members, "['alignment']['selectedValue']", 'left'),
	            'text-align': _.get(properties.members, "['alignment']['selectedValue']", 'left'),
	            'color': _.get(properties.members, "['font-color']['selectedValue']", 'black'),
	            'padding-top': _.get(marginProps, "['margin-top']['selectedValue']", 0) + 'px',
	            'padding-bottom': _.get(marginProps, "['margin-bottom']['selectedValue']", 0) + 'px',
	            'padding-right': _.get(marginProps, "['margin-right']['selectedValue']", 5) + 'px',
	            'padding-left': _.get(marginProps, "['margin-left']['selectedValue']", 5) + 'px'
	        };
	        if (control == "Button") {
	            delete styleObj['background-color'];
	        }
	        return styleObj;
	    };
	    CreateComponent.prototype.applyCellStyle = function (item) {
	        var row, col;
	        var props = item.properties.Style;
	        var properties = angular.merge({}, props['font-style-group'], props['style-group']);
	        for (var i = 0; i < item.ids.length; ++i) {
	            if (item.ids[i]) {
	                row = parseInt(item.ids[i].split("-")[0], 10);
	                col = parseInt(item.ids[i].split("-")[1], 10);
	                var control = void 0;
	                if (item.type == "Layout") {
	                    control = item.data[col];
	                }
	                else {
	                    control = item.data[row][col];
	                }
	                if (control) {
	                    control.style = {
	                        'font-family': _.get(properties.members, "['font-family']['selectedValue']", 'initial'),
	                        'font-size': _.get(properties.members, "['font-size']['selectedValue']", '16') + 'px',
	                        'background-color': control.style && control.style['background-color'] ? control.style['background-color'] : 'rgba(255, 255, 255, 0)',
	                        'font-weight': _.get(properties.members, "['bold']['selectedValue']", false) ? 'bold' : 'normal',
	                        'font-style': _.get(properties.members, "['italic']['selectedValue']", false) ? 'italic' : 'normal',
	                        'text-decoration': _.get(properties.members, "['underline']['selectedValue']", false) ? 'underline' : 'none',
	                        'text-align-last': _.get(properties.members, "['alignment']['selectedValue']", 'left'),
	                        'text-align': _.get(properties.members, "['alignment']['selectedValue']", 'left'),
	                        'color': _.get(properties.members, "['font-color']['selectedValue']", 'black')
	                    };
	                }
	            }
	        }
	    };
	    CreateComponent.prototype.getTableCss = function (item) {
	        return {
	            'table-layout': Object.keys(item.width).length > 0 ? 'auto' : 'fixed',
	            'margin': '0px'
	        };
	    };
	    CreateComponent.prototype.getAssociationBorderStyle = function (item) {
	        return {
	            'border-width': item.properties.Borders['border-style-group'].members['border-width'].selectedValue + 'px',
	            'border-color': item.properties.Borders['border-style-group'].members['border-color'].selectedValue,
	        };
	    };
	    CreateComponent.prototype.getAssociationTableCss = function (item) {
	        return {
	            'table-layout': 'fixed',
	            'margin': '0px',
	            'font-family': item.properties.ControlStyle['font-style-group'].members['font-family'].selectedValue,
	            'font-size': item.properties.ControlStyle['font-style-group'].members['font-size'].selectedValue,
	        };
	    };
	    CreateComponent.prototype.getBorderStyleObect = function (item, extraStyle, width) {
	        if (width === void 0) { width = 'auto'; }
	        if (item.type == "Layout") {
	            var styleObj = {
	                'border': item.properties.Display.Border.selectedValue,
	                width: width
	            };
	            return angular.merge({}, styleObj, extraStyle);
	        }
	        if (!item.properties.Borders) {
	            return {
	                width: width
	            };
	        }
	        var props = item.properties.Borders;
	        var properties = angular.merge({}, props['border-style-group'], props['style-group']);
	        return angular.merge({}, {
	            'border-color': _.get(properties.members, "['border-color']['selectedValue']", 'black'),
	            'border-width': _.get(properties.members, "['border-width']['selectedValue']", 0),
	            width: width
	        }, extraStyle);
	    };
	    CreateComponent.prototype.getRepeatingTableBorderStyle = function (item) {
	        if (item.properties.Borders) {
	            var properties = item.properties.Borders['border-style-group'];
	            return {
	                'border-color': _.get(properties.members, "['border-color']['selectedValue']", 'black'),
	                'border-width': _.get(properties.members, "['border-width']['selectedValue']", 0)
	            };
	        }
	    };
	    CreateComponent.prototype.ensureGoogleMapsLoaded = function () {
	        var _this = this;
	        if (this.maps) {
	            return Promise.resolve();
	        }
	        if (this._googleMapsLoadPromise) {
	            return this._googleMapsLoadPromise;
	        }
	        this._googleMapsLoadPromise = this.$http({
	            method: 'GET',
	            url: window.properties.service.commonApiUrl + 'vault/secret?key=googleMapGeocoderUrlKey',
	            withCredentials: true
	        }).then(function (response) {
	            var apiKey = response.data;
	            if (!apiKey) {
	                throw new Error('Google Maps API key not found');
	            }
	            return new Promise(function (resolve, reject) {
	                var script = document.createElement('script');
	                script.type = 'text/javascript';
	                script.src = 'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&libraries=places';
	                script.onload = function () {
	                    _this.maps = window.google.maps;
	                    _this.geoCoder = new _this.maps.Geocoder();
	                    resolve();
	                };
	                script.onerror = function () {
	                    _this._googleMapsLoadPromise = null;
	                    reject(new Error('Failed to load Google Maps script'));
	                };
	                document.body.appendChild(script);
	            });
	        }).catch(function (err) {
	            _this._googleMapsLoadPromise = null;
	            throw err;
	        });
	        return this._googleMapsLoadPromise;
	    };
	    CreateComponent.prototype.openMap = function (properties, uid) {
	        var _this = this;
	        this.ensureGoogleMapsLoaded().then(function () {
	            var type = _.get(properties, 'Type.selectedValue', '35');
	            var selectedValue = _.get(properties, 'Default.selectedValue', '');
	            var self = _this, lat = '', long = '', osGridRef = '', marker;
	            var forMetaData = self.config.for == "Meta-Data";
	            if (type == '36') {
	                if (selectedValue.indexOf(' (') != -1) {
	                    osGridRef = selectedValue.split(' (')[1].split(')')[0];
	                }
	                else {
	                    osGridRef = selectedValue;
	                }
	                if (osGridRef) {
	                    var latlong = self.convertGridRef(osGridRef);
	                    lat = latlong.lat;
	                    long = latlong.long;
	                }
	            }
	            else {
	                if (selectedValue.indexOf(' (') != -1) {
	                    var latlangstr = selectedValue.split(' (')[1].split(')')[0];
	                    lat = parseFloat(latlangstr.split(', ')[0]) || '';
	                    long = parseFloat(latlangstr.split(', ')[1]) || '';
	                }
	                else {
	                    lat = parseFloat(selectedValue.split(', ')[0]);
	                    long = parseFloat(selectedValue.split(', ')[1]);
	                }
	            }
	            var clearMarker = function () {
	                if (marker && marker.setMap) {
	                    marker.setMap(null);
	                }
	                lat = '';
	                long = '';
	                osGridRef = '';
	            };
	            var getAddress = function (latitude, longitude, callback) {
	                var latlng = {
	                    lat: parseFloat(latitude),
	                    lng: parseFloat(longitude)
	                };
	                self.geoCoder.geocode({
	                    'location': latlng
	                }, function (results, status) {
	                    var address = '';
	                    if (status === 'OK') {
	                        if (results[0]) {
	                            address = results[0].formatted_address;
	                        }
	                    }
	                    callback && callback(address);
	                });
	            };
	            var modalInstance = _this.$uibModal.open({
	                animation: true,
	                ariaLabelledBy: 'modal-title',
	                ariaDescribedBy: 'modal-body',
	                templateUrl: 'map-popup.html',
	                backdrop: 'static',
	                keyboard: false,
	                controllerAs: '$ctrl',
	                appendTo: angular.element(self.$document[0].querySelector('.canvas')),
	                controller: function () {
	                    var ctrl = this;
	                    this.clearMarker = clearMarker;
	                    this.save = function () {
	                        var address = getAddress(lat, long, function (address) {
	                            if (address && !forMetaData) {
	                                if (type == '36' && !osGridRef) {
	                                    _.set(properties, 'Default.selectedValue', '');
	                                }
	                                else {
	                                    _.set(properties, 'Default.selectedValue', address + ' (' + (type == '36' ? osGridRef : lat + ', ' + long) + ')');
	                                }
	                            }
	                            else {
	                                if (type == '36') {
	                                    _.set(properties, 'Default.selectedValue', osGridRef);
	                                }
	                                else {
	                                    _.set(properties, 'Default.selectedValue', lat ? lat + ', ' + long : '');
	                                }
	                            }
	                            self.onChangeModelValue(uid, properties.ControlType, properties['Data Field Name'].selectedValue, properties.Default.selectedValue);
	                            /* if(eventsDetail && eventsDetail.change) {
	                              self.onEvent(eventsDetail.change.selectedValue);
	                            } */
	                            ctrl.cancel();
	                        });
	                    };
	                    this.cancel = function () {
	                        modalInstance.dismiss('cancel');
	                    };
	                }
	            });
	            var setMarker = function (map, latitude, longitude) {
	                clearMarker();
	                marker = new self.maps.Marker({
	                    position: {
	                        lat: latitude,
	                        lng: longitude
	                    },
	                    map: map
	                });
	                lat = parseFloat(latitude.toFixed(8));
	                long = parseFloat(longitude.toFixed(8));
	                osGridRef = self.getGridRef({
	                    lat: lat,
	                    lng: long
	                });
	            };
	            modalInstance.rendered.then(function () {
	                var ukLatLang = {
	                    lat: 53.54030739150022,
	                    lng: -1.7578125
	                };
	                var zoom = type == '36' ? 5 : 1;
	                if (lat) {
	                    zoom = 18;
	                }
	                var center = (!lat && type == '36') ? ukLatLang : {
	                    lat: lat || 0,
	                    lng: long || 0
	                };
	                var map = new self.maps.Map(self.$document[0].querySelector('.map'), {
	                    center: center,
	                    scrollwheel: true,
	                    zoom: zoom,
	                    size: new self.maps.Size('100%', '100%'),
	                    disableDefaultUI: true
	                });
	                var input = document.getElementById('map-search-box');
	                var searchBox = new self.maps.places.SearchBox(input);
	                map.controls[self.maps.ControlPosition.TOP_LEFT].push(input);
	                map.addListener('bounds_changed', function () {
	                    searchBox.setBounds(map.getBounds());
	                });
	                searchBox.addListener('places_changed', function () {
	                    var places = searchBox.getPlaces();
	                    if (places.length == 0) {
	                        return;
	                    }
	                    clearMarker();
	                    var bounds = new self.maps.LatLngBounds();
	                    places.forEach(function (place) {
	                        if (!place.geometry) {
	                            console.log("Returned place contains no geometry");
	                            return;
	                        }
	                        if (place.geometry.viewport) {
	                            bounds.union(place.geometry.viewport);
	                        }
	                        else {
	                            bounds.extend(place.geometry.location);
	                        }
	                    });
	                    map.fitBounds(bounds);
	                });
	                map.addListener('click', function (e) {
	                    setMarker(map, e.latLng.lat(), e.latLng.lng());
	                });
	                lat && long && setMarker(map, lat, long);
	            });
	        }).catch(function (err) {
	            console.error('Failed to load Google Maps:', err);
	        });
	    };
	    CreateComponent.prototype.getGridRef = function (pos) {
	        var wgs84 = new geoTools.GT_WGS84();
	        wgs84.setDegrees(pos.lat, pos.lng);
	        var osgb = wgs84.getOSGB(), gridref10Dig = osgb.getGridRef(5), gridref6Dig = osgb.getGridRef(3);
	        if ("Coordinate not within Great Britain" === osgb.status || (gridref10Dig.indexOf("undefined") > -1 || gridref6Dig.indexOf("undefined") > -1)) {
	            gridref10Dig = "";
	            gridref6Dig = "";
	        }
	        return gridref10Dig;
	    };
	    CreateComponent.prototype.convertGridRef = function (gridref10Dig) {
	        var osgb = new geoTools.GT_OSGB();
	        if (osgb.parseGridRef(gridref10Dig)) {
	            var wgs84 = osgb.getWGS84();
	            return {
	                lat: wgs84.latitude,
	                long: wgs84.longitude
	            };
	        }
	        else {
	            return {
	                lat: '',
	                long: ''
	            };
	        }
	    };
	    CreateComponent.prototype.resetDefaultForRadio = function (value, list) {
	        if (list.length) {
	            for (var i = 0; i < list.length; i++) {
	                var element = list[i];
	                element.selectedValue.name = '';
	            }
	        }
	        value.selectedValue.name = true;
	    };
	    CreateComponent.prototype.filterDropdownOption = function (parentAttr, data) {
	        var list = [];
	        if (data.length) {
	            for (var i = 0; i < data.length; i++) {
	                var element = data[i];
	                if (element.id && this.filterOption.filterList && Object.keys(this.filterOption.filterList).length > 0) {
	                    var filterList = this.filterOption.filterList[parentAttr.properties.Basic["Field Name"].selectedValue] || [];
	                    if (!(filterList.length > 0 && filterList.indexOf(element.id) < 0)) {
	                        list.push(element);
	                    }
	                }
	                else {
	                    list.push(element);
	                }
	            }
	        }
	        return list;
	    };
	    CreateComponent.prototype.selectAllCheckboxOption = function (event, list) {
	        event.stopPropagation();
	        list = list['Data Source'].table.list;
	        for (var i = 0; i < list.length; ++i) {
	            list[i].selectedValue.name = event.currentTarget.checked;
	        }
	    };
	    CreateComponent.prototype.selectAllDropdownOption = function (event, property) {
	        event.stopPropagation();
	        var list = property['Data Source'].table.list, selectedArray = [];
	        if (event.currentTarget.checked) {
	            for (var i = 0; i < list.length; ++i) {
	                selectedArray.push(list[i].Value.name);
	            }
	            property.Basic.Value.selectedValue = selectedArray;
	        }
	        else {
	            property.Basic.Value.selectedValue = [];
	        }
	    };
	    CreateComponent.prototype.isDisableDropdown = function (event, property) {
	        property.Basic.FilterValue.isFilterValue = 1;
	        if (event.currentTarget.checked) {
	            property.Basic.FilterValue.isFilterValue = 2;
	        }
	        this.selectAllDropdownOption(event, property);
	    };
	    CreateComponent.prototype.isDisableCheckbox = function (event, property) {
	        property.Basic.FilterValue.isFilterValue = 1;
	        if (event.currentTarget.checked) {
	            property.Basic.FilterValue.isFilterValue = 2;
	        }
	        this.selectAllCheckboxOption(event, property);
	    };
	    CreateComponent.prototype.getPrintViewJson = function (viewData, languageData) {
	        if (!viewData.ORI_PRINT_VIEW && viewData.ORI_VIEW) {
	            var selectedItems = this.Util.returnSelectedForCopy(_.get(viewData, 'ORI_VIEW.controls.A', []), [], false, true);
	            var copiedItems = angular.copy(selectedItems);
	            for (var i = 0; i < copiedItems.length; i++) {
	                copiedItems[i].selected = false;
	                this.convertToReadOnly(copiedItems[i]);
	            }
	            var defaultName = angular.copy(this.defaultView);
	            defaultName.viewName = 'ORI_PRINT_VIEW';
	            viewData['ORI_PRINT_VIEW'] = defaultName;
	            viewData['ORI_PRINT_VIEW'].controls.A = copiedItems;
	            viewData['ORI_PRINT_VIEW'].removeOnLoad = true;
	        }
	        if (!viewData.RES_PRINT_VIEW && viewData.RES_VIEW) {
	            var selectedItems = this.Util.returnSelectedForCopy(_.get(viewData, 'RES_VIEW.controls.A', []), [], false, true);
	            var copiedItems = angular.copy(selectedItems);
	            for (var i = 0; i < copiedItems.length; i++) {
	                copiedItems[i].selected = false;
	                this.convertToReadOnly(copiedItems[i]);
	            }
	            var defaultName = angular.copy(this.defaultView);
	            defaultName.viewName = 'RES_PRINT_VIEW';
	            viewData['RES_PRINT_VIEW'] = defaultName;
	            viewData['RES_PRINT_VIEW'].controls.A = copiedItems;
	            viewData['RES_PRINT_VIEW'].removeOnLoad = true;
	        }
	    };
	    CreateComponent.prototype.getColumnWidth = function (item, index, row) {
	        var width = 'auto';
	        if (item.type == "Layout") {
	            width = item.width[index];
	            return width;
	        }
	        if (item.data[row][index].colspan && item.data[row][index].colspan > 0) {
	            width = 'auto';
	        }
	        else {
	            width = item.width[index];
	        }
	        return width;
	    };
	    CreateComponent.prototype.publishWarning = function () {
	        var msg = this.$translate.instant('publish.warning');
	        this.ngNotification.warning({
	            message: msg, positionX: 'center', replaceMessage: true, templateUrl: "infrom_msg_for_publish.html", scope: this.$scope, delay: false
	        });
	        this.publishWarn = true;
	    };
	    CreateComponent.prototype.publish = function () {
	        var self = this;
	        var timeStamp = new Date().getTime();
	        if (self.editTempName) {
	            self.editTempNameCancle();
	        }
	        if (self.params.formName.match(/[|<>\\/:?*"'$#]/gi)) {
	            self.ngNotification.error({ message: 'Template Name cannot contain any of the following characters: # \\ / : * ? " < > | $ \' ', positionX: 'center', replaceMessage: true });
	            return;
	        }
	        if (self.config.for === 'Marketplace') {
	            window.top.postMessage('PublishBtnClicked', "*");
	        }
	        self.validateAndSave(function () {
	            self.publishWarn = undefined;
	            self.loading = true;
	            var formTypeID = self.params.id.formTypeId || self.params.id.formTypeID;
	            var instanceGroupId = self.params.id.instanceGroupId;
	            var extraParams = self.params.extraParams ? JSON.stringify(self.params.extraParams) : '';
	            var formtemplateType = self.params.id.formSubTemplateType ? self.params.id.formSubTemplateType : "0";
	            var responsePattern = self.params.id.responsePattern ? self.params.id.responsePattern : 0;
	            self.formProperties.theme = self.selectedTheme ? parseInt(self.selectedTheme) : 1;
	            self.formProperties.isThemeChanged = self.themeChanged ? parseInt(self.themeChanged) : 0;
	            self.formProperties.addAppType = self.addAppType ? self.addAppType : 0;
	            self.formProperties.isPuppeteerWithAngularViewEnabled = self.isPuppeteerViewEnabled && JSON.parse(self.isPuppeteerViewEnabled);
	            self.formProperties.isLandscape = self.isLandscape && JSON.parse(self.isLandscape);
	            var data = {
	                "timeStamp": timeStamp,
	                "formTypeId": formTypeID,
	                "projectId": self.params.id.projectId,
	                "instanceGroupId": instanceGroupId,
	                "for": self.config.for,
	                "formSubTemplateType": self.params.id.formSubTemplateType,
	                "responsePattern": self.params.id.responsePattern,
	                "name": self.params.formName,
	                "formProperties": self.formProperties
	            };
	            if (self.config.for == 'Marketplace') {
	                data = {
	                    "timeStamp": timeStamp,
	                    "formTypeId": formTypeID,
	                    "projectId": self.params.id.projectId,
	                    "for": self.config.for,
	                    "formSubTemplateType": formtemplateType,
	                    "responsePattern": responsePattern,
	                    "name": self.params.formName,
	                    "extraParams": extraParams
	                };
	            }
	            self.$http({
	                'url': '/publish',
	                'method': 'POST',
	                'data': data,
	                'headers': {
	                    'Content-Type': 'application/json;charset=UTF-8'
	                },
	                'withCredentials': true
	            }).then(function (response) {
	                self.ngNotification.success({ message: 'Operation successful.', positionX: 'center', replaceMessage: true });
	                //var publishDataString = 'publishData::'+JSON.stringify(response.data);
	                var repsonseData = response.data;
	                repsonseData.publish = true;
	                if (self.config.for == 'Marketplace') {
	                    window.top.postMessage(repsonseData, "*");
	                }
	                else {
	                    window.opener.postMessage(repsonseData, "*");
	                }
	                window.onbeforeunload = function () { };
	                self.$window.close();
	            }, function (response) {
	                var msg = self.$translate.instant('error.while.processing.request');
	                self.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
	                self.loading = false;
	            });
	        }, true, true);
	        self.publishWarn = false;
	    };
	    CreateComponent.prototype.discardDraft = function () {
	        var self = this;
	        this.loading = true;
	        this.$http({
	            'url': window.properties.service.commonApiUrl + action_constants_1.Ids.DISCARD_DRAFT + this.params.id.formTypeId + '/' + this.params.id.projectId,
	            'method': 'GET',
	            'data': {},
	            'withCredentials': true,
	            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	            transformRequest: function (obj) {
	                var str = [];
	                for (var p in obj)
	                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
	                return str.join("&");
	            },
	        }).then(function (response) {
	            var msg = self.$translate.instant('operation.successful');
	            self.ngNotification.success({ message: msg, positionX: 'center', replaceMessage: true });
	            self.loading = false;
	            self.getFormDesignData();
	        }, function (response) {
	            var msg = self.$translate.instant('error.while.processing.request');
	            self.ngNotification.error({ message: msg, positionX: 'center', replaceMessage: true });
	            self.loading = false;
	        });
	    };
	    CreateComponent.prototype.editTemplateName = function () {
	        var self = this;
	        this.tempTemplateName = self.params.formName;
	        self.editTempName = true;
	    };
	    CreateComponent.prototype.editTemplateNameSave = function () {
	        var self = this;
	        var letters = /^[A-Za-z0-9\_\-\!\~\%\&\(\)\+\,\.\=\@\[\b\]\^\`\{\}\s]+$/;
	        if (self.params.formName.match(letters)) {
	            self.editTempName = false;
	            var updatedTemplateName = self.params.formName;
	            var data = {
	                "templateName": updatedTemplateName,
	                "formTypeId": self.params.id.formTypeId || self.params.id.formTypeID,
	                "projectId": self.params.id.projectId
	            };
	            var httpParams = {
	                'url': window.properties.service.commonApiUrl + action_constants_1.Ids.UPDATE_TEMPLATENAME,
	                'method': 'POST',
	                'data': data,
	                'headers': {
	                    'Content-Type': 'application/x-www-form-urlencoded'
	                },
	                'withCredentials': true
	            };
	            httpParams.transformRequest = function (obj) {
	                var str = [];
	                for (var p in obj)
	                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
	                return str.join("&");
	            };
	            this.loading = true;
	            this.$http(httpParams).then(function (response) {
	                self.ngNotification.success({ message: 'Operation successful.', positionX: 'center', replaceMessage: true });
	                self.loading = false;
	                self.params.formName = updatedTemplateName;
	                var renameStr = 'renameData::' + updatedTemplateName;
	                if (self.config.for == 'Marketplace') {
	                    window.top.postMessage(renameStr, "*");
	                }
	                else {
	                    window.opener.postMessage(renameStr, "*");
	                }
	            }, function errorCallback(response) {
	                self.ngNotification.error({ message: 'There was an error processing your request.', positionX: 'center', replaceMessage: true });
	                self.loading = false;
	            });
	        }
	        else {
	            self.ngNotification.error({ message: 'Invalid characters entered. Characters (#,\\,/,:,*,?,<,>,|,$,single quote,double quotes), HTML Tags or any character with ASCII value less than 32 are not allowed.', positionX: 'center', replaceMessage: true });
	        }
	    };
	    CreateComponent.prototype.editTempNameCancle = function () {
	        var self = this;
	        self.params.formName = this.tempTemplateName;
	        this.tempTemplateName = '';
	        self.editTempName = false;
	    };
	    CreateComponent.prototype.deselectAll = function (event) {
	        if (event && event.shiftKey) {
	            return;
	        }
	        var selected = this.Util.returnSelected(this.selectedView.view.controls.A);
	        if (selected.length) {
	            for (var i = 0; i < selected.length; i++) {
	                selected[i].selected = false;
	            }
	        }
	        this.selectedItemDomain = [];
	        this.selectedItemIndex = null;
	    };
	    CreateComponent.prototype.deselectAllOtherViews = function () {
	        var _this = this;
	        var views = Object.keys(this.views);
	        views.forEach(function (view) {
	            if (_this.views[view].viewName != _this.selectedItemView) {
	                var selectedItemOtherView = _this.Util.returnSelected(_this.views[view].controls.A);
	                selectedItemOtherView.forEach(function (item, i) {
	                    item['selected'] = false;
	                }, _this);
	            }
	        }, this);
	    };
	    CreateComponent.prototype.clearAllCell = function () {
	        var ele = angular.element('.canvas').find('.eng-selected-item');
	        if (ele.length) {
	            for (var i = 0; i < ele.length; i++) {
	                ele.removeClass('eng-selected-item');
	            }
	        }
	    };
	    CreateComponent.prototype.removeLanguageLabels = function (viewName, data) {
	        if (data === void 0) { data = {}; }
	        if (Object.keys(data).length) {
	            for (var languageId in data) {
	                if (data.hasOwnProperty(languageId)) {
	                    var element = data[languageId];
	                    if (Object.keys(element).length) {
	                        for (var el in element) {
	                            if (element.hasOwnProperty(el) && el.indexOf(viewName) == 0) {
	                                delete element[el];
	                            }
	                        }
	                    }
	                }
	            }
	        }
	    };
	    CreateComponent.prototype.setStyle = function ($event) {
	        if (this.mousemoved) {
	            angular.element('.canvas').find('table').find('tr').children('td').each(function (i, el) {
	                el.style.height = el.clientHeight + 'px';
	            });
	            this.mousemoved = false;
	        }
	    };
	    CreateComponent.prototype.removeStyle = function ($event) {
	        if (!this.mousemoved) {
	            angular.element($event.currentTarget).find('td').css('height', '');
	            this.mousemoved = true;
	        }
	    };
	    //setting same parentNode id for textbox and display fields if they are added under same repeating table
	    CreateComponent.prototype.updateChildId = function (item, event) {
	        var tableid = angular.element(event.target).parents("div[type=RepeatingTable]").attr("repeating-table-id");
	        var isFooter = angular.element(event.target).parents("tr[type=footer]");
	        if (item.properties.Basic.parentNode) {
	            if (tableid)
	                item.properties.Basic.parentNode.id = "repeatingTable" + tableid;
	            else {
	                item.properties.Basic.parentNode.id = 0;
	                item.properties.Basic.Type.numberUnderRepeatingTable = false;
	            }
	            if (item.type.toLowerCase() == "display field") {
	                if (isFooter.length)
	                    item.properties.Basic.parentNode.footer = true;
	                else
	                    item.properties.Basic.parentNode.footer = false;
	            }
	        }
	    };
	    /**
	     * Perform migration for all controls from all views and set/update/delete property based on requirement
	     */
	    CreateComponent.prototype.doInitialMigration = function () {
	        var _this = this;
	        var self = this;
	        if (!self.views) {
	            return;
	        }
	        var controls = self.Util.getAllControls();
	        for (var key in controls) {
	            var control = controls[key];
	            self.doMigration(control, controls);
	        }
	        // controls.forEach((control) => {
	        //   self.doMigration(control, controls);
	        // });
	        var regex = /(^\{\{.*?\}\}$)/;
	        function renamedFxValue(curName, newName) {
	            controls.forEach(function (control) {
	                var controlValue = _.get(control, 'properties.Basic.Value.selectedValue', '');
	                if (controlValue && typeof controlValue == 'string' && controlValue.match && controlValue.match(regex)) {
	                    var val = controlValue.replace('{{', '').replace('}}', '');
	                    if (val && (curName == val)) {
	                        _.set(control, 'properties.Basic.Value.selectedValue', '{{' + newName + '}}');
	                        _.set(control, 'properties.Basic.DSName.selectedValue', newName);
	                    }
	                }
	                //Migrate' derivedFromFieldName' value
	                var derivedFromFieldName = _.get(control, 'derivedFromFieldName', '');
	                if (derivedFromFieldName && (curName == derivedFromFieldName)) {
	                    _.set(control, 'derivedFromFieldName', newName);
	                }
	                //Migrate' copiedFrom' value
	                var copiedFrom = _.get(control, 'copiedFrom', '');
	                if (copiedFrom && (curName == copiedFrom)) {
	                    _.set(control, 'copiedFrom', newName);
	                }
	                //Migrate' DSName' value
	                var curDSName = _.get(control, 'properties.Basic.DSName.selectedValue', '');
	                if (curDSName && (curName == curDSName)) {
	                    _.set(control, 'properties.Basic.DSName.selectedValue', newName);
	                }
	            });
	        }
	        ;
	        //Rename data field in FX value if same data field name is used
	        for (var fieldName in this.renamedFieldNames) {
	            renamedFxValue(fieldName, this.renamedFieldNames[fieldName]);
	            self.Util.replaceFieldNameInCodeEditor(controls, fieldName, this.renamedFieldNames[fieldName]);
	        }
	        for (var dataFieldName in this.renamedDataFieldNames) {
	            renamedFxValue(dataFieldName, this.renamedDataFieldNames[dataFieldName]);
	            self.Util.replaceDataFieldNameInCodeEditor(controls, dataFieldName, this.renamedDataFieldNames[dataFieldName]);
	        }
	        this.renamedFieldNames = {};
	        this.renamedDataFieldNames = {};
	        controls.forEach(function (control) {
	            //Migrate' copiedFrom' value
	            var copiedFrom = _.get(control, 'copiedFrom', '');
	            if (copiedFrom && (copiedFrom.indexOf('-') != -1 || copiedFrom.indexOf('.') != -1 || copiedFrom.indexOf('___') != -1)) {
	                copiedFrom = _this.Util.replaceAllMatches(copiedFrom, '-', '_');
	                copiedFrom = _this.Util.replaceAllMatches(copiedFrom, '.', '_');
	                copiedFrom = _this.Util.replaceUnderscoresValue(copiedFrom);
	                _.set(control, 'copiedFrom', copiedFrom);
	            }
	            if (!control.propMigrated && copiedFrom && self.readOnlyControlsToUpdate.indexOf(copiedFrom) == -1) {
	                if (control.type != "Table" && control.type != "Layout" && control.type != "RepeatingTable") {
	                    self.readOnlyControlsToUpdate.push(copiedFrom);
	                }
	                else {
	                    _.set(control.properties, "Display.Hidden.hidden", true);
	                }
	            }
	            //Migrate' DSName' value
	            var curDSName = _.get(control, 'properties.Basic.DSName.selectedValue', '');
	            if (curDSName && (curDSName.indexOf('-') != -1 || curDSName.indexOf('.') != -1 || curDSName.indexOf('___') != -1)) {
	                curDSName = _this.Util.replaceAllMatches(curDSName, '-', '_');
	                curDSName = _this.Util.replaceAllMatches(curDSName, '.', '_');
	                curDSName = _this.Util.replaceUnderscoresValue(curDSName);
	                _.set(control, 'properties.Basic.DSName.selectedValue', curDSName);
	            }
	        });
	        self.processToUpdateReadOnlyControlProperties();
	    };
	    /**
	     * @return {Number} - Unique incremental number
	     */
	    CreateComponent.prototype.getIncrementCount = function () {
	        return ++this.incrementCount;
	    };
	    /**
	     * @brief Add missing properties or newly introduced properties for old design.
	     * @param {object} control
	     */
	    CreateComponent.prototype.doMigration = function (control, allControls) {
	        if (!control || !control.type || !control.properties) {
	            return;
	        }
	        if (this.config && this.config.for == "Meta-Data") {
	            return;
	        }
	        var properties = control.properties;
	        var migrateDataFieldName = false;
	        try {
	            switch (control.type) {
	                case 'Textbox':
	                    if (properties && properties.ControlStyle) {
	                        properties.ControlStyle['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.ControlStyle['font-style-group'].members['font-family'].options);
	                    }
	                    if (properties && properties.Basic['Data Field Name'] && properties.Basic['Data Field Name'].selectedValue == 'ORI_FORMTITLE' && !properties.ControlStyle) {
	                        properties['ControlStyle'] = angular.copy(properties.Style);
	                        properties['ControlStyle'].Name.selectedValue = 'control.style';
	                        delete properties['ControlStyle']['font-style-group'].members['background-color'];
	                    }
	                    if (properties && properties.Style && properties.Basic['Data Field Name'] && properties.Basic['Data Field Name'].selectedValue == 'ORI_FORMTITLE') {
	                        properties.Style.Name.selectedValue = 'label.style';
	                    }
	                    if (properties && properties.Basic['Data Field Name'] && properties.Basic['Data Field Name'].selectedValue == 'ORI_FORMTITLE' && !properties.Margin) {
	                        properties['Margin'] = angular.copy(ControlProperties.TextboxProperties.Margin); // padding
	                    }
	                    if (properties && properties.Display && !properties.Display['HasMic']) {
	                        properties.Display['HasMic'] = angular.copy(ControlProperties.TextboxProperties.Display.HasMic);
	                    }
	                    if (properties && properties.Style) {
	                        properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
	                    }
	                    if (!properties.Events) {
	                        properties.Events = angular.copy(ControlProperties.TextboxProperties.Events);
	                    }
	                    if (properties.Basic && !properties.Basic.ControlType) {
	                        properties.Basic.ControlType = 'Textbox';
	                    }
	                    if (properties.Basic && !properties.Basic.Validate && properties.Advance.Validate) {
	                        properties.Basic.Validate = angular.copy(properties.Advance.Validate);
	                        properties.Basic.Validate.onChangeFunction = 'onFormatTypeChanged';
	                        properties.Basic.Validate.name = 'format';
	                        delete properties.Advance.Validate;
	                        properties.Basic.DigitSeparator = angular.copy(ControlProperties.TextboxProperties.Basic.DigitSeparator);
	                        properties.Basic.DecimalPlaces = angular.copy(ControlProperties.TextboxProperties.Basic.DecimalPlaces);
	                        properties.Basic.DecimalThousandSeparator = angular.copy(ControlProperties.TextboxProperties.Basic.DecimalThousandSeparator);
	                        if (this.numberFormatEnabled && (properties.Basic.Validate.selectedValue == 'Integer' || properties.Basic.Validate.selectedValue == 'Decimal')) {
	                            properties.Basic.DigitSeparator.hidden = false;
	                            if (properties.Basic.Validate.selectedValue == 'Decimal') {
	                                properties.Basic.DecimalPlaces.hidden = false;
	                            }
	                            properties.Basic.DecimalPlaces.selectedValue = '0';
	                        }
	                    }
	                    // add hasMic property in display object
	                    if (properties && properties.Display && !properties.Display['HasMic']) {
	                        properties.Display['HasMic'] = angular.copy(ControlProperties.TextboxProperties.Display.HasMic);
	                    }
	                    if (!this.numberFormatEnabled) {
	                        properties.Basic.DigitSeparator && (properties.Basic.DigitSeparator.selectedValue = false);
	                        properties.Basic.DigitSeparator && (properties.Basic.DigitSeparator.hidden = true);
	                        properties.Basic.DecimalPlaces && (properties.Basic.DecimalPlaces.hidden = true);
	                        properties.Basic.DecimalPlaces && (properties.Basic.DecimalPlaces.selectedValue = '0');
	                    }
	                    if (!properties.Display.Wraptext) {
	                        properties.Display.Wraptext = angular.copy(ControlProperties.TextboxProperties.Display.Wraptext);
	                    }
	                    migrateDataFieldName = true;
	                    break;
	                case 'Text-Area':
	                    if (properties && properties.ControlStyle) {
	                        properties.ControlStyle['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.ControlStyle['font-style-group'].members['font-family'].options);
	                    }
	                    if (properties && properties.Style) {
	                        properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
	                    }
	                    if (!properties.Events) {
	                        properties.Events = angular.copy(ControlProperties.TextareaProperties.Events);
	                    }
	                    if (properties.Basic && !properties.Basic.ControlType) {
	                        properties.Basic.ControlType = 'Textarea';
	                    }
	                    if (properties.Basic && !properties.Basic.Validate && properties.Advance.Validate) {
	                        properties.Basic.Validate = angular.copy(properties.Advance.Validate);
	                        properties.Basic.Validate.onChangeFunction = 'onFormatTypeChanged';
	                        properties.Basic.Validate.name = 'format';
	                        delete properties.Advance.Validate;
	                        properties.Basic.DigitSeparator = angular.copy(ControlProperties.TextareaProperties.Basic.DigitSeparator);
	                        properties.Basic.DecimalPlaces = angular.copy(ControlProperties.TextareaProperties.Basic.DecimalPlaces);
	                        properties.Basic.DecimalThousandSeparator = angular.copy(ControlProperties.TextareaProperties.Basic.DecimalThousandSeparator);
	                        if (this.numberFormatEnabled && (properties.Basic.Validate.selectedValue == 'Integer' || properties.Basic.Validate.selectedValue == 'Decimal')) {
	                            properties.Basic.DigitSeparator.hidden = false;
	                            if (properties.Basic.Validate.selectedValue == 'Decimal') {
	                                properties.Basic.DecimalPlaces.hidden = false;
	                            }
	                            properties.Basic.DecimalPlaces.selectedValue = '0';
	                        }
	                    }
	                    if (!this.numberFormatEnabled) {
	                        properties.Basic.DigitSeparator && (properties.Basic.DigitSeparator.selectedValue = false);
	                        properties.Basic.DigitSeparator && (properties.Basic.DigitSeparator.hidden = true);
	                        properties.Basic.DecimalPlaces && (properties.Basic.DecimalPlaces.hidden = true);
	                        properties.Basic.DecimalPlaces && (properties.Basic.DecimalPlaces.selectedValue = '0');
	                    }
	                    if (properties.Size) {
	                        delete properties.Size;
	                    }
	                    migrateDataFieldName = true;
	                    break;
	                case 'Rich-Text-Box':
	                    if (properties && properties.Style) {
	                        properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
	                    }
	                    if (!properties.Events) {
	                        properties.Events = angular.copy(ControlProperties.RichTextAreaProperties.Events);
	                    }
	                    if (properties.Basic && !properties.Basic.ControlType) {
	                        properties.Basic.ControlType = 'RichTextArea';
	                    }
	                    if (properties.Display && !properties.Display['Char-Limit']) {
	                        properties.Display['Char-Limit'] = angular.copy(ControlProperties.RichTextAreaProperties.Display['Char-Limit']);
	                    }
	                    // add hasMic property in display object
	                    if (properties && properties.Display && !properties.Display['HasMic']) {
	                        properties.Display['HasMic'] = angular.copy(ControlProperties.TextboxProperties.Display.HasMic);
	                    }
	                    migrateDataFieldName = true;
	                    break;
	                case 'Attachment':
	                    if (properties && properties.Style) {
	                        properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
	                    }
	                    if (!properties.Events) {
	                        properties.Events = angular.copy(ControlProperties.AttachmentProperties.Events);
	                    }
	                    if (properties.Basic && !properties.Basic['Name']) {
	                        properties.Basic['Name'] = angular.copy(ControlProperties.AttachmentProperties.Basic['Name']);
	                    }
	                    if (properties.Basic && !properties.Basic.ControlType) {
	                        properties.Basic.ControlType = 'Attachment';
	                    }
	                    if (properties.Display && !properties.Display['Generate Thumbnail']) {
	                        properties.Display['Generate Thumbnail'] = angular.copy(ControlProperties.AttachmentProperties.Display['Generate Thumbnail']);
	                    }
	                    if (properties.Display && !properties.Display['Caption']) {
	                        properties.Display['Caption'] = angular.copy(ControlProperties.AttachmentProperties.Display['Caption']);
	                    }
	                    if (properties.Display && !properties.Display['Caption Position']) {
	                        properties.Display['Caption Position'] = angular.copy(ControlProperties.AttachmentProperties.Display['Caption Position']);
	                    }
	                    if (properties.Display && !properties.Display['Thumbnail Size']) {
	                        properties.Display['Thumbnail Size'] = angular.copy(ControlProperties.AttachmentProperties.Display['Thumbnail Size']);
	                    }
	                    if (properties.Display && !properties.Display['Thumbnail Width']) {
	                        properties.Display['Thumbnail Width'] = angular.copy(ControlProperties.AttachmentProperties.Display['Thumbnail Width']);
	                    }
	                    if (properties.Display && !properties.Display['Thumbnail Height']) {
	                        properties.Display['Thumbnail Height'] = angular.copy(ControlProperties.AttachmentProperties.Display['Thumbnail Height']);
	                    }
	                    if (properties.Basic && properties.Basic['Value']) {
	                        properties.Basic['Value'] = angular.copy(ControlProperties.AttachmentProperties.Basic['Value']);
	                    }
	                    if (properties.Display && !properties.Display['Embedded Attachment']) {
	                        properties.Display['Embedded Attachment'] = angular.copy(ControlProperties.AttachmentProperties.Display['Embedded Attachment']);
	                    }
	                    migrateDataFieldName = true;
	                    break;
	                case 'Button':
	                    if (properties && properties.Style) {
	                        properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
	                    }
	                    if (!properties.Events) {
	                        properties.Events = angular.copy(ControlProperties.ButtonProperties.Events);
	                    }
	                    if (properties.Basic && !properties.Basic.ControlType) {
	                        properties.Basic.ControlType = 'Button';
	                    }
	                    break;
	                case 'ToggleButton':
	                    if (properties && properties.ControlStyle) {
	                        properties.ControlStyle['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.ControlStyle['font-style-group'].members['font-family'].options);
	                    }
	                    if (properties && properties.Style) {
	                        properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
	                    }
	                    if (!properties.Events) {
	                        properties.Events = angular.copy(ControlProperties.ToggleButtonProperties.Events);
	                    }
	                    if (properties.Basic && !properties.Basic.ControlType) {
	                        properties.Basic.ControlType = 'ToggleButton';
	                    }
	                    if (properties.Basic && !properties.Basic['ValueOn']) {
	                        properties.Basic['ValueOn'] = angular.copy(ControlProperties.ToggleButtonProperties.Basic['ValueOn']);
	                    }
	                    if (properties.Basic && !properties.Basic['ValueOff']) {
	                        properties.Basic['ValueOff'] = angular.copy(ControlProperties.ToggleButtonProperties.Basic['ValueOff']);
	                    }
	                    migrateDataFieldName = true;
	                    break;
	                case 'Hyperlink':
	                    if (properties && properties.ControlStyle) {
	                        properties.ControlStyle['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.ControlStyle['font-style-group'].members['font-family'].options);
	                    }
	                    if (properties && properties.Style) {
	                        properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
	                    }
	                    if (!properties.Events) {
	                        properties.Events = angular.copy(ControlProperties.HyperlinkProperties.Events);
	                    }
	                    if (properties.Basic['Value']) {
	                        properties.Basic['Value'].onChangeFunction = 'checkRequired';
	                    }
	                    if (properties.Basic && !properties.Basic.ControlType) {
	                        properties.Basic.ControlType = 'Hyperlink';
	                    }
	                    migrateDataFieldName = true;
	                    break;
	                case 'Radio':
	                    if (properties && properties.ControlStyle) {
	                        properties.ControlStyle['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.ControlStyle['font-style-group'].members['font-family'].options);
	                    }
	                    if (properties && properties.Style) {
	                        properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
	                    }
	                    if (!properties.Events) {
	                        properties.Events = angular.copy(ControlProperties.RadioProperties.Events);
	                    }
	                    if (properties.Basic && !properties.Basic.ControlType) {
	                        properties.Basic.ControlType = 'Radio';
	                    }
	                    if (properties.Basic['Spread Columns']) {
	                        delete properties.Basic['Spread Columns'];
	                    }
	                    if (!(properties.Basic['Display Format'])) {
	                        control.properties.Basic['Display Format'] = angular.copy(ControlProperties.RadioProperties.Basic['Display Format']);
	                    }
	                    if (!(properties.Basic['Number'])) {
	                        properties.Basic['Number'] = angular.copy(ControlProperties.RadioProperties.Basic['Number']);
	                    }
	                    migrateDataFieldName = true;
	                    break;
	                case 'Layout':
	                    if (!properties.Events) {
	                        properties.Events = angular.copy(ControlProperties.LayoutProperties.Events);
	                    }
	                    if (!properties.Basic) {
	                        //Set Basic with Field name value
	                        properties.Basic = angular.copy(ControlProperties.LayoutProperties.Basic);
	                        properties.Basic['Field Name'].selectedValue = control.type + '__' + this.getIncrementCount();
	                    }
	                    if (properties.Basic && !properties.Basic.ControlType) {
	                        properties.Basic.ControlType = 'Layout';
	                    }
	                    if (properties.Basic && properties.Basic.Name && properties.Basic.Name.hideSection) {
	                        properties.Basic.Name.hideSection = false;
	                    }
	                    if (!properties.Display) {
	                        properties.Display = angular.copy(ControlProperties.LayoutProperties.Display);
	                    }
	                    if (!properties.Display.RemoveOptions) {
	                        properties.Display.RemoveOptions = angular.copy(ControlProperties.LayoutProperties.Display.RemoveOptions);
	                    }
	                    if (properties.Style) {
	                        properties.Style['style-group'].members = {};
	                        delete properties.Style['font-style-group'].members['font-family'];
	                        delete properties.Style['font-style-group'].members['font-size'];
	                    }
	                    if (!control.width) {
	                        control.ids = [];
	                        control.selectedRows = [];
	                        control.width = {};
	                        control.reset = false;
	                    }
	                    control.data.forEach(function (dataObj) {
	                        if (dataObj.style && (dataObj.style["background-color"] == 'rgb(255, 255, 255)' || dataObj.style["background-color"] == '#ffffff')) {
	                            dataObj.style["background-color"] = 'rgba(255, 255, 255, 0)';
	                        }
	                    });
	                    break;
	                case 'Table':
	                    if (!properties.Borders['Name']) {
	                        properties.Borders['Name'] = angular.copy(ControlProperties.TableProperties.Borders['Name']);
	                    }
	                    if (!properties.Merge['Name']) {
	                        properties.Merge['Name'] = angular.copy(ControlProperties.TableProperties.Merge['Name']);
	                    }
	                    if (!properties.Events) {
	                        properties.Events = angular.copy(ControlProperties.TableProperties.Events);
	                    }
	                    if (!properties.Display['Fit-to-Screen']) {
	                        properties.Display['Fit-to-Screen'] = angular.copy(ControlProperties.TableProperties.Display['Fit-to-Screen']);
	                    }
	                    if (!properties.Basic) {
	                        //Set Basic with Field name value
	                        properties.Basic = angular.copy(ControlProperties.TableProperties.Basic);
	                        properties.Basic['Field Name'].selectedValue = control.type + '__' + this.getIncrementCount();
	                    }
	                    if (properties.Basic && !properties.Basic.ControlType) {
	                        properties.Basic.ControlType = 'Table';
	                    }
	                    if (properties.Basic && properties.Basic.Name && properties.Basic.Name.hideSection) {
	                        properties.Basic.Name.hideSection = false;
	                    }
	                    if (properties.Style) {
	                        properties.Style['style-group'].members = {};
	                        delete properties.Style['font-style-group'].members['font-family'];
	                        delete properties.Style['font-style-group'].members['font-size'];
	                    }
	                    control.data.forEach(function (row) {
	                        row.forEach(function (dataObj) {
	                            if (dataObj.style && (dataObj.style["background-color"] == 'rgb(255, 255, 255)' || dataObj.style["background-color"] == '#ffffff')) {
	                                dataObj.style["background-color"] = 'rgba(255, 255, 255, 0)';
	                            }
	                        });
	                    });
	                    break;
	                case 'RepeatingTable':
	                    if (properties && properties.Borders && !properties.Borders['Name']) {
	                        properties.Borders['Name'] = angular.copy(ControlProperties.RepeatingTableProperties.Borders['Name']);
	                    }
	                    if (!properties.Events) {
	                        properties.Events = angular.copy(ControlProperties.RepeatingTableProperties.Events);
	                    }
	                    if (!properties.Display['Fit-to-Screen']) {
	                        properties.Display['Fit-to-Screen'] = angular.copy(ControlProperties.TableProperties.Display['Fit-to-Screen']);
	                    }
	                    if (properties.Basic && !properties.Basic.ControlType) {
	                        properties.Basic.ControlType = 'RepeatingTable';
	                    }
	                    if (!properties.Display) {
	                        properties.Display = angular.copy(ControlProperties.RepeatingTableProperties.Display);
	                    }
	                    if (!properties.Display.RemoveOptions) {
	                        properties.Display.RemoveOptions = angular.copy(ControlProperties.RepeatingTableProperties.Display.RemoveOptions);
	                    }
	                    if (properties.Events && !properties.Events.OnInsertRow) {
	                        properties.Events['OnInsertRow'] = angular.copy(ControlProperties.RepeatingTableProperties.Events.OnInsertRow);
	                    }
	                    if (properties.Events && !properties.Events.OnDeleteRow) {
	                        properties.Events['OnDeleteRow'] = angular.copy(ControlProperties.RepeatingTableProperties.Events.OnDeleteRow);
	                    }
	                    if (properties && !properties.EvenOddRowStyle) {
	                        properties['EvenOddRowStyle'] = angular.copy(ControlProperties.RepeatingTableProperties.EvenOddRowStyle);
	                    }
	                    if (properties.Style) {
	                        properties.Style['style-group'].members = {};
	                        delete properties.Style['font-style-group'].members['font-family'];
	                        delete properties.Style['font-style-group'].members['font-size'];
	                    }
	                    if (!control.width) {
	                        control.ids = [];
	                        control.selectedRows = [];
	                        control.width = {};
	                        control.reset = false;
	                    }
	                    if (!properties['InsertButtonStyle']) {
	                        properties['InsertButtonStyle'] = angular.copy(ControlProperties.RepeatingTableProperties.InsertButtonStyle);
	                    }
	                    control.data[0].forEach(function (dataObj) {
	                        if (dataObj.style && (dataObj.style["background-color"] == 'rgb(255, 255, 255)' || dataObj.style["background-color"] == '#ffffff')) {
	                            dataObj.style["background-color"] = 'rgba(255, 255, 255, 0)';
	                        }
	                    });
	                    control.header_data[0].forEach(function (dataObj) {
	                        if (dataObj.style && (dataObj.style["background-color"] == 'rgb(255, 255, 255)' || dataObj.style["background-color"] == '#ffffff')) {
	                            dataObj.style["background-color"] = 'rgba(255, 255, 255, 0)';
	                        }
	                    });
	                    control.footer_data[0].forEach(function (dataObj) {
	                        if (dataObj.style && (dataObj.style["background-color"] == 'rgb(255, 255, 255)' || dataObj.style["background-color"] == '#ffffff')) {
	                            dataObj.style["background-color"] = 'rgba(255, 255, 255, 0)';
	                        }
	                    });
	                    this.findAndAddDataFieldName(control, allControls);
	                    migrateDataFieldName = true;
	                    break;
	                case 'Section':
	                    if (!properties.Events) {
	                        properties.Events = angular.copy(ControlProperties.SectionProperties.Events);
	                    }
	                    if (properties.Basic && !properties.Basic.ControlType) {
	                        properties.Basic.ControlType = 'Section';
	                    }
	                    if (properties.Style) {
	                        properties.Style['style-group'].members = {};
	                        delete properties.Style['font-style-group'].members['font-family'];
	                        delete properties.Style['font-style-group'].members['font-size'];
	                    }
	                    migrateDataFieldName = true;
	                    break;
	                case 'Map':
	                    if (properties && properties.ControlStyle) {
	                        properties.ControlStyle['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.ControlStyle['font-style-group'].members['font-family'].options);
	                    }
	                    if (properties && properties.Style) {
	                        properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
	                    }
	                    if (!properties.Events) {
	                        properties.Events = angular.copy(ControlProperties.MapProperties.Events);
	                    }
	                    if (properties.Basic && !properties.Basic.ControlType) {
	                        properties.Basic.ControlType = 'Map';
	                    }
	                    migrateDataFieldName = true;
	                    break;
	                case 'Signature':
	                    if (properties && properties.Style) {
	                        properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
	                    }
	                    if (!properties.Basic['Name']) {
	                        properties.Basic['Name'] = angular.copy(ControlProperties.SignatureProperties.Basic['Name']);
	                    }
	                    if (!properties.Events) {
	                        properties.Events = angular.copy(ControlProperties.SignatureProperties.Events);
	                    }
	                    if (properties.Basic && !properties.Basic.ControlType) {
	                        properties.Basic.ControlType = 'Signature';
	                    }
	                    if (!properties.Basic.Type) {
	                        properties.Basic.Type = angular.copy(ControlProperties.SignatureProperties.Basic.Type);
	                    }
	                    migrateDataFieldName = true;
	                    break;
	                case 'Checkbox':
	                    if (properties && properties.ControlStyle) {
	                        properties.ControlStyle['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.ControlStyle['font-style-group'].members['font-family'].options);
	                    }
	                    if (properties && properties.Style) {
	                        properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
	                    }
	                    if (!properties.Events) {
	                        properties.Events = angular.copy(ControlProperties.CheckboxProperties.Events);
	                    }
	                    if (properties.Basic && !properties.Basic.ControlType) {
	                        properties.Basic.ControlType = 'Checkbox';
	                    }
	                    if (properties.Basic['Spread Columns']) {
	                        delete properties.Basic['Spread Columns'];
	                    }
	                    if (!(properties.Basic['Display Format'])) {
	                        properties.Basic['Display Format'] = angular.copy(ControlProperties.CheckboxProperties.Basic['Display Format']);
	                    }
	                    if (!(properties.Basic['Number'])) {
	                        properties.Basic['Number'] = angular.copy(ControlProperties.CheckboxProperties.Basic['Number']);
	                    }
	                    migrateDataFieldName = true;
	                    break;
	                case 'Image':
	                    if (properties.Basic && !properties.Basic.ControlType) {
	                        properties.Basic.ControlType = 'Image';
	                    }
	                    break;
	                case 'Label':
	                    if (properties && properties.Style) {
	                        properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
	                    }
	                    if (properties.Basic && !properties.Basic.ControlType) {
	                        properties.Basic.ControlType = 'Label';
	                    }
	                    break;
	                case 'Dropdown':
	                    if (properties && properties.ControlStyle) {
	                        properties.ControlStyle['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.ControlStyle['font-style-group'].members['font-family'].options);
	                    }
	                    if (properties && properties.Style) {
	                        properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
	                    }
	                    if (!properties.Advance['App Status']) {
	                        properties.Advance['App Status'] = angular.copy(ControlProperties.DropdownProperties.Advance['App Status']);
	                    }
	                    if (properties.Advance['App Status'].selectedValue) {
	                        properties["Data Source"].Source.selectedValue = '4';
	                        properties["Data Source"].forceToDisabled = true;
	                    }
	                    if (!properties.Events) {
	                        properties.Events = angular.copy(ControlProperties.DropdownProperties.Events);
	                    }
	                    if (properties.Basic && !properties.Basic.ControlType) {
	                        properties.Basic.ControlType = 'Dropdown';
	                    }
	                    if (properties['Data Source'].Source.list) {
	                        properties['Data Source'].Source.list = ControlProperties.DropdownProperties['Data Source'].Source.list;
	                    }
	                    if (properties.Basic.Value.selectedValue.length > 0) {
	                        if (Array.isArray(properties.Basic.Value.selectedValue)) {
	                            var data = properties.Basic.Value.selectedValue;
	                            if (data && data[0].hasOwnProperty("Value")) {
	                                properties.Basic.Value.selectedValue = data.map(function (el) { return el.Value.name; }).join(",").split(',');
	                            }
	                        }
	                        else {
	                            properties.Basic.Value.selectedValue = properties.Basic.Value.selectedValue ? properties.Basic.Value.selectedValue.split(',') : [];
	                        }
	                    }
	                    if (properties && properties["Data Source"] && properties["Data Source"].customAttr && !properties["Data Source"].customAttr.hierarchyData) {
	                        properties["Data Source"].customAttr.hierarchyData = [];
	                    }
	                    if (properties && properties["Data Source"] && properties["Data Source"].customAttr && !properties["Data Source"].customAttr.hierarchyApplied) {
	                        properties["Data Source"].customAttr.hierarchyApplied = false;
	                    }
	                    migrateDataFieldName = true;
	                    break;
	                case 'MultiDropdown':
	                    if (properties && properties.ControlStyle) {
	                        properties.ControlStyle['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.ControlStyle['font-style-group'].members['font-family'].options);
	                    }
	                    if (properties && properties.Style) {
	                        properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
	                    }
	                    if (!properties.Events) {
	                        properties.Events = angular.copy(ControlProperties.MultiDropdownProperties.Events);
	                    }
	                    if (properties.Basic && !properties.Basic.ControlType) {
	                        properties.Basic.ControlType = 'MultiDropdown';
	                    }
	                    if (!properties["Data Source"].customAttr.hierarchyData) {
	                        properties["Data Source"].customAttr.hierarchyData = [];
	                    }
	                    if (!properties["Data Source"].customAttr.hierarchyApplied) {
	                        properties["Data Source"].customAttr.hierarchyApplied = false;
	                    }
	                    migrateDataFieldName = true;
	                    break;
	                case 'Datepicker':
	                    if (properties && properties.ControlStyle) {
	                        properties.ControlStyle['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.ControlStyle['font-style-group'].members['font-family'].options);
	                    }
	                    if (properties && properties.Style) {
	                        properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
	                    }
	                    if (!properties.Advance['Closed Date']) {
	                        properties.Advance['Closed Date'] = angular.copy(ControlProperties.DatepickerProperties.Advance['Closed Date']);
	                    }
	                    if (!properties.Basic.Default.dateType) {
	                        properties.Basic.Default.dateType = "1";
	                    }
	                    if (!properties.Basic.Default.days) {
	                        properties.Basic.Default.days = 0;
	                    }
	                    if (!properties.Events) {
	                        properties.Events = angular.copy(ControlProperties.DatepickerProperties.Events);
	                    }
	                    if (properties.Basic && !properties.Basic.ControlType) {
	                        properties.Basic.ControlType = 'Datepicker';
	                    }
	                    if (properties.Basic && properties.Basic['Display Format']) {
	                        properties.Basic['Display Format'].options = angular.copy(ControlProperties.DatepickerProperties.Basic['Display Format'].options);
	                    }
	                    properties.Basic['Display Format'].selectedValue = this.getDisplayFormat(properties);
	                    if (properties.Basic && !properties.Basic['Time']) {
	                        properties.Basic['Time'] = angular.copy(ControlProperties.DatepickerProperties.Basic['Time']);
	                    }
	                    if (properties.Basic && !properties.Basic['Time Format']) {
	                        properties.Basic['Time Format'] = angular.copy(ControlProperties.DatepickerProperties.Basic['Time Format']);
	                    }
	                    if (properties.Basic && !properties.Basic['Working Days']) {
	                        properties.Basic['Working Days'] = angular.copy(ControlProperties.DatepickerProperties.Basic['Working Days']);
	                        if (properties.Basic['Default']['dateType'] == '2') {
	                            properties.Basic['Working Days']['hidden'] = false;
	                        }
	                    }
	                    if (properties.Basic && !properties.Basic['Default'].onChangeFunction) {
	                        properties.Basic['Default']['onChangeFunction'] = angular.copy(ControlProperties.DatepickerProperties.Basic['Default'].onChangeFunction);
	                    }
	                    migrateDataFieldName = true;
	                    break;
	                case 'Timepicker':
	                    if (properties && properties.ControlStyle) {
	                        properties.ControlStyle['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.ControlStyle['font-style-group'].members['font-family'].options);
	                    }
	                    if (properties && properties.Style) {
	                        properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
	                    }
	                    if (!properties.Events) {
	                        properties.Events = angular.copy(ControlProperties.TimepickerProperties.Events);
	                    }
	                    if (properties.Basic && !properties.Basic.ControlType) {
	                        properties.Basic.ControlType = 'Timepicker';
	                    }
	                    if (!properties.Basic.Default.timeType) {
	                        properties.Basic.Default.timeType = "1";
	                    }
	                    migrateDataFieldName = true;
	                    break;
	                case 'Rating':
	                    if (properties && properties.ControlStyle) {
	                        properties.ControlStyle['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.ControlStyle['font-style-group'].members['font-family'].options);
	                    }
	                    if (properties && properties.Style) {
	                        properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
	                    }
	                    migrateDataFieldName = true;
	                    break;
	                case 'Display field':
	                    if (properties && properties.ControlStyle) {
	                        properties.ControlStyle['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.ControlStyle['font-style-group'].members['font-family'].options);
	                    }
	                    if (properties && properties.Style) {
	                        properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.TextboxProperties.Style['font-style-group'].members['font-family'].options);
	                    }
	                    if (!properties.Basic['formula']) {
	                        properties.Basic['formula'] = angular.copy(ControlProperties.DisplayFieldPropertise.Basic['formula']);
	                        if (!properties.Basic['formula']["edit"]) {
	                            properties.Basic['formula']["edit"] = angular.copy(ControlProperties.DisplayFieldPropertise.Basic['formula']["edit"]);
	                            properties.Basic['formula']["editText"] = angular.copy(ControlProperties.DisplayFieldPropertise.Basic['formula']["editText"]);
	                            properties.Basic['formula']["editValue"] = angular.copy(ControlProperties.DisplayFieldPropertise.Basic['formula']["editValue"]);
	                        }
	                    }
	                    if (properties.Basic && !properties.Basic.ControlType) {
	                        properties.Basic.ControlType = 'DisplayField';
	                    }
	                    if (control.derivedControlType == 'Datepicker') {
	                        if (properties.Basic) {
	                            this.getFieldNameForCalculatedField(control.derivedFromFieldName, properties);
	                        }
	                    }
	                    break;
	                case 'InlineAssocFiles':
	                    if (properties && properties.Style) {
	                        properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.InlineAssocFiles.Style['font-style-group'].members['font-family'].options);
	                    }
	                    if (!properties.Events) {
	                        properties.Events = angular.copy(ControlProperties.InlineAssocFiles.Events);
	                    }
	                    if (properties.Basic && !properties.Basic.ControlType) {
	                        properties.Basic.ControlType = 'InlineAssocFiles';
	                    }
	                    if (properties && properties.Style && properties['Style']['font-style-group'] && !properties['Style']['font-style-group'].members['background-color']) {
	                        properties['Style']['font-style-group'].members['background-color'] = {
	                            type: 'color-picker',
	                            title: 'background.color',
	                            selectedValue: '#ffffff',
	                            icon: 'fa fa-paint-brush'
	                        };
	                    }
	                    if (properties && !properties['Borders']) {
	                        properties['Borders'] = angular.copy(ControlProperties.InlineAssocFiles.Borders);
	                    }
	                    if (properties && properties.Style && !properties['Style']['style-group']) {
	                        properties['Style']['style-group'] = angular.copy(ControlProperties.InlineAssocFiles.Style['style-group']);
	                    }
	                    if (properties && properties.ControlStyle &&
	                        properties.ControlStyle['font-style-group'] &&
	                        properties.ControlStyle['font-style-group'].members &&
	                        properties.ControlStyle['font-style-group'].members['font-size'] &&
	                        properties.ControlStyle['font-style-group'].members['font-size'].min != '1') {
	                        properties.ControlStyle['font-style-group'].members['font-size'].min = '1';
	                    }
	                    migrateDataFieldName = true;
	                    break;
	                case 'InlineAssocApps':
	                    if (properties && properties.Style) {
	                        properties.Style['font-style-group'].members['font-family'].options = angular.copy(ControlProperties.InlineAssocApps.Style['font-style-group'].members['font-family'].options);
	                    }
	                    if (properties && properties.Style && properties['Style']['font-style-group'] && !properties['Style']['font-style-group'].members['background-color']) {
	                        properties['Style']['font-style-group'].members['background-color'] = {
	                            type: 'color-picker',
	                            title: 'background.color',
	                            selectedValue: '#ffffff',
	                            icon: 'fa fa-paint-brush'
	                        };
	                    }
	                    if (properties && !properties['Borders']) {
	                        properties['Borders'] = angular.copy(ControlProperties.InlineAssocApps.Borders);
	                    }
	                    if (properties && properties.Style && !properties['Style']['style-group']) {
	                        properties['Style']['style-group'] = angular.copy(ControlProperties.InlineAssocApps.Style['style-group']);
	                    }
	                    if (!properties.Events) {
	                        properties.Events = angular.copy(ControlProperties.InlineAssocApps.Events);
	                    }
	                    if (properties.Basic && !properties.Basic.ControlType) {
	                        properties.Basic.ControlType = 'InlineAssocApps';
	                    }
	                    if (properties && properties.ControlStyle &&
	                        properties.ControlStyle['font-style-group'] &&
	                        properties.ControlStyle['font-style-group'].members &&
	                        properties.ControlStyle['font-style-group'].members['font-size'] &&
	                        properties.ControlStyle['font-style-group'].members['font-size'].min != '1') {
	                        properties.ControlStyle['font-style-group'].members['font-size'].min = '1';
	                    }
	                    migrateDataFieldName = true;
	                    break;
	                case 'ViewAssociations':
	                    if (properties && properties.Style && properties['Style']['font-style-group'] && !properties['Style']['font-style-group'].members['background-color']) {
	                        properties['Style']['font-style-group'].members['background-color'] = {
	                            type: 'color-picker',
	                            title: 'background.color',
	                            selectedValue: '#ffffff',
	                            icon: 'fa fa-paint-brush'
	                        };
	                    }
	                    if (properties && !properties['Borders']) {
	                        properties['Borders'] = angular.copy(ControlProperties.ViewAssociations.Borders);
	                    }
	                    if (properties && properties.Style && !properties['Style']['style-group']) {
	                        properties['Style']['style-group'] = angular.copy(ControlProperties.ViewAssociations.Style['style-group']);
	                    }
	                    if (properties && properties.ControlStyle &&
	                        properties.ControlStyle['font-style-group'] &&
	                        properties.ControlStyle['font-style-group'].members &&
	                        properties.ControlStyle['font-style-group'].members['font-size'] &&
	                        properties.ControlStyle['font-style-group'].members['font-size'].min != '1') {
	                        properties.ControlStyle['font-style-group'].members['font-size'].min = '1';
	                    }
	                    migrateDataFieldName = true;
	                    break;
	            }
	            //Migrate Field name
	            if (properties.Basic && properties.Basic['Field Name']) {
	                var curFieldName = properties.Basic['Field Name'].selectedValue;
	                var controlFieldName = curFieldName;
	                if (controlFieldName.indexOf('-') != -1 || controlFieldName.indexOf('.') != -1 || controlFieldName.indexOf('___') != -1) {
	                    controlFieldName = this.Util.replaceAllMatches(controlFieldName, '-', '_');
	                    controlFieldName = this.Util.replaceAllMatches(controlFieldName, '.', '_');
	                    controlFieldName = this.Util.replaceUnderscoresValue(controlFieldName);
	                    this.renamedFieldNames[curFieldName] = controlFieldName;
	                    properties.Basic['Field Name'].selectedValue = controlFieldName;
	                }
	                properties.Basic['Field Name'].prevSelectedValue = controlFieldName;
	            }
	            //Set hidden property exluding Line control
	            if (control.type != 'Line') {
	                if (!properties.Display) {
	                    properties.Display = {
	                        Name: {
	                            selectedValue: 'Display',
	                            hidden: true
	                        }
	                    };
	                }
	                if (!properties.Display.Hidden) {
	                    properties.Display.Hidden = {
	                        name: "hidden",
	                        selectedValue: false,
	                        type: "checkbox"
	                    };
	                }
	            }
	            //Set Data Field Name from Field Name property
	            if (migrateDataFieldName) {
	                if (properties.Basic && properties.Basic['Field Name'] && !properties.Basic['Data Field Name']) {
	                    properties.Basic['Data Field Name'] = Props.getDataFieldName(properties.Basic['Field Name'].selectedValue);
	                    properties.Basic['Data Field Name'].prevSelectedValue = properties.Basic['Field Name'].selectedValue;
	                }
	                if (properties.Basic && properties.Basic['Data Field Name']) {
	                    var curDataFieldName = properties.Basic['Data Field Name'].selectedValue;
	                    var controlDataFieldName = curDataFieldName;
	                    if (controlDataFieldName && (controlDataFieldName.indexOf('-') != -1 || controlDataFieldName.indexOf('.') != -1 || controlDataFieldName.indexOf('___') != -1)) {
	                        controlDataFieldName = this.Util.replaceAllMatches(controlDataFieldName, '-', '_');
	                        controlDataFieldName = this.Util.replaceAllMatches(controlDataFieldName, '.', '_');
	                        controlDataFieldName = this.Util.replaceUnderscoresValue(controlDataFieldName);
	                        this.renamedDataFieldNames[curDataFieldName] = controlDataFieldName;
	                        properties.Basic['Data Field Name'].selectedValue = controlDataFieldName;
	                    }
	                    properties.Basic['Data Field Name'].prevSelectedValue = controlDataFieldName;
	                }
	                if (control.readOnly || control.forceToReadOnly) {
	                    properties.Basic['Data Field Name'].disable = true;
	                }
	            }
	            else if (properties.Basic && properties.Basic['Data Field Name']) {
	                delete properties.Basic['Data Field Name'];
	            }
	            //Mark event as disable if control is paste as readonly control
	            if (properties.Events && (control.readOnly || control.forceToReadOnly || control.copiedFrom)) {
	                for (var event_5 in properties.Events) {
	                    if (event_5 != 'Name' && event_5 != 'forceToDisabled') {
	                        properties.Events[event_5].disable = true;
	                    }
	                }
	            }
	        }
	        catch (e) {
	            console.error('Failed to initial migration for control type is : ', control.type, e);
	        }
	    };
	    CreateComponent.prototype.findAndAddDataFieldName = function (control, allControls) {
	        var _this = this;
	        var datafieldname = _.get(control.properties, 'Basic["Data Field Name"].selectedValue');
	        if (datafieldname === undefined) {
	            var copiedFromRepeatingTable_1 = control.copiedFromRepeatingTable;
	            var pasteAsCalculatedFrom = control.pasteAsCalculatedFrom;
	            if (control.copiedFrom) {
	                control.forceToReadOnly = true;
	            }
	            if (copiedFromRepeatingTable_1 === undefined && pasteAsCalculatedFrom === undefined) {
	                copiedFromRepeatingTable_1 = _.get(control.properties, 'Basic["Field Name"].selectedValue');
	                this.addDatafieldName(control, copiedFromRepeatingTable_1, pasteAsCalculatedFrom !== undefined);
	            }
	            else if (copiedFromRepeatingTable_1 !== undefined) {
	                var newDFName_1 = "";
	                allControls.every(function (allElement) {
	                    if (_.get(allElement.properties, 'Basic["Field Name"].selectedValue') === copiedFromRepeatingTable_1) {
	                        if (!(_.get(allElement.properties, 'Basic["Data Field Name"].selectedValue'))) {
	                            _this.findAndAddDataFieldName(allElement, allControls);
	                        }
	                        newDFName_1 = _.get(allElement.properties, 'Basic["Data Field Name"].selectedValue');
	                    }
	                    return newDFName_1 === "";
	                });
	                this.addDatafieldName(control, newDFName_1, pasteAsCalculatedFrom !== undefined);
	            }
	            else if (pasteAsCalculatedFrom !== undefined) {
	                var newDFName = pasteAsCalculatedFrom;
	                this.addDatafieldName(control, newDFName, true);
	            }
	        }
	    };
	    CreateComponent.prototype.addDatafieldName = function (control, dataFieldName, hiddenView) {
	        var newBasic = {};
	        for (var key in control.properties.Basic) {
	            newBasic[key] = control.properties.Basic[key];
	            if (key === 'Field Name') {
	                dataFieldName = !dataFieldName ? newBasic[key].selectedValue : dataFieldName; // if we get datafieldname empty;
	                newBasic['Data Field Name'] = Props.getDataFieldName(dataFieldName);
	                newBasic['Data Field Name'].prevSelectedValue = dataFieldName;
	                if (hiddenView) {
	                    newBasic['Data Field Name'].hidden = hiddenView;
	                }
	            }
	        }
	        control.properties.Basic = newBasic;
	    };
	    CreateComponent.prototype.getFieldNameForCalculatedField = function (dataFieldName, properties) {
	        var controlList = this.getControlsByDataFieldName(dataFieldName);
	        if (controlList.length >= 1) {
	            controlList.forEach(function (control) {
	                if (!control.forceToReadOnly && !control.readOnly && control.properties.Basic && control.properties.Basic['Field Name'].selectedValue) {
	                    properties.Basic.RefFieldName = control.properties.Basic['Field Name'].selectedValue;
	                }
	            });
	        }
	    };
	    CreateComponent.prototype.getValidationMsg = function (pattern) {
	        try {
	            if (!pattern) {
	                return '';
	            }
	            var validationMsg = '';
	            switch (pattern) {
	                case 'Numeric':
	                    validationMsg = "Please enter a valid number.";
	                    break;
	                case 'Alphanumeric':
	                    validationMsg = "Please enter only alphanumeric characters.";
	                    break;
	                case "Email":
	                    validationMsg = "Please enter valid email address.";
	                    break;
	                case "Integer":
	                    validationMsg = "Please enter valid integer.";
	                    break;
	                case "Decimal":
	                    validationMsg = "Please enter valid decimal.";
	                    break;
	                case "Letters":
	                    validationMsg = "Please enter valid letters.";
	                    break;
	            }
	            return validationMsg;
	        }
	        catch (e) {
	            console.log(e);
	            return '';
	        }
	    };
	    CreateComponent.prototype.setErrorMessage = function (BasicProps, AdvanceProps) {
	        var _this = this;
	        var input = window.event && angular.element(window.event.target);
	        setTimeout(function () {
	            if (input && input.hasClass('ng-invalid')) {
	                AdvanceProps.Tooltip.errorMessage = _this.getValidationMsg(BasicProps.Validate.selectedValue);
	            }
	            else {
	                AdvanceProps.Tooltip.errorMessage = '';
	            }
	        }, 0);
	    };
	    CreateComponent.prototype.onEvent = function (handler) {
	        //Don't set any proerpty via script logic as of now so mark this line as commented
	        /* if(handler) {
	          try {
	            eval(handler);
	          } catch(e) {
	            console.error('Error when execute method on event. Method: ', e, handler)
	          }
	        } */
	    };
	    CreateComponent.prototype.extractContent = function (s) {
	        var span = document.createElement('span');
	        span.innerHTML = s;
	        return span.textContent || span.innerText;
	    };
	    ;
	    CreateComponent.prototype.onChangeModelValue = function (uid, controlType, dataFieldName, value) {
	        if (!uid || !controlType || !dataFieldName) {
	            return;
	        }
	        var controlList = this.getControlsByDataFieldName(dataFieldName);
	        if (controlType == 'Textbox') {
	            this.$rootScope.$broadcast('controlValueChanged', controlList[0].properties.Basic);
	        }
	        if (controlType == "RichTextArea") {
	            if (this.extractContent(value).length > controlList[0].properties.Display['Char-Limit'].selectedValue) {
	                return;
	            }
	        }
	        if (controlList.length == 1) {
	            return;
	        }
	        //specially for timepicker
	        if (typeof value == 'object' && controlType == 'Timepicker') {
	            value = value['Basic']['Default'].selectedValue;
	        }
	        if (value == undefined || value == null) {
	            value = '';
	        }
	        if (controlType == 'Checkbox' || controlType == 'Radio') {
	            var selectedItemsVal_2 = [];
	            value.forEach && value.forEach(function (item) {
	                if (item.selectedValue && item.selectedValue.name) {
	                    selectedItemsVal_2.push(item.Value.name);
	                }
	            });
	            value = selectedItemsVal_2.join(', ');
	        }
	        window.setPropValueByDataFieldName(dataFieldName, value, uid, true);
	    };
	    CreateComponent.prototype.setWrapText = function (item, el) {
	        var _this = this;
	        clearTimeout(this.wrapTextTimeOut);
	        this.wrapTextTimeOut = setTimeout(function () {
	            _this.setWrapForPasteControl(item.properties.Basic['Data Field Name'].selectedValue);
	        }, 300);
	        if (el && el.target || item.type === 'Text-Area') {
	            if ((item.properties.Display.Wraptext && item.properties.Display.Wraptext.selectedValue) || item.type === 'Text-Area') {
	                item.type === 'Text-Area' ? el.target.style.height = 74 + 'px' : el.target.style.height = 35 + 'px';
	                el.target.style.height = el.target.scrollHeight + 'px';
	                el.target.style.whiteSpace = 'normal';
	                el.target.style.overflow = 'hidden';
	            }
	            else {
	                el.target.style.height = '';
	                el.target.style.whiteSpace = 'nowrap';
	            }
	        }
	    };
	    CreateComponent.prototype.setWrapForPasteControl = function (dataFieldName) {
	        var controlList = this.getControlsByDataFieldName(dataFieldName);
	        if (controlList && controlList.length > 1) {
	            for (var i = 0; i < controlList.length; i++) {
	                var textareaId = controlList[i].uid;
	                var textelem = angular.element("textarea[textarea-id=" + textareaId + "]");
	                if (controlList[i].properties.Display && controlList[i].properties.Display.Wraptext.selectedValue) {
	                    textelem[0].style.whiteSpace = 'normal';
	                    textelem[0].style.height = textelem[0].scrollHeight + 'px';
	                }
	            }
	        }
	    };
	    CreateComponent.prototype.setWrapTextarea = function (item) {
	        var textareaId = item.uid;
	        textareaId && setTimeout(function () {
	            var textelem = angular.element("textarea[textarea-id=" + textareaId + "]");
	            for (var i = 0; i < textelem.length; i++) {
	                if ((item.properties['Display'].Wraptext && item.properties['Display'].Wraptext.selectedValue && textelem[i].textLength > 0) || item.type === 'Text-Area') {
	                    textelem[i].style.whiteSpace = 'pre-wrap';
	                    textelem[i].style.overflow = 'hidden';
	                    textelem[i].style.height = textelem[0].scrollHeight + 'px';
	                }
	            }
	        }, 100);
	    };
	    CreateComponent.prototype.selectAll = function () {
	        var selected = this.selectedView.view.controls.A;
	        var i = 0;
	        if (selected.length) {
	            for (i; i < selected.length; i++) {
	                selected[i].selected = true;
	            }
	        }
	        this.selectedItemDomain = selected;
	        this.selectedItemIndex = i;
	        this.selectedItemView = this.selectedView.view.viewName;
	    };
	    CreateComponent.prototype.createArrayInRange = function (min, max) {
	        var result = [];
	        for (var i = min; i <= max; i++) {
	            result.push(i);
	        }
	        return result;
	    };
	    CreateComponent.prototype.getArray = function (item) {
	        var stop = Number(item.properties.Basic.Max.selectedValue);
	        var start = Number(item.properties.Basic.Min.selectedValue);
	        var step = Number(item.properties.Basic.Step.selectedValue);
	        var arrNumbers = Array.from({ length: (stop - start) / step + 1 }, function (_, i) { return start + i * step; });
	        return arrNumbers;
	    };
	    CreateComponent.prototype.isNotEmpty = function (item) {
	        var ele = angular.element('.form-builder').find("[name=\"" + item.properties.Basic["Field Name"].selectedValue + "\"]");
	        var empty = ele.hasClass("ng-empty"); //true if empty
	        var notEmpty = ele.hasClass("ng-not-empty"); //true if notEmpty
	        if (!empty && !notEmpty) {
	            var value = item.properties.Basic.Value.selectedValue;
	            return (value || value === undefined || value === 0);
	        }
	        else {
	            return !empty;
	        }
	    };
	    CreateComponent.prototype.onPrintChangeHandler = function () {
	        if (JSON.parse(this.isPuppeteerViewEnabled)) {
	            this.printTypeText = 'advance.printing';
	        }
	        else {
	            this.printTypeText = 'basic.printing';
	        }
	    };
	    CreateComponent.prototype.onKeyUp = function (event) {
	        var contentEditable = event.target.isContentEditable;
	        // Check if the platform is macOS
	        var isMac = navigator.platform.includes('Mac');
	        // Determine the correct modifier key based on the OS
	        var modifierKey = isMac ? event.metaKey : event.ctrlKey;
	        // Checking if any modal is open or only ctrl key is pressed or publish in progress
	        if (angular.element('.modal-open').length || !modifierKey || this.publishWarn == undefined) {
	            return;
	        }
	        if (modifierKey) {
	            if (!contentEditable) {
	                if (event.altKey && (event.keyCode == 65 || event.originalEvent["code"] == "KeyA")) {
	                    this.selectAll();
	                }
	                else if (event.shiftKey && (event.keyCode == 86 || event.originalEvent["code"] == "KeyV")) {
	                    this.pasteAsReadOnly();
	                }
	                else if (event.altKey && (event.keyCode == 86 || event.originalEvent["code"] == "KeyV")) {
	                    this.pasteAsCalculatedField();
	                }
	            }
	            if (event.altKey) {
	                if (event.key === 'z' || event.key === 'Z') {
	                    this.$rootScope.$broadcast('undoRedo', 'UNDO');
	                }
	                else if (event.key === 'y' || event.key === 'Y') {
	                    this.$rootScope.$broadcast('undoRedo', 'REDO');
	                }
	                else if (event.keyCode == 83 || event.originalEvent["code"] == "KeyS") {
	                    this.validateAndSave(undefined);
	                }
	                else if (event.keyCode == 80 || event.originalEvent["code"] == "KeyP") {
	                    if (this.publishWarn != undefined) {
	                        if (!this.publishWarn) {
	                            this.publishWarning();
	                        }
	                        else {
	                            this.ngNotification.warning({
	                                message: '', positionX: 'center', replaceMessage: true, templateUrl: "notification_dismiss.html", scope: this.$scope
	                            });
	                            this.publish();
	                        }
	                    }
	                }
	                else if (event.keyCode == 67 || event.originalEvent["code"] == "KeyC") {
	                    this.ngNotification.warning({
	                        message: '', positionX: 'center', replaceMessage: true, templateUrl: "notification_dismiss.html", scope: this.$scope
	                    });
	                    if (this.publishWarn != undefined)
	                        this.publishWarn = false;
	                }
	            }
	            else if (event.keyCode == 46 || event.originalEvent["code"] == "Delete") {
	                this.remove(false);
	            }
	        }
	    };
	    /**
	     * Handles the `keydown` event to implement undo and redo functionality for Mac users.
	     *
	     * - Listens for `Command + Z` to trigger an undo action.
	     * - Listens for `Command + Shift + Z` to trigger a redo action.
	     * - Prevents default browser behavior for these key combinations.
	     * - Ensures the functionality is only active when no modal is open and `publishWarn` is defined.
	     *
	     * @param event - The keyboard event triggered by the user.
	     */
	    CreateComponent.prototype.onKeyDown = function (event) {
	        var isMac = navigator.platform.includes("Mac");
	        if (!isMac)
	            return;
	        // Checking if any modal is open or only ctrl key is pressed or publish in progress
	        if (angular.element('.modal-open').length || this.publishWarn == undefined) {
	            return;
	        }
	        if (event.metaKey && !event.shiftKey && event.key.toLowerCase() === "z") {
	            event.preventDefault();
	            this.$rootScope.$broadcast("undoRedo", "UNDO");
	        }
	        if (event.metaKey && event.shiftKey && event.key.toLowerCase() === "z") {
	            event.preventDefault();
	            this.$rootScope.$broadcast("undoRedo", "REDO");
	        }
	    };
	    CreateComponent.prototype.openTemplateDialog = function (itemname) {
	        var parentCtrl = this;
	        this.$uibModal.open({
	            component: itemname,
	            backdrop: 'static',
	            keyboard: false,
	            size: 'lg',
	            resolve: {
	                modalData: function () {
	                    return parentCtrl;
	                }
	            }
	        }).result.then(function (result) {
	            console.info("I was closed, so do what I need to do myContent's controller now.  Result was->");
	        }, function (reason) {
	            console.info("I was dimissed, so do what I need to do myContent's controller now.  Reason was->" + reason);
	        });
	        ;
	    };
	    CreateComponent.prototype.openPrintSettingDialog = function () {
	        var self = this;
	        var printModalInstance = self.$uibModal.open({
	            animation: true,
	            ariaLabelledBy: 'modal-title',
	            ariaDescribedBy: 'modal-body',
	            templateUrl: 'printSetting.html',
	            backdrop: 'static',
	            keyboard: false,
	            controllerAs: '$printctrl',
	            windowClass: 'print-settings-modal',
	            appendTo: angular.element(self.$document[0].querySelector('.canvas')),
	            controller: function () {
	                this.printingOptions = {
	                    type: "false",
	                    isLandscape: "false"
	                };
	                this.printingOptions.type = self.isPuppeteerViewEnabled ? self.isPuppeteerViewEnabled : "false";
	                this.printingOptions.isLandscape = self.isLandscape ? self.isLandscape : "false";
	                this.save = function () {
	                    self.isPuppeteerViewEnabled = this.printingOptions.type;
	                    self.isLandscape = this.printingOptions.isLandscape;
	                    printModalInstance.close(false);
	                };
	                /**
	                 * @brief      Close dialog
	                 * @return     NULL
	                 */
	                this.cancel = function () {
	                    printModalInstance.close(false);
	                };
	            }
	        });
	    };
	    return CreateComponent;
	}());
	exports.CreateComponent = CreateComponent;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('nodeApp.create', [uiRouter, 'dndLists', html_source_component_1.default])
	    .config(create_routes_1.default)
	    .component('create', {
	    template: __webpack_require__(332),
	    controller: CreateComponent,
	    controllerAs: 'createCtrl'
	})
	    .name;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Label_1 = __webpack_require__(298);
	exports.LabelProperties = Label_1.default;
	var Button_1 = __webpack_require__(299);
	exports.ButtonProperties = Button_1.default;
	var SiteLocationButton_1 = __webpack_require__(300);
	exports.SiteLocationButtonProperties = SiteLocationButton_1.default;
	var Display_Field_1 = __webpack_require__(301);
	exports.DisplayFieldPropertise = Display_Field_1.default;
	var Textbox_1 = __webpack_require__(302);
	exports.TextboxProperties = Textbox_1.default;
	var Textarea_1 = __webpack_require__(303);
	exports.TextareaProperties = Textarea_1.default;
	var Rich_Text_Area_1 = __webpack_require__(304);
	exports.RichTextAreaProperties = Rich_Text_Area_1.default;
	var Dropdown_1 = __webpack_require__(305);
	exports.DropdownProperties = Dropdown_1.default;
	var Checkbox_1 = __webpack_require__(306);
	exports.CheckboxProperties = Checkbox_1.default;
	var Radio_1 = __webpack_require__(307);
	exports.RadioProperties = Radio_1.default;
	var Datepicker_1 = __webpack_require__(308);
	exports.DatepickerProperties = Datepicker_1.default;
	var Timepicker_1 = __webpack_require__(309);
	exports.TimepickerProperties = Timepicker_1.default;
	var Map_1 = __webpack_require__(310);
	exports.MapProperties = Map_1.default;
	var Image_1 = __webpack_require__(311);
	exports.ImageProperties = Image_1.default;
	var Signature_1 = __webpack_require__(312);
	exports.SignatureProperties = Signature_1.default;
	var Attachment_1 = __webpack_require__(313);
	exports.AttachmentProperties = Attachment_1.default;
	var Line_1 = __webpack_require__(314);
	exports.LineProperties = Line_1.default;
	var Layout_1 = __webpack_require__(315);
	exports.LayoutProperties = Layout_1.default;
	var Table_1 = __webpack_require__(316);
	exports.TableProperties = Table_1.default;
	var Repeating_Table_1 = __webpack_require__(317);
	exports.RepeatingTableProperties = Repeating_Table_1.default;
	var Toggle_Button_1 = __webpack_require__(318);
	exports.ToggleButtonProperties = Toggle_Button_1.default;
	var Hyperlink_1 = __webpack_require__(319);
	exports.HyperlinkProperties = Hyperlink_1.default;
	var MultiDropdown_1 = __webpack_require__(320);
	exports.MultiDropdownProperties = MultiDropdown_1.default;
	var Rating_1 = __webpack_require__(321);
	exports.RatingProperties = Rating_1.default;
	var Section_1 = __webpack_require__(322);
	exports.SectionProperties = Section_1.default;
	var Inlineassociation_1 = __webpack_require__(323);
	exports.InlineAssocFiles = Inlineassociation_1.default;
	var InlineassociationApps_1 = __webpack_require__(324);
	exports.InlineAssocApps = InlineassociationApps_1.default;
	var ViewAssociations_1 = __webpack_require__(325);
	exports.ViewAssociations = ViewAssociations_1.default;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var LabelPropertise = {
	    Basic: {
	        'ControlType': 'Label',
	        'Text': {
	            name: 'text',
	            selectedValue: 'Label',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe'
	        },
	        'Field Name': Props.getFieldName('Label'),
	        'Name': {
	            selectedValue: 'Basic',
	            hidden: true
	        }
	    },
	    Display: {
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        }
	    },
	    Style: angular.copy(Props.styleObject),
	    Margin: angular.copy(Props.marginObject)
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = LabelPropertise;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var ButtonPropertise = {
	    Basic: {
	        'ControlType': 'Button',
	        'Text': {
	            name: 'text',
	            selectedValue: 'Button',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe'
	        },
	        'Field Name': Props.getFieldName('Button'),
	        'Name': {
	            selectedValue: 'Basic',
	            hidden: true
	        },
	    },
	    Display: {
	        'Read-only': {
	            name: 'read.only',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        }
	    },
	    Style: angular.copy(Props.styleObject),
	    Margin: angular.copy(Props.marginObject),
	    Advance: {
	        'Tooltip': {
	            name: 'tooltip',
	            type: 'textbox',
	            selectedValue: ''
	        },
	        'Tabindex': {
	            name: 'tabindex',
	            selectedValue: '',
	            type: 'number'
	        },
	        'Name': {
	            selectedValue: 'Advanced',
	            hidden: true
	        }
	    },
	    Events: {
	        Name: {
	            selectedValue: 'Events',
	            hideSection: false,
	            hidden: true
	        },
	        load: angular.copy(Props.elementEventsObject).load,
	        click: {
	            name: 'onClick',
	            type: 'event',
	            selectedValue: '',
	            xmlValue: '',
	            onClickFunction: 'openCodeEditorDialog'
	        },
	    },
	    Size: {
	        'Height': {
	            name: 'height',
	            selectedValue: 'auto',
	            type: 'textbox'
	        },
	        'Width': {
	            name: 'width',
	            selectedValue: 'auto',
	            type: 'textbox'
	        },
	        'Name': {
	            selectedValue: 'Size',
	            hidden: true
	        }
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = ButtonPropertise;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var SiteLocationButtonProperties = {
	    Basic: {
	        'ControlType': 'SiteLocationButton',
	        'Text': {
	            name: 'text',
	            selectedValue: 'Site Location',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe'
	        },
	        'Field Name': Props.getFieldName('SiteLocationButton'),
	        'Name': {
	            selectedValue: 'Basic',
	            hidden: true
	        },
	    },
	    Display: {
	        'Read-only': {
	            name: 'read.only',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        }
	    },
	    Style: angular.copy(Props.styleObject),
	    Margin: angular.copy(Props.marginObject),
	    Advance: {
	        'Tooltip': {
	            name: 'tooltip',
	            type: 'textbox',
	            selectedValue: ''
	        },
	        'Tabindex': {
	            name: 'tabindex',
	            selectedValue: '',
	            type: 'number'
	        },
	        'Name': {
	            selectedValue: 'Advanced',
	            hidden: true
	        }
	    },
	    Events: {
	        Name: {
	            selectedValue: 'Events',
	            hideSection: false,
	            hidden: true
	        },
	        load: angular.copy(Props.elementEventsObject).load,
	        click: {
	            name: 'onClick',
	            type: 'event',
	            selectedValue: '',
	            xmlValue: '',
	            onClickFunction: 'openCodeEditorDialog'
	        },
	    },
	    Size: {
	        'Height': {
	            name: 'height',
	            selectedValue: 'auto',
	            type: 'textbox'
	        },
	        'Width': {
	            name: 'width',
	            selectedValue: 'auto',
	            type: 'textbox'
	        },
	        'Name': {
	            selectedValue: 'Size',
	            hidden: true
	        }
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = SiteLocationButtonProperties;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var DisplayFieldPropertise = {
	    Basic: {
	        'ControlType': 'DisplayField',
	        'Label': {
	            name: 'label',
	            selectedValue: 'Label',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe',
	            isSelected: false
	        },
	        'Field Name': Props.getFieldName('Calculated_Value'),
	        'Value': {
	            name: 'value',
	            selectedValue: '',
	            type: 'textbox',
	            onClickFunction: 'existingDataField',
	            addOnButton: 'fa fa-function',
	            onChangeFunction: 'updateDSField',
	            readonly: false
	        },
	        'DSName': {
	            selectedValue: '',
	            hidden: true
	        },
	        'Name': {
	            selectedValue: 'Basic',
	            hidden: true
	        },
	        'Type': {
	            number: false,
	            numberUnderRepeatingTable: false,
	            hidden: true,
	            calculation: ""
	        },
	        'formula': {
	            name: '',
	            selectedValue: '',
	            rules: '',
	            type: 'div',
	            hidden: true,
	            class: 'formulaDiv',
	            html: '',
	            advanceQuery: '',
	            edit: false,
	            editText: "Edit",
	            editedValue: "",
	            uids: []
	        },
	        'parentNode': {
	            id: 0,
	            hidden: true,
	            footer: false
	        },
	        'list': {
	            hidden: true,
	            listItem: [
	                {
	                    id: 0,
	                    drag: {
	                        name: "drag"
	                    },
	                    field: {
	                        name: "field",
	                        value: '',
	                        onClickFunction: 'existingDataField',
	                        selectedType: ''
	                    },
	                    operator: {
	                        name: "operator",
	                        options: [
	                            {
	                                key: 'Equal to',
	                                value: 'Equal to'
	                            },
	                            {
	                                key: 'Not equal to',
	                                value: 'Not equal to'
	                            },
	                            {
	                                key: 'Empty',
	                                value: 'Empty'
	                            },
	                            {
	                                key: 'Not empty',
	                                value: 'Not empty'
	                            },
	                            {
	                                key: 'Less than',
	                                value: 'Less than'
	                            },
	                            {
	                                key: 'Greater than',
	                                value: 'Greater than'
	                            }
	                        ],
	                        selected: 'Equal to'
	                    },
	                    target: {
	                        name: "target",
	                        value: 0,
	                        hidden: false,
	                        disable: false
	                    },
	                    conjuction: {
	                        name: "conjuction",
	                        hidden: true,
	                        options: [
	                            {
	                                key: 'AND',
	                                value: 'AND'
	                            }
	                        ],
	                        selected: 'AND'
	                    },
	                    add: {
	                        title: "add.condition"
	                    },
	                    remove: {
	                        title: "remove.condition",
	                        hidden: true
	                    },
	                    addField: {
	                        name: "addField",
	                        value: '',
	                        disable: true
	                    },
	                    addSum: {
	                        name: "addSum",
	                        disable: true
	                    },
	                }
	            ]
	        }
	    },
	    Display: {
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        }
	    },
	    Style: angular.copy(Props.labelStyleObject),
	    ControlStyle: angular.copy(Props.controlStyleObject),
	    Margin: angular.copy(Props.marginObject),
	    Advance: {
	        'Searchable': angular.copy(Props.Searchable),
	        'Reportable': angular.copy(Props.Reportable),
	        'customizable-column': angular.copy(Props.Customizable),
	        'Name': {
	            selectedValue: 'Advanced',
	            hidden: true
	        }
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = DisplayFieldPropertise;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var TextboxProperties = {
	    Basic: {
	        'ControlType': 'Textbox',
	        'Label': {
	            name: 'label',
	            selectedValue: 'Textbox',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe',
	        },
	        'Field Name': Props.getFieldName('Textbox'),
	        'Data Field Name': Props.getDataFieldName('Textbox'),
	        'Value': {
	            name: 'value',
	            selectedValue: '',
	            type: 'textbox',
	            onClickFunction: 'existingDataField',
	            addOnButton: 'fa fa-function',
	            onChangeFunction: 'updateDSField'
	        },
	        'DSName': {
	            selectedValue: '',
	            hidden: true
	        },
	        /*'Default': {
	            name: 'Default',
	            selectedValue: '',
	            type: 'textbox'
	        },*/
	        'Required': {
	            name: 'required',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Validate': {
	            name: 'format',
	            type: 'dd',
	            disable: false,
	            options: [
	                {
	                    key: 'Please Select',
	                    value: ''
	                },
	                {
	                    key: 'Integer',
	                    value: 'Integer'
	                },
	                {
	                    key: 'Decimal',
	                    value: 'Decimal'
	                },
	                {
	                    key: 'Letters-and-Numbers',
	                    value: 'Alphanumeric'
	                },
	                {
	                    key: 'Letters',
	                    value: 'Letters'
	                },
	                {
	                    key: 'Email',
	                    value: 'Email'
	                }
	            ],
	            selectedValue: '',
	            onChangeFunction: 'onFormatTypeChanged'
	        },
	        'DigitSeparator': {
	            name: 'digit.separator',
	            type: 'checkbox',
	            selectedValue: false,
	            onChangeFunction: 'onDigitSepratorToggle',
	            onClickFunction: 'openLanguageDialogForNumberSeparator',
	            addOnButton: 'fa fa-globe digit-separator-global-icon hidden',
	            extraClass: 'child-1',
	            hidden: true
	        },
	        'DecimalPlaces': {
	            name: 'decimal.places',
	            type: 'dd',
	            extraClass: 'child-1',
	            options: [
	                {
	                    key: '0',
	                    value: '0'
	                },
	                {
	                    key: '1',
	                    value: '1'
	                },
	                {
	                    key: '2',
	                    value: '2'
	                },
	                {
	                    key: '3',
	                    value: '3'
	                },
	                {
	                    key: '4',
	                    value: '4'
	                },
	                {
	                    key: '5',
	                    value: '5'
	                },
	                {
	                    key: '6',
	                    value: '6'
	                },
	                {
	                    key: '7',
	                    value: '7'
	                },
	                {
	                    key: '8',
	                    value: '8'
	                },
	                {
	                    key: '9',
	                    value: '9'
	                }
	            ],
	            selectedValue: '0',
	            hidden: true
	        },
	        'DecimalThousandSeparator': {
	            selectedValue: {
	                Default: {
	                    displayCountry: "Default",
	                    displayLanguage: "Default",
	                    languageId: "Default",
	                    decimal: ".",
	                    thousand: ",",
	                }
	            },
	            extraClass: 'child-1',
	            hidden: true
	        },
	        'Name': {
	            selectedValue: 'Basic',
	            hidden: true
	        },
	        'Type': {
	            number: false,
	            hidden: true
	        },
	        'parentNode': {
	            id: 0,
	            hidden: true
	        },
	    },
	    Display: {
	        'Place Holder': {
	            name: 'place.holder',
	            selectedValue: '',
	            type: 'textbox'
	        },
	        'Read-only': {
	            name: 'read.only',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Wraptext': {
	            name: 'wrap.text',
	            selectedValue: false,
	            type: 'checkbox',
	            onChangeFunction: 'setWrapText'
	        },
	        'Char-Limit': {
	            name: 'char.limit',
	            selectedValue: 500,
	            type: 'number',
	            min: 1,
	            max: 500
	        },
	        'HasMic': {
	            name: 'show.mic',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        }
	    },
	    Style: angular.copy(Props.labelStyleObject),
	    ControlStyle: angular.copy(Props.controlStyleObject),
	    Margin: angular.copy(Props.marginObject),
	    Advance: {
	        'Tooltip': {
	            name: 'tooltip',
	            type: 'textbox',
	            selectedValue: ''
	        },
	        'Tabindex': {
	            name: 'tabindex',
	            selectedValue: '',
	            type: 'number'
	        },
	        'Searchable': angular.copy(Props.Searchable),
	        'Reportable': angular.copy(Props.Reportable),
	        'customizable-column': angular.copy(Props.Customizable),
	        'Name': {
	            selectedValue: 'Advanced',
	            hidden: true
	        }
	    },
	    Events: angular.copy(Props.elementEventsObject)
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = TextboxProperties;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var TextareaProperties = {
	    Basic: {
	        'ControlType': 'Textarea',
	        'Label': {
	            name: 'label',
	            selectedValue: 'Text-Area',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe'
	        },
	        'Field Name': Props.getFieldName('Text_Area'),
	        'Data Field Name': Props.getDataFieldName('Text_Area'),
	        'Value': {
	            name: 'value',
	            selectedValue: '',
	            type: 'textbox',
	            onClickFunction: 'existingDataField',
	            addOnButton: 'fa fa-function',
	            onChangeFunction: 'updateDSField'
	        },
	        'DSName': {
	            selectedValue: '',
	            hidden: true
	        },
	        /*'Default': {
	            name: 'Default',
	            selectedValue: '',
	            type: 'textbox'
	        },*/
	        'Required': {
	            name: 'required',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Validate': {
	            name: 'format',
	            type: 'dd',
	            disable: false,
	            options: [
	                {
	                    key: 'Please Select',
	                    value: ''
	                },
	                {
	                    key: 'Integer',
	                    value: 'Integer'
	                },
	                {
	                    key: 'Decimal',
	                    value: 'Decimal'
	                },
	                {
	                    key: 'Letters-and-Numbers',
	                    value: 'Alphanumeric'
	                },
	                {
	                    key: 'Letters',
	                    value: 'Letters'
	                },
	                {
	                    key: 'Email',
	                    value: 'Email'
	                }
	            ],
	            selectedValue: '',
	            onChangeFunction: 'onFormatTypeChanged'
	        },
	        'DigitSeparator': {
	            name: 'digit.separator',
	            type: 'checkbox',
	            selectedValue: false,
	            onChangeFunction: 'onDigitSepratorToggle',
	            onClickFunction: 'openLanguageDialogForNumberSeparator',
	            addOnButton: 'fa fa-globe digit-separator-global-icon hidden',
	            extraClass: 'child-1',
	            hidden: true
	        },
	        'DecimalPlaces': {
	            name: 'decimal.places',
	            type: 'dd',
	            extraClass: 'child-1',
	            options: [
	                {
	                    key: '0',
	                    value: '0'
	                },
	                {
	                    key: '1',
	                    value: '1'
	                },
	                {
	                    key: '2',
	                    value: '2'
	                },
	                {
	                    key: '3',
	                    value: '3'
	                },
	                {
	                    key: '4',
	                    value: '4'
	                },
	                {
	                    key: '5',
	                    value: '5'
	                },
	                {
	                    key: '6',
	                    value: '6'
	                },
	                {
	                    key: '7',
	                    value: '7'
	                },
	                {
	                    key: '8',
	                    value: '8'
	                },
	                {
	                    key: '9',
	                    value: '9'
	                }
	            ],
	            selectedValue: '0',
	            hidden: true
	        },
	        'DecimalThousandSeparator': {
	            selectedValue: {
	                Default: {
	                    displayCountry: "Default",
	                    displayLanguage: "Default",
	                    languageId: "Default",
	                    decimal: ".",
	                    thousand: ",",
	                }
	            },
	            extraClass: 'child-1',
	            hidden: true
	        },
	        'Name': {
	            selectedValue: 'Basic',
	            hidden: true
	        }
	    },
	    Display: {
	        'Place Holder': {
	            name: 'place.holder',
	            selectedValue: '',
	            type: 'textbox'
	        },
	        'Read-only': {
	            name: 'read.only',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'HasMic': {
	            name: 'show.mic',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        }
	    },
	    Style: angular.copy(Props.labelStyleObject),
	    ControlStyle: angular.copy(Props.controlStyleObject),
	    Margin: angular.copy(Props.marginObject),
	    Advance: {
	        'Tooltip': {
	            name: 'tooltip',
	            type: 'textbox',
	            selectedValue: ''
	        },
	        'Tabindex': {
	            name: 'tabindex',
	            selectedValue: '',
	            type: 'number'
	        },
	        'Validate': {
	            name: 'validate',
	            type: 'dd',
	            disable: false,
	            options: [
	                {
	                    key: 'Please Select',
	                    value: ''
	                },
	                {
	                    key: 'Integer',
	                    value: 'Integer'
	                },
	                {
	                    key: 'Decimal',
	                    value: 'Decimal'
	                },
	                {
	                    key: 'Letters-and-Numbers',
	                    value: 'Alphanumeric'
	                },
	                {
	                    key: 'Letters',
	                    value: 'Letters'
	                },
	                {
	                    key: 'Email',
	                    value: 'Email'
	                }
	            ],
	            selectedValue: ''
	        },
	        'Searchable': angular.copy(Props.Searchable),
	        'Reportable': angular.copy(Props.Reportable),
	        'customizable-column': angular.copy(Props.Customizable),
	        'Name': {
	            selectedValue: 'Advanced',
	            hidden: true
	        }
	    },
	    Events: angular.copy(Props.elementEventsObject)
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = TextareaProperties;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var RichTextAreaProperties = {
	    Basic: {
	        'ControlType': 'RichTextArea',
	        'Label': {
	            name: 'label',
	            selectedValue: 'RichText-Area',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe'
	        },
	        'Field Name': Props.getFieldName('RichText_Area'),
	        'Data Field Name': Props.getDataFieldName('RichText_Area'),
	        'Value': {
	            name: 'value',
	            selectedValue: '',
	            type: 'textbox',
	            onClickFunction: 'existingDataField',
	            addOnButton: 'fa fa-function',
	            onChangeFunction: 'updateDSField',
	            hidden: true
	        },
	        'DSName': {
	            selectedValue: '',
	            hidden: true
	        },
	        'Required': {
	            name: 'required',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Basic',
	            hidden: true
	        }
	    },
	    Display: {
	        'Read-only': {
	            name: 'read.only',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        },
	        'Char-Limit': {
	            name: 'char.limit',
	            selectedValue: 3000,
	            type: 'number',
	            min: 1,
	            max: 5000
	        },
	        'HasMic': {
	            name: 'show.mic',
	            selectedValue: false,
	            type: 'checkbox'
	        }
	    },
	    Style: angular.copy(Props.labelStyleObject),
	    ControlStyle: {
	        'Name': {
	            hideSection: true
	        }
	    },
	    Margin: angular.copy(Props.marginObject),
	    Advance: {
	        'Tabindex': {
	            name: 'tabindex',
	            selectedValue: '',
	            type: 'number'
	        },
	        'Searchable': angular.copy(Props.Searchable),
	        'Reportable': angular.copy(Props.Reportable),
	        'customizable-column': angular.copy(Props.Customizable),
	        'Name': {
	            selectedValue: 'Advanced',
	            hidden: true
	        }
	    },
	    Events: angular.copy(Props.elementEventsObject)
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = RichTextAreaProperties;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var contolSty = angular.copy(Props.controlStyleObject);
	delete contolSty['style-group'].members.alignment;
	var DropdownProperties = {
	    Basic: {
	        'ControlType': 'Dropdown',
	        'Label': {
	            name: 'label',
	            selectedValue: 'Dropdown',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe',
	            disable: false
	        },
	        'Field Name': Props.getFieldName('Dropdown'),
	        'Data Field Name': Props.getDataFieldName('Dropdown'),
	        'Required': {
	            name: 'required',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Value': {
	            selectedValue: [],
	            hidden: true
	        },
	        'Multi-Select': {
	            name: 'multi.select',
	            selectedValue: false,
	            type: 'checkbox',
	            onChangeFunction: 'resetDefault',
	            disable: false
	        },
	        'Name': {
	            selectedValue: 'Basic',
	            hidden: true
	        },
	        'FilterValue': {
	            isFilterValue: 1,
	            hidden: true
	        }
	    },
	    Display: {
	        'Read-only': {
	            name: 'read.only',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        }
	    },
	    Style: angular.copy(Props.labelStyleObject),
	    ControlStyle: angular.copy(Props.controlStyleObject),
	    Margin: angular.copy(Props.marginObject),
	    Advance: {
	        'Tooltip': {
	            name: 'tooltip',
	            type: 'textbox',
	            selectedValue: ''
	        },
	        'Tabindex': {
	            name: 'tabindex',
	            selectedValue: '',
	            type: 'number'
	        },
	        'Searchable': angular.copy(Props.Searchable),
	        'Reportable': angular.copy(Props.Reportable),
	        'customizable-column': angular.copy(Props.Customizable),
	        'App Status': {
	            name: 'app.status',
	            selectedValue: false,
	            type: 'checkbox',
	            onChangeFunction: 'enableAppStatusSync',
	            disable: false
	        },
	        'Name': {
	            selectedValue: 'Advanced',
	            hidden: true
	        }
	    },
	    Events: {
	        Name: angular.copy(Props.elementEventsObject).Name,
	        load: angular.copy(Props.elementEventsObject).load,
	        change: angular.copy(Props.elementEventsObject).change
	    },
	    "Data Source": {
	        'Source': {
	            name: 'source',
	            type: 'radio',
	            selectedValue: '3',
	            list: [
	                /*{
	                    name:'Adoddle API',
	                    value: '1'
	                },*/
	                /*{
	                    name:'External',
	                    value: '2'
	                },*/
	                {
	                    name: 'Static-Data',
	                    value: '3'
	                },
	                {
	                    name: 'System-Data',
	                    value: '4',
	                    tooltip: 'System attributes are available for fetching the system level data e.g. Project Name etc.'
	                },
	                {
	                    name: 'Link-to-Custom-Attribute',
	                    value: '5'
	                }
	            ]
	        },
	        Url: {
	            name: 'Url',
	            selectedValue: '',
	            hidden: true
	        },
	        fixedFieldUrl: {
	            name: 'Url',
	            singleValue: false,
	            selectedValue: '',
	            hidden: true
	        },
	        customAttr: {
	            name: 'customAttr',
	            selectedValue: '',
	            hierarchyData: [],
	            hierarchyApplied: false,
	            displayVal: '1',
	            hidden: true
	        },
	        'Parameters': {
	            type: 'table',
	            headers: ['key', 'value'],
	            list: [
	                {
	                    key: {
	                        name: '',
	                        type: 'text',
	                        inputWidth: "width:100px;"
	                    },
	                    value: {
	                        name: '',
	                        type: 'text',
	                        inputWidth: "width:100px;"
	                    }
	                }
	            ],
	            hidden: true
	        },
	        'table': {
	            type: 'table',
	            headers: ['Label', 'Value', 'Default'],
	            default: 'datasource',
	            list: [
	                {
	                    id: 1,
	                    Label: {
	                        name: 'Option 1',
	                        type: 'text',
	                        inputWidth: "width:100px;",
	                        disable: false,
	                    },
	                    Value: {
	                        name: 'option1',
	                        type: 'text',
	                        inputWidth: "width:100px;",
	                        disable: false,
	                    },
	                    Default: {
	                        name: false,
	                        type: 'checkbox',
	                        inputWidth: ""
	                    },
	                    showUpdateOptions: true,
	                    relation: {}
	                },
	                {
	                    id: 2,
	                    Label: {
	                        name: 'Option 2',
	                        type: 'text',
	                        inputWidth: "width:100px;",
	                        disable: false,
	                    },
	                    Value: {
	                        name: 'option2',
	                        type: 'text',
	                        inputWidth: "width:100px;",
	                        disable: false,
	                    },
	                    Default: {
	                        name: false,
	                        type: 'checkbox',
	                        inputWidth: ""
	                    },
	                    showUpdateOptions: true,
	                    relation: {}
	                }
	            ],
	            hidden: true
	        },
	        'Name': {
	            selectedValue: 'datasource',
	            hidden: true
	        }
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = DropdownProperties;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var CheckboxProperties = {
	    Basic: {
	        'ControlType': 'Checkbox',
	        'Label': {
	            name: 'label',
	            selectedValue: 'Checkbox',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe'
	        },
	        'Field Name': Props.getFieldName('Checkbox'),
	        'Data Field Name': Props.getDataFieldName('Checkbox'),
	        'Display Format': {
	            name: 'display.format',
	            type: 'dd',
	            options: [
	                {
	                    value: 'checkbox',
	                    key: 'Flat Checkbox Buttons',
	                    icon: 'flat-checkbox'
	                }, {
	                    value: 'fCheckBox',
	                    key: 'Futrico Checkbox Buttons',
	                    icon: 'futrico-checkbox'
	                },
	                {
	                    value: 'buttons',
	                    key: 'Buttons Checkbox',
	                    icon: 'buttons-radios'
	                }, {
	                    value: 'lineCheckbox',
	                    key: 'Line Checkbox Buttons',
	                    icon: 'line-radio'
	                }],
	            selectedValue: 'checkbox',
	            selectedName: 'Flat Checkbox Buttons',
	            selectedIcon: 'flat-checkbox',
	            onChangeFunction: 'setDisplayFormat'
	        },
	        'Number': {
	            name: 'number.columns',
	            selectedValue: 1,
	            type: 'number',
	            onChangeFunction: 'updateRows',
	            min: '1',
	            max: '999'
	        },
	        'Required': {
	            name: 'required',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Basic',
	            hidden: true
	        },
	        'FilterValue': {
	            isFilterValue: 1,
	            hidden: true
	        }
	    },
	    Display: {
	        'Read-only': {
	            name: 'read.only',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        }
	    },
	    Style: angular.copy(Props.labelStyleObject),
	    ControlStyle: angular.copy(Props.controlStyleObject),
	    Margin: angular.copy(Props.marginObject),
	    Advance: {
	        'Tabindex': {
	            name: 'tabindex',
	            selectedValue: '',
	            type: 'number'
	        },
	        'Searchable': angular.copy(Props.Searchable),
	        'Reportable': angular.copy(Props.Reportable),
	        'customizable-column': angular.copy(Props.Customizable),
	        'Name': {
	            selectedValue: 'Advanced',
	            hidden: true
	        }
	    },
	    Events: {
	        Name: angular.copy(Props.elementEventsObject).Name,
	        load: angular.copy(Props.elementEventsObject).load,
	        change: angular.copy(Props.elementEventsObject).change
	    },
	    "Data Source": {
	        'table': {
	            type: 'table',
	            headers: ['Label', 'Value', 'Default'],
	            list: [
	                {
	                    id: 1,
	                    Label: {
	                        name: 'Checkbox 1',
	                        type: "text",
	                        inputWidth: "width:100px;",
	                        disable: false,
	                    },
	                    Value: {
	                        name: 'checkbox1',
	                        type: "text",
	                        inputWidth: "width:100px;",
	                        disable: false,
	                    },
	                    Default: {
	                        name: false,
	                        type: 'checkbox',
	                        inputWidth: ""
	                    },
	                    selectedValue: {
	                        name: false,
	                        type: 'checkbox',
	                        inputWidth: "",
	                        hidden: true
	                    },
	                    showUpdateOptions: true,
	                    relation: {}
	                },
	                {
	                    id: 2,
	                    Label: {
	                        name: 'Checkbox 2',
	                        type: "text",
	                        inputWidth: "width:100px;",
	                        disable: false,
	                    },
	                    Value: {
	                        name: 'checkbox2',
	                        type: "text",
	                        inputWidth: "width:100px;",
	                        disable: false,
	                    },
	                    Default: {
	                        name: false,
	                        type: 'checkbox',
	                        inputWidth: ""
	                    },
	                    selectedValue: {
	                        name: false,
	                        type: 'checkbox',
	                        inputWidth: "",
	                        hidden: true
	                    },
	                    showUpdateOptions: true,
	                    relation: {}
	                }
	            ],
	        },
	        'Name': {
	            selectedValue: 'datasource',
	            hidden: true
	        }
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = CheckboxProperties;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var RadioProperties = {
	    Basic: {
	        'ControlType': 'Radio',
	        'Label': {
	            name: 'label',
	            selectedValue: 'Radio',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe'
	        },
	        'Field Name': Props.getFieldName('Radio'),
	        'Data Field Name': Props.getDataFieldName('Radio'),
	        'Display Format': {
	            name: 'display.format',
	            type: 'dd',
	            options: [
	                {
	                    value: 'radio',
	                    key: 'Flat Radio Buttons',
	                    icon: 'flat-radio'
	                }, {
	                    value: 'fRadioButtons',
	                    key: 'Futrico Radio Buttons',
	                    icon: 'futrico-radio'
	                }, {
	                    value: 'buttons',
	                    key: 'Button Radio',
	                    icon: 'buttons-radios'
	                }, {
	                    value: 'lineRadio',
	                    key: 'Line Radio Buttons',
	                    icon: 'line-radio'
	                }],
	            selectedValue: 'radio',
	            selectedName: 'Flat Radio Buttons',
	            selectedIcon: 'flat-radio',
	            onChangeFunction: 'setDisplayFormat'
	        },
	        'Number': {
	            name: 'number.columns',
	            selectedValue: 1,
	            type: 'number',
	            onChangeFunction: 'updateRows',
	            min: '1',
	            max: '999'
	        },
	        'Value': {
	            hidden: true,
	            selectedValue: ''
	        },
	        'Required': {
	            name: 'required',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Basic',
	            hidden: true
	        }
	    },
	    Display: {
	        'Read-only': {
	            name: 'read.only',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        }
	    },
	    Style: angular.copy(Props.labelStyleObject),
	    ControlStyle: angular.copy(Props.controlStyleObject),
	    Margin: angular.copy(Props.marginObject),
	    Advance: {
	        'Tabindex': {
	            name: 'tabindex',
	            selectedValue: '',
	            type: 'number'
	        },
	        'Searchable': angular.copy(Props.Searchable),
	        'Reportable': angular.copy(Props.Reportable),
	        'customizable-column': angular.copy(Props.Customizable),
	        'Name': {
	            selectedValue: 'Advanced',
	            hidden: true
	        }
	    },
	    Events: {
	        Name: angular.copy(Props.elementEventsObject).Name,
	        load: angular.copy(Props.elementEventsObject).load,
	        change: angular.copy(Props.elementEventsObject).change
	    },
	    "Data Source": {
	        'table': {
	            type: 'table',
	            headers: ['Label', 'Value', 'Default'],
	            default: 'radio',
	            list: [
	                {
	                    id: 1,
	                    Label: {
	                        name: 'Option 1',
	                        type: 'text',
	                        inputWidth: "width:100px;",
	                        disable: false,
	                    },
	                    Value: {
	                        name: '1',
	                        type: 'text',
	                        inputWidth: "width:100px;",
	                        disable: false,
	                    },
	                    Default: {
	                        name: "",
	                        type: "radio",
	                        inputWidth: "",
	                        onChangeFunction: 'resetDefaultForRadio'
	                    },
	                    selectedValue: {
	                        name: false,
	                        type: 'checkbox',
	                        inputWidth: "",
	                        hidden: true
	                    },
	                    showUpdateOptions: true,
	                    relation: {}
	                },
	                {
	                    id: 2,
	                    Label: {
	                        name: 'Option 2',
	                        type: 'text',
	                        inputWidth: "width:100px;",
	                        disable: false,
	                    },
	                    Value: {
	                        name: '2',
	                        type: 'text',
	                        inputWidth: "width:100px;",
	                        disable: false,
	                    },
	                    Default: {
	                        name: "",
	                        type: "radio",
	                        inputWidth: "",
	                        onChangeFunction: 'resetDefaultForRadio'
	                    },
	                    selectedValue: {
	                        name: false,
	                        type: 'checkbox',
	                        inputWidth: "",
	                        hidden: true
	                    },
	                    showUpdateOptions: true,
	                    relation: {}
	                }
	            ],
	        },
	        'Name': {
	            selectedValue: 'datasource',
	            hidden: true
	        }
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = RadioProperties;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var DatepickerProperties = {
	    Basic: {
	        'ControlType': 'Datepicker',
	        'Label': {
	            name: 'label',
	            selectedValue: 'Datepicker',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe'
	        },
	        'Field Name': Props.getFieldName('Datepicker'),
	        'Data Field Name': Props.getDataFieldName('Datepicker'),
	        'Display Format': {
	            name: 'display.format',
	            type: 'dd',
	            options: [
	                {
	                    value: 'default',
	                    key: 'Default'
	                }, {
	                    value: 'DD-MMM-YYYY',
	                    key: 'dd-mmm-yyyy'
	                }, {
	                    value: 'DD-MM-YYYY',
	                    key: 'dd-mm-yyyy'
	                }, {
	                    value: 'DD-MM-YY',
	                    key: 'dd-mm-yy'
	                }, {
	                    value: 'MM-DD-YYYY',
	                    key: 'mm-dd-yyyy'
	                }, {
	                    value: 'MM-DD-YY',
	                    key: 'mm-dd-yy'
	                }, {
	                    value: 'DD/MM/YY',
	                    key: 'dd/mm/yy'
	                }, {
	                    value: 'DD/MM/YYYY',
	                    key: 'dd/mm/yyyy'
	                }],
	            selectedValue: 'default',
	            onChangeFunction: 'updateDefaultDate'
	        },
	        /*'Data Format': {
	            name: 'Data Format',
	            type: 'dd',
	            options: [
	                {
	                    value: 'dd-M-yy',
	                    key: 'dd-mmm-yyyy'
	                }, {
	                    value: 'dd-mm-yy',
	                    key: 'dd-mm-yyyy'
	                }, {
	                    value: 'dd-mm-y',
	                    key: 'dd-mm-yy'
	                }, {
	                    value: 'mm-dd-yy',
	                    key: 'mm-dd-yyyy'
	                }, {
	                    value: 'mm-dd-y',
	                    key: 'mm-dd-yy'
	                }, {
	                    value: 'dd/mm/y',
	                    key: 'dd/mm/yy'
	                }, {
	                    value: 'dd/mm/yy',
	                    key: 'dd/mm/yyyy'
	                }],
	            selectedValue: 'dd-M-yy'
	        },*/
	        'Default': {
	            name: 'default',
	            selectedValue: '',
	            type: 'datepicker',
	            dateObj: '',
	            dateType: '1',
	            days: 0,
	            onChangeFunction: 'updateDateType'
	        },
	        'Working Days': {
	            name: 'working-days',
	            selectedValue: false,
	            type: 'checkbox',
	            hidden: true,
	            icon: 'fa fa-info'
	        },
	        'Time': {
	            name: 'time',
	            selectedValue: false,
	            type: 'checkbox',
	            onChangeFunction: 'updateDefaultDate',
	            disable: false
	        },
	        'Time Format': {
	            name: 'hour_12_format',
	            type: 'dd',
	            options: [
	                {
	                    value: true,
	                    key: '12Hrs'
	                }, {
	                    value: false,
	                    key: '24Hrs'
	                }],
	            selectedValue: 'false',
	            onChangeFunction: 'updateDefaultDate'
	        },
	        /*'Min Date': {
	            name: 'Min Date',
	            type: 'number',
	            selectedValue: ''
	        },
	        'Max Date': {
	            name: 'Max Date',
	            type: 'number',
	            selectedValue: ''
	        },*/
	        'Required': {
	            name: 'required',
	            selectedValue: false,
	            type: 'checkbox',
	            disable: false
	        },
	        'Name': {
	            selectedValue: 'Basic',
	            hidden: true
	        }
	    },
	    Display: {
	        'Read-only': {
	            name: 'read.only',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        }
	    },
	    Style: angular.copy(Props.labelStyleObject),
	    ControlStyle: angular.copy(Props.controlStyleObject),
	    Margin: angular.copy(Props.marginObject),
	    Advance: {
	        'Tooltip': {
	            name: 'tooltip',
	            type: 'textbox',
	            selectedValue: ''
	        },
	        'Tabindex': {
	            name: 'tabindex',
	            selectedValue: '',
	            type: 'number'
	        },
	        'Searchable': angular.copy(Props.Searchable),
	        'Reportable': angular.copy(Props.Reportable),
	        'customizable-column': angular.copy(Props.Customizable),
	        'Closed Date': {
	            name: 'closed.date',
	            selectedValue: false,
	            type: 'checkbox',
	            onChangeFunction: 'enableClosedDateSync'
	        },
	        'Name': {
	            selectedValue: 'Advanced',
	            hidden: true
	        }
	    },
	    Events: {
	        Name: angular.copy(Props.elementEventsObject).Name,
	        load: angular.copy(Props.elementEventsObject).load,
	        change: angular.copy(Props.elementEventsObject).change
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = DatepickerProperties;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var TimepickerProperties = {
	    Basic: {
	        'ControlType': 'Timepicker',
	        'Label': {
	            name: 'label',
	            selectedValue: 'Timepicker',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe'
	        },
	        'Field Name': Props.getFieldName('Timepicker'),
	        'Data Field Name': Props.getDataFieldName('Timepicker'),
	        'Time Format': {
	            name: 'hour_12_format',
	            type: 'dd',
	            options: [
	                {
	                    value: true,
	                    key: '12Hrs'
	                }, {
	                    value: false,
	                    key: '24Hrs'
	                }],
	            selectedValue: 'false',
	            onChangeFunction: 'updateDefaultTime'
	        },
	        'Default': {
	            name: 'default.time',
	            selectedValue: '',
	            type: 'timepicker',
	            dateObj: '',
	            timeType: '1',
	            onChangeFunction: 'checkValidInput'
	        },
	        'Required': {
	            name: 'required',
	            selectedValue: false,
	            type: 'checkbox',
	            disable: false
	        },
	        'Name': {
	            selectedValue: 'Basic',
	            hidden: true
	        }
	    },
	    Display: {
	        'Read-only': {
	            name: 'read.only',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        }
	    },
	    Style: angular.copy(Props.labelStyleObject),
	    ControlStyle: angular.copy(Props.controlStyleObject),
	    Margin: angular.copy(Props.marginObject),
	    Advance: {
	        'Tooltip': {
	            name: 'tooltip',
	            type: 'textbox',
	            selectedValue: ''
	        },
	        'Tabindex': {
	            name: 'tabindex',
	            selectedValue: '',
	            type: 'number'
	        },
	        'Searchable': angular.copy(Props.Searchable),
	        'Reportable': angular.copy(Props.Reportable),
	        'customizable-column': angular.copy(Props.Customizable),
	        'Name': {
	            selectedValue: 'Advanced',
	            hidden: true
	        }
	    },
	    Events: {
	        Name: angular.copy(Props.elementEventsObject).Name,
	        load: angular.copy(Props.elementEventsObject).load,
	        change: angular.copy(Props.elementEventsObject).change
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = TimepickerProperties;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var MapProperties = {
	    Basic: {
	        'ControlType': 'Map',
	        'Label': {
	            name: 'label',
	            selectedValue: 'Map',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe'
	        },
	        'Field Name': Props.getFieldName('Map'),
	        'Data Field Name': Props.getDataFieldName('Map'),
	        'Default': {
	            type: 'textbox',
	            name: 'default',
	            disable: true,
	            selectedValue: ''
	        },
	        'Type': {
	            name: 'type',
	            type: 'dd',
	            options: [
	                {
	                    value: '36',
	                    key: 'Ordnance Survey Grid Reference'
	                }, {
	                    value: '35',
	                    key: 'Geo Cordinates'
	                }],
	            selectedValue: '35',
	            onChangeFunction: 'mapTypeChanged'
	        },
	        'Required': {
	            name: 'required',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Basic',
	            hidden: true
	        }
	    },
	    Display: {
	        'Read-only': {
	            name: 'read.only',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        }
	    },
	    Style: angular.copy(Props.labelStyleObject),
	    ControlStyle: angular.copy(Props.controlStyleObject),
	    Margin: angular.copy(Props.marginObject),
	    Advance: {
	        'Searchable': angular.copy(Props.Searchable),
	        'Reportable': angular.copy(Props.Reportable),
	        'customizable-column': angular.copy(Props.Customizable),
	        'Name': {
	            selectedValue: 'Advanced',
	            hidden: true
	        }
	    },
	    Events: {
	        Name: angular.copy(Props.elementEventsObject).Name,
	        load: angular.copy(Props.elementEventsObject).load,
	        change: angular.copy(Props.elementEventsObject).change
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = MapProperties;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var ImageProperties = {
	    Basic: {
	        'ControlType': 'Image',
	        'Label': {
	            name: 'label',
	            selectedValue: 'Image',
	            type: 'textbox',
	            hidden: true,
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe'
	        },
	        'Field Name': Props.getFieldName('Image'),
	        'Source': {
	            name: 'source',
	            type: 'radio',
	            selectedValue: '0',
	            list: [
	                {
	                    name: 'URL',
	                    value: '0'
	                },
	                {
	                    name: 'upload',
	                    value: '1'
	                }
	            ]
	        },
	        'Url': {
	            name: 'Url',
	            selectedValue: '',
	            type: 'textbox',
	            hidden: true
	        },
	        'Name': {
	            selectedValue: 'Basic',
	            hidden: true
	        }
	    },
	    Display: {
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        }
	    },
	    Style: {
	        'font-style-group': {
	            type: 'style-group',
	            members: {
	                'alignment': {
	                    type: 'radio-btn',
	                    selectedValue: 'left',
	                    options: [{
	                            value: 'left',
	                            title: 'align.left',
	                            icon: 'fa fa-align-left'
	                        }, {
	                            value: 'center',
	                            title: 'align.center',
	                            icon: 'fa fa-align-justify'
	                        }, {
	                            value: 'right',
	                            title: 'align.right',
	                            icon: 'fa fa-align-right'
	                        }]
	                },
	                'background-color': {
	                    type: 'color-picker',
	                    title: 'background.color',
	                    selectedValue: '#ffffff',
	                    icon: 'fa fa-paint-brush'
	                }
	            }
	        },
	        'Name': {
	            selectedValue: 'style',
	            hidden: true
	        }
	    },
	    Margin: angular.copy(Props.marginObject),
	    Size: {
	        'Height': {
	            name: 'height',
	            selectedValue: 'auto',
	            type: 'textbox'
	        },
	        'Width': {
	            name: 'width',
	            selectedValue: 'auto',
	            type: 'textbox'
	        },
	        'Name': {
	            selectedValue: 'Size',
	            hidden: true
	        }
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = ImageProperties;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var SignatureProperties = {
	    Basic: {
	        'ControlType': 'Signature',
	        'Label': {
	            name: 'label',
	            selectedValue: 'Signature',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe'
	        },
	        'Field Name': Props.getFieldName('Signature'),
	        'Data Field Name': Props.getDataFieldName('Signature'),
	        'Value': {
	            selectedValue: '',
	            type: 'textbox',
	            hidden: true
	        },
	        'Required': {
	            name: 'required',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Basic',
	            hidden: true
	        },
	        'Type': {
	            name: 'type',
	            type: 'dd',
	            options: [
	                {
	                    value: 'standard',
	                    key: 'Standard'
	                }, {
	                    value: 'fullScreen',
	                    key: 'Full Screen'
	                }],
	            selectedValue: 'standard',
	            onChangeFunction: 'signatureTypeChanged'
	        },
	    },
	    Display: {
	        'Read-only': {
	            name: 'read.only',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        }
	    },
	    Margin: angular.copy(Props.marginObject),
	    Style: {
	        'font-style-group': {
	            type: 'style-group',
	            members: {
	                'font-family': {
	                    type: 'dd',
	                    title: 'font.family',
	                    selectedValue: 'Helvetica',
	                    options: ['Arial', 'Arial Black', 'Bookman Old Style', 'Calibri', 'Century Gothic', 'Comic Sans MS', 'Courier', 'Courier New', 'Garamond', 'Georgia', 'Helvetica', 'Impact', 'Palatino Linotype', 'Sans Serif', 'Sofia Pro Regular', 'Sofia Pro Semi Bold', 'Times', 'Times New Roman', 'Trebuchet MS', 'Verdana'],
	                    onChangeFunction: 'updateStyle'
	                },
	                'font-size': {
	                    type: 'number',
	                    title: 'font.size',
	                    selectedValue: 14,
	                    min: '1',
	                    max: '99',
	                    default: 14,
	                    onChangeFunction: 'updateStyle'
	                },
	                'background-color': {
	                    type: 'color-picker',
	                    title: 'background.color',
	                    selectedValue: '#ffffff',
	                    icon: 'fa fa-paint-brush',
	                    onChangeFunction: 'updateStyle'
	                }
	            }
	        },
	        'style-group': {
	            type: 'style-group',
	            members: {
	                'bold': {
	                    type: 'btn-toggle',
	                    title: 'bold',
	                    icon: 'fa fa-bold',
	                    selectedValue: false,
	                    onChangeFunction: 'updateStyle'
	                }, 'italic': {
	                    type: 'btn-toggle',
	                    title: 'italic',
	                    icon: 'fa fa-italic',
	                    selectedValue: false,
	                    onChangeFunction: 'updateStyle'
	                }, 'underline': {
	                    type: 'btn-toggle',
	                    title: 'underline',
	                    icon: 'fa fa-underline',
	                    selectedValue: false,
	                    onChangeFunction: 'updateStyle'
	                },
	                'alignment': {
	                    type: 'radio-btn',
	                    selectedValue: 'left',
	                    options: [{
	                            value: 'left',
	                            title: 'align.left',
	                            icon: 'fa fa-align-left',
	                            onChangeFunction: 'updateStyle'
	                        }, {
	                            value: 'center',
	                            title: 'align.center',
	                            icon: 'fa fa-align-justify',
	                            onChangeFunction: 'updateStyle'
	                        }, {
	                            value: 'right',
	                            title: 'align.right',
	                            icon: 'fa fa-align-right',
	                            onChangeFunction: 'updateStyle'
	                        }]
	                },
	                'font-color': {
	                    type: 'color-picker',
	                    title: 'font.color',
	                    selectedValue: '#000000',
	                    icon: 'fa fa-font',
	                    onChangeFunction: 'updateStyle'
	                }
	            }
	        },
	        'Name': {
	            selectedValue: 'style',
	            hidden: true
	        }
	    },
	    Events: {
	        Name: angular.copy(Props.elementEventsObject).Name,
	        load: angular.copy(Props.elementEventsObject).load,
	        change: angular.copy(Props.elementEventsObject).change
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = SignatureProperties;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var AttachmentProperties = {
	    Basic: {
	        'ControlType': 'Attachment',
	        'Label': {
	            name: 'label',
	            selectedValue: 'Attachment',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe'
	        },
	        'Field Name': Props.getFieldName('Attachment'),
	        'Data Field Name': Props.getDataFieldName('Attachment'),
	        'Value': {
	            selectedValue: [],
	            type: 'textbox',
	            hidden: true
	        },
	        'Required': {
	            name: 'required',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Basic',
	            hidden: true
	        }
	    },
	    Display: {
	        'Read-only': {
	            name: 'read.only',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Generate Thumbnail': {
	            name: 'generate-thumbnail',
	            selectedValue: false,
	            type: 'checkbox',
	            onChangeFunction: 'onThumbnailViewChanged',
	        },
	        'Caption': {
	            name: 'caption',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Caption Position': {
	            name: 'caption.position',
	            type: 'dd',
	            options: [
	                {
	                    value: 'top',
	                    key: 'Top'
	                }, {
	                    value: 'bottom',
	                    key: 'Bottom'
	                }],
	            selectedValue: 'top',
	        },
	        'Thumbnail Size': {
	            name: 'thumbnail.size',
	            type: 'dd',
	            options: [
	                {
	                    value: 'standard',
	                    key: 'Standard'
	                }, {
	                    value: 'customize',
	                    key: 'Customize'
	                }],
	            selectedValue: 'standard',
	            onChangeFunction: 'onThumbailSizeChanged'
	        },
	        'Thumbnail Width': {
	            name: 'thumbnail.width',
	            selectedValue: 100,
	            type: 'number',
	            hidden: true,
	            default: 100,
	            min: 100,
	            max: 1000
	        },
	        'Thumbnail Height': {
	            name: 'thumbnail.height',
	            selectedValue: 75,
	            type: 'number',
	            hidden: true,
	            default: 75,
	            min: 75,
	            max: 1000
	        },
	        'Embedded Attachment': {
	            name: 'embeddedAttachment',
	            selectedValue: false,
	            type: 'checkbox',
	            icon: 'fa fa-info'
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        }
	    },
	    Margin: angular.copy(Props.marginObject),
	    Style: {
	        'font-style-group': {
	            type: 'style-group',
	            members: {
	                'font-family': {
	                    type: 'dd',
	                    title: 'font.family',
	                    selectedValue: 'Helvetica',
	                    options: ['Arial', 'Arial Black', 'Bookman Old Style', 'Calibri', 'Century Gothic', 'Comic Sans MS', 'Courier', 'Courier New', 'Garamond', 'Georgia', 'Helvetica', 'Impact', 'Palatino Linotype', 'Sans Serif', 'Sofia Pro Regular', 'Sofia Pro Semi Bold', 'Times', 'Times New Roman', 'Trebuchet MS', 'Verdana'],
	                    onChangeFunction: 'updateStyle'
	                },
	                'font-size': {
	                    type: 'number',
	                    title: 'font.size',
	                    selectedValue: 14,
	                    min: '1',
	                    max: '99',
	                    default: 14,
	                    onChangeFunction: 'updateStyle'
	                },
	                'background-color': {
	                    type: 'color-picker',
	                    title: 'background.color',
	                    selectedValue: '#ffffff',
	                    icon: 'fa fa-paint-brush',
	                    onChangeFunction: 'updateStyle'
	                }
	            }
	        },
	        'style-group': {
	            type: 'style-group',
	            members: {
	                'bold': {
	                    type: 'btn-toggle',
	                    title: 'bold',
	                    icon: 'fa fa-bold',
	                    selectedValue: false,
	                    onChangeFunction: 'updateStyle'
	                }, 'italic': {
	                    type: 'btn-toggle',
	                    title: 'italic',
	                    icon: 'fa fa-italic',
	                    selectedValue: false,
	                    onChangeFunction: 'updateStyle'
	                }, 'underline': {
	                    type: 'btn-toggle',
	                    title: 'underline',
	                    icon: 'fa fa-underline',
	                    selectedValue: false,
	                    onChangeFunction: 'updateStyle'
	                },
	                'alignment': {
	                    type: 'radio-btn',
	                    selectedValue: 'left',
	                    options: [{
	                            value: 'left',
	                            title: 'align.left',
	                            icon: 'fa fa-align-left',
	                            onChangeFunction: 'updateStyle'
	                        }, {
	                            value: 'center',
	                            title: 'align.center',
	                            icon: 'fa fa-align-justify',
	                            onChangeFunction: 'updateStyle'
	                        }, {
	                            value: 'right',
	                            title: 'align.right',
	                            icon: 'fa fa-align-right',
	                            onChangeFunction: 'updateStyle'
	                        }]
	                },
	                'font-color': {
	                    type: 'color-picker',
	                    title: 'font.color',
	                    selectedValue: '#000000',
	                    icon: 'fa fa-font',
	                    onChangeFunction: 'updateStyle'
	                }
	            }
	        },
	        'Name': {
	            selectedValue: 'style',
	            hidden: true
	        }
	    },
	    Events: {
	        Name: angular.copy(Props.elementEventsObject).Name,
	        load: angular.copy(Props.elementEventsObject).load,
	        change: angular.copy(Props.elementEventsObject).change
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = AttachmentProperties;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var LineProperties = {
	    Style: {
	        'style-group': {
	            type: 'style-group',
	            members: {
	                'font-color': {
	                    type: 'color-picker',
	                    title: 'line.color',
	                    selectedValue: '#ccc',
	                    icon: 'fa fa-font'
	                }
	            }
	        },
	        'Name': {
	            selectedValue: 'style',
	            hidden: true
	        }
	    },
	    Margin: angular.copy(Props.marginObject)
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = LineProperties;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var LayoutProperties = {
	    Basic: {
	        'ControlType': 'Layout',
	        'Label': {
	            name: 'label',
	            selectedValue: 'Layout',
	            type: 'textbox',
	            hidden: true
	        },
	        'Field Name': Props.getFieldName('Layout'),
	        'Name': {
	            selectedValue: 'Basic',
	            hideSection: false,
	            hidden: true
	        }
	    },
	    Display: {
	        'Columns': {
	            name: 'columns',
	            type: 'dd',
	            options: [
	                {
	                    key: '1',
	                    value: 'col-md-12/1'
	                }, {
	                    key: '2',
	                    value: 'col-md-6/2'
	                }, {
	                    key: '3',
	                    value: 'col-md-4/3'
	                }, {
	                    key: '4',
	                    value: 'col-md-3/4'
	                }, {
	                    key: '5',
	                    value: 'col-md-5/5'
	                }, {
	                    key: '6',
	                    value: 'col-md-2/6'
	                }, {
	                    key: '7',
	                    value: 'col-md-7/7'
	                }, {
	                    key: '8',
	                    value: 'col-md-8/8'
	                }, {
	                    key: '9',
	                    value: 'col-md-9/9'
	                }, {
	                    key: '10',
	                    value: 'col-md-10/10'
	                }, {
	                    key: '11',
	                    value: 'col-md-11/11'
	                }, {
	                    key: '12',
	                    value: 'col-md-1/12'
	                }
	            ],
	            selectedValue: 'col-md-6/2',
	            onChangeFunction: 'updateColumns'
	        },
	        'Border': {
	            name: 'border',
	            type: 'dd',
	            options: [
	                {
	                    key: '0',
	                    value: '0px solid #ccc'
	                }, {
	                    key: '1',
	                    value: '1px solid #ccc'
	                }, {
	                    key: '2',
	                    value: '2px solid #ccc'
	                }, {
	                    key: '3',
	                    value: '3px solid #ccc'
	                }, {
	                    key: '4',
	                    value: '4px solid #ccc'
	                }, {
	                    key: '5',
	                    value: '5px solid #ccc'
	                }, {
	                    key: '6',
	                    value: '6px solid #ccc'
	                }, {
	                    key: '7',
	                    value: '7px solid #ccc'
	                }, {
	                    key: '8',
	                    value: '8px solid #ccc'
	                }, {
	                    key: '9',
	                    value: '9px solid #ccc'
	                }, {
	                    key: '10',
	                    value: '10px solid #ccc'
	                }
	            ],
	            selectedValue: '1px solid #ccc'
	        },
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'RemoveOptions': {
	            type: 'button-group',
	            members: {
	                'Remove Width': {
	                    type: 'button',
	                    title: 'Remove Width',
	                    selectedValue: '1',
	                    icon: 'fa fa-eraser',
	                    onClickFunction: 'removeWidth'
	                }
	            }
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        }
	    },
	    Style: {
	        'font-style-group': {
	            type: 'style-group',
	            members: {
	                'background-color': {
	                    type: 'color-picker',
	                    title: 'background.color',
	                    selectedValue: '#ffffff',
	                    icon: 'fa fa-paint-brush',
	                    onChangeFunction: 'updateStyle'
	                }
	            }
	        },
	        'style-group': {
	            type: 'style-group',
	            members: {}
	        },
	        'Name': {
	            selectedValue: 'style',
	            hidden: true
	        }
	    },
	    Margin: angular.copy(Props.marginObject),
	    Events: {
	        Name: angular.copy(Props.elementEventsObject).Name,
	        load: angular.copy(Props.elementEventsObject).load
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = LayoutProperties;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var TableProperties = {
	    Basic: {
	        'ControlType': 'Table',
	        'Label': {
	            name: 'label',
	            selectedValue: 'Table',
	            type: 'textbox',
	            hidden: true
	        },
	        'Field Name': Props.getFieldName('Table'),
	        'Name': {
	            selectedValue: 'Basic',
	            hideSection: false,
	            hidden: true
	        }
	    },
	    Display: {
	        'Rows': {
	            name: 'Rows',
	            selectedValue: 3,
	            type: 'number',
	            onChangeFunction: 'updateTable'
	        },
	        'Columns': {
	            name: 'Columns',
	            selectedValue: 3,
	            type: 'number',
	            onChangeFunction: 'updateTable',
	            min: 1,
	            max: 20
	        },
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'RemoveOptions': {
	            type: 'button-group',
	            members: {
	                'Remove Width': {
	                    type: 'button',
	                    title: 'Remove Width',
	                    selectedValue: '1',
	                    icon: 'fa fa-eraser',
	                    onClickFunction: 'removeWidth'
	                },
	                'Remove': {
	                    type: 'button',
	                    title: 'Remove',
	                    selectedValue: '1',
	                    icon: 'fa fa-remove',
	                    onClickFunction: 'removeRow'
	                }
	            }
	        },
	        'Fit-to-Screen': {
	            name: 'fit.to.screen',
	            extraClass: 'fit-to-screen',
	            selectedValue: false,
	            type: 'checkbox',
	            icon: 'fa fa-info'
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        }
	    },
	    Borders: {
	        'border-style-group': {
	            type: 'style-group',
	            members: {
	                'border-width': {
	                    type: 'number',
	                    title: 'font.size',
	                    selectedValue: 1,
	                    min: '1',
	                    max: '99',
	                    default: 1,
	                    onChangeFunction: 'updateStyle'
	                },
	                'border-color': {
	                    type: 'color-picker',
	                    title: 'border.color',
	                    selectedValue: '#cccccc',
	                    icon: 'fa fa-paint-brush',
	                    onChangeFunction: 'updateStyle'
	                }
	            }
	        },
	        'Name': {
	            selectedValue: 'Borders',
	            hidden: true
	        }
	    },
	    Style: {
	        'font-style-group': {
	            type: 'style-group',
	            members: {
	                'background-color': {
	                    type: 'color-picker',
	                    title: 'background.color',
	                    selectedValue: '#ffffff',
	                    icon: 'fa fa-paint-brush',
	                    onChangeFunction: 'updateStyle'
	                }
	            }
	        },
	        'style-group': {
	            type: 'style-group',
	            members: {}
	        },
	        'Name': {
	            selectedValue: 'style',
	            hidden: true
	        }
	    },
	    Margin: angular.copy(Props.marginObject),
	    'Merge': {
	        'merge': {
	            type: 'button-group',
	            members: {
	                'merge': {
	                    title: 'mergeCellMsg',
	                    selectedValue: '1',
	                    icon: 'fa fa-compress',
	                    onClickFunction: 'mergeCell'
	                },
	                'split': {
	                    type: 'button',
	                    title: 'split',
	                    selectedValue: '1',
	                    icon: 'fa fa-expand',
	                    onClickFunction: 'splitCell'
	                }
	            }
	        },
	        'Name': {
	            selectedValue: 'Merge',
	            hidden: true
	        }
	    },
	    Events: {
	        Name: angular.copy(Props.elementEventsObject).Name,
	        load: angular.copy(Props.elementEventsObject).load
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = TableProperties;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var RepeatingTableProperties = {
	    Basic: {
	        'ControlType': 'RepeatingTable',
	        'Label': {
	            name: 'label',
	            selectedValue: 'Repeating Table',
	            type: 'textbox',
	            hidden: true
	        },
	        'Field Name': Props.getFieldName('Repeating_Table'),
	        'Data Field Name': Props.getDataFieldName('Repeating_Table'),
	        'Columns': {
	            name: 'columns',
	            selectedValue: 3,
	            type: 'number',
	            onChangeFunction: 'updateRepeatingTable',
	            min: 1,
	            max: 20
	        },
	        'Include_Header': {
	            name: 'include.header',
	            selectedValue: false,
	            type: 'checkbox',
	            onChangeFunction: 'updateHeaderAndFooter'
	        },
	        'Include_Footer': {
	            name: 'include.footer',
	            selectedValue: false,
	            type: 'checkbox',
	            onChangeFunction: 'updateHeaderAndFooter'
	        },
	        'Insert_Button_Text': {
	            name: 'insert.button.text',
	            selectedValue: 'Insert Row',
	            type: 'textbox'
	        },
	        'DSName': {
	            selectedValue: '',
	            hidden: true
	        },
	        'Name': {
	            selectedValue: 'Basic',
	            hidden: true
	        }
	    },
	    Display: {
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'RemoveOptions': {
	            type: 'button-group',
	            members: {
	                'Remove Width': {
	                    type: 'button',
	                    title: 'Remove Width',
	                    selectedValue: '1',
	                    icon: 'fa fa-eraser',
	                    onClickFunction: 'removeWidth'
	                }
	            }
	        },
	        'Fit-to-Screen': {
	            name: 'fit.to.screen',
	            extraClass: 'fit-to-screen',
	            selectedValue: false,
	            type: 'checkbox',
	            icon: 'fa fa-info'
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        }
	    },
	    Borders: {
	        'border-style-group': {
	            type: 'style-group',
	            members: {
	                'border-width': {
	                    type: 'number',
	                    title: 'font.size',
	                    selectedValue: 1,
	                    min: '1',
	                    max: '99',
	                    default: 1,
	                    onChangeFunction: 'updateStyle'
	                },
	                'border-color': {
	                    type: 'color-picker',
	                    title: 'border.color',
	                    selectedValue: '#cccccc',
	                    icon: 'fa fa-paint-brush',
	                    onChangeFunction: 'updateStyle'
	                }
	            }
	        },
	        'Name': {
	            selectedValue: 'Borders',
	            hidden: true
	        }
	    },
	    Style: {
	        'font-style-group': {
	            type: 'style-group',
	            members: {
	                'background-color': {
	                    type: 'color-picker',
	                    title: 'background.color',
	                    selectedValue: '#ffffff',
	                    icon: 'fa fa-paint-brush',
	                    onChangeFunction: 'updateStyle'
	                }
	            }
	        },
	        'style-group': {
	            type: 'style-group',
	            members: {}
	        },
	        'Name': {
	            selectedValue: 'style',
	            hidden: true
	        }
	    },
	    InsertButtonStyle: angular.copy(Props.InsertButtonStyleObj),
	    EvenOddRowStyle: {
	        'style-group': {
	            type: 'style-group',
	            members: {
	                'background-color-even': {
	                    type: 'color-picker',
	                    title: 'backgroundcoloreven',
	                    selectedValue: '#ffffff',
	                    icon: 'fa fa-paint-brush',
	                    onChangeFunction: 'updateStyle',
	                    name: 'backgroundcoloreven'
	                },
	                'background-color-odd': {
	                    type: 'color-picker',
	                    title: 'backgroundcolorodd',
	                    selectedValue: '#ffffff',
	                    icon: 'fa fa-paint-brush',
	                    onChangeFunction: 'updateStyle',
	                    name: 'backgroundcolorodd'
	                },
	            }
	        },
	        'Name': {
	            selectedValue: 'row.style',
	            hidden: true
	        }
	    },
	    Margin: angular.copy(Props.marginObject),
	    Events: {
	        Name: angular.copy(Props.elementEventsObject).Name,
	        load: angular.copy(Props.elementEventsObject).load,
	        OnInsertRow: {
	            name: 'OnInsertRow',
	            type: 'event',
	            selectedValue: '',
	            xmlValue: '',
	            systemFields: [],
	            onClickFunction: 'openCodeEditorDialog'
	        },
	        OnDeleteRow: {
	            name: 'OnDeleteRow',
	            type: 'event',
	            selectedValue: '',
	            xmlValue: '',
	            systemFields: [],
	            onClickFunction: 'openCodeEditorDialog'
	        }
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = RepeatingTableProperties;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var ToggleButtonProperties = {
	    Basic: {
	        'ControlType': 'ToggleButton',
	        'Label': {
	            name: 'label',
	            selectedValue: 'Toggle Button',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe',
	        },
	        'Field Name': Props.getFieldName('ToggleButton'),
	        'Data Field Name': Props.getDataFieldName('ToggleButton'),
	        'LabelOff': {
	            name: 'labeloff',
	            selectedValue: 'OFF',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe',
	        },
	        'LabelOn': {
	            name: 'labelon',
	            selectedValue: 'ON',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe',
	        },
	        'ValueOff': {
	            name: 'value.off',
	            selectedValue: 'Value Off',
	            type: 'textbox',
	            onChangeFunction: 'updateValueText'
	        },
	        'ValueOn': {
	            name: 'value.on',
	            selectedValue: 'Value On',
	            type: 'textbox',
	            onChangeFunction: 'updateValueText'
	        },
	        'Value': {
	            name: 'value',
	            selectedValue: false,
	            type: 'checkbox',
	            hidden: true
	        },
	        'DSName': {
	            selectedValue: '',
	            hidden: true
	        },
	        'Name': {
	            selectedValue: 'Basic',
	            hidden: true
	        },
	    },
	    Display: {
	        'Read-only': {
	            name: 'read.only',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        }
	    },
	    Style: angular.copy(Props.labelStyleObject),
	    ControlStyle: angular.copy(Props.controlStyleObject),
	    SwitchToggleStyle: {
	        'style-group': {
	            type: 'style-group',
	            members: {
	                'background-color-on': {
	                    type: 'color-picker',
	                    title: 'backgroundcoloron',
	                    selectedValue: '#007bff',
	                    icon: 'fa fa-paint-brush',
	                    onChangeFunction: 'updateStyle',
	                    name: 'backgroundcoloron'
	                },
	                'background-color-off': {
	                    type: 'color-picker',
	                    title: 'backgroundcoloroff',
	                    selectedValue: '#cccccc',
	                    icon: 'fa fa-paint-brush',
	                    onChangeFunction: 'updateStyle',
	                    name: 'backgroundcoloroff'
	                },
	            }
	        },
	        'Name': {
	            selectedValue: 'switch.style',
	            hidden: true
	        }
	    },
	    Margin: angular.copy(Props.marginObject),
	    Advance: {
	        'Tooltip': {
	            name: 'tooltip',
	            type: 'textbox',
	            selectedValue: ''
	        },
	        'Tabindex': {
	            name: 'tabindex',
	            selectedValue: '',
	            type: 'number'
	        },
	        'Searchable': angular.copy(Props.Searchable),
	        'Reportable': angular.copy(Props.Reportable),
	        'customizable-column': angular.copy(Props.Customizable),
	        'Name': {
	            selectedValue: 'Advanced',
	            hidden: true
	        }
	    },
	    Events: {
	        Name: angular.copy(Props.elementEventsObject).Name,
	        load: angular.copy(Props.elementEventsObject).load,
	        click: {
	            name: 'onClick',
	            type: 'event',
	            selectedValue: '',
	            xmlValue: '',
	            onClickFunction: 'openCodeEditorDialog'
	        },
	    },
	    Size: {
	        'Height': {
	            name: 'height',
	            selectedValue: 25,
	            type: 'number',
	            min: 25,
	            max: 50
	        },
	        'Width': {
	            name: 'width',
	            selectedValue: 50,
	            type: 'number',
	            min: 50,
	            max: 100
	        },
	        'Name': {
	            selectedValue: 'Size',
	            hidden: true
	        }
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = ToggleButtonProperties;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var HyperlinkProperties = {
	    Basic: {
	        'ControlType': 'Hyperlink',
	        'Label': {
	            name: 'label',
	            selectedValue: 'Hyperlink',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe',
	            isSelected: false
	        },
	        'Field Name': Props.getFieldName('Hyperlink'),
	        'Data Field Name': Props.getDataFieldName('Hyperlink'),
	        'Value': {
	            name: 'linkAddress',
	            selectedValue: '',
	            type: 'textbox',
	            onClickFunction: 'existingDataField',
	            addOnButton: 'fa fa-function',
	            onChangeFunction: 'checkRequired',
	            readonly: false,
	            placeholder: 'https://www.abc.com'
	        },
	        'DisplayLabel': {
	            name: 'displayLabel',
	            selectedValue: 'Link to site',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe',
	            onChangeFunction: 'checkRequired',
	            isSelected: false
	        },
	        'DSName': {
	            selectedValue: '',
	            hidden: true
	        },
	        'Name': {
	            selectedValue: 'Basic',
	            hidden: true
	        },
	    },
	    Display: {
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        }
	    },
	    Style: angular.copy(Props.labelStyleObject),
	    ControlStyle: {
	        'font-style-group': {
	            type: 'style-group',
	            members: {
	                'font-family': {
	                    type: 'dd',
	                    title: 'font.family',
	                    selectedValue: 'Helvetica',
	                    options: ['Arial', 'Arial Black', 'Bookman Old Style', 'Calibri', 'Century Gothic', 'Comic Sans MS', 'Courier', 'Courier New', 'Garamond', 'Georgia', 'Helvetica', 'Impact', 'Palatino Linotype', 'Sans Serif', 'Sofia Pro Regular', 'Sofia Pro Semi Bold', 'Times', 'Times New Roman', 'Trebuchet MS', 'Verdana']
	                },
	                'font-size': {
	                    type: 'number',
	                    title: 'font.size',
	                    selectedValue: 14,
	                    min: '1',
	                    max: '99',
	                    default: 16
	                },
	                'background-color': {
	                    type: 'color-picker',
	                    title: 'background.color',
	                    selectedValue: '#ffffff',
	                    icon: 'fa fa-paint-brush'
	                }
	            }
	        },
	        'style-group': {
	            type: 'style-group',
	            members: {
	                'bold': {
	                    type: 'btn-toggle',
	                    title: 'bold',
	                    icon: 'fa fa-bold',
	                    selectedValue: false
	                }, 'italic': {
	                    type: 'btn-toggle',
	                    title: 'italic',
	                    icon: 'fa fa-italic',
	                    selectedValue: false
	                }, 'underline': {
	                    type: 'btn-toggle',
	                    title: 'underline',
	                    icon: 'fa fa-underline',
	                    selectedValue: false
	                },
	                'alignment': {
	                    type: 'radio-btn',
	                    selectedValue: 'left',
	                    options: [{
	                            value: 'left',
	                            title: 'align.left',
	                            icon: 'fa fa-align-left',
	                            name: 'controlAlignment'
	                        }, {
	                            value: 'center',
	                            title: 'align.center',
	                            icon: 'fa fa-align-justify',
	                            name: 'controlAlignment'
	                        }, {
	                            value: 'right',
	                            title: 'align.right',
	                            icon: 'fa fa-align-right',
	                            name: 'controlAlignment'
	                        }]
	                },
	                'font-color': {
	                    type: 'color-picker',
	                    title: 'font.color',
	                    selectedValue: '#1d6bb3',
	                    icon: 'fa fa-font'
	                }
	            }
	        },
	        'Name': {
	            selectedValue: 'style',
	            hidden: true
	        }
	    },
	    Margin: angular.copy(Props.marginObject),
	    Advance: {
	        'Searchable': angular.copy(Props.Searchable),
	        'Reportable': angular.copy(Props.Reportable),
	        'customizable-column': angular.copy(Props.Customizable),
	        'Name': {
	            selectedValue: 'Advanced',
	            hidden: true
	        }
	    },
	    Events: {
	        Name: {
	            selectedValue: 'Events',
	            hideSection: false,
	            hidden: true
	        },
	        load: angular.copy(Props.elementEventsObject).load,
	        click: {
	            name: 'onClick',
	            type: 'event',
	            selectedValue: '',
	            xmlValue: '',
	            onClickFunction: 'openCodeEditorDialog'
	        },
	    },
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = HyperlinkProperties;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var contolSty = angular.copy(Props.controlStyleObject);
	delete contolSty['style-group'].members.alignment;
	var MultiDropdownProperties = {
	    Basic: {
	        'ControlType': 'MultiDropdown',
	        'Label': {
	            name: 'label',
	            selectedValue: 'Multiselect Dropdown',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe',
	            disable: false
	        },
	        'Field Name': Props.getFieldName('MultiDropdown'),
	        'Data Field Name': Props.getDataFieldName('MultiDropdown'),
	        'Required': {
	            name: 'required',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Value': {
	            selectedValue: [],
	            hidden: true
	        },
	        'Name': {
	            selectedValue: 'Basic',
	            hidden: true
	        },
	        'FilterValue': {
	            isFilterValue: 1,
	            hidden: true
	        }
	    },
	    Display: {
	        'Read-only': {
	            name: 'read.only',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        }
	    },
	    Style: angular.copy(Props.labelStyleObject),
	    ControlStyle: angular.copy(Props.controlStyleObject),
	    Margin: angular.copy(Props.marginObject),
	    Advance: {
	        'Tooltip': {
	            name: 'tooltip',
	            type: 'textbox',
	            selectedValue: ''
	        },
	        'Tabindex': {
	            name: 'tabindex',
	            selectedValue: '',
	            type: 'number'
	        },
	        'Searchable': angular.copy(Props.Searchable),
	        'Reportable': angular.copy(Props.Reportable),
	        'customizable-column': angular.copy(Props.Customizable),
	        'Name': {
	            selectedValue: 'Advanced',
	            hidden: true
	        }
	    },
	    Events: {
	        Name: angular.copy(Props.elementEventsObject).Name,
	        load: angular.copy(Props.elementEventsObject).load,
	        change: angular.copy(Props.elementEventsObject).change
	    },
	    "Data Source": {
	        'Source': {
	            name: 'source',
	            type: 'radio',
	            selectedValue: '3',
	            list: [
	                /*{
	                    name:'Adoddle API',
	                    value: '1'
	                },*/
	                /*{
	                    name:'External',
	                    value: '2'
	                },*/
	                {
	                    name: 'Static-Data',
	                    value: '3'
	                },
	                {
	                    name: 'System-Data',
	                    value: '4',
	                    tooltip: 'System attributes are available for fetching the system level data e.g. Project Name etc.'
	                },
	                {
	                    name: 'Link-to-Custom-Attribute',
	                    value: '5'
	                }
	            ]
	        },
	        Url: {
	            name: 'Url',
	            selectedValue: '',
	            hidden: true
	        },
	        fixedFieldUrl: {
	            name: 'Url',
	            singleValue: false,
	            selectedValue: '',
	            hidden: true
	        },
	        customAttr: {
	            name: 'customAttr',
	            selectedValue: '',
	            hierarchyData: [],
	            hierarchyApplied: false,
	            displayVal: '1',
	            hidden: true
	        },
	        'Parameters': {
	            type: 'table',
	            headers: ['key', 'value'],
	            list: [
	                {
	                    key: {
	                        name: '',
	                        type: 'text',
	                        inputWidth: "width:100px;"
	                    },
	                    value: {
	                        name: '',
	                        type: 'text',
	                        inputWidth: "width:100px;"
	                    }
	                }
	            ],
	            hidden: true
	        },
	        'table': {
	            type: 'table',
	            headers: ['Label', 'Value', 'Default'],
	            default: 'datasource',
	            list: [
	                {
	                    id: 1,
	                    Label: {
	                        name: 'Option 1',
	                        type: 'text',
	                        inputWidth: "width:100px;",
	                        disable: false,
	                    },
	                    Value: {
	                        name: 'option1',
	                        type: 'text',
	                        inputWidth: "width:100px;",
	                        disable: false,
	                    },
	                    Default: {
	                        name: false,
	                        type: 'checkbox',
	                        inputWidth: ""
	                    },
	                    showUpdateOptions: true,
	                    relation: {}
	                },
	                {
	                    id: 2,
	                    Label: {
	                        name: 'Option 2',
	                        type: 'text',
	                        inputWidth: "width:100px;",
	                        disable: false,
	                    },
	                    Value: {
	                        name: 'option2',
	                        type: 'text',
	                        inputWidth: "width:100px;",
	                        disable: false,
	                    },
	                    Default: {
	                        name: false,
	                        type: 'checkbox',
	                        inputWidth: ""
	                    },
	                    showUpdateOptions: true,
	                    relation: {}
	                }
	            ],
	            hidden: true
	        },
	        'Name': {
	            selectedValue: 'datasource',
	            hidden: true
	        }
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = MultiDropdownProperties;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var RatingProperties = {
	    Basic: {
	        'ControlType': 'Rating',
	        'Label': {
	            name: 'label',
	            selectedValue: 'Rating',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe',
	        },
	        'Field Name': Props.getFieldName('Rating'),
	        'Data Field Name': Props.getDataFieldName('Rating'),
	        'Value': {
	            name: 'value',
	            selectedValue: 1,
	            type: 'number',
	            default: 1,
	            min: 0,
	            max: 10,
	            addOnButton: 'fa fa-info'
	        },
	        'Min': {
	            name: 'min',
	            selectedValue: 0,
	            type: 'number',
	            min: 0,
	            default: 0,
	            max: 9,
	            onChangeFunction: 'validateMin',
	            addOnButton: 'fa fa-info'
	        },
	        'Max': {
	            name: 'max',
	            selectedValue: 10,
	            type: 'number',
	            min: 1,
	            max: 10,
	            default: 10,
	            addOnButton: 'fa fa-info'
	        },
	        'Step': {
	            name: 'step',
	            selectedValue: 1,
	            type: 'number',
	            hidden: true
	        },
	        'DSName': {
	            selectedValue: '',
	            hidden: true
	        },
	        /*'Default': {
	            name: 'Default',
	            selectedValue: '',
	            type: 'textbox'
	        },*/
	        'Required': {
	            name: 'required',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Basic',
	            hidden: true
	        },
	        'Type': {
	            number: false,
	            hidden: true
	        },
	        'parentNode': {
	            id: 0,
	            hidden: true
	        },
	    },
	    Display: {
	        'Read-only': {
	            name: 'read.only',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        }
	    },
	    Style: angular.copy(Props.labelStyleObject),
	    ControlStyle: angular.copy(Props.controlStyleObject),
	    Margin: angular.copy(Props.marginObject),
	    Advance: {
	        'Tabindex': {
	            name: 'tabindex',
	            selectedValue: '',
	            type: 'number'
	        },
	        'Searchable': angular.copy(Props.Searchable),
	        'Reportable': angular.copy(Props.Reportable),
	        'customizable-column': angular.copy(Props.Customizable),
	        'Name': {
	            selectedValue: 'Advanced',
	            hidden: true
	        }
	    },
	    Events: {
	        Name: {
	            selectedValue: 'Events',
	            hideSection: false,
	            hidden: true
	        },
	        load: angular.copy(Props.elementEventsObject).load,
	        change: angular.copy(Props.elementEventsObject).change
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = RatingProperties;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var SectionProperties = {
	    Basic: {
	        'ControlType': 'Section',
	        'Label': {
	            name: 'label',
	            selectedValue: 'Section',
	            type: 'textbox',
	            hidden: true
	        },
	        'Field Name': Props.getFieldName('Section'),
	        'Data Field Name': Props.getDataFieldName('Section'),
	        'DSName': {
	            selectedValue: '',
	            hidden: true
	        },
	        'Name': {
	            selectedValue: 'Basic',
	            hidden: true
	        }
	    },
	    Display: {
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        }
	    },
	    Style: {
	        'font-style-group': {
	            type: 'style-group',
	            members: {
	                'background-color': {
	                    type: 'color-picker',
	                    title: 'background.color',
	                    selectedValue: '#ffffff',
	                    icon: 'fa fa-paint-brush',
	                    onChangeFunction: 'updateStyle'
	                }
	            }
	        },
	        'style-group': {
	            type: 'style-group',
	            members: {}
	        },
	        'Name': {
	            selectedValue: 'style',
	            hidden: true
	        }
	    },
	    Margin: angular.copy(Props.marginObject),
	    Events: {
	        Name: angular.copy(Props.elementEventsObject).Name,
	        load: angular.copy(Props.elementEventsObject).load
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = SectionProperties;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var InlineAssocFiles = {
	    Basic: {
	        'ControlType': 'InlineAssocFiles',
	        'Label': {
	            name: 'label',
	            selectedValue: 'Associate Files',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe',
	        },
	        'Text': {
	            name: 'text',
	            selectedValue: 'Associate Files',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe'
	        },
	        'Field Name': Props.getFieldName('InlineAssocFiles'),
	        'Data Field Name': Props.getDataFieldName('InlineAssocFiles'),
	        'Required': {
	            name: 'required',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Basic',
	            hidden: true
	        },
	    },
	    Association: {
	        'AddSetup': {
	            type: "button",
	            title: "Add Setup",
	            selectedValue: "1",
	            icon: "fa fa-plus",
	            onClickFunction: "addcolumnName",
	            clicked: false
	        },
	        'selectedColumn': {
	            'Parameters': {
	                type: "table",
	                list: [
	                    {
	                        value: {
	                            selectedValue: "",
	                            type: "dropdown",
	                            inputWidth: "width:100px;"
	                        },
	                        sorting: {
	                            selectedValue: "",
	                            type: "radio",
	                        }
	                    }
	                ],
	                hidden: true
	            },
	            'table': {
	                type: "table",
	                default: "datasource",
	                list: [
	                    {
	                        id: 1,
	                        Value: {
	                            name: {
	                                "id": "2",
	                                "fieldName": "document_ref",
	                                "colDisplayName": "Doc Ref",
	                                "dataType": "text",
	                                "function": "openDocument",
	                                "widthOfColumn": 125,
	                                "isSortSupported": true,
	                                "isCustomAttributeColumn": false,
	                            },
	                            type: "dropdown",
	                            inputWidth: "width:100px;",
	                            disable: false,
	                        },
	                        Sorting: {
	                            name: 'sorting',
	                            type: 'radio',
	                            selectedValue: '',
	                            disable: false,
	                            list: [
	                                {
	                                    name: 'Descending',
	                                    value: '1'
	                                },
	                                {
	                                    name: 'Ascending',
	                                    value: '0'
	                                },
	                            ]
	                        },
	                        showUpdateOptions: true
	                    }
	                ],
	                hidden: true
	            },
	            hidden: true
	        },
	        'Name': {
	            selectedValue: 'File Attributes Setup',
	            hidden: true
	        },
	    },
	    Display: {
	        'Read-only': {
	            name: 'read.only',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        }
	    },
	    Borders: {
	        'border-style-group': {
	            type: 'style-group',
	            members: {
	                'border-width': {
	                    type: 'number',
	                    title: 'border.width',
	                    selectedValue: 1,
	                    min: '1',
	                    max: '99',
	                    default: 1,
	                    onChangeFunction: 'updateStyle'
	                },
	                'border-color': {
	                    type: 'color-picker',
	                    title: 'border.color',
	                    selectedValue: '#cccccc',
	                    icon: 'fa fa-paint-brush',
	                    onChangeFunction: 'updateStyle'
	                }
	            }
	        },
	        'Name': {
	            selectedValue: 'Borders',
	            hidden: true
	        }
	    },
	    Style: angular.copy(Props.labelStyleObject),
	    ControlStyle: {
	        'font-style-group': {
	            type: 'style-group',
	            members: {
	                'font-family': {
	                    type: 'dd',
	                    title: 'font.family',
	                    selectedValue: 'Helvetica',
	                    options: ['Arial', 'Arial Black', 'Bookman Old Style', 'Calibri', 'Century Gothic', 'Comic Sans MS', 'Courier', 'Courier New', 'Garamond', 'Georgia', 'Helvetica', 'Impact', 'Palatino Linotype', 'Sans Serif', 'Sofia Pro Regular', 'Sofia Pro Semi Bold', 'Times', 'Times New Roman', 'Trebuchet MS', 'Verdana']
	                },
	                'font-size': {
	                    type: 'number',
	                    title: 'font.size',
	                    selectedValue: 14,
	                    min: '1',
	                    max: '20',
	                    default: 16
	                },
	            }
	        },
	        'Name': {
	            selectedValue: 'control.style',
	            hidden: true
	        }
	    },
	    Margin: angular.copy(Props.marginObject),
	    Advanced: {
	        'Tooltip': {
	            name: 'tooltip',
	            type: 'textbox',
	            selectedValue: ''
	        },
	        'Tabindex': {
	            name: 'tabindex',
	            selectedValue: '',
	            type: 'number'
	        },
	        'Reportable': angular.copy(Props.Reportable),
	        Name: {
	            selectedValue: 'Advanced',
	            hideSection: false,
	            hidden: true
	        },
	    },
	    Events: {
	        Name: {
	            selectedValue: 'Events',
	            hideSection: false,
	            hidden: true
	        },
	        load: angular.copy(Props.elementEventsObject).load,
	        click: {
	            name: 'onClick',
	            type: 'event',
	            selectedValue: '',
	            xmlValue: '',
	            onClickFunction: 'openCodeEditorDialog'
	        },
	    },
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = InlineAssocFiles;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var InlineAssocApps = {
	    Basic: {
	        'ControlType': 'InlineAssocApps',
	        'Label': {
	            name: 'label',
	            selectedValue: 'Associate Apps',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe',
	        },
	        'Text': {
	            name: 'text',
	            selectedValue: 'Associate Apps',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe'
	        },
	        'Field Name': Props.getFieldName('InlineAssocApps'),
	        'Data Field Name': Props.getDataFieldName('InlineAssocApps'),
	        'Required': {
	            name: 'required',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Basic',
	            hidden: true
	        },
	    },
	    Association: {
	        'AddSetup': {
	            type: "button",
	            title: "Add Setup",
	            selectedValue: "1",
	            icon: "fa fa-plus",
	            onClickFunction: "addcolumnName",
	            clicked: false
	        },
	        'selectedColumn': {
	            'Parameters': {
	                type: "table",
	                list: [
	                    {
	                        value: {
	                            selectedValue: "",
	                            type: "dropdown",
	                            inputWidth: "width:100px;"
	                        },
	                        sorting: {
	                            selectedValue: "",
	                            type: "radio",
	                        }
	                    }
	                ],
	                hidden: true
	            },
	            'table': {
	                type: "table",
	                default: "datasource",
	                list: [
	                    {
	                        id: 1,
	                        Value: {
	                            name: {
	                                "id": "5",
	                                "fieldName": "formDisplayId",
	                                "colDisplayName": "ID",
	                                "dataType": "text",
	                                "function": "openApps",
	                                "widthOfColumn": 125,
	                                "isSortSupported": true,
	                                "isCustomAttributeColumn": false,
	                            },
	                            type: "dropdown",
	                            inputWidth: "width:100px;",
	                            disable: false,
	                        },
	                        Sorting: {
	                            name: 'sorting',
	                            type: 'radio',
	                            selectedValue: '',
	                            disable: false,
	                            list: [
	                                {
	                                    name: 'Descending',
	                                    value: '1'
	                                },
	                                {
	                                    name: 'Ascending',
	                                    value: '0'
	                                },
	                            ]
	                        },
	                        showUpdateOptions: true
	                    }
	                ],
	                hidden: true
	            },
	            hidden: true
	        },
	        'Name': {
	            selectedValue: 'Form Fields Setup',
	            hidden: true
	        },
	    },
	    Display: {
	        'Read-only': {
	            name: 'read.only',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        }
	    },
	    Borders: {
	        'border-style-group': {
	            type: 'style-group',
	            members: {
	                'border-width': {
	                    type: 'number',
	                    title: 'border.width',
	                    selectedValue: 1,
	                    min: '1',
	                    max: '99',
	                    default: 1,
	                    onChangeFunction: 'updateStyle'
	                },
	                'border-color': {
	                    type: 'color-picker',
	                    title: 'border.color',
	                    selectedValue: '#cccccc',
	                    icon: 'fa fa-paint-brush',
	                    onChangeFunction: 'updateStyle'
	                }
	            }
	        },
	        'Name': {
	            selectedValue: 'Borders',
	            hidden: true
	        }
	    },
	    Style: angular.copy(Props.labelStyleObject),
	    ControlStyle: {
	        'font-style-group': {
	            type: 'style-group',
	            members: {
	                'font-family': {
	                    type: 'dd',
	                    title: 'font.family',
	                    selectedValue: 'Helvetica',
	                    options: ['Arial', 'Arial Black', 'Bookman Old Style', 'Calibri', 'Century Gothic', 'Comic Sans MS', 'Courier', 'Courier New', 'Garamond', 'Georgia', 'Helvetica', 'Impact', 'Palatino Linotype', 'Sans Serif', 'Sofia Pro Regular', 'Sofia Pro Semi Bold', 'Times', 'Times New Roman', 'Trebuchet MS', 'Verdana']
	                },
	                'font-size': {
	                    type: 'number',
	                    title: 'font.size',
	                    selectedValue: 14,
	                    min: '1',
	                    max: '20',
	                    default: 16
	                },
	            }
	        },
	        'Name': {
	            selectedValue: 'control.style',
	            hidden: true
	        }
	    },
	    Margin: angular.copy(Props.marginObject),
	    Advanced: {
	        'Tooltip': {
	            name: 'tooltip',
	            type: 'textbox',
	            selectedValue: ''
	        },
	        'Tabindex': {
	            name: 'tabindex',
	            selectedValue: '',
	            type: 'number'
	        },
	        'Reportable': angular.copy(Props.Reportable),
	        Name: {
	            selectedValue: 'Advanced',
	            hideSection: false,
	            hidden: true
	        },
	    },
	    Events: {
	        Name: {
	            selectedValue: 'Events',
	            hideSection: false,
	            hidden: true
	        },
	        load: angular.copy(Props.elementEventsObject).load,
	        click: {
	            name: 'onClick',
	            type: 'event',
	            selectedValue: '',
	            xmlValue: '',
	            onClickFunction: 'openCodeEditorDialog'
	        },
	    },
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = InlineAssocApps;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var Props = __webpack_require__(268);
	var angular = __webpack_require__(1);
	var ViewAssociations = {
	    Basic: {
	        'ControlType': 'ViewAssociations',
	        'Label': {
	            name: 'label',
	            selectedValue: 'View Associations',
	            type: 'textbox',
	            onClickFunction: 'openLanguageDialog',
	            addOnButton: 'fa fa-globe',
	        },
	        'Field Name': Props.getFieldName('ViewAssociations'),
	        'Data Field Name': Props.getDataFieldName('ViewAssociations'),
	        'Assoc Type': {
	            name: 'assoc.type',
	            type: 'dd',
	            options: [
	                {
	                    value: '',
	                    key: 'Please select'
	                },
	                {
	                    value: 'Files',
	                    key: 'Files'
	                }, {
	                    value: 'Apps',
	                    key: 'Apps'
	                }],
	            selectedValue: '',
	        },
	        'Message Type': {
	            name: 'msg.type',
	            type: 'dd',
	            options: [{
	                    value: '',
	                    key: 'Please select'
	                },
	                {
	                    value: '0',
	                    key: 'All messages'
	                }, {
	                    value: '1',
	                    key: 'Current message'
	                },
	            ],
	            selectedValue: '',
	        },
	        'Name': {
	            selectedValue: 'Basic',
	            hidden: true
	        },
	    },
	    Association: {
	        'AddSetup': {
	            type: "button",
	            title: "Add Setup",
	            selectedValue: "1",
	            icon: "fa fa-plus",
	            onClickFunction: "addcolumnName",
	            clicked: false
	        },
	        'Files': {
	            'Parameters': {
	                type: "table",
	                list: [
	                    {
	                        value: {
	                            selectedValue: "",
	                            type: "dropdown",
	                            inputWidth: "width:100px;"
	                        },
	                        sorting: {
	                            selectedValue: "",
	                            type: "radio",
	                        }
	                    }
	                ],
	                hidden: true
	            },
	            'table': {
	                type: "table",
	                default: "datasource",
	                list: [
	                    {
	                        id: 1,
	                        Value: {
	                            name: {
	                                "id": "2",
	                                "fieldName": "document_ref",
	                                "colDisplayName": "Doc Ref",
	                                "dataType": "text",
	                                "function": "openDocument",
	                                "widthOfColumn": 125,
	                                "isSortSupported": true,
	                                "isCustomAttributeColumn": false,
	                            },
	                            type: "dropdown",
	                            inputWidth: "width:100px;",
	                            disable: false,
	                        },
	                        Sorting: {
	                            name: 'sorting',
	                            type: 'radio',
	                            selectedValue: '',
	                            disable: false,
	                            list: [
	                                {
	                                    name: 'Descending',
	                                    value: '1'
	                                },
	                                {
	                                    name: 'Ascending',
	                                    value: '0'
	                                },
	                            ]
	                        },
	                        showUpdateOptions: true
	                    }
	                ],
	                hidden: true
	            },
	            hidden: true
	        },
	        'Apps': {
	            'Parameters': {
	                type: "table",
	                list: [
	                    {
	                        value: {
	                            selectedValue: "",
	                            type: "dropdown",
	                            inputWidth: "width:100px;"
	                        },
	                        sorting: {
	                            selectedValue: "",
	                            type: "radio",
	                        }
	                    }
	                ],
	                hidden: true
	            },
	            'table': {
	                type: "table",
	                default: "datasource",
	                list: [
	                    {
	                        id: 1,
	                        Value: {
	                            name: {
	                                "id": "5",
	                                "fieldName": "formDisplayId",
	                                "colDisplayName": "ID",
	                                "dataType": "text",
	                                "function": "openApps",
	                                "widthOfColumn": 125,
	                                "isSortSupported": true,
	                                "isCustomAttributeColumn": false,
	                            },
	                            type: "dropdown",
	                            inputWidth: "width:100px;",
	                            disable: false,
	                        },
	                        Sorting: {
	                            name: 'sorting',
	                            type: 'radio',
	                            selectedValue: '',
	                            disable: false,
	                            list: [
	                                {
	                                    name: 'Descending',
	                                    value: '1'
	                                },
	                                {
	                                    name: 'Ascending',
	                                    value: '0'
	                                },
	                            ]
	                        },
	                        showUpdateOptions: true
	                    }
	                ],
	                hidden: true
	            },
	            hidden: true
	        },
	        'Name': {
	            selectedValue: 'Add/Edit Fields',
	            hidden: true
	        },
	    },
	    Display: {
	        'Hidden': {
	            name: 'hidden',
	            selectedValue: false,
	            type: 'checkbox'
	        },
	        'Name': {
	            selectedValue: 'Display',
	            hidden: true
	        }
	    },
	    Borders: {
	        'border-style-group': {
	            type: 'style-group',
	            members: {
	                'border-width': {
	                    type: 'number',
	                    title: 'border.width',
	                    selectedValue: 1,
	                    min: '1',
	                    max: '99',
	                    default: 1,
	                    onChangeFunction: 'updateStyle'
	                },
	                'border-color': {
	                    type: 'color-picker',
	                    title: 'border.color',
	                    selectedValue: '#cccccc',
	                    icon: 'fa fa-paint-brush',
	                    onChangeFunction: 'updateStyle'
	                }
	            }
	        },
	        'Name': {
	            selectedValue: 'Borders',
	            hidden: true
	        }
	    },
	    Style: angular.copy(Props.labelStyleObject),
	    ControlStyle: {
	        'font-style-group': {
	            type: 'style-group',
	            members: {
	                'font-family': {
	                    type: 'dd',
	                    title: 'font.family',
	                    selectedValue: 'Helvetica',
	                    options: ['Arial', 'Arial Black', 'Bookman Old Style', 'Calibri', 'Century Gothic', 'Comic Sans MS', 'Courier', 'Courier New', 'Garamond', 'Georgia', 'Helvetica', 'Impact', 'Palatino Linotype', 'Sans Serif', 'Sofia Pro Regular', 'Sofia Pro Semi Bold', 'Times', 'Times New Roman', 'Trebuchet MS', 'Verdana']
	                },
	                'font-size': {
	                    type: 'number',
	                    title: 'font.size',
	                    selectedValue: 14,
	                    min: '1',
	                    max: '20',
	                    default: 16
	                },
	            }
	        },
	        'Name': {
	            selectedValue: 'control.style',
	            hidden: true
	        }
	    },
	    Advanced: {
	        'Reportable': angular.copy(Props.Reportable),
	        'Name': {
	            selectedValue: 'Advanced',
	            hideSection: false,
	            hidden: true
	        },
	    },
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = ViewAssociations;


/***/ }),
/* 326 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.GT_OSGB = GT_OSGB;
	exports.GT_Irish = GT_Irish;
	exports.GT_WGS84 = GT_WGS84;
	exports.GT_Math = GT_Math;
	/**
	 * GeoTools javascript coordinate transformations
	 * http://files.dixo.net/geotools.html
	 *
	 * This file copyright (c)2005 Paul Dixon (paul@elphin.com)
	 *
	
	 * This program is free software; you can redistribute it and/or
	 * modify it under the terms of the GNU General Public License
	 * as published by the Free Software Foundation; either version 2
	 * of the License, or (at your option) any later version.
	 * 
	 * This program is distributed in the hope that it will be useful,
	 * but WITHOUT ANY WARRANTY; without even the implied warranty of
	 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	 * GNU General Public License for more details.
	 * 
	 * You should have received a copy of the GNU General Public License
	 * along with this program; if not, write to the Free Software
	 * Foundation, Inc., 59 Temple Place - Suite 330, Boston, MA  02111-1307, USA.
	 * 
	
	 * --------------------------------------------------------------------------- 
	 * 
	 * Credits
	
	 *
	
	 * The algorithm used by the script for WGS84-OSGB36 conversions is derived 
	 * from an OSGB spreadsheet (www.gps.gov.uk) with permission. This has been
	 * adapted into PHP by Ian Harris, and Irish added by Barry Hunter. Conversion
	 * accuracy is in the order of 7m for 90% of Great Britain, and should be 
	 * be similar to the conversion made by a typical GPSr
	 *
	
	 * See accompanying documentation for more information
	 * http://www.nearby.org.uk/tests/GeoTools2.html
	 */
	
	/*****************************************************************************
	*
	* GT_OSGB holds OSGB grid coordinates
	*
	*****************************************************************************/
	
	function GT_OSGB() {
		this.northings = 0;
		this.eastings = 0;
		this.status = "Undefined";
	}
	
	GT_OSGB.prefixes = new Array(new Array("SV", "SW", "SX", "SY", "SZ", "TV", "TW"), new Array("SQ", "SR", "SS", "ST", "SU", "TQ", "TR"), new Array("SL", "SM", "SN", "SO", "SP", "TL", "TM"), new Array("SF", "SG", "SH", "SJ", "SK", "TF", "TG"), new Array("SA", "SB", "SC", "SD", "SE", "TA", "TB"), new Array("NV", "NW", "NX", "NY", "NZ", "OV", "OW"), new Array("NQ", "NR", "NS", "NT", "NU", "OQ", "OR"), new Array("NL", "NM", "NN", "NO", "NP", "OL", "OM"), new Array("NF", "NG", "NH", "NJ", "NK", "OF", "OG"), new Array("NA", "NB", "NC", "ND", "NE", "OA", "OB"), new Array("HV", "HW", "HX", "HY", "HZ", "JV", "JW"), new Array("HQ", "HR", "HS", "HT", "HU", "JQ", "JR"), new Array("HL", "HM", "HN", "HO", "HP", "JL", "JM"));
	
	GT_OSGB.prototype.setGridCoordinates = function (eastings, northings) {
		this.northings = northings;
		this.eastings = eastings;
		this.status = "OK";
	};
	
	GT_OSGB.prototype.setError = function (msg) {
		this.status = msg;
	};
	
	GT_OSGB.prototype._zeropad = function (num, len) {
		var str = new String(num);
		while (str.length < len) {
			str = '0' + str;
		}
		return str;
	};
	
	GT_OSGB.prototype.getGridRef = function (precision) {
	
		if (precision < 0) precision = 0;
		if (precision > 5) precision = 5;
	
		var e = "";
	
		var n = "";
		if (precision > 0) {
			var y = Math.floor(this.northings / 100000);
			var x = Math.floor(this.eastings / 100000);
	
			var e = Math.floor(this.eastings % 100000);
			var n = Math.floor(this.northings % 100000);
	
			var div = 5 - precision;
			e = Math.floor(e / Math.pow(10, div));
			n = Math.floor(n / Math.pow(10, div));
		}
	
		var prefix = GT_OSGB.prefixes[y][x];
	
		return prefix + " " + this._zeropad(e, precision) + " " + this._zeropad(n, precision);
	};
	
	GT_OSGB.prototype.parseGridRef = function (landranger) {
		var ok = false;
	
		this.northings = 0;
		this.eastings = 0;
	
		var precision;
	
		for (precision = 5; precision >= 1; precision--) {
			var pattern = new RegExp("^([A-Z]{2})\\s*(\\d{" + precision + "})\\s*(\\d{" + precision + "})$", "i");
			var gridRef = landranger.match(pattern);
			if (gridRef) {
				var gridSheet = gridRef[1];
				var gridEast = 0;
				var gridNorth = 0;
	
				//5x1 4x10 3x100 2x1000 1x10000 
				if (precision > 0) {
					var mult = Math.pow(10, 5 - precision);
					gridEast = parseInt(gridRef[2], 10) * mult;
					gridNorth = parseInt(gridRef[3], 10) * mult;
				}
	
				var x, y;
				search: for (y = 0; y < GT_OSGB.prefixes.length; y++) {
					for (x = 0; x < GT_OSGB.prefixes[y].length; x++) {
						if (GT_OSGB.prefixes[y][x] == gridSheet) {
							this.eastings = x * 100000 + gridEast;
							this.northings = y * 100000 + gridNorth;
							ok = true;
							break search;
						}
					}
				}
			}
		}
	
		return ok;
	};
	
	GT_OSGB.prototype.getWGS84 = function () {
	
		var height = 0;
	
		var lat1 = GT_Math.E_N_to_Lat(this.eastings, this.northings, 6377563.396, 6356256.910, 400000, -100000, 0.999601272, 49.00000, -2.00000);
		var lon1 = GT_Math.E_N_to_Long(this.eastings, this.northings, 6377563.396, 6356256.910, 400000, -100000, 0.999601272, 49.00000, -2.00000);
	
		var x1 = GT_Math.Lat_Long_H_to_X(lat1, lon1, height, 6377563.396, 6356256.910);
		var y1 = GT_Math.Lat_Long_H_to_Y(lat1, lon1, height, 6377563.396, 6356256.910);
		var z1 = GT_Math.Lat_H_to_Z(lat1, height, 6377563.396, 6356256.910);
	
		var x2 = GT_Math.Helmert_X(x1, y1, z1, 446.448, 0.2470, 0.8421, -20.4894);
		var y2 = GT_Math.Helmert_Y(x1, y1, z1, -125.157, 0.1502, 0.8421, -20.4894);
		var z2 = GT_Math.Helmert_Z(x1, y1, z1, 542.060, 0.1502, 0.2470, -20.4894);
	
		var latitude = GT_Math.XYZ_to_Lat(x2, y2, z2, 6378137.000, 6356752.313);
		var longitude = GT_Math.XYZ_to_Long(x2, y2);
	
		var wgs84 = new GT_WGS84();
		wgs84.setDegrees(latitude, longitude);
		return wgs84;
	};
	
	/*****************************************************************************
	*
	* GT_OSGB holds Irish grid coordinates
	*
	*****************************************************************************/
	
	function GT_Irish() {
		this.northings = 0;
		this.eastings = 0;
		this.status = "Undefined";
	}
	
	GT_Irish.prefixes = new Array(new Array("V", "Q", "L", "F", "A"), new Array("W", "R", "M", "G", "B"), new Array("X", "S", "N", "H", "C"), new Array("Y", "T", "O", "J", "D"), new Array("Z", "U", "P", "K", "E"));
	
	GT_Irish.prototype.setGridCoordinates = function (eastings, northings) {
		this.northings = northings;
		this.eastings = eastings;
		this.status = "OK";
	};
	
	GT_Irish.prototype.setError = function (msg) {
		this.status = msg;
	};
	
	GT_Irish.prototype._zeropad = function (num, len) {
		var str = new String(num);
		while (str.length < len) {
			str = '0' + str;
		}
		return str;
	};
	
	GT_Irish.prototype.getGridRef = function (precision) {
	
		if (precision < 0) precision = 0;
		if (precision > 5) precision = 5;
	
		var e = "";
	
		var n = "";
		if (precision > 0) {
			var y = Math.floor(this.northings / 100000);
			var x = Math.floor(this.eastings / 100000);
	
			var e = Math.floor(this.eastings % 100000);
			var n = Math.floor(this.northings % 100000);
	
			var div = 5 - precision;
			e = Math.floor(e / Math.pow(10, div));
			n = Math.floor(n / Math.pow(10, div));
		}
	
		var prefix = GT_Irish.prefixes[x][y];
	
		return prefix + " " + this._zeropad(e, precision) + " " + this._zeropad(n, precision);
	};
	
	GT_Irish.prototype.parseGridRef = function (landranger) {
		var ok = false;
	
		this.northings = 0;
		this.eastings = 0;
	
		var precision;
	
		for (precision = 5; precision >= 1; precision--) {
			var pattern = new RegExp("^([A-Z]{1})\\s*(\\d{" + precision + "})\\s*(\\d{" + precision + "})$", "i");
			var gridRef = landranger.match(pattern);
			if (gridRef) {
				var gridSheet = gridRef[1];
				var gridEast = 0;
				var gridNorth = 0;
	
				//5x1 4x10 3x100 2x1000 1x10000 
				if (precision > 0) {
					var mult = Math.pow(10, 5 - precision);
					gridEast = parseInt(gridRef[2], 10) * mult;
					gridNorth = parseInt(gridRef[3], 10) * mult;
				}
	
				var x, y;
				search: for (x = 0; x < GT_Irish.prefixes.length; x++) {
					for (y = 0; y < GT_Irish.prefixes[x].length; y++) {
						if (GT_Irish.prefixes[x][y] == gridSheet) {
							this.eastings = x * 100000 + gridEast;
							this.northings = y * 100000 + gridNorth;
							ok = true;
							break search;
						}
					}
				}
			}
		}
	
		return ok;
	};
	
	GT_Irish.prototype.getWGS84 = function (uselevel2) {
	
		var height = 0;
	
		if (uselevel2) {
			e = this.eastings;
			n = this.northings;
		} else {
			//fixed datum shift correction (instead of fancy hermert translation below!)
			e = this.eastings - 49;
			n = this.northings + 23.4;
		}
	
		var lat1 = GT_Math.E_N_to_Lat(e, n, 6377340.189, 6356034.447, 200000, 250000, 1.000035, 53.50000, -8.00000);
		var lon1 = GT_Math.E_N_to_Long(e, n, 6377340.189, 6356034.447, 200000, 250000, 1.000035, 53.50000, -8.00000);
	
		var wgs84 = new GT_WGS84();
		if (uselevel2) {
			var x1 = GT_Math.Lat_Long_H_to_X(lat1, lon1, height, 6377340.189, 6356034.447);
			var y1 = GT_Math.Lat_Long_H_to_Y(lat1, lon1, height, 6377340.189, 6356034.447);
			var z1 = GT_Math.Lat_H_to_Z(lat1, height, 6377340.189, 6356034.447);
	
			var x2 = GT_Math.Helmert_X(x1, y1, z1, 482.53, 0.214, 0.631, 8.15);
			var y2 = GT_Math.Helmert_Y(x1, y1, z1, -130.596, 1.042, 0.631, 8.15);
			var z2 = GT_Math.Helmert_Z(x1, y1, z1, 564.557, 1.042, 0.214, 8.15);
	
			var latitude = GT_Math.XYZ_to_Lat(x2, y2, z2, 6378137.000, 6356752.313);
			var longitude = GT_Math.XYZ_to_Long(x2, y2);
			wgs84.setDegrees(latitude, longitude);
		} else {
			wgs84.setDegrees(lat1, lon1);
		}
		return wgs84;
	};
	
	/*****************************************************************************
	*
	* GT_WGS84 holds WGS84 latitude and longitude
	*
	*****************************************************************************/
	
	function GT_WGS84() {
		this.latitude = 0;
		this.longitude = 0;
	}
	
	GT_WGS84.prototype.setDegrees = function (latitude, longitude) {
		this.latitude = latitude;
		this.longitude = longitude;
	};
	
	GT_WGS84.prototype.parseString = function (text) {
		var ok = false;
	
		var str = new String(text);
	
		//N 51� 53.947 W 000� 10.018
	
		var pattern = /([ns])\s*(\d+)[�\s]+(\d+\.\d+)\s+([we])\s*(\d+)[�\s]+(\d+\.\d+)/i;
		var matches = str.match(pattern);
		if (matches) {
			ok = true;
			var latsign = matches[1] == 's' || matches[1] == 'S' ? -1 : 1;
			var longsign = matches[4] == 'w' || matches[4] == 'W' ? -1 : 1;
	
			var d1 = parseFloat(matches[2]);
			var m1 = parseFloat(matches[3]);
			var d2 = parseFloat(matches[5]);
			var m2 = parseFloat(matches[6]);
	
			this.latitude = latsign * (d1 + m1 / 60.0);
			this.longitude = longsign * (d2 + m2 / 60.0);
		}
	
		return ok;
	};
	
	GT_WGS84.prototype.isGreatBritain = function () {
		return this.latitude > 49 && this.latitude < 62 && this.longitude > -9.5 && this.longitude < 2.3;
	};
	
	GT_WGS84.prototype.isIreland = function () {
		return this.latitude > 51.2 && this.latitude < 55.73 && this.longitude > -12.2 && this.longitude < -4.8;
	};
	
	GT_WGS84.prototype.isIreland2 = function () {
	
		//rough border for ireland
		var points = [[-12.19, 50.38], [-6.39, 50.94], [-5.07, 53.71], [-5.25, 54.71], [-6.13, 55.42], [-10.65, 56.15], [-12.19, 50.38]];
	
		// === A method for testing if a point is inside a polygon
		// === Returns true if poly contains point
		// === Algorithm shamelessly stolen from http://alienryderflex.com/polygon/ 
		var j = 0;
		var oddNodes = false;
		var x = this.longitude;
		var y = this.latitude;
		for (var i = 0; i < points.length; i++) {
			j++;
			if (j == points.length) {
				j = 0;
			}
			if (points[i][1] < y && points[j][1] >= y || points[j][1] < y && points[i][1] >= y) {
				if (points[i][0] + (y - points[i][1]) / (points[j][1] - points[i][1]) * (points[j][0] - points[i][0]) < x) {
					oddNodes = !oddNodes;
				}
			}
		}
		return oddNodes;
	};
	
	GT_WGS84.prototype.getIrish = function (uselevel2) {
		var irish = new GT_Irish();
		if (this.isIreland()) {
			var height = 0;
	
			if (uselevel2) {
				var x1 = GT_Math.Lat_Long_H_to_X(this.latitude, this.longitude, height, 6378137.00, 6356752.313);
				var y1 = GT_Math.Lat_Long_H_to_Y(this.latitude, this.longitude, height, 6378137.00, 6356752.313);
				var z1 = GT_Math.Lat_H_to_Z(this.latitude, height, 6378137.00, 6356752.313);
	
				var x2 = GT_Math.Helmert_X(x1, y1, z1, -482.53, -0.214, -0.631, -8.15);
				var y2 = GT_Math.Helmert_Y(x1, y1, z1, 130.596, -1.042, -0.631, -8.15);
				var z2 = GT_Math.Helmert_Z(x1, y1, z1, -564.557, -1.042, -0.214, -8.15);
	
				var latitude2 = GT_Math.XYZ_to_Lat(x2, y2, z2, 6377340.189, 6356034.447);
				var longitude2 = GT_Math.XYZ_to_Long(x2, y2);
			} else {
				var latitude2 = this.latitude;
				var longitude2 = this.longitude;
			}
	
			var e = GT_Math.Lat_Long_to_East(latitude2, longitude2, 6377340.189, 6356034.447, 200000, 1.000035, 53.50000, -8.00000);
			var n = GT_Math.Lat_Long_to_North(latitude2, longitude2, 6377340.189, 6356034.447, 200000, 250000, 1.000035, 53.50000, -8.00000);
	
			if (!uselevel2) {
				//Level 1 Transformation - 95% of points within 2 metres
				//fixed datum shift correction (instead of fancy hermert translation above!)
				//source http://www.osni.gov.uk/downloads/Making%20maps%20GPS%20compatible.pdf
				e = e + 49;
				n = n - 23.4;
			}
	
			irish.setGridCoordinates(Math.round(e), Math.round(n));
		} else {
			irish.setError("Coordinate not within Ireland");
		}
	
		return irish;
	};
	
	GT_WGS84.prototype.getOSGB = function (uselevel2) {
		var osgb = new GT_OSGB();
		if (this.isGreatBritain()) {
			var height = 0;
	
			var x1 = GT_Math.Lat_Long_H_to_X(this.latitude, this.longitude, height, 6378137.00, 6356752.313);
			var y1 = GT_Math.Lat_Long_H_to_Y(this.latitude, this.longitude, height, 6378137.00, 6356752.313);
			var z1 = GT_Math.Lat_H_to_Z(this.latitude, height, 6378137.00, 6356752.313);
	
			var x2 = GT_Math.Helmert_X(x1, y1, z1, -446.448, -0.2470, -0.8421, 20.4894);
			var y2 = GT_Math.Helmert_Y(x1, y1, z1, 125.157, -0.1502, -0.8421, 20.4894);
			var z2 = GT_Math.Helmert_Z(x1, y1, z1, -542.060, -0.1502, -0.2470, 20.4894);
	
			var latitude2 = GT_Math.XYZ_to_Lat(x2, y2, z2, 6377563.396, 6356256.910);
			var longitude2 = GT_Math.XYZ_to_Long(x2, y2);
	
			var e = GT_Math.Lat_Long_to_East(latitude2, longitude2, 6377563.396, 6356256.910, 400000, 0.999601272, 49.00000, -2.00000);
			var n = GT_Math.Lat_Long_to_North(latitude2, longitude2, 6377563.396, 6356256.910, 400000, -100000, 0.999601272, 49.00000, -2.00000);
	
			osgb.setGridCoordinates(Math.round(e), Math.round(n));
		} else {
			osgb.setError("Coordinate not within Great Britain");
		}
	
		return osgb;
	};
	
	/*****************************************************************************
	*
	* GT_Math is a collection of static methods doing all the nasty sums
	*
	*****************************************************************************/
	
	//GT_Math is just namespace for all the nasty maths functions
	function GT_Math() {}
	
	GT_Math.E_N_to_Lat = function (East, North, a, b, e0, n0, f0, PHI0, LAM0) {
		//Un-project Transverse Mercator eastings and northings back to latitude.
		//Input: - _
		//eastings (East) and northings (North) in meters; _
		//ellipsoid axis dimensions (a & b) in meters; _
		//eastings (e0) and northings (n0) of false origin in meters; _
		//central meridian scale factor (f0) and _
		//latitude (PHI0) and longitude (LAM0) of false origin in decimal degrees.
	
		//'REQUIRES THE "Marc" AND "InitialLat" FUNCTIONS
	
		//Convert angle measures to radians
		var Pi = 3.14159265358979;
		var RadPHI0 = PHI0 * (Pi / 180);
		var RadLAM0 = LAM0 * (Pi / 180);
	
		//Compute af0, bf0, e squared (e2), n and Et
		var af0 = a * f0;
		var bf0 = b * f0;
		var e2 = (Math.pow(af0, 2) - Math.pow(bf0, 2)) / Math.pow(af0, 2);
		var n = (af0 - bf0) / (af0 + bf0);
		var Et = East - e0;
	
		//Compute initial value for latitude (PHI) in radians
		var PHId = GT_Math.InitialLat(North, n0, af0, RadPHI0, n, bf0);
	
		//Compute nu, rho and eta2 using value for PHId
		var nu = af0 / Math.sqrt(1 - e2 * Math.pow(Math.sin(PHId), 2));
		var rho = nu * (1 - e2) / (1 - e2 * Math.pow(Math.sin(PHId), 2));
		var eta2 = nu / rho - 1;
	
		//Compute Latitude
		var VII = Math.tan(PHId) / (2 * rho * nu);
		var VIII = Math.tan(PHId) / (24 * rho * Math.pow(nu, 3)) * (5 + 3 * Math.pow(Math.tan(PHId), 2) + eta2 - 9 * eta2 * Math.pow(Math.tan(PHId), 2));
		var IX = Math.tan(PHId) / (720 * rho * Math.pow(nu, 5)) * (61 + 90 * (Math.tan(PHId) ^ 2) + 45 * Math.pow(Math.tan(PHId), 4));
	
		var E_N_to_Lat = 180 / Pi * (PHId - Math.pow(Et, 2) * VII + Math.pow(Et, 4) * VIII - (Et ^ 6) * IX);
	
		return E_N_to_Lat;
	};
	
	GT_Math.E_N_to_Long = function (East, North, a, b, e0, n0, f0, PHI0, LAM0) {
		//Un-project Transverse Mercator eastings and northings back to longitude.
		//Input: - _
		//eastings (East) and northings (North) in meters; _
		//ellipsoid axis dimensions (a & b) in meters; _
		//eastings (e0) and northings (n0) of false origin in meters; _
		//central meridian scale factor (f0) and _
		//latitude (PHI0) and longitude (LAM0) of false origin in decimal degrees.
	
		//REQUIRES THE "Marc" AND "InitialLat" FUNCTIONS
	
		//Convert angle measures to radians
		var Pi = 3.14159265358979;
		var RadPHI0 = PHI0 * (Pi / 180);
		var RadLAM0 = LAM0 * (Pi / 180);
	
		//Compute af0, bf0, e squared (e2), n and Et
		var af0 = a * f0;
		var bf0 = b * f0;
		var e2 = (Math.pow(af0, 2) - Math.pow(bf0, 2)) / Math.pow(af0, 2);
		var n = (af0 - bf0) / (af0 + bf0);
		var Et = East - e0;
	
		//Compute initial value for latitude (PHI) in radians
		var PHId = GT_Math.InitialLat(North, n0, af0, RadPHI0, n, bf0);
	
		//Compute nu, rho and eta2 using value for PHId
		var nu = af0 / Math.sqrt(1 - e2 * Math.pow(Math.sin(PHId), 2));
		var rho = nu * (1 - e2) / (1 - e2 * Math.pow(Math.sin(PHId), 2));
		var eta2 = nu / rho - 1;
	
		//Compute Longitude
		var X = Math.pow(Math.cos(PHId), -1) / nu;
		var XI = Math.pow(Math.cos(PHId), -1) / (6 * Math.pow(nu, 3)) * (nu / rho + 2 * Math.pow(Math.tan(PHId), 2));
		var XII = Math.pow(Math.cos(PHId), -1) / (120 * Math.pow(nu, 5)) * (5 + 28 * Math.pow(Math.tan(PHId), 2) + 24 * Math.pow(Math.tan(PHId), 4));
		var XIIA = Math.pow(Math.cos(PHId), -1) / (5040 * Math.pow(nu, 7)) * (61 + 662 * Math.pow(Math.tan(PHId), 2) + 1320 * Math.pow(Math.tan(PHId), 4) + 720 * Math.pow(Math.tan(PHId), 6));
	
		var E_N_to_Long = 180 / Pi * (RadLAM0 + Et * X - Math.pow(Et, 3) * XI + Math.pow(Et, 5) * XII - Math.pow(Et, 7) * XIIA);
	
		return E_N_to_Long;
	};
	
	GT_Math.InitialLat = function (North, n0, afo, PHI0, n, bfo) {
		//Compute initial value for Latitude (PHI) IN RADIANS.
		//Input: - _
		//northing of point (North) and northing of false origin (n0) in meters; _
		//semi major axis multiplied by central meridian scale factor (af0) in meters; _
		//latitude of false origin (PHI0) IN RADIANS; _
		//n (computed from a, b and f0) and _
		//ellipsoid semi major axis multiplied by central meridian scale factor (bf0) in meters.
	
		//REQUIRES THE "Marc" FUNCTION
		//THIS FUNCTION IS CALLED BY THE "E_N_to_Lat", "E_N_to_Long" and "E_N_to_C" FUNCTIONS
		//THIS FUNCTION IS ALSO USED ON IT'S OWN IN THE  "Projection and Transformation Calculations.xls" SPREADSHEET
	
		//First PHI value (PHI1)
		var PHI1 = (North - n0) / afo + PHI0;
	
		//Calculate M
		var M = GT_Math.Marc(bfo, n, PHI0, PHI1);
	
		//Calculate new PHI value (PHI2)
		var PHI2 = (North - n0 - M) / afo + PHI1;
	
		//Iterate to get final value for InitialLat
		while (Math.abs(North - n0 - M) > 0.00001) {
			PHI2 = (North - n0 - M) / afo + PHI1;
			M = GT_Math.Marc(bfo, n, PHI0, PHI2);
			PHI1 = PHI2;
		}
		return PHI2;
	};
	
	GT_Math.Lat_Long_H_to_X = function (PHI, LAM, H, a, b) {
		// Convert geodetic coords lat (PHI), long (LAM) and height (H) to cartesian X coordinate.
		// Input: - _
		//    Latitude (PHI)& Longitude (LAM) both in decimal degrees; _
		//  Ellipsoidal height (H) and ellipsoid axis dimensions (a & b) all in meters.
	
		// Convert angle measures to radians
		var Pi = 3.14159265358979;
		var RadPHI = PHI * (Pi / 180);
		var RadLAM = LAM * (Pi / 180);
	
		// Compute eccentricity squared and nu
		var e2 = (Math.pow(a, 2) - Math.pow(b, 2)) / Math.pow(a, 2);
		var V = a / Math.sqrt(1 - e2 * Math.pow(Math.sin(RadPHI), 2));
	
		// Compute X
		return (V + H) * Math.cos(RadPHI) * Math.cos(RadLAM);
	};
	
	GT_Math.Lat_Long_H_to_Y = function (PHI, LAM, H, a, b) {
		// Convert geodetic coords lat (PHI), long (LAM) and height (H) to cartesian Y coordinate.
		// Input: - _
		// Latitude (PHI)& Longitude (LAM) both in decimal degrees; _
		// Ellipsoidal height (H) and ellipsoid axis dimensions (a & b) all in meters.
	
		// Convert angle measures to radians
		var Pi = 3.14159265358979;
		var RadPHI = PHI * (Pi / 180);
		var RadLAM = LAM * (Pi / 180);
	
		// Compute eccentricity squared and nu
		var e2 = (Math.pow(a, 2) - Math.pow(b, 2)) / Math.pow(a, 2);
		var V = a / Math.sqrt(1 - e2 * Math.pow(Math.sin(RadPHI), 2));
	
		// Compute Y
		return (V + H) * Math.cos(RadPHI) * Math.sin(RadLAM);
	};
	
	GT_Math.Lat_H_to_Z = function (PHI, H, a, b) {
		// Convert geodetic coord components latitude (PHI) and height (H) to cartesian Z coordinate.
		// Input: - _
		//    Latitude (PHI) decimal degrees; _
		// Ellipsoidal height (H) and ellipsoid axis dimensions (a & b) all in meters.
	
		// Convert angle measures to radians
		var Pi = 3.14159265358979;
		var RadPHI = PHI * (Pi / 180);
	
		// Compute eccentricity squared and nu
		var e2 = (Math.pow(a, 2) - Math.pow(b, 2)) / Math.pow(a, 2);
		var V = a / Math.sqrt(1 - e2 * Math.pow(Math.sin(RadPHI), 2));
	
		// Compute X
		return (V * (1 - e2) + H) * Math.sin(RadPHI);
	};
	
	GT_Math.Helmert_X = function (X, Y, Z, DX, Y_Rot, Z_Rot, s) {
	
		// (X, Y, Z, DX, Y_Rot, Z_Rot, s)
		// Computed Helmert transformed X coordinate.
		// Input: - _
		//    cartesian XYZ coords (X,Y,Z), X translation (DX) all in meters ; _
		// Y and Z rotations in seconds of arc (Y_Rot, Z_Rot) and scale in ppm (s).
	
		// Convert rotations to radians and ppm scale to a factor
		var Pi = 3.14159265358979;
		var sfactor = s * 0.000001;
	
		var RadY_Rot = Y_Rot / 3600 * (Pi / 180);
	
		var RadZ_Rot = Z_Rot / 3600 * (Pi / 180);
	
		//Compute transformed X coord
		return X + X * sfactor - Y * RadZ_Rot + Z * RadY_Rot + DX;
	};
	
	GT_Math.Helmert_Y = function (X, Y, Z, DY, X_Rot, Z_Rot, s) {
		// (X, Y, Z, DY, X_Rot, Z_Rot, s)
		// Computed Helmert transformed Y coordinate.
		// Input: - _
		//    cartesian XYZ coords (X,Y,Z), Y translation (DY) all in meters ; _
		//  X and Z rotations in seconds of arc (X_Rot, Z_Rot) and scale in ppm (s).
	
		// Convert rotations to radians and ppm scale to a factor
		var Pi = 3.14159265358979;
		var sfactor = s * 0.000001;
		var RadX_Rot = X_Rot / 3600 * (Pi / 180);
		var RadZ_Rot = Z_Rot / 3600 * (Pi / 180);
	
		// Compute transformed Y coord
		return X * RadZ_Rot + Y + Y * sfactor - Z * RadX_Rot + DY;
	};
	
	GT_Math.Helmert_Z = function (X, Y, Z, DZ, X_Rot, Y_Rot, s) {
		// (X, Y, Z, DZ, X_Rot, Y_Rot, s)
		// Computed Helmert transformed Z coordinate.
		// Input: - _
		//    cartesian XYZ coords (X,Y,Z), Z translation (DZ) all in meters ; _
		// X and Y rotations in seconds of arc (X_Rot, Y_Rot) and scale in ppm (s).
		// 
		// Convert rotations to radians and ppm scale to a factor
		var Pi = 3.14159265358979;
		var sfactor = s * 0.000001;
		var RadX_Rot = X_Rot / 3600 * (Pi / 180);
		var RadY_Rot = Y_Rot / 3600 * (Pi / 180);
	
		// Compute transformed Z coord
		return -1 * X * RadY_Rot + Y * RadX_Rot + Z + Z * sfactor + DZ;
	};
	
	GT_Math.XYZ_to_Lat = function (X, Y, Z, a, b) {
		// Convert XYZ to Latitude (PHI) in Dec Degrees.
		// Input: - _
		// XYZ cartesian coords (X,Y,Z) and ellipsoid axis dimensions (a & b), all in meters.
	
		// THIS FUNCTION REQUIRES THE "Iterate_XYZ_to_Lat" FUNCTION
		// THIS FUNCTION IS CALLED BY THE "XYZ_to_H" FUNCTION
	
		var RootXYSqr = Math.sqrt(Math.pow(X, 2) + Math.pow(Y, 2));
		var e2 = (Math.pow(a, 2) - Math.pow(b, 2)) / Math.pow(a, 2);
		var PHI1 = Math.atan2(Z, RootXYSqr * (1 - e2));
	
		var PHI = GT_Math.Iterate_XYZ_to_Lat(a, e2, PHI1, Z, RootXYSqr);
	
		var Pi = 3.14159265358979;
	
		return PHI * (180 / Pi);
	};
	
	GT_Math.Iterate_XYZ_to_Lat = function (a, e2, PHI1, Z, RootXYSqr) {
		// Iteratively computes Latitude (PHI).
		// Input: - _
		//    ellipsoid semi major axis (a) in meters; _
		//    eta squared (e2); _
		//    estimated value for latitude (PHI1) in radians; _
		//    cartesian Z coordinate (Z) in meters; _
		// RootXYSqr computed from X & Y in meters.
	
		// THIS FUNCTION IS CALLED BY THE "XYZ_to_PHI" FUNCTION
		// THIS FUNCTION IS ALSO USED ON IT'S OWN IN THE _
		// "Projection and Transformation Calculations.xls" SPREADSHEET
	
	
		var V = a / Math.sqrt(1 - e2 * Math.pow(Math.sin(PHI1), 2));
		var PHI2 = Math.atan2(Z + e2 * V * Math.sin(PHI1), RootXYSqr);
	
		while (Math.abs(PHI1 - PHI2) > 0.000000001) {
			PHI1 = PHI2;
			V = a / Math.sqrt(1 - e2 * Math.pow(Math.sin(PHI1), 2));
			PHI2 = Math.atan2(Z + e2 * V * Math.sin(PHI1), RootXYSqr);
		}
	
		return PHI2;
	};
	
	GT_Math.XYZ_to_Long = function (X, Y) {
		// Convert XYZ to Longitude (LAM) in Dec Degrees.
		// Input: - _
		// X and Y cartesian coords in meters.
	
		var Pi = 3.14159265358979;
		return Math.atan2(Y, X) * (180 / Pi);
	};
	
	GT_Math.Marc = function (bf0, n, PHI0, PHI) {
		//Compute meridional arc.
		//Input: - _
		// ellipsoid semi major axis multiplied by central meridian scale factor (bf0) in meters; _
		// n (computed from a, b and f0); _
		// lat of false origin (PHI0) and initial or final latitude of point (PHI) IN RADIANS.
	
		//THIS FUNCTION IS CALLED BY THE - _
		// "Lat_Long_to_North" and "InitialLat" FUNCTIONS
		// THIS FUNCTION IS ALSO USED ON IT'S OWN IN THE "Projection and Transformation Calculations.xls" SPREADSHEET
	
		return bf0 * ((1 + n + 5 / 4 * Math.pow(n, 2) + 5 / 4 * Math.pow(n, 3)) * (PHI - PHI0) - (3 * n + 3 * Math.pow(n, 2) + 21 / 8 * Math.pow(n, 3)) * Math.sin(PHI - PHI0) * Math.cos(PHI + PHI0) + (15 / 8 * Math.pow(n, 2) + 15 / 8 * Math.pow(n, 3)) * Math.sin(2 * (PHI - PHI0)) * Math.cos(2 * (PHI + PHI0)) - 35 / 24 * Math.pow(n, 3) * Math.sin(3 * (PHI - PHI0)) * Math.cos(3 * (PHI + PHI0)));
	};
	
	GT_Math.Lat_Long_to_East = function (PHI, LAM, a, b, e0, f0, PHI0, LAM0) {
		//Project Latitude and longitude to Transverse Mercator eastings.
		//Input: - _
		//    Latitude (PHI) and Longitude (LAM) in decimal degrees; _
		//    ellipsoid axis dimensions (a & b) in meters; _
		//    eastings of false origin (e0) in meters; _
		//    central meridian scale factor (f0); _
		// latitude (PHI0) and longitude (LAM0) of false origin in decimal degrees.
	
		// Convert angle measures to radians
		var Pi = 3.14159265358979;
		var RadPHI = PHI * (Pi / 180);
		var RadLAM = LAM * (Pi / 180);
		var RadPHI0 = PHI0 * (Pi / 180);
		var RadLAM0 = LAM0 * (Pi / 180);
	
		var af0 = a * f0;
		var bf0 = b * f0;
		var e2 = (Math.pow(af0, 2) - Math.pow(bf0, 2)) / Math.pow(af0, 2);
		var n = (af0 - bf0) / (af0 + bf0);
		var nu = af0 / Math.sqrt(1 - e2 * Math.pow(Math.sin(RadPHI), 2));
		var rho = nu * (1 - e2) / (1 - e2 * Math.pow(Math.sin(RadPHI), 2));
		var eta2 = nu / rho - 1;
		var p = RadLAM - RadLAM0;
	
		var IV = nu * Math.cos(RadPHI);
		var V = nu / 6 * Math.pow(Math.cos(RadPHI), 3) * (nu / rho - Math.pow(Math.tan(RadPHI), 2));
		var VI = nu / 120 * Math.pow(Math.cos(RadPHI), 5) * (5 - 18 * Math.pow(Math.tan(RadPHI), 2) + Math.pow(Math.tan(RadPHI), 4) + 14 * eta2 - 58 * Math.pow(Math.tan(RadPHI), 2) * eta2);
	
		return e0 + p * IV + Math.pow(p, 3) * V + Math.pow(p, 5) * VI;
	};
	
	GT_Math.Lat_Long_to_North = function (PHI, LAM, a, b, e0, n0, f0, PHI0, LAM0) {
		// Project Latitude and longitude to Transverse Mercator northings
		// Input: - _
		// Latitude (PHI) and Longitude (LAM) in decimal degrees; _
		// ellipsoid axis dimensions (a & b) in meters; _
		// eastings (e0) and northings (n0) of false origin in meters; _
		// central meridian scale factor (f0); _
		// latitude (PHI0) and longitude (LAM0) of false origin in decimal degrees.
	
		// REQUIRES THE "Marc" FUNCTION
	
		// Convert angle measures to radians
		var Pi = 3.14159265358979;
		var RadPHI = PHI * (Pi / 180);
		var RadLAM = LAM * (Pi / 180);
		var RadPHI0 = PHI0 * (Pi / 180);
		var RadLAM0 = LAM0 * (Pi / 180);
	
		var af0 = a * f0;
		var bf0 = b * f0;
		var e2 = (Math.pow(af0, 2) - Math.pow(bf0, 2)) / Math.pow(af0, 2);
		var n = (af0 - bf0) / (af0 + bf0);
		var nu = af0 / Math.sqrt(1 - e2 * Math.pow(Math.sin(RadPHI), 2));
		var rho = nu * (1 - e2) / (1 - e2 * Math.pow(Math.sin(RadPHI), 2));
		var eta2 = nu / rho - 1;
		var p = RadLAM - RadLAM0;
		var M = GT_Math.Marc(bf0, n, RadPHI0, RadPHI);
	
		var I = M + n0;
		var II = nu / 2 * Math.sin(RadPHI) * Math.cos(RadPHI);
		var III = nu / 24 * Math.sin(RadPHI) * Math.pow(Math.cos(RadPHI), 3) * (5 - Math.pow(Math.tan(RadPHI), 2) + 9 * eta2);
		var IIIA = nu / 720 * Math.sin(RadPHI) * Math.pow(Math.cos(RadPHI), 5) * (61 - 58 * Math.pow(Math.tan(RadPHI), 2) + Math.pow(Math.tan(RadPHI), 4));
	
		return I + Math.pow(p, 2) * II + Math.pow(p, 4) * III + Math.pow(p, 6) * IIIA;
	};

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	/**
	 * angular-drag-and-drop-lists v1.4.0
	 *
	 * Copyright (c) 2014 Marcel Juenemann marcel@juenemann.cc
	 * Copyright (c) 2014-2016 Google Inc.
	 * https://github.com/marceljuenemann/angular-drag-and-drop-lists
	 *
	 * License: MIT
	 */
	angular.module('dndLists', [])
	
	  /**
	   * Use the dnd-draggable attribute to make your element draggable
	   *
	   * Attributes:
	   * - dnd-draggable      Required attribute. The value has to be an object that represents the data
	   *                      of the element. In case of a drag and drop operation the object will be
	   *                      serialized and unserialized on the receiving end.
	   * - dnd-selected       Callback that is invoked when the element was clicked but not dragged.
	   *                      The original click event will be provided in the local event variable.
	   * - dnd-effect-allowed Use this attribute to limit the operations that can be performed. Options:
	   *                      - "move": The drag operation will move the element. This is the default.
	   *                      - "copy": The drag operation will copy the element. Shows a copy cursor.
	   *                      - "copyMove": The user can choose between copy and move by pressing the
	   *                        ctrl or shift key. *Not supported in IE:* In Internet Explorer this
	   *                        option will be the same as "copy". *Not fully supported in Chrome on
	   *                        Windows:* In the Windows version of Chrome the cursor will always be the
	   *                        move cursor. However, when the user drops an element and has the ctrl
	   *                        key pressed, we will perform a copy anyways.
	   *                      - HTML5 also specifies the "link" option, but this library does not
	   *                        actively support it yet, so use it at your own risk.
	   * - dnd-moved          Callback that is invoked when the element was moved. Usually you will
	   *                      remove your element from the original list in this callback, since the
	   *                      directive is not doing that for you automatically. The original dragend
	   *                      event will be provided in the local event variable.
	   * - dnd-canceled       Callback that is invoked if the element was dragged, but the operation was
	   *                      canceled and the element was not dropped. The original dragend event will
	   *                      be provided in the local event variable.
	   * - dnd-copied         Same as dnd-moved, just that it is called when the element was copied
	   *                      instead of moved. The original dragend event will be provided in the local
	   *                      event variable.
	   * - dnd-dragstart      Callback that is invoked when the element was dragged. The original
	   *                      dragstart event will be provided in the local event variable.
	   * - dnd-dragend        Callback that is invoked when the drag operation ended. Available local
	   *                      variables are event and dropEffect.
	   * - dnd-type           Use this attribute if you have different kinds of items in your
	   *                      application and you want to limit which items can be dropped into which
	   *                      lists. Combine with dnd-allowed-types on the dnd-list(s). This attribute
	   *                      should evaluate to a string, although this restriction is not enforced.
	   * - dnd-disable-if     You can use this attribute to dynamically disable the draggability of the
	   *                      element. This is useful if you have certain list items that you don't want
	   *                      to be draggable, or if you want to disable drag & drop completely without
	   *                      having two different code branches (e.g. only allow for admins).
	   *                      **Note**: If your element is not draggable, the user is probably able to
	   *                      select text or images inside of it. Since a selection is always draggable,
	   *                      this breaks your UI. You most likely want to disable user selection via
	   *                      CSS (see user-select).
	   *
	   * CSS classes:
	   * - dndDragging        This class will be added to the element while the element is being
	   *                      dragged. It will affect both the element you see while dragging and the
	   *                      source element that stays at it's position. Do not try to hide the source
	   *                      element with this class, because that will abort the drag operation.
	   * - dndDraggingSource  This class will be added to the element after the drag operation was
	   *                      started, meaning it only affects the original element that is still at
	   *                      it's source position, and not the "element" that the user is dragging with
	   *                      his mouse pointer.
	   */
	  .directive('dndDraggable', ['$parse', '$timeout', 'dndDropEffectWorkaround', 'dndDragTypeWorkaround',
	                      function($parse,   $timeout,   dndDropEffectWorkaround,   dndDragTypeWorkaround) {
	    return function(scope, element, attr) {
	      // Set the HTML5 draggable attribute on the element
	      element.attr("draggable", "true");
	
	      // If the dnd-disable-if attribute is set, we have to watch that
	      if (attr.dndDisableIf) {
	        scope.$watch(attr.dndDisableIf, function(disabled) {
	          element.attr("draggable", !disabled);
	        });
	      }
	
	      /**
	       * When the drag operation is started we have to prepare the dataTransfer object,
	       * which is the primary way we communicate with the target element
	       */
	      element.on('dragstart', function(event) {
	        event = event.originalEvent || event;
	
	        // Check whether the element is draggable, since dragstart might be triggered on a child.
	        if (element.attr('draggable') == 'false') return true;
	
	        // Serialize the data associated with this element. IE only supports the Text drag type
	        event.dataTransfer.setData("Text", angular.toJson(scope.$eval(attr.dndDraggable)));
	
	        // Only allow actions specified in dnd-effect-allowed attribute
	        event.dataTransfer.effectAllowed = attr.dndEffectAllowed || "move";
	
	        // Add CSS classes. See documentation above
	        element.addClass("dndDragging");
	        $timeout(function() { element.addClass("dndDraggingSource"); }, 0);
	
	        // Workarounds for stupid browsers, see description below
	        dndDropEffectWorkaround.dropEffect = "none";
	        dndDragTypeWorkaround.isDragging = true;
	
	        // Save type of item in global state. Usually, this would go into the dataTransfer
	        // typename, but we have to use "Text" there to support IE
	        dndDragTypeWorkaround.dragType = attr.dndType ? scope.$eval(attr.dndType) : undefined;
	
	        // Try setting a proper drag image if triggered on a dnd-handle (won't work in IE).
	        if (event._dndHandle && event.dataTransfer.setDragImage) {
	          event.dataTransfer.setDragImage(element[0], 0, 0);
	        }
	
	        // Invoke callback
	        $parse(attr.dndDragstart)(scope, {event: event});
	
	        event.stopPropagation();
	      });
	
	      /**
	       * The dragend event is triggered when the element was dropped or when the drag
	       * operation was aborted (e.g. hit escape button). Depending on the executed action
	       * we will invoke the callbacks specified with the dnd-moved or dnd-copied attribute.
	       */
	      element.on('dragend', function(event) {
	        event = event.originalEvent || event;
	
	        // Invoke callbacks. Usually we would use event.dataTransfer.dropEffect to determine
	        // the used effect, but Chrome has not implemented that field correctly. On Windows
	        // it always sets it to 'none', while Chrome on Linux sometimes sets it to something
	        // else when it's supposed to send 'none' (drag operation aborted).
	        var dropEffect = dndDropEffectWorkaround.dropEffect;
	        scope.$apply(function() {
	          switch (dropEffect) {
	            case "move":
	              $parse(attr.dndMoved)(scope, {event: event});
	              break;
	            case "copy":
	              $parse(attr.dndCopied)(scope, {event: event});
	              break;
	            case "none":
	              $parse(attr.dndCanceled)(scope, {event: event});
	              break;
	          }
	          $parse(attr.dndDragend)(scope, {event: event, dropEffect: dropEffect});
	        });
	
	        // Clean up
	        element.removeClass("dndDragging");
	        $timeout(function() { element.removeClass("dndDraggingSource"); }, 0);
	        dndDragTypeWorkaround.isDragging = false;
	        event.stopPropagation();
	      });
	
	      /**
	       * When the element is clicked we invoke the callback function
	       * specified with the dnd-selected attribute.
	       */
	      element.on('click', function(event) {
	        if (!attr.dndSelected) return;
	
	        event = event.originalEvent || event;
	        scope.$apply(function() {
	          $parse(attr.dndSelected)(scope, {event: event});
	        });
	
	        // Prevent triggering dndSelected in parent elements.
	        event.stopPropagation();
	      });
	
	      /**
	       * Workaround to make element draggable in IE9
	       */
	      element.on('selectstart', function() {
	        if (this.dragDrop) this.dragDrop();
	      });
	    };
	  }])
	
	  /**
	   * Use the dnd-list attribute to make your list element a dropzone. Usually you will add a single
	   * li element as child with the ng-repeat directive. If you don't do that, we will not be able to
	   * position the dropped element correctly. If you want your list to be sortable, also add the
	   * dnd-draggable directive to your li element(s). Both the dnd-list and it's direct children must
	   * have position: relative CSS style, otherwise the positioning algorithm will not be able to
	   * determine the correct placeholder position in all browsers.
	   *
	   * Attributes:
	   * - dnd-list             Required attribute. The value has to be the array in which the data of
	   *                        the dropped element should be inserted.
	   * - dnd-allowed-types    Optional array of allowed item types. When used, only items that had a
	   *                        matching dnd-type attribute will be dropable.
	   * - dnd-disable-if       Optional boolean expresssion. When it evaluates to true, no dropping
	   *                        into the list is possible. Note that this also disables rearranging
	   *                        items inside the list.
	   * - dnd-horizontal-list  Optional boolean expresssion. When it evaluates to true, the positioning
	   *                        algorithm will use the left and right halfs of the list items instead of
	   *                        the upper and lower halfs.
	   * - dnd-dragover         Optional expression that is invoked when an element is dragged over the
	   *                        list. If the expression is set, but does not return true, the element is
	   *                        not allowed to be dropped. The following variables will be available:
	   *                        - event: The original dragover event sent by the browser.
	   *                        - index: The position in the list at which the element would be dropped.
	   *                        - type: The dnd-type set on the dnd-draggable, or undefined if unset.
	   *                        - external: Whether the element was dragged from an external source.
	   * - dnd-drop             Optional expression that is invoked when an element is dropped on the
	   *                        list. The following variables will be available:
	   *                        - event: The original drop event sent by the browser.
	   *                        - index: The position in the list at which the element would be dropped.
	   *                        - item: The transferred object.
	   *                        - type: The dnd-type set on the dnd-draggable, or undefined if unset.
	   *                        - external: Whether the element was dragged from an external source.
	   *                        The return value determines the further handling of the drop:
	   *                        - false: The drop will be canceled and the element won't be inserted.
	   *                        - true: Signalises that the drop is allowed, but the dnd-drop
	   *                          callback already took care of inserting the element.
	   *                        - otherwise: All other return values will be treated as the object to
	   *                          insert into the array. In most cases you want to simply return the
	   *                          item parameter, but there are no restrictions on what you can return.
	   * - dnd-inserted         Optional expression that is invoked after a drop if the element was
	   *                        actually inserted into the list. The same local variables as for
	   *                        dnd-drop will be available. Note that for reorderings inside the same
	   *                        list the old element will still be in the list due to the fact that
	   *                        dnd-moved was not called yet.
	   * - dnd-external-sources Optional boolean expression. When it evaluates to true, the list accepts
	   *                        drops from sources outside of the current browser tab. This allows to
	   *                        drag and drop accross different browser tabs. Note that this will allow
	   *                        to drop arbitrary text into the list, thus it is highly recommended to
	   *                        implement the dnd-drop callback to check the incoming element for
	   *                        sanity. Furthermore, the dnd-type of external sources can not be
	   *                        determined, therefore do not rely on restrictions of dnd-allowed-type.
	   *
	   * CSS classes:
	   * - dndPlaceholder       When an element is dragged over the list, a new placeholder child
	   *                        element will be added. This element is of type li and has the class
	   *                        dndPlaceholder set. Alternatively, you can define your own placeholder
	   *                        by creating a child element with dndPlaceholder class.
	   * - dndDragover          Will be added to the list while an element is dragged over the list.
	   */
	  .directive('dndList', ['$parse', '$timeout', 'dndDropEffectWorkaround', 'dndDragTypeWorkaround',
	                 function($parse,   $timeout,   dndDropEffectWorkaround,   dndDragTypeWorkaround) {
	    return function(scope, element, attr) {
	      // While an element is dragged over the list, this placeholder element is inserted
	      // at the location where the element would be inserted after dropping
	      var placeholder = getPlaceholderElement();
	      var placeholderNode = placeholder[0];
	      var listNode = element[0];
	      placeholder.remove();
	
	      var horizontal = attr.dndHorizontalList && scope.$eval(attr.dndHorizontalList);
	      var externalSources = attr.dndExternalSources && scope.$eval(attr.dndExternalSources);
	
	      /**
	       * The dragenter event is fired when a dragged element or text selection enters a valid drop
	       * target. According to the spec, we either need to have a dropzone attribute or listen on
	       * dragenter events and call preventDefault(). It should be noted though that no browser seems
	       * to enforce this behaviour.
	       */
	      element.on('dragenter', function (event) {
	        event = event.originalEvent || event;
	        if (!isDropAllowed(event)) return true;
	        event.preventDefault();
	      });
	
	      /**
	       * The dragover event is triggered "every few hundred milliseconds" while an element
	       * is being dragged over our list, or over an child element.
	       */
	      element.on('dragover', function(event) {
	        event = event.originalEvent || event;
	
	        if (!isDropAllowed(event)) return true;
	
	        // First of all, make sure that the placeholder is shown
	        // This is especially important if the list is empty
	        if (placeholderNode.parentNode != listNode) {
	          element.append(placeholder);
	        }
	
	        if (event.target !== listNode) {
	          // Try to find the node direct directly below the list node.
	          var listItemNode = event.target;
	          while (listItemNode.parentNode !== listNode && listItemNode.parentNode) {
	            listItemNode = listItemNode.parentNode;
	          }
	
	          if (listItemNode.parentNode === listNode && listItemNode !== placeholderNode) {
	            // If the mouse pointer is in the upper half of the child element,
	            // we place it before the child element, otherwise below it.
	            if (isMouseInFirstHalf(event, listItemNode)) {
	              listNode.insertBefore(placeholderNode, listItemNode);
	            } else {
	              listNode.insertBefore(placeholderNode, listItemNode.nextSibling);
	            }
	          }
	        } else {
	          // This branch is reached when we are dragging directly over the list element.
	          // Usually we wouldn't need to do anything here, but the IE does not fire it's
	          // events for the child element, only for the list directly. Therefore, we repeat
	          // the positioning algorithm for IE here.
	          if (isMouseInFirstHalf(event, placeholderNode, true)) {
	            // Check if we should move the placeholder element one spot towards the top.
	            // Note that display none elements will have offsetTop and offsetHeight set to
	            // zero, therefore we need a special check for them.
	            while (placeholderNode.previousElementSibling
	                 && (isMouseInFirstHalf(event, placeholderNode.previousElementSibling, true)
	                 || placeholderNode.previousElementSibling.offsetHeight === 0)) {
	              listNode.insertBefore(placeholderNode, placeholderNode.previousElementSibling);
	            }
	          } else {
	            // Check if we should move the placeholder element one spot towards the bottom
	            while (placeholderNode.nextElementSibling &&
	                 !isMouseInFirstHalf(event, placeholderNode.nextElementSibling, true)) {
	              listNode.insertBefore(placeholderNode,
	                  placeholderNode.nextElementSibling.nextElementSibling);
	            }
	          }
	        }
	
	        // At this point we invoke the callback, which still can disallow the drop.
	        // We can't do this earlier because we want to pass the index of the placeholder.
	        if (attr.dndDragover && !invokeCallback(attr.dndDragover, event, getPlaceholderIndex())) {
	          return stopDragover();
	        }
	
	        element.addClass("dndDragover");
	        event.preventDefault();
	        event.stopPropagation();
	        return false;
	      });
	
	      /**
	       * When the element is dropped, we use the position of the placeholder element as the
	       * position where we insert the transferred data. This assumes that the list has exactly
	       * one child element per array element.
	       */
	      element.on('drop', function(event) {
	        event = event.originalEvent || event;
	
	        if (!isDropAllowed(event)) return true;
	
	        // The default behavior in Firefox is to interpret the dropped element as URL and
	        // forward to it. We want to prevent that even if our drop is aborted.
	        event.preventDefault();
	
	        // Unserialize the data that was serialized in dragstart. According to the HTML5 specs,
	        // the "Text" drag type will be converted to text/plain, but IE does not do that.
	        var data = event.dataTransfer.getData("Text") || event.dataTransfer.getData("text/plain");
	        var transferredObject;
	        try {
	          transferredObject = JSON.parse(data);
	        } catch(e) {
	          return stopDragover();
	        }
	
	        // Invoke the callback, which can transform the transferredObject and even abort the drop.
	        var index = getPlaceholderIndex();
	        if (attr.dndDrop) {
	          transferredObject = invokeCallback(attr.dndDrop, event, index, transferredObject);
	          if (!transferredObject) {
	            return stopDragover();
	          }
	        }
	
	        // Insert the object into the array, unless dnd-drop took care of that (returned true).
	        if (transferredObject !== true) {
	          scope.$apply(function() {
	            scope.$eval(attr.dndList).splice(index, 0, transferredObject);
	          });
	        }
	        invokeCallback(attr.dndInserted, event, index, transferredObject);
	
	        // In Chrome on Windows the dropEffect will always be none...
	        // We have to determine the actual effect manually from the allowed effects
	        if (event.dataTransfer.dropEffect === "none") {
	          if (event.dataTransfer.effectAllowed === "copy" ||
	              event.dataTransfer.effectAllowed === "move") {
	            dndDropEffectWorkaround.dropEffect = event.dataTransfer.effectAllowed;
	          } else {
	            dndDropEffectWorkaround.dropEffect = event.ctrlKey ? "copy" : "move";
	          }
	        } else {
	          dndDropEffectWorkaround.dropEffect = event.dataTransfer.dropEffect;
	        }
	
	        // Clean up
	        stopDragover();
	        event.stopPropagation();
	        return false;
	      });
	
	      /**
	       * We have to remove the placeholder when the element is no longer dragged over our list. The
	       * problem is that the dragleave event is not only fired when the element leaves our list,
	       * but also when it leaves a child element -- so practically it's fired all the time. As a
	       * workaround we wait a few milliseconds and then check if the dndDragover class was added
	       * again. If it is there, dragover must have been called in the meantime, i.e. the element
	       * is still dragging over the list. If you know a better way of doing this, please tell me!
	       */
	      element.on('dragleave', function(event) {
	        event = event.originalEvent || event;
	
	        element.removeClass("dndDragover");
	        $timeout(function() {
	          if (!element.hasClass("dndDragover")) {
	            placeholder.remove();
	          }
	        }, 100);
	      });
	
	      /**
	       * Checks whether the mouse pointer is in the first half of the given target element.
	       *
	       * In Chrome we can just use offsetY, but in Firefox we have to use layerY, which only
	       * works if the child element has position relative. In IE the events are only triggered
	       * on the listNode instead of the listNodeItem, therefore the mouse positions are
	       * relative to the parent element of targetNode.
	       */
	      function isMouseInFirstHalf(event, targetNode, relativeToParent) {
	        var mousePointer = horizontal ? (event.offsetX || event.layerX)
	                                      : (event.offsetY || event.layerY);
	        var targetSize = horizontal ? targetNode.offsetWidth : targetNode.offsetHeight;
	        var targetPosition = horizontal ? targetNode.offsetLeft : targetNode.offsetTop;
	        targetPosition = relativeToParent ? targetPosition : 0;
	        return mousePointer < targetPosition + targetSize / 2;
	      }
	
	      /**
	       * Tries to find a child element that has the dndPlaceholder class set. If none was found, a
	       * new li element is created.
	       */
	      function getPlaceholderElement() {
	        var placeholder;
	        angular.forEach(element.children(), function(childNode) {
	          var child = angular.element(childNode);
	          if (child.hasClass('dndPlaceholder')) {
	            placeholder = child;
	          }
	        });
	        return placeholder || angular.element("<li class='dndPlaceholder'></li>");
	      }
	
	      /**
	       * We use the position of the placeholder node to determine at which position of the array the
	       * object needs to be inserted
	       */
	      function getPlaceholderIndex() {
	        return Array.prototype.indexOf.call(listNode.children, placeholderNode);
	      }
	
	      /**
	       * Checks various conditions that must be fulfilled for a drop to be allowed
	       */
	      function isDropAllowed(event) {
	        // Disallow drop from external source unless it's allowed explicitly.
	        if (!dndDragTypeWorkaround.isDragging && !externalSources) return false;
	
	        // Check mimetype. Usually we would use a custom drag type instead of Text, but IE doesn't
	        // support that.
	        if (!hasTextMimetype(event.dataTransfer.types)) return false;
	
	        // Now check the dnd-allowed-types against the type of the incoming element. For drops from
	        // external sources we don't know the type, so it will need to be checked via dnd-drop.
	        if (attr.dndAllowedTypes && dndDragTypeWorkaround.isDragging) {
	          var allowed = scope.$eval(attr.dndAllowedTypes);
	          if (angular.isArray(allowed) && allowed.indexOf(dndDragTypeWorkaround.dragType) === -1) {
	            return false;
	          }
	        }
	
	        // Check whether droping is disabled completely
	        if (attr.dndDisableIf && scope.$eval(attr.dndDisableIf)) return false;
	
	        return true;
	      }
	
	      /**
	       * Small helper function that cleans up if we aborted a drop.
	       */
	      function stopDragover() {
	        placeholder.remove();
	        element.removeClass("dndDragover");
	        return true;
	      }
	
	      /**
	       * Invokes a callback with some interesting parameters and returns the callbacks return value.
	       */
	      function invokeCallback(expression, event, index, item) {
	        return $parse(expression)(scope, {
	          event: event,
	          index: index,
	          item: item || undefined,
	          external: !dndDragTypeWorkaround.isDragging,
	          type: dndDragTypeWorkaround.isDragging ? dndDragTypeWorkaround.dragType : undefined
	        });
	      }
	
	      /**
	       * Check if the dataTransfer object contains a drag type that we can handle. In old versions
	       * of IE the types collection will not even be there, so we just assume a drop is possible.
	       */
	      function hasTextMimetype(types) {
	        if (!types) return true;
	        for (var i = 0; i < types.length; i++) {
	          if (types[i] === "Text" || types[i] === "text/plain") return true;
	        }
	
	        return false;
	      }
	    };
	  }])
	
	  /**
	   * Use the dnd-nodrag attribute inside of dnd-draggable elements to prevent them from starting
	   * drag operations. This is especially useful if you want to use input elements inside of
	   * dnd-draggable elements or create specific handle elements. Note: This directive does not work
	   * in Internet Explorer 9.
	   */
	  .directive('dndNodrag', function() {
	    return function(scope, element, attr) {
	      // Set as draggable so that we can cancel the events explicitly
	      element.attr("draggable", "true");
	
	      /**
	       * Since the element is draggable, the browser's default operation is to drag it on dragstart.
	       * We will prevent that and also stop the event from bubbling up.
	       */
	      element.on('dragstart', function(event) {
	        event = event.originalEvent || event;
	
	        if (!event._dndHandle) {
	          // If a child element already reacted to dragstart and set a dataTransfer object, we will
	          // allow that. For example, this is the case for user selections inside of input elements.
	          if (!(event.dataTransfer.types && event.dataTransfer.types.length)) {
	            event.preventDefault();
	          }
	          event.stopPropagation();
	        }
	      });
	
	      /**
	       * Stop propagation of dragend events, otherwise dnd-moved might be triggered and the element
	       * would be removed.
	       */
	      element.on('dragend', function(event) {
	        event = event.originalEvent || event;
	        if (!event._dndHandle) {
	          event.stopPropagation();
	        }
	      });
	    };
	  })
	
	  /**
	   * Use the dnd-handle directive within a dnd-nodrag element in order to allow dragging with that
	   * element after all. Therefore, by combining dnd-nodrag and dnd-handle you can allow
	   * dnd-draggable elements to only be dragged via specific "handle" elements. Note that Internet
	   * Explorer will show the handle element as drag image instead of the dnd-draggable element. You
	   * can work around this by styling the handle element differently when it is being dragged. Use
	   * the CSS selector .dndDragging:not(.dndDraggingSource) [dnd-handle] for that.
	   */
	  .directive('dndHandle', function() {
	    return function(scope, element, attr) {
	      element.attr("draggable", "true");
	
	      element.on('dragstart dragend', function(event) {
	        event = event.originalEvent || event;
	        event._dndHandle = true;
	      });
	    };
	  })
	
	  /**
	   * This workaround handles the fact that Internet Explorer does not support drag types other than
	   * "Text" and "URL". That means we can not know whether the data comes from one of our elements or
	   * is just some other data like a text selection. As a workaround we save the isDragging flag in
	   * here. When a dropover event occurs, we only allow the drop if we are already dragging, because
	   * that means the element is ours.
	   */
	  .factory('dndDragTypeWorkaround', function(){ return {} })
	
	  /**
	   * Chrome on Windows does not set the dropEffect field, which we need in dragend to determine
	   * whether a drag operation was successful. Therefore we have to maintain it in this global
	   * variable. The bug report for that has been open for years:
	   * https://code.google.com/p/chromium/issues/detail?id=39399
	   */
	  .factory('dndDropEffectWorkaround', function(){ return {} });


/***/ }),
/* 328 */
/***/ (function(module, exports) {

	'use strict';
	default_1.$inject = ['$stateProvider'];
	function default_1($stateProvider) {
	    'ngInject';
	    $stateProvider
	        .state('create', {
	        url: '/create',
	        template: '<create></create>',
	        params: {
	            params: null
	        },
	    });
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var angular = __webpack_require__(1);
	var uiRouter = __webpack_require__(5);
	var html_source_routes_1 = __webpack_require__(330);
	var ace = window['ace']; // Global instance of ACE
	var HtmlSourceComponent = (function () {
	    /*@ngInject*/
	    HtmlSourceComponent.$inject = ['localStorage'];
	    function HtmlSourceComponent(localStorage) {
	        this.store = localStorage;
	        this.radioModel = 'HTML';
	        this.formhtml = this.store.get('formhtml');
	    }
	    /* ACE editor on loaded callback */
	    HtmlSourceComponent.prototype.aceLoaded = function (_editor) {
	        // Editor part
	        var _session = _editor.getSession();
	        var _renderer = _editor.renderer;
	        // Setting theme
	        _editor.setTheme('ace/theme/xcode');
	        // Options
	        _editor.setReadOnly(false);
	        _session.setUndoManager(new ace.UndoManager());
	        _renderer.setShowGutter(true);
	        // Events
	        _editor.on('changeSession', function () { });
	        _session.on('change', function () { });
	    };
	    return HtmlSourceComponent;
	}());
	exports.HtmlSourceComponent = HtmlSourceComponent;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('nodeApp.create.html-source', [uiRouter])
	    .config(html_source_routes_1.default)
	    .component('htmlSource', {
	    template: __webpack_require__(331),
	    controller: HtmlSourceComponent,
	    controllerAs: 'htmlSourceCtrl'
	})
	    .name;


/***/ }),
/* 330 */
/***/ (function(module, exports) {

	'use strict';
	default_1.$inject = ['$stateProvider'];
	function default_1($stateProvider) {
	    'ngInject';
	    $stateProvider
	        .state('html-source', {
	        url: '/create/html',
	        template: '<html-source></html-source>'
	    });
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = default_1;


/***/ }),
/* 331 */
/***/ (function(module, exports) {

	module.exports = "<toolbar active=\"HTML\"></toolbar>\n\n<div class=\"container-fluid\">\n    <div class=\"row\">\n        <div class=\"col-xs-6 col-md-offset-3\">\n        \t<br>\n       \t\t<div ui-ace=\"{\n       \t\t\tonLoad : htmlSourceCtrl.aceLoaded,\n       \t\t\tworkerPath: '/assets/scripts/',\n       \t\t\tmode: 'html'\n       \t\t}\" ng-model=\"htmlSourceCtrl.formhtml\"></div>\n        </div>\n    </div>\n</div>\n\n"

/***/ }),
/* 332 */
/***/ (function(module, exports) {

	module.exports = "<script type=\"text/ng-template\" id=\"Label.html\">\n    <div>\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\"></i>\n        <p style=\"word-wrap: break-word; word-break: break-word;\" ng-style=\"{'font-size': item.properties.Size.Size.selectedValue, 'text-align': item.properties.Size.Alignment.selectedValue}\">{{item.properties.Basic.Text.selectedValue}}</p>\n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"Display field.html\">\n    <div class=\"form-group display-field\">\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\"></i>\n        <label ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'Style')\">{{item.properties.Basic.Label.selectedValue}}</label>\n        <div class=\"display-text\">\n            <p class=\"description\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\">{{item.properties.Basic.Value.selectedValue}}</p>\n        </div>\n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"Hyperlink.html\">\n    <div class=\"form-group\">\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\"></i>\n        <i class=\"fa fa-info-circle script-event-info pull-right\" ng-class=\"{'selected-control-event-info' : item.selected}\" ng-if=\"createCtrl.hasScriptLogic(item.properties.Events)\" title=\"{{ 'field-have-some-validations' | translate }}\"></i>\n        <label ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'Style')\">{{item.properties.Basic.Label.selectedValue}}</label>\n        <a href=\"javascript:void(0)\" class=\"hyperlink-ctrl\" target=\"_blank\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\" ng-click=\"$event.preventDefault();createCtrl.linkModelFunc($event,item.properties.Basic.Value.selectedValue)\">{{item.properties.Basic.DisplayLabel.selectedValue}}</a>\n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"Textbox.html\">\n    <div class=\"form-group input-container\" ng-class=\"{'hasValue':  ((createCtrl.selectedTheme!= createCtrl.designStyle.STANDARD && createCtrl.isNotEmpty(item)) || item.properties.Display['Place Holder'].selectedValue)}\"\n        ng-init=\"item.properties.Basic.Value.selectedValue = (createCtrl.selectedTheme != createCtrl.designStyle.STANDARD && item.properties.Basic.Value.selectedValue == null)? '' : item.properties.Basic.Value.selectedValue\">\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\"></i>\n        <label ng-if=\"item.properties.Basic.Label.selectedValue\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'Style')\" >{{item.properties.Basic.Label.selectedValue}}<i ng-if=\"item.properties.Basic.Required.selectedValue\" class=\"red\">*</i><i class=\"fa fa-info-circle script-event-info pull-right\" ng-class=\"{'selected-control-event-info' : item.selected}\" ng-if=\"createCtrl.hasScriptLogic(item.properties.Events)\" title=\"{{ 'field-have-some-validations' | translate }}\"></i></label>\n        <span ng-if=\"item.properties.Display.HasMic.selectedValue\" class=\"hasMic\" ng-style=\"createCtrl.selectedTheme === 1 && {'margin-top': '14px'}\">\n            <svg style=\"height:18px;\" xmlns=\"http://www.w3.org/2000/svg\" height=\"1em\" viewBox=\"0 0 384 512\"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><style>svg{fill:#808080}</style><path d=\"M192 0C139 0 96 43 96 96V256c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V216z\"/></svg>\n\t\t</span>\n        <textarea type=\"textarea\" class=\"form-control {{item.properties.Size.Size.selectedValue}}\" id=\"wrap-textarea\"\n            textarea-id=\"{{item.uid}}\"\n            name=\"{{item.properties.Basic['Field Name'].selectedValue}}\"\n            contenteditable=\"true\"\n            ng-if=\"!item.properties.Basic.DigitSeparator.selectedValue\" \n            ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\" \n            ng-attr-placeholder=\"{{item.properties.Display['Place Holder'].selectedValue}}\"\n            ng-model=\"item.properties.Basic.Value.selectedValue\" \n            ng-init=\"createCtrl.setWrapTextarea(item)\"\n            title=\"{{item.properties.Advance.Tooltip.errorMessage || item.properties.Advance.Tooltip.selectedValue}}\"\n            ng-change=\"createCtrl.setWrapText(item,event);createCtrl.setErrorMessage(item.properties.Basic,item.properties.Advance); createCtrl.onChangeModelValue(item.uid, item.properties.Basic.ControlType, item.properties.Basic['Data Field Name'].selectedValue, item.properties.Basic.Value.selectedValue);\" \n            maxlength=\"{{item.properties.Display['Char-Limit'].selectedValue}}\" \n            ng-focus=\"event=$event\"\n            rows=\"1\"\n            ng-disabled=\"item.properties.Display['Read-only'].selectedValue\" \n            ng-pattern=\"createCtrl.validatorRegEx[item.properties.Basic.Validate.selectedValue]\"></textarea>\n\n        <input type=\"text\" class=\"form-control {{item.properties.Size.Size.selectedValue}}\"\n            name=\"{{item.properties.Basic['Field Name'].selectedValue}}\"\n            contenteditable=\"true\"\n            ng-if=\"item.properties.Basic.DigitSeparator.selectedValue\" \n            ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\" \n            ng-attr-placeholder=\"{{item.properties.Display['Place Holder'].selectedValue}}\"\n            ng-model=\"item.properties.Basic.Value.selectedValue\" \n            title=\"{{item.properties.Advance.Tooltip.errorMessage || item.properties.Advance.Tooltip.selectedValue}}\"\n            ng-change=\"createCtrl.setErrorMessage(item.properties.Basic, item.properties.Advance); createCtrl.onChangeModelValue(item.uid, item.properties.Basic.ControlType, item.properties.Basic['Data Field Name'].selectedValue, item.properties.Basic.Value.selectedValue);\" \n            maxlength=\"{{item.properties.Display['Char-Limit'].selectedValue}}\" \n            ng-disabled=\"item.properties.Display['Read-only'].selectedValue\" \n            awnum \n            num-thousand=true \n            num-int=\"{{item.properties.Display['Char-Limit'].selectedValue}}\"\n            num-fract=\"{{item.properties.Basic.DecimalPlaces.selectedValue}}\" \n            num-fixed=\"{{item.properties.Basic.Validate.selectedValue == 'Decimal' && item.properties.Basic.DecimalPlaces.selectedValue != 0}}\"\n            num-sep=\"{{item.properties.Basic.DecimalThousandSeparator.selectedValue.Default.decimal}}\"\n            num-thousand-sep=\"{{item.properties.Basic.DecimalThousandSeparator.selectedValue.Default.thousand}}\">\n\n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"Map.html\">\n    <div class=\"form-group map-container\" ng-class=\"{hasscript: createCtrl.hasScriptLogic(item.properties.Events)}\">\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\"></i>\n        <label ng-if=\"item.properties.Basic.Label.selectedValue\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'Style')\">{{item.properties.Basic.Label.selectedValue}}<i ng-if=\"item.properties.Basic.Required.selectedValue\" class=\"red\">*</i><i class=\"fa fa-info-circle script-event-info pull-right\" ng-class=\"{'selected-control-event-info' : item.selected}\" ng-if=\"createCtrl.hasScriptLogic(item.properties.Events)\" title=\"{{ 'field-have-some-validations' | translate }}\"></i></label>\n        <div class=\"input-group\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\">\n            <div class=\"input-group-addon\">{{ item.properties.Basic.Type.selectedValue == '36' ? 'OS-Grid-Ref.:' : 'Coordinates:' | translate}}</div>\n            <input type=\"text\" class=\"form-control\" readonly title=\"{{item.properties.Basic.Default.selectedValue}}\" ng-model=\"item.properties.Basic.Default.selectedValue\" ng-click=\"!item.properties.Display['Read-only'].selectedValue && createCtrl.openMap(item.properties.Basic)\" ng-disabled=\"item.properties.Display['Read-only'].selectedValue\">\n            <div class=\"input-group-addon btn btn-danger\" ng-click=\"!item.properties.Display['Read-only'].selectedValue && createCtrl.openMap(item.properties.Basic, item.uid)\"><i class=\"fa fa-map-marker\" style=\"color: white\"></i></div>\n        </div>\n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"Button.html\">\n    <div class=\"form-group\">\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\" ></i>\n        <button class=\"btn btn-danger\" ng-class=\"{readonly : item.properties.Display['Read-only'].selectedValue}\" ng-style=\"createCtrl.getButtonStyle(item.properties, 'Style')\" style=\"padding:5px;\" title=\"{{item.properties.Advance.Tooltip.selectedValue}}\" >{{item.properties.Basic.Text.selectedValue}}</button>\n        <i class=\"fa fa-info-circle script-event-info pull-right\" ng-class=\"{'selected-control-event-info' : item.selected}\" ng-if=\"createCtrl.hasScriptLogic(item.properties.Events)\" title=\"{{ 'field-have-some-validations' | translate }}\"></i>\n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"SiteLocationButton.html\">\n    <div class=\"form-group\">\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\" ></i>\n        <button class=\"btn btn-danger\" ng-class=\"{readonly : item.properties.Display['Read-only'].selectedValue}\" ng-style=\"createCtrl.getButtonStyle(item.properties, 'Style')\" style=\"padding:5px;\" title=\"{{item.properties.Advance.Tooltip.selectedValue}}\" >{{item.properties.Basic.Text.selectedValue}}</button>\n        <i class=\"fa fa-info-circle script-event-info pull-right\" ng-class=\"{'selected-control-event-info' : item.selected}\" ng-if=\"createCtrl.hasScriptLogic(item.properties.Events)\" title=\"{{ 'field-have-some-validations' | translate }}\"></i>\n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"ToggleButton.html\">\n<div class=\"form-group\">\n    <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\"\n        ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\"></i>\n        <i class=\"fa fa-info-circle script-event-info pull-right\" ng-class=\"{'selected-control-event-info' : item.selected}\" ng-if=\"createCtrl.hasScriptLogic(item.properties.Events)\" title=\"{{ 'field-have-some-validations' | translate }}\"></i>\n    <label ng-if=\"item.properties.Basic.Label.selectedValue\"\n        ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'Style')\">{{item.properties.Basic.Label.selectedValue}}<i\n            ng-if=\"item.properties.Basic.Required.selectedValue\" class=\"red\">*</i></label>\n    <div class=\"toggle-label\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\" style=\"display:inline-grid;\">\n        {{item.properties.Basic.LabelOff.selectedValue}}</div>\n    <fieldset class=\"btn-switch\" style=\"display:inline-grid;\"\n        ng-style=\"{'background-color':item.properties.Basic.Value.selectedValue == true ? item.properties.SwitchToggleStyle['style-group'].members['background-color-on'].selectedValue : item.properties.SwitchToggleStyle['style-group'].members['background-color-off'].selectedValue,\n                    'width': item.properties.Size.Width.selectedValue,'height': item.properties.Size.Height.selectedValue,\n                    'border-color':item.properties.Basic.Value.selectedValue == true ? item.properties.SwitchToggleStyle['style-group'].members['background-color-on'].selectedValue : item.properties.SwitchToggleStyle['style-group'].members['background-color-off'].selectedValue}\"\n        ng-class=\"{'btn-switch--on':item.properties.Basic.Value.selectedValue, 'btn-switch--off':item.properties.Basic.Value.selectedValue != true}\"\n        title=\"{{ item.properties.Advance.Tooltip.selectedValue}}\"\n        ng-model=\"item.properties.Basic.Value.selectedValue\" ng-click=\"createCtrl.onToggle(item.properties);createCtrl.onChangeModelValue(item.uid, item.properties.Basic.ControlType, item.properties.Basic['Data Field Name'].selectedValue, item.properties.Basic.Value.selectedValue)\"\n        ng-disabled=\"item.properties.Display['Read-only'].selectedValue\">\n\n        <div class=\"btn-switch-circle\" ng-class=\"{'btn-switch-circle--on':item.properties.Basic.Value.selectedValue, 'btn-switch-circle--off': !item.properties.Basic.Value.selectedValue}\"\n            ng-style= \"createCtrl.getHeightWidthOfToggleSwitch(item)\"\n            ng-model=\"item.properties.Basic.Value.selectedValue\"></div>\n\n    </fieldset>\n    <div  class=\"toggle-label\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\" style=\"display:inline-grid;\">\n    {{item.properties.Basic.LabelOn.selectedValue}}</div>\n</div>\n</script>\n<script type=\"text/ng-template\" id=\"File-Input.html\">\n    <div class=\"form-group\">\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\"></i>\n        <label for=\"inptfile\">File input</label>\n        <input type=\"file\" name=\"inptfile\" id=\"inptfile\" ng-disabled=\"item.properties.Display['Read-only'].selectedValue\" />\n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"Text-Area.html\">\n    <div class=\"form-group input-container\" ng-class=\"{'hasValue': ((createCtrl.selectedTheme!= createCtrl.designStyle.STANDARD && createCtrl.isNotEmpty(item)) || item.properties.Display['Place Holder'].selectedValue)}\" \n        ng-init=\"item.properties.Basic.Value.selectedValue = (createCtrl.selectedTheme != createCtrl.designStyle.STANDARD && item.properties.Basic.Value.selectedValue == null)? '' : item.properties.Basic.Value.selectedValue\">\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\"></i>\n        <label ng-if=\"item.properties.Basic.Label.selectedValue\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'Style')\">{{item.properties.Basic.Label.selectedValue}}<i ng-if=\"item.properties.Basic.Required.selectedValue\" class=\"red\">*</i><i class=\"fa fa-info-circle script-event-info pull-right\" ng-class=\"{'selected-control-event-info' : item.selected}\" ng-if=\"createCtrl.hasScriptLogic(item.properties.Events)\" title=\"{{ 'field-have-some-validations' | translate }}\"></i></label>\n        <span ng-if=\"item.properties.Display.HasMic.selectedValue\" class=\"hasMic\" ng-style=\"createCtrl.selectedTheme === 1 && {'margin-top': '14px'}\">\n            <svg style=\"height:18px;\" xmlns=\"http://www.w3.org/2000/svg\" height=\"1em\" viewBox=\"0 0 384 512\"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><style>svg{fill:#808080}</style><path d=\"M192 0C139 0 96 43 96 96V256c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V216z\"/></svg>\n\t\t</span>\n        <textarea ng-if=\"!item.properties.Basic.DigitSeparator.selectedValue\"\n            textarea-id=\"{{item.uid}}\"\n            name=\"{{item.properties.Basic['Field Name'].selectedValue}}\"\n            contenteditable=\"true\"\n            rows=\"3\"\n            ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\"\n            ng-init=\"createCtrl.setWrapTextarea(item)\" \n            class=\"form-control\" ng-attr-placeholder=\"{{item.properties.Display['Place Holder'].selectedValue}}\"\n            ng-model=\"item.properties.Basic.Value.selectedValue\" \n            title=\"{{item.properties.Advance.Tooltip.errorMessage || item.properties.Advance.Tooltip.selectedValue}}\"\n            ng-change=\"createCtrl.setWrapText(item,event);createCtrl.setErrorMessage(item.properties.Basic, item.properties.Advance); createCtrl.onChangeModelValue(item.uid, item.properties.Basic.ControlType, item.properties.Basic['Data Field Name'].selectedValue, item.properties.Basic.Value.selectedValue);\"\n            ng-focus=\"event=$event\"\n            ng-disabled=\"item.properties.Display['Read-only'].selectedValue\" \n            ng-pattern=\"createCtrl.validatorRegEx[item.properties.Basic.Validate.selectedValue]\"></textarea>\n\n        <input type=\"text\" class=\"form-control {{item.properties.Size.Size.selectedValue}}\"\n            name=\"{{item.properties.Basic['Field Name'].selectedValue}}\"\n            contenteditable=\"true\"\n            ng-if=\"item.properties.Basic.DigitSeparator.selectedValue\" \n            ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\" \n            ng-attr-placeholder=\"{{item.properties.Display['Place Holder'].selectedValue}}\"\n            ng-model=\"item.properties.Basic.Value.selectedValue\" \n            title=\"{{item.properties.Advance.Tooltip.errorMessage || item.properties.Advance.Tooltip.selectedValue}}\"\n            ng-change=\"createCtrl.setErrorMessage(item.properties.Basic, item.properties.Advance); createCtrl.onChangeModelValue(item.uid, item.properties.Basic.ControlType, item.properties.Basic['Data Field Name'].selectedValue, item.properties.Basic.Value.selectedValue);\" \n            maxlength=\"200\" \n            ng-disabled=\"item.properties.Display['Read-only'].selectedValue\" \n            awnum \n            num-thousand=true \n            num-fixed=\"{{item.properties.Basic.Validate.selectedValue == 'Decimal' && item.properties.Basic.DecimalPlaces.selectedValue != 0}}\"\n            num-int=\"200\"\n            num-fract=\"{{item.properties.Basic.DecimalPlaces.selectedValue}}\"\n            num-sep=\"{{item.properties.Basic.DecimalThousandSeparator.selectedValue.Default.decimal}}\"\n            num-thousand-sep=\"{{item.properties.Basic.DecimalThousandSeparator.selectedValue.Default.thousand}}\">\n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"Rich-Text-Box.html\">\n    <div>\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\"></i>\n        <label ng-if=\"item.properties.Basic.Label.selectedValue\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'Style')\">{{item.properties.Basic.Label.selectedValue}}<i ng-if=\"item.properties.Basic.Required.selectedValue\" class=\"red\">*</i><i class=\"fa fa-info-circle script-event-info pull-right\" ng-class=\"{'selected-control-event-info' : item.selected}\" ng-if=\"createCtrl.hasScriptLogic(item.properties.Events)\" title=\"{{ 'field-have-some-validations' | translate }}\"></i></label>\n        <span ng-if=\"item.properties.Display.HasMic.selectedValue\" class=\"hasMic \" ng-style=\"createCtrl.getHeightRTextToolbar(item.properties.Basic['Field Name'].selectedValue)\">\n            <svg style=\"height:18px;\" xmlns=\"http://www.w3.org/2000/svg\" height=\"1em\" viewBox=\"0 0 384 512\"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><style>svg{fill:#808080}</style><path d=\"M192 0C139 0 96 43 96 96V256c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V216z\"/></svg>\n\t\t</span>\n        <div text-angular ng-model=\"item.properties.Basic.Value.selectedValue\" ta-keep-styles=\"true\" \n            ng-change=\"createCtrl.onChangeModelValue(item.uid, item.properties.Basic.ControlType, item.properties.Basic['Data Field Name'].selectedValue, item.properties.Basic.Value.selectedValue);\" \n            ta-disabled=\"item.properties.Display['Read-only'].selectedValue\" rta-field-name=\"{{item.properties.Basic['Field Name'].selectedValue}}\"></div>\n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"Dropdown.html\">\n    <div class=\"form-group dropdown-container\" ng-class=\"{'hasValue':  item.properties.Basic.Value.selectedValue.length > 0}\">\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\"></i>\n            <input ng-if=\"createCtrl.external\" title=\"Select / Deselect All\" type=\"checkbox\"  ng-click=\"createCtrl.selectAllDropdownOption($event,item.properties);\" ng-disabled=\"item.properties.Basic.FilterValue.isFilterValue == 2\"/>\n            <label ng-if=\"item.properties.Basic.Label.selectedValue\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'Style')\">{{item.properties.Basic.Label.selectedValue}}<i ng-if=\"item.properties.Basic.Required.selectedValue\" class=\"red\">*</i><i class=\"fa fa-info-circle script-event-info pull-right\" ng-class=\"{'selected-control-event-info' : item.selected}\" ng-if=\"createCtrl.hasScriptLogic(item.properties.Events)\" title=\"{{ 'field-have-some-validations' | translate }}\"></i></label>\n            <label ng-if=\"createCtrl.external\" class=\"roundSwitch\">{{ 'all-value' | translate }} <input type=\"checkbox\" ng-click=\"createCtrl.isDisableDropdown($event,item.properties);\" ng-checked=\"item.properties.Basic.FilterValue.isFilterValue == 2\"/><span></span></label>\n    \n        <div ng-if=\"createCtrl.config.for != 'Meta-Data'\" data-name=\"{{item.uid}}\" class=\"btn-group dropdown filter-dd\" uib-dropdown is-open=\"item.properties.Basic.isOpen\" dropdown-append-to-body auto-close=\"outsideClick\">\n            <button ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\" ng-disabled=\"item.properties.Display['Read-only'].selectedValue || createCtrl.external && item.properties.Basic.FilterValue.isFilterValue == 2\"\n            class=\"btn btn-default dropdown-toggle\" type=\"button\" uib-dropdown-toggle title=\"{{item.properties.Advance.Tooltip.selectedValue}}\" ng-click=\"createCtrl.onMultiDropdownToggle(item, $event)\">\n                <span ng-if=\"item.properties.Basic.Value.selectedValue.length > 0 && (createCtrl.selectedTheme == createCtrl.designStyle.STANDARD)\">\n                    <span ng-repeat=\"list in item.properties['Data Source'].table.list\">\n                        <span ng-repeat=\"selectedValue in item.properties.Basic.Value.selectedValue track by $index\">\n                            <span ng-if=\"selectedValue == list.Value.name\">{{list.Label.name}}<span ng-if=\"item.properties.Basic.Value.selectedValue.length > $index + 1\">,</span></span>                            \n                        </span>\n                    </span> \n                    <!-- {{ item.properties.Basic.Value.selectedValue.toString()}} -->\n                </span>\n\n                <div ng-if=\"item.properties.Basic.Value.selectedValue.length > 0 && (createCtrl.selectedTheme != createCtrl.designStyle.STANDARD)\">\n                    <div  ng-repeat=\"list in item.properties['Data Source'].table.list\">\n                        <div  class=\"chips\" ng-repeat=\"selectedValue in item.properties.Basic.Value.selectedValue track by $index\">\n                            <div class=\"chip\" ng-if=\"selectedValue == list.Value.name\">\n                                <div class=\"text\">{{list.Label.name}}</div>\n                                <div class=\"remove\"></div>\n                            </div>                            \n                        </div>\n                    </div> \n                    <!-- {{ item.properties.Basic.Value.selectedValue.toString()}} -->\n                </div>\n                <span ng-if=\"item.properties.Basic.Value.selectedValue.length == 0 && (createCtrl.selectedTheme == createCtrl.designStyle.STANDARD)\">Please Select</span>\n                <span class=\"caret innerDdMargin\"></span>\n            </button>\n            <div data-name=\"dd_{{item.uid}}\" class=\"dropdown-menu filter-dd-menu\" uib-dropdown-menu ng-style=\"createCtrl.getDropDownHeight(item)\">\n                <div>\n                    <div class=\"inpt-wrap clearfix\">\n                        <input type=\"text\" class=\"form-control\" ng-model=\"item.properties.Basic.searchText\" ng-keyup=\"createCtrl.updateDropdownPosition(item)\"/>\n                        <i class=\"icon-search fa\" ng-click=\"createCtrl.clearMultiDropdownSearch(item)\" ng-class=\"{'fa-search': !item.properties.Basic.searchText, 'fa-close': item.properties.Basic.searchText}\"></i>\n                    </div>\n                    <div class=\"link-wrap clearfix\">\n                        <a  style=\"cursor: pointer;\" ng-show=\"!item.properties.Basic.searchText\" class=\"pull-left\" ng-click=\"createCtrl.clearMultiDropdown(item);createCtrl.onChangeModelValue(item.uid, item.properties.Basic.ControlType, item.properties.Basic['Data Field Name'].selectedValue, item.properties.Basic.Value.selectedValue);\">{{ 'clear' | translate }}</a>\n                        <a style=\"cursor: pointer;\" ng-show=\"!item.properties.Basic.searchText\" class=\"pull-right\" ng-click=\"createCtrl.closeMultiDropdown(item)\">{{ 'close' | translate }}</a>\n                        <a style=\"margin-left:15%; cursor: pointer;\" ng-show=\"!item.properties.Basic.searchText && item.properties.Basic.isLimited\" ng-click=\"createCtrl.showAll(item)\">{{ 'show-all' | translate }}</a>\n                    </div>\n                    <ul class=\"opt-list {{item.properties.Size.Size.selectedValue}}\">\n                        <li  ng-if=\"item.properties.Basic.isLimited\" ng-repeat=\"list in item.properties['Data Source'].table.list | searchFilter:item.properties.Basic.searchText| limitTo: 10\"><a ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\" href=\"javascript:void(0)\" ng-class=\"{checked: list.isSelected}\" ng-click=\"createCtrl.setMultiDDSelection(item,list);createCtrl.setDropDownOption(item); createCtrl.onChangeModelValue(item.uid, item.properties.Basic.ControlType, item.properties.Basic['Data Field Name'].selectedValue, item.properties.Basic.Value.selectedValue);createCtrl.closeMultiDropdown(item, 'dropdownList');\" title=\"{{list.Label.name}}\"> <span>{{list.Label.name}}</span></a></li>\n                        <li ng-if=\"!item.properties.Basic.isLimited\" ng-repeat=\"list in item.properties['Data Source'].table.list | searchFilter:item.properties.Basic.searchText\"><a ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\" href=\"javascript:void(0)\" ng-class=\"{checked: list.isSelected}\" ng-click=\"createCtrl.setMultiDDSelection(item,list);createCtrl.setDropDownOption(item); createCtrl.onChangeModelValue(item.uid, item.properties.Basic.ControlType, item.properties.Basic['Data Field Name'].selectedValue, item.properties.Basic.Value.selectedValue);createCtrl.closeMultiDropdown(item, 'dropdownList');\" title=\"{{list.Label.name}}\"> <span>{{list.Label.name}}</span></a></li>\n                        <li ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\" class=\"dropdown-header text-center\" ng-if=\"!((item.properties['Data Source'].table.list).length)\">{{ 'no-match-found' | translate }}</li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n    </div>\n    <select ng-if=\"item.properties.Basic['Multi-Select'].selectedValue && createCtrl.config.for == 'Meta-Data'\"\n        class=\"form-control {{item.properties.Size.Size.selectedValue}}\"\n        multiple\n        ng-disabled=\"item.properties.Display['Read-only'].selectedValue || createCtrl.external && item.properties.Basic.FilterValue.isFilterValue == 2\"\n        title=\"{{item.properties.Advance.Tooltip.selectedValue}}\"\n        ng-model=\"item.properties.Basic.Value.selectedValue\"\n        ng-change=\"createCtrl.setDropDownOption(item); createCtrl.onChangeModelValue(item.uid, item.properties.Basic.ControlType, item.properties.Basic['Data Field Name'].selectedValue, item.properties.Basic.Value.selectedValue);\"\n        ng-style=\"createCtrl.getDropDownHeight(item)\"\n        ng-options=\"list.Value.name as list.Label.name for list in createCtrl.filterDropdownOption(item, item.properties['Data Source'].table.list)\" >\n    </select>\n    <select ng-if=\"!item.properties.Basic['Multi-Select'].selectedValue && createCtrl.config.for == 'Meta-Data'\"\n        class=\"form-control {{item.properties.Size.Size.selectedValue}}\"\n        title=\"{{item.properties.Advance.Tooltip.selectedValue}}\"\n        ng-click=\"createCtrl.stopPropagation($event)\"\n        ng-model=\"item.properties.Basic.Value.selectedValue\"\n        ng-change=\"createCtrl.setDropDownOption(item); createCtrl.onChangeModelValue(item.uid, item.properties.Basic.ControlType, item.properties.Basic['Data Field Name'].selectedValue, item.properties.Basic.Value.selectedValue);\"\n        ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\"\n        ng-disabled=\"item.properties.Display['Read-only'].selectedValue\" >\n        <option ng-repeat=\"list in item.properties['Data Source'].table.list\" ng-value=\"list.Value.name\" ng-hide=\"createCtrl.filterElementOption(item,list)\">{{list.Label.name}}</option>\n    </select>\n\n</script>\n\n<script type=\"text/ng-template\" id=\"MultiDropdown.html\">\n    <div class=\"form-group dropdown-container\" ng-class=\"{'hasValue':  item.properties.Basic.Value.selectedValue.length > 0}\">\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\"></i>\n            <input ng-if=\"createCtrl.external\" title=\"Select / Deselect All\" type=\"checkbox\"  ng-click=\"createCtrl.selectAllDropdownOption($event,item.properties);\" ng-disabled=\"item.properties.Basic.FilterValue.isFilterValue == 2\"/>\n            <label ng-if=\"item.properties.Basic.Label.selectedValue\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'Style')\">{{item.properties.Basic.Label.selectedValue}}<i ng-if=\"item.properties.Basic.Required.selectedValue\" class=\"red\">*</i><i class=\"fa fa-info-circle script-event-info pull-right\" ng-class=\"{'selected-control-event-info' : item.selected}\" ng-if=\"createCtrl.hasScriptLogic(item.properties.Events)\" title=\"{{ 'field-have-some-validations' | translate }}\"></i></label>\n            <label ng-if=\"createCtrl.external\" class=\"roundSwitch\">{{ 'all-value' | translate }} <input type=\"checkbox\" ng-click=\"createCtrl.isDisableDropdown($event,item.properties);\" ng-checked=\"item.properties.Basic.FilterValue.isFilterValue == 2\"/><span></span></label>\n\n        <div data-name=\"{{item.uid}}\" class=\"btn-group dropdown filter-dd\" uib-dropdown is-open=\"item.properties.Basic.isOpen\" dropdown-append-to-body auto-close=\"outsideClick\">\n            <button ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\" ng-disabled=\"item.properties.Display['Read-only'].selectedValue || createCtrl.external && item.properties.Basic.FilterValue.isFilterValue == 2\"\n            class=\"btn btn-default dropdown-toggle\" type=\"button\" uib-dropdown-toggle title=\"{{item.properties.Advance.Tooltip.selectedValue}}\" ng-click=\"createCtrl.onMultiDropdownToggle(item, $event)\">\n                <span ng-if=\"item.properties.Basic.Value.selectedValue.length > 0 && (createCtrl.selectedTheme == createCtrl.designStyle.STANDARD)\">{{item.properties.Basic.Value.selectedValue.toString()}}</span>\n                <div class=\"chips\" ng-if=\"(createCtrl.selectedTheme != createCtrl.designStyle.STANDARD)\">\n                    <div class=\"chip\" ng-repeat=\"selectedValue in item.properties.Basic.Value.selectedValue\">\n                          <div class=\"text\">{{selectedValue}}</div>\n                          <div class=\"remove\">&nbsp;</div>                           \n                    </div>\n              </div>\n                <span ng-if=\"item.properties.Basic.Value.selectedValue.length == 0 && (createCtrl.selectedTheme == createCtrl.designStyle.STANDARD)\">{{ 'select-options' | translate }}</span>\n                <span class=\"caret\"></span>\n            </button>\n            <div data-name=\"dd_{{item.uid}}\" class=\"dropdown-menu filter-dd-menu\" uib-dropdown-menu ng-style=\"createCtrl.getDropDownHeight(item)\">\n                <div>\n                    <div class=\"inpt-wrap clearfix\">\n                        <input type=\"text\" class=\"form-control\" ng-model=\"item.properties.Basic.searchText\" ng-keyup=\"createCtrl.updateDropdownPosition(item)\"/>\n                        <i class=\"icon-search fa\" ng-click=\"createCtrl.clearMultiDropdownSearch(item)\" ng-class=\"{'fa-search': !item.properties.Basic.searchText, 'fa-close': item.properties.Basic.searchText}\"></i>\n                    </div>\n                    <div class=\"link-wrap clearfix\">\n                        <a  style=\"cursor: pointer;\" ng-show=\"!item.properties.Basic.searchText\" class=\"pull-left\" ng-click=\"createCtrl.clearMultiDropdown(item);createCtrl.onChangeModelValue(item.uid, item.properties.Basic.ControlType, item.properties.Basic['Data Field Name'].selectedValue, item.properties.Basic.Value.selectedValue);\">{{ 'clear' | translate }}</a>\n                        <a style=\"cursor: pointer;\" ng-show=\"!item.properties.Basic.searchText\" class=\"pull-right\" ng-click=\"createCtrl.closeMultiDropdown(item)\">{{ 'close' | translate }}</a>\n                        <a style=\"margin-left:15%; cursor: pointer;\" ng-show=\"!item.properties.Basic.searchText && item.properties.Basic.isLimited\" ng-click=\"createCtrl.showAll(item)\">{{ 'show-all' | translate }}</a>\n                    </div>\n                    <ul class=\"opt-list {{item.properties.Size.Size.selectedValue}}\">\n                        <!-- <li class=\"dropdown-header\" ng-if=\"dd.dynamic && dd.limited && filtered.length && !dd.search.value\">{{dd.suggestionLabel || '<adoddle-i18n-ui:message key=\"suggested-filter-crieria\"/>'}}</li> -->\n                        <li  ng-if=\"item.properties.Basic.isLimited\" ng-repeat=\"list in item.properties['Data Source'].table.list | searchFilter:item.properties.Basic.searchText| limitTo: 10\"><a ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\" href=\"javascript:void(0)\" ng-class=\"{checked: list.isSelected}\" ng-click=\"createCtrl.setMultiDDSelection(item,list);createCtrl.setDropDownOption(item); createCtrl.onChangeModelValue(item.uid, item.properties.Basic.ControlType, item.properties.Basic['Data Field Name'].selectedValue, item.properties.Basic.Value.selectedValue);\" title=\"{{list.Label.name}}\"> <span>{{list.Label.name}}</span></a></li>\n                        <li ng-if=\"!item.properties.Basic.isLimited\" ng-repeat=\"list in item.properties['Data Source'].table.list | searchFilter:item.properties.Basic.searchText\"><a ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\" href=\"javascript:void(0)\" ng-class=\"{checked: list.isSelected}\" ng-click=\"createCtrl.setMultiDDSelection(item,list);createCtrl.setDropDownOption(item); createCtrl.onChangeModelValue(item.uid, item.properties.Basic.ControlType, item.properties.Basic['Data Field Name'].selectedValue, item.properties.Basic.Value.selectedValue);\" title=\"{{list.Label.name}}\"> <span>{{list.Label.name}}</span></a></li>\n                        <li ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\" class=\"dropdown-header text-center\" ng-if=\"!((item.properties['Data Source'].table.list).length)\">{{ 'no-match-found' | translate }}</li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"Table.html\">\n    <div>\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\"></i>\n        <div class=\"table-wrapper\">\n            <i class=\"fa fa-arrows\" aria-hidden=\"true\" ng-click=\"item.selectAll = !item.selectAll\"></i>\n            <i class=\"fa fa-info-circle script-event-info pull-right\" ng-class=\"{'selected-control-event-info' : item.selected}\" ng-if=\"createCtrl.hasScriptLogic(item.properties.Events)\" title=\"{{ 'field-have-some-validations' | translate }}\"></i>\n            <table multi-cell-select multi-cell-ids=\"item.ids\" columns-width=\"item.width\" reset-cells=\"item.reset\" \n                selected-rows=\"item.selectedRows\" select-all=\"item.selectAll || false\" \n                class=\"table form-group\" ng-style=\"createCtrl.getTableCss(item);\">\n                <tr ng-repeat=\"rows in item.data\">\n                    <td ng-hide=\"columns.hide\" colspan=\"{{columns.colspan}}\" rowspan=\"{{columns.rowspan}}\" id=\"{{$parent.$index}}-{{$index}}\" class=\"ui-state-default\" ng-repeat=\"columns in item.data[$index]\" style=\"position:relative;background-clip: padding-box;min-width: 130px;\" ng-style=\"createCtrl.getBorderStyleObect(item, columns.style, createCtrl.getColumnWidth(item, $index, $parent.$index))\">\n                        <div class='resizer' ng-if=\"!columns.colspan || columns.colspan < 1\"></div>\n                        <div class='row-selector-handler' ng-if=\"$index === 0\" row-id=\"{{$parent.$parent.$index}}\"></div>\n                        <div class='column-selector-handler' ng-if=\"$parent.$index === 0\" col-id=\"{{$index}}\"></div>\n                        <div class=\"column height-inherit\" ng-style=\"{ width: createCtrl.getColumnWidth(item, $parent.$parent.$index, $parent.$parent.$parent.$index)}\" style=\"min-height: 45px;min-width: 125px;\" ng-repeat=\"list in columns.elems\" ng-include=\"'list.html'\"></div>\n                    </td>\n                </tr>\n            </table>\n        </div>\n    </div>\n\n</script>\n<script type=\"text/ng-template\" id=\"RepeatingTable.html\">\n    <div id=\"formdesigner-rtable\">\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\"></i>\n        <i class=\"fa fa-info-circle script-event-info pull-right\" ng-class=\"{'selected-control-event-info' : item.selected}\" ng-if=\"createCtrl.hasScriptLogic(item.properties.Events)\" title=\"{{ 'field-have-some-validations' | translate }}\"></i>\n        <div class=\"table-wrapper\" ng-class=\"{'col-md-12':createCtrl.models.selected === item }\" type=\"{{item.type}}\" repeating-table-id=\"{{item.id}}\">\n            <table multi-cell-select multi-cell-ids=\"item.ids\" columns-width=\"item.width\" reset-cells=\"item.reset\" \n                selected-rows=\"item.selectedRows\" select-all=\"item.selectAll || false\" \n                class=\"table form-group\" ng-style=\"createCtrl.getTableCss(item)\" >\n\n                <tr ng-repeat=\"rows in item.header_data\" ng-if=\"item.properties.Basic.Include_Header.selectedValue\">\n                    <td ng-repeat=\"columns in item.header_data[$index]\" id=\"{{$parent.$index}}-{{$index}}\" name=\"header_data\" class=\"ui-state-default\" \n                    style=\"position:relative;background-clip: padding-box;min-width: 130px;\" \n                    ng-style=\"createCtrl.getBorderStyleObect(item, columns.style, createCtrl.getColumnWidth(item, $index, $parent.$index))\" >\n                        <div class='resizer'></div>\n                        <div class='row-selector-handler' ng-if=\"$index === 0\" row-id=\"{{$parent.$parent.$index}}\"></div>\n                        <div class='column-selector-handler' ng-if=\"$parent.$index === 0\" col-id=\"{{$index}}\"></div>\n                        <div ng-repeat=\"list in columns.elems\" ng-include=\"'list.html'\" class=\"column height-inherit\" \n                        ng-style=\"{ width: createCtrl.getColumnWidth(item, $parent.$parent.$index, $parent.$parent.$parent.$index)}\" \n                        style=\"min-height: 45px;min-width: 130px;\"></div>\n                    </td>\n                </tr>\n\n                <tr ng-repeat=\"rows in item.data\">\n                    <td ng-repeat=\"columns in item.data[$index]\" \n                    id=\"{{$parent.$index}}-{{$index}}\" class=\"ui-state-default\" \n                    style=\"position:relative;background-clip: padding-box;min-width: 130px;\" \n                    ng-style=\"createCtrl.getBorderStyleObect(item, columns.style, createCtrl.getColumnWidth(item, $index, $parent.$index))\">\n                        <div class='resizer'></div>\n                        <div class='row-selector-handler' ng-if=\"$index === 0\" row-id=\"{{$parent.$parent.$index}}\"></div>\n                        <div class='column-selector-handler' ng-if=\"$parent.$index === 0 && !item.properties.Basic.Include_Header.selectedValue\" col-id=\"{{$index}}\"></div>\n                        <div ng-repeat=\"list in columns.elems\" ng-include=\"'list.html'\" class=\"column height-inherit\" \n                        ng-style=\"{ width: createCtrl.getColumnWidth(item, $parent.$parent.$index, $parent.$parent.$parent.$index)}\" \n                        style=\"min-height: 45px;min-width: 130px;\"></div>\n                    </td>\n                </tr>\n\n                <tr ng-repeat=\"rows in item.footer_data\" ng-if=\"item.properties.Basic.Include_Footer.selectedValue\" type=\"footer\">\n                    <td ng-repeat=\"columns in item.footer_data[$index]\" \n                    id=\"{{$parent.$index}}-{{$index}}\" name=\"footer_data\" class=\"ui-state-default\" \n                    style=\"position:relative;background-clip: padding-box;min-width: 130px;\" \n                    ng-style=\"createCtrl.getBorderStyleObect(item, columns.style, createCtrl.getColumnWidth(item, $index, $parent.$index))\" >\n                        <div class='resizer'></div>\n                        <div class='row-selector-handler' ng-if=\"$index === 0\" row-id=\"{{$parent.$parent.$index}}\"></div>\n                        <div ng-repeat=\"list in columns.elems\" ng-include=\"'list.html'\" class=\"column height-inherit\" \n                        ng-style=\"{ width: createCtrl.getColumnWidth(item, $parent.$parent.$index, $parent.$parent.$parent.$index)}\" \n                        style=\"min-height: 45px;min-width: 130px;\"></div>\n                    </td>\n                </tr>\n            </table> \n                <div ng-if=\"item.properties.Basic.Insert_Button_Text.selectedValue && !item.forceToReadOnly\" class=\"add-row-wrapper disabled\">\n                    <span class=\"add-row\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'InsertButtonStyle')\">\n                        <i class=\"fa fa-plus\"></i>{{ item.properties.Basic.Insert_Button_Text.selectedValue }}\n                    </span>\n                </div>\n            \n        </div>\n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"Tabs.html\">\n    <div class=\"form-group\">\n        <uib-tabset active=\"activeJustified\" justified=\"true\">\n            <uib-tab index=\"0\" heading=\"Tab 1\">Tab 1</uib-tab>\n            <uib-tab index=\"1\" heading=\"Tab 2\">Tab 2</uib-tab>\n            <uib-tab index=\"2\" heading=\"Tab 3\">Tab 3</uib-tab>\n        </uib-tabset>\n    </div>\n</script>\n<!-- <script type=\"text/ng-template\" id=\"Datepicker.html\">\n    <div class=\"form-group\">\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\"></i>\n        <label ng-if=\"item.properties.Basic.Label.selectedValue\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'Style')\">{{item.properties.Basic.Label.selectedValue}}<i ng-if=\"item.properties.Basic.Required.selectedValue\" class=\"red\">*</i><i class=\"fa fa-info-circle script-event-info pull-right\" ng-class=\"{'selected-control-event-info' : item.selected}\" ng-if=\"createCtrl.hasScriptLogic(item.properties.Events)\" title=\"{{ 'field-have-some-validations' | translate }}\"></i></label>\n        <div class=\"566\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\">\n            <input type=\"text\" class=\"form-control\" value=\"{{('current.date' | translate) + ' + ' + (item.properties.Basic.Default.days || 0) + ' d'}}\" ng-if=\"item.properties.Basic.Default.dateType == 2\" disabled>\n            <input type=\"text\" class=\"form-control\" ng-if=\"item.properties.Basic.Default.dateType != 2\" datepicker-options=\"createCtrl.dateOptions\" uib-datepicker-popup=\"{{createCtrl.Util.getDateFormat(item.properties.Basic['Display Format'].selectedValue)}}\"\n            is-open=\"opened\" ng-click=\"opened = true\" ng-model=\"item.properties.Basic.Default.dateObj\" ng-init=\"item.properties.Basic.Default.dateObj = createCtrl.Util.getDateObj(item.properties.Basic.Default.dateObj)\"\n            title=\"{{item.properties.Advance.Tooltip.selectedValue}}\" ng-change=\"item.properties.Basic.Default.selectedValue = createCtrl.Util.formatDate(createCtrl.Util.getLanguageSpecificDateFormat(item.properties.Basic['Display Format'].selectedValue), item.properties.Basic.Default.dateObj); createCtrl.onChangeModelValue(item.uid, item.properties.Basic.ControlType, item.properties.Basic['Data Field Name'].selectedValue, item.properties.Basic.Default.dateObj);\" \n            datepicker-append-to-body=\"true\"  ng-disabled=\"item.properties.Display['Read-only'].selectedValue\"/>\n            <i class=\"fa fa-calendar\" ng-if=\"item.properties.Basic.Default.dateType != 2\" ng-click=\"opened = true\" style=\"cursor: pointer\"></i>\n        </div>\n    </div>\n</script>  -->\n<script type=\"text/ng-template\" id=\"Datepicker.html\">\n    <div class=\"form-group date-container\" ng-class=\"{'hasValue':  item.properties.Basic.Default.selectedValue || item.properties.Basic.Default.dateType == '2'}\">\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\"></i>\n        <label ng-if=\"item.properties.Basic.Label.selectedValue\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'Style')\">{{item.properties.Basic.Label.selectedValue}}<i ng-if=\"item.properties.Basic.Required.selectedValue\" class=\"red\">*</i><i class=\"fa fa-info-circle script-event-info pull-right\" ng-class=\"{'selected-control-event-info' : item.selected}\" ng-if=\"createCtrl.hasScriptLogic(item.properties.Events)\" title=\"{{ 'field-have-some-validations' | translate }}\"></i></label>\n        <div  ng-if=\"item.properties.Basic.Default.dateType == 2\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\">\n            <input type=\"text\" class=\"form-control\" value=\"{{('current.date' | translate) + ' + ' + (item.properties.Basic.Default.days || 0) + ' d'}}\" disabled ng-init=\"item.properties.Basic['Display Format'].selectedValue = createCtrl.getDisplayFormat(item.properties)\">\n        </div>\n        <div class=\"a-date-picker date-picker-wrapper\" type=\"{{item.type}}\" ng-if=\"item.properties.Basic.Default.dateType != 2\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\">\n            <input  ng-disabled=\"item.properties.Display['Read-only'].selectedValue\" picker-id=\"{{item.uid}}\" type=\"text\" id=\"dt1\" class=\"form-control\" ng-model=\"item.properties.Basic.Default.selectedValue\"\n            ng-init=\"item.properties.Basic.Default.dateObj = createCtrl.Util.getDateObj(item.properties.Basic.Default.dateObj)\"\n            title=\"{{item.properties.Advance.Tooltip.selectedValue}}\"  \n            datetimepicker datetimepicker-options=\"createCtrl.getDatePickerOptions(item.properties)\"\n                ng-change=\"createCtrl.getParsedDate(item.properties); createCtrl.onChangeModelValue(item.uid, item.properties.Basic.ControlType, item.properties.Basic['Data Field Name'].selectedValue, item.properties.Basic.Default.dateObj);\" \n                name=\"time\"\n                ng-keyup=\"createCtrl.updatePickerDisplay($event,item)\"\n                ng-blur=\"createCtrl.checkValidInputDate(event,item.properties,item)\"\n                autocomplete=\"off\">\n                <i class=\"fa fa-calendar\" style=\"cursor: pointer\" ng-click=\"createCtrl.showDatepicker($event)\"></i>\n        </div>\n        <p class=\"info-text\" ng-if=\"item.properties.Basic['Working Days']['selectedValue']\">Please use the visual script for calculating the working days in repeating tables.</p>\n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"Timepicker.html\">\n    <div class=\"form-group date-container\" ng-class=\"{'hasValue':  item.properties.Basic.Default.selectedValue || item.properties.Basic.Default.timeType == '2'}\">\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\"></i>\n        <label ng-if=\"item.properties.Basic.Label.selectedValue\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'Style')\">{{item.properties.Basic.Label.selectedValue}}<i ng-if=\"item.properties.Basic.Required.selectedValue\" class=\"red\">*</i><i class=\"fa fa-info-circle script-event-info pull-right\" ng-class=\"{'selected-control-event-info' : item.selected}\" ng-if=\"createCtrl.hasScriptLogic(item.properties.Events)\" title=\"{{ 'field-have-some-validations' | translate }}\"></i></label>\n            <div ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\" ng-if=\"item.properties.Basic.Default.timeType == 2\">\n                <input type=\"text\" class=\"form-control\" value=\"current time\"  disabled>\n            </div>\n                <div  ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\" class=\"date-picker-wrapper timepicker-wrapper\" type=\"{{item.type}}\" ng-if=\"item.properties.Basic.Default.timeType == 1\" ng-init=\"createCtrl.setTimeFormat(item)\">\n                    <input picker-id=\"{{item.uid}}\" type=\"text\" class=\"form-control\" datetime-picker=\"{{item.timeFormat}}\"\n                    contenteditable=\"true\"\n                    ng-disabled=\"item.properties.Display['Read-only'].selectedValue\"\n                    title=\"{{item.properties.Advance.Tooltip.selectedValue}}\"\n                    enable-date=\"false\" timepicker-options = \"createCtrl.getTimePickerOptions(item.properties)\" \n                    ng-init=\"item.properties.Basic.Default.selectedValue = createCtrl.Util.getDateObj(item.properties.Basic.Default.selectedValue)\"\n                    ng-model=\"item.properties.Basic.Default.selectedValue\" is-open=\"item.properties.Basic.showFlag\"\n                    ng-focus=\"item.properties.Basic.showFlag = true\"\n                    ng-blur=\"createCtrl.checkValidInput($event,item)\"\n                    datepicker-append-to-body=\"true\"\n                    ng-change=\"createCtrl.onChangeModelValue(item.uid, item.properties.Basic.ControlType, item.properties.Basic['Data Field Name'].selectedValue,item.properties);\">\n                        <i class=\"fa fa-clock-o\" ng-click=\"item.properties.Basic.showFlag = true\" style=\"cursor:pointer;\"></i>\n                </div>    \n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"Checkbox.html\">\n    <div class=\"form-group\">\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\"></i>\n        <input ng-if=\"createCtrl.external\" style=\"margin-left:0px\" title=\"Select / Deselect All\" ng-disabled=\"item.properties.Display['Read-only'].selectedValue\"  name=\"textarea{{item.id}}\" type=\"checkbox\" ng-click=\"createCtrl.selectAllCheckboxOption($event,item.properties);\" ng-disabled=\"item.properties.Basic.FilterValue.isFilterValue == 2\"/>\n        <label ng-if=\"item.properties.Basic.Label.selectedValue\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'Style')\">{{item.properties.Basic.Label.selectedValue}}<i ng-if=\"item.properties.Basic.Required.selectedValue\" class=\"red\">*</i>{{list.Label.name}}<i class=\"fa fa-info-circle script-event-info pull-right\" ng-class=\"{'selected-control-event-info' : item.selected}\" ng-if=\"createCtrl.hasScriptLogic(item.properties.Events)\" title=\"{{ 'field-have-some-validations' | translate }}\"></i></label>\n        <label ng-if=\"createCtrl.external\" class=\"roundSwitch\">{{ 'all-value' | translate }}<input type=\"checkbox\" ng-checked=\"item.properties.Basic.FilterValue.isFilterValue == 2\" ng-click=\"createCtrl.isDisableCheckbox($event,item.properties);\"/><span></span></label>\n        <div ng-init=\"createCtrl.getListItems(item,item.properties)\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\">\n            <div ng-repeat=\"(key, option) in item.optionsList\"  class=\"row-cls\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\">\n                <div class=\"btn-group column-cls\" ng-class=\"{'line-button' : (item.properties.Basic['Display Format'] && item.properties.Basic['Display Format'].selectedValue == 'lineCheckbox'),\n                    'fill-button': (item.properties.Basic['Display Format'] && item.properties.Basic['Display Format'].selectedValue == 'buttons'),\n                    'flat-checkbox-button': (item.properties.Basic['Display Format'] && item.properties.Basic['Display Format'].selectedValue == 'checkbox'),\n                    'f-checkbox-button': (item.properties.Basic['Display Format'] && item.properties.Basic['Display Format'].selectedValue == 'fCheckBox'),\n                    'checked': list.selectedValue.name}\" \n                    ng-style=\"{ width: createCtrl.getRadioCheckboxWidth(item)}\"\n                    ng-repeat=\"list in option track by $index\" >\n                    <input name=\"textarea{{item.uid}}\" type=\"checkbox\" ng-disabled=\"item.properties.Display['Read-only'].selectedValue\" ng-value=\"true\" \n                    ng-model=\"list.selectedValue.name\" id=\"{{item.uid+$index+key}}\" ng-disabled=\"createCtrl.external && item.properties.Basic.FilterValue.isFilterValue == 2\"\n                    ng-change=\"createCtrl.onChangeModelValue(item.uid, item.properties.Basic.ControlType, item.properties.Basic['Data Field Name'].selectedValue, item.properties['Data Source'].table.list);\">    \n                    <label class=\"label-cls\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\" ng-click=\"createCtrl.setCheckBoxOption(item);\" for=\"{{item.uid+$index+key}}\" ng-class=\"{'line-button' : (item.properties.Basic['Display Format'] && item.properties.Basic['Display Format'].selectedValue == 'lineCheckbox'),\n                    'fill-button': (item.properties.Basic['Display Format'] && item.properties.Basic['Display Format'].selectedValue == 'buttons'),\n                    'f-checkbox-button': (item.properties.Basic['Display Format'] && item.properties.Basic['Display Format'].selectedValue == 'fCheckBox'),\n                    'flat-checkbox-button': (item.properties.Basic['Display Format'] && item.properties.Basic['Display Format'].selectedValue == 'checkbox'),\n                    'checkbox-inline': (item.properties.Basic['Display Format'] && item.properties.Basic['Display Format'].selectedValue == 'checkbox' || item.properties.Basic['Display Format'].selectedValue == 'fCheckBox')}\"\n                    title=\"{{list.Label.name}}\">\n                        {{list.Label.name}}\n                    </label>\n                </div>\n            </div>\n            \n        </div>\n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"Radio.html\">\n    <div class=\"form-group\">\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\"></i>\n        <label ng-if=\"item.properties.Basic.Label.selectedValue\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'Style')\">{{item.properties.Basic.Label.selectedValue}}<i ng-if=\"item.properties.Basic.Required.selectedValue\" class=\"red\">*</i><i class=\"fa fa-info-circle script-event-info pull-right\" ng-class=\"{'selected-control-event-info' : item.selected}\" ng-if=\"createCtrl.hasScriptLogic(item.properties.Events)\" title=\"{{ 'field-have-some-validations' | translate }}\"></i></label>\n        <div ng-init=\"createCtrl.getListItems(item,item.properties)\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\">\n            <div ng-repeat=\"(key, option) in item.optionsList\" class=\"row-cls\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\">\n                <div class=\"btn-group column-cls\" ng-class=\"{'line-button' : (item.properties.Basic['Display Format'] && item.properties.Basic['Display Format'].selectedValue == 'lineRadio'),\n                    'fill-button': (item.properties.Basic['Display Format'] && item.properties.Basic['Display Format'].selectedValue == 'buttons'),\n                    'f-radio-button': (item.properties.Basic['Display Format'] && item.properties.Basic['Display Format'].selectedValue == 'fRadioButtons'),\n                    'flat-radio-button': (item.properties.Basic['Display Format'] && item.properties.Basic['Display Format'].selectedValue == 'radio'),\n                    'checked': list.selectedValue.name}\" \n                    ng-style=\"{ width: createCtrl.getRadioCheckboxWidth(item)}\" \n                    ng-repeat=\"list in option track by $index\">\n                    <input name=\"textarea{{item.uid}}\" type=\"radio\" ng-disabled=\"item.properties.Display['Read-only'].selectedValue\" ng-value=\"true\" \n                    ng-model=\"list.selectedValue.name\" id=\"{{item.uid+$index+key}}\"\n                    ng-change=\"createCtrl.resetDefaultForRadio(list, item.properties['Data Source'].table.list); createCtrl.onChangeModelValue(item.uid, item.properties.Basic.ControlType, item.properties.Basic['Data Field Name'].selectedValue, item.properties['Data Source'].table.list);\">    \n                    <label class=\"label-cls\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'ControlStyle')\" for=\"{{item.uid+$index+key}}\" ng-class=\"{'line-button' : (item.properties.Basic['Display Format'] && item.properties.Basic['Display Format'].selectedValue == 'lineRadio'),\n                    'fill-button': (item.properties.Basic['Display Format'] && item.properties.Basic['Display Format'].selectedValue == 'buttons'),\n                    'f-radio-button': (item.properties.Basic['Display Format'] && item.properties.Basic['Display Format'].selectedValue == 'fRadioButtons'),\n                    'flat-radio-button': (item.properties.Basic['Display Format'] && item.properties.Basic['Display Format'].selectedValue == 'radio'),\n                    'radio-inline': (item.properties.Basic['Display Format'] && item.properties.Basic['Display Format'].selectedValue == 'radio' || item.properties.Basic['Display Format'].selectedValue == 'fRadioButtons')}\"\n                    title=\"{{list.Label.name}}\">\n                        {{list.Label.name}}\n                    </label>\n                </div>\n            </div>\n        </div>\n        \n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"Layout.html\">\n    <div id=\"layout\">\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\"></i>\n        <i class=\"fa fa-info-circle script-event-info pull-right\" ng-class=\"{'selected-control-event-info' : item.selected}\" ng-if=\"createCtrl.hasScriptLogic(item.properties.Events)\" title=\"{{ 'field-have-some-validations' | translate }}\"></i>\n        <div class=\"table-wrapper\" ng-class=\"{'col-md-12':createCtrl.models.selected === item }\">\n            <table multi-cell-select multi-cell-ids=\"item.ids\" \n                columns-width=\"item.width\" reset-cells=\"item.reset\" \n                selected-rows=\"item.selectedRows\" select-all=\"item.selectAll || false\" \n                class=\"table form-group\" ng-style=\"createCtrl.getTableCss(item)\">\n                <tr>\n                    <td ng-hide=\"columns.hide\" id=\"0-{{$index}}\" class=\"ui-state-default\" \n                    ng-repeat=\"columns in item.data\" style=\"position:relative;background-clip: padding-box;min-width: 130px;\" \n                    ng-style=\"createCtrl.getBorderStyleObect(item, columns.style, createCtrl.getColumnWidth(item, $index, 0))\">\n                        <div ng-if= \"createCtrl.config.for != 'Marketplace'\" class='resizer'></div>\n                        <div class='row-selector-handler'ng-if=\"$index === 0\" ng-style=\"createCtrl.config.for == 'Marketplace' && {'cursor': 'default'}\" row-id=\"0\"></div>\n                        <div class='column-selector-handler' ng-style=\"createCtrl.config.for == 'Marketplace' && {'cursor': 'default'}\" col-id=\"{{$index}}\"></div>\n\n                        <div class=\"column height-inherit\" ng-repeat=\"list in columns.elems\" ng-include=\"'list.html'\"\n                        ng-style=\"{ width: createCtrl.getColumnWidth(item, $parent.$parent.$index, $parent.$parent.$parent.$index)}\" \n                        style=\"min-height: 45px;min-width: 125px;\"></div>\n                    </td>\n                </tr>\n            </table>\n        </div>\n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"Section.html\">\n    <div>\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\"></i>\n        <i class=\"fa fa-info-circle script-event-info pull-right\" ng-class=\"{'selected-control-event-info' : item.selected}\" ng-if=\"createCtrl.hasScriptLogic(item.properties.Events)\" title=\"{{ 'field-have-some-validations' | translate }}\"></i>\n        <div type=\"{{item.type}}\" section-id=\"{{item.id}}\">\n            <div ng-repeat=\"list in item.data.elems\" ng-include=\"'list.html'\" class=\"column height-inherit\" \n            style=\"min-height: 45px;min-width: 130px;\"></div>\n        </div>\n        </div>\n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"Image.html\">\n    <div>\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\"></i>\n        <div ng-style=\"{'text-align': item.properties.Size.Alignment.selectedValue }\">\n            <img class=\"image-control\" onerror=\"this.src='assets/images/image.png'\" src=\"{{item.properties.Basic.Url.selectedValue}}\" ng-style=\"{'height': (item.properties.Size.Height.selectedValue || '100px'),'width': (item.properties.Size.Width.selectedValue || '100px')}\"/>\n        </div>\n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"Line.html\">\n    <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\"></i>\n    <hr ng-style=\"{'border-top-color':item.properties.Style['style-group'].members['font-color'].selectedValue }\">\n</script>\n<script type=\"text/ng-template\" id=\"Rating.html\">\n    <div class=\"form-group\">\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\"></i>\n        <label ng-if=\"item.properties.Basic.Label.selectedValue\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'Style')\" >{{item.properties.Basic.Label.selectedValue}}<i ng-if=\"item.properties.Basic.Required.selectedValue\" class=\"red\">*</i></label>\n        <div class=\"range-div\" style=\"width: 50%;\">\n            <input class=\"range-input\" ng-model=\"item.properties.Basic.Value.selectedValue\" type=\"range\" name=\"rating\" step=\"{{item.properties.Basic.Step.selectedValue}}\" min=\"{{item.properties.Basic.Min.selectedValue}}\" max=\"{{item.properties.Basic.Max.selectedValue}}\" list=\"{{item.uid}}\">\n            <div class=\"range-datalist\" id=\"{{item.uid}}\">\n                <span class=\"range-step\" ng-repeat=\"n in createCtrl.getArray(item)\">{{n}}</span>\n            </div>\n        </div>\n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"Signature.html\">\n    <div class=\"form-group\">\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\"></i>\n        <label>{{item.properties.Basic.Label.selectedValue}}\n           <i ng-if=\"item.properties.Basic.Required.selectedValue\" class=\"red\">*</i>\n           <i class=\"fa fa-info-circle script-event-info pull-right\" ng-class=\"{'selected-control-event-info' : item.selected}\" ng-if=\"createCtrl.hasScriptLogic(item.properties.Events)\" title=\"{{ 'field-have-some-validations' | translate }}\"></i>\n        </label>\n        <div id=\"signatureBox\" style=\"height:120px;min-width: 70px;width:100%;border: 2px solid #ccc;border-radius: 5px;padding: 5px;background-color:#fff;\">\n            <button ng-if=\"!item.properties.Display['Read-only'].selectedValue\" style=\"border: 2px solid #ccc;border-radius: 5px;background: none;float: right;\">\n                <img src=\"assets/images/edit-pencil.svg\">\n            </button>\n        </div>\n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"Attachment.html\">\n    <div class=\"form-group attachmentbox\">\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\"></i>\n        <label ng-if=\"item.properties.Basic.Label.selectedValue\">{{item.properties.Basic.Label.selectedValue}}<i ng-if=\"item.properties.Basic.Required.selectedValue\" class=\"red\">*</i><i class=\"fa fa-info-circle script-event-info pull-right\" ng-class=\"{'selected-control-event-info' : item.selected}\" ng-if=\"createCtrl.hasScriptLogic(item.properties.Events)\" title=\"{{ 'field-have-some-validations' | translate }}\"></i></label>\n        <div ng-if=\"item.properties.Display['Generate Thumbnail'].selectedValue\" id=\"set-thumbnail\"><img src=\"assets/images/image.png\"/></div>\n        <div ng-style=\"{'text-align': item.properties.Size.Alignment.selectedValue }\">\n            <a style=\"margin-left:18px;\" href=\"javascript:void(0)\"  ng-disabled=\"item.properties.Display['Read-only'].selectedValue\">\n                {{'add-files'| translate}}\n            </a>\n        </div>\n    </div>\n</script>\n\n<script type=\"text/ng-template\" id=\"InlineAssocFiles.html\">\n    <div class=\"form-group\">\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\" ></i>\n        <label ng-if=\"item.properties.Basic.Label.selectedValue\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'Style')\" class=\"ng-binding ng-scope\">{{item.properties.Basic.Label.selectedValue}}<i ng-if=\"item.properties.Basic.Required.selectedValue\" class=\"red\">*</i><i class=\"fa fa-info-circle script-event-info pull-right\" ng-class=\"{'selected-control-event-info' : item.selected}\" ng-if=\"createCtrl.hasScriptLogic(item.properties.Events)\" title=\"{{ 'field-have-some-validations' | translate }}\"></i></label>\n        <button class=\"btn btn-danger\" ng-class=\"{readonly : item.properties.Display['Read-only'].selectedValue}\" ng-style=\"{'font-family': item.properties.Style['font-style-group'].members['font-family'].selectedValue}\" style=\"padding:5px;background-color:white;height:auto;width:auto;color:black;\" title=\"{{item.properties.Advance.Tooltip.selectedValue}}\" >{{item.properties.Basic.Text.selectedValue}}</button>\n    </div>\n    <div class=\"table-wrapper\">\n        <table class=\"table form-group\" ng-style=\"createCtrl.getAssociationTableCss(item);\">\n            <tr>\n                  <td ng-repeat=\"list in item.properties.Association.selectedColumn.table.list\" style=\"position:relative;background-clip: padding-box;min-width: 130px; border-color: rgb(204, 204, 204); border-width: 1px; width: auto; text-align: center;\" ng-style=\"createCtrl.getAssociationBorderStyle(item)\">{{list.Value.name.colDisplayName}}</td>\n            </tr>\n        </table> \n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"InlineAssocApps.html\">\n    <div class=\"form-group\">\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\" ></i>\n        <label label ng-if=\"item.properties.Basic.Label.selectedValue\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'Style')\" class=\"ng-binding ng-scope\">{{item.properties.Basic.Label.selectedValue}}<i ng-if=\"item.properties.Basic.Required.selectedValue\" class=\"red\">*</i><i class=\"fa fa-info-circle script-event-info pull-right\" ng-class=\"{'selected-control-event-info' : item.selected}\" ng-if=\"createCtrl.hasScriptLogic(item.properties.Events)\" title=\"{{ 'field-have-some-validations' | translate }}\"></i></label>\n        <button class=\"btn btn-danger\" ng-class=\"{readonly : item.properties.Display['Read-only'].selectedValue}\"  ng-style=\"{'font-family': item.properties.Style['font-style-group'].members['font-family'].selectedValue}\" style=\"padding:5px;background-color:white;height:auto;width:auto;color:black;\" title=\"{{item.properties.Advance.Tooltip.selectedValue}}\" >{{item.properties.Basic.Text.selectedValue}}</button>\n    </div>\n    <div class=\"table-wrapper\">\n        <table class=\"table form-group\" ng-style=\"createCtrl.getAssociationTableCss(item);\">\n            <tr>\n                  <td ng-repeat=\"list in item.properties.Association.selectedColumn.table.list\" style=\"position:relative;background-clip: padding-box;min-width: 130px; text-align: center;\" ng-style=\"createCtrl.getAssociationBorderStyle(item)\">{{list.Value.name.colDisplayName}}</td>\n            </tr>\n        </table>\n    </div>\n</script>\n<script type=\"text/ng-template\" id=\"ViewAssociations.html\">\n    <div class=\"form-group\">\n        <i class=\"fa fa-remove pull-right\" ng-if=\"item.selected && createCtrl.config.sectionAvailibility.removeControl\" ng-click=\"createCtrl.removeFromList(item, list)\" title=\"{{ 'delete' | translate }}\" ></i>\n        <label ng-if=\"item.properties.Basic.Label.selectedValue\" ng-style=\"createCtrl.getIndividualStyleObj(item.properties, 'Style')\" class=\"ng-binding ng-scope\">{{item.properties.Basic.Label.selectedValue}}<i class=\"fa fa-info-circle script-event-info pull-right\" ng-class=\"{'selected-control-event-info' : item.selected}\" ng-if=\"createCtrl.hasScriptLogic(item.properties.Events)\" title=\"{{ 'field-have-some-validations' | translate }}\"></i></label>\n        <i class=\"fa fa-info-circle script-event-info pull-right\" ng-class=\"{'selected-control-event-info' : item.selected}\" ng-if=\"createCtrl.hasScriptLogic(item.properties.Events)\" title=\"{{ 'field-have-some-validations' | translate }}\"></i>\n    </div>\n    <div class=\"table-wrapper\">\n        <table class=\"table form-group\" ng-style=\"createCtrl.getAssociationTableCss(item);\">\n            <tr ng-if=\"item.properties.Basic['Assoc Type'].selectedValue == 'Apps'\">\n                <td  ng-repeat=\"list in item.properties.Association.Apps.table.list\" style=\"position:relative;background-clip: padding-box;min-width: 130px; border-color: rgb(204, 204, 204); border-width: 1px; width: auto; text-align: center;\" ng-style=\"createCtrl.getAssociationBorderStyle(item)\">{{list.Value.name.colDisplayName}}</td>\n            </tr>\n            <tr ng-if=\"item.properties.Basic['Assoc Type'].selectedValue == 'Files'\">\n                <td  ng-repeat=\"list in item.properties.Association.Files.table.list\" style=\"position:relative;background-clip: padding-box;min-width: 130px; border-color: rgb(204, 204, 204); border-width: 1px; width: auto; text-align: center;\" ng-style=\"createCtrl.getAssociationBorderStyle(item)\">{{list.Value.name.colDisplayName}}</td>\n            </tr>\n        </table> \n    </div>\n</script>\n\n<script type=\"text/ng-template\" id=\"list.html\">\n    <div class=\"row drop-area\" dnd-list=\"list\" tabindex=\"-1\" dnd-drop=\"createCtrl.onDrop(list, item, index);\" dnd-inserted =\"createCtrl.onMoved(list)\" ng-click=\"createCtrl.deselectAll($event)\">\n        <div ng-repeat=\"item in list\"\n        dnd-disable-if=\"createCtrl.config.external || createCtrl.config.for=='Marketplace'\"\n        dnd-draggable=\"createCtrl.getSelectedItemsIncluding(list, item)\"\n        dnd-effect-allowed=\"move\"\n        dnd-canceled=\"createCtrl.removeDragging()\"\n        id=\"{{item.properties.Basic['Data Field Name'].selectedValue}}\"\n        data-fieldname=\"{{item.properties.Basic['Field Name'].selectedValue}}\"\n        dnd-selected=\"createCtrl.selectItem(item, event, list, $index); createCtrl.closeDropdown(event);createCtrl.hideColorPicker(event);\"\n        ng-class=\"{selected: item.selected && createCtrl.config.for !== 'Marketplace', hide: item.dragging}\" class=\"col-md-12\"\n        ng-include=\"item.type + '.html'\" ng-style=\"createCtrl.getStyleObect(item)\"></div>\n    </div>\n</script>\n\n<div class=\"form-builder\" ng-class=\"{'loading': createCtrl.loading }\">\n    <div class=\"navigation\" ng-show=\"createCtrl.config.sectionAvailibility.header\">\n        <span class=\"formNameHover pull-left\" ng-show=\"!createCtrl.editTempName\" style=\"margin-right: 15px;\">{{createCtrl.params.formName}}</span>\n        <input type=\"text\" class=\"templateInputName pull-left\" ng-show=\"createCtrl.editTempName\" ng-model=\"createCtrl.params.formName\"\n            style=\"background-color: #1d6bb3;border: 1px solid #ccc;border-radius: 4px;width: 200px;margin-top: -3px;margin-right: 15px;\">\n        <button type=\"button\" class=\"btn btn-danger pull-left btn-sm\" ng-show=\"!createCtrl.editTempName\" ng-click=\"createCtrl.editTemplateName()\"\n            ng-if=\"createCtrl.config.for == 'Direct-Design'\" title=\"Edit\">\n            <i class=\"fa fa-pencil\"></i>\n        </button>\n        <button type=\"button\" class=\"btn btn-danger pull-left btn-sm\" ng-show=\"createCtrl.editTempName\" ng-click=\"createCtrl.editTemplateNameSave()\"\n            ng-if=\"(createCtrl.config.for == 'Direct-Design' || createCtrl.config.for == 'Marketplace')\" title=\"Save\">\n            <i class=\"fa fa-check\"></i>\n        </button>\n        <button type=\"button\" class=\"btn btn-danger pull-left btn-sm\" ng-show=\"createCtrl.editTempName\" ng-click=\"createCtrl.editTempNameCancle()\"\n            ng-if=\"(createCtrl.config.for == 'Direct-Design' || createCtrl.config.for == 'Marketplace')\" title=\"Cancel\">\n            <i class=\"fa fa-remove\"></i>\n        </button>\n        <button type=\"button\" class=\"btn btn-danger pull-right btn-sm\" ng-click=\"createCtrl.showHelpPopup = !createCtrl.showHelpPopup\"\n            title=\"{{ 'help' | translate }}\" ng-if=\"(createCtrl.config.for != 'Marketplace')\">\n            <i class=\"fa fa-question\"></i>\n        </button>\n        <button type=\"button\" class=\"btn btn-danger pull-right btn-sm\" ng-click=\"createCtrl.goBack()\" title=\"{{ 'close' | translate }}\">\n            <i class=\"fa fa-remove\"></i>\n        </button>\n        <button type=\"button\" class=\"btn btn-danger pull-right btn-sm\" ng-click=\"createCtrl.downloadZip()\" title=\"{{ 'download' | translate }}\"\n        ng-if=\"(createCtrl.config.for != 'Marketplace')\">\n            <i class=\"fa fa-download\"></i>\n        </button>\n        <button type=\"button\" class=\"btn btn-danger pull-right btn-sm\" ng-click=\"createCtrl.discardDraft()\" title=\"{{ 'discard.draft' | translate }}\"\n            ng-if=\"createCtrl.config.for == 'Direct-Design' && !createCtrl.published\">\n            <i class=\"fa fa-trash\"></i>&nbsp;\n            <span>{{ 'discard.draft' | translate }}</span>\n        </button>\n        <button type=\"button\" class=\"btn btn-danger pull-right btn-sm\" ng-click=\"createCtrl.validateAndSave()\" title=\"{{ 'save' | translate }} Ctrl+Alt+S\">\n            <i class=\"fa fa-save\"></i>&nbsp;\n            <span>{{ 'save' | translate }}</span>\n        </button>\n        <button type=\"button\" class=\"btn btn-danger pull-right btn-sm\" ng-click=\"createCtrl.publishWarning()\" title=\"{{ 'publish' | translate }} Ctrl+Alt+P\"\n            ng-if=\"(createCtrl.config.for == 'Direct-Design' || createCtrl.config.for == 'Marketplace')\">\n            <i class=\"fa fa-upload\"></i>&nbsp;\n            <span>{{ 'publish' | translate }}</span>\n        </button>\n        <!-- print -->\n        <div ng-if=\"createCtrl.config.for != 'Marketplace'\" class=\"btn-group pull-right print-type\" ng-disable = \"createCtrl.config.for=='Marketplace'\">\n            <button type=\"button\" class=\"btn btn-danger btn-sm\"  ng-click=\"createCtrl.openPrintSettingDialog()\">\n                <span>{{ 'print.setting' | translate }}</span>\n            </button>\n        </div>\n        <div ng-if = \"createCtrl.config.for!='Marketplace'\" class=\"theme-toggle pull-right theme-menu\">\n            <div class=\"toggle-button\">\n                <label for=\"publish\" translate=\"theme.toggle\" style=\"vertical-align: bottom;\">Switch to New Look</label>\n                <fieldset class=\"btn-switch\"\n                    ng-class=\"{'btn-switch--on': createCtrl.selectedTheme == createCtrl.designStyle.ADVANCED}\"\n                    title=\"{{ 'theme.toggle' | translate }}\"\n                    ng-model=\"createCtrl.selectedTheme\"\n                    ng-click=\"createCtrl.changeTheme()\"\n                    >\n                <div class=\"btn-switch-circle\" ng-class=\"{'btn-switch-circle--on':createCtrl.selectedTheme == createCtrl.designStyle.ADVANCED}\"\n                    ng-model=\"createCtrl.selectedTheme\"></div>\n                </fieldset>\n            </div>\n        </div>\n    </div>\n    <div class=\"side-panel\" ng-show=\"createCtrl.config.sectionAvailibility.view || createCtrl.config.sectionAvailibility.control\"\n        ng-class=\"{'no-border-top': !createCtrl.config.sectionAvailibility.header, 'side-bar-hidden': createCtrl.hideSideBar}\">\n        \n            <div class=\"manage-view-wrapper\" ng-style=\"{'height':createCtrl.config.sectionAvailibility.view && !createCtrl.config.sectionAvailibility.components && !createCtrl.hideSideBar ? '120px' : 'auto'}\">\n                <span ng-hide=\"!createCtrl.hideSideBar\" class=\"show-sidebar-btn\" ng-click=\"createCtrl.hideSideBar = !createCtrl.hideSideBar\">\n                    {{ 'tools' | translate }}<i class=\"fa fa-chevron-down\"></i>\n                </span>\n                <i ng-hide=\"createCtrl.hideSideBar\" class=\"fa hide-sidbar-btn fa-chevron-left\" ng-click=\"createCtrl.hideSideBar = !createCtrl.hideSideBar\"></i>\n                <!-- Manage View -->\n                <manageview ng-show=\"createCtrl.config.sectionAvailibility.view && !createCtrl.config.sectionAvailibility.components && !createCtrl.hideSideBar\"></manageview>\n            <!-- Tool Box -->\n            </div>\n            <toolbox ng-style=\"{'border-top': createCtrl.config.sectionAvailibility.components && !createCtrl.config.sectionAvailibility.view? '30px solid transparent' : '120px solid transparent'}\" ng-show=\"createCtrl.config.sectionAvailibility.control && !createCtrl.hideSideBar\" opendialog=\"createCtrl.openTemplateDialog(templateItem)\" showsection=\"createCtrl.config.sectionAvailibility\"></toolbox>\n        \n    </div>\n    <!-- Property Box -->\n    <propertybox ng-show=\"createCtrl.showPropertybox() && createCtrl.config.sectionAvailibility.properties\" ng-class=\"{'no-border-top': !createCtrl.config.sectionAvailibility.header}\"></propertybox>\n    <!-- Canvas -->\n    <div class=\"canvas\" ng-class=\"{'no-border-top': !createCtrl.config.sectionAvailibility.header, 'external': createCtrl.config.external, 'metadata': createCtrl.config.for == 'Meta-Data'}\">\n        <div class=\"create-form-header\" ng-show=\"createCtrl.config.sectionAvailibility['sub-header']\">\n            <div>{{ 'form' | translate}}\n                <div class=\"pull-right\">\n                    <apiconnection api-connection-closed=\"createCtrl.apiConnectionClosed()\"></apiconnection>\n                    <undoredo class=\"btn-group\"></undoredo>\n                    <commonpropertybox></commonpropertybox>\n                    <div class=\"btn-group\" uib-dropdown keyboard-nav>\n                        <button type=\"button\" class=\"btn btn-default dropdown-toggle-btn\" uib-dropdown-toggle>\n                            <i class=\"fa fa-files-o\"></i>\n                            <span class=\"caret\"></span>\n                        </button>\n                        <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"split-buttonv\">\n                            <li role=\"menuitem\">\n                                <a href=\"#\" ng-click=\"createCtrl.copy()\" title=\"{{ 'copy.selected' | translate }} Ctrl+C\" translate=\"copy.selected\">Copy</a>\n                            </li>\n                            <li role=\"menuitem\">\n                                <a href=\"#\" ng-click=\"createCtrl.copy(true)\" title=\"{{ 'copy.all' | translate }}\" translate=\"copy.all\">Copy All</a>\n                            </li>\n                        </ul>\n                    </div>\n                    <div class=\"btn-group\" uib-dropdown keyboard-nav>\n                        <button type=\"button\" class=\"btn btn-default dropdown-toggle-btn\" uib-dropdown-toggle ng-disabled=\"!createCtrl.copiedItems.length\">\n                            <i class=\"fa fa-clipboard\"></i>\n                            <span class=\"caret\"></span>\n                        </button>\n                        <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"split-buttonv\">\n                            <li role=\"menuitem\">\n                                <a href=\"#\" ng-click=\"createCtrl.paste()\" title=\"{{ 'paste' | translate }} Ctrl+V\" translate=\"paste\">Paste</a>\n                            </li>\n                            <li role=\"menuitem\">\n                                <a href=\"#\" ng-click=\"createCtrl.pasteAsReadOnly()\" title=\"{{ 'paste.as.read.only' | translate }} Ctrl+Shift+V\" translate=\"paste.as.read.only\">Paste as Read-only</a>\n                            </li>\n                            <li role=\"menuitem\">\n                                <a href=\"#\" ng-click=\"createCtrl.pasteAsCalculatedField()\" title=\"{{ 'paste-as-calculated-value' | translate }} Ctrl+Alt+V\" translate=\"paste-as-calculated-value\">Paste as Calculated Value</a>\n                            </li>\n                        </ul>\n                    </div>\n                    <div class=\"btn-group\" uib-dropdown keyboard-nav>\n                        <button type=\"button\" class=\"btn btn-default dropdown-toggle-btn\" uib-dropdown-toggle>\n                            <i class=\"fa fa-trash-o\"></i>\n                            <span class=\"caret\"></span>\n                        </button>\n                        <ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"split-buttonv\">\n                            <li role=\"menuitem\">\n                                <a href=\"#\" ng-click=\"createCtrl.remove()\" title=\"{{ 'remove.selected' | translate }}\" translate=\"remove.selected\" >Remove Selected</a>\n                            </li>\n                            <li role=\"menuitem\">\n                                <a href=\"#\" ng-click=\"createCtrl.remove(true)\" title=\"{{ 'remove.all' | translate }}\" translate=\"remove.all\">Remove All</a>\n                            </li>\n                        </ul>\n                    </div>\n                    <hierarchy></hierarchy>\n                    <button class=\"btn btn-default\" ng-click=\"createCtrl.openCodeEditorDialog()\" title=\"{{ 'open-code-editor-tooltip' | translate }}\">\n                        <i class=\"fa fa-code\" style=\"font-weight: bold;\"></i>\n                    </button>\n                </div>\n                \n            </div>\n        </div>\n        <div class=\"height-inherit\" ng-repeat=\"(zone, list) in createCtrl.selectedView.view.controls\" class=\"col-md-6\">\n            <div class=\"height-inherit\" class=\"dropzone box box-yellow\" class=\"formhtml\" id=\"formhtml\">\n                <div class=\"dnd-main-container\">\n                    <div class=\"scroller-outer\" id=\"scroller-outer\">\n                        <div class=\"scroller\">\n                            <div class=\"scroller-inner\">\n                                <a href=\"javacript:void(0)\" id=\"top\"></a>\n                                <div class=\"container-fluid\" ng-include=\"'list.html'\"></div>\n                                <a ng-click=\"createCtrl.gotoTop()\" ng-if=\"createCtrl.showScrollToTop\" class=\"go-to-top\" title=\"{{ 'scroll-to-top' | translate }}\">\n                                    <i class=\"fa fa-chevron-up\"></i>\n                                </a>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"help-popup animate-show-hide\" ng-show=\"createCtrl.showHelpPopup\">\n        <a href=\"javascript:void(0)\" class=\"close-help-popup\" ng-click=\"createCtrl.showHelpPopup = !createCtrl.showHelpPopup\" title=\"{{ 'close' | translate }}\">\n            <i class=\"fa fa-times-circle-o\"></i>\n        </a>\n        <h4 translate=\"appbuilder\">AppBuilder</h4>\n        <p translate=\"administrators-can-edit-existing-app-templates-directly-from-within-adoddle\">Administrators can edit existing App templates directly from within Adoddle.</p>\n        <p>\n            <b translate=\"step-1\">Step 1</b>\n        </p>\n        <p translate=\"edit-the-name-of-this-app-template-by-clicking-on-edit-icon-at-the-top\">Edit the name of this App template by clicking on Edit icon at the top.</p>\n        <p>\n            <b translate=\"step-2\">Step 2</b>\n        </p>\n        <p translate=\"use-the-available-controls-to-design-the-app-depending-on-your-needs\">Use the available controls to design the App depending on your needs.</p>\n        <p>\n            <b translate=\"step-3\">Step 3</b>\n        </p>\n        <p translate=\"click-save-icon-to-save-the-changes-to-the-app-template\">Click Save icon to save the changes to the App template.</p>\n        <p translate=\"to-learn-more-click\">To learn more click</p>\n        <div class=\"clearfix help-links\">\n            <div class=\"help-link\" ng-click=\"createCtrl.openHelpPage()\">\n                <img src=\"/assets/images/help.jpg\">\n            </div>\n            <div class=\"help-link\" ng-click=\"createCtrl.openELearning()\">\n                <img src=\"/assets/images/eLearning.jpg\">\n            </div>\n        </div>\n    </div>\n</div>\n</div>\n\n<script type=\"text/ng-template\" id=\"validation_template.html\">\n    <div class=\"ui-notification \" style=\"max-height:95vh;overflow: auto;\">\n        <div class=\"message\" ng-bind-html=\"message\"></div>\n        <div class=\"message clearfix\">\n            <a class=\"btn btn-sm btn-danger pull-right\" ng-click=\"save()\">Continue</a>\n        </div>\n    </div>\n</script>\n\n<script type=\"text/ng-template\" id=\"warning_before_leave_template.html\">\n    <div class=\"ui-notification \" style=\"max-height:95vh;overflow: auto;\">\n        <div class=\"message\" ng-bind-html=\"message\"></div>\n        <div class=\"message clearfix\">\n            <a class=\"btn btn-sm btn-danger pull-right\" ng-click=\"goBack()\">Continue</a>\n        </div>\n    </div>\n</script>\n\n<script type=\"text/ng-template\" id=\"infrom_msg_for_publish.html\">\n    <div class=\"ui-notification \" style=\"max-height:95vh;overflow: auto;\" ng-click=\"publishWarn(false)\">\n        <div class=\"message\" ng-bind-html=\"message\"></div>\n        <div class=\"message clearfix\">\n            <a class=\"btn btn-sm btn-danger pull-left\" title=\"Ctrl+Alt+P\" ng-click=\"publish()\">Publish</a>\n            <a class=\"btn btn-sm btn-danger pull-right\" title=\"Ctrl+Alt+C\" ng-click=\"goCancle()\">Cancel</a>\n        </div>\n    </div>\n</script>\n\n<script type=\"text/ng-template\" id=\"warning_before_remove_control.html\">\n    <div class=\"ui-notification \" style=\"max-height:95vh;overflow: auto;\">\n        <div class=\"message\" ng-bind=\"message | translate\"></div>\n        <div class=\"message clearfix\">\n            <a class=\"btn btn-sm btn-danger pull-right\" ng-click=\"\">No</a>\n            <a class=\"btn btn-sm btn-danger pull-right\" style=\"margin-right: 8px;\" ng-click=\"removeTitle()\">Yes</a>\n        </div>\n    </div>\n</script>\n\n<script type=\"text/ng-template\" id=\"warning_before_remove_copied.html\">\n    <div class=\"ui-notification \">\n        <div class=\"message\">\n          <p>You are about to delete the field which is referenced to other field/controls. Following actions will be taken across all the views if field is deleted: </p>\n          <p>1. Controls copied using 'Paste as read only' and 'Paste as calculated value' from this field will be deleted </p>\n          <p>Click on 'Continue' to delete the field, or 'Cancel' to cancel the operation.</p>\n        </div>\n        <div class=\"message clearfix\">\n            <a class=\"btn btn-sm btn-danger pull-right\" ng-click=\"\">Cancel</a>\n            <a class=\"btn btn-sm btn-danger pull-right\" style=\"margin-right: 8px;\" ng-click=\"removeCopied()\">Continue</a>\n        </div>\n    </div>\n</script>\n\n<script type=\"text/ng-template\" id=\"notification_dismiss.html\">\n        <div></div>\n</script>\n\n<script type=\"text/ng-template\" id=\"warning_before_delete.html\">\n    <div class=\"ui-notification \">\n        <div class=\"message\">\n          <p>You are about to delete the multiple field which is referenced to other field/controls. Following actions will be taken across all the views if field is deleted: </p>\n          <p>1. Controls copied using 'Paste as read only' and 'Paste as calculated value' from this field will be deleted </p>\n          <p>Click on 'Continue' to delete the field, or 'Cancel' to cancel the operation.</p>\n        </div>\n        <div class=\"message clearfix\">\n            <a class=\"btn btn-sm btn-danger pull-right\" ng-click=\"\">Cancel</a>\n            <a class=\"btn btn-sm btn-danger pull-right\" style=\"margin-right: 8px;\" ng-click=\"removeMultipleCopied()\">Continue</a>\n        </div>\n    </div>\n</script>\n\n<script type=\"text/ng-template\" id=\"warning_before_delete_selected.html\">\n    <div class=\"ui-notification \">\n        <div class=\"message\">\n          <p>You are about to delete the selected field which is referenced to other field/controls. Following actions will be taken across all the views if field is deleted: </p>\n          <p>1. Controls copied using 'Paste as read only' and 'Paste as calculated value' from this field will be deleted </p>\n          <p>Click on 'Continue' to delete the field, or 'Cancel' to cancel the operation.</p>\n        </div>\n        <div class=\"message clearfix\">\n            <a class=\"btn btn-sm btn-danger pull-right\" ng-click=\"\">Cancel</a>\n            <a class=\"btn btn-sm btn-danger pull-right\" style=\"margin-right: 8px;\" ng-click=\"removeSelectedOrAll()\">Continue</a>\n        </div>\n    </div>\n</script>\n\n<script type=\"text/ng-template\" id=\"warning_before_delete_all.html\">\n    <div class=\"ui-notification \">\n        <div class=\"message\">\n          <p>You are about to delete the all field which is referenced to other field/controls. Following actions will be taken across all the views if field is deleted: </p>\n          <p>1. Controls copied using 'Paste as read only' and 'Paste as calculated value' from this field will be deleted </p>\n          <p>Click on 'Continue' to delete the field, or 'Cancel' to cancel the operation.</p>\n        </div>\n        <div class=\"message clearfix\">\n            <a class=\"btn btn-sm btn-danger pull-right\" ng-click=\"\">Cancel</a>\n            <a class=\"btn btn-sm btn-danger pull-right\" style=\"margin-right: 8px;\" ng-click=\"removeSelectedOrAll()\">Continue</a>\n        </div>\n    </div>\n</script>\n\n<script type=\"text/ng-template\" id=\"map-popup.html\">\n\t<div class=\"modal-header\">\n\t\t<h3 class=\"modal-title\" translate=\"map\">Map</h3>\n\t</div>\n\t<div class=\"modal-body\">\n        <input type=\"text\" placeholder=\"{{ 'search' | translate }}\" id=\"map-search-box\" class=\"form-control\">\n        <button type=\"button\" class=\"btn btn-default btn-xs marker-reset\" ng-click=\"$ctrl.clearMarker()\">Clear</button>\n\t\t<div class=\"map\"></div>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button class=\"btn btn-danger\" type=\"button\" ng-click=\"$ctrl.save()\" ng-dblclick=\"return\" translate=\"ok\">OK</button>\n\t\t<button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.cancel()\" translate=\"cancel\">Cancel</button>\n\t</div>\n</script>\n\n<script type=\"text/ng-template\" id=\"globleCodeEditor.html\">\n\t<div class=\"modal-header\">\n        <h3 class=\"modal-title\">Code Editor</h3>\n        <button class=\"btn btn-default resize-btn\" type=\"button\" ng-if=\"!$ctrl.maximized\" title=\"Maximize\" ng-click=\"$ctrl.maximize()\">\n            <i class=\"fa fa-expand\"></i>\n        </button>\n        <button class=\"btn btn-default resize-btn\" type=\"button\" ng-if=\"$ctrl.maximized\" title=\"Minimize\" ng-click=\"$ctrl.minimize()\">\n            <i class=\"fa fa-compress\"></i>\n        </button>\n        <button class=\"btn btn-default resize-btn\" type=\"button\" ng-click=\"$ctrl.pasteGlobalBlockly()\" ng-disabled=\"$ctrl.isPasteDisabled()\" title=\"Paste\"><i class=\"fa fa-lg fa-paste\"></i></button>\n\t</div>\n\t<div class=\"modal-body code-editor-modal\" ng-class=\"{'loading': $ctrl.showSpinner }\">\n        <asite-blockly id=\"globleBlocklyCodeEditor\" globle-code-editor=\"true\" maximized=\"$ctrl.maximized\"></asite-blockly>\n    </div>\n\t<div class=\"modal-footer\">\n\t\t<button class=\"btn btn-danger\" type=\"button\" ng-click=\"$ctrl.save()\" translate=\"ok\">OK</button>\n\t\t<button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.cancel()\" translate=\"cancel\">Cancel</button>\n\t</div>\n</script>\n\n<script type=\"text/ng-template\" id=\"printSetting.html\">\n\t<div class=\"modal-header\">\n        <h3 class=\"modal-title\" translate=\"print.setting\">{{ 'print.setting' | translate }}</h3>\n\t</div>\n\t<div class=\"modal-body print-modal\" ng-class=\"{'loading': $ctrl.showSpinner }\">\n        <div class=\"form-data\" style=\"margin: 0px 20px;\">\n            <div class=\"form-group\">\n                <div class=\"form-inline api-field\">\n                    <label for=\"inputName\" translate=\"print.type\">{{ 'print.type' | translate }}</label>\n                </div>\n                <div class=\"form-inline\">\n                    <select \n                        class=\"form-control api-select\"\n                        name=\"type\"\n                        ng-model=\"$printctrl.printingOptions.type\"\n                        >\n                        <option value=\"false\">{{'basic.printing' | translate}}</option>\n                        <option value=\"true\">{{ 'advance.printing' | translate }}</option>\n                    </select>\n                </div>\n            </div>\n            <div class=\"form-group\" style=\"margin-top:5px;\">\n                    <div class=\"form-inline api-field\">\n                        <label for=\"inputName\">{{'print.orientation' | translate}}</label>\n                            <button type=\"button\" class=\"btn btn-default btn-xs addOnButton\"\n                            uib-popover-html=\"'Note: Applies to all PDF exports and automated print tasks; browser prints require manual adjustments and cannot be modified automatically.'\"\n                            popover-trigger=\"'mouseenter'\" popover-placement=\"bottom-left\"\n                            popover-class=\"popover-fit-screen\">\n                            <i class=\"fa fa-info\"></i>\n                            </button>\n                    </div>\n                    <div style=\"margin-left: 15px;di\">\n                        <div>\n                            <input type=\"radio\" id=\"portrait\" name=\"orientation-type\" ng-model=\"$printctrl.printingOptions.isLandscape\" translate=\"portrait\" value=\"false\"/>\n                            <label for=\"portrait\" title=\"{{'portrait' | translate}}\">{{'portrait' | translate}}</label>\n                        </div>\n                        <div>\n                            <input type=\"radio\" id=\"landscap\" name=\"orientation-type\" ng-model=\"$printctrl.printingOptions.isLandscape\" translate=\"landscap\" value=\"true\" />\n                            <label for=\"landscap\" title=\"{{'landscap' | translate}}\">{{'landscap' | translate}}</label>\n                        </div>\n                    </div>\n            </div>\n        </div>\n    </div>\n\t<div class=\"modal-footer\">\n\t\t<button class=\"btn btn-default\" type=\"button\" ng-click=\"$printctrl.cancel()\" translate=\"cancel\">Cancel</button>\n        <button class=\"btn btn-danger\" type=\"button\" ng-click=\"$printctrl.save()\" translate=\"Save\">Save</button>\n\t</div>\n</script>\n"

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var angular = __webpack_require__(1);
	var ControlProperties = __webpack_require__(297);
	/*@ngInject*/
	function localStorageService() {
	    var store = {
	        components: {
	            selected: null,
	            items: [
	                {
	                    type: 'Label',
	                    label: 'label',
	                    id: 1,
	                    cssclass: 'icon fa fa-font',
	                    properties: ControlProperties.LabelProperties
	                },
	                {
	                    type: 'Display field',
	                    label: 'display.field',
	                    id: 1,
	                    cssclass: 'icon fa fa-function',
	                    properties: ControlProperties.DisplayFieldPropertise
	                },
	                {
	                    type: 'Hyperlink',
	                    label: 'hyperlink',
	                    id: 1,
	                    cssclass: 'icon fa fa-link',
	                    properties: ControlProperties.HyperlinkProperties
	                },
	                {
	                    type: 'Textbox',
	                    label: 'textbox',
	                    id: 1,
	                    cssclass: 'icon fa fa-square-o',
	                    properties: ControlProperties.TextboxProperties
	                }, {
	                    type: 'Text-Area',
	                    label: 'textarea',
	                    id: 1,
	                    cssclass: 'icon fa fa-file-code-o',
	                    properties: ControlProperties.TextareaProperties
	                }, {
	                    type: 'Rich-Text-Box',
	                    label: 'rich.text.box',
	                    id: 1,
	                    cssclass: 'icon fa fa-file-code-o',
	                    properties: ControlProperties.RichTextAreaProperties
	                }, {
	                    type: 'Dropdown',
	                    label: 'dropdown',
	                    id: 1,
	                    cssclass: 'icon fa fa-caret-square-o-down',
	                    data: [],
	                    selectedItem: '',
	                    properties: ControlProperties.DropdownProperties
	                }, {
	                    type: 'MultiDropdown',
	                    label: 'multidropdown',
	                    id: 1,
	                    cssclass: 'icon fa fa-caret-square-o-down',
	                    data: [],
	                    selectedItem: '',
	                    properties: ControlProperties.MultiDropdownProperties
	                }, {
	                    type: 'Checkbox',
	                    label: 'checkbox',
	                    id: 1,
	                    cssclass: 'icon fa fa-check-square-o',
	                    properties: ControlProperties.CheckboxProperties
	                }, {
	                    type: 'Radio',
	                    label: 'radio',
	                    id: 1,
	                    cssclass: 'icon fa fa-dot-circle-o',
	                    properties: ControlProperties.RadioProperties
	                },
	                {
	                    type: 'Datepicker',
	                    label: 'date.picker',
	                    id: 1,
	                    cssclass: 'icon fa fa-calendar',
	                    properties: ControlProperties.DatepickerProperties
	                },
	                {
	                    type: 'Timepicker',
	                    label: 'time.picker',
	                    id: 1,
	                    cssclass: 'icon fa fa-clock-o',
	                    properties: ControlProperties.TimepickerProperties
	                },
	                {
	                    type: 'Map',
	                    label: 'map',
	                    id: 1,
	                    cssclass: 'icon fa fa-map-marker',
	                    properties: ControlProperties.MapProperties
	                },
	                {
	                    type: 'Image',
	                    label: 'image',
	                    id: 1,
	                    cssclass: 'icon fa fa-picture-o',
	                    properties: ControlProperties.ImageProperties
	                }, {
	                    type: 'Signature',
	                    label: 'signature',
	                    id: 1,
	                    cssclass: 'icon fa fa-pencil-square-o',
	                    properties: ControlProperties.SignatureProperties
	                },
	                {
	                    type: 'Attachment',
	                    label: 'attachment',
	                    id: 1,
	                    cssclass: 'icon fa fa-paperclip',
	                    properties: ControlProperties.AttachmentProperties
	                },
	                {
	                    type: 'Button',
	                    label: 'button',
	                    id: 1,
	                    cssclass: 'icon fa fa-plus',
	                    properties: ControlProperties.ButtonProperties
	                },
	                {
	                    type: 'SiteLocationButton',
	                    label: 'Site Location',
	                    id: 1,
	                    cssclass: 'icon fa fa-thumb-tack',
	                    properties: ControlProperties.SiteLocationButtonProperties
	                },
	                {
	                    type: 'ToggleButton',
	                    label: 'togglebutton',
	                    id: 1,
	                    cssclass: 'icon fa fa-toggle-on',
	                    properties: ControlProperties.ToggleButtonProperties
	                },
	                {
	                    type: 'Line',
	                    label: 'line',
	                    id: 1,
	                    cssclass: 'separator',
	                    properties: ControlProperties.LineProperties
	                },
	                {
	                    type: 'Rating',
	                    label: 'rating',
	                    id: 1,
	                    cssclass: 'icon fa fa-square-o',
	                    properties: ControlProperties.RatingProperties
	                },
	                {
	                    type: 'Layout',
	                    label: 'layout',
	                    id: 1,
	                    cssclass: 'icon fa fa-columns',
	                    data: [
	                        { elems: [[]] }, { elems: [[]] }
	                    ],
	                    ids: [],
	                    selectedRows: [],
	                    width: {},
	                    reset: false,
	                    columnMap: {
	                        1: 12,
	                        2: 6,
	                        3: 4,
	                        4: 3,
	                        5: 5,
	                        6: 2,
	                        7: 7,
	                        8: 8,
	                        9: 9,
	                        10: 10,
	                        11: 11,
	                        12: 1
	                    },
	                    properties: ControlProperties.LayoutProperties
	                },
	                {
	                    type: 'Section',
	                    label: 'section',
	                    id: 1,
	                    cssclass: 'icon fa fa-columns',
	                    data: { elems: [[]] },
	                    ids: [],
	                    reset: false,
	                    properties: ControlProperties.SectionProperties
	                },
	                {
	                    type: 'Table',
	                    label: 'table',
	                    id: 1,
	                    cssclass: 'icon fa fa-table',
	                    data: [
	                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
	                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
	                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }]
	                    ],
	                    ids: [],
	                    selectedRows: [],
	                    width: {},
	                    reset: false,
	                    columnMap: {
	                        1: 12,
	                        2: 6,
	                        3: 4,
	                        4: 3,
	                        5: 5,
	                        6: 2,
	                        7: 7,
	                        8: 8,
	                        9: 9,
	                        10: 10,
	                        11: 11,
	                        12: 1
	                    },
	                    properties: ControlProperties.TableProperties
	                },
	                {
	                    type: 'RepeatingTable',
	                    label: 'repeating.table',
	                    id: 1,
	                    cssclass: 'icon fa fa-table',
	                    data: [
	                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
	                    ],
	                    header_data: [
	                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
	                    ],
	                    footer_data: [
	                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
	                    ],
	                    ids: [],
	                    selectedRows: [],
	                    width: {},
	                    reset: false,
	                    columnMap: {
	                        1: 12,
	                        2: 6,
	                        3: 4,
	                        4: 3,
	                        5: 5,
	                        6: 2,
	                        7: 7,
	                        8: 8,
	                        9: 9,
	                        10: 10,
	                        11: 11,
	                        12: 1
	                    },
	                    properties: ControlProperties.RepeatingTableProperties
	                },
	                {
	                    type: 'InlineAssocFiles',
	                    label: 'inline.assoc.files',
	                    id: 1,
	                    cssclass: 'fa fa-file-o',
	                    data: [
	                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
	                    ],
	                    header_data: [
	                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
	                    ],
	                    footer_data: [
	                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
	                    ],
	                    ids: [],
	                    selectedRows: [],
	                    width: {},
	                    reset: false,
	                    columnMap: {
	                        1: 12,
	                        2: 6,
	                        3: 4,
	                        4: 3,
	                        5: 5,
	                        6: 2,
	                        7: 7,
	                        8: 8,
	                        9: 9,
	                        10: 10,
	                        11: 11,
	                        12: 1
	                    },
	                    properties: ControlProperties.InlineAssocFiles
	                },
	                {
	                    type: 'InlineAssocApps',
	                    label: 'inline.assoc.apps',
	                    id: 1,
	                    cssclass: 'fa fa-file-text-o',
	                    data: [
	                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
	                    ],
	                    header_data: [
	                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
	                    ],
	                    footer_data: [
	                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
	                    ],
	                    ids: [],
	                    selectedRows: [],
	                    width: {},
	                    reset: false,
	                    columnMap: {
	                        1: 12,
	                        2: 6,
	                        3: 4,
	                        4: 3,
	                        5: 5,
	                        6: 2,
	                        7: 7,
	                        8: 8,
	                        9: 9,
	                        10: 10,
	                        11: 11,
	                        12: 1
	                    },
	                    properties: ControlProperties.InlineAssocApps
	                },
	                {
	                    type: 'ViewAssociations',
	                    label: 'view.associations',
	                    id: 1,
	                    cssclass: 'fa fa-file-text-o',
	                    data: [
	                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
	                    ],
	                    header_data: [
	                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
	                    ],
	                    footer_data: [
	                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
	                    ],
	                    ids: [],
	                    selectedRows: [],
	                    width: {},
	                    reset: false,
	                    columnMap: {
	                        1: 12,
	                        2: 6,
	                        3: 4,
	                        4: 3,
	                        5: 5,
	                        6: 2,
	                        7: 7,
	                        8: 8,
	                        9: 9,
	                        10: 10,
	                        11: 11,
	                        12: 1
	                    },
	                    properties: ControlProperties.ViewAssociations
	                }
	            ]
	        },
	        views: {
	            'ORI_VIEW': {
	                editing: false,
	                controls: {
	                    'A': []
	                },
	                viewName: 'ORI_VIEW'
	            }
	        },
	        selectedView: {
	            view: {}
	        },
	        Languages: {},
	        templates: {
	            items: [
	                {
	                    type: 'ReviewTemplate',
	                    label: 'reviewtemplatelabel',
	                    id: 1,
	                    cssclass: 'icon fa fa-font',
	                    name: 'reviewcomponent'
	                },
	            ]
	        },
	        numberFormatEnabled: false
	    };
	    function getData(key) {
	        return store[key];
	    }
	    ;
	    function setData(key, value) {
	        store[key] = value;
	    }
	    ;
	    return {
	        set: setData,
	        get: getData
	    };
	}
	exports.localStorageService = localStorageService;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = angular.module('nodeApp.localStorage', [])
	    .service('localStorage', localStorageService)
	    .name;


/***/ }),
/* 334 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.3.10
	 * (c) 2010-2014 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	!function(a,b,c){"use strict";/**
	 * @ngdoc module
	 * @name ngSanitize
	 * @description
	 *
	 * # ngSanitize
	 *
	 * The `ngSanitize` module provides functionality to sanitize HTML.
	 *
	 *
	 * <div doc-module-components="ngSanitize"></div>
	 *
	 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	 */
	/*
	 * HTML Parser By Misko Hevery (misko@hevery.com)
	 * based on:  HTML Parser By John Resig (ejohn.org)
	 * Original code by Erik Arvidsson, Mozilla Public License
	 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
	 *
	 * // Use like so:
	 * htmlParser(htmlString, {
	 *     start: function(tag, attrs, unary) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * });
	 *
	 */
	/**
	 * @ngdoc service
	 * @name $sanitize
	 * @kind function
	 *
	 * @description
	 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
	 *   then serialized back to properly escaped html string. This means that no unsafe input can make
	 *   it into the returned string, however, since our parser is more strict than a typical browser
	 *   parser, it's possible that some obscure input, which would be recognized as valid HTML by a
	 *   browser, won't make it through the sanitizer. The input may also contain SVG markup.
	 *   The whitelist is configured using the functions `aHrefSanitizationWhitelist` and
	 *   `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider `$compileProvider`}.
	 *
	 * @param {string} html HTML input.
	 * @returns {string} Sanitized HTML.
	 *
	 * @example
	   <example module="sanitizeExample" deps="angular-sanitize.js">
	   <file name="index.html">
	     <script>
	         angular.module('sanitizeExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	             $scope.snippet =
	               '<p style="color:blue">an html\n' +
	               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	               'snippet</p>';
	             $scope.deliberatelyTrustDangerousSnippet = function() {
	               return $sce.trustAsHtml($scope.snippet);
	             };
	           }]);
	     </script>
	     <div ng-controller="ExampleController">
	        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Directive</td>
	           <td>How</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="bind-html-with-sanitize">
	           <td>ng-bind-html</td>
	           <td>Automatically uses $sanitize</td>
	           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind-html="snippet"></div></td>
	         </tr>
	         <tr id="bind-html-with-trust">
	           <td>ng-bind-html</td>
	           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	           <td>
	           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	&lt;/div&gt;</pre>
	           </td>
	           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	         </tr>
	         <tr id="bind-default">
	           <td>ng-bind</td>
	           <td>Automatically escapes</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	       </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should sanitize the html snippet by default', function() {
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	     });
	
	     it('should inline raw snippet if bound to a trusted value', function() {
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).
	         toBe("<p style=\"color:blue\">an html\n" +
	              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	              "snippet</p>");
	     });
	
	     it('should escape snippet without any filter', function() {
	       expect(element(by.css('#bind-default div')).getInnerHtml()).
	         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	              "snippet&lt;/p&gt;");
	     });
	
	     it('should update', function() {
	       element(by.model('snippet')).clear();
	       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('new <b>text</b>');
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).toBe(
	         'new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-default div')).getInnerHtml()).toBe(
	         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	     });
	   </file>
	   </example>
	 */
	function d(){this.$get=["$$sanitizeUri",function(a){return function(b){"undefined"!=typeof arguments[1]&&(arguments[1].version="taSanitize");var c=[];return g(b,l(c,function(b,c){return!/^unsafe/.test(a(b,c))})),c.join("")}}]}function e(a){var c=[],d=l(c,b.noop);return d.chars(a),c.join("")}function f(a){var b,c={},d=a.split(",");for(b=0;b<d.length;b++)c[d[b]]=!0;return c}/**
	 * @example
	 * htmlParser(htmlString, {
	 *     start: function(tag, attrs, unary) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * });
	 *
	 * @param {string} html string
	 * @param {object} handler
	 */
	function g(a,c){function d(a,d,f,g){if(d=b.lowercase(d),D[d])for(;k.last()&&E[k.last()];)e("",k.last());C[d]&&k.last()==d&&e("",d),g=z[d]||!!g,g||k.push(d);var i={};f.replace(p,function(a,b,c,d,e){var f=c||d||e||"";i[b]=h(f)}),c.start&&c.start(d,i,g)}function e(a,d){var e,f=0;if(d=b.lowercase(d))
	// Find the closest opened tag of the same type
	for(f=k.length-1;f>=0&&k[f]!=d;f--);if(f>=0){
	// Close all the open elements, up the stack
	for(e=k.length-1;e>=f;e--)c.end&&c.end(k[e]);
	// Remove the open elements from the stack
	k.length=f}}"string"!=typeof a&&(a=null===a||"undefined"==typeof a?"":""+a);var f,g,i,j,k=[],l=a;for(k.last=function(){return k[k.length-1]};a;){
	// Make sure we're not in a script or style element
	if(j="",g=!0,k.last()&&G[k.last()])a=a.replace(new RegExp("([^]*)<\\s*\\/\\s*"+k.last()+"[^>]*>","i"),function(a,b){return b=b.replace(s,"$1").replace(v,"$1"),c.chars&&c.chars(h(b)),""}),e("",k.last());else{
	// White space
	if(y.test(a)){if(i=a.match(y)){i[0];c.whitespace&&c.whitespace(i[0]),a=a.replace(i[0],""),g=!1}}else t.test(a)?(i=a.match(t),i&&(c.comment&&c.comment(i[1]),a=a.replace(i[0],""),g=!1)):u.test(a)?(i=a.match(u),i&&(a=a.replace(i[0],""),g=!1)):r.test(a)?(i=a.match(o),i&&(a=a.substring(i[0].length),i[0].replace(o,e),g=!1)):q.test(a)&&(i=a.match(n),i?(
	// We only have a valid start-tag if there is a '>'.
	i[4]&&(a=a.substring(i[0].length),i[0].replace(n,d)),g=!1):(
	// no ending tag found --- this piece should be encoded as an entity.
	j+="<",a=a.substring(1)));g&&(f=a.indexOf("<"),j+=f<0?a:a.substring(0,f),a=f<0?"":a.substring(f),c.chars&&c.chars(h(j)))}if(a==l)throw m("badparse","The sanitizer was unable to parse the following block of html: {0}",a);l=a}
	// Clean up any remaining tags
	e()}/**
	 * decodes all entities into regular string
	 * @param value
	 * @returns {string} A string with decoded entities.
	 */
	function h(a){if(!a)return"";
	// Note: IE8 does not preserve spaces at the start/end of innerHTML
	// so we must capture them and reattach them afterward
	var b=N.exec(a),c=b[1],d=b[3],e=b[2];
	// innerText depends on styling as it doesn't display hidden elements.
	// Therefore, it's better to use textContent not to cause unnecessary
	// reflows. However, IE<9 don't support textContent so the innerText
	// fallback is necessary.
	return e&&(M.innerHTML=e.replace(/</g,"&lt;"),e="textContent"in M?M.textContent:M.innerText),c+e+d}/**
	 * Escapes all potentially dangerous characters, so that the
	 * resulting string can be safely inserted into attribute or
	 * element text.
	 * @param value
	 * @returns {string} escaped text
	 */
	function i(a){return a.replace(/&/g,"&amp;").replace(w,function(a){var b=a.charCodeAt(0),c=a.charCodeAt(1);return"&#"+(1024*(b-55296)+(c-56320)+65536)+";"}).replace(x,function(a){
	// unsafe chars are: \u0000-\u001f \u007f-\u009f \u00ad \u0600-\u0604 \u070f \u17b4 \u17b5 \u200c-\u200f \u2028-\u202f \u2060-\u206f \ufeff \ufff0-\uffff from jslint.com/lint.html
	// decimal values are: 0-31, 127-159, 173, 1536-1540, 1807, 6068, 6069, 8204-8207, 8232-8239, 8288-8303, 65279, 65520-65535
	var b=a.charCodeAt(0);
	// if unsafe character encode
	// if unsafe character encode
	return b<=159||173==b||b>=1536&&b<=1540||1807==b||6068==b||6069==b||b>=8204&&b<=8207||b>=8232&&b<=8239||b>=8288&&b<=8303||65279==b||b>=65520&&b<=65535?"&#"+b+";":a}).replace(/</g,"&lt;").replace(/>/g,"&gt;")}
	// Custom logic for accepting certain style options only - textAngular
	// Currently allows only the color, background-color, text-align, float, width and height attributes
	// all other attributes should be easily done through classes.
	function j(a){var c="",d=a.split(";");return b.forEach(d,function(a){var d=a.split(":");if(2==d.length){var e=O(b.lowercase(d[0])),a=O(b.lowercase(d[1]));(("color"===e||"background-color"===e)&&(a.match(/^rgb\([0-9%,\. ]*\)$/i)||a.match(/^rgba\([0-9%,\. ]*\)$/i)||a.match(/^hsl\([0-9%,\. ]*\)$/i)||a.match(/^hsla\([0-9%,\. ]*\)$/i)||a.match(/^#[0-9a-f]{3,6}$/i)||a.match(/^[a-z]*$/i))||"text-align"===e&&("left"===a||"right"===a||"center"===a||"justify"===a)||"text-decoration"===e&&("underline"===a||"line-through"===a)||"font-weight"===e&&"bold"===a||"font-style"===e&&"italic"===a||"float"===e&&("left"===a||"right"===a||"none"===a)||"vertical-align"===e&&("baseline"===a||"sub"===a||"super"===a||"test-top"===a||"text-bottom"===a||"middle"===a||"top"===a||"bottom"===a||a.match(/[0-9]*(px|em)/)||a.match(/[0-9]+?%/))||"font-size"===e&&("xx-small"===a||"x-small"===a||"small"===a||"medium"===a||"large"===a||"x-large"===a||"xx-large"===a||"larger"===a||"smaller"===a||a.match(/[0-9]*\.?[0-9]*(px|em|rem|mm|q|cm|in|pt|pc|%)/))||("width"===e||"height"===e)&&a.match(/[0-9\.]*(px|em|rem|%)/)||// Reference #520
	"direction"===e&&a.match(/^ltr|rtl|initial|inherit$/))&&(c+=e+": "+a+";")}}),c}
	// this function is used to manually allow specific attributes on specific tags with certain prerequisites
	function k(a,b,c,d){
	// catch the div placeholder for the iframe replacement
	return!("img"!==a||!b["ta-insert-video"]||"ta-insert-video"!==c&&"allowfullscreen"!==c&&"frameborder"!==c&&("contenteditable"!==c||"false"!==d))}/**
	 * create an HTML/XML writer which writes to buffer
	 * @param {Array} buf use buf.jain('') to get out sanitized html string
	 * @returns {object} in the form of {
	 *     start: function(tag, attrs, unary) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * }
	 */
	function l(a,c){var d=!1,e=b.bind(a,a.push);return{start:function(a,f,g){a=b.lowercase(a),!d&&G[a]&&(d=a),d||H[a]!==!0||(e("<"),e(a),b.forEach(f,function(d,g){var h=b.lowercase(g),l="img"===a&&"src"===h||"background"===h;("style"===h&&""!==(d=j(d))||k(a,f,h,d)||L[h]===!0&&(I[h]!==!0||c(d,l)))&&(e(" "),e(g),e('="'),e(i(d)),e('"'))}),e(g?"/>":">"))},comment:function(a){e(a)},whitespace:function(a){e(i(a))},end:function(a){a=b.lowercase(a),d||H[a]!==!0||(e("</"),e(a),e(">")),a==d&&(d=!1)},chars:function(a){d||e(i(a))}}}var m=b.$$minErr("$sanitize"),n=/^<((?:[a-zA-Z])[\w:-]*)((?:\s+[\w:-]+(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)\s*(>?)/,o=/^<\/\s*([\w:-]+)[^>]*>/,p=/([\w:-]+)(?:\s*=\s*(?:(?:"((?:[^"])*)")|(?:'((?:[^'])*)')|([^>\s]+)))?/g,q=/^</,r=/^<\//,s=/<!--(.*?)-->/g,t=/(^<!--.*?-->)/,u=/<!DOCTYPE([^>]*?)>/i,v=/<!\[CDATA\[(.*?)]]>/g,w=/[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	// Match everything outside of normal chars and " (quote character)
	x=/([^\#-~| |!])/g,y=/^(\s+)/,z=f("area,br,col,hr,img,wbr,input"),A=f("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),B=f("rp,rt"),C=b.extend({},B,A),D=b.extend({},A,f("address,article,aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,script,section,table,ul")),E=b.extend({},B,f("a,abbr,acronym,b,bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,samp,small,span,strike,strong,sub,sup,time,tt,u,var")),F=f("animate,animateColor,animateMotion,animateTransform,circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,radialGradient,rect,set,stop,svg,switch,text,title,tspan,use"),G=f("script,style"),H=b.extend({},z,D,E,C,F),I=f("background,cite,href,longdesc,src,usemap,xlink:href"),J=f("abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,id,ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,scope,scrolling,shape,size,span,start,summary,target,title,type,valign,value,vspace,width"),K=f("accent-height,accumulate,additive,alphabetic,arabic-form,ascent,attributeName,attributeType,baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan"),L=b.extend({},I,K,J),M=document.createElement("pre"),N=/^(\s*)([\s\S]*?)(\s*)$/,O=function(){
	// native trim is way faster: http://jsperf.com/angular-trim-test
	// but IE doesn't have it... :-(
	// TODO: we should move this into IE/ES5 polyfill
	// native trim is way faster: http://jsperf.com/angular-trim-test
	// but IE doesn't have it... :-(
	// TODO: we should move this into IE/ES5 polyfill
	return String.prototype.trim?function(a){return b.isString(a)?a.trim():a}:function(a){return b.isString(a)?a.replace(/^\s\s*/,"").replace(/\s\s*$/,""):a}}();
	// define ngSanitize module and register $sanitize service
	b.module("ngSanitize",[]).provider("$sanitize",d),/* global sanitizeText: false */
	/**
	 * @ngdoc filter
	 * @name linky
	 * @kind function
	 *
	 * @description
	 * Finds links in text input and turns them into html links. Supports http/https/ftp/mailto and
	 * plain email address links.
	 *
	 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	 *
	 * @param {string} text Input text.
	 * @param {string} target Window (_blank|_self|_parent|_top) or named frame to open links in.
	 * @returns {string} Html-linkified text.
	 *
	 * @usage
	   <span ng-bind-html="linky_expression | linky"></span>
	 *
	 * @example
	   <example module="linkyExample" deps="angular-sanitize.js">
	     <file name="index.html">
	       <script>
	         angular.module('linkyExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.snippet =
	               'Pretty text with some links:\n'+
	               'http://angularjs.org/,\n'+
	               'mailto:us@somewhere.org,\n'+
	               'another@somewhere.org,\n'+
	               'and one more: ftp://127.0.0.1/.';
	             $scope.snippetWithTarget = 'http://angularjs.org/';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Filter</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="linky-filter">
	           <td>linky filter</td>
	           <td>
	             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	           </td>
	           <td>
	             <div ng-bind-html="snippet | linky"></div>
	           </td>
	         </tr>
	         <tr id="linky-target">
	          <td>linky target</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithTarget | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithTarget | linky:'_blank'"></div>
	          </td>
	         </tr>
	         <tr id="escaped-html">
	           <td>no filter</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should linkify the snippet with urls', function() {
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	       });
	
	       it('should not linkify snippet without the linky filter', function() {
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	       });
	
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new http://link.');
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('new http://link.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	             .toBe('new http://link.');
	       });
	
	       it('should work with the target property', function() {
	        expect(element(by.id('linky-target')).
	            element(by.binding("snippetWithTarget | linky:'_blank'")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	       });
	     </file>
	   </example>
	 */
	b.module("ngSanitize").filter("linky",["$sanitize",function(a){var c=/((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"”’]/,d=/^mailto:/;return function(f,g){function h(a){a&&n.push(e(a))}function i(a,c){n.push("<a "),b.isDefined(g)&&n.push('target="',g,'" '),n.push('href="',a.replace(/"/g,"&quot;"),'">'),h(c),n.push("</a>")}if(!f)return f;for(var j,k,l,m=f,n=[];j=m.match(c);)
	// We can not end in these as they are sometimes found at the end of the sentence
	k=j[0],
	// if we did not match ftp/http/www/mailto then assume mailto
	j[2]||j[4]||(k=(j[3]?"http://":"mailto:")+k),l=j.index,h(m.substr(0,l)),i(k,j[0].replace(d,"")),m=m.substring(l+j[0].length);return h(m),a(n.join(""))}}])}(window,window.angular);

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(336),__webpack_require__(337)], __WEBPACK_AMD_DEFINE_RESULT__ = function (a0,b1) {
	      return (root['textAngular.name'] = factory(a0,b1));
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory(require("rangy"),require("rangy/lib/rangy-selectionsaverestore"));
	  } else {
	    root['textAngular'] = factory(rangy);
	  }
	}(this, function (rangy) {
	
	
	// tests against the current jqLite/jquery implementation if this can be an element
	function validElementString(string){
	    try{
	        return angular.element(string).length !== 0;
	    }catch(any){
	        return false;
	    }
	}
	// setup the global contstant functions for setting up the toolbar
	
	// all tool definitions
	var taTools = {};
	/*
	    A tool definition is an object with the following key/value parameters:
	        action: [function(deferred, restoreSelection)]
	                a function that is executed on clicking on the button - this will allways be executed using ng-click and will
	                overwrite any ng-click value in the display attribute.
	                The function is passed a deferred object ($q.defer()), if this is wanted to be used `return false;` from the action and
	                manually call `deferred.resolve();` elsewhere to notify the editor that the action has finished.
	                restoreSelection is only defined if the rangy library is included and it can be called as `restoreSelection()` to restore the users
	                selection in the WYSIWYG editor.
	        display: [string]?
	                Optional, an HTML element to be displayed as the button. The `scope` of the button is the tool definition object with some additional functions
	                If set this will cause buttontext and iconclass to be ignored
	        class: [string]?
	                Optional, if set will override the taOptions.classes.toolbarButton class.
	        buttontext: [string]?
	                if this is defined it will replace the contents of the element contained in the `display` element
	        iconclass: [string]?
	                if this is defined an icon (<i>) will be appended to the `display` element with this string as it's class
	        tooltiptext: [string]?
	                Optional, a plain text description of the action, used for the title attribute of the action button in the toolbar by default.
	        activestate: [function(commonElement)]?
	                this function is called on every caret movement, if it returns true then the class taOptions.classes.toolbarButtonActive
	                will be applied to the `display` element, else the class will be removed
	        disabled: [function()]?
	                if this function returns true then the tool will have the class taOptions.classes.disabled applied to it, else it will be removed
	    Other functions available on the scope are:
	        name: [string]
	                the name of the tool, this is the first parameter passed into taRegisterTool
	        isDisabled: [function()]
	                returns true if the tool is disabled, false if it isn't
	        displayActiveToolClass: [function(boolean)]
	                returns true if the tool is 'active' in the currently focussed toolbar
	        onElementSelect: [Object]
	                This object contains the following key/value pairs and is used to trigger the ta-element-select event
	                element: [String]
	                    an element name, will only trigger the onElementSelect action if the tagName of the element matches this string
	                filter: [function(element)]?
	                    an optional filter that returns a boolean, if true it will trigger the onElementSelect.
	                action: [function(event, element, editorScope)]
	                    the action that should be executed if the onElementSelect function runs
	*/
	// name and toolDefinition to add into the tools available to be added on the toolbar
	function registerTextAngularTool(name, toolDefinition){
	    if(!name || name === '' || taTools.hasOwnProperty(name)) throw('textAngular Error: A unique name is required for a Tool Definition');
	    if(
	        (toolDefinition.display && (toolDefinition.display === '' || !validElementString(toolDefinition.display))) ||
	        (!toolDefinition.display && !toolDefinition.buttontext && !toolDefinition.iconclass)
	    )
	        throw('textAngular Error: Tool Definition for "' + name + '" does not have a valid display/iconclass/buttontext value');
	    taTools[name] = toolDefinition;
	}
	
	angular.module('textAngularSetup', [])
	.constant('taRegisterTool', registerTextAngularTool)
	.value('taTools', taTools)
	// Here we set up the global display defaults, to set your own use a angular $provider#decorator.
	.value('taOptions',  {
	    //////////////////////////////////////////////////////////////////////////////////////
	    // forceTextAngularSanitize
	    // set false to allow the textAngular-sanitize provider to be replaced
	    // with angular-sanitize or a custom provider.
	    forceTextAngularSanitize: true,
	    ///////////////////////////////////////////////////////////////////////////////////////
	    // keyMappings
	    // allow customizable keyMappings for specialized key boards or languages
	    //
	    // keyMappings provides key mappings that are attached to a given commandKeyCode.
	    // To modify a specific keyboard binding, simply provide function which returns true
	    // for the event you wish to map to.
	    // Or to disable a specific keyboard binding, provide a function which returns false.
	    // Note: 'RedoKey' and 'UndoKey' are internally bound to the redo and undo functionality.
	    // At present, the following commandKeyCodes are in use:
	    // 98, 'TabKey', 'ShiftTabKey', 105, 117, 'UndoKey', 'RedoKey'
	    //
	    // To map to an new commandKeyCode, add a new key mapping such as:
	    // {commandKeyCode: 'CustomKey', testForKey: function (event) {
	    //  if (event.keyCode=57 && event.ctrlKey && !event.shiftKey && !event.altKey) return true;
	    // } }
	    // to the keyMappings. This example maps ctrl+9 to 'CustomKey'
	    // Then where taRegisterTool(...) is called, add a commandKeyCode: 'CustomKey' and your
	    // tool will be bound to ctrl+9.
	    //
	    // To disble one of the already bound commandKeyCodes such as 'RedoKey' or 'UndoKey' add:
	    // {commandKeyCode: 'RedoKey', testForKey: function (event) { return false; } },
	    // {commandKeyCode: 'UndoKey', testForKey: function (event) { return false; } },
	    // to disable them.
	    //
	    keyMappings : [],
	    toolbar: [
	        ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote'],
	        ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
	        ['justifyLeft','justifyCenter','justifyRight','justifyFull','indent','outdent'],
	        ['html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
	    ],
	    classes: {
	        focussed: "focussed",
	        toolbar: "btn-toolbar",
	        toolbarGroup: "btn-group",
	        toolbarButton: "btn btn-default",
	        toolbarButtonActive: "active",
	        disabled: "disabled",
	        textEditor: 'form-control',
	        htmlEditor: 'form-control'
	    },
	    defaultTagAttributes : {
	        a: {target:""}
	    },
	    setup: {
	        // wysiwyg mode
	        textEditorSetup: function($element){ /* Do some processing here */ },
	        // raw html
	        htmlEditorSetup: function($element){ /* Do some processing here */ }
	    },
	    defaultFileDropHandler:
	        /* istanbul ignore next: untestable image processing */
	        function(file, insertAction){
	            var reader = new FileReader();
	            if(file.type.substring(0, 5) === 'image'){
	                reader.onload = function() {
	                    if(reader.result !== '') insertAction('insertImage', reader.result, true);
	                };
	
	                reader.readAsDataURL(file);
	                // NOTE: For async procedures return a promise and resolve it when the editor should update the model.
	                return true;
	            }
	            return false;
	        }
	})
	
	// This is the element selector string that is used to catch click events within a taBind, prevents the default and $emits a 'ta-element-select' event
	// these are individually used in an angular.element().find() call. What can go here depends on whether you have full jQuery loaded or just jQLite with angularjs.
	// div is only used as div.ta-insert-video caught in filter.
	.value('taSelectableElements', ['a','img'])
	
	// This is an array of objects with the following options:
	//				selector: <string> a jqLite or jQuery selector string
	//				customAttribute: <string> an attribute to search for
	//				renderLogic: <function(element)>
	// Both or one of selector and customAttribute must be defined.
	.value('taCustomRenderers', [
	    {
	        // Parse back out: '<div class="ta-insert-video" ta-insert-video src="' + urlLink + '" allowfullscreen="true" width="300" frameborder="0" height="250"></div>'
	        // To correct video element. For now only support youtube
	        selector: 'img',
	        customAttribute: 'ta-insert-video',
	        renderLogic: function(element){
	            var iframe = angular.element('<iframe></iframe>');
	            var attributes = element.prop("attributes");
	            // loop through element attributes and apply them on iframe
	            angular.forEach(attributes, function(attr) {
	                iframe.attr(attr.name, attr.value);
	            });
	            iframe.attr('src', iframe.attr('ta-insert-video'));
	            element.replaceWith(iframe);
	        }
	    }
	])
	
	.value('taTranslations', {
	    // moved to sub-elements
	    //toggleHTML: "Toggle HTML",
	    //insertImage: "Please enter a image URL to insert",
	    //insertLink: "Please enter a URL to insert",
	    //insertVideo: "Please enter a youtube URL to embed",
	    html: {
	        tooltip: 'Toggle html / Rich Text'
	    },
	    // tooltip for heading - might be worth splitting
	    heading: {
	        tooltip: 'Heading '
	    },
	    p: {
	        tooltip: 'Paragraph'
	    },
	    pre: {
	        tooltip: 'Preformatted text'
	    },
	    ul: {
	        tooltip: 'Unordered List'
	    },
	    ol: {
	        tooltip: 'Ordered List'
	    },
	    quote: {
	        tooltip: 'Quote/unquote selection or paragraph'
	    },
	    undo: {
	        tooltip: 'Undo'
	    },
	    redo: {
	        tooltip: 'Redo'
	    },
	    bold: {
	        tooltip: 'Bold'
	    },
	    italic: {
	        tooltip: 'Italic'
	    },
	    underline: {
	        tooltip: 'Underline'
	    },
	    strikeThrough:{
	        tooltip: 'Strikethrough'
	    },
	    justifyLeft: {
	        tooltip: 'Align text left'
	    },
	    justifyRight: {
	        tooltip: 'Align text right'
	    },
	    justifyFull: {
	        tooltip: 'Justify text'
	    },
	    justifyCenter: {
	        tooltip: 'Center'
	    },
	    indent: {
	        tooltip: 'Increase indent'
	    },
	    outdent: {
	        tooltip: 'Decrease indent'
	    },
	    clear: {
	        tooltip: 'Clear formatting'
	    },
	    insertImage: {
	        dialogPrompt: 'Please enter an image URL to insert',
	        tooltip: 'Insert image',
	        hotkey: 'the - possibly language dependent hotkey ... for some future implementation'
	    },
	    insertVideo: {
	        tooltip: 'Insert video',
	        dialogPrompt: 'Please enter a youtube URL to embed'
	    },
	    insertLink: {
	        tooltip: 'Insert / edit link',
	        dialogPrompt: "Please enter a URL to insert"
	    },
	    editLink: {
	        reLinkButton: {
	            tooltip: "Relink"
	        },
	        unLinkButton: {
	            tooltip: "Unlink"
	        },
	        targetToggle: {
	            buttontext: "Open in New Window"
	        }
	    },
	    wordcount: {
	        tooltip: 'Display words Count'
	    },
	        charcount: {
	        tooltip: 'Display characters Count'
	    }
	})
	.factory('taToolFunctions', ['$window','taTranslations', function($window, taTranslations) {
	    return {
	        imgOnSelectAction: function(event, $element, editorScope){
	            // setup the editor toolbar
	            // Credit to the work at http://hackerwins.github.io/summernote/ for this editbar logic/display
	            var finishEdit = function(){
	                editorScope.updateTaBindtaTextElement();
	                editorScope.hidePopover();
	            };
	            event.preventDefault();
	            editorScope.displayElements.popover.css('width', '375px');
	            var container = editorScope.displayElements.popoverContainer;
	            container.empty();
	            var buttonGroup = angular.element('<div class="btn-group" style="padding-right: 6px;">');
	            var fullButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">100% </button>');
	            fullButton.on('click', function(event){
	                event.preventDefault();
	                $element.css({
	                    'width': '100%',
	                    'height': ''
	                });
	                finishEdit();
	            });
	            var halfButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">50% </button>');
	            halfButton.on('click', function(event){
	                event.preventDefault();
	                $element.css({
	                    'width': '50%',
	                    'height': ''
	                });
	                finishEdit();
	            });
	            var quartButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">25% </button>');
	            quartButton.on('click', function(event){
	                event.preventDefault();
	                $element.css({
	                    'width': '25%',
	                    'height': ''
	                });
	                finishEdit();
	            });
	            var resetButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">Reset</button>');
	            resetButton.on('click', function(event){
	                event.preventDefault();
	                $element.css({
	                    width: '',
	                    height: ''
	                });
	                finishEdit();
	            });
	            buttonGroup.append(fullButton);
	            buttonGroup.append(halfButton);
	            buttonGroup.append(quartButton);
	            buttonGroup.append(resetButton);
	            container.append(buttonGroup);
	
	            buttonGroup = angular.element('<div class="btn-group" style="padding-right: 6px;">');
	            var floatLeft = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-left"></i></button>');
	            floatLeft.on('click', function(event){
	                event.preventDefault();
	                // webkit
	                $element.css('float', 'left');
	                // firefox
	                $element.css('cssFloat', 'left');
	                // IE < 8
	                $element.css('styleFloat', 'left');
	                finishEdit();
	            });
	            var floatRight = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-right"></i></button>');
	            floatRight.on('click', function(event){
	                event.preventDefault();
	                // webkit
	                $element.css('float', 'right');
	                // firefox
	                $element.css('cssFloat', 'right');
	                // IE < 8
	                $element.css('styleFloat', 'right');
	                finishEdit();
	            });
	            var floatNone = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-justify"></i></button>');
	            floatNone.on('click', function(event){
	                event.preventDefault();
	                // webkit
	                $element.css('float', '');
	                // firefox
	                $element.css('cssFloat', '');
	                // IE < 8
	                $element.css('styleFloat', '');
	                finishEdit();
	            });
	            buttonGroup.append(floatLeft);
	            buttonGroup.append(floatNone);
	            buttonGroup.append(floatRight);
	            container.append(buttonGroup);
	
	            buttonGroup = angular.element('<div class="btn-group">');
	            var remove = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-trash-o"></i></button>');
	            remove.on('click', function(event){
	                event.preventDefault();
	                $element.remove();
	                finishEdit();
	            });
	            buttonGroup.append(remove);
	            container.append(buttonGroup);
	
	            editorScope.showPopover($element);
	            editorScope.showResizeOverlay($element);
	        },
	        aOnSelectAction: function(event, $element, editorScope){
	            // setup the editor toolbar
	            // Credit to the work at http://hackerwins.github.io/summernote/ for this editbar logic
	            event.preventDefault();
	            editorScope.displayElements.popover.css('width', '436px');
	            var container = editorScope.displayElements.popoverContainer;
	            container.empty();
	            container.css('line-height', '28px');
	            var link = angular.element('<a href="' + $element.attr('href') + '" target="_blank">' + $element.attr('href') + '</a>');
	            link.css({
	                'display': 'inline-block',
	                'max-width': '200px',
	                'overflow': 'hidden',
	                'text-overflow': 'ellipsis',
	                'white-space': 'nowrap',
	                'vertical-align': 'middle'
	            });
	            container.append(link);
	            var buttonGroup = angular.element('<div class="btn-group pull-right">');
	            var reLinkButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on" title="' + taTranslations.editLink.reLinkButton.tooltip + '"><i class="fa fa-edit icon-edit"></i></button>');
	            reLinkButton.on('click', function(event){
	                event.preventDefault();
	                var urlLink = $window.prompt(taTranslations.insertLink.dialogPrompt, $element.attr('href'));
	                if(urlLink && urlLink !== '' && urlLink !== 'http://'){
	                    $element.attr('href', urlLink);
	                    editorScope.updateTaBindtaTextElement();
	                }
	                editorScope.hidePopover();
	            });
	            buttonGroup.append(reLinkButton);
	            var unLinkButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on" title="' + taTranslations.editLink.unLinkButton.tooltip + '"><i class="fa fa-unlink icon-unlink"></i></button>');
	            // directly before this click event is fired a digest is fired off whereby the reference to $element is orphaned off
	            unLinkButton.on('click', function(event){
	                event.preventDefault();
	                $element.replaceWith($element.contents());
	                editorScope.updateTaBindtaTextElement();
	                editorScope.hidePopover();
	            });
	            buttonGroup.append(unLinkButton);
	            var targetToggle = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on">' + taTranslations.editLink.targetToggle.buttontext + '</button>');
	            if($element.attr('target') === '_blank'){
	                targetToggle.addClass('active');
	            }
	            targetToggle.on('click', function(event){
	                event.preventDefault();
	                $element.attr('target', ($element.attr('target') === '_blank') ? '' : '_blank');
	                targetToggle.toggleClass('active');
	                editorScope.updateTaBindtaTextElement();
	            });
	            buttonGroup.append(targetToggle);
	            container.append(buttonGroup);
	            editorScope.showPopover($element);
	        },
	        extractYoutubeVideoId: function(url) {
	            var re = /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/i;
	            var match = url.match(re);
	            return (match && match[1]) || null;
	        }
	    };
	}])
	.run(['taRegisterTool', '$window', 'taTranslations', 'taSelection', 'taToolFunctions', '$sanitize', 'taOptions', '$log',
	    function(taRegisterTool, $window, taTranslations, taSelection, taToolFunctions, $sanitize, taOptions, $log){
	    // test for the version of $sanitize that is in use
	    // You can disable this check by setting taOptions.textAngularSanitize == false
	    var gv = {}; $sanitize('', gv);
	    /* istanbul ignore next, throws error */
	    if ((taOptions.forceTextAngularSanitize===true) && (gv.version !== 'taSanitize')) {
	        throw angular.$$minErr('textAngular')("textAngularSetup", "The textAngular-sanitize provider has been replaced by another -- have you included angular-sanitize by mistake?");
	    }
	    taRegisterTool("html", {
	        iconclass: 'fa fa-code',
	        tooltiptext: taTranslations.html.tooltip,
	        action: function(){
	            this.$editor().switchView();
	        },
	        activeState: function(){
	            return this.$editor().showHtml;
	        }
	    });
	    // add the Header tools
	    // convenience functions so that the loop works correctly
	    var _retActiveStateFunction = function(q){
	        return function(){ return this.$editor().queryFormatBlockState(q); };
	    };
	    var headerAction = function(){
	        return this.$editor().wrapSelection("formatBlock", "<" + this.name.toUpperCase() +">");
	    };
	    angular.forEach(['h1','h2','h3','h4','h5','h6'], function(h){
	        taRegisterTool(h.toLowerCase(), {
	            buttontext: h.toUpperCase(),
	            tooltiptext: taTranslations.heading.tooltip + h.charAt(1),
	            action: headerAction,
	            activeState: _retActiveStateFunction(h.toLowerCase())
	        });
	    });
	    taRegisterTool('p', {
	        buttontext: 'P',
	        tooltiptext: taTranslations.p.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("formatBlock", "<P>");
	        },
	        activeState: function(){ return this.$editor().queryFormatBlockState('p'); }
	    });
	    // key: pre -> taTranslations[key].tooltip, taTranslations[key].buttontext
	    taRegisterTool('pre', {
	        buttontext: 'pre',
	        tooltiptext: taTranslations.pre.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("formatBlock", "<PRE>");
	        },
	        activeState: function(){ return this.$editor().queryFormatBlockState('pre'); }
	    });
	    taRegisterTool('ul', {
	        iconclass: 'fa fa-list-ul',
	        tooltiptext: taTranslations.ul.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("insertUnorderedList", null);
	        },
	        activeState: function(){ return this.$editor().queryCommandState('insertUnorderedList'); }
	    });
	    taRegisterTool('ol', {
	        iconclass: 'fa fa-list-ol',
	        tooltiptext: taTranslations.ol.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("insertOrderedList", null);
	        },
	        activeState: function(){ return this.$editor().queryCommandState('insertOrderedList'); }
	    });
	    taRegisterTool('quote', {
	        iconclass: 'fa fa-quote-right',
	        tooltiptext: taTranslations.quote.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("formatBlock", "<BLOCKQUOTE>");
	        },
	        activeState: function(){ return this.$editor().queryFormatBlockState('blockquote'); }
	    });
	    taRegisterTool('undo', {
	        iconclass: 'fa fa-undo',
	        tooltiptext: taTranslations.undo.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("undo", null);
	        }
	    });
	    taRegisterTool('redo', {
	        iconclass: 'fa fa-repeat',
	        tooltiptext: taTranslations.redo.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("redo", null);
	        }
	    });
	    taRegisterTool('bold', {
	        iconclass: 'fa fa-bold',
	        tooltiptext: taTranslations.bold.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("bold", null);
	        },
	        activeState: function(){
	            return this.$editor().queryCommandState('bold');
	        },
	        commandKeyCode: 98
	    });
	    taRegisterTool('justifyLeft', {
	        iconclass: 'fa fa-align-left',
	        tooltiptext: taTranslations.justifyLeft.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("justifyLeft", null);
	        },
	        activeState: function(commonElement){
	            /* istanbul ignore next: */
	            if (commonElement && commonElement.nodeName === '#document') return false;
	            var result = false;
	            if (commonElement) {
	                // commonELement.css('text-align') can throw an error 'Cannot read property 'defaultView' of null' in rare conditions
	                // so we do try catch here...
	                try {
	                    result =
	                        commonElement.css('text-align') === 'left' ||
	                        commonElement.attr('align') === 'left' ||
	                        (
	                            commonElement.css('text-align') !== 'right' &&
	                            commonElement.css('text-align') !== 'center' &&
	                            commonElement.css('text-align') !== 'justify' && !this.$editor().queryCommandState('justifyRight') && !this.$editor().queryCommandState('justifyCenter')
	                        ) && !this.$editor().queryCommandState('justifyFull');
	                } catch(e) {
	                    /* istanbul ignore next: error handler */
	                    //console.log(e);
	                    result = false;
	                }
	            }
	            result = result || this.$editor().queryCommandState('justifyLeft');
	            return result;
	        }
	    });
	    taRegisterTool('justifyRight', {
	        iconclass: 'fa fa-align-right',
	        tooltiptext: taTranslations.justifyRight.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("justifyRight", null);
	        },
	        activeState: function(commonElement){
	            /* istanbul ignore next: */
	            if (commonElement && commonElement.nodeName === '#document') return false;
	            var result = false;
	            if(commonElement) {
	                // commonELement.css('text-align') can throw an error 'Cannot read property 'defaultView' of null' in rare conditions
	                // so we do try catch here...
	                try {
	                    result = commonElement.css('text-align') === 'right';
	                } catch(e) {
	                    /* istanbul ignore next: error handler */
	                    //console.log(e);
	                    result = false;
	                }
	            }
	            result = result || this.$editor().queryCommandState('justifyRight');
	            return result;
	        }
	    });
	    taRegisterTool('justifyFull', {
	        iconclass: 'fa fa-align-justify',
	        tooltiptext: taTranslations.justifyFull.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("justifyFull", null);
	        },
	        activeState: function(commonElement){
	            var result = false;
	            if(commonElement) {
	                // commonELement.css('text-align') can throw an error 'Cannot read property 'defaultView' of null' in rare conditions
	                // so we do try catch here...
	                try {
	                    result = commonElement.css('text-align') === 'justify';
	                } catch(e) {
	                    /* istanbul ignore next: error handler */
	                    //console.log(e);
	                    result = false;
	                }
	            }
	            result = result || this.$editor().queryCommandState('justifyFull');
	            return result;
	        }
	    });
	    taRegisterTool('justifyCenter', {
	        iconclass: 'fa fa-align-center',
	        tooltiptext: taTranslations.justifyCenter.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("justifyCenter", null);
	        },
	        activeState: function(commonElement){
	            /* istanbul ignore next: */
	            if (commonElement && commonElement.nodeName === '#document') return false;
	            var result = false;
	            if(commonElement) {
	                // commonELement.css('text-align') can throw an error 'Cannot read property 'defaultView' of null' in rare conditions
	                // so we do try catch here...
	                try {
	                    result = commonElement.css('text-align') === 'center';
	                } catch(e) {
	                    /* istanbul ignore next: error handler */
	                    //console.log(e);
	                    result = false;
	                }
	
	            }
	            result = result || this.$editor().queryCommandState('justifyCenter');
	            return result;
	        }
	    });
	    taRegisterTool('indent', {
	        iconclass: 'fa fa-indent',
	        tooltiptext: taTranslations.indent.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("indent", null);
	        },
	        activeState: function(){
	            return this.$editor().queryFormatBlockState('blockquote');
	        },
	        commandKeyCode: 'TabKey'
	    });
	    taRegisterTool('outdent', {
	        iconclass: 'fa fa-outdent',
	        tooltiptext: taTranslations.outdent.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("outdent", null);
	        },
	        activeState: function(){
	            return false;
	        },
	        commandKeyCode: 'ShiftTabKey'
	    });
	    taRegisterTool('italics', {
	        iconclass: 'fa fa-italic',
	        tooltiptext: taTranslations.italic.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("italic", null);
	        },
	        activeState: function(){
	            return this.$editor().queryCommandState('italic');
	        },
	        commandKeyCode: 105
	    });
	    taRegisterTool('underline', {
	        iconclass: 'fa fa-underline',
	        tooltiptext: taTranslations.underline.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("underline", null);
	        },
	        activeState: function(){
	            return this.$editor().queryCommandState('underline');
	        },
	        commandKeyCode: 117
	    });
	    taRegisterTool('strikeThrough', {
	        iconclass: 'fa fa-strikethrough',
	        tooltiptext: taTranslations.strikeThrough.tooltip,
	        action: function(){
	            return this.$editor().wrapSelection("strikeThrough", null);
	        },
	        activeState: function(){
	            return document.queryCommandState('strikeThrough');
	        }
	    });
	    taRegisterTool('clear', {
	        iconclass: 'fa fa-ban',
	        tooltiptext: taTranslations.clear.tooltip,
	        action: function(deferred, restoreSelection){
	            var i, selectedElements, elementsSeen;
	
	            this.$editor().wrapSelection("removeFormat", null);
	            var possibleNodes = angular.element(taSelection.getSelectionElement());
	            selectedElements = taSelection.getAllSelectedElements();
	            //$log.log('selectedElements:', selectedElements);
	            // remove lists
	            var removeListElements = function(list, pe){
	                list = angular.element(list);
	                var prevElement = pe;
	                if (!pe) {
	                    prevElement = list;
	                }
	                angular.forEach(list.children(), function(liElem){
	                    if (liElem.tagName.toLowerCase() === 'ul' ||
	                        liElem.tagName.toLowerCase() === 'ol') {
	                        prevElement = removeListElements(liElem, prevElement);
	                    } else {
	                        var newElem = angular.element('<p></p>');
	                        newElem.html(angular.element(liElem).html());
	                        prevElement.after(newElem);
	                        prevElement = newElem;
	                    }
	                });
	                list.remove();
	                return prevElement;
	            };
	
	            angular.forEach(selectedElements, function(element) {
	                if (element.nodeName.toLowerCase() === 'ul' ||
	                    element.nodeName.toLowerCase() === 'ol') {
	                    //console.log('removeListElements', element);
	                    removeListElements(element);
	                }
	            });
	
	            angular.forEach(possibleNodes.find("ul"), removeListElements);
	            angular.forEach(possibleNodes.find("ol"), removeListElements);
	
	            // clear out all class attributes. These do not seem to be cleared via removeFormat
	            var $editor = this.$editor();
	            var recursiveRemoveClass = function(node){
	                node = angular.element(node);
	                /* istanbul ignore next: this is not triggered in tests any longer since we now never select the whole displayELement */
	                if(node[0] !== $editor.displayElements.text[0]) {
	                    node.removeAttr('class');
	                }
	                angular.forEach(node.children(), recursiveRemoveClass);
	            };
	            angular.forEach(possibleNodes, recursiveRemoveClass);
	            // check if in list. If not in list then use formatBlock option
	            if(possibleNodes[0] && possibleNodes[0].tagName.toLowerCase() !== 'li' &&
	                possibleNodes[0].tagName.toLowerCase() !== 'ol' &&
	                possibleNodes[0].tagName.toLowerCase() !== 'ul' &&
	                possibleNodes[0].getAttribute("contenteditable") !== "true") {
	                this.$editor().wrapSelection("formatBlock", "default");
	            }
	            restoreSelection();
	        }
	    });
	
	        /* jshint -W099 */
	    /****************************
	     //  we don't use this code - since the previous way CLEAR is expected to work does not clear partially selected <li>
	
	     var removeListElement = function(listE){
	                console.log(listE);
	                var _list = listE.parentNode.childNodes;
	                console.log('_list', _list);
	                var _preLis = [], _postLis = [], _found = false;
	                for (i = 0; i < _list.length; i++) {
	                    if (_list[i] === listE) {
	                        _found = true;
	                    } else if (!_found) _preLis.push(_list[i]);
	                    else _postLis.push(_list[i]);
	                }
	                var _parent = angular.element(listE.parentNode);
	                var newElem = angular.element('<p></p>');
	                newElem.html(angular.element(listE).html());
	                if (_preLis.length === 0 || _postLis.length === 0) {
	                    if (_postLis.length === 0) _parent.after(newElem);
	                    else _parent[0].parentNode.insertBefore(newElem[0], _parent[0]);
	
	                    if (_preLis.length === 0 && _postLis.length === 0) _parent.remove();
	                    else angular.element(listE).remove();
	                } else {
	                    var _firstList = angular.element('<' + _parent[0].tagName + '></' + _parent[0].tagName + '>');
	                    var _secondList = angular.element('<' + _parent[0].tagName + '></' + _parent[0].tagName + '>');
	                    for (i = 0; i < _preLis.length; i++) _firstList.append(angular.element(_preLis[i]));
	                    for (i = 0; i < _postLis.length; i++) _secondList.append(angular.element(_postLis[i]));
	                    _parent.after(_secondList);
	                    _parent.after(newElem);
	                    _parent.after(_firstList);
	                    _parent.remove();
	                }
	                taSelection.setSelectionToElementEnd(newElem[0]);
	            };
	
	     elementsSeen = [];
	     if (selectedElements.length !==0) console.log(selectedElements);
	     angular.forEach(selectedElements, function (element) {
	                if (elementsSeen.indexOf(element) !== -1 || elementsSeen.indexOf(element.parentElement) !== -1) {
	                    return;
	                }
	                elementsSeen.push(element);
	                if (element.nodeName.toLowerCase() === 'li') {
	                    console.log('removeListElement', element);
	                    removeListElement(element);
	                }
	                else if (element.parentElement && element.parentElement.nodeName.toLowerCase() === 'li') {
	                    console.log('removeListElement', element.parentElement);
	                    elementsSeen.push(element.parentElement);
	                    removeListElement(element.parentElement);
	                }
	            });
	     **********************/
	
	    /**********************
	     if(possibleNodes[0].tagName.toLowerCase() === 'li'){
	                var _list = possibleNodes[0].parentNode.childNodes;
	                var _preLis = [], _postLis = [], _found = false;
	                for(i = 0; i < _list.length; i++){
	                    if(_list[i] === possibleNodes[0]){
	                        _found = true;
	                    }else if(!_found) _preLis.push(_list[i]);
	                    else _postLis.push(_list[i]);
	                }
	                var _parent = angular.element(possibleNodes[0].parentNode);
	                var newElem = angular.element('<p></p>');
	                newElem.html(angular.element(possibleNodes[0]).html());
	                if(_preLis.length === 0 || _postLis.length === 0){
	                    if(_postLis.length === 0) _parent.after(newElem);
	                    else _parent[0].parentNode.insertBefore(newElem[0], _parent[0]);
	
	                    if(_preLis.length === 0 && _postLis.length === 0) _parent.remove();
	                    else angular.element(possibleNodes[0]).remove();
	                }else{
	                    var _firstList = angular.element('<'+_parent[0].tagName+'></'+_parent[0].tagName+'>');
	                    var _secondList = angular.element('<'+_parent[0].tagName+'></'+_parent[0].tagName+'>');
	                    for(i = 0; i < _preLis.length; i++) _firstList.append(angular.element(_preLis[i]));
	                    for(i = 0; i < _postLis.length; i++) _secondList.append(angular.element(_postLis[i]));
	                    _parent.after(_secondList);
	                    _parent.after(newElem);
	                    _parent.after(_firstList);
	                    _parent.remove();
	                }
	                taSelection.setSelectionToElementEnd(newElem[0]);
	            }
	     *******************/
	
	
	    /* istanbul ignore next: if it's javascript don't worry - though probably should show some kind of error message */
	    var blockJavascript = function (link) {
	        if (link.toLowerCase().indexOf('javascript')!==-1) {
	            return true;
	        }
	        return false;
	    };
	
	    taRegisterTool('insertImage', {
	        iconclass: 'fa fa-picture-o',
	        tooltiptext: taTranslations.insertImage.tooltip,
	        action: function(){
	            var imageLink;
	            imageLink = $window.prompt(taTranslations.insertImage.dialogPrompt, 'http://');
	            if(imageLink && imageLink !== '' && imageLink !== 'http://'){
	                /* istanbul ignore next: don't know how to test this... since it needs a dialogPrompt */
	                // block javascript here
	                if (!blockJavascript(imageLink)) {
	                    if (taSelection.getSelectionElement().tagName && taSelection.getSelectionElement().tagName.toLowerCase() === 'a') {
	                        // due to differences in implementation between FireFox and Chrome, we must move the
	                        // insertion point past the <a> element, otherwise FireFox inserts inside the <a>
	                        // With this change, both FireFox and Chrome behave the same way!
	                        taSelection.setSelectionAfterElement(taSelection.getSelectionElement());
	                    }
	                    // In the past we used the simple statement:
	                    //return this.$editor().wrapSelection('insertImage', imageLink, true);
	                    //
	                    // However on Firefox only, when the content is empty this is a problem
	                    // See Issue #1201
	                    // Investigation reveals that Firefox only inserts a <p> only!!!!
	                    // So now we use insertHTML here and all is fine.
	                    // NOTE: this is what 'insertImage' is supposed to do anyway!
	                    var embed = '<img src="' + imageLink + '">';
	                    return this.$editor().wrapSelection('insertHTML', embed, true);
	                }
	            }
	        },
	        onElementSelect: {
	            element: 'img',
	            action: taToolFunctions.imgOnSelectAction
	        }
	    });
	    taRegisterTool('insertVideo', {
	        iconclass: 'fa fa-youtube-play',
	        tooltiptext: taTranslations.insertVideo.tooltip,
	        action: function(){
	            var urlPrompt;
	            urlPrompt = $window.prompt(taTranslations.insertVideo.dialogPrompt, 'https://');
	            // block javascript here
	            /* istanbul ignore else: if it's javascript don't worry - though probably should show some kind of error message */
	            if (!blockJavascript(urlPrompt)) {
	
	                if (urlPrompt && urlPrompt !== '' && urlPrompt !== 'https://') {
	
	                    videoId = taToolFunctions.extractYoutubeVideoId(urlPrompt);
	
	                    /* istanbul ignore else: if it's invalid don't worry - though probably should show some kind of error message */
	                    if (videoId) {
	                        // create the embed link
	                        var urlLink = "https://www.youtube.com/embed/" + videoId;
	                        // create the HTML
	                        // for all options see: http://stackoverflow.com/questions/2068344/how-do-i-get-a-youtube-video-thumbnail-from-the-youtube-api
	                        // maxresdefault.jpg seems to be undefined on some.
	                        var embed = '<img class="ta-insert-video" src="https://img.youtube.com/vi/' + videoId + '/hqdefault.jpg" ta-insert-video="' + urlLink + '" contenteditable="false" allowfullscreen="true" frameborder="0" />';
	                        /* istanbul ignore next: don't know how to test this... since it needs a dialogPrompt */
	                        if (taSelection.getSelectionElement().tagName && taSelection.getSelectionElement().tagName.toLowerCase() === 'a') {
	                            // due to differences in implementation between FireFox and Chrome, we must move the
	                            // insertion point past the <a> element, otherwise FireFox inserts inside the <a>
	                            // With this change, both FireFox and Chrome behave the same way!
	                            taSelection.setSelectionAfterElement(taSelection.getSelectionElement());
	                        }
	                        // insert
	                        return this.$editor().wrapSelection('insertHTML', embed, true);
	                    }
	                }
	            }
	        },
	        onElementSelect: {
	            element: 'img',
	            onlyWithAttrs: ['ta-insert-video'],
	            action: taToolFunctions.imgOnSelectAction
	        }
	    });
	    taRegisterTool('insertLink', {
	        tooltiptext: taTranslations.insertLink.tooltip,
	        iconclass: 'fa fa-link',
	        action: function(){
	            var urlLink;
	            // if this link has already been set, we need to just edit the existing link
	            /* istanbul ignore if: we do not test this */
	            if (taSelection.getSelectionElement().tagName && taSelection.getSelectionElement().tagName.toLowerCase() === 'a') {
	                urlLink = $window.prompt(taTranslations.insertLink.dialogPrompt, taSelection.getSelectionElement().href);
	            } else {
	                urlLink = $window.prompt(taTranslations.insertLink.dialogPrompt, 'http://');
	            }
	            if(urlLink && urlLink !== '' && urlLink !== 'http://'){
	                // block javascript here
	                /* istanbul ignore else: if it's javascript don't worry - though probably should show some kind of error message */
	                if (!blockJavascript(urlLink)) {
	                    return this.$editor().wrapSelection('createLink', urlLink, true);
	                }
	            }
	        },
	        activeState: function(commonElement){
	            if(commonElement) return commonElement[0].tagName === 'A';
	            return false;
	        },
	        onElementSelect: {
	            element: 'a',
	            action: taToolFunctions.aOnSelectAction
	        }
	    });
	    taRegisterTool('wordcount', {
	        display: '<div id="toolbarWC" style="display:block; min-width:100px;">Words: <span ng-bind="wordcount"></span></div>',
	        disabled: true,
	        wordcount: 0,
	        activeState: function(){ // this fires on keyup
	            var textElement = this.$editor().displayElements.text;
	            /* istanbul ignore next: will default to '' when undefined */
	            var workingHTML = textElement[0].innerHTML || '';
	            var noOfWords = 0;
	
	            /* istanbul ignore if: will default to '' when undefined */
	            if (workingHTML.replace(/\s*<[^>]*?>\s*/g, '') !== '') {
	                if (workingHTML.trim() !== '') {
	                    noOfWords = workingHTML.replace(/<\/?(b|i|em|strong|span|u|strikethrough|a|img|small|sub|sup|label)( [^>*?])?>/gi, '') // remove inline tags without adding spaces
	                        .replace(/(<[^>]*?>\s*<[^>]*?>)/ig, ' ') // replace adjacent tags with possible space between with a space
	                        .replace(/(<[^>]*?>)/ig, '') // remove any singular tags
	                        .replace(/\s+/ig, ' ') // condense spacing
	                        .match(/\S+/g).length; // count remaining non-space strings
	                }
	            }
	
	            //Set current scope
	            this.wordcount = noOfWords;
	            //Set editor scope
	            this.$editor().wordcount = noOfWords;
	
	            return false;
	        }
	    });
	    taRegisterTool('charcount', {
	        display: '<div id="toolbarCC" style="display:block; min-width:120px;">Characters: <span ng-bind="charcount"></span></div>',
	        disabled: true,
	        charcount: 0,
	        activeState: function(){ // this fires on keyup
	            var textElement = this.$editor().displayElements.text;
	            var sourceText = textElement[0].innerText || textElement[0].textContent; // to cover the non-jquery use case.
	
	            // Caculate number of chars
	            var noOfChars = sourceText.replace(/(\r\n|\n|\r)/gm,"").replace(/^\s+/g,' ').replace(/\s+$/g, ' ').length;
	            //Set current scope
	            this.charcount = noOfChars;
	            //Set editor scope
	            this.$editor().charcount = noOfChars;
	            return false;
	        }
	    });
	}]);
	
	/*
	@license textAngular
	Author : Austin Anderson
	License : 2013 MIT
	Version 1.5.16
	
	See README.md or https://github.com/fraywing/textAngular/wiki for requirements and use.
	*/
	
	/*
	Commonjs package manager support (eg componentjs).
	*/
	
	
	"use strict";// NOTE: textAngularVersion must match the Gruntfile.js 'setVersion' task.... and have format v/d+./d+./d+
	var textAngularVersion = 'v1.5.16';   // This is automatically updated during the build process to the current release!
	
	
	// IE version detection - http://stackoverflow.com/questions/4169160/javascript-ie-detection-why-not-use-simple-conditional-comments
	// We need this as IE sometimes plays funny tricks with the contenteditable.
	// ----------------------------------------------------------
	// If you're not in IE (or IE version is less than 5) then:
	// ie === undefined
	// If you're in IE (>=5) then you can determine which version:
	// ie === 7; // IE7
	// Thus, to detect IE:
	// if (ie) {}
	// And to detect the version:
	// ie === 6 // IE6
	// ie > 7 // IE8, IE9, IE10 ...
	// ie < 9 // Anything less than IE9
	// ----------------------------------------------------------
	/* istanbul ignore next: untestable browser check */
	var _browserDetect = {
		ie: (function(){
			var undef,
				v = 3,
				div = document.createElement('div'),
				all = div.getElementsByTagName('i');
	
			while (
				div.innerHTML = '<!--[if gt IE ' + (++v) + ']><i></i><![endif]-->',
				all[0]
			);
	
			return v > 4 ? v : undef;
		}()),
		webkit: /AppleWebKit\/([\d.]+)/i.test(navigator.userAgent),
		isFirefox: navigator.userAgent.toLowerCase().indexOf('firefox') > -1
	};
	
	// Global to textAngular to measure performance where needed
	/* istanbul ignore next: untestable browser check */
	var performance = performance || {};
	/* istanbul ignore next: untestable browser check */
	performance.now = (function() {
		return performance.now       ||
			performance.mozNow    ||
			performance.msNow     ||
			performance.oNow      ||
			performance.webkitNow ||
			function() { return new Date().getTime(); };
	})();
	// usage is:
	// var t0 = performance.now();
	// doSomething();
	// var t1 = performance.now();
	// console.log('Took', (t1 - t0).toFixed(4), 'milliseconds to do something!');
	//
	
	// turn html into pure text that shows visiblity
	function stripHtmlToText(html)
	{
		var tmp = document.createElement("DIV");
		tmp.innerHTML = html;
		var res = tmp.textContent || tmp.innerText || '';
		res.replace('\u200B', ''); // zero width space
		res = res.trim();
		return res;
	}
	// get html
	function getDomFromHtml(html)
	{
		var tmp = document.createElement("DIV");
		tmp.innerHTML = html;
		return tmp;
	}
	
	
	// Global to textAngular REGEXP vars for block and list elements.
	
	var BLOCKELEMENTS = /^(address|article|aside|audio|blockquote|canvas|center|dd|div|dl|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hgroup|hr|noscript|ol|output|p|pre|section|table|tfoot|ul|video)$/i;
	var LISTELEMENTS = /^(ul|li|ol)$/i;
	// updated VALIDELEMENTS to include #text and span so that we can use nodeName instead of tagName
	var VALIDELEMENTS = /^(#text|span|address|article|aside|audio|blockquote|canvas|center|dd|div|dl|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hgroup|hr|noscript|ol|output|p|pre|section|table|tfoot|ul|video|li)$/i;
	
	
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Compatibility
	/* istanbul ignore next: trim shim for older browsers */
	if (!String.prototype.trim) {
		String.prototype.trim = function () {
			return this.replace(/^\s+|\s+$/g, '');
		};
	}
	
	/*
		Custom stylesheet for the placeholders rules.
		Credit to: http://davidwalsh.name/add-rules-stylesheets
	*/
	var sheet, addCSSRule, removeCSSRule, _addCSSRule, _removeCSSRule, _getRuleIndex;
	/* istanbul ignore else: IE <8 test*/
	if(_browserDetect.ie > 8 || _browserDetect.ie === undefined){
		var _sheets = document.styleSheets;
		/* istanbul ignore next: preference for stylesheet loaded externally */
		for(var i = 0; i < _sheets.length; i++){
			if(_sheets[i].media.length === 0 || _sheets[i].media.mediaText.match(/(all|screen)/ig)){
				if(_sheets[i].href){
					if(_sheets[i].href.match(/textangular\.(min\.|)css/ig)){
						sheet = _sheets[i];
						break;
					}
				}
			}
		}
		/* istanbul ignore next: preference for stylesheet loaded externally */
		if(!sheet){
			// this sheet is used for the placeholders later on.
			sheet = (function() {
				// Create the <style> tag
				var style = document.createElement("style");
				/* istanbul ignore else : WebKit hack :( */
				if(_browserDetect.webkit) style.appendChild(document.createTextNode(""));
	
				// Add the <style> element to the page, add as first so the styles can be overridden by custom stylesheets
				document.getElementsByTagName('head')[0].appendChild(style);
	
				return style.sheet;
			})();
		}
	
		// use as: addCSSRule("header", "float: left");
		addCSSRule = function(selector, rules) {
			return _addCSSRule(sheet, selector, rules);
		};
		_addCSSRule = function(_sheet, selector, rules){
			var insertIndex;
			var insertedRule;
			// This order is important as IE 11 has both cssRules and rules but they have different lengths - cssRules is correct, rules gives an error in IE 11
			/* istanbul ignore next: browser catches */
			if(_sheet.cssRules) insertIndex = Math.max(_sheet.cssRules.length - 1, 0);
			else if(_sheet.rules) insertIndex = Math.max(_sheet.rules.length - 1, 0);
	
			/* istanbul ignore else: untestable IE option */
			if(_sheet.insertRule) {
				_sheet.insertRule(selector + "{" + rules + "}", insertIndex);
			}
			else {
				_sheet.addRule(selector, rules, insertIndex);
			}
			/* istanbul ignore next: browser catches */
			if(sheet.rules) insertedRule = sheet.rules[insertIndex];
			else if(sheet.cssRules) insertedRule = sheet.cssRules[insertIndex];
			// return the inserted stylesheet rule
			return insertedRule;
		};
	
		_getRuleIndex = function(rule, rules) {
			var i, ruleIndex;
			for (i=0; i < rules.length; i++) {
				/* istanbul ignore else: check for correct rule */
				if (rules[i].cssText === rule.cssText) {
					ruleIndex = i;
					break;
				}
			}
			return ruleIndex;
		};
	
		removeCSSRule = function(rule){
			_removeCSSRule(sheet, rule);
		};
		/* istanbul ignore next: tests are browser specific */
		_removeCSSRule = function(sheet, rule){
			var rules = sheet.cssRules || sheet.rules;
			if(!rules || rules.length === 0) return;
			var ruleIndex = _getRuleIndex(rule, rules);
			if(sheet.removeRule){
				sheet.removeRule(ruleIndex);
			}else{
				sheet.deleteRule(ruleIndex);
			}
		};
	}
	
	angular.module('textAngular.factories', [])
	.factory('taBrowserTag', [function(){
	    return function(tag){
	        /* istanbul ignore next: ie specific test */
	        if(!tag) return (_browserDetect.ie <= 8)? 'P' : 'p';
	        else if(tag === '') return (_browserDetect.ie === undefined)? 'div' : (_browserDetect.ie <= 8)? 'P' : 'p';
	        else return (_browserDetect.ie <= 8)? tag.toUpperCase() : tag;
	    };
	}]).factory('taApplyCustomRenderers', ['taCustomRenderers', 'taDOM', function(taCustomRenderers, taDOM){
	    return function(val){
	        var element = angular.element('<div></div>');
	        element[0].innerHTML = val;
	
	        angular.forEach(taCustomRenderers, function(renderer){
	            var elements = [];
	            // get elements based on what is defined. If both defined do secondary filter in the forEach after using selector string
	            if(renderer.selector && renderer.selector !== '')
	                elements = element.find(renderer.selector);
	            /* istanbul ignore else: shouldn't fire, if it does we're ignoring everything */
	            else if(renderer.customAttribute && renderer.customAttribute !== '')
	                elements = taDOM.getByAttribute(element, renderer.customAttribute);
	            // process elements if any found
	            angular.forEach(elements, function(_element){
	                _element = angular.element(_element);
	                if(renderer.selector && renderer.selector !== '' && renderer.customAttribute && renderer.customAttribute !== ''){
	                    if(_element.attr(renderer.customAttribute) !== undefined) renderer.renderLogic(_element);
	                } else renderer.renderLogic(_element);
	            });
	        });
	
	        return element[0].innerHTML;
	    };
	}]).factory('taFixChrome', function(){
	    // get whaterever rubbish is inserted in chrome
	    // should be passed an html string, returns an html string
	    var taFixChrome = function(html, keepStyles){
	        if(!html || !angular.isString(html) || html.length <= 0) return html;
	        // grab all elements with a style attibute
	        // a betterSpanMatch matches only a style=... with matching quotes
	        // this captures the whole:
	        // 'style="background-color: rgb(255, 255, 255);"'
	        var betterSpanMatch = /style\s?=\s?(["'])(?:(?=(\\?))\2.)*?\1/ig;
	        // where the original spanMatch = /<([^>\/]+?)style=("([^\"]+)"|'([^']+)')([^>]*)>/ig;
	        // captures too much and includes the front tag!
	        var spanMatch = /<([^>\/]+?)style=("([^\"]+)"|'([^']+)')([^>]*)>/ig;
	        var appleConvertedSpaceMatch = /<span class="Apple-converted-space">([^<]+)<\/span>/ig;
	        var match, styleVal, appleSpaceVal, newTag, finalHtml = '', lastIndex = 0;
	        // remove all the Apple-converted-space spans and replace with the content of the span
	        //console.log('before:', html);
	        /* istanbul ignore next: apple-contereted-space span match */
	        while(match = appleConvertedSpaceMatch.exec(html)){
	            appleSpaceVal = match[1];
	            appleSpaceVal = appleSpaceVal.replace(/&nbsp;/ig, ' ');
	            finalHtml += html.substring(lastIndex, match.index) + appleSpaceVal;
	            lastIndex = match.index + match[0].length;
	        }
	        /* istanbul ignore next: apple-contereted-space span has matched */
	        if (lastIndex) {
	            // modified....
	            finalHtml += html.substring(lastIndex);
	            html=finalHtml;
	            finalHtml='';
	            lastIndex=0;
	        }
	        /////////////////////////////////////////////////////////////
	        //
	        // Allow control of this modification
	        // taKeepStyles: False - removes these modification
	        //
	        // taFixChrome removes the following styles:
	        //    font-family: inherit;
	        //    line-height: <number>
	        //    color: inherit;
	        //    color: rgb( <rgb-component>#{3} )
	        //    background-color: rgb( <rgb-component>#{3} )
	        //
	        /////////////////////////////////////////////////////////////
	        if (!keepStyles) {
	            while (match = betterSpanMatch.exec(html)) {
	                finalHtml += html.substring(lastIndex, match.index-1);
	                styleVal = match[0];
	                // test for chrome inserted junk
	                match = /font-family: inherit;|line-height: 1.[0-9]{3,12};|color: inherit; line-height: 1.1;|color: rgb\(\d{1,3}, \d{1,3}, \d{1,3}\);|background-color: rgb\(\d{1,3}, \d{1,3}, \d{1,3}\);/gi.exec(styleVal);
	                if (match) {
	                    styleVal = styleVal.replace(/( |)font-family: inherit;|( |)line-height: 1.[0-9]{3,12};|( |)color: inherit;|( |)color: rgb\(\d{1,3}, \d{1,3}, \d{1,3}\);|( |)background-color: rgb\(\d{1,3}, \d{1,3}, \d{1,3}\);/ig, '');
	                    //console.log(styleVal, styleVal.length);
	                    if (styleVal.length > 8) {
	                        finalHtml += ' ' + styleVal;
	                    }
	                } else {
	                    finalHtml += ' ' + styleVal;
	                }
	                lastIndex = betterSpanMatch.lastIndex;
	            }
	            finalHtml += html.substring(lastIndex);
	        }
	        //console.log('final:', finalHtml);
	        // only replace when something has changed, else we get focus problems on inserting lists
	        if(lastIndex > 0){
	            // replace all empty strings
	            var fe = finalHtml.replace(/<span\s?>(.*?)<\/span>(<br(\/|)>|)/ig, '$1');
	            return fe;
	        } else return html;
	    };
	    return taFixChrome;
	}).factory('taSanitize', ['$sanitize', function taSanitizeFactory($sanitize){
	
	    var convert_infos = [
	        {
	            property: 'font-weight',
	            values: [ 'bold' ],
	            tag: 'b'
	        },
	        {
	            property: 'font-style',
	            values: [ 'italic' ],
	            tag: 'i'
	        }
	    ];
	
	    var styleMatch = [];
	    for(var i = 0; i < convert_infos.length; i++){
	        var _partialStyle = '(' + convert_infos[i].property + ':\\s*(';
	        for(var j = 0; j < convert_infos[i].values.length; j++){
	            /* istanbul ignore next: not needed to be tested yet */
	            if(j > 0) _partialStyle += '|';
	            _partialStyle += convert_infos[i].values[j];
	        }
	        _partialStyle += ');)';
	        styleMatch.push(_partialStyle);
	    }
	    var styleRegexString = '(' + styleMatch.join('|') + ')';
	
	    function wrapNested(html, wrapTag) {
	        var depth = 0;
	        var lastIndex = 0;
	        var match;
	        var tagRegex = /<[^>]*>/ig;
	        while(match = tagRegex.exec(html)){
	            lastIndex = match.index;
	            if(match[0].substr(1, 1) === '/'){
	                if(depth === 0) break;
	                else depth--;
	            }else depth++;
	        }
	        return wrapTag +
	            html.substring(0, lastIndex) +
	            // get the start tags reversed - this is safe as we construct the strings with no content except the tags
	            angular.element(wrapTag)[0].outerHTML.substring(wrapTag.length) +
	            html.substring(lastIndex);
	    }
	
	    function transformLegacyStyles(html){
	        if(!html || !angular.isString(html) || html.length <= 0) return html;
	        var i;
	        var styleElementMatch = /<([^>\/]+?)style=("([^"]+)"|'([^']+)')([^>]*)>/ig;
	        var match, subMatch, styleVal, newTag, lastNewTag = '', newHtml, finalHtml = '', lastIndex = 0;
	        while(match = styleElementMatch.exec(html)){
	            // one of the quoted values ' or "
	            /* istanbul ignore next: quotations match */
	            styleVal = match[3] || match[4];
	            var styleRegex = new RegExp(styleRegexString, 'i');
	            // test for style values to change
	            if(angular.isString(styleVal) && styleRegex.test(styleVal)){
	                // remove build tag list
	                newTag = '';
	                // init regex here for exec
	                var styleRegexExec = new RegExp(styleRegexString, 'ig');
	                // find relevand tags and build a string of them
	                while(subMatch = styleRegexExec.exec(styleVal)){
	                    for(i = 0; i < convert_infos.length; i++){
	                        if(!!subMatch[(i*2) + 2]){
	                            newTag += '<' + convert_infos[i].tag + '>';
	                        }
	                    }
	                }
	                // recursively find more legacy styles in html before this tag and after the previous match (if any)
	                newHtml = transformLegacyStyles(html.substring(lastIndex, match.index));
	                // build up html
	                if(lastNewTag.length > 0){
	                    finalHtml += wrapNested(newHtml, lastNewTag);
	                }else finalHtml += newHtml;
	                // grab the style val without the transformed values
	                styleVal = styleVal.replace(new RegExp(styleRegexString, 'ig'), '');
	                // build the html tag
	                finalHtml += '<' + match[1].trim();
	                if(styleVal.length > 0) finalHtml += ' style="' + styleVal + '"';
	                finalHtml += match[5] + '>';
	                // update the start index to after this tag
	                lastIndex = match.index + match[0].length;
	                lastNewTag = newTag;
	            }
	        }
	        if(lastNewTag.length > 0){
	            finalHtml += wrapNested(html.substring(lastIndex), lastNewTag);
	        }
	        else finalHtml += html.substring(lastIndex);
	        return finalHtml;
	    }
	
	    function transformLegacyAttributes(html){
	        if(!html || !angular.isString(html) || html.length <= 0) return html;
	        // replace all align='...' tags with text-align attributes
	        var attrElementMatch = /<([^>\/]+?)align=("([^"]+)"|'([^']+)')([^>]*)>/ig;
	        var match, finalHtml = '', lastIndex = 0;
	        // match all attr tags
	        while(match = attrElementMatch.exec(html)){
	            // add all html before this tag
	            finalHtml += html.substring(lastIndex, match.index);
	            // record last index after this tag
	            lastIndex = match.index + match[0].length;
	            // construct tag without the align attribute
	            var newTag = '<' + match[1] + match[5];
	            // add the style attribute
	            if(/style=("([^"]+)"|'([^']+)')/ig.test(newTag)){
	                /* istanbul ignore next: quotations match */
	                newTag = newTag.replace(/style=("([^"]+)"|'([^']+)')/i, 'style="$2$3 text-align:' + (match[3] || match[4]) + ';"');
	            }else{
	                /* istanbul ignore next: quotations match */
	                newTag += ' style="text-align:' + (match[3] || match[4]) + ';"';
	            }
	            newTag += '>';
	            // add to html
	            finalHtml += newTag;
	        }
	        // return with remaining html
	        return finalHtml + html.substring(lastIndex);
	    }
	
	    // use precompiled regexp for speed
	    var rsb1 = new RegExp(/<span id="selectionBoundary_\d+_\d+" class="rangySelectionBoundary">[^<>]+?<\/span>/ig);
	    var rsb2 = new RegExp(/<span class="rangySelectionBoundary" id="selectionBoundary_\d+_\d+">[^<>]+?<\/span>/ig);
	    var rsb3 = new RegExp(/<span id="selectionBoundary_\d+_\d+" class="rangySelectionBoundary">[^<>]+?<\/span>/ig);
	
	    return function taSanitize(unsafe, oldsafe, ignore){
	        // unsafe html should NEVER built into a DOM object via angular.element. This allows XSS to be inserted and run.
	        if ( !ignore ) {
	            try {
	                unsafe = transformLegacyStyles(unsafe);
	            } catch (e) {
	            }
	        }
	
	        // unsafe and oldsafe should be valid HTML strings
	        // any exceptions (lets say, color for example) should be made here but with great care
	        // setup unsafe element for modification
	        unsafe = transformLegacyAttributes(unsafe);
	
	        // we had an issue in the past, where we dumped a whole bunch of <span>'s into the content...
	        // so we remove them here
	        // IN A FUTURE release this can be removed after all have updated through release 1.5.9
	        if (unsafe) {
	            try {
	                unsafe = unsafe.replace(rsb1, '');
	                unsafe = unsafe.replace(rsb2, '');
	                unsafe = unsafe.replace(rsb1, '');
	                unsafe = unsafe.replace(rsb3, '');
	            } catch (e) {
	            }
	        }
	
	        var safe;
	        try {
	            safe = $sanitize(unsafe);
	            // do this afterwards, then the $sanitizer should still throw for bad markup
	            if(ignore) safe = unsafe;
	        } catch (e){
	            safe = oldsafe || '';
	        }
	
	        // Do processing for <pre> tags, removing tabs and return carriages outside of them
	
	        var _preTags = safe.match(/(<pre[^>]*>.*?<\/pre[^>]*>)/ig);
	        var processedSafe = safe.replace(/(&#(9|10);)*/ig, '');
	        var re = /<pre[^>]*>.*?<\/pre[^>]*>/ig;
	        var index = 0;
	        var lastIndex = 0;
	        var origTag;
	        safe = '';
	        while((origTag = re.exec(processedSafe)) !== null && index < _preTags.length){
	            safe += processedSafe.substring(lastIndex, origTag.index) + _preTags[index];
	            lastIndex = origTag.index + origTag[0].length;
	            index++;
	        }
	        return safe + processedSafe.substring(lastIndex);
	    };
	}]).factory('taToolExecuteAction', ['$q', '$log', function($q, $log){
	    // this must be called on a toolScope or instance
	    return function(editor){
	        if(editor !== undefined) this.$editor = function(){ return editor; };
	        var deferred = $q.defer(),
	            promise = deferred.promise,
	            _editor = this.$editor();
	        // pass into the action the deferred function and also the function to reload the current selection if rangy available
	        var result;
	        try{
	            result = this.action(deferred, _editor.startAction());
	            // We set the .finally callback here to make sure it doesn't get executed before any other .then callback.
	            promise['finally'](function(){
	                _editor.endAction.call(_editor);
	            });
	        }catch(exc){
	            $log.error(exc);
	        }
	        if(result || result === undefined){
	            // if true or undefined is returned then the action has finished. Otherwise the deferred action will be resolved manually.
	            deferred.resolve();
	        }
	    };
	}]);
	
	angular.module('textAngular.DOM', ['textAngular.factories'])
	.factory('taExecCommand', ['taSelection', 'taBrowserTag', '$document', function(taSelection, taBrowserTag, $document){
	    var listToDefault = function(listElement, defaultWrap){
	        var $target, i;
	        // if all selected then we should remove the list
	        // grab all li elements and convert to taDefaultWrap tags
	        var children = listElement.find('li');
	        for(i = children.length - 1; i >= 0; i--){
	            $target = angular.element('<' + defaultWrap + '>' + children[i].innerHTML + '</' + defaultWrap + '>');
	            listElement.after($target);
	        }
	        listElement.remove();
	        taSelection.setSelectionToElementEnd($target[0]);
	    };
	    var listElementToSelfTag = function(list, listElement, selfTag, bDefault, defaultWrap){
	        var $target, i;
	        // if all selected then we should remove the list
	        // grab all li elements
	        var priorElement;
	        var nextElement;
	        var children = list.find('li');
	        var foundIndex;
	        for (i = 0; i<children.length; i++) {
	            if (children[i].outerHTML === listElement[0].outerHTML) {
	                // found it...
	                foundIndex = i;
	                if (i>0) {
	                    priorElement = children[i-1];
	                }
	                if (i+1<children.length) {
	                    nextElement = children[i+1];
	                }
	                break;
	            }
	        }
	        //console.log('listElementToSelfTag', list, listElement, selfTag, bDefault, priorElement, nextElement);
	        // un-list the listElement
	        var html = '';
	        if (bDefault) {
	            html += '<' + defaultWrap + '>' + listElement[0].innerHTML + '</' + defaultWrap + '>';
	        } else {
	            html += '<' + taBrowserTag(selfTag) + '>';
	            html += '<li>' + listElement[0].innerHTML + '</li>';
	            html += '</' + taBrowserTag(selfTag) + '>';
	        }
	        $target = angular.element(html);
	        //console.log('$target', $target[0]);
	        if (!priorElement) {
	            // this is the first the list, so we just remove it...
	            listElement.remove();
	            list.after(angular.element(list[0].outerHTML));
	            list.after($target);
	            list.remove();
	            taSelection.setSelectionToElementEnd($target[0]);
	            return;
	        } else if (!nextElement) {
	            // this is the last in the list, so we just remove it..
	            listElement.remove();
	            list.after($target);
	            taSelection.setSelectionToElementEnd($target[0]);
	        } else {
	            var p = list.parent();
	            // okay it was some where in the middle... so we need to break apart the list...
	            var html1 = '';
	            var listTag = list[0].nodeName.toLowerCase();
	            html1 += '<' + listTag + '>';
	            for(i = 0; i < foundIndex; i++){
	                html1 += '<li>' + children[i].innerHTML + '</li>';
	            }
	            html1 += '</' + listTag + '>';
	            var html2 = '';
	            html2 += '<' + listTag + '>';
	            for(i = foundIndex+1; i < children.length; i++){
	                html2 += '<li>' + children[i].innerHTML + '</li>';
	            }
	            html2 += '</' + listTag + '>';
	            //console.log(html1, $target[0], html2);
	            list.after(angular.element(html2));
	            list.after($target);
	            list.after(angular.element(html1));
	            list.remove();
	            //console.log('parent ******XXX*****', p[0]);
	            taSelection.setSelectionToElementEnd($target[0]);
	        }
	    };
	    var listElementsToSelfTag = function(list, listElements, selfTag, bDefault, defaultWrap){
	        var $target, i, j, p;
	        // grab all li elements
	        var priorElement;
	        var afterElement;
	        //console.log('list:', list, 'listElements:', listElements, 'selfTag:', selfTag, 'bDefault:', bDefault);
	        var children = list.find('li');
	        var foundIndexes = [];
	        for (i = 0; i<children.length; i++) {
	            for (j = 0; j<listElements.length; j++) {
	                if (children[i].isEqualNode(listElements[j])) {
	                    // found it...
	                    foundIndexes[j] = i;
	                }
	            }
	        }
	        if (foundIndexes[0] > 0) {
	            priorElement = children[foundIndexes[0] - 1];
	        }
	        if (foundIndexes[listElements.length-1] + 1 < children.length) {
	            afterElement = children[foundIndexes[listElements.length-1] + 1];
	        }
	        //console.log('listElementsToSelfTag', list, listElements, selfTag, bDefault, !priorElement, !afterElement, foundIndexes[listElements.length-1], children.length);
	        // un-list the listElements
	        var html = '';
	        if (bDefault) {
	            for (j = 0; j < listElements.length; j++) {
	                html += '<' + defaultWrap + '>' + listElements[j].innerHTML + '</' + defaultWrap + '>';
	                listElements[j].remove();
	            }
	        } else {
	            html += '<' + taBrowserTag(selfTag) + '>';
	            for (j = 0; j < listElements.length; j++) {
	                html += listElements[j].outerHTML;
	                listElements[j].remove();
	            }
	            html += '</' + taBrowserTag(selfTag) + '>';
	        }
	        $target = angular.element(html);
	        if (!priorElement) {
	            // this is the first the list, so we just remove it...
	            list.after(angular.element(list[0].outerHTML));
	            list.after($target);
	            list.remove();
	            taSelection.setSelectionToElementEnd($target[0]);
	            return;
	        } else if (!afterElement) {
	            // this is the last in the list, so we just remove it..
	            list.after($target);
	            taSelection.setSelectionToElementEnd($target[0]);
	            return;
	        } else {
	            // okay it was some where in the middle... so we need to break apart the list...
	            var html1 = '';
	            var listTag = list[0].nodeName.toLowerCase();
	            html1 += '<' + listTag + '>';
	            for(i = 0; i < foundIndexes[0]; i++){
	                html1 += '<li>' + children[i].innerHTML + '</li>';
	            }
	            html1 += '</' + listTag + '>';
	            var html2 = '';
	            html2 += '<' + listTag + '>';
	            for(i = foundIndexes[listElements.length-1]+1; i < children.length; i++){
	                html2 += '<li>' + children[i].innerHTML + '</li>';
	            }
	            html2 += '</' + listTag + '>';
	            list.after(angular.element(html2));
	            list.after($target);
	            list.after(angular.element(html1));
	            list.remove();
	            //console.log('parent ******YYY*****', list.parent()[0]);
	            taSelection.setSelectionToElementEnd($target[0]);
	        }
	    };
	    var selectLi = function(liElement){
	        if(/(<br(|\/)>)$/i.test(liElement.innerHTML.trim())) taSelection.setSelectionBeforeElement(angular.element(liElement).find("br")[0]);
	        else taSelection.setSelectionToElementEnd(liElement);
	    };
	    var listToList = function(listElement, newListTag){
	        var $target = angular.element('<' + newListTag + '>' + listElement[0].innerHTML + '</' + newListTag + '>');
	        listElement.after($target);
	        listElement.remove();
	        selectLi($target.find('li')[0]);
	    };
	    var childElementsToList = function(elements, listElement, newListTag){
	        var html = '';
	        for(var i = 0; i < elements.length; i++){
	            html += '<' + taBrowserTag('li') + '>' + elements[i].innerHTML + '</' + taBrowserTag('li') + '>';
	        }
	        var $target = angular.element('<' + newListTag + '>' + html + '</' + newListTag + '>');
	        listElement.after($target);
	        listElement.remove();
	        selectLi($target.find('li')[0]);
	    };
	    var turnBlockIntoBlocks = function(element, options) {
	        for(var i = 0; i<element.childNodes.length; i++) {
	            var _n = element.childNodes[i];
	            /* istanbul ignore next - more complex testing*/
	            if (_n.tagName && _n.tagName.match(BLOCKELEMENTS)) {
	                turnBlockIntoBlocks(_n, options);
	            }
	        }
	        /* istanbul ignore next - very rare condition that we do not test*/
	        if (element.parentNode === null) {
	            // nothing left to do..
	            return element;
	        }
	        /* istanbul ignore next - not sure have to test this */
	        if (options === '<br>'){
	            return element;
	        }
	        else {
	            var $target = angular.element(options);
	            $target[0].innerHTML = element.innerHTML;
	            element.parentNode.insertBefore($target[0], element);
	            element.parentNode.removeChild(element);
	            return $target;
	        }
	    };
	    return function(taDefaultWrap, topNode){
	        // NOTE: here we are dealing with the html directly from the browser and not the html the user sees.
	        // IF you want to modify the html the user sees, do it when the user does a switchView
	        taDefaultWrap = taBrowserTag(taDefaultWrap);
	        return function(command, showUI, options, defaultTagAttributes){
	            var i, $target, html, _nodes, next, optionsTagName, selectedElement, ourSelection;
	            var defaultWrapper = angular.element('<' + taDefaultWrap + '>');
	            try{
	                if (taSelection.getSelection) {
	                    ourSelection = taSelection.getSelection();
	                }
	                selectedElement = taSelection.getSelectionElement();
	                // special checks and fixes when we are selecting the whole container
	                var __h, _innerNode;
	                /* istanbul ignore next */
	                if (selectedElement.tagName !== undefined) {
	                    if (selectedElement.tagName.toLowerCase() === 'div' &&
	                        /taTextElement.+/.test(selectedElement.id) &&
	                        ourSelection && ourSelection.start &&
	                        ourSelection.start.offset === 1 &&
	                        ourSelection.end.offset === 1) {
	                        // opps we are actually selecting the whole container!
	                        //console.log('selecting whole container!');
	                        __h = selectedElement.innerHTML;
	                        if (/<br>/i.test(__h)) {
	                            // Firefox adds <br>'s and so we remove the <br>
	                            __h = __h.replace(/<br>/i, '&#8203;');  // no space-space
	                        }
	                        if (/<br\/>/i.test(__h)) {
	                            // Firefox adds <br/>'s and so we remove the <br/>
	                            __h = __h.replace(/<br\/>/i, '&#8203;');  // no space-space
	                        }
	                        // remove stacked up <span>'s
	                        if (/<span>(<span>)+/i.test(__h)) {
	                            __h = __.replace(/<span>(<span>)+/i, '<span>');
	                        }
	                        // remove stacked up </span>'s
	                        if (/<\/span>(<\/span>)+/i.test(__h)) {
	                            __h = __.replace(/<\/span>(<\/span>)+/i, '<\/span>');
	                        }
	                        if (/<span><\/span>/i.test(__h)) {
	                            // if we end up with a <span></span> here we remove it...
	                            __h = __h.replace(/<span><\/span>/i, '');
	                        }
	                        //console.log('inner whole container', selectedElement.childNodes);
	                        _innerNode = '<div>' + __h + '</div>';
	                        selectedElement.innerHTML = _innerNode;
	                        taSelection.setSelectionToElementEnd(selectedElement.childNodes[0]);
	                        selectedElement = taSelection.getSelectionElement();
	                    } else if (selectedElement.tagName.toLowerCase() === 'span' &&
	                        ourSelection && ourSelection.start &&
	                        ourSelection.start.offset === 1 &&
	                        ourSelection.end.offset === 1) {
	                        // just a span -- this is a problem...
	                        //console.log('selecting span!');
	                        __h = selectedElement.innerHTML;
	                        if (/<br>/i.test(__h)) {
	                            // Firefox adds <br>'s and so we remove the <br>
	                            __h = __h.replace(/<br>/i, '&#8203;');  // no space-space
	                        }
	                        if (/<br\/>/i.test(__h)) {
	                            // Firefox adds <br/>'s and so we remove the <br/>
	                            __h = __h.replace(/<br\/>/i, '&#8203;');  // no space-space
	                        }
	                        // remove stacked up <span>'s
	                        if (/<span>(<span>)+/i.test(__h)) {
	                            __h = __.replace(/<span>(<span>)+/i, '<span>');
	                        }
	                        // remove stacked up </span>'s
	                        if (/<\/span>(<\/span>)+/i.test(__h)) {
	                            __h = __.replace(/<\/span>(<\/span>)+/i, '<\/span>');
	                        }
	                        if (/<span><\/span>/i.test(__h)) {
	                            // if we end up with a <span></span> here we remove it...
	                            __h = __h.replace(/<span><\/span>/i, '');
	                        }
	                        //console.log('inner span', selectedElement.childNodes);
	                        // we wrap this in a <div> because otherwise the browser get confused when we attempt to select the whole node
	                        // and the focus is not set correctly no matter what we do
	                        _innerNode = '<div>' + __h + '</div>';
	                        selectedElement.innerHTML = _innerNode;
	                        taSelection.setSelectionToElementEnd(selectedElement.childNodes[0]);
	                        selectedElement = taSelection.getSelectionElement();
	                        //console.log(selectedElement.innerHTML);
	                    } else if (selectedElement.tagName.toLowerCase() === 'p' &&
	                        ourSelection && ourSelection.start &&
	                        ourSelection.start.offset === 1 &&
	                        ourSelection.end.offset === 1) {
	                        //console.log('p special');
	                        // we need to remove the </br> that firefox adds!
	                        __h = selectedElement.innerHTML;
	                        if (/<br>/i.test(__h)) {
	                            // Firefox adds <br>'s and so we remove the <br>
	                            __h = __h.replace(/<br>/i, '&#8203;');  // no space-space
	                            selectedElement.innerHTML = __h;
	                        }
	                    } else if (selectedElement.tagName.toLowerCase() === 'li' &&
	                        ourSelection && ourSelection.start &&
	                        ourSelection.start.offset === ourSelection.end.offset) {
	                        // we need to remove the </br> that firefox adds!
	                        __h = selectedElement.innerHTML;
	                        if (/<br>/i.test(__h)) {
	                            // Firefox adds <br>'s and so we remove the <br>
	                            __h = __h.replace(/<br>/i, '');  // nothing
	                            selectedElement.innerHTML = __h;
	                        }
	                    }
	                }
	            }catch(e){}
	            //console.log('************** selectedElement:', selectedElement);
	            /* istanbul ignore if: */
	            if (!selectedElement){return;}
	            var $selected = angular.element(selectedElement);
	            var tagName = (selectedElement && selectedElement.tagName && selectedElement.tagName.toLowerCase()) ||
	                /* istanbul ignore next: */ "";
	            if(command.toLowerCase() === 'insertorderedlist' || command.toLowerCase() === 'insertunorderedlist'){
	                var selfTag = taBrowserTag((command.toLowerCase() === 'insertorderedlist')? 'ol' : 'ul');
	                var selectedElements = taSelection.getOnlySelectedElements();
	                //console.log('PPPPPPPPPPPPP', tagName, selfTag, selectedElements, tagName.match(BLOCKELEMENTS), $selected.hasClass('ta-bind'), $selected.parent()[0].tagName);
	                if (selectedElements.length>1 && (tagName === 'ol' ||  tagName === 'ul' )) {
	                    return listElementsToSelfTag($selected, selectedElements, selfTag, selfTag===tagName, taDefaultWrap);
	                }
	                if(tagName === selfTag){
	                    // if all selected then we should remove the list
	                    // grab all li elements and convert to taDefaultWrap tags
	                    //console.log('tagName===selfTag');
	                    if ($selected[0].childNodes.length !== selectedElements.length && selectedElements.length===1) {
	                        $selected = angular.element(selectedElements[0]);
	                        return listElementToSelfTag($selected.parent(), $selected, selfTag, true, taDefaultWrap);
	                    } else {
	                        return listToDefault($selected, taDefaultWrap);
	                    }
	                }else if(tagName === 'li' &&
	                    $selected.parent()[0].tagName.toLowerCase() === selfTag &&
	                    $selected.parent().children().length === 1){
	                    // catch for the previous statement if only one li exists
	                    return listToDefault($selected.parent(), taDefaultWrap);
	                }else if(tagName === 'li' &&
	                    $selected.parent()[0].tagName.toLowerCase() !== selfTag &&
	                    $selected.parent().children().length === 1){
	                    // catch for the previous statement if only one li exists
	                    return listToList($selected.parent(), selfTag);
	                }else if(tagName.match(BLOCKELEMENTS) && !$selected.hasClass('ta-bind')){
	                    // if it's one of those block elements we have to change the contents
	                    // if it's a ol/ul we are changing from one to the other
	                    if (selectedElements.length) {
	                        if ($selected[0].childNodes.length !== selectedElements.length && selectedElements.length===1) {
	                            //console.log('&&&&&&&&&&&&&&& --------- &&&&&&&&&&&&&&&&', selectedElements[0], $selected[0].childNodes);
	                            $selected = angular.element(selectedElements[0]);
	                            return listElementToSelfTag($selected.parent(), $selected, selfTag, selfTag===tagName, taDefaultWrap);
	                        }
	                    }
	                    if(tagName === 'ol' || tagName === 'ul'){
	                        // now if this is a set of selected elements... behave diferently
	                        return listToList($selected, selfTag);
	                    }else{
	                        var childBlockElements = false;
	                        angular.forEach($selected.children(), function(elem){
	                            if(elem.tagName.match(BLOCKELEMENTS)) {
	                                childBlockElements = true;
	                            }
	                        });
	                        if(childBlockElements){
	                            return childElementsToList($selected.children(), $selected, selfTag);
	                        }else{
	                            return childElementsToList([angular.element('<div>' + selectedElement.innerHTML + '</div>')[0]], $selected, selfTag);
	                        }
	                    }
	                }else if(tagName.match(BLOCKELEMENTS)){
	                    // if we get here then the contents of the ta-bind are selected
	                    _nodes = taSelection.getOnlySelectedElements();
	                    //console.log('_nodes', _nodes, tagName);
	                    if(_nodes.length === 0){
	                        // here is if there is only text in ta-bind ie <div ta-bind>test content</div>
	                        $target = angular.element('<' + selfTag + '><li>' + selectedElement.innerHTML + '</li></' + selfTag + '>');
	                        $selected.html('');
	                        $selected.append($target);
	                    }else if(_nodes.length === 1 && (_nodes[0].tagName.toLowerCase() === 'ol' || _nodes[0].tagName.toLowerCase() === 'ul')){
	                        if(_nodes[0].tagName.toLowerCase() === selfTag){
	                            // remove
	                            return listToDefault(angular.element(_nodes[0]), taDefaultWrap);
	                        }else{
	                            return listToList(angular.element(_nodes[0]), selfTag);
	                        }
	                    }else{
	                        html = '';
	                        var $nodes = [];
	                        for(i = 0; i < _nodes.length; i++){
	                            /* istanbul ignore else: catch for real-world can't make it occur in testing */
	                            if(_nodes[i].nodeType !== 3){
	                                var $n = angular.element(_nodes[i]);
	                                /* istanbul ignore if: browser check only, phantomjs doesn't return children nodes but chrome at least does */
	                                if(_nodes[i].tagName.toLowerCase() === 'li') continue;
	                                else if(_nodes[i].tagName.toLowerCase() === 'ol' || _nodes[i].tagName.toLowerCase() === 'ul'){
	                                    html += $n[0].innerHTML; // if it's a list, add all it's children
	                                }else if(_nodes[i].tagName.toLowerCase() === 'span' && (_nodes[i].childNodes[0].tagName.toLowerCase() === 'ol' || _nodes[i].childNodes[0].tagName.toLowerCase() === 'ul')){
	                                    html += $n[0].childNodes[0].innerHTML; // if it's a list, add all it's children
	                                }else{
	                                    html += '<' + taBrowserTag('li') + '>' + $n[0].innerHTML + '</' + taBrowserTag('li') + '>';
	                                }
	                                $nodes.unshift($n);
	                            }
	                        }
	                        //console.log('$nodes', $nodes);
	                        $target = angular.element('<' + selfTag + '>' + html + '</' + selfTag + '>');
	                        $nodes.pop().replaceWith($target);
	                        angular.forEach($nodes, function($node){ $node.remove(); });
	                    }
	                    taSelection.setSelectionToElementEnd($target[0]);
	                    return;
	                }
	            }else if(command.toLowerCase() === 'formatblock'){
	                optionsTagName = options.toLowerCase().replace(/[<>]/ig, '');
	                if(optionsTagName.trim() === 'default') {
	                    optionsTagName = taDefaultWrap;
	                    options = '<' + taDefaultWrap + '>';
	                }
	                if(tagName === 'li') {
	                    $target = $selected.parent();
	                }
	                else {
	                    $target = $selected;
	                }
	                // find the first blockElement
	                while(!$target[0].tagName || !$target[0].tagName.match(BLOCKELEMENTS) && !$target.parent().attr('contenteditable')){
	                    $target = $target.parent();
	                    /* istanbul ignore next */
	                    tagName = ($target[0].tagName || '').toLowerCase();
	                }
	                if(tagName === optionsTagName){
	                    // $target is wrap element
	                    _nodes = $target.children();
	                    var hasBlock = false;
	                    for(i = 0; i < _nodes.length; i++){
	                        hasBlock = hasBlock || _nodes[i].tagName.match(BLOCKELEMENTS);
	                    }
	                    if(hasBlock){
	                        $target.after(_nodes);
	                        next = $target.next();
	                        $target.remove();
	                        $target = next;
	                    }else{
	                        defaultWrapper.append($target[0].childNodes);
	                        $target.after(defaultWrapper);
	                        $target.remove();
	                        $target = defaultWrapper;
	                    }
	                }else if($target.parent()[0].tagName.toLowerCase() === optionsTagName &&
	                    !$target.parent().hasClass('ta-bind')){
	                    //unwrap logic for parent
	                    var blockElement = $target.parent();
	                    var contents = blockElement.contents();
	                    for(i = 0; i < contents.length; i ++){
	                        /* istanbul ignore next: can't test - some wierd thing with how phantomjs works */
	                        if(blockElement.parent().hasClass('ta-bind') && contents[i].nodeType === 3){
	                            defaultWrapper = angular.element('<' + taDefaultWrap + '>');
	                            defaultWrapper[0].innerHTML = contents[i].outerHTML;
	                            contents[i] = defaultWrapper[0];
	                        }
	                        blockElement.parent()[0].insertBefore(contents[i], blockElement[0]);
	                    }
	                    blockElement.remove();
	                }else if(tagName.match(LISTELEMENTS)){
	                    // wrapping a list element
	                    $target.wrap(options);
	                }else{
	                    // default wrap behaviour
	                    _nodes = taSelection.getOnlySelectedElements();
	                    if(_nodes.length === 0) {
	                        // no nodes at all....
	                        _nodes = [$target[0]];
	                    }
	                    // find the parent block element if any of the nodes are inline or text
	                    for(i = 0; i < _nodes.length; i++){
	                        if(_nodes[i].nodeType === 3 || !_nodes[i].tagName.match(BLOCKELEMENTS)){
	                            while(_nodes[i].nodeType === 3 || !_nodes[i].tagName || !_nodes[i].tagName.match(BLOCKELEMENTS)){
	                                _nodes[i] = _nodes[i].parentNode;
	                            }
	                        }
	                    }
	                    // remove any duplicates from the array of _nodes!
	                    _nodes = _nodes.filter(function(value, index, self) {
	                        return self.indexOf(value) === index;
	                    });
	                    // remove all whole taTextElement if it is here... unless it is the only element!
	                    if (_nodes.length>1) {
	                        _nodes = _nodes.filter(function (value, index, self) {
	                            return !(value.nodeName.toLowerCase() === 'div' && /^taTextElement/.test(value.id));
	                        });
	                    }
	                    if(angular.element(_nodes[0]).hasClass('ta-bind')){
	                        $target = angular.element(options);
	                        $target[0].innerHTML = _nodes[0].innerHTML;
	                        _nodes[0].innerHTML = $target[0].outerHTML;
	                    }else if(optionsTagName === 'blockquote'){
	                        // blockquotes wrap other block elements
	                        html = '';
	                        for(i = 0; i < _nodes.length; i++){
	                            html += _nodes[i].outerHTML;
	                        }
	                        $target = angular.element(options);
	                        $target[0].innerHTML = html;
	                        _nodes[0].parentNode.insertBefore($target[0],_nodes[0]);
	                        for(i = _nodes.length - 1; i >= 0; i--){
	                            /* istanbul ignore else:  */
	                            if (_nodes[i].parentNode) _nodes[i].parentNode.removeChild(_nodes[i]);
	                        }
	                    } else /* istanbul ignore next: not tested since identical to blockquote */
	                    if (optionsTagName === 'pre' && taSelection.getStateShiftKey()) {
	                        //console.log('shift pre', _nodes);
	                        // pre wrap other block elements
	                        html = '';
	                        for (i = 0; i < _nodes.length; i++) {
	                            html += _nodes[i].outerHTML;
	                        }
	                        $target = angular.element(options);
	                        $target[0].innerHTML = html;
	                        _nodes[0].parentNode.insertBefore($target[0], _nodes[0]);
	                        for (i = _nodes.length - 1; i >= 0; i--) {
	                            /* istanbul ignore else:  */
	                            if (_nodes[i].parentNode) _nodes[i].parentNode.removeChild(_nodes[i]);
	                        }
	                    }
	                    else {
	                        //console.log(optionsTagName, _nodes);
	                        // regular block elements replace other block elements
	                        for (i = 0; i < _nodes.length; i++) {
	                            var newBlock = turnBlockIntoBlocks(_nodes[i], options);
	                            if (_nodes[i] === $target[0]) {
	                                $target = angular.element(newBlock);
	                            }
	                        }
	                    }
	                }
	                taSelection.setSelectionToElementEnd($target[0]);
	                // looses focus when we have the whole container selected and no text!
	                // refocus on the shown display element, this fixes a bug when using firefox
	                $target[0].focus();
	                return;
	            }else if(command.toLowerCase() === 'createlink'){
	                /* istanbul ignore next: firefox specific fix */
	                if (tagName === 'a') {
	                    // already a link!!! we are just replacing it...
	                    taSelection.getSelectionElement().href = options;
	                    return;
	                }
	                var tagBegin = '<a href="' + options + '" target="' +
	                        (defaultTagAttributes.a.target ? defaultTagAttributes.a.target : '') +
	                        '">',
	                    tagEnd = '</a>',
	                    _selection = taSelection.getSelection();
	                if(_selection.collapsed){
	                    //console.log('collapsed');
	                    // insert text at selection, then select then just let normal exec-command run
	                    taSelection.insertHtml(tagBegin + options + tagEnd, topNode);
	                }else if(rangy.getSelection().getRangeAt(0).canSurroundContents()){
	                    var node = angular.element(tagBegin + tagEnd)[0];
	                    rangy.getSelection().getRangeAt(0).surroundContents(node);
	                }
	                return;
	            }else if(command.toLowerCase() === 'inserthtml'){
	                //console.log('inserthtml');
	                taSelection.insertHtml(options, topNode);
	                return;
	            }
	            try{
	                $document[0].execCommand(command, showUI, options);
	            }catch(e){}
	        };
	    };
	}]).service('taSelection', ['$document', 'taDOM', '$log',
	/* istanbul ignore next: all browser specifics and PhantomJS dosen't seem to support half of it */
	function($document, taDOM, $log){
	    // need to dereference the document else the calls don't work correctly
	    var _document = $document[0];
	    var bShiftState;
	    var brException = function (element, offset) {
	        /* check if selection is a BR element at the beginning of a container. If so, get
	        * the parentNode instead.
	        * offset should be zero in this case. Otherwise, return the original
	        * element.
	        */
	        if (element.tagName && element.tagName.match(/^br$/i) && offset === 0 && !element.previousSibling) {
	            return {
	                element: element.parentNode,
	                offset: 0
	            };
	        } else {
	            return {
	                element: element,
	                offset: offset
	            };
	        }
	    };
	    var api = {
	        getSelection: function(){
	            var range;
	            try {
	                // catch any errors from rangy and ignore the issue
	                range = rangy.getSelection().getRangeAt(0);
	            } catch(e) {
	                //console.info(e);
	                return undefined;
	            }
	            var container = range.commonAncestorContainer;
	            var selection = {
	                start: brException(range.startContainer, range.startOffset),
	                end: brException(range.endContainer, range.endOffset),
	                collapsed: range.collapsed
	            };
	            // This has problems under Firefox.
	            // On Firefox with
	            // <p>Try me !</p>
	            // <ul>
	            // <li>line 1</li>
	            // <li>line 2</li>
	            // </ul>
	            // <p>line 3</p>
	            // <ul>
	            // <li>line 4</li>
	            // <li>line 5</li>
	            // </ul>
	            // <p>Hello textAngular</p>
	            // WITH the cursor after the 3 on line 3, it gets the commonAncestorContainer as:
	            // <TextNode textContent='line 3'>
	            // AND Chrome gets the commonAncestorContainer as:
	            // <p>line 3</p>
	            //
	            // Check if the container is a text node and return its parent if so
	            // unless this is the whole taTextElement.  If so we return the textNode
	            if (container.nodeType === 3) {
	                if (container.parentNode.nodeName.toLowerCase() === 'div' &&
	                    /^taTextElement/.test(container.parentNode.id)) {
	                    // textNode where the parent is the whole <div>!!!
	                    //console.log('textNode ***************** container:', container);
	                } else {
	                    container = container.parentNode;
	                }
	            }
	            if (container.nodeName.toLowerCase() === 'div' &&
	                /^taTextElement/.test(container.id)) {
	                //console.log('*********taTextElement************');
	                //console.log('commonAncestorContainer:', container);
	                selection.start.element = container.childNodes[selection.start.offset];
	                selection.end.element = container.childNodes[selection.end.offset];
	                selection.container = container;
	            } else {
	                if (container.parentNode === selection.start.element ||
	                    container.parentNode === selection.end.element) {
	                    selection.container = container.parentNode;
	                } else {
	                    selection.container = container;
	                }
	            }
	            //console.log('***selection container:', selection.container.nodeName, selection.start.offset, selection.container);
	            return selection;
	        },
	        // if we use the LEFT_ARROW and we are at the special place <span>&#65279;</span> we move the cursor over by one...
	        // Chrome and Firefox behave differently so so fix this for Firefox here.  No adjustment needed for Chrome.
	        updateLeftArrowKey: function(element) {
	            var range = rangy.getSelection().getRangeAt(0);
	            if (range && range.collapsed) {
	                var _nodes = api.getFlattenedDom(range);
	                if (!_nodes.findIndex) return;
	                var _node = range.startContainer;
	                var indexStartContainer = _nodes.findIndex(function(element, index){
	                    if (element.node===_node) return true;
	                    var _indexp = element.parents.indexOf(_node);
	                    return (_indexp !== -1);
	                });
	                var m;
	                var nextNodeToRight;
	                //console.log('indexStartContainer', indexStartContainer, _nodes.length, 'startContainer:', _node, _node === _nodes[indexStartContainer].node);
	                _nodes.forEach(function (n, i) {
	                    //console.log(i, n.node);
	                    n.parents.forEach(function (nn, j){
	                        //console.log(i, j, nn);
	                    });
	                });
	                if (indexStartContainer+1 < _nodes.length) {
	                    // we need the node just after this startContainer
	                    // so we can check and see it this is a special place
	                    nextNodeToRight = _nodes[indexStartContainer+1].node;
	                    //console.log(nextNodeToRight, range.startContainer);
	                }
	                //console.log('updateLeftArrowKey', range.startOffset, range.startContainer.textContent);
	                // this first section handles the case for Chrome browser
	                // if the first character of the nextNode is a \ufeff we know that we are just before the special span...
	                // and so we most left by one character
	                if (nextNodeToRight && nextNodeToRight.textContent) {
	                    m = /^\ufeff([^\ufeff]*)$/.exec(nextNodeToRight.textContent);
	                    if (m) {
	                        // we are before the special node with begins with a \ufeff character
	                        //console.log('LEFT ...found it...', 'startOffset:', range.startOffset, m[0].length, m[1].length);
	                        // no need to change anything in this case
	                        return;
	                    }
	                }
	                var nextNodeToLeft;
	                if (indexStartContainer > 0) {
	                    // we need the node just after this startContainer
	                    // so we can check and see it this is a special place
	                    nextNodeToLeft = _nodes[indexStartContainer-1].node;
	                    //console.log(nextNodeToLeft, nextNodeToLeft);
	                }
	                if (range.startOffset === 0 && nextNodeToLeft) {
	                    //console.log(nextNodeToLeft, range.startOffset, nextNodeToLeft.textContent);
	                    m = /^\ufeff([^\ufeff]*)$/.exec(nextNodeToLeft.textContent);
	                    if (m) {
	                        //console.log('LEFT &&&&&&&&&&&&&&&&&&&...found it...&&&&&&&&&&&', nextNodeToLeft, m[0].length, m[1].length);
	                        // move over to the left my one -- Firefox triggers this case
	                        api.setSelectionToElementEnd(nextNodeToLeft);
	                        return;
	                    }
	                }
	            }
	            return;
	        },
	        // if we use the RIGHT_ARROW and we are at the special place <span>&#65279;</span> we move the cursor over by one...
	        updateRightArrowKey: function(element) {
	            // we do not need to make any adjustments here, so we ignore all this code
	            if (false) {
	                var range = rangy.getSelection().getRangeAt(0);
	                if (range && range.collapsed) {
	                    var _nodes = api.getFlattenedDom(range);
	                    if (!_nodes.findIndex) return;
	                    var _node = range.startContainer;
	                    var indexStartContainer = _nodes.findIndex(function (element, index) {
	                        if (element.node === _node) return true;
	                        var _indexp = element.parents.indexOf(_node);
	                        return (_indexp !== -1);
	                    });
	                    var _sel;
	                    var i;
	                    var m;
	
	                    // if the last character is a \ufeff we know that we are just before the special span...
	                    // and so we most right by one character
	                    var indexFound = _nodes.findIndex(function (n, index) {
	                        if (n.textContent) {
	                            var m = /^\ufeff([^\ufeff]*)$/.exec(n.textContent);
	                            if (m) {
	                                return true;
	                            } else {
	                                return false;
	                            }
	                        } else {
	                            return false;
	                        }
	                    });
	                    if (indexFound === -1) {
	                        return;
	                    }
	                    //console.log(indexFound, range.startContainer, range.startOffset);
	                    _node = _nodes[indexStartContainer];
	                    //console.log('indexStartContainer', indexStartContainer);
	                    if (_node && _node.textContent) {
	                        m = /^\ufeff([^\ufeff]*)$/.exec(_node.textContent);
	                        if (m && range.startOffset - 1 === m[1].length) {
	                            //console.log('RIGHT found it...&&&&&&&&&&&', range.startOffset);
	                            // no need to make any adjustment
	                            return;
	                        }
	                    }
	                    //console.log(range.startOffset);
	                    if (_nodes && range.startOffset === 0) {
	                        indexStartContainer = _nodes.indexOf(range.startContainer);
	                        if (indexStartContainer !== -1 && indexStartContainer > 0) {
	                            _node = _nodes[indexStartContainer - 1];
	                            if (_node.textContent) {
	                                m = /\ufeff([^\ufeff]*)$/.exec(_node.textContent);
	                                if (m && true || range.startOffset === m[1].length + 1) {
	                                    //console.log('RIGHT &&&&&&&&&&&&&&&&&&&...found it...&&&&&&&&&&&', range.startOffset, m[1].length);
	                                    // no need to make any adjustment
	                                    return;
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	        },
	        getFlattenedDom: function(range) {
	            var parent = range.commonAncestorContainer.parentNode;
	            if (!parent) {
	                return range.commonAncestorContainer.childNodes;
	            }
	            var nodes = Array.prototype.slice.call(parent.childNodes); // converts NodeList to Array
	            var indexStartContainer = nodes.indexOf(range.startContainer);
	            // make sure that we have a big enough set of nodes
	            if (indexStartContainer+1 < nodes.length && indexStartContainer > 0) {
	                // we are good
	                // we can go down one node or up one node
	            } else {
	                if (parent.parentNode) {
	                    parent = parent.parentNode;
	                }
	            }
	            // now walk the parent
	            nodes = [];
	            function addNodes(_set) {
	                if (_set.node.childNodes.length) {
	                    var childNodes = Array.prototype.slice.call(_set.node.childNodes); // converts NodeList to Array
	                    childNodes.forEach(function(n) {
	                        var _t = _set.parents.slice();
	                        if (_t.slice(-1)[0]!==_set.node) {
	                            _t.push(_set.node);
	                        }
	                        addNodes({parents: _t, node: n});
	                    });
	                } else {
	                    nodes.push({parents: _set.parents, node: _set.node});
	                }
	            }
	            addNodes({parents: [parent], node: parent});
	            return nodes;
	        },
	        getOnlySelectedElements: function(){
	            var range = rangy.getSelection().getRangeAt(0);
	            var container = range.commonAncestorContainer;
	            // Node.TEXT_NODE === 3
	            // Node.ELEMENT_NODE === 1
	            // Node.COMMENT_NODE === 8
	            // Check if the container is a text node and return its parent if so
	            container = container.nodeType === 3 ? container.parentNode : container;
	            // get the nodes in the range that are ELEMENT_NODE and are children of the container
	            // in this range...
	            return range.getNodes([1], function(node){
	                return node.parentNode === container;
	            });
	        },
	        // this includes the container element if all children are selected
	        getAllSelectedElements: function(){
	            var range = rangy.getSelection().getRangeAt(0);
	            var container = range.commonAncestorContainer;
	            // Node.TEXT_NODE === 3
	            // Node.ELEMENT_NODE === 1
	            // Node.COMMENT_NODE === 8
	            // Check if the container is a text node and return its parent if so
	            container = container.nodeType === 3 ? container.parentNode : container;
	            // get the nodes in the range that are ELEMENT_NODE and are children of the container
	            // in this range...
	            var selectedNodes = range.getNodes([1], function(node){
	                return node.parentNode === container;
	            });
	            var innerHtml = container.innerHTML;
	            // remove the junk that rangy has put down
	            innerHtml = innerHtml.replace(/<span id=.selectionBoundary[^>]+>\ufeff?<\/span>/ig, '');
	            //console.log(innerHtml);
	            //console.log(range.toHtml());
	            //console.log(innerHtml === range.toHtml());
	            if (innerHtml === range.toHtml() &&
	                // not the whole taTextElement
	                (!(container.nodeName.toLowerCase() === 'div' &&  /^taTextElement/.test(container.id)))
	            ) {
	                var arr = [];
	                for(var i = selectedNodes.length; i--; arr.unshift(selectedNodes[i]));
	                selectedNodes = arr;
	                selectedNodes.push(container);
	                //$log.debug(selectedNodes);
	            }
	            return selectedNodes;
	        },
	        // Some basic selection functions
	        getSelectionElement: function () {
	            var s = api.getSelection();
	            if (s) {
	                return api.getSelection().container;
	            } else {
	                return undefined;
	            }
	        },
	        setSelection: function(elStart, elEnd, start, end){
	            var range = rangy.createRange();
	
	            range.setStart(elStart, start);
	            range.setEnd(elEnd, end);
	
	            rangy.getSelection().setSingleRange(range);
	        },
	        setSelectionBeforeElement: function (el){
	            var range = rangy.createRange();
	
	            range.selectNode(el);
	            range.collapse(true);
	
	            rangy.getSelection().setSingleRange(range);
	        },
	        setSelectionAfterElement: function (el){
	            var range = rangy.createRange();
	
	            range.selectNode(el);
	            range.collapse(false);
	
	            rangy.getSelection().setSingleRange(range);
	        },
	        setSelectionToElementStart: function (el){
	            var range = rangy.createRange();
	
	            range.selectNodeContents(el);
	            range.collapse(true);
	
	            rangy.getSelection().setSingleRange(range);
	        },
	        setSelectionToElementEnd: function (el){
	            var range = rangy.createRange();
	
	            range.selectNodeContents(el);
	            range.collapse(false);
	            if(el.childNodes && el.childNodes[el.childNodes.length - 1] && el.childNodes[el.childNodes.length - 1].nodeName === 'br'){
	                range.startOffset = range.endOffset = range.startOffset - 1;
	            }
	            rangy.getSelection().setSingleRange(range);
	        },
	        setStateShiftKey: function(bS) {
	            bShiftState = bS;
	        },
	        getStateShiftKey: function() {
	            return bShiftState;
	        },
	        // from http://stackoverflow.com/questions/6690752/insert-html-at-caret-in-a-contenteditable-div
	        // topNode is the contenteditable normally, all manipulation MUST be inside this.
	        insertHtml: function(html, topNode){
	            var parent, secondParent, _childI, nodes, i, lastNode, _tempFrag;
	            var element = angular.element("<div>" + html + "</div>");
	            var range = rangy.getSelection().getRangeAt(0);
	            var frag = _document.createDocumentFragment();
	            var children = element[0].childNodes;
	            var isInline = true;
	
	            if(children.length > 0){
	                // NOTE!! We need to do the following:
	                // check for blockelements - if they exist then we have to split the current element in half (and all others up to the closest block element) and insert all children in-between.
	                // If there are no block elements, or there is a mixture we need to create textNodes for the non wrapped text (we don't want them spans messing up the picture).
	                nodes = [];
	                for(_childI = 0; _childI < children.length; _childI++){
	                    var _cnode = children[_childI];
	                    if (_cnode.nodeName.toLowerCase() === 'p' &&
	                        _cnode.innerHTML.trim() === '') { // empty p element
	                        continue;
	                    }
	                    /****************
	                     *  allow any text to be inserted...
	                    if((   _cnode.nodeType === 3 &&
	                           _cnode.nodeValue === '\ufeff'[0] &&
	                           _cnode.nodeValue.trim() === '') // empty no-space space element
	                        ) {
	                        // no change to isInline
	                        nodes.push(_cnode);
	                        continue;
	                    }
	                    if(_cnode.nodeType === 3 &&
	                         _cnode.nodeValue.trim() === '') { // empty text node
	                        continue;
	                    }
	                    *****************/
	                    isInline = isInline && !BLOCKELEMENTS.test(_cnode.nodeName);
	                    nodes.push(_cnode);
	                }
	                for(var _n = 0; _n < nodes.length; _n++) {
	                    lastNode = frag.appendChild(nodes[_n]);
	                }
	                if( !isInline &&
	                    range.collapsed &&
	                    /^(|<br(|\/)>)$/i.test(range.startContainer.innerHTML) ) {
	                    range.selectNode(range.startContainer);
	                }
	            }else{
	                isInline = true;
	                // paste text of some sort
	                lastNode = frag = _document.createTextNode(html);
	            }
	
	            // Other Edge case - selected data spans multiple blocks.
	            if(isInline){
	                range.deleteContents();
	            }else{ // not inline insert
	                if(range.collapsed && range.startContainer !== topNode){
	                    if(range.startContainer.innerHTML && range.startContainer.innerHTML.match(/^<[^>]*>$/i)){
	                        // this log is to catch when innerHTML is something like `<img ...>`
	                        parent = range.startContainer;
	                        if(range.startOffset === 1){
	                            // before single tag
	                            range.setStartAfter(parent);
	                            range.setEndAfter(parent);
	                        }else{
	                            // after single tag
	                            range.setStartBefore(parent);
	                            range.setEndBefore(parent);
	                        }
	                    }else{
	                        // split element into 2 and insert block element in middle
	                        if(range.startContainer.nodeType === 3 && range.startContainer.parentNode !== topNode){ // if text node
	                            parent = range.startContainer.parentNode;
	                            secondParent = parent.cloneNode();
	                            // split the nodes into two lists - before and after, splitting the node with the selection into 2 text nodes.
	                            taDOM.splitNodes(parent.childNodes, parent, secondParent, range.startContainer, range.startOffset);
	
	                            // Escape out of the inline tags like b
	                            while(!VALIDELEMENTS.test(parent.nodeName)){
	                                angular.element(parent).after(secondParent);
	                                parent = parent.parentNode;
	                                var _lastSecondParent = secondParent;
	                                secondParent = parent.cloneNode();
	                                // split the nodes into two lists - before and after, splitting the node with the selection into 2 text nodes.
	                                taDOM.splitNodes(parent.childNodes, parent, secondParent, _lastSecondParent);
	                            }
	                        }else{
	                            parent = range.startContainer;
	                            secondParent = parent.cloneNode();
	                            taDOM.splitNodes(parent.childNodes, parent, secondParent, undefined, undefined, range.startOffset);
	                        }
	
	                        angular.element(parent).after(secondParent);
	                        // put cursor to end of inserted content
	                        //console.log('setStartAfter', parent);
	                        range.setStartAfter(parent);
	                        range.setEndAfter(parent);
	
	                        if(/^(|<br(|\/)>)$/i.test(parent.innerHTML.trim())){
	                            range.setStartBefore(parent);
	                            range.setEndBefore(parent);
	                            angular.element(parent).remove();
	                        }
	                        if(/^(|<br(|\/)>)$/i.test(secondParent.innerHTML.trim())) angular.element(secondParent).remove();
	                        if(parent.nodeName.toLowerCase() === 'li'){
	                            _tempFrag = _document.createDocumentFragment();
	                            for(i = 0; i < frag.childNodes.length; i++){
	                                element = angular.element('<li>');
	                                taDOM.transferChildNodes(frag.childNodes[i], element[0]);
	                                taDOM.transferNodeAttributes(frag.childNodes[i], element[0]);
	                                _tempFrag.appendChild(element[0]);
	                            }
	                            frag = _tempFrag;
	                            if(lastNode){
	                                lastNode = frag.childNodes[frag.childNodes.length - 1];
	                                lastNode = lastNode.childNodes[lastNode.childNodes.length - 1];
	                            }
	                        }
	                    }
	                }else{
	                    range.deleteContents();
	                }
	            }
	
	            range.insertNode(frag);
	            if(lastNode){
	                api.setSelectionToElementEnd(lastNode);
	            }
	        }
	
	        /* NOT FUNCTIONAL YET
	         // under Firefox, we may have a selection that needs to be normalized
	         isSelectionContainerWhole_taTextElement: function (){
	         var range = rangy.getSelection().getRangeAt(0);
	         var container = range.commonAncestorContainer;
	         if (container.nodeName.toLowerCase() === 'div' &&
	         /^taTextElement/.test(container.id)) {
	         // container is the whole taTextElement
	         return true;
	         }
	         return false;
	         },
	         setNormalizedSelection: function (){
	         var range = rangy.getSelection().getRangeAt(0);
	         var container = range.commonAncestorContainer;
	         console.log(range);
	         console.log(container.childNodes);
	         if (range.collapsed) {
	         // we know what to do...
	         console.log(container.childNodes[range.startOffset]);
	         api.setSelectionToElementStart(container.childNodes[range.startOffset]);
	         }
	         },
	         */
	    };
	    return api;
	}]).service('taDOM', function(){
	    var taDOM = {
	        // recursive function that returns an array of angular.elements that have the passed attribute set on them
	        getByAttribute: function(element, attribute){
	            var resultingElements = [];
	            var childNodes = element.children();
	            if(childNodes.length){
	                angular.forEach(childNodes, function(child){
	                    resultingElements = resultingElements.concat(taDOM.getByAttribute(angular.element(child), attribute));
	                });
	            }
	            if(element.attr(attribute) !== undefined) resultingElements.push(element);
	            return resultingElements;
	        },
	
	        transferChildNodes: function(source, target){
	            // clear out target
	            target.innerHTML = '';
	            while(source.childNodes.length > 0) target.appendChild(source.childNodes[0]);
	            return target;
	        },
	
	        splitNodes: function(nodes, target1, target2, splitNode, subSplitIndex, splitIndex){
	            if(!splitNode && isNaN(splitIndex)) throw new Error('taDOM.splitNodes requires a splitNode or splitIndex');
	            var startNodes = document.createDocumentFragment();
	            var endNodes = document.createDocumentFragment();
	            var index = 0;
	
	            while(nodes.length > 0 && (isNaN(splitIndex) || splitIndex !== index) && nodes[0] !== splitNode){
	                startNodes.appendChild(nodes[0]); // this removes from the nodes array (if proper childNodes object.
	                index++;
	            }
	
	            if(!isNaN(subSplitIndex) && subSplitIndex >= 0 && nodes[0]){
	                startNodes.appendChild(document.createTextNode(nodes[0].nodeValue.substring(0, subSplitIndex)));
	                nodes[0].nodeValue = nodes[0].nodeValue.substring(subSplitIndex);
	            }
	            while(nodes.length > 0) endNodes.appendChild(nodes[0]);
	
	            taDOM.transferChildNodes(startNodes, target1);
	            taDOM.transferChildNodes(endNodes, target2);
	        },
	
	        transferNodeAttributes: function(source, target){
	            for(var i = 0; i < source.attributes.length; i++) target.setAttribute(source.attributes[i].name, source.attributes[i].value);
	            return target;
	        }
	    };
	    return taDOM;
	});
	
	angular.module('textAngular.validators', [])
	.directive('taMaxText', function(){
	    return {
	        restrict: 'A',
	        require: 'ngModel',
	        link: function(scope, elem, attrs, ctrl){
	            var max = parseInt(scope.$eval(attrs.taMaxText));
	            if (isNaN(max)){
	                throw('Max text must be an integer');
	            }
	            attrs.$observe('taMaxText', function(value){
	                max = parseInt(value);
	                if (isNaN(max)){
	                    throw('Max text must be an integer');
	                }
	                if (ctrl.$dirty){
	                    ctrl.$validate();
	                }
	            });
	            ctrl.$validators.taMaxText = function(viewValue){
	                var source = angular.element('<div/>');
	                source.html(viewValue);
	                return source.text().length <= max;
	            };
	        }
	    };
	}).directive('taMinText', function(){
	    return {
	        restrict: 'A',
	        require: 'ngModel',
	        link: function(scope, elem, attrs, ctrl){
	            var min = parseInt(scope.$eval(attrs.taMinText));
	            if (isNaN(min)){
	                throw('Min text must be an integer');
	            }
	            attrs.$observe('taMinText', function(value){
	                min = parseInt(value);
	                if (isNaN(min)){
	                    throw('Min text must be an integer');
	                }
	                if (ctrl.$dirty){
	                    ctrl.$validate();
	                }
	            });
	            ctrl.$validators.taMinText = function(viewValue){
	                var source = angular.element('<div/>');
	                source.html(viewValue);
	                return !source.text().length || source.text().length >= min;
	            };
	        }
	    };
	});
	angular.module('textAngular.taBind', ['textAngular.factories', 'textAngular.DOM'])
	.service('_taBlankTest', [function(){
	    return function(_blankVal){
	        // we radically restructure this code.
	        // what was here before was incredibly fragile.
	        // What we do now is to check that the html is non-blank visually
	        // which we check by looking at html->text
	        if(!_blankVal) return true;
	        // find first non-tag match - ie start of string or after tag that is not whitespace
	        // var t0 = performance.now();
	        // Takes a small fraction of a mSec to do this...
	        var _text_ = stripHtmlToText(_blankVal);
	        // var t1 = performance.now();
	        // console.log('Took', (t1 - t0).toFixed(4), 'milliseconds to generate:');
	        if (_text_=== '') {
	            // img generates a visible item so it is not blank!
	            if (/<img[^>]+>/.test(_blankVal)) {
	                return false;
	            }
	            return true;
	        } else {
	            return false;
	        }
	    };
	}])
	.directive('taButton', [function(){
	    return {
	        link: function(scope, element, attrs){
	            element.attr('unselectable', 'on');
	            element.on('mousedown', function(e, eventData){
	                /* istanbul ignore else: this is for catching the jqLite testing*/
	                if(eventData) angular.extend(e, eventData);
	                // this prevents focusout from firing on the editor when clicking toolbar buttons
	                e.preventDefault();
	                return false;
	            });
	        }
	    };
	}])
	.directive('taBind', [
	        'taSanitize', '$timeout', '$document', 'taFixChrome', 'taBrowserTag',
	        'taSelection', 'taSelectableElements', 'taApplyCustomRenderers', 'taOptions',
	        '_taBlankTest', '$parse', 'taDOM', 'textAngularManager',
	        function(
	            taSanitize, $timeout, $document, taFixChrome, taBrowserTag,
	            taSelection, taSelectableElements, taApplyCustomRenderers, taOptions,
	            _taBlankTest, $parse, taDOM, textAngularManager){
	    // Uses for this are textarea or input with ng-model and ta-bind='text'
	    // OR any non-form element with contenteditable="contenteditable" ta-bind="html|text" ng-model
	    return {
	        priority: 2, // So we override validators correctly
	        require: ['ngModel','?ngModelOptions'],
	        link: function(scope, element, attrs, controller){
	            var ngModel = controller[0];
	            var ngModelOptions = controller[1] || {};
	            // the option to use taBind on an input or textarea is required as it will sanitize all input into it correctly.
	            var _isContentEditable = element.attr('contenteditable') !== undefined && element.attr('contenteditable');
	            var _isInputFriendly = _isContentEditable || element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input';
	            var _isReadonly = false;
	            var _focussed = false;
	            var _skipRender = false;
	            var _disableSanitizer = attrs.taUnsafeSanitizer || taOptions.disableSanitizer;
	            var _keepStyles = attrs.taKeepStyles || taOptions.keepStyles;
	            var _lastKey;
	            // see http://www.javascripter.net/faq/keycodes.htm for good information
	            // NOTE Mute On|Off 173 (Opera MSIE Safari Chrome) 181 (Firefox)
	            // BLOCKED_KEYS are special keys...
	            // Tab, pause/break, CapsLock, Esc, Page Up, End, Home,
	            // Left arrow, Up arrow, Right arrow, Down arrow, Insert, Delete,
	            // f1, f2, f3, f4, f5, f6, f7, f8, f9, f10, f11, f12
	            // NumLock, ScrollLock
	            var BLOCKED_KEYS = /^(9|19|20|27|33|34|35|36|37|38|39|40|45|112|113|114|115|116|117|118|119|120|121|122|123|144|145)$/i;
	            // UNDO_TRIGGER_KEYS - spaces, enter, delete, backspace, all punctuation
	            // Backspace, Enter, Space, Delete, (; :) (Firefox), (= +) (Firefox),
	            // Numpad +, Numpad -, (; :), (= +),
	            // (, <), (- _), (. >), (/ ?), (` ~), ([ {), (\ |), (] }), (' ")
	            // NOTE - Firefox: 173 = (- _) -- adding this to UNDO_TRIGGER_KEYS
	            var UNDO_TRIGGER_KEYS = /^(8|13|32|46|59|61|107|109|173|186|187|188|189|190|191|192|219|220|221|222)$/i;
	            var _pasteHandler;
	
	            // defaults to the paragraph element, but we need the line-break or it doesn't allow you to type into the empty element
	            // non IE is '<p><br/></p>', ie is '<p></p>' as for once IE gets it correct...
	            var _defaultVal, _defaultTest;
	
	            var _CTRL_KEY = 0x0001;
	            var _META_KEY = 0x0002;
	            var _ALT_KEY = 0x0004;
	            var _SHIFT_KEY = 0x0008;
	            // KEYCODEs we use
	            var _ENTER_KEYCODE = 13;
	            var _SHIFT_KEYCODE = 16;
	            var _TAB_KEYCODE = 9;
	            var _LEFT_ARROW_KEYCODE = 37;
	            var _RIGHT_ARROW_KEYCODE = 39;
	            // map events to special keys...
	            // mappings is an array of maps from events to specialKeys as declared in textAngularSetup
	            var _keyMappings = [
	                //		ctrl/command + z
	                {
	                    specialKey: 'UndoKey',
	                    forbiddenModifiers: _ALT_KEY + _SHIFT_KEY,
	                    mustHaveModifiers: [_META_KEY + _CTRL_KEY],
	                    keyCode: 90
	                },
	                //		ctrl/command + shift + z
	                {
	                    specialKey: 'RedoKey',
	                    forbiddenModifiers: _ALT_KEY,
	                    mustHaveModifiers: [_META_KEY + _CTRL_KEY, _SHIFT_KEY],
	                    keyCode: 90
	                },
	                //		ctrl/command + y
	                {
	                    specialKey: 'RedoKey',
	                    forbiddenModifiers: _ALT_KEY + _SHIFT_KEY,
	                    mustHaveModifiers: [_META_KEY + _CTRL_KEY],
	                    keyCode: 89
	                },
	                //		TabKey
	                {
	                    specialKey: 'TabKey',
	                    forbiddenModifiers: _META_KEY + _SHIFT_KEY + _ALT_KEY + _CTRL_KEY,
	                    mustHaveModifiers: [],
	                    keyCode: _TAB_KEYCODE
	                },
	                //		shift + TabKey
	                {
	                    specialKey: 'ShiftTabKey',
	                    forbiddenModifiers: _META_KEY + _ALT_KEY + _CTRL_KEY,
	                    mustHaveModifiers: [_SHIFT_KEY],
	                    keyCode: _TAB_KEYCODE
	                }
	            ];
	            function _mapKeys(event) {
	                var specialKey;
	                _keyMappings.forEach(function (map){
	                    if (map.keyCode === event.keyCode) {
	                        var netModifiers = (event.metaKey ? _META_KEY: 0) +
	                            (event.ctrlKey ? _CTRL_KEY: 0) +
	                            (event.shiftKey ? _SHIFT_KEY: 0) +
	                            (event.altKey ? _ALT_KEY: 0);
	                        if (map.forbiddenModifiers & netModifiers) return;
	                        if (map.mustHaveModifiers.every(function (modifier) { return netModifiers & modifier; })){
	                            specialKey = map.specialKey;
	                        }
	                    }
	                });
	                return specialKey;
	            }
	
	            // set the default to be a paragraph value
	            if(attrs.taDefaultWrap === undefined) attrs.taDefaultWrap = 'p';
	            /* istanbul ignore next: ie specific test */
	            if(attrs.taDefaultWrap === ''){
	                _defaultVal = '';
	                _defaultTest = (_browserDetect.ie === undefined)? '<div><br></div>' : (_browserDetect.ie >= 11)? '<p><br></p>' : (_browserDetect.ie <= 8)? '<P>&nbsp;</P>' : '<p>&nbsp;</p>';
	            }else{
	                _defaultVal = (_browserDetect.ie === undefined || _browserDetect.ie >= 11)?
	                    (attrs.taDefaultWrap.toLowerCase() === 'br' ? '<BR><BR>' : '<' + attrs.taDefaultWrap + '><br></' + attrs.taDefaultWrap + '>') :
	                    (_browserDetect.ie <= 8)?
	                        '<' + attrs.taDefaultWrap.toUpperCase() + '></' + attrs.taDefaultWrap.toUpperCase() + '>' :
	                        '<' + attrs.taDefaultWrap + '></' + attrs.taDefaultWrap + '>';
	                _defaultTest = (_browserDetect.ie === undefined || _browserDetect.ie >= 11)?
	                    (attrs.taDefaultWrap.toLowerCase() === 'br' ? '<br><br>' : '<' + attrs.taDefaultWrap + '><br></' + attrs.taDefaultWrap + '>') :
	                    (_browserDetect.ie <= 8)?
	                        '<' + attrs.taDefaultWrap.toUpperCase() + '>&nbsp;</' + attrs.taDefaultWrap.toUpperCase() + '>' :
	                        '<' + attrs.taDefaultWrap + '>&nbsp;</' + attrs.taDefaultWrap + '>';
	            }
	
	            /* istanbul ignore else */
	            if(!ngModelOptions.$options) ngModelOptions.$options = {}; // ng-model-options support
	
	            var _ensureContentWrapped = function(value) {
	                if (_taBlankTest(value)) return value;
	                var domTest = angular.element("<div>" + value + "</div>");
	                //console.log('domTest.children().length():', domTest.children().length);
	                //console.log('_ensureContentWrapped', domTest.children());
	                //console.log(value, attrs.taDefaultWrap);
	                if (domTest.children().length === 0) {
	                    // if we have a <br> and the attrs.taDefaultWrap is a <p> we need to remove the <br>
	                    //value = value.replace(/<br>/i, '');
	                    value = "<" + attrs.taDefaultWrap + ">" + value + "</" + attrs.taDefaultWrap + ">";
	                } else {
	                    var _children = domTest[0].childNodes;
	                    var i;
	                    var _foundBlockElement = false;
	                    for (i = 0; i < _children.length; i++) {
	                        if (_foundBlockElement = _children[i].nodeName.toLowerCase().match(BLOCKELEMENTS)) break;
	                    }
	                    if (!_foundBlockElement) {
	                        value = "<" + attrs.taDefaultWrap + ">" + value + "</" + attrs.taDefaultWrap + ">";
	                    }
	                    else{
	                        value = "";
	                        for(i = 0; i < _children.length; i++){
	                            var node = _children[i];
	                            var nodeName = node.nodeName.toLowerCase();
	                            //console.log('node#:', i, 'name:', nodeName);
	                            if(nodeName === '#comment') {
	                                value += '<!--' + node.nodeValue + '-->';
	                            } else if(nodeName === '#text') {
	                                // determine if this is all whitespace, if so, we will leave it as it is.
	                                // otherwise, we will wrap it as it is
	                                var text = node.textContent;
	                                if (!text.trim()) {
	                                    // just whitespace
	                                    value += text;
	                                } else {
	                                    // not pure white space so wrap in <p>...</p> or whatever attrs.taDefaultWrap is set to.
	                                    value += "<" + attrs.taDefaultWrap + ">" + text + "</" + attrs.taDefaultWrap + ">";
	                                }
	                            } else if(!nodeName.match(BLOCKELEMENTS)){
	                                /* istanbul ignore  next: Doesn't seem to trigger on tests */
	                                var _subVal = (node.outerHTML || node.nodeValue);
	                                /* istanbul ignore else: Doesn't seem to trigger on tests, is tested though */
	                                if(_subVal.trim() !== '')
	                                    value += "<" + attrs.taDefaultWrap + ">" + _subVal + "</" + attrs.taDefaultWrap + ">";
	                                else value += _subVal;
	                            } else {
	                                value += node.outerHTML;
	                            }
	                            //console.log(value);
	                        }
	                    }
	                }
	                //console.log(value);
	                return value;
	            };
	
	            if(attrs.taPaste) {
	                _pasteHandler = $parse(attrs.taPaste);
	            }
	
	            element.addClass('ta-bind');
	
	            var _undoKeyupTimeout;
	
	            scope['$undoManager' + (attrs.id || '')] = ngModel.$undoManager = {
	                _stack: [],
	                _index: 0,
	                _max: 1000,
	                push: function(value){
	                    if((typeof value === "undefined" || value === null) ||
	                        ((typeof this.current() !== "undefined" && this.current() !== null) && value === this.current())) return value;
	                    if(this._index < this._stack.length - 1){
	                        this._stack = this._stack.slice(0,this._index+1);
	                    }
	                    this._stack.push(value);
	                    if(_undoKeyupTimeout) $timeout.cancel(_undoKeyupTimeout);
	                    if(this._stack.length > this._max) this._stack.shift();
	                    this._index = this._stack.length - 1;
	                    return value;
	                },
	                undo: function(){
	                    return this.setToIndex(this._index-1);
	                },
	                redo: function(){
	                    return this.setToIndex(this._index+1);
	                },
	                setToIndex: function(index){
	                    if(index < 0 || index > this._stack.length - 1){
	                        return undefined;
	                    }
	                    this._index = index;
	                    return this.current();
	                },
	                current: function(){
	                    return this._stack[this._index];
	                }
	            };
	
	            // in here we are undoing the converts used elsewhere to prevent the < > and & being displayed when they shouldn't in the code.
	            var _compileHtml = function(){
	                if(_isContentEditable) {
	                    return element[0].innerHTML;
	                }
	                if(_isInputFriendly) {
	                    return element.val();
	                }
	                throw ('textAngular Error: attempting to update non-editable taBind');
	            };
	
	            var selectorClickHandler = function(event){
	                // emit the element-select event, pass the element
	                scope.$emit('ta-element-select', this);
	                event.preventDefault();
	                return false;
	            };
	
	            //used for updating when inserting wrapped elements
	            var _reApplyOnSelectorHandlers = scope['reApplyOnSelectorHandlers' + (attrs.id || '')] = function(){
	                /* istanbul ignore else */
	                if(!_isReadonly) angular.forEach(taSelectableElements, function(selector){
	                    // check we don't apply the handler twice
	                    element.find(selector)
	                        .off('click', selectorClickHandler)
	                        .on('click', selectorClickHandler);
	                });
	            };
	
	            var _setViewValue = function(_val, triggerUndo, skipRender){
	                _skipRender = skipRender || false;
	                if(typeof triggerUndo === "undefined" || triggerUndo === null) triggerUndo = true && _isContentEditable; // if not contentEditable then the native undo/redo is fine
	                if(typeof _val === "undefined" || _val === null) _val = _compileHtml();
	                if(_taBlankTest(_val)){
	                    // this avoids us from tripping the ng-pristine flag if we click in and out with out typing
	                    if(ngModel.$viewValue !== '') ngModel.$setViewValue('');
	                    if(triggerUndo && ngModel.$undoManager.current() !== '') ngModel.$undoManager.push('');
	                }else{
	                    _reApplyOnSelectorHandlers();
	                    if(ngModel.$viewValue !== _val){
	                        ngModel.$setViewValue(_val);
	                        if(triggerUndo) ngModel.$undoManager.push(_val);
	                    }
	                }
	                ngModel.$render();
	            };
	
	            var _setInnerHTML = function(newval){
	                element[0].innerHTML = newval;
	            };
	
	            var _redoUndoTimeout;
	            var _undo = scope['$undoTaBind' + (attrs.id || '')] = function(){
	                /* istanbul ignore else: can't really test it due to all changes being ignored as well in readonly */
	                if(!_isReadonly && _isContentEditable){
	                    var content = ngModel.$undoManager.undo();
	                    if(typeof content !== "undefined" && content !== null){
	                        _setInnerHTML(content);
	                        _setViewValue(content, false);
	                        if(_redoUndoTimeout) $timeout.cancel(_redoUndoTimeout);
	                        _redoUndoTimeout = $timeout(function(){
	                            element[0].focus();
	                            taSelection.setSelectionToElementEnd(element[0]);
	                        }, 1);
	                    }
	                }
	            };
	
	            var _redo = scope['$redoTaBind' + (attrs.id || '')] = function(){
	                /* istanbul ignore else: can't really test it due to all changes being ignored as well in readonly */
	                if(!_isReadonly && _isContentEditable){
	                    var content = ngModel.$undoManager.redo();
	                    if(typeof content !== "undefined" && content !== null){
	                        _setInnerHTML(content);
	                        _setViewValue(content, false);
	                        /* istanbul ignore next */
	                        if(_redoUndoTimeout) $timeout.cancel(_redoUndoTimeout);
	                        _redoUndoTimeout = $timeout(function(){
	                            element[0].focus();
	                            taSelection.setSelectionToElementEnd(element[0]);
	                        }, 1);
	                    }
	                }
	            };
	
	            //used for updating when inserting wrapped elements
	            scope['updateTaBind' + (attrs.id || '')] = function(){
	                if(!_isReadonly) _setViewValue(undefined, undefined, true);
	            };
	
	            // catch DOM XSS via taSanitize
	            // Sanitizing both ways is identical
	            var _sanitize = function(unsafe){
	                return (ngModel.$oldViewValue = taSanitize(taFixChrome(unsafe, _keepStyles), ngModel.$oldViewValue, _disableSanitizer));
	            };
	
	            // trigger the validation calls
	            if(element.attr('required')) ngModel.$validators.required = function(modelValue, viewValue) {
	                return !_taBlankTest(modelValue || viewValue);
	            };
	            // parsers trigger from the above keyup function or any other time that the viewValue is updated and parses it for storage in the ngModel
	            ngModel.$parsers.push(_sanitize);
	            ngModel.$parsers.unshift(_ensureContentWrapped);
	            // because textAngular is bi-directional (which is awesome) we need to also sanitize values going in from the server
	            ngModel.$formatters.push(_sanitize);
	            ngModel.$formatters.unshift(_ensureContentWrapped);
	            ngModel.$formatters.unshift(function(value){
	                return ngModel.$undoManager.push(value || '');
	            });
	
	            //this code is used to update the models when data is entered/deleted
	            if(_isInputFriendly){
	                scope.events = {};
	                if(!_isContentEditable){
	                    // if a textarea or input just add in change and blur handlers, everything else is done by angulars input directive
	                    element.on('change blur', scope.events.change = scope.events.blur = function(){
	                        if(!_isReadonly) ngModel.$setViewValue(_compileHtml());
	                    });
	
	                    element.on('keydown', scope.events.keydown = function(event, eventData){
	                        /* istanbul ignore else: this is for catching the jqLite testing*/
	                        if(eventData) angular.extend(event, eventData);
	                        // Reference to http://stackoverflow.com/questions/6140632/how-to-handle-tab-in-textarea
	                        /* istanbul ignore else: otherwise normal functionality */
	                        if(event.keyCode === _TAB_KEYCODE){ // tab was pressed
	                            // get caret position/selection
	                            var start = this.selectionStart;
	                            var end = this.selectionEnd;
	
	                            var value = element.val();
	                            if(event.shiftKey){
	                                // find \t
	                                var _linebreak = value.lastIndexOf('\n', start), _tab = value.lastIndexOf('\t', start);
	                                if(_tab !== -1 && _tab >= _linebreak){
	                                    // set textarea value to: text before caret + tab + text after caret
	                                    element.val(value.substring(0, _tab) + value.substring(_tab + 1));
	
	                                    // put caret at right position again (add one for the tab)
	                                    this.selectionStart = this.selectionEnd = start - 1;
	                                }
	                            }else{
	                                // set textarea value to: text before caret + tab + text after caret
	                                element.val(value.substring(0, start) + "\t" + value.substring(end));
	
	                                // put caret at right position again (add one for the tab)
	                                this.selectionStart = this.selectionEnd = start + 1;
	                            }
	                            // prevent the focus lose
	                            event.preventDefault();
	                        }
	                    });
	
	                    var _repeat = function(string, n){
	                        var result = '';
	                        for(var _n = 0; _n < n; _n++) result += string;
	                        return result;
	                    };
	
	                    // add a forEach function that will work on a NodeList, etc..
	                    var forEach = function (array, callback, scope) {
	                        for (var i= 0; i<array.length; i++) {
	                            callback.call(scope, i, array[i]);
	                        }
	                    };
	
	                    // handle <ul> or <ol> nodes
	                    var recursiveListFormat = function(listNode, tablevel){
	                        var _html = '';
	                        var _subnodes = listNode.childNodes;
	                        tablevel++;
	                        // tab out and add the <ul> or <ol> html piece
	                        _html += _repeat('\t', tablevel-1) + listNode.outerHTML.substring(0, 4);
	                        forEach(_subnodes, function (index, node) {
	                            /* istanbul ignore next: browser catch */
	                            var nodeName = node.nodeName.toLowerCase();
	                            if (nodeName === '#comment') {
	                                _html += '<!--' + node.nodeValue + '-->';
	                                return;
	                            }
	                            if (nodeName === '#text') {
	                                _html += node.textContent;
	                                return;
	                            }
	                            /* istanbul ignore next: not tested, and this was original code -- so not wanting to possibly cause an issue, leaving it... */
	                            if(!node.outerHTML) {
	                                // no html to add
	                                return;
	                            }
	                            if(nodeName === 'ul' || nodeName === 'ol') {
	                                _html += '\n' + recursiveListFormat(node, tablevel);
	                            }
	                            else {
	                                // no reformatting within this subnode, so just do the tabing...
	                                _html += '\n' + _repeat('\t', tablevel) + node.outerHTML;
	                            }
	                        });
	                        // now add on the </ol> or </ul> piece
	                        _html += '\n' + _repeat('\t', tablevel-1) + listNode.outerHTML.substring(listNode.outerHTML.lastIndexOf('<'));
	                        return _html;
	                    };
	                    // handle formating of something like:
	                    // <ol><!--First comment-->
	                    //  <li>Test Line 1<!--comment test list 1--></li>
	                    //    <ul><!--comment ul-->
	                    //      <li>Nested Line 1</li>
	                    //        <!--comment between nested lines--><li>Nested Line 2</li>
	                    //    </ul>
	                    //  <li>Test Line 3</li>
	                    // </ol>
	                    ngModel.$formatters.unshift(function(htmlValue){
	                        // tabulate the HTML so it looks nicer
	                        //
	                        // first get a list of the nodes...
	                        // we do this by using the element parser...
	                        //
	                        // doing this -- which is simpiler -- breaks our tests...
	                        //var _nodes=angular.element(htmlValue);
	                        var _nodes = angular.element('<div>' + htmlValue + '</div>')[0].childNodes;
	                        if(_nodes.length > 0){
	                            // do the reformatting of the layout...
	                            htmlValue = '';
	                            forEach(_nodes, function (index, node) {
	                                var nodeName = node.nodeName.toLowerCase();
	                                if (nodeName === '#comment') {
	                                    htmlValue += '<!--' + node.nodeValue + '-->';
	                                    return;
	                                }
	                                if (nodeName === '#text') {
	                                    htmlValue += node.textContent;
	                                    return;
	                                }
	                                /* istanbul ignore next: not tested, and this was original code -- so not wanting to possibly cause an issue, leaving it... */
	                                if(!node.outerHTML)
	                                {
	                                    // nothing to format!
	                                    return;
	                                }
	                                if(htmlValue.length > 0) {
	                                    // we aready have some content, so drop to a new line
	                                    htmlValue += '\n';
	                                }
	                                if(nodeName === 'ul' || nodeName === 'ol') {
	                                    // okay a set of list stuff we want to reformat in a nested way
	                                    htmlValue += '' + recursiveListFormat(node, 0);
	                                }
	                                else {
	                                    // just use the original without any additional formating
	                                    htmlValue += '' + node.outerHTML;
	                                }
	                            });
	                        }
	                        return htmlValue;
	                    });
	                }else{
	                    // all the code specific to contenteditable divs
	                    var _processingPaste = false;
	                    /* istanbul ignore next: phantom js cannot test this for some reason */
	                    var processpaste = function(text) {
	                       var _isOneNote = text!==undefined? text.match(/content=["']*OneNote.File/i): false;
	                        /* istanbul ignore else: don't care if nothing pasted */
	                        //console.log(text);
	                        if(text && text.trim().length){
	                            // test paste from word/microsoft product
	                            if(text.match(/class=["']*Mso(Normal|List)/i) || text.match(/content=["']*Word.Document/i) || text.match(/content=["']*OneNote.File/i)){
	                                var textFragment = text.match(/<!--StartFragment-->([\s\S]*?)<!--EndFragment-->/i);
	                                if(!textFragment) textFragment = text;
	                                else textFragment = textFragment[1];
	                                textFragment = textFragment.replace(/<o:p>[\s\S]*?<\/o:p>/ig, '').replace(/class=(["']|)MsoNormal(["']|)/ig, '');
	                                var dom = angular.element("<div>" + textFragment + "</div>");
	                                var targetDom = angular.element("<div></div>");
	                                var _list = {
	                                    element: null,
	                                    lastIndent: [],
	                                    lastLi: null,
	                                    isUl: false
	                                };
	                                _list.lastIndent.peek = function(){
	                                    var n = this.length;
	                                    if (n>0) return this[n-1];
	                                };
	                                var _resetList = function(isUl){
	                                    _list.isUl = isUl;
	                                    _list.element = angular.element(isUl ? "<ul>" : "<ol>");
	                                    _list.lastIndent = [];
	                                    _list.lastIndent.peek = function(){
	                                        var n = this.length;
	                                        if (n>0) return this[n-1];
	                                    };
	                                    _list.lastLevelMatch = null;
	                                };
	                                for(var i = 0; i <= dom[0].childNodes.length; i++){
	                                    if(!dom[0].childNodes[i] || dom[0].childNodes[i].nodeName === "#text"){
	                                        continue;
	                                    } else {
	                                        var tagName = dom[0].childNodes[i].tagName.toLowerCase();
	                                        if(tagName !== 'p' &&
	                                            tagName !== 'ul' &&
	                                            tagName !== 'h1' &&
	                                            tagName !== 'h2' &&
	                                            tagName !== 'h3' &&
	                                            tagName !== 'h4' &&
	                                            tagName !== 'h5' &&
	                                            tagName !== 'h6' &&
	                                            tagName !== 'table'){
	                                            continue;
	                                        }
	                                    }
	                                    var el = angular.element(dom[0].childNodes[i]);
	                                    var _listMatch = (el.attr('class') || '').match(/MsoList(Bullet|Number|Paragraph)(CxSp(First|Middle|Last)|)/i);
	
	                                    if(_listMatch){
	                                        if(el[0].childNodes.length < 2 || el[0].childNodes[1].childNodes.length < 1){
	                                            continue;
	                                        }
	                                        var isUl = _listMatch[1].toLowerCase() === 'bullet' || (_listMatch[1].toLowerCase() !== 'number' && !(/^[^0-9a-z<]*[0-9a-z]+[^0-9a-z<>]</i.test(el[0].childNodes[1].innerHTML) || /^[^0-9a-z<]*[0-9a-z]+[^0-9a-z<>]</i.test(el[0].childNodes[1].childNodes[0].innerHTML)));
	                                        var _indentMatch = (el.attr('style') || '').match(/margin-left:([\-\.0-9]*)/i);
	                                        var indent = parseFloat((_indentMatch)?_indentMatch[1]:0);
	                                        var _levelMatch = (el.attr('style') || '').match(/mso-list:l([0-9]+) level([0-9]+) lfo[0-9+]($|;)/i);
	                                        // prefers the mso-list syntax
	
	                                        if(_levelMatch && _levelMatch[2]) indent = parseInt(_levelMatch[2]);
	
	                                        if ((_levelMatch && (!_list.lastLevelMatch || _levelMatch[1] !== _list.lastLevelMatch[1])) || !_listMatch[3] || _listMatch[3].toLowerCase() === 'first' || (_list.lastIndent.peek() === null) || (_list.isUl !== isUl && _list.lastIndent.peek() === indent)) {
	                                            _resetList(isUl);
	                                            targetDom.append(_list.element);
	                                        } else if (_list.lastIndent.peek() != null && _list.lastIndent.peek() < indent){
	                                            _list.element = angular.element(isUl ? '<ul>' : '<ol>');
	                                            _list.lastLi.append(_list.element);
	                                        } else if (_list.lastIndent.peek() != null && _list.lastIndent.peek() > indent){
	                                            while(_list.lastIndent.peek() != null && _list.lastIndent.peek() > indent){
	                                                if(_list.element.parent()[0].tagName.toLowerCase() === 'li'){
	                                                    _list.element = _list.element.parent();
	                                                    continue;
	                                                }else if(/[uo]l/i.test(_list.element.parent()[0].tagName.toLowerCase())){
	                                                    _list.element = _list.element.parent();
	                                                }else{ // else it's it should be a sibling
	                                                    break;
	                                                }
	                                                _list.lastIndent.pop();
	                                            }
	                                            _list.isUl = _list.element[0].tagName.toLowerCase() === 'ul';
	                                            if (isUl !== _list.isUl) {
	                                                _resetList(isUl);
	                                                targetDom.append(_list.element);
	                                            }
	                                        }
	
	                                        _list.lastLevelMatch = _levelMatch;
	                                        if(indent !== _list.lastIndent.peek()) _list.lastIndent.push(indent);
	                                        _list.lastLi = angular.element('<li>');
	                                        _list.element.append(_list.lastLi);
	                                        _list.lastLi.html(el.html().replace(/<!(--|)\[if !supportLists\](--|)>[\s\S]*?<!(--|)\[endif\](--|)>/ig, ''));
	                                        el.remove();
	                                    }else{
	                                        _resetList(false);
	                                        targetDom.append(el);
	                                    }
	                                }
	                                var _unwrapElement = function(node){
	                                    node = angular.element(node);
	                                    for(var _n = node[0].childNodes.length - 1; _n >= 0; _n--) node.after(node[0].childNodes[_n]);
	                                    node.remove();
	                                };
	
	                                angular.forEach(targetDom.find('span'), function(node){
	                                    node.removeAttribute('lang');
	                                    if(node.attributes.length <= 0) _unwrapElement(node);
	                                });
	                                angular.forEach(targetDom.find('font'), _unwrapElement);
	
	                                text = targetDom.html();
	                                if(_isOneNote){
	                                    text = targetDom.html() || dom.html();
	                                }
	                                // LF characters instead of spaces in some spots and they are replaced by '/n', so we need to just swap them to spaces
	                                text = text.replace(/\n/g, ' ');
	                            }else{
	                                // remove unnecessary chrome insert
	                                text = text.replace(/<(|\/)meta[^>]*?>/ig, '');
	                                if(text.match(/<[^>]*?(ta-bind)[^>]*?>/)){
	                                    // entire text-angular or ta-bind has been pasted, REMOVE AT ONCE!!
	                                    if(text.match(/<[^>]*?(text-angular)[^>]*?>/)){
	                                        var _el = angular.element('<div>' + text + '</div>');
	                                        _el.find('textarea').remove();
	                                        for(var _b = 0; _b < binds.length; _b++){
	                                            var _target = binds[_b][0].parentNode.parentNode;
	                                            for(var _c = 0; _c < binds[_b][0].childNodes.length; _c++){
	                                                _target.parentNode.insertBefore(binds[_b][0].childNodes[_c], _target);
	                                            }
	                                            _target.parentNode.removeChild(_target);
	                                        }
	                                        text = _el.html().replace('<br class="Apple-interchange-newline">', '');
	                                    }
	                                }else if(text.match(/^<span/)){
	                                    // in case of pasting only a span - chrome paste, remove them. THis is just some wierd formatting
	                                    // if we remove the '<span class="Apple-converted-space"> </span>' here we destroy the spacing
	                                    // on paste from even ourselves!
	                                    if (!text.match(/<span class=(\"Apple-converted-space\"|\'Apple-converted-space\')>.<\/span>/ig)) {
	                                        text = text.replace(/<(|\/)span[^>]*?>/ig, '');
	                                    }
	                                }
	                                // Webkit on Apple tags
	                                text = text.replace(/<br class="Apple-interchange-newline"[^>]*?>/ig, '').replace(/<span class="Apple-converted-space">( |&nbsp;)<\/span>/ig, '&nbsp;');
	                            }
	
	                            if (/<li(\s.*)?>/i.test(text) && /(<ul(\s.*)?>|<ol(\s.*)?>).*<li(\s.*)?>/i.test(text) === false) {
	                                // insert missing parent of li element
	                                text = text.replace(/<li(\s.*)?>.*<\/li(\s.*)?>/i, '<ul>$&</ul>');
	                            }
	
	                            // parse whitespace from plaintext input, starting with preceding spaces that get stripped on paste
	                            text = text.replace(/^[ |\u00A0]+/gm, function (match) {
	                                var result = '';
	                                for (var i = 0; i < match.length; i++) {
	                                    result += '&nbsp;';
	                                }
	                                return result;
	                            }).replace(/\n|\r\n|\r/g, '<br />').replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;');
	
	                            if(_pasteHandler) text = _pasteHandler(scope, {$html: text}) || text;
	
	                            // turn span vertical-align:super into <sup></sup>
	                            text = text.replace(/<span style=("|')([^<]*?)vertical-align\s*:\s*super;?([^>]*?)("|')>([^<]+?)<\/span>/g, "<sup style='$2$3'>$5</sup>");
	
	                            text = taSanitize(text, '', _disableSanitizer);
	                            //console.log('DONE\n', text);
	
	                            taSelection.insertHtml(text, element[0]);
	                            $timeout(function(){
	                                ngModel.$setViewValue(_compileHtml());
	                                _processingPaste = false;
	                                element.removeClass('processing-paste');
	                            }, 0);
	                        }else{
	                            _processingPaste = false;
	                            element.removeClass('processing-paste');
	                        }
	                    };
	
	                    element.on('paste', scope.events.paste = function(e, eventData){
	                        /* istanbul ignore else: this is for catching the jqLite testing*/
	                        if(eventData) angular.extend(e, eventData);
	                        if(_isReadonly || _processingPaste){
	                            e.stopPropagation();
	                            e.preventDefault();
	                            return false;
	                        }
	
	                        // Code adapted from http://stackoverflow.com/questions/2176861/javascript-get-clipboard-data-on-paste-event-cross-browser/6804718#6804718
	                        _processingPaste = true;
	                        element.addClass('processing-paste');
	                        var pastedContent;
	                        var clipboardData = (e.originalEvent || e).clipboardData;
	                        /* istanbul ignore next: Handle legacy IE paste */
	                        if ( !clipboardData && window.clipboardData && window.clipboardData.getData ){
	                            pastedContent = window.clipboardData.getData("Text");
	                            processpaste(pastedContent);
	                            e.stopPropagation();
	                            e.preventDefault();
	                            return false;
	                        }
	                        if (clipboardData && clipboardData.getData && clipboardData.types.length > 0) {// Webkit - get data from clipboard, put into editdiv, cleanup, then cancel event
	                            var _types = "";
	                            for(var _t = 0; _t < clipboardData.types.length; _t++){
	                                _types += " " + clipboardData.types[_t];
	                            }
	                            /* istanbul ignore next: browser tests */
	                            if (/text\/html/i.test(_types)) {
	                                pastedContent = clipboardData.getData('text/html');
	                            } else if (/text\/plain/i.test(_types)) {
	                                pastedContent = clipboardData.getData('text/plain');
	                            }
	                            processpaste(pastedContent);
	                            e.stopPropagation();
	                            e.preventDefault();
	                            return false;
	                        } else {// Everything else - empty editdiv and allow browser to paste content into it, then cleanup
	                            var _savedSelection = rangy.saveSelection(),
	                                _tempDiv = angular.element('<div class="ta-hidden-input" contenteditable="true"></div>');
	                            $document.find('body').append(_tempDiv);
	                            _tempDiv[0].focus();
	                            $timeout(function(){
	                                // restore selection
	                                rangy.restoreSelection(_savedSelection);
	                                processpaste(_tempDiv[0].innerHTML);
	                                element[0].focus();
	                                _tempDiv.remove();
	                            }, 0);
	                        }
	                    });
	                    element.on('cut', scope.events.cut = function(e){
	                        // timeout to next is needed as otherwise the paste/cut event has not finished actually changing the display
	                        if(!_isReadonly) $timeout(function(){
	                            ngModel.$setViewValue(_compileHtml());
	                        }, 0);
	                        else e.preventDefault();
	                    });
	
	                    element.on('keydown', scope.events.keydown = function(event, eventData){
	                        /* istanbul ignore else: this is for catching the jqLite testing*/
	                        if(eventData) angular.extend(event, eventData);
	                        if (event.keyCode === _SHIFT_KEYCODE) {
	                            taSelection.setStateShiftKey(true);
	                        } else {
	                            taSelection.setStateShiftKey(false);
	                        }
	                        event.specialKey = _mapKeys(event);
	                        var userSpecialKey;
	                        /* istanbul ignore next: difficult to test */
	                        taOptions.keyMappings.forEach(function (mapping) {
	                            if (event.specialKey === mapping.commandKeyCode) {
	                                // taOptions has remapped this binding... so
	                                // we disable our own
	                                event.specialKey = undefined;
	                            }
	                            if (mapping.testForKey(event)) {
	                                userSpecialKey = mapping.commandKeyCode;
	                            }
	                            if ((mapping.commandKeyCode === 'UndoKey') || (mapping.commandKeyCode === 'RedoKey')) {
	                                // this is necessary to fully stop the propagation.
	                                if (!mapping.enablePropagation) {
	                                    event.preventDefault();
	                                }
	                            }
	                        });
	                        /* istanbul ignore next: difficult to test */
	                        if (typeof userSpecialKey !== 'undefined') {
	                            event.specialKey = userSpecialKey;
	                        }
	                        /* istanbul ignore next: difficult to test as can't seem to select */
	                        if ((typeof event.specialKey !== 'undefined') && (
	                                event.specialKey !== 'UndoKey' || event.specialKey !== 'RedoKey'
	                            )) {
	                            event.preventDefault();
	                            textAngularManager.sendKeyCommand(scope, event);
	                        }
	                        /* istanbul ignore else: readonly check */
	                        if(!_isReadonly){
	                            if (event.specialKey==='UndoKey') {
	                                _undo();
	                                event.preventDefault();
	                            }
	                            if (event.specialKey==='RedoKey') {
	                                _redo();
	                                event.preventDefault();
	                            }
	                            /* istanbul ignore next: difficult to test as can't seem to select */
	                            if(event.keyCode === _ENTER_KEYCODE && !event.shiftKey && !event.ctrlKey && !event.metaKey && !event.altKey)
	                            {
	                                var contains = function(a, obj) {
	                                    for (var i = 0; i < a.length; i++) {
	                                        if (a[i] === obj) {
	                                            return true;
	                                        }
	                                    }
	                                    return false;
	                                };
	                                var $selection;
	                                var selection = taSelection.getSelectionElement();
	                                // shifted to nodeName here from tagName since it is more widely supported see: http://stackoverflow.com/questions/4878484/difference-between-tagname-and-nodename
	                                if(!selection.nodeName.match(VALIDELEMENTS)) return;
	                                var _new = angular.element(_defaultVal);
	                                // if we are in the last element of a blockquote, or ul or ol and the element is blank
	                                // we need to pull the element outside of the said type
	                                var moveOutsideElements = ['blockquote', 'ul', 'ol'];
	                                if (contains(moveOutsideElements, selection.parentNode.tagName.toLowerCase())) {
	                                    if (/^<br(|\/)>$/i.test(selection.innerHTML.trim()) && !selection.nextSibling) {
	                                        // if last element is blank, pull element outside.
	                                        $selection = angular.element(selection);
	                                        var _parent = $selection.parent();
	                                        _parent.after(_new);
	                                        $selection.remove();
	                                        if (_parent.children().length === 0) _parent.remove();
	                                        taSelection.setSelectionToElementStart(_new[0]);
	                                        event.preventDefault();
	                                    }
	                                    if (/^<[^>]+><br(|\/)><\/[^>]+>$/i.test(selection.innerHTML.trim())) {
	                                        $selection = angular.element(selection);
	                                        $selection.after(_new);
	                                        $selection.remove();
	                                        taSelection.setSelectionToElementStart(_new[0]);
	                                        event.preventDefault();
	                                    }
	                                }
	                            }
	                        }
	                    });
	                    var _keyupTimeout;
	                    element.on('keyup', scope.events.keyup = function(event, eventData){
	                        /* istanbul ignore else: this is for catching the jqLite testing*/
	                        if(eventData) angular.extend(event, eventData);
	                        taSelection.setStateShiftKey(false);	// clear the ShiftKey state
	                        /* istanbul ignore next: FF specific bug fix */
	                        if (event.keyCode === _TAB_KEYCODE) {
	                            var _selection = taSelection.getSelection();
	                            if(_selection.start.element === element[0] && element.children().length) taSelection.setSelectionToElementStart(element.children()[0]);
	                            return;
	                        }
	                        // we do this here during the 'keyup' so that the browser has already moved the slection by one character...
	                        if (event.keyCode === _LEFT_ARROW_KEYCODE && !event.shiftKey) {
	                            taSelection.updateLeftArrowKey(element);
	                        }
	                        // we do this here during the 'keyup' so that the browser has already moved the slection by one character...
	                        if (event.keyCode === _RIGHT_ARROW_KEYCODE && !event.shiftKey) {
	                            taSelection.updateRightArrowKey(element);
	                        }
	                        if(_undoKeyupTimeout) $timeout.cancel(_undoKeyupTimeout);
	                        if(!_isReadonly && !BLOCKED_KEYS.test(event.keyCode)){
	                            /* istanbul ignore next: Ignore any _ENTER_KEYCODE that has ctrlKey, metaKey or alKey */
	                            if (event.keyCode === _ENTER_KEYCODE && (event.ctrlKey || event.metaKey || event.altKey)) {
	                                // we ignore any ENTER_	KEYCODE that is anything but plain or a shift one...
	                            } else {
	                                // if enter - insert new taDefaultWrap, if shift+enter insert <br/>
	                                if(_defaultVal !== '' && _defaultVal !== '<BR><BR>' && event.keyCode === _ENTER_KEYCODE && !event.ctrlKey && !event.metaKey && !event.altKey){
	                                    var selection = taSelection.getSelectionElement();
	                                    while(!selection.nodeName.match(VALIDELEMENTS) && selection !== element[0]){
	                                        selection = selection.parentNode;
	                                    }
	                                    if(!event.shiftKey){
	                                        // new paragraph, br should be caught correctly
	                                        // shifted to nodeName here from tagName since it is more widely supported see: http://stackoverflow.com/questions/4878484/difference-between-tagname-and-nodename
	                                        //console.log('Enter', selection.nodeName, attrs.taDefaultWrap, selection.innerHTML.trim());
	                                        if(selection.tagName.toLowerCase() !==
	                                            attrs.taDefaultWrap &&
	                                            selection.nodeName.toLowerCase() !== 'li' &&
	                                            (selection.innerHTML.trim() === '' || selection.innerHTML.trim() === '<br>')
	                                        ) {
	                                            // Chrome starts with a <div><br></div> after an EnterKey
	                                            // so we replace this with the _defaultVal
	                                            var _new = angular.element(_defaultVal);
	                                            angular.element(selection).replaceWith(_new);
	                                            taSelection.setSelectionToElementStart(_new[0]);
	                                        }
	                                    } else {
	                                        // shift + Enter
	                                        var tagName = selection.tagName.toLowerCase();
	                                        //console.log('Shift+Enter', selection.tagName, attrs.taDefaultWrap, selection.innerHTML.trim());
	                                        // For an LI: We see: LI p ....<br><br>
	                                        // For a P: We see: P p ....<br><br>
	                                        // on Safari, the browser ignores the Shift+Enter and acts just as an Enter Key
	                                        // For an LI: We see: LI p <br>
	                                        // For a P: We see: P p <br>
	                                        if((tagName === attrs.taDefaultWrap ||
	                                            tagName === 'li' ||
	                                            tagName === 'pre' ||
	                                            tagName === 'div') &&
	                                            !/.+<br><br>/.test(selection.innerHTML.trim())) {
	                                            var ps = selection.previousSibling;
	                                            //console.log('wrong....', ps);
	                                            // we need to remove this selection and fix the previousSibling up...
	                                            if (ps) {
	                                                ps.innerHTML = ps.innerHTML + '<br><br>';
	                                                angular.element(selection).remove();
	                                                taSelection.setSelectionToElementEnd(ps);
	                                            }
	                                        }
	                                    }
	                                }
	                                var val = _compileHtml();
	                                if(_defaultVal !== '' && (val.trim() === '' || val.trim() === '<br>')){
	                                    _setInnerHTML(_defaultVal);
	                                    taSelection.setSelectionToElementStart(element.children()[0]);
	                                }else if(val.substring(0, 1) !== '<' && attrs.taDefaultWrap !== ''){
	                                    /* we no longer do this, since there can be comments here and white space
	                                     var _savedSelection = rangy.saveSelection();
	                                     val = _compileHtml();
	                                     val = "<" + attrs.taDefaultWrap + ">" + val + "</" + attrs.taDefaultWrap + ">";
	                                     _setInnerHTML(val);
	                                     rangy.restoreSelection(_savedSelection);
	                                     */
	                                }
	                                var triggerUndo = _lastKey !== event.keyCode && UNDO_TRIGGER_KEYS.test(event.keyCode);
	                                if(_keyupTimeout) $timeout.cancel(_keyupTimeout);
	                                _keyupTimeout = $timeout(function() {
	                                    _setViewValue(val, triggerUndo, true);
	                                }, ngModelOptions.$options.debounce || 400);
	                                if(!triggerUndo) _undoKeyupTimeout = $timeout(function(){ ngModel.$undoManager.push(val); }, 250);
	                                _lastKey = event.keyCode;
	                            }
	                        }
	                    });
	
	                    // when there is a change from a spelling correction in the browser, the only
	                    // change that is seen is a 'input' and the $watch('html') sees nothing... So
	                    // we added this element.on('input') to catch this change and call the _setViewValue()
	                    // so the ngModel is updated and all works as it should.
	                    var _inputTimeout;
	                    element.on('input', function() {
	                        if (_compileHtml() !== ngModel.$viewValue) {
	                            // we wait a time now to allow the natural $watch('html') to handle this change
	                            // and then after a 1 second delay, if there is still a difference we will do the
	                            // _setViewValue() call.
	                            /* istanbul ignore if: can't test */
	                            if(_inputTimeout) $timeout.cancel(_inputTimeout);
	                            /* istanbul ignore next: cant' test? */
	                            _inputTimeout = $timeout(function() {
	                                var _savedSelection = rangy.saveSelection();
	                                var _val = _compileHtml();
	                                if (_val !== ngModel.$viewValue) {
	                                    //console.log('_setViewValue');
	                                    //console.log('old:', ngModel.$viewValue);
	                                    //console.log('new:', _val);
	                                    _setViewValue(_val, true);
	                                }
	                                // if the savedSelection marker is gone at this point, we cannot restore the selection!!!
	                                //console.log('rangy.restoreSelection', ngModel.$viewValue.length, _savedSelection);
	                                if (ngModel.$viewValue.length !== 0) {
	                                    rangy.restoreSelection(_savedSelection);
	                                }
	                            }, 1000);
	                        }
	                    });
	
	                    element.on('blur', scope.events.blur = function(){
	                        _focussed = false;
	                        /* istanbul ignore else: if readonly don't update model */
	                        if(!_isReadonly){
	                            _setViewValue(undefined, undefined, true);
	                        }else{
	                            _skipRender = true; // don't redo the whole thing, just check the placeholder logic
	                            ngModel.$render();
	                        }
	                    });
	
	                    // Placeholders not supported on ie 8 and below
	                    if(attrs.placeholder && (_browserDetect.ie > 8 || _browserDetect.ie === undefined)){
	                        var rule;
	                        if(attrs.id) rule = addCSSRule('#' + attrs.id + '.placeholder-text:before', 'content: "' + attrs.placeholder + '"');
	                        else throw('textAngular Error: An unique ID is required for placeholders to work');
	
	                        scope.$on('$destroy', function(){
	                            removeCSSRule(rule);
	                        });
	                    }
	
	                    element.on('focus', scope.events.focus = function(){
	                        _focussed = true;
	                        element.removeClass('placeholder-text');
	                        _reApplyOnSelectorHandlers();
	                    });
	
	                    element.on('mouseup', scope.events.mouseup = function(){
	                        var _selection = taSelection.getSelection();
	                        if(_selection && _selection.start.element === element[0] && element.children().length) taSelection.setSelectionToElementStart(element.children()[0]);
	                    });
	
	                    // prevent propagation on mousedown in editor, see #206
	                    element.on('mousedown', scope.events.mousedown = function(event, eventData){
	                        /* istanbul ignore else: this is for catching the jqLite testing*/
	                        if(eventData) angular.extend(event, eventData);
	                        event.stopPropagation();
	                    });
	                }
	            }
	
	            var fileDropHandler = function(event, eventData){
	                /* istanbul ignore else: this is for catching the jqLite testing*/
	                if(eventData) angular.extend(event, eventData);
	                // emit the drop event, pass the element, preventing should be done elsewhere
	                if(!dropFired && !_isReadonly){
	                    dropFired = true;
	                    var dataTransfer;
	                    if(event.originalEvent) dataTransfer = event.originalEvent.dataTransfer;
	                    else dataTransfer = event.dataTransfer;
	                    scope.$emit('ta-drop-event', this, event, dataTransfer);
	                    $timeout(function(){
	                        dropFired = false;
	                        _setViewValue(undefined, undefined, true);
	                    }, 100);
	                }
	            };
	
	            var _renderTimeout;
	            var _renderInProgress = false;
	            // changes to the model variable from outside the html/text inputs
	            ngModel.$render = function(){
	                /* istanbul ignore if: Catches rogue renders, hard to replicate in tests */
	                if(_renderInProgress) return;
	                else _renderInProgress = true;
	                // catch model being null or undefined
	                var val = ngModel.$viewValue || '';
	                // if the editor isn't focused it needs to be updated, otherwise it's receiving user input
	                if(!_skipRender){
	                    /* istanbul ignore else: in other cases we don't care */
	                    if(_isContentEditable && _focussed){
	                        // update while focussed
	                        element.removeClass('placeholder-text');
	                        /* istanbul ignore next: don't know how to test this */
	                        if(_renderTimeout) $timeout.cancel(_renderTimeout);
	                        _renderTimeout = $timeout(function(){
	                            /* istanbul ignore if: Can't be bothered testing this... */
	                            if(!_focussed){
	                                element[0].focus();
	                                taSelection.setSelectionToElementEnd(element.children()[element.children().length - 1]);
	                            }
	                            _renderTimeout = undefined;
	                        }, 1);
	                    }
	                    if(_isContentEditable){
	                        // WYSIWYG Mode
	                        if(attrs.placeholder){
	                            if(val === ''){
	                                // blank
	                                _setInnerHTML(_defaultVal);
	                            }else{
	                                // not-blank
	                                _setInnerHTML(val);
	                            }
	                        }else{
	                            _setInnerHTML((val === '') ? _defaultVal : val);
	                        }
	                        // if in WYSIWYG and readOnly we kill the use of links by clicking
	                        if(!_isReadonly){
	                            _reApplyOnSelectorHandlers();
	                            element.on('drop', fileDropHandler);
	                        }else{
	                            element.off('drop', fileDropHandler);
	                        }
	                    }else if(element[0].tagName.toLowerCase() !== 'textarea' && element[0].tagName.toLowerCase() !== 'input'){
	                        // make sure the end user can SEE the html code as a display. This is a read-only display element
	                        _setInnerHTML(taApplyCustomRenderers(val));
	                    }else{
	                        // only for input and textarea inputs
	                        element.val(val);
	                    }
	                }
	                if(_isContentEditable && attrs.placeholder){
	                    if(val === ''){
	                        if(_focussed) element.removeClass('placeholder-text');
	                        else element.addClass('placeholder-text');
	                    }else{
	                        element.removeClass('placeholder-text');
	                    }
	                }
	                _renderInProgress = _skipRender = false;
	            };
	
	            if(attrs.taReadonly){
	                //set initial value
	                _isReadonly = scope.$eval(attrs.taReadonly);
	                if(_isReadonly){
	                    element.addClass('ta-readonly');
	                    // we changed to readOnly mode (taReadonly='true')
	                    if(element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input'){
	                        element.attr('disabled', 'disabled');
	                    }
	                    if(element.attr('contenteditable') !== undefined && element.attr('contenteditable')){
	                        element.removeAttr('contenteditable');
	                    }
	                }else{
	                    element.removeClass('ta-readonly');
	                    // we changed to NOT readOnly mode (taReadonly='false')
	                    if(element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input'){
	                        element.removeAttr('disabled');
	                    }else if(_isContentEditable){
	                        element.attr('contenteditable', 'true');
	                    }
	                }
	                // taReadonly only has an effect if the taBind element is an input or textarea or has contenteditable='true' on it.
	                // Otherwise it is readonly by default
	                scope.$watch(attrs.taReadonly, function(newVal, oldVal){
	                    if(oldVal === newVal) return;
	                    if(newVal){
	                        element.addClass('ta-readonly');
	                        // we changed to readOnly mode (taReadonly='true')
	                        if(element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input'){
	                            element.attr('disabled', 'disabled');
	                        }
	                        if(element.attr('contenteditable') !== undefined && element.attr('contenteditable')){
	                            element.removeAttr('contenteditable');
	                        }
	                        // turn ON selector click handlers
	                        angular.forEach(taSelectableElements, function(selector){
	                            element.find(selector).on('click', selectorClickHandler);
	                        });
	                        element.off('drop', fileDropHandler);
	                    }else{
	                        element.removeClass('ta-readonly');
	                        // we changed to NOT readOnly mode (taReadonly='false')
	                        if(element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input'){
	                            element.removeAttr('disabled');
	                        }else if(_isContentEditable){
	                            element.attr('contenteditable', 'true');
	                        }
	                        // remove the selector click handlers
	                        angular.forEach(taSelectableElements, function(selector){
	                            element.find(selector).off('click', selectorClickHandler);
	                        });
	                        element.on('drop', fileDropHandler);
	                    }
	                    _isReadonly = newVal;
	                });
	            }
	
	            // Initialise the selectableElements
	            // if in WYSIWYG and readOnly we kill the use of links by clicking
	            if(_isContentEditable && !_isReadonly){
	                angular.forEach(taSelectableElements, function(selector){
	                    element.find(selector).on('click', selectorClickHandler);
	                });
	                element.on('drop', fileDropHandler);
	            }
	        }
	    };
	}]);
	
	// this global var is used to prevent multiple fires of the drop event. Needs to be global to the textAngular file.
	var dropFired = false;
	var textAngular = angular.module("textAngular", ['ngSanitize', 'textAngularSetup', 'textAngular.factories', 'textAngular.DOM', 'textAngular.validators', 'textAngular.taBind']); //This makes ngSanitize required
	
	textAngular.config([function(){
	    // clear taTools variable. Just catches testing and any other time that this config may run multiple times...
	    angular.forEach(taTools, function(value, key){ delete taTools[key];	});
	}]);
	
	textAngular.directive("textAngular", [
	    '$compile', '$timeout', 'taOptions', 'taSelection', 'taExecCommand',
	    'textAngularManager', '$document', '$animate', '$log', '$q', '$parse',
	    function($compile, $timeout, taOptions, taSelection, taExecCommand,
	        textAngularManager, $document, $animate, $log, $q, $parse){
	        return {
	            require: '?ngModel',
	            scope: {},
	            restrict: "EA",
	            priority: 2, // So we override validators correctly
	            link: function(scope, element, attrs, ngModel){
	                // all these vars should not be accessable outside this directive
	                var _keydown, _keyup, _keypress, _mouseup, _focusin, _focusout,
	                    _originalContents, _editorFunctions,
	                    _serial = (attrs.serial) ? attrs.serial : Math.floor(Math.random() * 10000000000000000),
	                    _taExecCommand, _resizeMouseDown, _updateSelectedStylesTimeout;
	                var _resizeTimeout;
	
	                scope._name = (attrs.name) ? attrs.name : 'textAngularEditor' + _serial;
	
	                var oneEvent = function(_element, event, action){
	                    $timeout(function(){
	                        _element.one(event, action);
	                    }, 100);
	                };
	                _taExecCommand = taExecCommand(attrs.taDefaultWrap);
	                // get the settings from the defaults and add our specific functions that need to be on the scope
	                angular.extend(scope, angular.copy(taOptions), {
	                    // wraps the selection in the provided tag / execCommand function. Should only be called in WYSIWYG mode.
	                    wrapSelection: function(command, opt, isSelectableElementTool){
	                        // we restore the saved selection that was saved when focus was lost
	                        /* NOT FUNCTIONAL YET */
	                        /* textAngularManager.restoreFocusSelection(scope._name, scope); */
	                        if(command.toLowerCase() === "undo"){
	                            scope['$undoTaBindtaTextElement' + _serial]();
	                        }else if(command.toLowerCase() === "redo"){
	                            scope['$redoTaBindtaTextElement' + _serial]();
	                        }else{
	                            // catch errors like FF erroring when you try to force an undo with nothing done
	                            _taExecCommand(command, false, opt, scope.defaultTagAttributes);
	                            if(isSelectableElementTool){
	                                // re-apply the selectable tool events
	                                scope['reApplyOnSelectorHandlerstaTextElement' + _serial]();
	                            }
	                            // refocus on the shown display element, this fixes a display bug when using :focus styles to outline the box.
	                            // You still have focus on the text/html input it just doesn't show up
	                            scope.displayElements.text[0].focus();
	                        }
	                    },
	                    showHtml: scope.$eval(attrs.taShowHtml) || false
	                });
	                // setup the options from the optional attributes
	                if(attrs.taFocussedClass)			scope.classes.focussed = attrs.taFocussedClass;
	                if(attrs.taTextEditorClass)			scope.classes.textEditor = attrs.taTextEditorClass;
	                if(attrs.taHtmlEditorClass)			scope.classes.htmlEditor = attrs.taHtmlEditorClass;
	                if(attrs.taDefaultTagAttributes){
	                    try	{
	                        //	TODO: This should use angular.merge to enhance functionality once angular 1.4 is required
	                        angular.extend(scope.defaultTagAttributes, angular.fromJson(attrs.taDefaultTagAttributes));
	                    } catch (error) {
	                        $log.error(error);
	                    }
	                }
	                // optional setup functions
	                if(attrs.taTextEditorSetup)			scope.setup.textEditorSetup = scope.$parent.$eval(attrs.taTextEditorSetup);
	                if(attrs.taHtmlEditorSetup)			scope.setup.htmlEditorSetup = scope.$parent.$eval(attrs.taHtmlEditorSetup);
	                // optional fileDropHandler function
	                if(attrs.taFileDrop)				scope.fileDropHandler = scope.$parent.$eval(attrs.taFileDrop);
	                else								scope.fileDropHandler = scope.defaultFileDropHandler;
	
	                _originalContents = element[0].innerHTML;
	                // clear the original content
	                element[0].innerHTML = '';
	
	                // Setup the HTML elements as variable references for use later
	                scope.displayElements = {
	                    // we still need the hidden input even with a textarea as the textarea may have invalid/old input in it,
	                    // wheras the input will ALLWAYS have the correct value.
	                    forminput: angular.element("<input type='hidden' tabindex='-1' style='display: none;'>"),
	                    html: angular.element("<textarea></textarea>"),
	                    text: angular.element("<div></div>"),
	                    // other toolbased elements
	                    scrollWindow: angular.element("<div class='ta-scroll-window'></div>"),
	                    popover: angular.element('<div class="popover fade bottom" style="max-width: none; width: 305px;"></div>'),
	                    popoverArrow: angular.element('<div class="arrow"></div>'),
	                    popoverContainer: angular.element('<div class="popover-content"></div>'),
	                    resize: {
	                        overlay: angular.element('<div class="ta-resizer-handle-overlay"></div>'),
	                        background: angular.element('<div class="ta-resizer-handle-background"></div>'),
	                        anchors: [
	                            angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-tl"></div>'),
	                            angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-tr"></div>'),
	                            angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-bl"></div>'),
	                            angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-br"></div>')
	                        ],
	                        info: angular.element('<div class="ta-resizer-handle-info"></div>')
	                    }
	                };
	
	                // Setup the popover
	                scope.displayElements.popover.append(scope.displayElements.popoverArrow);
	                scope.displayElements.popover.append(scope.displayElements.popoverContainer);
	                scope.displayElements.scrollWindow.append(scope.displayElements.popover);
	
	                scope.displayElements.popover.on('mousedown', function(e, eventData){
	                    /* istanbul ignore else: this is for catching the jqLite testing*/
	                    if(eventData) angular.extend(e, eventData);
	                    // this prevents focusout from firing on the editor when clicking anything in the popover
	                    e.preventDefault();
	                    return false;
	                });
	
	                /* istanbul ignore next: popover resize and scroll events handled */
	                scope.handlePopoverEvents = function() {
	                    if (scope.displayElements.popover.css('display')==='block') {
	                        if(_resizeTimeout) $timeout.cancel(_resizeTimeout);
	                        _resizeTimeout = $timeout(function() {
	                            //console.log('resize', scope.displayElements.popover.css('display'));
	                            scope.reflowPopover(scope.resizeElement);
	                            scope.reflowResizeOverlay(scope.resizeElement);
	                        }, 100);
	                    }
	                };
	
	                /* istanbul ignore next: browser resize check */
	                angular.element(window).on('resize', scope.handlePopoverEvents);
	
	                /* istanbul ignore next: browser scroll check */
	                angular.element(window).on('scroll', scope.handlePopoverEvents);
	
	                // we want to know if a given node has a scrollbar!
	                // credit to lotif on http://stackoverflow.com/questions/4880381/check-whether-html-element-has-scrollbars
	                var isScrollable = function(node) {
	                    var cs;
	                    var _notScrollable = {
	                        vertical: false,
	                        horizontal: false,
	                    };
	                    try {
	                        cs = window.getComputedStyle(node);
	                        if (cs === null) {
	                            return _notScrollable;
	                        }
	                    } catch (e) {
	                        /* istanbul ignore next: error handler */
	                        return _notScrollable;
	                    }
	                    var overflowY = cs['overflow-y'];
	                    var overflowX = cs['overflow-x'];
	                    return {
	                        vertical: (overflowY === 'scroll' || overflowY === 'auto') &&
	                                    /* istanbul ignore next: not tested */
	                                    node.scrollHeight > node.clientHeight,
	                        horizontal: (overflowX === 'scroll' || overflowX === 'auto') &&
	                                    /* istanbul ignore next: not tested */
	                                    node.scrollWidth > node.clientWidth,
	                    };
	                };
	
	                // getScrollTop
	                //
	                // we structure this so that it can climb the parents of the _el and when it finds
	                // one with scrollbars, it adds an EventListener, so that no matter how the
	                // DOM is structured in the user APP, if there is a scrollbar not as part of the
	                // ta-scroll-window, we will still capture the 'scroll' events...
	                // and handle the scroll event properly and do the resize, etc.
	                //
	                scope.getScrollTop = function (_el, bAddListener) {
	                    var scrollTop = _el.scrollTop;
	                    if (typeof scrollTop === 'undefined') {
	                        scrollTop = 0;
	                    }
	                    /* istanbul ignore next: triggered only if has scrollbar */
	                    if (bAddListener && isScrollable(_el).vertical) {
	                        // remove element eventListener
	                        _el.removeEventListener('scroll', scope._scrollListener, false);
	                        _el.addEventListener('scroll', scope._scrollListener, false);
	                    }
	                    /* istanbul ignore next: triggered only if has scrollbar and scrolled */
	                    if (scrollTop !== 0) {
	                        return { node:_el.nodeName, top:scrollTop };
	                    }
	                    /* istanbul ignore else: catches only if no scroll */
	                    if (_el.parentNode) {
	                        return scope.getScrollTop(_el.parentNode, bAddListener);
	                    } else {
	                        return { node:'<none>', top:0 };
	                    }
	                };
	
	                // define the popover show and hide functions
	                scope.showPopover = function(_el){
	                    scope.getScrollTop(scope.displayElements.scrollWindow[0], true);
	                    scope.displayElements.popover.css('display', 'block');
	                    // we must use a $timeout here, or the css change to the
	                    // displayElements.resize.overlay will not take!!!
	                    // WHY???
	                    $timeout(function() {
	                        scope.displayElements.resize.overlay.css('display', 'block');
	                    });
	                    scope.resizeElement = _el;
	                    scope.reflowPopover(_el);
	                    $animate.addClass(scope.displayElements.popover, 'in');
	                    oneEvent($document.find('body'), 'click keyup', function(){scope.hidePopover();});
	                };
	
	                /* istanbul ignore next: browser scroll event handler */
	                scope._scrollListener = function (e, eventData){
	                    scope.handlePopoverEvents();
	                };
	
	                scope.reflowPopover = function(_el){
	                    var scrollTop = scope.getScrollTop(scope.displayElements.scrollWindow[0], false);
	                    var spaceAboveImage = _el[0].offsetTop-scrollTop.top;
	                    //var spaceBelowImage = scope.displayElements.text[0].offsetHeight - _el[0].offsetHeight - spaceAboveImage;
	                    //console.log(spaceAboveImage, spaceBelowImage);
	
	                    /* istanbul ignore if: catches only if near bottom of editor */
	                    if(spaceAboveImage < 51) {
	                        scope.displayElements.popover.css('top', _el[0].offsetTop + _el[0].offsetHeight + scope.displayElements.scrollWindow[0].scrollTop + 'px');
	                        scope.displayElements.popover.removeClass('top').addClass('bottom');
	                    } else {
	                        scope.displayElements.popover.css('top', _el[0].offsetTop - 54 + scope.displayElements.scrollWindow[0].scrollTop + 'px');
	                        scope.displayElements.popover.removeClass('bottom').addClass('top');
	                    }
	                    var _maxLeft = scope.displayElements.text[0].offsetWidth - scope.displayElements.popover[0].offsetWidth;
	                    var _targetLeft = _el[0].offsetLeft + (_el[0].offsetWidth / 2.0) - (scope.displayElements.popover[0].offsetWidth / 2.0);
	                    var _rleft = Math.max(0, Math.min(_maxLeft, _targetLeft));
	                    var _marginLeft = (Math.min(_targetLeft, (Math.max(0, _targetLeft - _maxLeft))) - 11);
	                    _rleft += window.scrollX;
	                    _marginLeft -= window.scrollX;
	                    scope.displayElements.popover.css('left', _rleft + 'px');
	                    scope.displayElements.popoverArrow.css('margin-left', _marginLeft + 'px');
	                };
	                scope.hidePopover = function(){
	                    scope.displayElements.popover.css('display', 'none');
	                    scope.displayElements.popoverContainer.attr('style', '');
	                    scope.displayElements.popoverContainer.attr('class', 'popover-content');
	                    scope.displayElements.popover.removeClass('in');
	                    scope.displayElements.resize.overlay.css('display', 'none');
	                };
	
	                // setup the resize overlay
	                scope.displayElements.resize.overlay.append(scope.displayElements.resize.background);
	                angular.forEach(scope.displayElements.resize.anchors, function(anchor){ scope.displayElements.resize.overlay.append(anchor);});
	                scope.displayElements.resize.overlay.append(scope.displayElements.resize.info);
	                scope.displayElements.scrollWindow.append(scope.displayElements.resize.overlay);
	
	                // A click event on the resize.background will now shift the focus to the editor
	                /* istanbul ignore next: click on the resize.background to focus back to editor */
	                scope.displayElements.resize.background.on('click', function(e) {
	                    scope.displayElements.text[0].focus();
	                });
	
	                // define the show and hide events
	                scope.reflowResizeOverlay = function(_el){
	                    _el = angular.element(_el)[0];
	                    scope.displayElements.resize.overlay.css({
	                        'display': 'block',
	                        'left': _el.offsetLeft - 5 + 'px',
	                        'top': _el.offsetTop - 5 + 'px',
	                        'width': _el.offsetWidth + 10 + 'px',
	                        'height': _el.offsetHeight + 10 + 'px'
	                    });
	                    scope.displayElements.resize.info.text(_el.offsetWidth + ' x ' + _el.offsetHeight);
	                };
	                /* istanbul ignore next: pretty sure phantomjs won't test this */
	                scope.showResizeOverlay = function(_el){
	                    var _body = $document.find('body');
	                    _resizeMouseDown = function(event){
	                        var startPosition = {
	                            width: parseInt(_el.attr('width')),
	                            height: parseInt(_el.attr('height')),
	                            x: event.clientX,
	                            y: event.clientY
	                        };
	                        if(startPosition.width === undefined || isNaN(startPosition.width)) startPosition.width = _el[0].offsetWidth;
	                        if(startPosition.height === undefined || isNaN(startPosition.height)) startPosition.height = _el[0].offsetHeight;
	                        scope.hidePopover();
	                        var ratio = startPosition.height / startPosition.width;
	                        var mousemove = function(event){
	                            // calculate new size
	                            var pos = {
	                                x: Math.max(0, startPosition.width + (event.clientX - startPosition.x)),
	                                y: Math.max(0, startPosition.height + (event.clientY - startPosition.y))
	                            };
	
	                            // DEFAULT: the aspect ratio is not locked unless the Shift key is pressed.
	                            //
	                            // attribute: ta-resize-force-aspect-ratio -- locks resize into maintaing the aspect ratio
	                            var bForceAspectRatio = (attrs.taResizeForceAspectRatio !== undefined);
	                            // attribute: ta-resize-maintain-aspect-ratio=true causes the space ratio to remain locked
	                            // unless the Shift key is pressed
	                            var bFlipKeyBinding = attrs.taResizeMaintainAspectRatio;
	                            var bKeepRatio =  bForceAspectRatio || (bFlipKeyBinding && !event.shiftKey);
	                            if(bKeepRatio) {
	                                var newRatio = pos.y / pos.x;
	                                pos.x = ratio > newRatio ? pos.x : pos.y / ratio;
	                                pos.y = ratio > newRatio ? pos.x * ratio : pos.y;
	                            }
	                            var el = angular.element(_el);
	                            function roundedMaxVal(val) {
	                                return Math.round(Math.max(0, val));
	                            }
	                            el.css('height', roundedMaxVal(pos.y) + 'px');
	                            el.css('width', roundedMaxVal(pos.x) + 'px');
	
	                            // reflow the popover tooltip
	                            scope.reflowResizeOverlay(_el);
	                        };
	                        _body.on('mousemove', mousemove);
	                        oneEvent(_body, 'mouseup', function(event){
	                            event.preventDefault();
	                            event.stopPropagation();
	                            _body.off('mousemove', mousemove);
	                            // at this point, we need to force the model to update! since the css has changed!
	                            // this fixes bug: #862 - we now hide the popover -- as this seems more consitent.
	                            // there are still issues under firefox, the window does not repaint. -- not sure
	                            // how best to resolve this, but clicking anywhere works.
	                            scope.$apply(function (){
	                                scope.hidePopover();
	                                scope.updateTaBindtaTextElement();
	                            }, 100);
	                        });
	                        event.stopPropagation();
	                        event.preventDefault();
	                    };
	
	                    scope.displayElements.resize.anchors[3].off('mousedown');
	                    scope.displayElements.resize.anchors[3].on('mousedown', _resizeMouseDown);
	
	                    scope.reflowResizeOverlay(_el);
	                    oneEvent(_body, 'click', function(){scope.hideResizeOverlay();});
	                };
	                /* istanbul ignore next: pretty sure phantomjs won't test this */
	                scope.hideResizeOverlay = function(){
	                    scope.displayElements.resize.anchors[3].off('mousedown', _resizeMouseDown);
	                    scope.displayElements.resize.overlay.css('display', 'none');
	                };
	
	                // allow for insertion of custom directives on the textarea and div
	                scope.setup.htmlEditorSetup(scope.displayElements.html);
	                scope.setup.textEditorSetup(scope.displayElements.text);
	                scope.displayElements.html.attr({
	                    'id': 'taHtmlElement' + _serial,
	                    'ng-show': 'showHtml',
	                    'ta-bind': 'ta-bind',
	                    'ng-model': 'html',
	                    'ng-model-options': element.attr('ng-model-options')
	                });
	                scope.displayElements.text.attr({
	                    'id': 'taTextElement' + _serial,
	                    'contentEditable': 'true',
	                    'ta-bind': 'ta-bind',
	                    'ng-model': 'html',
	                    'ng-model-options': element.attr('ng-model-options')
	                });
	                scope.displayElements.scrollWindow.attr({'ng-hide': 'showHtml'});
	                if(attrs.taDefaultWrap) {
	                    // taDefaultWrap is only applied to the text and not the html view
	                    scope.displayElements.text.attr('ta-default-wrap', attrs.taDefaultWrap);
	                }
	
	                if(attrs.taUnsafeSanitizer){
	                    scope.displayElements.text.attr('ta-unsafe-sanitizer', attrs.taUnsafeSanitizer);
	                    scope.displayElements.html.attr('ta-unsafe-sanitizer', attrs.taUnsafeSanitizer);
	                }
	
	                if(attrs.taKeepStyles){
	                    scope.displayElements.text.attr('ta-keep-styles', attrs.taKeepStyles);
	                    scope.displayElements.html.attr('ta-keep-styles', attrs.taKeepStyles);
	                }
	
	                // add the main elements to the origional element
	                scope.displayElements.scrollWindow.append(scope.displayElements.text);
	                element.append(scope.displayElements.scrollWindow);
	                element.append(scope.displayElements.html);
	
	                scope.displayElements.forminput.attr('name', scope._name);
	                element.append(scope.displayElements.forminput);
	
	                if(attrs.tabindex){
	                    element.removeAttr('tabindex');
	                    scope.displayElements.text.attr('tabindex', attrs.tabindex);
	                    scope.displayElements.html.attr('tabindex', attrs.tabindex);
	                }
	
	                if (attrs.placeholder) {
	                    scope.displayElements.text.attr('placeholder', attrs.placeholder);
	                    scope.displayElements.html.attr('placeholder', attrs.placeholder);
	                }
	
	                if(attrs.taDisabled){
	                    scope.displayElements.text.attr('ta-readonly', 'disabled');
	                    scope.displayElements.html.attr('ta-readonly', 'disabled');
	                    scope.disabled = scope.$parent.$eval(attrs.taDisabled);
	                    scope.$parent.$watch(attrs.taDisabled, function(newVal){
	                        scope.disabled = newVal;
	                        if(scope.disabled){
	                            element.addClass(scope.classes.disabled);
	                        }else{
	                            element.removeClass(scope.classes.disabled);
	                        }
	                    });
	                }
	
	                if(attrs.taPaste){
	                    scope._pasteHandler = function(_html){
	                        return $parse(attrs.taPaste)(scope.$parent, {$html: _html});
	                    };
	                    scope.displayElements.text.attr('ta-paste', '_pasteHandler($html)');
	                }
	
	                // compile the scope with the text and html elements only - if we do this with the main element it causes a compile loop
	                $compile(scope.displayElements.scrollWindow)(scope);
	                $compile(scope.displayElements.html)(scope);
	
	                scope.updateTaBindtaTextElement = scope['updateTaBindtaTextElement' + _serial];
	                scope.updateTaBindtaHtmlElement = scope['updateTaBindtaHtmlElement' + _serial];
	
	                // add the classes manually last
	                element.addClass("ta-root");
	                scope.displayElements.scrollWindow.addClass("ta-text ta-editor " + scope.classes.textEditor);
	                scope.displayElements.html.addClass("ta-html ta-editor " + scope.classes.htmlEditor);
	
	                var testAndSet = function(choice, beforeState) {
	                    /* istanbul ignore next: this is only here because of a bug in rangy where rangy.saveSelection() has cleared the state */
	                    if (beforeState !== $document[0].queryCommandState(choice)) {
	                        $document[0].execCommand(choice, false, null);
	                    }
	                };
	                // used in the toolbar actions
	                scope._actionRunning = false;
	                var _savedSelection = false;
	                scope.startAction = function(){
	                    var _beforeStateBold = false;
	                    var _beforeStateItalic = false;
	                    var _beforeStateUnderline = false;
	                    var _beforeStateStrikethough = false;
	                    scope._actionRunning = true;
	                    _beforeStateBold = $document[0].queryCommandState('bold');
	                    _beforeStateItalic = $document[0].queryCommandState('italic');
	                    _beforeStateUnderline = $document[0].queryCommandState('underline');
	                    _beforeStateStrikethough = $document[0].queryCommandState('strikeThrough');
	                    //console.log('B', _beforeStateBold, 'I', _beforeStateItalic, '_', _beforeStateUnderline, 'S', _beforeStateStrikethough);
	                    // if rangy library is loaded return a function to reload the current selection
	                    _savedSelection = rangy.saveSelection();
	                    // rangy.saveSelection() clear the state of bold, italic, underline, strikethrough
	                    // so we reset them here....!!!
	                    // this fixes bugs #423, #1129, #1105, #693 which are actually rangy bugs!
	                    testAndSet('bold', _beforeStateBold);
	                    testAndSet('italic', _beforeStateItalic);
	                    testAndSet('underline', _beforeStateUnderline);
	                    testAndSet('strikeThrough', _beforeStateStrikethough);
	                    //console.log('B', $document[0].queryCommandState('bold'), 'I', $document[0].queryCommandState('italic'), '_', $document[0].queryCommandState('underline'), 'S', $document[0].queryCommandState('strikeThrough') );
	                    return function(){
	                        if(_savedSelection) rangy.restoreSelection(_savedSelection);
	                        // perhaps if we restore the selections here, we would do better overall???
	                        // BUT what we do above does well in 90% of the cases...
	                    };
	                };
	                scope.endAction = function(){
	                    scope._actionRunning = false;
	                    if(_savedSelection){
	                        if(scope.showHtml){
	                            scope.displayElements.html[0].focus();
	                        }else{
	                            scope.displayElements.text[0].focus();
	                        }
	                        // rangy.restoreSelection(_savedSelection);
	                        rangy.removeMarkers(_savedSelection);
	                    }
	                    _savedSelection = false;
	                    scope.updateSelectedStyles();
	                    // only update if in text or WYSIWYG mode
	                    if(!scope.showHtml) scope['updateTaBindtaTextElement' + _serial]();
	                };
	
	                // note that focusout > focusin is called everytime we click a button - except bad support: http://www.quirksmode.org/dom/events/blurfocus.html
	                // cascades to displayElements.text and displayElements.html automatically.
	                _focusin = function(e){
	                    scope.focussed = true;
	                    element.addClass(scope.classes.focussed);
	/*******  NOT FUNCTIONAL YET
	                    if (e.target.id === 'taTextElement' + _serial) {
	                        console.log('_focusin taTextElement');
	                        // we only do this if NOT focussed
	                        textAngularManager.restoreFocusSelection(scope._name);
	                    }
	*******/
	                    _editorFunctions.focus();
	                    element.triggerHandler('focus');
	                    // we call editorScope.updateSelectedStyles() here because we want the toolbar to be focussed
	                    // as soon as we have focus.  Otherwise this only happens on mousedown or keydown etc...
	                    /* istanbul ignore else: don't run if already running */
	                    if(scope.updateSelectedStyles && !scope._bUpdateSelectedStyles){
	                        // we don't set editorScope._bUpdateSelectedStyles here, because we do not want the
	                        // updateSelectedStyles() to run twice which it will do after 200 msec if we have
	                        // set editorScope._bUpdateSelectedStyles
	                        //
	                        // WOW, normally I would do a scope.$apply here, but this causes ERRORs when doing tests!
	                        $timeout(function () {
	                            scope.updateSelectedStyles();
	                        }, 0);
	                    }
	                };
	                scope.displayElements.html.on('focus', _focusin);
	                scope.displayElements.text.on('focus', _focusin);
	                _focusout = function(e){
	                    /****************** NOT FUNCTIONAL YET
	                    try {
	                        var _s = rangy.getSelection();
	                        if (_s) {
	                            // we save the selection when we loose focus so that if do a wrapSelection, the
	                            // apropriate selection in the editor is restored before action.
	                            var _savedFocusRange = rangy.saveRange(_s.getRangeAt(0));
	                            textAngularManager.saveFocusSelection(scope._name, _savedFocusRange);
	                        }
	                    } catch(error) { }
	                    *****************/
	                    // if we are NOT runnig an action and have NOT focussed again on the text etc then fire the blur events
	                    if(!scope._actionRunning &&
	                        $document[0].activeElement !== scope.displayElements.html[0] &&
	                        $document[0].activeElement !== scope.displayElements.text[0])
	                    {
	                        element.removeClass(scope.classes.focussed);
	                        _editorFunctions.unfocus();
	                        // to prevent multiple apply error defer to next seems to work.
	                        $timeout(function(){
	                            scope._bUpdateSelectedStyles = false;
	                            element.triggerHandler('blur');
	                            scope.focussed = false;
	                        }, 0);
	                    }
	                    e.preventDefault();
	                    return false;
	                };
	                scope.displayElements.html.on('blur', _focusout);
	                scope.displayElements.text.on('blur', _focusout);
	
	                scope.displayElements.text.on('paste', function(event){
	                    element.triggerHandler('paste', event);
	                });
	
	                // Setup the default toolbar tools, this way allows the user to add new tools like plugins.
	                // This is on the editor for future proofing if we find a better way to do this.
	                scope.queryFormatBlockState = function(command){
	                    // $document[0].queryCommandValue('formatBlock') errors in Firefox if we call this when focussed on the textarea
	                    return !scope.showHtml && command.toLowerCase() === $document[0].queryCommandValue('formatBlock').toLowerCase();
	                };
	                scope.queryCommandState = function(command){
	                    // $document[0].queryCommandValue('formatBlock') errors in Firefox if we call this when focussed on the textarea
	                    return (!scope.showHtml) ? $document[0].queryCommandState(command) : '';
	                };
	                scope.switchView = function(){
	                    scope.showHtml = !scope.showHtml;
	                    $animate.enabled(false, scope.displayElements.html);
	                    $animate.enabled(false, scope.displayElements.text);
	                    //Show the HTML view
	                    /* istanbul ignore next: ngModel exists check */
	/* THIS is not the correct thing to do, here....
	   The ngModel is correct, but it is not formatted as the user as done it...
	                    var _model;
	                    if (ngModel) {
	                        _model = ngModel.$viewValue;
	                    } else {
	                        _model = scope.html;
	                    }
	                    var _html = scope.displayElements.html[0].value;
	                    if (getDomFromHtml(_html).childElementCount !== getDomFromHtml(_model).childElementCount) {
	                        // the model and the html do not agree
	                        // they can get out of sync and when they do, we correct that here...
	                        scope.displayElements.html.val(_model);
	                    }
	*/
	                    if(scope.showHtml){
	                        //defer until the element is visible
	                        $timeout(function(){
	                            $animate.enabled(true, scope.displayElements.html);
	                            $animate.enabled(true, scope.displayElements.text);
	                            // [0] dereferences the DOM object from the angular.element
	                            return scope.displayElements.html[0].focus();
	                        }, 100);
	                    }else{
	                        //Show the WYSIWYG view
	                        //defer until the element is visible
	                        $timeout(function(){
	                            $animate.enabled(true, scope.displayElements.html);
	                            $animate.enabled(true, scope.displayElements.text);
	                            // [0] dereferences the DOM object from the angular.element
	                            return scope.displayElements.text[0].focus();
	                        }, 100);
	                    }
	                };
	
	                // changes to the model variable from outside the html/text inputs
	                // if no ngModel, then the only input is from inside text-angular
	                if(attrs.ngModel){
	                    var _firstRun = true;
	                    ngModel.$render = function(){
	                        if(_firstRun){
	                            // we need this firstRun to set the originalContents otherwise it gets overrided by the setting of ngModel to undefined from NaN
	                            _firstRun = false;
	                            // if view value is null or undefined initially and there was original content, set to the original content
	                            var _initialValue = scope.$parent.$eval(attrs.ngModel);
	                            if((_initialValue === undefined || _initialValue === null) && (_originalContents && _originalContents !== '')){
	                                // on passing through to taBind it will be sanitised
	                                ngModel.$setViewValue(_originalContents);
	                            }
	                        }
	                        scope.displayElements.forminput.val(ngModel.$viewValue);
	                        // if the editors aren't focused they need to be updated, otherwise they are doing the updating
	                        scope.html = ngModel.$viewValue || '';
	                    };
	                    // trigger the validation calls
	                    if(element.attr('required')) ngModel.$validators.required = function(modelValue, viewValue) {
	                        var value = modelValue || viewValue;
	                        return !(!value || value.trim() === '');
	                    };
	                }else{
	                    // if no ngModel then update from the contents of the origional html.
	                    scope.displayElements.forminput.val(_originalContents);
	                    scope.html = _originalContents;
	                }
	
	                // changes from taBind back up to here
	                scope.$watch('html', function(newValue, oldValue){
	                    if(newValue !== oldValue){
	                        if(attrs.ngModel && ngModel.$viewValue !== newValue) {
	                            ngModel.$setViewValue(newValue);
	                        }
	                        scope.displayElements.forminput.val(newValue);
	                    }
	                });
	
	                if(attrs.taTargetToolbars) {
	                    _editorFunctions = textAngularManager.registerEditor(scope._name, scope, attrs.taTargetToolbars.split(','));
	                }
	                else{
	                    var _toolbar = angular.element('<div text-angular-toolbar name="textAngularToolbar' + _serial + '">');
	                    // passthrough init of toolbar options
	                    if(attrs.taToolbar)						_toolbar.attr('ta-toolbar', attrs.taToolbar);
	                    if(attrs.taToolbarClass)				_toolbar.attr('ta-toolbar-class', attrs.taToolbarClass);
	                    if(attrs.taToolbarGroupClass)			_toolbar.attr('ta-toolbar-group-class', attrs.taToolbarGroupClass);
	                    if(attrs.taToolbarButtonClass)			_toolbar.attr('ta-toolbar-button-class', attrs.taToolbarButtonClass);
	                    if(attrs.taToolbarActiveButtonClass)	_toolbar.attr('ta-toolbar-active-button-class', attrs.taToolbarActiveButtonClass);
	                    if(attrs.taFocussedClass)				_toolbar.attr('ta-focussed-class', attrs.taFocussedClass);
	
	                    element.prepend(_toolbar);
	                    $compile(_toolbar)(scope.$parent);
	                    _editorFunctions = textAngularManager.registerEditor(scope._name, scope, ['textAngularToolbar' + _serial]);
	                }
	
	                scope.$on('$destroy', function(){
	                    textAngularManager.unregisterEditor(scope._name);
	                    angular.element(window).off('blur');
	                    angular.element(window).off('resize', scope.handlePopoverEvents);
	                    angular.element(window).off('scroll', scope.handlePopoverEvents);
	                });
	
	                // catch element select event and pass to toolbar tools
	                scope.$on('ta-element-select', function(event, element){
	                    if(_editorFunctions.triggerElementSelect(event, element)){
	                        scope['reApplyOnSelectorHandlerstaTextElement' + _serial]();
	                    }
	                });
	
	/******************* no working fully
	                var distanceFromPoint = function (px, py, x, y) {
	                    return Math.sqrt((px-x)*(px-x)+(py-y)*(py-y));
	                };
	                // because each object is a rectangle and we have a single point,
	                // we need to give priority if the point is inside the rectangle
	                var getPositionDistance = function(el, x, y) {
	                    var range = document.createRange();
	                    range.selectNode(el);
	                    var rect = range.getBoundingClientRect();
	                    console.log(el, rect);
	                    range.detach();
	                    var bcr = rect;
	                    // top left
	                    var d1 = distanceFromPoint(bcr.left, bcr.top, x, y);
	                    // bottom left
	                    var d2 = distanceFromPoint(bcr.left, bcr.bottom, x, y);
	                    // top right
	                    var d3 = distanceFromPoint(bcr.right, bcr.top, x, y);
	                    // bottom right
	                    var d4 = distanceFromPoint(bcr.right, bcr.bottom, x, y);
	                    return Math.min(d1, d2, d3, d4);
	                };
	                var findClosest = function(el, minElement, maxDistance, x, y) {
	                    var _d=0;
	                    for (var i = 0; i < el.childNodes.length; i++) {
	                        var _n = el.childNodes[i];
	                        if (!_n.childNodes.length) {
	                            _d = getPositionDistance(_n, x, y);
	                            //console.log(_n, _n.childNodes, _d);
	                            if (_d < maxDistance) {
	                                maxDistance = _d;
	                                minElement = _n;
	                            }
	                        }
	                        var res = findClosest(_n, minElement, maxDistance, x, y);
	                        if (res.max < maxDistance) {
	                            maxDistance = res.max;
	                            minElement = res.min;
	                        }
	                    }
	                    return { max: maxDistance, min: minElement };
	                };
	                var getClosestElement = function (el, x, y) {
	                    return findClosest(el, null, 12341234124, x, y);
	                };
	****************/
	
	                scope.$on('ta-drop-event', function(event, element, dropEvent, dataTransfer){
	                    if(dataTransfer && dataTransfer.files && dataTransfer.files.length > 0){
	                        scope.displayElements.text[0].focus();
	                        // we must set the location of the drop!
	                        //console.log(dropEvent.clientX, dropEvent.clientY, dropEvent.target);
	                        taSelection.setSelectionToElementEnd(dropEvent.target);
	                        angular.forEach(dataTransfer.files, function(file){
	                            // taking advantage of boolean execution, if the fileDropHandler returns true, nothing else after it is executed
	                            // If it is false then execute the defaultFileDropHandler if the fileDropHandler is NOT the default one
	                            // Once one of these has been executed wrap the result as a promise, if undefined or variable update the taBind, else we should wait for the promise
	                            try{
	                                $q.when(scope.fileDropHandler(file, scope.wrapSelection) ||
	                                    (scope.fileDropHandler !== scope.defaultFileDropHandler &&
	                                    $q.when(scope.defaultFileDropHandler(file, scope.wrapSelection)))).then(function(){
	                                        scope['updateTaBindtaTextElement' + _serial]();
	                                    });
	                            }catch(error){
	                                $log.error(error);
	                            }
	                        });
	                        dropEvent.preventDefault();
	                        dropEvent.stopPropagation();
	                    /* istanbul ignore else, the updates if moved text */
	                    }else{
	                        $timeout(function(){
	                            scope['updateTaBindtaTextElement' + _serial]();
	                        }, 0);
	                    }
	                });
	
	                // the following is for applying the active states to the tools that support it
	                scope._bUpdateSelectedStyles = false;
	                /* istanbul ignore next: browser window/tab leave check */
	                angular.element(window).on('blur', function(){
	                    scope._bUpdateSelectedStyles = false;
	                    scope.focussed = false;
	                });
	                // loop through all the tools polling their activeState function if it exists
	                scope.updateSelectedStyles = function(){
	                    var _selection;
	                    /* istanbul ignore next: This check is to ensure multiple timeouts don't exist */
	                    if(_updateSelectedStylesTimeout) $timeout.cancel(_updateSelectedStylesTimeout);
	                    // test if the common element ISN'T the root ta-text node
	                    if((_selection = taSelection.getSelectionElement()) !== undefined && _selection.parentNode !== scope.displayElements.text[0]){
	                        _editorFunctions.updateSelectedStyles(angular.element(_selection));
	                    }else _editorFunctions.updateSelectedStyles();
	                    // used to update the active state when a key is held down, ie the left arrow
	                    /* istanbul ignore else: browser only check */
	                    if(scope._bUpdateSelectedStyles) _updateSelectedStylesTimeout = $timeout(scope.updateSelectedStyles, 200);
	                };
	                // start updating on keydown
	                _keydown = function(){
	                    /* istanbul ignore next: ie catch */
	                    if(!scope.focussed){
	                        scope._bUpdateSelectedStyles = false;
	                        return;
	                    }
	                    /* istanbul ignore else: don't run if already running */
	                    if(!scope._bUpdateSelectedStyles){
	                        scope._bUpdateSelectedStyles = true;
	                        scope.$apply(function(){
	                            scope.updateSelectedStyles();
	                        });
	                    }
	                };
	                scope.displayElements.html.on('keydown', _keydown);
	                scope.displayElements.text.on('keydown', _keydown);
	                // stop updating on key up and update the display/model
	                _keyup = function(){
	                    scope._bUpdateSelectedStyles = false;
	                };
	                scope.displayElements.html.on('keyup', _keyup);
	                scope.displayElements.text.on('keyup', _keyup);
	                // stop updating on key up and update the display/model
	                _keypress = function(event, eventData){
	                    // bug fix for Firefox.  If we are selecting a <a> already, any characters will
	                    // be added within the <a> which is bad!
	                    /* istanbul ignore next: don't see how to test this... */
	                    if (taSelection.getSelection) {
	                        var _selection = taSelection.getSelection();
	                        // in a weird case (can't reproduce) taSelection.getSelectionElement() can be undefined!!
	                        // this comes from range.commonAncestorContainer;
	                        // so I check for this here which fixes the error case
	                        if (taSelection.getSelectionElement() && taSelection.getSelectionElement().nodeName.toLowerCase() === 'a') {
	                            // check and see if we are at the edge of the <a>
	                            if (_selection.start.element.nodeType === 3 &&
	                                _selection.start.element.textContent.length === _selection.end.offset) {
	                                // we are at the end of the <a>!!!
	                                // so move the selection to after the <a>!!
	                                taSelection.setSelectionAfterElement(taSelection.getSelectionElement());
	                            }
	                            if (_selection.start.element.nodeType === 3 &&
	                                _selection.start.offset === 0) {
	                                // we are at the start of the <a>!!!
	                                // so move the selection before the <a>!!
	                                taSelection.setSelectionBeforeElement(taSelection.getSelectionElement());
	                            }
	                        }
	                    }
	                    /* istanbul ignore else: this is for catching the jqLite testing*/
	                    if(eventData) angular.extend(event, eventData);
	                    scope.$apply(function(){
	                        if(_editorFunctions.sendKeyCommand(event)){
	                            /* istanbul ignore else: don't run if already running */
	                            if(!scope._bUpdateSelectedStyles){
	                                scope.updateSelectedStyles();
	                            }
	                            event.preventDefault();
	                            return false;
	                        }
	                    });
	                };
	                scope.displayElements.html.on('keypress', _keypress);
	                scope.displayElements.text.on('keypress', _keypress);
	                // update the toolbar active states when we click somewhere in the text/html boxed
	                _mouseup = function(){
	                    // ensure only one execution of updateSelectedStyles()
	                    scope._bUpdateSelectedStyles = false;
	                    // for some reason, unless we do a $timeout here, after a _mouseup when the line is
	                    // highlighted, and instead use a scope.$apply(function(){ scope.updateSelectedStyles(); });
	                    // doesn't work properly, so we replaced this with:
	                    /* istanbul ignore next: not tested  */
	                    $timeout(function() { scope.updateSelectedStyles(); }, 0);
	                };
	                scope.displayElements.html.on('mouseup', _mouseup);
	                scope.displayElements.text.on('mouseup', _mouseup);
	            }
	        };
	    }
	]);
	textAngular.service('textAngularManager', ['taToolExecuteAction', 'taTools', 'taRegisterTool', '$interval', '$rootScope', '$log',
	    function(taToolExecuteAction, taTools, taRegisterTool, $interval, $rootScope, $log){
	    // this service is used to manage all textAngular editors and toolbars.
	    // All publicly published functions that modify/need to access the toolbar or editor scopes should be in here
	    // these contain references to all the editors and toolbars that have been initialised in this app
	    var toolbars = {}, editors = {};
	    // we touch the time any change occurs through register of an editor or tool so that we
	    // in the future will fire and event to trigger an updateSelection
	    var timeRecentModification = 0;
	    var updateStyles = function(selectedElement){
	        angular.forEach(editors, function(editor) {
	            editor.editorFunctions.updateSelectedStyles(selectedElement);
	        });
	    };
	    var triggerInterval = 50;
	    var triggerIntervalTimer;
	    var setupTriggerUpdateStyles = function() {
	        timeRecentModification = Date.now();
	        /* istanbul ignore next: setup a one time updateStyles() */
	        triggerIntervalTimer = $interval(function() {
	            updateStyles();
	            triggerIntervalTimer = undefined;
	        }, triggerInterval, 1); // only trigger once
	    };
	    /* istanbul ignore next: make sure clean up on destroy */
	    $rootScope.$on('destroy', function() {
	        if (triggerIntervalTimer) {
	            $interval.cancel(triggerIntervalTimer);
	            triggerIntervalTimer = undefined;
	        }
	    });
	    var touchModification = function() {
	        if (Math.abs(Date.now() - timeRecentModification) > triggerInterval) {
	            // we have already triggered the updateStyles a long time back... so setup it again...
	            setupTriggerUpdateStyles();
	        }
	    };
	    // when we focus into a toolbar, we need to set the TOOLBAR's $parent to be the toolbars it's linked to.
	    // We also need to set the tools to be updated to be the toolbars...
	    return {
	        // register an editor and the toolbars that it is affected by
	        registerEditor: function(editorName, editorScope, targetToolbars){
	            // NOTE: name === editorScope._name
	            // targetToolbars is an [] of 'toolbar name's
	            // targetToolbars are optional, we don't require a toolbar to function
	            if(!editorName || editorName === '') throw('textAngular Error: An editor requires a name');
	            if(!editorScope) throw('textAngular Error: An editor requires a scope');
	            if(editors[editorName]) throw('textAngular Error: An Editor with name "' + editorName + '" already exists');
	            editors[editorName] = {
	                scope: editorScope,
	                toolbars: targetToolbars,
	                // toolbarScopes used by this editor
	                toolbarScopes: [],
	                _registerToolbarScope: function(toolbarScope){
	                    // add to the list late
	                    if(this.toolbars.indexOf(toolbarScope.name) >= 0) {
	                        // if this toolbarScope is being used by this editor we add it as one of the scopes
	                        this.toolbarScopes.push(toolbarScope);
	                    }
	                },
	                // this is a suite of functions the editor should use to update all it's linked toolbars
	                editorFunctions: {
	                    disable: function(){
	                        // disable all linked toolbars
	                        angular.forEach(editors[editorName].toolbarScopes, function(toolbarScope){
	                            toolbarScope.disabled = true;
	                        });
	                    },
	                    enable: function(){
	                        // enable all linked toolbars
	                        angular.forEach(editors[editorName].toolbarScopes, function(toolbarScope){
	                            toolbarScope.disabled = false;
	                        });
	                    },
	                    focus: function(){
	                        // this should be called when the editor is focussed
	                        angular.forEach(editors[editorName].toolbarScopes, function(toolbarScope){
	                            toolbarScope._parent = editorScope;
	                            toolbarScope.disabled = false;
	                            toolbarScope.focussed = true;
	                        });
	                        editorScope.focussed = true;
	                    },
	                    unfocus: function(){
	                        // this should be called when the editor becomes unfocussed
	                        angular.forEach(editors[editorName].toolbarScopes, function(toolbarScope){
	                            toolbarScope.disabled = true;
	                            toolbarScope.focussed = false;
	                        });
	                        editorScope.focussed = false;
	                    },
	                    updateSelectedStyles: function(selectedElement){
	                        // update the active state of all buttons on liked toolbars
	                        angular.forEach(editors[editorName].toolbarScopes, function(toolbarScope){
	                            angular.forEach(toolbarScope.tools, function(toolScope){
	                                if(toolScope.activeState){
	                                    toolbarScope._parent = editorScope;
	                                    // selectedElement may be undefined if nothing selected
	                                    toolScope.active = toolScope.activeState(selectedElement);
	                                }
	                            });
	                        });
	                    },
	                    sendKeyCommand: function(event){
	                        // we return true if we applied an action, false otherwise
	                        var result = false;
	                        if(event.ctrlKey || event.metaKey || event.specialKey) angular.forEach(taTools, function(tool, name){
	                            if(tool.commandKeyCode && (tool.commandKeyCode === event.which || tool.commandKeyCode === event.specialKey)){
	                                for(var _t = 0; _t < editors[editorName].toolbarScopes.length; _t++){
	                                    if(editors[editorName].toolbarScopes[_t].tools[name] !== undefined){
	                                        taToolExecuteAction.call(editors[editorName].toolbarScopes[_t].tools[name], editorScope);
	                                        result = true;
	                                        break;
	                                    }
	                                }
	                            }
	                        });
	                        return result;
	                    },
	                    triggerElementSelect: function(event, element){
	                        // search through the taTools to see if a match for the tag is made.
	                        // if there is, see if the tool is on a registered toolbar and not disabled.
	                        // NOTE: This can trigger on MULTIPLE tools simultaneously.
	                        var elementHasAttrs = function(_element, attrs){
	                            var result = true;
	                            for(var i = 0; i < attrs.length; i++) result = result && _element.attr(attrs[i]);
	                            return result;
	                        };
	                        var workerTools = [];
	                        var unfilteredTools = {};
	                        var result = false;
	                        element = angular.element(element);
	                        // get all valid tools by element name, keep track if one matches the
	                        var onlyWithAttrsFilter = false;
	                        angular.forEach(taTools, function(tool, name){
	                            if(
	                                tool.onElementSelect &&
	                                tool.onElementSelect.element &&
	                                tool.onElementSelect.element.toLowerCase() === element[0].tagName.toLowerCase() &&
	                                (!tool.onElementSelect.filter || tool.onElementSelect.filter(element))
	                            ){
	                                // this should only end up true if the element matches the only attributes
	                                onlyWithAttrsFilter = onlyWithAttrsFilter ||
	                                    (angular.isArray(tool.onElementSelect.onlyWithAttrs) && elementHasAttrs(element, tool.onElementSelect.onlyWithAttrs));
	                                if(!tool.onElementSelect.onlyWithAttrs || elementHasAttrs(element, tool.onElementSelect.onlyWithAttrs)) unfilteredTools[name] = tool;
	                            }
	                        });
	                        // if we matched attributes to filter on, then filter, else continue
	                        if(onlyWithAttrsFilter){
	                            angular.forEach(unfilteredTools, function(tool, name){
	                                if(tool.onElementSelect.onlyWithAttrs && elementHasAttrs(element, tool.onElementSelect.onlyWithAttrs)) workerTools.push({'name': name, 'tool': tool});
	                            });
	                            // sort most specific (most attrs to find) first
	                            workerTools.sort(function(a,b){
	                                return b.tool.onElementSelect.onlyWithAttrs.length - a.tool.onElementSelect.onlyWithAttrs.length;
	                            });
	                        }else{
	                            angular.forEach(unfilteredTools, function(tool, name){
	                                workerTools.push({'name': name, 'tool': tool});
	                            });
	                        }
	                        // Run the actions on the first visible filtered tool only
	                        if(workerTools.length > 0){
	                            for(var _i = 0; _i < workerTools.length; _i++){
	                                var tool = workerTools[_i].tool;
	                                var name = workerTools[_i].name;
	                                for(var _t = 0; _t < editors[editorName].toolbarScopes.length; _t++){
	                                    if(editors[editorName].toolbarScopes[_t].tools[name] !== undefined){
	                                        tool.onElementSelect.action.call(editors[editorName].toolbarScopes[_t].tools[name], event, element, editorScope);
	                                        result = true;
	                                        break;
	                                    }
	                                }
	                                if(result) break;
	                            }
	                        }
	                        return result;
	                    }
	                }
	            };
	            angular.forEach(targetToolbars, function(_name){
	                if(toolbars[_name]) {
	                    editors[editorName].toolbarScopes.push(toolbars[_name]);
	                }
	                // if it doesn't exist it may not have been compiled yet and it will be added later
	            });
	            touchModification();
	            return editors[editorName].editorFunctions;
	        },
	        // retrieve editor by name, largely used by testing suites only
	        retrieveEditor: function(name){
	            return editors[name];
	        },
	        unregisterEditor: function(name){
	            delete editors[name];
	            touchModification();
	        },
	        // registers a toolbar such that it can be linked to editors
	        registerToolbar: function(toolbarScope){
	            if(!toolbarScope) throw('textAngular Error: A toolbar requires a scope');
	            if(!toolbarScope.name || toolbarScope.name === '') throw('textAngular Error: A toolbar requires a name');
	            if(toolbars[toolbarScope.name]) throw('textAngular Error: A toolbar with name "' + toolbarScope.name + '" already exists');
	            toolbars[toolbarScope.name] = toolbarScope;
	            // walk all the editors and connect this toolbarScope to the editors.... if we need to.  This way, it does
	            // not matter if we register the editors after the toolbars or not
	            // Note the editor will ignore this toolbarScope if it is not connected to it...
	            angular.forEach(editors, function(_editor){
	                _editor._registerToolbarScope(toolbarScope);
	            });
	            touchModification();
	        },
	        // retrieve toolbar by name, largely used by testing suites only
	        retrieveToolbar: function(name){
	            return toolbars[name];
	        },
	        // retrieve toolbars by editor name, largely used by testing suites only
	        retrieveToolbarsViaEditor: function(name){
	            var result = [], _this = this;
	            angular.forEach(this.retrieveEditor(name).toolbars, function(name){
	                result.push(_this.retrieveToolbar(name));
	            });
	            return result;
	        },
	        unregisterToolbar: function(name){
	            delete toolbars[name];
	            touchModification();
	        },
	        // functions for updating the toolbar buttons display
	        updateToolsDisplay: function(newTaTools){
	            // pass a partial struct of the taTools, this allows us to update the tools on the fly, will not change the defaults.
	            var _this = this;
	            angular.forEach(newTaTools, function(_newTool, key){
	                _this.updateToolDisplay(key, _newTool);
	            });
	        },
	        // this function resets all toolbars to their default tool definitions
	        resetToolsDisplay: function(){
	            var _this = this;
	            angular.forEach(taTools, function(_newTool, key){
	                _this.resetToolDisplay(key);
	            });
	            touchModification();
	        },
	        // update a tool on all toolbars
	        updateToolDisplay: function(toolKey, _newTool){
	            var _this = this;
	            angular.forEach(toolbars, function(toolbarScope, toolbarKey){
	                _this.updateToolbarToolDisplay(toolbarKey, toolKey, _newTool);
	            });
	            touchModification();
	        },
	        // resets a tool to the default/starting state on all toolbars
	        resetToolDisplay: function(toolKey){
	            var _this = this;
	            angular.forEach(toolbars, function(toolbarScope, toolbarKey){
	                _this.resetToolbarToolDisplay(toolbarKey, toolKey);
	            });
	            touchModification();
	        },
	        // update a tool on a specific toolbar
	        updateToolbarToolDisplay: function(toolbarKey, toolKey, _newTool){
	            if(toolbars[toolbarKey]) toolbars[toolbarKey].updateToolDisplay(toolKey, _newTool);
	            else throw('textAngular Error: No Toolbar with name "' + toolbarKey + '" exists');
	        },
	        // reset a tool on a specific toolbar to it's default starting value
	        resetToolbarToolDisplay: function(toolbarKey, toolKey){
	            if(toolbars[toolbarKey]) toolbars[toolbarKey].updateToolDisplay(toolKey, taTools[toolKey], true);
	            else throw('textAngular Error: No Toolbar with name "' + toolbarKey + '" exists');
	        },
	        // removes a tool from all toolbars and it's definition
	        removeTool: function(toolKey){
	            delete taTools[toolKey];
	            angular.forEach(toolbars, function(toolbarScope){
	                delete toolbarScope.tools[toolKey];
	                for(var i = 0; i < toolbarScope.toolbar.length; i++){
	                    var toolbarIndex;
	                    for(var j = 0; j < toolbarScope.toolbar[i].length; j++){
	                        if(toolbarScope.toolbar[i][j] === toolKey){
	                            toolbarIndex = {
	                                group: i,
	                                index: j
	                            };
	                            break;
	                        }
	                        if(toolbarIndex !== undefined) break;
	                    }
	                    if(toolbarIndex !== undefined){
	                        toolbarScope.toolbar[toolbarIndex.group].slice(toolbarIndex.index, 1);
	                        toolbarScope._$element.children().eq(toolbarIndex.group).children().eq(toolbarIndex.index).remove();
	                    }
	                }
	            });
	            touchModification();
	        },
	        // toolkey, toolDefinition are required. If group is not specified will pick the last group, if index isnt defined will append to group
	        addTool: function(toolKey, toolDefinition, group, index){
	            taRegisterTool(toolKey, toolDefinition);
	            angular.forEach(toolbars, function(toolbarScope){
	                toolbarScope.addTool(toolKey, toolDefinition, group, index);
	            });
	            touchModification();
	        },
	        // adds a Tool but only to one toolbar not all
	        addToolToToolbar: function(toolKey, toolDefinition, toolbarKey, group, index){
	            taRegisterTool(toolKey, toolDefinition);
	            toolbars[toolbarKey].addTool(toolKey, toolDefinition, group, index);
	            touchModification();
	        },
	        // this is used when externally the html of an editor has been changed and textAngular needs to be notified to update the model.
	        // this will call a $digest if not already happening
	        refreshEditor: function(name){
	            if(editors[name]){
	                editors[name].scope.updateTaBindtaTextElement();
	                /* istanbul ignore else: phase catch */
	                if(!editors[name].scope.$$phase) editors[name].scope.$digest();
	            }else throw('textAngular Error: No Editor with name "' + name + '" exists');
	            touchModification();
	        },
	        // this is used by taBind to send a key command in response to a special key event
	        sendKeyCommand: function(scope, event){
	            var _editor = editors[scope._name];
	            /* istanbul ignore else: if nothing to do, do nothing */
	            if (_editor && _editor.editorFunctions.sendKeyCommand(event)) {
	                /* istanbul ignore else: don't run if already running */
	                if(!scope._bUpdateSelectedStyles){
	                    scope.updateSelectedStyles();
	                }
	                event.preventDefault();
	                return false;
	            }
	        },
	        //
	        // When a toolbar and tools are created, it isn't until there is a key event or mouse event
	        // that the updateSelectedStyles() is called behind the scenes.
	        // This function forces an update through the existing editors to help the application make sure
	        // the inital state is correct.
	        //
	        updateStyles: updateStyles,
	        // return the current version of textAngular in use to the user
	        getVersion: function () { return textAngularVersion; },
	        // for testing
	        getToolbarScopes: function () {
	            var tmp=[];
	            angular.forEach(editors, function (_editor) {
	                tmp = tmp.concat(_editor.toolbarScopes);
	            });
	            return tmp;
	        }
	/********************** not functional yet
	        // save the selection ('range') for the given editor
	        saveFocusSelection: function (name, range) {
	            editors[name].savedFocusRange = range;
	        },
	        // restore the saved selection from when the focus was lost
	        restoreFocusSelection: function(name, scope) {
	            // we only do this if NOT focussed and saved...
	            if (editors[name].savedFocusRange && !scope.focussed) {
	                try {
	                    var _r = rangy.restoreRange(editors[name].savedFocusRange);
	                    var _sel = rangy.getSelection();
	                    _sel.addRange(_r);
	                } catch(e) {}
	            }
	        }
	*************/
	    };
	}]);
	textAngular.directive('textAngularToolbar', [
	    '$compile', 'textAngularManager', 'taOptions', 'taTools', 'taToolExecuteAction', '$window',
	    function($compile, textAngularManager, taOptions, taTools, taToolExecuteAction, $window){
	        return {
	            scope: {
	                name: '@' // a name IS required
	            },
	            restrict: "EA",
	            link: function(scope, element, attrs){
	                if(!scope.name || scope.name === '') throw('textAngular Error: A toolbar requires a name');
	                angular.extend(scope, angular.copy(taOptions));
	                if(attrs.taToolbar)						scope.toolbar = scope.$parent.$eval(attrs.taToolbar);
	                if(attrs.taToolbarClass)				scope.classes.toolbar = attrs.taToolbarClass;
	                if(attrs.taToolbarGroupClass)			scope.classes.toolbarGroup = attrs.taToolbarGroupClass;
	                if(attrs.taToolbarButtonClass)			scope.classes.toolbarButton = attrs.taToolbarButtonClass;
	                if(attrs.taToolbarActiveButtonClass)	scope.classes.toolbarButtonActive = attrs.taToolbarActiveButtonClass;
	                if(attrs.taFocussedClass)				scope.classes.focussed = attrs.taFocussedClass;
	
	                scope.disabled = true;
	                scope.focussed = false;
	                scope._$element = element;
	                element[0].innerHTML = '';
	                element.addClass("ta-toolbar " + scope.classes.toolbar);
	
	                scope.$watch('focussed', function(){
	                    if(scope.focussed) element.addClass(scope.classes.focussed);
	                    else element.removeClass(scope.classes.focussed);
	                });
	
	                var setupToolElement = function(toolDefinition, toolScope){
	                    var toolElement;
	                    if(toolDefinition && toolDefinition.display){
	                        toolElement = angular.element(toolDefinition.display);
	                    }
	                    else toolElement = angular.element("<button type='button'>");
	
	                    if(toolDefinition && toolDefinition["class"]) toolElement.addClass(toolDefinition["class"]);
	                    else toolElement.addClass(scope.classes.toolbarButton);
	
	                    toolElement.attr('name', toolScope.name);
	                    // important to not take focus from the main text/html entry
	                    toolElement.attr('ta-button', 'ta-button');
	                    toolElement.attr('ng-disabled', 'isDisabled()');
	                    toolElement.attr('tabindex', '-1');
	                    toolElement.attr('ng-click', 'executeAction()');
	                    toolElement.attr('ng-class', 'displayActiveToolClass(active)');
	
	                    if (toolDefinition && toolDefinition.tooltiptext) {
	                        toolElement.attr('title', toolDefinition.tooltiptext);
	                    }
	                    if(toolDefinition && !toolDefinition.display && !toolScope._display){
	                        // first clear out the current contents if any
	                        toolElement[0].innerHTML = '';
	                        // add the buttonText
	                        if(toolDefinition.buttontext) toolElement[0].innerHTML = toolDefinition.buttontext;
	                        // add the icon to the front of the button if there is content
	                        if(toolDefinition.iconclass){
	                            var icon = angular.element('<i>'), content = toolElement[0].innerHTML;
	                            icon.addClass(toolDefinition.iconclass);
	                            toolElement[0].innerHTML = '';
	                            toolElement.append(icon);
	                            if(content && content !== '') toolElement.append('&nbsp;' + content);
	                        }
	                    }
	
	                    toolScope._lastToolDefinition = angular.copy(toolDefinition);
	
	                    return $compile(toolElement)(toolScope);
	                };
	
	                // Keep a reference for updating the active states later
	                scope.tools = {};
	                // create the tools in the toolbar
	                // default functions and values to prevent errors in testing and on init
	                scope._parent = {
	                    disabled: true,
	                    showHtml: false,
	                    queryFormatBlockState: function(){ return false; },
	                    queryCommandState: function(){ return false; }
	                };
	                var defaultChildScope = {
	                    $window: $window,
	                    $editor: function(){
	                        // dynamically gets the editor as it is set
	                        return scope._parent;
	                    },
	                    isDisabled: function(){
	                        // view selection button is always enabled since it doesn not depend on a selction!
	                        if (this.name === 'html' && scope._parent.startAction) {
	                            return false;
	                        }
	                        // to set your own disabled logic set a function or boolean on the tool called 'disabled'
	                        return ( // this bracket is important as without it it just returns the first bracket and ignores the rest
	                            // when the button's disabled function/value evaluates to true
	                            (typeof this.$eval('disabled') !== 'function' && this.$eval('disabled')) || this.$eval('disabled()') ||
	                            // all buttons except the HTML Switch button should be disabled in the showHtml (RAW html) mode
	                            (this.name !== 'html' && this.$editor().showHtml) ||
	                            // if the toolbar is disabled
	                            this.$parent.disabled ||
	                            // if the current editor is disabled
	                            this.$editor().disabled
	                        );
	                    },
	                    displayActiveToolClass: function(active){
	                        return (active)? scope.classes.toolbarButtonActive : '';
	                    },
	                    executeAction: taToolExecuteAction
	                };
	
	                angular.forEach(scope.toolbar, function(group){
	                    // setup the toolbar group
	                    var groupElement = angular.element("<div>");
	                    groupElement.addClass(scope.classes.toolbarGroup);
	                    angular.forEach(group, function(tool){
	                        // init and add the tools to the group
	                        // a tool name (key name from taTools struct)
	                        //creates a child scope of the main angularText scope and then extends the childScope with the functions of this particular tool
	                        // reference to the scope and element kept
	                        scope.tools[tool] = angular.extend(scope.$new(true), taTools[tool], defaultChildScope, {name: tool});
	                        scope.tools[tool].$element = setupToolElement(taTools[tool], scope.tools[tool]);
	                        // append the tool compiled with the childScope to the group element
	                        groupElement.append(scope.tools[tool].$element);
	                    });
	                    // append the group to the toolbar
	                    element.append(groupElement);
	                });
	
	                // update a tool
	                // if a value is set to null, remove from the display
	                // when forceNew is set to true it will ignore all previous settings, used to reset to taTools definition
	                // to reset to defaults pass in taTools[key] as _newTool and forceNew as true, ie `updateToolDisplay(key, taTools[key], true);`
	                scope.updateToolDisplay = function(key, _newTool, forceNew){
	                    var toolInstance = scope.tools[key];
	                    if(toolInstance){
	                        // get the last toolDefinition, then override with the new definition
	                        if(toolInstance._lastToolDefinition && !forceNew) _newTool = angular.extend({}, toolInstance._lastToolDefinition, _newTool);
	                        if(_newTool.buttontext === null && _newTool.iconclass === null && _newTool.display === null)
	                            throw('textAngular Error: Tool Definition for updating "' + key + '" does not have a valid display/iconclass/buttontext value');
	
	                        // if tool is defined on this toolbar, update/redo the tool
	                        if(_newTool.buttontext === null){
	                            delete _newTool.buttontext;
	                        }
	                        if(_newTool.iconclass === null){
	                            delete _newTool.iconclass;
	                        }
	                        if(_newTool.display === null){
	                            delete _newTool.display;
	                        }
	
	                        var toolElement = setupToolElement(_newTool, toolInstance);
	                        toolInstance.$element.replaceWith(toolElement);
	                        toolInstance.$element = toolElement;
	                    }
	                };
	
	                // we assume here that all values passed are valid and correct
	                scope.addTool = function(key, _newTool, groupIndex, index){
	                    scope.tools[key] = angular.extend(scope.$new(true), taTools[key], defaultChildScope, {name: key});
	                    scope.tools[key].$element = setupToolElement(taTools[key], scope.tools[key]);
	                    var group;
	                    if(groupIndex === undefined) groupIndex = scope.toolbar.length - 1;
	                    group = angular.element(element.children()[groupIndex]);
	
	                    if(index === undefined){
	                        group.append(scope.tools[key].$element);
	                        scope.toolbar[groupIndex][scope.toolbar[groupIndex].length - 1] = key;
	                    }else{
	                        group.children().eq(index).after(scope.tools[key].$element);
	                        scope.toolbar[groupIndex][index] = key;
	                    }
	                };
	
	                textAngularManager.registerToolbar(scope);
	
	                scope.$on('$destroy', function(){
	                    textAngularManager.unregisterToolbar(scope.name);
	                });
	            }
	        };
	    }
	]);
	textAngular.directive('textAngularVersion', ['textAngularManager',
	    function(textAngularManager) {
	        var version = textAngularManager.getVersion();
	        return {
	            restrict: "EA",
	            link: function (scope, element, attrs) {
	                element.html(version);
	            }
	        };
	    }
	]);
	
	return textAngular.name;
	
	}));


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Rangy, a cross-browser JavaScript range and selection library
	 * https://github.com/timdown/rangy
	 *
	 * Copyright 2024, Tim Down
	 * Licensed under the MIT license.
	 * Version: 1.3.2
	 * Build date: 2 November 2024
	 */
	
	(function(factory, root) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module != "undefined" && typeof exports == "object") {
	        // Node/CommonJS style
	        module.exports = factory();
	    } else {
	        // No AMD or CommonJS support so we place Rangy in (probably) the global variable
	        root.rangy = factory();
	    }
	})(function() {
	
	    var OBJECT = "object", FUNCTION = "function", UNDEFINED = "undefined";
	
	    // Minimal set of properties required for DOM Level 2 Range compliance. Comparison constants such as START_TO_START
	    // are omitted because ranges in KHTML do not have them but otherwise work perfectly well. See issue 113.
	    var domRangeProperties = ["startContainer", "startOffset", "endContainer", "endOffset", "collapsed",
	        "commonAncestorContainer"];
	
	    // Minimal set of methods required for DOM Level 2 Range compliance
	    var domRangeMethods = ["setStart", "setStartBefore", "setStartAfter", "setEnd", "setEndBefore",
	        "setEndAfter", "collapse", "selectNode", "selectNodeContents", "compareBoundaryPoints", "deleteContents",
	        "extractContents", "cloneContents", "insertNode", "surroundContents", "cloneRange", "toString", "detach"];
	
	    var textRangeProperties = ["boundingHeight", "boundingLeft", "boundingTop", "boundingWidth", "htmlText", "text"];
	
	    // Subset of TextRange's full set of methods that we're interested in
	    var textRangeMethods = ["collapse", "compareEndPoints", "duplicate", "moveToElementText", "parentElement", "select",
	        "setEndPoint", "getBoundingClientRect"];
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Trio of functions taken from Peter Michaux's article:
	    // http://peter.michaux.ca/articles/feature-detection-state-of-the-art-browser-scripting
	    function isHostMethod(o, p) {
	        var t = typeof o[p];
	        return t == FUNCTION || (!!(t == OBJECT && o[p])) || t == "unknown";
	    }
	
	    function isHostObject(o, p) {
	        return !!(typeof o[p] == OBJECT && o[p]);
	    }
	
	    function isHostProperty(o, p) {
	        return typeof o[p] != UNDEFINED;
	    }
	
	    // Creates a convenience function to save verbose repeated calls to tests functions
	    function createMultiplePropertyTest(testFunc) {
	        return function(o, props) {
	            var i = props.length;
	            while (i--) {
	                if (!testFunc(o, props[i])) {
	                    return false;
	                }
	            }
	            return true;
	        };
	    }
	
	    // Next trio of functions are a convenience to save verbose repeated calls to previous two functions
	    var areHostMethods = createMultiplePropertyTest(isHostMethod);
	    var areHostObjects = createMultiplePropertyTest(isHostObject);
	    var areHostProperties = createMultiplePropertyTest(isHostProperty);
	
	    function isTextRange(range) {
	        return range && areHostMethods(range, textRangeMethods) && areHostProperties(range, textRangeProperties);
	    }
	
	    function getBody(doc) {
	        return isHostObject(doc, "body") ? doc.body : doc.getElementsByTagName("body")[0];
	    }
	
	    var forEach = [].forEach ?
	        function(arr, func) {
	            arr.forEach(func);
	        } :
	        function(arr, func) {
	            for (var i = 0, len = arr.length; i < len; ++i) {
	                func(arr[i], i);
	            }
	        };
	
	    var modules = {};
	
	    var isBrowser = (typeof window != UNDEFINED && typeof document != UNDEFINED);
	
	    var util = {
	        isHostMethod: isHostMethod,
	        isHostObject: isHostObject,
	        isHostProperty: isHostProperty,
	        areHostMethods: areHostMethods,
	        areHostObjects: areHostObjects,
	        areHostProperties: areHostProperties,
	        isTextRange: isTextRange,
	        getBody: getBody,
	        forEach: forEach
	    };
	
	    var api = {
	        version: "1.3.2",
	        initialized: false,
	        isBrowser: isBrowser,
	        supported: true,
	        util: util,
	        features: {},
	        modules: modules,
	        config: {
	            alertOnFail: false,
	            alertOnWarn: false,
	            preferTextRange: false,
	            autoInitialize: (typeof rangyAutoInitialize == UNDEFINED) ? true : rangyAutoInitialize
	        }
	    };
	
	    function consoleLog(msg) {
	        if (typeof console != UNDEFINED && isHostMethod(console, "log")) {
	            console.log(msg);
	        }
	    }
	
	    function alertOrLog(msg, shouldAlert) {
	        if (isBrowser && shouldAlert) {
	            alert(msg);
	        } else  {
	            consoleLog(msg);
	        }
	    }
	
	    function fail(reason) {
	        api.initialized = true;
	        api.supported = false;
	        alertOrLog("Rangy is not supported in this environment. Reason: " + reason, api.config.alertOnFail);
	    }
	
	    api.fail = fail;
	
	    function warn(msg) {
	        alertOrLog("Rangy warning: " + msg, api.config.alertOnWarn);
	    }
	
	    api.warn = warn;
	
	    // Add utility extend() method
	    var extend;
	    if ({}.hasOwnProperty) {
	        util.extend = extend = function(obj, props, deep) {
	            var o, p;
	            for (var i in props) {
	                if (i === "__proto__" || i === "constructor" || i === "prototype") {
	                    continue;
	                }
	                if (props.hasOwnProperty(i)) {
	                    o = obj[i];
	                    p = props[i];
	                    if (deep && o !== null && typeof o == "object" && p !== null && typeof p == "object") {
	                        extend(o, p, true);
	                    }
	                    obj[i] = p;
	                }
	            }
	            // Special case for toString, which does not show up in for...in loops in IE <= 8
	            if (props.hasOwnProperty("toString")) {
	                obj.toString = props.toString;
	            }
	            return obj;
	        };
	
	        util.createOptions = function(optionsParam, defaults) {
	            var options = {};
	            extend(options, defaults);
	            if (optionsParam) {
	                extend(options, optionsParam);
	            }
	            return options;
	        };
	    } else {
	        fail("hasOwnProperty not supported");
	    }
	
	    // Test whether we're in a browser and bail out if not
	    if (!isBrowser) {
	        fail("Rangy can only run in a browser");
	    }
	
	    // Test whether Array.prototype.slice can be relied on for NodeLists and use an alternative toArray() if not
	    (function() {
	        var toArray;
	
	        if (isBrowser) {
	            var el = document.createElement("div");
	            el.appendChild(document.createElement("span"));
	            var slice = [].slice;
	            try {
	                if (slice.call(el.childNodes, 0)[0].nodeType == 1) {
	                    toArray = function(arrayLike) {
	                        return slice.call(arrayLike, 0);
	                    };
	                }
	            } catch (e) {}
	        }
	
	        if (!toArray) {
	            toArray = function(arrayLike) {
	                var arr = [];
	                for (var i = 0, len = arrayLike.length; i < len; ++i) {
	                    arr[i] = arrayLike[i];
	                }
	                return arr;
	            };
	        }
	
	        util.toArray = toArray;
	    })();
	
	    // Very simple event handler wrapper function that doesn't attempt to solve issues such as "this" handling or
	    // normalization of event properties because we don't need this.
	    var addListener;
	    if (isBrowser) {
	        if (isHostMethod(document, "addEventListener")) {
	            addListener = function(obj, eventType, listener) {
	                obj.addEventListener(eventType, listener, false);
	            };
	        } else if (isHostMethod(document, "attachEvent")) {
	            addListener = function(obj, eventType, listener) {
	                obj.attachEvent("on" + eventType, listener);
	            };
	        } else {
	            fail("Document does not have required addEventListener or attachEvent method");
	        }
	
	        util.addListener = addListener;
	    }
	
	    var initListeners = [];
	
	    function getErrorDesc(ex) {
	        return ex.message || ex.description || String(ex);
	    }
	
	    // Initialization
	    function init() {
	        if (!isBrowser || api.initialized) {
	            return;
	        }
	        var testRange;
	        var implementsDomRange = false, implementsTextRange = false;
	
	        // First, perform basic feature tests
	
	        if (isHostMethod(document, "createRange")) {
	            testRange = document.createRange();
	            if (areHostMethods(testRange, domRangeMethods) && areHostProperties(testRange, domRangeProperties)) {
	                implementsDomRange = true;
	            }
	        }
	
	        var body = getBody(document);
	        if (!body || body.nodeName.toLowerCase() != "body") {
	            fail("No body element found");
	            return;
	        }
	
	        if (body && isHostMethod(body, "createTextRange")) {
	            testRange = body.createTextRange();
	            if (isTextRange(testRange)) {
	                implementsTextRange = true;
	            }
	        }
	
	        if (!implementsDomRange && !implementsTextRange) {
	            fail("Neither Range nor TextRange are available");
	            return;
	        }
	
	        api.initialized = true;
	        api.features = {
	            implementsDomRange: implementsDomRange,
	            implementsTextRange: implementsTextRange
	        };
	
	        // Initialize modules
	        var module, errorMessage;
	        for (var moduleName in modules) {
	            if ( (module = modules[moduleName]) instanceof Module ) {
	                module.init(module, api);
	            }
	        }
	
	        // Call init listeners
	        for (var i = 0, len = initListeners.length; i < len; ++i) {
	            try {
	                initListeners[i](api);
	            } catch (ex) {
	                errorMessage = "Rangy init listener threw an exception. Continuing. Detail: " + getErrorDesc(ex);
	                consoleLog(errorMessage);
	            }
	        }
	    }
	
	    function deprecationNotice(deprecated, replacement, module) {
	        if (module) {
	            deprecated += " in module " + module.name;
	        }
	        api.warn("DEPRECATED: " + deprecated + " is deprecated. Please use " +
	        replacement + " instead.");
	    }
	
	    function createAliasForDeprecatedMethod(owner, deprecated, replacement, module) {
	        owner[deprecated] = function() {
	            deprecationNotice(deprecated, replacement, module);
	            return owner[replacement].apply(owner, util.toArray(arguments));
	        };
	    }
	
	    util.deprecationNotice = deprecationNotice;
	    util.createAliasForDeprecatedMethod = createAliasForDeprecatedMethod;
	
	    // Allow external scripts to initialize this library in case it's loaded after the document has loaded
	    api.init = init;
	
	    // Execute listener immediately if already initialized
	    api.addInitListener = function(listener) {
	        if (api.initialized) {
	            listener(api);
	        } else {
	            initListeners.push(listener);
	        }
	    };
	
	    var shimListeners = [];
	
	    api.addShimListener = function(listener) {
	        shimListeners.push(listener);
	    };
	
	    function shim(win) {
	        win = win || window;
	        init();
	
	        // Notify listeners
	        for (var i = 0, len = shimListeners.length; i < len; ++i) {
	            shimListeners[i](win);
	        }
	    }
	
	    if (isBrowser) {
	        api.shim = api.createMissingNativeApi = shim;
	        createAliasForDeprecatedMethod(api, "createMissingNativeApi", "shim");
	    }
	
	    function Module(name, dependencies, initializer) {
	        this.name = name;
	        this.dependencies = dependencies;
	        this.initialized = false;
	        this.supported = false;
	        this.initializer = initializer;
	    }
	
	    Module.prototype = {
	        init: function() {
	            var requiredModuleNames = this.dependencies || [];
	            for (var i = 0, len = requiredModuleNames.length, requiredModule, moduleName; i < len; ++i) {
	                moduleName = requiredModuleNames[i];
	
	                requiredModule = modules[moduleName];
	                if (!requiredModule || !(requiredModule instanceof Module)) {
	                    throw new Error("required module '" + moduleName + "' not found");
	                }
	
	                requiredModule.init();
	
	                if (!requiredModule.supported) {
	                    throw new Error("required module '" + moduleName + "' not supported");
	                }
	            }
	
	            // Now run initializer
	            this.initializer(this);
	        },
	
	        fail: function(reason) {
	            this.initialized = true;
	            this.supported = false;
	            throw new Error(reason);
	        },
	
	        warn: function(msg) {
	            api.warn("Module " + this.name + ": " + msg);
	        },
	
	        deprecationNotice: function(deprecated, replacement) {
	            api.warn("DEPRECATED: " + deprecated + " in module " + this.name + " is deprecated. Please use " +
	                replacement + " instead");
	        },
	
	        createError: function(msg) {
	            return new Error("Error in Rangy " + this.name + " module: " + msg);
	        }
	    };
	
	    function createModule(name, dependencies, initFunc) {
	        var newModule = new Module(name, dependencies, function(module) {
	            if (!module.initialized) {
	                module.initialized = true;
	                try {
	                    initFunc(api, module);
	                    module.supported = true;
	                } catch (ex) {
	                    var errorMessage = "Module '" + name + "' failed to load: " + getErrorDesc(ex);
	                    consoleLog(errorMessage);
	                    if (ex.stack) {
	                        consoleLog(ex.stack);
	                    }
	                }
	            }
	        });
	        modules[name] = newModule;
	        return newModule;
	    }
	
	    api.createModule = function(name) {
	        // Allow 2 or 3 arguments (second argument is an optional array of dependencies)
	        var initFunc, dependencies;
	        if (arguments.length == 2) {
	            initFunc = arguments[1];
	            dependencies = [];
	        } else {
	            initFunc = arguments[2];
	            dependencies = arguments[1];
	        }
	
	        var module = createModule(name, dependencies, initFunc);
	
	        // Initialize the module immediately if the core is already initialized
	        if (api.initialized && api.supported) {
	            module.init();
	        }
	    };
	
	    api.createCoreModule = function(name, dependencies, initFunc) {
	        createModule(name, dependencies, initFunc);
	    };
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Ensure rangy.rangePrototype and rangy.selectionPrototype are available immediately
	
	    function RangePrototype() {}
	    api.RangePrototype = RangePrototype;
	    api.rangePrototype = new RangePrototype();
	
	    function SelectionPrototype() {}
	    api.selectionPrototype = new SelectionPrototype();
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // DOM utility methods used by Rangy
	    api.createCoreModule("DomUtil", [], function(api, module) {
	        var UNDEF = "undefined";
	        var util = api.util;
	        var getBody = util.getBody;
	
	        // Perform feature tests
	        if (!util.areHostMethods(document, ["createDocumentFragment", "createElement", "createTextNode"])) {
	            module.fail("document missing a Node creation method");
	        }
	
	        if (!util.isHostMethod(document, "getElementsByTagName")) {
	            module.fail("document missing getElementsByTagName method");
	        }
	
	        var el = document.createElement("div");
	        if (!util.areHostMethods(el, ["insertBefore", "appendChild", "cloneNode"] ||
	                !util.areHostObjects(el, ["previousSibling", "nextSibling", "childNodes", "parentNode"]))) {
	            module.fail("Incomplete Element implementation");
	        }
	
	        // innerHTML is required for Range's createContextualFragment method
	        if (!util.isHostProperty(el, "innerHTML")) {
	            module.fail("Element is missing innerHTML property");
	        }
	
	        var textNode = document.createTextNode("test");
	        if (!util.areHostMethods(textNode, ["splitText", "deleteData", "insertData", "appendData", "cloneNode"] ||
	                !util.areHostObjects(el, ["previousSibling", "nextSibling", "childNodes", "parentNode"]) ||
	                !util.areHostProperties(textNode, ["data"]))) {
	            module.fail("Incomplete Text Node implementation");
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Removed use of indexOf because of a bizarre bug in Opera that is thrown in one of the Acid3 tests. I haven't been
	        // able to replicate it outside of the test. The bug is that indexOf returns -1 when called on an Array that
	        // contains just the document as a single element and the value searched for is the document.
	        var arrayContains = /*Array.prototype.indexOf ?
	            function(arr, val) {
	                return arr.indexOf(val) > -1;
	            }:*/
	
	            function(arr, val) {
	                var i = arr.length;
	                while (i--) {
	                    if (arr[i] === val) {
	                        return true;
	                    }
	                }
	                return false;
	            };
	
	        // Opera 11 puts HTML elements in the null namespace, it seems, and IE 7 has undefined namespaceURI
	        function isHtmlNamespace(node) {
	            var ns;
	            return typeof node.namespaceURI == UNDEF || ((ns = node.namespaceURI) === null || ns == "http://www.w3.org/1999/xhtml");
	        }
	
	        function parentElement(node) {
	            var parent = node.parentNode;
	            return (parent.nodeType == 1) ? parent : null;
	        }
	
	        function getNodeIndex(node) {
	            var i = 0;
	            while( (node = node.previousSibling) ) {
	                ++i;
	            }
	            return i;
	        }
	
	        function getNodeLength(node) {
	            switch (node.nodeType) {
	                case 7:
	                case 10:
	                    return 0;
	                case 3:
	                case 8:
	                    return node.length;
	                default:
	                    return node.childNodes.length;
	            }
	        }
	
	        function getCommonAncestor(node1, node2) {
	            var ancestors = [], n;
	            for (n = node1; n; n = n.parentNode) {
	                ancestors.push(n);
	            }
	
	            for (n = node2; n; n = n.parentNode) {
	                if (arrayContains(ancestors, n)) {
	                    return n;
	                }
	            }
	
	            return null;
	        }
	
	        function isAncestorOf(ancestor, descendant, selfIsAncestor) {
	            var n = selfIsAncestor ? descendant : descendant.parentNode;
	            while (n) {
	                if (n === ancestor) {
	                    return true;
	                } else {
	                    n = n.parentNode;
	                }
	            }
	            return false;
	        }
	
	        function isOrIsAncestorOf(ancestor, descendant) {
	            return isAncestorOf(ancestor, descendant, true);
	        }
	
	        function getClosestAncestorIn(node, ancestor, selfIsAncestor) {
	            var p, n = selfIsAncestor ? node : node.parentNode;
	            while (n) {
	                p = n.parentNode;
	                if (p === ancestor) {
	                    return n;
	                }
	                n = p;
	            }
	            return null;
	        }
	
	        function isCharacterDataNode(node) {
	            var t = node.nodeType;
	            return t == 3 || t == 4 || t == 8 ; // Text, CDataSection or Comment
	        }
	
	        function isTextOrCommentNode(node) {
	            if (!node) {
	                return false;
	            }
	            var t = node.nodeType;
	            return t == 3 || t == 8 ; // Text or Comment
	        }
	
	        function insertAfter(node, precedingNode) {
	            var nextNode = precedingNode.nextSibling, parent = precedingNode.parentNode;
	            if (nextNode) {
	                parent.insertBefore(node, nextNode);
	            } else {
	                parent.appendChild(node);
	            }
	            return node;
	        }
	
	        // Note that we cannot use splitText() because it is bugridden in IE 9.
	        function splitDataNode(node, index, positionsToPreserve) {
	            var newNode = node.cloneNode(false);
	            newNode.deleteData(0, index);
	            node.deleteData(index, node.length - index);
	            insertAfter(newNode, node);
	
	            // Preserve positions
	            if (positionsToPreserve) {
	                for (var i = 0, position; position = positionsToPreserve[i++]; ) {
	                    // Handle case where position was inside the portion of node after the split point
	                    if (position.node == node && position.offset > index) {
	                        position.node = newNode;
	                        position.offset -= index;
	                    }
	                    // Handle the case where the position is a node offset within node's parent
	                    else if (position.node == node.parentNode && position.offset > getNodeIndex(node)) {
	                        ++position.offset;
	                    }
	                }
	            }
	            return newNode;
	        }
	
	        function getDocument(node) {
	            if (node.nodeType == 9) {
	                return node;
	            } else if (typeof node.ownerDocument != UNDEF) {
	                return node.ownerDocument;
	            } else if (typeof node.document != UNDEF) {
	                return node.document;
	            } else if (node.parentNode) {
	                return getDocument(node.parentNode);
	            } else {
	                throw module.createError("getDocument: no document found for node");
	            }
	        }
	
	        function getWindow(node) {
	            var doc = getDocument(node);
	            if (typeof doc.defaultView != UNDEF) {
	                return doc.defaultView;
	            } else if (typeof doc.parentWindow != UNDEF) {
	                return doc.parentWindow;
	            } else {
	                throw module.createError("Cannot get a window object for node");
	            }
	        }
	
	        function getIframeDocument(iframeEl) {
	            if (typeof iframeEl.contentDocument != UNDEF) {
	                return iframeEl.contentDocument;
	            } else if (typeof iframeEl.contentWindow != UNDEF) {
	                return iframeEl.contentWindow.document;
	            } else {
	                throw module.createError("getIframeDocument: No Document object found for iframe element");
	            }
	        }
	
	        function getIframeWindow(iframeEl) {
	            if (typeof iframeEl.contentWindow != UNDEF) {
	                return iframeEl.contentWindow;
	            } else if (typeof iframeEl.contentDocument != UNDEF) {
	                return iframeEl.contentDocument.defaultView;
	            } else {
	                throw module.createError("getIframeWindow: No Window object found for iframe element");
	            }
	        }
	
	        // This looks bad. Is it worth it?
	        function isWindow(obj) {
	            return obj && util.isHostMethod(obj, "setTimeout") && util.isHostObject(obj, "document");
	        }
	
	        function getContentDocument(obj, module, methodName) {
	            var doc;
	
	            if (!obj) {
	                doc = document;
	            }
	
	            // Test if a DOM node has been passed and obtain a document object for it if so
	            else if (util.isHostProperty(obj, "nodeType")) {
	                doc = (obj.nodeType == 1 && obj.tagName.toLowerCase() == "iframe") ?
	                    getIframeDocument(obj) : getDocument(obj);
	            }
	
	            // Test if the doc parameter appears to be a Window object
	            else if (isWindow(obj)) {
	                doc = obj.document;
	            }
	
	            if (!doc) {
	                throw module.createError(methodName + "(): Parameter must be a Window object or DOM node");
	            }
	
	            return doc;
	        }
	
	        function getRootContainer(node) {
	            var parent;
	            while ( (parent = node.parentNode) ) {
	                node = parent;
	            }
	            return node;
	        }
	
	        function comparePoints(nodeA, offsetA, nodeB, offsetB) {
	            // See http://www.w3.org/TR/DOM-Level-2-Traversal-Range/ranges.html#Level-2-Range-Comparing
	            var nodeC, root, childA, childB, n;
	            if (nodeA == nodeB) {
	                // Case 1: nodes are the same
	                return offsetA === offsetB ? 0 : (offsetA < offsetB) ? -1 : 1;
	            } else if ( (nodeC = getClosestAncestorIn(nodeB, nodeA, true)) ) {
	                // Case 2: node C (container B or an ancestor) is a child node of A
	                return offsetA <= getNodeIndex(nodeC) ? -1 : 1;
	            } else if ( (nodeC = getClosestAncestorIn(nodeA, nodeB, true)) ) {
	                // Case 3: node C (container A or an ancestor) is a child node of B
	                return getNodeIndex(nodeC) < offsetB  ? -1 : 1;
	            } else {
	                root = getCommonAncestor(nodeA, nodeB);
	                if (!root) {
	                    throw new Error("comparePoints error: nodes have no common ancestor");
	                }
	
	                // Case 4: containers are siblings or descendants of siblings
	                childA = (nodeA === root) ? root : getClosestAncestorIn(nodeA, root, true);
	                childB = (nodeB === root) ? root : getClosestAncestorIn(nodeB, root, true);
	
	                if (childA === childB) {
	                    // This shouldn't be possible
	                    throw module.createError("comparePoints got to case 4 and childA and childB are the same!");
	                } else {
	                    n = root.firstChild;
	                    while (n) {
	                        if (n === childA) {
	                            return -1;
	                        } else if (n === childB) {
	                            return 1;
	                        }
	                        n = n.nextSibling;
	                    }
	                }
	            }
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Test for IE's crash (IE 6/7) or exception (IE >= 8) when a reference to garbage-collected text node is queried
	        var crashyTextNodes = false;
	
	        function isBrokenNode(node) {
	            var n;
	            try {
	                n = node.parentNode;
	                return false;
	            } catch (e) {
	                return true;
	            }
	        }
	
	        (function() {
	            var el = document.createElement("b");
	            el.innerHTML = "1";
	            var textNode = el.firstChild;
	            el.innerHTML = "<br />";
	            crashyTextNodes = isBrokenNode(textNode);
	
	            api.features.crashyTextNodes = crashyTextNodes;
	        })();
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        function inspectNode(node) {
	            if (!node) {
	                return "[No node]";
	            }
	            if (crashyTextNodes && isBrokenNode(node)) {
	                return "[Broken node]";
	            }
	            if (isCharacterDataNode(node)) {
	                return '"' + node.data + '"';
	            }
	            if (node.nodeType == 1) {
	                var idAttr = node.id ? ' id="' + node.id + '"' : "";
	                return "<" + node.nodeName + idAttr + ">[index:" + getNodeIndex(node) + ",length:" + node.childNodes.length + "][" + (node.innerHTML || "[innerHTML not supported]").slice(0, 25) + "]";
	            }
	            return node.nodeName;
	        }
	
	        function fragmentFromNodeChildren(node) {
	            var fragment = getDocument(node).createDocumentFragment(), child;
	            while ( (child = node.firstChild) ) {
	                fragment.appendChild(child);
	            }
	            return fragment;
	        }
	
	        var getComputedStyleProperty;
	        if (typeof window.getComputedStyle != UNDEF) {
	            getComputedStyleProperty = function(el, propName) {
	                return getWindow(el).getComputedStyle(el, null)[propName];
	            };
	        } else if (typeof document.documentElement.currentStyle != UNDEF) {
	            getComputedStyleProperty = function(el, propName) {
	                return el.currentStyle ? el.currentStyle[propName] : "";
	            };
	        } else {
	            module.fail("No means of obtaining computed style properties found");
	        }
	
	        function createTestElement(doc, html, contentEditable) {
	            var body = getBody(doc);
	            var el = doc.createElement("div");
	            el.contentEditable = "" + !!contentEditable;
	            if (html) {
	                el.innerHTML = html;
	            }
	
	            // Insert the test element at the start of the body to prevent scrolling to the bottom in iOS (issue #292)
	            var bodyFirstChild = body.firstChild;
	            if (bodyFirstChild) {
	                body.insertBefore(el, bodyFirstChild);
	            } else {
	                body.appendChild(el);
	            }
	
	            return el;
	        }
	
	        function removeNode(node) {
	            return node.parentNode.removeChild(node);
	        }
	
	        function NodeIterator(root) {
	            this.root = root;
	            this._next = root;
	        }
	
	        NodeIterator.prototype = {
	            _current: null,
	
	            hasNext: function() {
	                return !!this._next;
	            },
	
	            next: function() {
	                var n = this._current = this._next;
	                var child, next;
	                if (this._current) {
	                    child = n.firstChild;
	                    if (child) {
	                        this._next = child;
	                    } else {
	                        next = null;
	                        while ((n !== this.root) && !(next = n.nextSibling)) {
	                            n = n.parentNode;
	                        }
	                        this._next = next;
	                    }
	                }
	                return this._current;
	            },
	
	            detach: function() {
	                this._current = this._next = this.root = null;
	            }
	        };
	
	        function createIterator(root) {
	            return new NodeIterator(root);
	        }
	
	        function DomPosition(node, offset) {
	            this.node = node;
	            this.offset = offset;
	        }
	
	        DomPosition.prototype = {
	            equals: function(pos) {
	                return !!pos && this.node === pos.node && this.offset == pos.offset;
	            },
	
	            inspect: function() {
	                return "[DomPosition(" + inspectNode(this.node) + ":" + this.offset + ")]";
	            },
	
	            toString: function() {
	                return this.inspect();
	            }
	        };
	
	        function DOMException(codeName) {
	            this.code = this[codeName];
	            this.codeName = codeName;
	            this.message = "DOMException: " + this.codeName;
	        }
	
	        DOMException.prototype = {
	            INDEX_SIZE_ERR: 1,
	            HIERARCHY_REQUEST_ERR: 3,
	            WRONG_DOCUMENT_ERR: 4,
	            NO_MODIFICATION_ALLOWED_ERR: 7,
	            NOT_FOUND_ERR: 8,
	            NOT_SUPPORTED_ERR: 9,
	            INVALID_STATE_ERR: 11,
	            INVALID_NODE_TYPE_ERR: 24
	        };
	
	        DOMException.prototype.toString = function() {
	            return this.message;
	        };
	
	        api.dom = {
	            arrayContains: arrayContains,
	            isHtmlNamespace: isHtmlNamespace,
	            parentElement: parentElement,
	            getNodeIndex: getNodeIndex,
	            getNodeLength: getNodeLength,
	            getCommonAncestor: getCommonAncestor,
	            isAncestorOf: isAncestorOf,
	            isOrIsAncestorOf: isOrIsAncestorOf,
	            getClosestAncestorIn: getClosestAncestorIn,
	            isCharacterDataNode: isCharacterDataNode,
	            isTextOrCommentNode: isTextOrCommentNode,
	            insertAfter: insertAfter,
	            splitDataNode: splitDataNode,
	            getDocument: getDocument,
	            getWindow: getWindow,
	            getIframeWindow: getIframeWindow,
	            getIframeDocument: getIframeDocument,
	            getBody: getBody,
	            isWindow: isWindow,
	            getContentDocument: getContentDocument,
	            getRootContainer: getRootContainer,
	            comparePoints: comparePoints,
	            isBrokenNode: isBrokenNode,
	            inspectNode: inspectNode,
	            getComputedStyleProperty: getComputedStyleProperty,
	            createTestElement: createTestElement,
	            removeNode: removeNode,
	            fragmentFromNodeChildren: fragmentFromNodeChildren,
	            createIterator: createIterator,
	            DomPosition: DomPosition
	        };
	
	        api.DOMException = DOMException;
	    });
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Pure JavaScript implementation of DOM Range
	    api.createCoreModule("DomRange", ["DomUtil"], function(api, module) {
	        var dom = api.dom;
	        var util = api.util;
	        var DomPosition = dom.DomPosition;
	        var DOMException = api.DOMException;
	
	        var isCharacterDataNode = dom.isCharacterDataNode;
	        var getNodeIndex = dom.getNodeIndex;
	        var isOrIsAncestorOf = dom.isOrIsAncestorOf;
	        var getDocument = dom.getDocument;
	        var comparePoints = dom.comparePoints;
	        var splitDataNode = dom.splitDataNode;
	        var getClosestAncestorIn = dom.getClosestAncestorIn;
	        var getNodeLength = dom.getNodeLength;
	        var arrayContains = dom.arrayContains;
	        var getRootContainer = dom.getRootContainer;
	        var crashyTextNodes = api.features.crashyTextNodes;
	
	        var removeNode = dom.removeNode;
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Utility functions
	
	        function isNonTextPartiallySelected(node, range) {
	            return (node.nodeType != 3) &&
	                   (isOrIsAncestorOf(node, range.startContainer) || isOrIsAncestorOf(node, range.endContainer));
	        }
	
	        function getRangeDocument(range) {
	            return range.document || getDocument(range.startContainer);
	        }
	
	        function getRangeRoot(range) {
	            return getRootContainer(range.startContainer);
	        }
	
	        function getBoundaryBeforeNode(node) {
	            return new DomPosition(node.parentNode, getNodeIndex(node));
	        }
	
	        function getBoundaryAfterNode(node) {
	            return new DomPosition(node.parentNode, getNodeIndex(node) + 1);
	        }
	
	        function insertNodeAtPosition(node, n, o) {
	            var firstNodeInserted = node.nodeType == 11 ? node.firstChild : node;
	            if (isCharacterDataNode(n)) {
	                if (o == n.length) {
	                    dom.insertAfter(node, n);
	                } else {
	                    n.parentNode.insertBefore(node, o == 0 ? n : splitDataNode(n, o));
	                }
	            } else if (o >= n.childNodes.length) {
	                n.appendChild(node);
	            } else {
	                n.insertBefore(node, n.childNodes[o]);
	            }
	            return firstNodeInserted;
	        }
	
	        function rangesIntersect(rangeA, rangeB, touchingIsIntersecting) {
	            assertRangeValid(rangeA);
	            assertRangeValid(rangeB);
	
	            if (getRangeDocument(rangeB) != getRangeDocument(rangeA)) {
	                throw new DOMException("WRONG_DOCUMENT_ERR");
	            }
	
	            var startComparison = comparePoints(rangeA.startContainer, rangeA.startOffset, rangeB.endContainer, rangeB.endOffset),
	                endComparison = comparePoints(rangeA.endContainer, rangeA.endOffset, rangeB.startContainer, rangeB.startOffset);
	
	            return touchingIsIntersecting ? startComparison <= 0 && endComparison >= 0 : startComparison < 0 && endComparison > 0;
	        }
	
	        function cloneSubtree(iterator) {
	            var partiallySelected;
	            for (var node, frag = getRangeDocument(iterator.range).createDocumentFragment(), subIterator; node = iterator.next(); ) {
	                partiallySelected = iterator.isPartiallySelectedSubtree();
	                node = node.cloneNode(!partiallySelected);
	                if (partiallySelected) {
	                    subIterator = iterator.getSubtreeIterator();
	                    node.appendChild(cloneSubtree(subIterator));
	                    subIterator.detach();
	                }
	
	                if (node.nodeType == 10) { // DocumentType
	                    throw new DOMException("HIERARCHY_REQUEST_ERR");
	                }
	                frag.appendChild(node);
	            }
	            return frag;
	        }
	
	        function iterateSubtree(rangeIterator, func, iteratorState) {
	            var it, n;
	            iteratorState = iteratorState || { stop: false };
	            for (var node, subRangeIterator; node = rangeIterator.next(); ) {
	                if (rangeIterator.isPartiallySelectedSubtree()) {
	                    if (func(node) === false) {
	                        iteratorState.stop = true;
	                        return;
	                    } else {
	                        // The node is partially selected by the Range, so we can use a new RangeIterator on the portion of
	                        // the node selected by the Range.
	                        subRangeIterator = rangeIterator.getSubtreeIterator();
	                        iterateSubtree(subRangeIterator, func, iteratorState);
	                        subRangeIterator.detach();
	                        if (iteratorState.stop) {
	                            return;
	                        }
	                    }
	                } else {
	                    // The whole node is selected, so we can use efficient DOM iteration to iterate over the node and its
	                    // descendants
	                    it = dom.createIterator(node);
	                    while ( (n = it.next()) ) {
	                        if (func(n) === false) {
	                            iteratorState.stop = true;
	                            return;
	                        }
	                    }
	                }
	            }
	        }
	
	        function deleteSubtree(iterator) {
	            var subIterator;
	            while (iterator.next()) {
	                if (iterator.isPartiallySelectedSubtree()) {
	                    subIterator = iterator.getSubtreeIterator();
	                    deleteSubtree(subIterator);
	                    subIterator.detach();
	                } else {
	                    iterator.remove();
	                }
	            }
	        }
	
	        function extractSubtree(iterator) {
	            for (var node, frag = getRangeDocument(iterator.range).createDocumentFragment(), subIterator; node = iterator.next(); ) {
	
	                if (iterator.isPartiallySelectedSubtree()) {
	                    node = node.cloneNode(false);
	                    subIterator = iterator.getSubtreeIterator();
	                    node.appendChild(extractSubtree(subIterator));
	                    subIterator.detach();
	                } else {
	                    iterator.remove();
	                }
	                if (node.nodeType == 10) { // DocumentType
	                    throw new DOMException("HIERARCHY_REQUEST_ERR");
	                }
	                frag.appendChild(node);
	            }
	            return frag;
	        }
	
	        function getNodesInRange(range, nodeTypes, filter) {
	            var filterNodeTypes = !!(nodeTypes && nodeTypes.length), regex;
	            var filterExists = !!filter;
	            if (filterNodeTypes) {
	                regex = new RegExp("^(" + nodeTypes.join("|") + ")$");
	            }
	
	            var nodes = [];
	            iterateSubtree(new RangeIterator(range, false), function(node) {
	                if (filterNodeTypes && !regex.test(node.nodeType)) {
	                    return;
	                }
	                if (filterExists && !filter(node)) {
	                    return;
	                }
	                // Don't include a boundary container if it is a character data node and the range does not contain any
	                // of its character data. See issue 190.
	                var sc = range.startContainer;
	                if (node == sc && isCharacterDataNode(sc) && range.startOffset == sc.length) {
	                    return;
	                }
	
	                var ec = range.endContainer;
	                if (node == ec && isCharacterDataNode(ec) && range.endOffset == 0) {
	                    return;
	                }
	
	                nodes.push(node);
	            });
	            return nodes;
	        }
	
	        function inspect(range) {
	            var name = (typeof range.getName == "undefined") ? "Range" : range.getName();
	            return "[" + name + "(" + dom.inspectNode(range.startContainer) + ":" + range.startOffset + ", " +
	                    dom.inspectNode(range.endContainer) + ":" + range.endOffset + ")]";
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // RangeIterator code partially borrows from IERange by Tim Ryan (http://github.com/timcameronryan/IERange)
	
	        function RangeIterator(range, clonePartiallySelectedTextNodes) {
	            this.range = range;
	            this.clonePartiallySelectedTextNodes = clonePartiallySelectedTextNodes;
	
	
	            if (!range.collapsed) {
	                this.sc = range.startContainer;
	                this.so = range.startOffset;
	                this.ec = range.endContainer;
	                this.eo = range.endOffset;
	                var root = range.commonAncestorContainer;
	
	                if (this.sc === this.ec && isCharacterDataNode(this.sc)) {
	                    this.isSingleCharacterDataNode = true;
	                    this._first = this._last = this._next = this.sc;
	                } else {
	                    this._first = this._next = (this.sc === root && !isCharacterDataNode(this.sc)) ?
	                        this.sc.childNodes[this.so] : getClosestAncestorIn(this.sc, root, true);
	                    this._last = (this.ec === root && !isCharacterDataNode(this.ec)) ?
	                        this.ec.childNodes[this.eo - 1] : getClosestAncestorIn(this.ec, root, true);
	                }
	            }
	        }
	
	        RangeIterator.prototype = {
	            _current: null,
	            _next: null,
	            _first: null,
	            _last: null,
	            isSingleCharacterDataNode: false,
	
	            reset: function() {
	                this._current = null;
	                this._next = this._first;
	            },
	
	            hasNext: function() {
	                return !!this._next;
	            },
	
	            next: function() {
	                // Move to next node
	                var current = this._current = this._next;
	                if (current) {
	                    this._next = (current !== this._last) ? current.nextSibling : null;
	
	                    // Check for partially selected text nodes
	                    if (isCharacterDataNode(current) && this.clonePartiallySelectedTextNodes) {
	                        if (current === this.ec) {
	                            (current = current.cloneNode(true)).deleteData(this.eo, current.length - this.eo);
	                        }
	                        if (this._current === this.sc) {
	                            (current = current.cloneNode(true)).deleteData(0, this.so);
	                        }
	                    }
	                }
	
	                return current;
	            },
	
	            remove: function() {
	                var current = this._current, start, end;
	
	                if (isCharacterDataNode(current) && (current === this.sc || current === this.ec)) {
	                    start = (current === this.sc) ? this.so : 0;
	                    end = (current === this.ec) ? this.eo : current.length;
	                    if (start != end) {
	                        current.deleteData(start, end - start);
	                    }
	                } else {
	                    if (current.parentNode) {
	                        removeNode(current);
	                    } else {
	                    }
	                }
	            },
	
	            // Checks if the current node is partially selected
	            isPartiallySelectedSubtree: function() {
	                var current = this._current;
	                return isNonTextPartiallySelected(current, this.range);
	            },
	
	            getSubtreeIterator: function() {
	                var subRange;
	                if (this.isSingleCharacterDataNode) {
	                    subRange = this.range.cloneRange();
	                    subRange.collapse(false);
	                } else {
	                    subRange = new Range(getRangeDocument(this.range));
	                    var current = this._current;
	                    var startContainer = current, startOffset = 0, endContainer = current, endOffset = getNodeLength(current);
	
	                    if (isOrIsAncestorOf(current, this.sc)) {
	                        startContainer = this.sc;
	                        startOffset = this.so;
	                    }
	                    if (isOrIsAncestorOf(current, this.ec)) {
	                        endContainer = this.ec;
	                        endOffset = this.eo;
	                    }
	
	                    updateBoundaries(subRange, startContainer, startOffset, endContainer, endOffset);
	                }
	                return new RangeIterator(subRange, this.clonePartiallySelectedTextNodes);
	            },
	
	            detach: function() {
	                this.range = this._current = this._next = this._first = this._last = this.sc = this.so = this.ec = this.eo = null;
	            }
	        };
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        var beforeAfterNodeTypes = [1, 3, 4, 5, 7, 8, 10];
	        var rootContainerNodeTypes = [2, 9, 11];
	        var readonlyNodeTypes = [5, 6, 10, 12];
	        var insertableNodeTypes = [1, 3, 4, 5, 7, 8, 10, 11];
	        var surroundNodeTypes = [1, 3, 4, 5, 7, 8];
	
	        function createAncestorFinder(nodeTypes) {
	            return function(node, selfIsAncestor) {
	                var t, n = selfIsAncestor ? node : node.parentNode;
	                while (n) {
	                    t = n.nodeType;
	                    if (arrayContains(nodeTypes, t)) {
	                        return n;
	                    }
	                    n = n.parentNode;
	                }
	                return null;
	            };
	        }
	
	        var getDocumentOrFragmentContainer = createAncestorFinder( [9, 11] );
	        var getReadonlyAncestor = createAncestorFinder(readonlyNodeTypes);
	        var getDocTypeNotationEntityAncestor = createAncestorFinder( [6, 10, 12] );
	        var getElementAncestor = createAncestorFinder( [1] );
	
	        function assertNoDocTypeNotationEntityAncestor(node, allowSelf) {
	            if (getDocTypeNotationEntityAncestor(node, allowSelf)) {
	                throw new DOMException("INVALID_NODE_TYPE_ERR");
	            }
	        }
	
	        function assertValidNodeType(node, invalidTypes) {
	            if (!arrayContains(invalidTypes, node.nodeType)) {
	                throw new DOMException("INVALID_NODE_TYPE_ERR");
	            }
	        }
	
	        function assertValidOffset(node, offset) {
	            if (offset < 0 || offset > (isCharacterDataNode(node) ? node.length : node.childNodes.length)) {
	                throw new DOMException("INDEX_SIZE_ERR");
	            }
	        }
	
	        function assertSameDocumentOrFragment(node1, node2) {
	            if (getDocumentOrFragmentContainer(node1, true) !== getDocumentOrFragmentContainer(node2, true)) {
	                throw new DOMException("WRONG_DOCUMENT_ERR");
	            }
	        }
	
	        function assertNodeNotReadOnly(node) {
	            if (getReadonlyAncestor(node, true)) {
	                throw new DOMException("NO_MODIFICATION_ALLOWED_ERR");
	            }
	        }
	
	        function assertNode(node, codeName) {
	            if (!node) {
	                throw new DOMException(codeName);
	            }
	        }
	
	        function isValidOffset(node, offset) {
	            return offset <= (isCharacterDataNode(node) ? node.length : node.childNodes.length);
	        }
	
	        function isRangeValid(range) {
	            return (!!range.startContainer && !!range.endContainer &&
	                    !(crashyTextNodes && (dom.isBrokenNode(range.startContainer) || dom.isBrokenNode(range.endContainer))) &&
	                    getRootContainer(range.startContainer) == getRootContainer(range.endContainer) &&
	                    isValidOffset(range.startContainer, range.startOffset) &&
	                    isValidOffset(range.endContainer, range.endOffset));
	        }
	
	        function assertRangeValid(range) {
	            if (!isRangeValid(range)) {
	                throw new Error("Range error: Range is not valid. This usually happens after DOM mutation. Range: (" + range.inspect() + ")");
	            }
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Test the browser's innerHTML support to decide how to implement createContextualFragment
	        var styleEl = document.createElement("style");
	        var htmlParsingConforms = false;
	        try {
	            styleEl.innerHTML = "<b>x</b>";
	            htmlParsingConforms = (styleEl.firstChild.nodeType == 3); // Pre-Blink Opera incorrectly creates an element node
	        } catch (e) {
	            // IE 6 and 7 throw
	        }
	
	        api.features.htmlParsingConforms = htmlParsingConforms;
	
	        var createContextualFragment = htmlParsingConforms ?
	
	            // Implementation as per HTML parsing spec, trusting in the browser's implementation of innerHTML. See
	            // discussion and base code for this implementation at issue 67.
	            // Spec: http://html5.org/specs/dom-parsing.html#extensions-to-the-range-interface
	            // Thanks to Aleks Williams.
	            function(fragmentStr) {
	                // "Let node the context object's start's node."
	                var node = this.startContainer;
	                var doc = getDocument(node);
	
	                // "If the context object's start's node is null, raise an INVALID_STATE_ERR
	                // exception and abort these steps."
	                if (!node) {
	                    throw new DOMException("INVALID_STATE_ERR");
	                }
	
	                // "Let element be as follows, depending on node's interface:"
	                // Document, Document Fragment: null
	                var el = null;
	
	                // "Element: node"
	                if (node.nodeType == 1) {
	                    el = node;
	
	                // "Text, Comment: node's parentElement"
	                } else if (isCharacterDataNode(node)) {
	                    el = dom.parentElement(node);
	                }
	
	                // "If either element is null or element's ownerDocument is an HTML document
	                // and element's local name is "html" and element's namespace is the HTML
	                // namespace"
	                if (el === null || (
	                    el.nodeName == "HTML" &&
	                    dom.isHtmlNamespace(getDocument(el).documentElement) &&
	                    dom.isHtmlNamespace(el)
	                )) {
	
	                // "let element be a new Element with "body" as its local name and the HTML
	                // namespace as its namespace.""
	                    el = doc.createElement("body");
	                } else {
	                    el = el.cloneNode(false);
	                }
	
	                // "If the node's document is an HTML document: Invoke the HTML fragment parsing algorithm."
	                // "If the node's document is an XML document: Invoke the XML fragment parsing algorithm."
	                // "In either case, the algorithm must be invoked with fragment as the input
	                // and element as the context element."
	                el.innerHTML = fragmentStr;
	
	                // "If this raises an exception, then abort these steps. Otherwise, let new
	                // children be the nodes returned."
	
	                // "Let fragment be a new DocumentFragment."
	                // "Append all new children to fragment."
	                // "Return fragment."
	                return dom.fragmentFromNodeChildren(el);
	            } :
	
	            // In this case, innerHTML cannot be trusted, so fall back to a simpler, non-conformant implementation that
	            // previous versions of Rangy used (with the exception of using a body element rather than a div)
	            function(fragmentStr) {
	                var doc = getRangeDocument(this);
	                var el = doc.createElement("body");
	                el.innerHTML = fragmentStr;
	
	                return dom.fragmentFromNodeChildren(el);
	            };
	
	        function splitRangeBoundaries(range, positionsToPreserve) {
	            assertRangeValid(range);
	
	            var sc = range.startContainer, so = range.startOffset, ec = range.endContainer, eo = range.endOffset;
	            var startEndSame = (sc === ec);
	
	            if (isCharacterDataNode(ec) && eo > 0 && eo < ec.length) {
	                splitDataNode(ec, eo, positionsToPreserve);
	            }
	
	            if (isCharacterDataNode(sc) && so > 0 && so < sc.length) {
	                sc = splitDataNode(sc, so, positionsToPreserve);
	                if (startEndSame) {
	                    eo -= so;
	                    ec = sc;
	                } else if (ec == sc.parentNode && eo >= getNodeIndex(sc)) {
	                    eo++;
	                }
	                so = 0;
	            }
	            range.setStartAndEnd(sc, so, ec, eo);
	        }
	
	        function rangeToHtml(range) {
	            assertRangeValid(range);
	            var container = range.commonAncestorContainer.parentNode.cloneNode(false);
	            container.appendChild( range.cloneContents() );
	            return container.innerHTML;
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        var rangeProperties = ["startContainer", "startOffset", "endContainer", "endOffset", "collapsed",
	            "commonAncestorContainer"];
	
	        var s2s = 0, s2e = 1, e2e = 2, e2s = 3;
	        var n_b = 0, n_a = 1, n_b_a = 2, n_i = 3;
	
	        util.extend(api.rangePrototype, {
	            compareBoundaryPoints: function(how, range) {
	                assertRangeValid(this);
	                assertSameDocumentOrFragment(this.startContainer, range.startContainer);
	
	                var nodeA, offsetA, nodeB, offsetB;
	                var prefixA = (how == e2s || how == s2s) ? "start" : "end";
	                var prefixB = (how == s2e || how == s2s) ? "start" : "end";
	                nodeA = this[prefixA + "Container"];
	                offsetA = this[prefixA + "Offset"];
	                nodeB = range[prefixB + "Container"];
	                offsetB = range[prefixB + "Offset"];
	                return comparePoints(nodeA, offsetA, nodeB, offsetB);
	            },
	
	            insertNode: function(node) {
	                assertRangeValid(this);
	                assertValidNodeType(node, insertableNodeTypes);
	                assertNodeNotReadOnly(this.startContainer);
	
	                if (isOrIsAncestorOf(node, this.startContainer)) {
	                    throw new DOMException("HIERARCHY_REQUEST_ERR");
	                }
	
	                // No check for whether the container of the start of the Range is of a type that does not allow
	                // children of the type of node: the browser's DOM implementation should do this for us when we attempt
	                // to add the node
	
	                var firstNodeInserted = insertNodeAtPosition(node, this.startContainer, this.startOffset);
	                this.setStartBefore(firstNodeInserted);
	            },
	
	            cloneContents: function() {
	                assertRangeValid(this);
	
	                var clone, frag;
	                if (this.collapsed) {
	                    return getRangeDocument(this).createDocumentFragment();
	                } else {
	                    if (this.startContainer === this.endContainer && isCharacterDataNode(this.startContainer)) {
	                        clone = this.startContainer.cloneNode(true);
	                        clone.data = clone.data.slice(this.startOffset, this.endOffset);
	                        frag = getRangeDocument(this).createDocumentFragment();
	                        frag.appendChild(clone);
	                        return frag;
	                    } else {
	                        var iterator = new RangeIterator(this, true);
	                        clone = cloneSubtree(iterator);
	                        iterator.detach();
	                    }
	                    return clone;
	                }
	            },
	
	            canSurroundContents: function() {
	                assertRangeValid(this);
	                assertNodeNotReadOnly(this.startContainer);
	                assertNodeNotReadOnly(this.endContainer);
	
	                // Check if the contents can be surrounded. Specifically, this means whether the range partially selects
	                // no non-text nodes.
	                var iterator = new RangeIterator(this, true);
	                var boundariesInvalid = (iterator._first && (isNonTextPartiallySelected(iterator._first, this)) ||
	                        (iterator._last && isNonTextPartiallySelected(iterator._last, this)));
	                iterator.detach();
	                return !boundariesInvalid;
	            },
	
	            surroundContents: function(node) {
	                assertValidNodeType(node, surroundNodeTypes);
	
	                if (!this.canSurroundContents()) {
	                    throw new DOMException("INVALID_STATE_ERR");
	                }
	
	                // Extract the contents
	                var content = this.extractContents();
	
	                // Clear the children of the node
	                if (node.hasChildNodes()) {
	                    while (node.lastChild) {
	                        node.removeChild(node.lastChild);
	                    }
	                }
	
	                // Insert the new node and add the extracted contents
	                insertNodeAtPosition(node, this.startContainer, this.startOffset);
	                node.appendChild(content);
	
	                this.selectNode(node);
	            },
	
	            cloneRange: function() {
	                assertRangeValid(this);
	                var range = new Range(getRangeDocument(this));
	                var i = rangeProperties.length, prop;
	                while (i--) {
	                    prop = rangeProperties[i];
	                    range[prop] = this[prop];
	                }
	                return range;
	            },
	
	            toString: function() {
	                assertRangeValid(this);
	                var sc = this.startContainer;
	                if (sc === this.endContainer && isCharacterDataNode(sc)) {
	                    return (sc.nodeType == 3 || sc.nodeType == 4) ? sc.data.slice(this.startOffset, this.endOffset) : "";
	                } else {
	                    var textParts = [], iterator = new RangeIterator(this, true);
	                    iterateSubtree(iterator, function(node) {
	                        // Accept only text or CDATA nodes, not comments
	                        if (node.nodeType == 3 || node.nodeType == 4) {
	                            textParts.push(node.data);
	                        }
	                    });
	                    iterator.detach();
	                    return textParts.join("");
	                }
	            },
	
	            // The methods below are all non-standard. The following batch were introduced by Mozilla but have since
	            // been removed from Mozilla.
	
	            compareNode: function(node) {
	                assertRangeValid(this);
	
	                var parent = node.parentNode;
	                var nodeIndex = getNodeIndex(node);
	
	                if (!parent) {
	                    throw new DOMException("NOT_FOUND_ERR");
	                }
	
	                var startComparison = this.comparePoint(parent, nodeIndex),
	                    endComparison = this.comparePoint(parent, nodeIndex + 1);
	
	                if (startComparison < 0) { // Node starts before
	                    return (endComparison > 0) ? n_b_a : n_b;
	                } else {
	                    return (endComparison > 0) ? n_a : n_i;
	                }
	            },
	
	            comparePoint: function(node, offset) {
	                assertRangeValid(this);
	                assertNode(node, "HIERARCHY_REQUEST_ERR");
	                assertSameDocumentOrFragment(node, this.startContainer);
	
	                if (comparePoints(node, offset, this.startContainer, this.startOffset) < 0) {
	                    return -1;
	                } else if (comparePoints(node, offset, this.endContainer, this.endOffset) > 0) {
	                    return 1;
	                }
	                return 0;
	            },
	
	            createContextualFragment: createContextualFragment,
	
	            toHtml: function() {
	                return rangeToHtml(this);
	            },
	
	            // touchingIsIntersecting determines whether this method considers a node that borders a range intersects
	            // with it (as in WebKit) or not (as in Gecko pre-1.9, and the default)
	            intersectsNode: function(node, touchingIsIntersecting) {
	                assertRangeValid(this);
	                if (getRootContainer(node) != getRangeRoot(this)) {
	                    return false;
	                }
	
	                var parent = node.parentNode, offset = getNodeIndex(node);
	                if (!parent) {
	                    return true;
	                }
	
	                var startComparison = comparePoints(parent, offset, this.endContainer, this.endOffset),
	                    endComparison = comparePoints(parent, offset + 1, this.startContainer, this.startOffset);
	
	                return touchingIsIntersecting ? startComparison <= 0 && endComparison >= 0 : startComparison < 0 && endComparison > 0;
	            },
	
	            isPointInRange: function(node, offset) {
	                assertRangeValid(this);
	                assertNode(node, "HIERARCHY_REQUEST_ERR");
	                assertSameDocumentOrFragment(node, this.startContainer);
	
	                return (comparePoints(node, offset, this.startContainer, this.startOffset) >= 0) &&
	                       (comparePoints(node, offset, this.endContainer, this.endOffset) <= 0);
	            },
	
	            // The methods below are non-standard and invented by me.
	
	            // Sharing a boundary start-to-end or end-to-start does not count as intersection.
	            intersectsRange: function(range) {
	                return rangesIntersect(this, range, false);
	            },
	
	            // Sharing a boundary start-to-end or end-to-start does count as intersection.
	            intersectsOrTouchesRange: function(range) {
	                return rangesIntersect(this, range, true);
	            },
	
	            intersection: function(range) {
	                if (this.intersectsRange(range)) {
	                    var startComparison = comparePoints(this.startContainer, this.startOffset, range.startContainer, range.startOffset),
	                        endComparison = comparePoints(this.endContainer, this.endOffset, range.endContainer, range.endOffset);
	
	                    var intersectionRange = this.cloneRange();
	                    if (startComparison == -1) {
	                        intersectionRange.setStart(range.startContainer, range.startOffset);
	                    }
	                    if (endComparison == 1) {
	                        intersectionRange.setEnd(range.endContainer, range.endOffset);
	                    }
	                    return intersectionRange;
	                }
	                return null;
	            },
	
	            union: function(range) {
	                if (this.intersectsOrTouchesRange(range)) {
	                    var unionRange = this.cloneRange();
	                    if (comparePoints(range.startContainer, range.startOffset, this.startContainer, this.startOffset) == -1) {
	                        unionRange.setStart(range.startContainer, range.startOffset);
	                    }
	                    if (comparePoints(range.endContainer, range.endOffset, this.endContainer, this.endOffset) == 1) {
	                        unionRange.setEnd(range.endContainer, range.endOffset);
	                    }
	                    return unionRange;
	                } else {
	                    throw new DOMException("Ranges do not intersect");
	                }
	            },
	
	            containsNode: function(node, allowPartial) {
	                if (allowPartial) {
	                    return this.intersectsNode(node, false);
	                } else {
	                    return this.compareNode(node) == n_i;
	                }
	            },
	
	            containsNodeContents: function(node) {
	                return this.comparePoint(node, 0) >= 0 && this.comparePoint(node, getNodeLength(node)) <= 0;
	            },
	
	            containsRange: function(range) {
	                var intersection = this.intersection(range);
	                return intersection !== null && range.equals(intersection);
	            },
	
	            containsNodeText: function(node) {
	                var nodeRange = this.cloneRange();
	                nodeRange.selectNode(node);
	                var textNodes = nodeRange.getNodes([3]);
	                if (textNodes.length > 0) {
	                    nodeRange.setStart(textNodes[0], 0);
	                    var lastTextNode = textNodes.pop();
	                    nodeRange.setEnd(lastTextNode, lastTextNode.length);
	                    return this.containsRange(nodeRange);
	                } else {
	                    return this.containsNodeContents(node);
	                }
	            },
	
	            getNodes: function(nodeTypes, filter) {
	                assertRangeValid(this);
	                return getNodesInRange(this, nodeTypes, filter);
	            },
	
	            getDocument: function() {
	                return getRangeDocument(this);
	            },
	
	            collapseBefore: function(node) {
	                this.setEndBefore(node);
	                this.collapse(false);
	            },
	
	            collapseAfter: function(node) {
	                this.setStartAfter(node);
	                this.collapse(true);
	            },
	
	            getBookmark: function(containerNode) {
	                var doc = getRangeDocument(this);
	                var preSelectionRange = api.createRange(doc);
	                containerNode = containerNode || dom.getBody(doc);
	                preSelectionRange.selectNodeContents(containerNode);
	                var range = this.intersection(preSelectionRange);
	                var start = 0, end = 0;
	                if (range) {
	                    preSelectionRange.setEnd(range.startContainer, range.startOffset);
	                    start = preSelectionRange.toString().length;
	                    end = start + range.toString().length;
	                }
	
	                return {
	                    start: start,
	                    end: end,
	                    containerNode: containerNode
	                };
	            },
	
	            moveToBookmark: function(bookmark) {
	                var containerNode = bookmark.containerNode;
	                var charIndex = 0;
	                this.setStart(containerNode, 0);
	                this.collapse(true);
	                var nodeStack = [containerNode], node, foundStart = false, stop = false;
	                var nextCharIndex, i, childNodes;
	
	                while (!stop && (node = nodeStack.pop())) {
	                    if (node.nodeType == 3) {
	                        nextCharIndex = charIndex + node.length;
	                        if (!foundStart && bookmark.start >= charIndex && bookmark.start <= nextCharIndex) {
	                            this.setStart(node, bookmark.start - charIndex);
	                            foundStart = true;
	                        }
	                        if (foundStart && bookmark.end >= charIndex && bookmark.end <= nextCharIndex) {
	                            this.setEnd(node, bookmark.end - charIndex);
	                            stop = true;
	                        }
	                        charIndex = nextCharIndex;
	                    } else {
	                        childNodes = node.childNodes;
	                        i = childNodes.length;
	                        while (i--) {
	                            nodeStack.push(childNodes[i]);
	                        }
	                    }
	                }
	            },
	
	            getName: function() {
	                return "DomRange";
	            },
	
	            equals: function(range) {
	                return Range.rangesEqual(this, range);
	            },
	
	            isValid: function() {
	                return isRangeValid(this);
	            },
	
	            inspect: function() {
	                return inspect(this);
	            },
	
	            detach: function() {
	                // In DOM4, detach() is now a no-op.
	            }
	        });
	
	        function copyComparisonConstantsToObject(obj) {
	            obj.START_TO_START = s2s;
	            obj.START_TO_END = s2e;
	            obj.END_TO_END = e2e;
	            obj.END_TO_START = e2s;
	
	            obj.NODE_BEFORE = n_b;
	            obj.NODE_AFTER = n_a;
	            obj.NODE_BEFORE_AND_AFTER = n_b_a;
	            obj.NODE_INSIDE = n_i;
	        }
	
	        function copyComparisonConstants(constructor) {
	            copyComparisonConstantsToObject(constructor);
	            copyComparisonConstantsToObject(constructor.prototype);
	        }
	
	        function createRangeContentRemover(remover, boundaryUpdater) {
	            return function() {
	                assertRangeValid(this);
	
	                var sc = this.startContainer, so = this.startOffset, root = this.commonAncestorContainer;
	
	                var iterator = new RangeIterator(this, true);
	
	                // Work out where to position the range after content removal
	                var node, boundary;
	                if (sc !== root) {
	                    node = getClosestAncestorIn(sc, root, true);
	                    boundary = getBoundaryAfterNode(node);
	                    sc = boundary.node;
	                    so = boundary.offset;
	                }
	
	                // Check none of the range is read-only
	                iterateSubtree(iterator, assertNodeNotReadOnly);
	
	                iterator.reset();
	
	                // Remove the content
	                var returnValue = remover(iterator);
	                iterator.detach();
	
	                // Move to the new position
	                boundaryUpdater(this, sc, so, sc, so);
	
	                return returnValue;
	            };
	        }
	
	        function createPrototypeRange(constructor, boundaryUpdater) {
	            function createBeforeAfterNodeSetter(isBefore, isStart) {
	                return function(node) {
	                    assertValidNodeType(node, beforeAfterNodeTypes);
	                    assertValidNodeType(getRootContainer(node), rootContainerNodeTypes);
	
	                    var boundary = (isBefore ? getBoundaryBeforeNode : getBoundaryAfterNode)(node);
	                    (isStart ? setRangeStart : setRangeEnd)(this, boundary.node, boundary.offset);
	                };
	            }
	
	            function setRangeStart(range, node, offset) {
	                var ec = range.endContainer, eo = range.endOffset;
	                if (node !== range.startContainer || offset !== range.startOffset) {
	                    // Check the root containers of the range and the new boundary, and also check whether the new boundary
	                    // is after the current end. In either case, collapse the range to the new position
	                    if (getRootContainer(node) != getRootContainer(ec) || comparePoints(node, offset, ec, eo) == 1) {
	                        ec = node;
	                        eo = offset;
	                    }
	                    boundaryUpdater(range, node, offset, ec, eo);
	                }
	            }
	
	            function setRangeEnd(range, node, offset) {
	                var sc = range.startContainer, so = range.startOffset;
	                if (node !== range.endContainer || offset !== range.endOffset) {
	                    // Check the root containers of the range and the new boundary, and also check whether the new boundary
	                    // is after the current end. In either case, collapse the range to the new position
	                    if (getRootContainer(node) != getRootContainer(sc) || comparePoints(node, offset, sc, so) == -1) {
	                        sc = node;
	                        so = offset;
	                    }
	                    boundaryUpdater(range, sc, so, node, offset);
	                }
	            }
	
	            // Set up inheritance
	            var F = function() {};
	            F.prototype = api.rangePrototype;
	            constructor.prototype = new F();
	
	            util.extend(constructor.prototype, {
	                setStart: function(node, offset) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	                    assertValidOffset(node, offset);
	
	                    setRangeStart(this, node, offset);
	                },
	
	                setEnd: function(node, offset) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	                    assertValidOffset(node, offset);
	
	                    setRangeEnd(this, node, offset);
	                },
	
	                /**
	                 * Convenience method to set a range's start and end boundaries. Overloaded as follows:
	                 * - Two parameters (node, offset) creates a collapsed range at that position
	                 * - Three parameters (node, startOffset, endOffset) creates a range contained with node starting at
	                 *   startOffset and ending at endOffset
	                 * - Four parameters (startNode, startOffset, endNode, endOffset) creates a range starting at startOffset in
	                 *   startNode and ending at endOffset in endNode
	                 */
	                setStartAndEnd: function() {
	                    var args = arguments;
	                    var sc = args[0], so = args[1], ec = sc, eo = so;
	
	                    switch (args.length) {
	                        case 3:
	                            eo = args[2];
	                            break;
	                        case 4:
	                            ec = args[2];
	                            eo = args[3];
	                            break;
	                    }
	
	                    assertNoDocTypeNotationEntityAncestor(sc, true);
	                    assertValidOffset(sc, so);
	
	                    assertNoDocTypeNotationEntityAncestor(ec, true);
	                    assertValidOffset(ec, eo);
	
	                    boundaryUpdater(this, sc, so, ec, eo);
	                },
	
	                setBoundary: function(node, offset, isStart) {
	                    this["set" + (isStart ? "Start" : "End")](node, offset);
	                },
	
	                setStartBefore: createBeforeAfterNodeSetter(true, true),
	                setStartAfter: createBeforeAfterNodeSetter(false, true),
	                setEndBefore: createBeforeAfterNodeSetter(true, false),
	                setEndAfter: createBeforeAfterNodeSetter(false, false),
	
	                collapse: function(isStart) {
	                    assertRangeValid(this);
	                    if (isStart) {
	                        boundaryUpdater(this, this.startContainer, this.startOffset, this.startContainer, this.startOffset);
	                    } else {
	                        boundaryUpdater(this, this.endContainer, this.endOffset, this.endContainer, this.endOffset);
	                    }
	                },
	
	                selectNodeContents: function(node) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	
	                    boundaryUpdater(this, node, 0, node, getNodeLength(node));
	                },
	
	                selectNode: function(node) {
	                    assertNoDocTypeNotationEntityAncestor(node, false);
	                    assertValidNodeType(node, beforeAfterNodeTypes);
	
	                    var start = getBoundaryBeforeNode(node), end = getBoundaryAfterNode(node);
	                    boundaryUpdater(this, start.node, start.offset, end.node, end.offset);
	                },
	
	                extractContents: createRangeContentRemover(extractSubtree, boundaryUpdater),
	
	                deleteContents: createRangeContentRemover(deleteSubtree, boundaryUpdater),
	
	                canSurroundContents: function() {
	                    assertRangeValid(this);
	                    assertNodeNotReadOnly(this.startContainer);
	                    assertNodeNotReadOnly(this.endContainer);
	
	                    // Check if the contents can be surrounded. Specifically, this means whether the range partially selects
	                    // no non-text nodes.
	                    var iterator = new RangeIterator(this, true);
	                    var boundariesInvalid = (iterator._first && isNonTextPartiallySelected(iterator._first, this) ||
	                            (iterator._last && isNonTextPartiallySelected(iterator._last, this)));
	                    iterator.detach();
	                    return !boundariesInvalid;
	                },
	
	                splitBoundaries: function() {
	                    splitRangeBoundaries(this);
	                },
	
	                splitBoundariesPreservingPositions: function(positionsToPreserve) {
	                    splitRangeBoundaries(this, positionsToPreserve);
	                },
	
	                normalizeBoundaries: function() {
	                    assertRangeValid(this);
	
	                    var sc = this.startContainer, so = this.startOffset, ec = this.endContainer, eo = this.endOffset;
	
	                    var mergeForward = function(node) {
	                        var sibling = node.nextSibling;
	                        if (sibling && sibling.nodeType == node.nodeType) {
	                            ec = node;
	                            eo = node.length;
	                            node.appendData(sibling.data);
	                            removeNode(sibling);
	                        }
	                    };
	
	                    var mergeBackward = function(node) {
	                        var sibling = node.previousSibling;
	                        if (sibling && sibling.nodeType == node.nodeType) {
	                            sc = node;
	                            var nodeLength = node.length;
	                            so = sibling.length;
	                            node.insertData(0, sibling.data);
	                            removeNode(sibling);
	                            if (sc == ec) {
	                                eo += so;
	                                ec = sc;
	                            } else if (ec == node.parentNode) {
	                                var nodeIndex = getNodeIndex(node);
	                                if (eo == nodeIndex) {
	                                    ec = node;
	                                    eo = nodeLength;
	                                } else if (eo > nodeIndex) {
	                                    eo--;
	                                }
	                            }
	                        }
	                    };
	
	                    var normalizeStart = true;
	                    var sibling;
	
	                    if (isCharacterDataNode(ec)) {
	                        if (eo == ec.length) {
	                            mergeForward(ec);
	                        } else if (eo == 0) {
	                            sibling = ec.previousSibling;
	                            if (sibling && sibling.nodeType == ec.nodeType) {
	                                eo = sibling.length;
	                                if (sc == ec) {
	                                    normalizeStart = false;
	                                }
	                                sibling.appendData(ec.data);
	                                removeNode(ec);
	                                ec = sibling;
	                            }
	                        }
	                    } else {
	                        if (eo > 0) {
	                            var endNode = ec.childNodes[eo - 1];
	                            if (endNode && isCharacterDataNode(endNode)) {
	                                mergeForward(endNode);
	                            }
	                        }
	                        normalizeStart = !this.collapsed;
	                    }
	
	                    if (normalizeStart) {
	                        if (isCharacterDataNode(sc)) {
	                            if (so == 0) {
	                                mergeBackward(sc);
	                            } else if (so == sc.length) {
	                                sibling = sc.nextSibling;
	                                if (sibling && sibling.nodeType == sc.nodeType) {
	                                    if (ec == sibling) {
	                                        ec = sc;
	                                        eo += sc.length;
	                                    }
	                                    sc.appendData(sibling.data);
	                                    removeNode(sibling);
	                                }
	                            }
	                        } else {
	                            if (so < sc.childNodes.length) {
	                                var startNode = sc.childNodes[so];
	                                if (startNode && isCharacterDataNode(startNode)) {
	                                    mergeBackward(startNode);
	                                }
	                            }
	                        }
	                    } else {
	                        sc = ec;
	                        so = eo;
	                    }
	
	                    boundaryUpdater(this, sc, so, ec, eo);
	                },
	
	                collapseToPoint: function(node, offset) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	                    assertValidOffset(node, offset);
	                    this.setStartAndEnd(node, offset);
	                },
	
	                parentElement: function() {
	                    assertRangeValid(this);
	                    var parentNode = this.commonAncestorContainer;
	                    return parentNode ? getElementAncestor(this.commonAncestorContainer, true) : null;
	                }
	            });
	
	            copyComparisonConstants(constructor);
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Updates commonAncestorContainer and collapsed after boundary change
	        function updateCollapsedAndCommonAncestor(range) {
	            range.collapsed = (range.startContainer === range.endContainer && range.startOffset === range.endOffset);
	            range.commonAncestorContainer = range.collapsed ?
	                range.startContainer : dom.getCommonAncestor(range.startContainer, range.endContainer);
	        }
	
	        function updateBoundaries(range, startContainer, startOffset, endContainer, endOffset) {
	            range.startContainer = startContainer;
	            range.startOffset = startOffset;
	            range.endContainer = endContainer;
	            range.endOffset = endOffset;
	            range.document = dom.getDocument(startContainer);
	            updateCollapsedAndCommonAncestor(range);
	        }
	
	        function Range(doc) {
	            updateBoundaries(this, doc, 0, doc, 0);
	        }
	
	        createPrototypeRange(Range, updateBoundaries);
	
	        util.extend(Range, {
	            rangeProperties: rangeProperties,
	            RangeIterator: RangeIterator,
	            copyComparisonConstants: copyComparisonConstants,
	            createPrototypeRange: createPrototypeRange,
	            inspect: inspect,
	            toHtml: rangeToHtml,
	            getRangeDocument: getRangeDocument,
	            rangesEqual: function(r1, r2) {
	                return r1.startContainer === r2.startContainer &&
	                    r1.startOffset === r2.startOffset &&
	                    r1.endContainer === r2.endContainer &&
	                    r1.endOffset === r2.endOffset;
	            }
	        });
	
	        api.DomRange = Range;
	    });
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Wrappers for the browser's native DOM Range and/or TextRange implementation
	    api.createCoreModule("WrappedRange", ["DomRange"], function(api, module) {
	        var WrappedRange, WrappedTextRange;
	        var dom = api.dom;
	        var util = api.util;
	        var DomPosition = dom.DomPosition;
	        var DomRange = api.DomRange;
	        var getBody = dom.getBody;
	        var getContentDocument = dom.getContentDocument;
	        var isCharacterDataNode = dom.isCharacterDataNode;
	
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        if (api.features.implementsDomRange) {
	            // This is a wrapper around the browser's native DOM Range. It has two aims:
	            // - Provide workarounds for specific browser bugs
	            // - provide convenient extensions, which are inherited from Rangy's DomRange
	
	            (function() {
	                var rangeProto;
	                var rangeProperties = DomRange.rangeProperties;
	
	                function updateRangeProperties(range) {
	                    var i = rangeProperties.length, prop;
	                    while (i--) {
	                        prop = rangeProperties[i];
	                        range[prop] = range.nativeRange[prop];
	                    }
	                    // Fix for broken collapsed property in IE 9.
	                    range.collapsed = (range.startContainer === range.endContainer && range.startOffset === range.endOffset);
	                }
	
	                function updateNativeRange(range, startContainer, startOffset, endContainer, endOffset) {
	                    var startMoved = (range.startContainer !== startContainer || range.startOffset != startOffset);
	                    var endMoved = (range.endContainer !== endContainer || range.endOffset != endOffset);
	                    var nativeRangeDifferent = !range.equals(range.nativeRange);
	
	                    // Always set both boundaries for the benefit of IE9 (see issue 35)
	                    if (startMoved || endMoved || nativeRangeDifferent) {
	                        range.setEnd(endContainer, endOffset);
	                        range.setStart(startContainer, startOffset);
	                    }
	                }
	
	                var createBeforeAfterNodeSetter;
	
	                WrappedRange = function(range) {
	                    if (!range) {
	                        throw module.createError("WrappedRange: Range must be specified");
	                    }
	                    this.nativeRange = range;
	                    updateRangeProperties(this);
	                };
	
	                DomRange.createPrototypeRange(WrappedRange, updateNativeRange);
	
	                rangeProto = WrappedRange.prototype;
	
	                rangeProto.selectNode = function(node) {
	                    this.nativeRange.selectNode(node);
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.cloneContents = function() {
	                    return this.nativeRange.cloneContents();
	                };
	
	                // Due to a long-standing Firefox bug that I have not been able to find a reliable way to detect,
	                // insertNode() is never delegated to the native range.
	
	                rangeProto.surroundContents = function(node) {
	                    this.nativeRange.surroundContents(node);
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.collapse = function(isStart) {
	                    this.nativeRange.collapse(isStart);
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.cloneRange = function() {
	                    return new WrappedRange(this.nativeRange.cloneRange());
	                };
	
	                rangeProto.refresh = function() {
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.toString = function() {
	                    return this.nativeRange.toString();
	                };
	
	                // Create test range and node for feature detection
	
	                var testTextNode = document.createTextNode("test");
	                getBody(document).appendChild(testTextNode);
	                var range = document.createRange();
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for Firefox 2 bug that prevents moving the start of a Range to a point after its current end and
	                // correct for it
	
	                range.setStart(testTextNode, 0);
	                range.setEnd(testTextNode, 0);
	
	                try {
	                    range.setStart(testTextNode, 1);
	
	                    rangeProto.setStart = function(node, offset) {
	                        this.nativeRange.setStart(node, offset);
	                        updateRangeProperties(this);
	                    };
	
	                    rangeProto.setEnd = function(node, offset) {
	                        this.nativeRange.setEnd(node, offset);
	                        updateRangeProperties(this);
	                    };
	
	                    createBeforeAfterNodeSetter = function(name) {
	                        return function(node) {
	                            this.nativeRange[name](node);
	                            updateRangeProperties(this);
	                        };
	                    };
	
	                } catch(ex) {
	
	                    rangeProto.setStart = function(node, offset) {
	                        try {
	                            this.nativeRange.setStart(node, offset);
	                        } catch (ex) {
	                            this.nativeRange.setEnd(node, offset);
	                            this.nativeRange.setStart(node, offset);
	                        }
	                        updateRangeProperties(this);
	                    };
	
	                    rangeProto.setEnd = function(node, offset) {
	                        try {
	                            this.nativeRange.setEnd(node, offset);
	                        } catch (ex) {
	                            this.nativeRange.setStart(node, offset);
	                            this.nativeRange.setEnd(node, offset);
	                        }
	                        updateRangeProperties(this);
	                    };
	
	                    createBeforeAfterNodeSetter = function(name, oppositeName) {
	                        return function(node) {
	                            try {
	                                this.nativeRange[name](node);
	                            } catch (ex) {
	                                this.nativeRange[oppositeName](node);
	                                this.nativeRange[name](node);
	                            }
	                            updateRangeProperties(this);
	                        };
	                    };
	                }
	
	                rangeProto.setStartBefore = createBeforeAfterNodeSetter("setStartBefore", "setEndBefore");
	                rangeProto.setStartAfter = createBeforeAfterNodeSetter("setStartAfter", "setEndAfter");
	                rangeProto.setEndBefore = createBeforeAfterNodeSetter("setEndBefore", "setStartBefore");
	                rangeProto.setEndAfter = createBeforeAfterNodeSetter("setEndAfter", "setStartAfter");
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Always use DOM4-compliant selectNodeContents implementation: it's simpler and less code than testing
	                // whether the native implementation can be trusted
	                rangeProto.selectNodeContents = function(node) {
	                    this.setStartAndEnd(node, 0, dom.getNodeLength(node));
	                };
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for and correct WebKit bug that has the behaviour of compareBoundaryPoints round the wrong way for
	                // constants START_TO_END and END_TO_START: https://bugs.webkit.org/show_bug.cgi?id=20738
	
	                range.selectNodeContents(testTextNode);
	                range.setEnd(testTextNode, 3);
	
	                var range2 = document.createRange();
	                range2.selectNodeContents(testTextNode);
	                range2.setEnd(testTextNode, 4);
	                range2.setStart(testTextNode, 2);
	
	                if (range.compareBoundaryPoints(range.START_TO_END, range2) == -1 &&
	                        range.compareBoundaryPoints(range.END_TO_START, range2) == 1) {
	                    // This is the wrong way round, so correct for it
	
	                    rangeProto.compareBoundaryPoints = function(type, range) {
	                        range = range.nativeRange || range;
	                        if (type == range.START_TO_END) {
	                            type = range.END_TO_START;
	                        } else if (type == range.END_TO_START) {
	                            type = range.START_TO_END;
	                        }
	                        return this.nativeRange.compareBoundaryPoints(type, range);
	                    };
	                } else {
	                    rangeProto.compareBoundaryPoints = function(type, range) {
	                        return this.nativeRange.compareBoundaryPoints(type, range.nativeRange || range);
	                    };
	                }
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for IE deleteContents() and extractContents() bug and correct it. See issue 107.
	
	                var el = document.createElement("div");
	                el.innerHTML = "123";
	                var textNode = el.firstChild;
	                var body = getBody(document);
	                body.appendChild(el);
	
	                range.setStart(textNode, 1);
	                range.setEnd(textNode, 2);
	                range.deleteContents();
	
	                if (textNode.data == "13") {
	                    // Behaviour is correct per DOM4 Range so wrap the browser's implementation of deleteContents() and
	                    // extractContents()
	                    rangeProto.deleteContents = function() {
	                        this.nativeRange.deleteContents();
	                        updateRangeProperties(this);
	                    };
	
	                    rangeProto.extractContents = function() {
	                        var frag = this.nativeRange.extractContents();
	                        updateRangeProperties(this);
	                        return frag;
	                    };
	                } else {
	                }
	
	                body.removeChild(el);
	                body = null;
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for existence of createContextualFragment and delegate to it if it exists
	                if (util.isHostMethod(range, "createContextualFragment")) {
	                    rangeProto.createContextualFragment = function(fragmentStr) {
	                        return this.nativeRange.createContextualFragment(fragmentStr);
	                    };
	                }
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Clean up
	                getBody(document).removeChild(testTextNode);
	
	                rangeProto.getName = function() {
	                    return "WrappedRange";
	                };
	
	                api.WrappedRange = WrappedRange;
	
	                api.createNativeRange = function(doc) {
	                    doc = getContentDocument(doc, module, "createNativeRange");
	                    return doc.createRange();
	                };
	            })();
	        }
	
	        if (api.features.implementsTextRange) {
	            /*
	            This is a workaround for a bug where IE returns the wrong container element from the TextRange's parentElement()
	            method. For example, in the following (where pipes denote the selection boundaries):
	
	            <ul id="ul"><li id="a">| a </li><li id="b"> b |</li></ul>
	
	            var range = document.selection.createRange();
	            alert(range.parentElement().id); // Should alert "ul" but alerts "b"
	
	            This method returns the common ancestor node of the following:
	            - the parentElement() of the textRange
	            - the parentElement() of the textRange after calling collapse(true)
	            - the parentElement() of the textRange after calling collapse(false)
	            */
	            var getTextRangeContainerElement = function(textRange) {
	                var parentEl = textRange.parentElement();
	                var range = textRange.duplicate();
	                range.collapse(true);
	                var startEl = range.parentElement();
	                range = textRange.duplicate();
	                range.collapse(false);
	                var endEl = range.parentElement();
	                var startEndContainer = (startEl == endEl) ? startEl : dom.getCommonAncestor(startEl, endEl);
	
	                return startEndContainer == parentEl ? startEndContainer : dom.getCommonAncestor(parentEl, startEndContainer);
	            };
	
	            var textRangeIsCollapsed = function(textRange) {
	                return textRange.compareEndPoints("StartToEnd", textRange) == 0;
	            };
	
	            // Gets the boundary of a TextRange expressed as a node and an offset within that node. This function started
	            // out as an improved version of code found in Tim Cameron Ryan's IERange (http://code.google.com/p/ierange/)
	            // but has grown, fixing problems with line breaks in preformatted text, adding workaround for IE TextRange
	            // bugs, handling for inputs and images, plus optimizations.
	            var getTextRangeBoundaryPosition = function(textRange, wholeRangeContainerElement, isStart, isCollapsed, startInfo) {
	                var workingRange = textRange.duplicate();
	                workingRange.collapse(isStart);
	                var containerElement = workingRange.parentElement();
	
	                // Sometimes collapsing a TextRange that's at the start of a text node can move it into the previous node, so
	                // check for that
	                if (!dom.isOrIsAncestorOf(wholeRangeContainerElement, containerElement)) {
	                    containerElement = wholeRangeContainerElement;
	                }
	
	
	                // Deal with nodes that cannot "contain rich HTML markup". In practice, this means form inputs, images and
	                // similar. See http://msdn.microsoft.com/en-us/library/aa703950%28VS.85%29.aspx
	                if (!containerElement.canHaveHTML) {
	                    var pos = new DomPosition(containerElement.parentNode, dom.getNodeIndex(containerElement));
	                    return {
	                        boundaryPosition: pos,
	                        nodeInfo: {
	                            nodeIndex: pos.offset,
	                            containerElement: pos.node
	                        }
	                    };
	                }
	
	                var workingNode = dom.getDocument(containerElement).createElement("span");
	
	                // Workaround for HTML5 Shiv's insane violation of document.createElement(). See Rangy issue 104 and HTML5
	                // Shiv issue 64: https://github.com/aFarkas/html5shiv/issues/64
	                if (workingNode.parentNode) {
	                    dom.removeNode(workingNode);
	                }
	
	                var comparison, workingComparisonType = isStart ? "StartToStart" : "StartToEnd";
	                var previousNode, nextNode, boundaryPosition, boundaryNode;
	                var start = (startInfo && startInfo.containerElement == containerElement) ? startInfo.nodeIndex : 0;
	                var childNodeCount = containerElement.childNodes.length;
	                var end = childNodeCount;
	
	                // Check end first. Code within the loop assumes that the endth child node of the container is definitely
	                // after the range boundary.
	                var nodeIndex = end;
	
	                while (true) {
	                    if (nodeIndex == childNodeCount) {
	                        containerElement.appendChild(workingNode);
	                    } else {
	                        containerElement.insertBefore(workingNode, containerElement.childNodes[nodeIndex]);
	                    }
	                    workingRange.moveToElementText(workingNode);
	                    comparison = workingRange.compareEndPoints(workingComparisonType, textRange);
	                    if (comparison == 0 || start == end) {
	                        break;
	                    } else if (comparison == -1) {
	                        if (end == start + 1) {
	                            // We know the endth child node is after the range boundary, so we must be done.
	                            break;
	                        } else {
	                            start = nodeIndex;
	                        }
	                    } else {
	                        end = (end == start + 1) ? start : nodeIndex;
	                    }
	                    nodeIndex = Math.floor((start + end) / 2);
	                    containerElement.removeChild(workingNode);
	                }
	
	
	                // We've now reached or gone past the boundary of the text range we're interested in
	                // so have identified the node we want
	                boundaryNode = workingNode.nextSibling;
	
	                if (comparison == -1 && boundaryNode && isCharacterDataNode(boundaryNode)) {
	                    // This is a character data node (text, comment, cdata). The working range is collapsed at the start of
	                    // the node containing the text range's boundary, so we move the end of the working range to the
	                    // boundary point and measure the length of its text to get the boundary's offset within the node.
	                    workingRange.setEndPoint(isStart ? "EndToStart" : "EndToEnd", textRange);
	
	                    var offset;
	
	                    if (/[\r\n]/.test(boundaryNode.data)) {
	                        /*
	                        For the particular case of a boundary within a text node containing rendered line breaks (within a
	                        <pre> element, for example), we need a slightly complicated approach to get the boundary's offset in
	                        IE. The facts:
	
	                        - Each line break is represented as \r in the text node's data/nodeValue properties
	                        - Each line break is represented as \r\n in the TextRange's 'text' property
	                        - The 'text' property of the TextRange does not contain trailing line breaks
	
	                        To get round the problem presented by the final fact above, we can use the fact that TextRange's
	                        moveStart() and moveEnd() methods return the actual number of characters moved, which is not
	                        necessarily the same as the number of characters it was instructed to move. The simplest approach is
	                        to use this to store the characters moved when moving both the start and end of the range to the
	                        start of the document body and subtracting the start offset from the end offset (the
	                        "move-negative-gazillion" method). However, this is extremely slow when the document is large and
	                        the range is near the end of it. Clearly doing the mirror image (i.e. moving the range boundaries to
	                        the end of the document) has the same problem.
	
	                        Another approach that works is to use moveStart() to move the start boundary of the range up to the
	                        end boundary one character at a time and incrementing a counter with the value returned by the
	                        moveStart() call. However, the check for whether the start boundary has reached the end boundary is
	                        expensive, so this method is slow (although unlike "move-negative-gazillion" is largely unaffected
	                        by the location of the range within the document).
	
	                        The approach used below is a hybrid of the two methods above. It uses the fact that a string
	                        containing the TextRange's 'text' property with each \r\n converted to a single \r character cannot
	                        be longer than the text of the TextRange, so the start of the range is moved that length initially
	                        and then a character at a time to make up for any trailing line breaks not contained in the 'text'
	                        property. This has good performance in most situations compared to the previous two methods.
	                        */
	                        var tempRange = workingRange.duplicate();
	                        var rangeLength = tempRange.text.replace(/\r\n/g, "\r").length;
	
	                        offset = tempRange.moveStart("character", rangeLength);
	                        while ( (comparison = tempRange.compareEndPoints("StartToEnd", tempRange)) == -1) {
	                            offset++;
	                            tempRange.moveStart("character", 1);
	                        }
	                    } else {
	                        offset = workingRange.text.length;
	                    }
	                    boundaryPosition = new DomPosition(boundaryNode, offset);
	                } else {
	
	                    // If the boundary immediately follows a character data node and this is the end boundary, we should favour
	                    // a position within that, and likewise for a start boundary preceding a character data node
	                    previousNode = (isCollapsed || !isStart) && workingNode.previousSibling;
	                    nextNode = (isCollapsed || isStart) && workingNode.nextSibling;
	                    if (nextNode && isCharacterDataNode(nextNode)) {
	                        boundaryPosition = new DomPosition(nextNode, 0);
	                    } else if (previousNode && isCharacterDataNode(previousNode)) {
	                        boundaryPosition = new DomPosition(previousNode, previousNode.data.length);
	                    } else {
	                        boundaryPosition = new DomPosition(containerElement, dom.getNodeIndex(workingNode));
	                    }
	                }
	
	                // Clean up
	                dom.removeNode(workingNode);
	
	                return {
	                    boundaryPosition: boundaryPosition,
	                    nodeInfo: {
	                        nodeIndex: nodeIndex,
	                        containerElement: containerElement
	                    }
	                };
	            };
	
	            // Returns a TextRange representing the boundary of a TextRange expressed as a node and an offset within that
	            // node. This function started out as an optimized version of code found in Tim Cameron Ryan's IERange
	            // (http://code.google.com/p/ierange/)
	            var createBoundaryTextRange = function(boundaryPosition, isStart) {
	                var boundaryNode, boundaryParent, boundaryOffset = boundaryPosition.offset;
	                var doc = dom.getDocument(boundaryPosition.node);
	                var workingNode, childNodes, workingRange = getBody(doc).createTextRange();
	                var nodeIsDataNode = isCharacterDataNode(boundaryPosition.node);
	
	                if (nodeIsDataNode) {
	                    boundaryNode = boundaryPosition.node;
	                    boundaryParent = boundaryNode.parentNode;
	                } else {
	                    childNodes = boundaryPosition.node.childNodes;
	                    boundaryNode = (boundaryOffset < childNodes.length) ? childNodes[boundaryOffset] : null;
	                    boundaryParent = boundaryPosition.node;
	                }
	
	                // Position the range immediately before the node containing the boundary
	                workingNode = doc.createElement("span");
	
	                // Making the working element non-empty element persuades IE to consider the TextRange boundary to be within
	                // the element rather than immediately before or after it
	                workingNode.innerHTML = "&#feff;";
	
	                // insertBefore is supposed to work like appendChild if the second parameter is null. However, a bug report
	                // for IERange suggests that it can crash the browser: http://code.google.com/p/ierange/issues/detail?id=12
	                if (boundaryNode) {
	                    boundaryParent.insertBefore(workingNode, boundaryNode);
	                } else {
	                    boundaryParent.appendChild(workingNode);
	                }
	
	                workingRange.moveToElementText(workingNode);
	                workingRange.collapse(!isStart);
	
	                // Clean up
	                boundaryParent.removeChild(workingNode);
	
	                // Move the working range to the text offset, if required
	                if (nodeIsDataNode) {
	                    workingRange[isStart ? "moveStart" : "moveEnd"]("character", boundaryOffset);
	                }
	
	                return workingRange;
	            };
	
	            /*------------------------------------------------------------------------------------------------------------*/
	
	            // This is a wrapper around a TextRange, providing full DOM Range functionality using rangy's DomRange as a
	            // prototype
	
	            WrappedTextRange = function(textRange) {
	                this.textRange = textRange;
	                this.refresh();
	            };
	
	            WrappedTextRange.prototype = new DomRange(document);
	
	            WrappedTextRange.prototype.refresh = function() {
	                var start, end, startBoundary;
	
	                // TextRange's parentElement() method cannot be trusted. getTextRangeContainerElement() works around that.
	                var rangeContainerElement = getTextRangeContainerElement(this.textRange);
	
	                if (textRangeIsCollapsed(this.textRange)) {
	                    end = start = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, true,
	                        true).boundaryPosition;
	                } else {
	                    startBoundary = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, true, false);
	                    start = startBoundary.boundaryPosition;
	
	                    // An optimization used here is that if the start and end boundaries have the same parent element, the
	                    // search scope for the end boundary can be limited to exclude the portion of the element that precedes
	                    // the start boundary
	                    end = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, false, false,
	                        startBoundary.nodeInfo).boundaryPosition;
	                }
	
	                this.setStart(start.node, start.offset);
	                this.setEnd(end.node, end.offset);
	            };
	
	            WrappedTextRange.prototype.getName = function() {
	                return "WrappedTextRange";
	            };
	
	            DomRange.copyComparisonConstants(WrappedTextRange);
	
	            var rangeToTextRange = function(range) {
	                if (range.collapsed) {
	                    return createBoundaryTextRange(new DomPosition(range.startContainer, range.startOffset), true);
	                } else {
	                    var startRange = createBoundaryTextRange(new DomPosition(range.startContainer, range.startOffset), true);
	                    var endRange = createBoundaryTextRange(new DomPosition(range.endContainer, range.endOffset), false);
	                    var textRange = getBody( DomRange.getRangeDocument(range) ).createTextRange();
	                    textRange.setEndPoint("StartToStart", startRange);
	                    textRange.setEndPoint("EndToEnd", endRange);
	                    return textRange;
	                }
	            };
	
	            WrappedTextRange.rangeToTextRange = rangeToTextRange;
	
	            WrappedTextRange.prototype.toTextRange = function() {
	                return rangeToTextRange(this);
	            };
	
	            api.WrappedTextRange = WrappedTextRange;
	
	            // IE 9 and above have both implementations and Rangy makes both available. The next few lines sets which
	            // implementation to use by default.
	            if (!api.features.implementsDomRange || api.config.preferTextRange) {
	                // Add WrappedTextRange as the Range property of the global object to allow expression like Range.END_TO_END to work
	                var globalObj = (function(f) { return f("return this;")(); })(Function);
	                if (typeof globalObj.Range == "undefined") {
	                    globalObj.Range = WrappedTextRange;
	                }
	
	                api.createNativeRange = function(doc) {
	                    doc = getContentDocument(doc, module, "createNativeRange");
	                    return getBody(doc).createTextRange();
	                };
	
	                api.WrappedRange = WrappedTextRange;
	            }
	        }
	
	        api.createRange = function(doc) {
	            doc = getContentDocument(doc, module, "createRange");
	            return new api.WrappedRange(api.createNativeRange(doc));
	        };
	
	        api.createRangyRange = function(doc) {
	            doc = getContentDocument(doc, module, "createRangyRange");
	            return new DomRange(doc);
	        };
	
	        util.createAliasForDeprecatedMethod(api, "createIframeRange", "createRange");
	        util.createAliasForDeprecatedMethod(api, "createIframeRangyRange", "createRangyRange");
	
	        api.addShimListener(function(win) {
	            var doc = win.document;
	            if (typeof doc.createRange == "undefined") {
	                doc.createRange = function() {
	                    return api.createRange(doc);
	                };
	            }
	            doc = win = null;
	        });
	    });
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // This module creates a selection object wrapper that conforms as closely as possible to the Selection specification
	    // in the W3C Selection API spec (https://www.w3.org/TR/selection-api)
	    api.createCoreModule("WrappedSelection", ["DomRange", "WrappedRange"], function(api, module) {
	        api.config.checkSelectionRanges = true;
	
	        var BOOLEAN = "boolean";
	        var NUMBER = "number";
	        var dom = api.dom;
	        var util = api.util;
	        var isHostMethod = util.isHostMethod;
	        var DomRange = api.DomRange;
	        var WrappedRange = api.WrappedRange;
	        var DOMException = api.DOMException;
	        var DomPosition = dom.DomPosition;
	        var getNativeSelection;
	        var selectionIsCollapsed;
	        var features = api.features;
	        var CONTROL = "Control";
	        var getDocument = dom.getDocument;
	        var getBody = dom.getBody;
	        var rangesEqual = DomRange.rangesEqual;
	
	
	        // Utility function to support direction parameters in the API that may be a string ("backward", "backwards",
	        // "forward" or "forwards") or a Boolean (true for backwards).
	        function isDirectionBackward(dir) {
	            return (typeof dir == "string") ? /^backward(s)?$/i.test(dir) : !!dir;
	        }
	
	        function getWindow(win, methodName) {
	            if (!win) {
	                return window;
	            } else if (dom.isWindow(win)) {
	                return win;
	            } else if (win instanceof WrappedSelection) {
	                return win.win;
	            } else {
	                var doc = dom.getContentDocument(win, module, methodName);
	                return dom.getWindow(doc);
	            }
	        }
	
	        function getWinSelection(winParam) {
	            return getWindow(winParam, "getWinSelection").getSelection();
	        }
	
	        function getDocSelection(winParam) {
	            return getWindow(winParam, "getDocSelection").document.selection;
	        }
	
	        function winSelectionIsBackward(sel) {
	            var backward = false;
	            if (sel.anchorNode) {
	                backward = (dom.comparePoints(sel.anchorNode, sel.anchorOffset, sel.focusNode, sel.focusOffset) == 1);
	            }
	            return backward;
	        }
	
	        // Test for the Range/TextRange and Selection features required
	        // Test for ability to retrieve selection
	        var implementsWinGetSelection = isHostMethod(window, "getSelection"),
	            implementsDocSelection = util.isHostObject(document, "selection");
	
	        features.implementsWinGetSelection = implementsWinGetSelection;
	        features.implementsDocSelection = implementsDocSelection;
	
	        var useDocumentSelection = implementsDocSelection && (!implementsWinGetSelection || api.config.preferTextRange);
	
	        if (useDocumentSelection) {
	            getNativeSelection = getDocSelection;
	            api.isSelectionValid = function(winParam) {
	                var doc = getWindow(winParam, "isSelectionValid").document, nativeSel = doc.selection;
	
	                // Check whether the selection TextRange is actually contained within the correct document
	                return (nativeSel.type != "None" || getDocument(nativeSel.createRange().parentElement()) == doc);
	            };
	        } else if (implementsWinGetSelection) {
	            getNativeSelection = getWinSelection;
	            api.isSelectionValid = function() {
	                return true;
	            };
	        } else {
	            module.fail("Neither document.selection or window.getSelection() detected.");
	            return false;
	        }
	
	        api.getNativeSelection = getNativeSelection;
	
	        var testSelection = getNativeSelection();
	
	        // In Firefox, the selection is null in an iframe with display: none. See issue #138.
	        if (!testSelection) {
	            module.fail("Native selection was null (possibly issue 138?)");
	            return false;
	        }
	
	        var testRange = api.createNativeRange(document);
	        var body = getBody(document);
	
	        // Obtaining a range from a selection
	        var selectionHasAnchorAndFocus = util.areHostProperties(testSelection,
	            ["anchorNode", "focusNode", "anchorOffset", "focusOffset"]);
	
	        features.selectionHasAnchorAndFocus = selectionHasAnchorAndFocus;
	
	        // Test for existence of native selection extend() method
	        var selectionHasExtend = isHostMethod(testSelection, "extend");
	        features.selectionHasExtend = selectionHasExtend;
	
	        // Test for existence of native selection setBaseAndExtent() method
	        var selectionHasSetBaseAndExtent = isHostMethod(testSelection, "setBaseAndExtent");
	        features.selectionHasSetBaseAndExtent = selectionHasSetBaseAndExtent;
	
	        // Test if rangeCount exists
	        var selectionHasRangeCount = (typeof testSelection.rangeCount == NUMBER);
	        features.selectionHasRangeCount = selectionHasRangeCount;
	
	        var selectionSupportsMultipleRanges = false;
	        var collapsedNonEditableSelectionsSupported = true;
	
	        var addRangeBackwardToNative = selectionHasExtend ?
	            function(nativeSelection, range) {
	                var doc = DomRange.getRangeDocument(range);
	                var endRange = api.createRange(doc);
	                endRange.collapseToPoint(range.endContainer, range.endOffset);
	                nativeSelection.addRange(getNativeRange(endRange));
	                nativeSelection.extend(range.startContainer, range.startOffset);
	            } : null;
	
	        if (util.areHostMethods(testSelection, ["addRange", "getRangeAt", "removeAllRanges"]) &&
	                typeof testSelection.rangeCount == NUMBER && features.implementsDomRange) {
	
	            (function() {
	                // Previously an iframe was used but this caused problems in some circumstances in IE, so tests are
	                // performed on the current document's selection. See issue 109.
	
	                // Note also that if a selection previously existed, it is wiped and later restored by these tests. This
	                // will result in the selection direction being reversed if the original selection was backwards and the
	                // browser does not support setting backwards selections (Internet Explorer, I'm looking at you).
	                var sel = window.getSelection();
	                if (sel) {
	                    // Store the current selection
	                    var originalSelectionRangeCount = sel.rangeCount;
	                    var selectionHasMultipleRanges = (originalSelectionRangeCount > 1);
	                    var originalSelectionRanges = [];
	                    var originalSelectionBackward = winSelectionIsBackward(sel);
	                    for (var i = 0; i < originalSelectionRangeCount; ++i) {
	                        originalSelectionRanges[i] = sel.getRangeAt(i);
	                    }
	
	                    // Create some test elements
	                    var testEl = dom.createTestElement(document, "", false);
	                    var textNode = testEl.appendChild( document.createTextNode("\u00a0\u00a0\u00a0") );
	
	                    // Test whether the native selection will allow a collapsed selection within a non-editable element
	                    var r1 = document.createRange();
	
	                    r1.setStart(textNode, 1);
	                    r1.collapse(true);
	                    sel.removeAllRanges();
	                    sel.addRange(r1);
	                    collapsedNonEditableSelectionsSupported = (sel.rangeCount == 1);
	                    sel.removeAllRanges();
	
	                    // Test whether the native selection is capable of supporting multiple ranges.
	                    if (!selectionHasMultipleRanges) {
	                        // Doing the original feature test here in Chrome 36 (and presumably later versions) prints a
	                        // console error of "Discontiguous selection is not supported." that cannot be suppressed. There's
	                        // nothing we can do about this while retaining the feature test so we have to resort to a browser
	                        // sniff. I'm not happy about it. See
	                        // https://code.google.com/p/chromium/issues/detail?id=399791
	                        var chromeMatch = window.navigator.appVersion.match(/Chrome\/(.*?) /);
	                        if (chromeMatch && parseInt(chromeMatch[1]) >= 36) {
	                            selectionSupportsMultipleRanges = false;
	                        } else {
	                            var r2 = r1.cloneRange();
	                            r1.setStart(textNode, 0);
	                            r2.setEnd(textNode, 3);
	                            r2.setStart(textNode, 2);
	                            sel.addRange(r1);
	                            sel.addRange(r2);
	                            selectionSupportsMultipleRanges = (sel.rangeCount == 2);
	                        }
	                    }
	
	                    // Clean up
	                    dom.removeNode(testEl);
	                    sel.removeAllRanges();
	
	                    for (i = 0; i < originalSelectionRangeCount; ++i) {
	                        if (i == 0 && originalSelectionBackward) {
	                            if (addRangeBackwardToNative) {
	                                addRangeBackwardToNative(sel, originalSelectionRanges[i]);
	                            } else {
	                                api.warn("Rangy initialization: original selection was backwards but selection has been restored forwards because the browser does not support Selection.extend");
	                                sel.addRange(originalSelectionRanges[i]);
	                            }
	                        } else {
	                            sel.addRange(originalSelectionRanges[i]);
	                        }
	                    }
	                }
	            })();
	        }
	
	        features.selectionSupportsMultipleRanges = selectionSupportsMultipleRanges;
	        features.collapsedNonEditableSelectionsSupported = collapsedNonEditableSelectionsSupported;
	
	        // ControlRanges
	        var implementsControlRange = false, testControlRange;
	
	        if (body && isHostMethod(body, "createControlRange")) {
	            testControlRange = body.createControlRange();
	            if (util.areHostProperties(testControlRange, ["item", "add"])) {
	                implementsControlRange = true;
	            }
	        }
	        features.implementsControlRange = implementsControlRange;
	
	        // Selection collapsedness
	        if (selectionHasAnchorAndFocus) {
	            selectionIsCollapsed = function(sel) {
	                return sel.anchorNode === sel.focusNode && sel.anchorOffset === sel.focusOffset;
	            };
	        } else {
	            selectionIsCollapsed = function(sel) {
	                return sel.rangeCount ? sel.getRangeAt(sel.rangeCount - 1).collapsed : false;
	            };
	        }
	
	        function updateAnchorAndFocusFromRange(sel, range, backward) {
	            var anchorPrefix = backward ? "end" : "start", focusPrefix = backward ? "start" : "end";
	            sel.anchorNode = range[anchorPrefix + "Container"];
	            sel.anchorOffset = range[anchorPrefix + "Offset"];
	            sel.focusNode = range[focusPrefix + "Container"];
	            sel.focusOffset = range[focusPrefix + "Offset"];
	        }
	
	        function updateAnchorAndFocusFromNativeSelection(sel) {
	            var nativeSel = sel.nativeSelection;
	            sel.anchorNode = nativeSel.anchorNode;
	            sel.anchorOffset = nativeSel.anchorOffset;
	            sel.focusNode = nativeSel.focusNode;
	            sel.focusOffset = nativeSel.focusOffset;
	        }
	
	        function updateEmptySelection(sel) {
	            sel.anchorNode = sel.focusNode = null;
	            sel.anchorOffset = sel.focusOffset = 0;
	            sel.rangeCount = 0;
	            sel.isCollapsed = true;
	            sel._ranges.length = 0;
	            updateType(sel);
	        }
	
	        function updateType(sel) {
	            sel.type = (sel.rangeCount == 0) ? "None" : (selectionIsCollapsed(sel) ? "Caret" : "Range");
	        }
	
	        function getNativeRange(range) {
	            var nativeRange;
	            if (range instanceof DomRange) {
	                nativeRange = api.createNativeRange(range.getDocument());
	                nativeRange.setEnd(range.endContainer, range.endOffset);
	                nativeRange.setStart(range.startContainer, range.startOffset);
	            } else if (range instanceof WrappedRange) {
	                nativeRange = range.nativeRange;
	            } else if (features.implementsDomRange && (range instanceof dom.getWindow(range.startContainer).Range)) {
	                nativeRange = range;
	            }
	            return nativeRange;
	        }
	
	        function rangeContainsSingleElement(rangeNodes) {
	            if (!rangeNodes.length || rangeNodes[0].nodeType != 1) {
	                return false;
	            }
	            for (var i = 1, len = rangeNodes.length; i < len; ++i) {
	                if (!dom.isAncestorOf(rangeNodes[0], rangeNodes[i])) {
	                    return false;
	                }
	            }
	            return true;
	        }
	
	        function getSingleElementFromRange(range) {
	            var nodes = range.getNodes();
	            if (!rangeContainsSingleElement(nodes)) {
	                throw module.createError("getSingleElementFromRange: range " + range.inspect() + " did not consist of a single element");
	            }
	            return nodes[0];
	        }
	
	        // Simple, quick test which only needs to distinguish between a TextRange and a ControlRange
	        function isTextRange(range) {
	            return !!range && typeof range.text != "undefined";
	        }
	
	        function updateFromTextRange(sel, range) {
	            // Create a Range from the selected TextRange
	            var wrappedRange = new WrappedRange(range);
	            sel._ranges = [wrappedRange];
	
	            updateAnchorAndFocusFromRange(sel, wrappedRange, false);
	            sel.rangeCount = 1;
	            sel.isCollapsed = wrappedRange.collapsed;
	            updateType(sel);
	        }
	
	        function updateControlSelection(sel) {
	            // Update the wrapped selection based on what's now in the native selection
	            sel._ranges.length = 0;
	            if (sel.docSelection.type == "None") {
	                updateEmptySelection(sel);
	            } else {
	                var controlRange = sel.docSelection.createRange();
	                if (isTextRange(controlRange)) {
	                    // This case (where the selection type is "Control" and calling createRange() on the selection returns
	                    // a TextRange) can happen in IE 9. It happens, for example, when all elements in the selected
	                    // ControlRange have been removed from the ControlRange and removed from the document.
	                    updateFromTextRange(sel, controlRange);
	                } else {
	                    sel.rangeCount = controlRange.length;
	                    var range, doc = getDocument(controlRange.item(0));
	                    for (var i = 0; i < sel.rangeCount; ++i) {
	                        range = api.createRange(doc);
	                        range.selectNode(controlRange.item(i));
	                        sel._ranges.push(range);
	                    }
	                    sel.isCollapsed = sel.rangeCount == 1 && sel._ranges[0].collapsed;
	                    updateAnchorAndFocusFromRange(sel, sel._ranges[sel.rangeCount - 1], false);
	                    updateType(sel);
	                }
	            }
	        }
	
	        function addRangeToControlSelection(sel, range) {
	            var controlRange = sel.docSelection.createRange();
	            var rangeElement = getSingleElementFromRange(range);
	
	            // Create a new ControlRange containing all the elements in the selected ControlRange plus the element
	            // contained by the supplied range
	            var doc = getDocument(controlRange.item(0));
	            var newControlRange = getBody(doc).createControlRange();
	            for (var i = 0, len = controlRange.length; i < len; ++i) {
	                newControlRange.add(controlRange.item(i));
	            }
	            try {
	                newControlRange.add(rangeElement);
	            } catch (ex) {
	                throw module.createError("addRange(): Element within the specified Range could not be added to control selection (does it have layout?)");
	            }
	            newControlRange.select();
	
	            // Update the wrapped selection based on what's now in the native selection
	            updateControlSelection(sel);
	        }
	
	        var getSelectionRangeAt;
	
	        if (isHostMethod(testSelection, "getRangeAt")) {
	            // try/catch is present because getRangeAt() must have thrown an error in some browser and some situation.
	            // Unfortunately, I didn't write a comment about the specifics and am now scared to take it out. Let that be a
	            // lesson to us all, especially me.
	            getSelectionRangeAt = function(sel, index) {
	                try {
	                    return sel.getRangeAt(index);
	                } catch (ex) {
	                    return null;
	                }
	            };
	        } else if (selectionHasAnchorAndFocus) {
	            getSelectionRangeAt = function(sel) {
	                var doc = getDocument(sel.anchorNode);
	                var range = api.createRange(doc);
	                range.setStartAndEnd(sel.anchorNode, sel.anchorOffset, sel.focusNode, sel.focusOffset);
	
	                // Handle the case when the selection was selected backwards (from the end to the start in the
	                // document)
	                if (range.collapsed !== this.isCollapsed) {
	                    range.setStartAndEnd(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset);
	                }
	
	                return range;
	            };
	        }
	
	        function WrappedSelection(selection, docSelection, win) {
	            this.nativeSelection = selection;
	            this.docSelection = docSelection;
	            this._ranges = [];
	            this.win = win;
	            this.refresh();
	        }
	
	        WrappedSelection.prototype = api.selectionPrototype;
	
	        function deleteProperties(sel) {
	            sel.win = sel.anchorNode = sel.focusNode = sel._ranges = null;
	            sel.rangeCount = sel.anchorOffset = sel.focusOffset = 0;
	            sel.detached = true;
	            updateType(sel);
	        }
	
	        var cachedRangySelections = [];
	
	        function actOnCachedSelection(win, action) {
	            var i = cachedRangySelections.length, cached, sel;
	            while (i--) {
	                cached = cachedRangySelections[i];
	                sel = cached.selection;
	                if (action == "deleteAll") {
	                    deleteProperties(sel);
	                } else if (cached.win == win) {
	                    if (action == "delete") {
	                        cachedRangySelections.splice(i, 1);
	                        return true;
	                    } else {
	                        return sel;
	                    }
	                }
	            }
	            if (action == "deleteAll") {
	                cachedRangySelections.length = 0;
	            }
	            return null;
	        }
	
	        var getSelection = function(win) {
	            // Check if the parameter is a Rangy Selection object
	            if (win && win instanceof WrappedSelection) {
	                win.refresh();
	                return win;
	            }
	
	            win = getWindow(win, "getNativeSelection");
	
	            var sel = actOnCachedSelection(win);
	            var nativeSel = getNativeSelection(win), docSel = implementsDocSelection ? getDocSelection(win) : null;
	            if (sel) {
	                sel.nativeSelection = nativeSel;
	                sel.docSelection = docSel;
	                sel.refresh();
	            } else {
	                sel = new WrappedSelection(nativeSel, docSel, win);
	                cachedRangySelections.push( { win: win, selection: sel } );
	            }
	            return sel;
	        };
	
	        api.getSelection = getSelection;
	
	        util.createAliasForDeprecatedMethod(api, "getIframeSelection", "getSelection");
	
	        var selProto = WrappedSelection.prototype;
	
	        function createControlSelection(sel, ranges) {
	            // Ensure that the selection becomes of type "Control"
	            var doc = getDocument(ranges[0].startContainer);
	            var controlRange = getBody(doc).createControlRange();
	            for (var i = 0, el, len = ranges.length; i < len; ++i) {
	                el = getSingleElementFromRange(ranges[i]);
	                try {
	                    controlRange.add(el);
	                } catch (ex) {
	                    throw module.createError("setRanges(): Element within one of the specified Ranges could not be added to control selection (does it have layout?)");
	                }
	            }
	            controlRange.select();
	
	            // Update the wrapped selection based on what's now in the native selection
	            updateControlSelection(sel);
	        }
	
	        // Selecting a range
	        if (!useDocumentSelection && selectionHasAnchorAndFocus && util.areHostMethods(testSelection, ["removeAllRanges", "addRange"])) {
	            selProto.removeAllRanges = function() {
	                this.nativeSelection.removeAllRanges();
	                updateEmptySelection(this);
	            };
	
	            var addRangeBackward = function(sel, range) {
	                addRangeBackwardToNative(sel.nativeSelection, range);
	                sel.refresh();
	            };
	
	            if (selectionHasRangeCount) {
	                selProto.addRange = function(range, direction) {
	                    if (implementsControlRange && implementsDocSelection && this.docSelection.type == CONTROL) {
	                        addRangeToControlSelection(this, range);
	                    } else {
	                        if (isDirectionBackward(direction) && selectionHasExtend) {
	                            addRangeBackward(this, range);
	                        } else {
	                            var previousRangeCount;
	                            if (selectionSupportsMultipleRanges) {
	                                previousRangeCount = this.rangeCount;
	                            } else {
	                                this.removeAllRanges();
	                                previousRangeCount = 0;
	                            }
	                            // Clone the native range so that changing the selected range does not affect the selection.
	                            // This is contrary to the spec but is the only way to achieve consistency between browsers. See
	                            // issue 80.
	                            var clonedNativeRange = getNativeRange(range).cloneRange();
	                            try {
	                                this.nativeSelection.addRange(clonedNativeRange);
	                            } catch (ex) {
	                            }
	
	                            // Check whether adding the range was successful
	                            this.rangeCount = this.nativeSelection.rangeCount;
	
	                            if (this.rangeCount == previousRangeCount + 1) {
	                                // The range was added successfully
	
	                                // Check whether the range that we added to the selection is reflected in the last range extracted from
	                                // the selection
	                                if (api.config.checkSelectionRanges) {
	                                    var nativeRange = getSelectionRangeAt(this.nativeSelection, this.rangeCount - 1);
	                                    if (nativeRange && !rangesEqual(nativeRange, range)) {
	                                        // Happens in WebKit with, for example, a selection placed at the start of a text node
	                                        range = new WrappedRange(nativeRange);
	                                    }
	                                }
	                                this._ranges[this.rangeCount - 1] = range;
	                                updateAnchorAndFocusFromRange(this, range, selectionIsBackward(this.nativeSelection));
	                                this.isCollapsed = selectionIsCollapsed(this);
	                                updateType(this);
	                            } else {
	                                // The range was not added successfully. The simplest thing is to refresh
	                                this.refresh();
	                            }
	                        }
	                    }
	                };
	            } else {
	                selProto.addRange = function(range, direction) {
	                    if (isDirectionBackward(direction) && selectionHasExtend) {
	                        addRangeBackward(this, range);
	                    } else {
	                        this.nativeSelection.addRange(getNativeRange(range));
	                        this.refresh();
	                    }
	                };
	            }
	
	            selProto.setRanges = function(ranges) {
	                if (implementsControlRange && implementsDocSelection && ranges.length > 1) {
	                    createControlSelection(this, ranges);
	                } else {
	                    this.removeAllRanges();
	                    for (var i = 0, len = ranges.length; i < len; ++i) {
	                        this.addRange(ranges[i]);
	                    }
	                }
	            };
	        } else if (isHostMethod(testSelection, "empty") && isHostMethod(testRange, "select") &&
	                   implementsControlRange && useDocumentSelection) {
	
	            selProto.removeAllRanges = function() {
	                // Added try/catch as fix for issue #21
	                try {
	                    this.docSelection.empty();
	
	                    // Check for empty() not working (issue #24)
	                    if (this.docSelection.type != "None") {
	                        // Work around failure to empty a control selection by instead selecting a TextRange and then
	                        // calling empty()
	                        var doc;
	                        if (this.anchorNode) {
	                            doc = getDocument(this.anchorNode);
	                        } else if (this.docSelection.type == CONTROL) {
	                            var controlRange = this.docSelection.createRange();
	                            if (controlRange.length) {
	                                doc = getDocument( controlRange.item(0) );
	                            }
	                        }
	                        if (doc) {
	                            var textRange = getBody(doc).createTextRange();
	                            textRange.select();
	                            this.docSelection.empty();
	                        }
	                    }
	                } catch(ex) {}
	                updateEmptySelection(this);
	            };
	
	            selProto.addRange = function(range) {
	                if (this.docSelection.type == CONTROL) {
	                    addRangeToControlSelection(this, range);
	                } else {
	                    api.WrappedTextRange.rangeToTextRange(range).select();
	                    this._ranges[0] = range;
	                    this.rangeCount = 1;
	                    this.isCollapsed = this._ranges[0].collapsed;
	                    updateAnchorAndFocusFromRange(this, range, false);
	                    updateType(this);
	                }
	            };
	
	            selProto.setRanges = function(ranges) {
	                this.removeAllRanges();
	                var rangeCount = ranges.length;
	                if (rangeCount > 1) {
	                    createControlSelection(this, ranges);
	                } else if (rangeCount) {
	                    this.addRange(ranges[0]);
	                }
	            };
	        } else {
	            module.fail("No means of selecting a Range or TextRange was found");
	            return false;
	        }
	
	        selProto.getRangeAt = function(index) {
	            if (index < 0 || index >= this.rangeCount) {
	                throw new DOMException("INDEX_SIZE_ERR");
	            } else {
	                // Clone the range to preserve selection-range independence. See issue 80.
	                return this._ranges[index].cloneRange();
	            }
	        };
	
	        var refreshSelection;
	
	        if (useDocumentSelection) {
	            refreshSelection = function(sel) {
	                var range;
	                if (api.isSelectionValid(sel.win)) {
	                    range = sel.docSelection.createRange();
	                } else {
	                    range = getBody(sel.win.document).createTextRange();
	                    range.collapse(true);
	                }
	
	                if (sel.docSelection.type == CONTROL) {
	                    updateControlSelection(sel);
	                } else if (isTextRange(range)) {
	                    updateFromTextRange(sel, range);
	                } else {
	                    updateEmptySelection(sel);
	                }
	            };
	        } else if (isHostMethod(testSelection, "getRangeAt") && typeof testSelection.rangeCount == NUMBER) {
	            refreshSelection = function(sel) {
	                if (implementsControlRange && implementsDocSelection && sel.docSelection.type == CONTROL) {
	                    updateControlSelection(sel);
	                } else {
	                    sel._ranges.length = sel.rangeCount = sel.nativeSelection.rangeCount;
	                    if (sel.rangeCount) {
	                        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
	                            sel._ranges[i] = new api.WrappedRange(sel.nativeSelection.getRangeAt(i));
	                        }
	                        updateAnchorAndFocusFromRange(sel, sel._ranges[sel.rangeCount - 1], selectionIsBackward(sel.nativeSelection));
	                        sel.isCollapsed = selectionIsCollapsed(sel);
	                        updateType(sel);
	                    } else {
	                        updateEmptySelection(sel);
	                    }
	                }
	            };
	        } else if (selectionHasAnchorAndFocus && typeof testSelection.isCollapsed == BOOLEAN && typeof testRange.collapsed == BOOLEAN && features.implementsDomRange) {
	            refreshSelection = function(sel) {
	                var range, nativeSel = sel.nativeSelection;
	                if (nativeSel.anchorNode) {
	                    range = getSelectionRangeAt(nativeSel, 0);
	                    sel._ranges = [range];
	                    sel.rangeCount = 1;
	                    updateAnchorAndFocusFromNativeSelection(sel);
	                    sel.isCollapsed = selectionIsCollapsed(sel);
	                    updateType(sel);
	                } else {
	                    updateEmptySelection(sel);
	                }
	            };
	        } else {
	            module.fail("No means of obtaining a Range or TextRange from the user's selection was found");
	            return false;
	        }
	
	        selProto.refresh = function(checkForChanges) {
	            var oldRanges = checkForChanges ? this._ranges.slice(0) : null;
	            var oldAnchorNode = this.anchorNode, oldAnchorOffset = this.anchorOffset;
	
	            refreshSelection(this);
	            if (checkForChanges) {
	                // Check the range count first
	                var i = oldRanges.length;
	                if (i != this._ranges.length) {
	                    return true;
	                }
	
	                // Now check the direction. Checking the anchor position is the same is enough since we're checking all the
	                // ranges after this
	                if (this.anchorNode != oldAnchorNode || this.anchorOffset != oldAnchorOffset) {
	                    return true;
	                }
	
	                // Finally, compare each range in turn
	                while (i--) {
	                    if (!rangesEqual(oldRanges[i], this._ranges[i])) {
	                        return true;
	                    }
	                }
	                return false;
	            }
	        };
	
	        // Removal of a single range
	        var removeRangeManually = function(sel, range) {
	            var ranges = sel.getAllRanges();
	            sel.removeAllRanges();
	            for (var i = 0, len = ranges.length; i < len; ++i) {
	                if (!rangesEqual(range, ranges[i])) {
	                    sel.addRange(ranges[i]);
	                }
	            }
	            if (!sel.rangeCount) {
	                updateEmptySelection(sel);
	            }
	        };
	
	        if (implementsControlRange && implementsDocSelection) {
	            selProto.removeRange = function(range) {
	                if (this.docSelection.type == CONTROL) {
	                    var controlRange = this.docSelection.createRange();
	                    var rangeElement = getSingleElementFromRange(range);
	
	                    // Create a new ControlRange containing all the elements in the selected ControlRange minus the
	                    // element contained by the supplied range
	                    var doc = getDocument(controlRange.item(0));
	                    var newControlRange = getBody(doc).createControlRange();
	                    var el, removed = false;
	                    for (var i = 0, len = controlRange.length; i < len; ++i) {
	                        el = controlRange.item(i);
	                        if (el !== rangeElement || removed) {
	                            newControlRange.add(controlRange.item(i));
	                        } else {
	                            removed = true;
	                        }
	                    }
	                    newControlRange.select();
	
	                    // Update the wrapped selection based on what's now in the native selection
	                    updateControlSelection(this);
	                } else {
	                    removeRangeManually(this, range);
	                }
	            };
	        } else {
	            selProto.removeRange = function(range) {
	                removeRangeManually(this, range);
	            };
	        }
	
	        // Detecting if a selection is backward
	        var selectionIsBackward;
	        if (!useDocumentSelection && selectionHasAnchorAndFocus && features.implementsDomRange) {
	            selectionIsBackward = winSelectionIsBackward;
	
	            selProto.isBackward = function() {
	                return selectionIsBackward(this);
	            };
	        } else {
	            selectionIsBackward = selProto.isBackward = function() {
	                return false;
	            };
	        }
	
	        // Create an alias for backwards compatibility. From 1.3, everything is "backward" rather than "backwards"
	        selProto.isBackwards = selProto.isBackward;
	
	        // Selection stringifier
	        // This is conformant to the old HTML5 selections draft spec but differs from WebKit and Mozilla's implementation.
	        // The current spec does not yet define this method.
	        selProto.toString = function() {
	            var rangeTexts = [];
	            for (var i = 0, len = this.rangeCount; i < len; ++i) {
	                rangeTexts[i] = "" + this._ranges[i];
	            }
	            return rangeTexts.join("");
	        };
	
	        function assertNodeInSameDocument(sel, node) {
	            if (sel.win.document != getDocument(node)) {
	                throw new DOMException("WRONG_DOCUMENT_ERR");
	            }
	        }
	
	        function assertValidOffset(node, offset) {
	            if (offset < 0 || offset > (dom.isCharacterDataNode(node) ? node.length : node.childNodes.length)) {
	                throw new DOMException("INDEX_SIZE_ERR");
	            }
	        }
	
	        // No current browser conforms fully to the spec for this method, so Rangy's own method is always used
	        selProto.collapse = function(node, offset) {
	            assertNodeInSameDocument(this, node);
	            var range = api.createRange(node);
	            range.collapseToPoint(node, offset);
	            this.setSingleRange(range);
	            this.isCollapsed = true;
	        };
	
	        selProto.collapseToStart = function() {
	            if (this.rangeCount) {
	                var range = this._ranges[0];
	                this.collapse(range.startContainer, range.startOffset);
	            } else {
	                throw new DOMException("INVALID_STATE_ERR");
	            }
	        };
	
	        selProto.collapseToEnd = function() {
	            if (this.rangeCount) {
	                var range = this._ranges[this.rangeCount - 1];
	                this.collapse(range.endContainer, range.endOffset);
	            } else {
	                throw new DOMException("INVALID_STATE_ERR");
	            }
	        };
	
	        // The spec is very specific on how selectAllChildren should be implemented and not all browsers implement it as
	        // specified so the native implementation is never used by Rangy.
	        selProto.selectAllChildren = function(node) {
	            assertNodeInSameDocument(this, node);
	            var range = api.createRange(node);
	            range.selectNodeContents(node);
	            this.setSingleRange(range);
	        };
	
	        if (selectionHasSetBaseAndExtent) {
	            selProto.setBaseAndExtent = function(anchorNode, anchorOffset, focusNode, focusOffset) {
	                this.nativeSelection.setBaseAndExtent(anchorNode, anchorOffset, focusNode, focusOffset);
	                this.refresh();
	            };
	        } else if (selectionHasExtend) {
	            selProto.setBaseAndExtent = function(anchorNode, anchorOffset, focusNode, focusOffset) {
	                assertValidOffset(anchorNode, anchorOffset);
	                assertValidOffset(focusNode, focusOffset);
	                assertNodeInSameDocument(this, anchorNode);
	                assertNodeInSameDocument(this, focusNode);
	                var range = api.createRange(node);
	                var isBackwards = (dom.comparePoints(anchorNode, anchorOffset, focusNode, focusOffset) == -1);
	                if (isBackwards) {
	                    range.setStartAndEnd(focusNode, focusOffset, anchorNode, anchorOffset);
	                } else {
	                    range.setStartAndEnd(anchorNode, anchorOffset, focusNode, focusOffset);
	                }
	                this.setSingleRange(range, isBackwards);
	            };
	        }
	
	        selProto.deleteFromDocument = function() {
	            // Sepcial behaviour required for IE's control selections
	            if (implementsControlRange && implementsDocSelection && this.docSelection.type == CONTROL) {
	                var controlRange = this.docSelection.createRange();
	                var element;
	                while (controlRange.length) {
	                    element = controlRange.item(0);
	                    controlRange.remove(element);
	                    dom.removeNode(element);
	                }
	                this.refresh();
	            } else if (this.rangeCount) {
	                var ranges = this.getAllRanges();
	                if (ranges.length) {
	                    this.removeAllRanges();
	                    for (var i = 0, len = ranges.length; i < len; ++i) {
	                        ranges[i].deleteContents();
	                    }
	                    // The spec says nothing about what the selection should contain after calling deleteContents on each
	                    // range. Firefox moves the selection to where the final selected range was, so we emulate that
	                    this.addRange(ranges[len - 1]);
	                }
	            }
	        };
	
	        // The following are non-standard extensions
	        selProto.eachRange = function(func, returnValue) {
	            for (var i = 0, len = this._ranges.length; i < len; ++i) {
	                if ( func( this.getRangeAt(i) ) ) {
	                    return returnValue;
	                }
	            }
	        };
	
	        selProto.getAllRanges = function() {
	            var ranges = [];
	            this.eachRange(function(range) {
	                ranges.push(range);
	            });
	            return ranges;
	        };
	
	        selProto.setSingleRange = function(range, direction) {
	            this.removeAllRanges();
	            this.addRange(range, direction);
	        };
	
	        selProto.callMethodOnEachRange = function(methodName, params) {
	            var results = [];
	            this.eachRange( function(range) {
	                results.push( range[methodName].apply(range, params || []) );
	            } );
	            return results;
	        };
	
	        function createStartOrEndSetter(isStart) {
	            return function(node, offset) {
	                var range;
	                if (this.rangeCount) {
	                    range = this.getRangeAt(0);
	                    range["set" + (isStart ? "Start" : "End")](node, offset);
	                } else {
	                    range = api.createRange(this.win.document);
	                    range.setStartAndEnd(node, offset);
	                }
	                this.setSingleRange(range, this.isBackward());
	            };
	        }
	
	        selProto.setStart = createStartOrEndSetter(true);
	        selProto.setEnd = createStartOrEndSetter(false);
	
	        // Add select() method to Range prototype. Any existing selection will be removed.
	        api.rangePrototype.select = function(direction) {
	            getSelection( this.getDocument() ).setSingleRange(this, direction);
	        };
	
	        selProto.changeEachRange = function(func) {
	            var ranges = [];
	            var backward = this.isBackward();
	
	            this.eachRange(function(range) {
	                func(range);
	                ranges.push(range);
	            });
	
	            this.removeAllRanges();
	            if (backward && ranges.length == 1) {
	                this.addRange(ranges[0], "backward");
	            } else {
	                this.setRanges(ranges);
	            }
	        };
	
	        selProto.containsNode = function(node, allowPartial) {
	            return this.eachRange( function(range) {
	                return range.containsNode(node, allowPartial);
	            }, true ) || false;
	        };
	
	        selProto.getBookmark = function(containerNode) {
	            return {
	                backward: this.isBackward(),
	                rangeBookmarks: this.callMethodOnEachRange("getBookmark", [containerNode])
	            };
	        };
	
	        selProto.moveToBookmark = function(bookmark) {
	            var selRanges = [];
	            for (var i = 0, rangeBookmark, range; rangeBookmark = bookmark.rangeBookmarks[i++]; ) {
	                range = api.createRange(this.win);
	                range.moveToBookmark(rangeBookmark);
	                selRanges.push(range);
	            }
	            if (bookmark.backward) {
	                this.setSingleRange(selRanges[0], "backward");
	            } else {
	                this.setRanges(selRanges);
	            }
	        };
	
	        selProto.saveRanges = function() {
	            return {
	                backward: this.isBackward(),
	                ranges: this.callMethodOnEachRange("cloneRange")
	            };
	        };
	
	        selProto.restoreRanges = function(selRanges) {
	            this.removeAllRanges();
	            for (var i = 0, range; range = selRanges.ranges[i]; ++i) {
	                this.addRange(range, (selRanges.backward && i == 0));
	            }
	        };
	
	        selProto.toHtml = function() {
	            var rangeHtmls = [];
	            this.eachRange(function(range) {
	                rangeHtmls.push( DomRange.toHtml(range) );
	            });
	            return rangeHtmls.join("");
	        };
	
	        if (features.implementsTextRange) {
	            selProto.getNativeTextRange = function() {
	                var sel, textRange;
	                if ( (sel = this.docSelection) ) {
	                    var range = sel.createRange();
	                    if (isTextRange(range)) {
	                        return range;
	                    } else {
	                        throw module.createError("getNativeTextRange: selection is a control selection");
	                    }
	                } else if (this.rangeCount > 0) {
	                    return api.WrappedTextRange.rangeToTextRange( this.getRangeAt(0) );
	                } else {
	                    throw module.createError("getNativeTextRange: selection contains no range");
	                }
	            };
	        }
	
	        function inspect(sel) {
	            var rangeInspects = [];
	            var anchor = new DomPosition(sel.anchorNode, sel.anchorOffset);
	            var focus = new DomPosition(sel.focusNode, sel.focusOffset);
	            var name = (typeof sel.getName == "function") ? sel.getName() : "Selection";
	
	            if (typeof sel.rangeCount != "undefined") {
	                for (var i = 0, len = sel.rangeCount; i < len; ++i) {
	                    rangeInspects[i] = DomRange.inspect(sel.getRangeAt(i));
	                }
	            }
	            return "[" + name + "(Ranges: " + rangeInspects.join(", ") +
	                    ")(anchor: " + anchor.inspect() + ", focus: " + focus.inspect() + "]";
	        }
	
	        selProto.getName = function() {
	            return "WrappedSelection";
	        };
	
	        selProto.inspect = function() {
	            return inspect(this);
	        };
	
	        selProto.detach = function() {
	            actOnCachedSelection(this.win, "delete");
	            deleteProperties(this);
	        };
	
	        WrappedSelection.detachAll = function() {
	            actOnCachedSelection(null, "deleteAll");
	        };
	
	        WrappedSelection.inspect = inspect;
	        WrappedSelection.isDirectionBackward = isDirectionBackward;
	
	        api.Selection = WrappedSelection;
	
	        api.selectionPrototype = selProto;
	
	        api.addShimListener(function(win) {
	            if (typeof win.getSelection == "undefined") {
	                win.getSelection = function() {
	                    return getSelection(win);
	                };
	            }
	            win = null;
	        });
	    });
	    
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Wait for document to load before initializing
	    var docReady = false;
	
	    var loadHandler = function(e) {
	        if (!docReady) {
	            docReady = true;
	            if (!api.initialized && api.config.autoInitialize) {
	                init();
	            }
	        }
	    };
	
	    if (isBrowser) {
	        // Test whether the document has already been loaded and initialize immediately if so
	        if (document.readyState == "complete") {
	            loadHandler();
	        } else {
	            if (isHostMethod(document, "addEventListener")) {
	                document.addEventListener("DOMContentLoaded", loadHandler, false);
	            }
	
	            // Add a fallback in case the DOMContentLoaded event isn't supported
	            addListener(window, "load", loadHandler);
	        }
	    }
	
	    return api;
	}, this);

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Selection save and restore module for Rangy.
	 * Saves and restores user selections using marker invisible elements in the DOM.
	 *
	 * Part of Rangy, a cross-browser JavaScript range and selection library
	 * https://github.com/timdown/rangy
	 *
	 * Depends on Rangy core.
	 *
	 * Copyright 2024, Tim Down
	 * Licensed under the MIT license.
	 * Version: 1.3.2
	 * Build date: 2 November 2024
	 */
	(function(factory, root) {
	    if (true) {
	        // AMD. Register as an anonymous module with a dependency on Rangy.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(336)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module != "undefined" && typeof exports == "object") {
	        // Node/CommonJS style
	        module.exports = factory( require("rangy") );
	    } else {
	        // No AMD or CommonJS support so we use the rangy property of root (probably the global variable)
	        factory(root.rangy);
	    }
	})(function(rangy) {
	    rangy.createModule("SaveRestore", ["WrappedSelection"], function(api, module) {
	        var dom = api.dom;
	        var removeNode = dom.removeNode;
	        var isDirectionBackward = api.Selection.isDirectionBackward;
	        var markerTextChar = "\ufeff";
	
	        function gEBI(id, doc) {
	            return (doc || document).getElementById(id);
	        }
	
	        function insertRangeBoundaryMarker(range, atStart) {
	            var markerId = "selectionBoundary_" + (+new Date()) + "_" + ("" + Math.random()).slice(2);
	            var markerEl;
	            var doc = dom.getDocument(range.startContainer);
	
	            // Clone the Range and collapse to the appropriate boundary point
	            var boundaryRange = range.cloneRange();
	            boundaryRange.collapse(atStart);
	
	            // Create the marker element containing a single invisible character using DOM methods and insert it
	            markerEl = doc.createElement("span");
	            markerEl.id = markerId;
	            markerEl.style.lineHeight = "0";
	            markerEl.style.display = "none";
	            markerEl.className = "rangySelectionBoundary";
	            markerEl.appendChild(doc.createTextNode(markerTextChar));
	
	            boundaryRange.insertNode(markerEl);
	            return markerEl;
	        }
	
	        function setRangeBoundary(doc, range, markerId, atStart) {
	            var markerEl = gEBI(markerId, doc);
	            if (markerEl) {
	                range[atStart ? "setStartBefore" : "setEndBefore"](markerEl);
	                removeNode(markerEl);
	            } else {
	                module.warn("Marker element has been removed. Cannot restore selection.");
	            }
	        }
	
	        function compareRanges(r1, r2) {
	            return r2.compareBoundaryPoints(r1.START_TO_START, r1);
	        }
	
	        function saveRange(range, direction) {
	            var startEl, endEl, doc = api.DomRange.getRangeDocument(range), text = range.toString();
	            var backward = isDirectionBackward(direction);
	
	            if (range.collapsed) {
	                endEl = insertRangeBoundaryMarker(range, false);
	                return {
	                    document: doc,
	                    markerId: endEl.id,
	                    collapsed: true
	                };
	            } else {
	                endEl = insertRangeBoundaryMarker(range, false);
	                startEl = insertRangeBoundaryMarker(range, true);
	
	                return {
	                    document: doc,
	                    startMarkerId: startEl.id,
	                    endMarkerId: endEl.id,
	                    collapsed: false,
	                    backward: backward,
	                    toString: function() {
	                        return "original text: '" + text + "', new text: '" + range.toString() + "'";
	                    }
	                };
	            }
	        }
	
	        function restoreRange(rangeInfo, normalize) {
	            var doc = rangeInfo.document;
	            if (typeof normalize == "undefined") {
	                normalize = true;
	            }
	            var range = api.createRange(doc);
	            if (rangeInfo.collapsed) {
	                var markerEl = gEBI(rangeInfo.markerId, doc);
	                if (markerEl) {
	                    markerEl.style.display = "inline";
	                    var previousNode = markerEl.previousSibling;
	
	                    // Workaround for issue 17
	                    if (previousNode && previousNode.nodeType == 3) {
	                        removeNode(markerEl);
	                        range.collapseToPoint(previousNode, previousNode.length);
	                    } else {
	                        range.collapseBefore(markerEl);
	                        removeNode(markerEl);
	                    }
	                } else {
	                    module.warn("Marker element has been removed. Cannot restore selection.");
	                }
	            } else {
	                setRangeBoundary(doc, range, rangeInfo.startMarkerId, true);
	                setRangeBoundary(doc, range, rangeInfo.endMarkerId, false);
	            }
	
	            if (normalize) {
	                range.normalizeBoundaries();
	            }
	
	            return range;
	        }
	
	        function saveRanges(ranges, direction) {
	            var rangeInfos = [], range, doc;
	            var backward = isDirectionBackward(direction);
	
	            // Order the ranges by position within the DOM, latest first, cloning the array to leave the original untouched
	            ranges = ranges.slice(0);
	            ranges.sort(compareRanges);
	
	            for (var i = 0, len = ranges.length; i < len; ++i) {
	                rangeInfos[i] = saveRange(ranges[i], backward);
	            }
	
	            // Now that all the markers are in place and DOM manipulation over, adjust each range's boundaries to lie
	            // between its markers
	            for (i = len - 1; i >= 0; --i) {
	                range = ranges[i];
	                doc = api.DomRange.getRangeDocument(range);
	                if (range.collapsed) {
	                    range.collapseAfter(gEBI(rangeInfos[i].markerId, doc));
	                } else {
	                    range.setEndBefore(gEBI(rangeInfos[i].endMarkerId, doc));
	                    range.setStartAfter(gEBI(rangeInfos[i].startMarkerId, doc));
	                }
	            }
	
	            return rangeInfos;
	        }
	
	        function saveSelection(win) {
	            if (!api.isSelectionValid(win)) {
	                module.warn("Cannot save selection. This usually happens when the selection is collapsed and the selection document has lost focus.");
	                return null;
	            }
	            var sel = api.getSelection(win);
	            var ranges = sel.getAllRanges();
	            var backward = (ranges.length == 1 && sel.isBackward());
	
	            var rangeInfos = saveRanges(ranges, backward);
	
	            // Ensure current selection is unaffected
	            if (backward) {
	                sel.setSingleRange(ranges[0], backward);
	            } else {
	                sel.setRanges(ranges);
	            }
	
	            return {
	                win: win,
	                rangeInfos: rangeInfos,
	                restored: false
	            };
	        }
	
	        function restoreRanges(rangeInfos) {
	            var ranges = [];
	
	            // Ranges are in reverse order of appearance in the DOM. We want to restore earliest first to avoid
	            // normalization affecting previously restored ranges.
	            var rangeCount = rangeInfos.length;
	
	            for (var i = rangeCount - 1; i >= 0; i--) {
	                ranges[i] = restoreRange(rangeInfos[i], true);
	            }
	
	            return ranges;
	        }
	
	        function restoreSelection(savedSelection, preserveDirection) {
	            if (!savedSelection.restored) {
	                var rangeInfos = savedSelection.rangeInfos;
	                var sel = api.getSelection(savedSelection.win);
	                var ranges = restoreRanges(rangeInfos), rangeCount = rangeInfos.length;
	
	                if (rangeCount == 1 && preserveDirection && api.features.selectionHasExtend && rangeInfos[0].backward) {
	                    sel.removeAllRanges();
	                    sel.addRange(ranges[0], true);
	                } else {
	                    sel.setRanges(ranges);
	                }
	
	                savedSelection.restored = true;
	            }
	        }
	
	        function removeMarkerElement(doc, markerId) {
	            var markerEl = gEBI(markerId, doc);
	            if (markerEl) {
	                removeNode(markerEl);
	            }
	        }
	
	        function removeMarkers(savedSelection) {
	            var rangeInfos = savedSelection.rangeInfos;
	            for (var i = 0, len = rangeInfos.length, rangeInfo; i < len; ++i) {
	                rangeInfo = rangeInfos[i];
	                if (rangeInfo.collapsed) {
	                    removeMarkerElement(savedSelection.doc, rangeInfo.markerId);
	                } else {
	                    removeMarkerElement(savedSelection.doc, rangeInfo.startMarkerId);
	                    removeMarkerElement(savedSelection.doc, rangeInfo.endMarkerId);
	                }
	            }
	        }
	
	        api.util.extend(api, {
	            saveRange: saveRange,
	            restoreRange: restoreRange,
	            saveRanges: saveRanges,
	            restoreRanges: restoreRanges,
	            saveSelection: saveSelection,
	            restoreSelection: restoreSelection,
	            removeMarkerElement: removeMarkerElement,
	            removeMarkers: removeMarkers
	        });
	    });
	    
	    return rangy;
	}, this);

/***/ })
]);


// WEBPACK FOOTER //
// app.ce21c3d4faa61f595963.js